(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components"], factory);
	else if(typeof exports === 'object')
		exports["Zakeke"] = factory(require("react"), require("styled-components"));
	else
		root["Zakeke"] = factory(root["react"], root["styled-components"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_styled_components__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/call-bind/callBound.js":
/*!*********************************************!*\
  !*** ./node_modules/call-bind/callBound.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");

var callBind = __webpack_require__(/*! ./ */ "./node_modules/call-bind/index.js");

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ "./node_modules/call-bind/index.js":
/*!*****************************************!*\
  !*** ./node_modules/call-bind/index.js ***!
  \*****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");
var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ "./node_modules/function-bind/implementation.js":
/*!******************************************************!*\
  !*** ./node_modules/function-bind/implementation.js ***!
  \******************************************************/
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ "./node_modules/function-bind/index.js":
/*!*********************************************!*\
  !*** ./node_modules/function-bind/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(/*! ./implementation */ "./node_modules/function-bind/implementation.js");

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ "./node_modules/get-intrinsic/index.js":
/*!*********************************************!*\
  !*** ./node_modules/get-intrinsic/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(/*! has-symbols */ "./node_modules/has-symbols/index.js")();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

try {
	null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
	// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
	var errorProto = getProto(getProto(e));
	INTRINSICS['%Error.prototype%'] = errorProto;
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");
var hasOwn = __webpack_require__(/*! has */ "./node_modules/has/src/index.js");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ "./node_modules/has-symbols/index.js":
/*!*******************************************!*\
  !*** ./node_modules/has-symbols/index.js ***!
  \*******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(/*! ./shams */ "./node_modules/has-symbols/shams.js");

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ "./node_modules/has-symbols/shams.js":
/*!*******************************************!*\
  !*** ./node_modules/has-symbols/shams.js ***!
  \*******************************************/
/***/ ((module) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ "./node_modules/has/src/index.js":
/*!***************************************!*\
  !*** ./node_modules/has/src/index.js ***!
  \***************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ "./node_modules/lodash/lodash.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/lodash.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ "./node_modules/object-inspect/index.js":
/*!**********************************************!*\
  !*** ./node_modules/object-inspect/index.js ***!
  \**********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(/*! ./util.inspect */ "?4f7e");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ "./node_modules/qs/lib/formats.js":
/*!****************************************!*\
  !*** ./node_modules/qs/lib/formats.js ***!
  \****************************************/
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ "./node_modules/qs/lib/index.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/index.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(/*! ./stringify */ "./node_modules/qs/lib/stringify.js");
var parse = __webpack_require__(/*! ./parse */ "./node_modules/qs/lib/parse.js");
var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ "./node_modules/qs/lib/parse.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/parse.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "./node_modules/qs/lib/utils.js");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ "./node_modules/qs/lib/stringify.js":
/*!******************************************!*\
  !*** ./node_modules/qs/lib/stringify.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(/*! side-channel */ "./node_modules/side-channel/index.js");
var utils = __webpack_require__(/*! ./utils */ "./node_modules/qs/lib/utils.js");
var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ "./node_modules/qs/lib/utils.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/utils.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ "./node_modules/side-channel/index.js":
/*!********************************************!*\
  !*** ./node_modules/side-channel/index.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");
var callBound = __webpack_require__(/*! call-bind/callBound */ "./node_modules/call-bind/callBound.js");
var inspect = __webpack_require__(/*! object-inspect */ "./node_modules/object-inspect/index.js");

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ "../../../../../node_modules/axios/index.js":
/*!**************************************************!*\
  !*** ../../../../../node_modules/axios/index.js ***!
  \**************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(/*! ./lib/axios */ "../../../../../node_modules/axios/lib/axios.js");

/***/ }),

/***/ "../../../../../node_modules/axios/lib/adapters/xhr.js":
/*!*************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/adapters/xhr.js ***!
  \*************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");
var settle = __webpack_require__(/*! ./../core/settle */ "../../../../../node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__(/*! ./../helpers/buildURL */ "../../../../../node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__(/*! ./../helpers/parseHeaders */ "../../../../../node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__(/*! ./../helpers/isURLSameOrigin */ "../../../../../node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__(/*! ../core/createError */ "../../../../../node_modules/axios/lib/core/createError.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(/*! ./../helpers/cookies */ "../../../../../node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/axios.js":
/*!******************************************************!*\
  !*** ../../../../../node_modules/axios/lib/axios.js ***!
  \******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "../../../../../node_modules/axios/lib/utils.js");
var bind = __webpack_require__(/*! ./helpers/bind */ "../../../../../node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__(/*! ./core/Axios */ "../../../../../node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__(/*! ./defaults */ "../../../../../node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(/*! ./cancel/Cancel */ "../../../../../node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__(/*! ./cancel/CancelToken */ "../../../../../node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__(/*! ./cancel/isCancel */ "../../../../../node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(/*! ./helpers/spread */ "../../../../../node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/cancel/Cancel.js":
/*!**************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/cancel/Cancel.js ***!
  \**************************************************************/
/***/ ((module) => {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/cancel/CancelToken.js":
/*!*******************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/cancel/CancelToken.js ***!
  \*******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var Cancel = __webpack_require__(/*! ./Cancel */ "../../../../../node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/cancel/isCancel.js":
/*!****************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/cancel/isCancel.js ***!
  \****************************************************************/
/***/ ((module) => {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/Axios.js":
/*!***********************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/Axios.js ***!
  \***********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var defaults = __webpack_require__(/*! ./../defaults */ "../../../../../node_modules/axios/lib/defaults.js");
var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__(/*! ./InterceptorManager */ "../../../../../node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__(/*! ./dispatchRequest */ "../../../../../node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/InterceptorManager.js":
/*!************************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/InterceptorManager.js ***!
  \************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/createError.js":
/*!*****************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/createError.js ***!
  \*****************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var enhanceError = __webpack_require__(/*! ./enhanceError */ "../../../../../node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/dispatchRequest.js":
/*!*********************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/dispatchRequest.js ***!
  \*********************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");
var transformData = __webpack_require__(/*! ./transformData */ "../../../../../node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__(/*! ../cancel/isCancel */ "../../../../../node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__(/*! ../defaults */ "../../../../../node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__(/*! ./../helpers/isAbsoluteURL */ "../../../../../node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__(/*! ./../helpers/combineURLs */ "../../../../../node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/enhanceError.js":
/*!******************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/enhanceError.js ***!
  \******************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/settle.js":
/*!************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/settle.js ***!
  \************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var createError = __webpack_require__(/*! ./createError */ "../../../../../node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/transformData.js":
/*!*******************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/transformData.js ***!
  \*******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/defaults.js":
/*!*********************************************************!*\
  !*** ../../../../../node_modules/axios/lib/defaults.js ***!
  \*********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "../../../../../node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__(/*! ./helpers/normalizeHeaderName */ "../../../../../node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(/*! ./adapters/xhr */ "../../../../../node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(/*! ./adapters/http */ "../../../../../node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/bind.js":
/*!*************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/bind.js ***!
  \*************************************************************/
/***/ ((module) => {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/buildURL.js":
/*!*****************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/buildURL.js ***!
  \*****************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/combineURLs.js":
/*!********************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/combineURLs.js ***!
  \********************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/cookies.js":
/*!****************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/cookies.js ***!
  \****************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/isAbsoluteURL.js":
/*!**********************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \**********************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/isURLSameOrigin.js":
/*!************************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/normalizeHeaderName.js":
/*!****************************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/normalizeHeaderName.js ***!
  \****************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "../../../../../node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/parseHeaders.js":
/*!*********************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/parseHeaders.js ***!
  \*********************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/spread.js":
/*!***************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/spread.js ***!
  \***************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/utils.js":
/*!******************************************************!*\
  !*** ../../../../../node_modules/axios/lib/utils.js ***!
  \******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! ./helpers/bind */ "../../../../../node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__(/*! is-buffer */ "../../../../../node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "./src/api.ts":
/*!********************!*\
  !*** ./src/api.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "axiosApi": () => (/* binding */ axiosApi),
/* harmony export */   "setupApi": () => (/* binding */ setupApi)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers */ "./src/helpers.tsx");



var axiosApi;
function setupApi(culture, token) {
  console.log(Zakeke.config);
  axiosApi = axios__WEBPACK_IMPORTED_MODULE_2__["default"].create({
    baseURL: Zakeke.config.cloudFlareApiUrl || Zakeke.config.baseApiUrl,
    timeout: 120000,
    withCredentials: true,
    headers: {
      Authorization: 'Bearer ' + token,
      'Accept-Language': culture
    }
  });
  $.ajaxSetup({
    xhrFields: {
      withCredentials: true
    },
    headers: {
      Authorization: 'Bearer ' + token,
      'Accept-Language': culture
    }
  });
  axiosApi.interceptors.response.use(function (response) {
    // Convert all to camelCase
    if (response.data && (lodash__WEBPACK_IMPORTED_MODULE_0___default().isObject(response.data) || lodash__WEBPACK_IMPORTED_MODULE_0___default().isArray(response.data))) response.data = _helpers__WEBPACK_IMPORTED_MODULE_1__.StringHelper.pascalToCamel(response.data);
    return response;
  }, function (error) {
    // Convert all to camelCase
    if (error.response && error.response.data) {
      error.response.data = _helpers__WEBPACK_IMPORTED_MODULE_1__.StringHelper.pascalToCamel(error.response.data);
    }
    return Promise.reject(error);
  });
}

/***/ }),

/***/ "./src/components/customizer.tsx":
/*!***************************************!*\
  !*** ./src/components/customizer.tsx ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeDesigner": () => (/* binding */ ZakekeDesigner)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
/* harmony import */ var _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../hooks/useZakeke */ "./src/hooks/useZakeke.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../state/provider */ "./src/state/provider.tsx");
var _templateObject;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }






var ZakekeDesignerContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\toutline: none !important;\n\n\tcanvas {\n\t\toutline: none !important;\n\t}\n"])));
// Persistent mode will keep the SceneEditor alive after unmount.
// You should save the current editor with the ref
var ZakekeDesigner = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_4__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = stateRef.current.state.environment;
  var _useZakeke = (0,_hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__.useZakeke)(),
    designUpdate = _useZakeke.designUpdate;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState((0,_helpers__WEBPACK_IMPORTED_MODULE_2__.uuid)()),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    guid = _React$useState2[0];
  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    customizer = _React$useState4[0],
    setCustomizer = _React$useState4[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var container = document.getElementById('zakeke-designer-container-' + guid);
    var newCustomizer = new MPlaza.Customizer(false, false, null, true);
    newCustomizer.showSideImage = false;
    newCustomizer.addItemChangedListener(handleItemChanged);
    newCustomizer.addItemRemovedListener(handleItemRemoved);

    // Hide DPI warnings
    newCustomizer.setCustomizedMessages([{
      Description: '',
      EventID: MPlaza.EventMessages.DPIWarning,
      Visible: false
    }]);
    newCustomizer.appendTo(container);
    setCustomizer(newCustomizer);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (store.internalProduct) {
      var side = store.internalProduct.get('colors').at(0).get('sides').find(function (x) {
        return x.get('sideID') == props.areaId;
      });
      if (side && customizer && store.internalCurrentTemplate) {
        customizer.model = store.internalProduct;
        customizer.setDesign(store.internalCurrentTemplate);
        customizer.setSide(side).then(function () {
          customizer.adaptZoomToSideAreas(false);
        });
      }
    }
  }, [props.areaId, store.currentTemplate, !!customizer]);
  var handleItemChanged = function handleItemChanged() {
    designUpdate();
  };
  var handleItemRemoved = function handleItemRemoved() {
    designUpdate();
  };
  var zoomIn = function zoomIn() {
    if (customizer) customizer.zoomIn();
  };
  var zoomOut = function zoomOut() {
    if (customizer) customizer.zoomOut();
  };

  // Expose the zoom methods to ref
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () {
    return {
      zoomIn: zoomIn,
      zoomOut: zoomOut
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZakekeDesignerContainer, {
    id: 'zakeke-designer-container-' + guid
  });
});

/***/ }),

/***/ "./src/components/debugs/debugPanel.tsx":
/*!**********************************************!*\
  !*** ./src/components/debugs/debugPanel.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DebugPanel": () => (/* binding */ DebugPanel)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../state/provider */ "./src/state/provider.tsx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var DebugPanelContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: fixed;\n\tmin-width: 120px;\n\tbottom: 0;\n\tright: 0;\n\tbackground: #fff;\n\tpadding: 10px 20px;\n\tborder: 1px solid #ccc;\n\tz-index: 10000;\n\tcursor: ", ";\n"])), function (props) {
  return props.$hideCursor ? 'auto' : 'pointer';
});
var DebugContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tpadding: 25px 10px 10px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n"])));
var DebugPanelTitle = styled_components__WEBPACK_IMPORTED_MODULE_1___default().h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 5px;\n\tleft: 10px;\n\tmargin: 0;\n"])));
var DebugPanelClose = styled_components__WEBPACK_IMPORTED_MODULE_1___default().button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 5px;\n\tright: 10px;\n\tmargin: 0;\n\tpadding: 0;\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\tz-index: 10002;\n"])));
var DebugMeshTitle = styled_components__WEBPACK_IMPORTED_MODULE_1___default().h4(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tmargin: 0;\n"])));
var DebugMeshList = styled_components__WEBPACK_IMPORTED_MODULE_1___default().ul(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tlist-style: none;\n\tpadding: 0;\n\toverflow: auto;\n\tmax-height: 200px;\n"])));
var DebugTextArea = styled_components__WEBPACK_IMPORTED_MODULE_1___default().textarea(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tmin-width: 400px;\n\theight: 200px;\n"])));
var DebugPanel = function DebugPanel(_ref) {
  var _viewer$scene;
  _objectDestructuringEmpty(_ref);
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    show = _React$useState2[0],
    setShow = _React$useState2[1];
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_2__.useInternalState)();
  var stateRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(internalState);
  var env = stateRef.current.state.environment;
  var viewer = stateRef.current.state.sceneViewer;
  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    sceneConfig = _React$useState4[0],
    setSceneConfig = _React$useState4[1];
  var handleShow = function handleShow() {
    setShow(!show);
  };
  var showIfHidden = function showIfHidden() {
    if (!show) {
      setShow(true);
    }
  };
  var downloadFile = function downloadFile(blob, filename) {
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
  };
  var downloadScene = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var blob;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('Download Scene');
            _context.next = 3;
            return env.exportSceneToGlb();
          case 3:
            blob = _context.sent;
            downloadFile(blob, 'scene.glb');
            console.log('Scene downloaded');
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function downloadScene() {
      return _ref2.apply(this, arguments);
    };
  }();
  var downloadTryOnGLB = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var blob;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            console.log('Download TryOn GLB');
            _context2.next = 3;
            return env.exportTryOnMeshToGlb();
          case 3:
            blob = _context2.sent;
            downloadFile(blob, 'tryon.glb');
            console.log('TryOn GLB downloaded');
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function downloadTryOnGLB() {
      return _ref3.apply(this, arguments);
    };
  }();
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var _viewer$zkScene, _viewer$zkScene$getSc;
    var sceneConfig = viewer === null || viewer === void 0 ? void 0 : (_viewer$zkScene = viewer.zkScene) === null || _viewer$zkScene === void 0 ? void 0 : (_viewer$zkScene$getSc = _viewer$zkScene.getSceneConfig()) === null || _viewer$zkScene$getSc === void 0 ? void 0 : _viewer$zkScene$getSc.toJSON();
    if (sceneConfig) {
      setSceneConfig(JSON.stringify(sceneConfig, null, 2));
    }
  }, [viewer]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugPanelContainer, {
    $hideCursor: show,
    onClick: showIfHidden
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugPanelTitle, null, "Debug Panel"), show && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugPanelClose, {
    onClick: handleShow
  }, "X"), show && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugContainer, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: downloadScene
  }, "Download Scene"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: downloadTryOnGLB
  }, "Download TryOn GLB"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugContainer, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugMeshTitle, null, "Mesh list"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugMeshList, null, viewer === null || viewer === void 0 ? void 0 : (_viewer$scene = viewer.scene) === null || _viewer$scene === void 0 ? void 0 : _viewer$scene.meshes.map(function (mesh) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
      key: mesh.id
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
      onClick: function onClick() {
        mesh.visibility = 1;
      }
    }, "Show"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
      onClick: function onClick() {
        mesh.visibility = 0;
      }
    }, "Hide"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, mesh.name));
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {
      var _viewer$scene2;
      console.log(viewer === null || viewer === void 0 ? void 0 : (_viewer$scene2 = viewer.scene) === null || _viewer$scene2 === void 0 ? void 0 : _viewer$scene2.meshes);
    }
  }, "Log Meshes"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {
      var _viewer$scene3;
      console.log(viewer === null || viewer === void 0 ? void 0 : (_viewer$scene3 = viewer.scene) === null || _viewer$scene3 === void 0 ? void 0 : _viewer$scene3.materials);
    }
  }, "Log Materials"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {
      var _viewer$scene4;
      console.log(viewer === null || viewer === void 0 ? void 0 : (_viewer$scene4 = viewer.scene) === null || _viewer$scene4 === void 0 ? void 0 : _viewer$scene4.textures);
    }
  }, "Log Textures")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugContainer, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugMeshTitle, null, "Scene config"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugTextArea, {
    value: sceneConfig,
    onChange: function onChange(e) {
      return setSceneConfig(e.target.value);
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {
      var _viewer$zkScene2, _viewer$zkScene2$getS;
      console.log(viewer === null || viewer === void 0 ? void 0 : (_viewer$zkScene2 = viewer.zkScene) === null || _viewer$zkScene2 === void 0 ? void 0 : (_viewer$zkScene2$getS = _viewer$zkScene2.getSceneConfig()) === null || _viewer$zkScene2$getS === void 0 ? void 0 : _viewer$zkScene2$getS.toJSON());
    }
  }, "Log Scene Config"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {
      viewer === null || viewer === void 0 ? void 0 : viewer.loadSceneConfig(JSON.parse(sceneConfig));
      viewer === null || viewer === void 0 ? void 0 : viewer.setRenderingNeeded();
      viewer === null || viewer === void 0 ? void 0 : viewer.refreshRendering();
    }
  }, "Apply Scene Config"))));
};

/***/ }),

/***/ "./src/components/sceneViewer.tsx":
/*!****************************************!*\
  !*** ./src/components/sceneViewer.tsx ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeViewer": () => (/* binding */ ZakekeViewer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
/* harmony import */ var _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../hooks/useZakeke */ "./src/hooks/useZakeke.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../state/provider */ "./src/state/provider.tsx");
/* harmony import */ var _debugs_debugPanel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./debugs/debugPanel */ "./src/components/debugs/debugPanel.tsx");
var _templateObject;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }







var ZakekeViewerContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\toutline: none !important;\n\n\tcanvas {\n\t\toutline: none !important;\n\t\tbackground-color: ", ";\n\t}\n"])), function (props) {
  return props.backgroundColor ? props.backgroundColor : 'transparent';
});

// Persistent mode will keep the SceneEditor alive after unmount.
// You should save the current editor with the ref
var ZakekeViewer = function ZakekeViewer(_ref) {
  var className = _ref.className,
    bgColor = _ref.bgColor;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState((0,_helpers__WEBPACK_IMPORTED_MODULE_2__.uuid)()),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    guid = _React$useState2[0];
  var _useZakeke = (0,_hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__.useZakeke)(),
    isViewerReady = _useZakeke.isViewerReady,
    internalAppendViewer = _useZakeke.internalAppendViewer,
    backgroundColor = _useZakeke.backgroundColor,
    removeBackground = _useZakeke.removeBackground;
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_4__.useInternalState)();
  var stateRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(internalState);
  var getBackgroundColor = function getBackgroundColor() {
    var isFullscreen = !!document.fullscreenElement;
    var removeBackground = stateRef.current.state.environment.removeBackground;
    var backgroundColor = stateRef.current.state.environment.backgroundColor;
    if (!isFullscreen && removeBackground) return null; //			1 non cè' il background
    if (!isFullscreen && backgroundColor) return backgroundColor; // 2 background lato config
    return bgColor !== null && bgColor !== void 0 ? bgColor : '#f2f2f2'; //					3 background lato tema o default
  };
  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState(getBackgroundColor()),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    stateBackgroundCol = _React$useState4[0],
    setStateBackgroundCol = _React$useState4[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isViewerReady) internalAppendViewer(document.getElementById('zakeke-viewer-container-' + guid));
  }, [isViewerReady]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setStateBackgroundCol(getBackgroundColor());
    var e = function e() {
      setStateBackgroundCol(getBackgroundColor());
    };
    document.addEventListener('fullscreenchange', e);
    return function () {
      document.removeEventListener('fullscreenchange', e);
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZakekeViewerContainer, {
    backgroundColor: stateBackgroundCol,
    id: 'zakeke-viewer-container-' + guid,
    className: "zakeke-viewer-container ".concat(className)
  }, (stateRef === null || stateRef === void 0 ? void 0 : stateRef.current.state.isDebug) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_debugs_debugPanel__WEBPACK_IMPORTED_MODULE_5__.DebugPanel, null));
};

/***/ }),

/***/ "./src/components/tryon/tryOnFrame.tsx":
/*!*********************************************!*\
  !*** ./src/components/tryon/tryOnFrame.tsx ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TryOnFrame": () => (/* binding */ TryOnFrame)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
var _templateObject;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var TryOnIFrame = styled_components__WEBPACK_IMPORTED_MODULE_1___default().iframe(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tborder: none;\n\toutline: none;\n"])));
// #region common frame
var TryOnFrame = function TryOnFrame(props) {
  var frame = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    eventAdded = _useState2[0],
    setEventAdded = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    timeOut = _useState4[0],
    setTimeOut = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    lockForTimeOut = _useState6[0],
    setLockForTimeOut = _useState6[1];
  var pdToolFrame = frame === null || frame === void 0 ? void 0 : frame.current;
  var windowFineTuning = pdToolFrame === null || pdToolFrame === void 0 ? void 0 : pdToolFrame.contentWindow;
  var startTimeOut = function startTimeOut() {
    if (timeOut) clearTimeout(timeOut);
    setLockForTimeOut(true);
    pdToolFrame === null || pdToolFrame === void 0 ? void 0 : pdToolFrame.setAttribute('src', 'about:blank');
    setTimeOut(setTimeout(function () {
      setLockForTimeOut(false);
      pdToolFrame === null || pdToolFrame === void 0 ? void 0 : pdToolFrame.setAttribute('src', props.providerUrl);
    }, 1500));
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (pdToolFrame && windowFineTuning) {
      props.onReady && props.onReady(windowFineTuning);
      startTimeOut();
    }
  }, [windowFineTuning]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!eventAdded) {
      setEventAdded(true);
      window.addEventListener('message', props.outMessageHandler);
    }
    return function () {
      if (eventAdded) {
        window.removeEventListener('message', props.outMessageHandler);
        setEventAdded(false);
      }
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(TryOnIFrame, {
    ref: frame,
    className: props.className ? props.className : '' + ' tryon-' + props.providerTitle + '-frame',
    src: "about:blank",
    scrolling: "no",
    allowFullScreen: true,
    allow: "accelerometer; magnetometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;"
  });
};

// #endregion

/***/ }),

/***/ "./src/components/tryon/tryOnModels.ts":
/*!*********************************************!*\
  !*** ./src/components/tryon/tryOnModels.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PupillaryDistanceBaseProviderReceivedMessage": () => (/* binding */ PupillaryDistanceBaseProviderReceivedMessage),
/* harmony export */   "PupillaryDistanceBaseProviderResponseMessage": () => (/* binding */ PupillaryDistanceBaseProviderResponseMessage),
/* harmony export */   "TryOnBaseProviderReceivedMessage": () => (/* binding */ TryOnBaseProviderReceivedMessage),
/* harmony export */   "TryOnBaseProviderResponseMessage": () => (/* binding */ TryOnBaseProviderResponseMessage),
/* harmony export */   "TryOnMode": () => (/* binding */ TryOnMode),
/* harmony export */   "parseJSON": () => (/* binding */ parseJSON)
/* harmony export */ });
var TryOnMode = /*#__PURE__*/function (TryOnMode) {
  TryOnMode[TryOnMode["TryOn"] = 1] = "TryOn";
  TryOnMode[TryOnMode["PDTool"] = 2] = "PDTool";
  return TryOnMode;
}({});
var TryOnBaseProviderReceivedMessage = {
  Start: '',
  WaitingAuthentication: 'WAITING_AUTH',
  AuthSuccessful: 'AUTH_SUCCESS',
  AuthError: 'AUTH_ERROR',
  WebcamError: 'WEBCAM_ERROR'
};
var TryOnBaseProviderResponseMessage = {};
var PupillaryDistanceBaseProviderReceivedMessage = {
  Start: '',
  WaitingAuthentication: 'WAITING_AUTH',
  AuthSuccessful: 'AUTH_SUCCESS',
  AuthError: 'AUTH_ERROR'
};
var PupillaryDistanceBaseProviderResponseMessage = {};
function parseJSON(json) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

/***/ }),

/***/ "./src/components/tryon/tryOnProviders/tryOnBanuba.tsx":
/*!*************************************************************!*\
  !*** ./src/components/tryon/tryOnProviders/tryOnBanuba.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BanubaTryOn": () => (/* binding */ BanubaTryOn),
/* harmony export */   "BanubaTryOnReceivedMessage": () => (/* binding */ BanubaTryOnReceivedMessage),
/* harmony export */   "BanubaTryOnResponseMessage": () => (/* binding */ BanubaTryOnResponseMessage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tryOnModels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../tryOnModels */ "./src/components/tryon/tryOnModels.ts");
/* harmony import */ var _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../hooks/tryonContext */ "./src/hooks/tryonContext.ts");
/* harmony import */ var _tryOnFrame__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../tryOnFrame */ "./src/components/tryon/tryOnFrame.tsx");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../state/provider */ "./src/state/provider.tsx");
var _templateObject,
  _this = undefined;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






// #region interfaces
var BanubaTryOnBaseReceivedMessage = {
  WaitingAuthentication: 'WAITING_AUTH',
  TryOnLoaded: 'MODEL_LOADED',
  ScreenShotTaken: 'SCREENSHOT_TAKEN',
  WebcamStopped: 'WEBCAM_STOPPED'
};
var BanubaTryOnReceivedMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderReceivedMessage), BanubaTryOnBaseReceivedMessage);
var BanubaTryOnBaseResponseMessage = {
  StartAuthenticationTryOn: 'AUTH',
  LoadTryOn: 'LOAD_MODEL',
  LoadHands: 'LOAD_HANDS',
  TakeScreenshot: 'TAKE_SCREENSHOT',
  StopWebcam: 'STOP_WEBCAM'
};
var BanubaHandTypes = [
  //QUI TIPI DI PRODOTTI CHE RICHIEDONO LE MANI
];
var BanubaTryOnResponseMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderResponseMessage), BanubaTryOnBaseResponseMessage);
//#endregion

var BanubaTryOnComponentContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: white;\n\tdisplay: flex;\n\t& .tryon-banuba-frame {\n\t\twidth: 77%;\n\t\theight: 100%;\n\t\tborder: none;\n\t\toutline: none;\n\t\tmargin: auto;\n\t}\n"])));

// #region virtual try on

var BanubaTryOn = function BanubaTryOn(props) {
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_5__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = stateRef.current.state.environment;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    tryOnState = _useState2[0],
    setTryOnState = _useState2[1];
  var _useZakekeTryOn = (0,_hooks_tryonContext__WEBPACK_IMPORTED_MODULE_3__.useZakekeTryOn)(),
    tryon = _useZakekeTryOn.tryon,
    setTryon = _useZakekeTryOn.setTryon;
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    frameWindow = _useState4[0],
    setFrameWindow = _useState4[1];
  var frameWindowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  frameWindowRef.current = frameWindow;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      closeFrame: function closeFrame() {
        var _tryon$setVisible;
        return tryon === null || tryon === void 0 ? void 0 : (_tryon$setVisible = tryon.setVisible) === null || _tryon$setVisible === void 0 ? void 0 : _tryon$setVisible.call(tryon, false);
      },
      takeScreenshot: function takeScreenshot() {
        return sendMessage(frameWindowRef.current, BanubaTryOnResponseMessage.TakeScreenshot, null);
      },
      switchToPDTool: function switchToPDTool() {
        console.log('switchToPDTool');
      },
      switchToTryOn: function switchToTryOn() {
        console.log('switchToTryOn');
      },
      startPupillaryDistance: function startPupillaryDistance(time) {
        console.log('startPupillaryDistance');
      }
    }));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _props$onLoaded, _props$onClose;
    switch (tryOnState.type) {
      // TRYON MESSAGES
      case BanubaTryOnReceivedMessage.Start:
        break;
      case BanubaTryOnReceivedMessage.WaitingAuthentication:
        sendMessage(frameWindow, BanubaTryOnResponseMessage.StartAuthenticationTryOn, {
          token: Zakeke.config.banubaSettings.token
        });
        break;
      case BanubaTryOnReceivedMessage.AuthSuccessful:
        if (BanubaHandTypes.includes(props.product.typeID)) {
          sendMessage(frameWindow, BanubaTryOnResponseMessage.LoadHands, null);
          setTimeout(function () {
            sendMessage(frameWindow, BanubaTryOnResponseMessage.LoadTryOn, {
              glb: props.obj,
              settings: props.fineTuningSettings
            });
          }, 1500);
          return;
        }
        sendMessage(frameWindow, BanubaTryOnResponseMessage.LoadTryOn, {
          glb: props.obj,
          settings: props.fineTuningSettings
        });
        break;
      case BanubaTryOnReceivedMessage.TryOnLoaded:
        (_props$onLoaded = props.onLoaded) === null || _props$onLoaded === void 0 ? void 0 : _props$onLoaded.call(props);
        break;
      case BanubaTryOnReceivedMessage.WebcamError:
        props.onWebcamError();
        break;
      case BanubaTryOnReceivedMessage.WebcamStopped:
        (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
        break;
    }
  }, [tryOnState]);
  var sendMessage = function sendMessage(window, message, value) {
    window.postMessage(_objectSpread({
      type: message
    }, value), '*');
  };
  var handleMessage = function handleMessage(e) {
    setTryOnState(e.data);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(BanubaTryOnComponentContainer, {
    className: "Banuba-tryon ".concat(props.className ? props.className : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnFrame__WEBPACK_IMPORTED_MODULE_4__.TryOnFrame, {
    providerTitle: "banuba",
    providerUrl: Zakeke.config.banubaSettings.url,
    onReady: function onReady(w) {
      var _props$onReady;
      setFrameWindow(w);
      (_props$onReady = props.onReady) === null || _props$onReady === void 0 ? void 0 : _props$onReady.call(props);
    },
    outMessageHandler: handleMessage.bind(_this)
  }));
};

// #endregion

/***/ }),

/***/ "./src/components/tryon/tryOnProviders/tryOnDeepAR.tsx":
/*!*************************************************************!*\
  !*** ./src/components/tryon/tryOnProviders/tryOnDeepAR.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DeepARTryOn": () => (/* binding */ DeepARTryOn),
/* harmony export */   "DeepARTryOnReceivedMessage": () => (/* binding */ DeepARTryOnReceivedMessage),
/* harmony export */   "DeepARTryOnResponseMessage": () => (/* binding */ DeepARTryOnResponseMessage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../hooks/tryonContext */ "./src/hooks/tryonContext.ts");
/* harmony import */ var _tryOnModels__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../tryOnModels */ "./src/components/tryon/tryOnModels.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../state/provider */ "./src/state/provider.tsx");
/* harmony import */ var _tryOnFrame__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../tryOnFrame */ "./src/components/tryon/tryOnFrame.tsx");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../helpers */ "./src/helpers.tsx");
var _templateObject,
  _this = undefined;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







// #region interfaces
var DeepARTryOnBaseReceivedMessage = {
  WaitingAuthentication: 'WAITING_AUTH',
  TryOnLoaded: 'MODEL_LOADED',
  ScreenShotTaken: 'SCREENSHOT_TAKEN',
  WebcamStopped: 'WEBCAM_STOPPED'
};
var DeepARTryOnReceivedMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_3__.TryOnBaseProviderReceivedMessage), DeepARTryOnBaseReceivedMessage);
var DeepARTryOnBaseResponseMessage = {
  StartAuthenticationTryOn: 'AUTH',
  LoadTryOn: 'LOAD_MODEL',
  LoadHands: 'LOAD_HANDS',
  TakeScreenshot: 'TAKE_SCREENSHOT',
  StopWebcam: 'STOP_WEBCAM'
};
var DeepARTryOnResponseMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_3__.TryOnBaseProviderResponseMessage), DeepARTryOnBaseResponseMessage);
//#endregion

// const DeepARTryOnComponentContainer = styled.div`
// 	position: absolute;
// 	top: 0;
// 	left: 0;
// 	width: 100%;
// 	height: 100%;
// 	display: flex;
// 	& .tryon-deepAR-frame {
// 		width: 77%;
// 		height: 100%;
// 		border: none;
// 		outline: none;
// 		margin: auto;
// 	}

// `;

var DeepARMobileContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: fixed;\n\tbackground-color: rgba(0, 0, 0, 0.7);\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\talign-items: center;\n\toverflow: auto;\n\tz-index: 12;\n\tborder-radius: 10px;\n"])));
var DeepARTryOn = function DeepARTryOn(props) {
  console.log('DeepAR props.fineTuningSettings', props.fineTuningSettings);
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_4__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = stateRef.current.state.environment;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    tryOnState = _useState2[0],
    setTryOnState = _useState2[1];
  var _useZakekeTryOn = (0,_hooks_tryonContext__WEBPACK_IMPORTED_MODULE_2__.useZakekeTryOn)(),
    tryon = _useZakekeTryOn.tryon,
    setTryon = _useZakekeTryOn.setTryon;
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    frameWindow = _useState4[0],
    setFrameWindow = _useState4[1];
  var frameWindowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  frameWindowRef.current = frameWindow;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0___default().useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    deepARIframeUrl = _React$useState2[0],
    setDeepARIframeUrl = _React$useState2[1];
  var isDesktop = !(_helpers__WEBPACK_IMPORTED_MODULE_6__.IS_ANDROID || _helpers__WEBPACK_IMPORTED_MODULE_6__.IS_IOS);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      closeFrame: function closeFrame() {
        var _tryon$setVisible;
        return tryon === null || tryon === void 0 ? void 0 : (_tryon$setVisible = tryon.setVisible) === null || _tryon$setVisible === void 0 ? void 0 : _tryon$setVisible.call(tryon, false);
      },
      takeScreenshot: function takeScreenshot() {
        return sendMessage(frameWindowRef.current, DeepARTryOnResponseMessage.TakeScreenshot, null);
      },
      switchToPDTool: function switchToPDTool() {
        console.log('switchToPDTool');
      },
      switchToTryOn: function switchToTryOn() {
        console.log('switchToTryOn');
      },
      startPupillaryDistance: function startPupillaryDistance(time) {
        console.log('startPupillaryDistance');
      }
    }));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _props$onLoaded, _props$onClose;
    switch (tryOnState.type) {
      // TRYON MESSAGES
      case DeepARTryOnReceivedMessage.Start:
        break;
      case DeepARTryOnReceivedMessage.WaitingAuthentication:
        sendMessage(frameWindow, DeepARTryOnResponseMessage.StartAuthenticationTryOn, {
          token: Zakeke.config.deepARSettings.token
        });
        break;
      case DeepARTryOnReceivedMessage.AuthSuccessful:
        sendMessage(frameWindow, DeepARTryOnResponseMessage.LoadTryOn, {
          glb: props.obj,
          settings: props.fineTuningSettings
        });
        break;
      case DeepARTryOnReceivedMessage.TryOnLoaded:
        (_props$onLoaded = props.onLoaded) === null || _props$onLoaded === void 0 ? void 0 : _props$onLoaded.call(props);
        break;
      case DeepARTryOnReceivedMessage.WebcamError:
        props.onWebcamError();
        break;
      case DeepARTryOnReceivedMessage.WebcamStopped:
        (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
        break;
    }
  }, [tryOnState]);
  var sendMessage = function sendMessage(window, message, value) {
    window.postMessage(_objectSpread({
      type: message
    }, value), '*');
  };
  var handleMessage = function handleMessage(e) {
    setTryOnState(e.data);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(DeepARMobileContainer, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnFrame__WEBPACK_IMPORTED_MODULE_5__.TryOnFrame, {
    providerTitle: "deepAR",
    providerUrl: Zakeke.config.deepARSettings.url,
    onReady: function onReady(w) {
      var _props$onReady;
      setFrameWindow(w);
      (_props$onReady = props.onReady) === null || _props$onReady === void 0 ? void 0 : _props$onReady.call(props);
    },
    outMessageHandler: handleMessage.bind(_this)
  }));
};

// #endregion

/***/ }),

/***/ "./src/components/tryon/tryOnProviders/tryOnMazing.tsx":
/*!*************************************************************!*\
  !*** ./src/components/tryon/tryOnProviders/tryOnMazing.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MazingPupillaryDistance": () => (/* binding */ MazingPupillaryDistance),
/* harmony export */   "MazingPupillaryDistanceResponseMessage": () => (/* binding */ MazingPupillaryDistanceResponseMessage),
/* harmony export */   "MazingPupillaryDistanceStateReceivedMessage": () => (/* binding */ MazingPupillaryDistanceStateReceivedMessage),
/* harmony export */   "MazingTryOn": () => (/* binding */ MazingTryOn),
/* harmony export */   "MazingTryOnReceivedMessage": () => (/* binding */ MazingTryOnReceivedMessage),
/* harmony export */   "MazingTryOnResponseMessage": () => (/* binding */ MazingTryOnResponseMessage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tryOnModels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../tryOnModels */ "./src/components/tryon/tryOnModels.ts");
/* harmony import */ var _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../hooks/tryonContext */ "./src/hooks/tryonContext.ts");
/* harmony import */ var _tryOnFrame__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../tryOnFrame */ "./src/components/tryon/tryOnFrame.tsx");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../state/provider */ "./src/state/provider.tsx");
var _templateObject,
  _this = undefined;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







// #region interfaces
var MazingTryOnBaseReceivedMessage = {
  WaitingAuthentication: 'WAITING_AUTH',
  TryOnLoaded: 'MODEL_LOADED',
  ScreenShotTaken: 'SCREENSHOT_TAKEN',
  WebcamStopped: 'WEBCAM_STOPPED'
};
var MazingTryOnReceivedMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderReceivedMessage), MazingTryOnBaseReceivedMessage);
var MazingTryOnBaseResponseMessage = {
  StartAuthenticationTryOn: 'AUTH_TRY_ON',
  LoadTryOn: 'LOAD_MODEL',
  TakeScreenshot: 'TAKE_SCREENSHOT',
  StopWebcam: 'STOP_WEBCAM'
};
var MazingTryOnResponseMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderResponseMessage), MazingTryOnBaseResponseMessage);
var MazingPupillaryDistanceBaseStateReceivedMessage = {
  PDLoaded: 'PD_LOADED',
  PDUpdated: 'NEW_PD',
  PDDataNotFoundError: 'PD_ERROR',
  WebcamError: 'WEBCAM_ERROR',
  PDCountdown: 'PD_COUNTDOWN',
  WebcamStopped: 'WEBCAM_STOPPED'
};
var MazingPupillaryDistanceStateReceivedMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.PupillaryDistanceBaseProviderReceivedMessage), MazingPupillaryDistanceBaseStateReceivedMessage);
var MazingPupillaryDistanceBaseResponseMessage = {
  StartAuthenticationPD: 'AUTH_TRY_ON',
  LoadPD: 'LOAD_PD',
  StartPD: 'START_PD',
  StopWebcam: 'STOP_WEBCAM'
};
var MazingPupillaryDistanceResponseMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.PupillaryDistanceBaseProviderResponseMessage), MazingPupillaryDistanceBaseResponseMessage);
//#endregion

var MazingTryOnComponentContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tbackground-color: white;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n"])));

// #region virtual try on

var MazingTryOn = function MazingTryOn(props) {
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_5__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = stateRef.current.state.environment;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    tryOnState = _useState2[0],
    setTryOnState = _useState2[1];
  var _useZakekeTryOn = (0,_hooks_tryonContext__WEBPACK_IMPORTED_MODULE_3__.useZakekeTryOn)(),
    tryon = _useZakekeTryOn.tryon,
    setTryon = _useZakekeTryOn.setTryon,
    tryOnPickedMode = _useZakekeTryOn.tryOnPickedMode,
    setTryOnPickedMode = _useZakekeTryOn.setTryOnPickedMode;
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    frameWindow = _useState4[0],
    setFrameWindow = _useState4[1];
  var frameWindowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  frameWindowRef.current = frameWindow;
  var customerUid = (0,_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.parseJSON)(props.customer.settings).uid;
  var productUid = (0,_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.parseJSON)(props.product.settings).uid;
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    switchedToPDTool = _useState6[0],
    setSwitchedToPDTool = _useState6[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      closeFrame: function closeFrame() {
        return sendMessage(frameWindowRef.current, MazingTryOnResponseMessage.StopWebcam, null);
      },
      takeScreenshot: function takeScreenshot() {
        return sendMessage(frameWindowRef.current, MazingTryOnResponseMessage.TakeScreenshot, null);
      },
      switchToPDTool: function switchToPDTool() {
        var _tryon$changeMode;
        setSwitchedToPDTool(true);
        sendMessage(frameWindowRef.current, MazingPupillaryDistanceResponseMessage.LoadPD, null);
        (_tryon$changeMode = tryon.changeMode) === null || _tryon$changeMode === void 0 ? void 0 : _tryon$changeMode.call(tryon, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnMode.PDTool);
      },
      switchToTryOn: function switchToTryOn() {
        var _tryon$changeMode2;
        setSwitchedToPDTool(false);
        sendMessage(frameWindowRef.current, MazingTryOnResponseMessage.LoadTryOn, {
          glb: props.obj,
          settings: props.fineTuningSettings
        });
        (_tryon$changeMode2 = tryon.changeMode) === null || _tryon$changeMode2 === void 0 ? void 0 : _tryon$changeMode2.call(tryon, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnMode.TryOn);
      },
      startPupillaryDistance: function startPupillaryDistance(time) {
        sendMessage(frameWindowRef.current, MazingPupillaryDistanceResponseMessage.StartPD, {
          seconds: time
        });
      }
    }));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _props$onLoaded, _props$onLoaded2, _tryOnState$value, _props$onPDUpdated, _tryOnState$value2, _props$onClose;
    switch (tryOnState.type) {
      // TRYON MESSAGES
      case MazingTryOnReceivedMessage.Start:
        break;
      case MazingTryOnReceivedMessage.WaitingAuthentication:
        sendMessage(frameWindow, MazingTryOnResponseMessage.StartAuthenticationTryOn, {
          customer_uid: customerUid,
          product_uid: productUid
        });
        break;
      case MazingTryOnReceivedMessage.AuthSuccessful:
        sendMessage(frameWindow, MazingTryOnResponseMessage.LoadTryOn, {
          glb: props.obj,
          settings: props.fineTuningSettings
        });
        break;
      case MazingTryOnReceivedMessage.TryOnLoaded:
        (_props$onLoaded = props.onLoaded) === null || _props$onLoaded === void 0 ? void 0 : _props$onLoaded.call(props);
        break;

      // PD MESSAGES
      case MazingPupillaryDistanceStateReceivedMessage.PDLoaded:
        (_props$onLoaded2 = props.onLoaded) === null || _props$onLoaded2 === void 0 ? void 0 : _props$onLoaded2.call(props);
        break;
      case MazingPupillaryDistanceStateReceivedMessage.PDUpdated:
        store.setPDDistance((_tryOnState$value = tryOnState.value) === null || _tryOnState$value === void 0 ? void 0 : _tryOnState$value.pd);
        (_props$onPDUpdated = props.onPDUpdated) === null || _props$onPDUpdated === void 0 ? void 0 : _props$onPDUpdated.call(props, (_tryOnState$value2 = tryOnState.value) === null || _tryOnState$value2 === void 0 ? void 0 : _tryOnState$value2.pd);
        break;
      case MazingPupillaryDistanceStateReceivedMessage.PDDataNotFoundError:
        break;
      case MazingTryOnReceivedMessage.WebcamError:
        props.onWebcamError();
        break;
      case MazingTryOnReceivedMessage.WebcamStopped:
        (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
        break;
    }
  }, [tryOnState]);
  var sendMessage = function sendMessage(window, message, value) {
    window.postMessage({
      type: message,
      value: value
    }, '*');
  };
  var handleMessage = function handleMessage(e) {
    setTryOnState(e.data);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(MazingTryOnComponentContainer, {
    className: "mazing-tryon ".concat(props.className ? props.className : "")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnFrame__WEBPACK_IMPORTED_MODULE_4__.TryOnFrame, {
    providerTitle: "Mazing",
    providerUrl: Zakeke.config.mazingSettings.url,
    onReady: function onReady(w) {
      var _props$onReady;
      setFrameWindow(w);
      (_props$onReady = props.onReady) === null || _props$onReady === void 0 ? void 0 : _props$onReady.call(props);
    },
    outMessageHandler: handleMessage.bind(_this)
  }));
};

// #endregion

// #region pd tool
var MazingPupillaryDistance = function MazingPupillaryDistance(props) {
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    pdState = _useState8[0],
    setPDState = _useState8[1];
  var _useZakekeTryOn2 = (0,_hooks_tryonContext__WEBPACK_IMPORTED_MODULE_3__.useZakekeTryOn)(),
    tryon = _useZakekeTryOn2.tryon,
    setTryon = _useZakekeTryOn2.setTryon;
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_5__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = stateRef.current.state.environment;
  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    frameWindow = _useState10[0],
    setFrameWindow = _useState10[1];
  var frameWindowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  frameWindowRef.current = frameWindow;
  var customerUid = (0,_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.parseJSON)(props.customer.settings).uid;
  var productUid = (0,_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.parseJSON)(props.product.settings).uid;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      closeFrame: function closeFrame() {
        return sendMessage(frameWindowRef.current, MazingPupillaryDistanceResponseMessage.StopWebcam, null);
      },
      switchToPDTool: function switchToPDTool() {
        console.log('switchToPDTool not active');
      },
      switchToTryOn: function switchToTryOn() {
        console.log('switchToTryOn not active');
      },
      takeScreenshot: function takeScreenshot() {
        return console.log('takeScreenshot not active');
      },
      startPupillaryDistance: function startPupillaryDistance(time) {
        return sendMessage(frameWindowRef.current, MazingPupillaryDistanceResponseMessage.StartPD, {
          seconds: time
        });
      }
    }));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _props$onLoaded3, _props$onPDUpdated2, _props$onClose2;
    switch (pdState.type) {
      case MazingPupillaryDistanceStateReceivedMessage.Start:
        break;
      case MazingPupillaryDistanceStateReceivedMessage.WaitingAuthentication:
        sendMessage(frameWindow, MazingPupillaryDistanceResponseMessage.StartAuthenticationPD, {
          customer_uid: customerUid,
          product_uid: productUid
        });
        break;
      case MazingPupillaryDistanceStateReceivedMessage.AuthSuccessful:
        sendMessage(frameWindow, MazingPupillaryDistanceResponseMessage.LoadPD, {});
        break;
      case MazingPupillaryDistanceStateReceivedMessage.PDLoaded:
        (_props$onLoaded3 = props.onLoaded) === null || _props$onLoaded3 === void 0 ? void 0 : _props$onLoaded3.call(props);
        break;
      case MazingPupillaryDistanceStateReceivedMessage.PDUpdated:
        store.setPDDistance(pdState.value.pd);
        (_props$onPDUpdated2 = props.onPDUpdated) === null || _props$onPDUpdated2 === void 0 ? void 0 : _props$onPDUpdated2.call(props, pdState.value.pd);
        break;
      case MazingPupillaryDistanceStateReceivedMessage.PDDataNotFoundError:
        break;
      case MazingPupillaryDistanceStateReceivedMessage.WebcamError:
        props.onWebcamError();
        break;
      case MazingPupillaryDistanceStateReceivedMessage.WebcamStopped:
        (_props$onClose2 = props.onClose) === null || _props$onClose2 === void 0 ? void 0 : _props$onClose2.call(props);
        break;
    }
  }, [pdState]);
  var sendMessage = function sendMessage(window, message, value) {
    window.postMessage({
      type: message,
      value: value
    }, '*');
  };
  var handleMessage = function handleMessage(e) {
    var _e$data;
    if (!!((_e$data = e.data) !== null && _e$data !== void 0 && _e$data.type)) setPDState(e.data);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(MazingTryOnComponentContainer, {
    className: "mazing-pd ".concat(props.className ? props.className : "")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnFrame__WEBPACK_IMPORTED_MODULE_4__.TryOnFrame, {
    providerTitle: "mazing",
    providerUrl: Zakeke.config.mazingSettings.url,
    onReady: function onReady(w) {
      var _props$onReady2;
      setFrameWindow(w);
      (_props$onReady2 = props.onReady) === null || _props$onReady2 === void 0 ? void 0 : _props$onReady2.call(props);
    },
    outMessageHandler: handleMessage.bind(_this)
  }));
};
// #endregion

// MazingTryOnComponent.defaultProps = {
//   initialState: {
//     type: MazingTryOnState.Start,
//     value: null,
//   },
//   fineTuningSettings: {
//     position: {
//       x: 0,
//       y: 0,
//       z: 0,
//     },
//     scale: 0,
//     temple: true,
//     environment: TryOnFineTuningMazingEnvironment.Neutral,
//   },
// };

// MazingPDToolComponent.defaultProps = {
//   initialState: {
//     type: MazingTryOnState.Start,
//     value: null,
//   },
// };

/***/ }),

/***/ "./src/components/tryon/tryOnViewer.tsx":
/*!**********************************************!*\
  !*** ./src/components/tryon/tryOnViewer.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PupillaryDistanceView": () => (/* binding */ PupillaryDistanceView),
/* harmony export */   "TryOnView": () => (/* binding */ TryOnView),
/* harmony export */   "ZakekeTryOnViewer": () => (/* binding */ ZakekeTryOnViewer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../hooks/tryonContext */ "./src/hooks/tryonContext.ts");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../models */ "./src/models.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../state/provider */ "./src/state/provider.tsx");
/* harmony import */ var _tryOnModels__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./tryOnModels */ "./src/components/tryon/tryOnModels.ts");
/* harmony import */ var _tryOnProviders_tryOnBanuba__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./tryOnProviders/tryOnBanuba */ "./src/components/tryon/tryOnProviders/tryOnBanuba.tsx");
/* harmony import */ var _tryOnProviders_tryOnDeepAR__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./tryOnProviders/tryOnDeepAR */ "./src/components/tryon/tryOnProviders/tryOnDeepAR.tsx");
/* harmony import */ var _tryOnProviders_tryOnMazing__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./tryOnProviders/tryOnMazing */ "./src/components/tryon/tryOnProviders/tryOnMazing.tsx");
/* harmony import */ var _zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @zakeke/zakeke-3d-core */ "./node_modules/@zakeke/zakeke-3d-core/dist/index.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }










var TryOnOverlay = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: black;\n\topacity: 0.5;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 3;\n"])));
var TryOnViewContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: fixed;\n\tz-index: 6;\n\tleft: 0%;\n\ttop: 0%;\n"])));
var PupillaryDistanceViewContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: fixed;\n\tbackground-color: white;\n\tz-index: 6;\n\tleft: 0%;\n\ttop: 0%;\n"])));
var ZakekeTryOnViewer = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
  var _stateRef$current;
  console.log('props ZakekeTryonviewer', props);
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_4__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = (_stateRef$current = stateRef.current) === null || _stateRef$current === void 0 ? void 0 : _stateRef$current.state.environment;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    tryon = _useState2[0],
    setTryon = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(_tryOnModels__WEBPACK_IMPORTED_MODULE_5__.TryOnMode.TryOn),
    _useState4 = _slicedToArray(_useState3, 2),
    tryOnPickedMode = _useState4[0],
    setTryOnPickedMode = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    tryOnVisibility = _useState6[0],
    setTryOnVisibility = _useState6[1];
  var frameRef = {
    tryon: tryon,
    setTryon: setTryon,
    tryOnPickedMode: tryOnPickedMode,
    setTryOnPickedMode: setTryOnPickedMode,
    tryOnVisibility: tryOnVisibility,
    setTryOnVisibility: setTryOnVisibility
  };
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    dataFetched = _useState8[0],
    setDataFetched = _useState8[1];
  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    switchToPDTool = _useState10[0],
    setSwitchToPDTool = _useState10[1];
  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    hasDataBeenFetched = _useState12[0],
    setHasDataBeenFetched = _useState12[1];
  var handleFrameReady = function handleFrameReady(sellerID, provider) {
    var _props$onReady;
    // conteggio view per billing
    store.tryOnCountView(sellerID, provider, tryOnPickedMode);
    (_props$onReady = props.onReady) === null || _props$onReady === void 0 ? void 0 : _props$onReady.call(props);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      mode: tryOnPickedMode,
      changeMode: function changeMode(mode) {
        setTryOnPickedMode(mode);
      },
      visible: tryOnVisibility,
      setVisible: function setVisible(visible) {
        setTryOnVisibility(visible);
      }
    }));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setSwitchToPDTool(!!props.switchable);
  }, [props.switchable]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      mode: tryOnPickedMode
    }));
  }, [tryOnPickedMode]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (tryOnVisibility) {
      if (hasDataBeenFetched && !switchToPDTool) setHasDataBeenFetched(false);
      console.log('fetching data');
      store.exportTryOnMeshToGlb().then(function (blob) {
        if (store.tryOnSellerSettings) {
          var product = store.tryOnProductSettings;
          var customer = store.tryOnSellerSettings;
          setDataFetched({
            product: product,
            customer: customer,
            provider: product.providerID,
            // forzo al momento a 3
            // provider: 3,
            mode: tryOnPickedMode,
            obj: blob,
            settings: store.tryOnMeshVisibleSettings
          });
          setTimeout(function () {
            setHasDataBeenFetched(true);
          }, 500);
        }
      });
    }
  }, [tryOnPickedMode, tryOnVisibility]);
  // Espongo i metodi esterni come reference per controllare il tryon/pd tool
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () {
    return {
      closeFrame: tryon.closeFrame,
      takeScreenshot: tryon.takeScreenshot,
      switchToPDTool: tryon.switchToPDTool,
      switchToTryOn: tryon.switchToTryOn,
      startPupillaryDistance: tryon.startPupillaryDistance,
      mode: tryon.mode,
      changeMode: tryon.changeMode,
      visible: tryon.visible,
      setVisible: tryon.setVisible
    };
  }, [tryon]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_hooks_tryonContext__WEBPACK_IMPORTED_MODULE_2__.TryOnContext.Provider, {
    value: frameRef
  }, tryOnVisibility && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, hasDataBeenFetched && tryOnPickedMode === _tryOnModels__WEBPACK_IMPORTED_MODULE_5__.TryOnMode.PDTool && !switchToPDTool && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(PupillaryDistanceView, {
    className: 'tryon-pd-tool' + (props.className ? ' ' + props.className : ''),
    provider: dataFetched.provider,
    product: dataFetched.product,
    customer: dataFetched.customer,
    onReady: function onReady() {
      return handleFrameReady(dataFetched.customer.sellerID, dataFetched.product.providerID);
    },
    onLoaded: props.onLoaded,
    onPDUpdated: props.onPDUpdated,
    onClose: props.onClose,
    onWebcamError: props.onWebcamError
  }), hasDataBeenFetched && (tryOnPickedMode === _tryOnModels__WEBPACK_IMPORTED_MODULE_5__.TryOnMode.TryOn || switchToPDTool) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(TryOnView, {
    className: 'tryon-view-tool' + (props.className ? ' ' + props.className : ''),
    provider: dataFetched.product.providerID,
    type: dataFetched.product.typeID,
    obj: dataFetched.obj,
    settings: store.tryOnMeshVisibleSettings,
    product: dataFetched.product,
    customer: dataFetched.customer,
    onPDUpdated: props.onPDUpdated,
    onReady: function onReady() {
      return handleFrameReady(dataFetched.customer.sellerID, dataFetched.product.providerID);
    },
    onLoaded: props.onLoaded,
    onClose: props.onClose,
    onWebcamError: props.onWebcamError
  }), props.children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(TryOnOverlay, null)));
});
var TryOnView = function TryOnView(props) {
  var _stateRef$current2;
  console.log(JSON.stringify(props, null, 2) + ' tryonview');
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_4__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = (_stateRef$current2 = stateRef.current) === null || _stateRef$current2 === void 0 ? void 0 : _stateRef$current2.state.environment;
  var pickViewer = function pickViewer() {
    var _store$tryOnProviders;
    var mappings = (_store$tryOnProviders = store.tryOnProvidersSettings) !== null && _store$tryOnProviders !== void 0 ? _store$tryOnProviders : {
      list: {}
    };
    var currentProvider = _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.NotSelected;
    console.log('currentProvider', currentProvider);
    if (mappings && mappings.list) {
      if (props.type.toString() in mappings.list) {
        currentProvider = mappings.list[props.type.toString()];
      }
    }
    switch (currentProvider) {
      case _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.Mazing:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnProviders_tryOnMazing__WEBPACK_IMPORTED_MODULE_8__.MazingTryOn, {
          obj: props.obj,
          className: props.className,
          product: props.product,
          customer: props.customer,
          fineTuningSettings: props.settings ? props.settings : _models__WEBPACK_IMPORTED_MODULE_3__.DefaultMazingFineTuningSettings,
          onReady: props.onReady,
          onLoaded: props.onLoaded,
          onClose: props.onClose,
          onPDUpdated: props.onPDUpdated,
          onWebcamError: props.onWebcamError
        });
      case _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.Banuba:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnProviders_tryOnBanuba__WEBPACK_IMPORTED_MODULE_6__.BanubaTryOn, {
          obj: props.obj,
          className: props.className,
          product: props.product,
          customer: props.customer,
          fineTuningSettings: props.settings ? props.settings : _models__WEBPACK_IMPORTED_MODULE_3__.DefaultBanubaFineTuningSettings,
          onReady: props.onReady,
          onLoaded: props.onLoaded,
          onClose: props.onClose,
          onPDUpdated: props.onPDUpdated,
          onWebcamError: props.onWebcamError
        });
      case _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.DeepAR:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnProviders_tryOnDeepAR__WEBPACK_IMPORTED_MODULE_7__.DeepARTryOn, {
          obj: props.obj,
          className: props.className,
          product: props.product,
          customer: props.customer,
          fineTuningSettings: props.settings ? props.settings : _models__WEBPACK_IMPORTED_MODULE_3__.DefaultDeepARFineTuningSettings,
          onReady: props.onReady,
          onLoaded: props.onLoaded,
          onClose: props.onClose,
          onPDUpdated: props.onPDUpdated,
          onWebcamError: props.onWebcamError
        });
      default:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, "Unsupported Type");
    }
  };
  return props && props.provider === _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.DeepAR && !(_zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_9__.IS_ANDROID || _zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_9__.IS_IOS) ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(TryOnViewContainer, {
    className: props.className ? props.className : '' + ' tryon-viewer'
  }, pickViewer());
};
var PupillaryDistanceView = function PupillaryDistanceView(props) {
  var pickViewer = function pickViewer() {
    switch (props.provider) {
      case _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.Mazing:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnProviders_tryOnMazing__WEBPACK_IMPORTED_MODULE_8__.MazingPupillaryDistance, {
          product: props.product,
          customer: props.customer,
          onPDUpdated: props.onPDUpdated,
          onReady: props.onReady,
          onLoaded: props.onLoaded,
          className: props.className,
          onClose: props.onClose,
          onWebcamError: props.onWebcamError
        });
      default:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, "Unsupported Provider");
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(PupillaryDistanceViewContainer, {
    className: props.className
  }, pickViewer());
};

/***/ }),

/***/ "./src/environment.tsx":
/*!*****************************!*\
  !*** ./src/environment.tsx ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeEnvironment": () => (/* binding */ ZakekeEnvironment)
/* harmony export */ });
/* harmony import */ var _zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @zakeke/zakeke-3d-core */ "./node_modules/@zakeke/zakeke-3d-core/dist/index.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! . */ "./src/index.tsx");
/* harmony import */ var _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased */ "../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx");
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./api */ "./src/api.ts");
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
/* harmony import */ var _fontsManager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./fontsManager */ "./src/fontsManager.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./helpers */ "./src/helpers.tsx");
/* harmony import */ var _imageUploadTask__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./imageUploadTask */ "./src/imageUploadTask.ts");
/* harmony import */ var _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./integrations/Integration */ "./src/integrations/Integration.ts");
/* harmony import */ var _integrations_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./integrations/helpers */ "./src/integrations/helpers.ts");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./models */ "./src/models.ts");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/// <reference path="../../../typescript_definitions/declarations/All.d.ts" />















var ZakekeEnvironment = /*#__PURE__*/function () {
  function ZakekeEnvironment() {
    var _this = this;
    _classCallCheck(this, ZakekeEnvironment);
    _defineProperty(this, "booted", false);
    _defineProperty(this, "platformAttributesSelection", []);
    _defineProperty(this, "previewWidth", 1024);
    _defineProperty(this, "previewHeight", 1024);
    _defineProperty(this, "clientPreviewWidth", 1024);
    _defineProperty(this, "clientPreviewHeight", 1024);
    _defineProperty(this, "shareUrlPrefix", null);
    _defineProperty(this, "events", []);
    _defineProperty(this, "zkProduct", null);
    _defineProperty(this, "zkScene", null);
    _defineProperty(this, "zkCurrentTemplate", null);
    _defineProperty(this, "zkTemplates", []);
    _defineProperty(this, "internalIsFullscreen", false);
    _defineProperty(this, "highlightSettings", null);
    _defineProperty(this, "previousMeshesVisibleStates", {});
    _defineProperty(this, "lastCameraLocation", null);
    _defineProperty(this, "enableShareCompositionUrl", false);
    _defineProperty(this, "sharedCompositionDocId", null);
    _defineProperty(this, "templateId", null);
    _defineProperty(this, "deepARsceneGLBUrl", '');
    _defineProperty(this, "loadedComposition", null);
    _defineProperty(this, "savedCompositions", null);
    _defineProperty(this, "isDraftEditor", false);
    _defineProperty(this, "isViewerMode", false);
    _defineProperty(this, "isDAMViewer", false);
    // if DAM viewer
    _defineProperty(this, "isTemplateEditor", false);
    _defineProperty(this, "debugMode", false);
    _defineProperty(this, "draftCompositionDocId", null);
    _defineProperty(this, "undoStack", []);
    _defineProperty(this, "redoStack", []);
    _defineProperty(this, "currentAttributesSelection", null);
    _defineProperty(this, "currentCompositionInfo", null);
    _defineProperty(this, "copyrightMessageLocalStorageKey", '');
    _defineProperty(this, "isPupillaryDistanceMandatory", false);
    _defineProperty(this, "isAIEnabled", false);
    _defineProperty(this, "sellerSettings", null);
    _defineProperty(this, "themeCompositions", null);
    _defineProperty(this, "currency", 'EUR');
    _defineProperty(this, "groups", []);
    _defineProperty(this, "fonts", []);
    _defineProperty(this, "disableTextColors", false);
    _defineProperty(this, "textColors", []);
    /**
     * Get the current text default color.
     */
    _defineProperty(this, "defaultColor", '');
    _defineProperty(this, "quantity", 1);
    _defineProperty(this, "quantityRule", null);
    _defineProperty(this, "culture", 'en-US');
    _defineProperty(this, "price", 0);
    _defineProperty(this, "isOutOfStock", false);
    _defineProperty(this, "compositionId", null);
    _defineProperty(this, "templates", []);
    _defineProperty(this, "currentTemplate", null);
    _defineProperty(this, "product", null);
    _defineProperty(this, "templateMacroCategories", null);
    _defineProperty(this, "selectedTemplateCategory", null);
    _defineProperty(this, "cameras", []);
    _defineProperty(this, "isExplodedMode", false);
    _defineProperty(this, "isAssetsLoading", false);
    _defineProperty(this, "additionalCustomProperties", []);
    _defineProperty(this, "nftSettings", null);
    _defineProperty(this, "eventMessages", null);
    _defineProperty(this, "personalizedMessages", null);
    _defineProperty(this, "visibleEventMessages", []);
    _defineProperty(this, "tryOnProvidersSettings", null);
    _defineProperty(this, "tryOnProductSettings", null);
    _defineProperty(this, "tryOnSellerSettings", null);
    _defineProperty(this, "pdSettings", -1);
    _defineProperty(this, "isInfoPointContentVisible", false);
    _defineProperty(this, "internalTranslations", {
      statics: [],
      dynamics: []
    });
    _defineProperty(this, "integrationVersion", 1);
    _defineProperty(this, "translations", null);
    _defineProperty(this, "useLegacyScreenshot", false);
    _defineProperty(this, "uiConfig", null);
    _defineProperty(this, "backgroundColor", null);
    _defineProperty(this, "removeBackground", false);
    _defineProperty(this, "parseParameters", function (parameters) {
      console.info('Parameters', parameters);
      var parseSecure = function parseSecure(value) {
        //return decodeURIComponent(fixedEncodeURIComponent(value.toString().replace(/\+/g, ' ')));
        return decodeURIComponent(value.toString().replaceAll('%', '').replace(/\+/g, '%20'));
      };
      var parseSingleParameter = function parseSingleParameter(key, value) {
        var _parseInt;
        if (!value) return;
        switch (key) {
          case 'name':
            _this.productName = parseSecure(value);
            break;
          case 'ecommerce':
            _this.platform = decodeURIComponent(value);
            break;
          case 'qty':
            _this.quantity = parseFloat(decodeURIComponent(value));
            break;
          case 'culture':
            _this.culture = decodeURIComponent(value);
            break;
          case 'currency':
            _this.currency = decodeURIComponent(value);
            break;
          case 'token':
            _this.token = decodeURIComponent(value);
            break;
          case 'compositionId':
            _this.compositionId = decodeURIComponent(value);
            break;
          case 'modelCode':
            _this.productCode = parseSecure(value);
            break;
          case 'previewWidth':
            _this.previewWidth = parseInt(parseSecure(value));
            break;
          case 'previewHeight':
            _this.previewHeight = parseInt(parseSecure(value));
            break;
          case 'shareUrlPrefix':
            _this.shareUrlPrefix = parseSecure(value);
            break;
          case 'sharedCompositionDocId':
            _this.sharedCompositionDocId = parseSecure(value);
            break;
          case 'templateId':
            _this.templateId = parseSecure(value);
            break;
          case 'isDraftEditor':
            _this.isDraftEditor = true;
            break;
          case 'enableShareCompositionUrl':
            _this.enableShareCompositionUrl = true;
            break;
          case 'draftCompositionDocId':
            _this.draftCompositionDocId = value;
            break;
          case 'viewerMode':
            _this.isViewerMode = true;
            break;
          case 'isTemplateEditor':
            _this.isTemplateEditor = true;
            break;
          case 'selectedTemplateCategory':
            _this.selectedTemplateCategory = parseSecure(value);
            break;
          case 'legacyScreenshot':
            _this.useLegacyScreenshot = value == '1';
            break;
          case 'integrationVersion':
            _this.integrationVersion = (_parseInt = parseInt(value)) !== null && _parseInt !== void 0 ? _parseInt : 1;
            break;
          case 'dam':
            _this.isDAMViewer = value == '1' || value == 'true';
            break;
          case 'debugMode':
            _this.debugMode = value == '1' || value == 'true';
            break;
        }
      };

      // From parameters or URL
      if (parameters) {
        for (var key in parameters) {
          var value = parameters[key];
          parseSingleParameter(key, value);

          // Attributes collection
          if (key.indexOf('attributes') == 0) {
            var _iterator = _createForOfIteratorHelper(value),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var attr = _step.value;
                // In some special cases, the plugin could pass empty options (e.g. seat and tools)
                // In this cases, ignore them and take the Zakeke one.
                if (attr[0].id === '' || attr[1].id === '') continue;

                // For each attribute/option
                _this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__.PlatformAttributeSelection(JSON.stringify(attr[0]), JSON.stringify(attr[1]), '', '', true, true));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }
      } else {
        var queryString = window.location.href.substring(window.location.href.lastIndexOf('?') + 1);
        var pieces = queryString.split('&');
        for (var i = 0; i < pieces.length; i++) {
          var index = pieces[i].indexOf('=');
          if (index == -1) {
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.ParametersParseFailException(pieces[i]);
          }
          var _key = decodeURIComponent(pieces[i].substring(0, index));
          var _value = pieces[i].substring(index + 1);
          parseSingleParameter(_key, _value);

          // Attributes collection
          if (_key.indexOf('attributes') == 0) {
            var data = decodeURIComponent(_value.replace(/\+/g, '%20'));
            if (data && data != '') {
              var json = JSON.parse(data);
              var _iterator2 = _createForOfIteratorHelper(json),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _attr = _step2.value;
                  // In some special cases, the plugin could pass empty options (e.g. seat and tools)
                  // In this cases, ignore them and take the Zakeke one.
                  if (_attr[0].id === '' || _attr[1].id === '') continue;
                  _this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__.PlatformAttributeSelection(JSON.stringify(_attr[0]), JSON.stringify(_attr[1]), '', '', true, true));
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          }
        }
      }

      // Parameter validation
      var requiredParams = {
        'culture (in xx_XX format)': _this.culture,
        currency: _this.currency,
        'name (product name)': _this.productName,
        ecommerce: _this.platform,
        'qty (product quantity)': _this.quantity,
        token: _this.token,
        modelCode: _this.productCode
      };
      for (var _key2 in requiredParams) {
        if (!requiredParams[_key2]) throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Missing parameter: ' + _key2);
      }
      window['token'] = _this.token;
      window['isOwin'] = true;
      return true;
    });
    // Get product
    _defineProperty(this, "getProduct", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!_this.productCode || _this.productCode == '')) {
              _context.next = 2;
              break;
            }
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Loading product but no SKU found');
          case 2:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var zkModel = new MPlaza.Model();
              zkModel.set('modelID', 1);
              zkModel.fetch({
                success: function success() {
                  resolve(zkModel);
                },
                error: function error() {
                  reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Failed loading product'));
                },
                data: {
                  c: _this.productCode
                }
              });
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    // Get scene
    _defineProperty(this, "getScene", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(product) {
        var zkScene;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (product) {
                _context2.next = 2;
                break;
              }
              throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Loading scene but no product found');
            case 2:
              if (!(product.get('scenes').length == 0)) {
                _context2.next = 4;
                break;
              }
              throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("The product don't have any scene configured");
            case 4:
              zkScene = new Zakeke.Scene();
              zkScene.set('sceneID', product.get('scenes').at(0).get('sceneID'));
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                zkScene.fetch({
                  success: function success(zkScene) {
                    resolve(zkScene);
                  },
                  error: function error() {
                    reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Failed loading scene'));
                  }
                });
              }));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    // Get composer models
    _defineProperty(this, "getComposerModels", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!_this.productCode || _this.productCode == '')) {
              _context3.next = 2;
              break;
            }
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Loading product but no SKU found');
          case 2:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var models = new Zakeke.ComposerModels();
              models.set('modelID', 1);
              models.fetch({
                success: function success() {
                  resolve(models);
                },
                error: function error() {
                  reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Failed loading product'));
                },
                data: {
                  c: _this.productCode
                }
              });
            }));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    // Get fonts
    _defineProperty(this, "getFonts", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _this$zkProduct$get$a, _this$zkProduct;
      var fonts, productFonts;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('fontfamilies/');
          case 2:
            fonts = _context4.sent.data;
            productFonts = (_this$zkProduct$get$a = (_this$zkProduct = _this.zkProduct) === null || _this$zkProduct === void 0 ? void 0 : _this$zkProduct.get('printTypes').at(0).get('fonts').map(function (x) {
              return x.get('fontFamilyID');
            })) !== null && _this$zkProduct$get$a !== void 0 ? _this$zkProduct$get$a : [];
            if (productFonts.length > 0) fonts = fonts.filter(function (font) {
              return productFonts.indexOf(font.fontFamilyID) != -1;
            });
            return _context4.abrupt("return", fonts);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    // Get settings
    _defineProperty(this, "getSettings", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var settings;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('customizerinfo/');
          case 2:
            settings = _context5.sent.data;
            return _context5.abrupt("return", settings);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    _defineProperty(this, "getSellerSetting", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", new Promise(/*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve, reject) {
                var sellerSetting;
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('sellerSetting/');
                    case 2:
                      sellerSetting = _context6.sent.data;
                      resolve(sellerSetting);
                    case 4:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return function (_x2, _x3) {
                return _ref7.apply(this, arguments);
              };
            }()));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    })));
    // Create quote for composition
    _defineProperty(this, "createQuote", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(formData) {
        var _name;
        var quote, quoteCreated;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              quote = new _models__WEBPACK_IMPORTED_MODULE_11__.Quote();
              quote.formData = JSON.stringify(formData);
              quote.quantity = _this.quantity;
              quote.compositionDocID = _this.composition.get('docID');
              _context8.next = 6;
              return _this.getPrice();
            case 6:
              quote.modelPrice = _context8.sent.price;
              quote.variantName = (_name = _this.product.name) !== null && _name !== void 0 ? _name : '';
              _context8.next = 10;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'quotes', quote);
            case 10:
              quoteCreated = _context8.sent.data;
              return _context8.abrupt("return", quoteCreated);
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function (_x4) {
        return _ref8.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getPrice", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var price, isOutOfStock, result, objectResult;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            price = 0;
            isOutOfStock = false;
            console.log('Get price from store (integration version ' + _this.integrationVersion + ')...');
            _context9.next = 5;
            return _this.integration.getPrice(_this.composition, _this.zkCurrentTemplate, _this.zkProduct, _this.platformAttributesSelection, _this.composition.getPrice(_this.zkProduct, _this.quantity), _this.settings.additionalFeatures.prices3dConfigurator, _this.settings.isPricingAdvancedEnabled, _this.quantity, 0);
          case 5:
            result = _context9.sent;
            if (_this.integrationVersion === 1) {
              price = result;
            } else if (_this.integrationVersion === 2) {
              objectResult = result;
              price = objectResult.price;
              isOutOfStock = objectResult.isOutOfStock;
            }
            console.log('Price from store: ' + price);
            return _context9.abrupt("return", {
              price: price,
              isOutOfStock: isOutOfStock
            });
          case 9:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    })));
    _defineProperty(this, "getTranslations", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var response;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('sellerLocalizations/customizer-localizations');
          case 3:
            response = _context10.sent;
            if (!response) {
              _context10.next = 8;
              break;
            }
            return _context10.abrupt("return", response.data);
          case 8:
            console.log('getTranslations response is empty');
          case 9:
            _context10.next = 14;
            break;
          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](0);
            console.error(_context10.t0);
          case 14:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[0, 11]]);
    })));
    _defineProperty(this, "loadLocalization", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      var lang;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            lang = _this.culture; // Try zh-TW
            if (Zakeke.config.avaibleLanguages.indexOf(lang) == -1) lang = _this.culture.substring(0, 2);

            // Try zh
            if (Zakeke.config.avaibleLanguages.lastIndexOf(lang) == -1) lang = 'en';
            _context11.next = 6;
            return _this.loadScript(Zakeke.config.localizationsUrl + "".concat(lang.toLowerCase(), "/composer.js"));
          case 6:
            _context11.next = 11;
            break;
          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11["catch"](0);
            console.error('Failed loading localization', _context11.t0);
          case 11:
          case "end":
            return _context11.stop();
        }
      }, _callee11, null, [[0, 8]]);
    })));
    _defineProperty(this, "getTemplateMacroCategories", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var response, categories;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('compositionmacrocategories');
          case 2:
            response = _context12.sent;
            categories = response.data.map(function (macroCategory) {
              var allCategories = macroCategory.category.map(function (category) {
                return {
                  categoryName: category.name,
                  categoryID: category.categoryID
                };
              });
              return {
                macroCategoryName: macroCategory.name,
                macroCategoryID: macroCategory.macroCategoryID,
                categories: allCategories
              };
            });
            return _context12.abrupt("return", categories);
          case 5:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    })));
    _defineProperty(this, "loadScript", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(src) {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.onload = resolve;
                script.src = src;
                document.body.appendChild(script);
              }));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return function (_x5) {
        return _ref13.apply(this, arguments);
      };
    }());
    _defineProperty(this, "validationNFTEmail", function (email) {
      var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return EMAIL_REGEX.test(email);
    });
    _defineProperty(this, "validationNFTWalletAddress", function (address) {
      var NFT_WALLET_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
      return NFT_WALLET_ADDRESS_REGEX.test(address);
    });
    _defineProperty(this, "saveCustomerWalletInfo", /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(docID, email, walletAddress) {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'customerwalletdocs', {
                email: email,
                walletAddress: walletAddress,
                zakekeEnvironment: 2,
                //configurator
                compositionDocID: docID
              });
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      return function (_x6, _x7, _x8) {
        return _ref14.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setCopyrightMessageAccepted", function (copyrightMandatoryCheckbox) {
      try {
        if (copyrightMandatoryCheckbox) window.localStorage.setItem(_this.copyrightMessageLocalStorageKey, copyrightMandatoryCheckbox.toString());else window.localStorage.removeItem(_this.copyrightMessageLocalStorageKey);
      } catch (e) {}
    });
    _defineProperty(this, "getCopyrightMessageAccepted", function () {
      var copyrightMessageAccepted = false;
      try {
        copyrightMessageAccepted = window.localStorage.getItem(_this.copyrightMessageLocalStorageKey) ? true : false;
      } catch (e) {}
      return copyrightMessageAccepted;
    });
    /**
     * @private
     */
    _defineProperty(this, "boot", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(parameters) {
        var _this$zkProduct2;
        var staticTranslations, dynamicTranslations, composerModels, statusID, event, _this$zkScene, _this$zkScene2, _this$zkScene2$get, _this$zkScene$get$get, _this$zkScene$get, _this$zkScene$get$get2, _this$zkScene$get$get3, _this$zkScene$get2, _this$zkScene$get$get4, _this$zkScene3, _this$zkScene3$get, _this$zkScene3$get$ge, _this$zkScene$get$get5, _this$zkScene4, _this$zkScene4$get, _this$zkScene4$get$ge, _this$zkScene5, _this$zkScene7, _this$zkScene7$getTry, _tryOnSettings$typeSe, promises, tryonPromises, tryOnSettings;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!_this.booted) {
                _context15.next = 2;
                break;
              }
              return _context15.abrupt("return");
            case 2:
              _this.booted = true;
              _this.parseParameters(parameters);
              (0,_api__WEBPACK_IMPORTED_MODULE_4__.setupApi)(_this.culture, _this.token);
              _context15.next = 7;
              return _this.loadLocalization();
            case 7:
              _context15.next = 9;
              return _this.getSettings();
            case 9:
              _this.settings = _context15.sent;
              _this.copyrightMessageLocalStorageKey = _this.settings.userID + '_copyright_accepted';
              _this.eventMessages = _this.settings.eventMessages.map(function (message) {
                return ___WEBPACK_IMPORTED_MODULE_2__.EventMessage.fromMessage(message);
              });
              console.log(_this.eventMessages, 'eventMessages');
              _this.nftSettings = _this.settings.nftSettings;
              _this.isAIEnabled = _this.settings.additionalFeatures.aiPoweredTools;
              _this.trigger('change');
              _context15.next = 18;
              return _this.getTranslations();
            case 18:
              _this.internalTranslations = _context15.sent;
              staticTranslations = new Map(_this.internalTranslations.statics.map(function (staticTranslation) {
                return [staticTranslation.original, staticTranslation.localization];
              }));
              dynamicTranslations = new Map(_this.internalTranslations.dynamics.map(function (staticTranslation) {
                return [staticTranslation.original, staticTranslation.localization];
              }));
              _this.translations = {
                statics: staticTranslations,
                dynamics: dynamicTranslations
              };
              _helpers__WEBPACK_IMPORTED_MODULE_7__.T.translations = _this.translations;
              _this.trigger('change');
              _context15.next = 26;
              return _this.getComposerModels();
            case 26:
              composerModels = _context15.sent;
              if (!composerModels.get('scene').get('config')) composerModels.set('config', composerModels.get('model').get('sceneConfig'));
              _this.zkScene = composerModels.get('scene');
              _this.zkProduct = composerModels.get('model');
              statusID = (_this$zkProduct2 = _this.zkProduct) === null || _this$zkProduct2 === void 0 ? void 0 : _this$zkProduct2.get('statusID');
              console.log('sono prima del customEvent', statusID);
              if (!(statusID === 2 && _this.zkScene && _this.zkScene.get('url') && _this.zkScene.get('url').endsWith('.glb') || statusID === 2 && !_this.isShoppingPreview)) {
                _context15.next = 38;
                break;
              }
              console.log('Product unpublished, triggering event');
              event = new CustomEvent('productUnpublished', {
                detail: {
                  statusID: statusID
                }
              });
              window.dispatchEvent(event);
              _context15.next = 80;
              break;
            case 38:
              // fill the uiconfig with zkscene config url loader and ar icon
              if ((_this$zkScene = _this.zkScene) !== null && _this$zkScene !== void 0 && _this$zkScene.get('config') && (_this$zkScene2 = _this.zkScene) !== null && _this$zkScene2 !== void 0 && (_this$zkScene2$get = _this$zkScene2.get('config')) !== null && _this$zkScene2$get !== void 0 && _this$zkScene2$get.get('uiConfig')) _this.uiConfig = {
                urlLoader: (_this$zkScene$get$get = (_this$zkScene$get = _this.zkScene.get('config')) === null || _this$zkScene$get === void 0 ? void 0 : (_this$zkScene$get$get2 = _this$zkScene$get.get('uiConfig')) === null || _this$zkScene$get$get2 === void 0 ? void 0 : _this$zkScene$get$get2.get('urlLoader')) !== null && _this$zkScene$get$get !== void 0 ? _this$zkScene$get$get : '',
                urlARIcon: (_this$zkScene$get$get3 = (_this$zkScene$get2 = _this.zkScene.get('config')) === null || _this$zkScene$get2 === void 0 ? void 0 : _this$zkScene$get2.get('uiConfig').get('urlARIcon')) !== null && _this$zkScene$get$get3 !== void 0 ? _this$zkScene$get$get3 : ''
              };
              _this.backgroundColor = (_this$zkScene$get$get4 = (_this$zkScene3 = _this.zkScene) === null || _this$zkScene3 === void 0 ? void 0 : (_this$zkScene3$get = _this$zkScene3.get('config')) === null || _this$zkScene3$get === void 0 ? void 0 : (_this$zkScene3$get$ge = _this$zkScene3$get.get('general')) === null || _this$zkScene3$get$ge === void 0 ? void 0 : _this$zkScene3$get$ge.get('backgroundColor')) !== null && _this$zkScene$get$get4 !== void 0 ? _this$zkScene$get$get4 : null;
              _this.removeBackground = (_this$zkScene$get$get5 = (_this$zkScene4 = _this.zkScene) === null || _this$zkScene4 === void 0 ? void 0 : (_this$zkScene4$get = _this$zkScene4.get('config')) === null || _this$zkScene4$get === void 0 ? void 0 : (_this$zkScene4$get$ge = _this$zkScene4$get.get('general')) === null || _this$zkScene4$get$ge === void 0 ? void 0 : _this$zkScene4$get$ge.get('removeDefaultBackground')) !== null && _this$zkScene$get$get5 !== void 0 ? _this$zkScene$get$get5 : false;
              if ((_this$zkScene5 = _this.zkScene) !== null && _this$zkScene5 !== void 0 && _this$zkScene5.get('config')) _this.product = _models__WEBPACK_IMPORTED_MODULE_11__.Product.fromProduct(_this.zkProduct);
              _this.quantityRule = _this.zkProduct.get('quantityRule') ? _models__WEBPACK_IMPORTED_MODULE_11__.ProductQuantityRule.fromQuantityRule(_this.zkProduct.get('quantityRule')) : null;
              promises = [_this.getSettings(), _this.getTranslations(), (0,_integrations_helpers__WEBPACK_IMPORTED_MODULE_10__.integrationFor)(_this.platform), _this.getSellerSetting(), _this.getTemplateMacroCategories(), _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__.DesignPriceCalculatorRuleFactory.create(_this.zkProduct, Zakeke.config.baseApiUrl, _this.token, true, Zakeke.config.cloudFlareApiUrl), _this.getFonts(), _this.getTemplates(), _this.getMessagesByProductCode(_this.productCode)];
              if (_this.zkScene && _this.zkScene.get('config') && _this.zkScene.getTryOnEnabled()) {
                tryonPromises = [_this.getTryOnProvidersList(), _this.getTryOnProductInfo()];
                promises.push.apply(promises, tryonPromises);
              }
              _context15.next = 47;
              return Promise.all(promises).then(function (_ref16) {
                var _this$zkScene$get$map, _this$zkScene6;
                var _ref17 = _slicedToArray(_ref16, 9),
                  customizerInfo = _ref17[0],
                  translations = _ref17[1],
                  integration = _ref17[2],
                  sellerSettings = _ref17[3],
                  templateMacroCategories = _ref17[4],
                  pricingCalculator = _ref17[5],
                  fonts = _ref17[6],
                  zkTemplates = _ref17[7],
                  personalizedMessages = _ref17[8];
                _this.settings = customizerInfo;
                _this.copyrightMessageLocalStorageKey = _this.settings.userID + '_copyright_accepted';
                _this.eventMessages = _this.settings.eventMessages.map(function (message) {
                  return ___WEBPACK_IMPORTED_MODULE_2__.EventMessage.fromMessage(message);
                });
                _this.nftSettings = _this.settings.nftSettings;
                _this.internalTranslations = translations;
                console.log(personalizedMessages, 'personalizedMessages');
                _this.personalizedMessages = personalizedMessages;
                var staticTranslations = new Map(_this.internalTranslations.statics.map(function (staticTranslation) {
                  return [staticTranslation.original, staticTranslation.localization];
                }));
                var dynamicTranslations = new Map(_this.internalTranslations.dynamics.map(function (staticTranslation) {
                  return [staticTranslation.original, staticTranslation.localization];
                }));
                _this.translations = {
                  statics: staticTranslations,
                  dynamics: dynamicTranslations
                };
                _helpers__WEBPACK_IMPORTED_MODULE_7__.T.translations = _this.translations;
                _this.integration = integration;
                _this.sellerSettings = sellerSettings ? _models__WEBPACK_IMPORTED_MODULE_11__.SellerSettings.fromSellerSettings(sellerSettings) : null;
                _this.templateMacroCategories = templateMacroCategories;
                _this.pricingCalculator = pricingCalculator;
                if (_this.zkProduct.get('colors').length > 0) {
                  _this.pricingCalculator.colorID = _this.zkProduct.get('colors').at(0).get('colorID');
                }
                _this.integration.setPricingCalculator(_this.pricingCalculator);
                _this.fonts = fonts;
                var restriction = _this.getPrintingMethodsRestrictions();
                _this.defaultColor = restriction.defaultColor;
                _this.disableTextColors = restriction.disableTextColors;
                _this.textColors = restriction.textColors;
                _this.zkTemplates = zkTemplates;
                _this.templates = _this.zkTemplates.map(function (zkTemplate) {
                  return _models__WEBPACK_IMPORTED_MODULE_11__.Template.fromTemplate(zkTemplate);
                });
                _this.cameras = (_this$zkScene$get$map = (_this$zkScene6 = _this.zkScene) === null || _this$zkScene6 === void 0 ? void 0 : _this$zkScene6.get('cameraLocations').map(function (x) {
                  return _models__WEBPACK_IMPORTED_MODULE_11__.Camera.fromZkCamera(x);
                })) !== null && _this$zkScene$get$map !== void 0 ? _this$zkScene$get$map : [];
                if (_this.tryOnProductSettings) _this.getTryOnSellerInfo(_this.tryOnProductSettings.typeID, _this.tryOnProductSettings.providerID);
              });
            case 47:
              if (_this.zkScene) {
                _context15.next = 49;
                break;
              }
              throw new Error('Product has no 3D scene.');
            case 49:
              if (_this.debugMode) _this.trigger('debugMode');
              _this.trigger('change');
              _context15.next = 53;
              return _zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_0__.SceneViewer.createSceneViewerAsync({
                isViewer: _this.isDAMViewer
              });
            case 53:
              _this.viewer = _context15.sent;
              _this.trigger('viewer', _this.viewer);
              _this.viewer.isHologramSource = true;
              _this.viewer.addInfoPointPickedListener(function () {
                _this.isInfoPointContentVisible = true;
                _this.trigger('change');
              });
              _this.viewer.addInfoPointContentHiddenListener(function () {
                _this.isInfoPointContentVisible = false;
                _this.trigger('change');
              });
              _this.viewer.addBeginAssetsLoadingListener(function () {
                _this.isAssetsLoading = true;
                _this.trigger('change');
              });
              _this.viewer.addEndAssetsLoadingListener(function () {
                _this.isAssetsLoading = false;
                _this.trigger('change');
              });
              if (_this.highlightSettings) {
                _this.viewer.highlightColor = _this.highlightSettings.color;
                _this.viewer.highlightSize = _this.highlightSettings.size;
              }
              _this.viewer.setLoadingScreen({
                displayLoadingUI: function displayLoadingUI() {
                  return null;
                },
                hideLoadingUI: function hideLoadingUI() {
                  return null;
                },
                loadingUIBackgroundColor: 'black',
                loadingUIText: 'black'
              });
              _this.viewer.infoPointsManagerStyle = {
                imagePanelStyle: {
                  backgroundColor: 'white',
                  loadingTextColor: '#cccccc',
                  buttonsBorderColor: '#dddddd',
                  buttonsBorderHighlightColor: '#eeeeee',
                  buttonsColor: '#888888',
                  buttonsHighlightColor: '#555555',
                  buttonsIconColor: 'white'
                }
              };

              // Set transparent background
              // this.zkScene.getOrCreateEnvironmentConfig().set('mainColor', '#000000');
              // this.zkScene.getOrCreateGeneralConfig().set('backgroundColor', '#000000');
              // this.zkScene.getOrCreateGeneralConfig().set('backgroundAlpha', 0);

              // Pricing calculator
              _context15.next = 65;
              return _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__.DesignPriceCalculatorRuleFactory.create(_this.zkProduct, Zakeke.config.baseApiUrl, _this.token, true, Zakeke.config.cloudFlareApiUrl);
            case 65:
              _this.pricingCalculator = _context15.sent;
              if (_this.zkProduct.get('colors').length > 0) {
                _this.pricingCalculator.colorID = _this.zkProduct.get('colors').at(0).get('colorID');
                _this.integration.setPricingCalculator(_this.pricingCalculator);
              }
              if (!(_this.zkScene && _this.zkScene.get('url') && _this.zkScene.get('url').endsWith('.glb'))) {
                _context15.next = 72;
                break;
              }
              _context15.next = 70;
              return _this.loadSceneFromGlbUrl(_this.zkScene.get('url'), _this.zkScene.get('config'));
            case 70:
              _context15.next = 74;
              break;
            case 72:
              _context15.next = 74;
              return _this.viewer.loadSceneFromModelAsync(_this.zkProduct, _this.zkScene);
            case 74:
              if (_this.settings.brand) _this.viewer.createBrandLogoButton();
              tryOnSettings = (_this$zkScene7 = _this.zkScene) === null || _this$zkScene7 === void 0 ? void 0 : (_this$zkScene7$getTry = _this$zkScene7.getTryOnSettings) === null || _this$zkScene7$getTry === void 0 ? void 0 : _this$zkScene7$getTry.call(_this$zkScene7);
              if (tryOnSettings !== null && tryOnSettings !== void 0 && (_tryOnSettings$typeSe = tryOnSettings.typeSettings) !== null && _tryOnSettings$typeSe !== void 0 && _tryOnSettings$typeSe.mandatoryPD) _this.isPupillaryDistanceMandatory = true;
              _this.trigger('change');
              _context15.next = 80;
              return _this.handleSceneLoaded();
            case 80:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return function (_x9) {
        return _ref15.apply(this, arguments);
      };
    }());
    _defineProperty(this, "buildDeepARSceneGLBUrl", function (config) {
      var finalUrl = Zakeke.config.deepARSettings.url + '?fileUrl=' + encodeURIComponent(_this.zkScene.get('url'));
      var settings = _this.tryOnMeshVisibleSettings || ___WEBPACK_IMPORTED_MODULE_2__.DefaultDeepARFineTuningSettings;
      var model = config.model;
      var queryParams = new URLSearchParams({
        positionX: settings.position.x.toString(),
        positionY: settings.position.y.toString(),
        positionZ: settings.position.z.toString(),
        rotationX: config.model.rotation.x.toString(),
        rotationY: config.model.rotation.y.toString(),
        rotationZ: config.model.rotation.z.toString(),
        scale: settings.scale.toString(),
        environment: settings.environment.toString(),
        modelPositionX: model.position.x.toString(),
        modelPositionY: model.position.y.toString(),
        modelPositionZ: model.position.z.toString(),
        modelScale: model.scale.x.toString()
      });
      console.log('buildDeepARSceneGLBUrl con nuovi param model ', model.position.x, model.position.y, model.position.z, model.scale.x);
      finalUrl = "".concat(finalUrl, "&").concat(queryParams.toString(), "&isDesktopDeepARUrl=true");
      console.log('sono finalUrl', finalUrl);
      return finalUrl;
    });
    _defineProperty(this, "loadSceneFromGlbUrl", /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(glbUrl, sceneConfig) {
        var config;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              config = sceneConfig.toJSON();
              console.log(config, 'config scena');
              _this.deepARsceneGLBUrl = _this.buildDeepARSceneGLBUrl(config);
              _context16.next = 5;
              return _this.viewer.loadFromGlbUrl(glbUrl, config);
            case 5:
              if (_this.isDAMViewer) {
                _this.makeDAMAnalyticsView(_models__WEBPACK_IMPORTED_MODULE_11__.DAMViewerAnalyticsEventType.ViewProduct);
              }
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      return function (_x10, _x11) {
        return _ref18.apply(this, arguments);
      };
    }());
    _defineProperty(this, "appendViewer", function (container) {
      if (_this.viewer) _this.viewer.appendTo(container);
      _this.viewer.updateView(true, true);
    });
    _defineProperty(this, "setHighlightSettings", function (settings) {
      _this.highlightSettings = settings;
      if (_this.viewer) {
        _this.viewer.highlightColor = settings.color;
        _this.viewer.highlightSize = settings.size;
      }
    });
    /*public renderDesign = _.throttle(async () => {
    	if (this.viewer && this.zkCurrentTemplate) {
    		await this.viewer.renderDesignAsync(this.zkCurrentTemplate);
    		this.fireItemsChange();
    	}
    }, 300);*/
    _defineProperty(this, "renderDesign", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            if (!(_this.viewer && _this.zkCurrentTemplate)) {
              _context17.next = 4;
              break;
            }
            _context17.next = 3;
            return _this.viewer.renderDesignAsync(_this.zkCurrentTemplate);
          case 3:
            _this.debouncedChange();
          case 4:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    })));
    _defineProperty(this, "debouncedChange", (0,lodash__WEBPACK_IMPORTED_MODULE_1__.debounce)(function () {
      return _this.trigger('change');
    }, 300));
    _defineProperty(this, "restoreLastCameraLocation", function () {
      if (!_this.viewer) return;

      //this.viewer.updateView(false);

      // Restore last camera location
      if (_this.lastCameraLocation && _this.lastCameraLocation !== Zakeke.getEmptyUUID()) {
        console.log('Restoring last camera location ' + _this.lastCameraLocation + ' ...');
        _this.setCamera(_this.lastCameraLocation, false, false);
      } else {
        _this.viewer.adjustCamera(false);
      }
    });
    _defineProperty(this, "buildRecapProps", lodash__WEBPACK_IMPORTED_MODULE_1___default().debounce(function (selectedOptions) {
      if (!_this.sellerSettings || !_this.sellerSettings.isCompositionRecapEnabled) return;
      var storeAttr = _this.zkProduct.get('attributes');
      var storeGroups = _this.zkProduct.get('attributeGroups');
      var storeSteps = _this.zkProduct.get('attributeSteps');
      var recapProps = {};
      selectedOptions.forEach(function (item) {
        var _this$selection;
        var currentAttr = storeAttr.find(function (attr) {
          return attr.get('attributeID') == item.attributeID;
        });
        var currentOption = currentAttr.get('options').find(function (opt) {
          return opt.get('optionID') == item.optionID;
        });
        var currentGroup = storeGroups.find(function (group) {
          return group.get('groupID') == currentAttr.get('groupID');
        });
        var currentStep = storeSteps.find(function (step) {
          return step.get('stepID') == currentAttr.get('stepID');
        });
        var label = '';
        var isOptionEnabled = false;
        (_this$selection = _this.selection) === null || _this$selection === void 0 ? void 0 : _this$selection.get('groups').each(function (group) {
          group.get('attributes').each(function (attr) {
            var option = attr.get('options').find(function (x) {
              return x.get('optionID') == currentOption.get('optionID');
            });
            if (option && attr.get('enabled')) {
              var _currentGroup$get, _currentStep$get, _currentAttr$get, _currentOption$get;
              isOptionEnabled = _this.isOptionEnabled(currentOption.get('optionID'));
              label = group.get('groupID') !== -1 ? _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(group.get('name')) + ' ' + _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentAttr.get('name')) : _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentAttr.get('name'));
              recapProps["".concat(label)] = {
                groupDisplayOrder: (_currentGroup$get = currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.get('displayOrder')) !== null && _currentGroup$get !== void 0 ? _currentGroup$get : 0,
                stepDisplayOrder: (_currentStep$get = currentStep === null || currentStep === void 0 ? void 0 : currentStep.get('displayOrder')) !== null && _currentStep$get !== void 0 ? _currentStep$get : 0,
                attributeDisplayOrder: (_currentAttr$get = currentAttr === null || currentAttr === void 0 ? void 0 : currentAttr.get('displayOrder')) !== null && _currentAttr$get !== void 0 ? _currentAttr$get : 0,
                optionDisplayOrder: (_currentOption$get = currentOption === null || currentOption === void 0 ? void 0 : currentOption.get('displayOrder')) !== null && _currentOption$get !== void 0 ? _currentOption$get : 0,
                value: _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentOption.get('name'))
              };
            }
          });
        });
      });
      _this.currentAttributesSelection = recapProps;
    }, 200));
    _defineProperty(this, "updateRecapAndExtensionField", function () {
      var _this$selection2;
      var selectedOptions = [];
      (_this$selection2 = _this.selection) === null || _this$selection2 === void 0 ? void 0 : _this$selection2.getAllAttributeSelections().forEach(function (attribute) {
        attribute.get('options').forEach(function (option) {
          if (option.get('selected')) {
            selectedOptions.push({
              attributeID: option.get('attributeID'),
              optionID: option.get('optionID')
            });
          }
        });
      });
      _this.getCurrentExtensionFields(selectedOptions);
      _this.buildRecapProps(selectedOptions);
      _this.trigger('change');
    });
    _defineProperty(this, "getCurrentExtensionFields", function (options) {
      var propsValues = [];
      var propsMap = {};
      var storeAttr = _this.zkProduct.get('attributes');
      options.forEach(function (item) {
        var currentAttr = storeAttr.find(function (attr) {
          return attr.get('attributeID') == item.attributeID;
        });
        var currentOption = currentAttr.get('options').find(function (opt) {
          return opt.get('optionID') == item.optionID;
        });
        if (currentOption.get('extensionFields').length) {
          currentOption.get('extensionFields').forEach(function (item) {
            if (propsValues.length === 0 || propsValues.indexOf(item.name) == -1) {
              propsValues.push(item.name);
              propsMap[item.name] = {
                value: 0,
                label: item.label,
                formatString: item.formatString
              };
            }
            var val;
            if (item.dataTypeID === _models__WEBPACK_IMPORTED_MODULE_11__.ExtensionFieldDataType.Integer) {
              val = parseInt(item.value);
            } else {
              val = parseFloat(item.value);
            }
            propsMap[item.name].value += val;
          });
        }
      });
      var itemsArray = Object.keys(propsMap).map(function (key) {
        return propsMap[key];
      });
      _this.additionalCustomProperties = itemsArray;
    });
    _defineProperty(this, "handleSceneLoaded", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
      var currentCompositionId, _this$sellerSettings, _this$sellerSettings2;
      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            // window.addEventListener('resize', this.resize);

            console.log('Scene loaded');
            _this.selection = Zakeke.ComposerSelection.CreateComposerSelection(_this.zkProduct);
            currentCompositionId = _this.templateId || _this.draftCompositionDocId || _this.sharedCompositionDocId || _this.compositionId;
            if (_this.initialSelection == undefined) {
              _this.initialSelection = _this.cloneSelection(_this.selection);
            }
            _context18.next = 6;
            return _this.internalLoadComposition(currentCompositionId);
          case 6:
            _this.trigger('change');
            _this.buildStructure();

            // Trigger quantity update
            _this.setQuantity(_this.quantity);
            _this.renderDesign();
            _this.viewer.addNotifyMessageListener(function (areaID, itemGuid, type, title, message, closabled, requiredWidth, requiredHeight, addToCartDisabledIfVisible) {
              _this.visibleEventMessages.push({
                areaID: areaID,
                itemGuid: itemGuid,
                type: type,
                title: title,
                message: message,
                closabled: closabled,
                requiredWidth: requiredWidth,
                requiredHeight: requiredHeight,
                addToCartDisabledIfVisible: addToCartDisabledIfVisible
              });
              _this.trigger('change');
            });
            _this.viewer.addRemoveMessageListener(function (areaID, itemGuid) {
              _this.visibleEventMessages = _this.visibleEventMessages.filter(function (x) {
                return x.areaID !== areaID && x.itemGuid !== itemGuid;
              });
              _this.trigger('change');
            });
            _this.viewer.setEventMessages(_this.settings.eventMessages.map(function (x) {
              return {
                AddToCartDisabledIfVisible: x.addToCartDisabledIfVisible,
                AdditionalData: x.additionalData,
                Closeable: x.closeable,
                Description: x.description,
                EnableCheckForSellerImages: x.enableCheckForSellerImages,
                EventID: x.eventID,
                Visible: x.visible
              };
            }));
            if (_this.sellerSettings) {
              _this.addHotjarScript((_this$sellerSettings = _this.sellerSettings) === null || _this$sellerSettings === void 0 ? void 0 : _this$sellerSettings.hotjarSiteID);
              _this.addGoogleTagManagerID((_this$sellerSettings2 = _this.sellerSettings) === null || _this$sellerSettings2 === void 0 ? void 0 : _this$sellerSettings2.googleTagManagerID);
            }
            if (_this.sharedCompositionDocId) {
              _this.composition.set('docID', null);
              _this.composition.set('designDocID', null);
            }
            _this.registerView();
            if (_this.isTemplateEditor) {
              _context18.next = 19;
              break;
            }
            _context18.next = 19;
            return _this.updateSavedCompositions();
          case 19:
            setTimeout(function () {
              return _this.updateRecapAndExtensionField();
            }, 1000);
          case 20:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    })));
    _defineProperty(this, "getComposition", /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(id) {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", new Promise(function (resolve, reject) {
                var composition = new MPlaza.Composition();
                composition.set('docID', id);
                composition.fetch({
                  success: function success(model) {
                    resolve(model);
                  },
                  error: function error() {
                    reject();
                  },
                  data: {
                    frombackoffice: _this.isDraftEditor ? true : false
                  }
                });
              }));
            case 1:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      return function (_x12) {
        return _ref21.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getDesign", /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(id) {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", new Promise(function (resolve, reject) {
                var design = new MPlaza.Design();
                design.set('docID', id);
                design.fetch({
                  success: function success(model) {
                    resolve(model);
                  },
                  error: function error() {
                    reject();
                  },
                  data: {
                    frombackoffice: _this.isDraftEditor ? true : false
                  }
                });
                design.addEventListener('change', _this.updatePrice);
              }));
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x13) {
        return _ref22.apply(this, arguments);
      };
    }());
    _defineProperty(this, "internalLoadDesign", /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(id) {
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return _this.getDesign(_this.composition.get('designDocID'));
            case 2:
              _this.zkCurrentTemplate = _context21.sent;
              _context21.next = 5;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.downloadFontsOfDesign)(_this.zkCurrentTemplate, _this.fonts);
            case 5:
              _this.renderDesign();
            case 6:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
      return function (_x14) {
        return _ref23.apply(this, arguments);
      };
    }());
    _defineProperty(this, "loadComposition", /*#__PURE__*/function () {
      var _ref24 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(id) {
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return _this.internalLoadComposition(id);
            case 2:
              _this.buildStructure();
            case 3:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
      return function (_x15) {
        return _ref24.apply(this, arguments);
      };
    }());
    _defineProperty(this, "internalLoadComposition", /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(id) {
        var _iterator3, _step3, _loop;
        return _regeneratorRuntime().wrap(function _callee23$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (!id) {
                _context24.next = 16;
                break;
              }
              _context24.next = 3;
              return _this.getComposition(id);
            case 3:
              _this.composition = _context24.sent;
              if (_this.templateId) {
                _this.loadedComposition = {
                  templateName: _this.composition.get('name'),
                  attributesOptions: _this.composition.get('compositionItems').map(function (compositionItem) {
                    return {
                      attributeID: compositionItem.get('attributeID'),
                      optionID: compositionItem.get('selectedOptionID')
                    };
                  }),
                  selectedCategoryID: _this.composition.get('categories').length > 0 ? _this.composition.get('categories').at(0).get('categoryID') : null
                };
              }
              _this.selection.setupOnComposition(_this.composition);
              if (!_this.composition.get('designDocID')) {
                _context24.next = 11;
                break;
              }
              _context24.next = 9;
              return _this.internalLoadDesign(_this.composition.get('designDocID'));
            case 9:
              _context24.next = 14;
              break;
            case 11:
              if (!(_this.templates.length > 0)) {
                _context24.next = 14;
                break;
              }
              _context24.next = 14;
              return _this.setTemplate(_this.templates[0].id);
            case 14:
              _context24.next = 36;
              break;
            case 16:
              _this.composition = _this.selection.buildComposition();
              // Select initial values from platform
              _iterator3 = _createForOfIteratorHelper(_this.platformAttributesSelection);
              _context24.prev = 18;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var platformSelection;
                return _regeneratorRuntime().wrap(function _loop$(_context23) {
                  while (1) switch (_context23.prev = _context23.next) {
                    case 0:
                      platformSelection = _step3.value;
                      // Search the attribute
                      _this.zkProduct.get('attributes').each(function (attribute) {
                        if ((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(attribute.get('attributeCode'))) {
                          try {
                            if ((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.compare)(JSON.parse(attribute.get('attributeCode')), JSON.parse(platformSelection.attributeCode))) {
                              var option = attribute.get('options').find(function (option) {
                                return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.compare)(JSON.parse(option.get('optionCode')), JSON.parse(platformSelection.optionCode));
                              });
                              if (option) {
                                _this.selection.selectAttributeValue(attribute.get('attributeID'), option.get('optionID').toString());

                                // Update here the labels because events are not attached yet (attached below)
                                platformSelection.attributeLabel = attribute.get('name');
                                platformSelection.optionLabel = option.get('name');
                              }
                            }
                          } catch (ex) {
                            console.error('Failed parsing attribute from data:', platformSelection);
                            console.error(ex);
                          }
                        }
                      });
                    case 2:
                    case "end":
                      return _context23.stop();
                  }
                }, _loop);
              });
              _iterator3.s();
            case 21:
              if ((_step3 = _iterator3.n()).done) {
                _context24.next = 25;
                break;
              }
              return _context24.delegateYield(_loop(), "t0", 23);
            case 23:
              _context24.next = 21;
              break;
            case 25:
              _context24.next = 30;
              break;
            case 27:
              _context24.prev = 27;
              _context24.t1 = _context24["catch"](18);
              _iterator3.e(_context24.t1);
            case 30:
              _context24.prev = 30;
              _iterator3.f();
              return _context24.finish(30);
            case 33:
              if (!(_this.templates.length > 0)) {
                _context24.next = 36;
                break;
              }
              _context24.next = 36;
              return _this.setTemplate(_this.templates[0].id);
            case 36:
              _context24.next = 38;
              return _this.sync3DAndPlatformSelectionWithCurrentSelection();
            case 38:
              _this.updateComposition();
              _this.updateRecapAndExtensionField();
            case 40:
            case "end":
              return _context24.stop();
          }
        }, _callee23, null, [[18, 27, 30, 33]]);
      }));
      return function (_x16) {
        return _ref25.apply(this, arguments);
      };
    }());
    _defineProperty(this, "sync3DAndPlatformSelectionWithCurrentSelection", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
      var script;
      return _regeneratorRuntime().wrap(function _callee24$(_context25) {
        while (1) switch (_context25.prev = _context25.next) {
          case 0:
            // Add all composition attributes to the platformAttributes that we will send to the plugin
            _this.selection.get('groups').each(function (group) {
              group.get('attributes').each(function (attribute) {
                // Here we check if this attributes was already passed from the parameters.
                // If yes, we ignore it because the correct value was already selected in the previous rows.
                // else we add it to the list of attributes selections

                var oldAttribute = _this.platformAttributesSelection.find(function (x) {
                  return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attribute.get('attributeCode'));
                });
                if (!oldAttribute) {
                  var selectedOption = attribute.get('options').findWhere({
                    selected: true
                  });
                  if (selectedOption) _this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__.PlatformAttributeSelection(attribute.get('attributeCode'), selectedOption.get('optionCode'), attribute.get('name'), selectedOption.get('name'), attribute.get('enabled'), selectedOption.get('enabled')));
                }
              });
            });
            script = _this.selection.getAllAttributeTransformationScript();
            _this.viewer.adjustCamera(false);
            _context25.next = 5;
            return _this.viewer.executeScriptAsync(script);
          case 5:
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
          case 10:
          case "end":
            return _context25.stop();
        }
      }, _callee24);
    })));
    _defineProperty(this, "cloneSelection", function (selection) {
      var clone = new Zakeke.ComposerSelection();
      clone.set('zkModel', _this.zkProduct);
      clone.set('attributeDependencies', selection.get('attributeDependencies'));
      clone.set('optionDependencies', selection.get('optionDependencies'));
      clone.get('groups').reset();
      selection.get('groups').each(function (group) {
        var cloneGroup = new Zakeke.AttributeGroupSelection();
        for (var key in group.attributes) {
          cloneGroup.set(key, group.attributes[key]);
        }
        clone.get('groups').add(cloneGroup);
      });
      var idx = 0;
      clone.get('groups').each(function (group) {
        group.set('attributes', selection.get('groups').at(idx).get('attributes').clone());
        group.get('attributes').reset();
        selection.get('groups').at(idx).get('attributes').each(function (attribute) {
          var cloneAttribute = new Zakeke.AttributeSelection();
          for (var key in attribute.attributes) {
            cloneAttribute.set(key, attribute.attributes[key]);
          }
          group.get('attributes').add(cloneAttribute);
        });
        var idx2 = 0;
        group.get('attributes').each(function (attribute) {
          attribute.set('options', selection.get('groups').at(idx).get('attributes').at(idx2).get('options').clone());
          attribute.get('options').reset();
          selection.get('groups').at(idx).get('attributes').at(idx2).get('options').each(function (option) {
            var cloneOption = new Zakeke.OptionSelection();
            for (var key in option.attributes) {
              cloneOption.set(key, option.attributes[key]);
            }
            attribute.get('options').add(cloneOption);
          });
          idx2++;
        });
        idx++;
      });
      return clone;
    });
    _defineProperty(this, "undo", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
      var selection, script;
      return _regeneratorRuntime().wrap(function _callee25$(_context26) {
        while (1) switch (_context26.prev = _context26.next) {
          case 0:
            selection = _this.undoStack && _this.undoStack.length > 0 ? _this.undoStack.pop() : null;
            if (selection) {
              _context26.next = 3;
              break;
            }
            return _context26.abrupt("return");
          case 3:
            _this.redoStack.push(_this.selection);
            _this.selection = selection;
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            _this.selection.attachEvents();
            script = _this.selection.getAllAttributeTransformationScript();
            _context26.next = 14;
            return _this.viewer.executeScriptAsync(script);
          case 14:
            _this.buildStructure();
            _this.resetPlatformAttributesSelection();
            _this.updateComposition();
            _this.updateRecapAndExtensionField();
          case 18:
          case "end":
            return _context26.stop();
        }
      }, _callee25);
    })));
    _defineProperty(this, "redo", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
      var selection, script;
      return _regeneratorRuntime().wrap(function _callee26$(_context27) {
        while (1) switch (_context27.prev = _context27.next) {
          case 0:
            selection = _this.redoStack && _this.redoStack.length > 0 ? _this.redoStack.pop() : null;
            if (selection) {
              _context27.next = 3;
              break;
            }
            return _context27.abrupt("return");
          case 3:
            _this.undoStack.push(_this.selection);
            _this.selection = selection;
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            _this.selection.attachEvents();
            script = _this.selection.getAllAttributeTransformationScript();
            _context27.next = 14;
            return _this.viewer.executeScriptAsync(script);
          case 14:
            _this.buildStructure();
            _this.resetPlatformAttributesSelection();
            _this.updateComposition();
            _this.updateRecapAndExtensionField();
          case 18:
          case "end":
            return _context27.stop();
        }
      }, _callee26);
    })));
    /**
     * Reset the platform attributes selection to the current selection
     */
    _defineProperty(this, "resetPlatformAttributesSelection", function () {
      _this.selection.get('groups').each(function (group) {
        group.get('attributes').each(function (attribute) {
          var resetAttribute = _this.platformAttributesSelection.find(function (x) {
            return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attribute.get('attributeCode'));
          });
          if (resetAttribute) {
            var selectedOption = attribute.get('options').findWhere({
              selected: true
            });
            resetAttribute.attributeCode = attribute.get('attributeCode');
            resetAttribute.attributeIsEnabled = attribute.get('enabled');
            resetAttribute.attributeLabel = attribute.get('name');
            resetAttribute.optionCode = selectedOption.get('optionCode');
            resetAttribute.optionLabel = selectedOption.get('name');
            resetAttribute.optionIsEnabled = selectedOption.get('enabled');
          }
        });
      });
    });
    _defineProperty(this, "reset", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
      var script;
      return _regeneratorRuntime().wrap(function _callee27$(_context28) {
        while (1) switch (_context28.prev = _context28.next) {
          case 0:
            if (_this.initialSelection) {
              _context28.next = 2;
              break;
            }
            return _context28.abrupt("return");
          case 2:
            _this.undoStack = [];
            _this.redoStack = [];
            _this.selection = _this.cloneSelection(_this.initialSelection);
            _this.selection.attachEvents();
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            script = _this.selection.getAllAttributeTransformationScript();
            _context28.next = 14;
            return _this.viewer.executeScriptAsync(script);
          case 14:
            _this.buildStructure();
            _this.resetPlatformAttributesSelection();
            _this.updateComposition();
            _this.updateRecapAndExtensionField();
          case 18:
          case "end":
            return _context28.stop();
        }
      }, _callee27);
    })));
    _defineProperty(this, "handleAttributeSelectionChanged", /*#__PURE__*/function () {
      var _ref30 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28(e) {
        var attribute, option, platformSelection;
        return _regeneratorRuntime().wrap(function _callee28$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return _this.viewer.executeActionsAsync(e.attributeID, e.selectedValue, e.actions);
            case 2:
              _this.updateComposition();
              attribute = _this.zkProduct.get('attributes').find(function (attribute) {
                return attribute.get('attributeID') == e.attributeID;
              });
              if (attribute) {
                option = attribute.get('options').find(function (option) {
                  return option.get('optionID') == e.selectedValue;
                });
                if (option) {
                  // Change platform selection
                  platformSelection = _this.platformAttributesSelection.find(function (x) {
                    return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attribute.get('attributeCode'));
                  });
                  if (platformSelection) {
                    platformSelection.optionCode = option.get('optionCode');
                    platformSelection.optionLabel = option.get('name');
                  }
                  _this.setOptionSelectionEnabled(attribute.get('attributeID'), option.get('optionID'), _this.isOptionEnabled(option.get('optionID')));
                }
              }
              _this.buildStructure();
              _this.renderDesign();
            case 7:
            case "end":
              return _context29.stop();
          }
        }, _callee28);
      }));
      return function (_x17) {
        return _ref30.apply(this, arguments);
      };
    }());
    _defineProperty(this, "handleAttributeEnabled", function (attributeId) {
      _this.updateComposition();
      _this.setAttributeSelectionEnabled(attributeId, true);
      _this.buildStructure();
      _this.renderDesign();
    });
    _defineProperty(this, "handleAttributeDisabled", function (attributeId) {
      _this.updateComposition();
      _this.setAttributeSelectionEnabled(attributeId, false);
      _this.buildStructure();
      _this.renderDesign();
    });
    _defineProperty(this, "handleAttributeOptionEnabled", function (attributeId, optionId) {
      _this.updateComposition();
      _this.setOptionSelectionEnabled(attributeId, optionId, true);
      _this.buildStructure();
      _this.renderDesign();
    });
    _defineProperty(this, "handleAttributeOptionDisabled", function (attributeId, optionId) {
      _this.updateComposition();
      _this.setOptionSelectionEnabled(attributeId, optionId, false);
      _this.buildStructure();
      _this.renderDesign();
    });
    // Set the current attribute platform selection as enabled or not
    _defineProperty(this, "setAttributeSelectionEnabled", function (attributeId, isEnabled) {
      var attribute = _this.zkProduct.get('attributes').find(function (attribute) {
        return attribute.get('attributeID') == attributeId;
      });
      if (attribute) {
        var attributePlatformSelection = _this.platformAttributesSelection.find(function (selection) {
          return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(selection.attributeCode, attribute.get('attributeCode'));
        });
        if (attributePlatformSelection) {
          attributePlatformSelection.attributeIsEnabled = isEnabled;
        }

        // Set all options as disabled too in platfrom attributes
        attribute.get('options').each(function (option) {
          _this.setOptionSelectionEnabled(attributeId, option.get('optionID'), isEnabled);
        });
      }
    });
    // Set the current option platform selection as enabled or not but only if it's the selected option
    _defineProperty(this, "setOptionSelectionEnabled", function (attributeId, optionId, isEnabled) {
      var attribute = _this.zkProduct.get('attributes').find(function (attribute) {
        return attribute.get('attributeID') == attributeId;
      });
      if (attribute) {
        var option = attribute.get('options').find(function (option) {
          return option.get('optionID') == optionId;
        });
        if (option) {
          var attributePlatformSelection = _this.platformAttributesSelection.find(function (selection) {
            return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(selection.attributeCode, attribute.get('attributeCode'));
          });
          if (attributePlatformSelection && (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(attributePlatformSelection.optionCode, option.get('optionCode'))) {
            attributePlatformSelection.optionIsEnabled = isEnabled;
          }
        }
      }
      _this.updateRecapAndExtensionField();
    });
    _defineProperty(this, "isOptionEnabled", function (optionId) {
      var enabled = false;
      _this.selection.get('groups').each(function (group) {
        group.get('attributes').each(function (attr) {
          var option = attr.get('options').find(function (x) {
            return x.get('optionID') == optionId;
          });
          if (option) enabled = option.get('enabled');
        });
      });
      return enabled;
    });
    _defineProperty(this, "updateComposition", function () {
      _this.selection.updateComposition(_this.composition);
      _this.updatePrice();
    });
    _defineProperty(this, "_updatePrice", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
      var price, isOutOfStock, result;
      return _regeneratorRuntime().wrap(function _callee29$(_context30) {
        while (1) switch (_context30.prev = _context30.next) {
          case 0:
            price = 0;
            isOutOfStock = false;
            if (!(_this.composition && _this.zkProduct)) {
              _context30.next = 8;
              break;
            }
            _context30.next = 5;
            return _this.getPrice();
          case 5:
            result = _context30.sent;
            price = result.price;
            isOutOfStock = result.isOutOfStock;
          case 8:
            _this.price = price;
            _this.isOutOfStock = isOutOfStock;
            _this.trigger('change');
          case 11:
          case "end":
            return _context30.stop();
        }
      }, _callee29);
    })));
    _defineProperty(this, "updatePrice", lodash__WEBPACK_IMPORTED_MODULE_1___default().debounce(this._updatePrice, 300));
    _defineProperty(this, "buildStructure", function () {
      var data = [];
      if (_this.selection) {
        for (var i = 0; i < _this.selection.get('groups').length; i++) {
          var group = _this.selection.get('groups').at(i);
          var groupData = _this.createGroupFromSelection(group);
          data.push(groupData);
        }
        data.sort(function (a, b) {
          return a.displayOrder - b.displayOrder;
        });
      }
      _this.groups = data;
      _this.trigger('change');
    });
    _defineProperty(this, "createGroupFromSelection", function (groupSelection) {
      var zakekeGroup = _this.zkProduct.get('attributeGroups').get(groupSelection.get('groupID'));
      var imageUrl = zakekeGroup ? zakekeGroup.get('imageUrl') : null;
      var group = new _models__WEBPACK_IMPORTED_MODULE_11__.Group();
      group.id = zakekeGroup ? zakekeGroup.get('groupID') : -1;
      group.guid = zakekeGroup ? zakekeGroup.get('groupGuid') : '-1';
      group.name = zakekeGroup ? zakekeGroup.get('name') : 'Other';
      group.imageUrl = imageUrl;
      group.enabled = true;
      group.cameraLocationId = zakekeGroup ? zakekeGroup.get('sceneCameraLocationID') : null;
      group.steps = _this.zkProduct.get('attributeSteps').filter(function (step) {
        return step.get('groupID') == group.id;
      }).map(function (step) {
        return _this.createStep(step, groupSelection);
      });
      if (zakekeGroup) {
        group.displayOrder = zakekeGroup.get('displayOrder');
        group.direction = zakekeGroup.get('direction');
        group.attributesAlwaysOpened = zakekeGroup.get('attributesAlwaysOpened');
      }
      var _loop2 = function _loop2() {
        var attributeSelection = groupSelection.get('attributes').at(i);
        var zakekeAttribute = _this.zkProduct.get('attributes').find(function (attribute) {
          return attribute.get('attributeID') == attributeSelection.get('attributeID');
        });
        if (zakekeAttribute.get('stepID') == -1) {
          var attribute = _this.createAttributeFromSelection(attributeSelection);
          group.attributes.push(attribute);
        }
      };
      for (var i = 0; i < groupSelection.get('attributes').length; i++) {
        _loop2();
      }
      group.attributes.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });

      // template groups

      var templateGroups = groupSelection === null || groupSelection === void 0 ? void 0 : groupSelection.get('templateGroups');
      if (templateGroups) {
        var _loop3 = function _loop3() {
          var zakekeTemplateGroup = _this.zkProduct.get('templateGroups').at(k);
          var templateGroupSelection = templateGroups.find(function (templGr) {
            return templGr.get('templateGroupID') == zakekeTemplateGroup.get('templateGroupID');
          });
          if (templateGroupSelection && zakekeTemplateGroup.get('stepID') == null) {
            var templateGroup = _this.createTemplateGroupFromSelection(templateGroupSelection);
            group.templateGroups.push(templateGroup);
          }
        };
        for (var k = 0; k < _this.zkProduct.get('templateGroups').length; k++) {
          _loop3();
        }
      }
      group.templateGroups.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });
      return group;
    });
    _defineProperty(this, "createAttributeFromSelection", function (attributeSelection) {
      var zakekeAttribute = _this.zkProduct.get('attributes').get(attributeSelection.get('attributeID'));
      var attribute = new _models__WEBPACK_IMPORTED_MODULE_11__.Attribute();
      attribute.id = zakekeAttribute.get('attributeID');
      attribute.guid = zakekeAttribute.get('attributeGuid');
      attribute.code = zakekeAttribute.get('attributeCode');
      attribute.name = zakekeAttribute.get('name') || '';
      attribute.description = zakekeAttribute.get('description') || '';
      attribute.optionShapeType = zakekeAttribute.get('optionPreviewShapeID') == 1 ? _models__WEBPACK_IMPORTED_MODULE_11__.AttributeOptionShapeType.Round : _models__WEBPACK_IMPORTED_MODULE_11__.AttributeOptionShapeType.Square;
      attribute.displayOrder = zakekeAttribute.get('displayOrder');
      attribute.enabled = attributeSelection.get('enabled');
      attribute.groupId = zakekeAttribute.get('groupID');
      attribute.stepId = zakekeAttribute.get('stepID');
      attribute.hideOptionsLabel = zakekeAttribute.get('hideOptionsLabel');
      attribute.cameraLocationId = zakekeAttribute ? zakekeAttribute.get('sceneCameraLocationID') : null;

      // Options
      for (var i = 0; i < attributeSelection.get('options').length; i++) {
        var optionSelection = attributeSelection.get('options').at(i);
        var option = _this.createOptionFromSelection(optionSelection);
        option.attribute = attribute;
        attribute.options.push(option);
      }
      if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.Options) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Select;
      } else if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.Color) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
        attribute.value = attributeSelection.get('selectedValue');
      } else if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.Number) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
        attribute.value = attributeSelection.get('selectedValue');
        attribute.numberFormat = '';
      } else if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.String) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
        attribute.value = attributeSelection.get('selectedValue');
        attribute.numberFormat = '';
      }
      attribute.options.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });
      return attribute;
    });
    _defineProperty(this, "createOptionFromSelection", function (optionSelection) {
      var zakekeOption = _this.zkProduct.get('attributes').get(optionSelection.get('attributeID')).get('options').get(optionSelection.get('optionID'));
      var option = new _models__WEBPACK_IMPORTED_MODULE_11__.Option();
      var pricings = _this.zkProduct.get('attributes').get(optionSelection.get('attributeID')).get('pricings');
      if (pricings.length > 0) {
        var _pricings$find;
        var optionPrice = (_pricings$find = pricings.find(function (price) {
          return price.get('selectedOptionID') === optionSelection.get('optionID');
        })) === null || _pricings$find === void 0 ? void 0 : _pricings$find.get('price');
        if (optionPrice) option.pricings = [{
          fromQuantity: 0,
          price: optionPrice
        }];
      }
      option.id = zakekeOption.get('optionID');
      option.guid = zakekeOption.get('optionGuid');
      option.code = zakekeOption.get('optionCode');
      option.name = zakekeOption.get('name') || '';
      option.description = zakekeOption.get('description') || '';
      option.imageUrl = zakekeOption.get('imageUrl');
      option.displayOrder = zakekeOption.get('displayOrder');
      option.selected = optionSelection.get('selected');
      option.enabled = optionSelection.get('enabled');
      return option;
    });
    _defineProperty(this, "createTemplateGroupFromSelection", function (templateGroupSelection) {
      var _zakekeTemplateGroup$;
      var zakekeTemplateGroup = _this.zkProduct.get('templateGroups').find(function (templateGroup) {
        return templateGroup.get('templateGroupID') === templateGroupSelection.get('templateGroupID');
      });
      if (!zakekeTemplateGroup) return new ___WEBPACK_IMPORTED_MODULE_2__.ThemeTemplateGroup();
      var templateGroup = new ___WEBPACK_IMPORTED_MODULE_2__.ThemeTemplateGroup();
      templateGroup.templateGroupID = zakekeTemplateGroup.get('templateGroupID');
      templateGroup.name = (_zakekeTemplateGroup$ = zakekeTemplateGroup.get('name')) !== null && _zakekeTemplateGroup$ !== void 0 ? _zakekeTemplateGroup$ : '';
      templateGroup.groupID = zakekeTemplateGroup.get('groupID');
      templateGroup.stepID = zakekeTemplateGroup.get('stepID');
      templateGroup.displayOrder = zakekeTemplateGroup.get('displayOrder');
      var _loop4 = function _loop4() {
        var macroCategorySelection = templateGroupSelection.get('macrocategory').at(i);
        var zakekeMacroCategory = zakekeTemplateGroup.get('macrocategory').find(function (macroCategory) {
          return macroCategory.get('macroCategoryID') === macroCategorySelection.get('macroCategoryID');
        });
        if (!zakekeMacroCategory) return {
          v: templateGroup
        };
        var macroCategory = new ___WEBPACK_IMPORTED_MODULE_2__.ThemeMacroCategory();
        macroCategory.id = zakekeMacroCategory.get('macroCategoryID');
        macroCategory.name = zakekeMacroCategory.get('name');
        var _loop5 = function _loop5() {
          var categorySelection = macroCategorySelection.get('category').at(j);
          var zakekeCategory = zakekeMacroCategory.get('category').find(function (category) {
            return category.get('categoryID') === categorySelection.get('categoryID');
          });
          if (!zakekeCategory) return {
            v: {
              v: templateGroup
            }
          };
          var category = new ___WEBPACK_IMPORTED_MODULE_2__.ThemeCategory();
          category.id = zakekeCategory.get('categoryID');
          category.name = zakekeCategory.get('name');
          var _loop6 = function _loop6() {
            var compositionSelection = categorySelection.get('composition').at(k);
            var zakekeComposition = zakekeCategory.get('composition').find(function (composition) {
              return composition.get('compositionID') === compositionSelection.get('compositionID');
            });
            if (!zakekeComposition) return {
              v: {
                v: {
                  v: templateGroup
                }
              }
            };
            var composition = new ___WEBPACK_IMPORTED_MODULE_2__.TemplateComposition();
            composition.name = zakekeComposition.get('name');
            composition.previewImageUrl = zakekeComposition.get('previewImageUrl');
            composition.compositionID = zakekeComposition.get('compositionID');
            category.composition.push(composition);
          };
          for (k = 0; k < categorySelection.get('composition').length; k++) {
            var _ret3 = _loop6();
            if (_typeof(_ret3) === "object") return _ret3.v;
          }
          macroCategory.category.push(category);
        };
        for (j = 0; j < macroCategorySelection.get('category').length; j++) {
          var _ret2 = _loop5();
          if (_typeof(_ret2) === "object") return _ret2.v;
        }
        templateGroup.macroCategory.push(macroCategory);
      };
      for (var i = 0; i < templateGroupSelection.get('macrocategory').length; i++) {
        var j, k;
        var _ret = _loop4();
        if (_typeof(_ret) === "object") return _ret.v;
      }
      return templateGroup;
    });
    _defineProperty(this, "saveDesignBackbone", /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30(isSharing) {
        return _regeneratorRuntime().wrap(function _callee30$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              return _context31.abrupt("return", new Promise(function (resolve, reject) {
                var design = _this.zkCurrentTemplate;
                if (!design) {
                  resolve();
                  return;
                }
                design.save(null, {
                  success: function success(model) {
                    _this.composition.set('designDocID', model.get('docID'));
                    resolve();
                  },
                  error: function error() {
                    reject();
                  },
                  headers: {
                    fromBackOffice: _this.isDraftEditor ? true : false,
                    isSharing: isSharing ? true : false
                  }
                });
              }));
            case 1:
            case "end":
              return _context31.stop();
          }
        }, _callee30);
      }));
      return function (_x18) {
        return _ref32.apply(this, arguments);
      };
    }());
    _defineProperty(this, "saveCompositionBackbone", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
      return _regeneratorRuntime().wrap(function _callee31$(_context32) {
        while (1) switch (_context32.prev = _context32.next) {
          case 0:
            return _context32.abrupt("return", new Promise(function (resolve, reject) {
              _this.composition.save(null, {
                success: function success() {
                  resolve();
                },
                error: function error() {
                  reject();
                },
                headers: {
                  fromBackOffice: _this.isDraftEditor ? true : false
                }
              });
            }));
          case 1:
          case "end":
            return _context32.stop();
        }
      }, _callee31);
    })));
    // Events
    _defineProperty(this, "trigger", function (event) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key3 = 1; _key3 < _len; _key3++) {
        params[_key3 - 1] = arguments[_key3];
      }
      var _iterator4 = _createForOfIteratorHelper(_this.events.filter(function (x) {
          return x.event == event;
        })),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var handler = _step4.value;
          if (handler.callback) handler.callback.apply(_this, params);else console.error("Event handler can't be null or undefined");
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    });
    _defineProperty(this, "on", function (event, callback) {
      _this.events.push(new _models__WEBPACK_IMPORTED_MODULE_11__.ZakekeEvent(event, callback));
    });
    _defineProperty(this, "off", function (event, callback) {
      _this.events = _this.events.filter(function (x) {
        return x.event == event && x.callback == callback;
      });
    });
    _defineProperty(this, "setTemplate", /*#__PURE__*/function () {
      var _ref34 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32(templateId) {
        return _regeneratorRuntime().wrap(function _callee32$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _this.zkCurrentTemplate = _this.zkTemplates.find(function (x) {
                return x.get('templateDesignID') == templateId;
              });
              _this.currentTemplate = _this.templates.find(function (x) {
                return x.id == templateId;
              }) || null;
              _context33.next = 4;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.downloadFontsOfDesign)(_this.zkCurrentTemplate, _this.fonts);
            case 4:
              _this.renderDesign();
            case 5:
            case "end":
              return _context33.stop();
          }
        }, _callee32);
      }));
      return function (_x19) {
        return _ref34.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getTemplateUploadRestrictictions", function (templateId, areaId) {
      var _ref35, _ref36, _getUploadRestriction, _getUploadRestriction2, _getUploadRestriction3, _getUploadRestriction4, _getUploadRestriction5, _getUploadRestriction6, _getUploadRestriction7;
      var design = _this.zkTemplates.find(function (x) {
        return x.get('templateDesignID') == templateId;
      });
      if (!design) throw 'Template does not exists with id ' + templateId;
      var designSide = design.getDesignSide(_this.zkProduct.get('colors').at(0).get('sides').get(areaId));
      var getUploadRestriction = function getUploadRestriction(restriction) {
        var _designSide$get, _design$get;
        if (designSide && designSide.get('uploadRestrictions')) return (_designSide$get = designSide.get('uploadRestrictions')) === null || _designSide$get === void 0 ? void 0 : _designSide$get[restriction];else if (design.get('uploadRestrictions')) (_design$get = design.get('uploadRestrictions')) === null || _design$get === void 0 ? void 0 : _design$get[restriction];else return null;
      };
      var pdfAddonEnabled = (_ref35 = _this.settings.addons.find(function (x) {
        return x.addonName === 'PDF' || x.addonName === 'PDF_EPS';
      }) || _this.settings.isPdfEpsEnabled) !== null && _ref35 !== void 0 ? _ref35 : false;
      var epsAddonEnabled = (_ref36 = _this.settings.addons.find(function (x) {
        return x.addonName === 'EPS' || x.addonName === 'PDF_EPS';
      }) || _this.settings.isPdfEpsEnabled) !== null && _ref36 !== void 0 ? _ref36 : false;
      return {
        isUserImageAllowed: (_getUploadRestriction = getUploadRestriction('isUserImageAllowed')) !== null && _getUploadRestriction !== void 0 ? _getUploadRestriction : true,
        isJpgAllowed: (_getUploadRestriction2 = getUploadRestriction('isJpgAllowed')) !== null && _getUploadRestriction2 !== void 0 ? _getUploadRestriction2 : true,
        isPngAllowed: (_getUploadRestriction3 = getUploadRestriction('isPngAllowed')) !== null && _getUploadRestriction3 !== void 0 ? _getUploadRestriction3 : true,
        isSvgAllowed: (_getUploadRestriction4 = getUploadRestriction('isSvgAllowed')) !== null && _getUploadRestriction4 !== void 0 ? _getUploadRestriction4 : true,
        isPdfAllowed: ((_getUploadRestriction5 = getUploadRestriction('isPdfAllowed')) !== null && _getUploadRestriction5 !== void 0 ? _getUploadRestriction5 : true) && !!pdfAddonEnabled,
        isEpsAllowed: ((_getUploadRestriction6 = getUploadRestriction('isEpsAllowed')) !== null && _getUploadRestriction6 !== void 0 ? _getUploadRestriction6 : true) && !!epsAddonEnabled,
        isPdfWithRasterAllowed: ((_getUploadRestriction7 = getUploadRestriction('isPdfWithRasterAllowed')) !== null && _getUploadRestriction7 !== void 0 ? _getUploadRestriction7 : true) && !!pdfAddonEnabled
      };
    });
    // Get template
    _defineProperty(this, "getTemplates", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
      return _regeneratorRuntime().wrap(function _callee34$(_context35) {
        while (1) switch (_context35.prev = _context35.next) {
          case 0:
            return _context35.abrupt("return", new Promise(/*#__PURE__*/function () {
              var _ref38 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33(resolve, reject) {
                var templatesList, templates, _iterator5, _step5, _template, template;
                return _regeneratorRuntime().wrap(function _callee33$(_context34) {
                  while (1) switch (_context34.prev = _context34.next) {
                    case 0:
                      _context34.next = 2;
                      return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('designs/templates/' + _this.zkProduct.get('modelID'));
                    case 2:
                      templatesList = _context34.sent.data;
                      templates = []; // Build a new design
                      if (!(templatesList.length > 0)) {
                        _context34.next = 24;
                        break;
                      }
                      _iterator5 = _createForOfIteratorHelper(templatesList[0].categories[0].templates);
                      _context34.prev = 6;
                      _iterator5.s();
                    case 8:
                      if ((_step5 = _iterator5.n()).done) {
                        _context34.next = 16;
                        break;
                      }
                      _template = _step5.value;
                      _context34.next = 12;
                      return _this.getTemplate(_template.designID);
                    case 12:
                      template = _context34.sent;
                      //await downloadFontsOfDesign(template, this.fonts);
                      templates.push(template);
                    case 14:
                      _context34.next = 8;
                      break;
                    case 16:
                      _context34.next = 21;
                      break;
                    case 18:
                      _context34.prev = 18;
                      _context34.t0 = _context34["catch"](6);
                      _iterator5.e(_context34.t0);
                    case 21:
                      _context34.prev = 21;
                      _iterator5.f();
                      return _context34.finish(21);
                    case 24:
                      resolve(templates);
                    case 25:
                    case "end":
                      return _context34.stop();
                  }
                }, _callee33, null, [[6, 18, 21, 24]]);
              }));
              return function (_x20, _x21) {
                return _ref38.apply(this, arguments);
              };
            }()));
          case 1:
          case "end":
            return _context35.stop();
        }
      }, _callee34);
    })));
    _defineProperty(this, "saveProduct", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
      return _regeneratorRuntime().wrap(function _callee35$(_context36) {
        while (1) switch (_context36.prev = _context36.next) {
          case 0:
            return _context36.abrupt("return", new Promise(function (resolve, reject) {
              _this.zkProduct && _this.zkProduct.save(null, {
                success: function success(model, response, options) {
                  resolve();
                },
                error: function error(model, response, options) {
                  reject(response);
                }
              });
            }));
          case 1:
          case "end":
            return _context36.stop();
        }
      }, _callee35);
    })));
    // Get single template
    _defineProperty(this, "getTemplate", /*#__PURE__*/function () {
      var _ref40 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37(templateId) {
        return _regeneratorRuntime().wrap(function _callee37$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              return _context38.abrupt("return", new Promise(function (resolve, reject) {
                var design = new MPlaza.Design();
                design.set('docID', templateId);
                design.fetch({
                  success: function () {
                    var _success = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
                      return _regeneratorRuntime().wrap(function _callee36$(_context37) {
                        while (1) switch (_context37.prev = _context37.next) {
                          case 0:
                            resolve(design);
                          case 1:
                          case "end":
                            return _context37.stop();
                        }
                      }, _callee36);
                    }));
                    function success() {
                      return _success.apply(this, arguments);
                    }
                    return success;
                  }(),
                  error: function error() {
                    return null;
                  },
                  data: {
                    template: true
                  }
                });
                design.addEventListener('change', _this.updatePrice);
              }));
            case 1:
            case "end":
              return _context38.stop();
          }
        }, _callee37);
      }));
      return function (_x22) {
        return _ref40.apply(this, arguments);
      };
    }());
    // Public methods
    _defineProperty(this, "updateView", function () {
      _this.viewer.updateView();
    });
    _defineProperty(this, "selectOption", function (optionId) {
      var clone = _this.cloneSelection(_this.selection);
      _this.undoStack.push(clone);
      var option;
      var attribute;
      _this.zkProduct.get('attributes').each(function (attr) {
        var _option = attr.get('options').find(function (option) {
          return option.get('optionID') == optionId;
        });
        if (_option) {
          option = _option;
          attribute = attr;
        }
      });
      if (option) {
        // Don' t reselect it.
        if (option.selected) return;
        _this.selection.selectAttributeValue(attribute.get('attributeID'), optionId.toString());
      } else {
        throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Invalid option with id ' + optionId);
      }
    });
    // Focus a group executing some camera movements
    _defineProperty(this, "focusGroup", function (groupId) {
      var sceneGroup = _this.groups.find(function (x) {
        return x.id == groupId;
      });
      if (sceneGroup && sceneGroup.cameraLocationId) {
        _this.viewer.setCameraLocation(sceneGroup.cameraLocationId);
        _this.lastCameraLocation = sceneGroup.cameraLocationId;
      }
    });
    _defineProperty(this, "focusAttribute", /*#__PURE__*/function () {
      var _ref41 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(attributeId) {
        var unselectedOptionsActions, attribute;
        return _regeneratorRuntime().wrap(function _callee38$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              unselectedOptionsActions = _this.selection.getAttributeUnselectedOptionsSceneActions(attributeId);
              _context39.next = 3;
              return _this.viewer.prefetchDataForUnselectedOptionsAsync(unselectedOptionsActions);
            case 3:
              attribute = _this.zkProduct.get('attributes').find(function (attribute) {
                return attribute.get('attributeID') == attributeId;
              });
              if (attribute && attribute.get('sceneCameraLocationID') && attribute.get('sceneCameraLocationID') != Zakeke.getEmptyUUID()) {
                _this.viewer.setCameraLocation(attribute.get('sceneCameraLocationID'));
                _this.lastCameraLocation = attribute.get('sceneCameraLocationID');
              }
            case 5:
            case "end":
              return _context39.stop();
          }
        }, _callee38);
      }));
      return function (_x23) {
        return _ref41.apply(this, arguments);
      };
    }());
    _defineProperty(this, "base64StringToFile", function (base64String, filename) {
      var _arr$0$match$, _arr$, _arr$$match;
      var arr = base64String.split(','),
        mime = (_arr$0$match$ = (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : (_arr$$match = _arr$.match(/:(.*?);/)) === null || _arr$$match === void 0 ? void 0 : _arr$$match[1]) !== null && _arr$0$match$ !== void 0 ? _arr$0$match$ : '',
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    });
    _defineProperty(this, "saveTemplate", /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39(templateName, selectedCategoryID, attributeOptions) {
        var attributes, compositionItems, categories, mapping, _mapping, parsedCategory, templateGroup, group, step, attributesWithoutGroup;
        return _regeneratorRuntime().wrap(function _callee39$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              attributes = Array.from(attributeOptions.keys());
              compositionItems = _this.composition.get('compositionItems');
              compositionItems.toArray().forEach(function (compositionItem) {
                if (!attributes.includes(compositionItem.get('attributeID'))) compositionItems.remove(compositionItem);
              });
              _this.composition.set('name', templateName);
              _this.composition.set('compositionItems', compositionItems);
              _this.composition.set('isTemplate', true);
              categories = new MPlaza.CompositionCategoriesMapping();
              if (selectedCategoryID) {
                mapping = new MPlaza.CompositionCategoryMapping();
                mapping.set('categoryID', selectedCategoryID);
                mapping.set('name', ' ');
                categories.add(mapping);
              } else if (_this.selectedTemplateCategory) {
                try {
                  _mapping = new MPlaza.CompositionCategoryMapping();
                  parsedCategory = _this.selectedTemplateCategory.split(';');
                  _mapping.set('categoryID', Number.parseInt(parsedCategory[0]));
                  _mapping.set('name', parsedCategory[1]);
                  categories.add(_mapping);
                } catch (ex) {
                  console.error('Error while parsing associated category for template', ex, _this.selectedTemplateCategory);
                }
              }
              _this.composition.set('categories', categories);
              if (!(_this.zkProduct.get('templateGroups').length === 0)) {
                _context40.next = 16;
                break;
              }
              templateGroup = new MPlaza.TemplateGroup();
              templateGroup.set('name', 'Pre-set configurations');
              if (_this.zkProduct.get('attributeGroups').length > 0) {
                group = new MPlaza.AttributeGroup();
                group.set('name', 'Pre-set configurations');
                group.set('displayOrder', _this.zkProduct.get('attributeGroups').at(0).get('displayOrder') - 1);
                _this.zkProduct.get('attributeGroups').unshift(group);
                templateGroup.set('groupGuid', group.get('groupGuid'));
              } else {
                if (_this.zkProduct.get('attributeSteps') && _this.zkProduct.get('attributeSteps').length > 0) {
                  step = new MPlaza.AttributeStep();
                  step.set('name', 'Pre-set configurations');
                  step.set('groupGuid', Zakeke.generateUUID());
                  step.set('displayOrder', _this.zkProduct.get('attributeSteps').at(0).get('displayOrder') - 1);
                  _this.zkProduct.get('attributeSteps').unshift(step);
                  templateGroup.set('stepGuid', step.get('stepGuid'));
                } else {
                  attributesWithoutGroup = _this.zkProduct.get('attributes').filter(function (attr) {
                    return attr.get('groupID') === -1;
                  }).sort((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.ascComparator)(function (x) {
                    return x.get('displayOrder');
                  }));
                  if (attributesWithoutGroup.length > 0) templateGroup.set('displayOrder', attributesWithoutGroup[0].get('displayOrder') - 1);
                }
              }
              _this.zkProduct.get('templateGroups').add(templateGroup);
              _context40.next = 16;
              return _this.saveProduct();
            case 16:
              _context40.next = 18;
              return _this.addToCart([], undefined, undefined, undefined);
            case 18:
              _context40.next = 20;
              return _this.reset();
            case 20:
            case "end":
              return _context40.stop();
          }
        }, _callee39);
      }));
      return function (_x24, _x25, _x26) {
        return _ref42.apply(this, arguments);
      };
    }());
    _defineProperty(this, "addToCart", /*#__PURE__*/function () {
      var _ref43 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee40(additionalProperties, onBeforeSendDataToParent, legacyScreenshot, nftForm) {
        var _this$zkScene8;
        var compositionClientPreviews, sortedBuyScreenshotCameras, previewFiles, buyScreenshotCameras, _iterator6, _step6, camera, preview, formData, file, previewCameraFile, previewFile;
        return _regeneratorRuntime().wrap(function _callee40$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return _this.setExplodedMode(false);
            case 2:
              if (_this.pdSettings) _this.composition.set('pdSettings', _this.pdSettings);
              _this.composition.set('compositionClientPreviews', []);
              compositionClientPreviews = [];
              sortedBuyScreenshotCameras = [];
              previewFiles = [];
              buyScreenshotCameras = (_this$zkScene8 = _this.zkScene) === null || _this$zkScene8 === void 0 ? void 0 : _this$zkScene8.get('cameraLocations').filter(function (x) {
                var _x$get;
                return ((_x$get = x.get('name')) === null || _x$get === void 0 ? void 0 : _x$get.toLowerCase().indexOf('buy_screenshot_camera_')) !== -1;
              });
              if (buyScreenshotCameras) sortedBuyScreenshotCameras = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.sortBy)(buyScreenshotCameras, function (a) {
                return a.get('name');
              });
              if (!(sortedBuyScreenshotCameras && sortedBuyScreenshotCameras.length > 0)) {
                _context41.next = 42;
                break;
              }
              _iterator6 = _createForOfIteratorHelper(sortedBuyScreenshotCameras);
              _context41.prev = 11;
              _iterator6.s();
            case 13:
              if ((_step6 = _iterator6.n()).done) {
                _context41.next = 33;
                break;
              }
              camera = _step6.value;
              _context41.next = 17;
              return _this.viewer.getSceneContentScreenshotAsync(_this.clientPreviewWidth, _this.clientPreviewHeight, 0, _this.zkCurrentTemplate, legacyScreenshot, camera);
            case 17:
              preview = _context41.sent;
              formData = new FormData();
              if (preview) {
                _context41.next = 21;
                break;
              }
              return _context41.abrupt("return");
            case 21:
              file = _this.base64StringToFile(preview, camera + '.png');
              formData.set('file', file);
              _context41.next = 25;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'compositions/upload-client-preview', formData);
            case 25:
              previewCameraFile = _context41.sent.data;
              compositionClientPreviews.push({
                fileObjectID: previewCameraFile.id,
                cameraName: camera.get('name'),
                url: previewCameraFile.url
              });
              previewFile = {
                url: previewCameraFile.url,
                cameraName: camera.get('name')
              };
              previewFiles.push(previewFile);
              _context41.next = 31;
              return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.sleep)(1);
            case 31:
              _context41.next = 13;
              break;
            case 33:
              _context41.next = 38;
              break;
            case 35:
              _context41.prev = 35;
              _context41.t0 = _context41["catch"](11);
              _iterator6.e(_context41.t0);
            case 38:
              _context41.prev = 38;
              _iterator6.f();
              return _context41.finish(38);
            case 41:
              _this.composition.set('compositionClientPreviews', compositionClientPreviews);
            case 42:
              if (_this.composition.get('isDraft') && !_this.isDraftEditor) {
                _this.composition.set('docID', null);
                _this.composition.set('designDocID', null);
                _this.composition.set('isDraft', false);
                if (_this.zkCurrentTemplate) _this.zkCurrentTemplate.set('docID', null);
              }
              console.log('previewFiles', previewFiles);
              // Save composition
              _context41.next = 46;
              return _this.saveComposition(undefined, legacyScreenshot);
            case 46:
              if (!nftForm) {
                _context41.next = 49;
                break;
              }
              _context41.next = 49;
              return _this.saveCustomerWalletInfo(_this.composition.get('docID'), nftForm.email, nftForm.walletAddress);
            case 49:
              if (!onBeforeSendDataToParent) {
                _context41.next = 53;
                break;
              }
              _context41.next = 52;
              return onBeforeSendDataToParent({
                composition: _this.composition.id,
                preview: _this.composition.get('previewImageUrl'),
                attributes: _this.platformAttributesSelection,
                designItems: _this.getDesignItemsInfo(),
                quantity: _this.quantity,
                previewFiles: previewFiles,
                additionalProperties: additionalProperties
              });
            case 52:
              additionalProperties = _context41.sent;
            case 53:
              // Add to cart
              _this.integration.addToCart(_this.composition, _this.zkCurrentTemplate, _this.zkProduct, _this.platformAttributesSelection, _this.getDesignItemsInfo(), _this.quantity, additionalProperties, nftForm && _this.settings.ecommerceID === 3 ? _this.nftSettings ? _this.nftSettings.priceToAdd : 0 : 0);
            case 54:
            case "end":
              return _context41.stop();
          }
        }, _callee40, null, [[11, 35, 38, 41]]);
      }));
      return function (_x27, _x28, _x29, _x30) {
        return _ref43.apply(this, arguments);
      };
    }());
    _defineProperty(this, "zoomIn", function () {
      if (_this.viewer) _this.viewer.zoomIn();
    });
    _defineProperty(this, "zoomOut", function () {
      if (_this.viewer) _this.viewer.zoomOut();
    });
    _defineProperty(this, "isFullscreenEnabled", function () {
      return !_helpers__WEBPACK_IMPORTED_MODULE_7__.iOS;
    });
    _defineProperty(this, "switchFullscreen", function () {
      var interval = null;
      _this.viewer.switchFullScreen(document.querySelector('.zakeke-viewer-container'));
      if (!interval) {
        //eslint-disable-next-line
        interval = setInterval(function () {
          if (_this.isFullscreenMode && _this.internalIsFullscreen == false) {
            setTimeout(function () {
              _this.viewer.updateView();
              // doppio resize per mobile
              _this.viewer.updateView();
              _this.internalIsFullscreen = true;
              console.info('Fullscreen enabled');
            }, 10);
          }
          if (!_this.isFullscreenMode && _this.internalIsFullscreen == true) {
            clearInterval(interval);
            interval = null;
            setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
              return _regeneratorRuntime().wrap(function _callee41$(_context42) {
                while (1) switch (_context42.prev = _context42.next) {
                  case 0:
                    _this.internalIsFullscreen = false;

                    // Update layout for two seconds
                    _context42.next = 3;
                    return _this.extendedUpdate();
                  case 3:
                    _this.viewer.updateView();
                    // doppio resize per mobile
                    _this.viewer.updateView();
                    console.info('Fullscreen disabled');
                  case 6:
                  case "end":
                    return _context42.stop();
                }
              }, _callee41);
            })), 10);
          }
        }, 100);
      }
    });
    _defineProperty(this, "openSecondScreen", function () {
      var url = Zakeke.config.baseUrl + 'en/SecondScreen?token=' + _this.token + '&modelID=' + _this.zkProduct.get('modelID');
      window.open(url);
    });
    _defineProperty(this, "extendedUpdate", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
      return _regeneratorRuntime().wrap(function _callee42$(_context43) {
        while (1) switch (_context43.prev = _context43.next) {
          case 0:
            return _context43.abrupt("return", new Promise(function (resolve, reject) {
              var count = 0;
              var interval = setInterval(function () {
                _this.viewer.updateView();
                if (++count > 20) {
                  // After two seconds
                  clearInterval(interval);
                  resolve();
                }
              }, 100);
            }));
          case 1:
          case "end":
            return _context43.stop();
        }
      }, _callee42);
    })));
    _defineProperty(this, "exportSceneToUsdz", /*#__PURE__*/function () {
      var _ref46 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee43(hash) {
        return _regeneratorRuntime().wrap(function _callee43$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              if (!(_this.viewer && _this.viewer.zkScene)) {
                _context44.next = 2;
                break;
              }
              return _context44.abrupt("return", _this.viewer.exportSceneToUsdzAsync(_this.viewer.zkScene.get('sceneID'), hash));
            case 2:
            case "end":
              return _context44.stop();
          }
        }, _callee43);
      }));
      return function (_x31) {
        return _ref46.apply(this, arguments);
      };
    }());
    _defineProperty(this, "exportSceneToGlb", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
      return _regeneratorRuntime().wrap(function _callee44$(_context45) {
        while (1) switch (_context45.prev = _context45.next) {
          case 0:
            return _context45.abrupt("return", _this.viewer.exportSceneToLocalGLBAsync());
          case 1:
          case "end":
            return _context45.stop();
        }
      }, _callee44);
    })));
    _defineProperty(this, "setExplodedMode", /*#__PURE__*/function () {
      var _ref48 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee45(explodedMode) {
        return _regeneratorRuntime().wrap(function _callee45$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              if (!_this.viewer) {
                _context46.next = 8;
                break;
              }
              if (!explodedMode) {
                _context46.next = 6;
                break;
              }
              _context46.next = 4;
              return _this.viewer.explodeMeshes();
            case 4:
              _context46.next = 8;
              break;
            case 6:
              _context46.next = 8;
              return _this.viewer.collapseMeshes();
            case 8:
              _this.isExplodedMode = explodedMode;
            case 9:
            case "end":
              return _context46.stop();
          }
        }, _callee45);
      }));
      return function (_x32) {
        return _ref48.apply(this, arguments);
      };
    }());
    _defineProperty(this, "hasExplodedMode", function () {
      var zkScene = _this.zkScene;
      if (zkScene) return !!zkScene.getFirstExplodedMeshLocation();else return false;
    });
    _defineProperty(this, "setBackgroundColor", function (color, alpha) {
      var zkScene = _this.zkScene;
      if (color.indexOf('rgb') == 0) {
        var values = color.replace('rgb(', '').replace(')', '').split(',');
        color = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.rgb2hex)(values[0], values[1], values[2]);
      }
      if (_this.viewer && zkScene) {
        zkScene.getOrCreateEnvironmentConfig().set('mainColor', color);
        zkScene.getOrCreateGeneralConfig().set('backgroundColor', color);
        zkScene.getOrCreateGeneralConfig().set('backgroundAlpha', alpha);
        _this.viewer.refreshEnvironment();
      }
    });
    _defineProperty(this, "getCurrentSelection", function () {
      return lodash__WEBPACK_IMPORTED_MODULE_1___default().cloneDeep(_this.platformAttributesSelection);
    });
    _defineProperty(this, "getScreenshot", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
      var width,
        height,
        legacyScreenshot,
        backgroundColor,
        padding,
        camera,
        url,
        _args47 = arguments;
      return _regeneratorRuntime().wrap(function _callee46$(_context47) {
        while (1) switch (_context47.prev = _context47.next) {
          case 0:
            width = _args47.length > 0 && _args47[0] !== undefined ? _args47[0] : 1024;
            height = _args47.length > 1 && _args47[1] !== undefined ? _args47[1] : 1024;
            legacyScreenshot = _args47.length > 2 ? _args47[2] : undefined;
            backgroundColor = _args47.length > 3 && _args47[3] !== undefined ? _args47[3] : null;
            padding = _args47.length > 4 && _args47[4] !== undefined ? _args47[4] : 0;
            camera = _args47.length > 5 && _args47[5] !== undefined ? _args47[5] : null;
            _context47.next = 8;
            return _this.viewer.getSceneContentScreenshotAsync(width, height, padding, _this.zkCurrentTemplate, legacyScreenshot, camera);
          case 8:
            url = _context47.sent;
            if (url) {
              _context47.next = 11;
              break;
            }
            throw new Error('Failed generating screenshot');
          case 11:
            if (!backgroundColor) {
              _context47.next = 14;
              break;
            }
            _context47.next = 14;
            return new Promise(function (resolve) {
              var img = new Image();
              img.onload = function () {
                var canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext('2d');
                if (ctx) {
                  ctx.fillStyle = backgroundColor;
                  ctx.fillRect(0, 0, img.width, img.height);
                  ctx.drawImage(img, 0, 0);
                  url = canvas.toDataURL();
                  resolve();
                }
              };
              img.src = url;
            });
          case 14:
            return _context47.abrupt("return", url);
          case 15:
          case "end":
            return _context47.stop();
        }
      }, _callee46);
    })));
    _defineProperty(this, "fireItemsChange", function () {
      _this.trigger('change');
    });
    _defineProperty(this, "removeItem", /*#__PURE__*/function () {
      var _ref50 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee47(guid) {
        return _regeneratorRuntime().wrap(function _callee47$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              return _context48.abrupt("return", new Promise(function (resolve, reject) {
                if (_this.viewer) {
                  _this.viewer.removeDesignItem(guid);
                  _this.fireItemsChange();
                  resolve();
                } else {
                  reject('Called remove item but no viewer or viewer not ready');
                }
              }));
            case 1:
            case "end":
              return _context48.stop();
          }
        }, _callee47);
      }));
      return function (_x33) {
        return _ref50.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemText", function (guid, text) {
      if (_this.viewer) {
        _this.viewer.setDesignItemText(guid, text);
      } else throw 'Called set item text but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemItalic", function (guid, italic) {
      if (_this.viewer) {
        _this.viewer.setDesignItemItalic(guid, italic);
      } else throw 'Called set item italic but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemBold", function (guid, bold) {
      if (_this.viewer) {
        _this.viewer.setDesignItemBold(guid, bold);
      } else throw 'Called set item bold but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemColor", function (guid, color) {
      if (_this.viewer) {
        _this.viewer.setDesignItemColor(guid, color);
      } else throw 'Called set item color but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemFontFamily", /*#__PURE__*/function () {
      var _ref51 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee48(guid, fontFamily) {
        var font;
        return _regeneratorRuntime().wrap(function _callee48$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              if (!_this.viewer) {
                _context49.next = 12;
                break;
              }
              font = _this.fonts.find(function (x) {
                return x.name === fontFamily;
              });
              if (!font) {
                _context49.next = 9;
                break;
              }
              _context49.next = 5;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([font])["catch"](function (e) {
                console.error('Error loading font', e, font);
              });
            case 5:
              _this.viewer.setDesignItemFontFamily(guid, fontFamily);
              _this.fireItemsChange();
              _context49.next = 10;
              break;
            case 9:
              console.warn("No font found for ".concat(fontFamily));
            case 10:
              _context49.next = 13;
              break;
            case 12:
              throw 'Called set item font family but no viewer or viewer not ready';
            case 13:
            case "end":
              return _context49.stop();
          }
        }, _callee48);
      }));
      return function (_x34, _x35) {
        return _ref51.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemTextOnPath", function (guid, areaId, value) {
      if (_this.viewer) {
        _this.viewer.setItemTextOnPath(guid, areaId, value);
        _this.fireItemsChange();
      } else throw 'Called toggleItemTextOnPath but no viewer or viewer not ready';
    });
    _defineProperty(this, "sanitizeString", function (family, text) {
      var _family$faces$;
      var face = (_family$faces$ = family.faces[0]) !== null && _family$faces$ !== void 0 ? _family$faces$ : null;
      if (!face) return text;
      return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.sanitizeString)(face, text);
    });
    _defineProperty(this, "getSanitationText", function (family, text) {
      var _family$faces$2;
      var face = (_family$faces$2 = family.faces[0]) !== null && _family$faces$2 !== void 0 ? _family$faces$2 : null;
      if (!face) return {
        dirtyChars: [],
        sanitizedText: text
      };
      return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.sanitizeText)(face, text);
    });
    _defineProperty(this, "createImage", /*#__PURE__*/function () {
      var _ref52 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee49(file, progress) {
        var _this$zkProduct3, imageTask, printingMethods, result, image;
        return _regeneratorRuntime().wrap(function _callee49$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!_this.viewer) {
                _context50.next = 11;
                break;
              }
              imageTask = new _imageUploadTask__WEBPACK_IMPORTED_MODULE_8__["default"](_this.culture, _this.token);
              printingMethods = (_this$zkProduct3 = _this.zkProduct) === null || _this$zkProduct3 === void 0 ? void 0 : _this$zkProduct3.get('printTypes');
              imageTask.addPrintingOptions(printingMethods);
              _context50.next = 6;
              return imageTask.upload(file, progress);
            case 6:
              result = _context50.sent;
              image = result ? result[0] : null;
              return _context50.abrupt("return", image);
            case 11:
              throw 'Called create image but no viewer or viewer not ready';
            case 12:
            case "end":
              return _context50.stop();
          }
        }, _callee49);
      }));
      return function (_x36, _x37) {
        return _ref52.apply(this, arguments);
      };
    }());
    _defineProperty(this, "createImageFromUrl", /*#__PURE__*/function () {
      var _ref53 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee50(url) {
        var result;
        return _regeneratorRuntime().wrap(function _callee50$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              if (!_this.viewer) {
                _context51.next = 7;
                break;
              }
              _context51.next = 3;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'images/import/url', {
                url: url
              });
            case 3:
              result = _context51.sent.data;
              return _context51.abrupt("return", result);
            case 7:
              throw 'Called create image from url but no viewer or viewer not ready';
            case 8:
            case "end":
              return _context51.stop();
          }
        }, _callee50);
      }));
      return function (_x38) {
        return _ref53.apply(this, arguments);
      };
    }());
    _defineProperty(this, "addItemImage", /*#__PURE__*/function () {
      var _ref54 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee51(id, areaId) {
        return _regeneratorRuntime().wrap(function _callee51$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              if (!_this.viewer) {
                _context52.next = 8;
                break;
              }
              _context52.next = 3;
              return _this.viewer.addDesignItemImage(id, areaId);
            case 3:
              _context52.next = 5;
              return _this.renderDesign();
            case 5:
              _this.fireItemsChange();
              _context52.next = 9;
              break;
            case 8:
              throw 'Called add item text but no viewer or viewer not ready';
            case 9:
            case "end":
              return _context52.stop();
          }
        }, _callee51);
      }));
      return function (_x39, _x40) {
        return _ref54.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemImageFromFile", /*#__PURE__*/function () {
      var _ref55 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee52(guid, file, progress) {
        var image;
        return _regeneratorRuntime().wrap(function _callee52$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              if (!_this.viewer) {
                _context53.next = 9;
                break;
              }
              _context53.next = 3;
              return _this.createImage(file, progress);
            case 3:
              image = _context53.sent;
              _context53.next = 6;
              return _this.setItemImage(guid, image.imageID);
            case 6:
              _this.fireItemsChange();
              _context53.next = 10;
              break;
            case 9:
              throw 'Called set item image but no viewer or viewer not ready';
            case 10:
            case "end":
              return _context53.stop();
          }
        }, _callee52);
      }));
      return function (_x41, _x42, _x43) {
        return _ref55.apply(this, arguments);
      };
    }());
    // For preview only!!
    _defineProperty(this, "setItemImageFromBase64", /*#__PURE__*/function () {
      var _ref56 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee53(guid, base64) {
        var image;
        return _regeneratorRuntime().wrap(function _callee53$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              if (!_this.viewer) {
                _context54.next = 9;
                break;
              }
              image = new MPlaza.Image();
              image.set('imageID', -1);
              image.set('previewUrl', base64);
              _context54.next = 6;
              return _this.viewer.setDesignItemImage(guid, image);
            case 6:
              _this.fireItemsChange();
              _context54.next = 10;
              break;
            case 9:
              throw 'Called set item image but no viewer or viewer not ready';
            case 10:
            case "end":
              return _context54.stop();
          }
        }, _callee53);
      }));
      return function (_x44, _x45) {
        return _ref56.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemImage", /*#__PURE__*/function () {
      var _ref57 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee56(guid, id) {
        return _regeneratorRuntime().wrap(function _callee56$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              return _context57.abrupt("return", new Promise(/*#__PURE__*/function () {
                var _ref58 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee55(resolve, reject) {
                  var image;
                  return _regeneratorRuntime().wrap(function _callee55$(_context56) {
                    while (1) switch (_context56.prev = _context56.next) {
                      case 0:
                        if (!_this.viewer) {
                          _context56.next = 6;
                          break;
                        }
                        image = new MPlaza.Image();
                        image.set('imageID', id);
                        image.fetch({
                          success: function () {
                            var _success2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee54(model, response, opts) {
                              return _regeneratorRuntime().wrap(function _callee54$(_context55) {
                                while (1) switch (_context55.prev = _context55.next) {
                                  case 0:
                                    _context55.next = 2;
                                    return _this.viewer.setDesignItemImage(guid, image);
                                  case 2:
                                    _this.fireItemsChange();
                                    resolve();
                                  case 4:
                                  case "end":
                                    return _context55.stop();
                                }
                              }, _callee54);
                            }));
                            function success(_x50, _x51, _x52) {
                              return _success2.apply(this, arguments);
                            }
                            return success;
                          }(),
                          error: function error(model, response, opts) {
                            return null;
                          }
                        });
                        _context56.next = 7;
                        break;
                      case 6:
                        throw 'Called set item image but no viewer or viewer not ready';
                      case 7:
                      case "end":
                        return _context56.stop();
                    }
                  }, _callee55);
                }));
                return function (_x48, _x49) {
                  return _ref58.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context57.stop();
          }
        }, _callee56);
      }));
      return function (_x46, _x47) {
        return _ref57.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getMacroCategories", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
      var _this$product;
      var macroCategories, _iterator7, _step7, macroCategory;
      return _regeneratorRuntime().wrap(function _callee57$(_context58) {
        while (1) switch (_context58.prev = _context58.next) {
          case 0:
            _context58.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('imagemacrocategories/', {
              params: {
                productID: (_this$product = _this.product) === null || _this$product === void 0 ? void 0 : _this$product.id
              }
            });
          case 2:
            macroCategories = _context58.sent.data;
            macroCategories = macroCategories.filter(function (x) {
              return x.hasImages;
            });
            _iterator7 = _createForOfIteratorHelper(macroCategories);
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                macroCategory = _step7.value;
                macroCategory.categories = macroCategory.categories.filter(function (x) {
                  return x.hasImages;
                });
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
            return _context58.abrupt("return", macroCategories);
          case 7:
          case "end":
            return _context58.stop();
        }
      }, _callee57);
    })));
    _defineProperty(this, "getImages", /*#__PURE__*/function () {
      var _ref60 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee58(categoryId) {
        var _this$product2;
        var images;
        return _regeneratorRuntime().wrap(function _callee58$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              _context59.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('images', {
                params: {
                  type: 'lib',
                  c: categoryId,
                  productID: (_this$product2 = _this.product) === null || _this$product2 === void 0 ? void 0 : _this$product2.id
                }
              });
            case 2:
              images = _context59.sent.data;
              return _context59.abrupt("return", images);
            case 4:
            case "end":
              return _context59.stop();
          }
        }, _callee58);
      }));
      return function (_x53) {
        return _ref60.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getPDF", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
      var _this$zkScene9, _this$product3;
      var pdfScreenshotCamera, data, items, areas, selectedOptions, params, pdf;
      return _regeneratorRuntime().wrap(function _callee59$(_context60) {
        while (1) switch (_context60.prev = _context60.next) {
          case 0:
            pdfScreenshotCamera = (_this$zkScene9 = _this.zkScene) === null || _this$zkScene9 === void 0 ? void 0 : _this$zkScene9.get('cameraLocations').find(function (x) {
              var _x$get2;
              return ((_x$get2 = x.get('name')) === null || _x$get2 === void 0 ? void 0 : _x$get2.toLowerCase()) === 'pdf_screenshot_camera';
            });
            _context60.next = 3;
            return _this.getScreenshot(2048, 2048, false, null, 0, pdfScreenshotCamera);
          case 3:
            data = _context60.sent;
            items = _this.getDesignItemsInfo();
            areas = (_this$product3 = _this.product) === null || _this$product3 === void 0 ? void 0 : _this$product3.areas.filter(function (x) {
              return _this.isAreaVisible(x.id);
            }).map(function (x) {
              return {
                name: x.name,
                textItems: items.filter(function (i) {
                  return i.areaId == x.id && i.type === ___WEBPACK_IMPORTED_MODULE_2__.ItemType.Text;
                })
              };
            }).filter(function (x) {
              return x.textItems.length > 0;
            });
            selectedOptions = _this.platformAttributesSelection.filter(function (x) {
              return x.attributeIsEnabled && x.attributeIsEnabled;
            }).map(function (_ref62) {
              var attributeLabel = _ref62.attributeLabel,
                attributeCode = _ref62.attributeCode,
                optionCode = _ref62.optionCode,
                optionLabel = _ref62.optionLabel;
              return {
                attributeLabel: attributeLabel,
                attributeCode: !(0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(attributeCode) ? attributeCode : '',
                optionLabel: optionLabel,
                optionCode: !(0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(optionCode) ? optionCode : ''
              };
            });
            params = {
              environment: 2,
              productName: _this.zkProduct.get('name'),
              previewImage: data,
              sides: [],
              areas: areas,
              selectedOptions: selectedOptions
            };
            _context60.next = 10;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'previewdesigns/pdf', params, {
              transformResponse: function transformResponse(res) {
                return res;
              },
              responseType: 'text'
            });
          case 10:
            pdf = _context60.sent.data.replace(/"/g, '');
            return _context60.abrupt("return", pdf);
          case 12:
          case "end":
            return _context60.stop();
        }
      }, _callee59);
    })));
    _defineProperty(this, "rewriteShareUrl", function (url) {
      var path = url.split('/SharedPreview')[1];
      if (_this.shareUrlPrefix) {
        return _this.shareUrlPrefix + path;
      }
      if (!_this.isShoppingPreview && document.referrer && _this.settings.referrerID === 2) {
        var regex = /(apps\/configurator\/)([\s\S]*)/gm;
        var firstPart = document.referrer.replace(regex, '$1');
        if (!firstPart.endsWith('/')) firstPart += '/';
        return firstPart + path;
      }
      return url;
    });
    _defineProperty(this, "getShareCompositionUrl", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
      var _this$composition$get;
      var isDraft, docID, result;
      return _regeneratorRuntime().wrap(function _callee60$(_context61) {
        while (1) switch (_context61.prev = _context61.next) {
          case 0:
            // salvo (e riassegno dopo la creazione dello share url) l'id , per evitare problemi in caso di add to cart e edit
            // in questo modo ogni composizione condivisa è sempre diversa da quella di partenza
            isDraft = (_this$composition$get = _this.composition.get('isDraft')) !== null && _this$composition$get !== void 0 ? _this$composition$get : false;
            _this.composition.set('isDraft', false);
            _context61.next = 4;
            return _this.saveCompositionCopy(true);
          case 4:
            docID = _context61.sent;
            _this.composition.set('isDraft', isDraft);
            _context61.next = 8;
            return _this.integration.getSharedCompositionUrl(docID);
          case 8:
            result = _context61.sent;
            return _context61.abrupt("return", result.url);
          case 10:
          case "end":
            return _context61.stop();
        }
      }, _callee60);
    })));
    _defineProperty(this, "saveCompositionCopy", /*#__PURE__*/function () {
      var _ref64 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee61(isSharing) {
        var docId, designDocId, currentTemplate, newCompositionDocId;
        return _regeneratorRuntime().wrap(function _callee61$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              docId = null;
              designDocId = null;
              currentTemplate = _this.zkCurrentTemplate;
              if (currentTemplate) {
                designDocId = currentTemplate.get('docID');
                currentTemplate.set('docID', null);
              }
              docId = _this.composition.get('docID');
              _this.composition.set('docID', null);
              _this.composition.set('designDocID', null);
              _context62.next = 9;
              return _this.saveComposition(undefined, undefined, isSharing);
            case 9:
              newCompositionDocId = _this.composition.get('docID');
              _this.composition.set('docID', docId);
              _this.composition.set('designDocID', designDocId);
              if (currentTemplate) currentTemplate.set('docID', designDocId);
              return _context62.abrupt("return", newCompositionDocId);
            case 14:
            case "end":
              return _context62.stop();
          }
        }, _callee61);
      }));
      return function (_x54) {
        return _ref64.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getOnlineScreenshot", /*#__PURE__*/function () {
      var _ref65 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee62(width, height, legacyScreenshot, backgroundColor) {
        var padding,
          preview,
          originalUrl,
          rewrittenUrl,
          _args63 = arguments;
        return _regeneratorRuntime().wrap(function _callee62$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              padding = _args63.length > 4 && _args63[4] !== undefined ? _args63[4] : 30;
              _context63.next = 3;
              return _this.getScreenshot(width, height, legacyScreenshot, backgroundColor, padding);
            case 3:
              preview = _context63.sent;
              _context63.next = 6;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'designs/save-share-preview', {
                preview: preview
              });
            case 6:
              originalUrl = _context63.sent.data.url;
              rewrittenUrl = _this.rewriteShareUrl(originalUrl);
              return _context63.abrupt("return", {
                originalUrl: originalUrl,
                rewrittenUrl: rewrittenUrl
              });
            case 9:
            case "end":
              return _context63.stop();
          }
        }, _callee62);
      }));
      return function (_x55, _x56, _x57, _x58) {
        return _ref65.apply(this, arguments);
      };
    }());
    // AR - Augmented Reality
    _defineProperty(this, "isSceneArOnTheFly", function () {
      var _this$zkScene10;
      if (_this.viewer) return (_this$zkScene10 = _this.zkScene) === null || _this$zkScene10 === void 0 ? void 0 : _this$zkScene10.getAROnTheFly();
      return false;
    });
    _defineProperty(this, "isArDeviceCompliant", function () {
      return _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_AR_DEVICE_COMPLIANT;
    });
    _defineProperty(this, "isAndroidOrIOS", function () {
      return _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID || _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS;
    });
    _defineProperty(this, "isAndroid", _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID);
    _defineProperty(this, "isIOS", _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS);
    _defineProperty(this, "buildModelViewerUrl", function (fileInfos) {
      var _getARAnchor;
      var url = Zakeke.config.modelViewerPage;
      var link = new URL(url);
      var search = '';
      var _iterator8 = _createForOfIteratorHelper(fileInfos),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var file = _step8.value;
          if (file.format && file.arFileUrl) {
            var encodedUrl = encodeURIComponent(file.arFileUrl);
            var searchFile = '';
            switch (file.format) {
              case 'gltf':
              case 'glb':
                searchFile = 'gltf=' + encodedUrl;
                break;
              case 'usdz':
                searchFile = 'usdz=' + encodedUrl;
                break;
              case 'png':
                searchFile = 'poster=' + encodedUrl;
                break;
            }
            if (searchFile) search += (search ? '&' : '') + searchFile;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      search += '&arScale=' + (_this.zkScene.getARScale() ? 1 : 0);
      search += '&arAnchor=' + ((_getARAnchor = _this.zkScene.getARAnchor()) !== null && _getARAnchor !== void 0 ? _getARAnchor : '');
      link.search += search;
      var pageUrl = link.toString();
      return pageUrl;
    });
    _defineProperty(this, "isSceneArEnabled", function () {
      if (_this.zkScene) return _this.zkScene.getAREnabled() || false;
      return false;
    });
    _defineProperty(this, "getPregeneratedARUrl", function (fileType) {
      var _this$zkScene11, _this$zkScene11$get, _this$zkScene11$get$f;
      return (_this$zkScene11 = _this.zkScene) === null || _this$zkScene11 === void 0 ? void 0 : (_this$zkScene11$get = _this$zkScene11.get('arFiles')) === null || _this$zkScene11$get === void 0 ? void 0 : (_this$zkScene11$get$f = _this$zkScene11$get.find(function (x) {
        return x.get('fileType') == fileType;
      })) === null || _this$zkScene11$get$f === void 0 ? void 0 : _this$zkScene11$get$f.get('url');
    });
    _defineProperty(this, "getQrCodeArUrl", /*#__PURE__*/function () {
      var _ref66 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee63(device) {
        var _this$zkProduct$get, _this$zkProduct4;
        var fileInfos, sceneCode, url, glb, usdz;
        return _regeneratorRuntime().wrap(function _callee63$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              fileInfos = [];
              sceneCode = _this.isDAMViewer ? (_this$zkProduct$get = (_this$zkProduct4 = _this.zkProduct) === null || _this$zkProduct4 === void 0 ? void 0 : _this$zkProduct4.get('code')) !== null && _this$zkProduct$get !== void 0 ? _this$zkProduct$get : undefined : _this.selection.getCompositionHashCode();
              if (!(device == 'Android')) {
                _context64.next = 12;
                break;
              }
              _context64.t0 = _this.getPregeneratedARUrl('glb');
              if (_context64.t0) {
                _context64.next = 8;
                break;
              }
              _context64.next = 7;
              return _this.viewer.exportSceneToRemoteGLBAsync(_this.zkScene.get('sceneID'), sceneCode, false);
            case 7:
              _context64.t0 = _context64.sent;
            case 8:
              url = _context64.t0;
              if (url) fileInfos = [{
                format: 'gltf',
                arFileUrl: url
              }];
              _context64.next = 21;
              break;
            case 12:
              glb = _this.getPregeneratedARUrl('glb');
              usdz = _this.getPregeneratedARUrl('usdz');
              if (!(glb && usdz)) {
                _context64.next = 18;
                break;
              }
              fileInfos = [{
                format: 'glb',
                arFileUrl: glb
              }, {
                format: 'usdz',
                arFileUrl: usdz
              }];
              _context64.next = 21;
              break;
            case 18:
              _context64.next = 20;
              return _this.viewer.exportSceneToARAsync(_this.zkScene.get('sceneID'), sceneCode);
            case 20:
              fileInfos = _context64.sent;
            case 21:
              if (!(fileInfos.length == 0)) {
                _context64.next = 23;
                break;
              }
              return _context64.abrupt("return", '');
            case 23:
              if (_this.isDAMViewer) {
                _this.makeDAMAnalyticsView(_models__WEBPACK_IMPORTED_MODULE_11__.DAMViewerAnalyticsEventType.ViewArProdutc);
              }
              return _context64.abrupt("return", _this.buildModelViewerUrl(fileInfos));
            case 25:
            case "end":
              return _context64.stop();
          }
        }, _callee63);
      }));
      return function (_x59) {
        return _ref66.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getMobileArUrl", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
      var _this$zkProduct$get2, _this$zkProduct5;
      var sceneCode, url;
      return _regeneratorRuntime().wrap(function _callee64$(_context65) {
        while (1) switch (_context65.prev = _context65.next) {
          case 0:
            sceneCode = _this.isDAMViewer ? (_this$zkProduct$get2 = (_this$zkProduct5 = _this.zkProduct) === null || _this$zkProduct5 === void 0 ? void 0 : _this$zkProduct5.get('code')) !== null && _this$zkProduct$get2 !== void 0 ? _this$zkProduct$get2 : undefined : _this.selection.getCompositionHashCode();
            url = null;
            _context65.prev = 2;
            _context65.next = 5;
            return document.requestStorageAccess();
          case 5:
            _context65.next = 10;
            break;
          case 7:
            _context65.prev = 7;
            _context65.t0 = _context65["catch"](2);
            console.error('Storage access denied');
          case 10:
            if (!_this.isSceneArOnTheFly()) {
              _context65.next = 16;
              break;
            }
            _context65.next = 13;
            return _this.getMobileLocalArUrl();
          case 13:
            return _context65.abrupt("return", url = _context65.sent);
          case 16:
            if (!_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
              _context65.next = 25;
              break;
            }
            _context65.t1 = _this.getPregeneratedARUrl('usdz');
            if (_context65.t1) {
              _context65.next = 22;
              break;
            }
            _context65.next = 21;
            return _this.viewer.exportSceneToUsdzAsync(_this.zkScene.get('sceneID'), sceneCode, false);
          case 21:
            _context65.t1 = _context65.sent;
          case 22:
            url = _context65.t1;
            _context65.next = 31;
            break;
          case 25:
            _context65.t2 = _this.getPregeneratedARUrl('glb');
            if (_context65.t2) {
              _context65.next = 30;
              break;
            }
            _context65.next = 29;
            return _this.viewer.exportSceneToRemoteGLBAsync(_this.zkScene.get('sceneID'), sceneCode, false);
          case 29:
            _context65.t2 = _context65.sent;
          case 30:
            url = _context65.t2;
          case 31:
            if (_this.isDAMViewer) {
              _this.makeDAMAnalyticsView(_models__WEBPACK_IMPORTED_MODULE_11__.DAMViewerAnalyticsEventType.ViewArProdutc);
            }
            return _context65.abrupt("return", url);
          case 33:
          case "end":
            return _context65.stop();
        }
      }, _callee64, null, [[2, 7]]);
    })));
    _defineProperty(this, "getMobileLocalArUrl", function () {
      return new Promise(function (resolve, reject) {
        if (_this.zkScene && _this.viewer) {
          var fileId = _this.zkScene.getSceneID();
          if (!fileId) {
            reject('Scene ID is missing.');
            return;
          }
          _this.viewer.getSceneRootUrl().then(/*#__PURE__*/function () {
            var _ref68 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee65(rootUrl) {
              var url;
              return _regeneratorRuntime().wrap(function _callee65$(_context66) {
                while (1) switch (_context66.prev = _context66.next) {
                  case 0:
                    if (rootUrl) {
                      _context66.next = 3;
                      break;
                    }
                    reject('Root URL is missing.');
                    return _context66.abrupt("return");
                  case 3:
                    if (!_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
                      _context66.next = 10;
                      break;
                    }
                    _context66.next = 6;
                    return _this.viewer.exportSceneToLocalUSDZAsync()["catch"](function (ex) {
                      console.error('Failed exporting scene to usdz', ex);
                      return null;
                    });
                  case 6:
                    url = _context66.sent;
                    if (!url) {
                      reject('Failed to export scene to USDZ.');
                    } else {
                      resolve(url);
                    }
                    _context66.next = 11;
                    break;
                  case 10:
                    _this.viewer.saveGlbOnDatabaseAsync(fileId).then(function (uploadedModelUrl) {
                      // Base AR file URL
                      var arFileUrl = Zakeke.config.onFlyArPage;
                      var link = new URL(arFileUrl);

                      // Append query parameters
                      var search = "?uploadedModelUrl=".concat(uploadedModelUrl);
                      search += "&rootUrl=".concat(encodeURIComponent(rootUrl));
                      search += "&productId=".concat(_this.product.id);
                      search += "&environment=".concat(_this.product.environment);
                      search += "&token=".concat(_this.token);
                      if (_this.zkScene.getARAnchor()) {
                        search += "&arAnchor=".concat(_this.zkScene.getARAnchor());
                      }
                      link.search += search;
                      var pageUrl = link.toString();

                      // Resolve with the final URL
                      resolve(pageUrl);
                    })["catch"](function (ex) {
                      console.error('Failed saving glb on database', ex);
                      reject(ex);
                    });
                  case 11:
                  case "end":
                    return _context66.stop();
                }
              }, _callee65);
            }));
            return function (_x60) {
              return _ref68.apply(this, arguments);
            };
          }())["catch"](function (ex) {
            console.error('Failed to get scene root URL', ex);
            reject(ex);
          });
        } else {
          reject('Viewer or Scene is missing.');
        }
      });
    });
    _defineProperty(this, "openArMobile", function (url) {
      if (_this.viewer && _this.zkScene) {
        if (_this.isSceneArOnTheFly() && _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID) {
          console.log('sono openArMobile e sono su android', url);
          window.open(url, '_blank');
        } else if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
          if (url && !_this.zkScene.getARScale()) url += '#allowsContentScaling=0';
          var anchor = document.createElement('a');
          anchor.setAttribute('rel', 'ar');
          anchor.setAttribute('href', url);
          anchor.appendChild(document.createElement('img'));
          anchor.click();
        } else if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID) {
          _zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_0__.AndroidAR.openSceneViewer(url, function () {
            alert('Device not supported.');
          }, _this.zkScene.getARScale(), _this.zkScene.getARAnchor());
        }
      }
    });
    _defineProperty(this, "registerView", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee66() {
      return _regeneratorRuntime().wrap(function _callee66$(_context67) {
        while (1) switch (_context67.prev = _context67.next) {
          case 0:
            if (!(!_this.zkProduct || _this.isShoppingPreview)) {
              _context67.next = 2;
              break;
            }
            return _context67.abrupt("return");
          case 2:
            _context67.prev = 2;
            _context67.next = 5;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'viewscount/addview', {
              productID: _this.zkProduct.get('modelID'),
              environment: _this.zkProduct.get('environment'),
              ecommerceID: _this.settings.ecommerceID
            });
          case 5:
            _context67.next = 10;
            break;
          case 7:
            _context67.prev = 7;
            _context67.t0 = _context67["catch"](2);
            console.error('Failed registering view', _context67.t0);
          case 10:
          case "end":
            return _context67.stop();
        }
      }, _callee66, null, [[2, 7]]);
    })));
    // Manipulate scene
    _defineProperty(this, "getMeshIDbyName", function (name) {
      var _this$viewer, _this$viewer$getMeshB;
      return (_this$viewer = _this.viewer) === null || _this$viewer === void 0 ? void 0 : (_this$viewer$getMeshB = _this$viewer.getMeshByName(name)) === null || _this$viewer$getMeshB === void 0 ? void 0 : _this$viewer$getMeshB.id;
    });
    /**
     * Hide a mesh and its children and save the state
     * @param meshId The mesh and childs to hide
     */
    _defineProperty(this, "hideMeshAndSaveState", function (meshId) {
      if (_this.viewer.scene) {
        var rootMesh = _this.viewer.getMeshByID(meshId);

        // Add mesh and all submesh visibility to previousMeshVisibileStates
        if (rootMesh) {
          var meshes = [rootMesh].concat(_toConsumableArray(rootMesh.getChildMeshes()));
          var _iterator9 = _createForOfIteratorHelper(meshes),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var mesh = _step9.value;
              _this.previousMeshesVisibleStates[mesh.id] = mesh.isVisible;
              mesh.isVisible = false;
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
          _this.viewer.setRenderingNeeded();
        }
      }
    });
    /**
     * Restore a mesh visibility state from a previous saved one (see hideMeshAndSaveState)
     * @param meshId The mesh and childs to show
     */
    _defineProperty(this, "restoreMeshVisibility", function (meshId) {
      if (_this.viewer.scene) {
        var rootMesh = _this.viewer.getMeshByID(meshId);

        // Add mesh and all submesh visibility to previousMeshVisibileStates
        if (rootMesh && _this.previousMeshesVisibleStates[rootMesh.id] !== undefined) {
          var meshes = [rootMesh].concat(_toConsumableArray(rootMesh.getChildMeshes()));
          var _iterator10 = _createForOfIteratorHelper(meshes),
            _step10;
          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var mesh = _step10.value;
              mesh.isVisible = _this.previousMeshesVisibleStates[mesh.id];
              delete _this.previousMeshesVisibleStates[mesh.id];
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
          _this.viewer.setRenderingNeeded();
        }
      }
    });
    /**
     * Change opacity for a specific mesh
     * @param meshId The mesh to change the opacity
     * @param opacity The opacity to set
     */
    _defineProperty(this, "setMeshDesignVisibility", function (meshId, visible) {
      if (_this.viewer) {
        _this.viewer.setDesignVisibility(meshId, visible);
        _this.viewer.setRenderingNeeded();
      }
    });
    // Events
    _defineProperty(this, "addFocusAttributesListener", function (listenerFunction) {
      if (_this.viewer) _this.viewer.addFocusAttributesListener(listenerFunction);
    });
    _defineProperty(this, "clearListeners", function () {
      if (_this.viewer) _this.viewer.clearListeners();
    });
    _defineProperty(this, "setCameraLocked", function (isBlocked) {
      return _this.viewer.setCameraLocked(isBlocked);
    });
    _defineProperty(this, "isSceneTryOnEnabled", function () {
      var _this$zkScene$getTryO;
      if (_this.viewer) if (_this.zkScene) console.log(_this.zkScene.getTryOnEnabled());
      if (_this.viewer) if (_this.zkScene) return (_this$zkScene$getTryO = _this.zkScene.getTryOnEnabled()) !== null && _this$zkScene$getTryO !== void 0 ? _this$zkScene$getTryO : false;
      return false;
    });
    _defineProperty(this, "getTryOnUrl", function (tryOnUrl) {
      return new Promise(function (resolve) {
        if (_this.zkScene && _this.viewer) {
          var fileId = _this.zkScene.getSceneID();
          _this.viewer.getSceneRootUrl().then(function (rootUrl) {
            if (!rootUrl) return;
            var attachmentPoint = 'noseBridge';

            // Salvo le mesh su IndexedDB
            _this.viewer.saveVisibleMeshesOnDatabaseAsync(fileId).then(function () {
              var url = tryOnUrl !== null && tryOnUrl !== void 0 ? tryOnUrl : 'https://zakekecdn.blob.core.windows.net/cdn/c/tryon/index.html';
              var link = new URL(url);
              var search = 'id=' + fileId;
              search += '&rootUrl=' + encodeURIComponent(rootUrl);
              search += '&attachmentPoint=' + attachmentPoint;
              search += '&productId=' + _this.zkProduct.get('modelID');
              search += '&environment=' + _this.zkProduct.get('environment');
              search += '&token=' + _this.token;
              link.search += search;
              var pageUrl = link.toString();
              resolve(pageUrl);
            });
          });
        }
      });
    });
    _defineProperty(this, "saveComposition", /*#__PURE__*/function () {
      var _ref70 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee67(customPreviewSize, legacyScreenshot, isSharing) {
        var _this$zkScene12, _customPreviewSize$cu, _customPreviewSize$cu2;
        var buyScreenshotCamera, data, design, designItems, itemsNotPlaceholders, nonStaticElementsCount;
        return _regeneratorRuntime().wrap(function _callee67$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              console.log('Saving...');
              buyScreenshotCamera = (_this$zkScene12 = _this.zkScene) === null || _this$zkScene12 === void 0 ? void 0 : _this$zkScene12.get('cameraLocations').find(function (x) {
                var _x$get3;
                return ((_x$get3 = x.get('name')) === null || _x$get3 === void 0 ? void 0 : _x$get3.toLowerCase()) === 'buy_screenshot_camera';
              });
              if (!buyScreenshotCamera) _this.viewer.restoreCameraState();
              _context68.next = 5;
              return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.sleep)(1);
            case 5:
              _context68.next = 7;
              return _this.viewer.getSceneContentScreenshotAsync((_customPreviewSize$cu = customPreviewSize === null || customPreviewSize === void 0 ? void 0 : customPreviewSize.customCartPreviewHeight) !== null && _customPreviewSize$cu !== void 0 ? _customPreviewSize$cu : _this.previewWidth, (_customPreviewSize$cu2 = customPreviewSize === null || customPreviewSize === void 0 ? void 0 : customPreviewSize.customCartPreviewWidth) !== null && _customPreviewSize$cu2 !== void 0 ? _customPreviewSize$cu2 : _this.previewHeight, 0, _this.zkCurrentTemplate, legacyScreenshot, buyScreenshotCamera);
            case 7:
              data = _context68.sent;
              if (_this.pdSettings) _this.composition.set('pdSettings', _this.pdSettings);
              _this.composition.set('previewImageData', data);

              // Save composition
              if (!(!_this.composition.get('isTemplate') && _this.zkCurrentTemplate)) {
                _context68.next = 24;
                break;
              }
              design = _this.zkCurrentTemplate;
              designItems = design.get('designItems');
              itemsNotPlaceholders = designItems.filter(function (designItem) {
                return !JSON.parse(designItem.get('json'))[1].data.isTemplateElement;
              });
              itemsNotPlaceholders.forEach(function (item) {
                if (item.get('areas').length > 0 && !_this.isAreaVisible(item.get('areas').at(0).get('sideID'))) designItems.remove(item);
              });
              nonStaticElementsCount = designItems === null || designItems === void 0 ? void 0 : designItems.toArray().map(function (designItem) {
                return !designItem.get('constraints') || designItem.get('constraints').get('canResize') || designItem.get('constraints').get('canMove') || designItem.get('constraints').get('canDelete') || designItem.get('constraints').get('canRotate') || designItem.get('constraints').get('canEdit') || designItem.get('constraints').get('isPrintable')
                //  && designItem.get('areas').length > 0 &&
                // this.isAreaVisible(designItem.get('areas').at(0).get('sideID'))
                ;
              }).filter(function (x) {
                return x;
              }).length;
              if (!(nonStaticElementsCount > 0)) {
                _context68.next = 21;
                break;
              }
              _context68.next = 19;
              return _this.saveDesignBackbone(isSharing);
            case 19:
              _context68.next = 22;
              break;
            case 21:
              _this.composition.set('designDocID', null);
            case 22:
              _context68.next = 25;
              break;
            case 24:
              _this.composition.set('designDocID', null);
            case 25:
              _context68.next = 27;
              return _this.saveCompositionBackbone();
            case 27:
              console.log('Composition saved!');
            case 28:
            case "end":
              return _context68.stop();
          }
        }, _callee67);
      }));
      return function (_x61, _x62, _x63) {
        return _ref70.apply(this, arguments);
      };
    }());
    _defineProperty(this, "bootstrapComposition", /*#__PURE__*/function () {
      var _ref71 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee68(composition) {
        return _regeneratorRuntime().wrap(function _callee68$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              _this.selection = Zakeke.ComposerSelection.CreateComposerSelection(_this.zkProduct);
              _this.composition = composition;
              _context69.next = 4;
              return _this.internalLoadComposition(_this.composition.id);
            case 4:
              if (!_this.currentCompositionInfo) _this.currentCompositionInfo = {
                compositionId: '',
                compositionName: '',
                compositionTags: []
              };
              _this.currentCompositionInfo.compositionId = _this.compositionId;
              _this.currentCompositionInfo.compositionName = _this.composition.get('name');
              _this.currentCompositionInfo.compositionTags = _this.composition.get('tags');
            case 8:
            case "end":
              return _context69.stop();
          }
        }, _callee68);
      }));
      return function (_x64) {
        return _ref71.apply(this, arguments);
      };
    }());
    _defineProperty(this, "loadSavedComposition", /*#__PURE__*/function () {
      var _ref72 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee69(docID) {
        var _this$savedCompositio;
        var composition, compositionModel;
        return _regeneratorRuntime().wrap(function _callee69$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              composition = (_this$savedCompositio = _this.savedCompositions) === null || _this$savedCompositio === void 0 ? void 0 : _this$savedCompositio.find(function (x) {
                return x.docID == docID;
              });
              compositionModel = new MPlaza.Composition(composition);
              if (!composition) {
                _context70.next = 5;
                break;
              }
              _context70.next = 5;
              return _this.bootstrapComposition(new MPlaza.Composition(composition));
            case 5:
              _this.selection.setupOnComposition(compositionModel);
              _context70.next = 8;
              return _this.sync3DAndPlatformSelectionWithCurrentSelection();
            case 8:
              _this.buildStructure();
              _this.updatePrice();
              _this.selection.getAllAttributeSelections().forEach(function (attributeSelection) {
                var selectionOption = attributeSelection.get('options').find(function (x) {
                  return x.get('selected');
                });

                // Change platform selection
                var platformSelection = _this.platformAttributesSelection.find(function (x) {
                  return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attributeSelection.get('attributeCode'));
                });
                if (platformSelection && selectionOption) {
                  platformSelection.optionCode = selectionOption.get('optionCode');
                  platformSelection.optionLabel = selectionOption.get('name');
                }
                console.log({
                  platformSelection: platformSelection
                });
              });
            case 11:
            case "end":
              return _context70.stop();
          }
        }, _callee69);
      }));
      return function (_x65) {
        return _ref72.apply(this, arguments);
      };
    }());
    _defineProperty(this, "updateSavedCompositions", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee70() {
      var savedCompositions, themeCompositions;
      return _regeneratorRuntime().wrap(function _callee70$(_context71) {
        while (1) switch (_context71.prev = _context71.next) {
          case 0:
            _context71.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.baseApiUrl + "compositiondocs/product/".concat(_this.zkProduct.get('modelID')), {
              params: {
                draft: true
              }
            });
          case 2:
            savedCompositions = _context71.sent.data;
            _this.savedCompositions = savedCompositions;
            if (savedCompositions) {
              themeCompositions = _this.themeCompositionsFromSavedCompositions(savedCompositions);
              _this.themeCompositions = themeCompositions;
            }
            _this.trigger('change');
          case 6:
          case "end":
            return _context71.stop();
        }
      }, _callee70);
    })));
    _defineProperty(this, "themeCompositionsFromSavedCompositions", function (compositions) {
      var themeCompositions = compositions.map(function (composition) {
        return {
          name: composition.name,
          docID: composition.docID,
          previewImageUrl: composition.previewImageUrl,
          tags: composition.tags
        };
      });
      return themeCompositions;
    });
    _defineProperty(this, "saveDraftsComposition", /*#__PURE__*/function () {
      var _ref74 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee71(name, tags, isCopy) {
        return _regeneratorRuntime().wrap(function _callee71$(_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              _this.composition.set('name', name);
              _this.composition.set('tags', tags);
              _this.composition.set('isDraft', true);
              if (!isCopy) {
                _context72.next = 8;
                break;
              }
              _context72.next = 6;
              return _this.saveCompositionCopy();
            case 6:
              _context72.next = 10;
              break;
            case 8:
              _context72.next = 10;
              return _this.saveComposition(undefined);
            case 10:
              return _context72.abrupt("return", _this.updateSavedCompositions());
            case 11:
            case "end":
              return _context72.stop();
          }
        }, _callee71);
      }));
      return function (_x66, _x67, _x68) {
        return _ref74.apply(this, arguments);
      };
    }());
    _defineProperty(this, "deleteSavedComposition", /*#__PURE__*/function () {
      var _ref75 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee72(docId) {
        return _regeneratorRuntime().wrap(function _callee72$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              _context73.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi["delete"](Zakeke.config.baseApiUrl + "compositiondocs/".concat(docId));
            case 2:
              _this.updateSavedCompositions();
            case 3:
            case "end":
              return _context73.stop();
          }
        }, _callee72);
      }));
      return function (_x69) {
        return _ref75.apply(this, arguments);
      };
    }());
    _defineProperty(this, "applyTemplate", /*#__PURE__*/function () {
      var _ref76 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee73(templateGroupCompositionId) {
        var result, compositionItems, compositionItemsFromTemplate, newCompositionItems;
        return _regeneratorRuntime().wrap(function _callee73$(_context74) {
          while (1) switch (_context74.prev = _context74.next) {
            case 0:
              _context74.prev = 0;
              _context74.next = 3;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('proxycompositions/' + templateGroupCompositionId, {
                params: {
                  template: true
                }
              });
            case 3:
              _context74.next = 5;
              return _context74.sent.data;
            case 5:
              result = _context74.sent;
              compositionItems = _this.composition.get('compositionItems');
              compositionItemsFromTemplate = new MPlaza.CompositionItems(result.compositionItems);
              newCompositionItems = new MPlaza.CompositionItems();
              compositionItems.toArray().forEach(function (currentCompositionItem) {
                var templateCompositionItem = compositionItemsFromTemplate.find(function (compositionItem) {
                  return compositionItem.get('attributeID') === currentCompositionItem.get('attributeID');
                });
                newCompositionItems.add(templateCompositionItem !== null && templateCompositionItem !== void 0 ? templateCompositionItem : currentCompositionItem);
              });
              _this.composition.set('compositionItems', newCompositionItems);

              // await this.bootstrapComposition(this.composition);
              _this.selection.setupOnComposition(_this.composition);
              _context74.next = 14;
              return _this.sync3DAndPlatformSelectionWithCurrentSelection();
            case 14:
              _this.buildStructure();
              _this.updatePrice();
              _this.selection.getAllAttributeSelections().forEach(function (attributeSelection) {
                var selectionOption = attributeSelection.get('options').find(function (x) {
                  return x.get('selected');
                });

                // Change platform selection
                var platformSelection = _this.platformAttributesSelection.find(function (x) {
                  return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attributeSelection.get('attributeCode'));
                });
                if (platformSelection && selectionOption) {
                  platformSelection.optionCode = selectionOption.get('optionCode');
                  platformSelection.optionLabel = selectionOption.get('name');
                }
                console.log({
                  platformSelection: platformSelection
                });
              });
              _context74.next = 22;
              break;
            case 19:
              _context74.prev = 19;
              _context74.t0 = _context74["catch"](0);
              console.error(_context74.t0);
            case 22:
            case "end":
              return _context74.stop();
          }
        }, _callee73, null, [[0, 19]]);
      }));
      return function (_x70) {
        return _ref76.apply(this, arguments);
      };
    }());
    _defineProperty(this, "configureByAI", /*#__PURE__*/function () {
      var _ref77 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee74(text) {
        var response, _iterator11, _step11, _loop7;
        return _regeneratorRuntime().wrap(function _callee74$(_context76) {
          while (1) switch (_context76.prev = _context76.next) {
            case 0:
              _context76.prev = 0;
              _context76.next = 3;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('ai/configuration-by-prompt', {
                params: {
                  productId: _this.zkProduct.get('modelID'),
                  prompt: text
                }
              });
            case 3:
              response = _context76.sent.data;
              // Select all the options
              _iterator11 = _createForOfIteratorHelper(response);
              _context76.prev = 5;
              _loop7 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop7() {
                var option, attribute, optionToSelect;
                return _regeneratorRuntime().wrap(function _loop7$(_context75) {
                  while (1) switch (_context75.prev = _context75.next) {
                    case 0:
                      option = _step11.value;
                      attribute = _this.zkProduct.get('attributes').find(function (x) {
                        return x.get('name') == option.attributeName;
                      });
                      if (attribute) {
                        optionToSelect = attribute.get('options').find(function (x) {
                          return x.get('name') == option.optionName;
                        });
                        if (optionToSelect) {
                          _this.selectOption(optionToSelect.get('optionID'));
                        }
                      }
                    case 3:
                    case "end":
                      return _context75.stop();
                  }
                }, _loop7);
              });
              _iterator11.s();
            case 8:
              if ((_step11 = _iterator11.n()).done) {
                _context76.next = 12;
                break;
              }
              return _context76.delegateYield(_loop7(), "t0", 10);
            case 10:
              _context76.next = 8;
              break;
            case 12:
              _context76.next = 17;
              break;
            case 14:
              _context76.prev = 14;
              _context76.t1 = _context76["catch"](5);
              _iterator11.e(_context76.t1);
            case 17:
              _context76.prev = 17;
              _iterator11.f();
              return _context76.finish(17);
            case 20:
              _context76.next = 25;
              break;
            case 22:
              _context76.prev = 22;
              _context76.t2 = _context76["catch"](0);
              console.error(_context76.t2);
            case 25:
            case "end":
              return _context76.stop();
          }
        }, _callee74, null, [[0, 22], [5, 14, 17, 20]]);
      }));
      return function (_x71) {
        return _ref77.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getTryOnProvidersList", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee75() {
      var providersMapping;
      return _regeneratorRuntime().wrap(function _callee75$(_context77) {
        while (1) switch (_context77.prev = _context77.next) {
          case 0:
            if (!_this.tryOnProvidersSettings) {
              _context77.next = 2;
              break;
            }
            return _context77.abrupt("return", _this.tryOnProvidersSettings);
          case 2:
            _context77.next = 4;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.tryOnApiUrl + "tryonprovider/list");
          case 4:
            providersMapping = _context77.sent;
            return _context77.abrupt("return", _this.tryOnProvidersSettings = providersMapping.data);
          case 6:
          case "end":
            return _context77.stop();
        }
      }, _callee75);
    })));
    _defineProperty(this, "getTryOnProductInfo", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee76() {
      var _this$internalProduct;
      var productID, productInfo;
      return _regeneratorRuntime().wrap(function _callee76$(_context78) {
        while (1) switch (_context78.prev = _context78.next) {
          case 0:
            productID = (_this$internalProduct = _this.internalProduct) === null || _this$internalProduct === void 0 ? void 0 : _this$internalProduct.get('modelID');
            if (productID) {
              _context78.next = 3;
              break;
            }
            return _context78.abrupt("return", null);
          case 3:
            if (!(_this.tryOnProductSettings && _this.tryOnProductSettings.productID === productID)) {
              _context78.next = 5;
              break;
            }
            return _context78.abrupt("return", _this.tryOnProductSettings);
          case 5:
            _context78.next = 7;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.tryOnApiUrl + "tryonproduct/".concat(productID));
          case 7:
            productInfo = _context78.sent;
            _this.tryOnProductSettings = productInfo.data;
            return _context78.abrupt("return", _this.tryOnProductSettings);
          case 10:
          case "end":
            return _context78.stop();
        }
      }, _callee76);
    })));
    _defineProperty(this, "getMessagesByProductCode", /*#__PURE__*/function () {
      var _ref80 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee77(productCode) {
        var query, response, result;
        return _regeneratorRuntime().wrap(function _callee77$(_context79) {
          while (1) switch (_context79.prev = _context79.next) {
            case 0:
              console.log('query', productCode);
              query = {
                name: 'messagesByProduct',
                query: "query getEventMessagesByProduct($productGlobalCode: String!){\n\t\t\t\t\t\t\tmessagesByProduct(productGlobalCode: $productGlobalCode){\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\teventGlobalID\n\t\t\t\t\t\t\t\tmessageId\n\t\t\t\t\t\t\t\tmessageText\n\t\t\t\t\t\t\t\teventName\n\t\t\t\t\t\t\t\teventId\n\t\t\t\t\t\t\t\tcloseable\n\t\t\t\t\t\t\t\tvisible\n\t\t\t\t\t\t\t\taddToCartDisabledValue\n\t\t\t\t\t\t\t\tenableCheckForSellerImagesValue\n\t\t\t\t\t\t\t\tenableAdditionalMessage\n\t\t\t\t\t\t\t\tadditionalMessage\n\t\t\t\t\t\t\t\teventMessageId\n\t\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\t\ttitleSingleMessage\n\t\t\t\t\t\t\t\tinfoLink\n\t\t\t\t\t\t\t\tdefaultMessage\n\t\t\t\t\t\t\t\tvisibleOnlyOnApi\n\t\t\t\t\t\t\t\taddToCartLabel\n\t\t\t\t\t\t\t\tvisibleLowQualityInfoText\n\t\t\t\t\t\t\t\tdefaultAdditionalMessageText\n\t\t\t\t\t\t\t\twarningText\n\t\t\t\t\t\t\t\tonDeleteWarningText\n\t\t\t\t\t\t\t\tisDefault\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}",
                variables: {
                  productGlobalCode: 'guid://Zakeke/Model/' + productCode
                }
              };
              _context79.next = 4;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.graphqlUrl, query);
            case 4:
              response = _context79.sent;
              result = null;
              if (response && response.data && response.data.data.messagesByProduct) {
                result = response.data.data.messagesByProduct.map(function (message) {
                  return {
                    eventID: message.eventId,
                    description: message.messageText,
                    closeable: message.closeable,
                    visible: message.visible,
                    addToCartDisabledIfVisible: message.addToCartDisabledValue,
                    additionalData: message.additionalMessage,
                    enableCheckForSellerImages: message.enableCheckForSellerImagesValue,
                    isDefault: message.isDefault
                  };
                }).map(function (message) {
                  return ___WEBPACK_IMPORTED_MODULE_2__.EventMessage.fromMessage(message);
                });
              }
              return _context79.abrupt("return", result);
            case 8:
            case "end":
              return _context79.stop();
          }
        }, _callee77);
      }));
      return function (_x72) {
        return _ref80.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getTryOnSellerInfo", /*#__PURE__*/function () {
      var _ref81 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee78(typeID, providerID) {
        var sellerInfo;
        return _regeneratorRuntime().wrap(function _callee78$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              if (_this.settings) {
                _context80.next = 2;
                break;
              }
              return _context80.abrupt("return", null);
            case 2:
              if (!_this.tryOnSellerSettings) {
                _context80.next = 4;
                break;
              }
              return _context80.abrupt("return", _this.tryOnSellerSettings);
            case 4:
              _context80.next = 6;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.tryOnApiUrl + 'tryoncustomer/' + '?typeID=' + typeID.toString() + '&providerID=' + providerID.toString());
            case 6:
              sellerInfo = _context80.sent;
              _this.tryOnSellerSettings = sellerInfo.data;
              return _context80.abrupt("return", _this.tryOnSellerSettings);
            case 9:
            case "end":
              return _context80.stop();
          }
        }, _callee78);
      }));
      return function (_x73, _x74) {
        return _ref81.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setPDDistance", function (distance) {
      _this.pdSettings = distance;
    });
    _defineProperty(this, "pdDistance", function () {
      return _this.pdSettings;
    });
    _defineProperty(this, "exportTryOnMeshToGlb", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee79() {
      var tryOnMesh;
      return _regeneratorRuntime().wrap(function _callee79$(_context81) {
        while (1) switch (_context81.prev = _context81.next) {
          case 0:
            if (_this.zkScene) {
              _context81.next = 2;
              break;
            }
            return _context81.abrupt("return", null);
          case 2:
            if (_this.viewer) {
              _context81.next = 4;
              break;
            }
            return _context81.abrupt("return", null);
          case 4:
            tryOnMesh = _this.viewer.getTryOnMeshVisible();
            if (tryOnMesh) {
              _context81.next = 7;
              break;
            }
            return _context81.abrupt("return", null);
          case 7:
            return _context81.abrupt("return", _this.viewer.exportMeshToGLBBlob(tryOnMesh.id));
          case 8:
          case "end":
            return _context81.stop();
        }
      }, _callee79);
    })));
    _defineProperty(this, "getTryOnSettings", function () {
      if (_this.zkScene) return _this.zkScene.getTryOnSettings();
      return undefined;
    });
    _defineProperty(this, "getDeepARDesktopIframeUrl", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
      var finalUrl, blob, formData, glbModel, randomString, response, data, url, settings, queryParams;
      return _regeneratorRuntime().wrap(function _callee80$(_context82) {
        while (1) switch (_context82.prev = _context82.next) {
          case 0:
            finalUrl = '';
            _context82.prev = 1;
            _context82.next = 4;
            return _this.exportTryOnMeshToGlb();
          case 4:
            blob = _context82.sent;
            formData = new FormData();
            _context82.next = 8;
            return blob.arrayBuffer();
          case 8:
            glbModel = _context82.sent;
            randomString = Math.random().toString(36).substring(7);
            formData.append('blob', new Blob([glbModel]), "model_".concat(randomString, ".glb"));
            _context82.next = 13;
            return fetch(Zakeke.config.baseApiUrl + 'tryonassetupload/asset-upload', {
              method: 'POST',
              body: formData,
              headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + window['token']
              }
            });
          case 13:
            response = _context82.sent;
            if (!response.ok) {
              _context82.next = 26;
              break;
            }
            _context82.next = 17;
            return response.json();
          case 17:
            data = _context82.sent;
            url = data; // Costruisco i parametri di query una volta caricato il modello
            settings = _this.tryOnMeshVisibleSettings || ___WEBPACK_IMPORTED_MODULE_2__.DefaultDeepARFineTuningSettings;
            console.log('settings da getDeepARUrl ', settings);
            queryParams = new URLSearchParams({
              positionX: settings.position.x.toString(),
              positionY: settings.position.y.toString(),
              positionZ: settings.position.z.toString(),
              scale: settings.scale.toString(),
              environment: settings.environment.toString()
            });
            finalUrl = "".concat(url, "&").concat(queryParams.toString(), "&isDesktopDeepARUrl=true");
            console.log('>>>>>>>>> finalUrl2', finalUrl);
            _context82.next = 27;
            break;
          case 26:
            console.error('Error uploading model', response);
          case 27:
            _context82.next = 32;
            break;
          case 29:
            _context82.prev = 29;
            _context82.t0 = _context82["catch"](1);
            console.error('Error uploading model', _context82.t0);
          case 32:
            return _context82.abrupt("return", finalUrl);
          case 33:
          case "end":
            return _context82.stop();
        }
      }, _callee80, null, [[1, 29]]);
    })));
    _defineProperty(this, "tryOnCountView", /*#__PURE__*/function () {
      var _ref84 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee81(sellerID, providerID, modeChosen) {
        return _regeneratorRuntime().wrap(function _callee81$(_context83) {
          while (1) switch (_context83.prev = _context83.next) {
            case 0:
              _context83.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.tryOnApiUrl + 'tryoncount/view', {
                sellerID: sellerID,
                providerID: providerID,
                mode: modeChosen
              });
            case 2:
            case "end":
              return _context83.stop();
          }
        }, _callee81);
      }));
      return function (_x75, _x76, _x77) {
        return _ref84.apply(this, arguments);
      };
    }());
    /**
     * Ottiene le restrizioni sul printing method (che nel caso di un prodotto configuratore 3D c'è sempre ed è 1 solo).
     * @remarks
     * Se non ci sono restrizioni, ritorna quelle di default
     * @returns
     * Le restrizioni sul printing method o quelle di default
     */
    _defineProperty(this, "getPrintingMethodsRestrictions", function () {
      var defaultColor = {
        colorCode: '#000000',
        isDefault: true
      };
      var restrictions = {
        allowedBold: true,
        allowedItalic: true,
        allowedCurved: true,
        disableTextColors: false,
        textColors: [defaultColor],
        defaultColor: '#000000',
        isPDFPreviewEnabled: true
      };
      if (_this.zkProduct && _this.zkProduct.get('printTypes').length > 0) {
        var printType = _this.zkProduct.get('printTypes').at(0);
        var printRestrictions = printType.get('printTypeRestrictions');
        if (printRestrictions) {
          var _printRestrictions$ge, _printRestrictions$ge2, _printRestrictions$ge3, _printRestrictions$ge4, _printRestrictions$ge5, _printRestrictions$ge6, _printRestrictions$ge7, _printRestrictions$ge8;
          defaultColor = _objectSpread(_objectSpread({}, defaultColor), {}, {
            colorCode: (_printRestrictions$ge = printRestrictions.get('defaultColor')) !== null && _printRestrictions$ge !== void 0 ? _printRestrictions$ge : '#000000'
          });
          var textColors = (_printRestrictions$ge2 = printRestrictions.get('textColors')) !== null && _printRestrictions$ge2 !== void 0 ? _printRestrictions$ge2 : [];
          if (!textColors.find(function (color) {
            return color.colorCode === defaultColor.colorCode;
          })) textColors.push(defaultColor);
          restrictions = {
            allowedBold: (_printRestrictions$ge3 = printRestrictions.get('allowBold')) !== null && _printRestrictions$ge3 !== void 0 ? _printRestrictions$ge3 : true,
            allowedItalic: (_printRestrictions$ge4 = printRestrictions.get('allowItalic')) !== null && _printRestrictions$ge4 !== void 0 ? _printRestrictions$ge4 : true,
            allowedCurved: (_printRestrictions$ge5 = printRestrictions.get('curvedText')) !== null && _printRestrictions$ge5 !== void 0 ? _printRestrictions$ge5 : true,
            disableTextColors: (_printRestrictions$ge6 = printRestrictions.get('disableTextColors')) !== null && _printRestrictions$ge6 !== void 0 ? _printRestrictions$ge6 : false,
            textColors: textColors,
            defaultColor: (_printRestrictions$ge7 = printRestrictions.get('defaultColor')) !== null && _printRestrictions$ge7 !== void 0 ? _printRestrictions$ge7 : '#000000',
            isPDFPreviewEnabled: (_printRestrictions$ge8 = printRestrictions.get('canPreviewDesignsPDF')) !== null && _printRestrictions$ge8 !== void 0 ? _printRestrictions$ge8 : true
          };
        }
      }
      return restrictions;
    });
    _defineProperty(this, "setMouseWheelZoomEnabled", function (enabled) {
      _this.viewer.setMouseWheelInputEnabled(enabled);
    });
    _defineProperty(this, "setCameraPinchingZoom", function (toggle) {
      _this.viewer.setCameraPinchingZoom(toggle);
    });
    if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
      this.previewHeight = 512;
      this.previewWidth = 512;
    }
  }
  _createClass(ZakekeEnvironment, [{
    key: "internalProduct",
    get: function get() {
      return this.zkProduct;
    }
  }, {
    key: "internalScene",
    get: function get() {
      return this.zkScene;
    }
  }, {
    key: "internalCurrentTemplate",
    get: function get() {
      return this.zkCurrentTemplate;
    }
  }, {
    key: "isFullscreenMode",
    get: function get() {
      var doc = document;
      return Boolean(doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement);
    }
  }, {
    key: "isViewerReady",
    get: function get() {
      return !!this.viewer;
    }
  }, {
    key: "isShoppingPreview",
    get: function get() {
      return this.isViewerMode || this.platform.toLowerCase() == 'preview';
    }
  }, {
    key: "makeDAMAnalyticsView",
    value: function () {
      var _makeDAMAnalyticsView = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee82(type) {
        var _this$settings;
        var body;
        return _regeneratorRuntime().wrap(function _callee82$(_context84) {
          while (1) switch (_context84.prev = _context84.next) {
            case 0:
              body = {
                modelCode: this.productCode || '',
                userId: ((_this$settings = this.settings) === null || _this$settings === void 0 ? void 0 : _this$settings.userID) || 0,
                eventType: type
              };
              return _context84.abrupt("return", axios__WEBPACK_IMPORTED_MODULE_12__["default"].post(Zakeke.config.damSettings.analyticsUrl, body));
            case 2:
            case "end":
              return _context84.stop();
          }
        }, _callee82, this);
      }));
      function makeDAMAnalyticsView(_x78) {
        return _makeDAMAnalyticsView.apply(this, arguments);
      }
      return makeDAMAnalyticsView;
    }()
  }, {
    key: "addHotjarScript",
    value: function addHotjarScript(siteID) {
      if (siteID && siteID.length > 0 && this.platform && this.platform.toLowerCase() !== 'preview') {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = "(function(h,o,t,j,a,r){\n                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n                    h._hjSettings={hjid:".concat(siteID, ",hjsv:6};\n                    a=o.getElementsByTagName('head')[0];\n                    r=o.createElement('script');r.async=1;\n                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n                    a.appendChild(r);\n                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');");
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    }
  }, {
    key: "addGoogleTagManagerID",
    value: function addGoogleTagManagerID(siteID) {
      if (siteID && siteID.length > 0 && this.platform && this.platform.toLowerCase() !== 'preview') {
        var head = document.querySelector('head');
        if (head) {
          head.append('<script>' + "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n\t\t\t\tnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n\t\t\t\tj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n\t\t\t\t'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n\t\t\t\t})(window,document,'script','dataLayer','".concat(siteID, "')") + '</script>');
        }
        var noscript = document.createElement('noscript');
        var iframe = document.createElement('iframe');
        iframe.src = "https://www.googletagmanager.com/ns.html?id=".concat(siteID);
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.cssText = 'display:none;visibility:hidden';
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);
      }
    }
  }, {
    key: "setQuantity",
    value: function setQuantity(quantity) {
      // Adapt quantity to rules
      var quantityRule = this.zkProduct.get('quantityRule');
      if (quantityRule) {
        var min = quantityRule.get('minQuantity');
        var max = quantityRule.get('maxQuantity');
        var step = quantityRule.get('step');
        if (min && quantity < min) quantity = min;
        if (max && quantity > max) quantity = max;
        if (step) {
          quantity = Math.round(quantity / step) * step;
          if (quantity < step) quantity = step;
        }
      }
      this.quantity = quantity;
      this.trigger('change');
      this.updatePrice();
    }
  }, {
    key: "createStep",
    value: function createStep(zkStep, groupSelection) {
      var _zkStep$get,
        _zkStep$get2,
        _this2 = this;
      var step = new _models__WEBPACK_IMPORTED_MODULE_11__.Step();
      step.id = zkStep.get('stepID');
      step.guid = zkStep.get('stepGuid');
      step.name = (_zkStep$get = zkStep.get('name')) !== null && _zkStep$get !== void 0 ? _zkStep$get : '';
      step.cameraLocationID = (_zkStep$get2 = zkStep.get('cameraLocationID')) !== null && _zkStep$get2 !== void 0 ? _zkStep$get2 : null;
      step.displayOrder = zkStep.get('displayOrder');

      // The attributes in a step must have the group ID too or the group selection will be empty
      var _loop8 = function _loop8() {
        var zakekeAttribute = _this2.zkProduct.get('attributes').at(i);
        var attributeSelection = groupSelection.get('attributes').find(function (attr) {
          return attr.get('attributeID') == zakekeAttribute.get('attributeID');
        });
        if (attributeSelection && zakekeAttribute.get('stepID') == zkStep.get('stepID')) {
          var attribute = _this2.createAttributeFromSelection(attributeSelection);
          step.attributes.push(attribute);
        }
      };
      for (var i = 0; i < this.zkProduct.get('attributes').length; i++) {
        _loop8();
      }
      step.attributes.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });

      // Template groups
      var _loop9 = function _loop9() {
        var zakekeTemplateGroup = _this2.zkProduct.get('templateGroups').at(k);
        var templateGroupSelection = groupSelection.get('templateGroups').find(function (templGr) {
          return templGr.get('templateGroupID') == zakekeTemplateGroup.get('templateGroupID');
        });
        if (templateGroupSelection && zakekeTemplateGroup.get('stepID') == zkStep.get('stepID')) {
          var templateGroup = _this2.createTemplateGroupFromSelection(templateGroupSelection);
          step.templateGroups.push(templateGroup);
        }
      };
      for (var k = 0; k < this.zkProduct.get('templateGroups').length; k++) {
        _loop9();
      }
      step.templateGroups.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });
      return step;
    }
  }, {
    key: "selectOptionsbyPrompt",
    value: function () {
      var _selectOptionsbyPrompt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee83(prompt) {
        var _this$product4,
          _this3 = this;
        var response, _iterator12, _step12, _loop10;
        return _regeneratorRuntime().wrap(function _callee83$(_context86) {
          while (1) switch (_context86.prev = _context86.next) {
            case 0:
              if (prompt) {
                _context86.next = 2;
                break;
              }
              throw new Error('Invalid prompt');
            case 2:
              _context86.next = 4;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.baseApiUrl + 'ai/configuration-by-prompt', {
                params: {
                  productId: (_this$product4 = this.product) === null || _this$product4 === void 0 ? void 0 : _this$product4.id
                }
              });
            case 4:
              response = _context86.sent.data;
              _iterator12 = _createForOfIteratorHelper(response);
              _context86.prev = 6;
              _loop10 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop10() {
                var _this3$groups$flatMap;
                var _step12$value, attributeName, optionName, optionId;
                return _regeneratorRuntime().wrap(function _loop10$(_context85) {
                  while (1) switch (_context85.prev = _context85.next) {
                    case 0:
                      _step12$value = _slicedToArray(_step12.value, 2), attributeName = _step12$value[0], optionName = _step12$value[1];
                      optionId = (_this3$groups$flatMap = _this3.groups.flatMap(function (x) {
                        return x.attributes;
                      }).find(function (x) {
                        return x.name === attributeName;
                      })) === null || _this3$groups$flatMap === void 0 ? void 0 : _this3$groups$flatMap.options.find(function (x) {
                        return x.name === optionName;
                      });
                      if (optionId) {
                        _this3.selectOption(optionId.id);
                      }
                    case 3:
                    case "end":
                      return _context85.stop();
                  }
                }, _loop10);
              });
              _iterator12.s();
            case 9:
              if ((_step12 = _iterator12.n()).done) {
                _context86.next = 13;
                break;
              }
              return _context86.delegateYield(_loop10(), "t0", 11);
            case 11:
              _context86.next = 9;
              break;
            case 13:
              _context86.next = 18;
              break;
            case 15:
              _context86.prev = 15;
              _context86.t1 = _context86["catch"](6);
              _iterator12.e(_context86.t1);
            case 18:
              _context86.prev = 18;
              _iterator12.f();
              return _context86.finish(18);
            case 21:
            case "end":
              return _context86.stop();
          }
        }, _callee83, this, [[6, 15, 18, 21]]);
      }));
      function selectOptionsbyPrompt(_x79) {
        return _selectOptionsbyPrompt.apply(this, arguments);
      }
      return selectOptionsbyPrompt;
    }()
  }, {
    key: "setCamera",
    value: function setCamera(cameraLocationId, onlyAngleOfView, animate) {
      this.viewer.setCameraLocation(cameraLocationId, onlyAngleOfView, animate);
      this.lastCameraLocation = cameraLocationId;
    }
  }, {
    key: "getCameraByName",
    value: function getCameraByName(name) {
      var _this$zkScene13;
      var location = (_this$zkScene13 = this.zkScene) === null || _this$zkScene13 === void 0 ? void 0 : _this$zkScene13.get('cameraLocations').find(function (x) {
        return x.get('name') == name;
      });
      return location;
    }
  }, {
    key: "setCameraLocation",
    value: function setCameraLocation(name) {
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var location = this.getCameraByName(name);
      if (!location) throw new Error("Camera with name ".concat(name, " does not exists."));
      this.viewer.setCameraLocation(location.get('locationID'), false, animate);
      this.lastCameraLocation = location.get('locationID');
    }
  }, {
    key: "getDesignItemsInfo",
    value: function getDesignItemsInfo() {
      var items = [];
      if (this.viewer) {
        var _this$viewer$getDesig, _this$viewer$getDesig2;
        items = (_this$viewer$getDesig = (_this$viewer$getDesig2 = this.viewer.getDesignItemsInfo()) === null || _this$viewer$getDesig2 === void 0 ? void 0 : _this$viewer$getDesig2.map(function (item) {
          return item instanceof MPlaza.ImageItemInfo ? new _models__WEBPACK_IMPORTED_MODULE_11__.ImageItem(item) : new _models__WEBPACK_IMPORTED_MODULE_11__.TextItem(item);
        })) !== null && _this$viewer$getDesig !== void 0 ? _this$viewer$getDesig : [];
      }
      return items;
    }
  }, {
    key: "isAreaVisible",
    value: function isAreaVisible(areaId) {
      // Get the mesh side
      // in this case areaId is sideId
      var meshSides = this.zkProduct.get('scenes').at(0).get('meshSides').filter(function (x) {
        return x.get('sideID') == areaId;
      });
      var _iterator13 = _createForOfIteratorHelper(meshSides),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var meshSide = _step13.value;
          var meshId = meshSide.get('meshID');
          if (meshId) {
            var mesh = this.viewer.scene.getMeshByID(meshId);
            if (mesh && mesh.isVisible) return true;
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      return false;
    }
  }, {
    key: "addItemText",
    value: function () {
      var _addItemText = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee84(settings, areaId) {
        var font;
        return _regeneratorRuntime().wrap(function _callee84$(_context87) {
          while (1) switch (_context87.prev = _context87.next) {
            case 0:
              if (!this.viewer) {
                _context87.next = 12;
                break;
              }
              // First download the font
              font = this.fonts.find(function (x) {
                return x.name === settings.fontFamily;
              });
              if (!font) {
                _context87.next = 9;
                break;
              }
              _context87.next = 5;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([font])["catch"](function (e) {
                console.error('Error loading font', e, font);
              });
            case 5:
              this.viewer.addDesignItemText(_objectSpread(_objectSpread({}, settings), {}, {
                content: settings.text
              }), areaId);
              this.renderDesign();
              _context87.next = 10;
              break;
            case 9:
              console.warn("No font found for ".concat(settings.fontFamily));
            case 10:
              _context87.next = 13;
              break;
            case 12:
              throw 'Called add item text but no viewer or viewer not ready';
            case 13:
            case "end":
              return _context87.stop();
          }
        }, _callee84, this);
      }));
      function addItemText(_x80, _x81) {
        return _addItemText.apply(this, arguments);
      }
      return addItemText;
    }()
  }, {
    key: "fullyLoadFont",
    value: function () {
      var _fullyLoadFont = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee85(font) {
        var fontFamily;
        return _regeneratorRuntime().wrap(function _callee85$(_context88) {
          while (1) switch (_context88.prev = _context88.next) {
            case 0:
              if (!(typeof font === 'string')) {
                _context88.next = 12;
                break;
              }
              fontFamily = this.fonts.find(function (x) {
                return x.name === font;
              });
              if (!fontFamily) {
                _context88.next = 9;
                break;
              }
              if (fontFamily.fullLoaded) {
                _context88.next = 6;
                break;
              }
              _context88.next = 6;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([fontFamily]);
            case 6:
              return _context88.abrupt("return", fontFamily);
            case 9:
              return _context88.abrupt("return", this.fonts[0]);
            case 10:
              _context88.next = 16;
              break;
            case 12:
              if (font.fullLoaded) {
                _context88.next = 15;
                break;
              }
              _context88.next = 15;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([font]);
            case 15:
              return _context88.abrupt("return", font);
            case 16:
            case "end":
              return _context88.stop();
          }
        }, _callee85, this);
      }));
      function fullyLoadFont(_x82) {
        return _fullyLoadFont.apply(this, arguments);
      }
      return fullyLoadFont;
    }()
  }, {
    key: "setCameraPivot",
    value: function setCameraPivot(meshID) {
      this.viewer.setCameraPivot(meshID);
    }
  }, {
    key: "resetCameraPivot",
    value: function resetCameraPivot() {
      this.viewer.setCameraPivot(null);
    }
  }, {
    key: "setCameraZoomEnabled",
    value: function setCameraZoomEnabled(enabled) {
      this.viewer.setCameraZoomEnabled(enabled);
    }
  }, {
    key: "setCameraByName",
    value: function setCameraByName(name, onlyAngleOfView, animate) {
      if (this.zkScene) {
        var location = this.zkScene.get('cameraLocations').find(function (x) {
          return x.get('name') == name;
        });
        if (location) this.viewer.setCameraLocation(location.get('locationID'), onlyAngleOfView, animate);
      }
    }
  }, {
    key: "findObjectByName",
    value: function findObjectByName(name) {
      if (this.viewer && this.viewer.scene) return this.viewer.scene.meshes.find(function (x) {
        return x.name == name;
      });else return null;
    }
  }, {
    key: "hightlightGroup",
    value: function hightlightGroup(groupId) {
      var _this$viewer2;
      (_this$viewer2 = this.viewer) === null || _this$viewer2 === void 0 ? void 0 : _this$viewer2.highlightGroupByID(groupId);
    }
  }, {
    key: "highlightAttribute",
    value: function highlightAttribute(attributeId) {
      var _this$viewer3;
      (_this$viewer3 = this.viewer) === null || _this$viewer3 === void 0 ? void 0 : _this$viewer3.highlightAttributeByID(attributeId);
    }
  }, {
    key: "hasVTryOnEnabled",
    get: function get() {
      if (!this.zkScene) return false;
      if (!this.tryOnSellerSettings) return false;
      if (this.tryOnSellerSettings.vtoState === ___WEBPACK_IMPORTED_MODULE_2__.SellerTryOnState.NotActive) return false;
      if (!this.tryOnProductSettings) return false;
      var settings = JSON.parse(this.tryOnProductSettings.settings);
      if (!settings.active) return false;
      if (!this.zkScene.getTryOnEnabled()) return false;
      if (!this.zkScene.getTryOnSettings()) return false;
      if (!this.zkScene.getTryOnSettings().typeSettings.active) return false;
      return true;
    }
  }, {
    key: "canUseTryOn",
    get: function get() {
      if (!this.tryOnSellerSettings) return false;
      if (this.tryOnSellerSettings.vtoState === ___WEBPACK_IMPORTED_MODULE_2__.SellerTryOnState.NotActive) return false;
      if (!this.tryOnProductSettings) return false;
      var settings = JSON.parse(this.tryOnProductSettings.settings);
      if (!settings.try_on) return false;
      if (!this.tryOnSellerSettings) return false;
      if (this.zkScene.getTryOnSettings() && this.zkScene.getTryOnSettings().typeSettings.try_on) return false;
      return true;
    }
  }, {
    key: "canUsePD",
    get: function get() {
      if (!this.tryOnSellerSettings) return false;
      if (this.tryOnSellerSettings.vtoState === ___WEBPACK_IMPORTED_MODULE_2__.SellerTryOnState.NotActive) return false;
      if (!this.tryOnProductSettings) return false;
      var settings = JSON.parse(this.tryOnProductSettings.settings);
      if (!settings.pd) return false;
      if (!this.tryOnSellerSettings) return false;
      if (this.zkScene.getTryOnSettings().typeSettings.pd) return false;
      return true;
    }
  }, {
    key: "isVisibleMeshShownForTryOn",
    get: function get() {
      var _this$viewer4;
      return (_this$viewer4 = this.viewer) === null || _this$viewer4 === void 0 ? void 0 : _this$viewer4.isTryOnMeshVisibleEnabledToShow();
    }
  }, {
    key: "isMandatoryPD",
    get: function get() {
      return this.isPupillaryDistanceMandatory;
    }
  }, {
    key: "isTryOnMeshVisible",
    get: function get() {
      var _this$viewer5;
      return ((_this$viewer5 = this.viewer) === null || _this$viewer5 === void 0 ? void 0 : _this$viewer5.getTryOnMeshVisible()) != null;
    }
  }, {
    key: "tryOnMeshVisibleSettings",
    get: function get() {
      if (this.isTryOnMeshVisible) {
        var _this$viewer7;
        try {
          var _this$viewer6;
          var finetuningData = (this === null || this === void 0 ? void 0 : (_this$viewer6 = this.viewer) === null || _this$viewer6 === void 0 ? void 0 : _this$viewer6.getDAMFineTuningData()) || undefined;
          if (finetuningData) return finetuningData;
        } catch (ex) {
          console.error('Error parsing DAM fine tuning data', ex);
        }
        var tryOnMesh = this === null || this === void 0 ? void 0 : (_this$viewer7 = this.viewer) === null || _this$viewer7 === void 0 ? void 0 : _this$viewer7.getTryOnFineTuningMeshVisible();
        if (tryOnMesh) {
          return this.viewer.getMeshFineTuningData(tryOnMesh) || undefined;
        }
      }
      return undefined;
    }
  }]);
  return ZakekeEnvironment;
}();

/***/ }),

/***/ "./src/exceptions.tsx":
/*!****************************!*\
  !*** ./src/exceptions.tsx ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Exception": () => (/* binding */ Exception),
/* harmony export */   "NonSquarePixelException": () => (/* binding */ NonSquarePixelException),
/* harmony export */   "ParametersParseFailException": () => (/* binding */ ParametersParseFailException),
/* harmony export */   "UnsupportedPlatformException": () => (/* binding */ UnsupportedPlatformException),
/* harmony export */   "UploadFailedExpection": () => (/* binding */ UploadFailedExpection)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
// Exceptions
var Exception = /*#__PURE__*/_createClass(function Exception(message) {
  _classCallCheck(this, Exception);
  this.message = message;
});
var ParametersParseFailException = /*#__PURE__*/function (_Exception) {
  _inherits(ParametersParseFailException, _Exception);
  var _super = _createSuper(ParametersParseFailException);
  function ParametersParseFailException(parameter) {
    var _this;
    _classCallCheck(this, ParametersParseFailException);
    _this = _super.call(this, "Failed parsing parameters: " + parameter);
    _this.parameter = parameter;
    return _this;
  }
  return _createClass(ParametersParseFailException);
}(Exception);
var UnsupportedPlatformException = /*#__PURE__*/function (_Exception2) {
  _inherits(UnsupportedPlatformException, _Exception2);
  var _super2 = _createSuper(UnsupportedPlatformException);
  function UnsupportedPlatformException(platform) {
    var _this2;
    _classCallCheck(this, UnsupportedPlatformException);
    _this2 = _super2.call(this, "Platform " + platform.toString() + " not supported.");
    _this2.platform = platform;
    return _this2;
  }
  return _createClass(UnsupportedPlatformException);
}(Exception);
var UploadFailedExpection = /*#__PURE__*/function (_Exception3) {
  _inherits(UploadFailedExpection, _Exception3);
  var _super3 = _createSuper(UploadFailedExpection);
  function UploadFailedExpection() {
    _classCallCheck(this, UploadFailedExpection);
    return _super3.call(this, "Upload failed.");
  }
  return _createClass(UploadFailedExpection);
}(Exception);
var NonSquarePixelException = /*#__PURE__*/function (_Exception4) {
  _inherits(NonSquarePixelException, _Exception4);
  var _super4 = _createSuper(NonSquarePixelException);
  function NonSquarePixelException() {
    _classCallCheck(this, NonSquarePixelException);
    return _super4.call(this, "The image is not supported (non-square pixels)");
  }
  return _createClass(NonSquarePixelException);
}(Exception);

/***/ }),

/***/ "./src/fontsManager.ts":
/*!*****************************!*\
  !*** ./src/fontsManager.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "downloadFontsOfDesign": () => (/* binding */ downloadFontsOfDesign),
/* harmony export */   "getParsedFileFromFont": () => (/* binding */ getParsedFileFromFont),
/* harmony export */   "loadFonts": () => (/* binding */ loadFonts),
/* harmony export */   "removeEmojisFromText": () => (/* binding */ removeEmojisFromText),
/* harmony export */   "removeInvalidCharacters": () => (/* binding */ removeInvalidCharacters),
/* harmony export */   "removeInvalidCharactersFromText": () => (/* binding */ removeInvalidCharactersFromText),
/* harmony export */   "removeTextualEmojisFromText": () => (/* binding */ removeTextualEmojisFromText),
/* harmony export */   "removeUnsupportedCharacters": () => (/* binding */ removeUnsupportedCharacters),
/* harmony export */   "sanitizeString": () => (/* binding */ sanitizeString),
/* harmony export */   "sanitizeText": () => (/* binding */ sanitizeText)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Download a list of font families so that are available for the browser
 *
 * @param fontFamilies List of font families to download
 * @returns A promise that resolves when all fonts are downloaded
 */
function loadFonts(_x) {
  return _loadFonts.apply(this, arguments);
}

/**
 * Downlod all fonts used in a design
 *
 * @param design Design to load fonts for
 * @param downloadedFonts A list of downloaded fonts
 */
function _loadFonts() {
  _loadFonts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(fontFamilies) {
    return _regeneratorRuntime().wrap(function _callee2$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", new Promise(function (resolve, reject) {
            WebFont.load({
              timeout: 200000,
              custom: {
                families: fontFamilies.map(function (x) {
                  return x.name + (x.variations && x.variations != '' ? ':' + x.variations : '');
                }),
                urls: fontFamilies.map(function (x) {
                  return x.cssUrl;
                })
              },
              active: function () {
                var _active = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  var _iterator, _step, font, promises, _iterator2, _step2, _loop, _ret;
                  return _regeneratorRuntime().wrap(function _callee$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _iterator = _createForOfIteratorHelper(fontFamilies);
                        _context3.prev = 1;
                        _iterator.s();
                      case 3:
                        if ((_step = _iterator.n()).done) {
                          _context3.next = 30;
                          break;
                        }
                        font = _step.value;
                        promises = [];
                        _iterator2 = _createForOfIteratorHelper(font.faces);
                        _context3.prev = 7;
                        _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                          var face, _iterator3, _step3, _loop2;
                          return _regeneratorRuntime().wrap(function _loop$(_context2) {
                            while (1) switch (_context2.prev = _context2.next) {
                              case 0:
                                face = _step2.value;
                                if (!face.parsedFiles) {
                                  _context2.next = 3;
                                  break;
                                }
                                return _context2.abrupt("return", "continue");
                              case 3:
                                _iterator3 = _createForOfIteratorHelper(face.filesUrls);
                                _context2.prev = 4;
                                _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                                  var faceFile;
                                  return _regeneratorRuntime().wrap(function _loop2$(_context) {
                                    while (1) switch (_context.prev = _context.next) {
                                      case 0:
                                        faceFile = _step3.value;
                                        if (faceFile.toLowerCase().endsWith('.ttf') || faceFile.toLowerCase().endsWith('.otf')) {
                                          face.parsedFiles = face.parsedFiles || [];
                                          promises.push(opentype.load(faceFile).then(function (fontFile) {
                                            face.parsedFiles.push({
                                              url: faceFile,
                                              file: fontFile
                                            });
                                          }));
                                        }
                                      case 2:
                                      case "end":
                                        return _context.stop();
                                    }
                                  }, _loop2);
                                });
                                _iterator3.s();
                              case 7:
                                if ((_step3 = _iterator3.n()).done) {
                                  _context2.next = 11;
                                  break;
                                }
                                return _context2.delegateYield(_loop2(), "t0", 9);
                              case 9:
                                _context2.next = 7;
                                break;
                              case 11:
                                _context2.next = 16;
                                break;
                              case 13:
                                _context2.prev = 13;
                                _context2.t1 = _context2["catch"](4);
                                _iterator3.e(_context2.t1);
                              case 16:
                                _context2.prev = 16;
                                _iterator3.f();
                                return _context2.finish(16);
                              case 19:
                              case "end":
                                return _context2.stop();
                            }
                          }, _loop, null, [[4, 13, 16, 19]]);
                        });
                        _iterator2.s();
                      case 10:
                        if ((_step2 = _iterator2.n()).done) {
                          _context3.next = 17;
                          break;
                        }
                        return _context3.delegateYield(_loop(), "t0", 12);
                      case 12:
                        _ret = _context3.t0;
                        if (!(_ret === "continue")) {
                          _context3.next = 15;
                          break;
                        }
                        return _context3.abrupt("continue", 15);
                      case 15:
                        _context3.next = 10;
                        break;
                      case 17:
                        _context3.next = 22;
                        break;
                      case 19:
                        _context3.prev = 19;
                        _context3.t1 = _context3["catch"](7);
                        _iterator2.e(_context3.t1);
                      case 22:
                        _context3.prev = 22;
                        _iterator2.f();
                        return _context3.finish(22);
                      case 25:
                        _context3.next = 27;
                        return Promise.allSettled(promises);
                      case 27:
                        font.fullLoaded = true;
                      case 28:
                        _context3.next = 3;
                        break;
                      case 30:
                        _context3.next = 35;
                        break;
                      case 32:
                        _context3.prev = 32;
                        _context3.t2 = _context3["catch"](1);
                        _iterator.e(_context3.t2);
                      case 35:
                        _context3.prev = 35;
                        _iterator.f();
                        return _context3.finish(35);
                      case 38:
                        resolve();
                      case 39:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee, null, [[1, 32, 35, 38], [7, 19, 22, 25]]);
                }));
                function active() {
                  return _active.apply(this, arguments);
                }
                return active;
              }(),
              inactive: function inactive() {
                reject();
              }
            });
          }));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee2);
  }));
  return _loadFonts.apply(this, arguments);
}
function downloadFontsOfDesign(_x2, _x3) {
  return _downloadFontsOfDesign.apply(this, arguments);
}

/**
 * Remove invalid characters from the text.
 * Invalid characters include backspace (\x08) and null (\u0000) characters.
 *
 * @param text The text to remove invalid characters from
 * @returns The text without invalid characters
 */
function _downloadFontsOfDesign() {
  _downloadFontsOfDesign = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(design, downloadedFonts) {
    var fonts, _iterator4, _step4, item, data, attributes, fontFamily, fontFamilies;
    return _regeneratorRuntime().wrap(function _callee3$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          // Get all the fonts first
          fonts = [];
          _iterator4 = _createForOfIteratorHelper(design.get('designItems').models);
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              item = _step4.value;
              data = JSON.parse(item.get('json'));
              attributes = data[1]; //Get the global font family or from the first letter (in case of curved text)
              fontFamily = attributes.fontFamily || (attributes.children && attributes.children.length > 0 && attributes.children[0].length > 1 ? attributes.children[0][1].fontFamily : null);
              if (fontFamily) fonts.push(fontFamily.replace(/"/g, ''));
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          fontFamilies = fonts.map(function (fontName) {
            return downloadedFonts.find(function (fontFamily) {
              return fontFamily.name == fontName;
            }) || null;
          }).filter(function (x) {
            return x != null;
          });
          if (!(fontFamilies.length > 0)) {
            _context5.next = 7;
            break;
          }
          _context5.next = 7;
          return loadFonts(fontFamilies)["catch"](function (e) {
            console.error('Error loading fonts', e, fontFamilies);
          });
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee3);
  }));
  return _downloadFontsOfDesign.apply(this, arguments);
}
function removeInvalidCharactersFromText(text) {
  var finder = /\x08|\u0000/g;
  return text.replace(finder, '');
}
/**
 * Remove unsupported characters from the text.
 * Unsupported characters include characters that cannot be displayed or processed correctly.
 * @param face The font to check character support
 * @param text The text to remove unsupported characters from
 * @returns The text without unsupported characters
 */
function sanitizeString(face, string) {
  return removeUnsupportedCharacters(removeEmojisFromText(removeTextualEmojisFromText(removeInvalidCharactersFromText(string))), face);
}
/**
 * Remove unsupported characters from the text and return a list of removed characters.
 * Unsupported characters include characters that cannot be displayed or processed correctly.
 * @param face The font to check character support
 * @param text The text to remove unsupported characters from
 * @returns The text without unsupported characters and a list of removed characters
 */
function sanitizeText(face, text) {
  var dirtyChars = [];
  var sanitizedText = sanitizeString(face, text);
  for (var i = 0; i < text.length; i++) {
    if (text[i] !== sanitizedText[i]) {
      dirtyChars.push(text[i]);
    }
  }
  return {
    sanitizedText: sanitizedText,
    dirtyChars: dirtyChars
  };
}

/**
 * Remove invalid characters from the text based on the font file.
 * Invalid characters include whitespace or characters that are not supported by the font.
 *
 * @param text The text to remove invalid characters from
 * @param fontFile The font file used to check character support
 * @returns The text without invalid characters
 */
function removeInvalidCharacters(text, fontFile) {
  return text.split('').filter(function (_char) {
    return _char.match(/\s/) || fontFile.charToGlyph(_char).unicode;
  }).join('');
}

/**
 * Get the parsed file from a font
 *
 * @param face The font to get the parsed file from
 * @returns The parsed file
 */
function getParsedFileFromFont(face) {
  return face.parsedFiles.find(function (faceFile) {
    return faceFile.url.toLowerCase().endsWith('.ttf') || faceFile.url.toLowerCase().endsWith('.otf');
  });
}
/**
 * Remove unsupported characters from the text.
 * Unsupported characters include characters that cannot be displayed or processed correctly.
 * @param text The text to remove unsupported characters from
 * @returns The text without unsupported characters
 */
function removeUnsupportedCharacters(text, currentFont) {
  if (!text || !currentFont.parsedFiles) return text;
  var file = getParsedFileFromFont(currentFont);
  if (!file || !file.file) return text;
  return removeInvalidCharacters(text, file.file);
}
/**
 * Remove textual emojis from the text.
 * Textual emojis include emojis that are made up of multiple characters.
 * @param text The text to remove textual emojis from
 * @returns The text without textual emojis
 */
function removeTextualEmojisFromText(text) {
  // https://github.com/mathiasbynens/emoji-regex file text.js
  // Updated to Unicode v12

  var finder = /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F?|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
  var filteredText = text;
  (text.match(finder) || []).forEach(function (x) {
    if (!/[0-9*#]/.test(x)) filteredText = filteredText.replace(x, '');
  });
  return filteredText;
}

/**
 * Remove emojis from the text.
 * @param text The text to remove emojis from
 * @returns The text without emojis
 */
function removeEmojisFromText(text) {
  // https://github.com/mathiasbynens/emoji-regex file index.js
  // Updated to Unicode v12

  var finder = /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
  var filteredText = text;
  (text.match(finder) || []).forEach(function (x) {
    if (!/[0-9*#]/.test(x)) filteredText = filteredText.replace(x, '');
  });
  return filteredText;
}

/***/ }),

/***/ "./src/helpers.tsx":
/*!*************************!*\
  !*** ./src/helpers.tsx ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Browser": () => (/* binding */ Browser),
/* harmony export */   "IS_ANDROID": () => (/* binding */ IS_ANDROID),
/* harmony export */   "IS_AR_DEVICE_COMPLIANT": () => (/* binding */ IS_AR_DEVICE_COMPLIANT),
/* harmony export */   "IS_IOS": () => (/* binding */ IS_IOS),
/* harmony export */   "Pagination": () => (/* binding */ Pagination),
/* harmony export */   "StringHelper": () => (/* binding */ StringHelper),
/* harmony export */   "T": () => (/* binding */ T),
/* harmony export */   "ascComparator": () => (/* binding */ ascComparator),
/* harmony export */   "compare": () => (/* binding */ compare),
/* harmony export */   "copy": () => (/* binding */ copy),
/* harmony export */   "dataURLtoFile": () => (/* binding */ dataURLtoFile),
/* harmony export */   "getNavigatorQueryParams": () => (/* binding */ getNavigatorQueryParams),
/* harmony export */   "getPlatformSettings": () => (/* binding */ getPlatformSettings),
/* harmony export */   "hex2rgb": () => (/* binding */ hex2rgb),
/* harmony export */   "hslToRgb": () => (/* binding */ hslToRgb),
/* harmony export */   "hsvToRgb": () => (/* binding */ hsvToRgb),
/* harmony export */   "hue2rgb": () => (/* binding */ hue2rgb),
/* harmony export */   "iOS": () => (/* binding */ iOS),
/* harmony export */   "isPlatformCode": () => (/* binding */ isPlatformCode),
/* harmony export */   "isValidJSON": () => (/* binding */ isValidJSON),
/* harmony export */   "matchCodes": () => (/* binding */ matchCodes),
/* harmony export */   "rgb2hex": () => (/* binding */ rgb2hex),
/* harmony export */   "rgbToHsl": () => (/* binding */ rgbToHsl),
/* harmony export */   "rgbToHsv": () => (/* binding */ rgbToHsv),
/* harmony export */   "sleep": () => (/* binding */ sleep),
/* harmony export */   "uuid": () => (/* binding */ uuid)
/* harmony export */ });
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var T = /*#__PURE__*/function () {
  function T() {
    _classCallCheck(this, T);
  }
  _createClass(T, null, [{
    key: "_",
    value: function _(str, domain) {
      var _this$translations;
      if ((_this$translations = this.translations) !== null && _this$translations !== void 0 && _this$translations.statics) {
        var _this$translations2;
        var keys = Array.from((_this$translations2 = this.translations) === null || _this$translations2 === void 0 ? void 0 : _this$translations2.statics.keys());
        for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
          var key = _keys[_i];
          if (key.toLowerCase() === str.toLowerCase()) return this.translations.statics.get(key);
        }
      }
      var gt = window.gt;
      return gt ? gt.dgettext(domain, str) : str;
    }
  }, {
    key: "_d",
    value: function _d(str) {
      var _this$translations3;
      var string = str;
      if ((_this$translations3 = this.translations) !== null && _this$translations3 !== void 0 && _this$translations3.dynamics) {
        var _this$translations4;
        var keys = Array.from((_this$translations4 = this.translations) === null || _this$translations4 === void 0 ? void 0 : _this$translations4.dynamics.keys());
        for (var _i2 = 0, _keys2 = keys; _i2 < _keys2.length; _i2++) {
          var key = _keys2[_i2];
          if (key.toLowerCase() === str.toLowerCase()) {
            if (this.translations.dynamics.get(key)) string = this.translations.dynamics.get(key);
          }
        }
      }
      return string;
    }
  }]);
  return T;
}();
_defineProperty(T, "translations", null);
function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
}
var StringHelper = /*#__PURE__*/function () {
  function StringHelper() {
    _classCallCheck(this, StringHelper);
  }
  _createClass(StringHelper, null, [{
    key: "padLeft",
    value: function padLeft(str, width, _char) {
      var newStr = str.toString();
      for (var i = 0; i < width - newStr.length; i++) newStr = _char + newStr;
      return newStr;
    }
  }, {
    key: "padRight",
    value: function padRight(str, width, _char2) {
      var newStr = str.toString();
      for (var i = 0; i < width - newStr.length; i++) newStr = newStr + _char2;
      return newStr;
    }
  }, {
    key: "format",
    value: function format(str) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return args.reduce(function (prev, current, idx) {
        return prev.replace("{".concat(idx, "}"), current);
      }, str);
    }
  }, {
    key: "camelToSnake",
    value: function camelToSnake(o) {
      var newO = {},
        origKey,
        newKey,
        value;
      if (o instanceof Array) {
        newO = [];
        for (origKey in o) {
          value = o[origKey];
          if (_typeof(value) === 'object') {
            value = StringHelper.camelToSnake(value);
          }
          newO.push(value);
        }
      } else {
        newO = {};
        for (origKey in o) {
          if (o.hasOwnProperty(origKey)) {
            newKey = origKey.replace(/\.?([A-Z]+)/g, function (x, y) {
              return '_' + y.toLowerCase();
            }).replace(/^_/, '');
            value = o[origKey];
            if (value) if (value && value instanceof Array || value !== null && value.constructor === Object) {
              value = StringHelper.camelToSnake(value);
            }
            newO[newKey] = value;
          }
        }
      }
      return newO;
    }
  }, {
    key: "pascalToCamel",
    value: function pascalToCamel(o) {
      var newO = {},
        origKey,
        newKey,
        value;
      if (o instanceof Array) {
        newO = [];
        for (origKey in o) {
          value = o[origKey];
          if (_typeof(value) === 'object') {
            value = StringHelper.pascalToCamel(value);
          }
          newO.push(value);
        }
      } else {
        newO = {};
        for (origKey in o) {
          if (o.hasOwnProperty(origKey)) {
            newKey = origKey.replace(/^([A-Z])/g, function (x, y) {
              return y.toLowerCase();
            });
            value = o[origKey];
            if (value) if (value && value instanceof Array || value !== null && value.constructor === Object) {
              value = StringHelper.pascalToCamel(value);
            }
            newO[newKey] = value;
          }
        }
      }
      return newO;
    }
  }]);
  return StringHelper;
}();
var Browser = /*#__PURE__*/function () {
  function Browser() {
    _classCallCheck(this, Browser);
  }
  _createClass(Browser, null, [{
    key: "openWindow",
    value: function openWindow(url, width, height) {
      return window.open(url, 'width=' + width + ',height=' + height + ';menubar=no,location=no,status=no,toolbar=no');
    }
  }]);
  return Browser;
}();
var Pagination = /*#__PURE__*/function () {
  function Pagination() {
    _classCallCheck(this, Pagination);
  }
  _createClass(Pagination, null, [{
    key: "nextPage",
    value: function nextPage(headerLink) {
      var matches = /.*<(.*)>; rel="next".*/.exec(headerLink);
      if (!matches) {
        return null;
      }
      return matches[1];
    }
  }]);
  return Pagination;
}();
function hex2rgb(c) {
  var c = c.substring(1); // strip #
  var rgb = parseInt(c, 16); // convert rrggbb to decimal
  var r = rgb >> 16 & 0xff; // extract red
  var g = rgb >> 8 & 0xff; // extract green
  var b = rgb >> 0 & 0xff; // extract blue

  return {
    r: r,
    g: g,
    b: b
  };
}
function rgb2hex(r, g, b) {
  return '#' + ('0' + parseInt(r).toString(16)).slice(-2) + ('0' + parseInt(g).toString(16)).slice(-2) + ('0' + parseInt(b).toString(16)).slice(-2);
}
function rgbToHsl(r, g, b) {
  r /= 255, g /= 255, b /= 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return [h, s, l];
}
function hslToRgb(h, s, l) {
  var r, g, b;
  if (s == 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return [r * 255, g * 255, b * 255];
}
function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function rgbToHsv(r, g, b) {
  r /= 255, g /= 255, b /= 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    v = max;
  var d = max - min;
  s = max == 0 ? 0 : d / max;
  if (max == min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return [h, s, v];
}
function hsvToRgb(h, s, v) {
  var r, g, b;
  var i = Math.floor(h * 6);
  var f = h * 6 - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0:
      r = v, g = t, b = p;
      break;
    case 1:
      r = q, g = v, b = p;
      break;
    case 2:
      r = p, g = v, b = t;
      break;
    case 3:
      r = p, g = q, b = v;
      break;
    case 4:
      r = t, g = p, b = v;
      break;
    case 5:
      r = v, g = p, b = q;
      break;
  }
  return [r * 255, g * 255, b * 255];
}
var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
function copy(obj) {
  if (!obj) {
    return obj;
  }
  var bObject, v, k;
  bObject = Array.isArray(obj) ? [] : {};
  for (k in obj) {
    v = obj[k];
    bObject[k] = _typeof(v) === 'object' ? copy(v) : v;
  }
  return bObject;
}
function compare(_obj1, _obj2) {
  if (!_obj1 || !_obj2) {
    return false;
  }
  var obj1 = copy(_obj1);
  var obj2 = copy(_obj2);

  // Special DIS case, where the code is a object with id and other parameters.
  // We need to expand it
  try {
    var idJson1 = JSON.parse(obj1.id);
    if (_typeof(idJson1) === 'object' && idJson1.id) {
      obj1 = idJson1;
      console.log('Code is a valid json with Id for obj1, use json instead', obj1, obj2);
    }
    var idJson2 = JSON.parse(obj2.id);
    if (_typeof(idJson2) === 'object' && idJson2.id) {
      obj2 = idJson2;
      console.log('Code is a valid json with Id for obj2, use json instead', obj1, obj2);
    }
  } catch (ex) {}

  // Remove dummy property
  delete obj1.zakekePlatform;
  delete obj2.zakekePlatform;
  delete obj1.label;
  delete obj2.label;
  delete obj1.isGlobal;
  delete obj2.isGlobal;
  if (Object.keys(obj1).length != Object.keys(obj2).length) return false;
  var v, k;
  var same = true;
  for (k in obj1) {
    v = obj1[k];
    if (typeof obj2[k] === 'undefined') same = false;
    if (v != obj2[k]) same = false;

    // Check if are valid json
    if (_typeof(v) === 'object' && _typeof(obj2[k]) === 'object') {
      same = compare(v, obj2[k]);
    }
    if (isValidJSON(v) || isValidJSON(obj2[k])) {
      try {
        var a = _typeof(v) === 'object' ? v : JSON.parse(v);
        var b = _typeof(obj2[k]) === 'object' ? obj2[k] : JSON.parse(obj2[k]);
        if (_typeof(a) == 'object' && _typeof(b) == 'object') same = compare(a, b);
      } catch (_unused) {}
    }
    if (!same) break;
  }
  return same;
}
function isValidJSON(code) {
  try {
    JSON.parse(code);
    return true;
  } catch (ex) {}
  return false;
}
function isPlatformCode(code) {
  var json = null;
  try {
    json = JSON.parse(code);
    return json.zakekePlatform;
  } catch (ex) {}
  return false;
}
function matchCodes(code1, code2) {
  if (isPlatformCode(code1) && isPlatformCode(code2)) return compare(JSON.parse(code1), JSON.parse(code2));else return code1 == code2;
}
function getPlatformSettings() {
  return CURRENT_REDUX_STORE.getState().platformSettings;
}
var IS_ANDROID = /android/i.test(navigator.userAgent);
var IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
var IS_AR_DEVICE_COMPLIANT = function () {
  var tempAnchor = document.createElement('a');
  return Boolean(tempAnchor.relList && tempAnchor.relList.supports && tempAnchor.relList.supports('ar'));
}();
function uuid() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
  });
  return uuid;
}
function sleep(_x) {
  return _sleep.apply(this, arguments);
}
function _sleep() {
  _sleep = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(ms) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            return setTimeout(resolve, ms);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sleep.apply(this, arguments);
}
function ascComparator(getProp) {
  // map(x => x) is for converting backbone objects in normal array
  return function (a, b) {
    var propA = getProp(a);
    var propB = getProp(b);
    if (propA < propB) return -1;
    if (propB < propA) return 1;
    return 0;
  };
}
function getNavigatorQueryParams() {
  var url = new URL(window.location.href);
  var params = new URLSearchParams(url.search);
  return params;
}

/***/ }),

/***/ "./src/hooks/tryonContext.ts":
/*!***********************************!*\
  !*** ./src/hooks/tryonContext.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TryOnContext": () => (/* binding */ TryOnContext),
/* harmony export */   "useZakekeTryOn": () => (/* binding */ useZakekeTryOn)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../components/tryon/tryOnModels */ "./src/components/tryon/tryOnModels.ts");


var TryOnContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  tryon: {},
  setTryon: function setTryon(tryon) {},
  tryOnPickedMode: _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_1__.TryOnMode.TryOn,
  setTryOnPickedMode: function setTryOnPickedMode(mode) {},
  tryOnVisibility: false,
  setTryOnVisibility: function setTryOnVisibility(visibility) {}
});
var useZakekeTryOn = function useZakekeTryOn() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(TryOnContext);
  if (!value) throw new Error('Invalid Zakeke TryOn state. Ensure you have wrapped your component with the ZakekeProvider component and you are not calling useZakekeTryOn outside of it.');
  return value;
};

/***/ }),

/***/ "./src/hooks/useZakeke.ts":
/*!********************************!*\
  !*** ./src/hooks/useZakeke.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useZakeke": () => (/* binding */ useZakeke)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../state/provider */ "./src/state/provider.tsx");
/**
 * Use Zakeke hook
 * @module useZakeke
 */




/**
 * The entry point to use all Zakeke features
 * @returns {import("../state/providerValue").Zakeke} Contains all the data and methods to control a Zakeke configuration
 */
var useZakeke = function useZakeke() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_state_provider__WEBPACK_IMPORTED_MODULE_1__.context);
  if (!value) throw new Error('Invalid Zakeke state. Ensure you have wrapped your component with the ZakekeProvider component and you are not calling useZakeke outside of it.');
  return value;
};

/***/ }),

/***/ "./src/imageUploadTask.ts":
/*!********************************!*\
  !*** ./src/imageUploadTask.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ImageUploadTask)
/* harmony export */ });
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./api */ "./src/api.ts");
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var defaultImageTaskOptions = {
  convertEpsToSvg: false,
  convertPdfToSvg: false,
  convertAiToSvg: false,
  IsPdfWithRasterAllowed: false
};
var ImageUploadTask = /*#__PURE__*/_createClass(function ImageUploadTask(culture, token) {
  var _this = this;
  var _options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultImageTaskOptions;
  _classCallCheck(this, ImageUploadTask);
  _defineProperty(this, "upload", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(file, onProgress) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.uploadFileChunked(file, file.type, Zakeke.generateUUID(), _this.options, onProgress);
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "addPrintingOptions", function (printingOptions) {
    var options = _this.options;
    if (!printingOptions) return;
    var _iterator = _createForOfIteratorHelper(printingOptions.toArray()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var printingOption = _step.value;
        _this.options.convertEpsToSvg = !(printingOption.get('convertEpsToSvg') === false);
        _this.options.convertPdfToSvg = !(printingOption.get('convertPdfToSvg') === false);
        _this.options.convertAiToSvg = !(printingOption.get('convertAiToSvg') === false);
        _this.options.IsPdfWithRasterAllowed = !(printingOption.get('isPdfWithRasterAllowed') === false);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    _this.options = options;
  });
  _defineProperty(this, "uploadFileChunked", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(imageFile, mimeType, fileID, options, progressCallaback) {
      var status, taskID, responseTaskImage;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this.resumableUpload(imageFile, mimeType, fileID, progressCallaback);
          case 2:
            status = _context2.sent;
            if (!(status === 'OK')) {
              _context2.next = 21;
              break;
            }
            _context2.next = 6;
            return _this.createImageTask(fileID, options);
          case 6:
            taskID = _context2.sent;
            if (!(taskID !== -1)) {
              _context2.next = 20;
              break;
            }
            _context2.next = 10;
            return _this.getImageFromTask(taskID);
          case 10:
            responseTaskImage = _context2.sent;
            if (!options.IsPreview) {
              _context2.next = 16;
              break;
            }
            if (!responseTaskImage) {
              _context2.next = 14;
              break;
            }
            return _context2.abrupt("return", responseTaskImage.previewUrls);
          case 14:
            _context2.next = 18;
            break;
          case 16:
            if (!(responseTaskImage && responseTaskImage.images)) {
              _context2.next = 18;
              break;
            }
            return _context2.abrupt("return", responseTaskImage.images);
          case 18:
            _context2.next = 21;
            break;
          case 20:
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_1__.UploadFailedExpection();
          case 21:
            return _context2.abrupt("return", null);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4, _x5, _x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }());
  _defineProperty(this, "resumableUpload", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(imageFile, mimeType, fileID, progressCallback) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var headersRequest = {
                'Authorization': 'Bearer ' + _this.token,
                "Accept-Language": _this.culture
              };
              var r = new Resumable({
                target: Zakeke.config.baseImagesUploadApiUrl + "filechunks/upload",
                generateUniqueIdentifier: function generateUniqueIdentifier() {
                  return fileID;
                },
                maxFiles: 1,
                testChunks: false,
                headers: headersRequest,
                query: {
                  'resumableType': mimeType
                },
                simultaneousUploads: 3
              });

              // Adding file
              r.addFile(imageFile);

              // Event Upload handlers
              r.on('fileError', function (file, message) {
                resolve('KO');
                console.error('fileError', file, message);
              });
              r.on('error', function (message, file) {
                resolve('KO');
                console.error('error', message, file);
              });
              r.on('progress', function () {
                var percentage = r.progress() * 100;
                if (progressCallback) progressCallback(percentage);
              });
              r.on('fileAdded', function (file, event) {
                r.upload();
              });
              r.on('complete', function () {
                resolve('OK');
              });
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x8, _x9, _x10, _x11) {
      return _ref3.apply(this, arguments);
    };
  }());
  _defineProperty(this, "createImageTask", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(fileID, options) {
      var imageTask, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            imageTask = {
              'fileID': fileID,
              'options': options
            };
            _context4.next = 3;
            return _api__WEBPACK_IMPORTED_MODULE_0__.axiosApi.post(Zakeke.config.baseImagesUploadApiUrl + "imagetasks", imageTask);
          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response ? response.data.taskID : -1);
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x12, _x13) {
      return _ref4.apply(this, arguments);
    };
  }());
  _defineProperty(this, "getImageFromTask", /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(taskID) {
      var times, response, _response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            times = 0;
          case 1:
            _context5.prev = 1;
            _context5.next = 4;
            return _api__WEBPACK_IMPORTED_MODULE_0__.axiosApi.get(Zakeke.config.baseImagesUploadApiUrl + "imagetasks/results/" + taskID);
          case 4:
            response = _context5.sent;
            if (!(response && response.data.state === 2)) {
              _context5.next = 9;
              break;
            }
            return _context5.abrupt("return", response.data);
          case 9:
            if (!(response && response.data.state === 3)) {
              _context5.next = 11;
              break;
            }
            return _context5.abrupt("return", null);
          case 11:
            _context5.next = 20;
            break;
          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](1);
            if (!(((_response = _context5.t0.response) === null || _response === void 0 ? void 0 : _response.status) == 406)) {
              _context5.next = 19;
              break;
            }
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_1__.NonSquarePixelException();
          case 19:
            return _context5.abrupt("return", null);
          case 20:
            times++;
            if (!(times > 100)) {
              _context5.next = 23;
              break;
            }
            return _context5.abrupt("return", null);
          case 23:
            _context5.next = 25;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 1000);
            });
          case 25:
            _context5.next = 1;
            break;
          case 27:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 13]]);
    }));
    return function (_x14) {
      return _ref5.apply(this, arguments);
    };
  }());
  this.culture = culture;
  this.token = token;
  this.options = _options;
});


/***/ }),

/***/ "./src/index.tsx":
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Attribute": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Attribute),
/* harmony export */   "AttributeOptionShapeType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.AttributeOptionShapeType),
/* harmony export */   "AttributeType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.AttributeType),
/* harmony export */   "Camera": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Camera),
/* harmony export */   "Composition": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Composition),
/* harmony export */   "CompositionItem": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.CompositionItem),
/* harmony export */   "DAMViewerAnalyticsEventType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.DAMViewerAnalyticsEventType),
/* harmony export */   "DefaultBanubaFineTuningSettings": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.DefaultBanubaFineTuningSettings),
/* harmony export */   "DefaultDeepARFineTuningSettings": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.DefaultDeepARFineTuningSettings),
/* harmony export */   "DefaultMazingFineTuningSettings": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.DefaultMazingFineTuningSettings),
/* harmony export */   "EventMessage": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.EventMessage),
/* harmony export */   "EventMessageType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.EventMessageType),
/* harmony export */   "ExtensionFieldDataType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ExtensionFieldDataType),
/* harmony export */   "Group": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Group),
/* harmony export */   "ImageItem": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ImageItem),
/* harmony export */   "ItemType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ItemType),
/* harmony export */   "Option": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Option),
/* harmony export */   "Platform": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Platform),
/* harmony export */   "PlatformPriceType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.PlatformPriceType),
/* harmony export */   "PlatformSettings": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.PlatformSettings),
/* harmony export */   "Product": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Product),
/* harmony export */   "ProductArea": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ProductArea),
/* harmony export */   "ProductQuantityRule": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ProductQuantityRule),
/* harmony export */   "PupillaryDistanceBaseProviderReceivedMessage": () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.PupillaryDistanceBaseProviderReceivedMessage),
/* harmony export */   "PupillaryDistanceBaseProviderResponseMessage": () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.PupillaryDistanceBaseProviderResponseMessage),
/* harmony export */   "PupillaryDistanceView": () => (/* reexport safe */ _components_tryon_tryOnViewer__WEBPACK_IMPORTED_MODULE_3__.PupillaryDistanceView),
/* harmony export */   "Quote": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Quote),
/* harmony export */   "QuoteRule": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.QuoteRule),
/* harmony export */   "SellerSettings": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.SellerSettings),
/* harmony export */   "SellerTryOnState": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.SellerTryOnState),
/* harmony export */   "Step": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Step),
/* harmony export */   "Template": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Template),
/* harmony export */   "TemplateArea": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TemplateArea),
/* harmony export */   "TemplateComposition": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TemplateComposition),
/* harmony export */   "TemplateConstraints": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TemplateConstraints),
/* harmony export */   "TextItem": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TextItem),
/* harmony export */   "ThemeCategory": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ThemeCategory),
/* harmony export */   "ThemeMacroCategory": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ThemeMacroCategory),
/* harmony export */   "ThemeTemplateGroup": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ThemeTemplateGroup),
/* harmony export */   "TryOnBaseProviderReceivedMessage": () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderReceivedMessage),
/* harmony export */   "TryOnBaseProviderResponseMessage": () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderResponseMessage),
/* harmony export */   "TryOnContext": () => (/* reexport safe */ _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_6__.TryOnContext),
/* harmony export */   "TryOnFineTuningMazingEnvironment": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TryOnFineTuningMazingEnvironment),
/* harmony export */   "TryOnMode": () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnMode),
/* harmony export */   "TryOnProvider": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TryOnProvider),
/* harmony export */   "TryOnSettingsType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TryOnSettingsType),
/* harmony export */   "TryOnType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TryOnType),
/* harmony export */   "TryOnView": () => (/* reexport safe */ _components_tryon_tryOnViewer__WEBPACK_IMPORTED_MODULE_3__.TryOnView),
/* harmony export */   "User": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.User),
/* harmony export */   "Variant": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Variant),
/* harmony export */   "ZakekeDesigner": () => (/* reexport safe */ _components_customizer__WEBPACK_IMPORTED_MODULE_0__.ZakekeDesigner),
/* harmony export */   "ZakekeEnvironment": () => (/* reexport safe */ _environment__WEBPACK_IMPORTED_MODULE_4__.ZakekeEnvironment),
/* harmony export */   "ZakekeEvent": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ZakekeEvent),
/* harmony export */   "ZakekeProvider": () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_8__.ZakekeProvider),
/* harmony export */   "ZakekeTryOnViewer": () => (/* reexport safe */ _components_tryon_tryOnViewer__WEBPACK_IMPORTED_MODULE_3__.ZakekeTryOnViewer),
/* harmony export */   "ZakekeViewer": () => (/* reexport safe */ _components_sceneViewer__WEBPACK_IMPORTED_MODULE_1__.ZakekeViewer),
/* harmony export */   "context": () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_8__.context),
/* harmony export */   "parseJSON": () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.parseJSON),
/* harmony export */   "useInternalState": () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_8__.useInternalState),
/* harmony export */   "useZakeke": () => (/* reexport safe */ _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_5__.useZakeke),
/* harmony export */   "useZakekeTryOn": () => (/* reexport safe */ _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_6__.useZakekeTryOn)
/* harmony export */ });
/* harmony import */ var _components_customizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./components/customizer */ "./src/components/customizer.tsx");
/* harmony import */ var _components_sceneViewer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/sceneViewer */ "./src/components/sceneViewer.tsx");
/* harmony import */ var _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/tryon/tryOnModels */ "./src/components/tryon/tryOnModels.ts");
/* harmony import */ var _components_tryon_tryOnViewer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/tryon/tryOnViewer */ "./src/components/tryon/tryOnViewer.tsx");
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environment */ "./src/environment.tsx");
/* harmony import */ var _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./hooks/useZakeke */ "./src/hooks/useZakeke.ts");
/* harmony import */ var _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./hooks/tryonContext */ "./src/hooks/tryonContext.ts");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./models */ "./src/models.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./state/provider */ "./src/state/provider.tsx");











/***/ }),

/***/ "./src/integrations/Integration.ts":
/*!*****************************************!*\
  !*** ./src/integrations/Integration.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PlatformAttributeSelection": () => (/* binding */ PlatformAttributeSelection)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var PlatformAttributeSelection = /*#__PURE__*/_createClass(function PlatformAttributeSelection(attributeCode, optionCode, attributeLabel, optionLabel, attributeIsEnabled, optionIsEnabled) {
  _classCallCheck(this, PlatformAttributeSelection);
  this.attributeCode = attributeCode;
  this.optionCode = optionCode;
  this.attributeLabel = attributeLabel;
  this.optionLabel = optionLabel;
  this.attributeIsEnabled = attributeIsEnabled;
  this.optionIsEnabled = optionIsEnabled;
});

/***/ }),

/***/ "./src/integrations/generic.ts":
/*!*************************************!*\
  !*** ./src/integrations/generic.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MerchantIntegrationGeneric)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["AddToCart"] = "AddToCart";
  MessageType["Price"] = "Price";
  MessageType["Close"] = "Close";
  MessageType["SharedComposition"] = "SharedComposition";
  return MessageType;
}(MessageType || {});
var MerchantIntegrationGeneric = /*#__PURE__*/function () {
  function MerchantIntegrationGeneric() {
    var _this = this;
    _classCallCheck(this, MerchantIntegrationGeneric);
    _defineProperty(this, "callbacks", new Map());
    _defineProperty(this, "messageIds", 0);
    _defineProperty(this, "pricingCalculator", null);
    window.addEventListener('message', function (event) {
      var eventType = event.data.zakekeMessageType;
      if (eventType === MessageType.Price || eventType === MessageType.SharedComposition) {
        var messageId = event.data.messageId;
        if (!_this.callbacks.has(messageId)) {
          return;
        }
        var callback = _this.callbacks.get(messageId);
        _this.callbacks["delete"](messageId);
        callback(event.data.message);
      }
    });
  }
  _createClass(MerchantIntegrationGeneric, [{
    key: "addToCart",
    value: function addToCart(composition, design, model, attributes, designItems, quantity, additionalProperties, shopifyNFTPrice) {
      var designPrice = this.pricingCalculator && design ? this.pricingCalculator.calculate(design, quantity) : 0;
      if (designPrice !== 0) if (quantity > 1) designPrice = designPrice / quantity;
      designPrice += shopifyNFTPrice;
      window.parent.postMessage({
        zakekeMessageType: MessageType.AddToCart,
        message: {
          composition: composition.id,
          design: design === null || design === void 0 ? void 0 : design.id,
          preview: composition.get('previewImageUrl'),
          designPrice: designPrice,
          attributes: attributes,
          designItems: designItems,
          quantity: quantity,
          additionalProperties: additionalProperties
        }
      }, '*');
    }
  }, {
    key: "getPrice",
    value: function getPrice(composition, design, model, attributes, compositionPrice, isCustomPricingConfiguratorEnabled, isCustomPricingRuleBasedEnabled, quantity) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var messageId = _this2.messageIds++;
        _this2.callbacks.set(messageId, resolve);
        console.log('Calculating price...');
        var designPrice = _this2.pricingCalculator && design ? _this2.pricingCalculator.calculate(design, quantity) : 0;
        var conditions = _this2.pricingCalculator && design ? _this2.pricingCalculator.getMatchedConditions(design, quantity, true) : [];

        // Subscription does not contain custom price
        if (!isCustomPricingRuleBasedEnabled) {
          designPrice = 0;
          conditions = [];
        }
        if (!isCustomPricingConfiguratorEnabled) compositionPrice = 0;
        console.log('Calculated Zakeke price:');
        console.log('- Composition price: ' + compositionPrice);
        if (compositionPrice !== 0) if (quantity > 1) compositionPrice = compositionPrice / quantity;
        if (designPrice !== 0) if (quantity > 1) designPrice = designPrice / quantity;
        console.log('- Design price: ' + designPrice);
        window.parent.postMessage({
          zakekeMessageType: MessageType.Price,
          messageId: messageId,
          message: {
            attributes: attributes,
            compositionPrice: compositionPrice + designPrice,
            designPrice: designPrice,
            conditions: conditions,
            quantity: quantity
          }
        }, '*');
      });
    }
  }, {
    key: "getSharedCompositionUrl",
    value: function getSharedCompositionUrl(compositionDocID) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var messageId = _this3.messageIds++;
        _this3.callbacks.set(messageId, resolve);
        window.parent.postMessage({
          zakekeMessageType: MessageType.SharedComposition,
          messageId: messageId,
          message: {
            compositionDocID: compositionDocID
          }
        }, '*');
      });
    }
  }, {
    key: "close",
    value: function close() {
      window.parent.postMessage({
        zakekeMessageType: MessageType.Close
      }, '*');
    }
  }, {
    key: "setPricingCalculator",
    value: function setPricingCalculator(pricingCalculator) {
      this.pricingCalculator = pricingCalculator;
    }
  }]);
  return MerchantIntegrationGeneric;
}();


/***/ }),

/***/ "./src/integrations/helpers.ts":
/*!*************************************!*\
  !*** ./src/integrations/helpers.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "integrationFor": () => (/* binding */ integrationFor)
/* harmony export */ });
/* harmony import */ var _preview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./preview */ "./src/integrations/preview.ts");
/* harmony import */ var _generic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./generic */ "./src/integrations/generic.ts");


function integrationFor(platform) {
  return new Promise(function (resolve, reject) {
    switch (platform) {
      case "preview":
        resolve(new _preview__WEBPACK_IMPORTED_MODULE_0__["default"]());
        break;
      default:
        resolve(new _generic__WEBPACK_IMPORTED_MODULE_1__["default"]());
    }
  });
}

/***/ }),

/***/ "./src/integrations/preview.ts":
/*!*************************************!*\
  !*** ./src/integrations/preview.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MerchantIntegrationPreview)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["Close"] = "Close";
  return MessageType;
}(MessageType || {});
var MerchantIntegrationPreview = /*#__PURE__*/function () {
  function MerchantIntegrationPreview() {
    _classCallCheck(this, MerchantIntegrationPreview);
  }
  _createClass(MerchantIntegrationPreview, [{
    key: "addToCart",
    value: function addToCart(composition, design, model, attributes, designItems, quantity, additionalProperties) {
      // Not implemented
    }
  }, {
    key: "getPrice",
    value: function getPrice(composition, design, model, attributes, compositionPrice, isCustomPricingConfiguratorEnabled, isCustomPricingRuleBasedEnabled, quantity) {
      return new Promise(function (resolve, reject) {
        resolve({
          price: isCustomPricingConfiguratorEnabled ? compositionPrice : 0,
          isOutOfStock: false
        });
      });
    }
  }, {
    key: "getSharedCompositionUrl",
    value: function getSharedCompositionUrl(compositionDocID) {
      return new Promise(function (resolve, reject) {});
    }
  }, {
    key: "setPricingCalculator",
    value: function setPricingCalculator(pricingCalculator) {
      // Not implemented
    }
  }, {
    key: "close",
    value: function close() {
      window.parent.postMessage({
        zakekeMessageType: MessageType.Close
      }, '*');
    }
  }]);
  return MerchantIntegrationPreview;
}();


/***/ }),

/***/ "./src/models.ts":
/*!***********************!*\
  !*** ./src/models.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Attribute": () => (/* binding */ Attribute),
/* harmony export */   "AttributeOptionShapeType": () => (/* binding */ AttributeOptionShapeType),
/* harmony export */   "AttributeType": () => (/* binding */ AttributeType),
/* harmony export */   "Camera": () => (/* binding */ Camera),
/* harmony export */   "Composition": () => (/* binding */ Composition),
/* harmony export */   "CompositionItem": () => (/* binding */ CompositionItem),
/* harmony export */   "DAMViewerAnalyticsEventType": () => (/* binding */ DAMViewerAnalyticsEventType),
/* harmony export */   "DefaultBanubaFineTuningSettings": () => (/* binding */ DefaultBanubaFineTuningSettings),
/* harmony export */   "DefaultDeepARFineTuningSettings": () => (/* binding */ DefaultDeepARFineTuningSettings),
/* harmony export */   "DefaultMazingFineTuningSettings": () => (/* binding */ DefaultMazingFineTuningSettings),
/* harmony export */   "EventMessage": () => (/* binding */ EventMessage),
/* harmony export */   "EventMessageType": () => (/* binding */ EventMessageType),
/* harmony export */   "ExtensionFieldDataType": () => (/* binding */ ExtensionFieldDataType),
/* harmony export */   "Group": () => (/* binding */ Group),
/* harmony export */   "ImageItem": () => (/* binding */ ImageItem),
/* harmony export */   "ItemType": () => (/* binding */ ItemType),
/* harmony export */   "Option": () => (/* binding */ Option),
/* harmony export */   "Platform": () => (/* binding */ Platform),
/* harmony export */   "PlatformPriceType": () => (/* binding */ PlatformPriceType),
/* harmony export */   "PlatformSettings": () => (/* binding */ PlatformSettings),
/* harmony export */   "Product": () => (/* binding */ Product),
/* harmony export */   "ProductArea": () => (/* binding */ ProductArea),
/* harmony export */   "ProductQuantityRule": () => (/* binding */ ProductQuantityRule),
/* harmony export */   "Quote": () => (/* binding */ Quote),
/* harmony export */   "QuoteRule": () => (/* binding */ QuoteRule),
/* harmony export */   "SellerSettings": () => (/* binding */ SellerSettings),
/* harmony export */   "SellerTryOnState": () => (/* binding */ SellerTryOnState),
/* harmony export */   "Step": () => (/* binding */ Step),
/* harmony export */   "Template": () => (/* binding */ Template),
/* harmony export */   "TemplateArea": () => (/* binding */ TemplateArea),
/* harmony export */   "TemplateComposition": () => (/* binding */ TemplateComposition),
/* harmony export */   "TemplateConstraints": () => (/* binding */ TemplateConstraints),
/* harmony export */   "TextItem": () => (/* binding */ TextItem),
/* harmony export */   "ThemeCategory": () => (/* binding */ ThemeCategory),
/* harmony export */   "ThemeMacroCategory": () => (/* binding */ ThemeMacroCategory),
/* harmony export */   "ThemeTemplateGroup": () => (/* binding */ ThemeTemplateGroup),
/* harmony export */   "TryOnFineTuningMazingEnvironment": () => (/* binding */ TryOnFineTuningMazingEnvironment),
/* harmony export */   "TryOnProvider": () => (/* binding */ TryOnProvider),
/* harmony export */   "TryOnSettingsType": () => (/* binding */ TryOnSettingsType),
/* harmony export */   "TryOnType": () => (/* binding */ TryOnType),
/* harmony export */   "User": () => (/* binding */ User),
/* harmony export */   "Variant": () => (/* binding */ Variant),
/* harmony export */   "ZakekeEvent": () => (/* binding */ ZakekeEvent)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }


var Platform = /*#__PURE__*/function (Platform) {
  Platform[Platform["Magento1"] = 5] = "Magento1";
  Platform[Platform["Magento2"] = 1] = "Magento2";
  Platform[Platform["Shopify"] = 3] = "Shopify";
  Platform[Platform["WooCommerce"] = 2] = "WooCommerce";
  return Platform;
}({});
var PlatformPriceType = /*#__PURE__*/function (PlatformPriceType) {
  PlatformPriceType[PlatformPriceType["Standard"] = 0] = "Standard";
  PlatformPriceType[PlatformPriceType["Inline"] = 1] = "Inline";
  return PlatformPriceType;
}({});
var User = /*#__PURE__*/_createClass(function User(id, username, name) {
  _classCallCheck(this, User);
  this.id = id;
  this.username = username;
  this.name = name;
});
var ZakekeEnvironment = /*#__PURE__*/function (ZakekeEnvironment) {
  ZakekeEnvironment[ZakekeEnvironment["Customizer"] = 1] = "Customizer";
  ZakekeEnvironment[ZakekeEnvironment["Composer"] = 2] = "Composer";
  ZakekeEnvironment[ZakekeEnvironment["Viewer"] = 3] = "Viewer";
  return ZakekeEnvironment;
}(ZakekeEnvironment || {});
var TryOnType = /*#__PURE__*/function (TryOnType) {
  TryOnType[TryOnType["NotSelected"] = 0] = "NotSelected";
  TryOnType[TryOnType["Eyewear"] = 1] = "Eyewear";
  TryOnType[TryOnType["Scarves"] = 2] = "Scarves";
  TryOnType[TryOnType["Earrings"] = 3] = "Earrings";
  TryOnType[TryOnType["Headwear"] = 4] = "Headwear";
  TryOnType[TryOnType["Necklace"] = 5] = "Necklace";
  TryOnType[TryOnType["Shoes"] = 6] = "Shoes";
  TryOnType[TryOnType["Watches"] = 7] = "Watches";
  TryOnType[TryOnType["Bracelet"] = 8] = "Bracelet";
  return TryOnType;
}({});
var SellerTryOnState = /*#__PURE__*/function (SellerTryOnState) {
  SellerTryOnState[SellerTryOnState["NotActive"] = 0] = "NotActive";
  SellerTryOnState[SellerTryOnState["Active"] = 1] = "Active";
  return SellerTryOnState;
}({});
var TryOnProvider = /*#__PURE__*/function (TryOnProvider) {
  TryOnProvider[TryOnProvider["NotSelected"] = 0] = "NotSelected";
  TryOnProvider[TryOnProvider["Mazing"] = 1] = "Mazing";
  TryOnProvider[TryOnProvider["Banuba"] = 2] = "Banuba";
  TryOnProvider[TryOnProvider["DeepAR"] = 3] = "DeepAR";
  return TryOnProvider;
}({});
var TryOnSettingsType = /*#__PURE__*/function (TryOnSettingsType) {
  TryOnSettingsType["VirtualTryOn"] = "try_on";
  TryOnSettingsType["GlassPupillaryDistanceTool"] = "pd";
  TryOnSettingsType["StyleButton"] = "styleButton";
  return TryOnSettingsType;
}({});
var TryOnFineTuningMazingEnvironment = /*#__PURE__*/function (TryOnFineTuningMazingEnvironment) {
  TryOnFineTuningMazingEnvironment["Neutral"] = "neutral.hdr";
  TryOnFineTuningMazingEnvironment["Light"] = "light.hdr";
  TryOnFineTuningMazingEnvironment["Bright"] = "bright.hdr";
  TryOnFineTuningMazingEnvironment["Studio"] = "studio.hdr";
  TryOnFineTuningMazingEnvironment["Court"] = "court.hdr";
  TryOnFineTuningMazingEnvironment["Blurred_Studio"] = "startup.hdr";
  return TryOnFineTuningMazingEnvironment;
}({});
var DefaultMazingFineTuningSettings = {
  temple: false,
  environment: TryOnFineTuningMazingEnvironment.Neutral,
  position: {
    x: 0,
    y: 0,
    z: 0
  },
  scale: 0
};
var DefaultBanubaFineTuningSettings = {
  rotation: {
    x: 0,
    y: 0,
    z: 0
  },
  position: {
    x: 0,
    y: 0,
    z: 0
  },
  scale: 1
};
var DefaultDeepARFineTuningSettings = {
  rotation: {
    x: 0,
    y: 0,
    z: 0
  },
  position: {
    x: 0,
    y: 0,
    z: 0
  },
  scale: 1,
  environment: 'https://filescdn.zakeke.com/cdn/3d/assets/environments/deepAR_HDRs/Warehouse-with-lights_(intermediate)_new_512.hdr'
};
var Product = /*#__PURE__*/function () {
  function Product() {
    _classCallCheck(this, Product);
    _defineProperty(this, "areas", []);
    _defineProperty(this, "quantityRule", null);
    _defineProperty(this, "quoteRule", null);
    _defineProperty(this, "environment", null);
    _defineProperty(this, "isShowSecondScreenEnabled", false);
    _defineProperty(this, "isAiConfigurationEnabled", false);
    _defineProperty(this, "isOldViewer", false);
  }
  _createClass(Product, null, [{
    key: "fromProduct",
    value: function fromProduct(zkProduct) {
      var product = new Product();
      product.id = zkProduct.id;
      product.sku = zkProduct.get('code');
      product.name = zkProduct.get('name');
      product.previewUrl = zkProduct.get('largeImageUrl');
      product.quantityRule = zkProduct.get('quantityRule') ? ProductQuantityRule.fromQuantityRule(zkProduct.get('quantityRule')) : null;
      product.areas = zkProduct.get('colors').length > 0 ? zkProduct.get('colors').at(0).get('sides').map(function (side) {
        return ProductArea.fromSide(side);
      }) : [];
      product.quoteRule = zkProduct.get('quoteRule') ? new QuoteRule(zkProduct.get('quoteRule')) : null;
      product.environment = zkProduct.get('environment');
      product.isShowSecondScreenEnabled = zkProduct.get('isShowSecondScreenEnabled');
      product.isAiConfigurationEnabled = zkProduct.get('isAiConfigurationEnabled');
      product.isOldViewer = zkProduct.get('isOldViewer');
      return product;
    }
  }]);
  return Product;
}();
var QuoteRule = /*#__PURE__*/_createClass(function QuoteRule(quoteRule) {
  _classCallCheck(this, QuoteRule);
  this.quoteRuleID = quoteRule.quoteRuleID;
  this.name = quoteRule.name;
  this.sellerID = quoteRule.sellerID;
  this.formControlsData = quoteRule.formControlsData;
  this.isValidForAllProducts = quoteRule.isValidForAllProducts;
  this.allowAddToCart = quoteRule.allowAddToCart;
  this.products = quoteRule.products;
});
var Quote = /*#__PURE__*/_createClass(function Quote() {
  _classCallCheck(this, Quote);
  _defineProperty(this, "statusID", 1);
  _defineProperty(this, "quantity", 1);
  _defineProperty(this, "modelPrice", 0);
});
var ProductArea = /*#__PURE__*/function () {
  function ProductArea() {
    _classCallCheck(this, ProductArea);
  }
  _createClass(ProductArea, null, [{
    key: "fromSide",
    value: function fromSide(modelSide) {
      var area = new ProductArea();
      area.id = modelSide.id;
      area.name = modelSide.get('name');
      area.cameraLocationID = modelSide.get('cameraLocationID');
      return area;
    }
  }]);
  return ProductArea;
}();
var ProductQuantityRule = /*#__PURE__*/function () {
  function ProductQuantityRule() {
    _classCallCheck(this, ProductQuantityRule);
    _defineProperty(this, "minQuantity", null);
    _defineProperty(this, "maxQuantity", null);
    _defineProperty(this, "step", null);
  }
  _createClass(ProductQuantityRule, null, [{
    key: "fromQuantityRule",
    value: function fromQuantityRule(quantityRule) {
      if (!quantityRule) throw 'Invalid quantity rule';
      var rule = new ProductQuantityRule();
      rule.minQuantity = quantityRule.get('minQuantity');
      rule.maxQuantity = quantityRule.get('maxQuantity');
      rule.step = quantityRule.get('step');
      return rule;
    }
  }]);
  return ProductQuantityRule;
}();
var Variant = /*#__PURE__*/_createClass(function Variant(id, sku, name, price, metadata) {
  _classCallCheck(this, Variant);
  this.id = id;
  this.sku = sku;
  this.name = name;
  this.price = price;
  this.metadata = metadata;
});
var ZakekeEvent = /*#__PURE__*/_createClass(function ZakekeEvent(event, callback) {
  _classCallCheck(this, ZakekeEvent);
  this.event = event;
  this.callback = callback;
});
var TemplateConstraints = /*#__PURE__*/_createClass(function TemplateConstraints() {
  _classCallCheck(this, TemplateConstraints);
  _defineProperty(this, "isUserImageAllowed", true);
});
var TemplateArea = /*#__PURE__*/function () {
  function TemplateArea() {
    _classCallCheck(this, TemplateArea);
    _defineProperty(this, "id", -1);
    _defineProperty(this, "uploadRestrictions", new TemplateConstraints());
    _defineProperty(this, "disableSellerImages", false);
    _defineProperty(this, "canAddImage", true);
    _defineProperty(this, "canAddText", true);
  }
  _createClass(TemplateArea, null, [{
    key: "fromTemplateArea",
    value: function fromTemplateArea(zkSide) {
      var side = new TemplateArea();
      side.id = zkSide.get('sideID');
      side.disableSellerImages = zkSide.get('disableSellerImages');
      side.canAddImage = zkSide.get('canAddImage');
      side.canAddText = zkSide.get('canAddText');
      if (zkSide.get('uploadRestrictions')) side.uploadRestrictions = lodash__WEBPACK_IMPORTED_MODULE_0___default().mergeWith(new TemplateConstraints(), zkSide.get('uploadRestrictions'), function (a, b) {
        return b != undefined ? b : a;
      });
      return side;
    }
  }]);
  return TemplateArea;
}();
var Template = /*#__PURE__*/function () {
  function Template() {
    _classCallCheck(this, Template);
    _defineProperty(this, "id", -1);
    _defineProperty(this, "name", '');
    _defineProperty(this, "areas", []);
  }
  _createClass(Template, null, [{
    key: "fromTemplate",
    value: function fromTemplate(zkTemplate) {
      var template = new Template();
      template.id = zkTemplate.get('templateDesignID');
      template.name = zkTemplate.get('name');
      template.areas = zkTemplate.get('sides').map(function (x) {
        return TemplateArea.fromTemplateArea(x);
      });
      return template;
    }
  }]);
  return Template;
}();
var ItemType = /*#__PURE__*/function (ItemType) {
  ItemType[ItemType["Text"] = 0] = "Text";
  ItemType[ItemType["Image"] = 1] = "Image";
  return ItemType;
}({});
var TextItem = /*#__PURE__*/_createClass(function TextItem(item) {
  var _item$item$data$isTem;
  _classCallCheck(this, TextItem);
  _defineProperty(this, "constraints", null);
  _defineProperty(this, "index", 0);
  this.type = ItemType.Text;
  this.areaId = item.sideID;
  this.guid = item.itemGuid;
  this.name = item.designItem.get('name');
  this.text = item.text;
  this.strokeColor = item.strokeColor;
  this.strokeWidth = item.strokeWidth;
  this.fillColor = item.fillColor;
  this.fontFamily = item.fontFamily;
  this.fontSize = item.fontSize;
  this.fontWeight = item.fontWeight;
  this.fontStyle = item.fontStyle;
  this.fontStretch = item.fontStretch;
  this.justification = item.justification;
  this.isTextOnPath = item.isTextOnPath;
  this.isTemplateElement = (_item$item$data$isTem = item.item.data.isTemplateElement) !== null && _item$item$data$isTem !== void 0 ? _item$item$data$isTem : false;
  this.constraints = item.constraints;
  this.index = item.designItem.get('index');
});
var ImageItem = /*#__PURE__*/_createClass(function ImageItem(item) {
  _classCallCheck(this, ImageItem);
  _defineProperty(this, "constraints", null);
  _defineProperty(this, "index", 0);
  this.type = ItemType.Image;
  this.imageID = item.imageID;
  this.areaId = item.sideID;
  this.guid = item.itemGuid;
  this.name = item.designItem.get('name');
  this.url = item.url;
  this.deleted = !item.visible;
  this.constraints = item.constraints;
  this.index = item.designItem.get('index');
});
var PlatformSettings = /*#__PURE__*/function () {
  function PlatformSettings() {
    _classCallCheck(this, PlatformSettings);
    _defineProperty(this, "accessKey", '');
    _defineProperty(this, "accessSecret", '');
    _defineProperty(this, "adminPath", '');
    _defineProperty(this, "apiKey", '');
    _defineProperty(this, "apiSecret", '');
    _defineProperty(this, "currencyCode", 'EUR');
    _defineProperty(this, "currencyID", undefined);
    _defineProperty(this, "definitiveUrl", '');
    _defineProperty(this, "currencySymbol", '€');
    _defineProperty(this, "ecommerceID", -1);
    _defineProperty(this, "ecommerceName", -1);
    _defineProperty(this, "hasProductsApi", false);
    _defineProperty(this, "isMarketplace", false);
    _defineProperty(this, "remoteUrl", '');
    _defineProperty(this, "username", '');
    _defineProperty(this, "password", '');
    _defineProperty(this, "canCheckIsIntegrated", false);
    _defineProperty(this, "productsApi", '');
    _defineProperty(this, "salesChannelID", -1);
  }
  _createClass(PlatformSettings, [{
    key: "platform",
    get: function get() {
      return this.ecommerceID;
    }
  }], [{
    key: "fromData",
    value: function fromData(response) {
      if (!response) throw new _exceptions__WEBPACK_IMPORTED_MODULE_1__.Exception('Cannot create platform settings from null');
      var settings = new PlatformSettings();
      lodash__WEBPACK_IMPORTED_MODULE_0___default().assign(settings, response);
      return settings;
    }
  }]);
  return PlatformSettings;
}();
_defineProperty(PlatformSettings, "Empty", new PlatformSettings()); // Ajax DTO interfaces
/**
 * Represents an image.
 */
var EventMessage = /*#__PURE__*/function () {
  function EventMessage() {
    _classCallCheck(this, EventMessage);
    _defineProperty(this, "eventID", -1);
    _defineProperty(this, "description", '');
    _defineProperty(this, "closeable", false);
    _defineProperty(this, "visible", false);
    _defineProperty(this, "addToCartDisabledIfVisible", false);
    _defineProperty(this, "enableCheckForSellerImages", false);
    _defineProperty(this, "isDefault", false);
  }
  _createClass(EventMessage, null, [{
    key: "fromMessage",
    value: function fromMessage(message) {
      var eventMessage = new EventMessage();
      eventMessage.eventID = message.eventID;
      eventMessage.description = message.description;
      eventMessage.closeable = message.closeable;
      eventMessage.visible = message.visible;
      eventMessage.addToCartDisabledIfVisible = message.addToCartDisabledIfVisible;
      eventMessage.additionalData = message.additionalData !== '' && message.additionalData !== null ? JSON.parse(message.additionalData) : '';
      eventMessage.enableCheckForSellerImages = message.enableCheckForSellerImages;
      eventMessage.isDefault = message.isDefault;
      return eventMessage;
    }
  }]);
  return EventMessage;
}();
var EventMessageType = /*#__PURE__*/function (EventMessageType) {
  EventMessageType[EventMessageType["Undefined"] = -1] = "Undefined";
  EventMessageType[EventMessageType["ImageQualityWarning"] = 1] = "ImageQualityWarning";
  EventMessageType[EventMessageType["Welcome"] = 3] = "Welcome";
  EventMessageType[EventMessageType["AddToCart"] = 4] = "AddToCart";
  EventMessageType[EventMessageType["Copyright"] = 8] = "Copyright";
  return EventMessageType;
}({});
var Camera = /*#__PURE__*/function () {
  function Camera() {
    _classCallCheck(this, Camera);
    _defineProperty(this, "id", '');
    _defineProperty(this, "name", '');
  }
  _createClass(Camera, null, [{
    key: "fromZkCamera",
    value: function fromZkCamera(zkCamera) {
      var camera = new Camera();
      camera.id = zkCamera.get('locationID');
      camera.name = zkCamera.get('name');
      return camera;
    }
  }]);
  return Camera;
}();
var Group = /*#__PURE__*/_createClass(function Group() {
  _classCallCheck(this, Group);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "guid", '');
  _defineProperty(this, "name", 'Group');
  _defineProperty(this, "enabled", false);
  _defineProperty(this, "imageUrl", null);
  _defineProperty(this, "icon", null);
  _defineProperty(this, "attributes", []);
  _defineProperty(this, "steps", []);
  _defineProperty(this, "templateGroups", []);
  _defineProperty(this, "cameraLocationId", null);
  _defineProperty(this, "displayOrder", 1);
  _defineProperty(this, "direction", 0);
  _defineProperty(this, "attributesAlwaysOpened", false);
});
var Step = /*#__PURE__*/_createClass(function Step() {
  _classCallCheck(this, Step);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "guid", '');
  _defineProperty(this, "name", 'Step');
  _defineProperty(this, "cameraLocationID", null);
  _defineProperty(this, "displayOrder", 1);
  _defineProperty(this, "attributes", []);
  _defineProperty(this, "templateGroups", []);
});
var AttributeType = /*#__PURE__*/function (AttributeType) {
  AttributeType[AttributeType["Select"] = 0] = "Select";
  AttributeType[AttributeType["Input"] = 1] = "Input";
  AttributeType[AttributeType["Colorpicker"] = 2] = "Colorpicker";
  return AttributeType;
}({});
var AttributeOptionShapeType = /*#__PURE__*/function (AttributeOptionShapeType) {
  AttributeOptionShapeType[AttributeOptionShapeType["Round"] = 1] = "Round";
  AttributeOptionShapeType[AttributeOptionShapeType["Square"] = 2] = "Square";
  return AttributeOptionShapeType;
}({});
var Attribute = /*#__PURE__*/_createClass(function Attribute() {
  _classCallCheck(this, Attribute);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "guid", '');
  _defineProperty(this, "code", '');
  _defineProperty(this, "name", 'Attribute');
  _defineProperty(this, "description", '');
  _defineProperty(this, "enabled", false);
  _defineProperty(this, "imageUrl", null);
  _defineProperty(this, "groupId", -1);
  _defineProperty(this, "stepId", -1);
  _defineProperty(this, "options", []);
  _defineProperty(this, "value", null);
  _defineProperty(this, "numberFormat", '');
  _defineProperty(this, "type", AttributeType.Select);
  _defineProperty(this, "optionShapeType", AttributeOptionShapeType.Round);
  _defineProperty(this, "displayOrder", 1);
  _defineProperty(this, "hideOptionsLabel", false);
  _defineProperty(this, "cameraLocationId", null);
});
var Option = /*#__PURE__*/_createClass(function Option() {
  _classCallCheck(this, Option);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "guid", '');
  _defineProperty(this, "code", '');
  _defineProperty(this, "name", 'Option');
  _defineProperty(this, "description", '');
  _defineProperty(this, "enabled", false);
  _defineProperty(this, "selected", false);
  _defineProperty(this, "imageUrl", null);
  _defineProperty(this, "displayOrder", 1);
  _defineProperty(this, "pricings", []);
});
var TemplateComposition = /*#__PURE__*/_createClass(function TemplateComposition() {
  _classCallCheck(this, TemplateComposition);
  _defineProperty(this, "compositionID", -1);
  _defineProperty(this, "name", '');
  _defineProperty(this, "previewImageUrl", '');
});
var ThemeCategory = /*#__PURE__*/_createClass(function ThemeCategory() {
  _classCallCheck(this, ThemeCategory);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "name", '');
  _defineProperty(this, "composition", []);
});
var ThemeMacroCategory = /*#__PURE__*/_createClass(function ThemeMacroCategory() {
  _classCallCheck(this, ThemeMacroCategory);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "name", '');
  _defineProperty(this, "category", []);
});
var ThemeTemplateGroup = /*#__PURE__*/_createClass(function ThemeTemplateGroup() {
  _classCallCheck(this, ThemeTemplateGroup);
  _defineProperty(this, "templateGroupID", -1);
  _defineProperty(this, "name", '');
  _defineProperty(this, "groupID", -1);
  _defineProperty(this, "stepID", -1);
  _defineProperty(this, "displayOrder", -1);
  _defineProperty(this, "macroCategory", []);
});
var SellerSettings = /*#__PURE__*/function () {
  function SellerSettings() {
    _classCallCheck(this, SellerSettings);
    _defineProperty(this, "customizeButtonLabel", '');
    _defineProperty(this, "customizeButtonIconUrl", '');
    _defineProperty(this, "isCompositionRecapEnabled", false);
    _defineProperty(this, "isCompositionRecapVisibleFromStart", false);
    _defineProperty(this, "canUserCloseCompositionRecap", true);
    _defineProperty(this, "minimumFractionDigits", 1);
    _defineProperty(this, "priceInfoText", '');
    _defineProperty(this, "hidePrice", false);
    _defineProperty(this, "hotjarSiteID", null);
    _defineProperty(this, "googleTagManagerID", null);
    _defineProperty(this, "canSaveDraftComposition", false);
    _defineProperty(this, "canUndoRedo", false);
    _defineProperty(this, "shareType", null);
  }
  _createClass(SellerSettings, null, [{
    key: "fromSellerSettings",
    value: function fromSellerSettings(zkSellerSettings) {
      var sellerSettings = new SellerSettings();
      sellerSettings.customizeButtonLabel = zkSellerSettings.customizeButtonLabel;
      sellerSettings.customizeButtonIconUrl = zkSellerSettings.customizeButtonIconUrl;
      sellerSettings.isCompositionRecapEnabled = zkSellerSettings.isCompositionRecapEnabled;
      sellerSettings.isCompositionRecapVisibleFromStart = zkSellerSettings.isCompositionRecapVisibleFromStart;
      sellerSettings.canUserCloseCompositionRecap = zkSellerSettings.canUserCloseCompositionRecap;
      sellerSettings.minimumFractionDigits = zkSellerSettings.minimumFractionDigits;
      sellerSettings.priceInfoText = zkSellerSettings.priceInfoText;
      sellerSettings.hidePrice = zkSellerSettings.hidePrice;
      sellerSettings.hotjarSiteID = zkSellerSettings.hotjarSiteID;
      sellerSettings.googleTagManagerID = zkSellerSettings.googleTagManagerID;
      sellerSettings.canSaveDraftComposition = zkSellerSettings.canSaveDraftComposition;
      sellerSettings.canUndoRedo = zkSellerSettings.canUndoRedo;
      sellerSettings.shareType = zkSellerSettings.shareType;
      return sellerSettings;
    }
  }]);
  return SellerSettings;
}();
var CompositionItem = /*#__PURE__*/_createClass(function CompositionItem() {
  _classCallCheck(this, CompositionItem);
  _defineProperty(this, "attributeID", -1);
  _defineProperty(this, "attributeName", '');
  _defineProperty(this, "attributeCode", '');
  _defineProperty(this, "selectedOptionName", '');
  _defineProperty(this, "selectedOptionCode", '');
});
var Composition = /*#__PURE__*/function () {
  function Composition() {
    _classCallCheck(this, Composition);
    _defineProperty(this, "name", '');
    _defineProperty(this, "docID", '');
    _defineProperty(this, "compositionID", -1);
    _defineProperty(this, "compositionItems", []);
    _defineProperty(this, "previewImageUrl", '');
    _defineProperty(this, "designID", null);
    _defineProperty(this, "pdSettings", null);
    _defineProperty(this, "tags", []);
  }
  _createClass(Composition, null, [{
    key: "fromJSON",
    value: function fromJSON(json) {
      var composition = new Composition();
      lodash__WEBPACK_IMPORTED_MODULE_0___default().assign(composition, json);
      return composition;
    }
  }]);
  return Composition;
}();
var ExtensionFieldDataType = /*#__PURE__*/function (ExtensionFieldDataType) {
  ExtensionFieldDataType[ExtensionFieldDataType["Money"] = 1] = "Money";
  ExtensionFieldDataType[ExtensionFieldDataType["Integer"] = 2] = "Integer";
  ExtensionFieldDataType[ExtensionFieldDataType["Decimal"] = 3] = "Decimal";
  return ExtensionFieldDataType;
}({});

/**
 * Represents internal translations.
 */

/**
 * Represents translations.
 */

/**
 * Represents a static translation.
 */

/**
 * Represents a dynamic translation.
 */

/**
 * Represents a color restriction.
 */

/**
 * Represents custom preview size.
 */

/**
 * Represents draft compositions.
 */

/**
 @internal
 */

/**
 * Represents information about the current composition.
 */

/**
 * Represents a template category.
 */

/**
 * Represents a template macro category.
 */

/**
 @internal
 */

/**
 @internal
 */

/**
 * Represents the boot parameters for the Zakeke Configurator.
 */

var DAMViewerAnalyticsEventType = /*#__PURE__*/function (DAMViewerAnalyticsEventType) {
  DAMViewerAnalyticsEventType["ViewProduct"] = "VIEW_PRODUCT";
  DAMViewerAnalyticsEventType["ViewArProdutc"] = "VIEW_AR_PRODUCT";
  return DAMViewerAnalyticsEventType;
}({});

/***/ }),

/***/ "./src/state/boot.tsx":
/*!****************************!*\
  !*** ./src/state/boot.tsx ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! qs */ "./node_modules/qs/lib/index.js");
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! .. */ "./src/index.tsx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



// Handle boot when provider is ready
var Boot = function Boot(_ref) {
  var parameters = _ref.parameters,
    children = _ref.children;
  var internalState = (0,___WEBPACK_IMPORTED_MODULE_2__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(internalState);
  stateRef.current = internalState;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1___default().useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    booted = _React$useState2[0],
    setBooted = _React$useState2[1];
  var boot = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(parameters) {
      var _stateRef$current, _stateRef$current2, _stateRef$current4, _stateRef$current6, _stateRef$current8, _stateRef$current9;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            (_stateRef$current = stateRef.current) === null || _stateRef$current === void 0 ? void 0 : _stateRef$current.dispatch({
              type: 'IS_SCENE_LOADING',
              isLoading: true
            });

            // Register to environment changes
            (_stateRef$current2 = stateRef.current) === null || _stateRef$current2 === void 0 ? void 0 : _stateRef$current2.state.environment.on('change', function () {
              var _stateRef$current3;
              return (_stateRef$current3 = stateRef.current) === null || _stateRef$current3 === void 0 ? void 0 : _stateRef$current3.dispatch({
                type: 'UPDATE'
              });
            });
            (_stateRef$current4 = stateRef.current) === null || _stateRef$current4 === void 0 ? void 0 : _stateRef$current4.state.environment.on('debugMode', function () {
              var _stateRef$current5;
              return (_stateRef$current5 = stateRef.current) === null || _stateRef$current5 === void 0 ? void 0 : _stateRef$current5.dispatch({
                type: 'DEBUG_MODE'
              });
            });
            (_stateRef$current6 = stateRef.current) === null || _stateRef$current6 === void 0 ? void 0 : _stateRef$current6.state.environment.on('viewer', function (v) {
              var _stateRef$current7;
              return (_stateRef$current7 = stateRef.current) === null || _stateRef$current7 === void 0 ? void 0 : _stateRef$current7.dispatch({
                type: 'VIEWER',
                value: v
              });
            });
            _context.next = 6;
            return (_stateRef$current8 = stateRef.current) === null || _stateRef$current8 === void 0 ? void 0 : _stateRef$current8.state.environment.boot(parameters);
          case 6:
            (_stateRef$current9 = stateRef.current) === null || _stateRef$current9 === void 0 ? void 0 : _stateRef$current9.dispatch({
              type: 'IS_SCENE_LOADING',
              isLoading: false
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var handleMessageReceived = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      var _stateRef$current10;
      var _stateRef$current11;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (e.data.type == 'load' && !((_stateRef$current10 = stateRef.current) !== null && _stateRef$current10 !== void 0 && _stateRef$current10.state.parametersReceived)) {
              (_stateRef$current11 = stateRef.current) === null || _stateRef$current11 === void 0 ? void 0 : _stateRef$current11.dispatch({
                type: 'PARAMETERS_RECEIVED'
              });
              boot(e.data.parameters);
              window.parent.postMessage({
                zakekeType: 'loaded',
                message: {
                  integrationVersion: 2
                }
              }, '*');
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var query = qs__WEBPACK_IMPORTED_MODULE_0___default().parse(window.location.search);
    if (parameters) {
      console.log('Loading parameters from boot parameters prop...');
      boot(parameters);
    } else if (query && query.ecommerce && query.ecommerce == 'preview') {
      console.log('Loading parameters from query string...');
      boot(null);
    } else {
      console.log('Loading parameters from post message...');
      window.addEventListener('message', handleMessageReceived);
    }
    return function () {
      return window.removeEventListener('message', handleMessageReceived);
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, children);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Boot);

/***/ }),

/***/ "./src/state/createProviderValue.ts":
/*!******************************************!*\
  !*** ./src/state/createProviderValue.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createProviderValue": () => (/* binding */ createProviderValue)
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

var createProviderValue = function createProviderValue(state, dispatch) {
  if (!state.environment) throw new Error('Invalid Zakeke environment.');
  return {
    price: state.environment.price,
    isOutOfStock: state.environment.isOutOfStock,
    currency: state.environment.currency,
    culture: state.environment.culture,
    quantity: state.environment.quantity,
    quantityRule: state.environment.quantityRule,
    internalProduct: state.environment.internalProduct,
    internalScene: state.environment.internalScene,
    internalCurrentTemplate: state.environment.internalCurrentTemplate,
    draftCompositions: state.environment.themeCompositions,
    currentAttributesSelection: state.environment.currentAttributesSelection,
    isSceneLoading: state.isSceneLoading,
    isAddToCartLoading: state.isAddToCartLoading,
    isInfoPointContentVisible: state.environment.isInfoPointContentVisible,
    fonts: state.environment.fonts,
    disableTextColors: state.environment.disableTextColors,
    defaultColor: state.environment.defaultColor,
    textColors: state.environment.textColors,
    groups: state.environment.groups,
    templates: state.environment.templates,
    loadedComposition: state.environment.loadedComposition,
    currentTemplate: state.environment.currentTemplate,
    isViewerReady: state.environment.isViewerReady,
    translations: state.environment.translations,
    items: state.environment.getDesignItemsInfo(),
    productName: state.environment.productName,
    productCode: state.environment.productCode,
    product: state.environment.product,
    cameras: state.environment.cameras,
    sellerSettings: state.environment.sellerSettings,
    eventMessages: state.environment.eventMessages,
    personalizedMessages: state.environment.personalizedMessages,
    visibleEventMessages: state.environment.visibleEventMessages,
    isAssetsLoading: state.environment.isAssetsLoading,
    additionalCustomProperties: state.environment.additionalCustomProperties,
    currentCompositionInfo: state.environment.currentCompositionInfo,
    nftSettings: state.environment.nftSettings,
    isAIEnabled: state.environment.isAIEnabled,
    useLegacyScreenshot: state.environment.useLegacyScreenshot,
    uiConfig: state.environment.uiConfig,
    backgroundColor: state.environment.backgroundColor || '#f2f2f2',
    removeBackground: state.environment.removeBackground,
    deepARsceneGLBUrl: state.environment.deepARsceneGLBUrl,
    setMouseWheelZoomEnabled: state.environment.setMouseWheelZoomEnabled.bind(state.environment),
    setCameraPinchingZoom: state.environment.setCameraPinchingZoom.bind(state.environment),
    saveComposition: state.environment.saveComposition,
    loadComposition: state.environment.loadComposition,
    getPDF: state.environment.getPDF.bind(state.environment),
    fullyLoadFont: state.environment.fullyLoadFont.bind(state.environment),
    sanitizeString: state.environment.sanitizeString.bind(state.environment),
    getSanitationText: state.environment.getSanitationText.bind(state.environment),
    getOnlineScreenshot: state.environment.getOnlineScreenshot.bind(state.environment),
    reset: state.environment.reset.bind(state.environment),
    undo: state.environment.undo.bind(state.environment),
    redo: state.environment.redo.bind(state.environment),
    setCamera: state.environment.setCamera.bind(state.environment),
    setCameraByName: state.environment.setCameraByName.bind(state.environment),
    setCameraZoomEnabled: state.environment.setCameraZoomEnabled.bind(state.environment),
    resetCameraPivot: state.environment.resetCameraPivot.bind(state.environment),
    setCameraPivot: state.environment.setCameraPivot.bind(state.environment),
    setQuantity: state.environment.setQuantity.bind(state.environment),
    getImages: state.environment.getImages.bind(state.environment),
    openSecondScreen: state.environment.openSecondScreen.bind(state.environment),
    getMacroCategories: state.environment.getMacroCategories.bind(state.environment),
    createQuote: state.environment.createQuote,
    previewOnly__setItemImageFromBase64: function () {
      var _previewOnly__setItemImageFromBase = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(guid, base64) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch({
                type: 'SET_ITEM_IMAGE_FROM_BASE64',
                guid: guid,
                base64: base64
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function previewOnly__setItemImageFromBase64(_x, _x2) {
        return _previewOnly__setItemImageFromBase.apply(this, arguments);
      }
      return previewOnly__setItemImageFromBase64;
    }(),
    setItemImageFromFile: state.environment.setItemImageFromFile.bind(state.environment),
    addItemImage: state.environment.addItemImage.bind(state.environment),
    createImage: state.environment.createImage.bind(state.environment),
    createImageFromUrl: state.environment.createImageFromUrl.bind(state.environment),
    setItemImage: state.environment.setItemImage.bind(state.environment),
    setItemFontFamily: state.environment.setItemFontFamily.bind(state.environment),
    setItemColor: state.environment.setItemColor.bind(state.environment),
    setItemBold: state.environment.setItemBold.bind(state.environment),
    setItemItalic: state.environment.setItemItalic.bind(state.environment),
    setItemTextOnPath: state.environment.setItemTextOnPath.bind(state.environment),
    setItemText: state.environment.setItemText.bind(state.environment),
    addItemText: state.environment.addItemText.bind(state.environment),
    removeItem: state.environment.removeItem.bind(state.environment),
    isFullscreenMode: state.environment.isFullscreenMode,
    switchFullscreen: function switchFullscreen() {
      return dispatch({
        type: 'SWITCH_FULLSCREEN'
      });
    },
    zoomIn: function zoomIn() {
      return dispatch({
        type: 'ZOOM_IN'
      });
    },
    zoomOut: function zoomOut() {
      return dispatch({
        type: 'ZOOM_OUT'
      });
    },
    setHighlightSettings: function setHighlightSettings(settings) {
      return dispatch({
        type: 'SET_HIGHLIGHT_SETTINGS',
        settings: settings
      });
    },
    updateView: function updateView(adjustCamera) {
      return dispatch({
        type: 'UPDATE_VIEW',
        adjustCamera: adjustCamera
      });
    },
    hasExplodedMode: state.environment.hasExplodedMode,
    isExplodedMode: state.environment.isExplodedMode,
    setExplodedMode: function setExplodedMode(exploded) {
      return dispatch({
        type: 'SET_EXPLODED_MODE',
        exploded: exploded
      });
    },
    internalAppendViewer: function internalAppendViewer(container) {
      return dispatch({
        type: 'APPEND_VIEWER',
        container: container
      });
    },
    getPrintingMethodsRestrictions: state.environment.getPrintingMethodsRestrictions.bind(state.environment),
    designUpdate: function designUpdate() {
      return dispatch({
        type: 'DESIGN_UPDATE'
      });
    },
    selectOption: function selectOption(optionId) {
      return dispatch({
        type: 'SELECT_OPTION',
        optionId: optionId
      });
    },
    isAreaVisible: state.environment.isAreaVisible.bind(state.environment),
    setTemplate: function () {
      var _setTemplate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(templateId) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", dispatch({
                type: 'SET_TEMPLATE',
                templateId: templateId
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function setTemplate(_x3) {
        return _setTemplate.apply(this, arguments);
      }
      return setTemplate;
    }(),
    saveTemplate: state.environment.saveTemplate,
    addToCart: function () {
      var _addToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _state$environment;
        var _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              dispatch({
                type: 'IS_ADD_TO_CART_LOADING',
                isLoading: true
              });
              _context3.next = 3;
              return (_state$environment = state.environment).addToCart.apply(_state$environment, _args3);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function addToCart() {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }(),
    // save compositions
    loadSavedComposition: state.environment.loadSavedComposition,
    saveDraftsComposition: state.environment.saveDraftsComposition,
    deleteSavedComposition: state.environment.deleteSavedComposition,
    // Scene manipulation
    getMeshIDbyName: state.environment.getMeshIDbyName.bind(state.environment),
    hideMeshAndSaveState: state.environment.hideMeshAndSaveState.bind(state.environment),
    restoreMeshVisibility: state.environment.restoreMeshVisibility.bind(state.environment),
    setMeshDesignVisibility: state.environment.setMeshDesignVisibility.bind(state.environment),
    exportSceneToGlb: state.environment.exportSceneToGlb,
    // Events
    clearListeners: state.environment.clearListeners,
    addFocusAttributesListener: state.environment.addFocusAttributesListener,
    focusAttribute: state.environment.focusAttribute,
    // Highlight
    highlightGroup: state.environment.hightlightGroup.bind(state.environment),
    highlightAttribute: state.environment.highlightAttribute.bind(state.environment),
    // AR
    getQrCodeArUrl: state.environment.getQrCodeArUrl,
    getMobileArUrl: state.environment.getMobileArUrl,
    openArMobile: state.environment.openArMobile,
    isSceneArEnabled: state.environment.isSceneArEnabled,
    isArDeviceCompliant: state.environment.isArDeviceCompliant,
    IS_ANDROID: _helpers__WEBPACK_IMPORTED_MODULE_0__.IS_ANDROID,
    IS_IOS: _helpers__WEBPACK_IMPORTED_MODULE_0__.IS_IOS,
    setBackgroundColor: state.environment.setBackgroundColor.bind(state.environment),
    // TRY ON
    getTryOnUrl: state.environment.getTryOnUrl.bind(state.environment),
    isSceneTryOnEnabled: state.environment.isSceneTryOnEnabled.bind(state.environment),
    isVisibleMeshShownForTryOn: state.environment.isVisibleMeshShownForTryOn,
    hasVTryOnEnabled: state.environment.hasVTryOnEnabled,
    canUseTryOn: state.environment.canUseTryOn,
    canUsePD: state.environment.canUsePD,
    isTryOnMeshVisible: state.environment.isTryOnMeshVisible,
    isMandatoryPD: state.environment.isMandatoryPD,
    getTryOnSettings: state.environment.getTryOnSettings.bind(state.environment),
    setPDDistance: state.environment.setPDDistance.bind(state.environment),
    pdDistance: state.environment.pdDistance,
    exportTryOnMeshToGlb: state.environment.exportTryOnMeshToGlb.bind(state.environment),
    setCameraLocked: state.environment.setCameraLocked.bind(state.environment),
    getTemplateUploadRestrictictions: state.environment.getTemplateUploadRestrictictions.bind(state.environment),
    getShareCompositionUrl: state.environment.getShareCompositionUrl.bind(state.environment),
    // copyright message
    getCopyrightMessageAccepted: state.environment.getCopyrightMessageAccepted.bind(state.environment),
    setCopyrightMessageAccepted: state.environment.setCopyrightMessageAccepted.bind(state.environment),
    // nft form
    validationNFTEmail: state.environment.validationNFTEmail.bind(state.environment),
    validationNFTWalletAddress: state.environment.validationNFTWalletAddress.bind(state.environment),
    configureByAI: state.environment.configureByAI.bind(state.environment),
    templateMacroCategories: state.environment.templateMacroCategories,
    applyTemplate: state.environment.applyTemplate.bind(state.environment),
    getDeepARDesktopIframeUrl: state.environment.getDeepARDesktopIframeUrl.bind(state.environment)
  };
};

/***/ }),

/***/ "./src/state/provider.tsx":
/*!********************************!*\
  !*** ./src/state/provider.tsx ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeProvider": () => (/* binding */ ZakekeProvider),
/* harmony export */   "context": () => (/* binding */ context),
/* harmony export */   "useInternalState": () => (/* binding */ useInternalState)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _boot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./boot */ "./src/state/boot.tsx");
/* harmony import */ var _createProviderValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./createProviderValue */ "./src/state/createProviderValue.ts");
/* harmony import */ var _reducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reducer */ "./src/state/reducer.ts");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }




var context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createContext(null);
var internalContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createContext(null);

// Use zakeke hook
var useInternalState = function useInternalState() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(internalContext);
  if (!value) throw 'Corrupted Zakeke state';
  return value;
};

// ZakekeProvider
var ZakekeProvider = function ZakekeProvider(_ref) {
  var environment = _ref.environment,
    parameters = _ref.parameters,
    children = _ref.children;
  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(_reducer__WEBPACK_IMPORTED_MODULE_3__.reducer, {
      environment: environment,
      sceneViewer: null,
      isAddToCartLoading: false,
      isSceneLoading: false,
      parametersReceived: false,
      isDebug: false
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];

  // Create the provider value exposed to developer
  var value = (0,_createProviderValue__WEBPACK_IMPORTED_MODULE_2__.createProviderValue)(state, dispatch);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(context.Provider, {
    value: value
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(internalContext.Provider, {
    value: {
      state: state,
      dispatch: dispatch
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_boot__WEBPACK_IMPORTED_MODULE_1__["default"], {
    parameters: parameters
  }, children)));
};


/***/ }),

/***/ "./src/state/reducer.ts":
/*!******************************!*\
  !*** ./src/state/reducer.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "reducer": () => (/* binding */ reducer)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

// Reducer
function reducer(prevState, action) {
  var newState = lodash__WEBPACK_IMPORTED_MODULE_0___default().clone(prevState);
  switch (action.type) {
    case 'BOOT_COMPLETED':
    case 'UPDATE':
      break;
    case 'DESIGN_UPDATE':
      newState.environment.renderDesign();
      break;
    case 'PARAMETERS_RECEIVED':
      newState.parametersReceived = true;
      break;
    case 'UPDATE_VIEW':
      newState.environment.updateView();
      break;
    case 'SWITCH_FULLSCREEN':
      newState.environment.switchFullscreen();
      break;
    case 'SELECT_OPTION':
      newState.environment.selectOption(action.optionId);
      break;
    case 'APPEND_VIEWER':
      newState.environment.appendViewer(action.container);
      break;
    case 'SET_HIGHLIGHT_SETTINGS':
      newState.environment.setHighlightSettings(action.settings);
    case 'IS_SCENE_LOADING':
      newState.isSceneLoading = action.isLoading;
      break;
    case 'IS_ADD_TO_CART_LOADING':
      newState.isAddToCartLoading = action.isLoading;
      break;
    case 'SET_TEMPLATE':
      newState.environment.setTemplate(action.templateId);
      break;
    case 'SET_ITEM_IMAGE_FROM_BASE64':
      newState.environment.setItemImageFromBase64(action.guid, action.base64);
      break;
    case 'SET_ITEM_IMAGE_FROM_FILE':
      newState.environment.setItemImageFromFile(action.guid, action.file);
      break;
    case 'ADD_ITEM_IMAGE':
      newState.environment.addItemImage(action.imageId, action.areaId);
      break;
    case 'SET_ITEM_IMAGE':
      newState.environment.setItemImage(action.guid, action.imageId);
      break;
    case 'SET_ITEM_FONT_FAMILY':
      newState.environment.setItemFontFamily(action.guid, action.fontFamily);
      break;
    case 'SET_ITEM_COLOR':
      newState.environment.setItemColor(action.guid, action.color);
      break;
    case 'SET_ITEM_BOLD':
      newState.environment.setItemBold(action.guid, action.bold);
      break;
    case 'SET_ITEM_ITALIC':
      newState.environment.setItemItalic(action.guid, action.italic);
      break;
    case 'SET_ITEM_TEXT_PATH':
      newState.environment.setItemTextOnPath(action.guid, action.areaId, action.value);
      break;
    case 'SET_ITEM_TEXT':
      newState.environment.setItemText(action.guid, action.text);
      break;
    case 'ADD_ITEM_TEXT':
      newState.environment.addItemText(action.settings, action.areaId);
      break;
    case 'REMOVE_ITEM':
      newState.environment.removeItem(action.guid);
      break;
    case 'ZOOM_IN':
      newState.environment.zoomIn();
      break;
    case 'ZOOM_OUT':
      newState.environment.zoomOut();
      break;
    case 'SET_EXPLODED_MODE':
      newState.environment.setExplodedMode(action.exploded);
      break;
    case 'DEBUG_MODE':
      console.log('Debug mode ', !newState.isDebug ? 'enabled' : 'disabled');
      newState.isDebug = !newState.isDebug;
      break;
    case 'VIEWER':
      console.log(action);
      newState.sceneViewer = action.value;
      break;
    default:
      throw new Error("Invalid reducer action ".concat(action.type, "."));
  }
  return newState;
}

/***/ }),

/***/ "../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx":
/*!*********************************************************************!*\
  !*** ../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DesignPriceCalculatorRuleBased": () => (/* binding */ DesignPriceCalculatorRuleBased),
/* harmony export */   "DesignPriceCalculatorRuleFactory": () => (/* binding */ DesignPriceCalculatorRuleFactory)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "../../../../../node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "../../../../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_rectangle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/rectangle */ "../../utils/rectangle.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var PricingElements = /*#__PURE__*/function (PricingElements) {
  PricingElements[PricingElements["Tutti"] = 1] = "Tutti";
  PricingElements[PricingElements["AllElementsNoTemplateItems"] = 18] = "AllElementsNoTemplateItems";
  PricingElements[PricingElements["AllTexts"] = 8] = "AllTexts";
  PricingElements[PricingElements["AllCustomText"] = 9] = "AllCustomText";
  PricingElements[PricingElements["SingleElement"] = 10] = "SingleElement";
  PricingElements[PricingElements["AllImages"] = 11] = "AllImages";
  PricingElements[PricingElements["UploadedImages"] = 12] = "UploadedImages";
  PricingElements[PricingElements["AllTextArt"] = 13] = "AllTextArt";
  PricingElements[PricingElements["AllCustomTextArt"] = 14] = "AllCustomTextArt";
  PricingElements[PricingElements["AllCustomElements"] = 15] = "AllCustomElements";
  PricingElements[PricingElements["ClipartImages"] = 16] = "ClipartImages";
  PricingElements[PricingElements["TemplatesImages"] = 17] = "TemplatesImages";
  PricingElements[PricingElements["OnlyVectorImages"] = 19] = "OnlyVectorImages";
  PricingElements[PricingElements["OnlyRasterImages"] = 20] = "OnlyRasterImages";
  return PricingElements;
}(PricingElements || {});
var operatorsFunctions = function operatorsFunctions(operator) {
  var _find;
  var func = (_find = [{
    operator: '>',
    func: function func(a, b) {
      return a > b;
    }
  }, {
    operator: '<',
    func: function func(a, b) {
      return a < b;
    }
  }, {
    operator: '=',
    func: function func(a, b) {
      return a == b;
    }
  }, {
    operator: '>=',
    func: function func(a, b) {
      return a >= b;
    }
  }, {
    operator: '<=',
    func: function func(a, b) {
      return a <= b;
    }
  }, {
    operator: '!=',
    func: function func(a, b) {
      return a != b;
    }
  }].find(function (of) {
    return of.operator == operator;
  })) === null || _find === void 0 ? void 0 : _find.func;
  if (func == null) throw new Error("Function  for operator ".concat(operator, " not found"));
  return func;
};
// type PricingRuleConditionsModel = Pick<pricing_model['rules'][0], 'conditions'>;
// type PricingRuleConditionModel = Pick<PricingRuleConditionsModel[0],''>;

var DesignPriceCalculatorRuleFactory = /*#__PURE__*/_createClass(function DesignPriceCalculatorRuleFactory() {
  _classCallCheck(this, DesignPriceCalculatorRuleFactory);
});
_defineProperty(DesignPriceCalculatorRuleFactory, "create", /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(product, apiUrl, token, isOwin, cloudFlareApiUrl, clientLang) {
    var calculator;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          calculator = new DesignPriceCalculatorRuleBased(apiUrl, token, isOwin, cloudFlareApiUrl, clientLang);
          _context2.next = 3;
          return calculator.init(product)["catch"](function (e) {
            return console.log(e);
          });
        case 3:
          return _context2.abrupt("return", calculator);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}());
var DesignPriceCalculatorRuleBased = /*#__PURE__*/_createClass(function DesignPriceCalculatorRuleBased(apiUrl, token, isOwin, cloudFlareApiUrl, clientLang) {
  var _this = this;
  _classCallCheck(this, DesignPriceCalculatorRuleBased);
  _defineProperty(this, "colorID", -1);
  _defineProperty(this, "config", {
    isOwin: true,
    apiUrl: 'https://test-api.zakeke.com/api/graphql',
    cloudFlareApiUrl: null,
    token: 'Gw6IL2Q7e66r3osC16_T6XSlsrnuUAHmw59Y3-qJv2LaPPV-nuzDkC0eOGAU8ef_i94HLlu8vDVXpk9MAWBtwrXWN7_XizPAeIfKXArfol19Ek7wmZMR3zRQWwHChqPmYDJMrI3WeCIQGRJxsR7q8hh5xywTqdOwVi6LT7_8-qP9jkc_tdBUPiMUrT6HI1i1ygnEGEk6Eoa97zvbVGRE3NRt-W5nXKGv4_INB_VBdpOihHVXIzl7PtchqPyBr7AaW5Hdrbh_KoFwEhLTcTixXpxfzOcjecbyqFHw20fNFlg2ny6Cb375i7hpnFWD7Q4lj9xI3R6jbkpFHsQEFfBK-UF1f9vli0liCWQ3WdAYGQEmUYx7QjCy240GuR_cK6c28JHoabSGQdW91K7KEAug4o19nokKfzbWoZM7WD4T4RVXNB_ob_gjeYKsK7EJIt6qGiPpnJEbSeFCjz1EhE31Jw6MO-oawNSASxgYk1D6Z3XkLw1G',
    clientLang: null
  });
  _defineProperty(this, "init", function (product) {
    _this.product = product;
    return new Promise(function (resolve, reject) {
      try {
        _this.getPricings(product, function (pricings, properties) {
          _this.pricings = pricings;
          _this.properties = properties;
          resolve();
        });
      } catch (error) {
        reject(error);
      }
    });
  });
  _defineProperty(this, "getPricings", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(product, callback) {
      var query, axiosConfig, requestData, responseCF, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_this.pricings) {
              _context.next = 4;
              break;
            }
            callback(_this.pricings, _this.properties);
            _context.next = 30;
            break;
          case 4:
            query = {
              name: 'pricingsConfigurationQuery',
              query: "query pricingsQuery($first: Int!, $productID: Long!, $languageCulture: String) {\n                                    pricingProperties { propertyID functionName }\n                                    pricingsDetailed(first: $first, productID: $productID, isForFrontEnd: true, languageCulture: $languageCulture) {\n                                        edges {\n                                            node {\n                                                id\n                                                description\n                                                infoPricingText\n                                                priceDescriptionEnabled\n                                                priceStructure\n                                                products {\n                                                    productID\n                                                }\n                                                printTypes {\n                                                    printTypeID\n                                                }\n                                                rules {\n                                                    ruleID\n                                                    propertyID\n                                                    allMatchType\n                                                    elementID\n                                                    elementTitle\n                                                    isSetupPrice\n                                                    priceType\n                                                    targets {\n                                                        area\n                                                        color\n                                                        side\n                                                        targetID\n                                                    }\n                                                    conditions {\n                                                        conditionID\n                                                        formula\n                                                        position\n                                                        priceToAdd\n                                                        quantity\n                                                    }\n                                                }\n                                            }\n                                        }\n                                    }\n                                }",
              variables: {
                first: 50,
                productID: product.get('modelID'),
                languageCulture: _this.config.clientLang
              }
            };
            axiosConfig = {
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              }
            };
            if (_this.config.isOwin) {
              axiosConfig['headers']['Authorization'] = 'Bearer ' + _this.config.token;
            } else {
              axiosConfig['headers']['X-Auth-Token'] = _this.config.token;
            }
            requestData = {
              type: 'POST',
              url: Zakeke.config.graphqlUrl,
              data: JSON.stringify(query),
              contentType: 'application/json',
              dataType: 'json'
            };
            if (_this.config.isOwin) {
              requestData['Authorization'] = 'Bearer ' + _this.config.token;
            } else {
              requestData['X-Auth-Token'] = _this.config.token;
            }
            _context.prev = 9;
            if (!(typeof _this.config.cloudFlareApiUrl !== 'undefined' && _this.config.cloudFlareApiUrl !== null && _this.config.cloudFlareApiUrl !== '')) {
              _context.next = 16;
              break;
            }
            _context.next = 13;
            return axios__WEBPACK_IMPORTED_MODULE_0___default().post(_this.config.cloudFlareApiUrl, query, axiosConfig);
          case 13:
            responseCF = _context.sent;
            callback(responseCF.data.data.pricingsDetailed.edges.map(function (edge) {
              return edge.node;
            }), responseCF.data.data.pricingProperties);
            return _context.abrupt("return");
          case 16:
            _context.next = 20;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](9);
          case 20:
            _context.prev = 20;
            _context.next = 23;
            return axios__WEBPACK_IMPORTED_MODULE_0___default().post(Zakeke.config.graphqlUrl, query, axiosConfig);
          case 23:
            response = _context.sent;
            callback(response.data.data.pricingsDetailed.edges.map(function (edge) {
              return edge.node;
            }), response.data.data.pricingProperties);
            _context.next = 30;
            break;
          case 27:
            _context.prev = 27;
            _context.t1 = _context["catch"](20);
            console.log(_context.t1);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[9, 18], [20, 27]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "getPricing", function (design) {
    if (_this.pricings) {
      // let pricings;
      var pricingAndSideIDs;
      var pricing = _this.pricings.find(function (pricing) {
        return pricing.products.find(function (p) {
          return p.productID == _this.product.get('modelID');
        });
      });
      if (pricing && _this.colorID !== -1) {
        var sides = _this.product.get('colors').find(function (color) {
          return color.get('colorID') === _this.colorID;
        }).get('sides').map(function (side) {
          return side.get('sideID');
        });
        pricingAndSideIDs = [[pricing, sides]];
      }
      //se non trovo il pricing associato al prodotto cerco quello associato al print type

      if (!pricing && _this.colorID !== -1) {
        // if (this.colorID !== -1) {
        var sidesIDs = _this.product.get('colors').find(function (color) {
          return color.get('colorID') === _this.colorID;
        }).get('sides').map(function (side) {
          return side.get('sideID');
        });
        var sideIDsAndPrintTypesID = sidesIDs.map(function (sideID) {
          var sidePrintType = design.get('sidesPrintTypes').find(function (sPT) {
            return sPT.get('sideID') === sideID;
          });
          return [sideID, sidePrintType ? sidePrintType.get('printTypeID') : design.get('printTypeID')];
        });
        var pricingSidesMapping = new Map();
        var notRegroupedPricingAndSideIDs = [sideIDsAndPrintTypesID.map(function (sidePT) {
          var _this$pricings;
          return [sidePT[0], ((_this$pricings = _this.pricings) === null || _this$pricings === void 0 ? void 0 : _this$pricings.find(function (pricing) {
            return pricing.printTypes.find(function (p) {
              return p.printTypeID === sidePT[1];
            });
          })) || null];
        })];
        notRegroupedPricingAndSideIDs[0].forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            sideID = _ref3[0],
            pricing = _ref3[1];
          if (!pricingSidesMapping.get(pricing)) pricingSidesMapping.set(pricing, [sideID]);else {
            var value = pricingSidesMapping.get(pricing);
            value.push(sideID);
            pricingSidesMapping.set(pricing, value);
          }
        });
        pricingAndSideIDs = Array.from(pricingSidesMapping);
      }

      // if (pricingAndSideIDs) {
      // 	let firstPrice = pricingAndSideIDs[0];
      // 	if (firstPrice) this.pricing = firstPrice[0];
      // }

      return pricingAndSideIDs;
    }
  });
  _defineProperty(this, "distinct", function (value, index, self) {
    return self.indexOf(value) === index;
  });
  _defineProperty(this, "ElementSizeFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0,
      items: pContext.items
    };

    //qui dentro il mio context contiene già tutti gli item di tipo text, image o textart (eventualmente saranno già filtrati dagli
    //elements della rule. In ogni caso il calcolo della size in cm sarà lo stesso:
    //quidni basta fare width / side.ppcm e sai i cm (width viene preso dal json del designitem)
    //e height / side.ppcm;
    //poi confronto i valore ottenuti ognuno col valore corrispondente dell'action (che quindi in questo caso ha 2 valori)

    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    if (formula.values == null || formula.values.length == 0) throw 'ElementSize invalid value';
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      var myJson = JSON.parse(item.get('json'))[1];
      var width = myJson.data.transformsData.dimensions.width;
      var height = myJson.data.transformsData.dimensions.height;

      //qui dentro tutti i designItemAreas del'item stanno per forza sullo stesso lato, quindi basta prendere il primo
      var sideID = item.get('areas').at(0).get('sideID');
      var modelSide = pContext.sides.find(function (s) {
        return s.get('sideID') == sideID;
      });
      if (width != null && height != null && modelSide != null && modelSide.get('ppcm') > 0) {
        var itemWidth = width / modelSide.get('ppcm');
        var itemHeight = height / modelSide.get('ppcm');
        var itemArea = itemHeight * itemWidth;
        if (operatorsFunctions(formula.operator)(itemArea, formula.values[0])) {
          result.result = true;
          result.multiplier += 1;
          result.items = result.items.filter(function (x) {
            return x != item;
          });
        }
      }
    });
    return result;
  });
  _defineProperty(this, "NumberOfElementsSimplifiedFunction", function (pContext, formula) {
    return {
      result: pContext.items.length > 0,
      multiplier: pContext.items.length,
      items: pContext.items
    };
  });
  _defineProperty(this, "LinesLengthFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso la lunghezza dei caratteri inseriti con il valore inserito nella action dal seller

    //per ora sono escluse le textart
    var result = {
      result: false,
      multiplier: 0
    };

    //qui dentro il mio context contiene già item di tipo text (o di custom text)
    //in ogni deisgnitem prendo gli elemnti di testo e conto il i caratteri
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      var myJson = JSON.parse(item.get('json'))[1];
      var isText = myJson.data.isText;
      var isTextArea = myJson.data.isTextArea;
      var isTextOnPath = myJson.data.isTextOnPath;
      var isTextArt = myJson.data.isTextArt;
      var testo = '';
      if (isText != null && isText) testo = myJson.content.toString();else if (isTextArea != null && isTextArea || isTextOnPath != null && isTextOnPath) testo = myJson.data.text.toString();
      if (isTextArt != null && isTextArt) testo = item.get('textArt').get('text');
      if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo)) {
        //zero fine riga significa una riga
        var numLines = testo.split('\n').length;
        if (operatorsFunctions(formula.operator)(numLines, formula.values[0])) {
          result.result = true;
          result.multiplier += 1;
        }
      }
    });
    return result;
  });
  _defineProperty(this, "AmountOfElementsFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso saranno il numero di elementi e il valore inserito nella action dal seller

    var result = {
      result: false,
      multiplier: 0
    };

    ////in questa funzione si contano tutti gli items quindi non ci saranno items da escludere nella eventuale successiva action
    //result.MatchedItems = items;
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    if (operatorsFunctions(formula.operator)(pContext.items.length, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "AmountOfUsedColorsFunction", function (pContext, formula) {
    /*, i colori sono univoci ma per elemento: devi calcolare quelli per design:
      
              esempio:
      
              immagine1 = ['rosso', 'verde']
              immagine2 = ['verde', 'giallo']
      
              effettivamente hai usato 3 colori, rosso, verde e giallo.
           */
    var result = {
      result: false,
      multiplier: 0
    };
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    ////in questa funzione si contano tutti gli items quindi non ci saranno items da escludere nella eventuale successiva action
    ////a prescindere dal risultato

    // let colors: string[] = [];

    // pContext.items.forEach(item => {
    //     if (item.get('itemColors') && !isEmpty(item.get('itemColors')))
    //         colors.push(item.get('itemColors'));
    // });

    var colors = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniq)(pContext.items.filter(function (item) {
      return item.get('itemColors') && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(item.get('itemColors'));
    }).flatMap(function (item) {
      return item.get('itemColors');
    }));
    if (operatorsFunctions(formula.operator)(colors.filter(_this.distinct).length, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "CanvasSizeFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0
    };
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    if (pContext.sides && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(pContext.sides)) {
      var areas = pContext.sides.flatMap(function (s) {
        return s.get('areas').models;
      });
      var customizedAreas = [];

      //prendiamo le aree con almeno un item (ricorda che gli items del context sono già filtrati per target/elements)
      areas.forEach(function (area) {
        //per ogni area cerco, fra tutti gli items quelli che stanno su quell'area.
        if (pContext.items.filter(function (i) {
          return i.get('areas').filter(function (a) {
            return a.get('colorID') == area.getColorID() && a.get('sideID') == area.getSideID() && a.get('areaID') == area.get('areaID');
          }).length > 0;
        }).length > 0) {
          customizedAreas = [].concat(_toConsumableArray(customizedAreas), [area]);
        }
      });

      //a questo punto , per ogni area mi calcolo le misure in cm (dividendo i bound dell'area per i ppcm del side a cui appartiene
      //e eseguo la funzione con l'operatore e i due values del seller
      customizedAreas.forEach(function (area) {
        var _pContext$design, _pContext$design$get;
        var width = area.get('boundsWidth');
        var height = area.get('boundsHeight');

        // If is a resizable canvas, use the current size
        var designOptions = (_pContext$design = pContext.design) === null || _pContext$design === void 0 ? void 0 : (_pContext$design$get = _pContext$design.get('options')) === null || _pContext$design$get === void 0 ? void 0 : _pContext$design$get.find(function (x) {
          return x.get('colorID') == area.getColorID() && (x.get('sideID') === area.getSideID() || x.get('sideID') === null);
        });
        if (designOptions && designOptions.get('width') && designOptions.get('height')) {
          width = designOptions.get('width');
          height = designOptions.get('height');
        }
        var modelSide = pContext.sides.find(function (s) {
          return s.get('sideID') == area.getSideID();
        });
        if (modelSide != null && modelSide.get('ppcm') > 0) {
          var areaWidth = width / modelSide.get('ppcm');
          var areaHeight = height / modelSide.get('ppcm');

          // Round 2 decs
          areaWidth = Math.round(areaWidth * 100) / 100;
          areaHeight = Math.round(areaHeight * 100) / 100;
          if (operatorsFunctions(formula.operator)(areaWidth, formula.values[0]) && operatorsFunctions(formula.operator)(areaHeight, formula.values[1])) {
            result.result = true;
            result.multiplier += 1;
          }
        }
      });
    }
    return result;
  });
  _defineProperty(this, "DesignSizeFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0
    };
    var itemsArea = 0;
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    if (pContext.sides && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(pContext.sides)) {
      var areas = pContext.sides.flatMap(function (s) {
        return s.get('areas').models;
      });

      //prendiamo le aree con almeno un item (ricorda che gli items del context sono già filtrati per target/elements)
      areas.forEach(function (area) {
        //per ogni area cerco, fra tutti gli items quelli che stanno su quell'area.
        var items = pContext.items.filter(function (i) {
          return i.get('areas').filter(function (a) {
            return a.get('colorID') == area.getColorID() && a.get('sideID') == area.getSideID() && a.get('areaID') == area.get('areaID');
          }).length > 0;
        });
        // seconda versione somma delle aree di ogni item
        var modelSide = pContext.sides.find(function (s) {
          return s.get('sideID') == area.getSideID();
        });
        if (modelSide != null && modelSide.get('ppcm') > 0) {
          var itemsRectangles = items.map(function (item) {
            var json = JSON.parse(item.get('json'))[1];
            var width = json.data.transformsData.dimensions.width;
            var height = json.data.transformsData.dimensions.height;
            var xPosition = json.data.transformsData.position.x;
            var yPosition = json.data.transformsData.position.y;
            return new _utils_rectangle__WEBPACK_IMPORTED_MODULE_2__.Rectangle(width, height, xPosition - width / 2, yPosition - height / 2);
          });
          itemsArea = itemsArea + (0,_utils_rectangle__WEBPACK_IMPORTED_MODULE_2__.rectanglesDistinctArea)(itemsRectangles, modelSide.get('ppcm'));
          console.log('itemsArea', itemsArea);
        }
      });
    }
    if (itemsArea > 0 && operatorsFunctions(formula.operator)(itemsArea, formula.values[0])) {
      result.result = true;
      result.multiplier += 1;
    }
    return result;
  });
  _defineProperty(this, "DesignTextLengthFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0
    };

    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso saranno il totale dei caratteri di tutto il design (quindi non sul singolo item)
    //e il valore inserito nella action dal seller

    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    var totalLength = 0;
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      var myJson = JSON.parse(item.get('json'))[1];
      var isText = myJson.data.isText;
      var isTextArea = myJson.data.isTextArea;
      var isTextOnPath = myJson.data.isTextOnPath;
      var isTextArt = myJson.data.isTextArt;
      var testo = '';
      if (isText != null && isText) testo = myJson.content.toString();else if (isTextArea != null && isTextArea || isTextOnPath != null && isTextOnPath) testo = myJson.data.text.toString();else if (isTextArt != null && isTextArt) testo = item.get('textArt').get('text');
      if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo)) {
        totalLength += testo.trim().split(' ').join('').replace(/(\r\n|\n|\r)/gm, '').length;
      }
    });

    //questo è un caso  in cui il moltiplicatore può essere solo zero oppure uno e i matcheditems non devono influenzare
    //l'eventuale action successiva
    if (operatorsFunctions(formula.operator)(totalLength, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "CustomizedSidesFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso saranno il numero di elementi e il valore inserito nella action dal seller

    var result = {
      result: false,
      multiplier: 0
    };
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';

    //var modelSides = ((ModelSideInfoList)pContext["sides"]).ToList();

    var customizedSides = 0;

    //elimina il foreach
    pContext.sides.forEach(function (side) {
      //dato un certo side e un certo designItem, per sapere se quel side ha elementi personalizzati

      if (pContext.items.filter(function (item) {
        return item.get('areas').filter(function (area) {
          return area.get('sideID') == side.get('sideID');
        }).length > 0;
      }).length > 0) {
        customizedSides++;
      }
    });

    // We must check that we have at last one side to check.
    // If pContext.sides.length == 0 then this mean that the current rule is not valid for this
    // variation

    if (pContext.sides.length > 0 && operatorsFunctions(formula.operator)(customizedSides, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "TextLengthFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso la lunghezza dei caratteri inseriti con il valore inserito nella action dal seller

    //per ora sono escluse le textart
    var result = {
      result: false,
      multiplier: 0
    };

    //qui dentro il mio context contiene già item di tipo text (o di custom text)
    //in ogni deisgnitem prendo gli elemnti di testo e conto il i caratteri

    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      // Newtonsoft.Json.Linq.JToken myJson =
      //                    Newtonsoft.Json.JsonConvert.DeserializeObject<List<Newtonsoft.Json.Linq.JToken>>(
      //                        item.Json)[1];
      var myJson = JSON.parse(item.get('json'))[1];
      var isText = myJson.data.isText;
      var isTextArea = myJson.data.isTextArea;
      var isTextOnPath = myJson.data.isTextOnPath;
      var isTextArt = myJson.data.isTextArt;
      var testo = '';
      if (isText != null && isText) testo = myJson.content.toString();else if (isTextArea != null && isTextArea || isTextOnPath != null && isTextOnPath) testo = myJson.data.text.toString();else if (isTextArt != null && isTextArt) testo = item.get('textArt').get('text');
      if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo) && operatorsFunctions(formula.operator)(testo.trim().split(' ').join('').length, formula.values[0])) {
        result.result = true;
        result.multiplier += 1;
      }
    });
    return result;
  });
  _defineProperty(this, "conditionsToConditionsGroupByFormula", function (conditions) {
    var gb = lodash__WEBPACK_IMPORTED_MODULE_1___default().groupBy(conditions, function (c) {
      return c !== null && c !== void 0 && c.formula ? c === null || c === void 0 ? void 0 : c.formula : '';
    });
    return Object.keys(gb).map(function (k) {
      var _gb$k$;
      return {
        formula: k,
        position: (_gb$k$ = gb[k][0]) === null || _gb$k$ === void 0 ? void 0 : _gb$k$.position,
        conditions: gb[k]
      };
    });
  });
  _defineProperty(this, "getFunctionName", function (properties, rule) {
    try {
      return properties === null || properties === void 0 ? void 0 : properties.filter(function (p) {
        return p.propertyID == rule.propertyID;
      }).map(function (p) {
        return p.functionName;
      })[0];
    } catch (error) {
      throw "function or operator don't exist in dictionaries";
    }
  });
  // clearPricings = () => {
  // 	this.pricing = undefined;
  // 	this.pricings = undefined;
  // };
  // property functions
  // functions = [
  //     {"TextLength":  this.TextLengthFunction},
  //     {"ElementSize":  this.ElementSizeFunction},
  //     {"LinesLength":  this.LinesLengthFunction},
  //     {"AmountOfElements":  this.AmountOfElementsFunction},
  //     {"AmountOfUsedColors":  this.AmountOfUsedColorsFunction},
  //     {"CanvasSize":  this.CanvasSizeFunction},
  //     {"DesignTextLength":  this.DesignTextLengthFunction},
  //     {"CustomizedSides":  this.CustomizedSidesFunction},
  //     {"DesignSizeFunction":  this.DesignSizeFunction}, new
  // ]
  _defineProperty(this, "GetContextForRule", function (rule, product, design, sidesOnWhichThePriceIsEnabled) {
    var attributeMatchColorId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var context = {
      sides: [],
      items: [],
      design: design
    };
    var allItems = design.get('designItems').toArray();
    var selectedItems = []; // Item1, item 2, Item3, Item4

    //verifichiamo prima i targets e poi gli elements
    var colorName = ''; //ci serve per i target

    var attributeColor = attributeMatchColorId ? product.get('colors').find(function (c) {
      return c.get('colorID') == attributeMatchColorId;
    }) : null;
    var colore = product.get('colors').find(function (c) {
      return c.get('colorID') == _this.colorID;
    });
    if (colore == null || colore == undefined) return context;
    colorName = attributeColor ? attributeColor.get('name') : colore.get('name');
    var sides = colore.get('sides');
    context.sides = [];
    if (rule.targets.length == 0) {
      // Se non ho target vuol dire che non sto filtrando per nulla
      //e quindi devo prendere TUTTI gli item di TUTTO il prodotto personalizzato (a prescindere da area, lato o  variante)
      selectedItems = allItems;
      context.sides = sides.toArray();
    } else {
      rule.targets.forEach(function (target) {
        var skip = false;
        var side = null;
        var currentItems = allItems;
        // Se il target filtra per variante e la mia non corrisponde, salto completamente questo target e non aggiungo nulla ai selectedtItems
        //altrimenti per ora mi tengo tutti gli items del design (che ora stanno in sideItems)
        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.color) && target.color.toLowerCase() != colorName.toLowerCase()) {
          skip = true; //continue;
        } else {
          // Add sides of this color
          var _iterator = _createForOfIteratorHelper(sides.toArray()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _side = _step.value;
              if (context.sides.indexOf(_side) === -1) context.sides.push(_side);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        // se c'è un filtro per side name selezioni gli item che stanno solo su quel side
        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.side)) {
          side = sides.find(function (s) {
            return s.get('name').toLowerCase() == target.side.toLowerCase();
          });
          if (side == null || !side.get('areas')) skip = true; //continue;
          else {
            var areaItems = [];

            // All items that touches the area filter
            var filter = function filter(item, area) {
              return item.get('areas').filter(function (a) {
                return a.get('modelID') == product.get('modelID') && a.get('colorID') == area.getSide().getColor().get('colorID') && a.get('sideID') == area.getSide().get('sideID') && a.get('areaID') == area.get('areaID');
              }).length > 0;
            };
            side.get('areas').forEach(function (area) {
              areaItems = areaItems.concat(allItems.filter(function (item) {
                return filter(item, area);
              }));
            });
            currentItems = areaItems;
          }
        }

        // se c'è un filtro per area name selezioni gli item che stanno su quell'area
        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.area)) {
          var _areaItems = [];

          //se ci sono due lati, e un area su ogni lato con lo stesso nome. IN questo caso li voglio tutti e due gli item
          var areas = [];
          sides.forEach(function (side) {
            areas = areas.concat(side.get('areas').filter(function (a) {
              return a.get('name').toLowerCase() == target.area.toLowerCase();
            }));
          });
          areas.forEach(function (area) {
            //currentItems potrebbe essere già filtrato per lato, altrimenti contiene tutti gli item (allItems)
            _areaItems = _toConsumableArray(currentItems.filter(function (i) {
              return i.get('areas').filter(function (a) {
                return a.get('modelID') == product.get('modelID') && a.get('colorID') == area.getSide().getColor().get('colorID') && a.get('sideID') == area.getSide().get('sideID') && a.get('areaID') == area.get('areaID');
              }).length > 0;
            }));
          });

          //raggruppiamo alla fine
          currentItems = _areaItems;
        }

        //eliminiamo eventuali duplicati (raggruppa su ItemGuid perchè su cosmos (a livello di carrello siamo ancora su cosmosDb)
        //l'itemId non esiste ancora
        // currentItems = currentItems.GroupBy(c => c.ItemGuid, (key, c) => c.FirstOrDefault()).ToList();
        if (!skip) {
          selectedItems = [].concat(_toConsumableArray(selectedItems), _toConsumableArray(currentItems));
        }
      } //fine foreach target
      );
    }

    //chiedi come mettere gli id corretti nell'enumerativo degli elemnts
    if (rule.elementID == PricingElements.AllTexts) {
      selectedItems = selectedItems.filter(function (p) {
        var j = JSON.parse(p.get('json'))[1];
        return j.data.isText != null && j.data.isText || j.data.isTextArea != null && j.data.isTextArea || j.data.isTextOnPath != null && j.data.isTextOnPath || j.data.isTextArt != null && j.data.isTextArt;
      });
    } else if (rule.elementID == PricingElements.AllElementsNoTemplateItems) {
      selectedItems = selectedItems.filter(function (p) {
        var j = JSON.parse(p.get('json'))[1];
        return !j.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.AllCustomText) {
      //per gestire i vecchi casi in cui isTemplateElement non c'era: i null li considero custom
      selectedItems = selectedItems.filter(function (p) {
        var j = JSON.parse(p.get('json'))[1];
        return j.data.isTemplateElement != null && !j.data.isTemplateElement && (j.data.isText != null && j.data.isText || j.data.isTextArea != null && j.data.isTextArea || j.data.isTextOnPath != null && j.data.isTextOnPath || j.data.isTextArt != null && j.data.isTextArt) || j.data.isTemplateElement == null && (j.data.isText != null && j.data.isText || j.data.isTextArea != null && j.data.isTextArea || j.data.isTextOnPath != null && j.data.isTextOnPath || j.data.isTextArt != null && j.data.isTextArt);
      });
    } else if (rule.elementID == PricingElements.AllImages) {
      selectedItems = selectedItems.filter(function (i) {
        return i.get('imageID') > 0;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return !json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.UploadedImages) {
      selectedItems = selectedItems.filter(function (p) {
        if (p.get('imageID') > 0) {
          if (p.get('imageVisitorCode') || p.get('imageCustomerCode')) return true;
          if (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) return true;
        }
        return false;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return !json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.ClipartImages) {
      selectedItems = selectedItems.filter(function (p) {
        if (p.get('imageID') > 0) {
          if (p.get('imageVisitorCode') || p.get('imageCustomerCode')) return false;
          if (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) return false;
          return true;
        }
        return false;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return !json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.TemplatesImages) {
      selectedItems = selectedItems.filter(function (p) {
        return p.get('imageID') > 0;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.SingleElement) {
      selectedItems = selectedItems.filter(function (i) {
        return i.get('name').toLowerCase() == rule.elementTitle.toLowerCase();
      });
    } else if (rule.elementID == PricingElements.AllTextArt) {
      selectedItems = selectedItems.filter(function (p) {
        var json = JSON.parse(p.get('json'))[1];
        return json.data.isTextArt != null && json.data.isTextArt;
      });
    } else if (rule.elementID == PricingElements.AllCustomTextArt) {
      //selectedtItems = selectedtItems.Where(x => x.isTexArt == true && item.isCustom);
    } else if (rule.elementID == PricingElements.AllCustomElements) {
      selectedItems = selectedItems.filter(function (p) {
        var json = JSON.parse(p.get('json'))[1];
        return p.get('imageID') > 0 && !json.data.isTemplateElement && (p.get('imageVisitorCode') || p.get('imageCustomerCode') || p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) || json.data.isTemplateElement != null && !json.data.isTemplateElement && (json.data.isText != null && json.data.isText || json.data.isTextArea != null && json.data.isTextArea || json.data.isTextOnPath != null && json.data.isTextOnPath || json.data.isTextArt != null && json.data.isTextArt) || json.data.isTemplateElement == null && (json.data.isText != null && json.data.isText || json.data.isTextArea != null && json.data.isTextArea || json.data.isTextOnPath != null && json.data.isTextOnPath || json.data.isTextArt != null && json.data.isTextArt);
      });
    } else if (rule.elementID == PricingElements.UploadedImages) {
      selectedItems = selectedItems.filter(function (p) {
        if (p.get('imageID') > 0) {
          if (p.get('imageVisitorCode') || p.get('imageCustomerCode')) return true;
          if (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) return true;
        }
        return false;
      });
    } else if (rule.elementID === PricingElements.OnlyVectorImages) {
      selectedItems = selectedItems.filter(function (item) {
        return item.get('imageID') > 0 && item.get('imageType') === 'Vector';
      });
    } else if (rule.elementID === PricingElements.OnlyRasterImages) {
      selectedItems = selectedItems.filter(function (item) {
        return item.get('imageID') > 0 && item.get('imageType') === 'Raster' || item.get('imageType') === 'Vector+Raster';
      });
    }

    // eseguo una distinct
    var selectedItemsGroupByItemGuild = lodash__WEBPACK_IMPORTED_MODULE_1___default().groupBy(selectedItems, function (c) {
      return c.get('itemGuid');
    });
    context.items = Object.keys(selectedItemsGroupByItemGuild).map(function (k) {
      return selectedItemsGroupByItemGuild[k][0];
    });
    context.items = context.items.filter(function (x) {
      if (x.get('areas').length === 0) return false;
      var sideID = x.get('areas').at(0).get('sideID');
      return sidesOnWhichThePriceIsEnabled.includes(sideID);
    });
    return context;
  });
  // controllo se ci sono pricing sul prodotto, altrimenti sui print types
  _defineProperty(this, "isUsingAmountOfColors", function (printTypeID) {
    if (_this.pricings) {
      var pricing = _this.pricings.find(function (pricing) {
        return pricing.products.find(function (p) {
          return p.productID == _this.product.get('modelID');
        });
      });
      if (pricing) return pricing.rules.find(function (r) {
        return r.propertyID == 10;
      }) != undefined;else {
        var _pricing = _this.pricings.find(function (pricing) {
          return pricing.printTypes.find(function (p) {
            return p.printTypeID === printTypeID;
          });
        });
        if (_pricing) return _pricing.rules.find(function (r) {
          return r.propertyID == 10;
        }) != undefined;
      }
    }
    return false;
  });
  _defineProperty(this, "getPremiumPhotosPrice", function (design, quantity) {
    // Aggiungo il prezzo delle immagini esterne utilizzate
    var imageItemsGroups = [];
    var price = 0;
    var _loop = function _loop() {
      var _item$get;
      var item = design.get('designItems').at(i);
      if (item.get('imageID') > 0 && item.get('imagePrice') > 0 && item.get('providerImageID') != null && ((_item$get = item.get('providerImageID')) === null || _item$get === void 0 ? void 0 : _item$get.length) > 0 && !imageItemsGroups.find(function (x) {
        return x.get('providerImageID') === item.get('providerImageID');
      })) {
        imageItemsGroups.push(item);
        var pricePerImage = item.get('imagePrice');
        if (!_this.product.get('hasAdditionalFeeOnImagesProvider')) pricePerImage = item.get('applyImagePriceForQuantity') === null || item.get('applyImagePriceForQuantity') ? item.get('imagePrice') * quantity : item.get('imagePrice');else pricePerImage = item.get('imagePrice') * quantity;
        price += pricePerImage;
      }
    };
    for (var i = 0; i < design.get('designItems').length; i++) {
      _loop();
    }
    Logger.info('Premium photo price: ', price);
    return price;
  });
  /**
   * Get Image Price
   *
   * Metodo che calcola il prezzo per le immagini nel design a cui a backoffice
   * è stato valorizzato un prezzo
   *
   * @author f.checchia
   *
   * @param design Il design in input
   * @param {number} quantity La quantità del prodotto che si sta acquistando
   *
   * @return {number} Il prezzo complessivo delle immagini per la quantità
   *
   * */
  _defineProperty(this, "getImagePrice", function (design, quantity) {
    // Aggiungo il prezzo delle immagini utilizzate
    var price = 0;
    for (var i = 0; i < design.get('designItems').length; i++) {
      var item = design.get('designItems').at(i);
      if (item.get('imageID') > 0 && item.get('imagePrice') > 0 && !item.get('providerImageID')) {
        var pricePerImage = item.get('imagePrice');
        pricePerImage = item.get('imagePrice') * quantity;
        price += pricePerImage;
      }
    }
    Logger.info('Image price: ', price);
    return price;
  });
  _defineProperty(this, "getMatchedConditions", function (design, quantity, includePercentage) {
    var attributeMatchColorId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    // this.pricing = this.getPricing(design);
    var pricingsAndSidesIDs = _this.getPricing(design);

    // if (!this.pricing) return [];
    if (!pricingsAndSidesIDs) return [];
    var matchedConditions = [];

    // this.pricing.rules.forEach((rule) => {
    pricingsAndSidesIDs.forEach(function (pricingAndSidesIDs) {
      if (!pricingAndSidesIDs[0]) return;
      // this.pricing = pricingAndSidesIDs[0];

      var sideIDs = pricingAndSidesIDs[1];
      pricingAndSidesIDs[0].rules.forEach(function (rule) {
        if (!includePercentage && rule.priceType == 1) return;
        var context = _this.GetContextForRule(rule, _this.product, design, sideIDs, attributeMatchColorId);

        // If we don't have sides to check, we are in the wrong
        // variant probably, just skip it.
        if (context.sides.length === 0) return;
        var conditionsGroupByformula = _this.conditionsToConditionsGroupByFormula(rule.conditions);
        var forEachBreakException = {};
        try {
          conditionsGroupByformula.sort(function (c1, c2) {
            return c1 && c2 && c1.position > c2.position ? 1 : -1;
          }).forEach(function (conditionGroupByFormula) {
            //per ogni gruppo (le cui conditions avranno tutte la stessa formula) estraggo dalla formula l'operatore e il values e richiamo la function
            var formulaObject = JSON.parse(conditionGroupByFormula.formula);
            if (!formulaObject.operator) throw 'operator missing in formula';

            // if (!formulaObject.values || formulaObject.values.length == 0) throw ("values missing in formula");

            // conditionGroupByFormula.conditions.forEach( condition => {
            var functionName = _this.getFunctionName(_this.properties, rule) + 'Function';

            //richiama la funzione col nome preso dalla property e con l'operatore preso dalla conditions (che in questo gruppo hanno la stessa formula)
            var result = _this[functionName](context, formulaObject);

            // //sia nel caso any che all mi calcolo il prezzo da aggiungere.
            // //Nel caso any se il risultato è true non vado alla successiva condition
            if (result.result) {
              //in ogni gruppo prendo il priceToAdd della condition con la quantità più vicina alla quantità acquistata.
              var condition = conditionGroupByFormula.conditions.filter(function (g) {
                return g.quantity <= quantity;
              }).sort(function (c1, c2) {
                return c2.quantity - c1.quantity;
              })[0];

              //controlla condition: se è null vai avanti
              if (condition != null) {
                var priceToAdd = condition.priceToAdd;
                var isSetupPrice = rule.isSetupPrice;
                var multiplier = result.multiplier;
                var priceType = rule.priceType;
                matchedConditions.push({
                  priceToAdd: priceToAdd,
                  isSetupPrice: isSetupPrice,
                  multiplier: multiplier,
                  priceType: priceType
                });

                // If some itemes were not matched with this condition, we must continue to check
                // for other conditions
                var functionMatchedAllItems = !result.items || result.items.length == 0;
                if (!rule.allMatchType && result.items) context.items = result.items;
                if (!rule.allMatchType && functionMatchedAllItems) throw forEachBreakException;
              }
            }
          });
        } catch (e) {
          if (e !== forEachBreakException) throw e;
        }
      });
    });
    return matchedConditions;
  });
  _defineProperty(this, "calculate", function (design, quantity) {
    var attributeMatchColorId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var isPricingAdvancedEnabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var matchedConditions = [];
    var totalPriceToAdd = _this.getPremiumPhotosPrice(design, quantity);
    totalPriceToAdd += _this.getImagePrice(design, quantity);
    if (isPricingAdvancedEnabled) {
      matchedConditions = _this.getMatchedConditions(design, quantity, false, attributeMatchColorId);
      matchedConditions.forEach(function (matchedCondition) {
        var conditionPrice = matchedCondition.priceToAdd * matchedCondition.multiplier;
        if (!matchedCondition.isSetupPrice) conditionPrice *= quantity;
        totalPriceToAdd += conditionPrice;
      });
    }
    Logger.info('Total custom price: ', totalPriceToAdd);
    return totalPriceToAdd;
  });
  _defineProperty(this, "getPricingAdditionalInfo", function (printTypeID) {
    var pricing;
    if (_this.pricings) {
      pricing = _this.pricings.find(function (pricing) {
        return pricing.products.find(function (p) {
          return p.productID == _this.product.get('modelID');
        });
      });
      if (!pricing) pricing = _this.pricings.find(function (pricing) {
        return pricing.printTypes.find(function (p) {
          return p.printTypeID === printTypeID;
        });
      });
    }
    if (!pricing) return;
    return {
      description: pricing.description,
      priceDescriptionEnabled: pricing.priceDescriptionEnabled,
      infoPricingText: pricing.infoPricingText,
      priceStructure: pricing.priceStructure
    };
  });
  if (apiUrl !== undefined) this.config.apiUrl = apiUrl + 'graphql';
  if (token !== undefined) this.config.token = token;
  if (isOwin !== undefined) this.config.isOwin = isOwin;
  if (cloudFlareApiUrl) this.config.cloudFlareApiUrl = cloudFlareApiUrl + 'graphql';
  if (clientLang) this.config.clientLang = clientLang;
});

/***/ }),

/***/ "../../utils/rectangle.ts":
/*!********************************!*\
  !*** ../../utils/rectangle.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rectangle": () => (/* binding */ Rectangle),
/* harmony export */   "rectangleArea": () => (/* binding */ rectangleArea),
/* harmony export */   "rectanglesDistinctArea": () => (/* binding */ rectanglesDistinctArea)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Rectangle = /*#__PURE__*/_createClass(function Rectangle(width, height, x, y) {
  var _this = this;
  _classCallCheck(this, Rectangle);
  _defineProperty(this, "maxX", function () {
    return _this.x + _this.width;
  });
  _defineProperty(this, "maxY", function () {
    return _this.y + _this.height;
  });
  _defineProperty(this, "area", function () {
    return _this.width * _this.height;
  });
  _defineProperty(this, "areaPPCM", function (ppcm) {
    return _this.width / ppcm * (_this.height / ppcm);
  });
  _defineProperty(this, "equals", function (rectangleToCompare) {
    return _this.width.toFixed(4) == rectangleToCompare.width.toFixed(4) && _this.height.toFixed(4) == rectangleToCompare.height.toFixed(4) && _this.x == rectangleToCompare.x && _this.y == rectangleToCompare.y;
  });
  this.width = width;
  this.height = height;
  this.x = x;
  this.y = y;
});
var distinct = function distinct(n, i, array) {
  return array.indexOf(n) === i;
};
var rectangleArea = function rectangleArea(r) {
  return r.width * r.height;
};
var rectangleSplitAtXPosition = function rectangleSplitAtXPosition(rectangle, x) {
  if (x <= rectangle.x || x >= rectangle.x + rectangle.width) {
    return [rectangle];
  }
  var rect1 = new Rectangle(x - rectangle.x, rectangle.height, rectangle.x, rectangle.y);
  var rect2 = new Rectangle(rectangle.maxX() - x, rectangle.height, x, rectangle.y);
  return [rect1, rect2];
};
var rectangleSplitAtYPosition = function rectangleSplitAtYPosition(rectangle, y) {
  if (y <= rectangle.y || y >= rectangle.y + rectangle.height) {
    return [rectangle];
  }
  var rect1 = new Rectangle(rectangle.width, y - rectangle.y, rectangle.x, rectangle.y);
  var rect2 = new Rectangle(rectangle.width, rectangle.maxY() - y, rectangle.x, y);
  return [rect1, rect2];
};
var rectangleIncludeXPosition = function rectangleIncludeXPosition(rectangle, x) {
  return rectangle.x < x && rectangle.maxX() > x;
};
var rectangleIncludeYPosition = function rectangleIncludeYPosition(rectangle, y) {
  return rectangle.y < y && rectangle.maxY() > y;
};
var rectangleNotIncludeXPosition = function rectangleNotIncludeXPosition(rectangle, x) {
  return rectangle.x >= x || rectangle.maxX() <= x;
};
var rectangleNotIncludeYPosition = function rectangleNotIncludeYPosition(rectangle, y) {
  return rectangle.y >= y || rectangle.maxY() <= y;
};
var rectanglesDistinctArea = function rectanglesDistinctArea(rectangles, ppcm) {
  // all x values
  var xPositions = rectangles.reduce(function (acc, rectangle) {
    return [].concat(_toConsumableArray(acc), [rectangle.x, rectangle.maxX()]);
  }, []).filter(distinct).sort(function (v1, v2) {
    return v1 - v2;
  });
  var rectanglesOutputByXPosition = _toConsumableArray(rectangles);
  xPositions.forEach(function (xPosition) {
    var rectanglesToDivide = rectanglesOutputByXPosition.filter(function (rectangle) {
      return rectangleIncludeXPosition(rectangle, xPosition);
    });
    var rectanglesToNotDivide = rectanglesOutputByXPosition.filter(function (rectangle) {
      return rectangleNotIncludeXPosition(rectangle, xPosition);
    });
    var rectanglesDivided = rectanglesToDivide.map(function (rectangle) {
      return rectangleSplitAtXPosition(rectangle, xPosition);
    }).reduce(function (acc, val) {
      return acc.concat(val);
    }, []); // flatMap
    rectanglesOutputByXPosition = [].concat(_toConsumableArray(rectanglesToNotDivide), _toConsumableArray(rectanglesDivided));
  });
  var yPositions = rectanglesOutputByXPosition.reduce(function (acc, rectangle) {
    return [].concat(_toConsumableArray(acc), [rectangle.y, rectangle.maxY()]);
  }, []).filter(distinct).sort(function (v1, v2) {
    return v1 - v2;
  });
  var rectanglesOutputByYPosition = _toConsumableArray(rectanglesOutputByXPosition);
  yPositions.forEach(function (yPosition) {
    var rectanglesToDivide = rectanglesOutputByYPosition.filter(function (rectangle) {
      return rectangleIncludeYPosition(rectangle, yPosition);
    });
    var rectanglesToNotDivide = rectanglesOutputByYPosition.filter(function (rectangle) {
      return rectangleNotIncludeYPosition(rectangle, yPosition);
    });
    var rectanglesDivided = rectanglesToDivide.map(function (rectangle) {
      return rectangleSplitAtYPosition(rectangle, yPosition);
    }).reduce(function (acc, val) {
      return acc.concat(val);
    }, []); // flatMap
    rectanglesOutputByYPosition = [].concat(_toConsumableArray(rectanglesToNotDivide), _toConsumableArray(rectanglesDivided));
  });
  return rectanglesOutputByYPosition.filter(function (rect, index, arr) {
    return arr.findIndex(function (r) {
      return r.equals(rect);
    }) == index;
  }) // distinct rectangle
  .reduce(function (acc, rect) {
    return ppcm ? acc + rect.areaPPCM(ppcm) : acc + rect.area();
  }, 0); // sum all rectangles area
};

/***/ }),

/***/ "../../../../../node_modules/is-buffer/index.js":
/*!******************************************************!*\
  !*** ../../../../../node_modules/is-buffer/index.js ***!
  \******************************************************/
/***/ ((module) => {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),

/***/ "../../../../../node_modules/lodash/lodash.js":
/*!****************************************************!*\
  !*** ../../../../../node_modules/lodash/lodash.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "styled-components":
/*!************************************!*\
  !*** external "styled-components" ***!
  \************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_styled_components__;

/***/ }),

/***/ "?4f7e":
/*!********************************!*\
  !*** ./util.inspect (ignored) ***!
  \********************************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "./node_modules/@zakeke/zakeke-3d-core/dist/index.js":
/*!***********************************************************!*\
  !*** ./node_modules/@zakeke/zakeke-3d-core/dist/index.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AndroidAR": () => (/* binding */ Cl),
/* harmony export */   "AxesLayer": () => (/* binding */ Kx),
/* harmony export */   "BlendProceduralTexture": () => (/* binding */ Ld),
/* harmony export */   "BlurXProceduralTexture": () => (/* binding */ so),
/* harmony export */   "BlurYProceduralTexture": () => (/* binding */ ro),
/* harmony export */   "BroadcastChannelEventType": () => (/* binding */ Ow),
/* harmony export */   "DAMViewerAnalyticsEventType": () => (/* binding */ Xx),
/* harmony export */   "Database": () => (/* binding */ Ef),
/* harmony export */   "DefaultAssetUrls": () => (/* binding */ Wt),
/* harmony export */   "DracoCompression": () => (/* binding */ Yx),
/* harmony export */   "EditingMode": () => (/* binding */ Za),
/* harmony export */   "EditorMeshType": () => (/* binding */ Nw),
/* harmony export */   "ElementSelector": () => (/* binding */ Bd),
/* harmony export */   "EnvironmentManager": () => (/* binding */ Ud),
/* harmony export */   "EnvironmentMode": () => (/* binding */ Ss),
/* harmony export */   "EventState": () => (/* binding */ $x),
/* harmony export */   "ForegroundBackgroundProceduralTexture": () => (/* binding */ ao),
/* harmony export */   "GlowManager": () => (/* binding */ wx),
/* harmony export */   "IS_ANDROID": () => (/* binding */ Lf),
/* harmony export */   "IS_IOS": () => (/* binding */ Bf),
/* harmony export */   "IncrementalFiles": () => (/* binding */ Cx),
/* harmony export */   "InfoPointsManager": () => (/* binding */ qx),
/* harmony export */   "InnerShadow": () => (/* binding */ zx),
/* harmony export */   "LightsLayer": () => (/* binding */ Jx),
/* harmony export */   "MaterialEditor": () => (/* binding */ sg),
/* harmony export */   "MaterialGroup": () => (/* binding */ Iw),
/* harmony export */   "MaterialPreviewData": () => (/* binding */ Nx),
/* harmony export */   "MaterialsPreview": () => (/* binding */ oo),
/* harmony export */   "MeshDesignManager": () => (/* binding */ zd),
/* harmony export */   "MeshExpander": () => (/* binding */ Qb),
/* harmony export */   "MeshLocationsManager": () => (/* binding */ xx),
/* harmony export */   "MoveProceduralTexture": () => (/* binding */ ru),
/* harmony export */   "MultiObserver": () => (/* binding */ qd),
/* harmony export */   "MultiplyProceduralTexture": () => (/* binding */ Qa),
/* harmony export */   "NormalMapProceduralTexture": () => (/* binding */ Cd),
/* harmony export */   "Observable": () => (/* binding */ Zd),
/* harmony export */   "Observer": () => (/* binding */ Qx),
/* harmony export */   "OpacityProceduralTexture": () => (/* binding */ dx),
/* harmony export */   "OuterShadow": () => (/* binding */ Fx),
/* harmony export */   "OverlayProceduralTexture": () => (/* binding */ rl),
/* harmony export */   "Preview3DConfigurationManager": () => (/* binding */ Qw),
/* harmony export */   "ProceduralNormalMap": () => (/* binding */ Dx),
/* harmony export */   "SceneActionsExecutor": () => (/* binding */ bx),
/* harmony export */   "SceneDesignManager": () => (/* binding */ Ux),
/* harmony export */   "SceneEditor": () => (/* binding */ Pw),
/* harmony export */   "SceneHelper": () => (/* binding */ ni),
/* harmony export */   "SceneToBlobs": () => (/* binding */ Wx),
/* harmony export */   "SceneViewer": () => (/* binding */ pu),
/* harmony export */   "SourceTaskStatus": () => (/* binding */ kw),
/* harmony export */   "StringTools": () => (/* binding */ gr),
/* harmony export */   "TryOnFineTuningMazingEnvironment": () => (/* binding */ Zx),
/* harmony export */   "TryOnProvider": () => (/* binding */ Wd),
/* harmony export */   "TryOnSettingsType": () => (/* binding */ Or),
/* harmony export */   "TryOnType": () => (/* binding */ jd),
/* harmony export */   "UsdzHelper": () => (/* binding */ ex),
/* harmony export */   "WorkerPool": () => (/* binding */ cu),
/* harmony export */   "ZakekeEnvironment": () => (/* binding */ uy),
/* harmony export */   "arrayContains": () => (/* binding */ aa),
/* harmony export */   "changeColorLuminosity": () => (/* binding */ Ox),
/* harmony export */   "chunkString": () => (/* binding */ qw),
/* harmony export */   "cropImageTransparency": () => (/* binding */ Ix),
/* harmony export */   "cropImageTransparencyAsync": () => (/* binding */ jw),
/* harmony export */   "dataURItoBlob": () => (/* binding */ Rd),
/* harmony export */   "debounce": () => (/* binding */ Ah),
/* harmony export */   "defaultSceneConfig": () => (/* binding */ e1),
/* harmony export */   "flipImage": () => (/* binding */ Jw),
/* harmony export */   "getAbsoluteUrl": () => (/* binding */ Xw),
/* harmony export */   "getColorBrightness": () => (/* binding */ Bx),
/* harmony export */   "getColorImage": () => (/* binding */ Ww),
/* harmony export */   "getContrastYIQ": () => (/* binding */ Yw),
/* harmony export */   "getContrastYIQHex": () => (/* binding */ Gw),
/* harmony export */   "getNavigatorQueryParams": () => (/* binding */ $w),
/* harmony export */   "getRandomString": () => (/* binding */ Kw),
/* harmony export */   "getStringHashCode": () => (/* binding */ Zw),
/* harmony export */   "getViewport": () => (/* binding */ Hw),
/* harmony export */   "isAndroid": () => (/* binding */ Uw),
/* harmony export */   "isColorDark": () => (/* binding */ Ex),
/* harmony export */   "isIPhoneX": () => (/* binding */ Fw),
/* harmony export */   "isMobile": () => (/* binding */ Lx),
/* harmony export */   "isPBRMaterial": () => (/* binding */ Jo),
/* harmony export */   "isiOS": () => (/* binding */ Vw),
/* harmony export */   "removeBlanks": () => (/* binding */ Nd),
/* harmony export */   "resizeImageFromDataUri": () => (/* binding */ Px),
/* harmony export */   "trimCanvas": () => (/* binding */ kx),
/* harmony export */   "trimImageAsync": () => (/* binding */ zh)
/* harmony export */ });
Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
  value: function(v) {
    if (this == null)
      throw new TypeError("Array.prototype.find called on null or undefined");
    if (typeof v != "function")
      throw new TypeError("predicate must be a function");
    for (var e = Object(this), t = e.length >>> 0, s = arguments[1], o = 0; o !== t; o++)
      if (v.call(s, this[o], o, e))
        return this[o];
  }
});
Array.prototype.includes || (Array.prototype.includes = function(v) {
  if (this == null)
    throw new TypeError("Array.prototype.includes called on null or undefined");
  var e = Object(this), t = parseInt(e.length, 10) || 0;
  if (t === 0)
    return !1;
  var s = parseInt(arguments[1], 10) || 0, o;
  s >= 0 ? o = s : (o = t + s, o < 0 && (o = 0));
  for (var a; o < t; ) {
    if (a = e[o], v === a || v !== v && a !== a)
      return !0;
    o++;
  }
  return !1;
});
Array.prototype.map || (Array.prototype.map = function(v) {
  var e, t, s;
  if (this == null)
    throw new TypeError("this is null or not defined");
  var o = Object(this), a = o.length >>> 0;
  if (typeof v != "function")
    throw new TypeError(v + " is not a function");
  for (arguments.length > 1 && (e = arguments[1]), t = new Array(a), s = 0; s < a; ) {
    var c, g;
    s in o && (c = o[s], g = v.call(e, c, s, o), t[s] = g), s++;
  }
  return t;
});
String.prototype.startsWith || Object.defineProperty(String.prototype, "startsWith", {
  value: function(v, e) {
    var t = e > 0 ? e | 0 : 0;
    return this.substring(t, t + v.length) === v;
  }
});
String.prototype.endsWith || (String.prototype.endsWith = function(v, e) {
  return (e === void 0 || e > this.length) && (e = this.length), this.substring(e - v.length, e) === v;
});
var Ss = /* @__PURE__ */ ((v) => (v[v.Editor = 1] = "Editor", v[v.Viewer = 2] = "Viewer", v))(Ss || {}), Za = /* @__PURE__ */ ((v) => (v.None = "None", v.Translate = "Translate", v.Rotate = "Rotate", v.Scaling = "Scaling", v))(Za || {}), uy = /* @__PURE__ */ ((v) => (v[v.Customizer = 1] = "Customizer", v[v.Composer = 2] = "Composer", v[v.Viewer = 3] = "Viewer", v))(uy || {}), Eh = typeof Float32Array < "u" ? Float32Array : Array;
Math.hypot || (Math.hypot = function() {
  for (var v = 0, e = arguments.length; e--; )
    v += arguments[e] * arguments[e];
  return Math.sqrt(v);
});
function cy() {
  var v = new Eh(3);
  return Eh != Float32Array && (v[0] = 0, v[1] = 0, v[2] = 0), v;
}
function yh(v) {
  var e = v[0], t = v[1], s = v[2];
  return Math.hypot(e, t, s);
}
(function() {
  var v = cy();
  return function(e, t, s, o, a, c) {
    var g, w;
    for (t || (t = 3), s || (s = 0), o ? w = Math.min(o * t + s, e.length) : w = e.length, g = s; g < w; g += t)
      v[0] = e[g], v[1] = e[g + 1], v[2] = e[g + 2], a(v, v, c), e[g] = v[0], e[g + 1] = v[1], e[g + 2] = v[2];
    return e;
  };
})();
function fy(v) {
  var e = v[0], t = v[1], s = v[2], o = v[3], a = v[4], c = v[5], g = v[6], w = v[7], T = v[8], H = v[9], Y = v[10], ee = v[11], z = v[12], he = v[13], ne = v[14], ye = v[15], se = e * c - t * a, _e = e * g - s * a, ue = e * w - o * a, xe = t * g - s * c, Ee = t * w - o * c, K = s * w - o * g, j = T * he - H * z, ht = T * ne - Y * z, Ze = T * ye - ee * z, pt = H * ne - Y * he, Pt = H * ye - ee * he, Mt = Y * ye - ee * ne;
  return se * Mt - _e * Pt + ue * pt + xe * Ze - Ee * ht + K * j;
}
function dy(v, e, t) {
  var s = e[0], o = e[1], a = e[2], c = e[3], g = e[4], w = e[5], T = e[6], H = e[7], Y = e[8], ee = e[9], z = e[10], he = e[11], ne = e[12], ye = e[13], se = e[14], _e = e[15], ue = t[0], xe = t[1], Ee = t[2], K = t[3];
  return v[0] = ue * s + xe * g + Ee * Y + K * ne, v[1] = ue * o + xe * w + Ee * ee + K * ye, v[2] = ue * a + xe * T + Ee * z + K * se, v[3] = ue * c + xe * H + Ee * he + K * _e, ue = t[4], xe = t[5], Ee = t[6], K = t[7], v[4] = ue * s + xe * g + Ee * Y + K * ne, v[5] = ue * o + xe * w + Ee * ee + K * ye, v[6] = ue * a + xe * T + Ee * z + K * se, v[7] = ue * c + xe * H + Ee * he + K * _e, ue = t[8], xe = t[9], Ee = t[10], K = t[11], v[8] = ue * s + xe * g + Ee * Y + K * ne, v[9] = ue * o + xe * w + Ee * ee + K * ye, v[10] = ue * a + xe * T + Ee * z + K * se, v[11] = ue * c + xe * H + Ee * he + K * _e, ue = t[12], xe = t[13], Ee = t[14], K = t[15], v[12] = ue * s + xe * g + Ee * Y + K * ne, v[13] = ue * o + xe * w + Ee * ee + K * ye, v[14] = ue * a + xe * T + Ee * z + K * se, v[15] = ue * c + xe * H + Ee * he + K * _e, v;
}
function gy(v, e) {
  var t = e[0], s = e[1], o = e[2], a = e[4], c = e[5], g = e[6], w = e[8], T = e[9], H = e[10];
  return v[0] = Math.hypot(t, s, o), v[1] = Math.hypot(a, c, g), v[2] = Math.hypot(w, T, H), v;
}
function py(v, e) {
  var t = new Eh(3);
  gy(t, e);
  var s = 1 / t[0], o = 1 / t[1], a = 1 / t[2], c = e[0] * s, g = e[1] * o, w = e[2] * a, T = e[4] * s, H = e[5] * o, Y = e[6] * a, ee = e[8] * s, z = e[9] * o, he = e[10] * a, ne = c + H + he, ye = 0;
  return ne > 0 ? (ye = Math.sqrt(ne + 1) * 2, v[3] = 0.25 * ye, v[0] = (Y - z) / ye, v[1] = (ee - w) / ye, v[2] = (g - T) / ye) : c > H && c > he ? (ye = Math.sqrt(1 + c - H - he) * 2, v[3] = (Y - z) / ye, v[0] = 0.25 * ye, v[1] = (g + T) / ye, v[2] = (ee + w) / ye) : H > he ? (ye = Math.sqrt(1 + H - c - he) * 2, v[3] = (ee - w) / ye, v[0] = (g + T) / ye, v[1] = 0.25 * ye, v[2] = (Y + z) / ye) : (ye = Math.sqrt(1 + he - c - H) * 2, v[3] = (g - T) / ye, v[0] = (ee + w) / ye, v[1] = (Y + z) / ye, v[2] = 0.25 * ye), v;
}
var Ui, ll, Oh, oa;
function _i(v, e, t, s) {
  var o, a = arguments.length, c = a < 3 ? e : s === null ? s = Object.getOwnPropertyDescriptor(e, t) : s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    c = Reflect.decorate(v, e, t, s);
  else
    for (var g = v.length - 1; g >= 0; g--)
      (o = v[g]) && (c = (a < 3 ? o(c) : a > 3 ? o(e, t, c) : o(e, t)) || c);
  return a > 3 && c && Object.defineProperty(e, t, c), c;
}
(function(v) {
  v.ACCESSOR = "Accessor", v.ANIMATION = "Animation", v.ANIMATION_CHANNEL = "AnimationChannel", v.ANIMATION_SAMPLER = "AnimationSampler", v.BUFFER = "Buffer", v.CAMERA = "Camera", v.MATERIAL = "Material", v.MESH = "Mesh", v.PRIMITIVE = "Primitive", v.PRIMITIVE_TARGET = "PrimitiveTarget", v.NODE = "Node", v.ROOT = "Root", v.SCENE = "Scene", v.SKIN = "Skin", v.TEXTURE = "Texture", v.TEXTURE_INFO = "TextureInfo";
})(Ui || (Ui = {})), function(v) {
  v.INTERLEAVED = "interleaved", v.SEPARATE = "separate";
}(ll || (ll = {})), function(v) {
  v[v.R = 4096] = "R", v[v.G = 256] = "G", v[v.B = 16] = "B", v[v.A = 1] = "A";
}(Oh || (Oh = {})), function(v) {
  v.GLTF = "GLTF", v.GLB = "GLB";
}(oa || (oa = {}));
class vl {
  constructor(e, t, s) {
    if (this.t = void 0, this.i = void 0, this.h = void 0, this.o = !1, this.u = [], this.t = e, this.i = t, this.h = s, !t.canLink(s))
      throw new Error("Cannot link disconnected graphs/documents.");
  }
  getName() {
    return this.t;
  }
  getParent() {
    return this.i;
  }
  getChild() {
    return this.h;
  }
  setChild(e) {
    return this.h = e, this;
  }
  dispose() {
    this.o || (this.o = !0, this.u.forEach((e) => e()), this.u.length = 0);
  }
  onDispose(e) {
    return this.u.push(e), this;
  }
  isDisposed() {
    return this.o;
  }
}
class _y {
  constructor() {
    this.l = /* @__PURE__ */ new Set(), this.p = /* @__PURE__ */ new Set(), this.g = /* @__PURE__ */ new Map(), this.v = /* @__PURE__ */ new Map(), this.u = {};
  }
  on(e, t) {
    return this.u[e] = this.u[e] || [], this.u[e].push(t), this;
  }
  emit(e, t) {
    for (const s of this.u[e] || [])
      s(t);
    return this;
  }
  getLinks() {
    return Array.from(this.p);
  }
  listParentLinks(e) {
    return Array.from(this.v.get(e) || this.l);
  }
  listParents(e) {
    return this.listParentLinks(e).map((t) => t.getParent());
  }
  listChildLinks(e) {
    return Array.from(this.g.get(e) || this.l);
  }
  listChildren(e) {
    return this.listChildLinks(e).map((t) => t.getChild());
  }
  disconnectChildren(e) {
    return (this.g.get(e) || this.l).forEach((t) => t.dispose()), this;
  }
  disconnectParents(e, t) {
    let s = Array.from(this.v.get(e) || this.l);
    return t && (s = s.filter((o) => t(o.getParent()))), s.forEach((o) => o.dispose()), this;
  }
  swapChild(e, t, s) {
    const o = this.g.get(e) || this.l;
    return Array.from(o).filter((a) => a.getChild() === t).forEach((a) => {
      this.v.get(t).delete(a), a.setChild(s), this.v.has(s) || this.v.set(s, /* @__PURE__ */ new Set()), this.v.get(s).add(a);
    }), this;
  }
  link(e, t, s) {
    if (!s)
      return null;
    const o = new vl(e, t, s);
    return this.registerLink(o), o;
  }
  registerLink(e) {
    this.p.add(e);
    const t = e.getParent();
    this.g.has(t) || this.g.set(t, /* @__PURE__ */ new Set()), this.g.get(t).add(e);
    const s = e.getChild();
    return this.v.has(s) || this.v.set(s, /* @__PURE__ */ new Set()), this.v.get(s).add(e), e.onDispose(() => this.unlink(e)), e;
  }
  unlink(e) {
    return this.p.delete(e), this.g.get(e.getParent()).delete(e), this.v.get(e.getChild()).delete(e), this;
  }
}
function _n(v, e) {
  Object.defineProperty(v, e, { get: function() {
    return this["__" + e];
  }, set: function(t) {
    const s = this["__" + e];
    s && !Array.isArray(s) && s.dispose(), t && !Array.isArray(t) && t.onDispose(() => {
      this["__" + e] = null;
    }), this["__" + e] = t;
  }, enumerable: !0 });
}
function On(v, e) {
}
class ps {
  static createBufferFromDataURI(e) {
    if (typeof Buffer > "u") {
      const t = atob(e.split(",")[1]), s = new Uint8Array(t.length);
      for (let o = 0; o < t.length; o++)
        s[o] = t.charCodeAt(o);
      return s.buffer;
    }
    {
      const t = e.split(",")[1], s = e.indexOf("base64") >= 0;
      return this.trim(Buffer.from(t, s ? "base64" : "utf8"));
    }
  }
  static encodeText(e) {
    return typeof TextEncoder < "u" ? new TextEncoder().encode(e).buffer : this.trim(Buffer.from(e));
  }
  static decodeText(e) {
    return typeof TextDecoder < "u" ? new TextDecoder().decode(e) : Buffer.from(e).toString("utf8");
  }
  static trim(e) {
    const { byteOffset: t, byteLength: s } = e;
    return e.buffer.slice(t, t + s);
  }
  static concat(e) {
    let t = 0;
    for (const a of e)
      t += a.byteLength;
    const s = new Uint8Array(t);
    let o = 0;
    for (const a of e)
      s.set(new Uint8Array(a), o), o += a.byteLength;
    return s.buffer;
  }
  static pad(e, t = 0) {
    const s = this.padNumber(e.byteLength);
    if (s !== e.byteLength) {
      const o = new Uint8Array(s);
      if (o.set(new Uint8Array(e)), t !== 0)
        for (let a = e.byteLength; a < s; a++)
          o[a] = t;
      return o.buffer;
    }
    return e;
  }
  static padNumber(e) {
    return 4 * Math.ceil(e / 4);
  }
  static equals(e, t) {
    if (e === t)
      return !0;
    if (e.byteLength !== t.byteLength)
      return !1;
    const s = new DataView(e), o = new DataView(t);
    let a = e.byteLength;
    for (; a--; )
      if (s.getUint8(a) !== o.getUint8(a))
        return !1;
    return !0;
  }
}
class Wo {
  static hexToFactor(e, t) {
    e = Math.floor(e);
    const s = t;
    return s[0] = (e >> 16 & 255) / 255, s[1] = (e >> 8 & 255) / 255, s[2] = (255 & e) / 255, this.convertSRGBToLinear(t, t);
  }
  static factorToHex(e) {
    const t = [...e], [s, o, a] = this.convertLinearToSRGB(e, t);
    return 255 * s << 16 ^ 255 * o << 8 ^ 255 * a << 0;
  }
  static convertSRGBToLinear(e, t) {
    const s = e, o = t;
    for (let a = 0; a < 3; a++)
      o[a] = s[a] < 0.04045 ? 0.0773993808 * s[a] : Math.pow(0.9478672986 * s[a] + 0.0521327014, 2.4);
    return t;
  }
  static convertLinearToSRGB(e, t) {
    const s = e, o = t;
    for (let a = 0; a < 3; a++)
      o[a] = s[a] < 31308e-7 ? 12.92 * s[a] : 1.055 * Math.pow(s[a], 0.41666) - 0.055;
    return t;
  }
}
class hl {
  static basename(e) {
    const t = e.split(/[\\/]/).pop();
    return t.substr(0, t.lastIndexOf("."));
  }
  static extension(e) {
    return e.indexOf("data:") !== 0 ? e.split(/[\\/]/).pop().split(/[.]/).pop() : e.indexOf("data:image/png") === 0 ? "png" : e.indexOf("data:image/jpeg") === 0 ? "jpeg" : "bin";
  }
}
class yl {
  match(e) {
    const t = new Uint8Array(e);
    return t.length >= 8 && t[0] === 137 && t[1] === 80 && t[2] === 78 && t[3] === 71 && t[4] === 13 && t[5] === 10 && t[6] === 26 && t[7] === 10;
  }
  getSize(e) {
    const t = new DataView(e);
    return ps.decodeText(e.slice(12, 16)) === yl.PNG_FRIED_CHUNK_NAME ? [t.getUint32(32, !1), t.getUint32(36, !1)] : [t.getUint32(16, !1), t.getUint32(20, !1)];
  }
  getChannels(e) {
    return 4;
  }
}
yl.PNG_FRIED_CHUNK_NAME = "CgBI";
class Ca {
  static registerFormat(e, t) {
    this.impls[e] = t;
  }
  static getMimeType(e) {
    for (const t in this.impls)
      if (this.impls[t].match(e))
        return t;
    return null;
  }
  static getSize(e, t) {
    return this.impls[t] ? this.impls[t].getSize(e) : null;
  }
  static getChannels(e, t) {
    return this.impls[t] ? this.impls[t].getChannels(e) : null;
  }
  static getMemSize(e, t) {
    if (!this.impls[t])
      return null;
    if (this.impls[t].getGPUByteLength)
      return this.impls[t].getGPUByteLength(e);
    let s = 0;
    const o = this.getSize(e, t);
    if (!o)
      return null;
    for (; o[0] > 1 || o[1] > 1; )
      s += o[0] * o[1] * 4, o[0] = Math.max(Math.floor(o[0] / 2), 1), o[1] = Math.max(Math.floor(o[1] / 2), 1);
    return s += 4, s;
  }
  static mimeTypeToExtension(e) {
    return e === "image/jpeg" ? "jpg" : e.split("/").pop();
  }
  static extensionToMimeType(e) {
    return e === "jpg" ? "image/jpeg" : `image/${e}`;
  }
}
function my(v, e) {
  if (e > v.byteLength)
    throw new TypeError("Corrupt JPG, exceeded buffer limits");
  if (v.getUint8(e) !== 255)
    throw new TypeError("Invalid JPG, marker table corrupted");
  return v;
}
Ca.impls = { "image/jpeg": new class {
  match(v) {
    const e = new Uint8Array(v);
    return e.length >= 3 && e[0] === 255 && e[1] === 216 && e[2] === 255;
  }
  getSize(v) {
    let e, t, s = new DataView(v, 4);
    for (; s.byteLength; ) {
      if (e = s.getUint16(0, !1), my(s, e), t = s.getUint8(e + 1), t === 192 || t === 193 || t === 194)
        return [s.getUint16(e + 7, !1), s.getUint16(e + 5, !1)];
      s = new DataView(v, s.byteOffset + e + 2);
    }
    throw new TypeError("Invalid JPG, no size found");
  }
  getChannels(v) {
    return 3;
  }
}(), "image/png": new yl() };
class Rn {
  static identity(e) {
    return e;
  }
  static eq(e, t) {
    if (e.length !== t.length)
      return !1;
    for (let s = 0; s < e.length; s++)
      if (Math.abs(e[s] - t[s]) > 1e-5)
        return !1;
    return !0;
  }
  static denormalize(e, t) {
    switch (t) {
      case 5126:
        return e;
      case 5123:
        return e / 65535;
      case 5121:
        return e / 255;
      case 5122:
        return Math.max(e / 32767, -1);
      case 5120:
        return Math.max(e / 127, -1);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static normalize(e, t) {
    switch (t) {
      case 5126:
        return e;
      case 5123:
        return Math.round(65535 * e);
      case 5121:
        return Math.round(255 * e);
      case 5122:
        return Math.round(32767 * e);
      case 5120:
        return Math.round(127 * e);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static decompose(e, t, s, o) {
    let a = yh([e[0], e[1], e[2]]);
    const c = yh([e[4], e[5], e[6]]), g = yh([e[8], e[9], e[10]]);
    fy(e) < 0 && (a = -a), t[0] = e[12], t[1] = e[13], t[2] = e[14];
    const w = e.slice(), T = 1 / a, H = 1 / c, Y = 1 / g;
    w[0] *= T, w[1] *= T, w[2] *= T, w[4] *= H, w[5] *= H, w[6] *= H, w[8] *= Y, w[9] *= Y, w[10] *= Y, py(s, w), o[0] = a, o[1] = c, o[2] = g;
  }
  static compose(e, t, s, o) {
    const a = o, c = t[0], g = t[1], w = t[2], T = t[3], H = c + c, Y = g + g, ee = w + w, z = c * H, he = c * Y, ne = c * ee, ye = g * Y, se = g * ee, _e = w * ee, ue = T * H, xe = T * Y, Ee = T * ee, K = s[0], j = s[1], ht = s[2];
    return a[0] = (1 - (ye + _e)) * K, a[1] = (he + Ee) * K, a[2] = (ne - xe) * K, a[3] = 0, a[4] = (he - Ee) * j, a[5] = (1 - (z + _e)) * j, a[6] = (se + ue) * j, a[7] = 0, a[8] = (ne + xe) * ht, a[9] = (se - ue) * ht, a[10] = (1 - (z + ye)) * ht, a[11] = 0, a[12] = e[0], a[13] = e[1], a[14] = e[2], a[15] = 1, a;
  }
}
class Ns {
  constructor(e) {
    this.verbosity = void 0, this.verbosity = e;
  }
  debug(e) {
    this.verbosity <= Ns.Verbosity.DEBUG && console.debug(e);
  }
  info(e) {
    this.verbosity <= Ns.Verbosity.INFO && console.info(e);
  }
  warn(e) {
    this.verbosity <= Ns.Verbosity.WARN && console.warn(e);
  }
  error(e) {
    this.verbosity <= Ns.Verbosity.ERROR && console.error(e);
  }
}
Ns.Verbosity = { SILENT: 4, ERROR: 3, WARN: 2, INFO: 1, DEBUG: 0 }, Ns.DEFAULT_INSTANCE = new Ns(Ns.Verbosity.INFO);
const af = "23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ", of = /* @__PURE__ */ new Set(), vy = function() {
  let v = "";
  for (let e = 0; e < 6; e++)
    v += af.charAt(Math.floor(Math.random() * af.length));
  return v;
}, yy = function() {
  for (let v = 0; v < 999; v++) {
    const e = vy();
    if (!of.has(e))
      return of.add(e), e;
  }
  return "";
}, mn = (v) => v;
class Ta extends class {
  constructor(e) {
    this.graph = void 0, this.o = !1, this.graph = e, this.graph = e;
  }
  canLink(e) {
    return this.graph === e.graph;
  }
  isDisposed() {
    return this.o;
  }
  dispose() {
    this.graph.disconnectChildren(this), this.graph.disconnectParents(this), this.o = !0, this.graph.emit("dispose", this);
  }
  detach() {
    return this.graph.disconnectParents(this), this;
  }
  swap(e, t) {
    return this.graph.swapChild(this, e, t), this;
  }
  addGraphChild(e, t) {
    return e.push(t), t.onDispose(() => {
      const s = e.filter((o) => o !== t);
      e.length = 0;
      for (const o of s)
        e.push(o);
    }), this;
  }
  removeGraphChild(e, t) {
    return e.filter((s) => s.getChild() === t).forEach((s) => s.dispose()), this;
  }
  clearGraphChildList(e) {
    for (; e.length > 0; )
      e[0].dispose();
    return this;
  }
  listGraphParents() {
    return this.graph.listParents(this);
  }
} {
  constructor(e, t = "") {
    super(e), this.graph = void 0, this.m = {}, this.t = "", this.graph = e, this.t = t;
  }
  getName() {
    return this.t;
  }
  setName(e) {
    return this.t = e, this;
  }
  getExtras() {
    return this.m;
  }
  setExtras(e) {
    return this.m = e, this;
  }
  clone() {
    const e = new this.constructor(this.graph).copy(this, mn);
    return this.graph.emit("clone", e), e;
  }
  copy(e, t = mn) {
    return this.t = e.t, this.m = JSON.parse(JSON.stringify(e.m)), this;
  }
  detach() {
    return this.graph.disconnectParents(this, (e) => e.propertyType !== "Root"), this;
  }
  listParents() {
    return this.listGraphParents();
  }
}
const lf = "Pass extension name (string) as lookup token, not a constructor.";
class Rs extends Ta {
  constructor(...e) {
    super(...e), this.extensions = [];
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.clearGraphChildList(this.extensions), e.extensions.forEach((s) => {
      const o = s.getChild();
      this.setExtension(o.extensionName, t(o));
    }), this;
  }
  getExtension(e) {
    if (typeof e != "string")
      throw new Error(lf);
    const t = this.extensions.find((s) => s.getChild().extensionName === e);
    return t ? t.getChild() : null;
  }
  setExtension(e, t) {
    if (typeof e != "string")
      throw new Error(lf);
    const s = this.getExtension(e);
    return s && this.removeGraphChild(this.extensions, s), t ? (t.T(this), this.addGraphChild(this.extensions, this.graph.link(e, this, t))) : this;
  }
  listExtensions() {
    return this.extensions.map((e) => e.getChild());
  }
}
_i([On], Rs.prototype, "extensions", void 0);
class ui extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.ACCESSOR, this.S = null, this.M = ui.Type.SCALAR, this.I = ui.ComponentType.FLOAT, this.N = !1, this.C = Rn.identity, this.O = Rn.identity, this.buffer = null;
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.M = e.M, this.I = e.I, this.N = e.N, this.C = e.C, this.O = e.O, e.S && (this.S = e.S.slice()), this.setBuffer(e.buffer ? t(e.buffer.getChild()) : null), this;
  }
  static getElementSize(e) {
    switch (e) {
      case ui.Type.SCALAR:
        return 1;
      case ui.Type.VEC2:
        return 2;
      case ui.Type.VEC3:
        return 3;
      case ui.Type.VEC4:
      case ui.Type.MAT2:
        return 4;
      case ui.Type.MAT3:
        return 9;
      case ui.Type.MAT4:
        return 16;
      default:
        throw new Error("Unexpected type: " + e);
    }
  }
  static getComponentSize(e) {
    switch (e) {
      case ui.ComponentType.BYTE:
      case ui.ComponentType.UNSIGNED_BYTE:
        return 1;
      case ui.ComponentType.SHORT:
      case ui.ComponentType.UNSIGNED_SHORT:
        return 2;
      case ui.ComponentType.UNSIGNED_INT:
      case ui.ComponentType.FLOAT:
        return 4;
      default:
        throw new Error("Unexpected component type: " + e);
    }
  }
  getMinNormalized(e) {
    const t = this.getElementSize();
    this.getMin(e);
    for (let s = 0; s < t; s++)
      e[s] = this.O(e[s]);
    return e;
  }
  getMin(e) {
    const t = this.getCount(), s = this.getElementSize();
    for (let o = 0; o < s; o++)
      e[o] = 1 / 0;
    for (let o = 0; o < t * s; o += s)
      for (let a = 0; a < s; a++) {
        const c = this.S[o + a];
        Number.isFinite(c) && (e[a] = Math.min(e[a], c));
      }
    return e;
  }
  getMaxNormalized(e) {
    const t = this.getElementSize();
    this.getMax(e);
    for (let s = 0; s < t; s++)
      e[s] = this.O(e[s]);
    return e;
  }
  getMax(e) {
    const t = this.getCount(), s = this.getElementSize();
    for (let o = 0; o < s; o++)
      e[o] = -1 / 0;
    for (let o = 0; o < t * s; o += s)
      for (let a = 0; a < s; a++) {
        const c = this.S[o + a];
        Number.isFinite(c) && (e[a] = Math.max(e[a], c));
      }
    return e;
  }
  getCount() {
    return this.S ? this.S.length / this.getElementSize() : 0;
  }
  getType() {
    return this.M;
  }
  setType(e) {
    return this.M = e, this;
  }
  getElementSize() {
    return ui.getElementSize(this.M);
  }
  getComponentSize() {
    return this.S.BYTES_PER_ELEMENT;
  }
  getComponentType() {
    return this.I;
  }
  getNormalized() {
    return this.N;
  }
  setNormalized(e) {
    return this.N = e, e ? (this.O = (t) => Rn.denormalize(t, this.I), this.C = (t) => Rn.normalize(t, this.I)) : (this.O = Rn.identity, this.C = Rn.identity), this;
  }
  getScalar(e) {
    const t = this.getElementSize();
    return this.O(this.S[e * t]);
  }
  setScalar(e, t) {
    return this.S[e * this.getElementSize()] = this.C(t), this;
  }
  getElement(e, t) {
    const s = this.getElementSize();
    for (let o = 0; o < s; o++)
      t[o] = this.O(this.S[e * s + o]);
    return t;
  }
  setElement(e, t) {
    const s = this.getElementSize();
    for (let o = 0; o < s; o++)
      this.S[e * s + o] = this.C(t[o]);
    return this;
  }
  getBuffer() {
    return this.buffer ? this.buffer.getChild() : null;
  }
  setBuffer(e) {
    return this.buffer = this.graph.link("buffer", this, e), this;
  }
  getArray() {
    return this.S;
  }
  setArray(e) {
    return this.I = e ? function(t) {
      switch (t.constructor) {
        case Float32Array:
          return ui.ComponentType.FLOAT;
        case Uint32Array:
          return ui.ComponentType.UNSIGNED_INT;
        case Uint16Array:
          return ui.ComponentType.UNSIGNED_SHORT;
        case Uint8Array:
          return ui.ComponentType.UNSIGNED_BYTE;
        case Int16Array:
          return ui.ComponentType.SHORT;
        case Int8Array:
          return ui.ComponentType.BYTE;
        default:
          throw new Error("Unknown accessor componentType.");
      }
    }(e) : ui.ComponentType.FLOAT, this.S = e, this;
  }
  getByteLength() {
    return this.S ? this.S.byteLength : 0;
  }
}
ui.Type = { SCALAR: "SCALAR", VEC2: "VEC2", VEC3: "VEC3", VEC4: "VEC4", MAT2: "MAT2", MAT3: "MAT3", MAT4: "MAT4" }, ui.ComponentType = { BYTE: 5120, UNSIGNED_BYTE: 5121, SHORT: 5122, UNSIGNED_SHORT: 5123, UNSIGNED_INT: 5125, FLOAT: 5126 }, _i([_n], ui.prototype, "buffer", void 0);
class ul extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.ANIMATION, this.channels = [], this.samplers = [];
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.clearGraphChildList(this.channels), this.clearGraphChildList(this.samplers), e.channels.forEach((s) => this.addChannel(t(s.getChild()))), e.samplers.forEach((s) => this.addSampler(t(s.getChild()))), this;
  }
  addChannel(e) {
    const t = this.graph.link("channel", this, e);
    return this.addGraphChild(this.channels, t);
  }
  removeChannel(e) {
    return this.removeGraphChild(this.channels, e);
  }
  listChannels() {
    return this.channels.map((e) => e.getChild());
  }
  addSampler(e) {
    const t = this.graph.link("sampler", this, e);
    return this.addGraphChild(this.samplers, t);
  }
  removeSampler(e) {
    return this.removeGraphChild(this.samplers, e);
  }
  listSamplers() {
    return this.samplers.map((e) => e.getChild());
  }
}
_i([On], ul.prototype, "channels", void 0), _i([On], ul.prototype, "samplers", void 0);
class tl extends Ta {
  constructor(...e) {
    super(...e), this.propertyType = Ui.ANIMATION_CHANNEL, this._ = null, this.targetNode = null, this.sampler = null;
  }
  copy(e, t = mn) {
    return super.copy(e, t), this._ = e._, this.setTargetNode(e.targetNode ? t(e.targetNode.getChild()) : null), this.setSampler(e.sampler ? t(e.sampler.getChild()) : null), this;
  }
  getTargetPath() {
    return this._;
  }
  setTargetPath(e) {
    return this._ = e, this;
  }
  getTargetNode() {
    return this.targetNode ? this.targetNode.getChild() : null;
  }
  setTargetNode(e) {
    return this.targetNode = this.graph.link("target.node", this, e), this;
  }
  getSampler() {
    return this.sampler ? this.sampler.getChild() : null;
  }
  setSampler(e) {
    return this.sampler = this.graph.link("sampler", this, e), this;
  }
}
tl.TargetPath = { TRANSLATION: "translation", ROTATION: "rotation", SCALE: "scale", WEIGHTS: "weights" }, _i([_n], tl.prototype, "targetNode", void 0), _i([_n], tl.prototype, "sampler", void 0);
class la extends Ta {
  constructor(...e) {
    super(...e), this.propertyType = Ui.ANIMATION_SAMPLER, this.L = la.Interpolation.LINEAR, this.input = null, this.output = null;
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.L = e.L, this.setInput(e.input ? t(e.input.getChild()) : null), this.setOutput(e.output ? t(e.output.getChild()) : null), this;
  }
  getInterpolation() {
    return this.L;
  }
  setInterpolation(e) {
    return this.L = e, this;
  }
  getInput() {
    return this.input ? this.input.getChild() : null;
  }
  setInput(e) {
    return this.input = this.graph.link("input", this, e), this;
  }
  getOutput() {
    return this.output ? this.output.getChild() : null;
  }
  setOutput(e) {
    return this.output = this.graph.link("output", this, e), this;
  }
}
la.Interpolation = { LINEAR: "LINEAR", STEP: "STEP", CUBICSPLINE: "CUBICSPLINE" }, _i([_n], la.prototype, "input", void 0), _i([_n], la.prototype, "output", void 0);
class Gf extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.BUFFER, this.P = "";
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.P = e.P, this;
  }
  getURI() {
    return this.P;
  }
  setURI(e) {
    return this.P = e, this;
  }
}
class ha extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.CAMERA, this.M = ha.Type.PERSPECTIVE, this.U = 0.1, this.k = 100, this.F = null, this.j = 2 * Math.PI * 50 / 360, this.D = 1, this.J = 1;
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.M = e.M, this.U = e.U, this.k = e.k, this.F = e.F, this.j = e.j, this.D = e.D, this.J = e.J, this;
  }
  getType() {
    return this.M;
  }
  setType(e) {
    return this.M = e, this;
  }
  getZNear() {
    return this.U;
  }
  setZNear(e) {
    return this.U = e, this;
  }
  getZFar() {
    return this.k;
  }
  setZFar(e) {
    return this.k = e, this;
  }
  getAspectRatio() {
    return this.F;
  }
  setAspectRatio(e) {
    return this.F = e, this;
  }
  getYFov() {
    return this.j;
  }
  setYFov(e) {
    return this.j = e, this;
  }
  getXMag() {
    return this.D;
  }
  setXMag(e) {
    return this.D = e, this;
  }
  getYMag() {
    return this.J;
  }
  setYMag(e) {
    return this.J = e, this;
  }
}
ha.Type = { PERSPECTIVE: "perspective", ORTHOGRAPHIC: "orthographic" };
class jf extends Ta {
  constructor(e, t) {
    super(e), this.$ = void 0, this.$ = t, this.$.addExtensionProperty(this);
  }
  clone() {
    const e = new this.constructor(this.graph, this.$).copy(this, mn);
    return this.graph.emit("clone", e), e;
  }
  dispose() {
    this.$.removeExtensionProperty(this), super.dispose();
  }
  T(e) {
    if (!this.parentTypes.includes(e.propertyType))
      throw new Error(`Parent "${e.propertyType}" invalid for child "${this.propertyType}".`);
  }
}
jf.EXTENSION_NAME = void 0;
class Wf extends vl {
  constructor(...e) {
    super(...e), this.semantic = "";
  }
  copy(e) {
    return this.semantic = e.semantic, this;
  }
}
class qf extends vl {
  copy(e) {
    return this;
  }
}
let by = class extends vl {
  constructor(...e) {
    super(...e), this.channels = 0;
  }
  copy(e) {
    return this.channels = e.channels, this;
  }
};
class xy extends _y {
  linkAttribute(e, t, s) {
    if (!s)
      return null;
    const o = new Wf(e, t, s);
    return o.semantic = e, this.registerLink(o), o;
  }
  linkIndex(e, t, s) {
    if (!s)
      return null;
    const o = new qf(e, t, s);
    return this.registerLink(o), o;
  }
  linkTexture(e, t, s, o) {
    if (!o)
      return null;
    const a = new by(e, s, o);
    return a.channels = t, this.registerLink(a), a;
  }
}
class sr extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.TEXTURE_INFO, this.V = 0, this.W = null, this.q = null, this.Y = sr.WrapMode.REPEAT, this.H = sr.WrapMode.REPEAT;
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.V = e.V, this.W = e.W, this.q = e.q, this.Y = e.Y, this.H = e.H, this;
  }
  equals(e) {
    return this.getTexCoord() === e.getTexCoord() && this.getMagFilter() === e.getMagFilter() && this.getMinFilter() === e.getMinFilter() && this.getWrapS() === e.getWrapS() && this.getWrapT() === e.getWrapT();
  }
  getTexCoord() {
    return this.V;
  }
  setTexCoord(e) {
    return this.V = e, this;
  }
  getMagFilter() {
    return this.W;
  }
  setMagFilter(e) {
    return this.W = e, this;
  }
  getMinFilter() {
    return this.q;
  }
  setMinFilter(e) {
    return this.q = e, this;
  }
  getWrapS() {
    return this.Y;
  }
  setWrapS(e) {
    return this.Y = e, this;
  }
  getWrapT() {
    return this.H;
  }
  setWrapT(e) {
    return this.H = e, this;
  }
}
sr.WrapMode = { CLAMP_TO_EDGE: 33071, MIRRORED_REPEAT: 33648, REPEAT: 10497 }, sr.MagFilter = { NEAREST: 9728, LINEAR: 9729 }, sr.MinFilter = { NEAREST: 9728, LINEAR: 9729, NEAREST_MIPMAP_NEAREST: 9984, LINEAR_MIPMAP_NEAREST: 9985, NEAREST_MIPMAP_LINEAR: 9986, LINEAR_MIPMAP_LINEAR: 9987 };
const { R: qo, G: Zo, B: Xo, A: wy } = Oh;
class Kn extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.MATERIAL, this.Z = Kn.AlphaMode.OPAQUE, this.K = 0.5, this.X = !1, this.tt = [1, 1, 1, 1], this.st = [0, 0, 0], this.et = 1, this.it = 1, this.rt = 1, this.nt = 1, this.baseColorTexture = null, this.baseColorTextureInfo = this.graph.link("baseColorTextureInfo", this, new sr(this.graph)), this.emissiveTexture = null, this.emissiveTextureInfo = this.graph.link("emissiveTextureInfo", this, new sr(this.graph)), this.normalTexture = null, this.normalTextureInfo = this.graph.link("normalTextureInfo", this, new sr(this.graph)), this.occlusionTexture = null, this.occlusionTextureInfo = this.graph.link("occlusionTextureInfo", this, new sr(this.graph)), this.metallicRoughnessTexture = null, this.metallicRoughnessTextureInfo = this.graph.link("metallicRoughnessTextureInfo", this, new sr(this.graph));
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.Z = e.Z, this.K = e.K, this.X = e.X, this.tt = [...e.tt], this.st = [...e.st], this.et = e.et, this.it = e.it, this.rt = e.rt, this.nt = e.nt, this.setBaseColorTexture(e.baseColorTexture ? t(e.baseColorTexture.getChild()) : null), this.baseColorTextureInfo.getChild().copy(t(e.baseColorTextureInfo.getChild()), t), this.setEmissiveTexture(e.emissiveTexture ? t(e.emissiveTexture.getChild()) : null), this.emissiveTextureInfo.getChild().copy(t(e.emissiveTextureInfo.getChild()), t), this.setNormalTexture(e.normalTexture ? t(e.normalTexture.getChild()) : null), this.normalTextureInfo.getChild().copy(t(e.normalTextureInfo.getChild()), t), this.setOcclusionTexture(e.occlusionTexture ? t(e.occlusionTexture.getChild()) : null), this.occlusionTextureInfo.getChild().copy(t(e.occlusionTextureInfo.getChild()), t), this.setMetallicRoughnessTexture(e.metallicRoughnessTexture ? t(e.metallicRoughnessTexture.getChild()) : null), this.metallicRoughnessTextureInfo.getChild().copy(t(e.metallicRoughnessTextureInfo.getChild()), t), this;
  }
  equals(e) {
    if (this.getAlphaMode() !== e.getAlphaMode() || this.getAlphaCutoff() !== e.getAlphaCutoff() || this.getDoubleSided() !== e.getDoubleSided() || !Rn.eq(this.getBaseColorFactor(), e.getBaseColorFactor()) || !Rn.eq(this.getEmissiveFactor(), e.getEmissiveFactor()) || this.getNormalScale() !== e.getNormalScale() || this.getOcclusionStrength() !== e.getOcclusionStrength() || this.getRoughnessFactor() !== e.getRoughnessFactor() || this.getMetallicFactor() !== e.getMetallicFactor() || (this.getBaseColorTexture() || e.getBaseColorTexture()) && (this.getBaseColorTexture() !== e.getBaseColorTexture() || this.getBaseColorTexture() && !this.getBaseColorTextureInfo().equals(e.getBaseColorTextureInfo())) || (this.getEmissiveTexture() || e.getEmissiveTexture()) && (this.getEmissiveTexture() !== e.getEmissiveTexture() || this.getEmissiveTexture() && !this.getEmissiveTextureInfo().equals(e.getEmissiveTextureInfo())) || (this.getNormalTexture() || e.getNormalTexture()) && (this.getNormalTexture() !== e.getNormalTexture() || this.getNormalTexture() && !this.getNormalTextureInfo().equals(e.getNormalTextureInfo())) || (this.getOcclusionTexture() || e.getOcclusionTexture()) && (this.getOcclusionTexture() !== e.getOcclusionTexture() || this.getOcclusionTexture() && !this.getOcclusionTextureInfo().equals(e.getOcclusionTextureInfo())) || (this.getMetallicRoughnessTexture() || e.getMetallicRoughnessTexture()) && (this.getMetallicRoughnessTexture() !== e.getMetallicRoughnessTexture() || this.getMetallicRoughnessTexture() && !this.getMetallicRoughnessTextureInfo().equals(e.getMetallicRoughnessTextureInfo())))
      return !1;
    const t = this.listExtensions(), s = e.listExtensions();
    if (t.length !== s.length)
      return !1;
    for (let o = 0; o < t.length; o++)
      if (t[o] !== s[o])
        return !1;
    return !0;
  }
  dispose() {
    this.baseColorTextureInfo.getChild().dispose(), this.emissiveTextureInfo.getChild().dispose(), this.normalTextureInfo.getChild().dispose(), this.occlusionTextureInfo.getChild().dispose(), this.metallicRoughnessTextureInfo.getChild().dispose(), super.dispose();
  }
  getDoubleSided() {
    return this.X;
  }
  setDoubleSided(e) {
    return this.X = e, this;
  }
  getAlpha() {
    return this.tt[3];
  }
  setAlpha(e) {
    return this.tt[3] = e, this;
  }
  getAlphaMode() {
    return this.Z;
  }
  setAlphaMode(e) {
    return this.Z = e, this;
  }
  getAlphaCutoff() {
    return this.K;
  }
  setAlphaCutoff(e) {
    return this.K = e, this;
  }
  getBaseColorFactor() {
    return this.tt;
  }
  setBaseColorFactor(e) {
    return this.tt = e, this;
  }
  getBaseColorHex() {
    return Wo.factorToHex(this.tt);
  }
  setBaseColorHex(e) {
    return Wo.hexToFactor(e, this.tt), this;
  }
  getBaseColorTexture() {
    return this.baseColorTexture ? this.baseColorTexture.getChild() : null;
  }
  getBaseColorTextureInfo() {
    return this.baseColorTexture ? this.baseColorTextureInfo.getChild() : null;
  }
  setBaseColorTexture(e) {
    return this.baseColorTexture = this.graph.linkTexture("baseColorTexture", qo | Zo | Xo | wy, this, e), this;
  }
  getEmissiveFactor() {
    return this.st;
  }
  setEmissiveFactor(e) {
    return this.st = e, this;
  }
  getEmissiveHex() {
    return Wo.factorToHex(this.st);
  }
  setEmissiveHex(e) {
    return Wo.hexToFactor(e, this.st), this;
  }
  getEmissiveTexture() {
    return this.emissiveTexture ? this.emissiveTexture.getChild() : null;
  }
  getEmissiveTextureInfo() {
    return this.emissiveTexture ? this.emissiveTextureInfo.getChild() : null;
  }
  setEmissiveTexture(e) {
    return this.emissiveTexture = this.graph.linkTexture("emissiveTexture", qo | Zo | Xo, this, e), this;
  }
  getNormalScale() {
    return this.et;
  }
  setNormalScale(e) {
    return this.et = e, this;
  }
  getNormalTexture() {
    return this.normalTexture ? this.normalTexture.getChild() : null;
  }
  getNormalTextureInfo() {
    return this.normalTexture ? this.normalTextureInfo.getChild() : null;
  }
  setNormalTexture(e) {
    return this.normalTexture = this.graph.linkTexture("normalTexture", qo | Zo | Xo, this, e), this;
  }
  getOcclusionStrength() {
    return this.it;
  }
  setOcclusionStrength(e) {
    return this.it = e, this;
  }
  getOcclusionTexture() {
    return this.occlusionTexture ? this.occlusionTexture.getChild() : null;
  }
  getOcclusionTextureInfo() {
    return this.occlusionTexture ? this.occlusionTextureInfo.getChild() : null;
  }
  setOcclusionTexture(e) {
    return this.occlusionTexture = this.graph.linkTexture("occlusionTexture", qo, this, e), this;
  }
  getRoughnessFactor() {
    return this.rt;
  }
  setRoughnessFactor(e) {
    return this.rt = e, this;
  }
  getMetallicFactor() {
    return this.nt;
  }
  setMetallicFactor(e) {
    return this.nt = e, this;
  }
  getMetallicRoughnessTexture() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTexture.getChild() : null;
  }
  getMetallicRoughnessTextureInfo() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTextureInfo.getChild() : null;
  }
  setMetallicRoughnessTexture(e) {
    return this.metallicRoughnessTexture = this.graph.linkTexture("metallicRoughnessTexture", Zo | Xo, this, e), this;
  }
}
Kn.AlphaMode = { OPAQUE: "OPAQUE", MASK: "MASK", BLEND: "BLEND" }, _i([_n], Kn.prototype, "baseColorTexture", void 0), _i([_n], Kn.prototype, "baseColorTextureInfo", void 0), _i([_n], Kn.prototype, "emissiveTexture", void 0), _i([_n], Kn.prototype, "emissiveTextureInfo", void 0), _i([_n], Kn.prototype, "normalTexture", void 0), _i([_n], Kn.prototype, "normalTextureInfo", void 0), _i([_n], Kn.prototype, "occlusionTexture", void 0), _i([_n], Kn.prototype, "occlusionTextureInfo", void 0), _i([_n], Kn.prototype, "metallicRoughnessTexture", void 0), _i([_n], Kn.prototype, "metallicRoughnessTextureInfo", void 0);
class qh extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.MESH, this.ht = [], this.primitives = [];
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.ht = [...e.ht], this.clearGraphChildList(this.primitives), e.primitives.forEach((s) => this.addPrimitive(t(s.getChild()))), this;
  }
  addPrimitive(e) {
    return this.addGraphChild(this.primitives, this.graph.link("primitive", this, e));
  }
  removePrimitive(e) {
    return this.removeGraphChild(this.primitives, e);
  }
  listPrimitives() {
    return this.primitives.map((e) => e.getChild());
  }
  getWeights() {
    return this.ht;
  }
  setWeights(e) {
    return this.ht = e, this;
  }
}
_i([On], qh.prototype, "primitives", void 0);
class jr extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.NODE, this.ot = [0, 0, 0], this.ut = [0, 0, 0, 1], this.ct = [1, 1, 1], this.ht = [], this.i = null, this.camera = null, this.mesh = null, this.skin = null, this.children = [];
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.ot = [...e.ot], this.ut = [...e.ut], this.ct = [...e.ct], this.ht = [...e.ht], this.setCamera(e.camera ? t(e.camera.getChild()) : null), this.setMesh(e.mesh ? t(e.mesh.getChild()) : null), this.setSkin(e.skin ? t(e.skin.getChild()) : null), t !== mn && (this.clearGraphChildList(this.children), e.children.forEach((s) => this.addChild(t(s.getChild())))), this;
  }
  getTranslation() {
    return this.ot;
  }
  getRotation() {
    return this.ut;
  }
  getScale() {
    return this.ct;
  }
  setTranslation(e) {
    return this.ot = e, this;
  }
  setRotation(e) {
    return this.ut = e, this;
  }
  setScale(e) {
    return this.ct = e, this;
  }
  getMatrix() {
    return Rn.compose(this.ot, this.ut, this.ct, []);
  }
  setMatrix(e) {
    return Rn.decompose(e, this.ot, this.ut, this.ct), this;
  }
  getWorldTranslation() {
    const e = [0, 0, 0];
    return Rn.decompose(this.getWorldMatrix(), e, [0, 0, 0, 1], [1, 1, 1]), e;
  }
  getWorldRotation() {
    const e = [0, 0, 0, 1];
    return Rn.decompose(this.getWorldMatrix(), [0, 0, 0], e, [1, 1, 1]), e;
  }
  getWorldScale() {
    const e = [1, 1, 1];
    return Rn.decompose(this.getWorldMatrix(), [0, 0, 0], [0, 0, 0, 1], e), e;
  }
  getWorldMatrix() {
    const e = [];
    for (let o = this; o instanceof jr; o = o.i)
      e.push(o);
    let t;
    const s = e.pop().getMatrix();
    for (; t = e.pop(); )
      dy(s, s, t.getMatrix());
    return s;
  }
  addChild(e) {
    e.i && e.i.removeChild(e);
    const t = this.graph.link("child", this, e);
    return this.addGraphChild(this.children, t), e.i = this, t.onDispose(() => e.i = null), this;
  }
  removeChild(e) {
    return this.removeGraphChild(this.children, e);
  }
  listChildren() {
    return this.children.map((e) => e.getChild());
  }
  getParent() {
    return this.i;
  }
  getMesh() {
    return this.mesh ? this.mesh.getChild() : null;
  }
  setMesh(e) {
    return this.mesh = this.graph.link("mesh", this, e), this;
  }
  getCamera() {
    return this.camera ? this.camera.getChild() : null;
  }
  setCamera(e) {
    return this.camera = this.graph.link("camera", this, e), this;
  }
  getSkin() {
    return this.skin ? this.skin.getChild() : null;
  }
  setSkin(e) {
    return this.skin = this.graph.link("skin", this, e), this;
  }
  getWeights() {
    return this.ht;
  }
  setWeights(e) {
    return this.ht = e, this;
  }
  traverse(e) {
    e(this);
    for (const t of this.listChildren())
      t.traverse(e);
    return this;
  }
}
_i([_n], jr.prototype, "camera", void 0), _i([_n], jr.prototype, "mesh", void 0), _i([_n], jr.prototype, "skin", void 0), _i([On], jr.prototype, "children", void 0);
class Yr extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.PRIMITIVE, this.at = Yr.Mode.TRIANGLES, this.material = null, this.indices = null, this.attributes = [], this.targets = [];
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.at = e.at, this.setIndices(e.indices ? t(e.indices.getChild()) : null), this.setMaterial(e.material ? t(e.material.getChild()) : null), this.clearGraphChildList(this.attributes), e.listSemantics().forEach((s) => {
      this.setAttribute(s, t(e.getAttribute(s)));
    }), this.clearGraphChildList(this.targets), e.targets.forEach((s) => this.addTarget(t(s.getChild()))), this;
  }
  getIndices() {
    return this.indices ? this.indices.getChild() : null;
  }
  setIndices(e) {
    return this.indices = this.graph.linkIndex("indices", this, e), this;
  }
  getAttribute(e) {
    const t = this.attributes.find((s) => s.semantic === e);
    return t ? t.getChild() : null;
  }
  setAttribute(e, t) {
    const s = this.getAttribute(e);
    if (s && this.removeGraphChild(this.attributes, s), !t)
      return this;
    const o = this.graph.linkAttribute(e, this, t);
    return this.addGraphChild(this.attributes, o);
  }
  listAttributes() {
    return this.attributes.map((e) => e.getChild());
  }
  listSemantics() {
    return this.attributes.map((e) => e.semantic);
  }
  getMaterial() {
    return this.material ? this.material.getChild() : null;
  }
  setMaterial(e) {
    return this.material = this.graph.link("material", this, e), this;
  }
  getMode() {
    return this.at;
  }
  setMode(e) {
    return this.at = e, this;
  }
  listTargets() {
    return this.targets.map((e) => e.getChild());
  }
  addTarget(e) {
    return this.addGraphChild(this.targets, this.graph.link("target", this, e)), this;
  }
  removeTarget(e) {
    return this.removeGraphChild(this.targets, e);
  }
}
Yr.Mode = { POINTS: 0, LINES: 1, LINE_LOOP: 2, LINE_STRIP: 3, TRIANGLES: 4, TRIANGLE_STRIP: 5, TRIANGLE_FAN: 6 }, _i([_n], Yr.prototype, "material", void 0), _i([_n], Yr.prototype, "indices", void 0), _i([On], Yr.prototype, "attributes", void 0), _i([On], Yr.prototype, "targets", void 0);
class Zf extends Ta {
  constructor(...e) {
    super(...e), this.propertyType = Ui.PRIMITIVE_TARGET, this.attributes = [];
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.clearGraphChildList(this.attributes), e.listSemantics().forEach((s) => {
      this.setAttribute(s, t(e.getAttribute(s)));
    }), this;
  }
  getAttribute(e) {
    const t = this.attributes.find((s) => s.semantic === e);
    return t ? t.getChild() : null;
  }
  setAttribute(e, t) {
    const s = this.getAttribute(e);
    if (s && this.removeGraphChild(this.attributes, s), !t)
      return this;
    const o = this.graph.linkAttribute(e, this, t);
    return o.semantic = e, this.addGraphChild(this.attributes, o);
  }
  listAttributes() {
    return this.attributes.map((e) => e.getChild());
  }
  listSemantics() {
    return this.attributes.map((e) => e.semantic);
  }
}
_i([On], Zf.prototype, "attributes", void 0);
class io extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.SCENE, this.children = [];
  }
  copy(e, t = mn) {
    return super.copy(e, t), t !== mn && (this.clearGraphChildList(this.children), e.children.forEach((s) => this.addChild(t(s.getChild())))), this;
  }
  addChild(e) {
    e.i && e.i.removeChild(e);
    const t = this.graph.link("child", this, e);
    return this.addGraphChild(this.children, t), e.i = this, t.onDispose(() => e.i = null), this;
  }
  removeChild(e) {
    return this.removeGraphChild(this.children, e);
  }
  listChildren() {
    return this.children.map((e) => e.getChild());
  }
  traverse(e) {
    for (const t of this.listChildren())
      t.traverse(e);
    return this;
  }
}
_i([On], io.prototype, "children", void 0);
class Ka extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.SKIN, this.skeleton = null, this.inverseBindMatrices = null, this.joints = [];
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.setSkeleton(e.skeleton ? t(e.skeleton.getChild()) : null), this.setInverseBindMatrices(e.inverseBindMatrices ? t(e.inverseBindMatrices.getChild()) : null), this.clearGraphChildList(this.joints), e.joints.forEach((s) => this.addJoint(t(s.getChild()))), this;
  }
  getSkeleton() {
    return this.skeleton ? this.skeleton.getChild() : null;
  }
  setSkeleton(e) {
    return this.skeleton = this.graph.link("skeleton", this, e), this;
  }
  getInverseBindMatrices() {
    return this.inverseBindMatrices ? this.inverseBindMatrices.getChild() : null;
  }
  setInverseBindMatrices(e) {
    return this.inverseBindMatrices = this.graph.link("inverseBindMatrices", this, e), this;
  }
  addJoint(e) {
    const t = this.graph.link("joint", this, e);
    return this.addGraphChild(this.joints, t);
  }
  removeJoint(e) {
    return this.removeGraphChild(this.joints, e);
  }
  listJoints() {
    return this.joints.map((e) => e.getChild());
  }
}
_i([_n], Ka.prototype, "skeleton", void 0), _i([_n], Ka.prototype, "inverseBindMatrices", void 0), _i([On], Ka.prototype, "joints", void 0);
class Xf extends Rs {
  constructor(...e) {
    super(...e), this.propertyType = Ui.TEXTURE, this.lt = null, this.ft = "", this.P = "";
  }
  copy(e, t = mn) {
    return super.copy(e, t), this.ft = e.ft, this.P = e.P, e.lt && (this.lt = e.lt.slice(0)), this;
  }
  getMimeType() {
    return this.ft || Ca.extensionToMimeType(hl.extension(this.P));
  }
  setMimeType(e) {
    return this.ft = e, this;
  }
  getURI() {
    return this.P;
  }
  setURI(e) {
    return this.P = e, this.ft = Ca.extensionToMimeType(hl.extension(e)), this;
  }
  getImage() {
    return this.lt;
  }
  setImage(e) {
    return this.lt = e, this;
  }
  getSize() {
    return this.lt ? Ca.getSize(this.lt, this.getMimeType()) : null;
  }
}
class qs extends Ta {
  constructor(e) {
    super(e), this.propertyType = Ui.ROOT, this.dt = { generator: "glTF-Transform v1.2.4", version: "2.0" }, this.gt = /* @__PURE__ */ new Set(), this.defaultScene = null, this.accessors = [], this.animations = [], this.buffers = [], this.cameras = [], this.materials = [], this.meshes = [], this.nodes = [], this.scenes = [], this.skins = [], this.textures = [], e.on("clone", (t) => this.wt(t));
  }
  clone() {
    throw new Error("Root cannot be cloned.");
  }
  copy(e, t = mn) {
    if (super.copy(e, t), t === mn)
      throw new Error("Root cannot be copied.");
    return Object.assign(this.dt, e.dt), e.accessors.forEach((s) => this.vt(t(s.getChild()))), e.animations.forEach((s) => this.Tt(t(s.getChild()))), e.buffers.forEach((s) => this.yt(t(s.getChild()))), e.cameras.forEach((s) => this.At(t(s.getChild()))), e.materials.forEach((s) => this.Et(t(s.getChild()))), e.meshes.forEach((s) => this.xt(t(s.getChild()))), e.nodes.forEach((s) => this.St(t(s.getChild()))), e.scenes.forEach((s) => this.Mt(t(s.getChild()))), e.skins.forEach((s) => this.It(t(s.getChild()))), e.textures.forEach((s) => this.bt(t(s.getChild()))), this.setDefaultScene(e.defaultScene ? t(e.defaultScene.getChild()) : null), this;
  }
  wt(e) {
    return e instanceof io ? this.Mt(e) : e instanceof jr ? this.St(e) : e instanceof ha ? this.At(e) : e instanceof Ka ? this.It(e) : e instanceof qh ? this.xt(e) : e instanceof Kn ? this.Et(e) : e instanceof Xf ? this.bt(e) : e instanceof ul ? this.Tt(e) : e instanceof ui ? this.vt(e) : e instanceof Gf && this.yt(e), this;
  }
  getAsset() {
    return this.dt;
  }
  listExtensionsUsed() {
    return Array.from(this.gt);
  }
  listExtensionsRequired() {
    return this.listExtensionsUsed().filter((e) => e.isRequired());
  }
  Rt(e) {
    return this.gt.add(e), this;
  }
  Nt(e) {
    return this.gt.delete(e), this;
  }
  Mt(e) {
    return this.addGraphChild(this.scenes, this.graph.link("scene", this, e));
  }
  listScenes() {
    return this.scenes.map((e) => e.getChild());
  }
  setDefaultScene(e) {
    return this.defaultScene = this.graph.link("scene", this, e), this;
  }
  getDefaultScene() {
    return this.defaultScene ? this.defaultScene.getChild() : null;
  }
  St(e) {
    return this.addGraphChild(this.nodes, this.graph.link("node", this, e));
  }
  listNodes() {
    return this.nodes.map((e) => e.getChild());
  }
  At(e) {
    return this.addGraphChild(this.cameras, this.graph.link("camera", this, e));
  }
  listCameras() {
    return this.cameras.map((e) => e.getChild());
  }
  It(e) {
    return this.addGraphChild(this.skins, this.graph.link("skin", this, e));
  }
  listSkins() {
    return this.skins.map((e) => e.getChild());
  }
  xt(e) {
    return this.addGraphChild(this.meshes, this.graph.link("mesh", this, e));
  }
  listMeshes() {
    return this.meshes.map((e) => e.getChild());
  }
  Et(e) {
    return this.addGraphChild(this.materials, this.graph.link("material", this, e));
  }
  listMaterials() {
    return this.materials.map((e) => e.getChild());
  }
  bt(e) {
    return this.addGraphChild(this.textures, this.graph.link("texture", this, e));
  }
  listTextures() {
    return this.textures.map((e) => e.getChild());
  }
  Tt(e) {
    return this.addGraphChild(this.animations, this.graph.link("animation", this, e));
  }
  listAnimations() {
    return this.animations.map((e) => e.getChild());
  }
  vt(e) {
    return this.addGraphChild(this.accessors, this.graph.link("accessor", this, e));
  }
  listAccessors() {
    return this.accessors.map((e) => e.getChild());
  }
  yt(e) {
    return this.addGraphChild(this.buffers, this.graph.link("buffer", this, e));
  }
  listBuffers() {
    return this.buffers.map((e) => e.getChild());
  }
}
_i([_n], qs.prototype, "defaultScene", void 0), _i([On], qs.prototype, "accessors", void 0), _i([On], qs.prototype, "animations", void 0), _i([On], qs.prototype, "buffers", void 0), _i([On], qs.prototype, "cameras", void 0), _i([On], qs.prototype, "materials", void 0), _i([On], qs.prototype, "meshes", void 0), _i([On], qs.prototype, "nodes", void 0), _i([On], qs.prototype, "scenes", void 0), _i([On], qs.prototype, "skins", void 0), _i([On], qs.prototype, "textures", void 0);
class Zh {
  constructor() {
    this.Ct = new xy(), this.Ot = new qs(this.Ct), this._t = Ns.DEFAULT_INSTANCE;
  }
  getRoot() {
    return this.Ot;
  }
  getGraph() {
    return this.Ct;
  }
  getLogger() {
    return this._t;
  }
  setLogger(e) {
    return this._t = e, this;
  }
  clone() {
    return new Zh().merge(this).setLogger(this._t);
  }
  merge(e) {
    const t = {};
    for (const c of e.getRoot().listExtensionsUsed()) {
      const g = this.createExtension(c.constructor);
      c.isRequired() && g.setRequired(!0), t[g.extensionName] = g;
    }
    const s = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map();
    s.add(e.Ot), o.set(e.Ot, this.Ot);
    for (const c of e.Ct.getLinks())
      for (const g of [c.getParent(), c.getChild()]) {
        if (s.has(g))
          continue;
        let w;
        if (g.propertyType === Ui.TEXTURE_INFO)
          w = g;
        else {
          const T = g.constructor;
          w = g instanceof jf ? new T(this.Ct, t[g.extensionName]) : new T(this.Ct);
        }
        o.set(g, w), s.add(g);
      }
    const a = (c) => {
      const g = o.get(c);
      if (!g)
        throw new Error("Could resolve property.");
      return g;
    };
    for (const c of s) {
      const g = o.get(c);
      if (!g)
        throw new Error("Could resolve property.");
      g.copy(c, a);
    }
    return this;
  }
  async transform(...e) {
    const t = e.map((s) => s.name);
    for (const s of e)
      await s(this, { stack: t });
    return this;
  }
  createExtension(e) {
    const t = e.EXTENSION_NAME;
    return this.getRoot().listExtensionsUsed().find((s) => s.extensionName === t) || new e(this);
  }
  createScene(e = "") {
    const t = new io(this.Ct, e);
    return this.Ot.Mt(t), t;
  }
  createNode(e = "") {
    const t = new jr(this.Ct, e);
    return this.Ot.St(t), t;
  }
  createCamera(e = "") {
    const t = new ha(this.Ct, e);
    return this.Ot.At(t), t;
  }
  createSkin(e = "") {
    const t = new Ka(this.Ct, e);
    return this.Ot.It(t), t;
  }
  createMesh(e = "") {
    const t = new qh(this.Ct, e);
    return this.Ot.xt(t), t;
  }
  createPrimitive() {
    return new Yr(this.Ct);
  }
  createPrimitiveTarget(e = "") {
    return new Zf(this.Ct, e);
  }
  createMaterial(e = "") {
    const t = new Kn(this.Ct, e);
    return this.Ot.Et(t), t;
  }
  createTexture(e = "") {
    const t = new Xf(this.Ct, e);
    return this.Ot.bt(t), t;
  }
  createAnimation(e = "") {
    const t = new ul(this.Ct, e);
    return this.Ot.Tt(t), t;
  }
  createAnimationChannel(e = "") {
    return new tl(this.Ct, e);
  }
  createAnimationSampler(e = "") {
    return new la(this.Ct, e);
  }
  createAccessor(e = "", t = null) {
    t || (t = this.getRoot().listBuffers()[0]);
    const s = new ui(this.Ct, e).setBuffer(t);
    return this.Ot.vt(s), s;
  }
  createBuffer(e = "") {
    const t = new Gf(this.Ct, e);
    return this.Ot.yt(t), t;
  }
}
function Zs() {
  return (Zs = Object.assign || function(v) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (v[s] = t[s]);
    }
    return v;
  }).apply(this, arguments);
}
class Sy {
  constructor(e) {
    this.jsonDoc = void 0, this.buffers = [], this.bufferViews = [], this.bufferViewBuffers = [], this.accessors = [], this.textures = [], this.textureInfos = /* @__PURE__ */ new Map(), this.materials = [], this.meshes = [], this.cameras = [], this.nodes = [], this.skins = [], this.animations = [], this.scenes = [], this.jsonDoc = e;
  }
  setTextureInfo(e, t) {
    this.textureInfos.set(e, t), t.texCoord !== void 0 && e.setTexCoord(t.texCoord);
    const s = this.jsonDoc.json.textures[t.index];
    if (s.sampler === void 0)
      return;
    const o = this.jsonDoc.json.samplers[s.sampler];
    o.magFilter !== void 0 && e.setMagFilter(o.magFilter), o.minFilter !== void 0 && e.setMinFilter(o.minFilter), o.wrapS !== void 0 && e.setWrapS(o.wrapS), o.wrapT !== void 0 && e.setWrapT(o.wrapT);
  }
}
const Ih = { 5120: Int8Array, 5121: Uint8Array, 5122: Int16Array, 5123: Uint16Array, 5125: Uint32Array, 5126: Float32Array }, hf = { logger: Ns.DEFAULT_INSTANCE, extensions: [], dependencies: {} };
function Ko(v, e) {
  const t = e.bufferViews[v.bufferView], s = e.jsonDoc.json.bufferViews[v.bufferView], o = Ih[v.componentType], a = ui.getElementSize(v.type), c = o.BYTES_PER_ELEMENT;
  if (s.byteStride !== void 0 && s.byteStride !== a * c)
    return function(w, T) {
      const H = T.bufferViews[w.bufferView], Y = T.jsonDoc.json.bufferViews[w.bufferView], ee = Ih[w.componentType], z = ui.getElementSize(w.type), he = ee.BYTES_PER_ELEMENT, ne = w.byteOffset || 0, ye = new ee(w.count * z), se = new DataView(H.buffer, H.byteOffset, H.byteLength), _e = Y.byteStride;
      for (let ue = 0; ue < w.count; ue++)
        for (let xe = 0; xe < z; xe++) {
          const Ee = ne + ue * _e + xe * he;
          let K;
          switch (w.componentType) {
            case ui.ComponentType.FLOAT:
              K = se.getFloat32(Ee, !0);
              break;
            case ui.ComponentType.UNSIGNED_INT:
              K = se.getUint32(Ee, !0);
              break;
            case ui.ComponentType.UNSIGNED_SHORT:
              K = se.getUint16(Ee, !0);
              break;
            case ui.ComponentType.UNSIGNED_BYTE:
              K = se.getUint8(Ee);
              break;
            case ui.ComponentType.SHORT:
              K = se.getInt16(Ee, !0);
              break;
            case ui.ComponentType.BYTE:
              K = se.getInt8(Ee);
              break;
            default:
              throw new Error(`Unexpected componentType "${w.componentType}".`);
          }
          ye[ue * z + xe] = K;
        }
      return ye;
    }(v, e);
  const g = t.byteOffset + (v.byteOffset || 0);
  return new o(t.buffer.slice(g, g + v.count * a * c));
}
var Ja, $a;
(function(v) {
  v[v.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", v[v.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER";
})(Ja || (Ja = {})), function(v) {
  v.ARRAY_BUFFER = "ARRAY_BUFFER", v.ELEMENT_ARRAY_BUFFER = "ELEMENT_ARRAY_BUFFER", v.INVERSE_BIND_MATRICES = "INVERSE_BIND_MATRICES", v.OTHER = "OTHER";
}($a || ($a = {}));
class Xs {
  constructor(e, t, s) {
    this.Bt = void 0, this.jsonDoc = void 0, this.options = void 0, this.accessorIndexMap = /* @__PURE__ */ new Map(), this.bufferIndexMap = /* @__PURE__ */ new Map(), this.cameraIndexMap = /* @__PURE__ */ new Map(), this.skinIndexMap = /* @__PURE__ */ new Map(), this.materialIndexMap = /* @__PURE__ */ new Map(), this.meshIndexMap = /* @__PURE__ */ new Map(), this.nodeIndexMap = /* @__PURE__ */ new Map(), this.imageIndexMap = /* @__PURE__ */ new Map(), this.textureDefIndexMap = /* @__PURE__ */ new Map(), this.textureInfoDefMap = /* @__PURE__ */ new Map(), this.samplerDefIndexMap = /* @__PURE__ */ new Map(), this.imageBufferViews = [], this.otherBufferViews = /* @__PURE__ */ new Map(), this.otherBufferViewsIndexMap = /* @__PURE__ */ new Map(), this.extensionData = {}, this.bufferURIGenerator = void 0, this.imageURIGenerator = void 0, this.logger = void 0, this.Lt = /* @__PURE__ */ new Map(), this.accessorUsageGroupedByParent = /* @__PURE__ */ new Set(["ARRAY_BUFFER"]), this.accessorParents = /* @__PURE__ */ new Map(), this.Bt = e, this.jsonDoc = t, this.options = s;
    const o = e.getRoot(), a = o.listBuffers().length, c = o.listTextures().length;
    this.bufferURIGenerator = new uf(a > 1, s.basename), this.imageURIGenerator = new uf(c > 1, s.basename), this.logger = e.getLogger();
  }
  createTextureInfoDef(e, t) {
    const s = { magFilter: t.getMagFilter() || void 0, minFilter: t.getMinFilter() || void 0, wrapS: t.getWrapS(), wrapT: t.getWrapT() }, o = JSON.stringify(s);
    this.samplerDefIndexMap.has(o) || (this.samplerDefIndexMap.set(o, this.jsonDoc.json.samplers.length), this.jsonDoc.json.samplers.push(s));
    const a = { source: this.imageIndexMap.get(e), sampler: this.samplerDefIndexMap.get(o) }, c = JSON.stringify(a);
    this.textureDefIndexMap.has(c) || (this.textureDefIndexMap.set(c, this.jsonDoc.json.textures.length), this.jsonDoc.json.textures.push(a));
    const g = { index: this.textureDefIndexMap.get(c) };
    return t.getTexCoord() !== 0 && (g.texCoord = t.getTexCoord()), this.textureInfoDefMap.set(t, g), g;
  }
  createPropertyDef(e) {
    const t = {};
    return e.getName() && (t.name = e.getName()), Object.keys(e.getExtras()).length > 0 && (t.extras = e.getExtras()), t;
  }
  createAccessorDef(e) {
    const t = this.createPropertyDef(e);
    return t.type = e.getType(), t.componentType = e.getComponentType(), t.count = e.getCount(), this.Bt.getGraph().listParentLinks(e).some((s) => s.getName() === "POSITION" || s.getName() === "input") && (t.max = e.getMax([]).map(Math.fround), t.min = e.getMin([]).map(Math.fround)), e.getNormalized() && (t.normalized = e.getNormalized()), t;
  }
  createImageData(e, t, s) {
    if (this.options.format === oa.GLB)
      this.imageBufferViews.push(t), e.bufferView = this.jsonDoc.json.bufferViews.length, this.jsonDoc.json.bufferViews.push({ buffer: 0, byteOffset: -1, byteLength: t.byteLength });
    else {
      const o = Ca.mimeTypeToExtension(s.getMimeType());
      e.uri = this.imageURIGenerator.createURI(s, o), this.jsonDoc.resources[e.uri] = t;
    }
  }
  getAccessorUsage(e) {
    const t = this.Lt.get(e);
    if (t)
      return t;
    for (const s of this.Bt.getGraph().listParentLinks(e)) {
      if (s.getName() === "inverseBindMatrices")
        return Xs.BufferViewUsage.INVERSE_BIND_MATRICES;
      if (s instanceof Wf)
        return Xs.BufferViewUsage.ARRAY_BUFFER;
      if (s instanceof qf)
        return Xs.BufferViewUsage.ELEMENT_ARRAY_BUFFER;
    }
    return Xs.BufferViewUsage.OTHER;
  }
  addAccessorToUsageGroup(e, t) {
    const s = this.Lt.get(e);
    if (s && s !== t)
      throw new Error(`Accessor with usage "${s}" cannot be reused as "${t}".`);
    return this.Lt.set(e, t), this;
  }
  listAccessorUsageGroups() {
    const e = {};
    for (const [t, s] of Array.from(this.Lt.entries()))
      e[s] = e[s] || [], e[s].push(t);
    return e;
  }
}
Xs.BufferViewTarget = Ja, Xs.BufferViewUsage = $a, Xs.USAGE_TO_TARGET = { [$a.ARRAY_BUFFER]: Ja.ARRAY_BUFFER, [$a.ELEMENT_ARRAY_BUFFER]: Ja.ELEMENT_ARRAY_BUFFER };
class uf {
  constructor(e, t) {
    this.multiple = void 0, this.basename = void 0, this.counter = 1, this.multiple = e, this.basename = t;
  }
  createURI(e, t) {
    return e.getURI() ? e.getURI() : this.multiple ? `${this.basename}_${this.counter++}.${t}` : `${this.basename}.${t}`;
  }
}
const { BufferViewUsage: bh } = Xs;
var cl;
(function(v) {
  v[v.JSON = 1313821514] = "JSON", v[v.BIN = 5130562] = "BIN";
})(cl || (cl = {}));
class My {
  constructor() {
    this._t = Ns.DEFAULT_INSTANCE, this.gt = /* @__PURE__ */ new Set(), this.Pt = {}, this.Ut = ll.INTERLEAVED;
  }
  setLogger(e) {
    return this._t = e, this;
  }
  registerExtensions(e) {
    for (const t of e)
      this.gt.add(t), t.register();
    return this;
  }
  registerDependencies(e) {
    return Object.assign(this.Pt, e), this;
  }
  setVertexLayout(e) {
    return this.Ut = e, this;
  }
  kt(e) {
    function t(s) {
      if (s.uri && !(s.uri in e.resources) && s.uri.match(/data:/)) {
        const o = `__${yy()}.${hl.extension(s.uri)}`;
        e.resources[o] = ps.createBufferFromDataURI(s.uri), s.uri = o;
      }
    }
    (e.json.images || []).forEach((s) => {
      if (s.bufferView === void 0 && s.uri === void 0)
        throw new Error("Missing resource URI or buffer view.");
      t(s);
    }), (e.json.buffers || []).forEach(t);
  }
  readJSON(e) {
    return e = this.Ft(e), this.kt(e), (class {
      static read(t, s = hf) {
        const o = Zs({}, hf, s), { json: a } = t, c = new Zh();
        this.validate(t, o);
        const g = new Sy(t), w = a.asset, T = c.getRoot().getAsset();
        w.copyright && (T.copyright = w.copyright), w.extras && (T.extras = w.extras), a.extras !== void 0 && c.getRoot().setExtras(Zs({}, a.extras));
        const H = a.extensionsUsed || [], Y = a.extensionsRequired || [];
        for (const _e of o.extensions)
          if (H.includes(_e.EXTENSION_NAME)) {
            const ue = c.createExtension(_e).setRequired(Y.includes(_e.EXTENSION_NAME));
            for (const xe of ue.readDependencies)
              ue.install(xe, o.dependencies[xe]);
          }
        const ee = a.buffers || [];
        c.getRoot().listExtensionsUsed().filter((_e) => _e.prereadTypes.includes(Ui.BUFFER)).forEach((_e) => _e.preread(g, Ui.BUFFER)), g.buffers = ee.map((_e) => {
          const ue = c.createBuffer(_e.name);
          return _e.extras && ue.setExtras(_e.extras), _e.uri && _e.uri.indexOf("__") !== 0 && ue.setURI(_e.uri), ue;
        }), g.bufferViewBuffers = (a.bufferViews || []).map((_e, ue) => {
          if (!g.bufferViews[ue]) {
            const xe = t.json.buffers[_e.buffer], Ee = new Uint8Array(xe.uri ? t.resources[xe.uri] : t.resources["@glb.bin"], _e.byteOffset || 0, _e.byteLength);
            g.bufferViews[ue] = Ee;
          }
          return g.buffers[_e.buffer];
        }), g.accessors = (a.accessors || []).map((_e) => {
          const ue = c.createAccessor(_e.name, g.bufferViewBuffers[_e.bufferView]).setType(_e.type);
          if (_e.extras && ue.setExtras(_e.extras), _e.normalized !== void 0 && ue.setNormalized(_e.normalized), _e.bufferView === void 0 && !_e.sparse)
            return ue;
          let xe;
          return xe = _e.sparse !== void 0 ? function(Ee, K) {
            const j = Ih[Ee.componentType], ht = ui.getElementSize(Ee.type);
            let Ze;
            Ze = Ee.bufferView !== void 0 ? Ko(Ee, K) : new j(Ee.count * ht);
            const pt = Ee.sparse, Pt = pt.count, Mt = Zs({}, Ee, pt.indices, { count: Pt, type: "SCALAR" }), Tt = Zs({}, Ee, pt.values, { count: Pt }), at = Ko(Mt, K), Ai = Ko(Tt, K);
            for (let Ve = 0; Ve < Mt.count; Ve++)
              for (let Ot = 0; Ot < ht; Ot++)
                Ze[at[Ve] * ht + Ot] = Ai[Ve * ht + Ot];
            return Ze;
          }(_e, g) : Ko(_e, g), ue.setArray(xe), ue;
        });
        const z = a.images || [], he = a.textures || [];
        c.getRoot().listExtensionsUsed().filter((_e) => _e.prereadTypes.includes(Ui.TEXTURE)).forEach((_e) => _e.preread(g, Ui.TEXTURE)), g.textures = z.map((_e) => {
          const ue = c.createTexture(_e.name);
          if (_e.extras && ue.setExtras(_e.extras), _e.bufferView !== void 0) {
            const xe = a.bufferViews[_e.bufferView], Ee = t.json.buffers[xe.buffer], K = xe.byteOffset || 0, j = (Ee.uri ? t.resources[Ee.uri] : t.resources["@glb.bin"]).slice(K, K + xe.byteLength);
            ue.setImage(j);
          } else
            _e.uri !== void 0 && (ue.setImage(t.resources[_e.uri]), _e.uri.indexOf("__") !== 0 && ue.setURI(_e.uri));
          if (_e.mimeType !== void 0)
            ue.setMimeType(_e.mimeType);
          else if (_e.uri) {
            const xe = hl.extension(_e.uri);
            ue.setMimeType(Ca.extensionToMimeType(xe));
          }
          return ue;
        }), g.materials = (a.materials || []).map((_e) => {
          const ue = c.createMaterial(_e.name);
          _e.extras && ue.setExtras(_e.extras), _e.alphaMode !== void 0 && ue.setAlphaMode(_e.alphaMode), _e.alphaCutoff !== void 0 && ue.setAlphaCutoff(_e.alphaCutoff), _e.doubleSided !== void 0 && ue.setDoubleSided(_e.doubleSided);
          const xe = _e.pbrMetallicRoughness || {};
          if (xe.baseColorFactor !== void 0 && ue.setBaseColorFactor(xe.baseColorFactor), _e.emissiveFactor !== void 0 && ue.setEmissiveFactor(_e.emissiveFactor), xe.metallicFactor !== void 0 && ue.setMetallicFactor(xe.metallicFactor), xe.roughnessFactor !== void 0 && ue.setRoughnessFactor(xe.roughnessFactor), xe.baseColorTexture !== void 0) {
            const Ee = xe.baseColorTexture;
            ue.setBaseColorTexture(g.textures[he[Ee.index].source]), g.setTextureInfo(ue.getBaseColorTextureInfo(), Ee);
          }
          if (_e.emissiveTexture !== void 0) {
            const Ee = _e.emissiveTexture;
            ue.setEmissiveTexture(g.textures[he[Ee.index].source]), g.setTextureInfo(ue.getEmissiveTextureInfo(), Ee);
          }
          if (_e.normalTexture !== void 0) {
            const Ee = _e.normalTexture;
            ue.setNormalTexture(g.textures[he[Ee.index].source]), g.setTextureInfo(ue.getNormalTextureInfo(), Ee), _e.normalTexture.scale !== void 0 && ue.setNormalScale(_e.normalTexture.scale);
          }
          if (_e.occlusionTexture !== void 0) {
            const Ee = _e.occlusionTexture;
            ue.setOcclusionTexture(g.textures[he[Ee.index].source]), g.setTextureInfo(ue.getOcclusionTextureInfo(), Ee), _e.occlusionTexture.strength !== void 0 && ue.setOcclusionStrength(_e.occlusionTexture.strength);
          }
          if (xe.metallicRoughnessTexture !== void 0) {
            const Ee = xe.metallicRoughnessTexture;
            ue.setMetallicRoughnessTexture(g.textures[he[Ee.index].source]), g.setTextureInfo(ue.getMetallicRoughnessTextureInfo(), Ee);
          }
          return ue;
        });
        const ne = a.meshes || [];
        c.getRoot().listExtensionsUsed().filter((_e) => _e.prereadTypes.includes(Ui.PRIMITIVE)).forEach((_e) => _e.preread(g, Ui.PRIMITIVE)), g.meshes = ne.map((_e) => {
          const ue = c.createMesh(_e.name);
          return _e.extras && ue.setExtras(_e.extras), _e.weights !== void 0 && ue.setWeights(_e.weights), (_e.primitives || []).forEach((xe) => {
            const Ee = c.createPrimitive();
            xe.extras && Ee.setExtras(xe.extras), xe.material !== void 0 && Ee.setMaterial(g.materials[xe.material]), xe.mode !== void 0 && Ee.setMode(xe.mode);
            for (const [j, ht] of Object.entries(xe.attributes || {}))
              Ee.setAttribute(j, g.accessors[ht]);
            xe.indices !== void 0 && Ee.setIndices(g.accessors[xe.indices]);
            const K = _e.extras && _e.extras.targetNames || [];
            (xe.targets || []).forEach((j, ht) => {
              const Ze = K[ht] || ht.toString(), pt = c.createPrimitiveTarget(Ze);
              for (const [Pt, Mt] of Object.entries(j))
                pt.setAttribute(Pt, g.accessors[Mt]);
              Ee.addTarget(pt);
            }), ue.addPrimitive(Ee);
          }), ue;
        }), g.cameras = (a.cameras || []).map((_e) => {
          const ue = c.createCamera(_e.name).setType(_e.type);
          if (_e.extras && ue.setExtras(_e.extras), _e.type === ha.Type.PERSPECTIVE) {
            const xe = _e.perspective;
            ue.setYFov(xe.yfov), ue.setZNear(xe.znear), xe.zfar !== void 0 && ue.setZFar(xe.zfar), xe.aspectRatio !== void 0 && ue.setAspectRatio(xe.aspectRatio);
          } else {
            const xe = _e.orthographic;
            ue.setZNear(xe.znear).setZFar(xe.zfar).setXMag(xe.xmag).setYMag(xe.ymag);
          }
          return ue;
        });
        const ye = a.nodes || [];
        c.getRoot().listExtensionsUsed().filter((_e) => _e.prereadTypes.includes(Ui.NODE)).forEach((_e) => _e.preread(g, Ui.NODE)), g.nodes = ye.map((_e) => {
          const ue = c.createNode(_e.name);
          if (_e.extras && ue.setExtras(_e.extras), _e.translation !== void 0 && ue.setTranslation(_e.translation), _e.rotation !== void 0 && ue.setRotation(_e.rotation), _e.scale !== void 0 && ue.setScale(_e.scale), _e.matrix !== void 0) {
            const xe = [0, 0, 0], Ee = [0, 0, 0, 1], K = [1, 1, 1];
            Rn.decompose(_e.matrix, xe, Ee, K), ue.setTranslation(xe), ue.setRotation(Ee), ue.setScale(K);
          }
          return _e.weights !== void 0 && ue.setWeights(_e.weights), ue;
        }), g.skins = (a.skins || []).map((_e) => {
          const ue = c.createSkin(_e.name);
          _e.extras && ue.setExtras(_e.extras), _e.inverseBindMatrices !== void 0 && ue.setInverseBindMatrices(g.accessors[_e.inverseBindMatrices]), _e.skeleton !== void 0 && ue.setSkeleton(g.nodes[_e.skeleton]);
          for (const xe of _e.joints)
            ue.addJoint(g.nodes[xe]);
          return ue;
        }), ye.map((_e, ue) => {
          const xe = g.nodes[ue];
          (_e.children || []).forEach((Ee) => xe.addChild(g.nodes[Ee])), _e.mesh !== void 0 && xe.setMesh(g.meshes[_e.mesh]), _e.camera !== void 0 && xe.setCamera(g.cameras[_e.camera]), _e.skin !== void 0 && xe.setSkin(g.skins[_e.skin]);
        }), g.animations = (a.animations || []).map((_e) => {
          const ue = c.createAnimation(_e.name);
          _e.extras && ue.setExtras(_e.extras);
          const xe = (_e.samplers || []).map((Ee) => {
            const K = c.createAnimationSampler().setInput(g.accessors[Ee.input]).setOutput(g.accessors[Ee.output]).setInterpolation(Ee.interpolation || la.Interpolation.LINEAR);
            return Ee.extras && K.setExtras(Ee.extras), ue.addSampler(K), K;
          });
          return (_e.channels || []).forEach((Ee) => {
            const K = c.createAnimationChannel().setSampler(xe[Ee.sampler]).setTargetNode(g.nodes[Ee.target.node]).setTargetPath(Ee.target.path);
            Ee.extras && K.setExtras(Ee.extras), ue.addChannel(K);
          }), ue;
        });
        const se = a.scenes || [];
        return c.getRoot().listExtensionsUsed().filter((_e) => _e.prereadTypes.includes(Ui.SCENE)).forEach((_e) => _e.preread(g, Ui.SCENE)), g.scenes = se.map((_e) => {
          const ue = c.createScene(_e.name);
          return _e.extras && ue.setExtras(_e.extras), (_e.nodes || []).map((xe) => g.nodes[xe]).forEach((xe) => ue.addChild(xe)), ue;
        }), a.scene !== void 0 && c.getRoot().setDefaultScene(g.scenes[a.scene]), c.getRoot().listExtensionsUsed().forEach((_e) => _e.read(g)), c;
      }
      static validate(t, s) {
        const o = t.json;
        if (o.asset.version !== "2.0")
          throw new Error(`Unsupported glTF version, "${o.asset.version}".`);
        if (o.extensionsRequired) {
          for (const a of o.extensionsRequired)
            if (!s.extensions.find((c) => c.EXTENSION_NAME === a))
              throw new Error(`Missing required extension, "${a}".`);
        }
        if (o.extensionsUsed)
          for (const a of o.extensionsUsed)
            s.extensions.find((c) => c.EXTENSION_NAME === a) || s.logger.warn(`Missing optional extension, "${a}".`);
      }
    }).read(e, { extensions: Array.from(this.gt), dependencies: this.Pt, logger: this._t });
  }
  writeJSON(e, t = {}) {
    if (t.format === oa.GLB && e.getRoot().listBuffers().length > 1)
      throw new Error("GLB must have 0–1 buffers.");
    return (class {
      static write(s, o) {
        const a = s.getRoot(), c = { asset: Zs({ generator: "glTF-Transform v1.2.4" }, a.getAsset()), extras: Zs({}, a.getExtras()) }, g = { json: c, resources: {} }, w = new Xs(s, g, o), T = o.logger || Ns.DEFAULT_INSTANCE, H = new Set(o.extensions.map((se) => se.EXTENSION_NAME)), Y = s.getRoot().listExtensionsUsed().filter((se) => H.has(se.extensionName)), ee = s.getRoot().listExtensionsRequired().filter((se) => H.has(se.extensionName));
        Y.length < s.getRoot().listExtensionsUsed().length && T.debug("Some extensions were not registered for I/O, and will not be written.");
        for (const se of Y)
          for (const _e of se.writeDependencies)
            se.install(_e, o.dependencies[_e]);
        function z(se, _e, ue, xe) {
          const Ee = [];
          let K = 0;
          for (const ht of se) {
            const Ze = w.createAccessorDef(ht);
            Ze.bufferView = c.bufferViews.length;
            const pt = ps.pad(ht.getArray().buffer);
            Ze.byteOffset = K, K += pt.byteLength, Ee.push(pt), w.accessorIndexMap.set(ht, c.accessors.length), c.accessors.push(Ze);
          }
          const j = { buffer: _e, byteOffset: ue, byteLength: ps.concat(Ee).byteLength };
          return xe && (j.target = xe), c.bufferViews.push(j), { buffers: Ee, byteLength: K };
        }
        function he(se, _e, ue) {
          const xe = se[0].getCount();
          let Ee = 0;
          for (const Ze of se) {
            const pt = w.createAccessorDef(Ze);
            pt.bufferView = c.bufferViews.length, pt.byteOffset = Ee;
            const Pt = Ze.getElementSize(), Mt = Ze.getComponentSize();
            Ee += ps.padNumber(Pt * Mt), w.accessorIndexMap.set(Ze, c.accessors.length), c.accessors.push(pt);
          }
          const K = xe * Ee, j = new ArrayBuffer(K), ht = new DataView(j);
          for (let Ze = 0; Ze < xe; Ze++) {
            let pt = 0;
            for (const Pt of se) {
              const Mt = Pt.getElementSize(), Tt = Pt.getComponentSize(), at = Pt.getComponentType(), Ai = Pt.getArray();
              for (let Ve = 0; Ve < Mt; Ve++) {
                const Ot = Ze * Ee + pt + Ve * Tt, Ft = Ai[Ze * Mt + Ve];
                switch (at) {
                  case ui.ComponentType.FLOAT:
                    ht.setFloat32(Ot, Ft, !0);
                    break;
                  case ui.ComponentType.BYTE:
                    ht.setInt8(Ot, Ft);
                    break;
                  case ui.ComponentType.SHORT:
                    ht.setInt16(Ot, Ft, !0);
                    break;
                  case ui.ComponentType.UNSIGNED_BYTE:
                    ht.setUint8(Ot, Ft);
                    break;
                  case ui.ComponentType.UNSIGNED_SHORT:
                    ht.setUint16(Ot, Ft, !0);
                    break;
                  case ui.ComponentType.UNSIGNED_INT:
                    ht.setUint32(Ot, Ft, !0);
                    break;
                  default:
                    throw new Error("Unexpected component type: " + at);
                }
              }
              pt += ps.padNumber(Mt * Tt);
            }
          }
          return c.bufferViews.push({ buffer: _e, byteOffset: ue, byteLength: K, byteStride: Ee, target: Xs.BufferViewTarget.ARRAY_BUFFER }), { byteLength: K, buffers: [j] };
        }
        const ne = /* @__PURE__ */ new Map();
        for (const se of s.getGraph().getLinks()) {
          if (se.getParent() === a)
            continue;
          const _e = se.getChild();
          if (_e instanceof ui) {
            const ue = ne.get(_e) || [];
            ue.push(se), ne.set(_e, ue);
          }
        }
        if (c.accessors = [], c.bufferViews = [], c.samplers = [], c.textures = [], c.images = a.listTextures().map((se, _e) => {
          const ue = w.createPropertyDef(se);
          se.getMimeType() && (ue.mimeType = se.getMimeType());
          const xe = se.getImage();
          return xe && w.createImageData(ue, xe, se), w.imageIndexMap.set(se, _e), ue;
        }), Y.filter((se) => se.prewriteTypes.includes(Ui.ACCESSOR)).forEach((se) => se.prewrite(w, Ui.ACCESSOR)), a.listAccessors().forEach((se) => {
          const _e = w.accessorUsageGroupedByParent, ue = w.accessorParents;
          if (w.accessorIndexMap.has(se))
            return;
          const xe = ne.get(se) || [], Ee = w.getAccessorUsage(se);
          if (w.addAccessorToUsageGroup(se, Ee), _e.has(Ee)) {
            const K = xe[0].getParent(), j = ue.get(K) || /* @__PURE__ */ new Set();
            j.add(se), ue.set(K, j);
          }
        }), Y.filter((se) => se.prewriteTypes.includes(Ui.BUFFER)).forEach((se) => se.prewrite(w, Ui.BUFFER)), (a.listAccessors().length > 0 || a.listTextures().length > 0 || w.otherBufferViews.size > 0) && a.listBuffers().length === 0)
          throw new Error("Buffer required for Document resources, but none was found.");
        c.buffers = [], a.listBuffers().forEach((se, _e) => {
          const ue = w.createPropertyDef(se), xe = w.accessorUsageGroupedByParent, Ee = w.accessorParents, K = se.listParents().filter((Mt) => Mt instanceof ui), j = new Set(K), ht = [], Ze = c.buffers.length;
          let pt = 0;
          const Pt = w.listAccessorUsageGroups();
          for (const Mt in Pt)
            if (xe.has(Mt))
              for (const Tt of Array.from(Ee.values())) {
                const at = Array.from(Tt).filter((Ai) => j.has(Ai)).filter((Ai) => w.getAccessorUsage(Ai) === Mt);
                if (at.length)
                  if (Mt !== bh.ARRAY_BUFFER || o.vertexLayout === ll.INTERLEAVED) {
                    const Ai = Mt === bh.ARRAY_BUFFER ? he(at, Ze, pt) : z(at, Ze, pt);
                    pt += Ai.byteLength, ht.push(...Ai.buffers);
                  } else
                    for (const Ai of at) {
                      const Ve = he([Ai], Ze, pt);
                      pt += Ve.byteLength, ht.push(...Ve.buffers);
                    }
              }
            else {
              const Tt = Pt[Mt].filter((Ai) => j.has(Ai));
              if (!Tt.length)
                continue;
              const at = z(Tt, Ze, pt, Mt === bh.ELEMENT_ARRAY_BUFFER ? Xs.BufferViewTarget.ELEMENT_ARRAY_BUFFER : void 0);
              pt += at.byteLength, ht.push(...at.buffers);
            }
          if (w.imageBufferViews.length && _e === 0) {
            for (let Mt = 0; Mt < w.imageBufferViews.length; Mt++)
              if (c.bufferViews[c.images[Mt].bufferView].byteOffset = pt, pt += w.imageBufferViews[Mt].byteLength, ht.push(w.imageBufferViews[Mt]), pt % 8) {
                const Tt = 8 - pt % 8;
                pt += Tt, ht.push(new ArrayBuffer(Tt));
              }
          }
          if (w.otherBufferViews.has(se))
            for (const Mt of w.otherBufferViews.get(se))
              c.bufferViews.push({ buffer: Ze, byteOffset: pt, byteLength: Mt.byteLength }), w.otherBufferViewsIndexMap.set(Mt, c.bufferViews.length - 1), pt += Mt.byteLength, ht.push(Mt);
          if (pt) {
            let Mt;
            o.format === oa.GLB ? Mt = "@glb.bin" : (Mt = w.bufferURIGenerator.createURI(se, "bin"), ue.uri = Mt), ue.byteLength = pt, g.resources[Mt] = ps.concat(ht);
          }
          c.buffers.push(ue), w.bufferIndexMap.set(se, _e);
        }), a.listAccessors().find((se) => !se.getBuffer()) && T.warn("Skipped writing one or more Accessors: no Buffer assigned."), c.materials = a.listMaterials().map((se, _e) => {
          const ue = w.createPropertyDef(se);
          if (se.getAlphaMode() !== Kn.AlphaMode.OPAQUE && (ue.alphaMode = se.getAlphaMode()), se.getAlphaMode() === Kn.AlphaMode.MASK && (ue.alphaCutoff = se.getAlphaCutoff()), se.getDoubleSided() && (ue.doubleSided = !0), ue.pbrMetallicRoughness = {}, Rn.eq(se.getBaseColorFactor(), [1, 1, 1, 1]) || (ue.pbrMetallicRoughness.baseColorFactor = se.getBaseColorFactor()), Rn.eq(se.getEmissiveFactor(), [0, 0, 0]) || (ue.emissiveFactor = se.getEmissiveFactor()), se.getRoughnessFactor() !== 1 && (ue.pbrMetallicRoughness.roughnessFactor = se.getRoughnessFactor()), se.getMetallicFactor() !== 1 && (ue.pbrMetallicRoughness.metallicFactor = se.getMetallicFactor()), se.getBaseColorTexture()) {
            const xe = se.getBaseColorTexture(), Ee = se.getBaseColorTextureInfo();
            ue.pbrMetallicRoughness.baseColorTexture = w.createTextureInfoDef(xe, Ee);
          }
          if (se.getEmissiveTexture()) {
            const xe = se.getEmissiveTexture(), Ee = se.getEmissiveTextureInfo();
            ue.emissiveTexture = w.createTextureInfoDef(xe, Ee);
          }
          if (se.getNormalTexture()) {
            const xe = se.getNormalTexture(), Ee = se.getNormalTextureInfo(), K = w.createTextureInfoDef(xe, Ee);
            se.getNormalScale() !== 1 && (K.scale = se.getNormalScale()), ue.normalTexture = K;
          }
          if (se.getOcclusionTexture()) {
            const xe = se.getOcclusionTexture(), Ee = se.getOcclusionTextureInfo(), K = w.createTextureInfoDef(xe, Ee);
            se.getOcclusionStrength() !== 1 && (K.strength = se.getOcclusionStrength()), ue.occlusionTexture = K;
          }
          if (se.getMetallicRoughnessTexture()) {
            const xe = se.getMetallicRoughnessTexture(), Ee = se.getMetallicRoughnessTextureInfo();
            ue.pbrMetallicRoughness.metallicRoughnessTexture = w.createTextureInfoDef(xe, Ee);
          }
          return w.materialIndexMap.set(se, _e), ue;
        }), c.meshes = a.listMeshes().map((se, _e) => {
          const ue = w.createPropertyDef(se);
          let xe = null;
          return ue.primitives = se.listPrimitives().map((Ee) => {
            const K = { attributes: {} };
            K.mode = Ee.getMode();
            const j = Ee.getMaterial();
            j && (K.material = w.materialIndexMap.get(j)), Object.keys(Ee.getExtras()).length && (K.extras = Ee.getExtras());
            const ht = Ee.getIndices();
            ht && (K.indices = w.accessorIndexMap.get(ht));
            for (const Ze of Ee.listSemantics())
              K.attributes[Ze] = w.accessorIndexMap.get(Ee.getAttribute(Ze));
            for (const Ze of Ee.listTargets()) {
              const pt = {};
              for (const Pt of Ze.listSemantics())
                pt[Pt] = w.accessorIndexMap.get(Ze.getAttribute(Pt));
              K.targets = K.targets || [], K.targets.push(pt);
            }
            return Ee.listTargets().length && !xe && (xe = Ee.listTargets().map((Ze) => Ze.getName())), K;
          }), se.getWeights().length && (ue.weights = se.getWeights()), xe && (ue.extras = ue.extras || {}, ue.extras.targetNames = xe), w.meshIndexMap.set(se, _e), ue;
        }), c.cameras = a.listCameras().map((se, _e) => {
          const ue = w.createPropertyDef(se);
          if (ue.type = se.getType(), ue.type === ha.Type.PERSPECTIVE) {
            ue.perspective = { znear: se.getZNear(), zfar: se.getZFar(), yfov: se.getYFov() };
            const xe = se.getAspectRatio();
            xe !== null && (ue.perspective.aspectRatio = xe);
          } else
            ue.orthographic = { znear: se.getZNear(), zfar: se.getZFar(), xmag: se.getXMag(), ymag: se.getYMag() };
          return w.cameraIndexMap.set(se, _e), ue;
        }), c.nodes = a.listNodes().map((se, _e) => {
          const ue = w.createPropertyDef(se);
          return Rn.eq(se.getTranslation(), [0, 0, 0]) || (ue.translation = se.getTranslation()), Rn.eq(se.getRotation(), [0, 0, 0, 1]) || (ue.rotation = se.getRotation()), Rn.eq(se.getScale(), [1, 1, 1]) || (ue.scale = se.getScale()), se.getWeights().length && (ue.weights = se.getWeights()), w.nodeIndexMap.set(se, _e), ue;
        }), c.skins = a.listSkins().map((se, _e) => {
          const ue = w.createPropertyDef(se), xe = se.getInverseBindMatrices();
          xe && (ue.inverseBindMatrices = w.accessorIndexMap.get(xe));
          const Ee = se.getSkeleton();
          return Ee && (ue.skeleton = w.nodeIndexMap.get(Ee)), ue.joints = se.listJoints().map((K) => w.nodeIndexMap.get(K)), w.skinIndexMap.set(se, _e), ue;
        }), a.listNodes().forEach((se, _e) => {
          const ue = c.nodes[_e], xe = se.getMesh();
          xe && (ue.mesh = w.meshIndexMap.get(xe));
          const Ee = se.getCamera();
          Ee && (ue.camera = w.cameraIndexMap.get(Ee));
          const K = se.getSkin();
          K && (ue.skin = w.skinIndexMap.get(K)), se.listChildren().length > 0 && (ue.children = se.listChildren().map((j) => w.nodeIndexMap.get(j)));
        }), c.animations = a.listAnimations().map((se) => {
          const _e = w.createPropertyDef(se), ue = /* @__PURE__ */ new Map();
          return _e.samplers = se.listSamplers().map((xe, Ee) => {
            const K = w.createPropertyDef(xe);
            return K.input = w.accessorIndexMap.get(xe.getInput()), K.output = w.accessorIndexMap.get(xe.getOutput()), K.interpolation = xe.getInterpolation(), ue.set(xe, Ee), K;
          }), _e.channels = se.listChannels().map((xe) => {
            const Ee = w.createPropertyDef(xe);
            return Ee.sampler = ue.get(xe.getSampler()), Ee.target = { node: w.nodeIndexMap.get(xe.getTargetNode()), path: xe.getTargetPath() }, Ee;
          }), _e;
        }), c.scenes = a.listScenes().map((se) => {
          const _e = w.createPropertyDef(se);
          return _e.nodes = se.listChildren().map((ue) => w.nodeIndexMap.get(ue)), _e;
        });
        const ye = a.getDefaultScene();
        return ye && (c.scene = a.listScenes().indexOf(ye)), c.extensionsUsed = Y.map((se) => se.extensionName), c.extensionsRequired = ee.map((se) => se.extensionName), Y.forEach((se) => se.write(w)), function(se) {
          const _e = [];
          for (const ue in se) {
            const xe = se[ue];
            (Array.isArray(xe) && xe.length === 0 || xe === null || xe === "" || xe && typeof xe == "object" && Object.keys(xe).length === 0) && _e.push(ue);
          }
          for (const ue of _e)
            delete se[ue];
        }(c), g;
      }
    }).write(e, { format: t.format || oa.GLTF, basename: t.basename || "", logger: this._t, vertexLayout: this.Ut, dependencies: Zs({}, this.Pt), extensions: Array.from(this.gt) });
  }
  Ft(e) {
    const { images: t, buffers: s } = e.json;
    return e = { json: Zs({}, e.json), resources: Zs({}, e.resources) }, t && (e.json.images = t.map((o) => Zs({}, o))), s && (e.json.buffers = s.map((o) => Zs({}, o))), e;
  }
  binaryToJSON(e) {
    const t = this.Gt(e);
    this.kt(t);
    const s = t.json;
    if (s.buffers && s.buffers.some((o) => function(a, c) {
      return c.uri !== void 0 && !(c.uri in a.resources);
    }(t, o)))
      throw new Error("Cannot resolve external buffers with binaryToJSON().");
    if (s.images && s.images.some((o) => function(a, c) {
      return c.uri !== void 0 && !(c.uri in a.resources) && c.bufferView === void 0;
    }(t, o)))
      throw new Error("Cannot resolve external images with binaryToJSON().");
    return t;
  }
  Gt(e) {
    const t = new Uint32Array(e, 0, 3);
    if (t[0] !== 1179937895)
      throw new Error("Invalid glTF asset.");
    if (t[1] !== 2)
      throw new Error(`Unsupported glTF binary version, "${t[1]}".`);
    const s = new Uint32Array(e, 12, 2);
    if (s[1] !== cl.JSON)
      throw new Error("Missing required GLB JSON chunk.");
    const o = s[0], a = ps.decodeText(e.slice(20, 20 + o)), c = JSON.parse(a), g = 20 + o;
    if (e.byteLength <= g)
      return { json: c, resources: {} };
    const w = new Uint32Array(e, g, 2);
    if (w[1] !== cl.BIN)
      throw new Error("Expected GLB BIN in second chunk.");
    return { json: c, resources: { "@glb.bin": e.slice(g + 8, g + 8 + w[0]) } };
  }
  readBinary(e) {
    return this.readJSON(this.binaryToJSON(e));
  }
  writeBinary(e) {
    const { json: t, resources: s } = this.writeJSON(e, { format: oa.GLB }), o = new Uint32Array([1179937895, 2, 12]), a = JSON.stringify(t), c = ps.pad(ps.encodeText(a), 32), g = new Uint32Array([c.byteLength, 1313821514]).buffer, w = ps.concat([g, c]);
    o[o.length - 1] += w.byteLength;
    const T = Object.values(s)[0];
    if (!T || !T.byteLength)
      return ps.concat([o.buffer, w]);
    const H = ps.pad(T, 0), Y = new Uint32Array([H.byteLength, 5130562]).buffer, ee = ps.concat([Y, H]);
    return o[o.length - 1] += ee.byteLength, ps.concat([o.buffer, w, ee]);
  }
}
const Cy = {};
let cf = class extends My {
  constructor(e = Cy) {
    super(), this.qt = void 0, this.qt = e;
  }
  read(e) {
    return this.readAsJSON(e).then((t) => this.readJSON(t));
  }
  readAsJSON(e) {
    return e.match(/^data:application\/octet-stream;/) || new URL(e, window.location.href).pathname.match(/\.glb$/) ? this.Jt(e) : this.zt(e);
  }
  Wt(e, t) {
    const s = [...e.json.images || [], ...e.json.buffers || []].map((o) => {
      const a = o.uri;
      return !a || a.match(/data:/) ? Promise.resolve() : fetch(function(c, g) {
        if (!function(H) {
          return !/^(?:[a-zA-Z]+:)?\//.test(H);
        }(g))
          return g;
        const w = c.split("/"), T = g.split("/");
        w.pop();
        for (let H = 0; H < T.length; H++)
          T[H] !== "." && (T[H] === ".." ? w.pop() : w.push(T[H]));
        return w.join("/");
      }(t, a), this.qt).then((c) => c.arrayBuffer()).then((c) => {
        e.resources[a] = c;
      });
    });
    return Promise.all(s).then(() => {
    });
  }
  zt(e) {
    var t = this;
    const s = { json: {}, resources: {} };
    return fetch(e, this.qt).then((o) => o.json()).then(async function(o) {
      return s.json = o, await t.Wt(s, ff(e)), t.kt(s), s;
    });
  }
  Jt(e) {
    var t = this;
    return fetch(e, this.qt).then((s) => s.arrayBuffer()).then(async function(s) {
      const o = t.Gt(s);
      return await t.Wt(o, ff(e)), t.kt(o), o;
    });
  }
};
function ff(v) {
  const e = v.lastIndexOf("/");
  return e === -1 ? "./" : v.substr(0, e + 1);
}
var Ay = Object.defineProperty, Ty = (v, e, t) => e in v ? Ay(v, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : v[e] = t, xh = (v, e, t) => (Ty(v, typeof e != "symbol" ? e + "" : e, t), t), Ly = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function By(v) {
  return v && v.__esModule && Object.prototype.hasOwnProperty.call(v, "default") ? v.default : v;
}
function Ey(v) {
  if (v.__esModule)
    return v;
  var e = v.default;
  if (typeof e == "function") {
    var t = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(v).forEach(function(s) {
    var o = Object.getOwnPropertyDescriptor(v, s);
    Object.defineProperty(t, s, o.get ? o : {
      enumerable: !0,
      get: function() {
        return v[s];
      }
    });
  }), t;
}
function Oy(v) {
  throw new Error('Could not dynamically require "' + v + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Kf = { exports: {} };
const Iy = {}, ky = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Iy
}, Symbol.toStringTag, { value: "Module" })), df = /* @__PURE__ */ Ey(ky);
/*!
 * Paper.js v0.12.17 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Thu Nov 3 21:15:36 2022 +0100
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
(function(v) {
  (function(e, t) {
    e = e || df;
    var s = e.window, o = e.document, a = new function() {
      var i = /^(statics|enumerable|beans|preserve)$/, n = [], r = n.slice, l = Object.create, h = Object.getOwnPropertyDescriptor, f = Object.defineProperty, m = n.forEach || function(C, M) {
        for (var R = 0, E = this.length; R < E; R++)
          C.call(M, this[R], R, this);
      }, _ = function(C, M) {
        for (var R in this)
          this.hasOwnProperty(R) && C.call(M, this[R], R, this);
      }, y = Object.assign || function(C) {
        for (var M = 1, R = arguments.length; M < R; M++) {
          var E = arguments[M];
          for (var D in E)
            E.hasOwnProperty(D) && (C[D] = E[D]);
        }
        return C;
      }, x = function(C, M, R) {
        if (C) {
          var E = h(C, "length");
          (E && typeof E.value == "number" ? m : _).call(C, M, R = R || C);
        }
        return R;
      };
      function A(C, M, R, E, D) {
        var L = {};
        function P(F, W) {
          W = W || (W = h(M, F)) && (W.get ? W : W.value), typeof W == "string" && W[0] === "#" && (W = C[W.substring(1)] || W);
          var Q = typeof W == "function", ie = W, ae = D || Q && !W.base ? W && W.get ? F in C : C[F] : null, J;
          (!D || !ae) && (Q && ae && (W.base = ae), Q && E !== !1 && (J = F.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (L[J[3].toLowerCase() + J[4]] = J[2]), (!ie || Q || !ie.get || typeof ie.get != "function" || !B.isPlainObject(ie)) && (ie = { value: ie, writable: !0 }), (h(C, F) || { configurable: !0 }).configurable && (ie.configurable = !0, ie.enumerable = R ?? !J), f(C, F, ie));
        }
        if (M) {
          for (var S in M)
            M.hasOwnProperty(S) && !i.test(S) && P(S);
          for (var S in L) {
            var I = L[S], U = C["set" + I], V = C["get" + I] || U && C["is" + I];
            V && (E === !0 || V.length === 0) && P(S, { get: V, set: U });
          }
        }
        return C;
      }
      function B() {
        for (var C = 0, M = arguments.length; C < M; C++) {
          var R = arguments[C];
          R && y(this, R);
        }
        return this;
      }
      return A(B, {
        inject: function(C) {
          if (C) {
            var M = C.statics === !0 ? C : C.statics, R = C.beans, E = C.preserve;
            M !== C && A(this.prototype, C, C.enumerable, R, E), A(this, M, null, R, E);
          }
          for (var D = 1, L = arguments.length; D < L; D++)
            this.inject(arguments[D]);
          return this;
        },
        extend: function() {
          for (var C = this, M, R, E = 0, D, L = arguments.length; E < L && !(M && R); E++)
            D = arguments[E], M = M || D.initialize, R = R || D.prototype;
          return M = M || function() {
            C.apply(this, arguments);
          }, R = M.prototype = R || l(this.prototype), f(
            R,
            "constructor",
            { value: M, writable: !0, configurable: !0 }
          ), A(M, this), arguments.length && this.inject.apply(M, arguments), M.base = C, M;
        }
      }).inject({
        enumerable: !1,
        initialize: B,
        set: B,
        inject: function() {
          for (var C = 0, M = arguments.length; C < M; C++) {
            var R = arguments[C];
            R && A(this, R, R.enumerable, R.beans, R.preserve);
          }
          return this;
        },
        extend: function() {
          var C = l(this);
          return C.inject.apply(C, arguments);
        },
        each: function(C, M) {
          return x(this, C, M);
        },
        clone: function() {
          return new this.constructor(this);
        },
        statics: {
          set: y,
          each: x,
          create: l,
          define: f,
          describe: h,
          clone: function(C) {
            return y(new C.constructor(), C);
          },
          isPlainObject: function(C) {
            var M = C != null && C.constructor;
            return M && (M === Object || M === B || M.name === "Object");
          },
          pick: function(C, M) {
            return C !== t ? C : M;
          },
          slice: function(C, M, R) {
            return r.call(C, M, R);
          }
        }
      });
    }();
    v.exports = a, a.inject({
      enumerable: !1,
      toString: function() {
        return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + a.each(this, function(i, n) {
          if (!/^_/.test(n)) {
            var r = typeof i;
            this.push(n + ": " + (r === "number" ? H.instance.number(i) : r === "string" ? "'" + i + "'" : i));
          }
        }, []).join(", ") + " }";
      },
      getClassName: function() {
        return this._class || "";
      },
      importJSON: function(i) {
        return a.importJSON(i, this);
      },
      exportJSON: function(i) {
        return a.exportJSON(this, i);
      },
      toJSON: function() {
        return a.serialize(this);
      },
      set: function(i, n) {
        return i && a.filter(this, i, n, this._prioritize), this;
      }
    }, {
      beans: !1,
      statics: {
        exports: {},
        extend: function i() {
          var n = i.base.apply(this, arguments), r = n.prototype._class;
          return r && !a.exports[r] && (a.exports[r] = n), n;
        },
        equals: function(i, n) {
          if (i === n)
            return !0;
          if (i && i.equals)
            return i.equals(n);
          if (n && n.equals)
            return n.equals(i);
          if (i && n && typeof i == "object" && typeof n == "object") {
            if (Array.isArray(i) && Array.isArray(n)) {
              var r = i.length;
              if (r !== n.length)
                return !1;
              for (; r--; )
                if (!a.equals(i[r], n[r]))
                  return !1;
            } else {
              var l = Object.keys(i), r = l.length;
              if (r !== Object.keys(n).length)
                return !1;
              for (; r--; ) {
                var h = l[r];
                if (!(n.hasOwnProperty(h) && a.equals(i[h], n[h])))
                  return !1;
              }
            }
            return !0;
          }
          return !1;
        },
        read: function(i, n, r, l) {
          if (this === a) {
            var h = this.peek(i, n);
            return i.__index++, h;
          }
          var f = this.prototype, m = f._readIndex, _ = n || m && i.__index || 0, y = i.length, x = i[_];
          if (l = l || y - _, x instanceof this || r && r.readNull && x == null && l <= 1)
            return m && (i.__index = _ + 1), x && r && r.clone ? x.clone() : x;
          if (x = a.create(f), m && (x.__read = !0), x = x.initialize.apply(x, _ > 0 || _ + l < y ? a.slice(i, _, _ + l) : i) || x, m) {
            i.__index = _ + x.__read;
            var A = x.__filtered;
            A && (i.__filtered = A, x.__filtered = t), x.__read = t;
          }
          return x;
        },
        peek: function(i, n) {
          return i[i.__index = n || i.__index || 0];
        },
        remain: function(i) {
          return i.length - (i.__index || 0);
        },
        readList: function(i, n, r, l) {
          for (var h = [], f, m = n || 0, _ = l ? m + l : i.length, y = m; y < _; y++)
            h.push(Array.isArray(f = i[y]) ? this.read(f, 0, r) : this.read(i, y, r, 1));
          return h;
        },
        readNamed: function(i, n, r, l, h) {
          var f = this.getNamed(i, n), m = f !== t;
          if (m) {
            var _ = i.__filtered;
            if (!_) {
              var y = this.getSource(i);
              _ = i.__filtered = a.create(y), _.__unfiltered = y;
            }
            _[n] = t;
          }
          return this.read(m ? [f] : i, r, l, h);
        },
        readSupported: function(i, n) {
          var r = this.getSource(i), l = this, h = !1;
          return r && Object.keys(r).forEach(function(f) {
            if (f in n) {
              var m = l.readNamed(i, f);
              m !== t && (n[f] = m), h = !0;
            }
          }), h;
        },
        getSource: function(i) {
          var n = i.__source;
          if (n === t) {
            var r = i.length === 1 && i[0];
            n = i.__source = r && a.isPlainObject(r) ? r : null;
          }
          return n;
        },
        getNamed: function(i, n) {
          var r = this.getSource(i);
          if (r)
            return n ? r[n] : i.__filtered || r;
        },
        hasNamed: function(i, n) {
          return !!this.getNamed(i, n);
        },
        filter: function(i, n, r, l) {
          var h;
          function f(A) {
            if (!(r && A in r) && !(h && A in h)) {
              var B = n[A];
              B !== t && (i[A] = B);
            }
          }
          if (l) {
            for (var m = {}, _ = 0, y, x = l.length; _ < x; _++)
              (y = l[_]) in n && (f(y), m[y] = !0);
            h = m;
          }
          return Object.keys(n.__unfiltered || n).forEach(f), i;
        },
        isPlainValue: function(i, n) {
          return a.isPlainObject(i) || Array.isArray(i) || n && typeof i == "string";
        },
        serialize: function(i, n, r, l) {
          n = n || {};
          var h = !l, f;
          if (h && (n.formatter = new H(n.precision), l = {
            length: 0,
            definitions: {},
            references: {},
            add: function(B, C) {
              var M = "#" + B._id, R = this.references[M];
              if (!R) {
                this.length++;
                var E = C.call(B), D = B._class;
                D && E[0] !== D && E.unshift(D), this.definitions[M] = E, R = this.references[M] = [M];
              }
              return R;
            }
          }), i && i._serialize) {
            f = i._serialize(n, l);
            var m = i._class;
            m && !i._compactSerialize && (h || !r) && f[0] !== m && f.unshift(m);
          } else if (Array.isArray(i)) {
            f = [];
            for (var _ = 0, y = i.length; _ < y; _++)
              f[_] = a.serialize(i[_], n, r, l);
          } else if (a.isPlainObject(i)) {
            f = {};
            for (var x = Object.keys(i), _ = 0, y = x.length; _ < y; _++) {
              var A = x[_];
              f[A] = a.serialize(
                i[A],
                n,
                r,
                l
              );
            }
          } else
            typeof i == "number" ? f = n.formatter.number(i, n.precision) : f = i;
          return h && l.length > 0 ? [["dictionary", l.definitions], f] : f;
        },
        deserialize: function(i, n, r, l, h) {
          var f = i, m = !r, _ = m && i && i.length && i[0][0] === "dictionary";
          if (r = r || {}, Array.isArray(i)) {
            var y = i[0], x = y === "dictionary";
            if (i.length == 1 && /^#/.test(y))
              return r.dictionary[y];
            y = a.exports[y], f = [];
            for (var A = y ? 1 : 0, B = i.length; A < B; A++)
              f.push(a.deserialize(
                i[A],
                n,
                r,
                x,
                _
              ));
            if (y) {
              var C = f;
              n ? f = n(y, C, m || h) : f = new y(C);
            }
          } else if (a.isPlainObject(i)) {
            f = {}, l && (r.dictionary = f);
            for (var M in i)
              f[M] = a.deserialize(i[M], n, r);
          }
          return _ ? f[1] : f;
        },
        exportJSON: function(i, n) {
          var r = a.serialize(i, n);
          return n && n.asString == !1 ? r : JSON.stringify(r);
        },
        importJSON: function(i, n) {
          return a.deserialize(
            typeof i == "string" ? JSON.parse(i) : i,
            function(r, l, h) {
              var f = h && n && n.constructor === r, m = f ? n : a.create(r.prototype);
              if (l.length === 1 && m instanceof K && (f || !(m instanceof ht))) {
                var _ = l[0];
                a.isPlainObject(_) && (_.insert = !1, f && (l = l.concat([K.INSERT])));
              }
              return (f ? m.set : r).apply(m, l), f && (n = null), m;
            }
          );
        },
        push: function(i, n) {
          var r = n.length;
          if (r < 4096)
            i.push.apply(i, n);
          else {
            var l = i.length;
            i.length += r;
            for (var h = 0; h < r; h++)
              i[l + h] = n[h];
          }
          return i;
        },
        splice: function(i, n, r, l) {
          var h = n && n.length, f = r === t;
          r = f ? i.length : r, r > i.length && (r = i.length);
          for (var m = 0; m < h; m++)
            n[m]._index = r + m;
          if (f)
            return a.push(i, n), [];
          var _ = [r, l];
          n && a.push(_, n);
          for (var y = i.splice.apply(i, _), m = 0, x = y.length; m < x; m++)
            y[m]._index = t;
          for (var m = r + h, x = i.length; m < x; m++)
            i[m]._index = m;
          return y;
        },
        capitalize: function(i) {
          return i.replace(/\b[a-z]/g, function(n) {
            return n.toUpperCase();
          });
        },
        camelize: function(i) {
          return i.replace(/-(.)/g, function(n, r) {
            return r.toUpperCase();
          });
        },
        hyphenate: function(i) {
          return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }
      }
    });
    var c = {
      on: function(i, n) {
        if (typeof i != "string")
          a.each(i, function(f, m) {
            this.on(m, f);
          }, this);
        else {
          var r = this._eventTypes, l = r && r[i], h = this._callbacks = this._callbacks || {};
          h = h[i] = h[i] || [], h.indexOf(n) === -1 && (h.push(n), l && l.install && h.length === 1 && l.install.call(this, i));
        }
        return this;
      },
      off: function(i, n) {
        if (typeof i != "string") {
          a.each(i, function(m, _) {
            this.off(_, m);
          }, this);
          return;
        }
        var r = this._eventTypes, l = r && r[i], h = this._callbacks && this._callbacks[i], f;
        return h && (!n || (f = h.indexOf(n)) !== -1 && h.length === 1 ? (l && l.uninstall && l.uninstall.call(this, i), delete this._callbacks[i]) : f !== -1 && h.splice(f, 1)), this;
      },
      once: function(i, n) {
        return this.on(i, function r() {
          n.apply(this, arguments), this.off(i, r);
        });
      },
      emit: function(i, n) {
        var r = this._callbacks && this._callbacks[i];
        if (!r)
          return !1;
        var l = a.slice(arguments, 1), h = n && n.target && !n.currentTarget;
        r = r.slice(), h && (n.currentTarget = this);
        for (var f = 0, m = r.length; f < m; f++)
          if (r[f].apply(this, l) == !1) {
            n && n.stop && n.stop();
            break;
          }
        return h && delete n.currentTarget, !0;
      },
      responds: function(i) {
        return !!(this._callbacks && this._callbacks[i]);
      },
      attach: "#on",
      detach: "#off",
      fire: "#emit",
      _installEvents: function(i) {
        var n = this._eventTypes, r = this._callbacks, l = i ? "install" : "uninstall";
        if (n) {
          for (var h in r)
            if (r[h].length > 0) {
              var f = n[h], m = f && f[l];
              m && m.call(this, h);
            }
        }
      },
      statics: {
        inject: function i(n) {
          var r = n._events;
          if (r) {
            var l = {};
            a.each(r, function(h, f) {
              var m = typeof h == "string", _ = m ? h : f, y = a.capitalize(_), x = _.substring(2).toLowerCase();
              l[x] = m ? {} : h, _ = "_" + _, n["get" + y] = function() {
                return this[_];
              }, n["set" + y] = function(A) {
                var B = this[_];
                B && this.off(x, B), A && this.on(x, A), this[_] = A;
              };
            }), n._eventTypes = l;
          }
          return i.base.apply(this, arguments);
        }
      }
    }, g = a.extend({
      _class: "PaperScope",
      initialize: function i() {
        nt = this, this.settings = new a({
          applyMatrix: !0,
          insertItems: !0,
          handleSize: 4,
          hitTolerance: 0
        }), this.project = null, this.projects = [], this.tools = [], this._id = i._id++, i._scopes[this._id] = this;
        var n = i.prototype;
        if (!this.support) {
          var r = Ut.getContext(1, 1) || {};
          n.support = {
            nativeDash: "setLineDash" in r || "mozDash" in r,
            nativeBlendModes: ki.nativeModes
          }, Ut.release(r);
        }
        if (!this.agent) {
          var l = e.navigator.userAgent.toLowerCase(), h = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(l) || [])[0], f = h === "darwin" ? "mac" : h, m = n.agent = n.browser = { platform: f };
          f && (m[f] = !0), l.replace(
            /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
            function(_, y, x, A, B) {
              if (!m.chrome) {
                var C = y === "opera" ? A : /^(node|trident)$/.test(y) ? B : x;
                m.version = C, m.versionNumber = parseFloat(C), y = { trident: "msie", jsdom: "node" }[y] || y, m.name = y, m[y] = !0;
              }
            }
          ), m.chrome && delete m.webkit, m.atom && delete m.chrome;
        }
      },
      version: "0.12.17",
      getView: function() {
        var i = this.project;
        return i && i._view;
      },
      getPaper: function() {
        return this;
      },
      execute: function(i, n) {
        var r = nt.PaperScript.execute(i, this, n);
        return Ht.updateFocus(), r;
      },
      install: function(i) {
        var n = this;
        a.each(["project", "view", "tool"], function(l) {
          a.define(i, l, {
            configurable: !0,
            get: function() {
              return n[l];
            }
          });
        });
        for (var r in this)
          !/^_/.test(r) && this[r] && (i[r] = this[r]);
      },
      setup: function(i) {
        return nt = this, this.project = new Ee(i), this;
      },
      createCanvas: function(i, n) {
        return Ut.getCanvas(i, n);
      },
      activate: function() {
        nt = this;
      },
      clear: function() {
        for (var i = this.projects, n = this.tools, r = i.length - 1; r >= 0; r--)
          i[r].remove();
        for (var r = n.length - 1; r >= 0; r--)
          n[r].remove();
      },
      remove: function() {
        this.clear(), delete g._scopes[this._id];
      },
      statics: new function() {
        function i(n) {
          return n += "Attribute", function(r, l) {
            return r[n](l) || r[n]("data-paper-" + l);
          };
        }
        return {
          _scopes: {},
          _id: 0,
          get: function(n) {
            return this._scopes[n] || null;
          },
          getAttribute: i("get"),
          hasAttribute: i("has")
        };
      }()
    }), w = a.extend(c, {
      initialize: function(i) {
        this._scope = nt, this._index = this._scope[this._list].push(this) - 1, (i || !this._scope[this._reference]) && this.activate();
      },
      activate: function() {
        if (!this._scope)
          return !1;
        var i = this._scope[this._reference];
        return i && i !== this && i.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", i), !0;
      },
      isActive: function() {
        return this._scope[this._reference] === this;
      },
      remove: function() {
        return this._index == null ? !1 : (a.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
      },
      getView: function() {
        return this._scope.getView();
      }
    }), T = {
      findItemBoundsCollisions: function(i, n, r) {
        function l(m) {
          for (var _ = new Array(m.length), y = 0; y < m.length; y++) {
            var x = m[y].getBounds();
            _[y] = [x.left, x.top, x.right, x.bottom];
          }
          return _;
        }
        var h = l(i), f = !n || n === i ? h : l(n);
        return this.findBoundsCollisions(h, f, r || 0);
      },
      findCurveBoundsCollisions: function(i, n, r, l) {
        function h(C) {
          for (var M = Math.min, R = Math.max, E = new Array(C.length), D = 0; D < C.length; D++) {
            var L = C[D];
            E[D] = [
              M(L[0], L[2], L[4], L[6]),
              M(L[1], L[3], L[5], L[7]),
              R(L[0], L[2], L[4], L[6]),
              R(L[1], L[3], L[5], L[7])
            ];
          }
          return E;
        }
        var f = h(i), m = !n || n === i ? f : h(n);
        if (l) {
          for (var _ = this.findBoundsCollisions(
            f,
            m,
            r || 0,
            !1,
            !0
          ), y = this.findBoundsCollisions(
            f,
            m,
            r || 0,
            !0,
            !0
          ), x = [], A = 0, B = _.length; A < B; A++)
            x[A] = { hor: _[A], ver: y[A] };
          return x;
        }
        return this.findBoundsCollisions(f, m, r || 0);
      },
      findBoundsCollisions: function(i, n, r, l, h) {
        var f = !n || i === n, m = f ? i : i.concat(n), _ = i.length, y = m.length;
        function x(He, Ye, Je) {
          for (var Be = 0, Ie = He.length; Be < Ie; ) {
            var Ge = Ie + Be >>> 1;
            m[He[Ge]][Ye] < Je ? Be = Ge + 1 : Ie = Ge;
          }
          return Be - 1;
        }
        for (var A = l ? 1 : 0, B = A + 2, C = l ? 0 : 1, M = C + 2, R = new Array(y), E = 0; E < y; E++)
          R[E] = E;
        R.sort(function(He, Ye) {
          return m[He][A] - m[Ye][A];
        });
        for (var D = [], L = new Array(_), E = 0; E < y; E++) {
          var P = R[E], S = m[P], I = f ? P : P - _, U = P < _, V = f || !U, F = U ? [] : null;
          if (D.length) {
            var W = x(
              D,
              B,
              S[A] - r
            ) + 1;
            if (D.splice(0, W), f && h) {
              F = F.concat(D);
              for (var Q = 0; Q < D.length; Q++) {
                var ie = D[Q];
                L[ie].push(I);
              }
            } else
              for (var ae = S[M], J = S[C], Q = 0; Q < D.length; Q++) {
                var ie = D[Q], le = m[ie], fe = ie < _, me = f || ie >= _;
                (h || (U && me || V && fe) && ae >= le[C] - r && J <= le[M] + r) && (U && me && F.push(
                  f ? ie : ie - _
                ), V && fe && L[ie].push(I));
              }
          }
          if (U && (i === n && F.push(P), L[P] = F), D.length) {
            var ve = S[B], Se = x(D, B, ve);
            D.splice(Se + 1, 0, P);
          } else
            D.push(P);
        }
        for (var E = 0; E < L.length; E++) {
          var Re = L[E];
          Re && Re.sort(function(Ye, Je) {
            return Ye - Je;
          });
        }
        return L;
      }
    }, H = a.extend({
      initialize: function(i) {
        this.precision = a.pick(i, 5), this.multiplier = Math.pow(10, this.precision);
      },
      number: function(i) {
        return this.precision < 16 ? Math.round(i * this.multiplier) / this.multiplier : i;
      },
      pair: function(i, n, r) {
        return this.number(i) + (r || ",") + this.number(n);
      },
      point: function(i, n) {
        return this.number(i.x) + (n || ",") + this.number(i.y);
      },
      size: function(i, n) {
        return this.number(i.width) + (n || ",") + this.number(i.height);
      },
      rectangle: function(i, n) {
        return this.point(i, n) + (n || ",") + this.size(i, n);
      }
    });
    H.instance = new H();
    var Y = new function() {
      var i = [
        [0.5773502691896257],
        [0, 0.7745966692414834],
        [0.33998104358485626, 0.8611363115940526],
        [0, 0.5384693101056831, 0.906179845938664],
        [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
        [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
        [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
        [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
        [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
        [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
        [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
        [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
        [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
        [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
        [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
      ], n = [
        [1],
        [0.8888888888888888, 0.5555555555555556],
        [0.6521451548625461, 0.34785484513745385],
        [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
        [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
        [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
        [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
        [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
        [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
        [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
        [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
        [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
        [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
        [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
        [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
      ], r = Math.abs, l = Math.sqrt, h = Math.pow, f = Math.log2 || function(B) {
        return Math.log(B) * Math.LOG2E;
      }, m = 1e-12, _ = 112e-18;
      function y(B, C, M) {
        return B < C ? C : B > M ? M : B;
      }
      function x(B, C, M) {
        function R(W) {
          var Q = W * 134217729, ie = W - Q, ae = ie + Q, J = W - ae;
          return [ae, J];
        }
        var E = C * C - B * M, D = C * C + B * M;
        if (r(E) * 3 < D) {
          var L = R(B), P = R(C), S = R(M), I = C * C, U = P[0] * P[0] - I + 2 * P[0] * P[1] + P[1] * P[1], V = B * M, F = L[0] * S[0] - V + L[0] * S[1] + L[1] * S[0] + L[1] * S[1];
          E = I - V + (U - F);
        }
        return E;
      }
      function A() {
        var B = Math.max.apply(Math, arguments);
        return B && (B < 1e-8 || B > 1e8) ? h(2, -Math.round(f(B))) : 0;
      }
      return {
        EPSILON: m,
        MACHINE_EPSILON: _,
        CURVETIME_EPSILON: 1e-8,
        GEOMETRIC_EPSILON: 1e-7,
        TRIGONOMETRIC_EPSILON: 1e-8,
        ANGULAR_EPSILON: 1e-5,
        KAPPA: 4 * (l(2) - 1) / 3,
        isZero: function(B) {
          return B >= -m && B <= m;
        },
        isMachineZero: function(B) {
          return B >= -_ && B <= _;
        },
        clamp: y,
        integrate: function(B, C, M, R) {
          for (var E = i[R - 2], D = n[R - 2], L = (M - C) * 0.5, P = L + C, S = 0, I = R + 1 >> 1, U = R & 1 ? D[S++] * B(P) : 0; S < I; ) {
            var V = L * E[S];
            U += D[S++] * (B(P + V) + B(P - V));
          }
          return L * U;
        },
        findRoot: function(B, C, M, R, E, D, L) {
          for (var P = 0; P < D; P++) {
            var S = B(M), I = S / C(M), U = M - I;
            if (r(I) < L) {
              M = U;
              break;
            }
            S > 0 ? (E = M, M = U <= R ? (R + E) * 0.5 : U) : (R = M, M = U >= E ? (R + E) * 0.5 : U);
          }
          return y(M, R, E);
        },
        solveQuadratic: function(B, C, M, R, E, D) {
          var L, P = 1 / 0;
          if (r(B) < m) {
            if (r(C) < m)
              return r(M) < m ? -1 : 0;
            L = -M / C;
          } else {
            C *= -0.5;
            var S = x(B, C, M);
            if (S && r(S) < _) {
              var I = A(r(B), r(C), r(M));
              I && (B *= I, C *= I, M *= I, S = x(B, C, M));
            }
            if (S >= -_) {
              var U = S < 0 ? 0 : l(S), V = C + (C < 0 ? -U : U);
              V === 0 ? (L = M / B, P = -L) : (L = V / B, P = M / V);
            }
          }
          var F = 0, W = E == null, Q = E - m, ie = D + m;
          return isFinite(L) && (W || L > Q && L < ie) && (R[F++] = W ? L : y(L, E, D)), P !== L && isFinite(P) && (W || P > Q && P < ie) && (R[F++] = W ? P : y(P, E, D)), F;
        },
        solveCubic: function(B, C, M, R, E, D, L) {
          var P = A(r(B), r(C), r(M), r(R)), S, I, U, V, F;
          P && (B *= P, C *= P, M *= P, R *= P);
          function W(Se) {
            S = Se;
            var Re = B * S;
            I = Re + C, U = I * S + M, V = (Re + I) * S + U, F = U * S + R;
          }
          if (r(B) < m)
            B = C, I = M, U = R, S = 1 / 0;
          else if (r(R) < m)
            I = C, U = M, S = 0;
          else {
            W(-(C / B) / 3);
            var Q = F / B, ie = h(r(Q), 1 / 3), ae = Q < 0 ? -1 : 1, J = -V / B, le = J > 0 ? 1.324717957244746 * Math.max(ie, l(J)) : ie, fe = S - ae * le;
            if (fe !== S) {
              do
                W(fe), fe = V === 0 ? S : S - F / V / (1 + _);
              while (ae * fe > ae * S);
              r(B) * S * S > r(R / S) && (U = -R / S, I = (U - M) / S);
            }
          }
          var me = Y.solveQuadratic(B, I, U, E, D, L), ve = D == null;
          return isFinite(S) && (me === 0 || me > 0 && S !== E[0] && S !== E[1]) && (ve || S > D - m && S < L + m) && (E[me++] = ve ? S : y(S, D, L)), me;
        }
      };
    }(), ee = {
      _id: 1,
      _pools: {},
      get: function(i) {
        if (i) {
          var n = this._pools[i];
          return n || (n = this._pools[i] = { _id: 1 }), n._id++;
        } else
          return this._id++;
      }
    }, z = a.extend({
      _class: "Point",
      _readIndex: !0,
      initialize: function(i, n) {
        var r = typeof i, l = this.__read, h = 0;
        if (r === "number") {
          var f = typeof n == "number";
          this._set(i, f ? n : i), l && (h = f ? 2 : 1);
        } else if (r === "undefined" || i === null)
          this._set(0, 0), l && (h = i === null ? 1 : 0);
        else {
          var m = r === "string" ? i.split(/[\s,]+/) || [] : i;
          h = 1, Array.isArray(m) ? this._set(+m[0], +(m.length > 1 ? m[1] : m[0])) : "x" in m ? this._set(m.x || 0, m.y || 0) : "width" in m ? this._set(m.width || 0, m.height || 0) : "angle" in m ? (this._set(m.length || 0, 0), this.setAngle(m.angle || 0)) : (this._set(0, 0), h = 0);
        }
        return l && (this.__read = h), this;
      },
      set: "#initialize",
      _set: function(i, n) {
        return this.x = i, this.y = n, this;
      },
      equals: function(i) {
        return this === i || i && (this.x === i.x && this.y === i.y || Array.isArray(i) && this.x === i[0] && this.y === i[1]) || !1;
      },
      clone: function() {
        return new z(this.x, this.y);
      },
      toString: function() {
        var i = H.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [n.number(this.x), n.number(this.y)];
      },
      getLength: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      setLength: function(i) {
        if (this.isZero()) {
          var n = this._angle || 0;
          this._set(
            Math.cos(n) * i,
            Math.sin(n) * i
          );
        } else {
          var r = i / this.getLength();
          Y.isZero(r) && this.getAngle(), this._set(
            this.x * r,
            this.y * r
          );
        }
      },
      getAngle: function() {
        return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
      },
      setAngle: function(i) {
        this.setAngleInRadians.call(this, i * Math.PI / 180);
      },
      getAngleInDegrees: "#getAngle",
      setAngleInDegrees: "#setAngle",
      getAngleInRadians: function() {
        if (arguments.length) {
          var i = z.read(arguments), n = this.getLength() * i.getLength();
          if (Y.isZero(n))
            return NaN;
          var r = this.dot(i) / n;
          return Math.acos(r < -1 ? -1 : r > 1 ? 1 : r);
        } else
          return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
      },
      setAngleInRadians: function(i) {
        if (this._angle = i, !this.isZero()) {
          var n = this.getLength();
          this._set(
            Math.cos(i) * n,
            Math.sin(i) * n
          );
        }
      },
      getQuadrant: function() {
        return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
      }
    }, {
      beans: !1,
      getDirectedAngle: function() {
        var i = z.read(arguments);
        return Math.atan2(this.cross(i), this.dot(i)) * 180 / Math.PI;
      },
      getDistance: function() {
        var i = arguments, n = z.read(i), r = n.x - this.x, l = n.y - this.y, h = r * r + l * l, f = a.read(i);
        return f ? h : Math.sqrt(h);
      },
      normalize: function(i) {
        i === t && (i = 1);
        var n = this.getLength(), r = n !== 0 ? i / n : 0, l = new z(this.x * r, this.y * r);
        return r >= 0 && (l._angle = this._angle), l;
      },
      rotate: function(i, n) {
        if (i === 0)
          return this.clone();
        i = i * Math.PI / 180;
        var r = n ? this.subtract(n) : this, l = Math.sin(i), h = Math.cos(i);
        return r = new z(
          r.x * h - r.y * l,
          r.x * l + r.y * h
        ), n ? r.add(n) : r;
      },
      transform: function(i) {
        return i ? i._transformPoint(this) : this;
      },
      add: function() {
        var i = z.read(arguments);
        return new z(this.x + i.x, this.y + i.y);
      },
      subtract: function() {
        var i = z.read(arguments);
        return new z(this.x - i.x, this.y - i.y);
      },
      multiply: function() {
        var i = z.read(arguments);
        return new z(this.x * i.x, this.y * i.y);
      },
      divide: function() {
        var i = z.read(arguments);
        return new z(this.x / i.x, this.y / i.y);
      },
      modulo: function() {
        var i = z.read(arguments);
        return new z(this.x % i.x, this.y % i.y);
      },
      negate: function() {
        return new z(-this.x, -this.y);
      },
      isInside: function() {
        return se.read(arguments).contains(this);
      },
      isClose: function() {
        var i = arguments, n = z.read(i), r = a.read(i);
        return this.getDistance(n) <= r;
      },
      isCollinear: function() {
        var i = z.read(arguments);
        return z.isCollinear(this.x, this.y, i.x, i.y);
      },
      isColinear: "#isCollinear",
      isOrthogonal: function() {
        var i = z.read(arguments);
        return z.isOrthogonal(this.x, this.y, i.x, i.y);
      },
      isZero: function() {
        var i = Y.isZero;
        return i(this.x) && i(this.y);
      },
      isNaN: function() {
        return isNaN(this.x) || isNaN(this.y);
      },
      isInQuadrant: function(i) {
        return this.x * (i > 1 && i < 4 ? -1 : 1) >= 0 && this.y * (i > 2 ? -1 : 1) >= 0;
      },
      dot: function() {
        var i = z.read(arguments);
        return this.x * i.x + this.y * i.y;
      },
      cross: function() {
        var i = z.read(arguments);
        return this.x * i.y - this.y * i.x;
      },
      project: function() {
        var i = z.read(arguments), n = i.isZero() ? 0 : this.dot(i) / i.dot(i);
        return new z(
          i.x * n,
          i.y * n
        );
      },
      statics: {
        min: function() {
          var i = arguments, n = z.read(i), r = z.read(i);
          return new z(
            Math.min(n.x, r.x),
            Math.min(n.y, r.y)
          );
        },
        max: function() {
          var i = arguments, n = z.read(i), r = z.read(i);
          return new z(
            Math.max(n.x, r.x),
            Math.max(n.y, r.y)
          );
        },
        random: function() {
          return new z(Math.random(), Math.random());
        },
        isCollinear: function(i, n, r, l) {
          return Math.abs(i * l - n * r) <= Math.sqrt((i * i + n * n) * (r * r + l * l)) * 1e-8;
        },
        isOrthogonal: function(i, n, r, l) {
          return Math.abs(i * r + n * l) <= Math.sqrt((i * i + n * n) * (r * r + l * l)) * 1e-8;
        }
      }
    }, a.each(["round", "ceil", "floor", "abs"], function(i) {
      var n = Math[i];
      this[i] = function() {
        return new z(n(this.x), n(this.y));
      };
    }, {})), he = z.extend({
      initialize: function(i, n, r, l) {
        this._x = i, this._y = n, this._owner = r, this._setter = l;
      },
      _set: function(i, n, r) {
        return this._x = i, this._y = n, r || this._owner[this._setter](this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner[this._setter](this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner[this._setter](this);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        return this._setter === "setPosition" ? 4 : 0;
      }
    }), ne = a.extend({
      _class: "Size",
      _readIndex: !0,
      initialize: function(i, n) {
        var r = typeof i, l = this.__read, h = 0;
        if (r === "number") {
          var f = typeof n == "number";
          this._set(i, f ? n : i), l && (h = f ? 2 : 1);
        } else if (r === "undefined" || i === null)
          this._set(0, 0), l && (h = i === null ? 1 : 0);
        else {
          var m = r === "string" ? i.split(/[\s,]+/) || [] : i;
          h = 1, Array.isArray(m) ? this._set(+m[0], +(m.length > 1 ? m[1] : m[0])) : "width" in m ? this._set(m.width || 0, m.height || 0) : "x" in m ? this._set(m.x || 0, m.y || 0) : (this._set(0, 0), h = 0);
        }
        return l && (this.__read = h), this;
      },
      set: "#initialize",
      _set: function(i, n) {
        return this.width = i, this.height = n, this;
      },
      equals: function(i) {
        return i === this || i && (this.width === i.width && this.height === i.height || Array.isArray(i) && this.width === i[0] && this.height === i[1]) || !1;
      },
      clone: function() {
        return new ne(this.width, this.height);
      },
      toString: function() {
        var i = H.instance;
        return "{ width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [
          n.number(this.width),
          n.number(this.height)
        ];
      },
      add: function() {
        var i = ne.read(arguments);
        return new ne(this.width + i.width, this.height + i.height);
      },
      subtract: function() {
        var i = ne.read(arguments);
        return new ne(this.width - i.width, this.height - i.height);
      },
      multiply: function() {
        var i = ne.read(arguments);
        return new ne(this.width * i.width, this.height * i.height);
      },
      divide: function() {
        var i = ne.read(arguments);
        return new ne(this.width / i.width, this.height / i.height);
      },
      modulo: function() {
        var i = ne.read(arguments);
        return new ne(this.width % i.width, this.height % i.height);
      },
      negate: function() {
        return new ne(-this.width, -this.height);
      },
      isZero: function() {
        var i = Y.isZero;
        return i(this.width) && i(this.height);
      },
      isNaN: function() {
        return isNaN(this.width) || isNaN(this.height);
      },
      statics: {
        min: function(i, n) {
          return new ne(
            Math.min(i.width, n.width),
            Math.min(i.height, n.height)
          );
        },
        max: function(i, n) {
          return new ne(
            Math.max(i.width, n.width),
            Math.max(i.height, n.height)
          );
        },
        random: function() {
          return new ne(Math.random(), Math.random());
        }
      }
    }, a.each(["round", "ceil", "floor", "abs"], function(i) {
      var n = Math[i];
      this[i] = function() {
        return new ne(n(this.width), n(this.height));
      };
    }, {})), ye = ne.extend({
      initialize: function(i, n, r, l) {
        this._width = i, this._height = n, this._owner = r, this._setter = l;
      },
      _set: function(i, n, r) {
        return this._width = i, this._height = n, r || this._owner[this._setter](this), this;
      },
      getWidth: function() {
        return this._width;
      },
      setWidth: function(i) {
        this._width = i, this._owner[this._setter](this);
      },
      getHeight: function() {
        return this._height;
      },
      setHeight: function(i) {
        this._height = i, this._owner[this._setter](this);
      }
    }), se = a.extend({
      _class: "Rectangle",
      _readIndex: !0,
      beans: !0,
      initialize: function(i, n, r, l) {
        var h = arguments, f = typeof i, m;
        if (f === "number" ? (this._set(i, n, r, l), m = 4) : f === "undefined" || i === null ? (this._set(0, 0, 0, 0), m = i === null ? 1 : 0) : h.length === 1 && (Array.isArray(i) ? (this._set.apply(this, i), m = 1) : i.x !== t || i.width !== t ? (this._set(
          i.x || 0,
          i.y || 0,
          i.width || 0,
          i.height || 0
        ), m = 1) : i.from === t && i.to === t && (this._set(0, 0, 0, 0), a.readSupported(h, this) && (m = 1))), m === t) {
          var _ = z.readNamed(h, "from"), y = a.peek(h), x = _.x, A = _.y, B, C;
          if (y && y.x !== t || a.hasNamed(h, "to")) {
            var M = z.readNamed(h, "to");
            B = M.x - x, C = M.y - A, B < 0 && (x = M.x, B = -B), C < 0 && (A = M.y, C = -C);
          } else {
            var R = ne.read(h);
            B = R.width, C = R.height;
          }
          this._set(x, A, B, C), m = h.__index;
        }
        var E = h.__filtered;
        return E && (this.__filtered = E), this.__read && (this.__read = m), this;
      },
      set: "#initialize",
      _set: function(i, n, r, l) {
        return this.x = i, this.y = n, this.width = r, this.height = l, this;
      },
      clone: function() {
        return new se(this.x, this.y, this.width, this.height);
      },
      equals: function(i) {
        var n = a.isPlainValue(i) ? se.read(arguments) : i;
        return n === this || n && this.x === n.x && this.y === n.y && this.width === n.width && this.height === n.height || !1;
      },
      toString: function() {
        var i = H.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + ", width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [
          n.number(this.x),
          n.number(this.y),
          n.number(this.width),
          n.number(this.height)
        ];
      },
      getPoint: function(i) {
        var n = i ? z : he;
        return new n(this.x, this.y, this, "setPoint");
      },
      setPoint: function() {
        var i = z.read(arguments);
        this.x = i.x, this.y = i.y;
      },
      getSize: function(i) {
        var n = i ? ne : ye;
        return new n(this.width, this.height, this, "setSize");
      },
      _fw: 1,
      _fh: 1,
      setSize: function() {
        var i = ne.read(arguments), n = this._sx, r = this._sy, l = i.width, h = i.height;
        n && (this.x += (this.width - l) * n), r && (this.y += (this.height - h) * r), this.width = l, this.height = h, this._fw = this._fh = 1;
      },
      getLeft: function() {
        return this.x;
      },
      setLeft: function(i) {
        if (!this._fw) {
          var n = i - this.x;
          this.width -= this._sx === 0.5 ? n * 2 : n;
        }
        this.x = i, this._sx = this._fw = 0;
      },
      getTop: function() {
        return this.y;
      },
      setTop: function(i) {
        if (!this._fh) {
          var n = i - this.y;
          this.height -= this._sy === 0.5 ? n * 2 : n;
        }
        this.y = i, this._sy = this._fh = 0;
      },
      getRight: function() {
        return this.x + this.width;
      },
      setRight: function(i) {
        if (!this._fw) {
          var n = i - this.x;
          this.width = this._sx === 0.5 ? n * 2 : n;
        }
        this.x = i - this.width, this._sx = 1, this._fw = 0;
      },
      getBottom: function() {
        return this.y + this.height;
      },
      setBottom: function(i) {
        if (!this._fh) {
          var n = i - this.y;
          this.height = this._sy === 0.5 ? n * 2 : n;
        }
        this.y = i - this.height, this._sy = 1, this._fh = 0;
      },
      getCenterX: function() {
        return this.x + this.width / 2;
      },
      setCenterX: function(i) {
        this._fw || this._sx === 0.5 ? this.x = i - this.width / 2 : (this._sx && (this.x += (i - this.x) * 2 * this._sx), this.width = (i - this.x) * 2), this._sx = 0.5, this._fw = 0;
      },
      getCenterY: function() {
        return this.y + this.height / 2;
      },
      setCenterY: function(i) {
        this._fh || this._sy === 0.5 ? this.y = i - this.height / 2 : (this._sy && (this.y += (i - this.y) * 2 * this._sy), this.height = (i - this.y) * 2), this._sy = 0.5, this._fh = 0;
      },
      getCenter: function(i) {
        var n = i ? z : he;
        return new n(this.getCenterX(), this.getCenterY(), this, "setCenter");
      },
      setCenter: function() {
        var i = z.read(arguments);
        return this.setCenterX(i.x), this.setCenterY(i.y), this;
      },
      getArea: function() {
        return this.width * this.height;
      },
      isEmpty: function() {
        return this.width === 0 || this.height === 0;
      },
      contains: function(i) {
        return i && i.width !== t || (Array.isArray(i) ? i : arguments).length === 4 ? this._containsRectangle(se.read(arguments)) : this._containsPoint(z.read(arguments));
      },
      _containsPoint: function(i) {
        var n = i.x, r = i.y;
        return n >= this.x && r >= this.y && n <= this.x + this.width && r <= this.y + this.height;
      },
      _containsRectangle: function(i) {
        var n = i.x, r = i.y;
        return n >= this.x && r >= this.y && n + i.width <= this.x + this.width && r + i.height <= this.y + this.height;
      },
      intersects: function() {
        var i = se.read(arguments), n = a.read(arguments) || 0;
        return i.x + i.width > this.x - n && i.y + i.height > this.y - n && i.x < this.x + this.width + n && i.y < this.y + this.height + n;
      },
      intersect: function() {
        var i = se.read(arguments), n = Math.max(this.x, i.x), r = Math.max(this.y, i.y), l = Math.min(this.x + this.width, i.x + i.width), h = Math.min(this.y + this.height, i.y + i.height);
        return new se(n, r, l - n, h - r);
      },
      unite: function() {
        var i = se.read(arguments), n = Math.min(this.x, i.x), r = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x + i.width), h = Math.max(this.y + this.height, i.y + i.height);
        return new se(n, r, l - n, h - r);
      },
      include: function() {
        var i = z.read(arguments), n = Math.min(this.x, i.x), r = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x), h = Math.max(this.y + this.height, i.y);
        return new se(n, r, l - n, h - r);
      },
      expand: function() {
        var i = ne.read(arguments), n = i.width, r = i.height;
        return new se(
          this.x - n / 2,
          this.y - r / 2,
          this.width + n,
          this.height + r
        );
      },
      scale: function(i, n) {
        return this.expand(
          this.width * i - this.width,
          this.height * (n === t ? i : n) - this.height
        );
      }
    }, a.each(
      [
        ["Top", "Left"],
        ["Top", "Right"],
        ["Bottom", "Left"],
        ["Bottom", "Right"],
        ["Left", "Center"],
        ["Top", "Center"],
        ["Right", "Center"],
        ["Bottom", "Center"]
      ],
      function(i, n) {
        var r = i.join(""), l = /^[RL]/.test(r);
        n >= 4 && (i[1] += l ? "Y" : "X");
        var h = i[l ? 0 : 1], f = i[l ? 1 : 0], m = "get" + h, _ = "get" + f, y = "set" + h, x = "set" + f, A = "get" + r, B = "set" + r;
        this[A] = function(C) {
          var M = C ? z : he;
          return new M(this[m](), this[_](), this, B);
        }, this[B] = function() {
          var C = z.read(arguments);
          this[y](C.x), this[x](C.y);
        };
      },
      {
        beans: !0
      }
    )), _e = se.extend(
      {
        initialize: function(i, n, r, l, h, f) {
          this._set(i, n, r, l, !0), this._owner = h, this._setter = f;
        },
        _set: function(i, n, r, l, h) {
          return this._x = i, this._y = n, this._width = r, this._height = l, h || this._owner[this._setter](this), this;
        }
      },
      new function() {
        var i = se.prototype;
        return a.each(
          ["x", "y", "width", "height"],
          function(n) {
            var r = a.capitalize(n), l = "_" + n;
            this["get" + r] = function() {
              return this[l];
            }, this["set" + r] = function(h) {
              this[l] = h, this._dontNotify || this._owner[this._setter](this);
            };
          },
          a.each(
            [
              "Point",
              "Size",
              "Center",
              "Left",
              "Top",
              "Right",
              "Bottom",
              "CenterX",
              "CenterY",
              "TopLeft",
              "TopRight",
              "BottomLeft",
              "BottomRight",
              "LeftCenter",
              "TopCenter",
              "RightCenter",
              "BottomCenter"
            ],
            function(n) {
              var r = "set" + n;
              this[r] = function() {
                this._dontNotify = !0, i[r].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
              };
            },
            {
              isSelected: function() {
                return !!(this._owner._selection & 2);
              },
              setSelected: function(n) {
                var r = this._owner;
                r._changeSelection && r._changeSelection(2, n);
              }
            }
          )
        );
      }()
    ), ue = a.extend({
      _class: "Matrix",
      initialize: function i(n, r) {
        var l = arguments, h = l.length, f = !0;
        if (h >= 6 ? this._set.apply(this, l) : h === 1 || h === 2 ? n instanceof i ? this._set(
          n._a,
          n._b,
          n._c,
          n._d,
          n._tx,
          n._ty,
          r
        ) : Array.isArray(n) ? this._set.apply(
          this,
          r ? n.concat([r]) : n
        ) : f = !1 : h ? f = !1 : this.reset(), !f)
          throw new Error("Unsupported matrix parameters");
        return this;
      },
      set: "#initialize",
      _set: function(i, n, r, l, h, f, m) {
        return this._a = i, this._b = n, this._c = r, this._d = l, this._tx = h, this._ty = f, m || this._changed(), this;
      },
      _serialize: function(i, n) {
        return a.serialize(this.getValues(), i, !0, n);
      },
      _changed: function() {
        var i = this._owner;
        i && (i._applyMatrix ? i.transform(null, !0) : i._changed(25));
      },
      clone: function() {
        return new ue(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      },
      equals: function(i) {
        return i === this || i && this._a === i._a && this._b === i._b && this._c === i._c && this._d === i._d && this._tx === i._tx && this._ty === i._ty;
      },
      toString: function() {
        var i = H.instance;
        return "[[" + [
          i.number(this._a),
          i.number(this._c),
          i.number(this._tx)
        ].join(", ") + "], [" + [
          i.number(this._b),
          i.number(this._d),
          i.number(this._ty)
        ].join(", ") + "]]";
      },
      reset: function(i) {
        return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, i || this._changed(), this;
      },
      apply: function(i, n) {
        var r = this._owner;
        return r ? (r.transform(null, a.pick(i, !0), n), this.isIdentity()) : !1;
      },
      translate: function() {
        var i = z.read(arguments), n = i.x, r = i.y;
        return this._tx += n * this._a + r * this._c, this._ty += n * this._b + r * this._d, this._changed(), this;
      },
      scale: function() {
        var i = arguments, n = z.read(i), r = z.read(i, 0, { readNull: !0 });
        return r && this.translate(r), this._a *= n.x, this._b *= n.x, this._c *= n.y, this._d *= n.y, r && this.translate(r.negate()), this._changed(), this;
      },
      rotate: function(i) {
        i *= Math.PI / 180;
        var n = z.read(arguments, 1), r = n.x, l = n.y, h = Math.cos(i), f = Math.sin(i), m = r - r * h + l * f, _ = l - r * f - l * h, y = this._a, x = this._b, A = this._c, B = this._d;
        return this._a = h * y + f * A, this._b = h * x + f * B, this._c = -f * y + h * A, this._d = -f * x + h * B, this._tx += m * y + _ * A, this._ty += m * x + _ * B, this._changed(), this;
      },
      shear: function() {
        var i = arguments, n = z.read(i), r = z.read(i, 0, { readNull: !0 });
        r && this.translate(r);
        var l = this._a, h = this._b;
        return this._a += n.y * this._c, this._b += n.y * this._d, this._c += n.x * l, this._d += n.x * h, r && this.translate(r.negate()), this._changed(), this;
      },
      skew: function() {
        var i = arguments, n = z.read(i), r = z.read(i, 0, { readNull: !0 }), l = Math.PI / 180, h = new z(
          Math.tan(n.x * l),
          Math.tan(n.y * l)
        );
        return this.shear(h, r);
      },
      append: function(i, n) {
        if (i) {
          var r = this._a, l = this._b, h = this._c, f = this._d, m = i._a, _ = i._c, y = i._b, x = i._d, A = i._tx, B = i._ty;
          this._a = m * r + y * h, this._c = _ * r + x * h, this._b = m * l + y * f, this._d = _ * l + x * f, this._tx += A * r + B * h, this._ty += A * l + B * f, n || this._changed();
        }
        return this;
      },
      prepend: function(i, n) {
        if (i) {
          var r = this._a, l = this._b, h = this._c, f = this._d, m = this._tx, _ = this._ty, y = i._a, x = i._c, A = i._b, B = i._d, C = i._tx, M = i._ty;
          this._a = y * r + x * l, this._c = y * h + x * f, this._b = A * r + B * l, this._d = A * h + B * f, this._tx = y * m + x * _ + C, this._ty = A * m + B * _ + M, n || this._changed();
        }
        return this;
      },
      appended: function(i) {
        return this.clone().append(i);
      },
      prepended: function(i) {
        return this.clone().prepend(i);
      },
      invert: function() {
        var i = this._a, n = this._b, r = this._c, l = this._d, h = this._tx, f = this._ty, m = i * l - n * r, _ = null;
        return m && !isNaN(m) && isFinite(h) && isFinite(f) && (this._a = l / m, this._b = -n / m, this._c = -r / m, this._d = i / m, this._tx = (r * f - l * h) / m, this._ty = (n * h - i * f) / m, _ = this), _;
      },
      inverted: function() {
        return this.clone().invert();
      },
      concatenate: "#append",
      preConcatenate: "#prepend",
      chain: "#appended",
      _shiftless: function() {
        return new ue(this._a, this._b, this._c, this._d, 0, 0);
      },
      _orNullIfIdentity: function() {
        return this.isIdentity() ? null : this;
      },
      isIdentity: function() {
        return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
      },
      isInvertible: function() {
        var i = this._a * this._d - this._c * this._b;
        return i && !isNaN(i) && isFinite(this._tx) && isFinite(this._ty);
      },
      isSingular: function() {
        return !this.isInvertible();
      },
      transform: function(i, n, r) {
        return arguments.length < 3 ? this._transformPoint(z.read(arguments)) : this._transformCoordinates(i, n, r);
      },
      _transformPoint: function(i, n, r) {
        var l = i.x, h = i.y;
        return n || (n = new z()), n._set(
          l * this._a + h * this._c + this._tx,
          l * this._b + h * this._d + this._ty,
          r
        );
      },
      _transformCoordinates: function(i, n, r) {
        for (var l = 0, h = 2 * r; l < h; l += 2) {
          var f = i[l], m = i[l + 1];
          n[l] = f * this._a + m * this._c + this._tx, n[l + 1] = f * this._b + m * this._d + this._ty;
        }
        return n;
      },
      _transformCorners: function(i) {
        var n = i.x, r = i.y, l = n + i.width, h = r + i.height, f = [n, r, l, r, l, h, n, h];
        return this._transformCoordinates(f, f, 4);
      },
      _transformBounds: function(i, n, r) {
        for (var l = this._transformCorners(i), h = l.slice(0, 2), f = h.slice(), m = 2; m < 8; m++) {
          var _ = l[m], y = m & 1;
          _ < h[y] ? h[y] = _ : _ > f[y] && (f[y] = _);
        }
        return n || (n = new se()), n._set(
          h[0],
          h[1],
          f[0] - h[0],
          f[1] - h[1],
          r
        );
      },
      inverseTransform: function() {
        return this._inverseTransform(z.read(arguments));
      },
      _inverseTransform: function(i, n, r) {
        var l = this._a, h = this._b, f = this._c, m = this._d, _ = this._tx, y = this._ty, x = l * m - h * f, A = null;
        if (x && !isNaN(x) && isFinite(_) && isFinite(y)) {
          var B = i.x - this._tx, C = i.y - this._ty;
          n || (n = new z()), A = n._set(
            (B * m - C * f) / x,
            (C * l - B * h) / x,
            r
          );
        }
        return A;
      },
      decompose: function() {
        var i = this._a, n = this._b, r = this._c, l = this._d, h = i * l - n * r, f = Math.sqrt, m = Math.atan2, _ = 180 / Math.PI, y, x, A;
        if (i !== 0 || n !== 0) {
          var B = f(i * i + n * n);
          y = Math.acos(i / B) * (n > 0 ? 1 : -1), x = [B, h / B], A = [m(i * r + n * l, B * B), 0];
        } else if (r !== 0 || l !== 0) {
          var C = f(r * r + l * l);
          y = Math.asin(r / C) * (l > 0 ? 1 : -1), x = [h / C, C], A = [0, m(i * r + n * l, C * C)];
        } else
          y = 0, A = x = [0, 0];
        return {
          translation: this.getTranslation(),
          rotation: y * _,
          scaling: new z(x),
          skewing: new z(A[0] * _, A[1] * _)
        };
      },
      getValues: function() {
        return [this._a, this._b, this._c, this._d, this._tx, this._ty];
      },
      getTranslation: function() {
        return new z(this._tx, this._ty);
      },
      getScaling: function() {
        return this.decompose().scaling;
      },
      getRotation: function() {
        return this.decompose().rotation;
      },
      applyToContext: function(i) {
        this.isIdentity() || i.transform(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      }
    }, a.each(["a", "b", "c", "d", "tx", "ty"], function(i) {
      var n = a.capitalize(i), r = "_" + i;
      this["get" + n] = function() {
        return this[r];
      }, this["set" + n] = function(l) {
        this[r] = l, this._changed();
      };
    }, {})), xe = a.extend({
      _class: "Line",
      initialize: function(i, n, r, l, h) {
        var f = !1;
        arguments.length >= 4 ? (this._px = i, this._py = n, this._vx = r, this._vy = l, f = h) : (this._px = i.x, this._py = i.y, this._vx = n.x, this._vy = n.y, f = r), f || (this._vx -= this._px, this._vy -= this._py);
      },
      getPoint: function() {
        return new z(this._px, this._py);
      },
      getVector: function() {
        return new z(this._vx, this._vy);
      },
      getLength: function() {
        return this.getVector().getLength();
      },
      intersect: function(i, n) {
        return xe.intersect(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i._px,
          i._py,
          i._vx,
          i._vy,
          !0,
          n
        );
      },
      getSide: function(i, n) {
        return xe.getSide(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0,
          n
        );
      },
      getDistance: function(i) {
        return Math.abs(this.getSignedDistance(i));
      },
      getSignedDistance: function(i) {
        return xe.getSignedDistance(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0
        );
      },
      isCollinear: function(i) {
        return z.isCollinear(this._vx, this._vy, i._vx, i._vy);
      },
      isOrthogonal: function(i) {
        return z.isOrthogonal(this._vx, this._vy, i._vx, i._vy);
      },
      statics: {
        intersect: function(i, n, r, l, h, f, m, _, y, x) {
          y || (r -= i, l -= n, m -= h, _ -= f);
          var A = r * _ - l * m;
          if (!Y.isMachineZero(A)) {
            var B = i - h, C = n - f, M = (m * C - _ * B) / A, R = (r * C - l * B) / A, E = 1e-12, D = -E, L = 1 + E;
            if (x || D < M && M < L && D < R && R < L)
              return x || (M = M <= 0 ? 0 : M >= 1 ? 1 : M), new z(
                i + M * r,
                n + M * l
              );
          }
        },
        getSide: function(i, n, r, l, h, f, m, _) {
          m || (r -= i, l -= n);
          var y = h - i, x = f - n, A = y * l - x * r;
          return !_ && Y.isMachineZero(A) && (A = (y * r + y * r) / (r * r + l * l), A >= 0 && A <= 1 && (A = 0)), A < 0 ? -1 : A > 0 ? 1 : 0;
        },
        getSignedDistance: function(i, n, r, l, h, f, m) {
          return m || (r -= i, l -= n), r === 0 ? l > 0 ? h - i : i - h : l === 0 ? r < 0 ? f - n : n - f : ((h - i) * l - (f - n) * r) / (l > r ? l * Math.sqrt(1 + r * r / (l * l)) : r * Math.sqrt(1 + l * l / (r * r)));
        },
        getDistance: function(i, n, r, l, h, f, m) {
          return Math.abs(
            xe.getSignedDistance(i, n, r, l, h, f, m)
          );
        }
      }
    }), Ee = w.extend({
      _class: "Project",
      _list: "projects",
      _reference: "project",
      _compactSerialize: !0,
      initialize: function(i) {
        w.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new Wn(null, null, this), this._view = Ht.create(
          this,
          i || Ut.getCanvas(1, 1)
        ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
      },
      _serialize: function(i, n) {
        return a.serialize(this._children, i, !0, n);
      },
      _changed: function(i, n) {
        if (i & 1) {
          var r = this._view;
          r && (r._needsUpdate = !0, !r._requested && r._autoUpdate && r.requestUpdate());
        }
        var l = this._changes;
        if (l && n) {
          var h = this._changesById, f = n._id, m = h[f];
          m ? m.flags |= i : l.push(h[f] = { item: n, flags: i });
        }
      },
      clear: function() {
        for (var i = this._children, n = i.length - 1; n >= 0; n--)
          i[n].remove();
      },
      isEmpty: function() {
        return !this._children.length;
      },
      remove: function i() {
        return i.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
      },
      getView: function() {
        return this._view;
      },
      getCurrentStyle: function() {
        return this._currentStyle;
      },
      setCurrentStyle: function(i) {
        this._currentStyle.set(i);
      },
      getIndex: function() {
        return this._index;
      },
      getOptions: function() {
        return this._scope.settings;
      },
      getLayers: function() {
        return this._children;
      },
      getActiveLayer: function() {
        return this._activeLayer || new ht({ project: this, insert: !0 });
      },
      getSymbolDefinitions: function() {
        var i = [], n = {};
        return this.getItems({
          class: Pt,
          match: function(r) {
            var l = r._definition, h = l._id;
            return n[h] || (n[h] = !0, i.push(l)), !1;
          }
        }), i;
      },
      getSymbols: "getSymbolDefinitions",
      getSelectedItems: function() {
        var i = this._selectionItems, n = [];
        for (var r in i) {
          var l = i[r], h = l._selection;
          h & 1 && l.isInserted() ? n.push(l) : h || this._updateSelection(l);
        }
        return n;
      },
      _updateSelection: function(i) {
        var n = i._id, r = this._selectionItems;
        i._selection ? r[n] !== i && (this._selectionCount++, r[n] = i) : r[n] === i && (this._selectionCount--, delete r[n]);
      },
      selectAll: function() {
        for (var i = this._children, n = 0, r = i.length; n < r; n++)
          i[n].setFullySelected(!0);
      },
      deselectAll: function() {
        var i = this._selectionItems;
        for (var n in i)
          i[n].setFullySelected(!1);
      },
      addLayer: function(i) {
        return this.insertLayer(t, i);
      },
      insertLayer: function(i, n) {
        if (n instanceof ht) {
          n._remove(!1, !0), a.splice(this._children, [n], i, 0), n._setProject(this, !0);
          var r = n._name;
          r && n.setName(r), this._changes && n._changed(5), this._activeLayer || (this._activeLayer = n);
        } else
          n = null;
        return n;
      },
      _insertItem: function(i, n, r) {
        return n = this.insertLayer(i, n) || (this._activeLayer || this._insertItem(
          t,
          new ht(K.NO_INSERT),
          !0
        )).insertChild(i, n), r && n.activate && n.activate(), n;
      },
      getItems: function(i) {
        return K._getItems(this, i);
      },
      getItem: function(i) {
        return K._getItems(this, i, null, null, !0)[0] || null;
      },
      importJSON: function(i) {
        this.activate();
        var n = this._activeLayer;
        return a.importJSON(i, n && n.isEmpty() && n);
      },
      removeOn: function(i) {
        var n = this._removeSets;
        if (n) {
          i === "mouseup" && (n.mousedrag = null);
          var r = n[i];
          if (r) {
            for (var l in r) {
              var h = r[l];
              for (var f in n) {
                var m = n[f];
                m && m != r && delete m[h._id];
              }
              h.remove();
            }
            n[i] = null;
          }
        }
      },
      draw: function(i, n, r) {
        this._updateVersion++, i.save(), n.applyToContext(i);
        for (var l = this._children, h = new a({
          offset: new z(0, 0),
          pixelRatio: r,
          viewMatrix: n.isIdentity() ? null : n,
          matrices: [new ue()],
          updateMatrix: !0
        }), f = 0, m = l.length; f < m; f++)
          l[f].draw(i, h);
        if (i.restore(), this._selectionCount > 0) {
          i.save(), i.strokeWidth = 1;
          var _ = this._selectionItems, y = this._scope.settings.handleSize, x = this._updateVersion;
          for (var A in _)
            _[A]._drawSelection(i, n, y, _, x);
          i.restore();
        }
      }
    }), K = a.extend(
      c,
      {
        statics: {
          extend: function i(n) {
            return n._serializeFields && (n._serializeFields = a.set(
              {},
              this.prototype._serializeFields,
              n._serializeFields
            )), i.base.apply(this, arguments);
          },
          INSERT: { insert: !0 },
          NO_INSERT: { insert: !1 }
        },
        _class: "Item",
        _name: null,
        _applyMatrix: !0,
        _canApplyMatrix: !0,
        _canScaleStroke: !1,
        _pivot: null,
        _visible: !0,
        _blendMode: "normal",
        _opacity: 1,
        _locked: !1,
        _guide: !1,
        _clipMask: !1,
        _selection: 0,
        _selectBounds: !0,
        _selectChildren: !1,
        _serializeFields: {
          name: null,
          applyMatrix: null,
          matrix: new ue(),
          pivot: null,
          visible: !0,
          blendMode: "normal",
          opacity: 1,
          locked: !1,
          guide: !1,
          clipMask: !1,
          selected: !1,
          data: {}
        },
        _prioritize: ["applyMatrix"]
      },
      new function() {
        var i = [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onClick",
          "onDoubleClick",
          "onMouseMove",
          "onMouseEnter",
          "onMouseLeave"
        ];
        return a.each(
          i,
          function(n) {
            this._events[n] = {
              install: function(r) {
                this.getView()._countItemEvent(r, 1);
              },
              uninstall: function(r) {
                this.getView()._countItemEvent(r, -1);
              }
            };
          },
          {
            _events: {
              onFrame: {
                install: function() {
                  this.getView()._animateItem(this, !0);
                },
                uninstall: function() {
                  this.getView()._animateItem(this, !1);
                }
              },
              onLoad: {},
              onError: {}
            },
            statics: {
              _itemHandlers: i
            }
          }
        );
      }(),
      {
        initialize: function() {
        },
        _initialize: function(i, n) {
          var r = i && a.isPlainObject(i), l = r && i.internal === !0, h = this._matrix = new ue(), f = r && i.project || nt.project, m = nt.settings;
          return this._id = l ? null : ee.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && m.applyMatrix, n && h.translate(n), h._owner = this, this._style = new Wn(f._currentStyle, this, f), l || r && i.insert == !1 || !m.insertItems && !(r && i.insert == !0) ? this._setProject(f) : (r && i.parent || f)._insertItem(t, this, !0), r && i !== K.NO_INSERT && i !== K.INSERT && this.set(i, {
            internal: !0,
            insert: !0,
            project: !0,
            parent: !0
          }), r;
        },
        _serialize: function(i, n) {
          var r = {}, l = this;
          function h(f) {
            for (var m in f) {
              var _ = l[m];
              a.equals(_, m === "leading" ? f.fontSize * 1.2 : f[m]) || (r[m] = a.serialize(
                _,
                i,
                m !== "data",
                n
              ));
            }
          }
          return h(this._serializeFields), this instanceof j || h(this._style._defaults), [this._class, r];
        },
        _changed: function(i) {
          var n = this._symbol, r = this._parent || n, l = this._project;
          i & 8 && (this._bounds = this._position = this._decomposed = t), i & 16 && (this._globalMatrix = t), r && i & 72 && K._clearBoundsCache(r), i & 2 && K._clearBoundsCache(this), l && l._changed(i, this), n && n._changed(i);
        },
        getId: function() {
          return this._id;
        },
        getName: function() {
          return this._name;
        },
        setName: function(i) {
          if (this._name && this._removeNamed(), i === +i + "")
            throw new Error(
              "Names consisting only of numbers are not supported."
            );
          var n = this._getOwner();
          if (i && n) {
            var r = n._children, l = n._namedChildren;
            (l[i] = l[i] || []).push(this), i in r || (r[i] = this);
          }
          this._name = i || t, this._changed(256);
        },
        getStyle: function() {
          return this._style;
        },
        setStyle: function(i) {
          this.getStyle().set(i);
        }
      },
      a.each(
        ["locked", "visible", "blendMode", "opacity", "guide"],
        function(i) {
          var n = a.capitalize(i), r = "_" + i, l = {
            locked: 256,
            visible: 265
          };
          this["get" + n] = function() {
            return this[r];
          }, this["set" + n] = function(h) {
            h != this[r] && (this[r] = h, this._changed(l[i] || 257));
          };
        },
        {}
      ),
      {
        beans: !0,
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(i) {
          if (i !== this._selection) {
            this._selection = i;
            var n = this._project;
            n && (n._updateSelection(this), this._changed(257));
          }
        },
        _changeSelection: function(i, n) {
          var r = this._selection;
          this.setSelection(n ? r | i : r & ~i);
        },
        isSelected: function() {
          if (this._selectChildren) {
            for (var i = this._children, n = 0, r = i.length; n < r; n++)
              if (i[n].isSelected())
                return !0;
          }
          return !!(this._selection & 1);
        },
        setSelected: function(i) {
          if (this._selectChildren)
            for (var n = this._children, r = 0, l = n.length; r < l; r++)
              n[r].setSelected(i);
          this._changeSelection(1, i);
        },
        isFullySelected: function() {
          var i = this._children, n = !!(this._selection & 1);
          if (i && n) {
            for (var r = 0, l = i.length; r < l; r++)
              if (!i[r].isFullySelected())
                return !1;
            return !0;
          }
          return n;
        },
        setFullySelected: function(i) {
          var n = this._children;
          if (n)
            for (var r = 0, l = n.length; r < l; r++)
              n[r].setFullySelected(i);
          this._changeSelection(1, i);
        },
        isClipMask: function() {
          return this._clipMask;
        },
        setClipMask: function(i) {
          this._clipMask != (i = !!i) && (this._clipMask = i, i && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
        },
        getData: function() {
          return this._data || (this._data = {}), this._data;
        },
        setData: function(i) {
          this._data = i;
        },
        getPosition: function(i) {
          var n = i ? z : he, r = this._position || (this._position = this._getPositionFromBounds());
          return new n(r.x, r.y, this, "setPosition");
        },
        setPosition: function() {
          this.translate(z.read(arguments).subtract(this.getPosition(!0)));
        },
        _getPositionFromBounds: function(i) {
          return this._pivot ? this._matrix._transformPoint(this._pivot) : (i || this.getBounds()).getCenter(!0);
        },
        getPivot: function() {
          var i = this._pivot;
          return i ? new he(i.x, i.y, this, "setPivot") : null;
        },
        setPivot: function() {
          this._pivot = z.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = t;
        }
      },
      a.each(
        {
          getStrokeBounds: { stroke: !0 },
          getHandleBounds: { handle: !0 },
          getInternalBounds: { internal: !0 }
        },
        function(i, n) {
          this[n] = function(r) {
            return this.getBounds(r, i);
          };
        },
        {
          beans: !0,
          getBounds: function(i, n) {
            var r = n || i instanceof ue, l = a.set(
              {},
              r ? n : i,
              this._boundsOptions
            );
            (!l.stroke || this.getStrokeScaling()) && (l.cacheItem = this);
            var h = this._getCachedBounds(r && i, l).rect;
            return arguments.length ? h : new _e(
              h.x,
              h.y,
              h.width,
              h.height,
              this,
              "setBounds"
            );
          },
          setBounds: function() {
            var i = se.read(arguments), n = this.getBounds(), r = this._matrix, l = new ue(), h = i.getCenter();
            l.translate(h), (i.width != n.width || i.height != n.height) && (r.isInvertible() || (r.set(r._backup || new ue().translate(r.getTranslation())), n = this.getBounds()), l.scale(
              n.width !== 0 ? i.width / n.width : 0,
              n.height !== 0 ? i.height / n.height : 0
            )), h = n.getCenter(), l.translate(-h.x, -h.y), this.transform(l);
          },
          _getBounds: function(i, n) {
            var r = this._children;
            return !r || !r.length ? new se() : (K._updateBoundsCache(this, n.cacheItem), K._getBounds(r, i, n));
          },
          _getBoundsCacheKey: function(i, n) {
            return [
              i.stroke ? 1 : 0,
              i.handle ? 1 : 0,
              n ? 1 : 0
            ].join("");
          },
          _getCachedBounds: function(i, n, r) {
            i = i && i._orNullIfIdentity();
            var l = n.internal && !r, h = n.cacheItem, f = l ? null : this._matrix._orNullIfIdentity(), m = h && (!i || i.equals(f)) && this._getBoundsCacheKey(n, l), _ = this._bounds;
            if (K._updateBoundsCache(this._parent || this._symbol, h), m && _ && m in _) {
              var y = _[m];
              return {
                rect: y.rect.clone(),
                nonscaling: y.nonscaling
              };
            }
            var x = this._getBounds(i || f, n), A = x.rect || x, B = this._style, C = x.nonscaling || B.hasStroke() && !B.getStrokeScaling();
            if (m) {
              _ || (this._bounds = _ = {});
              var y = _[m] = {
                rect: A.clone(),
                nonscaling: C,
                internal: l
              };
            }
            return {
              rect: A,
              nonscaling: C
            };
          },
          _getStrokeMatrix: function(i, n) {
            var r = this.getStrokeScaling() ? null : n && n.internal ? this : this._parent || this._symbol && this._symbol._item, l = r ? r.getViewMatrix().invert() : i;
            return l && l._shiftless();
          },
          statics: {
            _updateBoundsCache: function(i, n) {
              if (i && n) {
                var r = n._id, l = i._boundsCache = i._boundsCache || {
                  ids: {},
                  list: []
                };
                l.ids[r] || (l.list.push(n), l.ids[r] = n);
              }
            },
            _clearBoundsCache: function(i) {
              var n = i._boundsCache;
              if (n) {
                i._bounds = i._position = i._boundsCache = t;
                for (var r = 0, l = n.list, h = l.length; r < h; r++) {
                  var f = l[r];
                  f !== i && (f._bounds = f._position = t, f._boundsCache && K._clearBoundsCache(f));
                }
              }
            },
            _getBounds: function(i, n, r) {
              var l = 1 / 0, h = -l, f = l, m = h, _ = !1;
              r = r || {};
              for (var y = 0, x = i.length; y < x; y++) {
                var A = i[y];
                if (A._visible && !A.isEmpty(!0)) {
                  var B = A._getCachedBounds(
                    n && n.appended(A._matrix),
                    r,
                    !0
                  ), C = B.rect;
                  l = Math.min(C.x, l), f = Math.min(C.y, f), h = Math.max(C.x + C.width, h), m = Math.max(C.y + C.height, m), B.nonscaling && (_ = !0);
                }
              }
              return {
                rect: isFinite(l) ? new se(l, f, h - l, m - f) : new se(),
                nonscaling: _
              };
            }
          }
        }
      ),
      {
        beans: !0,
        _decompose: function() {
          return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        getRotation: function() {
          var i = this._decompose();
          return i ? i.rotation : 0;
        },
        setRotation: function(i) {
          var n = this.getRotation();
          if (n != null && i != null) {
            var r = this._decomposed;
            this.rotate(i - n), r && (r.rotation = i, this._decomposed = r);
          }
        },
        getScaling: function() {
          var i = this._decompose(), n = i && i.scaling;
          return new he(n ? n.x : 1, n ? n.y : 1, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), n = z.read(arguments, 0, { clone: !0, readNull: !0 });
          if (i && n && !i.equals(n)) {
            var r = this.getRotation(), l = this._decomposed, h = new ue(), f = Y.isZero;
            if (f(i.x) || f(i.y))
              h.translate(l.translation), r && h.rotate(r), h.scale(n.x, n.y), this._matrix.set(h);
            else {
              var m = this.getPosition(!0);
              h.translate(m), r && h.rotate(r), h.scale(n.x / i.x, n.y / i.y), r && h.rotate(-r), h.translate(m.negate()), this.transform(h);
            }
            l && (l.scaling = n, this._decomposed = l);
          }
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        getGlobalMatrix: function(i) {
          var n = this._globalMatrix;
          if (n)
            for (var r = this._parent, l = []; r; ) {
              if (!r._globalMatrix) {
                n = null;
                for (var h = 0, f = l.length; h < f; h++)
                  l[h]._globalMatrix = null;
                break;
              }
              l.push(r), r = r._parent;
            }
          if (!n) {
            n = this._globalMatrix = this._matrix.clone();
            var r = this._parent;
            r && n.prepend(r.getGlobalMatrix(!0));
          }
          return i ? n : n.clone();
        },
        getViewMatrix: function() {
          return this.getGlobalMatrix().prepend(this.getView()._matrix);
        },
        getApplyMatrix: function() {
          return this._applyMatrix;
        },
        setApplyMatrix: function(i) {
          (this._applyMatrix = this._canApplyMatrix && !!i) && this.transform(null, !0);
        },
        getTransformContent: "#getApplyMatrix",
        setTransformContent: "#setApplyMatrix"
      },
      {
        getProject: function() {
          return this._project;
        },
        _setProject: function(i, n) {
          if (this._project !== i) {
            this._project && this._installEvents(!1), this._project = i;
            for (var r = this._children, l = 0, h = r && r.length; l < h; l++)
              r[l]._setProject(i);
            n = !0;
          }
          n && this._installEvents(!0);
        },
        getView: function() {
          return this._project._view;
        },
        _installEvents: function i(n) {
          i.base.call(this, n);
          for (var r = this._children, l = 0, h = r && r.length; l < h; l++)
            r[l]._installEvents(n);
        },
        getLayer: function() {
          for (var i = this; i = i._parent; )
            if (i instanceof ht)
              return i;
          return null;
        },
        getParent: function() {
          return this._parent;
        },
        setParent: function(i) {
          return i.addChild(this);
        },
        _getOwner: "#getParent",
        getChildren: function() {
          return this._children;
        },
        setChildren: function(i) {
          this.removeChildren(), this.addChildren(i);
        },
        getFirstChild: function() {
          return this._children && this._children[0] || null;
        },
        getLastChild: function() {
          return this._children && this._children[this._children.length - 1] || null;
        },
        getNextSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index + 1] || null;
        },
        getPreviousSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index - 1] || null;
        },
        getIndex: function() {
          return this._index;
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._style.equals(i._style) && this._matrix.equals(i._matrix) && this._locked === i._locked && this._visible === i._visible && this._blendMode === i._blendMode && this._opacity === i._opacity && this._clipMask === i._clipMask && this._guide === i._guide && this._equals(i) || !1;
        },
        _equals: function(i) {
          return a.equals(this._children, i._children);
        },
        clone: function(i) {
          var n = new this.constructor(K.NO_INSERT), r = this._children, l = a.pick(
            i ? i.insert : t,
            i === t || i === !0
          ), h = a.pick(i ? i.deep : t, !0);
          r && n.copyAttributes(this), (!r || h) && n.copyContent(this), r || n.copyAttributes(this), l && n.insertAbove(this);
          var f = this._name, m = this._parent;
          if (f && m) {
            for (var r = m._children, _ = f, y = 1; r[f]; )
              f = _ + " " + y++;
            f !== _ && n.setName(f);
          }
          return n;
        },
        copyContent: function(i) {
          for (var n = i._children, r = 0, l = n && n.length; r < l; r++)
            this.addChild(n[r].clone(!1), !0);
        },
        copyAttributes: function(i, n) {
          this.setStyle(i._style);
          for (var r = [
            "_locked",
            "_visible",
            "_blendMode",
            "_opacity",
            "_clipMask",
            "_guide"
          ], l = 0, h = r.length; l < h; l++) {
            var f = r[l];
            i.hasOwnProperty(f) && (this[f] = i[f]);
          }
          n || this._matrix.set(i._matrix, !0), this.setApplyMatrix(i._applyMatrix), this.setPivot(i._pivot), this.setSelection(i._selection);
          var m = i._data, _ = i._name;
          this._data = m ? a.clone(m) : null, _ && this.setName(_);
        },
        rasterize: function(i, n) {
          var r, l, h;
          a.isPlainObject(i) ? (r = i.resolution, l = i.insert, h = i.raster) : (r = i, l = n), h || (h = new pt(K.NO_INSERT));
          var f = this.getStrokeBounds(), m = (r || this.getView().getResolution()) / 72, _ = f.getTopLeft().floor(), y = f.getBottomRight().ceil(), x = new ne(y.subtract(_)), A = x.multiply(m);
          if (h.setSize(A, !0), !A.isZero()) {
            var B = h.getContext(!0), C = new ue().scale(m).translate(_.negate());
            B.save(), C.applyToContext(B), this.draw(B, new a({ matrices: [C] })), B.restore();
          }
          return h._matrix.set(
            new ue().translate(_.add(x.divide(2))).scale(1 / m)
          ), (l === t || l) && h.insertAbove(this), h;
        },
        contains: function() {
          var i = this._matrix;
          return i.isInvertible() && !!this._contains(i._inverseTransform(z.read(arguments)));
        },
        _contains: function(i) {
          var n = this._children;
          if (n) {
            for (var r = n.length - 1; r >= 0; r--)
              if (n[r].contains(i))
                return !0;
            return !1;
          }
          return i.isInside(this.getInternalBounds());
        },
        isInside: function() {
          return se.read(arguments).contains(this.getBounds());
        },
        _asPathItem: function() {
          return new Bt.Rectangle({
            rectangle: this.getInternalBounds(),
            matrix: this._matrix,
            insert: !1
          });
        },
        intersects: function(i, n) {
          return i instanceof K ? this._asPathItem().getIntersections(
            i._asPathItem(),
            null,
            n,
            !0
          ).length > 0 : !1;
        }
      },
      new function() {
        function i() {
          var l = arguments;
          return this._hitTest(
            z.read(l),
            Tt.getOptions(l)
          );
        }
        function n() {
          var l = arguments, h = z.read(l), f = Tt.getOptions(l), m = [];
          return this._hitTest(h, new a({ all: m }, f)), m;
        }
        function r(l, h, f, m) {
          var _ = this._children;
          if (_)
            for (var y = _.length - 1; y >= 0; y--) {
              var x = _[y], A = x !== m && x._hitTest(
                l,
                h,
                f
              );
              if (A && !h.all)
                return A;
            }
          return null;
        }
        return Ee.inject({
          hitTest: i,
          hitTestAll: n,
          _hitTest: r
        }), {
          hitTest: i,
          hitTestAll: n,
          _hitTestChildren: r
        };
      }(),
      {
        _hitTest: function(i, n, r) {
          if (this._locked || !this._visible || this._guide && !n.guides || this.isEmpty())
            return null;
          var l = this._matrix, h = r ? r.appended(l) : this.getGlobalMatrix().prepend(this.getView()._matrix), f = Math.max(n.tolerance, 1e-12), m = n._tolerancePadding = new ne(
            Bt._getStrokePadding(
              f,
              l._shiftless().invert()
            )
          );
          if (i = l._inverseTransform(i), !i || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(m.multiply(2))._containsPoint(i))
            return null;
          var _ = !(n.guides && !this._guide || n.selected && !this.isSelected() || n.type && n.type !== a.hyphenate(this._class) || n.class && !(this instanceof n.class)), y = n.match, x = this, A, B;
          function C(S) {
            return S && y && !y(S) && (S = null), S && n.all && n.all.push(S), S;
          }
          function M(S, I) {
            var U = I ? A["get" + I]() : x.getPosition();
            if (i.subtract(U).divide(m).length <= 1)
              return new Tt(S, x, {
                name: I ? a.hyphenate(I) : S,
                point: U
              });
          }
          var R = n.position, E = n.center, D = n.bounds;
          if (_ && this._parent && (R || E || D)) {
            if ((E || D) && (A = this.getInternalBounds()), B = R && M("position") || E && M("center", "Center"), !B && D)
              for (var L = [
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ], P = 0; P < 8 && !B; P++)
                B = M("bounds", L[P]);
            B = C(B);
          }
          return B || (B = this._hitTestChildren(i, n, h) || _ && C(this._hitTestSelf(
            i,
            n,
            h,
            this.getStrokeScaling() ? null : h._shiftless().invert()
          )) || null), B && B.point && (B.point = l.transform(B.point)), B;
        },
        _hitTestSelf: function(i, n) {
          if (n.fill && this.hasFill() && this._contains(i))
            return new Tt("fill", this);
        },
        matches: function(i, n) {
          function r(m, _) {
            for (var y in m)
              if (m.hasOwnProperty(y)) {
                var x = m[y], A = _[y];
                if (a.isPlainObject(x) && a.isPlainObject(A)) {
                  if (!r(x, A))
                    return !1;
                } else if (!a.equals(x, A))
                  return !1;
              }
            return !0;
          }
          var l = typeof i;
          if (l === "object") {
            for (var h in i)
              if (i.hasOwnProperty(h) && !this.matches(h, i[h]))
                return !1;
            return !0;
          } else {
            if (l === "function")
              return i(this);
            if (i === "match")
              return n(this);
            var f = /^(empty|editable)$/.test(i) ? this["is" + a.capitalize(i)]() : i === "type" ? a.hyphenate(this._class) : this[i];
            if (i === "class") {
              if (typeof n == "function")
                return this instanceof n;
              f = this._class;
            }
            if (typeof n == "function")
              return !!n(f);
            if (n) {
              if (n.test)
                return n.test(f);
              if (a.isPlainObject(n))
                return r(n, f);
            }
            return a.equals(f, n);
          }
        },
        getItems: function(i) {
          return K._getItems(this, i, this._matrix);
        },
        getItem: function(i) {
          return K._getItems(this, i, this._matrix, null, !0)[0] || null;
        },
        statics: {
          _getItems: function i(n, r, l, h, f) {
            if (!h) {
              var m = typeof r == "object" && r, _ = m && m.overlapping, y = m && m.inside, x = _ || y, C = x && se.read([x]);
              h = {
                items: [],
                recursive: m && m.recursive !== !1,
                inside: !!y,
                overlapping: !!_,
                rect: C,
                path: _ && new Bt.Rectangle({
                  rectangle: C,
                  insert: !1
                })
              }, m && (r = a.filter({}, r, {
                recursive: !0,
                inside: !0,
                overlapping: !0
              }));
            }
            var A = n._children, B = h.items, C = h.rect;
            l = C && (l || new ue());
            for (var M = 0, R = A && A.length; M < R; M++) {
              var E = A[M], D = l && l.appended(E._matrix), L = !0;
              if (C) {
                var x = E.getBounds(D);
                if (!C.intersects(x))
                  continue;
                C.contains(x) || h.overlapping && (x.contains(C) || h.path.intersects(E, D)) || (L = !1);
              }
              if (L && E.matches(r) && (B.push(E), f) || (h.recursive !== !1 && i(E, r, D, h, f), f && B.length > 0))
                break;
            }
            return B;
          }
        }
      },
      {
        importJSON: function(i) {
          var n = a.importJSON(i, this);
          return n !== this ? this.addChild(n) : n;
        },
        addChild: function(i) {
          return this.insertChild(t, i);
        },
        insertChild: function(i, n) {
          var r = n ? this.insertChildren(i, [n]) : null;
          return r && r[0];
        },
        addChildren: function(i) {
          return this.insertChildren(this._children.length, i);
        },
        insertChildren: function(i, n) {
          var r = this._children;
          if (r && n && n.length > 0) {
            n = a.slice(n);
            for (var l = {}, h = n.length - 1; h >= 0; h--) {
              var f = n[h], m = f && f._id;
              !f || l[m] ? n.splice(h, 1) : (f._remove(!1, !0), l[m] = !0);
            }
            a.splice(r, n, i, 0);
            for (var _ = this._project, y = _._changes, h = 0, x = n.length; h < x; h++) {
              var f = n[h], A = f._name;
              f._parent = this, f._setProject(_, !0), A && f.setName(A), y && f._changed(5);
            }
            this._changed(11);
          } else
            n = null;
          return n;
        },
        _insertItem: "#insertChild",
        _insertAt: function(i, n) {
          var r = i && i._getOwner(), l = i !== this && r ? this : null;
          return l && (l._remove(!1, !0), r._insertItem(i._index + n, l)), l;
        },
        insertAbove: function(i) {
          return this._insertAt(i, 1);
        },
        insertBelow: function(i) {
          return this._insertAt(i, 0);
        },
        sendToBack: function() {
          var i = this._getOwner();
          return i ? i._insertItem(0, this) : null;
        },
        bringToFront: function() {
          var i = this._getOwner();
          return i ? i._insertItem(t, this) : null;
        },
        appendTop: "#addChild",
        appendBottom: function(i) {
          return this.insertChild(0, i);
        },
        moveAbove: "#insertAbove",
        moveBelow: "#insertBelow",
        addTo: function(i) {
          return i._insertItem(t, this);
        },
        copyTo: function(i) {
          return this.clone(!1).addTo(i);
        },
        reduce: function(i) {
          var n = this._children;
          if (n && n.length === 1) {
            var r = n[0].reduce(i);
            return this._parent ? (r.insertAbove(this), this.remove()) : r.remove(), r;
          }
          return this;
        },
        _removeNamed: function() {
          var i = this._getOwner();
          if (i) {
            var n = i._children, r = i._namedChildren, l = this._name, h = r[l], f = h ? h.indexOf(this) : -1;
            f !== -1 && (n[l] == this && delete n[l], h.splice(f, 1), h.length ? n[l] = h[0] : delete r[l]);
          }
        },
        _remove: function(i, n) {
          var r = this._getOwner(), l = this._project, h = this._index;
          return this._style && this._style._dispose(), r ? (this._name && this._removeNamed(), h != null && (l._activeLayer === this && (l._activeLayer = this.getNextSibling() || this.getPreviousSibling()), a.splice(r._children, null, h, 1)), this._installEvents(!1), i && l._changes && this._changed(5), n && r._changed(11, this), this._parent = null, !0) : !1;
        },
        remove: function() {
          return this._remove(!0, !0);
        },
        replaceWith: function(i) {
          var n = i && i.insertBelow(this);
          return n && this.remove(), n;
        },
        removeChildren: function(i, n) {
          if (!this._children)
            return null;
          i = i || 0, n = a.pick(n, this._children.length);
          for (var r = a.splice(this._children, null, i, n - i), l = r.length - 1; l >= 0; l--)
            r[l]._remove(!0, !1);
          return r.length > 0 && this._changed(11), r;
        },
        clear: "#removeChildren",
        reverseChildren: function() {
          if (this._children) {
            this._children.reverse();
            for (var i = 0, n = this._children.length; i < n; i++)
              this._children[i]._index = i;
            this._changed(11);
          }
        },
        isEmpty: function(i) {
          var n = this._children, r = n ? n.length : 0;
          if (i) {
            for (var l = 0; l < r; l++)
              if (!n[l].isEmpty(i))
                return !1;
            return !0;
          }
          return !r;
        },
        isEditable: function() {
          for (var i = this; i; ) {
            if (!i._visible || i._locked)
              return !1;
            i = i._parent;
          }
          return !0;
        },
        hasFill: function() {
          return this.getStyle().hasFill();
        },
        hasStroke: function() {
          return this.getStyle().hasStroke();
        },
        hasShadow: function() {
          return this.getStyle().hasShadow();
        },
        _getOrder: function(i) {
          function n(m) {
            var _ = [];
            do
              _.unshift(m);
            while (m = m._parent);
            return _;
          }
          for (var r = n(this), l = n(i), h = 0, f = Math.min(r.length, l.length); h < f; h++)
            if (r[h] != l[h])
              return r[h]._index < l[h]._index ? 1 : -1;
          return 0;
        },
        hasChildren: function() {
          return this._children && this._children.length > 0;
        },
        isInserted: function() {
          return this._parent ? this._parent.isInserted() : !1;
        },
        isAbove: function(i) {
          return this._getOrder(i) === -1;
        },
        isBelow: function(i) {
          return this._getOrder(i) === 1;
        },
        isParent: function(i) {
          return this._parent === i;
        },
        isChild: function(i) {
          return i && i._parent === this;
        },
        isDescendant: function(i) {
          for (var n = this; n = n._parent; )
            if (n === i)
              return !0;
          return !1;
        },
        isAncestor: function(i) {
          return i ? i.isDescendant(this) : !1;
        },
        isSibling: function(i) {
          return this._parent === i._parent;
        },
        isGroupedWith: function(i) {
          for (var n = this._parent; n; ) {
            if (n._parent && /^(Group|Layer|CompoundPath)$/.test(n._class) && i.isDescendant(n))
              return !0;
            n = n._parent;
          }
          return !1;
        }
      },
      a.each(["rotate", "scale", "shear", "skew"], function(i) {
        var n = i === "rotate";
        this[i] = function() {
          var r = arguments, l = (n ? a : z).read(r), h = z.read(r, 0, { readNull: !0 });
          return this.transform(new ue()[i](
            l,
            h || this.getPosition(!0)
          ));
        };
      }, {
        translate: function() {
          var i = new ue();
          return this.transform(i.translate.apply(i, arguments));
        },
        transform: function(i, n, r) {
          var l = this._matrix, h = i && !i.isIdentity(), f = r && this._canApplyMatrix || this._applyMatrix && (h || !l.isIdentity() || n && this._children);
          if (!h && !f)
            return this;
          if (h) {
            !i.isInvertible() && l.isInvertible() && (l._backup = l.getValues()), l.prepend(i, !0);
            var m = this._style, _ = m.getFillColor(!0), y = m.getStrokeColor(!0);
            _ && _.transform(i), y && y.transform(i);
          }
          if (f && (f = this._transformContent(
            l,
            n,
            r
          ))) {
            var x = this._pivot;
            x && l._transformPoint(x, x, !0), l.reset(!0), r && this._canApplyMatrix && (this._applyMatrix = !0);
          }
          var A = this._bounds, B = this._position;
          (h || f) && this._changed(25);
          var C = h && A && i.decompose();
          if (C && C.skewing.isZero() && C.rotation % 90 === 0) {
            for (var M in A) {
              var R = A[M];
              if (R.nonscaling)
                delete A[M];
              else if (f || !R.internal) {
                var E = R.rect;
                i._transformBounds(E, E);
              }
            }
            this._bounds = A;
            var D = A[this._getBoundsCacheKey(
              this._boundsOptions || {}
            )];
            D && (this._position = this._getPositionFromBounds(D.rect));
          } else
            h && B && this._pivot && (this._position = i._transformPoint(B, B));
          return this;
        },
        _transformContent: function(i, n, r) {
          var l = this._children;
          if (l) {
            for (var h = 0, f = l.length; h < f; h++)
              l[h].transform(i, n, r);
            return !0;
          }
        },
        globalToLocal: function() {
          return this.getGlobalMatrix(!0)._inverseTransform(
            z.read(arguments)
          );
        },
        localToGlobal: function() {
          return this.getGlobalMatrix(!0)._transformPoint(
            z.read(arguments)
          );
        },
        parentToLocal: function() {
          return this._matrix._inverseTransform(z.read(arguments));
        },
        localToParent: function() {
          return this._matrix._transformPoint(z.read(arguments));
        },
        fitBounds: function(i, n) {
          i = se.read(arguments);
          var r = this.getBounds(), l = r.height / r.width, h = i.height / i.width, f = (n ? l > h : l < h) ? i.width / r.width : i.height / r.height, m = new se(
            new z(),
            new ne(r.width * f, r.height * f)
          );
          m.setCenter(i.getCenter()), this.setBounds(m);
        }
      }),
      {
        _setStyles: function(i, n, r) {
          var l = this._style, h = this._matrix;
          if (l.hasFill() && (i.fillStyle = l.getFillColor().toCanvasStyle(i, h)), l.hasStroke()) {
            i.strokeStyle = l.getStrokeColor().toCanvasStyle(i, h), i.lineWidth = l.getStrokeWidth();
            var f = l.getStrokeJoin(), m = l.getStrokeCap(), _ = l.getMiterLimit();
            if (f && (i.lineJoin = f), m && (i.lineCap = m), _ && (i.miterLimit = _), nt.support.nativeDash) {
              var y = l.getDashArray(), x = l.getDashOffset();
              y && y.length && ("setLineDash" in i ? (i.setLineDash(y), i.lineDashOffset = x) : (i.mozDash = y, i.mozDashOffset = x));
            }
          }
          if (l.hasShadow()) {
            var A = n.pixelRatio || 1, B = r._shiftless().prepend(
              new ue().scale(A, A)
            ), C = B.transform(new z(l.getShadowBlur(), 0)), M = B.transform(this.getShadowOffset());
            i.shadowColor = l.getShadowColor().toCanvasStyle(i), i.shadowBlur = C.getLength(), i.shadowOffsetX = M.x, i.shadowOffsetY = M.y;
          }
        },
        draw: function(i, n, r) {
          if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
            var l = n.matrices, h = n.viewMatrix, f = this._matrix, m = l[l.length - 1].appended(f);
            if (m.isInvertible()) {
              h = h ? h.appended(m) : m, l.push(m), n.updateMatrix && (this._globalMatrix = m);
              var _ = this._blendMode, y = Y.clamp(this._opacity, 0, 1), x = _ === "normal", A = ki.nativeModes[_], B = x && y === 1 || n.dontStart || n.clip || (A || x && y < 1) && this._canComposite(), C = n.pixelRatio || 1, M, R, E;
              if (!B) {
                var D = this.getStrokeBounds(h);
                if (!D.width || !D.height) {
                  l.pop();
                  return;
                }
                E = n.offset, R = n.offset = D.getTopLeft().floor(), M = i, i = Ut.getContext(D.getSize().ceil().add(1).multiply(C)), C !== 1 && i.scale(C, C);
              }
              i.save();
              var L = r ? r.appended(f) : this._canScaleStroke && !this.getStrokeScaling(!0) && h, P = !B && n.clipItem, S = !L || P;
              if (B ? (i.globalAlpha = y, A && (i.globalCompositeOperation = _)) : S && i.translate(-R.x, -R.y), S && (B ? f : h).applyToContext(i), P && n.clipItem.draw(i, n.extend({ clip: !0 })), L) {
                i.setTransform(C, 0, 0, C, 0, 0);
                var I = n.offset;
                I && i.translate(-I.x, -I.y);
              }
              this._draw(i, n, h, L), i.restore(), l.pop(), n.clip && !n.dontFinish && i.clip(this.getFillRule()), B || (ki.process(
                _,
                i,
                M,
                y,
                R.subtract(E).multiply(C)
              ), Ut.release(i), n.offset = E);
            }
          }
        },
        _isUpdated: function(i) {
          var n = this._parent;
          if (n instanceof yi)
            return n._isUpdated(i);
          var r = this._updateVersion === i;
          return !r && n && n._visible && n._isUpdated(i) && (this._updateVersion = i, r = !0), r;
        },
        _drawSelection: function(i, n, r, l, h) {
          var f = this._selection, m = f & 1, _ = f & 2 || m && this._selectBounds, y = f & 4;
          if (this._drawSelected || (m = !1), (m || _ || y) && this._isUpdated(h)) {
            var x, A = this.getSelectedColor(!0) || (x = this.getLayer()) && x.getSelectedColor(!0), B = n.appended(this.getGlobalMatrix(!0)), C = r / 2;
            if (i.strokeStyle = i.fillStyle = A ? A.toCanvasStyle(i) : "#009dec", m && this._drawSelected(i, B, l), y) {
              var M = this.getPosition(!0), R = this._parent, E = R ? R.localToGlobal(M) : M, D = E.x, L = E.y;
              i.beginPath(), i.arc(D, L, C, 0, Math.PI * 2, !0), i.stroke();
              for (var P = [[0, -1], [1, 0], [0, 1], [-1, 0]], S = C, I = r + 1, U = 0; U < 4; U++) {
                var V = P[U], F = V[0], W = V[1];
                i.moveTo(D + F * S, L + W * S), i.lineTo(D + F * I, L + W * I), i.stroke();
              }
            }
            if (_) {
              var Q = B._transformCorners(this.getInternalBounds());
              i.beginPath();
              for (var U = 0; U < 8; U++)
                i[U ? "lineTo" : "moveTo"](Q[U], Q[++U]);
              i.closePath(), i.stroke();
              for (var U = 0; U < 8; U++)
                i.fillRect(
                  Q[U] - C,
                  Q[++U] - C,
                  r,
                  r
                );
            }
          }
        },
        _canComposite: function() {
          return !1;
        }
      },
      a.each(["down", "drag", "up", "move"], function(i) {
        this["removeOn" + a.capitalize(i)] = function() {
          var n = {};
          return n[i] = !0, this.removeOn(n);
        };
      }, {
        removeOn: function(i) {
          for (var n in i)
            if (i[n]) {
              var r = "mouse" + n, l = this._project, h = l._removeSets = l._removeSets || {};
              h[r] = h[r] || {}, h[r][this._id] = this;
            }
          return this;
        }
      }),
      {
        tween: function(i, n, r) {
          r || (r = n, n = i, i = null, r || (r = n, n = null));
          var l = r && r.easing, h = r && r.start, f = r != null && (typeof r == "number" ? r : r.duration), m = new Js(this, i, n, f, l, h);
          function _(y) {
            m._handleFrame(y.time * 1e3), m.running || this.off("frame", _);
          }
          return f && this.on("frame", _), m;
        },
        tweenTo: function(i, n) {
          return this.tween(null, i, n);
        },
        tweenFrom: function(i, n) {
          return this.tween(i, null, n);
        }
      }
    ), j = K.extend({
      _class: "Group",
      _selectBounds: !1,
      _selectChildren: !0,
      _serializeFields: {
        children: []
      },
      initialize: function(i) {
        this._children = [], this._namedChildren = {}, this._initialize(i) || this.addChildren(Array.isArray(i) ? i : arguments);
      },
      _changed: function i(n) {
        i.base.call(this, n), n & 2050 && (this._clipItem = t);
      },
      _getClipItem: function() {
        var i = this._clipItem;
        if (i === t) {
          i = null;
          for (var n = this._children, r = 0, l = n.length; r < l; r++)
            if (n[r]._clipMask) {
              i = n[r];
              break;
            }
          this._clipItem = i;
        }
        return i;
      },
      isClipped: function() {
        return !!this._getClipItem();
      },
      setClipped: function(i) {
        var n = this.getFirstChild();
        n && n.setClipMask(i);
      },
      _getBounds: function i(n, r) {
        var l = this._getClipItem();
        return l ? l._getCachedBounds(
          l._matrix.prepended(n),
          a.set({}, r, { stroke: !1 })
        ) : i.base.call(this, n, r);
      },
      _hitTestChildren: function i(n, r, l) {
        var h = this._getClipItem();
        return (!h || h.contains(n)) && i.base.call(
          this,
          n,
          r,
          l,
          h
        );
      },
      _draw: function(i, n) {
        var r = n.clip, l = !r && this._getClipItem();
        n = n.extend({ clipItem: l, clip: !1 }), r ? (i.beginPath(), n.dontStart = n.dontFinish = !0) : l && l.draw(i, n.extend({ clip: !0 }));
        for (var h = this._children, f = 0, m = h.length; f < m; f++) {
          var _ = h[f];
          _ !== l && _.draw(i, n);
        }
      }
    }), ht = j.extend({
      _class: "Layer",
      initialize: function() {
        j.apply(this, arguments);
      },
      _getOwner: function() {
        return this._parent || this._index != null && this._project;
      },
      isInserted: function i() {
        return this._parent ? i.base.call(this) : this._index != null;
      },
      activate: function() {
        this._project._activeLayer = this;
      },
      _hitTestSelf: function() {
      }
    }), Ze = K.extend(
      {
        _class: "Shape",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _canScaleStroke: !0,
        _serializeFields: {
          type: null,
          size: null,
          radius: null
        },
        initialize: function(i, n) {
          this._initialize(i, n);
        },
        _equals: function(i) {
          return this._type === i._type && this._size.equals(i._size) && a.equals(this._radius, i._radius);
        },
        copyContent: function(i) {
          this.setType(i._type), this.setSize(i._size), this.setRadius(i._radius);
        },
        getType: function() {
          return this._type;
        },
        setType: function(i) {
          this._type = i;
        },
        getShape: "#getType",
        setShape: "#setType",
        getSize: function() {
          var i = this._size;
          return new ye(i.width, i.height, this, "setSize");
        },
        setSize: function() {
          var i = ne.read(arguments);
          if (!this._size)
            this._size = i.clone();
          else if (!this._size.equals(i)) {
            var n = this._type, r = i.width, l = i.height;
            n === "rectangle" ? this._radius.set(ne.min(this._radius, i.divide(2).abs())) : n === "circle" ? (r = l = (r + l) / 2, this._radius = r / 2) : n === "ellipse" && this._radius._set(r / 2, l / 2), this._size._set(r, l), this._changed(9);
          }
        },
        getRadius: function() {
          var i = this._radius;
          return this._type === "circle" ? i : new ye(i.width, i.height, this, "setRadius");
        },
        setRadius: function(i) {
          var n = this._type;
          if (n === "circle") {
            if (i === this._radius)
              return;
            var r = i * 2;
            this._radius = i, this._size._set(r, r);
          } else if (i = ne.read(arguments), !this._radius)
            this._radius = i.clone();
          else {
            if (this._radius.equals(i))
              return;
            if (this._radius.set(i), n === "rectangle") {
              var r = ne.max(this._size, i.multiply(2));
              this._size.set(r);
            } else
              n === "ellipse" && this._size._set(i.width * 2, i.height * 2);
          }
          this._changed(9);
        },
        isEmpty: function() {
          return !1;
        },
        toPath: function(i) {
          var n = new Bt[a.capitalize(this._type)]({
            center: new z(),
            size: this._size,
            radius: this._radius,
            insert: !1
          });
          return n.copyAttributes(this), nt.settings.applyMatrix && n.setApplyMatrix(!0), (i === t || i) && n.insertAbove(this), n;
        },
        toShape: "#clone",
        _asPathItem: function() {
          return this.toPath(!1);
        },
        _draw: function(i, n, r, l) {
          var h = this._style, f = h.hasFill(), m = h.hasStroke(), _ = n.dontFinish || n.clip, y = !l;
          if (f || m || _) {
            var x = this._type, A = this._radius, B = x === "circle";
            if (n.dontStart || i.beginPath(), y && B)
              i.arc(0, 0, A, 0, Math.PI * 2, !0);
            else {
              var C = B ? A : A.width, M = B ? A : A.height, R = this._size, E = R.width, D = R.height;
              if (y && x === "rectangle" && C === 0 && M === 0)
                i.rect(-E / 2, -D / 2, E, D);
              else {
                var L = E / 2, P = D / 2, S = 1 - 0.5522847498307936, I = C * S, U = M * S, V = [
                  -L,
                  -P + M,
                  -L,
                  -P + U,
                  -L + I,
                  -P,
                  -L + C,
                  -P,
                  L - C,
                  -P,
                  L - I,
                  -P,
                  L,
                  -P + U,
                  L,
                  -P + M,
                  L,
                  P - M,
                  L,
                  P - U,
                  L - I,
                  P,
                  L - C,
                  P,
                  -L + C,
                  P,
                  -L + I,
                  P,
                  -L,
                  P - U,
                  -L,
                  P - M
                ];
                l && l.transform(V, V, 32), i.moveTo(V[0], V[1]), i.bezierCurveTo(V[2], V[3], V[4], V[5], V[6], V[7]), L !== C && i.lineTo(V[8], V[9]), i.bezierCurveTo(V[10], V[11], V[12], V[13], V[14], V[15]), P !== M && i.lineTo(V[16], V[17]), i.bezierCurveTo(V[18], V[19], V[20], V[21], V[22], V[23]), L !== C && i.lineTo(V[24], V[25]), i.bezierCurveTo(V[26], V[27], V[28], V[29], V[30], V[31]);
              }
            }
            i.closePath();
          }
          !_ && (f || m) && (this._setStyles(i, n, r), f && (i.fill(h.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), m && i.stroke());
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _getBounds: function(i, n) {
          var r = new se(this._size).setCenter(0, 0), l = this._style, h = n.stroke && l.hasStroke() && l.getStrokeWidth();
          return i && (r = i._transformBounds(r)), h ? r.expand(Bt._getStrokePadding(
            h,
            this._getStrokeMatrix(i, n)
          )) : r;
        }
      },
      new function() {
        function i(r, l, h) {
          var f = r._radius;
          if (!f.isZero())
            for (var m = r._size.divide(2), _ = 1; _ <= 4; _++) {
              var y = new z(_ > 1 && _ < 4 ? -1 : 1, _ > 2 ? -1 : 1), x = y.multiply(m), A = x.subtract(y.multiply(f)), B = new se(
                h ? x.add(y.multiply(h)) : x,
                A
              );
              if (B.contains(l))
                return { point: A, quadrant: _ };
            }
        }
        function n(r, l, h, f) {
          var m = r.divide(l);
          return (!f || m.isInQuadrant(f)) && m.subtract(m.normalize()).multiply(l).divide(h).length <= 1;
        }
        return {
          _contains: function r(l) {
            if (this._type === "rectangle") {
              var h = i(this, l);
              return h ? l.subtract(h.point).divide(this._radius).getLength() <= 1 : r.base.call(this, l);
            } else
              return l.divide(this.size).getLength() <= 0.5;
          },
          _hitTestSelf: function r(l, h, f, m) {
            var _ = !1, y = this._style, x = h.stroke && y.hasStroke(), A = h.fill && y.hasFill();
            if (x || A) {
              var B = this._type, C = this._radius, M = x ? y.getStrokeWidth() / 2 : 0, R = h._tolerancePadding.add(
                Bt._getStrokePadding(
                  M,
                  !y.getStrokeScaling() && m
                )
              );
              if (B === "rectangle") {
                var E = R.multiply(2), D = i(this, l, E);
                if (D)
                  _ = n(
                    l.subtract(D.point),
                    C,
                    R,
                    D.quadrant
                  );
                else {
                  var L = new se(this._size).setCenter(0, 0), P = L.expand(E), S = L.expand(E.negate());
                  _ = P._containsPoint(l) && !S._containsPoint(l);
                }
              } else
                _ = n(l, C, R);
            }
            return _ ? new Tt(x ? "stroke" : "fill", this) : r.base.apply(this, arguments);
          }
        };
      }(),
      {
        statics: new function() {
          function i(n, r, l, h, f) {
            var m = a.create(Ze.prototype);
            return m._type = n, m._size = l, m._radius = h, m._initialize(a.getNamed(f), r), m;
          }
          return {
            Circle: function() {
              var n = arguments, r = z.readNamed(n, "center"), l = a.readNamed(n, "radius");
              return i(
                "circle",
                r,
                new ne(l * 2),
                l,
                n
              );
            },
            Rectangle: function() {
              var n = arguments, r = se.readNamed(n, "rectangle"), l = ne.min(
                ne.readNamed(n, "radius"),
                r.getSize(!0).divide(2)
              );
              return i(
                "rectangle",
                r.getCenter(!0),
                r.getSize(!0),
                l,
                n
              );
            },
            Ellipse: function() {
              var n = arguments, r = Ze._readEllipse(n), l = r.radius;
              return i(
                "ellipse",
                r.center,
                l.multiply(2),
                l,
                n
              );
            },
            _readEllipse: function(n) {
              var r, l;
              if (a.hasNamed(n, "radius"))
                r = z.readNamed(n, "center"), l = ne.readNamed(n, "radius");
              else {
                var h = se.readNamed(n, "rectangle");
                r = h.getCenter(!0), l = h.getSize(!0).divide(2);
              }
              return { center: r, radius: l };
            }
          };
        }()
      }
    ), pt = K.extend({
      _class: "Raster",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !1, handle: !1 },
      _serializeFields: {
        crossOrigin: null,
        source: null
      },
      _prioritize: ["crossOrigin"],
      _smoothing: "low",
      beans: !0,
      initialize: function(i, n) {
        if (!this._initialize(
          i,
          n !== t && z.read(arguments)
        )) {
          var r, l = typeof i, h = l === "string" ? o.getElementById(i) : l === "object" ? i : null;
          if (h && h !== K.NO_INSERT) {
            if (h.getContext || h.naturalHeight != null)
              r = h;
            else if (h) {
              var f = ne.read(arguments);
              f.isZero() || (r = Ut.getCanvas(f));
            }
          }
          r ? this.setImage(r) : this.setSource(i);
        }
        this._size || (this._size = new ne(), this._loaded = !1);
      },
      _equals: function(i) {
        return this.getSource() === i.getSource();
      },
      copyContent: function(i) {
        var n = i._image, r = i._canvas;
        if (n)
          this._setImage(n);
        else if (r) {
          var l = Ut.getCanvas(i._size);
          l.getContext("2d").drawImage(r, 0, 0), this._setImage(l);
        }
        this._crossOrigin = i._crossOrigin;
      },
      getSize: function() {
        var i = this._size;
        return new ye(
          i ? i.width : 0,
          i ? i.height : 0,
          this,
          "setSize"
        );
      },
      setSize: function(i, n) {
        var r = ne.read(arguments);
        if (r.equals(this._size))
          n && this.clear();
        else if (r.width > 0 && r.height > 0) {
          var l = !n && this.getElement();
          this._setImage(Ut.getCanvas(r)), l && this.getContext(!0).drawImage(
            l,
            0,
            0,
            r.width,
            r.height
          );
        } else
          this._canvas && Ut.release(this._canvas), this._size = r.clone();
      },
      getWidth: function() {
        return this._size ? this._size.width : 0;
      },
      setWidth: function(i) {
        this.setSize(i, this.getHeight());
      },
      getHeight: function() {
        return this._size ? this._size.height : 0;
      },
      setHeight: function(i) {
        this.setSize(this.getWidth(), i);
      },
      getLoaded: function() {
        return this._loaded;
      },
      isEmpty: function() {
        var i = this._size;
        return !i || i.width === 0 && i.height === 0;
      },
      getResolution: function() {
        var i = this._matrix, n = new z(0, 0).transform(i), r = new z(1, 0).transform(i).subtract(n), l = new z(0, 1).transform(i).subtract(n);
        return new ne(
          72 / r.getLength(),
          72 / l.getLength()
        );
      },
      getPpi: "#getResolution",
      getImage: function() {
        return this._image;
      },
      setImage: function(i) {
        var n = this;
        function r(l) {
          var h = n.getView(), f = l && l.type || "load";
          h && n.responds(f) && (nt = h._scope, n.emit(f, new Ln(l)));
        }
        this._setImage(i), this._loaded ? setTimeout(r, 0) : i && Dt.add(i, {
          load: function(l) {
            n._setImage(i), r(l);
          },
          error: r
        });
      },
      _setImage: function(i) {
        this._canvas && Ut.release(this._canvas), i && i.getContext ? (this._image = null, this._canvas = i, this._loaded = !0) : (this._image = i, this._canvas = null, this._loaded = !!(i && i.src && i.complete)), this._size = new ne(
          i ? i.naturalWidth || i.width : 0,
          i ? i.naturalHeight || i.height : 0
        ), this._context = null, this._changed(1033);
      },
      getCanvas: function() {
        if (!this._canvas) {
          var i = Ut.getContext(this._size);
          try {
            this._image && i.drawImage(this._image, 0, 0), this._canvas = i.canvas;
          } catch {
            Ut.release(i);
          }
        }
        return this._canvas;
      },
      setCanvas: "#setImage",
      getContext: function(i) {
        return this._context || (this._context = this.getCanvas().getContext("2d")), i && (this._image = null, this._changed(1025)), this._context;
      },
      setContext: function(i) {
        this._context = i;
      },
      getSource: function() {
        var i = this._image;
        return i && i.src || this.toDataURL();
      },
      setSource: function(i) {
        var n = new e.Image(), r = this._crossOrigin;
        r && (n.crossOrigin = r), i && (n.src = i), this.setImage(n);
      },
      getCrossOrigin: function() {
        var i = this._image;
        return i && i.crossOrigin || this._crossOrigin || "";
      },
      setCrossOrigin: function(i) {
        this._crossOrigin = i;
        var n = this._image;
        n && (n.crossOrigin = i);
      },
      getSmoothing: function() {
        return this._smoothing;
      },
      setSmoothing: function(i) {
        this._smoothing = typeof i == "string" ? i : i ? "low" : "off", this._changed(257);
      },
      getElement: function() {
        return this._canvas || this._loaded && this._image;
      }
    }, {
      beans: !1,
      getSubCanvas: function() {
        var i = se.read(arguments), n = Ut.getContext(i.getSize());
        return n.drawImage(
          this.getCanvas(),
          i.x,
          i.y,
          i.width,
          i.height,
          0,
          0,
          i.width,
          i.height
        ), n.canvas;
      },
      getSubRaster: function() {
        var i = se.read(arguments), n = new pt(K.NO_INSERT);
        return n._setImage(this.getSubCanvas(i)), n.translate(i.getCenter().subtract(this.getSize().divide(2))), n._matrix.prepend(this._matrix), n.insertAbove(this), n;
      },
      toDataURL: function() {
        var i = this._image, n = i && i.src;
        if (/^data:/.test(n))
          return n;
        var r = this.getCanvas();
        return r ? r.toDataURL.apply(r, arguments) : null;
      },
      drawImage: function(i) {
        var n = z.read(arguments, 1);
        this.getContext(!0).drawImage(i, n.x, n.y);
      },
      getAverageColor: function(i) {
        var n, r;
        if (i ? i instanceof Ft ? (r = i, n = i.getBounds()) : typeof i == "object" && ("width" in i ? n = new se(i) : "x" in i && (n = new se(i.x - 0.5, i.y - 0.5, 1, 1))) : n = this.getBounds(), !n)
          return null;
        var l = 32, h = Math.min(n.width, l), f = Math.min(n.height, l), m = pt._sampleContext;
        m ? m.clearRect(0, 0, l + 1, l + 1) : m = pt._sampleContext = Ut.getContext(
          new ne(l)
        ), m.save();
        var _ = new ue().scale(h / n.width, f / n.height).translate(-n.x, -n.y);
        _.applyToContext(m), r && r.draw(m, new a({ clip: !0, matrices: [_] })), this._matrix.applyToContext(m);
        var y = this.getElement(), x = this._size;
        y && m.drawImage(y, -x.width / 2, -x.height / 2), m.restore();
        for (var A = m.getImageData(
          0.5,
          0.5,
          Math.ceil(h),
          Math.ceil(f)
        ).data, B = [0, 0, 0], C = 0, M = 0, R = A.length; M < R; M += 4) {
          var E = A[M + 3];
          C += E, E /= 255, B[0] += A[M] * E, B[1] += A[M + 1] * E, B[2] += A[M + 2] * E;
        }
        for (var M = 0; M < 3; M++)
          B[M] /= C;
        return C ? qt.read(B) : null;
      },
      getPixel: function() {
        var i = z.read(arguments), n = this.getContext().getImageData(i.x, i.y, 1, 1).data;
        return new qt(
          "rgb",
          [n[0] / 255, n[1] / 255, n[2] / 255],
          n[3] / 255
        );
      },
      setPixel: function() {
        var i = arguments, n = z.read(i), r = qt.read(i), l = r._convert("rgb"), h = r._alpha, f = this.getContext(!0), m = f.createImageData(1, 1), _ = m.data;
        _[0] = l[0] * 255, _[1] = l[1] * 255, _[2] = l[2] * 255, _[3] = h != null ? h * 255 : 255, f.putImageData(m, n.x, n.y);
      },
      clear: function() {
        var i = this._size;
        this.getContext(!0).clearRect(0, 0, i.width + 1, i.height + 1);
      },
      createImageData: function() {
        var i = ne.read(arguments);
        return this.getContext().createImageData(i.width, i.height);
      },
      getImageData: function() {
        var i = se.read(arguments);
        return i.isEmpty() && (i = new se(this._size)), this.getContext().getImageData(
          i.x,
          i.y,
          i.width,
          i.height
        );
      },
      putImageData: function(i) {
        var n = z.read(arguments, 1);
        this.getContext(!0).putImageData(i, n.x, n.y);
      },
      setImageData: function(i) {
        this.setSize(i), this.getContext(!0).putImageData(i, 0, 0);
      },
      _getBounds: function(i, n) {
        var r = new se(this._size).setCenter(0, 0);
        return i ? i._transformBounds(r) : r;
      },
      _hitTestSelf: function(i) {
        if (this._contains(i)) {
          var n = this;
          return new Tt("pixel", n, {
            offset: i.add(n._size.divide(2)).round(),
            color: {
              get: function() {
                return n.getPixel(this.offset);
              }
            }
          });
        }
      },
      _draw: function(i, n, r) {
        var l = this.getElement();
        if (l && l.width > 0 && l.height > 0) {
          i.globalAlpha = Y.clamp(this._opacity, 0, 1), this._setStyles(i, n, r);
          var h = this._smoothing, f = h === "off";
          zt.setPrefixed(
            i,
            f ? "imageSmoothingEnabled" : "imageSmoothingQuality",
            f ? !1 : h
          ), i.drawImage(
            l,
            -this._size.width / 2,
            -this._size.height / 2
          );
        }
      },
      _canComposite: function() {
        return !0;
      }
    }), Pt = K.extend({
      _class: "SymbolItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !0 },
      _serializeFields: {
        symbol: null
      },
      initialize: function(i, n) {
        this._initialize(
          i,
          n !== t && z.read(arguments, 1)
        ) || this.setDefinition(i instanceof Mt ? i : new Mt(i));
      },
      _equals: function(i) {
        return this._definition === i._definition;
      },
      copyContent: function(i) {
        this.setDefinition(i._definition);
      },
      getDefinition: function() {
        return this._definition;
      },
      setDefinition: function(i) {
        this._definition = i, this._changed(9);
      },
      getSymbol: "#getDefinition",
      setSymbol: "#setDefinition",
      isEmpty: function() {
        return this._definition._item.isEmpty();
      },
      _getBounds: function(i, n) {
        var r = this._definition._item;
        return r._getCachedBounds(r._matrix.prepended(i), n);
      },
      _hitTestSelf: function(i, n, r) {
        var l = n.extend({ all: !1 }), h = this._definition._item._hitTest(i, l, r);
        return h && (h.item = this), h;
      },
      _draw: function(i, n) {
        this._definition._item.draw(i, n);
      }
    }), Mt = a.extend({
      _class: "SymbolDefinition",
      initialize: function(i, n) {
        this._id = ee.get(), this.project = nt.project, i && this.setItem(i, n);
      },
      _serialize: function(i, n) {
        return n.add(this, function() {
          return a.serialize(
            [this._class, this._item],
            i,
            !1,
            n
          );
        });
      },
      _changed: function(i) {
        i & 8 && K._clearBoundsCache(this), i & 1 && this.project._changed(i);
      },
      getItem: function() {
        return this._item;
      },
      setItem: function(i, n) {
        i._symbol && (i = i.clone()), this._item && (this._item._symbol = null), this._item = i, i.remove(), i.setSelected(!1), n || i.setPosition(new z()), i._symbol = this, this._changed(9);
      },
      getDefinition: "#getItem",
      setDefinition: "#setItem",
      place: function(i) {
        return new Pt(this, i);
      },
      clone: function() {
        return new Mt(this._item.clone(!1));
      },
      equals: function(i) {
        return i === this || i && this._item.equals(i._item) || !1;
      }
    }), Tt = a.extend({
      _class: "HitResult",
      initialize: function(i, n, r) {
        this.type = i, this.item = n, r && this.inject(r);
      },
      statics: {
        getOptions: function(i) {
          var n = i && a.read(i);
          return new a({
            type: null,
            tolerance: nt.settings.hitTolerance,
            fill: !n,
            stroke: !n,
            segments: !n,
            handles: !1,
            ends: !1,
            position: !1,
            center: !1,
            bounds: !1,
            guides: !1,
            selected: !1
          }, n);
        }
      }
    }), at = a.extend({
      _class: "Segment",
      beans: !0,
      _selection: 0,
      initialize: function(i, n, r, l, h, f) {
        var m = arguments.length, _, y, x, A;
        m > 0 && (i == null || typeof i == "object" ? m === 1 && i && "point" in i ? (_ = i.point, y = i.handleIn, x = i.handleOut, A = i.selection) : (_ = i, y = n, x = r, A = l) : (_ = [i, n], y = r !== t ? [r, l] : null, x = h !== t ? [h, f] : null)), new Ai(_, this, "_point"), new Ai(y, this, "_handleIn"), new Ai(x, this, "_handleOut"), A && this.setSelection(A);
      },
      _serialize: function(i, n) {
        var r = this._point, l = this._selection, h = l || this.hasHandles() ? [r, this._handleIn, this._handleOut] : r;
        return l && h.push(l), a.serialize(h, i, !0, n);
      },
      _changed: function(i) {
        var n = this._path;
        if (n) {
          var r = n._curves, l = this._index, h;
          r && ((!i || i === this._point || i === this._handleIn) && (h = l > 0 ? r[l - 1] : n._closed ? r[r.length - 1] : null) && h._changed(), (!i || i === this._point || i === this._handleOut) && (h = r[l]) && h._changed()), n._changed(41);
        }
      },
      getPoint: function() {
        return this._point;
      },
      setPoint: function() {
        this._point.set(z.read(arguments));
      },
      getHandleIn: function() {
        return this._handleIn;
      },
      setHandleIn: function() {
        this._handleIn.set(z.read(arguments));
      },
      getHandleOut: function() {
        return this._handleOut;
      },
      setHandleOut: function() {
        this._handleOut.set(z.read(arguments));
      },
      hasHandles: function() {
        return !this._handleIn.isZero() || !this._handleOut.isZero();
      },
      isSmooth: function() {
        var i = this._handleIn, n = this._handleOut;
        return !i.isZero() && !n.isZero() && i.isCollinear(n);
      },
      clearHandles: function() {
        this._handleIn._set(0, 0), this._handleOut._set(0, 0);
      },
      getSelection: function() {
        return this._selection;
      },
      setSelection: function(i) {
        var n = this._selection, r = this._path;
        this._selection = i = i || 0, r && i !== n && (r._updateSelection(this, n, i), r._changed(257));
      },
      _changeSelection: function(i, n) {
        var r = this._selection;
        this.setSelection(n ? r | i : r & ~i);
      },
      isSelected: function() {
        return !!(this._selection & 7);
      },
      setSelected: function(i) {
        this._changeSelection(7, i);
      },
      getIndex: function() {
        return this._index !== t ? this._index : null;
      },
      getPath: function() {
        return this._path || null;
      },
      getCurve: function() {
        var i = this._path, n = this._index;
        return i ? (n > 0 && !i._closed && n === i._segments.length - 1 && n--, i.getCurves()[n] || null) : null;
      },
      getLocation: function() {
        var i = this.getCurve();
        return i ? new Ot(i, this === i._segment1 ? 0 : 1) : null;
      },
      getNext: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index + 1] || this._path._closed && i[0]) || null;
      },
      smooth: function(i, n, r) {
        var l = i || {}, h = l.type, f = l.factor, m = this.getPrevious(), _ = this.getNext(), y = (m || this)._point, x = this._point, A = (_ || this)._point, B = y.getDistance(x), C = x.getDistance(A);
        if (!h || h === "catmull-rom") {
          var M = f === t ? 0.5 : f, R = Math.pow(B, M), E = R * R, D = Math.pow(C, M), L = D * D;
          if (!n && m) {
            var P = 2 * L + 3 * D * R + E, S = 3 * D * (D + R);
            this.setHandleIn(S !== 0 ? new z(
              (L * y._x + P * x._x - E * A._x) / S - x._x,
              (L * y._y + P * x._y - E * A._y) / S - x._y
            ) : new z());
          }
          if (!r && _) {
            var P = 2 * E + 3 * R * D + L, S = 3 * R * (R + D);
            this.setHandleOut(S !== 0 ? new z(
              (E * A._x + P * x._x - L * y._x) / S - x._x,
              (E * A._y + P * x._y - L * y._y) / S - x._y
            ) : new z());
          }
        } else if (h === "geometric") {
          if (m && _) {
            var I = y.subtract(A), U = f === t ? 0.4 : f, V = U * B / (B + C);
            n || this.setHandleIn(I.multiply(V)), r || this.setHandleOut(I.multiply(V - U));
          }
        } else
          throw new Error("Smoothing method '" + h + "' not supported.");
      },
      getPrevious: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index - 1] || this._path._closed && i[i.length - 1]) || null;
      },
      isFirst: function() {
        return !this._index;
      },
      isLast: function() {
        var i = this._path;
        return i && this._index === i._segments.length - 1 || !1;
      },
      reverse: function() {
        var i = this._handleIn, n = this._handleOut, r = i.clone();
        i.set(n), n.set(r);
      },
      reversed: function() {
        return new at(this._point, this._handleOut, this._handleIn);
      },
      remove: function() {
        return this._path ? !!this._path.removeSegment(this._index) : !1;
      },
      clone: function() {
        return new at(this._point, this._handleIn, this._handleOut);
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._point.equals(i._point) && this._handleIn.equals(i._handleIn) && this._handleOut.equals(i._handleOut) || !1;
      },
      toString: function() {
        var i = ["point: " + this._point];
        return this._handleIn.isZero() || i.push("handleIn: " + this._handleIn), this._handleOut.isZero() || i.push("handleOut: " + this._handleOut), "{ " + i.join(", ") + " }";
      },
      transform: function(i) {
        this._transformCoordinates(i, new Array(6), !0), this._changed();
      },
      interpolate: function(i, n, r) {
        var l = 1 - r, h = r, f = i._point, m = n._point, _ = i._handleIn, y = n._handleIn, x = n._handleOut, A = i._handleOut;
        this._point._set(
          l * f._x + h * m._x,
          l * f._y + h * m._y,
          !0
        ), this._handleIn._set(
          l * _._x + h * y._x,
          l * _._y + h * y._y,
          !0
        ), this._handleOut._set(
          l * A._x + h * x._x,
          l * A._y + h * x._y,
          !0
        ), this._changed();
      },
      _transformCoordinates: function(i, n, r) {
        var l = this._point, h = !r || !this._handleIn.isZero() ? this._handleIn : null, f = !r || !this._handleOut.isZero() ? this._handleOut : null, m = l._x, _ = l._y, y = 2;
        return n[0] = m, n[1] = _, h && (n[y++] = h._x + m, n[y++] = h._y + _), f && (n[y++] = f._x + m, n[y++] = f._y + _), i && (i._transformCoordinates(n, n, y / 2), m = n[0], _ = n[1], r ? (l._x = m, l._y = _, y = 2, h && (h._x = n[y++] - m, h._y = n[y++] - _), f && (f._x = n[y++] - m, f._y = n[y++] - _)) : (h || (n[y++] = m, n[y++] = _), f || (n[y++] = m, n[y++] = _))), n;
      }
    }), Ai = z.extend({
      initialize: function(i, n, r) {
        var l, h, f;
        if (!i)
          l = h = 0;
        else if ((l = i[0]) !== t)
          h = i[1];
        else {
          var m = i;
          (l = m.x) === t && (m = z.read(arguments), l = m.x), h = m.y, f = m.selected;
        }
        this._x = l, this._y = h, this._owner = n, n[r] = this, f && this.setSelected(!0);
      },
      _set: function(i, n) {
        return this._x = i, this._y = n, this._owner._changed(this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner._changed(this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner._changed(this);
      },
      isZero: function() {
        var i = Y.isZero;
        return i(this._x) && i(this._y);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        var i = this._owner;
        return this === i._point ? 1 : this === i._handleIn ? 2 : this === i._handleOut ? 4 : 0;
      }
    }), Ve = a.extend(
      {
        _class: "Curve",
        beans: !0,
        initialize: function(i, n, r, l, h, f, m, _) {
          var y = arguments.length, x, A, B, C, M, R;
          y === 3 ? (this._path = i, x = n, A = r) : y ? y === 1 ? "segment1" in i ? (x = new at(i.segment1), A = new at(i.segment2)) : "point1" in i ? (B = i.point1, M = i.handle1, R = i.handle2, C = i.point2) : Array.isArray(i) && (B = [i[0], i[1]], C = [i[6], i[7]], M = [i[2] - i[0], i[3] - i[1]], R = [i[4] - i[6], i[5] - i[7]]) : y === 2 ? (x = new at(i), A = new at(n)) : y === 4 ? (B = i, M = n, R = r, C = l) : y === 8 && (B = [i, n], C = [m, _], M = [r - i, l - n], R = [h - m, f - _]) : (x = new at(), A = new at()), this._segment1 = x || new at(B, null, M), this._segment2 = A || new at(C, R, null);
        },
        _serialize: function(i, n) {
          return a.serialize(
            this.hasHandles() ? [
              this.getPoint1(),
              this.getHandle1(),
              this.getHandle2(),
              this.getPoint2()
            ] : [this.getPoint1(), this.getPoint2()],
            i,
            !0,
            n
          );
        },
        _changed: function() {
          this._length = this._bounds = t;
        },
        clone: function() {
          return new Ve(this._segment1, this._segment2);
        },
        toString: function() {
          var i = ["point1: " + this._segment1._point];
          return this._segment1._handleOut.isZero() || i.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || i.push("handle2: " + this._segment2._handleIn), i.push("point2: " + this._segment2._point), "{ " + i.join(", ") + " }";
        },
        classify: function() {
          return Ve.classify(this.getValues());
        },
        remove: function() {
          var i = !1;
          if (this._path) {
            var n = this._segment2, r = n._handleOut;
            i = n.remove(), i && this._segment1._handleOut.set(r);
          }
          return i;
        },
        getPoint1: function() {
          return this._segment1._point;
        },
        setPoint1: function() {
          this._segment1._point.set(z.read(arguments));
        },
        getPoint2: function() {
          return this._segment2._point;
        },
        setPoint2: function() {
          this._segment2._point.set(z.read(arguments));
        },
        getHandle1: function() {
          return this._segment1._handleOut;
        },
        setHandle1: function() {
          this._segment1._handleOut.set(z.read(arguments));
        },
        getHandle2: function() {
          return this._segment2._handleIn;
        },
        setHandle2: function() {
          this._segment2._handleIn.set(z.read(arguments));
        },
        getSegment1: function() {
          return this._segment1;
        },
        getSegment2: function() {
          return this._segment2;
        },
        getPath: function() {
          return this._path;
        },
        getIndex: function() {
          return this._segment1._index;
        },
        getNext: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index + 1] || this._path._closed && i[0]) || null;
        },
        getPrevious: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index - 1] || this._path._closed && i[i.length - 1]) || null;
        },
        isFirst: function() {
          return !this._segment1._index;
        },
        isLast: function() {
          var i = this._path;
          return i && this._segment1._index === i._curves.length - 1 || !1;
        },
        isSelected: function() {
          return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
        },
        setSelected: function(i) {
          this.getPoint1().setSelected(i), this.getHandle1().setSelected(i), this.getHandle2().setSelected(i), this.getPoint2().setSelected(i);
        },
        getValues: function(i) {
          return Ve.getValues(this._segment1, this._segment2, i);
        },
        getPoints: function() {
          for (var i = this.getValues(), n = [], r = 0; r < 8; r += 2)
            n.push(new z(i[r], i[r + 1]));
          return n;
        }
      },
      {
        getLength: function() {
          return this._length == null && (this._length = Ve.getLength(this.getValues(), 0, 1)), this._length;
        },
        getArea: function() {
          return Ve.getArea(this.getValues());
        },
        getLine: function() {
          return new xe(this._segment1._point, this._segment2._point);
        },
        getPart: function(i, n) {
          return new Ve(Ve.getPart(this.getValues(), i, n));
        },
        getPartLength: function(i, n) {
          return Ve.getLength(this.getValues(), i, n);
        },
        divideAt: function(i) {
          return this.divideAtTime(i && i.curve === this ? i.time : this.getTimeAt(i));
        },
        divideAtTime: function(i, n) {
          var r = 1e-8, l = 1 - r, h = null;
          if (i >= r && i <= l) {
            var f = Ve.subdivide(this.getValues(), i), m = f[0], _ = f[1], y = n || this.hasHandles(), x = this._segment1, A = this._segment2, B = this._path;
            y && (x._handleOut._set(m[2] - m[0], m[3] - m[1]), A._handleIn._set(_[4] - _[6], _[5] - _[7]));
            var C = m[6], M = m[7], R = new at(
              new z(C, M),
              y && new z(m[4] - C, m[5] - M),
              y && new z(_[2] - C, _[3] - M)
            );
            B ? (B.insert(x._index + 1, R), h = this.getNext()) : (this._segment2 = R, this._changed(), h = new Ve(R, A));
          }
          return h;
        },
        splitAt: function(i) {
          var n = this._path;
          return n ? n.splitAt(i) : null;
        },
        splitAtTime: function(i) {
          return this.splitAt(this.getLocationAtTime(i));
        },
        divide: function(i, n) {
          return this.divideAtTime(i === t ? 0.5 : n ? i : this.getTimeAt(i));
        },
        split: function(i, n) {
          return this.splitAtTime(i === t ? 0.5 : n ? i : this.getTimeAt(i));
        },
        reversed: function() {
          return new Ve(this._segment2.reversed(), this._segment1.reversed());
        },
        clearHandles: function() {
          this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
        },
        statics: {
          getValues: function(i, n, r, l) {
            var h = i._point, f = i._handleOut, m = n._handleIn, _ = n._point, y = h.x, x = h.y, A = _.x, B = _.y, C = l ? [y, x, y, x, A, B, A, B] : [
              y,
              x,
              y + f._x,
              x + f._y,
              A + m._x,
              B + m._y,
              A,
              B
            ];
            return r && r._transformCoordinates(C, C, 4), C;
          },
          subdivide: function(i, n) {
            var r = i[0], l = i[1], h = i[2], f = i[3], m = i[4], _ = i[5], y = i[6], x = i[7];
            n === t && (n = 0.5);
            var A = 1 - n, B = A * r + n * h, C = A * l + n * f, M = A * h + n * m, R = A * f + n * _, E = A * m + n * y, D = A * _ + n * x, L = A * B + n * M, P = A * C + n * R, S = A * M + n * E, I = A * R + n * D, U = A * L + n * S, V = A * P + n * I;
            return [
              [r, l, B, C, L, P, U, V],
              [U, V, S, I, E, D, y, x]
            ];
          },
          getMonoCurves: function(i, n) {
            var r = [], l = n ? 0 : 1, h = i[l + 0], f = i[l + 2], m = i[l + 4], _ = i[l + 6];
            if (h >= f == f >= m && f >= m == m >= _ || Ve.isStraight(i))
              r.push(i);
            else {
              var y = 3 * (f - m) - h + _, x = 2 * (h + m) - 4 * f, A = f - h, B = 1e-8, C = 1 - B, M = [], R = Y.solveQuadratic(y, x, A, M, B, C);
              if (!R)
                r.push(i);
              else {
                M.sort();
                var E = M[0], D = Ve.subdivide(i, E);
                r.push(D[0]), R > 1 && (E = (M[1] - E) / (1 - E), D = Ve.subdivide(D[1], E), r.push(D[0])), r.push(D[1]);
              }
            }
            return r;
          },
          solveCubic: function(i, n, r, l, h, f) {
            var m = i[n], _ = i[n + 2], y = i[n + 4], x = i[n + 6], A = 0;
            if (!(m < r && x < r && _ < r && y < r || m > r && x > r && _ > r && y > r)) {
              var B = 3 * (_ - m), C = 3 * (y - _) - B, M = x - m - B - C;
              A = Y.solveCubic(M, C, B, m - r, l, h, f);
            }
            return A;
          },
          getTimeOf: function(i, n) {
            var r = new z(i[0], i[1]), l = new z(i[6], i[7]), h = 1e-12, f = 1e-7, m = n.isClose(r, h) ? 0 : n.isClose(l, h) ? 1 : null;
            if (m === null)
              for (var _ = [n.x, n.y], y = [], x = 0; x < 2; x++)
                for (var A = Ve.solveCubic(i, x, _[x], y, 0, 1), B = 0; B < A; B++) {
                  var C = y[B];
                  if (n.isClose(Ve.getPoint(i, C), f))
                    return C;
                }
            return n.isClose(r, f) ? 0 : n.isClose(l, f) ? 1 : null;
          },
          getNearestTime: function(i, n) {
            if (Ve.isStraight(i)) {
              var r = i[0], l = i[1], h = i[6], f = i[7], m = h - r, _ = f - l, y = m * m + _ * _;
              if (y === 0)
                return 0;
              var x = ((n.x - r) * m + (n.y - l) * _) / y;
              return x < 1e-12 ? 0 : x > 0.999999999999 ? 1 : Ve.getTimeOf(
                i,
                new z(r + x * m, l + x * _)
              );
            }
            var A = 100, B = 1 / 0, C = 0;
            function M(D) {
              if (D >= 0 && D <= 1) {
                var L = n.getDistance(Ve.getPoint(i, D), !0);
                if (L < B)
                  return B = L, C = D, !0;
              }
            }
            for (var R = 0; R <= A; R++)
              M(R / A);
            for (var E = 1 / (A * 2); E > 1e-8; )
              !M(C - E) && !M(C + E) && (E /= 2);
            return C;
          },
          getPart: function(i, n, r) {
            var l = n > r;
            if (l) {
              var h = n;
              n = r, r = h;
            }
            return n > 0 && (i = Ve.subdivide(i, n)[1]), r < 1 && (i = Ve.subdivide(i, (r - n) / (1 - n))[0]), l ? [i[6], i[7], i[4], i[5], i[2], i[3], i[0], i[1]] : i;
          },
          isFlatEnough: function(i, n) {
            var r = i[0], l = i[1], h = i[2], f = i[3], m = i[4], _ = i[5], y = i[6], x = i[7], A = 3 * h - 2 * r - y, B = 3 * f - 2 * l - x, C = 3 * m - 2 * y - r, M = 3 * _ - 2 * x - l;
            return Math.max(A * A, C * C) + Math.max(B * B, M * M) <= 16 * n * n;
          },
          getArea: function(i) {
            var n = i[0], r = i[1], l = i[2], h = i[3], f = i[4], m = i[5], _ = i[6], y = i[7];
            return 3 * ((y - r) * (l + f) - (_ - n) * (h + m) + h * (n - f) - l * (r - m) + y * (f + n / 3) - _ * (m + r / 3)) / 20;
          },
          getBounds: function(i) {
            for (var n = i.slice(0, 2), r = n.slice(), l = [0, 0], h = 0; h < 2; h++)
              Ve._addBounds(
                i[h],
                i[h + 2],
                i[h + 4],
                i[h + 6],
                h,
                0,
                n,
                r,
                l
              );
            return new se(n[0], n[1], r[0] - n[0], r[1] - n[1]);
          },
          _addBounds: function(i, n, r, l, h, f, m, _, y) {
            function x(U, V) {
              var F = U - V, W = U + V;
              F < m[h] && (m[h] = F), W > _[h] && (_[h] = W);
            }
            f /= 2;
            var A = m[h] + f, B = _[h] - f;
            if (i < A || n < A || r < A || l < A || i > B || n > B || r > B || l > B)
              if (n < i != n < l && r < i != r < l)
                x(i, 0), x(l, 0);
              else {
                var C = 3 * (n - r) - i + l, M = 2 * (i + r) - 4 * n, R = n - i, E = Y.solveQuadratic(C, M, R, y), D = 1e-8, L = 1 - D;
                x(l, 0);
                for (var P = 0; P < E; P++) {
                  var S = y[P], I = 1 - S;
                  D <= S && S <= L && x(
                    I * I * I * i + 3 * I * I * S * n + 3 * I * S * S * r + S * S * S * l,
                    f
                  );
                }
              }
          }
        }
      },
      a.each(
        ["getBounds", "getStrokeBounds", "getHandleBounds"],
        function(i) {
          this[i] = function() {
            this._bounds || (this._bounds = {});
            var n = this._bounds[i];
            return n || (n = this._bounds[i] = Bt[i](
              [this._segment1, this._segment2],
              !1,
              this._path
            )), n.clone();
          };
        },
        {}
      ),
      a.each({
        isStraight: function(i, n, r, l) {
          if (n.isZero() && r.isZero())
            return !0;
          var h = l.subtract(i);
          if (h.isZero())
            return !1;
          if (h.isCollinear(n) && h.isCollinear(r)) {
            var f = new xe(i, l), m = 1e-7;
            if (f.getDistance(i.add(n)) < m && f.getDistance(l.add(r)) < m) {
              var _ = h.dot(h), y = h.dot(n) / _, x = h.dot(r) / _;
              return y >= 0 && y <= 1 && x <= 0 && x >= -1;
            }
          }
          return !1;
        },
        isLinear: function(i, n, r, l) {
          var h = l.subtract(i).divide(3);
          return n.equals(h) && r.negate().equals(h);
        }
      }, function(i, n) {
        this[n] = function(r) {
          var l = this._segment1, h = this._segment2;
          return i(
            l._point,
            l._handleOut,
            h._handleIn,
            h._point,
            r
          );
        }, this.statics[n] = function(r, l) {
          var h = r[0], f = r[1], m = r[6], _ = r[7];
          return i(
            new z(h, f),
            new z(r[2] - h, r[3] - f),
            new z(r[4] - m, r[5] - _),
            new z(m, _),
            l
          );
        };
      }, {
        statics: {},
        hasHandles: function() {
          return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
        },
        hasLength: function(i) {
          return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (i || 0);
        },
        isCollinear: function(i) {
          return i && this.isStraight() && i.isStraight() && this.getLine().isCollinear(i.getLine());
        },
        isHorizontal: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
        },
        isVertical: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
        }
      }),
      {
        beans: !1,
        getLocationAt: function(i, n) {
          return this.getLocationAtTime(
            n ? i : this.getTimeAt(i)
          );
        },
        getLocationAtTime: function(i) {
          return i != null && i >= 0 && i <= 1 ? new Ot(this, i) : null;
        },
        getTimeAt: function(i, n) {
          return Ve.getTimeAt(this.getValues(), i, n);
        },
        getParameterAt: "#getTimeAt",
        getTimesWithTangent: function() {
          var i = z.read(arguments);
          return i.isZero() ? [] : Ve.getTimesWithTangent(this.getValues(), i);
        },
        getOffsetAtTime: function(i) {
          return this.getPartLength(0, i);
        },
        getLocationOf: function() {
          return this.getLocationAtTime(this.getTimeOf(z.read(arguments)));
        },
        getOffsetOf: function() {
          var i = this.getLocationOf.apply(this, arguments);
          return i ? i.getOffset() : null;
        },
        getTimeOf: function() {
          return Ve.getTimeOf(this.getValues(), z.read(arguments));
        },
        getParameterOf: "#getTimeOf",
        getNearestLocation: function() {
          var i = z.read(arguments), n = this.getValues(), r = Ve.getNearestTime(n, i), l = Ve.getPoint(n, r);
          return new Ot(this, r, l, null, i.getDistance(l));
        },
        getNearestPoint: function() {
          var i = this.getNearestLocation.apply(this, arguments);
          return i && i.getPoint();
        }
      },
      new function() {
        var i = [
          "getPoint",
          "getTangent",
          "getNormal",
          "getWeightedTangent",
          "getWeightedNormal",
          "getCurvature"
        ];
        return a.each(
          i,
          function(n) {
            this[n + "At"] = function(r, l) {
              var h = this.getValues();
              return Ve[n](h, l ? r : Ve.getTimeAt(h, r));
            }, this[n + "AtTime"] = function(r) {
              return Ve[n](this.getValues(), r);
            };
          },
          {
            statics: {
              _evaluateMethods: i
            }
          }
        );
      }(),
      new function() {
        function i(l) {
          var h = l[0], f = l[1], m = l[2], _ = l[3], y = l[4], x = l[5], A = l[6], B = l[7], C = 9 * (m - y) + 3 * (A - h), M = 6 * (h + y) - 12 * m, R = 3 * (m - h), E = 9 * (_ - x) + 3 * (B - f), D = 6 * (f + x) - 12 * _, L = 3 * (_ - f);
          return function(P) {
            var S = (C * P + M) * P + R, I = (E * P + D) * P + L;
            return Math.sqrt(S * S + I * I);
          };
        }
        function n(l, h) {
          return Math.max(2, Math.min(16, Math.ceil(Math.abs(h - l) * 32)));
        }
        function r(l, h, f, m) {
          if (h == null || h < 0 || h > 1)
            return null;
          var _ = l[0], y = l[1], x = l[2], A = l[3], B = l[4], C = l[5], M = l[6], R = l[7], E = Y.isZero;
          E(x - _) && E(A - y) && (x = _, A = y), E(B - M) && E(C - R) && (B = M, C = R);
          var D = 3 * (x - _), L = 3 * (B - x) - D, P = M - _ - D - L, S = 3 * (A - y), I = 3 * (C - A) - S, U = R - y - S - I, V, F;
          if (f === 0)
            V = h === 0 ? _ : h === 1 ? M : ((P * h + L) * h + D) * h + _, F = h === 0 ? y : h === 1 ? R : ((U * h + I) * h + S) * h + y;
          else {
            var W = 1e-8, Q = 1 - W;
            if (h < W ? (V = D, F = S) : h > Q ? (V = 3 * (M - B), F = 3 * (R - C)) : (V = (3 * P * h + 2 * L) * h + D, F = (3 * U * h + 2 * I) * h + S), m) {
              V === 0 && F === 0 && (h < W || h > Q) && (V = B - x, F = C - A);
              var ie = Math.sqrt(V * V + F * F);
              ie && (V /= ie, F /= ie);
            }
            if (f === 3) {
              var B = 6 * P * h + 2 * L, C = 6 * U * h + 2 * I, ae = Math.pow(V * V + F * F, 3 / 2);
              V = ae !== 0 ? (V * C - F * B) / ae : 0, F = 0;
            }
          }
          return f === 2 ? new z(F, -V) : new z(V, F);
        }
        return { statics: {
          classify: function(l) {
            var h = l[0], f = l[1], m = l[2], _ = l[3], y = l[4], x = l[5], A = l[6], B = l[7], C = h * (B - x) + f * (y - A) + A * x - B * y, M = m * (f - B) + _ * (A - h) + h * B - f * A, R = y * (_ - f) + x * (h - m) + m * f - _ * h, E = 3 * R, D = E - M, L = D - M + C, P = Math.sqrt(L * L + D * D + E * E), S = P !== 0 ? 1 / P : 0, I = Y.isZero, U = "serpentine";
            L *= S, D *= S, E *= S;
            function V(ie, ae, J) {
              var le = ae !== t, fe = le && ae > 0 && ae < 1, me = le && J > 0 && J < 1;
              return le && (!(fe || me) || ie === "loop" && !(fe && me)) && (ie = "arch", fe = me = !1), {
                type: ie,
                roots: fe || me ? fe && me ? ae < J ? [ae, J] : [J, ae] : [fe ? ae : J] : null
              };
            }
            if (I(L))
              return I(D) ? V(I(E) ? "line" : "quadratic") : V(U, E / (3 * D));
            var F = 3 * D * D - 4 * L * E;
            if (I(F))
              return V("cusp", D / (2 * L));
            var W = F > 0 ? Math.sqrt(F / 3) : Math.sqrt(-F), Q = 2 * L;
            return V(
              F > 0 ? U : "loop",
              (D + W) / Q,
              (D - W) / Q
            );
          },
          getLength: function(l, h, f, m) {
            if (h === t && (h = 0), f === t && (f = 1), Ve.isStraight(l)) {
              var _ = l;
              f < 1 && (_ = Ve.subdivide(_, f)[0], h /= f), h > 0 && (_ = Ve.subdivide(_, h)[1]);
              var y = _[6] - _[0], x = _[7] - _[1];
              return Math.sqrt(y * y + x * x);
            }
            return Y.integrate(
              m || i(l),
              h,
              f,
              n(h, f)
            );
          },
          getTimeAt: function(l, h, f) {
            if (f === t && (f = h < 0 ? 1 : 0), h === 0)
              return f;
            var m = Math.abs, _ = 1e-12, y = h > 0, x = y ? f : 0, A = y ? 1 : f, B = i(l), C = Ve.getLength(l, x, A, B), M = m(h) - C;
            if (m(M) < _)
              return y ? A : x;
            if (M > _)
              return null;
            var R = h / C, E = 0;
            function D(L) {
              return E += Y.integrate(
                B,
                f,
                L,
                n(f, L)
              ), f = L, E - h;
            }
            return Y.findRoot(
              D,
              B,
              f + R,
              x,
              A,
              32,
              1e-12
            );
          },
          getPoint: function(l, h) {
            return r(l, h, 0, !1);
          },
          getTangent: function(l, h) {
            return r(l, h, 1, !0);
          },
          getWeightedTangent: function(l, h) {
            return r(l, h, 1, !1);
          },
          getNormal: function(l, h) {
            return r(l, h, 2, !0);
          },
          getWeightedNormal: function(l, h) {
            return r(l, h, 2, !1);
          },
          getCurvature: function(l, h) {
            return r(l, h, 3, !1).x;
          },
          getPeaks: function(l) {
            var h = l[0], f = l[1], m = l[2], _ = l[3], y = l[4], x = l[5], A = l[6], B = l[7], C = -h + 3 * m - 3 * y + A, M = 3 * h - 6 * m + 3 * y, R = -3 * h + 3 * m, E = -f + 3 * _ - 3 * x + B, D = 3 * f - 6 * _ + 3 * x, L = -3 * f + 3 * _, P = 1e-8, S = 1 - P, I = [];
            return Y.solveCubic(
              9 * (C * C + E * E),
              9 * (C * M + D * E),
              2 * (M * M + D * D) + 3 * (R * C + L * E),
              R * M + D * L,
              I,
              P,
              S
            ), I.sort();
          }
        } };
      }(),
      new function() {
        function i(M, R, E, D, L, P, S) {
          var I = !S && E.getPrevious() === L, U = !S && E !== L && E.getNext() === L, V = 1e-8, F = 1 - V;
          if (D !== null && D >= (I ? V : 0) && D <= (U ? F : 1) && P !== null && P >= (U ? V : 0) && P <= (I ? F : 1)) {
            var W = new Ot(E, D, null, S), Q = new Ot(L, P, null, S);
            W._intersection = Q, Q._intersection = W, (!R || R(W)) && Ot.insert(M, W, !0);
          }
        }
        function n(M, R, E, D, L, P, S, I, U, V, F, W, Q) {
          if (++U >= 4096 || ++I >= 40)
            return U;
          var ie = 1e-9, ae = R[0], J = R[1], le = R[6], fe = R[7], me = xe.getSignedDistance, ve = me(ae, J, le, fe, R[2], R[3]), Se = me(ae, J, le, fe, R[4], R[5]), Re = ve * Se > 0 ? 3 / 4 : 4 / 9, He = Re * Math.min(0, ve, Se), Ye = Re * Math.max(0, ve, Se), Je = me(ae, J, le, fe, M[0], M[1]), Be = me(ae, J, le, fe, M[2], M[3]), Ie = me(ae, J, le, fe, M[4], M[5]), Ge = me(ae, J, le, fe, M[6], M[7]), et = r(Je, Be, Ie, Ge), tt = et[0], gt = et[1], ut, yt;
          if (ve === 0 && Se === 0 && Je === 0 && Be === 0 && Ie === 0 && Ge === 0 || (ut = l(tt, gt, He, Ye)) == null || (yt = l(
            tt.reverse(),
            gt.reverse(),
            He,
            Ye
          )) == null)
            return U;
          var At = V + (F - V) * ut, bt = V + (F - V) * yt;
          if (Math.max(Q - W, bt - At) < ie) {
            var li = (At + bt) / 2, mt = (W + Q) / 2;
            i(
              L,
              P,
              S ? D : E,
              S ? mt : li,
              S ? E : D,
              S ? li : mt
            );
          } else {
            M = Ve.getPart(M, ut, yt);
            var Zt = Q - W;
            if (yt - ut > 0.8)
              if (bt - At > Zt) {
                var Xt = Ve.subdivide(M, 0.5), li = (At + bt) / 2;
                U = n(
                  R,
                  Xt[0],
                  D,
                  E,
                  L,
                  P,
                  !S,
                  I,
                  U,
                  W,
                  Q,
                  At,
                  li
                ), U = n(
                  R,
                  Xt[1],
                  D,
                  E,
                  L,
                  P,
                  !S,
                  I,
                  U,
                  W,
                  Q,
                  li,
                  bt
                );
              } else {
                var Xt = Ve.subdivide(R, 0.5), mt = (W + Q) / 2;
                U = n(
                  Xt[0],
                  M,
                  D,
                  E,
                  L,
                  P,
                  !S,
                  I,
                  U,
                  W,
                  mt,
                  At,
                  bt
                ), U = n(
                  Xt[1],
                  M,
                  D,
                  E,
                  L,
                  P,
                  !S,
                  I,
                  U,
                  mt,
                  Q,
                  At,
                  bt
                );
              }
            else
              Zt === 0 || Zt >= ie ? U = n(
                R,
                M,
                D,
                E,
                L,
                P,
                !S,
                I,
                U,
                W,
                Q,
                At,
                bt
              ) : U = n(
                M,
                R,
                E,
                D,
                L,
                P,
                S,
                I,
                U,
                At,
                bt,
                W,
                Q
              );
          }
          return U;
        }
        function r(M, R, E, D) {
          var L = [0, M], P = [1 / 3, R], S = [2 / 3, E], I = [1, D], U = R - (2 * M + D) / 3, V = E - (M + 2 * D) / 3, F;
          if (U * V < 0)
            F = [[L, P, I], [L, S, I]];
          else {
            var W = U / V;
            F = [
              W >= 2 ? [L, P, I] : W <= 0.5 ? [L, S, I] : [L, P, S, I],
              [L, I]
            ];
          }
          return (U || V) < 0 ? F.reverse() : F;
        }
        function l(M, R, E, D) {
          return M[0][1] < E ? h(M, !0, E) : R[0][1] > D ? h(R, !1, D) : M[0][0];
        }
        function h(M, R, E) {
          for (var D = M[0][0], L = M[0][1], P = 1, S = M.length; P < S; P++) {
            var I = M[P][0], U = M[P][1];
            if (R ? U >= E : U <= E)
              return U === E ? I : D + (E - L) * (I - D) / (U - L);
            D = I, L = U;
          }
          return null;
        }
        function f(M, R, E, D, L) {
          var P = Y.isZero;
          if (P(D) && P(L)) {
            var S = Ve.getTimeOf(M, new z(R, E));
            return S === null ? [] : [S];
          }
          for (var I = Math.atan2(-L, D), U = Math.sin(I), V = Math.cos(I), F = [], W = [], Q = 0; Q < 8; Q += 2) {
            var ie = M[Q] - R, ae = M[Q + 1] - E;
            F.push(
              ie * V - ae * U,
              ie * U + ae * V
            );
          }
          return Ve.solveCubic(F, 1, 0, W, 0, 1), W;
        }
        function m(M, R, E, D, L, P, S) {
          for (var I = R[0], U = R[1], V = R[6], F = R[7], W = f(M, I, U, V - I, F - U), Q = 0, ie = W.length; Q < ie; Q++) {
            var ae = W[Q], J = Ve.getPoint(M, ae), le = Ve.getTimeOf(R, J);
            le !== null && i(
              L,
              P,
              S ? D : E,
              S ? le : ae,
              S ? E : D,
              S ? ae : le
            );
          }
        }
        function _(M, R, E, D, L, P) {
          var S = xe.intersect(
            M[0],
            M[1],
            M[6],
            M[7],
            R[0],
            R[1],
            R[6],
            R[7]
          );
          S && i(
            L,
            P,
            E,
            Ve.getTimeOf(M, S),
            D,
            Ve.getTimeOf(R, S)
          );
        }
        function y(M, R, E, D, L, P) {
          var S = 1e-12, I = Math.min, U = Math.max;
          if (U(M[0], M[2], M[4], M[6]) + S > I(R[0], R[2], R[4], R[6]) && I(M[0], M[2], M[4], M[6]) - S < U(R[0], R[2], R[4], R[6]) && U(M[1], M[3], M[5], M[7]) + S > I(R[1], R[3], R[5], R[7]) && I(M[1], M[3], M[5], M[7]) - S < U(R[1], R[3], R[5], R[7])) {
            var V = B(M, R);
            if (V)
              for (var F = 0; F < 2; F++) {
                var W = V[F];
                i(
                  L,
                  P,
                  E,
                  W[0],
                  D,
                  W[1],
                  !0
                );
              }
            else {
              var Q = Ve.isStraight(M), ie = Ve.isStraight(R), ae = Q && ie, J = Q && !ie, le = L.length;
              if ((ae ? _ : Q || ie ? m : n)(
                J ? R : M,
                J ? M : R,
                J ? D : E,
                J ? E : D,
                L,
                P,
                J,
                0,
                0,
                0,
                1,
                0,
                1
              ), !ae || L.length === le)
                for (var F = 0; F < 4; F++) {
                  var fe = F >> 1, me = F & 1, ve = fe * 6, Se = me * 6, Re = new z(M[ve], M[ve + 1]), He = new z(R[Se], R[Se + 1]);
                  Re.isClose(He, S) && i(
                    L,
                    P,
                    E,
                    fe,
                    D,
                    me
                  );
                }
            }
          }
          return L;
        }
        function x(M, R, E, D) {
          var L = Ve.classify(M);
          if (L.type === "loop") {
            var P = L.roots;
            i(
              E,
              D,
              R,
              P[0],
              R,
              P[1]
            );
          }
          return E;
        }
        function A(M, R, E, D, L, P) {
          var S = 1e-7, I = !R;
          I && (R = M);
          for (var U = M.length, V = R.length, F = new Array(U), W = I ? F : new Array(V), Q = [], ie = 0; ie < U; ie++)
            F[ie] = M[ie].getValues(D);
          if (!I)
            for (var ie = 0; ie < V; ie++)
              W[ie] = R[ie].getValues(L);
          for (var ae = T.findCurveBoundsCollisions(
            F,
            W,
            S
          ), J = 0; J < U; J++) {
            var le = M[J], fe = F[J];
            I && x(fe, le, Q, E);
            var me = ae[J];
            if (me)
              for (var ve = 0; ve < me.length; ve++) {
                if (P && Q.length)
                  return Q;
                var Se = me[ve];
                if (!I || Se > J) {
                  var Re = R[Se], He = W[Se];
                  y(
                    fe,
                    He,
                    le,
                    Re,
                    Q,
                    E
                  );
                }
              }
          }
          return Q;
        }
        function B(M, R) {
          function E(Ge) {
            var et = Ge[6] - Ge[0], tt = Ge[7] - Ge[1];
            return et * et + tt * tt;
          }
          var D = Math.abs, L = xe.getDistance, P = 1e-8, S = 1e-7, I = Ve.isStraight(M), U = Ve.isStraight(R), V = I && U, F = E(M) < E(R), W = F ? R : M, Q = F ? M : R, ie = W[0], ae = W[1], J = W[6] - ie, le = W[7] - ae;
          if (L(ie, ae, J, le, Q[0], Q[1], !0) < S && L(ie, ae, J, le, Q[6], Q[7], !0) < S)
            !V && L(ie, ae, J, le, W[2], W[3], !0) < S && L(ie, ae, J, le, W[4], W[5], !0) < S && L(ie, ae, J, le, Q[2], Q[3], !0) < S && L(ie, ae, J, le, Q[4], Q[5], !0) < S && (I = U = V = !0);
          else if (V)
            return null;
          if (I ^ U)
            return null;
          for (var fe = [M, R], me = [], ve = 0; ve < 4 && me.length < 2; ve++) {
            var Se = ve & 1, Re = Se ^ 1, He = ve >> 1, Ye = Ve.getTimeOf(fe[Se], new z(
              fe[Re][He ? 6 : 0],
              fe[Re][He ? 7 : 1]
            ));
            if (Ye != null) {
              var Je = Se ? [He, Ye] : [Ye, He];
              (!me.length || D(Je[0] - me[0][0]) > P && D(Je[1] - me[0][1]) > P) && me.push(Je);
            }
            if (ve > 2 && !me.length)
              break;
          }
          if (me.length !== 2)
            me = null;
          else if (!V) {
            var Be = Ve.getPart(M, me[0][0], me[1][0]), Ie = Ve.getPart(R, me[0][1], me[1][1]);
            (D(Ie[2] - Be[2]) > S || D(Ie[3] - Be[3]) > S || D(Ie[4] - Be[4]) > S || D(Ie[5] - Be[5]) > S) && (me = null);
          }
          return me;
        }
        function C(M, R) {
          var E = M[0], D = M[1], L = M[2], P = M[3], S = M[4], I = M[5], U = M[6], V = M[7], F = R.normalize(), W = F.x, Q = F.y, ie = 3 * U - 9 * S + 9 * L - 3 * E, ae = 3 * V - 9 * I + 9 * P - 3 * D, J = 6 * S - 12 * L + 6 * E, le = 6 * I - 12 * P + 6 * D, fe = 3 * L - 3 * E, me = 3 * P - 3 * D, ve = 2 * ie * Q - 2 * ae * W, Se = [];
          if (Math.abs(ve) < Y.CURVETIME_EPSILON) {
            var Re = ie * me - ae * fe, ve = ie * le - ae * J;
            if (ve != 0) {
              var He = -Re / ve;
              He >= 0 && He <= 1 && Se.push(He);
            }
          } else {
            var Ye = (J * J - 4 * ie * fe) * Q * Q + (-2 * J * le + 4 * ae * fe + 4 * ie * me) * W * Q + (le * le - 4 * ae * me) * W * W, Je = J * Q - le * W;
            if (Ye >= 0 && ve != 0) {
              var Be = Math.sqrt(Ye), Ie = -(Je + Be) / ve, Ge = (-Je + Be) / ve;
              Ie >= 0 && Ie <= 1 && Se.push(Ie), Ge >= 0 && Ge <= 1 && Se.push(Ge);
            }
          }
          return Se;
        }
        return {
          getIntersections: function(M) {
            var R = this.getValues(), E = M && M !== this && M.getValues();
            return E ? y(R, E, this, M, []) : x(R, this, []);
          },
          statics: {
            getOverlaps: B,
            getIntersections: A,
            getCurveLineIntersections: f,
            getTimesWithTangent: C
          }
        };
      }()
    ), Ot = a.extend(
      {
        _class: "CurveLocation",
        initialize: function(i, n, r, l, h) {
          if (n >= 0.99999999) {
            var f = i.getNext();
            f && (n = 0, i = f);
          }
          this._setCurve(i), this._time = n, this._point = r || i.getPointAtTime(n), this._overlap = l, this._distance = h, this._intersection = this._next = this._previous = null;
        },
        _setPath: function(i) {
          this._path = i, this._version = i ? i._version : 0;
        },
        _setCurve: function(i) {
          this._setPath(i._path), this._curve = i, this._segment = null, this._segment1 = i._segment1, this._segment2 = i._segment2;
        },
        _setSegment: function(i) {
          var n = i.getCurve();
          n ? this._setCurve(n) : (this._setPath(i._path), this._segment1 = i, this._segment2 = null), this._segment = i, this._time = i === this._segment1 ? 0 : 1, this._point = i._point.clone();
        },
        getSegment: function() {
          var i = this._segment;
          if (!i) {
            var n = this.getCurve(), r = this.getTime();
            r === 0 ? i = n._segment1 : r === 1 ? i = n._segment2 : r != null && (i = n.getPartLength(0, r) < n.getPartLength(r, 1) ? n._segment1 : n._segment2), this._segment = i;
          }
          return i;
        },
        getCurve: function() {
          var i = this._path, n = this;
          i && i._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
          function r(l) {
            var h = l && l.getCurve();
            if (h && (n._time = h.getTimeOf(n._point)) != null)
              return n._setCurve(h), h;
          }
          return this._curve || r(this._segment) || r(this._segment1) || r(this._segment2.getPrevious());
        },
        getPath: function() {
          var i = this.getCurve();
          return i && i._path;
        },
        getIndex: function() {
          var i = this.getCurve();
          return i && i.getIndex();
        },
        getTime: function() {
          var i = this.getCurve(), n = this._time;
          return i && n == null ? this._time = i.getTimeOf(this._point) : n;
        },
        getParameter: "#getTime",
        getPoint: function() {
          return this._point;
        },
        getOffset: function() {
          var i = this._offset;
          if (i == null) {
            i = 0;
            var n = this.getPath(), r = this.getIndex();
            if (n && r != null)
              for (var l = n.getCurves(), h = 0; h < r; h++)
                i += l[h].getLength();
            this._offset = i += this.getCurveOffset();
          }
          return i;
        },
        getCurveOffset: function() {
          var i = this._curveOffset;
          if (i == null) {
            var n = this.getCurve(), r = this.getTime();
            this._curveOffset = i = r != null && n && n.getPartLength(0, r);
          }
          return i;
        },
        getIntersection: function() {
          return this._intersection;
        },
        getDistance: function() {
          return this._distance;
        },
        divide: function() {
          var i = this.getCurve(), n = i && i.divideAtTime(this.getTime());
          return n && this._setSegment(n._segment1), n;
        },
        split: function() {
          var i = this.getCurve(), n = i._path, r = i && i.splitAtTime(this.getTime());
          return r && this._setSegment(n.getLastSegment()), r;
        },
        equals: function(i, n) {
          var r = this === i;
          if (!r && i instanceof Ot) {
            var l = this.getCurve(), h = i.getCurve(), f = l._path, m = h._path;
            if (f === m) {
              var _ = Math.abs, y = 1e-7, x = _(this.getOffset() - i.getOffset()), A = !n && this._intersection, B = !n && i._intersection;
              r = (x < y || f && _(f.getLength() - x) < y) && (!A && !B || A && B && A.equals(B, !0));
            }
          }
          return r;
        },
        toString: function() {
          var i = [], n = this.getPoint(), r = H.instance;
          n && i.push("point: " + n);
          var l = this.getIndex();
          l != null && i.push("index: " + l);
          var h = this.getTime();
          return h != null && i.push("time: " + r.number(h)), this._distance != null && i.push("distance: " + r.number(this._distance)), "{ " + i.join(", ") + " }";
        },
        isTouching: function() {
          var i = this._intersection;
          if (i && this.getTangent().isCollinear(i.getTangent())) {
            var n = this.getCurve(), r = i.getCurve();
            return !(n.isStraight() && r.isStraight() && n.getLine().intersect(r.getLine()));
          }
          return !1;
        },
        isCrossing: function() {
          var i = this._intersection;
          if (!i)
            return !1;
          var n = this.getTime(), r = i.getTime(), l = 1e-8, h = 1 - l, f = n >= l && n <= h, m = r >= l && r <= h;
          if (f && m)
            return !this.isTouching();
          var _ = this.getCurve(), y = _ && n < l ? _.getPrevious() : _, x = i.getCurve(), A = x && r < l ? x.getPrevious() : x;
          if (n > h && (_ = _.getNext()), r > h && (x = x.getNext()), !y || !_ || !A || !x)
            return !1;
          var B = [];
          function C(W, Q) {
            var ie = W.getValues(), ae = Ve.classify(ie).roots || Ve.getPeaks(ie), J = ae.length, le = Ve.getLength(
              ie,
              Q && J ? ae[J - 1] : 0,
              !Q && J ? ae[0] : 1
            );
            B.push(J ? le : le / 32);
          }
          function M(W, Q, ie) {
            return Q < ie ? W > Q && W < ie : W > Q || W < ie;
          }
          f || (C(y, !0), C(_, !1)), m || (C(A, !0), C(x, !1));
          var R = this.getPoint(), E = Math.min.apply(Math, B), D = f ? _.getTangentAtTime(n) : _.getPointAt(E).subtract(R), L = f ? D.negate() : y.getPointAt(-E).subtract(R), P = m ? x.getTangentAtTime(r) : x.getPointAt(E).subtract(R), S = m ? P.negate() : A.getPointAt(-E).subtract(R), I = L.getAngle(), U = D.getAngle(), V = S.getAngle(), F = P.getAngle();
          return !!(f ? M(I, V, F) ^ M(U, V, F) && M(I, F, V) ^ M(U, F, V) : M(V, I, U) ^ M(F, I, U) && M(V, U, I) ^ M(F, U, I));
        },
        hasOverlap: function() {
          return !!this._overlap;
        }
      },
      a.each(Ve._evaluateMethods, function(i) {
        var n = i + "At";
        this[i] = function() {
          var r = this.getCurve(), l = this.getTime();
          return l != null && r && r[n](l, !0);
        };
      }, {
        preserve: !0
      }),
      new function() {
        function i(n, r, l) {
          var h = n.length, f = 0, m = h - 1;
          function _(R, E) {
            for (var D = R + E; D >= -1 && D <= h; D += E) {
              var L = n[(D % h + h) % h];
              if (!r.getPoint().isClose(
                L.getPoint(),
                1e-7
              ))
                break;
              if (r.equals(L))
                return L;
            }
            return null;
          }
          for (; f <= m; ) {
            var y = f + m >>> 1, x = n[y], A;
            if (l && (A = r.equals(x) ? x : _(y, -1) || _(y, 1)))
              return r._overlap && (A._overlap = A._intersection._overlap = !0), A;
            var B = r.getPath(), C = x.getPath(), M = B !== C ? B._id - C._id : r.getIndex() + r.getTime() - (x.getIndex() + x.getTime());
            M < 0 ? m = y - 1 : f = y + 1;
          }
          return n.splice(f, 0, r), r;
        }
        return { statics: {
          insert: i,
          expand: function(n) {
            for (var r = n.slice(), l = n.length - 1; l >= 0; l--)
              i(r, n[l]._intersection, !1);
            return r;
          }
        } };
      }()
    ), Ft = K.extend({
      _class: "PathItem",
      _selectBounds: !1,
      _canScaleStroke: !0,
      beans: !0,
      initialize: function() {
      },
      statics: {
        create: function(i) {
          var n, r, l;
          if (a.isPlainObject(i) ? (r = i.segments, n = i.pathData) : Array.isArray(i) ? r = i : typeof i == "string" && (n = i), r) {
            var h = r[0];
            l = h && Array.isArray(h[0]);
          } else
            n && (l = (n.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(n));
          var f = l ? yi : Bt;
          return new f(i);
        }
      },
      _asPathItem: function() {
        return this;
      },
      isClockwise: function() {
        return this.getArea() >= 0;
      },
      setClockwise: function(i) {
        this.isClockwise() != (i = !!i) && this.reverse();
      },
      setPathData: function(i) {
        var n = i && i.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), r, l = !1, h, f, m = new z(), _ = new z();
        function y(S, I) {
          var U = +r[S];
          return l && (U += m[I]), U;
        }
        function x(S) {
          return new z(
            y(S, "x"),
            y(S + 1, "y")
          );
        }
        this.clear();
        for (var A = 0, B = n && n.length; A < B; A++) {
          var C = n[A], M = C[0], R = M.toLowerCase();
          r = C.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
          var E = r && r.length;
          switch (l = M === R, h === "z" && !/[mz]/.test(R) && this.moveTo(m), R) {
            case "m":
            case "l":
              for (var D = R === "m", L = 0; L < E; L += 2)
                this[D ? "moveTo" : "lineTo"](m = x(L)), D && (_ = m, D = !1);
              f = m;
              break;
            case "h":
            case "v":
              var P = R === "h" ? "x" : "y";
              m = m.clone();
              for (var L = 0; L < E; L++)
                m[P] = y(L, P), this.lineTo(m);
              f = m;
              break;
            case "c":
              for (var L = 0; L < E; L += 6)
                this.cubicCurveTo(
                  x(L),
                  f = x(L + 2),
                  m = x(L + 4)
                );
              break;
            case "s":
              for (var L = 0; L < E; L += 4)
                this.cubicCurveTo(
                  /[cs]/.test(h) ? m.multiply(2).subtract(f) : m,
                  f = x(L),
                  m = x(L + 2)
                ), h = R;
              break;
            case "q":
              for (var L = 0; L < E; L += 4)
                this.quadraticCurveTo(
                  f = x(L),
                  m = x(L + 2)
                );
              break;
            case "t":
              for (var L = 0; L < E; L += 2)
                this.quadraticCurveTo(
                  f = /[qt]/.test(h) ? m.multiply(2).subtract(f) : m,
                  m = x(L)
                ), h = R;
              break;
            case "a":
              for (var L = 0; L < E; L += 7)
                this.arcTo(
                  m = x(L + 5),
                  new ne(+r[L], +r[L + 1]),
                  +r[L + 2],
                  +r[L + 4],
                  +r[L + 3]
                );
              break;
            case "z":
              this.closePath(1e-12), m = _;
              break;
          }
          h = R;
        }
      },
      _canComposite: function() {
        return !(this.hasFill() && this.hasStroke());
      },
      _contains: function(i) {
        var n = i.isInside(
          this.getBounds({ internal: !0, handle: !0 })
        ) ? this._getWinding(i) : {};
        return n.onPath || !!(this.getFillRule() === "evenodd" ? n.windingL & 1 || n.windingR & 1 : n.winding);
      },
      getIntersections: function(i, n, r, l) {
        var h = this === i || !i, f = this._matrix._orNullIfIdentity(), m = h ? f : (r || i._matrix)._orNullIfIdentity();
        return h || this.getBounds(f).intersects(
          i.getBounds(m),
          1e-12
        ) ? Ve.getIntersections(
          this.getCurves(),
          !h && i.getCurves(),
          n,
          f,
          m,
          l
        ) : [];
      },
      getCrossings: function(i) {
        return this.getIntersections(i, function(n) {
          return n.isCrossing();
        });
      },
      getNearestLocation: function() {
        for (var i = z.read(arguments), n = this.getCurves(), r = 1 / 0, l = null, h = 0, f = n.length; h < f; h++) {
          var m = n[h].getNearestLocation(i);
          m._distance < r && (r = m._distance, l = m);
        }
        return l;
      },
      getNearestPoint: function() {
        var i = this.getNearestLocation.apply(this, arguments);
        return i && i.getPoint();
      },
      interpolate: function(i, n, r) {
        var l = !this._children, h = l ? "_segments" : "_children", f = i[h], m = n[h], _ = this[h];
        if (!f || !m || f.length !== m.length)
          throw new Error("Invalid operands in interpolate() call: " + i + ", " + n);
        var y = _.length, x = m.length;
        if (y < x)
          for (var A = l ? at : Bt, B = y; B < x; B++)
            this.add(new A());
        else
          y > x && this[l ? "removeSegments" : "removeChildren"](x, y);
        for (var B = 0; B < x; B++)
          _[B].interpolate(f[B], m[B], r);
        l && (this.setClosed(i._closed), this._changed(9));
      },
      compare: function(i) {
        var n = !1;
        if (i) {
          var r = this._children || [this], l = i._children ? i._children.slice() : [i], h = r.length, f = l.length, m = [], _ = 0;
          n = !0;
          for (var y = T.findItemBoundsCollisions(r, l, Y.GEOMETRIC_EPSILON), x = h - 1; x >= 0 && n; x--) {
            var A = r[x];
            n = !1;
            var B = y[x];
            if (B)
              for (var C = B.length - 1; C >= 0 && !n; C--)
                A.compare(l[B[C]]) && (m[B[C]] || (m[B[C]] = !0, _++), n = !0);
          }
          n = n && _ === f;
        }
        return n;
      }
    }), Bt = Ft.extend(
      {
        _class: "Path",
        _serializeFields: {
          segments: [],
          closed: !1
        },
        initialize: function(i) {
          this._closed = !1, this._segments = [], this._version = 0;
          var n = arguments, r = Array.isArray(i) ? typeof i[0] == "object" ? i : n : i && i.size === t && (i.x !== t || i.point !== t) ? n : null;
          r && r.length > 0 ? this.setSegments(r) : (this._curves = t, this._segmentSelection = 0, !r && typeof i == "string" && (this.setPathData(i), i = null)), this._initialize(!r && i);
        },
        _equals: function(i) {
          return this._closed === i._closed && a.equals(this._segments, i._segments);
        },
        copyContent: function(i) {
          this.setSegments(i._segments), this._closed = i._closed;
        },
        _changed: function i(n) {
          if (i.base.call(this, n), n & 8) {
            if (this._length = this._area = t, n & 32)
              this._version++;
            else if (this._curves)
              for (var r = 0, l = this._curves.length; r < l; r++)
                this._curves[r]._changed();
          } else
            n & 64 && (this._bounds = t);
        },
        getStyle: function() {
          var i = this._parent;
          return (i instanceof yi ? i : this)._style;
        },
        getSegments: function() {
          return this._segments;
        },
        setSegments: function(i) {
          var n = this.isFullySelected(), r = i && i.length;
          if (this._segments.length = 0, this._segmentSelection = 0, this._curves = t, r) {
            var l = i[r - 1];
            typeof l == "boolean" && (this.setClosed(l), r--), this._add(at.readList(i, 0, {}, r));
          }
          n && this.setFullySelected(!0);
        },
        getFirstSegment: function() {
          return this._segments[0];
        },
        getLastSegment: function() {
          return this._segments[this._segments.length - 1];
        },
        getCurves: function() {
          var i = this._curves, n = this._segments;
          if (!i) {
            var r = this._countCurves();
            i = this._curves = new Array(r);
            for (var l = 0; l < r; l++)
              i[l] = new Ve(
                this,
                n[l],
                n[l + 1] || n[0]
              );
          }
          return i;
        },
        getFirstCurve: function() {
          return this.getCurves()[0];
        },
        getLastCurve: function() {
          var i = this.getCurves();
          return i[i.length - 1];
        },
        isClosed: function() {
          return this._closed;
        },
        setClosed: function(i) {
          if (this._closed != (i = !!i)) {
            if (this._closed = i, this._curves) {
              var n = this._curves.length = this._countCurves();
              i && (this._curves[n - 1] = new Ve(
                this,
                this._segments[n - 1],
                this._segments[0]
              ));
            }
            this._changed(41);
          }
        }
      },
      {
        beans: !0,
        getPathData: function(i, n) {
          var r = this._segments, l = r.length, h = new H(n), f = new Array(6), m = !0, _, y, x, A, B, C, M, R, E = [];
          function D(P, S) {
            if (P._transformCoordinates(i, f), _ = f[0], y = f[1], m)
              E.push("M" + h.pair(_, y)), m = !1;
            else if (B = f[2], C = f[3], B === _ && C === y && M === x && R === A) {
              if (!S) {
                var I = _ - x, U = y - A;
                E.push(
                  I === 0 ? "v" + h.number(U) : U === 0 ? "h" + h.number(I) : "l" + h.pair(I, U)
                );
              }
            } else
              E.push("c" + h.pair(M - x, R - A) + " " + h.pair(B - x, C - A) + " " + h.pair(_ - x, y - A));
            x = _, A = y, M = f[4], R = f[5];
          }
          if (!l)
            return "";
          for (var L = 0; L < l; L++)
            D(r[L]);
          return this._closed && l > 0 && (D(r[0], !0), E.push("z")), E.join("");
        },
        isEmpty: function() {
          return !this._segments.length;
        },
        _transformContent: function(i) {
          for (var n = this._segments, r = new Array(6), l = 0, h = n.length; l < h; l++)
            n[l]._transformCoordinates(i, r, !0);
          return !0;
        },
        _add: function(i, n) {
          for (var r = this._segments, l = this._curves, h = i.length, f = n == null, n = f ? r.length : n, m = 0; m < h; m++) {
            var _ = i[m];
            _._path && (_ = i[m] = _.clone()), _._path = this, _._index = n + m, _._selection && this._updateSelection(_, 0, _._selection);
          }
          if (f)
            a.push(r, i);
          else {
            r.splice.apply(r, [n, 0].concat(i));
            for (var m = n + h, y = r.length; m < y; m++)
              r[m]._index = m;
          }
          if (l) {
            var x = this._countCurves(), A = n > 0 && n + h - 1 === x ? n - 1 : n, B = A, C = Math.min(A + h, x);
            i._curves && (l.splice.apply(l, [A, 0].concat(i._curves)), B += i._curves.length);
            for (var m = B; m < C; m++)
              l.splice(m, 0, new Ve(this, null, null));
            this._adjustCurves(A, C);
          }
          return this._changed(41), i;
        },
        _adjustCurves: function(i, n) {
          for (var r = this._segments, l = this._curves, h, f = i; f < n; f++)
            h = l[f], h._path = this, h._segment1 = r[f], h._segment2 = r[f + 1] || r[0], h._changed();
          (h = l[this._closed && !i ? r.length - 1 : i - 1]) && (h._segment2 = r[i] || r[0], h._changed()), (h = l[n]) && (h._segment1 = r[n], h._changed());
        },
        _countCurves: function() {
          var i = this._segments.length;
          return !this._closed && i > 0 ? i - 1 : i;
        },
        add: function(i) {
          var n = arguments;
          return n.length > 1 && typeof i != "number" ? this._add(at.readList(n)) : this._add([at.read(n)])[0];
        },
        insert: function(i, n) {
          var r = arguments;
          return r.length > 2 && typeof n != "number" ? this._add(at.readList(r, 1), i) : this._add([at.read(r, 1)], i)[0];
        },
        addSegment: function() {
          return this._add([at.read(arguments)])[0];
        },
        insertSegment: function(i) {
          return this._add([at.read(arguments, 1)], i)[0];
        },
        addSegments: function(i) {
          return this._add(at.readList(i));
        },
        insertSegments: function(i, n) {
          return this._add(at.readList(n), i);
        },
        removeSegment: function(i) {
          return this.removeSegments(i, i + 1)[0] || null;
        },
        removeSegments: function(i, n, r) {
          i = i || 0, n = a.pick(n, this._segments.length);
          var l = this._segments, h = this._curves, f = l.length, m = l.splice(i, n - i), _ = m.length;
          if (!_)
            return m;
          for (var y = 0; y < _; y++) {
            var x = m[y];
            x._selection && this._updateSelection(x, x._selection, 0), x._index = x._path = null;
          }
          for (var y = i, A = l.length; y < A; y++)
            l[y]._index = y;
          if (h) {
            for (var B = i > 0 && n === f + (this._closed ? 1 : 0) ? i - 1 : i, h = h.splice(B, _), y = h.length - 1; y >= 0; y--)
              h[y]._path = null;
            r && (m._curves = h.slice(1)), this._adjustCurves(B, B);
          }
          return this._changed(41), m;
        },
        clear: "#removeSegments",
        hasHandles: function() {
          for (var i = this._segments, n = 0, r = i.length; n < r; n++)
            if (i[n].hasHandles())
              return !0;
          return !1;
        },
        clearHandles: function() {
          for (var i = this._segments, n = 0, r = i.length; n < r; n++)
            i[n].clearHandles();
        },
        getLength: function() {
          if (this._length == null) {
            for (var i = this.getCurves(), n = 0, r = 0, l = i.length; r < l; r++)
              n += i[r].getLength();
            this._length = n;
          }
          return this._length;
        },
        getArea: function() {
          var i = this._area;
          if (i == null) {
            var n = this._segments, r = this._closed;
            i = 0;
            for (var l = 0, h = n.length; l < h; l++) {
              var f = l + 1 === h;
              i += Ve.getArea(Ve.getValues(
                n[l],
                n[f ? 0 : l + 1],
                null,
                f && !r
              ));
            }
            this._area = i;
          }
          return i;
        },
        isFullySelected: function() {
          var i = this._segments.length;
          return this.isSelected() && i > 0 && this._segmentSelection === i * 7;
        },
        setFullySelected: function(i) {
          i && this._selectSegments(!0), this.setSelected(i);
        },
        setSelection: function i(n) {
          n & 1 || this._selectSegments(!1), i.base.call(this, n);
        },
        _selectSegments: function(i) {
          var n = this._segments, r = n.length, l = i ? 7 : 0;
          this._segmentSelection = l * r;
          for (var h = 0; h < r; h++)
            n[h]._selection = l;
        },
        _updateSelection: function(i, n, r) {
          i._selection = r;
          var l = this._segmentSelection += r - n;
          l > 0 && this.setSelected(!0);
        },
        divideAt: function(i) {
          var n = this.getLocationAt(i), r;
          return n && (r = n.getCurve().divideAt(n.getCurveOffset())) ? r._segment1 : null;
        },
        splitAt: function(i) {
          var n = this.getLocationAt(i), r = n && n.index, l = n && n.time, h = 1e-8, f = 1 - h;
          l > f && (r++, l = 0);
          var m = this.getCurves();
          if (r >= 0 && r < m.length) {
            l >= h && m[r++].divideAtTime(l);
            var _ = this.removeSegments(r, this._segments.length, !0), y;
            return this._closed ? (this.setClosed(!1), y = this) : (y = new Bt(K.NO_INSERT), y.insertAbove(this), y.copyAttributes(this)), y._add(_, 0), this.addSegment(_[0]), y;
          }
          return null;
        },
        split: function(i, n) {
          var r, l = n === t ? i : (r = this.getCurves()[i]) && r.getLocationAtTime(n);
          return l != null ? this.splitAt(l) : null;
        },
        join: function(i, n) {
          var r = n || 0;
          if (i && i !== this) {
            var l = i._segments, h = this.getLastSegment(), f = i.getLastSegment();
            if (!f)
              return this;
            h && h._point.isClose(f._point, r) && i.reverse();
            var m = i.getFirstSegment();
            if (h && h._point.isClose(m._point, r))
              h.setHandleOut(m._handleOut), this._add(l.slice(1));
            else {
              var _ = this.getFirstSegment();
              _ && _._point.isClose(m._point, r) && i.reverse(), f = i.getLastSegment(), _ && _._point.isClose(f._point, r) ? (_.setHandleIn(f._handleIn), this._add(l.slice(0, l.length - 1), 0)) : this._add(l.slice());
            }
            i._closed && this._add([l[0]]), i.remove();
          }
          var y = this.getFirstSegment(), x = this.getLastSegment();
          return y !== x && y._point.isClose(x._point, r) && (y.setHandleIn(x._handleIn), x.remove(), this.setClosed(!0)), this;
        },
        reduce: function(i) {
          for (var n = this.getCurves(), r = i && i.simplify, l = r ? 1e-7 : 0, h = n.length - 1; h >= 0; h--) {
            var f = n[h];
            !f.hasHandles() && (!f.hasLength(l) || r && f.isCollinear(f.getNext())) && f.remove();
          }
          return this;
        },
        reverse: function() {
          this._segments.reverse();
          for (var i = 0, n = this._segments.length; i < n; i++) {
            var r = this._segments[i], l = r._handleIn;
            r._handleIn = r._handleOut, r._handleOut = l, r._index = i;
          }
          this._curves = null, this._changed(9);
        },
        flatten: function(i) {
          for (var n = new on(this, i || 0.25, 256, !0), r = n.parts, l = r.length, h = [], f = 0; f < l; f++)
            h.push(new at(r[f].curve.slice(0, 2)));
          !this._closed && l > 0 && h.push(new at(r[l - 1].curve.slice(6))), this.setSegments(h);
        },
        simplify: function(i) {
          var n = new Tn(this).fit(i || 2.5);
          return n && this.setSegments(n), !!n;
        },
        smooth: function(i) {
          var n = this, r = i || {}, l = r.type || "asymmetric", h = this._segments, f = h.length, m = this._closed;
          function _(tt, gt) {
            var ut = tt && tt.index;
            if (ut != null) {
              var yt = tt.path;
              if (yt && yt !== n)
                throw new Error(tt._class + " " + ut + " of " + yt + " is not part of " + n);
              gt && tt instanceof Ve && ut++;
            } else
              ut = typeof tt == "number" ? tt : gt;
            return Math.min(ut < 0 && m ? ut % f : ut < 0 ? ut + f : ut, f - 1);
          }
          var y = m && r.from === t && r.to === t, x = _(r.from, 0), A = _(r.to, f - 1);
          if (x > A)
            if (m)
              x -= f;
            else {
              var B = x;
              x = A, A = B;
            }
          if (/^(?:asymmetric|continuous)$/.test(l)) {
            var C = l === "asymmetric", M = Math.min, R = A - x + 1, E = R - 1, D = y ? M(R, 4) : 1, L = D, P = D, S = [];
            if (m || (L = M(1, x), P = M(1, f - A - 1)), E += L + P, E <= 1)
              return;
            for (var I = 0, U = x - L; I <= E; I++, U++)
              S[I] = h[(U < 0 ? U + f : U) % f]._point;
            for (var V = S[0]._x + 2 * S[1]._x, F = S[0]._y + 2 * S[1]._y, W = 2, Q = E - 1, ie = [V], ae = [F], J = [W], le = [], fe = [], I = 1; I < E; I++) {
              var me = I < Q, ve = me || C ? 1 : 2, Se = me ? 4 : C ? 2 : 7, Re = me ? 4 : C ? 3 : 8, He = me ? 2 : C ? 0 : 1, Ye = ve / W;
              W = J[I] = Se - Ye, V = ie[I] = Re * S[I]._x + He * S[I + 1]._x - Ye * V, F = ae[I] = Re * S[I]._y + He * S[I + 1]._y - Ye * F;
            }
            le[Q] = ie[Q] / J[Q], fe[Q] = ae[Q] / J[Q];
            for (var I = E - 2; I >= 0; I--)
              le[I] = (ie[I] - le[I + 1]) / J[I], fe[I] = (ae[I] - fe[I + 1]) / J[I];
            le[E] = (3 * S[E]._x - le[Q]) / 2, fe[E] = (3 * S[E]._y - fe[Q]) / 2;
            for (var I = L, Je = E - P, U = x; I <= Je; I++, U++) {
              var Be = h[U < 0 ? U + f : U], Ie = Be._point, Ge = le[I] - Ie._x, et = fe[I] - Ie._y;
              (y || I < Je) && Be.setHandleOut(Ge, et), (y || I > L) && Be.setHandleIn(-Ge, -et);
            }
          } else
            for (var I = x; I <= A; I++)
              h[I < 0 ? I + f : I].smooth(
                r,
                !y && I === x,
                !y && I === A
              );
        },
        toShape: function(i) {
          if (!this._closed)
            return null;
          var n = this._segments, r, l, h, f;
          function m(C, M) {
            var R = n[C], E = R.getNext(), D = n[M], L = D.getNext();
            return R._handleOut.isZero() && E._handleIn.isZero() && D._handleOut.isZero() && L._handleIn.isZero() && E._point.subtract(R._point).isCollinear(
              L._point.subtract(D._point)
            );
          }
          function _(C) {
            var M = n[C], R = M.getPrevious(), E = M.getNext();
            return R._handleOut.isZero() && M._handleIn.isZero() && M._handleOut.isZero() && E._handleIn.isZero() && M._point.subtract(R._point).isOrthogonal(
              E._point.subtract(M._point)
            );
          }
          function y(C) {
            var M = n[C], R = M.getNext(), E = M._handleOut, D = R._handleIn, L = 0.5522847498307936;
            if (E.isOrthogonal(D)) {
              var P = M._point, S = R._point, I = new xe(P, E, !0).intersect(
                new xe(S, D, !0),
                !0
              );
              return I && Y.isZero(E.getLength() / I.subtract(P).getLength() - L) && Y.isZero(D.getLength() / I.subtract(S).getLength() - L);
            }
            return !1;
          }
          function x(C, M) {
            return n[C]._point.getDistance(n[M]._point);
          }
          if (!this.hasHandles() && n.length === 4 && m(0, 2) && m(1, 3) && _(1) ? (r = Ze.Rectangle, l = new ne(x(0, 3), x(0, 1)), f = n[1]._point.add(n[2]._point).divide(2)) : n.length === 8 && y(0) && y(2) && y(4) && y(6) && m(1, 5) && m(3, 7) ? (r = Ze.Rectangle, l = new ne(x(1, 6), x(0, 3)), h = l.subtract(new ne(
            x(0, 7),
            x(1, 2)
          )).divide(2), f = n[3]._point.add(n[4]._point).divide(2)) : n.length === 4 && y(0) && y(1) && y(2) && y(3) && (Y.isZero(x(0, 2) - x(1, 3)) ? (r = Ze.Circle, h = x(0, 2) / 2) : (r = Ze.Ellipse, h = new ne(x(2, 0) / 2, x(3, 1) / 2)), f = n[1]._point), r) {
            var A = this.getPosition(!0), B = new r({
              center: A,
              size: l,
              radius: h,
              insert: !1
            });
            return B.copyAttributes(this, !0), B._matrix.prepend(this._matrix), B.rotate(f.subtract(A).getAngle() + 90), (i === t || i) && B.insertAbove(this), B;
          }
          return null;
        },
        toPath: "#clone",
        compare: function i(n) {
          if (!n || n instanceof yi)
            return i.base.call(this, n);
          var r = this.getCurves(), l = n.getCurves(), h = r.length, f = l.length;
          if (!h || !f)
            return h == f;
          for (var m = r[0].getValues(), _ = [], y = 0, x, A = 0, B, C = 0; C < f; C++) {
            var M = l[C].getValues();
            _.push(M);
            var R = Ve.getOverlaps(m, M);
            if (R) {
              x = !C && R[0][0] > 0 ? f - 1 : C, B = R[0][1];
              break;
            }
          }
          for (var E = Math.abs, D = 1e-8, M = _[x], L; m && M; ) {
            var R = Ve.getOverlaps(m, M);
            if (R) {
              var P = R[0][0];
              if (E(P - A) < D) {
                A = R[1][0], A === 1 && (m = ++y < h ? r[y].getValues() : null, A = 0);
                var S = R[0][1];
                if (E(S - B) < D) {
                  if (L || (L = [x, S]), B = R[1][1], B === 1 && (++x >= f && (x = 0), M = _[x] || l[x].getValues(), B = 0), !m)
                    return L[0] === x && L[1] === B;
                  continue;
                }
              }
            }
            break;
          }
          return !1;
        },
        _hitTestSelf: function(i, n, r, l) {
          var h = this, f = this.getStyle(), m = this._segments, _ = m.length, y = this._closed, x = n._tolerancePadding, A = x, B, C, M, R, E, D, L = n.stroke && f.hasStroke(), P = n.fill && f.hasFill(), S = n.curves, I = L ? f.getStrokeWidth() / 2 : P && n.tolerance > 0 || S ? 0 : null;
          I !== null && (I > 0 ? (B = f.getStrokeJoin(), C = f.getStrokeCap(), M = f.getMiterLimit(), A = A.add(
            Bt._getStrokePadding(I, l)
          )) : B = C = "round");
          function U(le, fe) {
            return i.subtract(le).divide(fe).length <= 1;
          }
          function V(le, fe, me) {
            if (!n.selected || fe.isSelected()) {
              var ve = le._point;
              if (fe !== ve && (fe = fe.add(ve)), U(fe, A))
                return new Tt(me, h, {
                  segment: le,
                  point: fe
                });
            }
          }
          function F(le, fe) {
            return (fe || n.segments) && V(le, le._point, "segment") || !fe && n.handles && (V(le, le._handleIn, "handle-in") || V(le, le._handleOut, "handle-out"));
          }
          function W(le) {
            R.add(le);
          }
          function Q(le) {
            var fe = y || le._index > 0 && le._index < _ - 1;
            if ((fe ? B : C) === "round")
              return U(le._point, A);
            if (R = new Bt({ internal: !0, closed: !0 }), fe ? le.isSmooth() || Bt._addBevelJoin(
              le,
              B,
              I,
              M,
              null,
              l,
              W,
              !0
            ) : C === "square" && Bt._addSquareCap(
              le,
              C,
              I,
              null,
              l,
              W,
              !0
            ), !R.isEmpty()) {
              var me;
              return R.contains(i) || (me = R.getNearestLocation(i)) && U(me.getPoint(), x);
            }
          }
          if (n.ends && !n.segments && !y) {
            if (D = F(m[0], !0) || F(m[_ - 1], !0))
              return D;
          } else if (n.segments || n.handles) {
            for (var ie = 0; ie < _; ie++)
              if (D = F(m[ie]))
                return D;
          }
          if (I !== null) {
            if (E = this.getNearestLocation(i), E) {
              var ae = E.getTime();
              ae === 0 || ae === 1 && _ > 1 ? Q(E.getSegment()) || (E = null) : U(E.getPoint(), A) || (E = null);
            }
            if (!E && B === "miter" && _ > 1)
              for (var ie = 0; ie < _; ie++) {
                var J = m[ie];
                if (i.getDistance(J._point) <= M * I && Q(J)) {
                  E = J.getLocation();
                  break;
                }
              }
          }
          return !E && P && this._contains(i) || E && !L && !S ? new Tt("fill", this) : E ? new Tt(L ? "stroke" : "curve", this, {
            location: E,
            point: E.getPoint()
          }) : null;
        }
      },
      a.each(
        Ve._evaluateMethods,
        function(i) {
          this[i + "At"] = function(n) {
            var r = this.getLocationAt(n);
            return r && r[i]();
          };
        },
        {
          beans: !1,
          getLocationOf: function() {
            for (var i = z.read(arguments), n = this.getCurves(), r = 0, l = n.length; r < l; r++) {
              var h = n[r].getLocationOf(i);
              if (h)
                return h;
            }
            return null;
          },
          getOffsetOf: function() {
            var i = this.getLocationOf.apply(this, arguments);
            return i ? i.getOffset() : null;
          },
          getLocationAt: function(i) {
            if (typeof i == "number") {
              for (var n = this.getCurves(), r = 0, l = 0, h = n.length; l < h; l++) {
                var f = r, m = n[l];
                if (r += m.getLength(), r > i)
                  return m.getLocationAt(i - f);
              }
              if (n.length > 0 && i <= this.getLength())
                return new Ot(n[n.length - 1], 1);
            } else if (i && i.getPath && i.getPath() === this)
              return i;
            return null;
          },
          getOffsetsWithTangent: function() {
            var i = z.read(arguments);
            if (i.isZero())
              return [];
            for (var n = [], r = 0, l = this.getCurves(), h = 0, f = l.length; h < f; h++) {
              for (var m = l[h], _ = m.getTimesWithTangent(i), y = 0, x = _.length; y < x; y++) {
                var A = r + m.getOffsetAtTime(_[y]);
                n.indexOf(A) < 0 && n.push(A);
              }
              r += m.length;
            }
            return n;
          }
        }
      ),
      new function() {
        function i(r, l, h, f) {
          if (f <= 0)
            return;
          var m = f / 2, _ = f - 2, y = m - 1, x = new Array(6), A, B;
          function C(P) {
            var S = x[P], I = x[P + 1];
            (A != S || B != I) && (r.beginPath(), r.moveTo(A, B), r.lineTo(S, I), r.stroke(), r.beginPath(), r.arc(S, I, m, 0, Math.PI * 2, !0), r.fill());
          }
          for (var M = 0, R = l.length; M < R; M++) {
            var E = l[M], D = E._selection;
            if (E._transformCoordinates(h, x), A = x[0], B = x[1], D & 2 && C(2), D & 4 && C(4), r.fillRect(A - m, B - m, f, f), _ > 0 && !(D & 1)) {
              var L = r.fillStyle;
              r.fillStyle = "#ffffff", r.fillRect(A - y, B - y, _, _), r.fillStyle = L;
            }
          }
        }
        function n(r, l, h) {
          var f = l._segments, m = f.length, _ = new Array(6), y = !0, x, A, B, C, M, R, E, D;
          function L(S) {
            if (h)
              S._transformCoordinates(h, _), x = _[0], A = _[1];
            else {
              var I = S._point;
              x = I._x, A = I._y;
            }
            if (y)
              r.moveTo(x, A), y = !1;
            else {
              if (h)
                M = _[2], R = _[3];
              else {
                var U = S._handleIn;
                M = x + U._x, R = A + U._y;
              }
              M === x && R === A && E === B && D === C ? r.lineTo(x, A) : r.bezierCurveTo(E, D, M, R, x, A);
            }
            if (B = x, C = A, h)
              E = _[4], D = _[5];
            else {
              var U = S._handleOut;
              E = B + U._x, D = C + U._y;
            }
          }
          for (var P = 0; P < m; P++)
            L(f[P]);
          l._closed && m > 0 && L(f[0]);
        }
        return {
          _draw: function(r, l, h, f) {
            var m = l.dontStart, _ = l.dontFinish || l.clip, y = this.getStyle(), x = y.hasFill(), A = y.hasStroke(), B = y.getDashArray(), C = !nt.support.nativeDash && A && B && B.length;
            m || r.beginPath(), (x || A && !C || _) && (n(r, this, f), this._closed && r.closePath());
            function M(S) {
              return B[(S % C + C) % C];
            }
            if (!_ && (x || A) && (this._setStyles(r, l, h), x && (r.fill(y.getFillRule()), r.shadowColor = "rgba(0,0,0,0)"), A)) {
              if (C) {
                m || r.beginPath();
                for (var R = new on(
                  this,
                  0.25,
                  32,
                  !1,
                  f
                ), E = R.length, D = -y.getDashOffset(), L, P = 0; D > 0; )
                  D -= M(P--) + M(P--);
                for (; D < E; )
                  L = D + M(P++), (D > 0 || L > 0) && R.drawPart(
                    r,
                    Math.max(D, 0),
                    Math.max(L, 0)
                  ), D = L + M(P++);
              }
              r.stroke();
            }
          },
          _drawSelected: function(r, l) {
            r.beginPath(), n(r, this, l), r.stroke(), i(r, this._segments, l, nt.settings.handleSize);
          }
        };
      }(),
      new function() {
        function i(n) {
          var r = n._segments;
          if (!r.length)
            throw new Error("Use a moveTo() command first");
          return r[r.length - 1];
        }
        return {
          moveTo: function() {
            var n = this._segments;
            n.length === 1 && this.removeSegment(0), n.length || this._add([new at(z.read(arguments))]);
          },
          moveBy: function() {
            throw new Error("moveBy() is unsupported on Path items.");
          },
          lineTo: function() {
            this._add([new at(z.read(arguments))]);
          },
          cubicCurveTo: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = z.read(n), f = i(this);
            f.setHandleOut(r.subtract(f._point)), this._add([new at(h, l.subtract(h))]);
          },
          quadraticCurveTo: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = i(this)._point;
            this.cubicCurveTo(
              r.add(h.subtract(r).multiply(1 / 3)),
              r.add(l.subtract(r).multiply(1 / 3)),
              l
            );
          },
          curveTo: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = a.pick(a.read(n), 0.5), f = 1 - h, m = i(this)._point, _ = r.subtract(m.multiply(f * f)).subtract(l.multiply(h * h)).divide(2 * h * f);
            if (_.isNaN())
              throw new Error(
                "Cannot put a curve through points with parameter = " + h
              );
            this.quadraticCurveTo(_, l);
          },
          arcTo: function() {
            var n = arguments, r = Math.abs, l = Math.sqrt, h = i(this), f = h._point, m = z.read(n), R, _ = a.peek(n), y = a.pick(_, !0), x, A, B, C;
            if (typeof y == "boolean")
              var M = f.add(m).divide(2), R = M.add(M.subtract(f).rotate(
                y ? -90 : 90
              ));
            else if (a.remain(n) <= 2)
              R = m, m = z.read(n);
            else if (!f.equals(m)) {
              var E = ne.read(n), D = Y.isZero;
              if (D(E.width) || D(E.height))
                return this.lineTo(m);
              var L = a.read(n), y = !!a.read(n), P = !!a.read(n), M = f.add(m).divide(2), S = f.subtract(M).rotate(-L), I = S.x, U = S.y, V = r(E.width), F = r(E.height), W = V * V, Q = F * F, ie = I * I, ae = U * U, J = l(ie / W + ae / Q);
              if (J > 1 && (V *= J, F *= J, W = V * V, Q = F * F), J = (W * Q - W * ae - Q * ie) / (W * ae + Q * ie), r(J) < 1e-12 && (J = 0), J < 0)
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              x = new z(V * U / F, -F * I / V).multiply((P === y ? -1 : 1) * l(J)).rotate(L).add(M), C = new ue().translate(x).rotate(L).scale(V, F), B = C._inverseTransform(f), A = B.getDirectedAngle(C._inverseTransform(m)), !y && A > 0 ? A -= 360 : y && A < 0 && (A += 360);
            }
            if (R) {
              var le = new xe(
                f.add(R).divide(2),
                R.subtract(f).rotate(90),
                !0
              ), fe = new xe(
                R.add(m).divide(2),
                m.subtract(R).rotate(90),
                !0
              ), me = new xe(f, m), ve = me.getSide(R);
              if (x = le.intersect(fe, !0), !x) {
                if (!ve)
                  return this.lineTo(m);
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              }
              B = f.subtract(x), A = B.getDirectedAngle(m.subtract(x));
              var Se = me.getSide(x, !0);
              Se === 0 ? A = ve * r(A) : ve === Se && (A += A < 0 ? 360 : -360);
            }
            if (A) {
              for (var Re = 1e-5, He = r(A), Ye = He >= 360 ? 4 : Math.ceil((He - Re) / 90), Je = A / Ye, Be = Je * Math.PI / 360, Ie = 4 / 3 * Math.sin(Be) / (1 + Math.cos(Be)), Ge = [], et = 0; et <= Ye; et++) {
                var S = m, tt = null;
                if (et < Ye && (tt = B.rotate(90).multiply(Ie), C ? (S = C._transformPoint(B), tt = C._transformPoint(B.add(tt)).subtract(S)) : S = x.add(B)), !et)
                  h.setHandleOut(tt);
                else {
                  var gt = B.rotate(-90).multiply(Ie);
                  C && (gt = C._transformPoint(B.add(gt)).subtract(S)), Ge.push(new at(S, gt, tt));
                }
                B = B.rotate(Je);
              }
              this._add(Ge);
            }
          },
          lineBy: function() {
            var n = z.read(arguments), r = i(this)._point;
            this.lineTo(r.add(n));
          },
          curveBy: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = a.read(n), f = i(this)._point;
            this.curveTo(f.add(r), f.add(l), h);
          },
          cubicCurveBy: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = z.read(n), f = i(this)._point;
            this.cubicCurveTo(
              f.add(r),
              f.add(l),
              f.add(h)
            );
          },
          quadraticCurveBy: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = i(this)._point;
            this.quadraticCurveTo(h.add(r), h.add(l));
          },
          arcBy: function() {
            var n = arguments, r = i(this)._point, l = r.add(z.read(n)), h = a.pick(a.peek(n), !0);
            typeof h == "boolean" ? this.arcTo(l, h) : this.arcTo(l, r.add(z.read(n)));
          },
          closePath: function(n) {
            this.setClosed(!0), this.join(this, n);
          }
        };
      }(),
      {
        _getBounds: function(i, n) {
          var r = n.handle ? "getHandleBounds" : n.stroke ? "getStrokeBounds" : "getBounds";
          return Bt[r](this._segments, this._closed, this, i, n);
        },
        statics: {
          getBounds: function(i, n, r, l, h, f) {
            var m = i[0];
            if (!m)
              return new se();
            var _ = new Array(6), y = m._transformCoordinates(l, new Array(6)), x = y.slice(0, 2), A = x.slice(), B = new Array(2);
            function C(E) {
              E._transformCoordinates(l, _);
              for (var D = 0; D < 2; D++)
                Ve._addBounds(
                  y[D],
                  y[D + 4],
                  _[D + 2],
                  _[D],
                  D,
                  f ? f[D] : 0,
                  x,
                  A,
                  B
                );
              var L = y;
              y = _, _ = L;
            }
            for (var M = 1, R = i.length; M < R; M++)
              C(i[M]);
            return n && C(m), new se(x[0], x[1], A[0] - x[0], A[1] - x[1]);
          },
          getStrokeBounds: function(i, n, r, l, h) {
            var f = r.getStyle(), m = f.hasStroke(), _ = f.getStrokeWidth(), y = m && r._getStrokeMatrix(l, h), x = m && Bt._getStrokePadding(
              _,
              y
            ), A = Bt.getBounds(
              i,
              n,
              r,
              l,
              h,
              x
            );
            if (!m)
              return A;
            var B = _ / 2, C = f.getStrokeJoin(), M = f.getStrokeCap(), R = f.getMiterLimit(), E = new se(new ne(x));
            function D(V) {
              A = A.include(V);
            }
            function L(V) {
              A = A.unite(
                E.setCenter(V._point.transform(l))
              );
            }
            function P(V, F) {
              F === "round" || V.isSmooth() ? L(V) : Bt._addBevelJoin(
                V,
                F,
                B,
                R,
                l,
                y,
                D
              );
            }
            function S(V, F) {
              F === "round" ? L(V) : Bt._addSquareCap(
                V,
                F,
                B,
                l,
                y,
                D
              );
            }
            var I = i.length - (n ? 0 : 1);
            if (I > 0) {
              for (var U = 1; U < I; U++)
                P(i[U], C);
              n ? P(i[0], C) : (S(i[0], M), S(i[i.length - 1], M));
            }
            return A;
          },
          _getStrokePadding: function(i, n) {
            if (!n)
              return [i, i];
            var r = new z(i, 0).transform(n), l = new z(0, i).transform(n), h = r.getAngleInRadians(), f = r.getLength(), m = l.getLength(), _ = Math.sin(h), y = Math.cos(h), x = Math.tan(h), A = Math.atan2(m * x, f), B = Math.atan2(m, x * f);
            return [
              Math.abs(f * Math.cos(A) * y + m * Math.sin(A) * _),
              Math.abs(m * Math.sin(B) * y + f * Math.cos(B) * _)
            ];
          },
          _addBevelJoin: function(i, n, r, l, h, f, m, _) {
            var y = i.getCurve(), x = y.getPrevious(), A = y.getPoint1().transform(h), B = x.getNormalAtTime(1).multiply(r).transform(f), C = y.getNormalAtTime(0).multiply(r).transform(f), M = B.getDirectedAngle(C);
            if ((M < 0 || M >= 180) && (B = B.negate(), C = C.negate()), _ && m(A), m(A.add(B)), n === "miter") {
              var R = new xe(
                A.add(B),
                new z(-B.y, B.x),
                !0
              ).intersect(new xe(
                A.add(C),
                new z(-C.y, C.x),
                !0
              ), !0);
              R && A.getDistance(R) <= l * r && m(R);
            }
            m(A.add(C));
          },
          _addSquareCap: function(i, n, r, l, h, f, m) {
            var _ = i._point.transform(l), y = i.getLocation(), x = y.getNormal().multiply(y.getTime() === 0 ? r : -r).transform(h);
            n === "square" && (m && (f(_.subtract(x)), f(_.add(x))), _ = _.add(x.rotate(-90))), f(_.add(x)), f(_.subtract(x));
          },
          getHandleBounds: function(i, n, r, l, h) {
            var f = r.getStyle(), m = h.stroke && f.hasStroke(), _, y;
            if (m) {
              var x = r._getStrokeMatrix(l, h), A = f.getStrokeWidth() / 2, B = A;
              f.getStrokeJoin() === "miter" && (B = A * f.getMiterLimit()), f.getStrokeCap() === "square" && (B = Math.max(B, A * Math.SQRT2)), _ = Bt._getStrokePadding(A, x), y = Bt._getStrokePadding(B, x);
            }
            for (var C = new Array(6), M = 1 / 0, R = -M, E = M, D = R, L = 0, P = i.length; L < P; L++) {
              var S = i[L];
              S._transformCoordinates(l, C);
              for (var I = 0; I < 6; I += 2) {
                var U = I ? _ : y, V = U ? U[0] : 0, F = U ? U[1] : 0, W = C[I], Q = C[I + 1], ie = W - V, ae = W + V, J = Q - F, le = Q + F;
                ie < M && (M = ie), ae > R && (R = ae), J < E && (E = J), le > D && (D = le);
              }
            }
            return new se(M, E, R - M, D - E);
          }
        }
      }
    );
    Bt.inject({ statics: new function() {
      var i = 0.5522847498307936, n = [
        new at([-1, 0], [0, i], [0, -i]),
        new at([0, -1], [-i, 0], [i, 0]),
        new at([1, 0], [0, -i], [0, i]),
        new at([0, 1], [i, 0], [-i, 0])
      ];
      function r(h, f, m) {
        var _ = a.getNamed(m), y = new Bt(_ && (_.insert == !0 ? K.INSERT : _.insert == !1 ? K.NO_INSERT : null));
        return y._add(h), y._closed = f, y.set(_, K.INSERT);
      }
      function l(h, f, m) {
        for (var _ = new Array(4), y = 0; y < 4; y++) {
          var x = n[y];
          _[y] = new at(
            x._point.multiply(f).add(h),
            x._handleIn.multiply(f),
            x._handleOut.multiply(f)
          );
        }
        return r(_, !0, m);
      }
      return {
        Line: function() {
          var h = arguments;
          return r([
            new at(z.readNamed(h, "from")),
            new at(z.readNamed(h, "to"))
          ], !1, h);
        },
        Circle: function() {
          var h = arguments, f = z.readNamed(h, "center"), m = a.readNamed(h, "radius");
          return l(f, new ne(m), h);
        },
        Rectangle: function() {
          var h = arguments, f = se.readNamed(h, "rectangle"), m = ne.readNamed(
            h,
            "radius",
            0,
            { readNull: !0 }
          ), _ = f.getBottomLeft(!0), y = f.getTopLeft(!0), x = f.getTopRight(!0), A = f.getBottomRight(!0), B;
          if (!m || m.isZero())
            B = [
              new at(_),
              new at(y),
              new at(x),
              new at(A)
            ];
          else {
            m = ne.min(m, f.getSize(!0).divide(2));
            var C = m.width, M = m.height, R = C * i, E = M * i;
            B = [
              new at(_.add(C, 0), null, [-R, 0]),
              new at(_.subtract(0, M), [0, E]),
              new at(y.add(0, M), null, [0, -E]),
              new at(y.add(C, 0), [-R, 0], null),
              new at(x.subtract(C, 0), null, [R, 0]),
              new at(x.add(0, M), [0, -E], null),
              new at(A.subtract(0, M), null, [0, E]),
              new at(A.subtract(C, 0), [R, 0])
            ];
          }
          return r(B, !0, h);
        },
        RoundRectangle: "#Rectangle",
        Ellipse: function() {
          var h = arguments, f = Ze._readEllipse(h);
          return l(f.center, f.radius, h);
        },
        Oval: "#Ellipse",
        Arc: function() {
          var h = arguments, f = z.readNamed(h, "from"), m = z.readNamed(h, "through"), _ = z.readNamed(h, "to"), y = a.getNamed(h), x = new Bt(y && y.insert == !1 && K.NO_INSERT);
          return x.moveTo(f), x.arcTo(m, _), x.set(y);
        },
        RegularPolygon: function() {
          for (var h = arguments, f = z.readNamed(h, "center"), m = a.readNamed(h, "sides"), _ = a.readNamed(h, "radius"), y = 360 / m, x = m % 3 === 0, A = new z(0, x ? -_ : _), B = x ? -1 : 0.5, C = new Array(m), M = 0; M < m; M++)
            C[M] = new at(f.add(
              A.rotate((M + B) * y)
            ));
          return r(C, !0, h);
        },
        Star: function() {
          for (var h = arguments, f = z.readNamed(h, "center"), m = a.readNamed(h, "points") * 2, _ = a.readNamed(h, "radius1"), y = a.readNamed(h, "radius2"), x = 360 / m, A = new z(0, -1), B = new Array(m), C = 0; C < m; C++)
            B[C] = new at(f.add(A.rotate(x * C).multiply(C % 2 ? y : _)));
          return r(B, !0, h);
        }
      };
    }() });
    var yi = Ft.extend(
      {
        _class: "CompoundPath",
        _serializeFields: {
          children: []
        },
        beans: !0,
        initialize: function(i) {
          this._children = [], this._namedChildren = {}, this._initialize(i) || (typeof i == "string" ? this.setPathData(i) : this.addChildren(Array.isArray(i) ? i : arguments));
        },
        insertChildren: function i(n, r) {
          var l = r, h = l[0];
          h && typeof h[0] == "number" && (l = [l]);
          for (var f = r.length - 1; f >= 0; f--) {
            var m = l[f];
            l === r && !(m instanceof Bt) && (l = a.slice(l)), Array.isArray(m) ? l[f] = new Bt({ segments: m, insert: !1 }) : m instanceof yi && (l.splice.apply(l, [f, 1].concat(m.removeChildren())), m.remove());
          }
          return i.base.call(this, n, l);
        },
        reduce: function i(n) {
          for (var r = this._children, l = r.length - 1; l >= 0; l--) {
            var h = r[l].reduce(n);
            h.isEmpty() && h.remove();
          }
          if (!r.length) {
            var h = new Bt(K.NO_INSERT);
            return h.copyAttributes(this), h.insertAbove(this), this.remove(), h;
          }
          return i.base.call(this);
        },
        isClosed: function() {
          for (var i = this._children, n = 0, r = i.length; n < r; n++)
            if (!i[n]._closed)
              return !1;
          return !0;
        },
        setClosed: function(i) {
          for (var n = this._children, r = 0, l = n.length; r < l; r++)
            n[r].setClosed(i);
        },
        getFirstSegment: function() {
          var i = this.getFirstChild();
          return i && i.getFirstSegment();
        },
        getLastSegment: function() {
          var i = this.getLastChild();
          return i && i.getLastSegment();
        },
        getCurves: function() {
          for (var i = this._children, n = [], r = 0, l = i.length; r < l; r++)
            a.push(n, i[r].getCurves());
          return n;
        },
        getFirstCurve: function() {
          var i = this.getFirstChild();
          return i && i.getFirstCurve();
        },
        getLastCurve: function() {
          var i = this.getLastChild();
          return i && i.getLastCurve();
        },
        getArea: function() {
          for (var i = this._children, n = 0, r = 0, l = i.length; r < l; r++)
            n += i[r].getArea();
          return n;
        },
        getLength: function() {
          for (var i = this._children, n = 0, r = 0, l = i.length; r < l; r++)
            n += i[r].getLength();
          return n;
        },
        getPathData: function(i, n) {
          for (var r = this._children, l = [], h = 0, f = r.length; h < f; h++) {
            var m = r[h], _ = m._matrix;
            l.push(m.getPathData(i && !_.isIdentity() ? i.appended(_) : i, n));
          }
          return l.join("");
        },
        _hitTestChildren: function i(n, r, l) {
          return i.base.call(
            this,
            n,
            r.class === Bt || r.type === "path" ? r : a.set({}, r, { fill: !1 }),
            l
          );
        },
        _draw: function(i, n, r, l) {
          var h = this._children;
          if (h.length) {
            n = n.extend({ dontStart: !0, dontFinish: !0 }), i.beginPath();
            for (var f = 0, m = h.length; f < m; f++)
              h[f].draw(i, n, l);
            if (!n.clip) {
              this._setStyles(i, n, r);
              var _ = this._style;
              _.hasFill() && (i.fill(_.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), _.hasStroke() && i.stroke();
            }
          }
        },
        _drawSelected: function(i, n, r) {
          for (var l = this._children, h = 0, f = l.length; h < f; h++) {
            var m = l[h], _ = m._matrix;
            r[m._id] || m._drawSelected(i, _.isIdentity() ? n : n.appended(_));
          }
        }
      },
      new function() {
        function i(n, r) {
          var l = n._children;
          if (r && !l.length)
            throw new Error("Use a moveTo() command first");
          return l[l.length - 1];
        }
        return a.each(
          [
            "lineTo",
            "cubicCurveTo",
            "quadraticCurveTo",
            "curveTo",
            "arcTo",
            "lineBy",
            "cubicCurveBy",
            "quadraticCurveBy",
            "curveBy",
            "arcBy"
          ],
          function(n) {
            this[n] = function() {
              var r = i(this, !0);
              r[n].apply(r, arguments);
            };
          },
          {
            moveTo: function() {
              var n = i(this), r = n && n.isEmpty() ? n : new Bt(K.NO_INSERT);
              r !== n && this.addChild(r), r.moveTo.apply(r, arguments);
            },
            moveBy: function() {
              var n = i(this, !0), r = n && n.getLastSegment(), l = z.read(arguments);
              this.moveTo(r ? l.add(r._point) : l);
            },
            closePath: function(n) {
              i(this, !0).closePath(n);
            }
          }
        );
      }(),
      a.each(["reverse", "flatten", "simplify", "smooth"], function(i) {
        this[i] = function(n) {
          for (var r = this._children, l, h = 0, f = r.length; h < f; h++)
            l = r[h][i](n) || l;
          return l;
        };
      }, {})
    );
    Ft.inject(new function() {
      var i = Math.min, n = Math.max, r = Math.abs, l = {
        unite: { 1: !0, 2: !0 },
        intersect: { 2: !0 },
        subtract: { 1: !0 },
        exclude: { 1: !0, "-1": !0 }
      };
      function h(L) {
        return L._children || [L];
      }
      function f(L, P) {
        var S = L.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
        if (P) {
          for (var I = h(S), U = 0, V = I.length; U < V; U++) {
            var L = I[U];
            !L._closed && !L.isEmpty() && (L.closePath(1e-12), L.getFirstSegment().setHandleIn(0, 0), L.getLastSegment().setHandleOut(0, 0));
          }
          S = S.resolveCrossings().reorient(S.getFillRule() === "nonzero", !0);
        }
        return S;
      }
      function m(L, P, S, I, U) {
        var V = new yi(K.NO_INSERT);
        return V.addChildren(L, !0), V = V.reduce({ simplify: P }), U && U.insert == !1 || V.insertAbove(I && S.isSibling(I) && S.getIndex() < I.getIndex() ? I : S), V.copyAttributes(S, !0), V;
      }
      function _(L) {
        return L.hasOverlap() || L.isCrossing();
      }
      function y(L, P, S, I) {
        if (I && (I.trace == !1 || I.stroke) && /^(subtract|intersect)$/.test(S))
          return x(L, P, S);
        var U = f(L, !0), V = P && L !== P && f(P, !0), F = l[S];
        F[S] = !0, V && (F.subtract || F.exclude) ^ (V.isClockwise() ^ U.isClockwise()) && V.reverse();
        var W = M(Ot.expand(
          U.getIntersections(V, _)
        )), Q = h(U), ie = V && h(V), ae = [], J = [], le;
        function fe(tt) {
          for (var gt = 0, ut = tt.length; gt < ut; gt++) {
            var yt = tt[gt];
            a.push(ae, yt._segments), a.push(J, yt.getCurves()), yt._overlapsOnly = !0;
          }
        }
        function me(tt) {
          for (var gt = [], ut = 0, yt = tt && tt.length; ut < yt; ut++)
            gt.push(J[tt[ut]]);
          return gt;
        }
        if (W.length) {
          fe(Q), ie && fe(ie);
          for (var ve = new Array(J.length), Se = 0, Re = J.length; Se < Re; Se++)
            ve[Se] = J[Se].getValues();
          for (var He = T.findCurveBoundsCollisions(
            ve,
            ve,
            0,
            !0
          ), Ye = {}, Se = 0; Se < J.length; Se++) {
            var Je = J[Se], Be = Je._path._id, Ie = Ye[Be] = Ye[Be] || {};
            Ie[Je.getIndex()] = {
              hor: me(He[Se].hor),
              ver: me(He[Se].ver)
            };
          }
          for (var Se = 0, Re = W.length; Se < Re; Se++)
            E(
              W[Se]._segment,
              U,
              V,
              Ye,
              F
            );
          for (var Se = 0, Re = ae.length; Se < Re; Se++) {
            var Ge = ae[Se], et = Ge._intersection;
            Ge._winding || E(
              Ge,
              U,
              V,
              Ye,
              F
            ), et && et._overlap || (Ge._path._overlapsOnly = !1);
          }
          le = D(ae, F);
        } else
          le = C(
            ie ? Q.concat(ie) : Q.slice(),
            function(tt) {
              return !!F[tt];
            }
          );
        return m(le, !0, L, P, I);
      }
      function x(L, P, S) {
        var I = f(L), U = f(P), V = I.getIntersections(U, _), F = S === "subtract", W = S === "divide", Q = {}, ie = [];
        function ae(fe) {
          if (!Q[fe._id] && (W || U.contains(fe.getPointAt(fe.getLength() / 2)) ^ F))
            return ie.unshift(fe), Q[fe._id] = !0;
        }
        for (var J = V.length - 1; J >= 0; J--) {
          var le = V[J].split();
          le && (ae(le) && le.getFirstSegment().setHandleIn(0, 0), I.getLastSegment().setHandleOut(0, 0));
        }
        return ae(I), m(ie, !1, L, P);
      }
      function A(L, P) {
        for (var S = L; S; ) {
          if (S === P)
            return;
          S = S._previous;
        }
        for (; L._next && L._next !== P; )
          L = L._next;
        if (!L._next) {
          for (; P._previous; )
            P = P._previous;
          L._next = P, P._previous = L;
        }
      }
      function B(L) {
        for (var P = L.length - 1; P >= 0; P--)
          L[P].clearHandles();
      }
      function C(L, P, S) {
        var I = L && L.length;
        if (I) {
          var U = a.each(L, function(He, Ye) {
            this[He._id] = {
              container: null,
              winding: He.isClockwise() ? 1 : -1,
              index: Ye
            };
          }, {}), V = L.slice().sort(function(He, Ye) {
            return r(Ye.getArea()) - r(He.getArea());
          }), F = V[0], W = T.findItemBoundsCollisions(
            V,
            null,
            Y.GEOMETRIC_EPSILON
          );
          S == null && (S = F.isClockwise());
          for (var Q = 0; Q < I; Q++) {
            var ie = V[Q], ae = U[ie._id], J = 0, le = W[Q];
            if (le) {
              for (var fe = null, me = le.length - 1; me >= 0; me--)
                if (le[me] < Q) {
                  fe = fe || ie.getInteriorPoint();
                  var ve = V[le[me]];
                  if (ve.contains(fe)) {
                    var Se = U[ve._id];
                    J = Se.winding, ae.winding += J, ae.container = Se.exclude ? Se.container : ve;
                    break;
                  }
                }
            }
            if (P(ae.winding) === P(J))
              ae.exclude = !0, L[ae.index] = null;
            else {
              var Re = ae.container;
              ie.setClockwise(
                Re ? !Re.isClockwise() : S
              );
            }
          }
        }
        return L;
      }
      function M(L, P, S) {
        var I = P && [], U = 1e-8, V = 1 - U, F = !1, W = S || [], Q = S && {}, ie, ae, J;
        function le(gt) {
          return gt._path._id + "." + gt._segment1._index;
        }
        for (var fe = (S && S.length) - 1; fe >= 0; fe--) {
          var me = S[fe];
          me._path && (Q[le(me)] = !0);
        }
        for (var fe = L.length - 1; fe >= 0; fe--) {
          var ve = L[fe], Se = ve._time, Re = Se, He = P && !P(ve), me = ve._curve, Ye;
          if (me && (me !== ae ? (F = !me.hasHandles() || Q && Q[le(me)], ie = [], J = null, ae = me) : J >= U && (Se /= J)), He) {
            ie && ie.push(ve);
            continue;
          } else
            P && I.unshift(ve);
          if (J = Re, Se < U)
            Ye = me._segment1;
          else if (Se > V)
            Ye = me._segment2;
          else {
            var Je = me.divideAtTime(Se, !0);
            F && W.push(me, Je), Ye = Je._segment1;
            for (var Be = ie.length - 1; Be >= 0; Be--) {
              var Ie = ie[Be];
              Ie._time = (Ie._time - Se) / (1 - Se);
            }
          }
          ve._setSegment(Ye);
          var Ge = Ye._intersection, et = ve._intersection;
          if (Ge) {
            A(Ge, et);
            for (var tt = Ge; tt; )
              A(tt._intersection, Ge), tt = tt._next;
          } else
            Ye._intersection = et;
        }
        return S || B(W), I || L;
      }
      function R(L, P, S, I, U) {
        var V = Array.isArray(P) ? P : P[S ? "hor" : "ver"], F = S ? 1 : 0, W = F ^ 1, Q = [L.x, L.y], ie = Q[F], ae = Q[W], J = 1e-9, le = 1e-6, fe = ie - J, me = ie + J, ve = 0, Se = 0, Re = 0, He = 0, Ye = !1, Je = !1, Be = 1, Ie = [], Ge, et;
        function tt(Nt) {
          var Jt = Nt[W + 0], Ti = Nt[W + 6];
          if (!(ae < i(Jt, Ti) || ae > n(Jt, Ti))) {
            var ri = Nt[F + 0], Pi = Nt[F + 2], ci = Nt[F + 4], hi = Nt[F + 6];
            if (Jt === Ti) {
              (ri < me && hi > fe || hi < me && ri > fe) && (Ye = !0);
              return;
            }
            var Ni = ae === Jt ? 0 : ae === Ti || fe > n(ri, Pi, ci, hi) || me < i(ri, Pi, ci, hi) ? 1 : Ve.solveCubic(Nt, W, ae, Ie, 0, 1) > 0 ? Ie[0] : 1, Bi = Ni === 0 ? ri : Ni === 1 ? hi : Ve.getPoint(Nt, Ni)[S ? "y" : "x"], Ri = Jt > Ti ? 1 : -1, Wi = Ge[W] > Ge[W + 6] ? 1 : -1, Vi = Ge[F + 6];
            return ae !== Jt ? (Bi < fe ? Re += Ri : Bi > me ? He += Ri : Ye = !0, Bi > ie - le && Bi < ie + le && (Be /= 2)) : (Ri !== Wi ? ri < fe ? Re += Ri : ri > me && (He += Ri) : ri != Vi && (Vi < me && Bi > me ? (He += Ri, Ye = !0) : Vi > fe && Bi < fe && (Re += Ri, Ye = !0)), Be /= 4), Ge = Nt, !U && Bi > fe && Bi < me && Ve.getTangent(Nt, Ni)[S ? "x" : "y"] === 0 && R(L, P, !S, I, !0);
          }
        }
        function gt(Nt) {
          var Jt = Nt[W + 0], Ti = Nt[W + 2], ri = Nt[W + 4], Pi = Nt[W + 6];
          if (ae <= n(Jt, Ti, ri, Pi) && ae >= i(Jt, Ti, ri, Pi)) {
            for (var ci = Nt[F + 0], hi = Nt[F + 2], Ni = Nt[F + 4], Bi = Nt[F + 6], Ri = fe > n(ci, hi, Ni, Bi) || me < i(ci, hi, Ni, Bi) ? [Nt] : Ve.getMonoCurves(Nt, S), Wi, Vi = 0, Fn = Ri.length; Vi < Fn; Vi++)
              if (Wi = tt(Ri[Vi]))
                return Wi;
          }
        }
        for (var ut = 0, yt = V.length; ut < yt; ut++) {
          var At = V[ut], bt = At._path, li = At.getValues(), mt;
          if ((!ut || V[ut - 1]._path !== bt) && (Ge = null, bt._closed || (et = Ve.getValues(
            bt.getLastCurve().getSegment2(),
            At.getSegment1(),
            null,
            !I
          ), et[W] !== et[W + 6] && (Ge = et)), !Ge)) {
            Ge = li;
            for (var Zt = bt.getLastCurve(); Zt && Zt !== At; ) {
              var Xt = Zt.getValues();
              if (Xt[W] !== Xt[W + 6]) {
                Ge = Xt;
                break;
              }
              Zt = Zt.getPrevious();
            }
          }
          if (mt = gt(li))
            return mt;
          if (ut + 1 === yt || V[ut + 1]._path !== bt) {
            if (et && (mt = gt(et)))
              return mt;
            Ye && !Re && !He && (Re = He = bt.isClockwise(I) ^ S ? 1 : -1), ve += Re, Se += He, Re = He = 0, Ye && (Je = !0, Ye = !1), et = null;
          }
        }
        return ve = r(ve), Se = r(Se), {
          winding: n(ve, Se),
          windingL: ve,
          windingR: Se,
          quality: Be,
          onPath: Je
        };
      }
      function E(L, P, S, I, U) {
        var V = [], F = L, W = 0, Q;
        do {
          var ie = L.getCurve();
          if (ie) {
            var ae = ie.getLength();
            V.push({ segment: L, curve: ie, length: ae }), W += ae;
          }
          L = L.getNext();
        } while (L && !L._intersection && L !== F);
        for (var J = [0.5, 0.25, 0.75], Q = { winding: 0, quality: -1 }, le = 1e-3, fe = 1 - le, me = 0; me < J.length && Q.quality < 0.5; me++)
          for (var ae = W * J[me], ve = 0, Se = V.length; ve < Se; ve++) {
            var Re = V[ve], He = Re.length;
            if (ae <= He) {
              var ie = Re.curve, Ye = ie._path, Je = Ye._parent, Be = Je instanceof yi ? Je : Ye, Ie = Y.clamp(ie.getTimeAt(ae), le, fe), Ge = ie.getPointAtTime(Ie), et = r(ie.getTangentAtTime(Ie).y) < Math.SQRT1_2, tt = null;
              if (U.subtract && S) {
                var gt = Be === P ? S : P, ut = gt._getWinding(Ge, et, !0);
                if (Be === P && ut.winding || Be === S && !ut.winding) {
                  if (ut.quality < 1)
                    continue;
                  tt = { winding: 0, quality: 1 };
                }
              }
              tt = tt || R(
                Ge,
                I[Ye._id][ie.getIndex()],
                et,
                !0
              ), tt.quality > Q.quality && (Q = tt);
              break;
            }
            ae -= He;
          }
        for (var ve = V.length - 1; ve >= 0; ve--)
          V[ve].segment._winding = Q;
      }
      function D(L, P) {
        var S = [], I;
        function U(yt) {
          var At;
          return !!(yt && !yt._visited && (!P || P[(At = yt._winding || {}).winding] && !(P.unite && At.winding === 2 && At.windingL && At.windingR)));
        }
        function V(yt) {
          if (yt) {
            for (var At = 0, bt = I.length; At < bt; At++)
              if (yt === I[At])
                return !0;
          }
          return !1;
        }
        function F(yt) {
          for (var At = yt._segments, bt = 0, li = At.length; bt < li; bt++)
            At[bt]._visited = !0;
        }
        function W(yt, At) {
          var bt = yt._intersection, li = bt, mt = [];
          At && (I = [yt]);
          function Zt(Xt, Nt) {
            for (; Xt && Xt !== Nt; ) {
              var Jt = Xt._segment, Ti = Jt && Jt._path;
              if (Ti) {
                var ri = Jt.getNext() || Ti.getFirstSegment(), Pi = ri._intersection;
                Jt !== yt && (V(Jt) || V(ri) || ri && U(Jt) && (U(ri) || Pi && U(Pi._segment))) && mt.push(Jt), At && I.push(Jt);
              }
              Xt = Xt._next;
            }
          }
          if (bt) {
            for (Zt(bt); bt && bt._previous; )
              bt = bt._previous;
            Zt(bt, li);
          }
          return mt;
        }
        L.sort(function(yt, At) {
          var bt = yt._intersection, li = At._intersection, mt = !!(bt && bt._overlap), Zt = !!(li && li._overlap), Xt = yt._path, Nt = At._path;
          return mt ^ Zt ? mt ? 1 : -1 : !bt ^ !li ? bt ? 1 : -1 : Xt !== Nt ? Xt._id - Nt._id : yt._index - At._index;
        });
        for (var Q = 0, ie = L.length; Q < ie; Q++) {
          var ae = L[Q], J = U(ae), le = null, fe = !1, me = !0, ve = [], Se, Re, He;
          if (J && ae._path._overlapsOnly) {
            var Ye = ae._path, Je = ae._intersection._segment._path;
            Ye.compare(Je) && (Ye.getArea() && S.push(Ye.clone(!1)), F(Ye), F(Je), J = !1);
          }
          for (; J; ) {
            var Be = !le, Ie = W(ae, Be), Ge = Ie.shift(), fe = !Be && (V(ae) || V(Ge)), et = !fe && Ge;
            if (Be && (le = new Bt(K.NO_INSERT), Se = null), fe) {
              (ae.isFirst() || ae.isLast()) && (me = ae._path._closed), ae._visited = !0;
              break;
            }
            if (et && Se && (ve.push(Se), Se = null), Se || (et && Ie.push(ae), Se = {
              start: le._segments.length,
              crossings: Ie,
              visited: Re = [],
              handleIn: He
            }), et && (ae = Ge), !U(ae)) {
              le.removeSegments(Se.start);
              for (var tt = 0, gt = Re.length; tt < gt; tt++)
                Re[tt]._visited = !1;
              Re.length = 0;
              do
                ae = Se && Se.crossings.shift(), (!ae || !ae._path) && (ae = null, Se = ve.pop(), Se && (Re = Se.visited, He = Se.handleIn));
              while (Se && !U(ae));
              if (!ae)
                break;
            }
            var ut = ae.getNext();
            le.add(new at(
              ae._point,
              He,
              ut && ae._handleOut
            )), ae._visited = !0, Re.push(ae), ae = ut || ae._path.getFirstSegment(), He = ut && ut._handleIn;
          }
          fe && (me && (le.getFirstSegment().setHandleIn(He), le.setClosed(me)), le.getArea() !== 0 && S.push(le));
        }
        return S;
      }
      return {
        _getWinding: function(L, P, S) {
          return R(L, this.getCurves(), P, S);
        },
        unite: function(L, P) {
          return y(this, L, "unite", P);
        },
        intersect: function(L, P) {
          return y(this, L, "intersect", P);
        },
        subtract: function(L, P) {
          return y(this, L, "subtract", P);
        },
        exclude: function(L, P) {
          return y(this, L, "exclude", P);
        },
        divide: function(L, P) {
          return P && (P.trace == !1 || P.stroke) ? x(this, L, "divide") : m([
            this.subtract(L, P),
            this.intersect(L, P)
          ], !0, this, L, P);
        },
        resolveCrossings: function() {
          var L = this._children, P = L || [this];
          function S(Se, Re) {
            var He = Se && Se._intersection;
            return He && He._overlap && He._path === Re;
          }
          var I = !1, U = !1, V = this.getIntersections(null, function(Se) {
            return Se.hasOverlap() && (I = !0) || Se.isCrossing() && (U = !0);
          }), F = I && U && [];
          if (V = Ot.expand(V), I)
            for (var W = M(V, function(Se) {
              return Se.hasOverlap();
            }, F), Q = W.length - 1; Q >= 0; Q--) {
              var ie = W[Q], ae = ie._path, J = ie._segment, le = J.getPrevious(), fe = J.getNext();
              S(le, ae) && S(fe, ae) && (J.remove(), le._handleOut._set(0, 0), fe._handleIn._set(0, 0), le !== J && !le.getCurve().hasLength() && (fe._handleIn.set(le._handleIn), le.remove()));
            }
          U && (M(V, I && function(Se) {
            var Re = Se.getCurve(), He = Se.getSegment(), Ye = Se._intersection, Je = Ye._curve, Be = Ye._segment;
            if (Re && Je && Re._path && Je._path)
              return !0;
            He && (He._intersection = null), Be && (Be._intersection = null);
          }, F), F && B(F), P = D(a.each(P, function(Se) {
            a.push(this, Se._segments);
          }, [])));
          var me = P.length, ve;
          return me > 1 && L ? (P !== L && this.setChildren(P), ve = this) : me === 1 && !L && (P[0] !== this && this.setSegments(P[0].removeSegments()), ve = this), ve || (ve = new yi(K.NO_INSERT), ve.addChildren(P), ve = ve.reduce(), ve.copyAttributes(this), this.replaceWith(ve)), ve;
        },
        reorient: function(L, P) {
          var S = this._children;
          return S && S.length ? this.setChildren(C(
            this.removeChildren(),
            function(I) {
              return !!(L ? I : I & 1);
            },
            P
          )) : P !== t && this.setClockwise(P), this;
        },
        getInteriorPoint: function() {
          var L = this.getBounds(), P = L.getCenter(!0);
          if (!this.contains(P)) {
            for (var S = this.getCurves(), I = P.y, U = [], V = [], F = 0, W = S.length; F < W; F++) {
              var Q = S[F].getValues(), ie = Q[1], ae = Q[3], J = Q[5], le = Q[7];
              if (I >= i(ie, ae, J, le) && I <= n(ie, ae, J, le))
                for (var fe = Ve.getMonoCurves(Q), me = 0, ve = fe.length; me < ve; me++) {
                  var Se = fe[me], Re = Se[1], He = Se[7];
                  if (Re !== He && (I >= Re && I <= He || I >= He && I <= Re)) {
                    var Ye = I === Re ? Se[0] : I === He ? Se[6] : Ve.solveCubic(Se, 1, I, V, 0, 1) === 1 ? Ve.getPoint(Se, V[0]).x : (Se[0] + Se[6]) / 2;
                    U.push(Ye);
                  }
                }
            }
            U.length > 1 && (U.sort(function(Je, Be) {
              return Je - Be;
            }), P.x = (U[0] + U[1]) / 2);
          }
          return P;
        }
      };
    }());
    var on = a.extend(
      {
        _class: "PathFlattener",
        initialize: function(i, n, r, l, h) {
          var f = [], m = [], _ = 0, y = 1 / (r || 32), x = i._segments, A = x[0], B;
          function C(D, L) {
            var P = Ve.getValues(D, L, h);
            f.push(P), M(P, D._index, 0, 1);
          }
          function M(D, L, P, S) {
            if (S - P > y && !(l && Ve.isStraight(D)) && !Ve.isFlatEnough(D, n || 0.25)) {
              var I = Ve.subdivide(D, 0.5), U = (P + S) / 2;
              M(I[0], L, P, U), M(I[1], L, U, S);
            } else {
              var V = D[6] - D[0], F = D[7] - D[1], W = Math.sqrt(V * V + F * F);
              W > 0 && (_ += W, m.push({
                offset: _,
                curve: D,
                index: L,
                time: S
              }));
            }
          }
          for (var R = 1, E = x.length; R < E; R++)
            B = x[R], C(A, B), A = B;
          i._closed && C(B || A, x[0]), this.curves = f, this.parts = m, this.length = _, this.index = 0;
        },
        _get: function(i) {
          for (var n = this.parts, r = n.length, l, h = this.index; l = h, !(!h || n[--h].offset < i); )
            ;
          for (; l < r; l++) {
            var f = n[l];
            if (f.offset >= i) {
              this.index = l;
              var m = n[l - 1], _ = m && m.index === f.index ? m.time : 0, y = m ? m.offset : 0;
              return {
                index: f.index,
                time: _ + (f.time - _) * (i - y) / (f.offset - y)
              };
            }
          }
          return {
            index: n[r - 1].index,
            time: 1
          };
        },
        drawPart: function(i, n, r) {
          for (var l = this._get(n), h = this._get(r), f = l.index, m = h.index; f <= m; f++) {
            var _ = Ve.getPart(
              this.curves[f],
              f === l.index ? l.time : 0,
              f === h.index ? h.time : 1
            );
            f === l.index && i.moveTo(_[0], _[1]), i.bezierCurveTo.apply(i, _.slice(2));
          }
        }
      },
      a.each(
        Ve._evaluateMethods,
        function(i) {
          this[i + "At"] = function(n) {
            var r = this._get(n);
            return Ve[i](this.curves[r.index], r.time);
          };
        },
        {}
      )
    ), Tn = a.extend({
      initialize: function(i) {
        for (var n = this.points = [], r = i._segments, l = i._closed, h = 0, f, m = r.length; h < m; h++) {
          var _ = r[h].point;
          (!f || !f.equals(_)) && n.push(f = _.clone());
        }
        l && (n.unshift(n[n.length - 1]), n.push(n[1])), this.closed = l;
      },
      fit: function(i) {
        var n = this.points, r = n.length, l = null;
        return r > 0 && (l = [new at(n[0])], r > 1 && (this.fitCubic(
          l,
          i,
          0,
          r - 1,
          n[1].subtract(n[0]),
          n[r - 2].subtract(n[r - 1])
        ), this.closed && (l.shift(), l.pop()))), l;
      },
      fitCubic: function(i, n, r, l, h, f) {
        var m = this.points;
        if (l - r === 1) {
          var _ = m[r], y = m[l], x = _.getDistance(y) / 3;
          this.addCurve(i, [
            _,
            _.add(h.normalize(x)),
            y.add(f.normalize(x)),
            y
          ]);
          return;
        }
        for (var A = this.chordLengthParameterize(r, l), B = Math.max(n, n * n), C, M = !0, R = 0; R <= 4; R++) {
          var E = this.generateBezier(r, l, A, h, f), D = this.findMaxError(r, l, E, A);
          if (D.error < n && M) {
            this.addCurve(i, E);
            return;
          }
          if (C = D.index, D.error >= B)
            break;
          M = this.reparameterize(r, l, A, E), B = D.error;
        }
        var L = m[C - 1].subtract(m[C + 1]);
        this.fitCubic(i, n, r, C, h, L), this.fitCubic(i, n, C, l, L.negate(), f);
      },
      addCurve: function(i, n) {
        var r = i[i.length - 1];
        r.setHandleOut(n[1].subtract(n[0])), i.push(new at(n[3], n[2].subtract(n[3])));
      },
      generateBezier: function(i, n, r, l, h) {
        for (var f = 1e-12, m = Math.abs, _ = this.points, y = _[i], x = _[n], A = [[0, 0], [0, 0]], B = [0, 0], C = 0, M = n - i + 1; C < M; C++) {
          var R = r[C], E = 1 - R, D = 3 * R * E, L = E * E * E, P = D * E, S = D * R, I = R * R * R, U = l.normalize(P), V = h.normalize(S), F = _[i + C].subtract(y.multiply(L + P)).subtract(x.multiply(S + I));
          A[0][0] += U.dot(U), A[0][1] += U.dot(V), A[1][0] = A[0][1], A[1][1] += V.dot(V), B[0] += U.dot(F), B[1] += V.dot(F);
        }
        var W = A[0][0] * A[1][1] - A[1][0] * A[0][1], Q, ie;
        if (m(W) > f) {
          var ae = A[0][0] * B[1] - A[1][0] * B[0], J = B[0] * A[1][1] - B[1] * A[0][1];
          Q = J / W, ie = ae / W;
        } else {
          var le = A[0][0] + A[0][1], fe = A[1][0] + A[1][1];
          Q = ie = m(le) > f ? B[0] / le : m(fe) > f ? B[1] / fe : 0;
        }
        var me = x.getDistance(y), ve = f * me, Se, Re;
        if (Q < ve || ie < ve)
          Q = ie = me / 3;
        else {
          var He = x.subtract(y);
          Se = l.normalize(Q), Re = h.normalize(ie), Se.dot(He) - Re.dot(He) > me * me && (Q = ie = me / 3, Se = Re = null);
        }
        return [
          y,
          y.add(Se || l.normalize(Q)),
          x.add(Re || h.normalize(ie)),
          x
        ];
      },
      reparameterize: function(i, n, r, l) {
        for (var h = i; h <= n; h++)
          r[h - i] = this.findRoot(l, this.points[h], r[h - i]);
        for (var h = 1, f = r.length; h < f; h++)
          if (r[h] <= r[h - 1])
            return !1;
        return !0;
      },
      findRoot: function(i, n, r) {
        for (var l = [], h = [], f = 0; f <= 2; f++)
          l[f] = i[f + 1].subtract(i[f]).multiply(3);
        for (var f = 0; f <= 1; f++)
          h[f] = l[f + 1].subtract(l[f]).multiply(2);
        var m = this.evaluate(3, i, r), _ = this.evaluate(2, l, r), y = this.evaluate(1, h, r), x = m.subtract(n), A = _.dot(_) + x.dot(y);
        return Y.isMachineZero(A) ? r : r - x.dot(_) / A;
      },
      evaluate: function(i, n, r) {
        for (var l = n.slice(), h = 1; h <= i; h++)
          for (var f = 0; f <= i - h; f++)
            l[f] = l[f].multiply(1 - r).add(l[f + 1].multiply(r));
        return l[0];
      },
      chordLengthParameterize: function(i, n) {
        for (var r = [0], l = i + 1; l <= n; l++)
          r[l - i] = r[l - i - 1] + this.points[l].getDistance(this.points[l - 1]);
        for (var l = 1, h = n - i; l <= h; l++)
          r[l] /= r[h];
        return r;
      },
      findMaxError: function(i, n, r, l) {
        for (var h = Math.floor((n - i + 1) / 2), f = 0, m = i + 1; m < n; m++) {
          var _ = this.evaluate(3, r, l[m - i]), y = _.subtract(this.points[m]), x = y.x * y.x + y.y * y.y;
          x >= f && (f = x, h = m);
        }
        return {
          error: f,
          index: h
        };
      }
    }), Ki = K.extend({
      _class: "TextItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _serializeFields: {
        content: null
      },
      _boundsOptions: { stroke: !1, handle: !1 },
      initialize: function(i) {
        this._content = "", this._lines = [];
        var n = i && a.isPlainObject(i) && i.x === t && i.y === t;
        this._initialize(n && i, !n && z.read(arguments));
      },
      _equals: function(i) {
        return this._content === i._content;
      },
      copyContent: function(i) {
        this.setContent(i._content);
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(i) {
        this._content = "" + i, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
      },
      isEmpty: function() {
        return !this._content;
      },
      getCharacterStyle: "#getStyle",
      setCharacterStyle: "#setStyle",
      getParagraphStyle: "#getStyle",
      setParagraphStyle: "#setStyle"
    }), as = Ki.extend({
      _class: "PointText",
      initialize: function() {
        Ki.apply(this, arguments);
      },
      getPoint: function() {
        var i = this._matrix.getTranslation();
        return new he(i.x, i.y, this, "setPoint");
      },
      setPoint: function() {
        var i = z.read(arguments);
        this.translate(i.subtract(this._matrix.getTranslation()));
      },
      _draw: function(i, n, r) {
        if (this._content) {
          this._setStyles(i, n, r);
          var l = this._lines, h = this._style, f = h.hasFill(), m = h.hasStroke(), _ = h.getLeading(), y = i.shadowColor;
          i.font = h.getFontStyle(), i.textAlign = h.getJustification();
          for (var x = 0, A = l.length; x < A; x++) {
            i.shadowColor = y;
            var B = l[x];
            f && (i.fillText(B, 0, 0), i.shadowColor = "rgba(0,0,0,0)"), m && i.strokeText(B, 0, 0), i.translate(0, _);
          }
        }
      },
      _getBounds: function(i, n) {
        var r = this._style, l = this._lines, h = l.length, f = r.getJustification(), m = r.getLeading(), _ = this.getView().getTextWidth(r.getFontStyle(), l), y = 0;
        f !== "left" && (y -= _ / (f === "center" ? 2 : 1));
        var x = new se(
          y,
          h ? -0.75 * m : 0,
          _,
          h * m
        );
        return i ? i._transformBounds(x, x) : x;
      }
    }), qt = a.extend(
      new function() {
        var i = {
          gray: ["gray"],
          rgb: ["red", "green", "blue"],
          hsb: ["hue", "saturation", "brightness"],
          hsl: ["hue", "saturation", "lightness"],
          gradient: ["gradient", "origin", "destination", "highlight"]
        }, n = {}, r = {
          transparent: [0, 0, 0, 0]
        }, l;
        function h(_) {
          var y = _.match(
            /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
          ) || _.match(
            /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
          ), x = "rgb", A;
          if (y) {
            var B = y[4] ? 4 : 3;
            A = new Array(B);
            for (var C = 0; C < B; C++) {
              var M = y[C + 1];
              A[C] = parseInt(M.length == 1 ? M + M : M, 16) / 255;
            }
          } else if (y = _.match(/^(rgb|hsl)a?\((.*)\)$/)) {
            x = y[1], A = y[2].trim().split(/[,\s]+/g);
            for (var R = x === "hsl", C = 0, E = Math.min(A.length, 4); C < E; C++) {
              var D = A[C], M = parseFloat(D);
              if (R)
                if (C === 0) {
                  var L = D.match(/([a-z]*)$/)[1];
                  M *= {
                    turn: 360,
                    rad: 180 / Math.PI,
                    grad: 0.9
                  }[L] || 1;
                } else
                  C < 3 && (M /= 100);
              else
                C < 3 && (M /= /%$/.test(D) ? 100 : 255);
              A[C] = M;
            }
          } else {
            var P = r[_];
            if (!P)
              if (s) {
                l || (l = Ut.getContext(1, 1, {
                  willReadFrequently: !0
                }), l.globalCompositeOperation = "copy"), l.fillStyle = "rgba(0,0,0,0)", l.fillStyle = _, l.fillRect(0, 0, 1, 1);
                var S = l.getImageData(0, 0, 1, 1).data;
                P = r[_] = [
                  S[0] / 255,
                  S[1] / 255,
                  S[2] / 255
                ];
              } else
                P = [0, 0, 0];
            A = P.slice();
          }
          return [x, A];
        }
        var f = [
          [0, 3, 1],
          [2, 0, 1],
          [1, 0, 3],
          [1, 2, 0],
          [3, 1, 0],
          [0, 1, 2]
        ], m = {
          "rgb-hsb": function(_, y, x) {
            var A = Math.max(_, y, x), B = Math.min(_, y, x), C = A - B, M = C === 0 ? 0 : (A == _ ? (y - x) / C + (y < x ? 6 : 0) : A == y ? (x - _) / C + 2 : (_ - y) / C + 4) * 60;
            return [M, A === 0 ? 0 : C / A, A];
          },
          "hsb-rgb": function(_, y, x) {
            _ = (_ / 60 % 6 + 6) % 6;
            var B = Math.floor(_), A = _ - B, B = f[B], C = [
              x,
              x * (1 - y),
              x * (1 - y * A),
              x * (1 - y * (1 - A))
            ];
            return [C[B[0]], C[B[1]], C[B[2]]];
          },
          "rgb-hsl": function(_, y, x) {
            var A = Math.max(_, y, x), B = Math.min(_, y, x), C = A - B, M = C === 0, R = M ? 0 : (A == _ ? (y - x) / C + (y < x ? 6 : 0) : A == y ? (x - _) / C + 2 : (_ - y) / C + 4) * 60, E = (A + B) / 2, D = M ? 0 : E < 0.5 ? C / (A + B) : C / (2 - A - B);
            return [R, D, E];
          },
          "hsl-rgb": function(_, y, x) {
            if (_ = (_ / 360 % 1 + 1) % 1, y === 0)
              return [x, x, x];
            for (var A = [_ + 1 / 3, _, _ - 1 / 3], B = x < 0.5 ? x * (1 + y) : x + y - x * y, C = 2 * x - B, M = [], R = 0; R < 3; R++) {
              var E = A[R];
              E < 0 && (E += 1), E > 1 && (E -= 1), M[R] = 6 * E < 1 ? C + (B - C) * 6 * E : 2 * E < 1 ? B : 3 * E < 2 ? C + (B - C) * (2 / 3 - E) * 6 : C;
            }
            return M;
          },
          "rgb-gray": function(_, y, x) {
            return [_ * 0.2989 + y * 0.587 + x * 0.114];
          },
          "gray-rgb": function(_) {
            return [_, _, _];
          },
          "gray-hsb": function(_) {
            return [0, 0, _];
          },
          "gray-hsl": function(_) {
            return [0, 0, _];
          },
          "gradient-rgb": function() {
            return [];
          },
          "rgb-gradient": function() {
            return [];
          }
        };
        return a.each(i, function(_, y) {
          n[y] = [], a.each(_, function(x, A) {
            var B = a.capitalize(x), C = /^(hue|saturation)$/.test(x), M = n[y][A] = y === "gradient" ? x === "gradient" ? function(R) {
              var E = this._components[0];
              return R = kn.read(
                Array.isArray(R) ? R : arguments,
                0,
                { readNull: !0 }
              ), E !== R && (E && E._removeOwner(this), R && R._addOwner(this)), R;
            } : function() {
              return z.read(arguments, 0, {
                readNull: x === "highlight",
                clone: !0
              });
            } : function(R) {
              return R == null || isNaN(R) ? 0 : +R;
            };
            this["get" + B] = function() {
              return this._type === y || C && /^hs[bl]$/.test(this._type) ? this._components[A] : this._convert(y)[A];
            }, this["set" + B] = function(R) {
              this._type !== y && !(C && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(y), this._properties = i[y], this._type = y), this._components[A] = M.call(this, R), this._changed();
            };
          }, this);
        }, {
          _class: "Color",
          _readIndex: !0,
          initialize: function _(y) {
            var x = arguments, A = this.__read, B = 0, C, M, R, E;
            Array.isArray(y) && (x = y, y = x[0]);
            var D = y != null && typeof y;
            if (D === "string" && y in i && (C = y, y = x[1], Array.isArray(y) ? (M = y, R = x[2]) : (A && (B = 1), x = a.slice(x, 1), D = typeof y)), !M) {
              if (E = D === "number" ? x : D === "object" && y.length != null ? y : null, E) {
                C || (C = E.length >= 3 ? "rgb" : "gray");
                var L = i[C].length;
                R = E[L], A && (B += E === arguments ? L + (R != null ? 1 : 0) : 1), E.length > L && (E = a.slice(E, 0, L));
              } else if (D === "string") {
                var P = h(y);
                C = P[0], M = P[1], M.length === 4 && (R = M[3], M.length--);
              } else if (D === "object")
                if (y.constructor === _) {
                  if (C = y._type, M = y._components.slice(), R = y._alpha, C === "gradient")
                    for (var S = 1, I = M.length; S < I; S++) {
                      var U = M[S];
                      U && (M[S] = U.clone());
                    }
                } else if (y.constructor === kn)
                  C = "gradient", E = x;
                else {
                  C = "hue" in y ? "lightness" in y ? "hsl" : "hsb" : "gradient" in y || "stops" in y || "radial" in y ? "gradient" : "gray" in y ? "gray" : "rgb";
                  var V = i[C], F = n[C];
                  this._components = M = [];
                  for (var S = 0, I = V.length; S < I; S++) {
                    var W = y[V[S]];
                    W == null && !S && C === "gradient" && "stops" in y && (W = {
                      stops: y.stops,
                      radial: y.radial
                    }), W = F[S].call(this, W), W != null && (M[S] = W);
                  }
                  R = y.alpha;
                }
              A && C && (B = 1);
            }
            if (this._type = C || "rgb", !M) {
              this._components = M = [];
              for (var F = n[this._type], S = 0, I = F.length; S < I; S++) {
                var W = F[S].call(this, E && E[S]);
                W != null && (M[S] = W);
              }
            }
            return this._components = M, this._properties = i[this._type], this._alpha = R, A && (this.__read = B), this;
          },
          set: "#initialize",
          _serialize: function(_, y) {
            var x = this.getComponents();
            return a.serialize(
              /^(gray|rgb)$/.test(this._type) ? x : [this._type].concat(x),
              _,
              !0,
              y
            );
          },
          _changed: function() {
            this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
          },
          _convert: function(_) {
            var y;
            return this._type === _ ? this._components.slice() : (y = m[this._type + "-" + _]) ? y.apply(this, this._components) : m["rgb-" + _].apply(
              this,
              m[this._type + "-rgb"].apply(
                this,
                this._components
              )
            );
          },
          convert: function(_) {
            return new qt(_, this._convert(_), this._alpha);
          },
          getType: function() {
            return this._type;
          },
          setType: function(_) {
            this._components = this._convert(_), this._properties = i[_], this._type = _;
          },
          getComponents: function() {
            var _ = this._components.slice();
            return this._alpha != null && _.push(this._alpha), _;
          },
          getAlpha: function() {
            return this._alpha != null ? this._alpha : 1;
          },
          setAlpha: function(_) {
            this._alpha = _ == null ? null : Math.min(Math.max(_, 0), 1), this._changed();
          },
          hasAlpha: function() {
            return this._alpha != null;
          },
          equals: function(_) {
            var y = a.isPlainValue(_, !0) ? qt.read(arguments) : _;
            return y === this || y && this._class === y._class && this._type === y._type && this.getAlpha() === y.getAlpha() && a.equals(this._components, y._components) || !1;
          },
          toString: function() {
            for (var _ = this._properties, y = [], x = this._type === "gradient", A = H.instance, B = 0, C = _.length; B < C; B++) {
              var M = this._components[B];
              M != null && y.push(_[B] + ": " + (x ? M : A.number(M)));
            }
            return this._alpha != null && y.push("alpha: " + A.number(this._alpha)), "{ " + y.join(", ") + " }";
          },
          toCSS: function(_) {
            var y = this._convert("rgb"), x = _ || this._alpha == null ? 1 : this._alpha;
            function A(B) {
              return Math.round((B < 0 ? 0 : B > 1 ? 1 : B) * 255);
            }
            return y = [
              A(y[0]),
              A(y[1]),
              A(y[2])
            ], x < 1 && y.push(x < 0 ? 0 : x), _ ? "#" + ((1 << 24) + (y[0] << 16) + (y[1] << 8) + y[2]).toString(16).slice(1) : (y.length == 4 ? "rgba(" : "rgb(") + y.join(",") + ")";
          },
          toCanvasStyle: function(_, y) {
            if (this._canvasStyle)
              return this._canvasStyle;
            if (this._type !== "gradient")
              return this._canvasStyle = this.toCSS();
            var x = this._components, A = x[0], B = A._stops, C = x[1], M = x[2], R = x[3], E = y && y.inverted(), D;
            if (E && (C = E._transformPoint(C), M = E._transformPoint(M), R && (R = E._transformPoint(R))), A._radial) {
              var L = M.getDistance(C);
              if (R) {
                var P = R.subtract(C);
                P.getLength() > L && (R = C.add(P.normalize(L - 0.1)));
              }
              var S = R || C;
              D = _.createRadialGradient(
                S.x,
                S.y,
                0,
                C.x,
                C.y,
                L
              );
            } else
              D = _.createLinearGradient(
                C.x,
                C.y,
                M.x,
                M.y
              );
            for (var I = 0, U = B.length; I < U; I++) {
              var V = B[I], F = V._offset;
              D.addColorStop(
                F ?? I / (U - 1),
                V._color.toCanvasStyle()
              );
            }
            return this._canvasStyle = D;
          },
          transform: function(_) {
            if (this._type === "gradient") {
              for (var y = this._components, x = 1, A = y.length; x < A; x++) {
                var B = y[x];
                _._transformPoint(B, B, !0);
              }
              this._changed();
            }
          },
          statics: {
            _types: i,
            random: function() {
              var _ = Math.random;
              return new qt(_(), _(), _());
            },
            _setOwner: function(_, y, x) {
              return _ && (_._owner && y && _._owner !== y && (_ = _.clone()), !_._owner ^ !y && (_._owner = y || null, _._setter = x || null)), _;
            }
          }
        });
      }(),
      new function() {
        var i = {
          add: function(n, r) {
            return n + r;
          },
          subtract: function(n, r) {
            return n - r;
          },
          multiply: function(n, r) {
            return n * r;
          },
          divide: function(n, r) {
            return n / r;
          }
        };
        return a.each(i, function(n, r) {
          this[r] = function(l) {
            l = qt.read(arguments);
            for (var h = this._type, f = this._components, m = l._convert(h), _ = 0, y = f.length; _ < y; _++)
              m[_] = n(f[_], m[_]);
            return new qt(
              h,
              m,
              this._alpha != null ? n(this._alpha, l.getAlpha()) : null
            );
          };
        }, {});
      }()
    ), kn = a.extend({
      _class: "Gradient",
      initialize: function(i, n) {
        this._id = ee.get(), i && a.isPlainObject(i) && (this.set(i), i = n = null), this._stops == null && this.setStops(i || ["white", "black"]), this._radial == null && this.setRadial(typeof n == "string" && n === "radial" || n || !1);
      },
      _serialize: function(i, n) {
        return n.add(this, function() {
          return a.serialize(
            [this._stops, this._radial],
            i,
            !0,
            n
          );
        });
      },
      _changed: function() {
        for (var i = 0, n = this._owners && this._owners.length; i < n; i++)
          this._owners[i]._changed();
      },
      _addOwner: function(i) {
        this._owners || (this._owners = []), this._owners.push(i);
      },
      _removeOwner: function(i) {
        var n = this._owners ? this._owners.indexOf(i) : -1;
        n != -1 && (this._owners.splice(n, 1), this._owners.length || (this._owners = t));
      },
      clone: function() {
        for (var i = [], n = 0, r = this._stops.length; n < r; n++)
          i[n] = this._stops[n].clone();
        return new kn(i, this._radial);
      },
      getStops: function() {
        return this._stops;
      },
      setStops: function(i) {
        if (i.length < 2)
          throw new Error(
            "Gradient stop list needs to contain at least two stops."
          );
        var n = this._stops;
        if (n)
          for (var r = 0, l = n.length; r < l; r++)
            n[r]._owner = t;
        n = this._stops = Ms.readList(i, 0, { clone: !0 });
        for (var r = 0, l = n.length; r < l; r++)
          n[r]._owner = this;
        this._changed();
      },
      getRadial: function() {
        return this._radial;
      },
      setRadial: function(i) {
        this._radial = i, this._changed();
      },
      equals: function(i) {
        if (i === this)
          return !0;
        if (i && this._class === i._class) {
          var n = this._stops, r = i._stops, l = n.length;
          if (l === r.length) {
            for (var h = 0; h < l; h++)
              if (!n[h].equals(r[h]))
                return !1;
            return !0;
          }
        }
        return !1;
      }
    }), Ms = a.extend({
      _class: "GradientStop",
      initialize: function(i, n) {
        var r = i, l = n;
        typeof i == "object" && n === t && (Array.isArray(i) && typeof i[0] != "number" ? (r = i[0], l = i[1]) : ("color" in i || "offset" in i || "rampPoint" in i) && (r = i.color, l = i.offset || i.rampPoint || 0)), this.setColor(r), this.setOffset(l);
      },
      clone: function() {
        return new Ms(this._color.clone(), this._offset);
      },
      _serialize: function(i, n) {
        var r = this._color, l = this._offset;
        return a.serialize(
          l == null ? [r] : [r, l],
          i,
          !0,
          n
        );
      },
      _changed: function() {
        this._owner && this._owner._changed(129);
      },
      getOffset: function() {
        return this._offset;
      },
      setOffset: function(i) {
        this._offset = i, this._changed();
      },
      getRampPoint: "#getOffset",
      setRampPoint: "#setOffset",
      getColor: function() {
        return this._color;
      },
      setColor: function() {
        qt._setOwner(this._color, null), this._color = qt._setOwner(
          qt.read(arguments, 0),
          this,
          "setColor"
        ), this._changed();
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._color.equals(i._color) && this._offset == i._offset || !1;
      }
    }), Wn = a.extend(new function() {
      var i = {
        fillColor: null,
        fillRule: "nonzero",
        strokeColor: null,
        strokeWidth: 1,
        strokeCap: "butt",
        strokeJoin: "miter",
        strokeScaling: !0,
        miterLimit: 10,
        dashOffset: 0,
        dashArray: [],
        shadowColor: null,
        shadowBlur: 0,
        shadowOffset: new z(),
        selectedColor: null
      }, n = a.set({}, i, {
        fontFamily: "sans-serif",
        fontWeight: "normal",
        fontSize: 12,
        leading: null,
        justification: "left"
      }), r = a.set({}, n, {
        fillColor: new qt()
      }), l = {
        strokeWidth: 193,
        strokeCap: 193,
        strokeJoin: 193,
        strokeScaling: 201,
        miterLimit: 193,
        fontFamily: 9,
        fontWeight: 9,
        fontSize: 9,
        font: 9,
        leading: 9,
        justification: 9
      }, h = {
        beans: !0
      }, f = {
        _class: "Style",
        beans: !0,
        initialize: function(m, _, y) {
          this._values = {}, this._owner = _, this._project = _ && _._project || y || nt.project, this._defaults = !_ || _ instanceof j ? n : _ instanceof Ki ? r : i, m && this.set(m);
        }
      };
      return a.each(n, function(m, _) {
        var y = /Color$/.test(_), x = _ === "shadowOffset", A = a.capitalize(_), B = l[_], C = "set" + A, M = "get" + A;
        f[C] = function(R) {
          var E = this._owner, D = E && E._children, L = D && D.length > 0 && !(E instanceof yi);
          if (L)
            for (var P = 0, S = D.length; P < S; P++)
              D[P]._style[C](R);
          if ((_ === "selectedColor" || !L) && _ in this._defaults) {
            var I = this._values[_];
            I !== R && (y && (I && (qt._setOwner(I, null), I._canvasStyle = null), R && R.constructor === qt && (R = qt._setOwner(
              R,
              E,
              L && C
            ))), this._values[_] = R, E && E._changed(B || 129));
          }
        }, f[M] = function(R) {
          var E = this._owner, D = E && E._children, L = D && D.length > 0 && !(E instanceof yi), P;
          if (L && !R)
            for (var S = 0, I = D.length; S < I; S++) {
              var U = D[S]._style[M]();
              if (!S)
                P = U;
              else if (!a.equals(P, U))
                return t;
            }
          else if (_ in this._defaults) {
            var P = this._values[_];
            if (P === t)
              P = this._defaults[_], P && P.clone && (P = P.clone());
            else {
              var V = y ? qt : x ? z : null;
              V && !(P && P.constructor === V) && (this._values[_] = P = V.read(
                [P],
                0,
                { readNull: !0, clone: !0 }
              ));
            }
          }
          return P && y && (P = qt._setOwner(P, E, L && C)), P;
        }, h[M] = function(R) {
          return this._style[M](R);
        }, h[C] = function(R) {
          this._style[C](R);
        };
      }), a.each({
        Font: "FontFamily",
        WindingRule: "FillRule"
      }, function(m, _) {
        var y = "get" + _, x = "set" + _;
        f[y] = h[y] = "#get" + m, f[x] = h[x] = "#set" + m;
      }), K.inject(h), f;
    }(), {
      set: function(i) {
        var n = i instanceof Wn, r = n ? i._values : i;
        if (r) {
          for (var l in r)
            if (l in this._defaults) {
              var h = r[l];
              this[l] = h && n && h.clone ? h.clone() : h;
            }
        }
      },
      equals: function(i) {
        function n(r, l, h) {
          var f = r._values, m = l._values, _ = l._defaults;
          for (var y in f) {
            var x = f[y], A = m[y];
            if (!(h && y in m) && !a.equals(
              x,
              A === t ? _[y] : A
            ))
              return !1;
          }
          return !0;
        }
        return i === this || i && this._class === i._class && n(this, i) && n(i, this, !0) || !1;
      },
      _dispose: function() {
        var i;
        i = this.getFillColor(), i && (i._canvasStyle = null), i = this.getStrokeColor(), i && (i._canvasStyle = null), i = this.getShadowColor(), i && (i._canvasStyle = null);
      },
      hasFill: function() {
        var i = this.getFillColor();
        return !!i && i.alpha > 0;
      },
      hasStroke: function() {
        var i = this.getStrokeColor();
        return !!i && i.alpha > 0 && this.getStrokeWidth() > 0;
      },
      hasShadow: function() {
        var i = this.getShadowColor();
        return !!i && i.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
      },
      getView: function() {
        return this._project._view;
      },
      getFontStyle: function() {
        var i = this.getFontSize();
        return this.getFontWeight() + " " + i + (/[a-z]/i.test(i + "") ? " " : "px ") + this.getFontFamily();
      },
      getFont: "#getFontFamily",
      setFont: "#setFontFamily",
      getLeading: function i() {
        var n = i.base.call(this), r = this.getFontSize();
        return /pt|em|%|px/.test(r) && (r = this.getView().getPixelSize(r)), n ?? r * 1.2;
      }
    }), zt = new function() {
      function i(n, r, l, h) {
        for (var f = ["", "webkit", "moz", "Moz", "ms", "o"], m = r[0].toUpperCase() + r.substring(1), _ = 0; _ < 6; _++) {
          var y = f[_], x = y ? y + m : r;
          if (x in n) {
            if (l)
              n[x] = h;
            else
              return n[x];
            break;
          }
        }
      }
      return {
        getStyles: function(n) {
          var r = n && n.nodeType !== 9 ? n.ownerDocument : n, l = r && r.defaultView;
          return l && l.getComputedStyle(n, "");
        },
        getBounds: function(n, r) {
          var l = n.ownerDocument, h = l.body, f = l.documentElement, m;
          try {
            m = n.getBoundingClientRect();
          } catch {
            m = { left: 0, top: 0, width: 0, height: 0 };
          }
          var _ = m.left - (f.clientLeft || h.clientLeft || 0), y = m.top - (f.clientTop || h.clientTop || 0);
          if (!r) {
            var x = l.defaultView;
            _ += x.pageXOffset || f.scrollLeft || h.scrollLeft, y += x.pageYOffset || f.scrollTop || h.scrollTop;
          }
          return new se(_, y, m.width, m.height);
        },
        getViewportBounds: function(n) {
          var r = n.ownerDocument, l = r.defaultView, h = r.documentElement;
          return new se(
            0,
            0,
            l.innerWidth || h.clientWidth,
            l.innerHeight || h.clientHeight
          );
        },
        getOffset: function(n, r) {
          return zt.getBounds(n, r).getPoint();
        },
        getSize: function(n) {
          return zt.getBounds(n, !0).getSize();
        },
        isInvisible: function(n) {
          return zt.getSize(n).equals(new ne(0, 0));
        },
        isInView: function(n) {
          return !zt.isInvisible(n) && zt.getViewportBounds(n).intersects(
            zt.getBounds(n, !0)
          );
        },
        isInserted: function(n) {
          return o.body.contains(n);
        },
        getPrefixed: function(n, r) {
          return n && i(n, r);
        },
        setPrefixed: function(n, r, l) {
          if (typeof r == "object")
            for (var h in r)
              i(n, h, !0, r[h]);
          else
            i(n, r, !0, l);
        }
      };
    }(), Dt = {
      add: function(i, n) {
        if (i)
          for (var r in n)
            for (var l = n[r], h = r.split(/[\s,]+/g), f = 0, m = h.length; f < m; f++) {
              var _ = h[f], y = i === o && (_ === "touchstart" || _ === "touchmove") ? { passive: !1 } : !1;
              i.addEventListener(_, l, y);
            }
      },
      remove: function(i, n) {
        if (i)
          for (var r in n)
            for (var l = n[r], h = r.split(/[\s,]+/g), f = 0, m = h.length; f < m; f++)
              i.removeEventListener(h[f], l, !1);
      },
      getPoint: function(i) {
        var n = i.targetTouches ? i.targetTouches.length ? i.targetTouches[0] : i.changedTouches[0] : i;
        return new z(
          n.pageX || n.clientX + o.documentElement.scrollLeft,
          n.pageY || n.clientY + o.documentElement.scrollTop
        );
      },
      getTarget: function(i) {
        return i.target || i.srcElement;
      },
      getRelatedTarget: function(i) {
        return i.relatedTarget || i.toElement;
      },
      getOffset: function(i, n) {
        return Dt.getPoint(i).subtract(zt.getOffset(
          n || Dt.getTarget(i)
        ));
      }
    };
    Dt.requestAnimationFrame = new function() {
      var i = zt.getPrefixed(s, "requestAnimationFrame"), n = !1, r = [], l;
      function h() {
        var f = r;
        r = [];
        for (var m = 0, _ = f.length; m < _; m++)
          f[m]();
        n = i && r.length, n && i(h);
      }
      return function(f) {
        r.push(f), i ? n || (i(h), n = !0) : l || (l = setInterval(h, 1e3 / 60));
      };
    }();
    var Ht = a.extend(
      c,
      {
        _class: "View",
        initialize: function i(n, r) {
          function l(B) {
            return r[B] || parseInt(r.getAttribute(B), 10);
          }
          function h() {
            var B = zt.getSize(r);
            return B.isNaN() || B.isZero() ? new ne(l("width"), l("height")) : B;
          }
          var f;
          if (s && r) {
            this._id = r.getAttribute("id"), this._id == null && r.setAttribute("id", this._id = "paper-view-" + i._id++), Dt.add(r, this._viewEvents);
            var m = "none";
            if (zt.setPrefixed(r.style, {
              userDrag: m,
              userSelect: m,
              touchCallout: m,
              contentZooming: m,
              tapHighlightColor: "rgba(0,0,0,0)"
            }), g.hasAttribute(r, "resize")) {
              var _ = this;
              Dt.add(s, this._windowEvents = {
                resize: function() {
                  _.setViewSize(h());
                }
              });
            }
            if (f = h(), g.hasAttribute(r, "stats") && typeof Stats < "u") {
              this._stats = new Stats();
              var y = this._stats.domElement, x = y.style, A = zt.getOffset(r);
              x.position = "absolute", x.left = A.x + "px", x.top = A.y + "px", o.body.appendChild(y);
            }
          } else
            f = new ne(r), r = null;
          this._project = n, this._scope = n._scope, this._element = r, this._pixelRatio || (this._pixelRatio = s && s.devicePixelRatio || 1), this._setElementSize(f.width, f.height), this._viewSize = f, i._views.push(this), i._viewsById[this._id] = this, (this._matrix = new ue())._owner = this, i._focused || (i._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !nt.agent.node, this._needsUpdate = !1;
        },
        remove: function() {
          if (!this._project)
            return !1;
          Ht._focused === this && (Ht._focused = null), Ht._views.splice(Ht._views.indexOf(this), 1), delete Ht._viewsById[this._id];
          var i = this._project;
          return i._view === this && (i._view = null), Dt.remove(this._element, this._viewEvents), Dt.remove(s, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
        },
        _events: a.each(
          K._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
          function(i) {
            this[i] = {};
          },
          {
            onFrame: {
              install: function() {
                this.play();
              },
              uninstall: function() {
                this.pause();
              }
            }
          }
        ),
        _animate: !1,
        _time: 0,
        _count: 0,
        getAutoUpdate: function() {
          return this._autoUpdate;
        },
        setAutoUpdate: function(i) {
          this._autoUpdate = i, i && this.requestUpdate();
        },
        update: function() {
        },
        draw: function() {
          this.update();
        },
        requestUpdate: function() {
          if (!this._requested) {
            var i = this;
            Dt.requestAnimationFrame(function() {
              if (i._requested = !1, i._animate) {
                i.requestUpdate();
                var n = i._element;
                (!zt.getPrefixed(o, "hidden") || g.getAttribute(n, "keepalive") === "true") && zt.isInView(n) && i._handleFrame();
              }
              i._autoUpdate && i.update();
            }), this._requested = !0;
          }
        },
        play: function() {
          this._animate = !0, this.requestUpdate();
        },
        pause: function() {
          this._animate = !1;
        },
        _handleFrame: function() {
          nt = this._scope;
          var i = Date.now() / 1e3, n = this._last ? i - this._last : 0;
          this._last = i, this.emit("frame", new a({
            delta: n,
            time: this._time += n,
            count: this._count++
          })), this._stats && this._stats.update();
        },
        _animateItem: function(i, n) {
          var r = this._frameItems;
          n ? (r[i._id] = {
            item: i,
            time: 0,
            count: 0
          }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete r[i._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
        },
        _handleFrameItems: function(i) {
          for (var n in this._frameItems) {
            var r = this._frameItems[n];
            r.item.emit("frame", new a(i, {
              time: r.time += i.delta,
              count: r.count++
            }));
          }
        },
        _changed: function() {
          this._project._changed(4097), this._bounds = this._decomposed = t;
        },
        getElement: function() {
          return this._element;
        },
        getPixelRatio: function() {
          return this._pixelRatio;
        },
        getResolution: function() {
          return this._pixelRatio * 72;
        },
        getViewSize: function() {
          var i = this._viewSize;
          return new ye(i.width, i.height, this, "setViewSize");
        },
        setViewSize: function() {
          var i = ne.read(arguments), n = i.subtract(this._viewSize);
          n.isZero() || (this._setElementSize(i.width, i.height), this._viewSize.set(i), this._changed(), this.emit("resize", { size: i, delta: n }), this._autoUpdate && this.update());
        },
        _setElementSize: function(i, n) {
          var r = this._element;
          r && (r.width !== i && (r.width = i), r.height !== n && (r.height = n));
        },
        getBounds: function() {
          return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
            new se(new z(), this._viewSize)
          )), this._bounds;
        },
        getSize: function() {
          return this.getBounds().getSize();
        },
        isVisible: function() {
          return zt.isInView(this._element);
        },
        isInserted: function() {
          return zt.isInserted(this._element);
        },
        getPixelSize: function(i) {
          var n = this._element, r;
          if (n) {
            var l = n.parentNode, h = o.createElement("div");
            h.style.fontSize = i, l.appendChild(h), r = parseFloat(zt.getStyles(h).fontSize), l.removeChild(h);
          } else
            r = parseFloat(r);
          return r;
        },
        getTextWidth: function(i, n) {
          return 0;
        }
      },
      a.each(["rotate", "scale", "shear", "skew"], function(i) {
        var n = i === "rotate";
        this[i] = function() {
          var r = arguments, l = (n ? a : z).read(r), h = z.read(r, 0, { readNull: !0 });
          return this.transform(new ue()[i](
            l,
            h || this.getCenter(!0)
          ));
        };
      }, {
        _decompose: function() {
          return this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        translate: function() {
          var i = new ue();
          return this.transform(i.translate.apply(i, arguments));
        },
        getCenter: function() {
          return this.getBounds().getCenter();
        },
        setCenter: function() {
          var i = z.read(arguments);
          this.translate(this.getCenter().subtract(i));
        },
        getZoom: function() {
          var i = this._decompose().scaling;
          return (i.x + i.y) / 2;
        },
        setZoom: function(i) {
          this.transform(new ue().scale(
            i / this.getZoom(),
            this.getCenter()
          ));
        },
        getRotation: function() {
          return this._decompose().rotation;
        },
        setRotation: function(i) {
          var n = this.getRotation();
          n != null && i != null && this.rotate(i - n);
        },
        getScaling: function() {
          var i = this._decompose().scaling;
          return new he(i.x, i.y, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), n = z.read(arguments, 0, { clone: !0, readNull: !0 });
          i && n && this.scale(n.x / i.x, n.y / i.y);
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        transform: function(i) {
          this._matrix.append(i);
        },
        scrollBy: function() {
          this.translate(z.read(arguments).negate());
        }
      }),
      {
        projectToView: function() {
          return this._matrix._transformPoint(z.read(arguments));
        },
        viewToProject: function() {
          return this._matrix._inverseTransform(z.read(arguments));
        },
        getEventPoint: function(i) {
          return this.viewToProject(Dt.getOffset(i, this._element));
        }
      },
      {
        statics: {
          _views: [],
          _viewsById: {},
          _id: 0,
          create: function(i, n) {
            o && typeof n == "string" && (n = o.getElementById(n));
            var r = s ? Dn : Ht;
            return new r(i, n);
          }
        }
      },
      new function() {
        if (!s)
          return;
        var i, n, r = !1, l = !1;
        function h(J) {
          var le = Dt.getTarget(J);
          return le.getAttribute && Ht._viewsById[le.getAttribute("id")];
        }
        function f() {
          var J = Ht._focused;
          if (!J || !J.isVisible()) {
            for (var le = 0, fe = Ht._views.length; le < fe; le++)
              if ((J = Ht._views[le]).isVisible()) {
                Ht._focused = n = J;
                break;
              }
          }
        }
        function m(J, le, fe) {
          J._handleMouseEvent("mousemove", le, fe);
        }
        var _ = s.navigator, y, x, A;
        _.pointerEnabled || _.msPointerEnabled ? (y = "pointerdown MSPointerDown", x = "pointermove MSPointerMove", A = "pointerup pointercancel MSPointerUp MSPointerCancel") : (y = "touchstart", x = "touchmove", A = "touchend touchcancel", "ontouchstart" in s && _.userAgent.match(
          /mobile|tablet|ip(ad|hone|od)|android|silk/i
        ) || (y += " mousedown", x += " mousemove", A += " mouseup"));
        var B = {}, C = {
          mouseout: function(J) {
            var le = Ht._focused, fe = Dt.getRelatedTarget(J);
            if (le && (!fe || fe.nodeName === "HTML")) {
              var me = Dt.getOffset(J, le._element), ve = me.x, Se = Math.abs, Re = Se(ve), He = 1 << 25, Ye = Re - He;
              me.x = Se(Ye) < Re ? Ye * (ve < 0 ? -1 : 1) : ve, m(le, J, le.viewToProject(me));
            }
          },
          scroll: f
        };
        B[y] = function(J) {
          var le = Ht._focused = h(J);
          r || (r = !0, le._handleMouseEvent("mousedown", J));
        }, C[x] = function(J) {
          var le = Ht._focused;
          if (!l) {
            var fe = h(J);
            fe ? le !== fe && (le && m(le, J), i || (i = le), le = Ht._focused = n = fe) : n && n === le && (i && !i.isInserted() && (i = null), le = Ht._focused = i, i = null, f());
          }
          le && m(le, J);
        }, C[y] = function() {
          l = !0;
        }, C[A] = function(J) {
          var le = Ht._focused;
          le && r && le._handleMouseEvent("mouseup", J), l = r = !1;
        }, Dt.add(o, C), Dt.add(s, {
          load: f
        });
        var M = !1, R = !1, E = {
          doubleclick: "click",
          mousedrag: "mousemove"
        }, D = !1, L, P, S, I, U, V, F, W;
        function Q(J, le, fe, me, ve, Se, Re) {
          var He = !1, Ye;
          function Je(Be, Ie) {
            if (Be.responds(Ie)) {
              if (Ye || (Ye = new Ds(
                Ie,
                me,
                ve,
                le || Be,
                Se ? ve.subtract(Se) : null
              )), Be.emit(Ie, Ye) && (M = !0, Ye.prevented && (R = !0), Ye.stopped))
                return He = !0;
            } else {
              var Ge = E[Ie];
              if (Ge)
                return Je(Be, Ge);
            }
          }
          for (; J && J !== Re && !Je(J, fe); )
            J = J._parent;
          return He;
        }
        function ie(J, le, fe, me, ve, Se) {
          return J._project.removeOn(fe), R = M = !1, U && Q(
            U,
            null,
            fe,
            me,
            ve,
            Se
          ) || le && le !== U && !le.isDescendant(U) && Q(le, null, fe === "mousedrag" ? "mousemove" : fe, me, ve, Se, U) || Q(
            J,
            U || le || J,
            fe,
            me,
            ve,
            Se
          );
        }
        var ae = {
          mousedown: {
            mousedown: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mouseup: {
            mouseup: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mousemove: {
            mousedrag: 1,
            mousemove: 1,
            mouseenter: 1,
            mouseleave: 1
          }
        };
        return {
          _viewEvents: B,
          _handleMouseEvent: function(J, le, fe) {
            var me = this._itemEvents, ve = me.native[J], Se = J === "mousemove", Re = this._scope.tool, He = this;
            function Ye(gt) {
              return me.virtual[gt] || He.responds(gt) || Re && Re.responds(gt);
            }
            Se && r && Ye("mousedrag") && (J = "mousedrag"), fe || (fe = this.getEventPoint(le));
            var Je = this.getBounds().contains(fe), Be = ve && Je && He._project.hitTest(fe, {
              tolerance: 0,
              fill: !0,
              stroke: !0
            }), Ie = Be && Be.item || null, Ge = !1, et = {};
            if (et[J.substr(5)] = !0, ve && Ie !== I && (I && Q(I, null, "mouseleave", le, fe), Ie && Q(Ie, null, "mouseenter", le, fe), I = Ie), D ^ Je && (Q(
              this,
              null,
              Je ? "mouseenter" : "mouseleave",
              le,
              fe
            ), Ge = !0), (Je || et.drag) && !fe.equals(P) && (ie(
              this,
              Ie,
              Se ? J : "mousemove",
              le,
              fe,
              P
            ), Ge = !0), D = Je, et.down && Je || et.up && L) {
              if (ie(this, Ie, J, le, fe, L), et.down) {
                if (W = Ie === V && Date.now() - F < 300, S = V = Ie, !R && Ie) {
                  for (var tt = Ie; tt && !tt.responds("mousedrag"); )
                    tt = tt._parent;
                  tt && (U = Ie);
                }
                L = fe;
              } else
                et.up && (!R && Ie === S && (F = Date.now(), ie(this, Ie, W ? "doubleclick" : "click", le, fe, L), W = !1), S = U = null);
              D = !1, Ge = !0;
            }
            P = fe, Ge && Re && (M = Re._handleMouseEvent(J, le, fe, et) || M), le.cancelable !== !1 && (M && !et.move || et.down && Ye("mouseup")) && le.preventDefault();
          },
          _handleKeyEvent: function(J, le, fe, me) {
            var ve = this._scope, Se = ve.tool, Re;
            function He(Ye) {
              Ye.responds(J) && (nt = ve, Ye.emit(J, Re = Re || new Sn(J, le, fe, me)));
            }
            this.isVisible() && (He(this), Se && Se.responds(J) && He(Se));
          },
          _countItemEvent: function(J, le) {
            var fe = this._itemEvents, me = fe.native, ve = fe.virtual;
            for (var Se in ae)
              me[Se] = (me[Se] || 0) + (ae[Se][J] || 0) * le;
            ve[J] = (ve[J] || 0) + le;
          },
          statics: {
            updateFocus: f,
            _resetState: function() {
              r = l = M = D = !1, i = n = L = P = S = I = U = V = F = W = null;
            }
          }
        };
      }()
    ), Dn = Ht.extend({
      _class: "CanvasView",
      initialize: function(i, n) {
        if (!(n instanceof s.HTMLCanvasElement)) {
          var r = ne.read(arguments, 1);
          if (r.isZero())
            throw new Error(
              "Cannot create CanvasView with the provided argument: " + a.slice(arguments, 1)
            );
          n = Ut.getCanvas(r);
        }
        var l = this._context = n.getContext("2d");
        if (l.save(), this._pixelRatio = 1, !/^off|false$/.test(g.getAttribute(n, "hidpi"))) {
          var h = s.devicePixelRatio || 1, f = zt.getPrefixed(
            l,
            "backingStorePixelRatio"
          ) || 1;
          this._pixelRatio = h / f;
        }
        Ht.call(this, i, n), this._needsUpdate = !0;
      },
      remove: function i() {
        return this._context.restore(), i.base.call(this);
      },
      _setElementSize: function i(n, r) {
        var l = this._pixelRatio;
        if (i.base.call(this, n * l, r * l), l !== 1) {
          var h = this._element, f = this._context;
          if (!g.hasAttribute(h, "resize")) {
            var m = h.style;
            m.width = n + "px", m.height = r + "px";
          }
          f.restore(), f.save(), f.scale(l, l);
        }
      },
      getContext: function() {
        return this._context;
      },
      getPixelSize: function i(n) {
        var r = nt.agent, l;
        if (r && r.firefox)
          l = i.base.call(this, n);
        else {
          var h = this._context, f = h.font;
          h.font = n + " serif", l = parseFloat(h.font), h.font = f;
        }
        return l;
      },
      getTextWidth: function(i, n) {
        var r = this._context, l = r.font, h = 0;
        r.font = i;
        for (var f = 0, m = n.length; f < m; f++)
          h = Math.max(h, r.measureText(n[f]).width);
        return r.font = l, h;
      },
      update: function() {
        if (!this._needsUpdate)
          return !1;
        var i = this._project, n = this._context, r = this._viewSize;
        return n.clearRect(0, 0, r.width + 1, r.height + 1), i && i.draw(n, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
      }
    }), Ln = a.extend({
      _class: "Event",
      initialize: function(i) {
        this.event = i, this.type = i && i.type;
      },
      prevented: !1,
      stopped: !1,
      preventDefault: function() {
        this.prevented = !0, this.event.preventDefault();
      },
      stopPropagation: function() {
        this.stopped = !0, this.event.stopPropagation();
      },
      stop: function() {
        this.stopPropagation(), this.preventDefault();
      },
      getTimeStamp: function() {
        return this.event.timeStamp;
      },
      getModifiers: function() {
        return qn.modifiers;
      }
    }), Sn = Ln.extend({
      _class: "KeyEvent",
      initialize: function(i, n, r, l) {
        this.type = i, this.event = n, this.key = r, this.character = l;
      },
      toString: function() {
        return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
      }
    }), qn = new function() {
      var i = {
        "	": "tab",
        " ": "space",
        "\b": "backspace",
        "": "delete",
        Spacebar: "space",
        Del: "delete",
        Win: "meta",
        Esc: "escape"
      }, n = {
        tab: "	",
        space: " ",
        enter: "\r"
      }, r = {}, l = {}, h, f, m = new a({
        shift: !1,
        control: !1,
        alt: !1,
        meta: !1,
        capsLock: !1,
        space: !1
      }).inject({
        option: {
          get: function() {
            return this.alt;
          }
        },
        command: {
          get: function() {
            var x = nt && nt.agent;
            return x && x.mac ? this.meta : this.control;
          }
        }
      });
      function _(x) {
        var A = x.key || x.keyIdentifier;
        return A = /^U\+/.test(A) ? String.fromCharCode(parseInt(A.substr(2), 16)) : /^Arrow[A-Z]/.test(A) ? A.substr(5) : A === "Unidentified" || A === t ? String.fromCharCode(x.keyCode) : A, i[A] || (A.length > 1 ? a.hyphenate(A) : A.toLowerCase());
      }
      function y(x, A, B, C) {
        var M = Ht._focused, R;
        if (r[A] = x, x ? l[A] = B : delete l[A], A.length > 1 && (R = a.camelize(A)) in m) {
          m[R] = x;
          var E = nt && nt.agent;
          if (R === "meta" && E && E.mac)
            if (x)
              h = {};
            else {
              for (var D in h)
                D in l && y(!1, D, h[D], C);
              h = null;
            }
        } else
          x && h && (h[A] = B);
        M && M._handleKeyEvent(
          x ? "keydown" : "keyup",
          C,
          A,
          B
        );
      }
      return Dt.add(o, {
        keydown: function(x) {
          var A = _(x), B = nt && nt.agent;
          A.length > 1 || B && B.chrome && (x.altKey || B.mac && x.metaKey || !B.mac && x.ctrlKey) ? y(
            !0,
            A,
            n[A] || (A.length > 1 ? "" : A),
            x
          ) : f = A;
        },
        keypress: function(x) {
          if (f) {
            var A = _(x), B = x.charCode, C = B >= 32 ? String.fromCharCode(B) : A.length > 1 ? "" : A;
            A !== f && (A = C.toLowerCase()), y(!0, A, C, x), f = null;
          }
        },
        keyup: function(x) {
          var A = _(x);
          A in l && y(!1, A, l[A], x);
        }
      }), Dt.add(s, {
        blur: function(x) {
          for (var A in l)
            y(!1, A, l[A], x);
        }
      }), {
        modifiers: m,
        isDown: function(x) {
          return !!r[x];
        }
      };
    }(), Ds = Ln.extend({
      _class: "MouseEvent",
      initialize: function(i, n, r, l, h) {
        this.type = i, this.event = n, this.point = r, this.target = l, this.delta = h;
      },
      toString: function() {
        return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
      }
    }), ln = Ln.extend({
      _class: "ToolEvent",
      _item: null,
      initialize: function(i, n, r) {
        this.tool = i, this.type = n, this.event = r;
      },
      _choosePoint: function(i, n) {
        return i || (n ? n.clone() : null);
      },
      getPoint: function() {
        return this._choosePoint(this._point, this.tool._point);
      },
      setPoint: function(i) {
        this._point = i;
      },
      getLastPoint: function() {
        return this._choosePoint(this._lastPoint, this.tool._lastPoint);
      },
      setLastPoint: function(i) {
        this._lastPoint = i;
      },
      getDownPoint: function() {
        return this._choosePoint(this._downPoint, this.tool._downPoint);
      },
      setDownPoint: function(i) {
        this._downPoint = i;
      },
      getMiddlePoint: function() {
        return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
      },
      setMiddlePoint: function(i) {
        this._middlePoint = i;
      },
      getDelta: function() {
        return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
      },
      setDelta: function(i) {
        this._delta = i;
      },
      getCount: function() {
        return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
      },
      setCount: function(i) {
        this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = i;
      },
      getItem: function() {
        if (!this._item) {
          var i = this.tool._scope.project.hitTest(this.getPoint());
          if (i) {
            for (var n = i.item, r = n._parent; /^(Group|CompoundPath)$/.test(r._class); )
              n = r, r = r._parent;
            this._item = n;
          }
        }
        return this._item;
      },
      setItem: function(i) {
        this._item = i;
      },
      toString: function() {
        return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Bn = w.extend({
      _class: "Tool",
      _list: "tools",
      _reference: "tool",
      _events: [
        "onMouseDown",
        "onMouseUp",
        "onMouseDrag",
        "onMouseMove",
        "onActivate",
        "onDeactivate",
        "onEditOptions",
        "onKeyDown",
        "onKeyUp"
      ],
      initialize: function(i) {
        w.call(this), this._moveCount = -1, this._downCount = -1, this.set(i);
      },
      getMinDistance: function() {
        return this._minDistance;
      },
      setMinDistance: function(i) {
        this._minDistance = i, i != null && this._maxDistance != null && i > this._maxDistance && (this._maxDistance = i);
      },
      getMaxDistance: function() {
        return this._maxDistance;
      },
      setMaxDistance: function(i) {
        this._maxDistance = i, this._minDistance != null && i != null && i < this._minDistance && (this._minDistance = i);
      },
      getFixedDistance: function() {
        return this._minDistance == this._maxDistance ? this._minDistance : null;
      },
      setFixedDistance: function(i) {
        this._minDistance = this._maxDistance = i;
      },
      _handleMouseEvent: function(i, n, r, l) {
        nt = this._scope, l.drag && !this.responds(i) && (i = "mousemove");
        var h = l.move || l.drag, f = this.responds(i), m = this.minDistance, _ = this.maxDistance, y = !1, x = this;
        function A(C, M) {
          var R = r, E = h ? x._point : x._downPoint || R;
          if (h) {
            if (x._moveCount >= 0 && R.equals(E))
              return !1;
            if (E && (C != null || M != null)) {
              var D = R.subtract(E), L = D.getLength();
              if (L < (C || 0))
                return !1;
              M && (R = E.add(D.normalize(
                Math.min(L, M)
              )));
            }
            x._moveCount++;
          }
          return x._point = R, x._lastPoint = E || R, l.down && (x._moveCount = -1, x._downPoint = R, x._downCount++), !0;
        }
        function B() {
          f && (y = x.emit(i, new ln(x, i, n)) || y);
        }
        if (l.down)
          A(), B();
        else if (l.up)
          A(null, _), B();
        else if (f)
          for (; A(m, _); )
            B();
        return y;
      }
    }), Js = a.extend(c, {
      _class: "Tween",
      statics: {
        easings: new a({
          linear: function(i) {
            return i;
          },
          easeInQuad: function(i) {
            return i * i;
          },
          easeOutQuad: function(i) {
            return i * (2 - i);
          },
          easeInOutQuad: function(i) {
            return i < 0.5 ? 2 * i * i : -1 + 2 * (2 - i) * i;
          },
          easeInCubic: function(i) {
            return i * i * i;
          },
          easeOutCubic: function(i) {
            return --i * i * i + 1;
          },
          easeInOutCubic: function(i) {
            return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
          },
          easeInQuart: function(i) {
            return i * i * i * i;
          },
          easeOutQuart: function(i) {
            return 1 - --i * i * i * i;
          },
          easeInOutQuart: function(i) {
            return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
          },
          easeInQuint: function(i) {
            return i * i * i * i * i;
          },
          easeOutQuint: function(i) {
            return 1 + --i * i * i * i * i;
          },
          easeInOutQuint: function(i) {
            return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
          }
        })
      },
      initialize: function i(n, r, l, h, f, m) {
        this.object = n;
        var _ = typeof f, y = _ === "function";
        this.type = y ? _ : _ === "string" ? f : "linear", this.easing = y ? f : i.easings[this.type], this.duration = h, this.running = !1, this._then = null, this._startTime = null;
        var x = r || l;
        this._keys = x ? Object.keys(x) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = x && this._getState(r), this._to = x && this._getState(l), m !== !1 && this.start();
      },
      then: function(i) {
        return this._then = i, this;
      },
      start: function() {
        return this._startTime = null, this.running = !0, this;
      },
      stop: function() {
        return this.running = !1, this;
      },
      update: function(i) {
        if (this.running) {
          i >= 1 && (i = 1, this.running = !1);
          for (var n = this.easing(i), r = this._keys, l = function(A) {
            return typeof A == "function" ? A(n, i) : A;
          }, h = 0, f = r && r.length; h < f; h++) {
            var m = r[h], _ = l(this._from[m]), y = l(this._to[m]), x = _ && y && _.__add && y.__add ? y.__subtract(_).__multiply(n).__add(_) : (y - _) * n + _;
            this._setProperty(this._parsedKeys[m], x);
          }
          this.responds("update") && this.emit("update", new a({
            progress: i,
            factor: n
          })), !this.running && this._then && this._then(this.object);
        }
        return this;
      },
      _events: {
        onUpdate: {}
      },
      _handleFrame: function(i) {
        var n = this._startTime, r = n ? (i - n) / this.duration : 0;
        n || (this._startTime = i), this.update(r);
      },
      _getState: function(i) {
        for (var n = this._keys, r = {}, l = 0, h = n.length; l < h; l++) {
          var f = n[l], m = this._parsedKeys[f], _ = this._getProperty(m), y;
          if (i) {
            var x = this._resolveValue(_, i[f]);
            this._setProperty(m, x), y = this._getProperty(m), y = y && y.clone ? y.clone() : y, this._setProperty(m, _);
          } else
            y = _ && _.clone ? _.clone() : _;
          r[f] = y;
        }
        return r;
      },
      _resolveValue: function(i, n) {
        if (n) {
          if (Array.isArray(n) && n.length === 2) {
            var r = n[0];
            return r && r.match && r.match(/^[+\-\*\/]=/) ? this._calculate(i, r[0], n[1]) : n;
          } else if (typeof n == "string") {
            var l = n.match(/^[+\-*/]=(.*)/);
            if (l) {
              var h = JSON.parse(l[1].replace(
                /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                '"$2": '
              ));
              return this._calculate(i, n[0], h);
            }
          }
        }
        return n;
      },
      _calculate: function(i, n, r) {
        return nt.PaperScript.calculateBinary(i, n, r);
      },
      _parseKeys: function(i) {
        for (var n = {}, r = 0, l = i.length; r < l; r++) {
          var h = i[r], f = h.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
          n[h] = f.split("/");
        }
        return n;
      },
      _getProperty: function(i, n) {
        for (var r = this.object, l = 0, h = i.length - (n || 0); l < h && r; l++)
          r = r[i[l]];
        return r;
      },
      _setProperty: function(i, n) {
        var r = this._getProperty(i, 1);
        r && (r[i[i.length - 1]] = n);
      }
    }), zn = {
      request: function(i) {
        var n = new e.XMLHttpRequest();
        return n.open(
          (i.method || "get").toUpperCase(),
          i.url,
          a.pick(i.async, !0)
        ), i.mimeType && n.overrideMimeType(i.mimeType), n.onload = function() {
          var r = n.status;
          r === 0 || r === 200 ? i.onLoad && i.onLoad.call(n, n.responseText) : n.onerror();
        }, n.onerror = function() {
          var r = n.status, l = 'Could not load "' + i.url + '" (Status: ' + r + ")";
          if (i.onError)
            i.onError(l, r);
          else
            throw new Error(l);
        }, n.send(null);
      }
    }, Ut = a.exports.CanvasProvider = {
      canvases: [],
      getCanvas: function(i, n, r) {
        if (!s)
          return null;
        var l, h = !0;
        typeof i == "object" && (n = i.height, i = i.width), this.canvases.length ? l = this.canvases.pop() : (l = o.createElement("canvas"), h = !1);
        var f = l.getContext("2d", r || {});
        if (!f)
          throw new Error("Canvas " + l + " is unable to provide a 2D context.");
        return l.width === i && l.height === n ? h && f.clearRect(0, 0, i + 1, n + 1) : (l.width = i, l.height = n), f.save(), l;
      },
      getContext: function(i, n, r) {
        var l = this.getCanvas(i, n, r);
        return l ? l.getContext("2d", r || {}) : null;
      },
      release: function(i) {
        var n = i && i.canvas ? i.canvas : i;
        n && n.getContext && (n.getContext("2d").restore(), this.canvases.push(n));
      }
    }, ki = new function() {
      var i = Math.min, n = Math.max, r = Math.abs, l, h, f, m, _, y, x, A, B, C, M;
      function R(U, V, F) {
        return 0.2989 * U + 0.587 * V + 0.114 * F;
      }
      function E(U, V, F, ie) {
        var Q = ie - R(U, V, F);
        B = U + Q, C = V + Q, M = F + Q;
        var ie = R(B, C, M), ae = i(B, C, M), J = n(B, C, M);
        if (ae < 0) {
          var le = ie - ae;
          B = ie + (B - ie) * ie / le, C = ie + (C - ie) * ie / le, M = ie + (M - ie) * ie / le;
        }
        if (J > 255) {
          var fe = 255 - ie, me = J - ie;
          B = ie + (B - ie) * fe / me, C = ie + (C - ie) * fe / me, M = ie + (M - ie) * fe / me;
        }
      }
      function D(U, V, F) {
        return n(U, V, F) - i(U, V, F);
      }
      function L(U, V, F, W) {
        var Q = [U, V, F], ie = n(U, V, F), ae = i(U, V, F), J;
        ae = ae === U ? 0 : ae === V ? 1 : 2, ie = ie === U ? 0 : ie === V ? 1 : 2, J = i(ae, ie) === 0 ? n(ae, ie) === 1 ? 2 : 1 : 0, Q[ie] > Q[ae] ? (Q[J] = (Q[J] - Q[ae]) * W / (Q[ie] - Q[ae]), Q[ie] = W) : Q[J] = Q[ie] = 0, Q[ae] = 0, B = Q[0], C = Q[1], M = Q[2];
      }
      var P = {
        multiply: function() {
          B = _ * l / 255, C = y * h / 255, M = x * f / 255;
        },
        screen: function() {
          B = _ + l - _ * l / 255, C = y + h - y * h / 255, M = x + f - x * f / 255;
        },
        overlay: function() {
          B = _ < 128 ? 2 * _ * l / 255 : 255 - 2 * (255 - _) * (255 - l) / 255, C = y < 128 ? 2 * y * h / 255 : 255 - 2 * (255 - y) * (255 - h) / 255, M = x < 128 ? 2 * x * f / 255 : 255 - 2 * (255 - x) * (255 - f) / 255;
        },
        "soft-light": function() {
          var U = l * _ / 255;
          B = U + _ * (255 - (255 - _) * (255 - l) / 255 - U) / 255, U = h * y / 255, C = U + y * (255 - (255 - y) * (255 - h) / 255 - U) / 255, U = f * x / 255, M = U + x * (255 - (255 - x) * (255 - f) / 255 - U) / 255;
        },
        "hard-light": function() {
          B = l < 128 ? 2 * l * _ / 255 : 255 - 2 * (255 - l) * (255 - _) / 255, C = h < 128 ? 2 * h * y / 255 : 255 - 2 * (255 - h) * (255 - y) / 255, M = f < 128 ? 2 * f * x / 255 : 255 - 2 * (255 - f) * (255 - x) / 255;
        },
        "color-dodge": function() {
          B = _ === 0 ? 0 : l === 255 ? 255 : i(255, 255 * _ / (255 - l)), C = y === 0 ? 0 : h === 255 ? 255 : i(255, 255 * y / (255 - h)), M = x === 0 ? 0 : f === 255 ? 255 : i(255, 255 * x / (255 - f));
        },
        "color-burn": function() {
          B = _ === 255 ? 255 : l === 0 ? 0 : n(0, 255 - (255 - _) * 255 / l), C = y === 255 ? 255 : h === 0 ? 0 : n(0, 255 - (255 - y) * 255 / h), M = x === 255 ? 255 : f === 0 ? 0 : n(0, 255 - (255 - x) * 255 / f);
        },
        darken: function() {
          B = _ < l ? _ : l, C = y < h ? y : h, M = x < f ? x : f;
        },
        lighten: function() {
          B = _ > l ? _ : l, C = y > h ? y : h, M = x > f ? x : f;
        },
        difference: function() {
          B = _ - l, B < 0 && (B = -B), C = y - h, C < 0 && (C = -C), M = x - f, M < 0 && (M = -M);
        },
        exclusion: function() {
          B = _ + l * (255 - _ - _) / 255, C = y + h * (255 - y - y) / 255, M = x + f * (255 - x - x) / 255;
        },
        hue: function() {
          L(l, h, f, D(_, y, x)), E(B, C, M, R(_, y, x));
        },
        saturation: function() {
          L(_, y, x, D(l, h, f)), E(B, C, M, R(_, y, x));
        },
        luminosity: function() {
          E(_, y, x, R(l, h, f));
        },
        color: function() {
          E(l, h, f, R(_, y, x));
        },
        add: function() {
          B = i(_ + l, 255), C = i(y + h, 255), M = i(x + f, 255);
        },
        subtract: function() {
          B = n(_ - l, 0), C = n(y - h, 0), M = n(x - f, 0);
        },
        average: function() {
          B = (_ + l) / 2, C = (y + h) / 2, M = (x + f) / 2;
        },
        negation: function() {
          B = 255 - r(255 - l - _), C = 255 - r(255 - h - y), M = 255 - r(255 - f - x);
        }
      }, S = this.nativeModes = a.each([
        "source-over",
        "source-in",
        "source-out",
        "source-atop",
        "destination-over",
        "destination-in",
        "destination-out",
        "destination-atop",
        "lighter",
        "darker",
        "copy",
        "xor"
      ], function(U) {
        this[U] = !0;
      }, {}), I = Ut.getContext(1, 1, { willReadFrequently: !0 });
      I && (a.each(P, function(U, V) {
        var F = V === "darken", W = !1;
        I.save();
        try {
          I.fillStyle = F ? "#300" : "#a00", I.fillRect(0, 0, 1, 1), I.globalCompositeOperation = V, I.globalCompositeOperation === V && (I.fillStyle = F ? "#a00" : "#300", I.fillRect(0, 0, 1, 1), W = I.getImageData(0, 0, 1, 1).data[0] !== F ? 170 : 51);
        } catch {
        }
        I.restore(), S[V] = W;
      }), Ut.release(I)), this.process = function(U, V, F, W, Q) {
        var ie = V.canvas, ae = U === "normal";
        if (ae || S[U])
          F.save(), F.setTransform(1, 0, 0, 1, 0, 0), F.globalAlpha = W, ae || (F.globalCompositeOperation = U), F.drawImage(ie, Q.x, Q.y), F.restore();
        else {
          var J = P[U];
          if (!J)
            return;
          for (var le = F.getImageData(
            Q.x,
            Q.y,
            ie.width,
            ie.height
          ), fe = le.data, me = V.getImageData(
            0,
            0,
            ie.width,
            ie.height
          ).data, ve = 0, Se = fe.length; ve < Se; ve += 4) {
            l = me[ve], _ = fe[ve], h = me[ve + 1], y = fe[ve + 1], f = me[ve + 2], x = fe[ve + 2], m = me[ve + 3], A = fe[ve + 3], J();
            var Re = m * W / 255, He = 1 - Re;
            fe[ve] = Re * B + He * _, fe[ve + 1] = Re * C + He * y, fe[ve + 2] = Re * M + He * x, fe[ve + 3] = m * W + He * A;
          }
          F.putImageData(le, Q.x, Q.y);
        }
      };
    }(), Vt = new function() {
      var i = "http://www.w3.org/2000/svg", n = "http://www.w3.org/2000/xmlns", r = "http://www.w3.org/1999/xlink", l = {
        href: r,
        xlink: n,
        xmlns: n + "/",
        "xmlns:xlink": n + "/"
      };
      function h(_, y, x) {
        return m(o.createElementNS(i, _), y, x);
      }
      function f(_, y) {
        var x = l[y], A = x ? _.getAttributeNS(x, y) : _.getAttribute(y);
        return A === "null" ? null : A;
      }
      function m(_, y, x) {
        for (var A in y) {
          var B = y[A], C = l[A];
          typeof B == "number" && x && (B = x.number(B)), C ? _.setAttributeNS(C, A, B) : _.setAttribute(A, B);
        }
        return _;
      }
      return {
        svg: i,
        xmlns: n,
        xlink: r,
        create: h,
        get: f,
        set: m
      };
    }(), Jn = a.each({
      fillColor: ["fill", "color"],
      fillRule: ["fill-rule", "string"],
      strokeColor: ["stroke", "color"],
      strokeWidth: ["stroke-width", "number"],
      strokeCap: ["stroke-linecap", "string"],
      strokeJoin: ["stroke-linejoin", "string"],
      strokeScaling: ["vector-effect", "lookup", {
        true: "none",
        false: "non-scaling-stroke"
      }, function(i, n) {
        return !n && (i instanceof Ft || i instanceof Ze || i instanceof Ki);
      }],
      miterLimit: ["stroke-miterlimit", "number"],
      dashArray: ["stroke-dasharray", "array"],
      dashOffset: ["stroke-dashoffset", "number"],
      fontFamily: ["font-family", "string"],
      fontWeight: ["font-weight", "string"],
      fontSize: ["font-size", "number"],
      justification: ["text-anchor", "lookup", {
        left: "start",
        center: "middle",
        right: "end"
      }],
      opacity: ["opacity", "number"],
      blendMode: ["mix-blend-mode", "style"]
    }, function(i, n) {
      var r = a.capitalize(n), l = i[2];
      this[n] = {
        type: i[1],
        property: n,
        attribute: i[0],
        toSVG: l,
        fromSVG: l && a.each(l, function(h, f) {
          this[h] = f;
        }, {}),
        exportFilter: i[3],
        get: "get" + r,
        set: "set" + r
      };
    }, {});
    new function() {
      var i;
      function n(P, S, I) {
        var U = new a(), V = P.getTranslation();
        if (S) {
          var F;
          P.isInvertible() ? (P = P._shiftless(), F = P._inverseTransform(V), V = null) : F = new z(), U[I ? "cx" : "x"] = F.x, U[I ? "cy" : "y"] = F.y;
        }
        if (!P.isIdentity()) {
          var W = P.decompose();
          if (W) {
            var Q = [], ie = W.rotation, ae = W.scaling, J = W.skewing;
            V && !V.isZero() && Q.push("translate(" + i.point(V) + ")"), ie && Q.push("rotate(" + i.number(ie) + ")"), (!Y.isZero(ae.x - 1) || !Y.isZero(ae.y - 1)) && Q.push("scale(" + i.point(ae) + ")"), J.x && Q.push("skewX(" + i.number(J.x) + ")"), J.y && Q.push("skewY(" + i.number(J.y) + ")"), U.transform = Q.join(" ");
          } else
            U.transform = "matrix(" + P.getValues().join(",") + ")";
        }
        return U;
      }
      function r(P, S) {
        for (var I = n(P._matrix), U = P._children, V = Vt.create("g", I, i), F = 0, W = U.length; F < W; F++) {
          var Q = U[F], ie = D(Q, S);
          if (ie)
            if (Q.isClipMask()) {
              var ae = Vt.create("clipPath");
              ae.appendChild(ie), R(Q, ae, "clip"), Vt.set(V, {
                "clip-path": "url(#" + ae.id + ")"
              });
            } else
              V.appendChild(ie);
        }
        return V;
      }
      function l(P, S) {
        var I = n(P._matrix, !0), U = P.getSize(), V = P.getImage();
        return I.x -= U.width / 2, I.y -= U.height / 2, I.width = U.width, I.height = U.height, I.href = S.embedImages == !1 && V && V.src || P.toDataURL(), Vt.create("image", I, i);
      }
      function h(P, S) {
        var I = S.matchShapes;
        if (I) {
          var U = P.toShape(!1);
          if (U)
            return f(U);
        }
        var V = P._segments, F = V.length, W, Q = n(P._matrix);
        if (I && F >= 2 && !P.hasHandles())
          if (F > 2) {
            W = P._closed ? "polygon" : "polyline";
            for (var ie = [], ae = 0; ae < F; ae++)
              ie.push(i.point(V[ae]._point));
            Q.points = ie.join(" ");
          } else {
            W = "line";
            var J = V[0]._point, le = V[1]._point;
            Q.set({
              x1: J.x,
              y1: J.y,
              x2: le.x,
              y2: le.y
            });
          }
        else
          W = "path", Q.d = P.getPathData(null, S.precision);
        return Vt.create(W, Q, i);
      }
      function f(P) {
        var S = P._type, I = P._radius, U = n(P._matrix, !0, S !== "rectangle");
        if (S === "rectangle") {
          S = "rect";
          var V = P._size, F = V.width, W = V.height;
          U.x -= F / 2, U.y -= W / 2, U.width = F, U.height = W, I.isZero() && (I = null);
        }
        return I && (S === "circle" ? U.r = I : (U.rx = I.width, U.ry = I.height)), Vt.create(S, U, i);
      }
      function m(P, S) {
        var I = n(P._matrix), U = P.getPathData(null, S.precision);
        return U && (I.d = U), Vt.create("path", I, i);
      }
      function _(P, S) {
        var I = n(P._matrix, !0), U = P._definition, V = M(U, "symbol"), F = U._item, W = F.getStrokeBounds();
        return V || (V = Vt.create("symbol", {
          viewBox: i.rectangle(W)
        }), V.appendChild(D(F, S)), R(U, V, "symbol")), I.href = "#" + V.id, I.x += W.x, I.y += W.y, I.width = W.width, I.height = W.height, I.overflow = "visible", Vt.create("use", I, i);
      }
      function y(P) {
        var S = M(P, "color");
        if (!S) {
          var I = P.getGradient(), U = I._radial, V = P.getOrigin(), F = P.getDestination(), W;
          if (U) {
            W = {
              cx: V.x,
              cy: V.y,
              r: V.getDistance(F)
            };
            var Q = P.getHighlight();
            Q && (W.fx = Q.x, W.fy = Q.y);
          } else
            W = {
              x1: V.x,
              y1: V.y,
              x2: F.x,
              y2: F.y
            };
          W.gradientUnits = "userSpaceOnUse", S = Vt.create((U ? "radial" : "linear") + "Gradient", W, i);
          for (var ie = I._stops, ae = 0, J = ie.length; ae < J; ae++) {
            var le = ie[ae], fe = le._color, me = fe.getAlpha(), ve = le._offset;
            W = {
              offset: ve ?? ae / (J - 1)
            }, fe && (W["stop-color"] = fe.toCSS(!0)), me < 1 && (W["stop-opacity"] = me), S.appendChild(
              Vt.create("stop", W, i)
            );
          }
          R(P, S, "color");
        }
        return "url(#" + S.id + ")";
      }
      function x(P) {
        var S = Vt.create(
          "text",
          n(P._matrix, !0),
          i
        );
        return S.textContent = P._content, S;
      }
      var A = {
        Group: r,
        Layer: r,
        Raster: l,
        Path: h,
        Shape: f,
        CompoundPath: m,
        SymbolItem: _,
        PointText: x
      };
      function B(P, S, I) {
        var U = {}, V = !I && P.getParent(), F = [];
        return P._name != null && (U.id = P._name), a.each(Jn, function(W) {
          var Q = W.get, ie = W.type, ae = P[Q]();
          if (W.exportFilter ? W.exportFilter(P, ae) : !V || !a.equals(V[Q](), ae)) {
            if (ie === "color" && ae != null) {
              var J = ae.getAlpha();
              J < 1 && (U[W.attribute + "-opacity"] = J);
            }
            ie === "style" ? F.push(W.attribute + ": " + ae) : U[W.attribute] = ae == null ? "none" : ie === "color" ? ae.gradient ? y(ae) : ae.toCSS(!0) : ie === "array" ? ae.join(",") : ie === "lookup" ? W.toSVG[ae] : ae;
          }
        }), F.length && (U.style = F.join(";")), U.opacity === 1 && delete U.opacity, P._visible || (U.visibility = "hidden"), Vt.set(S, U, i);
      }
      var C;
      function M(P, S) {
        return C || (C = { ids: {}, svgs: {} }), P && C.svgs[S + "-" + (P._id || P.__id || (P.__id = ee.get("svg")))];
      }
      function R(P, S, I) {
        C || M();
        var U = C.ids[I] = (C.ids[I] || 0) + 1;
        S.id = I + "-" + U, C.svgs[I + "-" + (P._id || P.__id)] = S;
      }
      function E(P, S) {
        var I = P, U = null;
        if (C) {
          I = P.nodeName.toLowerCase() === "svg" && P;
          for (var V in C.svgs)
            U || (I || (I = Vt.create("svg"), I.appendChild(P)), U = I.insertBefore(
              Vt.create("defs"),
              I.firstChild
            )), U.appendChild(C.svgs[V]);
          C = null;
        }
        return S.asString ? new e.XMLSerializer().serializeToString(I) : I;
      }
      function D(P, S, I) {
        var U = A[P._class], V = U && U(P, S);
        if (V) {
          var F = S.onExport;
          F && (V = F(P, V, S) || V);
          var W = JSON.stringify(P._data);
          W && W !== "{}" && W !== "null" && V.setAttribute("data-paper-data", W);
        }
        return V && B(P, V, I);
      }
      function L(P) {
        return P || (P = {}), i = new H(P.precision), P;
      }
      K.inject({
        exportSVG: function(P) {
          return P = L(P), E(D(this, P, !0), P);
        }
      }), Ee.inject({
        exportSVG: function(P) {
          P = L(P);
          var S = this._children, I = this.getView(), U = a.pick(P.bounds, "view"), V = P.matrix || U === "view" && I._matrix, F = V && ue.read([V]), W = U === "view" ? new se([0, 0], I.getViewSize()) : U === "content" ? K._getBounds(S, F, { stroke: !0 }).rect : se.read([U], 0, { readNull: !0 }), Q = {
            version: "1.1",
            xmlns: Vt.svg,
            "xmlns:xlink": Vt.xlink
          };
          W && (Q.width = W.width, Q.height = W.height, (W.x || W.x === 0 || W.y || W.y === 0) && (Q.viewBox = i.rectangle(W)));
          var ie = Vt.create("svg", Q, i), ae = ie;
          F && !F.isIdentity() && (ae = ie.appendChild(Vt.create(
            "g",
            n(F),
            i
          )));
          for (var J = 0, le = S.length; J < le; J++)
            ae.appendChild(D(S[J], P, !0));
          return E(ie, P);
        }
      });
    }(), new function() {
      var i = {}, n;
      function r(S, I, U, V, F, W) {
        var Q = Vt.get(S, I) || W, ie = Q == null ? V ? null : U ? "" : 0 : U ? Q : parseFloat(Q);
        return /%\s*$/.test(Q) ? ie / 100 * (F ? 1 : n[/x|^width/.test(I) ? "width" : "height"]) : ie;
      }
      function l(S, I, U, V, F, W, Q) {
        return I = r(S, I || "x", !1, V, F, W), U = r(S, U || "y", !1, V, F, Q), V && (I == null || U == null) ? null : new z(I, U);
      }
      function h(S, I, U, V, F) {
        return I = r(S, I || "width", !1, V, F), U = r(S, U || "height", !1, V, F), V && (I == null || U == null) ? null : new ne(I, U);
      }
      function f(S, I, U) {
        return S === "none" ? null : I === "number" ? parseFloat(S) : I === "array" ? S ? S.split(/[\s,]+/g).map(parseFloat) : [] : I === "color" ? D(S) || S : I === "lookup" ? U[S] : S;
      }
      function m(S, I, U, V) {
        var F = S.childNodes, W = I === "clippath", Q = I === "defs", ie = new j(), ae = ie._project, J = ae._currentStyle, le = [];
        if (!W && !Q && (ie = E(ie, S, V), ae._currentStyle = ie._style.clone()), V)
          for (var fe = S.querySelectorAll("defs"), me = 0, ve = fe.length; me < ve; me++)
            L(fe[me], U, !1);
        for (var me = 0, ve = F.length; me < ve; me++) {
          var Se = F[me], Re;
          Se.nodeType === 1 && !/^defs$/i.test(Se.nodeName) && (Re = L(Se, U, !1)) && !(Re instanceof Mt) && le.push(Re);
        }
        return ie.addChildren(le), W && (ie = E(ie.reduce(), S, V)), ae._currentStyle = J, (W || Q) && (ie.remove(), ie = null), ie;
      }
      function _(S, I) {
        for (var U = S.getAttribute("points").match(
          /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
        ), V = [], F = 0, W = U.length; F < W; F += 2)
          V.push(new z(
            parseFloat(U[F]),
            parseFloat(U[F + 1])
          ));
        var Q = new Bt(V);
        return I === "polygon" && Q.closePath(), Q;
      }
      function y(S) {
        return Ft.create(S.getAttribute("d"));
      }
      function x(S, I) {
        var U = (r(S, "href", !0) || "").substring(1), V = I === "radialgradient", F;
        if (U)
          F = i[U].getGradient(), F._radial ^ V && (F = F.clone(), F._radial = V);
        else {
          for (var W = S.childNodes, Q = [], ie = 0, ae = W.length; ie < ae; ie++) {
            var J = W[ie];
            J.nodeType === 1 && Q.push(E(new Ms(), J));
          }
          F = new kn(Q, V);
        }
        var le, fe, me, ve = r(S, "gradientUnits", !0) !== "userSpaceOnUse";
        V ? (le = l(
          S,
          "cx",
          "cy",
          !1,
          ve,
          "50%",
          "50%"
        ), fe = le.add(
          r(S, "r", !1, !1, ve, "50%"),
          0
        ), me = l(S, "fx", "fy", !0, ve)) : (le = l(
          S,
          "x1",
          "y1",
          !1,
          ve,
          "0%",
          "0%"
        ), fe = l(
          S,
          "x2",
          "y2",
          !1,
          ve,
          "100%",
          "0%"
        ));
        var Se = E(
          new qt(F, le, fe, me),
          S
        );
        return Se._scaleToBounds = ve, null;
      }
      var A = {
        "#document": function(S, I, U, V) {
          for (var F = S.childNodes, W = 0, Q = F.length; W < Q; W++) {
            var ie = F[W];
            if (ie.nodeType === 1)
              return L(ie, U, V);
          }
        },
        g: m,
        svg: m,
        clippath: m,
        polygon: _,
        polyline: _,
        path: y,
        lineargradient: x,
        radialgradient: x,
        image: function(S) {
          var I = new pt(r(S, "href", !0));
          return I.on("load", function() {
            var U = h(S);
            this.setSize(U);
            var V = l(S).add(U.divide(2));
            this._matrix.append(new ue().translate(V));
          }), I;
        },
        symbol: function(S, I, U, V) {
          return new Mt(
            m(S, I, U, V),
            !0
          );
        },
        defs: m,
        use: function(S) {
          var I = (r(S, "href", !0) || "").substring(1), U = i[I], V = l(S);
          return U ? U instanceof Mt ? U.place(V) : U.clone().translate(V) : null;
        },
        circle: function(S) {
          return new Ze.Circle(
            l(S, "cx", "cy"),
            r(S, "r")
          );
        },
        ellipse: function(S) {
          return new Ze.Ellipse({
            center: l(S, "cx", "cy"),
            radius: h(S, "rx", "ry")
          });
        },
        rect: function(S) {
          return new Ze.Rectangle(new se(
            l(S),
            h(S)
          ), h(S, "rx", "ry"));
        },
        line: function(S) {
          return new Bt.Line(
            l(S, "x1", "y1"),
            l(S, "x2", "y2")
          );
        },
        text: function(S) {
          var I = new as(l(S).add(
            l(S, "dx", "dy")
          ));
          return I.setContent(S.textContent.trim() || ""), I;
        },
        switch: m
      };
      function B(S, I, U, V) {
        if (S.transform) {
          for (var F = (V.getAttribute(U) || "").split(/\)\s*/g), W = new ue(), Q = 0, ie = F.length; Q < ie; Q++) {
            var ae = F[Q];
            if (!ae)
              break;
            for (var J = ae.split(/\(\s*/), le = J[0], fe = J[1].split(/[\s,]+/g), me = 0, ve = fe.length; me < ve; me++)
              fe[me] = parseFloat(fe[me]);
            switch (le) {
              case "matrix":
                W.append(
                  new ue(fe[0], fe[1], fe[2], fe[3], fe[4], fe[5])
                );
                break;
              case "rotate":
                W.rotate(fe[0], fe[1] || 0, fe[2] || 0);
                break;
              case "translate":
                W.translate(fe[0], fe[1] || 0);
                break;
              case "scale":
                W.scale(fe);
                break;
              case "skewX":
                W.skew(fe[0], 0);
                break;
              case "skewY":
                W.skew(0, fe[0]);
                break;
            }
          }
          S.transform(W);
        }
      }
      function C(S, I, U) {
        var V = U === "fill-opacity" ? "getFillColor" : "getStrokeColor", F = S[V] && S[V]();
        F && F.setAlpha(parseFloat(I));
      }
      var M = a.set(a.each(Jn, function(S) {
        this[S.attribute] = function(I, U) {
          if (I[S.set] && (I[S.set](f(U, S.type, S.fromSVG)), S.type === "color")) {
            var V = I[S.get]();
            if (V && V._scaleToBounds) {
              var F = I.getBounds();
              V.transform(new ue().translate(F.getPoint()).scale(F.getSize()));
            }
          }
        };
      }, {}), {
        id: function(S, I) {
          i[I] = S, S.setName && S.setName(I);
        },
        "clip-path": function(S, I) {
          var U = D(I);
          if (U)
            if (U = U.clone(), U.setClipMask(!0), S instanceof j)
              S.insertChild(0, U);
            else
              return new j(U, S);
        },
        gradientTransform: B,
        transform: B,
        "fill-opacity": C,
        "stroke-opacity": C,
        visibility: function(S, I) {
          S.setVisible && S.setVisible(I === "visible");
        },
        display: function(S, I) {
          S.setVisible && S.setVisible(I !== null);
        },
        "stop-color": function(S, I) {
          S.setColor && S.setColor(I);
        },
        "stop-opacity": function(S, I) {
          S._color && S._color.setAlpha(parseFloat(I));
        },
        offset: function(S, I) {
          if (S.setOffset) {
            var U = I.match(/(.*)%$/);
            S.setOffset(U ? U[1] / 100 : parseFloat(I));
          }
        },
        viewBox: function(S, I, U, V, F) {
          var W = new se(f(I, "array")), Q = h(V, null, null, !0), ie, ae;
          if (S instanceof j) {
            var J = Q ? Q.divide(W.getSize()) : 1, ae = new ue().scale(J).translate(W.getPoint().negate());
            ie = S;
          } else
            S instanceof Mt && (Q && W.setSize(Q), ie = S._item);
          if (ie) {
            if (R(V, "overflow", F) !== "visible") {
              var le = new Ze.Rectangle(W);
              le.setClipMask(!0), ie.addChild(le);
            }
            ae && ie.transform(ae);
          }
        }
      });
      function R(S, I, U) {
        var V = S.attributes[I], F = V && V.value;
        if (!F && S.style) {
          var W = a.camelize(I);
          F = S.style[W], !F && U.node[W] !== U.parent[W] && (F = U.node[W]);
        }
        return F ? F === "none" ? null : F : t;
      }
      function E(S, I, U) {
        var V = I.parentNode, F = {
          node: zt.getStyles(I) || {},
          parent: !U && !/^defs$/i.test(V.tagName) && zt.getStyles(V) || {}
        };
        return a.each(M, function(W, Q) {
          var ie = R(I, Q, F);
          S = ie !== t && W(S, ie, Q, I, F) || S;
        }), S;
      }
      function D(S) {
        var I = S && S.match(/\((?:["'#]*)([^"')]+)/), U = I && I[1], V = U && i[s ? U.replace(s.location.href.split("#")[0] + "#", "") : U];
        return V && V._scaleToBounds && (V = V.clone(), V._scaleToBounds = !0), V;
      }
      function L(S, I, U) {
        var V = S.nodeName.toLowerCase(), F = V !== "#document", W = o.body, Q, ie, ae;
        U && F && (n = nt.getView().getSize(), n = h(S, null, null, !0) || n, Q = Vt.create("svg", {
          style: "stroke-width: 1px; stroke-miterlimit: 10"
        }), ie = S.parentNode, ae = S.nextSibling, Q.appendChild(S), W.appendChild(Q));
        var J = nt.settings, le = J.applyMatrix, fe = J.insertItems;
        J.applyMatrix = !1, J.insertItems = !1;
        var me = A[V], ve = me && me(S, V, I, U) || null;
        if (J.insertItems = fe, J.applyMatrix = le, ve) {
          F && !(ve instanceof j) && (ve = E(ve, S, U));
          var Se = I.onImport, Re = F && S.getAttribute("data-paper-data");
          Se && (ve = Se(S, ve, I) || ve), I.expandShapes && ve instanceof Ze && (ve.remove(), ve = ve.toPath()), Re && (ve._data = JSON.parse(Re));
        }
        return Q && (W.removeChild(Q), ie && (ae ? ie.insertBefore(S, ae) : ie.appendChild(S))), U && (i = {}, ve && a.pick(I.applyMatrix, le) && ve.matrix.apply(!0, !0)), ve;
      }
      function P(S, I, U) {
        if (!S)
          return null;
        I = typeof I == "function" ? { onLoad: I } : I || {};
        var V = nt, F = null;
        function W(J) {
          try {
            var le = typeof J == "object" ? J : new e.DOMParser().parseFromString(
              J.trim(),
              "image/svg+xml"
            );
            if (!le.nodeName)
              throw le = null, new Error("Unsupported SVG source: " + S);
            nt = V, F = L(le, I, !0), (!I || I.insert !== !1) && U._insertItem(t, F);
            var fe = I.onLoad;
            fe && fe(F, J);
          } catch (me) {
            Q(me);
          }
        }
        function Q(J, le) {
          var fe = I.onError;
          if (fe)
            fe(J, le);
          else
            throw new Error(J);
        }
        if (typeof S == "string" && !/^[\s\S]*</.test(S)) {
          var ie = o.getElementById(S);
          ie ? W(ie) : zn.request({
            url: S,
            async: !0,
            onLoad: W,
            onError: Q
          });
        } else if (typeof File < "u" && S instanceof File) {
          var ae = new FileReader();
          return ae.onload = function() {
            W(ae.result);
          }, ae.onerror = function() {
            Q(ae.error);
          }, ae.readAsText(S);
        } else
          W(S);
        return F;
      }
      K.inject({
        importSVG: function(S, I) {
          return P(S, I, this);
        }
      }), Ee.inject({
        importSVG: function(S, I) {
          return this.activate(), P(S, I, this);
        }
      });
    }(), a.exports.PaperScript = (function() {
      var i = this, n = i.acorn;
      if (!n && typeof Oy < "u")
        try {
          n = require("acorn");
        } catch {
        }
      if (!n) {
        var r, l;
        n = r = l = {}, function(E, D) {
          if (typeof r == "object" && typeof l == "object")
            return D(r);
          if (typeof t == "function" && t.amd)
            return t(["exports"], D);
          D(E.acorn || (E.acorn = {}));
        }(this, function(E) {
          E.version = "0.5.0";
          var D, L, P, S;
          E.parse = function(q, te) {
            return L = String(q), P = L.length, U(te), ce(), Jr(D.program);
          };
          var I = E.defaultOptions = {
            ecmaVersion: 5,
            strictSemicolons: !1,
            allowTrailingCommas: !0,
            forbidReserved: !1,
            allowReturnOutsideFunction: !1,
            locations: !1,
            onComment: null,
            ranges: !1,
            program: null,
            sourceFile: null,
            directSourceFile: null
          };
          function U(q) {
            D = q || {};
            for (var te in I)
              Object.prototype.hasOwnProperty.call(D, te) || (D[te] = I[te]);
            S = D.sourceFile || null;
          }
          var V = E.getLineInfo = function(q, te) {
            for (var be = 1, Ae = 0; ; ) {
              O.lastIndex = Ae;
              var qe = O.exec(q);
              if (qe && qe.index < te)
                ++be, Ae = qe.index + qe[0].length;
              else
                break;
            }
            return { line: be, column: te - Ae };
          };
          E.tokenize = function(q, te) {
            L = String(q), P = L.length, U(te), ce();
            var be = {};
            function Ae(qe) {
              return Re = Q, Zi(qe), be.start = W, be.end = Q, be.startLoc = ie, be.endLoc = ae, be.type = J, be.value = le, be;
            }
            return Ae.jumpTo = function(qe, ot) {
              if (F = qe, D.locations) {
                me = 1, ve = O.lastIndex = 0;
                for (var it; (it = O.exec(L)) && it.index < qe; )
                  ++me, ve = it.index + it[0].length;
              }
              fe = ot, Ue();
            }, Ae;
          };
          var F, W, Q, ie, ae, J, le, fe, me, ve, Se, Re, He, Ye, Je, Be;
          function Ie(q, te) {
            var be = V(L, q);
            te += " (" + be.line + ":" + be.column + ")";
            var Ae = new SyntaxError(te);
            throw Ae.pos = q, Ae.loc = be, Ae.raisedAt = F, Ae;
          }
          var Ge = [], et = { type: "num" }, tt = { type: "regexp" }, gt = { type: "string" }, ut = { type: "name" }, yt = { type: "eof" }, At = { keyword: "break" }, bt = { keyword: "case", beforeExpr: !0 }, li = { keyword: "catch" }, mt = { keyword: "continue" }, Zt = { keyword: "debugger" }, Xt = { keyword: "default" }, Nt = { keyword: "do", isLoop: !0 }, Jt = { keyword: "else", beforeExpr: !0 }, Ti = { keyword: "finally" }, ri = { keyword: "for", isLoop: !0 }, Pi = { keyword: "function" }, ci = { keyword: "if" }, hi = { keyword: "return", beforeExpr: !0 }, Ni = { keyword: "switch" }, Bi = { keyword: "throw", beforeExpr: !0 }, Ri = { keyword: "try" }, Wi = { keyword: "var" }, Vi = { keyword: "while", isLoop: !0 }, Fn = { keyword: "with" }, $n = { keyword: "new", beforeExpr: !0 }, Cs = { keyword: "this" }, _s = { keyword: "null", atomValue: null }, vn = { keyword: "true", atomValue: !0 }, Qn = { keyword: "false", atomValue: !1 }, Yt = { keyword: "in", binop: 7, beforeExpr: !0 }, os = {
            break: At,
            case: bt,
            catch: li,
            continue: mt,
            debugger: Zt,
            default: Xt,
            do: Nt,
            else: Jt,
            finally: Ti,
            for: ri,
            function: Pi,
            if: ci,
            return: hi,
            switch: Ni,
            throw: Bi,
            try: Ri,
            var: Wi,
            while: Vi,
            with: Fn,
            null: _s,
            true: vn,
            false: Qn,
            new: $n,
            in: Yt,
            instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
            this: Cs,
            typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
            void: { keyword: "void", prefix: !0, beforeExpr: !0 },
            delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
          }, Mn = { type: "[", beforeExpr: !0 }, un = { type: "]" }, Ji = { type: "{", beforeExpr: !0 }, cn = { type: "}" }, qi = { type: "(", beforeExpr: !0 }, Di = { type: ")" }, d = { type: ",", beforeExpr: !0 }, N = { type: ";", beforeExpr: !0 }, re = { type: ":", beforeExpr: !0 }, pe = { type: "." }, Le = { type: "?", beforeExpr: !0 }, je = { binop: 10, beforeExpr: !0 }, Qe = { isAssign: !0, beforeExpr: !0 }, vt = { isAssign: !0, beforeExpr: !0 }, Lt = { postfix: !0, prefix: !0, isUpdate: !0 }, $t = { prefix: !0, beforeExpr: !0 }, ii = { binop: 1, beforeExpr: !0 }, Gi = { binop: 2, beforeExpr: !0 }, ls = { binop: 3, beforeExpr: !0 }, As = { binop: 4, beforeExpr: !0 }, ms = { binop: 5, beforeExpr: !0 }, zs = { binop: 6, beforeExpr: !0 }, Si = { binop: 7, beforeExpr: !0 }, bi = { binop: 8, beforeExpr: !0 }, kr = { binop: 9, prefix: !0, beforeExpr: !0 }, yr = { binop: 10, beforeExpr: !0 };
          E.tokTypes = {
            bracketL: Mn,
            bracketR: un,
            braceL: Ji,
            braceR: cn,
            parenL: qi,
            parenR: Di,
            comma: d,
            semi: N,
            colon: re,
            dot: pe,
            question: Le,
            slash: je,
            eq: Qe,
            name: ut,
            eof: yt,
            num: et,
            regexp: tt,
            string: gt
          };
          for (var or in os)
            E.tokTypes["_" + or] = os[or];
          function es(q) {
            q = q.split(" ");
            var te = "", be = [];
            e:
              for (var Ae = 0; Ae < q.length; ++Ae) {
                for (var qe = 0; qe < be.length; ++qe)
                  if (be[qe][0].length == q[Ae].length) {
                    be[qe].push(q[Ae]);
                    continue e;
                  }
                be.push([q[Ae]]);
              }
            function ot(wt) {
              if (wt.length == 1)
                return te += "return str === " + JSON.stringify(wt[0]) + ";";
              te += "switch(str){";
              for (var gi = 0; gi < wt.length; ++gi)
                te += "case " + JSON.stringify(wt[gi]) + ":";
              te += "return true}return false;";
            }
            if (be.length > 3) {
              be.sort(function(wt, gi) {
                return gi.length - wt.length;
              }), te += "switch(str.length){";
              for (var Ae = 0; Ae < be.length; ++Ae) {
                var it = be[Ae];
                te += "case " + it[0].length + ":", ot(it);
              }
              te += "}";
            } else
              ot(q);
            return new Function("str", te);
          }
          var br = es("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), Kr = es("class enum extends super const export import"), lr = es("implements interface let package private protected public static yield"), Ts = es("eval arguments"), $i = es("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), hr = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Zn = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Pr = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", $s = new RegExp("[" + Zn + "]"), Un = new RegExp("[" + Zn + Pr + "]"), b = /[\n\r\u2028\u2029]/, O = /\r\n|[\n\r\u2028\u2029]/g, G = E.isIdentifierStart = function(q) {
            return q < 65 ? q === 36 : q < 91 ? !0 : q < 97 ? q === 95 : q < 123 ? !0 : q >= 170 && $s.test(String.fromCharCode(q));
          }, Z = E.isIdentifierChar = function(q) {
            return q < 48 ? q === 36 : q < 58 ? !0 : q < 65 ? !1 : q < 91 ? !0 : q < 97 ? q === 95 : q < 123 ? !0 : q >= 170 && Un.test(String.fromCharCode(q));
          };
          function oe() {
            this.line = me, this.column = F - ve;
          }
          function ce() {
            me = 1, F = ve = 0, fe = !0, Ue();
          }
          function de(q, te) {
            Q = F, D.locations && (ae = new oe()), J = q, Ue(), le = te, fe = q.beforeExpr;
          }
          function Pe() {
            var q = D.onComment && D.locations && new oe(), te = F, be = L.indexOf("*/", F += 2);
            if (be === -1 && Ie(F - 2, "Unterminated comment"), F = be + 2, D.locations) {
              O.lastIndex = te;
              for (var Ae; (Ae = O.exec(L)) && Ae.index < F; )
                ++me, ve = Ae.index + Ae[0].length;
            }
            D.onComment && D.onComment(
              !0,
              L.slice(te + 2, be),
              te,
              F,
              q,
              D.locations && new oe()
            );
          }
          function Oe() {
            for (var q = F, te = D.onComment && D.locations && new oe(), be = L.charCodeAt(F += 2); F < P && be !== 10 && be !== 13 && be !== 8232 && be !== 8233; )
              ++F, be = L.charCodeAt(F);
            D.onComment && D.onComment(
              !1,
              L.slice(q + 2, F),
              q,
              F,
              te,
              D.locations && new oe()
            );
          }
          function Ue() {
            for (; F < P; ) {
              var q = L.charCodeAt(F);
              if (q === 32)
                ++F;
              else if (q === 13) {
                ++F;
                var te = L.charCodeAt(F);
                te === 10 && ++F, D.locations && (++me, ve = F);
              } else if (q === 10 || q === 8232 || q === 8233)
                ++F, D.locations && (++me, ve = F);
              else if (q > 8 && q < 14)
                ++F;
              else if (q === 47) {
                var te = L.charCodeAt(F + 1);
                if (te === 42)
                  Pe();
                else if (te === 47)
                  Oe();
                else
                  break;
              } else if (q === 160)
                ++F;
              else if (q >= 5760 && hr.test(String.fromCharCode(q)))
                ++F;
              else
                break;
            }
          }
          function rt() {
            var q = L.charCodeAt(F + 1);
            return q >= 48 && q <= 57 ? Oi(!0) : (++F, de(pe));
          }
          function lt() {
            var q = L.charCodeAt(F + 1);
            return fe ? (++F, di()) : q === 61 ? Qt(vt, 2) : Qt(je, 1);
          }
          function Ke() {
            var q = L.charCodeAt(F + 1);
            return q === 61 ? Qt(vt, 2) : Qt(yr, 1);
          }
          function xt(q) {
            var te = L.charCodeAt(F + 1);
            return te === q ? Qt(q === 124 ? ii : Gi, 2) : te === 61 ? Qt(vt, 2) : Qt(q === 124 ? ls : ms, 1);
          }
          function It() {
            var q = L.charCodeAt(F + 1);
            return q === 61 ? Qt(vt, 2) : Qt(As, 1);
          }
          function ai(q) {
            var te = L.charCodeAt(F + 1);
            return te === q ? te == 45 && L.charCodeAt(F + 2) == 62 && b.test(L.slice(Re, F)) ? (F += 3, Oe(), Ue(), Zi()) : Qt(Lt, 2) : te === 61 ? Qt(vt, 2) : Qt(kr, 1);
          }
          function si(q) {
            var te = L.charCodeAt(F + 1), be = 1;
            return te === q ? (be = q === 62 && L.charCodeAt(F + 2) === 62 ? 3 : 2, L.charCodeAt(F + be) === 61 ? Qt(vt, be + 1) : Qt(bi, be)) : te == 33 && q == 60 && L.charCodeAt(F + 2) == 45 && L.charCodeAt(F + 3) == 45 ? (F += 4, Oe(), Ue(), Zi()) : (te === 61 && (be = L.charCodeAt(F + 2) === 61 ? 3 : 2), Qt(Si, be));
          }
          function fn(q) {
            var te = L.charCodeAt(F + 1);
            return te === 61 ? Qt(zs, L.charCodeAt(F + 2) === 61 ? 3 : 2) : Qt(q === 61 ? Qe : $t, 1);
          }
          function Qi(q) {
            switch (q) {
              case 46:
                return rt();
              case 40:
                return ++F, de(qi);
              case 41:
                return ++F, de(Di);
              case 59:
                return ++F, de(N);
              case 44:
                return ++F, de(d);
              case 91:
                return ++F, de(Mn);
              case 93:
                return ++F, de(un);
              case 123:
                return ++F, de(Ji);
              case 125:
                return ++F, de(cn);
              case 58:
                return ++F, de(re);
              case 63:
                return ++F, de(Le);
              case 48:
                var te = L.charCodeAt(F + 1);
                if (te === 120 || te === 88)
                  return mi();
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                return Oi(!1);
              case 34:
              case 39:
                return Qs(q);
              case 47:
                return lt();
              case 37:
              case 42:
                return Ke();
              case 124:
              case 38:
                return xt(q);
              case 94:
                return It();
              case 43:
              case 45:
                return ai(q);
              case 60:
              case 62:
                return si(q);
              case 61:
              case 33:
                return fn(q);
              case 126:
                return Qt($t, 1);
            }
            return !1;
          }
          function Zi(q) {
            if (q ? F = W + 1 : W = F, D.locations && (ie = new oe()), q)
              return di();
            if (F >= P)
              return de(yt);
            var te = L.charCodeAt(F);
            if (G(te) || te === 92)
              return En();
            var be = Qi(te);
            if (be === !1) {
              var Ae = String.fromCharCode(te);
              if (Ae === "\\" || $s.test(Ae))
                return En();
              Ie(F, "Unexpected character '" + Ae + "'");
            }
            return be;
          }
          function Qt(q, te) {
            var be = L.slice(F, F + te);
            F += te, de(q, be);
          }
          function di() {
            for (var qe = "", q, te, be = F; ; ) {
              F >= P && Ie(be, "Unterminated regular expression");
              var Ae = L.charAt(F);
              if (b.test(Ae) && Ie(be, "Unterminated regular expression"), q)
                q = !1;
              else {
                if (Ae === "[")
                  te = !0;
                else if (Ae === "]" && te)
                  te = !1;
                else if (Ae === "/" && !te)
                  break;
                q = Ae === "\\";
              }
              ++F;
            }
            var qe = L.slice(be, F);
            ++F;
            var ot = hs();
            ot && !/^[gmsiy]*$/.test(ot) && Ie(be, "Invalid regexp flag");
            try {
              var it = new RegExp(qe, ot);
            } catch (wt) {
              wt instanceof SyntaxError && Ie(be, wt.message), Ie(wt);
            }
            return de(tt, it);
          }
          function yn(q, te) {
            for (var be = F, Ae = 0, qe = 0, ot = te ?? 1 / 0; qe < ot; ++qe) {
              var it = L.charCodeAt(F), wt;
              if (it >= 97 ? wt = it - 97 + 10 : it >= 65 ? wt = it - 65 + 10 : it >= 48 && it <= 57 ? wt = it - 48 : wt = 1 / 0, wt >= q)
                break;
              ++F, Ae = Ae * q + wt;
            }
            return F === be || te != null && F - be !== te ? null : Ae;
          }
          function mi() {
            F += 2;
            var q = yn(16);
            return q == null && Ie(W + 2, "Expected hexadecimal number"), G(L.charCodeAt(F)) && Ie(F, "Identifier directly after number"), de(et, q);
          }
          function Oi(q) {
            var te = F, be = !1, Ae = L.charCodeAt(F) === 48;
            !q && yn(10) === null && Ie(te, "Invalid number"), L.charCodeAt(F) === 46 && (++F, yn(10), be = !0);
            var qe = L.charCodeAt(F);
            (qe === 69 || qe === 101) && (qe = L.charCodeAt(++F), (qe === 43 || qe === 45) && ++F, yn(10) === null && Ie(te, "Invalid number"), be = !0), G(L.charCodeAt(F)) && Ie(F, "Identifier directly after number");
            var ot = L.slice(te, F), it;
            return be ? it = parseFloat(ot) : !Ae || ot.length === 1 ? it = parseInt(ot, 10) : /[89]/.test(ot) || Be ? Ie(te, "Invalid number") : it = parseInt(ot, 8), de(et, it);
          }
          function Qs(q) {
            F++;
            for (var te = ""; ; ) {
              F >= P && Ie(W, "Unterminated string constant");
              var be = L.charCodeAt(F);
              if (be === q)
                return ++F, de(gt, te);
              if (be === 92) {
                be = L.charCodeAt(++F);
                var Ae = /^[0-7]+/.exec(L.slice(F, F + 3));
                for (Ae && (Ae = Ae[0]); Ae && parseInt(Ae, 8) > 255; )
                  Ae = Ae.slice(0, -1);
                if (Ae === "0" && (Ae = null), ++F, Ae)
                  Be && Ie(F - 2, "Octal literal in strict mode"), te += String.fromCharCode(parseInt(Ae, 8)), F += Ae.length - 1;
                else
                  switch (be) {
                    case 110:
                      te += `
`;
                      break;
                    case 114:
                      te += "\r";
                      break;
                    case 120:
                      te += String.fromCharCode(ts(2));
                      break;
                    case 117:
                      te += String.fromCharCode(ts(4));
                      break;
                    case 85:
                      te += String.fromCharCode(ts(8));
                      break;
                    case 116:
                      te += "	";
                      break;
                    case 98:
                      te += "\b";
                      break;
                    case 118:
                      te += "\v";
                      break;
                    case 102:
                      te += "\f";
                      break;
                    case 48:
                      te += "\0";
                      break;
                    case 13:
                      L.charCodeAt(F) === 10 && ++F;
                    case 10:
                      D.locations && (ve = F, ++me);
                      break;
                    default:
                      te += String.fromCharCode(be);
                      break;
                  }
              } else
                (be === 13 || be === 10 || be === 8232 || be === 8233) && Ie(W, "Unterminated string constant"), te += String.fromCharCode(be), ++F;
            }
          }
          function ts(q) {
            var te = yn(16, q);
            return te === null && Ie(W, "Bad character escape sequence"), te;
          }
          var en;
          function hs() {
            en = !1;
            for (var q, te = !0, be = F; ; ) {
              var Ae = L.charCodeAt(F);
              if (Z(Ae))
                en && (q += L.charAt(F)), ++F;
              else if (Ae === 92) {
                en || (q = L.slice(be, F)), en = !0, L.charCodeAt(++F) != 117 && Ie(F, "Expecting Unicode escape sequence \\uXXXX"), ++F;
                var qe = ts(4), ot = String.fromCharCode(qe);
                ot || Ie(F - 1, "Invalid Unicode escape"), (te ? G(qe) : Z(qe)) || Ie(F - 4, "Invalid Unicode escape"), q += ot;
              } else
                break;
              te = !1;
            }
            return en ? q : L.slice(be, F);
          }
          function En() {
            var q = hs(), te = ut;
            return !en && $i(q) && (te = os[q]), de(te, q);
          }
          function Et() {
            Se = W, Re = Q, He = ae, Zi();
          }
          function Vn(q) {
            if (Be = q, F = W, D.locations)
              for (; F < ve; )
                ve = L.lastIndexOf(`
`, ve - 2) + 1, --me;
            Ue(), Zi();
          }
          function bn() {
            this.type = null, this.start = W, this.end = null;
          }
          function Ls() {
            this.start = ie, this.end = null, S !== null && (this.source = S);
          }
          function oi() {
            var q = new bn();
            return D.locations && (q.loc = new Ls()), D.directSourceFile && (q.sourceFile = D.directSourceFile), D.ranges && (q.range = [W, 0]), q;
          }
          function Hi(q) {
            var te = new bn();
            return te.start = q.start, D.locations && (te.loc = new Ls(), te.loc.start = q.loc.start), D.ranges && (te.range = [q.range[0], 0]), te;
          }
          function Ct(q, te) {
            return q.type = te, q.end = Re, D.locations && (q.loc.end = He), D.ranges && (q.range[1] = Re), q;
          }
          function Bs(q) {
            return D.ecmaVersion >= 5 && q.type === "ExpressionStatement" && q.expression.type === "Literal" && q.expression.value === "use strict";
          }
          function Gt(q) {
            if (J === q)
              return Et(), !0;
          }
          function vi() {
            return !D.strictSemicolons && (J === yt || J === cn || b.test(L.slice(Re, W)));
          }
          function dn() {
            !Gt(N) && !vi() && Xi();
          }
          function jt(q) {
            J === q ? Et() : Xi();
          }
          function Xi() {
            Ie(W, "Unexpected token");
          }
          function Es(q) {
            q.type !== "Identifier" && q.type !== "MemberExpression" && Ie(q.start, "Assigning to rvalue"), Be && q.type === "Identifier" && Ts(q.name) && Ie(q.start, "Assigning to " + q.name + " in strict mode");
          }
          function Jr(q) {
            Se = Re = F, D.locations && (He = new oe()), Ye = Be = null, Je = [], Zi();
            var te = q || oi(), be = !0;
            for (q || (te.body = []); J !== yt; ) {
              var Ae = ji();
              te.body.push(Ae), be && Bs(Ae) && Vn(!0), be = !1;
            }
            return Ct(te, "Program");
          }
          var Fs = { kind: "loop" }, Hn = { kind: "switch" };
          function ji() {
            (J === je || J === vt && le == "/=") && Zi(!0);
            var q = J, te = oi();
            switch (q) {
              case At:
              case mt:
                Et();
                var be = q === At;
                Gt(N) || vi() ? te.label = null : J !== ut ? Xi() : (te.label = Ne(), dn());
                for (var Ae = 0; Ae < Je.length; ++Ae) {
                  var qe = Je[Ae];
                  if ((te.label == null || qe.name === te.label.name) && (qe.kind != null && (be || qe.kind === "loop") || te.label && be))
                    break;
                }
                return Ae === Je.length && Ie(te.start, "Unsyntactic " + q.keyword), Ct(te, be ? "BreakStatement" : "ContinueStatement");
              case Zt:
                return Et(), dn(), Ct(te, "DebuggerStatement");
              case Nt:
                return Et(), Je.push(Fs), te.body = ji(), Je.pop(), jt(Vi), te.test = xn(), dn(), Ct(te, "DoWhileStatement");
              case ri:
                if (Et(), Je.push(Fs), jt(qi), J === N)
                  return is(te, null);
                if (J === Wi) {
                  var ot = oi();
                  return Et(), us(ot, !0), Ct(ot, "VariableDeclaration"), ot.declarations.length === 1 && Gt(Yt) ? Pn(te, ot) : is(te, ot);
                }
                var ot = Mi(!1, !0);
                return Gt(Yt) ? (Es(ot), Pn(te, ot)) : is(te, ot);
              case Pi:
                return Et(), Ce(te, !0);
              case ci:
                return Et(), te.test = xn(), te.consequent = ji(), te.alternate = Gt(Jt) ? ji() : null, Ct(te, "IfStatement");
              case hi:
                return !Ye && !D.allowReturnOutsideFunction && Ie(W, "'return' outside of function"), Et(), Gt(N) || vi() ? te.argument = null : (te.argument = Mi(), dn()), Ct(te, "ReturnStatement");
              case Ni:
                Et(), te.discriminant = xn(), te.cases = [], jt(Ji), Je.push(Hn);
                for (var it, wt; J != cn; )
                  if (J === bt || J === Xt) {
                    var gi = J === bt;
                    it && Ct(it, "SwitchCase"), te.cases.push(it = oi()), it.consequent = [], Et(), gi ? it.test = Mi() : (wt && Ie(Se, "Multiple default clauses"), wt = !0, it.test = null), jt(re);
                  } else
                    it || Xi(), it.consequent.push(ji());
                return it && Ct(it, "SwitchCase"), Et(), Je.pop(), Ct(te, "SwitchStatement");
              case Bi:
                return Et(), b.test(L.slice(Re, W)) && Ie(Re, "Illegal newline after throw"), te.argument = Mi(), dn(), Ct(te, "ThrowStatement");
              case Ri:
                if (Et(), te.block = Yn(), te.handler = null, J === li) {
                  var zi = oi();
                  Et(), jt(qi), zi.param = Ne(), Be && Ts(zi.param.name) && Ie(zi.param.start, "Binding " + zi.param.name + " in strict mode"), jt(Di), zi.guard = null, zi.body = Yn(), te.handler = Ct(zi, "CatchClause");
                }
                return te.guardedHandlers = Ge, te.finalizer = Gt(Ti) ? Yn() : null, !te.handler && !te.finalizer && Ie(te.start, "Missing catch or finally clause"), Ct(te, "TryStatement");
              case Wi:
                return Et(), us(te), dn(), Ct(te, "VariableDeclaration");
              case Vi:
                return Et(), te.test = xn(), Je.push(Fs), te.body = ji(), Je.pop(), Ct(te, "WhileStatement");
              case Fn:
                return Be && Ie(W, "'with' in strict mode"), Et(), te.object = xn(), te.body = ji(), Ct(te, "WithStatement");
              case Ji:
                return Yn();
              case N:
                return Et(), Ct(te, "EmptyStatement");
              default:
                var tn = le, an = Mi();
                if (q === ut && an.type === "Identifier" && Gt(re)) {
                  for (var Ae = 0; Ae < Je.length; ++Ae)
                    Je[Ae].name === tn && Ie(an.start, "Label '" + tn + "' is already declared");
                  var cs = J.isLoop ? "loop" : J === Ni ? "switch" : null;
                  return Je.push({ name: tn, kind: cs }), te.body = ji(), Je.pop(), te.label = an, Ct(te, "LabeledStatement");
                } else
                  return te.expression = an, dn(), Ct(te, "ExpressionStatement");
            }
          }
          function xn() {
            jt(qi);
            var q = Mi();
            return jt(Di), q;
          }
          function Yn(q) {
            var te = oi(), be = !0, Ae = !1, qe;
            for (te.body = [], jt(Ji); !Gt(cn); ) {
              var ot = ji();
              te.body.push(ot), be && q && Bs(ot) && (qe = Ae, Vn(Ae = !0)), be = !1;
            }
            return Ae && !qe && Vn(!1), Ct(te, "BlockStatement");
          }
          function is(q, te) {
            return q.init = te, jt(N), q.test = J === N ? null : Mi(), jt(N), q.update = J === Di ? null : Mi(), jt(Di), q.body = ji(), Je.pop(), Ct(q, "ForStatement");
          }
          function Pn(q, te) {
            return q.left = te, q.right = Mi(), jt(Di), q.body = ji(), Je.pop(), Ct(q, "ForInStatement");
          }
          function us(q, te) {
            for (q.declarations = [], q.kind = "var"; ; ) {
              var be = oi();
              if (be.id = Ne(), Be && Ts(be.id.name) && Ie(be.id.start, "Binding " + be.id.name + " in strict mode"), be.init = Gt(Qe) ? Mi(!0, te) : null, q.declarations.push(Ct(be, "VariableDeclarator")), !Gt(d))
                break;
            }
            return q;
          }
          function Mi(q, te) {
            var be = er(te);
            if (!q && J === d) {
              var Ae = Hi(be);
              for (Ae.expressions = [be]; Gt(d); )
                Ae.expressions.push(er(te));
              return Ct(Ae, "SequenceExpression");
            }
            return be;
          }
          function er(q) {
            var te = ur(q);
            if (J.isAssign) {
              var be = Hi(te);
              return be.operator = le, be.left = te, Et(), be.right = er(q), Es(te), Ct(be, "AssignmentExpression");
            }
            return te;
          }
          function ur(q) {
            var te = vs(q);
            if (Gt(Le)) {
              var be = Hi(te);
              return be.test = te, be.consequent = Mi(!0), jt(re), be.alternate = Mi(!0, q), Ct(be, "ConditionalExpression");
            }
            return te;
          }
          function vs(q) {
            return gn(Us(), -1, q);
          }
          function gn(q, te, be) {
            var Ae = J.binop;
            if (Ae != null && (!be || J !== Yt) && Ae > te) {
              var qe = Hi(q);
              qe.left = q, qe.operator = le;
              var ot = J;
              Et(), qe.right = gn(Us(), Ae, be);
              var it = Ct(qe, ot === ii || ot === Gi ? "LogicalExpression" : "BinaryExpression");
              return gn(it, te, be);
            }
            return q;
          }
          function Us() {
            if (J.prefix) {
              var q = oi(), te = J.isUpdate;
              return q.operator = le, q.prefix = !0, fe = !0, Et(), q.argument = Us(), te ? Es(q.argument) : Be && q.operator === "delete" && q.argument.type === "Identifier" && Ie(q.start, "Deleting local variable in strict mode"), Ct(q, te ? "UpdateExpression" : "UnaryExpression");
            }
            for (var be = xr(); J.postfix && !vi(); ) {
              var q = Hi(be);
              q.operator = le, q.prefix = !1, q.argument = be, Es(be), Et(), be = Ct(q, "UpdateExpression");
            }
            return be;
          }
          function xr() {
            return ns(Te());
          }
          function ns(q, te) {
            if (Gt(pe)) {
              var be = Hi(q);
              return be.object = q, be.property = Ne(!0), be.computed = !1, ns(Ct(be, "MemberExpression"), te);
            } else if (Gt(Mn)) {
              var be = Hi(q);
              return be.object = q, be.property = Mi(), be.computed = !0, jt(un), ns(Ct(be, "MemberExpression"), te);
            } else if (!te && Gt(qi)) {
              var be = Hi(q);
              return be.callee = q, be.arguments = De(Di, !1), ns(Ct(be, "CallExpression"), te);
            } else
              return q;
          }
          function Te() {
            switch (J) {
              case Cs:
                var Ae = oi();
                return Et(), Ct(Ae, "ThisExpression");
              case ut:
                return Ne();
              case et:
              case gt:
              case tt:
                var Ae = oi();
                return Ae.value = le, Ae.raw = L.slice(W, Q), Et(), Ct(Ae, "Literal");
              case _s:
              case vn:
              case Qn:
                var Ae = oi();
                return Ae.value = J.atomValue, Ae.raw = J.keyword, Et(), Ct(Ae, "Literal");
              case qi:
                var q = ie, te = W;
                Et();
                var be = Mi();
                return be.start = te, be.end = Q, D.locations && (be.loc.start = q, be.loc.end = ae), D.ranges && (be.range = [te, Q]), jt(Di), be;
              case Mn:
                var Ae = oi();
                return Et(), Ae.elements = De(un, !0, !0), Ct(Ae, "ArrayExpression");
              case Ji:
                return Xe();
              case Pi:
                var Ae = oi();
                return Et(), Ce(Ae, !1);
              case $n:
                return Fe();
              default:
                Xi();
            }
          }
          function Fe() {
            var q = oi();
            return Et(), q.callee = ns(Te(), !0), Gt(qi) ? q.arguments = De(Di, !1) : q.arguments = Ge, Ct(q, "NewExpression");
          }
          function Xe() {
            var q = oi(), te = !0, be = !1;
            for (q.properties = [], Et(); !Gt(cn); ) {
              if (te)
                te = !1;
              else if (jt(d), D.allowTrailingCommas && Gt(cn))
                break;
              var Ae = { key: $e() }, qe = !1, ot;
              if (Gt(re) ? (Ae.value = Mi(!0), ot = Ae.kind = "init") : D.ecmaVersion >= 5 && Ae.key.type === "Identifier" && (Ae.key.name === "get" || Ae.key.name === "set") ? (qe = be = !0, ot = Ae.kind = Ae.key.name, Ae.key = $e(), J !== qi && Xi(), Ae.value = Ce(oi(), !1)) : Xi(), Ae.key.type === "Identifier" && (Be || be))
                for (var it = 0; it < q.properties.length; ++it) {
                  var wt = q.properties[it];
                  if (wt.key.name === Ae.key.name) {
                    var gi = ot == wt.kind || qe && wt.kind === "init" || ot === "init" && (wt.kind === "get" || wt.kind === "set");
                    gi && !Be && ot === "init" && wt.kind === "init" && (gi = !1), gi && Ie(Ae.key.start, "Redefinition of property");
                  }
                }
              q.properties.push(Ae);
            }
            return Ct(q, "ObjectExpression");
          }
          function $e() {
            return J === et || J === gt ? Te() : Ne(!0);
          }
          function Ce(q, te) {
            J === ut ? q.id = Ne() : te ? Xi() : q.id = null, q.params = [];
            var be = !0;
            for (jt(qi); !Gt(Di); )
              be ? be = !1 : jt(d), q.params.push(Ne());
            var Ae = Ye, qe = Je;
            if (Ye = !0, Je = [], q.body = Yn(!0), Ye = Ae, Je = qe, Be || q.body.body.length && Bs(q.body.body[0]))
              for (var ot = q.id ? -1 : 0; ot < q.params.length; ++ot) {
                var it = ot < 0 ? q.id : q.params[ot];
                if ((lr(it.name) || Ts(it.name)) && Ie(it.start, "Defining '" + it.name + "' in strict mode"), ot >= 0)
                  for (var wt = 0; wt < ot; ++wt)
                    it.name === q.params[wt].name && Ie(it.start, "Argument name clash in strict mode");
              }
            return Ct(q, te ? "FunctionDeclaration" : "FunctionExpression");
          }
          function De(q, te, be) {
            for (var Ae = [], qe = !0; !Gt(q); ) {
              if (qe)
                qe = !1;
              else if (jt(d), te && D.allowTrailingCommas && Gt(q))
                break;
              be && J === d ? Ae.push(null) : Ae.push(Mi(!0));
            }
            return Ae;
          }
          function Ne(q) {
            var te = oi();
            return q && D.forbidReserved == "everywhere" && (q = !1), J === ut ? (!q && (D.forbidReserved && (D.ecmaVersion === 3 ? br : Kr)(le) || Be && lr(le)) && L.slice(W, Q).indexOf("\\") == -1 && Ie(W, "The keyword '" + le + "' is reserved"), te.name = le) : q && J.keyword ? te.name = J.keyword : Xi(), fe = !1, Et(), Ct(te, "Identifier");
          }
        }), n.version || (n = null);
      }
      function h(E, D) {
        return (i.acorn || n).parse(E, D);
      }
      var f = {
        "+": "__add",
        "-": "__subtract",
        "*": "__multiply",
        "/": "__divide",
        "%": "__modulo",
        "==": "__equals",
        "!=": "__equals"
      }, m = {
        "-": "__negate",
        "+": "__self"
      }, _ = a.each(
        ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
        function(E) {
          this["__" + E] = "#" + E;
        },
        {
          __self: function() {
            return this;
          }
        }
      );
      z.inject(_), ne.inject(_), qt.inject(_);
      function y(E, D, L) {
        var P = f[D];
        if (E && E[P]) {
          var S = E[P](L);
          return D === "!=" ? !S : S;
        }
        switch (D) {
          case "+":
            return E + L;
          case "-":
            return E - L;
          case "*":
            return E * L;
          case "/":
            return E / L;
          case "%":
            return E % L;
          case "==":
            return E == L;
          case "!=":
            return E != L;
        }
      }
      function x(E, D) {
        var L = m[E];
        if (D && D[L])
          return D[L]();
        switch (E) {
          case "+":
            return +D;
          case "-":
            return -D;
        }
      }
      function A(E, D) {
        if (!E)
          return "";
        D = D || {};
        var L = [];
        function P(Be) {
          for (var Ie = 0, Ge = L.length; Ie < Ge; Ie++) {
            var et = L[Ie];
            if (et[0] >= Be)
              break;
            Be += et[1];
          }
          return Be;
        }
        function S(Be) {
          return E.substring(
            P(Be.range[0]),
            P(Be.range[1])
          );
        }
        function I(Be, Ie) {
          return E.substring(
            P(Be.range[1]),
            P(Ie.range[0])
          );
        }
        function U(Be, Ie) {
          for (var Ge = P(Be.range[0]), et = P(Be.range[1]), tt = 0, gt = L.length - 1; gt >= 0; gt--)
            if (Ge > L[gt][0]) {
              tt = gt + 1;
              break;
            }
          L.splice(tt, 0, [Ge, Ie.length - et + Ge]), E = E.substring(0, Ge) + Ie + E.substring(et);
        }
        function V(Be, Ie) {
          switch (Be.type) {
            case "UnaryExpression":
              if (Be.operator in m && Be.argument.type !== "Literal") {
                var Ge = S(Be.argument);
                U(Be, '$__("' + Be.operator + '", ' + Ge + ")");
              }
              break;
            case "BinaryExpression":
              if (Be.operator in f && Be.left.type !== "Literal") {
                var et = S(Be.left), tt = S(Be.right), gt = I(Be.left, Be.right), ut = Be.operator;
                U(Be, "__$__(" + et + "," + gt.replace(
                  new RegExp("\\" + ut),
                  '"' + ut + '"'
                ) + ", " + tt + ")");
              }
              break;
            case "UpdateExpression":
            case "AssignmentExpression":
              var yt = Ie && Ie.type;
              if (!(yt === "ForStatement" || yt === "BinaryExpression" && /^[=!<>]/.test(Ie.operator) || yt === "MemberExpression" && Ie.computed)) {
                if (Be.type === "UpdateExpression") {
                  var Ge = S(Be.argument), At = "__$__(" + Ge + ', "' + Be.operator[0] + '", 1)', bt = Ge + " = " + At;
                  Be.prefix ? bt = "(" + bt + ")" : (yt === "AssignmentExpression" || yt === "VariableDeclarator" || yt === "BinaryExpression") && (S(Ie.left || Ie.id) === Ge && (bt = At), bt = Ge + "; " + bt), U(Be, bt);
                } else if (/^.=$/.test(Be.operator) && Be.left.type !== "Literal") {
                  var et = S(Be.left), tt = S(Be.right), At = et + " = __$__(" + et + ', "' + Be.operator[0] + '", ' + tt + ")";
                  U(Be, /^\(.*\)$/.test(S(Be)) ? "(" + At + ")" : At);
                }
              }
              break;
          }
        }
        function F(Be) {
          switch (Be.type) {
            case "ExportDefaultDeclaration":
              U({
                range: [Be.start, Be.declaration.start]
              }, "module.exports = ");
              break;
            case "ExportNamedDeclaration":
              var Ie = Be.declaration, Ge = Be.specifiers;
              if (Ie) {
                var et = Ie.declarations;
                et && (et.forEach(function(gt) {
                  U(gt, "module.exports." + S(gt));
                }), U({
                  range: [
                    Be.start,
                    Ie.start + Ie.kind.length
                  ]
                }, ""));
              } else if (Ge) {
                var tt = Ge.map(function(gt) {
                  var ut = S(gt);
                  return "module.exports." + ut + " = " + ut + "; ";
                }).join("");
                tt && U(Be, tt);
              }
              break;
          }
        }
        function W(Be, Ie, Ge) {
          if (Be) {
            for (var et in Be)
              if (et !== "range" && et !== "loc") {
                var tt = Be[et];
                if (Array.isArray(tt))
                  for (var gt = 0, ut = tt.length; gt < ut; gt++)
                    W(tt[gt], Be, Ge);
                else
                  tt && typeof tt == "object" && W(tt, Be, Ge);
              }
            Ge.operatorOverloading !== !1 && V(Be, Ie), Ge.moduleExports !== !1 && F(Be);
          }
        }
        function Q(Be) {
          var Ie = "", Ge = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          for (Be = (Math.abs(Be) << 1) + (Be < 0 ? 1 : 0); Be || !Ie; ) {
            var et = Be & 31;
            Be >>= 5, Be && (et |= 32), Ie += Ge[et];
          }
          return Ie;
        }
        var ie = D.url || "", ae = D.sourceMaps, J = D.paperFeatures || {}, le = D.source || E, fe = D.offset || 0, me = nt.agent, ve = me.versionNumber, Se = !1, Re = /\r\n|\n|\r/mg, He;
        if (ae && (me.chrome && ve >= 30 || me.webkit && ve >= 537.76 || me.firefox && ve >= 23 || me.node)) {
          if (me.node)
            fe -= 2;
          else if (s && ie && !s.location.href.indexOf(ie)) {
            var Ye = o.getElementsByTagName("html")[0].innerHTML;
            fe = Ye.substr(0, Ye.indexOf(E) + 1).match(
              Re
            ).length + 1;
          }
          Se = fe > 0 && !(me.chrome && ve >= 36 || me.safari && ve >= 600 || me.firefox && ve >= 40 || me.node);
          var Je = ["AA" + Q(Se ? 0 : fe) + "A"];
          Je.length = (E.match(Re) || []).length + 1 + (Se ? fe : 0), He = {
            version: 3,
            file: ie,
            names: [],
            mappings: Je.join(";AACA"),
            sourceRoot: "",
            sources: [ie],
            sourcesContent: [le]
          };
        }
        return (J.operatorOverloading !== !1 || J.moduleExports !== !1) && W(h(E, {
          ranges: !0,
          preserveParens: !0,
          sourceType: "module"
        }), null, J), He && (Se && (E = new Array(fe + 1).join(`
`) + E), /^(inline|both)$/.test(ae) && (E += `
//# sourceMappingURL=data:application/json;base64,` + e.btoa(unescape(encodeURIComponent(
          JSON.stringify(He)
        )))), E += `
//# sourceURL=` + (ie || "paperscript")), {
          url: ie,
          source: le,
          code: E,
          map: He
        };
      }
      function B(E, D, L) {
        nt = D;
        var P = D.getView(), S = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(E) && !/\bnew\s+Tool\b/.test(E) ? new Bn() : null, I = S ? S._events : [], U = ["onFrame", "onResize"].concat(I), V = [], F = [], W, Q = typeof E == "object" ? E : A(E, L);
        E = Q.code;
        function ie(ve, Se) {
          for (var Re in ve)
            (Se || !/^_/.test(Re)) && new RegExp("([\\b\\s\\W]|^)" + Re.replace(/\$/g, "\\$") + "\\b").test(E) && (V.push(Re), F.push(ve[Re]));
        }
        ie(
          { __$__: y, $__: x, paper: D, tool: S },
          !0
        ), ie(D), E = "var module = { exports: {} }; " + E;
        var fe = a.each(U, function(ve) {
          new RegExp("\\s+" + ve + "\\b").test(E) && (V.push(ve), this.push("module.exports." + ve + " = " + ve + ";"));
        }, []).join(`
`);
        fe && (E += `
` + fe), E += `
return module.exports;`;
        var ae = nt.agent;
        if (o && (ae.chrome || ae.firefox && ae.versionNumber < 40)) {
          var J = o.createElement("script"), le = o.head || o.getElementsByTagName("head")[0];
          ae.firefox && (E = `
` + E), J.appendChild(o.createTextNode(
            "document.__paperscript__ = function(" + V + ") {" + E + `
}`
          )), le.appendChild(J), W = o.__paperscript__, delete o.__paperscript__, le.removeChild(J);
        } else
          W = Function(V, E);
        var fe = W && W.apply(D, F), me = fe || {};
        return a.each(I, function(ve) {
          var Se = me[ve];
          Se && (S[ve] = Se);
        }), P && (me.onResize && P.setOnResize(me.onResize), P.emit("resize", {
          size: P.size,
          delta: new z()
        }), me.onFrame && P.setOnFrame(me.onFrame), P.requestUpdate()), fe;
      }
      function C(E) {
        if (/^text\/(?:x-|)paperscript$/.test(E.type) && g.getAttribute(E, "ignore") !== "true") {
          var D = g.getAttribute(E, "canvas"), L = o.getElementById(D), P = E.src || E.getAttribute("data-src"), S = g.hasAttribute(E, "async"), I = "data-paper-scope";
          if (!L)
            throw new Error('Unable to find canvas with id "' + D + '"');
          var U = g.get(L.getAttribute(I)) || new g().setup(L);
          return L.setAttribute(I, U._id), P ? zn.request({
            url: P,
            async: S,
            mimeType: "text/plain",
            onLoad: function(V) {
              B(V, U, P);
            }
          }) : B(E.innerHTML, U, E.baseURI), E.setAttribute("data-paper-ignore", "true"), U;
        }
      }
      function M() {
        a.each(
          o && o.getElementsByTagName("script"),
          C
        );
      }
      function R(E) {
        return E ? C(E) : M();
      }
      return s && (o.readyState === "complete" ? setTimeout(M) : Dt.add(s, { load: M })), {
        compile: A,
        execute: B,
        load: R,
        parse: h,
        calculateBinary: y,
        calculateUnary: x
      };
    }).call(this);
    var nt = new (g.inject(a.exports, {
      Base: a,
      Numerical: Y,
      Key: qn,
      DomEvent: Dt,
      DomElement: zt,
      document: o,
      window: s,
      Symbol: Mt,
      PlacedSymbol: Pt
    }))();
    return nt.agent.node && df(nt), typeof t == "function" && t.amd ? t("paper", nt) : v && (v.exports = nt), nt;
  }).call(Ly, typeof self == "object" ? self : null);
})(Kf);
var Py = Kf.exports;
const gf = /* @__PURE__ */ By(Py);
class Ny {
  constructor() {
    xh(this, "_paperScope", new gf.PaperScope()), xh(this, "_baseMaterial", null), xh(this, "_borderMaterial", null);
    const e = document.createElement("canvas");
    e.width = 1, e.height = 1, this._paperScope.setup(new gf.Size(1, 1));
  }
  generatePreview3D(e, t) {
    if (!e.columns || isNaN(e.columns) || e.columns < 1 || e.rows < 1 || !e.rows || isNaN(e.rows))
      throw new Error("Invalid columns or rows value. Columns and rows must be greater than 0 and must be a number.");
    console.log("Generating 3D preview for resizable canvas...", e), this._baseMaterial || (this._baseMaterial = new BABYLON.PBRMaterial("baseMaterial", t)), this._borderMaterial || (this._borderMaterial = new BABYLON.PBRMaterial("borderMaterial", t)), this._baseMaterial.albedoColor = new BABYLON.Color3(1, 1, 1), this._baseMaterial.metallic = 0, this._baseMaterial.roughness = 0.5, this._borderMaterial.albedoColor = BABYLON.Color3.FromHexString(e.borderColor), this._borderMaterial.metallic = 0, this._borderMaterial.roughness = 0.5, e.useCheckerTexture && (this._baseMaterial.albedoTexture = new BABYLON.Texture("https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png", t), this._baseMaterial.albedoTexture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, this._baseMaterial.albedoTexture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE, this._borderMaterial.albedoTexture = new BABYLON.Texture("https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png", t), this._borderMaterial.albedoTexture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, this._borderMaterial.albedoTexture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
    const s = new BABYLON.Mesh("groupMesh", t), o = [], a = [], c = [];
    for (let Y = 0; Y < e.columns; Y++)
      for (let ee = 0; ee < e.rows; ee++) {
        const [z, he, ne] = this.generateCanvasMesh(e, t, Y, ee);
        o.push(z), a.push(he), c.push(ne);
      }
    const g = BABYLON.Mesh.MergeMeshes(o, !0, !0, void 0, !1, !1), w = BABYLON.Mesh.MergeMeshes(a, !0, !0, void 0, !1, !1), T = BABYLON.Mesh.MergeMeshes(c, !0, !0, void 0, !1, !1);
    if (!g || !w || !T)
      return null;
    g.material = this._borderMaterial, w.material = this._baseMaterial, T.material = this._baseMaterial, g.parent = s, w.parent = s, T.parent = s, g.name = "borders", w.name = "back", T.name = "front";
    const H = BABYLON.SceneSerializer.SerializeMesh(s, !1, !0);
    return s == null || s.dispose(), H;
  }
  generateCanvasMesh(e, t, s, o) {
    const a = e.width / e.columns, c = e.height / e.rows, g = a * 0.1, w = BABYLON.MeshBuilder.CreateBox(
      "borders",
      {
        width: a,
        height: c,
        depth: e.depth
      },
      t
    ), T = BABYLON.MeshBuilder.CreatePlane(
      "front",
      {
        width: a,
        height: c
      },
      t
    ), H = BABYLON.MeshBuilder.CreatePlane(
      "back",
      {
        width: a,
        height: c
      },
      t
    );
    w.position = new BABYLON.Vector3(a / 2 + s * (a + g), c / 2 + o * (c + g)), T.position = new BABYLON.Vector3(a / 2 + s * (a + g), c / 2 + o * (c + g), -e.depth / 2), H.position = new BABYLON.Vector3(a / 2 + s * (a + g), c / 2 + o * (c + g), e.depth / 2), H.rotate(BABYLON.Axis.X, Math.PI, BABYLON.Space.WORLD), H.rotate(BABYLON.Axis.Z, Math.PI, BABYLON.Space.WORLD), w.material = this._borderMaterial, H.material = this._borderMaterial, T.material = this._baseMaterial;
    const Y = w.getVerticesData(BABYLON.VertexBuffer.NormalKind), ee = w.getVerticesData(BABYLON.VertexBuffer.UVKind), z = T.getVerticesData(BABYLON.VertexBuffer.UVKind), he = H.getVerticesData(BABYLON.VertexBuffer.UVKind);
    if (e.borderRadius > 0 && console.warn("Mirror canvas effect will not work for border radius > 0"), e.borderRadius === 0) {
      const K = e.depth / e.width, j = e.depth / e.height, ht = Math.min(K, j), Ze = a / e.width, pt = c / e.height;
      for (var ne = 0; ne < ee.length; ne += 2) {
        const Pt = Math.round(Y[ne / 2 * 3]), Mt = Math.round(Y[ne / 2 * 3 + 1]), Tt = Math.round(Y[ne / 2 * 3 + 2]), at = Pt == -1 && Mt == 0 && Tt == 0, Ai = Pt == 1 && Mt == 0 && Tt == 0, Ve = Pt == 0 && Mt == 1 && Tt == 0, Ot = Pt == 0 && Mt == -1 && Tt == 0;
        if (at) {
          var ye = ee[ne], se = ee[ne + 1];
          ee[ne] = se * ht + Ze * s, ee[ne + 1] = ye * pt + pt * o;
        }
        if (Ai) {
          var ye = ee[ne], se = ee[ne + 1];
          ee[ne] = se * ht + (1 - ht) - Ze * (e.columns - 1 - s), ee[ne + 1] = ye * pt + pt * o;
        }
        if (Ot) {
          var ye = ee[ne], se = ee[ne + 1];
          ee[ne] = se * Ze + Ze * s, ee[ne + 1] = ye * ht + pt * o;
        }
        if (Ve) {
          var ye = ee[ne], se = ee[ne + 1];
          ee[ne] = (-se + 1) * Ze + Ze * s, ee[ne + 1] = (-ye + 1) * ht + (1 - ht);
        }
      }
      w.setVerticesData(BABYLON.VertexBuffer.UVKind, ee);
      for (var ne = 0; ne < z.length; ne += 2) {
        var ye = z[ne], se = z[ne + 1];
        z[ne] = ye * Ze + Ze * s, z[ne + 1] = se * pt + pt * o;
      }
      T.setVerticesData(BABYLON.VertexBuffer.UVKind, z);
      for (var ne = 0; ne < he.length; ne += 2) {
        var ye = he[ne], se = he[ne + 1];
        he[ne] = ye * Ze + Ze * (e.columns - 1 - s), he[ne + 1] = se * pt + pt * o;
      }
      H.setVerticesData(BABYLON.VertexBuffer.UVKind, he);
    }
    T.isVisible = !1, H.isVisible = !1;
    const _e = w.getVerticesData(BABYLON.VertexBuffer.PositionKind) ?? [], ue = w.getVerticesData(BABYLON.VertexBuffer.NormalKind) ?? [], xe = w.getVerticesData(BABYLON.VertexBuffer.UVKind) ?? [], Ee = w.getIndices() ?? [];
    return _e.splice(0, 8 * 3), ue.splice(0, 8 * 3), xe.splice(0, 8 * 2), Ee.splice(Ee.length - 4 * 3, 4 * 3), w.updateVerticesData(BABYLON.VertexBuffer.PositionKind, _e), w.updateVerticesData(BABYLON.VertexBuffer.NormalKind, ue), w.updateVerticesData(BABYLON.VertexBuffer.UVKind, xe), w.updateIndices(Ee), [w, H, T];
  }
  /*public generatePreview3D(options: ResizableCanvas3DOptions) {
  
          // Use paper to generate the path
          const rectangle = new this._paperScope.Path.Rectangle({
              point: [0, 0],
              size: [options.width, options.height],
              radius: options.borderRadius,
          });
  
          rectangle.flatten(options.radiusResolution);
          rectangle.remove();
  
          //Shape profile in XY plane
          const shape = [
              ...rectangle.segments.map(segment => new BABYLON.Vector3(segment.point.x, 0, segment.point.y)),
          ];
  
          var faceUV = new Array(3);
  
          // We know that the texture created from the customer is squared and the 
          // printing area is "fitted" inside the UV quadrant, at the center.
          // So, based on the width and height ratio, we know what portion of the UV map quadrant
          // we have to show, we just need to normalized the width and height in the quadrant
  
          //const ratio = options.width / options.height;
          //let width = 1;
          //let height = 1 / ratio;
  
          //if (ratio < 1) {
            //  width = 1 * ratio;
           //   height = 1;
          //}
  
          //const uvU = 0.5 - width / 2;
          //const uvV = 0.5 - height / 2;
  
          //faceUV[0] = new BABYLON.Vector4(uvU, uvV, uvU + width, uvV + height);
          //faceUV[1] = new BABYLON.Vector4(uvU, uvV, uvU + width, uvV + height);
          //faceUV[2] = new BABYLON.Vector4(uvU, uvV, uvU + width, uvV + height);
  
          faceUV[0] = new BABYLON.Vector4(0, 0, 1, 1);
          faceUV[1] = new BABYLON.Vector4(0, 0, 1, 1);
          faceUV[2] = new BABYLON.Vector4(0, 0, 1, -1);
  
  
          let mesh = BABYLON.MeshBuilder.ExtrudePolygon("canvas", {
              shape: shape,
              depth: options.depth,
              faceUV,
          }, null, earcut);
  
          // Get vertexes
          let positions = mesh!.getVerticesData(BABYLON.VertexBuffer.PositionKind) as number[];
          let indices = mesh!.getIndices() as number[];
          let normals = mesh!.getVerticesData(BABYLON.VertexBuffer.NormalKind) as number[];
          let uvs = mesh!.getVerticesData(BABYLON.VertexBuffer.UVKind) as number[];
  
          if (options.borderRadius > 0)
              console.warn("Mirror canvas effect will not work for border radius > 0")
  
          if (options.borderRadius === 0) {
              // Make the mirror UV map, normally is 0,0 1,1 but we need to use the correct portion too
              const sidePortionX = options.depth / options.width;
              const sidePortionY = options.depth / options.height;
  
              // Use the same portion for both directions
              const sidePortion = Math.min(sidePortionX, sidePortionY);
  
              for (var i = 0; i < uvs.length; i += 2) {
                  // Get the vertex normal
                  const normalX = Math.round(normals[i / 2 * 3]);
                  const normalY = Math.round(normals[i / 2 * 3 + 1]);
                  const normalZ = Math.round(normals[i / 2 * 3 + 2]);
  
  
                  // Left
                  if (normalX == -1 && normalY == 0 && normalZ == 0) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = -y * sidePortion + sidePortion;// uv is inverted??? 
                      uvs[i + 1] = -x + 1;
                  }
  
                  // Right
                  if (normalX == 1 && normalY == 0 && normalZ == 0) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = y * sidePortion - sidePortion + 1;// uv is inverted??? 
                      uvs[i + 1] = x;
  
  
                      console.log(i, uvs[i], uvs[i + 1])
                  }
  
                  // Bottom
                  if (normalX == 0 && normalY == 0 && normalZ == -1) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = x;
                      uvs[i + 1] = -y * sidePortion + sidePortion;// uv is inverted??? 
                  }
  
                  // Top
                  if (normalX == 0 && normalY == 0 && normalZ == 1) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = -x + 1;
                      uvs[i + 1] = y * sidePortion - sidePortion + 1; // uv is inverted??? 
                  }
              }
  
              mesh.setVerticesData(BABYLON.VertexBuffer.UVKind, uvs);
          }
  
          mesh?.dispose();
  
          return { positions, indices, normals, uvs };
      }*/
}
function Jf(v, e) {
  return function() {
    return v.apply(e, arguments);
  };
}
const { toString: Ry } = Object.prototype, { getPrototypeOf: Xh } = Object, bl = ((v) => (e) => {
  const t = Ry.call(e);
  return v[t] || (v[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), vr = (v) => (v = v.toLowerCase(), (e) => bl(e) === v), xl = (v) => (e) => typeof e === v, { isArray: La } = Array, no = xl("undefined");
function Dy(v) {
  return v !== null && !no(v) && v.constructor !== null && !no(v.constructor) && Ks(v.constructor.isBuffer) && v.constructor.isBuffer(v);
}
const $f = vr("ArrayBuffer");
function zy(v) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(v) : e = v && v.buffer && $f(v.buffer), e;
}
const Fy = xl("string"), Ks = xl("function"), Qf = xl("number"), wl = (v) => v !== null && typeof v == "object", Uy = (v) => v === !0 || v === !1, il = (v) => {
  if (bl(v) !== "object")
    return !1;
  const e = Xh(v);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in v) && !(Symbol.iterator in v);
}, Vy = vr("Date"), Hy = vr("File"), Yy = vr("Blob"), Gy = vr("FileList"), jy = (v) => wl(v) && Ks(v.pipe), Wy = (v) => {
  let e;
  return v && (typeof FormData == "function" && v instanceof FormData || Ks(v.append) && ((e = bl(v)) === "formdata" || // detect form-data instance
  e === "object" && Ks(v.toString) && v.toString() === "[object FormData]"));
}, qy = vr("URLSearchParams"), Zy = (v) => v.trim ? v.trim() : v.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function uo(v, e, { allOwnKeys: t = !1 } = {}) {
  if (v === null || typeof v > "u")
    return;
  let s, o;
  if (typeof v != "object" && (v = [v]), La(v))
    for (s = 0, o = v.length; s < o; s++)
      e.call(null, v[s], s, v);
  else {
    const a = t ? Object.getOwnPropertyNames(v) : Object.keys(v), c = a.length;
    let g;
    for (s = 0; s < c; s++)
      g = a[s], e.call(null, v[g], g, v);
  }
}
function ed(v, e) {
  e = e.toLowerCase();
  const t = Object.keys(v);
  let s = t.length, o;
  for (; s-- > 0; )
    if (o = t[s], e === o.toLowerCase())
      return o;
  return null;
}
const td = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), id = (v) => !no(v) && v !== td;
function kh() {
  const { caseless: v } = id(this) && this || {}, e = {}, t = (s, o) => {
    const a = v && ed(e, o) || o;
    il(e[a]) && il(s) ? e[a] = kh(e[a], s) : il(s) ? e[a] = kh({}, s) : La(s) ? e[a] = s.slice() : e[a] = s;
  };
  for (let s = 0, o = arguments.length; s < o; s++)
    arguments[s] && uo(arguments[s], t);
  return e;
}
const Xy = (v, e, t, { allOwnKeys: s } = {}) => (uo(e, (o, a) => {
  t && Ks(o) ? v[a] = Jf(o, t) : v[a] = o;
}, { allOwnKeys: s }), v), Ky = (v) => (v.charCodeAt(0) === 65279 && (v = v.slice(1)), v), Jy = (v, e, t, s) => {
  v.prototype = Object.create(e.prototype, s), v.prototype.constructor = v, Object.defineProperty(v, "super", {
    value: e.prototype
  }), t && Object.assign(v.prototype, t);
}, $y = (v, e, t, s) => {
  let o, a, c;
  const g = {};
  if (e = e || {}, v == null)
    return e;
  do {
    for (o = Object.getOwnPropertyNames(v), a = o.length; a-- > 0; )
      c = o[a], (!s || s(c, v, e)) && !g[c] && (e[c] = v[c], g[c] = !0);
    v = t !== !1 && Xh(v);
  } while (v && (!t || t(v, e)) && v !== Object.prototype);
  return e;
}, Qy = (v, e, t) => {
  v = String(v), (t === void 0 || t > v.length) && (t = v.length), t -= e.length;
  const s = v.indexOf(e, t);
  return s !== -1 && s === t;
}, eb = (v) => {
  if (!v)
    return null;
  if (La(v))
    return v;
  let e = v.length;
  if (!Qf(e))
    return null;
  const t = new Array(e);
  for (; e-- > 0; )
    t[e] = v[e];
  return t;
}, tb = ((v) => (e) => v && e instanceof v)(typeof Uint8Array < "u" && Xh(Uint8Array)), ib = (v, e) => {
  const s = (v && v[Symbol.iterator]).call(v);
  let o;
  for (; (o = s.next()) && !o.done; ) {
    const a = o.value;
    e.call(v, a[0], a[1]);
  }
}, nb = (v, e) => {
  let t;
  const s = [];
  for (; (t = v.exec(e)) !== null; )
    s.push(t);
  return s;
}, sb = vr("HTMLFormElement"), rb = (v) => v.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, s, o) {
    return s.toUpperCase() + o;
  }
), pf = (({ hasOwnProperty: v }) => (e, t) => v.call(e, t))(Object.prototype), ab = vr("RegExp"), nd = (v, e) => {
  const t = Object.getOwnPropertyDescriptors(v), s = {};
  uo(t, (o, a) => {
    let c;
    (c = e(o, a, v)) !== !1 && (s[a] = c || o);
  }), Object.defineProperties(v, s);
}, ob = (v) => {
  nd(v, (e, t) => {
    if (Ks(v) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const s = v[t];
    if (Ks(s)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, lb = (v, e) => {
  const t = {}, s = (o) => {
    o.forEach((a) => {
      t[a] = !0;
    });
  };
  return La(v) ? s(v) : s(String(v).split(e)), t;
}, hb = () => {
}, ub = (v, e) => (v = +v, Number.isFinite(v) ? v : e), wh = "abcdefghijklmnopqrstuvwxyz", _f = "0123456789", sd = {
  DIGIT: _f,
  ALPHA: wh,
  ALPHA_DIGIT: wh + wh.toUpperCase() + _f
}, cb = (v = 16, e = sd.ALPHA_DIGIT) => {
  let t = "";
  const { length: s } = e;
  for (; v--; )
    t += e[Math.random() * s | 0];
  return t;
};
function fb(v) {
  return !!(v && Ks(v.append) && v[Symbol.toStringTag] === "FormData" && v[Symbol.iterator]);
}
const db = (v) => {
  const e = new Array(10), t = (s, o) => {
    if (wl(s)) {
      if (e.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        e[o] = s;
        const a = La(s) ? [] : {};
        return uo(s, (c, g) => {
          const w = t(c, o + 1);
          !no(w) && (a[g] = w);
        }), e[o] = void 0, a;
      }
    }
    return s;
  };
  return t(v, 0);
}, gb = vr("AsyncFunction"), pb = (v) => v && (wl(v) || Ks(v)) && Ks(v.then) && Ks(v.catch), dt = {
  isArray: La,
  isArrayBuffer: $f,
  isBuffer: Dy,
  isFormData: Wy,
  isArrayBufferView: zy,
  isString: Fy,
  isNumber: Qf,
  isBoolean: Uy,
  isObject: wl,
  isPlainObject: il,
  isUndefined: no,
  isDate: Vy,
  isFile: Hy,
  isBlob: Yy,
  isRegExp: ab,
  isFunction: Ks,
  isStream: jy,
  isURLSearchParams: qy,
  isTypedArray: tb,
  isFileList: Gy,
  forEach: uo,
  merge: kh,
  extend: Xy,
  trim: Zy,
  stripBOM: Ky,
  inherits: Jy,
  toFlatObject: $y,
  kindOf: bl,
  kindOfTest: vr,
  endsWith: Qy,
  toArray: eb,
  forEachEntry: ib,
  matchAll: nb,
  isHTMLForm: sb,
  hasOwnProperty: pf,
  hasOwnProp: pf,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: nd,
  freezeMethods: ob,
  toObjectSet: lb,
  toCamelCase: rb,
  noop: hb,
  toFiniteNumber: ub,
  findKey: ed,
  global: td,
  isContextDefined: id,
  ALPHABET: sd,
  generateString: cb,
  isSpecCompliantForm: fb,
  toJSONObject: db,
  isAsyncFn: gb,
  isThenable: pb
};
function Fi(v, e, t, s, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = v, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), s && (this.request = s), o && (this.response = o);
}
dt.inherits(Fi, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: dt.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const rd = Fi.prototype, ad = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((v) => {
  ad[v] = { value: v };
});
Object.defineProperties(Fi, ad);
Object.defineProperty(rd, "isAxiosError", { value: !0 });
Fi.from = (v, e, t, s, o, a) => {
  const c = Object.create(rd);
  return dt.toFlatObject(v, c, function(w) {
    return w !== Error.prototype;
  }, (g) => g !== "isAxiosError"), Fi.call(c, v.message, e, t, s, o), c.cause = v, c.name = v.name, a && Object.assign(c, a), c;
};
const _b = null;
function Ph(v) {
  return dt.isPlainObject(v) || dt.isArray(v);
}
function od(v) {
  return dt.endsWith(v, "[]") ? v.slice(0, -2) : v;
}
function mf(v, e, t) {
  return v ? v.concat(e).map(function(o, a) {
    return o = od(o), !t && a ? "[" + o + "]" : o;
  }).join(t ? "." : "") : e;
}
function mb(v) {
  return dt.isArray(v) && !v.some(Ph);
}
const vb = dt.toFlatObject(dt, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Sl(v, e, t) {
  if (!dt.isObject(v))
    throw new TypeError("target must be an object");
  e = e || new FormData(), t = dt.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(ne, ye) {
    return !dt.isUndefined(ye[ne]);
  });
  const s = t.metaTokens, o = t.visitor || H, a = t.dots, c = t.indexes, w = (t.Blob || typeof Blob < "u" && Blob) && dt.isSpecCompliantForm(e);
  if (!dt.isFunction(o))
    throw new TypeError("visitor must be a function");
  function T(he) {
    if (he === null)
      return "";
    if (dt.isDate(he))
      return he.toISOString();
    if (!w && dt.isBlob(he))
      throw new Fi("Blob is not supported. Use a Buffer instead.");
    return dt.isArrayBuffer(he) || dt.isTypedArray(he) ? w && typeof Blob == "function" ? new Blob([he]) : Buffer.from(he) : he;
  }
  function H(he, ne, ye) {
    let se = he;
    if (he && !ye && typeof he == "object") {
      if (dt.endsWith(ne, "{}"))
        ne = s ? ne : ne.slice(0, -2), he = JSON.stringify(he);
      else if (dt.isArray(he) && mb(he) || (dt.isFileList(he) || dt.endsWith(ne, "[]")) && (se = dt.toArray(he)))
        return ne = od(ne), se.forEach(function(ue, xe) {
          !(dt.isUndefined(ue) || ue === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            c === !0 ? mf([ne], xe, a) : c === null ? ne : ne + "[]",
            T(ue)
          );
        }), !1;
    }
    return Ph(he) ? !0 : (e.append(mf(ye, ne, a), T(he)), !1);
  }
  const Y = [], ee = Object.assign(vb, {
    defaultVisitor: H,
    convertValue: T,
    isVisitable: Ph
  });
  function z(he, ne) {
    if (!dt.isUndefined(he)) {
      if (Y.indexOf(he) !== -1)
        throw Error("Circular reference detected in " + ne.join("."));
      Y.push(he), dt.forEach(he, function(se, _e) {
        (!(dt.isUndefined(se) || se === null) && o.call(
          e,
          se,
          dt.isString(_e) ? _e.trim() : _e,
          ne,
          ee
        )) === !0 && z(se, ne ? ne.concat(_e) : [_e]);
      }), Y.pop();
    }
  }
  if (!dt.isObject(v))
    throw new TypeError("data must be an object");
  return z(v), e;
}
function vf(v) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(v).replace(/[!'()~]|%20|%00/g, function(s) {
    return e[s];
  });
}
function Kh(v, e) {
  this._pairs = [], v && Sl(v, this, e);
}
const ld = Kh.prototype;
ld.append = function(e, t) {
  this._pairs.push([e, t]);
};
ld.toString = function(e) {
  const t = e ? function(s) {
    return e.call(this, s, vf);
  } : vf;
  return this._pairs.map(function(o) {
    return t(o[0]) + "=" + t(o[1]);
  }, "").join("&");
};
function yb(v) {
  return encodeURIComponent(v).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function hd(v, e, t) {
  if (!e)
    return v;
  const s = t && t.encode || yb, o = t && t.serialize;
  let a;
  if (o ? a = o(e, t) : a = dt.isURLSearchParams(e) ? e.toString() : new Kh(e, t).toString(s), a) {
    const c = v.indexOf("#");
    c !== -1 && (v = v.slice(0, c)), v += (v.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return v;
}
class bb {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, t, s) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    dt.forEach(this.handlers, function(s) {
      s !== null && e(s);
    });
  }
}
const yf = bb, ud = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, xb = typeof URLSearchParams < "u" ? URLSearchParams : Kh, wb = typeof FormData < "u" ? FormData : null, Sb = typeof Blob < "u" ? Blob : null, Mb = {
  isBrowser: !0,
  classes: {
    URLSearchParams: xb,
    FormData: wb,
    Blob: Sb
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, cd = typeof window < "u" && typeof document < "u", Cb = ((v) => cd && ["ReactNative", "NativeScript", "NS"].indexOf(v) < 0)(typeof navigator < "u" && navigator.product), Ab = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Tb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: cd,
  hasStandardBrowserEnv: Cb,
  hasStandardBrowserWebWorkerEnv: Ab
}, Symbol.toStringTag, { value: "Module" })), mr = {
  ...Tb,
  ...Mb
};
function Lb(v, e) {
  return Sl(v, new mr.classes.URLSearchParams(), Object.assign({
    visitor: function(t, s, o, a) {
      return mr.isNode && dt.isBuffer(t) ? (this.append(s, t.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function Bb(v) {
  return dt.matchAll(/\w+|\[(\w*)]/g, v).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function Eb(v) {
  const e = {}, t = Object.keys(v);
  let s;
  const o = t.length;
  let a;
  for (s = 0; s < o; s++)
    a = t[s], e[a] = v[a];
  return e;
}
function fd(v) {
  function e(t, s, o, a) {
    let c = t[a++];
    if (c === "__proto__")
      return !0;
    const g = Number.isFinite(+c), w = a >= t.length;
    return c = !c && dt.isArray(o) ? o.length : c, w ? (dt.hasOwnProp(o, c) ? o[c] = [o[c], s] : o[c] = s, !g) : ((!o[c] || !dt.isObject(o[c])) && (o[c] = []), e(t, s, o[c], a) && dt.isArray(o[c]) && (o[c] = Eb(o[c])), !g);
  }
  if (dt.isFormData(v) && dt.isFunction(v.entries)) {
    const t = {};
    return dt.forEachEntry(v, (s, o) => {
      e(Bb(s), o, t, 0);
    }), t;
  }
  return null;
}
function Ob(v, e, t) {
  if (dt.isString(v))
    try {
      return (e || JSON.parse)(v), dt.trim(v);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (t || JSON.stringify)(v);
}
const Jh = {
  transitional: ud,
  adapter: ["xhr", "http"],
  transformRequest: [function(e, t) {
    const s = t.getContentType() || "", o = s.indexOf("application/json") > -1, a = dt.isObject(e);
    if (a && dt.isHTMLForm(e) && (e = new FormData(e)), dt.isFormData(e))
      return o ? JSON.stringify(fd(e)) : e;
    if (dt.isArrayBuffer(e) || dt.isBuffer(e) || dt.isStream(e) || dt.isFile(e) || dt.isBlob(e))
      return e;
    if (dt.isArrayBufferView(e))
      return e.buffer;
    if (dt.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let g;
    if (a) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return Lb(e, this.formSerializer).toString();
      if ((g = dt.isFileList(e)) || s.indexOf("multipart/form-data") > -1) {
        const w = this.env && this.env.FormData;
        return Sl(
          g ? { "files[]": e } : e,
          w && new w(),
          this.formSerializer
        );
      }
    }
    return a || o ? (t.setContentType("application/json", !1), Ob(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || Jh.transitional, s = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (e && dt.isString(e) && (s && !this.responseType || o)) {
      const c = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(e);
      } catch (g) {
        if (c)
          throw g.name === "SyntaxError" ? Fi.from(g, Fi.ERR_BAD_RESPONSE, this, null, this.response) : g;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: mr.classes.FormData,
    Blob: mr.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
dt.forEach(["delete", "get", "head", "post", "put", "patch"], (v) => {
  Jh.headers[v] = {};
});
const $h = Jh, Ib = dt.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), kb = (v) => {
  const e = {};
  let t, s, o;
  return v && v.split(`
`).forEach(function(c) {
    o = c.indexOf(":"), t = c.substring(0, o).trim().toLowerCase(), s = c.substring(o + 1).trim(), !(!t || e[t] && Ib[t]) && (t === "set-cookie" ? e[t] ? e[t].push(s) : e[t] = [s] : e[t] = e[t] ? e[t] + ", " + s : s);
  }), e;
}, bf = Symbol("internals");
function Ya(v) {
  return v && String(v).trim().toLowerCase();
}
function nl(v) {
  return v === !1 || v == null ? v : dt.isArray(v) ? v.map(nl) : String(v);
}
function Pb(v) {
  const e = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = t.exec(v); )
    e[s[1]] = s[2];
  return e;
}
const Nb = (v) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(v.trim());
function Sh(v, e, t, s, o) {
  if (dt.isFunction(s))
    return s.call(this, e, t);
  if (o && (e = t), !!dt.isString(e)) {
    if (dt.isString(s))
      return e.indexOf(s) !== -1;
    if (dt.isRegExp(s))
      return s.test(e);
  }
}
function Rb(v) {
  return v.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, s) => t.toUpperCase() + s);
}
function Db(v, e) {
  const t = dt.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(v, s + t, {
      value: function(o, a, c) {
        return this[s].call(this, e, o, a, c);
      },
      configurable: !0
    });
  });
}
class Ml {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, s) {
    const o = this;
    function a(g, w, T) {
      const H = Ya(w);
      if (!H)
        throw new Error("header name must be a non-empty string");
      const Y = dt.findKey(o, H);
      (!Y || o[Y] === void 0 || T === !0 || T === void 0 && o[Y] !== !1) && (o[Y || w] = nl(g));
    }
    const c = (g, w) => dt.forEach(g, (T, H) => a(T, H, w));
    return dt.isPlainObject(e) || e instanceof this.constructor ? c(e, t) : dt.isString(e) && (e = e.trim()) && !Nb(e) ? c(kb(e), t) : e != null && a(t, e, s), this;
  }
  get(e, t) {
    if (e = Ya(e), e) {
      const s = dt.findKey(this, e);
      if (s) {
        const o = this[s];
        if (!t)
          return o;
        if (t === !0)
          return Pb(o);
        if (dt.isFunction(t))
          return t.call(this, o, s);
        if (dt.isRegExp(t))
          return t.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = Ya(e), e) {
      const s = dt.findKey(this, e);
      return !!(s && this[s] !== void 0 && (!t || Sh(this, this[s], s, t)));
    }
    return !1;
  }
  delete(e, t) {
    const s = this;
    let o = !1;
    function a(c) {
      if (c = Ya(c), c) {
        const g = dt.findKey(s, c);
        g && (!t || Sh(s, s[g], g, t)) && (delete s[g], o = !0);
      }
    }
    return dt.isArray(e) ? e.forEach(a) : a(e), o;
  }
  clear(e) {
    const t = Object.keys(this);
    let s = t.length, o = !1;
    for (; s--; ) {
      const a = t[s];
      (!e || Sh(this, this[a], a, e, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(e) {
    const t = this, s = {};
    return dt.forEach(this, (o, a) => {
      const c = dt.findKey(s, a);
      if (c) {
        t[c] = nl(o), delete t[a];
        return;
      }
      const g = e ? Rb(a) : String(a).trim();
      g !== a && delete t[a], t[g] = nl(o), s[g] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return dt.forEach(this, (s, o) => {
      s != null && s !== !1 && (t[o] = e && dt.isArray(s) ? s.join(", ") : s);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const s = new this(e);
    return t.forEach((o) => s.set(o)), s;
  }
  static accessor(e) {
    const s = (this[bf] = this[bf] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(c) {
      const g = Ya(c);
      s[g] || (Db(o, c), s[g] = !0);
    }
    return dt.isArray(e) ? e.forEach(a) : a(e), this;
  }
}
Ml.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
dt.reduceDescriptors(Ml.prototype, ({ value: v }, e) => {
  let t = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => v,
    set(s) {
      this[t] = s;
    }
  };
});
dt.freezeMethods(Ml);
const Ir = Ml;
function Mh(v, e) {
  const t = this || $h, s = e || t, o = Ir.from(s.headers);
  let a = s.data;
  return dt.forEach(v, function(g) {
    a = g.call(t, a, o.normalize(), e ? e.status : void 0);
  }), o.normalize(), a;
}
function dd(v) {
  return !!(v && v.__CANCEL__);
}
function co(v, e, t) {
  Fi.call(this, v ?? "canceled", Fi.ERR_CANCELED, e, t), this.name = "CanceledError";
}
dt.inherits(co, Fi, {
  __CANCEL__: !0
});
function zb(v, e, t) {
  const s = t.config.validateStatus;
  !t.status || !s || s(t.status) ? v(t) : e(new Fi(
    "Request failed with status code " + t.status,
    [Fi.ERR_BAD_REQUEST, Fi.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
const Fb = mr.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(v, e, t, s, o, a) {
      const c = [v + "=" + encodeURIComponent(e)];
      dt.isNumber(t) && c.push("expires=" + new Date(t).toGMTString()), dt.isString(s) && c.push("path=" + s), dt.isString(o) && c.push("domain=" + o), a === !0 && c.push("secure"), document.cookie = c.join("; ");
    },
    read(v) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + v + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(v) {
      this.write(v, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Ub(v) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(v);
}
function Vb(v, e) {
  return e ? v.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : v;
}
function gd(v, e) {
  return v && !Ub(e) ? Vb(v, e) : e;
}
const Hb = mr.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let s;
    function o(a) {
      let c = a;
      return e && (t.setAttribute("href", c), c = t.href), t.setAttribute("href", c), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return s = o(window.location.href), function(c) {
      const g = dt.isString(c) ? o(c) : c;
      return g.protocol === s.protocol && g.host === s.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function Yb(v) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(v);
  return e && e[1] || "";
}
function Gb(v, e) {
  v = v || 10;
  const t = new Array(v), s = new Array(v);
  let o = 0, a = 0, c;
  return e = e !== void 0 ? e : 1e3, function(w) {
    const T = Date.now(), H = s[a];
    c || (c = T), t[o] = w, s[o] = T;
    let Y = a, ee = 0;
    for (; Y !== o; )
      ee += t[Y++], Y = Y % v;
    if (o = (o + 1) % v, o === a && (a = (a + 1) % v), T - c < e)
      return;
    const z = H && T - H;
    return z ? Math.round(ee * 1e3 / z) : void 0;
  };
}
function xf(v, e) {
  let t = 0;
  const s = Gb(50, 250);
  return (o) => {
    const a = o.loaded, c = o.lengthComputable ? o.total : void 0, g = a - t, w = s(g), T = a <= c;
    t = a;
    const H = {
      loaded: a,
      total: c,
      progress: c ? a / c : void 0,
      bytes: g,
      rate: w || void 0,
      estimated: w && c && T ? (c - a) / w : void 0,
      event: o
    };
    H[e ? "download" : "upload"] = !0, v(H);
  };
}
const jb = typeof XMLHttpRequest < "u", Wb = jb && function(v) {
  return new Promise(function(t, s) {
    let o = v.data;
    const a = Ir.from(v.headers).normalize();
    let { responseType: c, withXSRFToken: g } = v, w;
    function T() {
      v.cancelToken && v.cancelToken.unsubscribe(w), v.signal && v.signal.removeEventListener("abort", w);
    }
    let H;
    if (dt.isFormData(o)) {
      if (mr.hasStandardBrowserEnv || mr.hasStandardBrowserWebWorkerEnv)
        a.setContentType(!1);
      else if ((H = a.getContentType()) !== !1) {
        const [ne, ...ye] = H ? H.split(";").map((se) => se.trim()).filter(Boolean) : [];
        a.setContentType([ne || "multipart/form-data", ...ye].join("; "));
      }
    }
    let Y = new XMLHttpRequest();
    if (v.auth) {
      const ne = v.auth.username || "", ye = v.auth.password ? unescape(encodeURIComponent(v.auth.password)) : "";
      a.set("Authorization", "Basic " + btoa(ne + ":" + ye));
    }
    const ee = gd(v.baseURL, v.url);
    Y.open(v.method.toUpperCase(), hd(ee, v.params, v.paramsSerializer), !0), Y.timeout = v.timeout;
    function z() {
      if (!Y)
        return;
      const ne = Ir.from(
        "getAllResponseHeaders" in Y && Y.getAllResponseHeaders()
      ), se = {
        data: !c || c === "text" || c === "json" ? Y.responseText : Y.response,
        status: Y.status,
        statusText: Y.statusText,
        headers: ne,
        config: v,
        request: Y
      };
      zb(function(ue) {
        t(ue), T();
      }, function(ue) {
        s(ue), T();
      }, se), Y = null;
    }
    if ("onloadend" in Y ? Y.onloadend = z : Y.onreadystatechange = function() {
      !Y || Y.readyState !== 4 || Y.status === 0 && !(Y.responseURL && Y.responseURL.indexOf("file:") === 0) || setTimeout(z);
    }, Y.onabort = function() {
      Y && (s(new Fi("Request aborted", Fi.ECONNABORTED, v, Y)), Y = null);
    }, Y.onerror = function() {
      s(new Fi("Network Error", Fi.ERR_NETWORK, v, Y)), Y = null;
    }, Y.ontimeout = function() {
      let ye = v.timeout ? "timeout of " + v.timeout + "ms exceeded" : "timeout exceeded";
      const se = v.transitional || ud;
      v.timeoutErrorMessage && (ye = v.timeoutErrorMessage), s(new Fi(
        ye,
        se.clarifyTimeoutError ? Fi.ETIMEDOUT : Fi.ECONNABORTED,
        v,
        Y
      )), Y = null;
    }, mr.hasStandardBrowserEnv && (g && dt.isFunction(g) && (g = g(v)), g || g !== !1 && Hb(ee))) {
      const ne = v.xsrfHeaderName && v.xsrfCookieName && Fb.read(v.xsrfCookieName);
      ne && a.set(v.xsrfHeaderName, ne);
    }
    o === void 0 && a.setContentType(null), "setRequestHeader" in Y && dt.forEach(a.toJSON(), function(ye, se) {
      Y.setRequestHeader(se, ye);
    }), dt.isUndefined(v.withCredentials) || (Y.withCredentials = !!v.withCredentials), c && c !== "json" && (Y.responseType = v.responseType), typeof v.onDownloadProgress == "function" && Y.addEventListener("progress", xf(v.onDownloadProgress, !0)), typeof v.onUploadProgress == "function" && Y.upload && Y.upload.addEventListener("progress", xf(v.onUploadProgress)), (v.cancelToken || v.signal) && (w = (ne) => {
      Y && (s(!ne || ne.type ? new co(null, v, Y) : ne), Y.abort(), Y = null);
    }, v.cancelToken && v.cancelToken.subscribe(w), v.signal && (v.signal.aborted ? w() : v.signal.addEventListener("abort", w)));
    const he = Yb(ee);
    if (he && mr.protocols.indexOf(he) === -1) {
      s(new Fi("Unsupported protocol " + he + ":", Fi.ERR_BAD_REQUEST, v));
      return;
    }
    Y.send(o || null);
  });
}, Nh = {
  http: _b,
  xhr: Wb
};
dt.forEach(Nh, (v, e) => {
  if (v) {
    try {
      Object.defineProperty(v, "name", { value: e });
    } catch {
    }
    Object.defineProperty(v, "adapterName", { value: e });
  }
});
const wf = (v) => `- ${v}`, qb = (v) => dt.isFunction(v) || v === null || v === !1, pd = {
  getAdapter: (v) => {
    v = dt.isArray(v) ? v : [v];
    const { length: e } = v;
    let t, s;
    const o = {};
    for (let a = 0; a < e; a++) {
      t = v[a];
      let c;
      if (s = t, !qb(t) && (s = Nh[(c = String(t)).toLowerCase()], s === void 0))
        throw new Fi(`Unknown adapter '${c}'`);
      if (s)
        break;
      o[c || "#" + a] = s;
    }
    if (!s) {
      const a = Object.entries(o).map(
        ([g, w]) => `adapter ${g} ` + (w === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let c = e ? a.length > 1 ? `since :
` + a.map(wf).join(`
`) : " " + wf(a[0]) : "as no adapter specified";
      throw new Fi(
        "There is no suitable adapter to dispatch the request " + c,
        "ERR_NOT_SUPPORT"
      );
    }
    return s;
  },
  adapters: Nh
};
function Ch(v) {
  if (v.cancelToken && v.cancelToken.throwIfRequested(), v.signal && v.signal.aborted)
    throw new co(null, v);
}
function Sf(v) {
  return Ch(v), v.headers = Ir.from(v.headers), v.data = Mh.call(
    v,
    v.transformRequest
  ), ["post", "put", "patch"].indexOf(v.method) !== -1 && v.headers.setContentType("application/x-www-form-urlencoded", !1), pd.getAdapter(v.adapter || $h.adapter)(v).then(function(s) {
    return Ch(v), s.data = Mh.call(
      v,
      v.transformResponse,
      s
    ), s.headers = Ir.from(s.headers), s;
  }, function(s) {
    return dd(s) || (Ch(v), s && s.response && (s.response.data = Mh.call(
      v,
      v.transformResponse,
      s.response
    ), s.response.headers = Ir.from(s.response.headers))), Promise.reject(s);
  });
}
const Mf = (v) => v instanceof Ir ? { ...v } : v;
function Aa(v, e) {
  e = e || {};
  const t = {};
  function s(T, H, Y) {
    return dt.isPlainObject(T) && dt.isPlainObject(H) ? dt.merge.call({ caseless: Y }, T, H) : dt.isPlainObject(H) ? dt.merge({}, H) : dt.isArray(H) ? H.slice() : H;
  }
  function o(T, H, Y) {
    if (dt.isUndefined(H)) {
      if (!dt.isUndefined(T))
        return s(void 0, T, Y);
    } else
      return s(T, H, Y);
  }
  function a(T, H) {
    if (!dt.isUndefined(H))
      return s(void 0, H);
  }
  function c(T, H) {
    if (dt.isUndefined(H)) {
      if (!dt.isUndefined(T))
        return s(void 0, T);
    } else
      return s(void 0, H);
  }
  function g(T, H, Y) {
    if (Y in e)
      return s(T, H);
    if (Y in v)
      return s(void 0, T);
  }
  const w = {
    url: a,
    method: a,
    data: a,
    baseURL: c,
    transformRequest: c,
    transformResponse: c,
    paramsSerializer: c,
    timeout: c,
    timeoutMessage: c,
    withCredentials: c,
    withXSRFToken: c,
    adapter: c,
    responseType: c,
    xsrfCookieName: c,
    xsrfHeaderName: c,
    onUploadProgress: c,
    onDownloadProgress: c,
    decompress: c,
    maxContentLength: c,
    maxBodyLength: c,
    beforeRedirect: c,
    transport: c,
    httpAgent: c,
    httpsAgent: c,
    cancelToken: c,
    socketPath: c,
    responseEncoding: c,
    validateStatus: g,
    headers: (T, H) => o(Mf(T), Mf(H), !0)
  };
  return dt.forEach(Object.keys(Object.assign({}, v, e)), function(H) {
    const Y = w[H] || o, ee = Y(v[H], e[H], H);
    dt.isUndefined(ee) && Y !== g || (t[H] = ee);
  }), t;
}
const _d = "1.6.8", Qh = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((v, e) => {
  Qh[v] = function(s) {
    return typeof s === v || "a" + (e < 1 ? "n " : " ") + v;
  };
});
const Cf = {};
Qh.transitional = function(e, t, s) {
  function o(a, c) {
    return "[Axios v" + _d + "] Transitional option '" + a + "'" + c + (s ? ". " + s : "");
  }
  return (a, c, g) => {
    if (e === !1)
      throw new Fi(
        o(c, " has been removed" + (t ? " in " + t : "")),
        Fi.ERR_DEPRECATED
      );
    return t && !Cf[c] && (Cf[c] = !0, console.warn(
      o(
        c,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(a, c, g) : !0;
  };
};
function Zb(v, e, t) {
  if (typeof v != "object")
    throw new Fi("options must be an object", Fi.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(v);
  let o = s.length;
  for (; o-- > 0; ) {
    const a = s[o], c = e[a];
    if (c) {
      const g = v[a], w = g === void 0 || c(g, a, v);
      if (w !== !0)
        throw new Fi("option " + a + " must be " + w, Fi.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new Fi("Unknown option " + a, Fi.ERR_BAD_OPTION);
  }
}
const Rh = {
  assertOptions: Zb,
  validators: Qh
}, Vr = Rh.validators;
class fl {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new yf(),
      response: new yf()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (s) {
      if (s instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const a = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        s.stack ? a && !String(s.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + a) : s.stack = a;
      }
      throw s;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = Aa(this.defaults, t);
    const { transitional: s, paramsSerializer: o, headers: a } = t;
    s !== void 0 && Rh.assertOptions(s, {
      silentJSONParsing: Vr.transitional(Vr.boolean),
      forcedJSONParsing: Vr.transitional(Vr.boolean),
      clarifyTimeoutError: Vr.transitional(Vr.boolean)
    }, !1), o != null && (dt.isFunction(o) ? t.paramsSerializer = {
      serialize: o
    } : Rh.assertOptions(o, {
      encode: Vr.function,
      serialize: Vr.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let c = a && dt.merge(
      a.common,
      a[t.method]
    );
    a && dt.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (he) => {
        delete a[he];
      }
    ), t.headers = Ir.concat(c, a);
    const g = [];
    let w = !0;
    this.interceptors.request.forEach(function(ne) {
      typeof ne.runWhen == "function" && ne.runWhen(t) === !1 || (w = w && ne.synchronous, g.unshift(ne.fulfilled, ne.rejected));
    });
    const T = [];
    this.interceptors.response.forEach(function(ne) {
      T.push(ne.fulfilled, ne.rejected);
    });
    let H, Y = 0, ee;
    if (!w) {
      const he = [Sf.bind(this), void 0];
      for (he.unshift.apply(he, g), he.push.apply(he, T), ee = he.length, H = Promise.resolve(t); Y < ee; )
        H = H.then(he[Y++], he[Y++]);
      return H;
    }
    ee = g.length;
    let z = t;
    for (Y = 0; Y < ee; ) {
      const he = g[Y++], ne = g[Y++];
      try {
        z = he(z);
      } catch (ye) {
        ne.call(this, ye);
        break;
      }
    }
    try {
      H = Sf.call(this, z);
    } catch (he) {
      return Promise.reject(he);
    }
    for (Y = 0, ee = T.length; Y < ee; )
      H = H.then(T[Y++], T[Y++]);
    return H;
  }
  getUri(e) {
    e = Aa(this.defaults, e);
    const t = gd(e.baseURL, e.url);
    return hd(t, e.params, e.paramsSerializer);
  }
}
dt.forEach(["delete", "get", "head", "options"], function(e) {
  fl.prototype[e] = function(t, s) {
    return this.request(Aa(s || {}, {
      method: e,
      url: t,
      data: (s || {}).data
    }));
  };
});
dt.forEach(["post", "put", "patch"], function(e) {
  function t(s) {
    return function(a, c, g) {
      return this.request(Aa(g || {}, {
        method: e,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: c
      }));
    };
  }
  fl.prototype[e] = t(), fl.prototype[e + "Form"] = t(!0);
});
const sl = fl;
class eu {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(a) {
      t = a;
    });
    const s = this;
    this.promise.then((o) => {
      if (!s._listeners)
        return;
      let a = s._listeners.length;
      for (; a-- > 0; )
        s._listeners[a](o);
      s._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const c = new Promise((g) => {
        s.subscribe(g), a = g;
      }).then(o);
      return c.cancel = function() {
        s.unsubscribe(a);
      }, c;
    }, e(function(a, c, g) {
      s.reason || (s.reason = new co(a, c, g), t(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new eu(function(o) {
        e = o;
      }),
      cancel: e
    };
  }
}
const Xb = eu;
function Kb(v) {
  return function(t) {
    return v.apply(null, t);
  };
}
function Jb(v) {
  return dt.isObject(v) && v.isAxiosError === !0;
}
const Dh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Dh).forEach(([v, e]) => {
  Dh[e] = v;
});
const $b = Dh;
function md(v) {
  const e = new sl(v), t = Jf(sl.prototype.request, e);
  return dt.extend(t, sl.prototype, e, { allOwnKeys: !0 }), dt.extend(t, e, null, { allOwnKeys: !0 }), t.create = function(o) {
    return md(Aa(v, o));
  }, t;
}
const In = md($h);
In.Axios = sl;
In.CanceledError = co;
In.CancelToken = Xb;
In.isCancel = dd;
In.VERSION = _d;
In.toFormData = Sl;
In.AxiosError = Fi;
In.Cancel = In.CanceledError;
In.all = function(e) {
  return Promise.all(e);
};
In.spread = Kb;
In.isAxiosError = Jb;
In.mergeConfig = Aa;
In.AxiosHeaders = Ir;
In.formToJSON = (v) => fd(dt.isHTMLForm(v) ? new FormData(v) : v);
In.getAdapter = pd.getAdapter;
In.HttpStatusCode = $b;
In.default = In;
const Af = In;
var Ga = globalThis && globalThis.__awaiter || function(v, e, t, s) {
  function o(a) {
    return a instanceof t ? a : new t(function(c) {
      c(a);
    });
  }
  return new (t || (t = Promise))(function(a, c) {
    function g(H) {
      try {
        T(s.next(H));
      } catch (Y) {
        c(Y);
      }
    }
    function w(H) {
      try {
        T(s.throw(H));
      } catch (Y) {
        c(Y);
      }
    }
    function T(H) {
      H.done ? a(H.value) : o(H.value).then(g, w);
    }
    T((s = s.apply(v, e || [])).next());
  });
}, ja = globalThis && globalThis.__generator || function(v, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, s, o, a, c;
  return c = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function g(T) {
    return function(H) {
      return w([T, H]);
    };
  }
  function w(T) {
    if (s)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (s = 1, o && (a = T[0] & 2 ? o.return : T[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, T[1])).done)
          return a;
        switch (o = 0, a && (T = [T[0] & 2, a.value]), T[0]) {
          case 0:
          case 1:
            a = T;
            break;
          case 4:
            return t.label++, { value: T[1], done: !1 };
          case 5:
            t.label++, o = T[1], T = [0];
            continue;
          case 7:
            T = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (T[0] === 6 || T[0] === 2)) {
              t = 0;
              continue;
            }
            if (T[0] === 3 && (!a || T[1] > a[0] && T[1] < a[3])) {
              t.label = T[1];
              break;
            }
            if (T[0] === 6 && t.label < a[1]) {
              t.label = a[1], a = T;
              break;
            }
            if (a && t.label < a[2]) {
              t.label = a[2], t.ops.push(T);
              break;
            }
            a[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        T = e.call(v, t);
      } catch (H) {
        T = [6, H], o = 0;
      } finally {
        s = a = 0;
      }
    if (T[0] & 5)
      throw T[1];
    return { value: T[0] ? T[1] : void 0, done: !0 };
  }
}, Tf = (
  /** @class */
  function() {
    function v(e, t, s) {
      var o = this;
      s === void 0 && (s = !0), this.tasksUrl = e, this.token = t, this.upload = function(a, c) {
        return Ga(o, void 0, void 0, function() {
          return ja(this, function(g) {
            switch (g.label) {
              case 0:
                return [4, this.uploadFileChunked(a, a.type, Zakeke.generateUUID(), c)];
              case 1:
                return [2, g.sent()];
            }
          });
        });
      }, this.uploadFileChunked = function(a, c, g, w, T) {
        return Ga(o, void 0, void 0, function() {
          var H, Y, ee;
          return ja(this, function(z) {
            switch (z.label) {
              case 0:
                return [4, this.resumableUpload(a, c, g, T)];
              case 1:
                return H = z.sent(), H !== "OK" ? [3, 5] : [4, this.createTask(g, w)];
              case 2:
                return Y = z.sent(), Y === -1 ? [3, 4] : [4, this.getResultFromTask(Y)];
              case 3:
                return ee = z.sent(), ee ? [2, ee.files] : [3, 5];
              case 4:
                throw "Upload failed";
              case 5:
                return [2, null];
            }
          });
        });
      }, this.resumableUpload = function(a, c, g, w) {
        return Ga(o, void 0, void 0, function() {
          var T = this;
          return ja(this, function(H) {
            return [2, new Promise(function(Y, ee) {
              var z = new Resumable({
                target: Zakeke.config.baseApiUrl + "filechunks/upload",
                generateUniqueIdentifier: function() {
                  return g;
                },
                maxFiles: 1,
                testChunks: !1,
                headers: T.headers,
                query: { resumableType: c },
                simultaneousUploads: 3
              });
              z.addFile(a), z.on("fileError", function(he, ne) {
                Y("KO"), console.error("fileError", he, ne);
              }), z.on("error", function(he, ne) {
                Y("KO"), console.error("error", he, ne);
              }), z.on("progress", function() {
                var he = z.progress() * 100;
                w && w(he);
              }), z.on("fileAdded", function(he, ne) {
                z.upload();
              }), z.on("complete", function() {
                Y("OK");
              });
            })];
          });
        });
      }, this.createTask = function(a, c) {
        return Ga(o, void 0, void 0, function() {
          var g, w;
          return ja(this, function(T) {
            switch (T.label) {
              case 0:
                return g = { fileID: a, options: c }, [4, Af.post(Zakeke.config.baseApiUrl + this.tasksUrl, g, { headers: this.headers })];
              case 1:
                return w = T.sent(), [2, w ? w.data.taskID : -1];
            }
          });
        });
      }, this.getResultFromTask = function(a) {
        return Ga(o, void 0, void 0, function() {
          var c, g;
          return ja(this, function(w) {
            switch (w.label) {
              case 0:
                c = 0, w.label = 1;
              case 1:
                return w.trys.push([1, 3, , 4]), [4, Af.get(Zakeke.config.baseApiUrl + this.tasksUrl + "/results/" + a, { headers: this.headers })];
              case 2:
                return g = w.sent(), g && g.data.state === 2 ? [2, g.data] : g && g.data.state === 3 ? [2, null] : [3, 4];
              case 3:
                return w.sent(), [2, null];
              case 4:
                return c++, c > 100 ? [2, null] : [4, new Promise(function(T) {
                  return setTimeout(T, 1e3);
                })];
              case 5:
                w.sent(), w.label = 6;
              case 6:
                return [3, 1];
              case 7:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, s ? this.headers = {
        Authorization: "Bearer " + this.token,
        "Accept-Language": "en-US"
      } : this.headers = {
        "X-Auth-Token": this.token,
        "Accept-Language": "en-US"
      };
    }
    return v;
  }()
);
class Wt {
}
Wt.Environment = {
  //EnvironmentTextureName: "environmentSpecular.dds",
  EnvironmentTextureName: "environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env",
  GroundTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/backgroundGround9.png",
  SkyboxTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/backgroundSkybox.dds",
  //EnvironmentTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/environmentSpecular.dds"
  //EnvironmentTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/environmentSpecular.dds"
  EnvironmentTextureCDNUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/environments/environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env"
};
Wt.TryonReferences = {
  RootUrl: "https://cdn.zakeke.com/cdn/3d/assets/tryon/references/",
  ReferenceGlassesFrameName: "Reference Glasses Frame",
  ReferenceGlassesFrameFileName: "Reference_Glasses_Frame_001.json",
  EyewearName: "glasses_VTO_Reference",
  EyewearURL: "Eyewear_VTO_Reference.babylon",
  EyewearDownloadableURL: "Eyewear_VTO_Reference.glb",
  ScarvesName: "scarves_VTO_Reference",
  ScarvesURL: "Scarves_VTO_Reference.babylon",
  ScarvesDownloadableURL: "Scarves_VTO_Reference.glb",
  EarringsName: "earrings_VTO_Reference",
  EarringsURL: "Earrings_VTO_Reference.babylon",
  EarringsDownloadableURL: "Earrings_VTO_Reference.glb",
  HeadwearName: "headwear_VTO_Reference",
  HeadwearURL: "Headwear_VTO_Reference.babylon",
  HeadwearDownloadableURL: "Headwear_VTO_Reference.glb",
  NecklaceName: "necklace_VTO_Reference",
  NecklaceURL: "Necklace_VTO_Reference.babylon",
  NecklaceDownloadableURL: "Necklace_VTO_Reference.glb",
  ShoeName: "foot_VTO_Reference",
  ShoeURL: "Foot_VTO_Reference.babylon",
  ShoeDownloadableURL: "Foot_VTO_Reference.glb"
};
Wt.Shapes = {
  RootUrl: "https://cdn.zakeke.com/cdn/3d/assets/shapes/",
  RoundedCubeName: "Rounded Cube",
  RoundedCubeFileName: "rounded_cube.babylon",
  RoundedCylinderName: "Rounded Cylinder",
  RoundedCylinderFileName: "rounded_cylinder.babylon",
  MatBallName: "Mat Ball",
  MatBallFileName: "mat_ball.babylon",
  MaleHeadName: "Group48944",
  MaleHeadFileName: "DemoHead.babylon",
  FemaleHeadName: "Group12208",
  FemaleHeadFileName: "FemaleHead.babylon",
  PokemonBallName: "PokemonBall",
  PokemonBallFileName: "PokemonBall.babylon",
  ShaderBallName: "Elements",
  ShaderBallFileName: "ShaderBall.babylon",
  BootsFolder: "boots/",
  BootsName: "shoe",
  BootsFileName: "boots.incremental.babylon",
  SuzanneName: "Suzanne",
  SuzanneFileName: "suzanne.babylon",
  StepPyramidName: "Pyramid",
  StepPyramidFileName: "step-pyramid.babylon",
  TeapotName: "Teapot",
  TeapotFileName: "teapot.babylon",
  AlloyWheelName: "Wheel",
  AlloyWheelFolder: "alloy_wheel/",
  AlloyWheelFileName: "alloy_wheel.incremental.babylon"
};
class gr {
  /**
   * Checks for a matching suffix at the end of a string (for ES5 and lower)
   * @param str Source string
   * @param suffix Suffix to search for in the source string
   * @returns Boolean indicating whether the suffix was found (true) or not (false)
   */
  static EndsWith(e, t) {
    return e.indexOf(t, e.length - t.length) !== -1;
  }
  /**
   * Checks for a matching suffix at the beginning of a string (for ES5 and lower)
   * @param str Source string
   * @param suffix Suffix to search for in the source string
   * @returns Boolean indicating whether the suffix was found (true) or not (false)
   */
  static StartsWith(e, t) {
    return e.indexOf(t) === 0;
  }
  /**
   * Decodes a buffer into a string
   * @param buffer The buffer to decode
   * @returns The decoded string
   */
  static Decode(e) {
    if (typeof TextDecoder < "u")
      return new TextDecoder().decode(e);
    let t = "";
    for (let s = 0; s < e.byteLength; s++)
      t += String.fromCharCode(e[s]);
    return t;
  }
  /**
   * Encode a buffer to a base64 string
   * @param buffer defines the buffer to encode
   * @returns the encoded string
   */
  static EncodeArrayBufferToBase64(e) {
    for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", s = "", o, a, c, g, w, T, H, Y = 0, ee = ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : new Uint8Array(e); Y < ee.length; )
      o = ee[Y++], a = Y < ee.length ? ee[Y++] : Number.NaN, c = Y < ee.length ? ee[Y++] : Number.NaN, g = o >> 2, w = (o & 3) << 4 | a >> 4, T = (a & 15) << 2 | c >> 6, H = c & 63, isNaN(a) ? T = H = 64 : isNaN(c) && (H = 64), s += t.charAt(g) + t.charAt(w) + t.charAt(T) + t.charAt(H);
    return s;
  }
}
class Qb {
  constructor() {
    this._mesh = null, this._scene = null, this._facesOfVertices = null, this._meshVerticesPositions = null, this._meshVerticesNormals = null, this._meshIndices = null, this._meshPositions = null, this._meshFacesNormals = null, this._sharedFacesOfVertices = {};
  }
  dispose() {
  }
  resetDataModel() {
    this._facesOfVertices = null, this._meshVerticesPositions = null, this._meshVerticesNormals = null, this._meshIndices = null, this._meshPositions = null, this._meshFacesNormals = null, this._sharedFacesOfVertices = {};
  }
  prepareDataModel() {
    if (this.resetDataModel(), this._mesh && this._scene && (this._facesOfVertices = [], this._sharedFacesOfVertices = {}, this._meshVerticesPositions = this._mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind), this._meshVerticesNormals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), this._meshIndices = this._mesh.getIndices(), this._meshPositions = [], this._meshFacesNormals = [], this._meshVerticesPositions && this._meshVerticesNormals && this._meshIndices)) {
      for (let e = 0; e < this._meshVerticesPositions.length; e += 3)
        this._meshPositions.push(new BABYLON.Vector3(this._meshVerticesPositions[e], this._meshVerticesPositions[e + 1], this._meshVerticesPositions[e + 2]));
      for (let e = 0; e < this._mesh.getTotalIndices() / 3; e++)
        this._computeFaceNormal(e);
      this._getFacesOfVertices();
    }
  }
  _getFaceVerticesIndex(e) {
    return this._meshIndices ? {
      v1: this._meshIndices[e * 3],
      v2: this._meshIndices[e * 3 + 1],
      v3: this._meshIndices[e * 3 + 2]
    } : null;
  }
  // La normale ad una faccia è calcolata come prodotto vettoriale (cross product)
  // tra i vettori che connettono gli spigoli
  _computeFaceNormal(e) {
    if (this._meshPositions && this._meshIndices && this._meshFacesNormals) {
      const t = this._getFaceVerticesIndex(e);
      if (t) {
        const s = this._meshPositions[t.v1].subtract(this._meshPositions[t.v2]), o = this._meshPositions[t.v3].subtract(this._meshPositions[t.v2]);
        this._meshFacesNormals[e] = BABYLON.Vector3.Normalize(BABYLON.Vector3.Cross(s, o));
      }
    }
  }
  _getPositionKey(e) {
    return `${e.x}_${e.y}_${e.z}`;
  }
  // Determina le facce di ogni vertice sia considerando vertici uguali ripetuti più volte (_facesOfVertices)
  // che quelle condivise da uno stesso vertice ripetuto (_sharedFacesOfVertices). Queste ultime saranno
  // quelle che verranno considerate per il calcolo della normale risultante da tutte le facce che hanno
  // un vertice come spigolo.
  _getFacesOfVertices() {
    if (this._mesh && this._meshPositions && this._meshIndices) {
      this._sharedFacesOfVertices = {}, this._facesOfVertices = [];
      for (let e = 0; e < this._meshPositions.length; e++) {
        this._facesOfVertices[e] = [];
        const t = this._meshPositions[e], s = this._getPositionKey(t);
        this._sharedFacesOfVertices.hasOwnProperty(s) || (this._sharedFacesOfVertices[s] = /* @__PURE__ */ new Set());
      }
      for (let e = 0; e < this._meshIndices.length; e++) {
        const t = this._meshIndices[e], s = e / 3 | 0;
        this._facesOfVertices[t].push(s);
        const o = this._meshPositions[t], a = this._getPositionKey(o);
        this._sharedFacesOfVertices.hasOwnProperty(a) && this._sharedFacesOfVertices[a].add(s);
      }
    }
  }
  expandMesh(e, t = 0.01) {
    if (e instanceof BABYLON.Mesh && (this._mesh = e, this._scene = e.getScene(), this.prepareDataModel(), this._meshPositions && this._meshVerticesPositions && this._meshVerticesNormals)) {
      for (let s = 0; s < this._meshPositions.length; s++) {
        const o = this._meshPositions[s], a = this._getVertexComputedNormal(s);
        if (a) {
          const c = a.scale(t);
          o.addInPlace(c), this._meshVerticesPositions[s * 3] = o.x, this._meshVerticesPositions[s * 3 + 1] = o.y, this._meshVerticesPositions[s * 3 + 2] = o.z;
        }
      }
      this._mesh.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.PositionKind, !0), this._mesh.updateVerticesData(BABYLON.VertexBuffer.PositionKind, this._meshVerticesPositions), this._mesh.computeWorldMatrix(!0);
    }
  }
  _reComputeNormals() {
    const e = [];
    if (this._meshPositions && this._facesOfVertices) {
      for (let s = 0; s < this._meshPositions.length; s++) {
        const o = this._facesOfVertices[s];
        for (let a = 0; a < o.length; a++)
          e[o[a]] = !0;
      }
      let t;
      for (t in e)
        this._computeFaceNormal(t);
      for (t in e) {
        const s = this._getFaceVerticesIndex(t);
        s && (this._computeNormal(s.v1), this._computeNormal(s.v2), this._computeNormal(s.v3));
      }
    }
  }
  _getVertexComputedNormal(e) {
    let t = null;
    if (this._meshPositions && this._meshFacesNormals) {
      const s = this._meshPositions, o = this._meshFacesNormals, a = s[e], c = this._getPositionKey(a);
      if (this._sharedFacesOfVertices.hasOwnProperty(c)) {
        const g = this._sharedFacesOfVertices[c];
        t = BABYLON.Vector3.Zero(), g.forEach((w) => {
          const T = o[w];
          t && T && (t = t.add(T));
        }), t = BABYLON.Vector3.Normalize(t.scale(1 / g.size));
      }
    }
    return t;
  }
  _computeNormal(e) {
    const t = this._getVertexComputedNormal(e);
    t && this._meshVerticesNormals && (this._meshVerticesNormals[e * 3] = t.x, this._meshVerticesNormals[e * 3 + 1] = t.y, this._meshVerticesNormals[e * 3 + 2] = t.z);
  }
}
class ex {
  static async convertGlbToUsdz(e) {
    return new Promise((t, s) => {
      let o = null;
      new THREE.GLTFLoader().load(e, async function(c) {
        c.scene.updateWorldMatrix(!0, !0);
        const w = await new THREE.USDZExporter().parse(c.scene);
        o = new Blob([w], { type: "model/vnd.usdz+zip" }), t(o);
      });
    });
  }
}
const vd = class hn {
  constructor(e) {
    this._hemiLight = null, this._pointLight = null, this._onPrePointerObservableObserver = null, this._isPointerDown = !1, this._radiusScale = 0.85, this._positionScale = 0.5, this._limitLowerRadius = !0, this._zoomEnabled = !0, this._minZoomPerc = null, this._maxZoomPerc = null, this._cameraZoom = null, this._cameraPivot = null, this._resizableCanvas3DGenerator = new Ny(), this.parentNode = null, this.enableShadows = !1, this.areShadowVisible = !0, this.setInitialZoomToBoundingBox = !0, this.changeRotationDirection = !1, this.initialZoomToBBInertiaDamping = 0.68, this._initialZoomToBBModelSizeRadius = 0.7, this.initialZoomToBBScrollZoomEnabled = !0, this.initialZoomToBBScrollLowerLimit = 2, this.initialZoomToBBScrollUpperLimit = 2, this.animateIntro = !1, this._defHemiLightID = "f90aba65-3b60-44ac-87f4-1b6441aee44b", this._defPointLightID = "b6491635-c471-45a4-bbb8-3f08556e5b3c", this._targetAnimationID = "6225769c-0113-4236-ab17-c39d24013de4", this._radiusAnimationID = "6f946c2f-af8d-46ab-9bea-9e22dedc4e9d", this._alphaAnimationID = "10713520-fe06-4cbf-bc6a-bab881d516e6", this._betaAnimationID = "6096ba34-852a-4423-bab3-dc97c1a9268f", this._dummyMaterialID = "081796b8-0908-44dc-a38a-d786b14cA6fc", this._loadingMaterials = {}, this.getVTOMeshes = () => {
      const t = [
        "vto_reference",
        "ground",
        "shadowGround",
        "shadow",
        "skybox",
        "environment",
        "axes",
        "grid",
        "boundingbox",
        "highlight",
        "EditControl",
        "guideCtl",
        "bxAxis",
        "byAxis",
        "bzAxis",
        "xAxis",
        "yAxis",
        "zAxis",
        "pALL",
        "pXZ",
        "pZY",
        "pYX",
        "pickPlanes",
        "tarnsCtl",
        "X",
        "Y",
        "Z",
        "XZ",
        "ZY",
        "YX",
        "ALL",
        "tEndX",
        "tEndY",
        "tEndZ",
        "XZ",
        "ZY",
        "YX",
        "tEndAll"
      ], s = (g) => t.filter((w) => g.toLowerCase() === w.toLowerCase()).length > 0, o = (g) => g.toLowerCase().includes("vto_reference"), a = this._scene.meshes.filter((g) => o(g.name)), c = this._scene.meshes.filter((g) => !s(g.name) && !o(g.name));
      return {
        tryonReferencesModels: a,
        userMeshes: c
      };
    }, this._loadedMeshes = [], this._isLoading = !1, this._lastVisibilityStates = /* @__PURE__ */ new Map(), this._scene = e, this._engine = e.getEngine(), this._camera = e.activeCamera, this._canvas = e.getEngine().getRenderingCanvas(), this.init();
  }
  get initialZoomToBBModelSizeRadius() {
    return console.log("Getting initialZoomToBBModelSizeRadius: ", this._initialZoomToBBModelSizeRadius), this._initialZoomToBBModelSizeRadius;
  }
  set initialZoomToBBModelSizeRadius(e) {
    console.log("Setting initialZoomToBBModelSizeRadius to: ", e), this._initialZoomToBBModelSizeRadius = e;
  }
  get camera() {
    return this._camera;
  }
  static checkAllMaterialTextureReady(e) {
    const t = e.getActiveTextures();
    for (let s = 0; s < t.length; s++) {
      const o = t[s];
      if (o.isReady())
        o instanceof BABYLON.ProceduralTexture && o.getEffect();
      else
        return !1;
    }
    return !0;
  }
  removeDefaultBackground(e) {
    e && (this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0));
  }
  setUpSceneToneMapping(e) {
    var c, g, w, T;
    const t = (c = e == null ? void 0 : e.getCameraConfig()) == null ? void 0 : c.get("toneMappingEnabled");
    t != null && (this._scene.imageProcessingConfiguration.toneMappingEnabled = t);
    const s = (g = e == null ? void 0 : e.getCameraConfig()) == null ? void 0 : g.get("toneMappingType");
    s != null && (this._scene.imageProcessingConfiguration.toneMappingType = s);
    const o = (w = e == null ? void 0 : e.getGeneralConfig()) == null ? void 0 : w.get("exposure"), a = (T = e == null ? void 0 : e.getGeneralConfig()) == null ? void 0 : T.get("contrast");
    a && (this._scene.imageProcessingConfiguration.contrast = a), o && (this._scene.imageProcessingConfiguration.exposure = o);
  }
  static whenAllMaterialTexturesAreReady(e) {
    return new Promise((t, s) => {
      if (this.checkAllMaterialTextureReady(e))
        t();
      else {
        let o = setInterval(() => {
          this.checkAllMaterialTextureReady(e) && (clearInterval(o), t());
        }, 5);
      }
    });
  }
  static whenTextureIsReadyAsync(e) {
    return new Promise((t, s) => {
      if (e.isReady())
        t();
      else {
        let o = setInterval(() => {
          e.isReady() && (clearInterval(o), e instanceof BABYLON.ProceduralTexture && e.getEffect(), t());
        }, 5);
      }
    });
  }
  static whenMeshMaterialIsReady(e) {
    return new Promise((t, s) => {
      let o = setInterval(() => {
        (!e.material || e.material.isReady(e)) && (clearInterval(o), t());
      }, 5);
    });
  }
  static whenMaterialIsReadyForSubMeshAsync(e, t, s) {
    return new Promise((o, a) => {
      if (e.isReadyForSubMesh(t, s))
        Logger.info(`Material ${e.name} ready`), o();
      else {
        Logger.info(`Material ${e.name} NOT ready`);
        let c = setInterval(() => {
          e.isReadyForSubMesh(t, s) && (!t.material || t.material != e || t.material.isReady(t)) && (Logger.info(`Material ${e.name} ready`), clearInterval(c), o());
        }, 5);
      }
    });
  }
  static getMeshGeometry(e) {
    if (e.geometry)
      return e.geometry;
    const s = e.getScene().getGeometries();
    for (let o = 0; o < s.length; o++) {
      const a = s[o];
      if (a.meshes.find((c) => c === e))
        return a;
    }
    return null;
  }
  static checkMeshIsReady(e) {
    if (e instanceof BABYLON.Mesh) {
      if (e._checkDelayState(), e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED)
        return !1;
      if (!e.geometry) {
        const s = e.getScene().getGeometries();
        for (let o = 0; o < s.length; o++) {
          const a = s[o];
          if (a.meshes.find((c) => c === e) && !a.isReady())
            return !1;
        }
      }
      if (e.geometry && !e.geometry.isReady())
        return !1;
      for (let t = 0; t < e.getChildMeshes().length; t++) {
        const s = e.getChildMeshes()[t];
        if (!this.checkMeshIsReady(s))
          return !1;
      }
    }
    return e.isReady(!0);
  }
  static checkAllMeshesAreReady(e) {
    let t = !0;
    for (let s = 0; s < e.length; s++)
      this.checkMeshIsReady(e[s]) || (t = !1);
    return t;
  }
  static whenAllMeshesAreReadyAsync(e) {
    return new Promise((t, s) => {
      if (this.checkAllMeshesAreReady(e))
        t();
      else {
        let o = setInterval(() => {
          this.checkAllMeshesAreReady(e) && (clearInterval(o), t());
        }, 5);
      }
    });
  }
  static async whenAllVisibleMeshesAreReadyAsync(e) {
    await this.whenAllMeshesAreReadyAsync(e);
  }
  static whenMeshIsReadyAsync(e) {
    return new Promise((t, s) => {
      if (this.checkMeshIsReady(e))
        t();
      else {
        let o = setInterval(() => {
          this.checkMeshIsReady(e) && (clearInterval(o), t());
        }, 100);
      }
    });
  }
  static visibleMeshesRequireDelayedLoading(e) {
    const t = e.meshes.filter((s) => s.isVisible);
    for (let s = 0; s < t.length; s++)
      if (this.meshRequiresDelayedLoading(t[s]))
        return !0;
    return !1;
  }
  static meshRequiresDelayedLoading(e) {
    if (e instanceof BABYLON.Mesh) {
      if (e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED || e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING)
        return !0;
      const t = hn.getMeshGeometry(e);
      if (t && (t.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING || t.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED))
        return !0;
    }
    return !1;
  }
  materialRequiresDelayedLoading(e) {
    return this._scene.getMaterialByID(e) ? !1 : !!(this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(e) || this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(e));
  }
  init() {
    this._onPrePointerObservableObserver = this._scene.onPrePointerObservable.add((e) => {
      if (e.type === BABYLON.PointerEventTypes.POINTERDOWN) {
        this._isPointerDown = !0;
        return;
      }
      e.type === BABYLON.PointerEventTypes.POINTERUP && (this._isPointerDown = !1);
    });
  }
  dispose() {
    this._scene && this._onPrePointerObservableObserver && this._scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver);
  }
  switchFullScreen(e) {
    document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement ? this.quitFullscreen(e || this._canvas) : this.launchFullscreen(e || this._canvas), this._canvas && (this._canvas.width = document.body.clientWidth, this._canvas.height = document.body.clientHeight, this.adjustCamera(void 0, !0, !0, !1));
  }
  quitFullscreen(e) {
    let t = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen;
    t && t.call(document);
  }
  launchFullscreen(e) {
    let t = e.requestFullscreen || e.webkitRequestFullscreen || e.msRequestFullscreen || e.mozRequestFullScreen;
    t && t.call(e);
  }
  getMeshHierarchySize(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return t.max.subtract(t.min);
  }
  getMeshHierarchyCenter(e) {
    const t = e.getHierarchyBoundingVectors(!0), s = t.max.subtract(t.min);
    return t.min.add(s.scale(0.5));
  }
  getSceneBoundingInfo() {
    if (!this._scene)
      return null;
    const e = this.getWorldExtends();
    return e ? new BABYLON.BoundingInfo(e.min, e.max) : null;
  }
  setupShadows(e) {
    var Ee, K, j, ht, Ze, pt, Pt, Mt, Tt, at, Ai, Ve, Ot, Ft, Bt, yi, on;
    if (!e)
      return;
    const t = (Ee = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Ee.get("enableShadows");
    t != null && (this.enableShadows = t), this.areShadowVisible || (this.enableShadows = !1);
    const s = (K = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : K.get("shadowMapSize"), o = (j = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : j.get("contactHardeningUVRatio"), a = (ht = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ht.get("useContactHardeningShadow"), c = (Ze = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Ze.get("useBlurCloseExponentialShadowMap"), g = (pt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : pt.get("usePercentageCloserFiltering"), w = (Pt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Pt.get("usePoissonSampling"), T = (Mt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Mt.get("useKernelBlur"), H = (Tt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Tt.get("blurBoxOffset"), Y = (at = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : at.get("blurScale"), ee = (Ai = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Ai.get("blurKernel"), z = (Ve = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Ve.get("depthScale"), he = (Ot = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Ot.get("shadowDarkness"), ne = (Ft = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Ft.get("shadowMinZ"), ye = (Bt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Bt.get("shadowMaxZ");
    if (!this.enableShadows) {
      const Tn = (yi = this._scene) == null ? void 0 : yi.getMeshByName("shadowGround");
      Tn && Tn.dispose();
      const Ki = (on = this._scene) == null ? void 0 : on.getMaterialByName("shadowMaterial");
      Ki && Ki.dispose();
      const as = this._scene.getLightByName("shadowDirectionalLight");
      as && as.dispose();
      return;
    }
    if (!this._scene)
      throw new Error("Scene is not defined");
    const se = this._scene.getLightByName("shadowDirectionalLight"), _e = new BABYLON.Vector3(0, -2, 0), ue = se ?? new BABYLON.DirectionalLight("shadowDirectionalLight", _e, this._scene);
    ue.intensity = 0, ue.shadowMinZ = ne ?? void 0, ue.shadowMaxZ = ye ?? void 0, hn._shadowGenerator = new BABYLON.ShadowGenerator(Number(s), ue), hn._shadowGenerator.usePoissonSampling = !!w, hn._shadowGenerator.usePercentageCloserFiltering = !!g, hn._shadowGenerator.useBlurCloseExponentialShadowMap = !!c, hn._shadowGenerator.useKernelBlur = !!T, hn._shadowGenerator.blurBoxOffset = Number(H), hn._shadowGenerator.blurScale = Number(Y), hn._shadowGenerator.blurKernel = Number(ee), hn._shadowGenerator.depthScale = Number(z), hn._shadowGenerator.setDarkness(Number(he)), hn._shadowGenerator.useContactHardeningShadow = !!a, hn._shadowGenerator.contactHardeningLightSizeUVRatio = Number(o), hn._shadowGenerator.transparencyShadow = !0, hn._shadowGenerator.enableSoftTransparentShadow = !0;
    const xe = hn._shadowGenerator.getShadowMap();
    this._scene.meshes.forEach((Tn) => {
      var Ki;
      (Ki = xe == null ? void 0 : xe.renderList) == null || Ki.push(Tn);
    }), this.createGroundFromBoundingBox(e);
  }
  setShadowsVisibility(e) {
    hn._shadowGenerator && (this.areShadowVisible = e);
  }
  stopAllAnimations() {
    this._scene && this._scene.stopAllAnimations();
  }
  hasAnimations() {
    return this._scene ? this._scene.animationGroups.length > 0 : !1;
  }
  playAnimations() {
    if (this._scene && this.hasAnimations()) {
      const e = this._scene.animationGroups[0];
      e.start(!0, 1, e.from, e.to, !1);
    }
  }
  setupAnimations(e) {
    var w;
    const t = e == null ? void 0 : e.getAnimationsConfig(), s = !!(t != null && t.get("runAtStart")), o = !!(t != null && t.get("loop")), a = (t == null ? void 0 : t.get("speed")) || 1, c = (w = this._scene) == null ? void 0 : w.animationGroups, g = c && this._scene.animationGroups.length > 0;
    if (c && c.forEach((T) => {
      T.stop(), T.reset();
    }), s && g) {
      const T = c[0];
      T.start(o, a, T.from, T.to, !1);
    }
  }
  createGroundFromBoundingBox(e) {
    var z, he, ne, ye, se, _e, ue, xe, Ee;
    if (!e)
      return;
    const t = (z = this._scene) == null ? void 0 : z.getMeshByName("shadowGround");
    t && t.dispose();
    const s = (he = this._scene) == null ? void 0 : he.getMaterialByName("shadowMaterial");
    s && s.dispose();
    const o = (ne = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ne.get("enableShadows");
    if (o != null && (this.enableShadows = o), !this.enableShadows) {
      console.log("Shadows are not enabled");
      return;
    }
    const a = this.getSceneBoundingInfo();
    if (!a || !a.boundingBox) {
      console.error("Cannot create ground: No bounding box information available.");
      return;
    }
    const c = (ye = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ye.get("shadowHexColor"), g = (se = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : se.get("groundSizeMultiplierWidth"), w = (_e = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : _e.get("groundSizeMultiplierLength"), T = a.boundingBox.minimumWorld, Y = a.boundingBox.maximumWorld.subtract(T), ee = T.add(Y.scale(0.5));
    if (this._scene !== null) {
      const K = BABYLON.MeshBuilder.CreateGround(
        "shadowGround",
        {
          width: Y.x * Number(g),
          height: Y.z * Number(w)
        },
        this._scene
      );
      K.position = new BABYLON.Vector3(ee.x, T.y, ee.z), K.rotation.y = Math.PI;
      const j = new BABYLON.ShadowOnlyMaterial("bbmat", this._scene);
      K.material = j, K.receiveShadows = !0, K.material.shadowColor = BABYLON.Color3.FromHexString(
        String(c)
      ), K.metadata = { AR: !1, isRealMesh: !1 };
      const ht = (ue = hn._shadowGenerator) == null ? void 0 : ue.getShadowMap();
      hn._shadowGenerator && ht ? ((xe = ht.renderList) == null || xe.push(K), K.receiveShadows = !0) : console.error("Failed to add ground mesh to shadow map render list.");
    } else
      console.error("Cannot create ground: Scene is null.");
    console.log("Shadow ground created"), (Ee = this._scene) == null || Ee.render();
  }
  userIsMoving() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0 || this._isPointerDown;
  }
  cameraIsMoving() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0;
  }
  cameraLimitsReached() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.lowerRadiusLimit !== void 0 && this._camera.lowerRadiusLimit !== null && this._camera.radius === this._camera.lowerRadiusLimit || this._camera.upperRadiusLimit !== void 0 && this._camera.upperRadiusLimit !== null && this._camera.radius === this._camera.upperRadiusLimit;
  }
  restoreCameraState() {
    this._camera && this._camera.restoreState();
  }
  isTextureWithUrl(e) {
    return e && (e instanceof BABYLON.Texture || e instanceof BABYLON.CubeTexture || e instanceof BABYLON.HDRCubeTexture || e instanceof BABYLON.ColorGradingTexture || e instanceof BABYLON.EquiRectangularCubeTexture);
  }
  getTextureUrl(e) {
    if (e && (e instanceof BABYLON.Texture || e instanceof BABYLON.CubeTexture || e instanceof BABYLON.HDRCubeTexture || e instanceof BABYLON.ColorGradingTexture || e instanceof BABYLON.EquiRectangularCubeTexture)) {
      let t = e.url;
      if (e.getInternalTexture) {
        const s = e.getInternalTexture();
        s && s.url && (t = s.url);
      }
      return t;
    }
    return null;
  }
  isEditControl(e) {
    return e && (e.name == "EditoControl" || e.metadata && e.metadata.isEditControl);
  }
  isRealMesh(e) {
    return !(this.isEditControl(e) || e.metadata && (e.metadata.boundingBox || e.metadata.isAxis || e.metadata.isGround || e.metadata.isEnvironmentNode || e.metadata.hasOwnProperty("isRealMesh") && !e.metadata.isRealMesh));
  }
  meshFineTuningSettings(e) {
    return e.metadata && e.metadata.hasOwnProperty("tryOnFineTuningSettings") && e.metadata.tryOnFineTuningSettings ? e.metadata.tryOnFineTuningSettings : null;
  }
  meshHasParent(e, t) {
    if (this._scene) {
      let s = this._scene.getMeshById(e);
      if (s)
        for (; s.parent; ) {
          if (s.parent.id === t)
            return !0;
          s = s.parent;
        }
    }
    return !1;
  }
  countSceneMeshes() {
    let e = 0;
    return this._scene && this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && e++;
    }), e;
  }
  sceneHasRealMeshes() {
    for (let e = 0; e < this._scene.meshes.length; e++)
      if (this.isRealMesh(this._scene.meshes[e]))
        return !0;
    return !1;
  }
  getSceneMeshes() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && e.push(t);
    }), e;
  }
  getSceneMeshesByName(e) {
    let t = [];
    if (this._scene) {
      const o = function(a) {
        return a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      };
      if (e) {
        var s = new RegExp(o(e).replace(/\\\*/g, ".*"), "i");
        for (let a = 0; a < this._scene.meshes.length; a++) {
          const c = this._scene.meshes[a];
          this.isRealMesh(c) && c.name && s.test(c.name) && t.push(c);
        }
      }
    }
    return t;
  }
  isVisibleMesh(e) {
    return this.isRealMesh(e) && e.isVisible;
  }
  getVisibleMeshes() {
    const e = [];
    return this._scene.meshes.forEach((t) => {
      this.isVisibleMesh(t) && e.push(t);
    }), e;
  }
  getInvisibleMeshes() {
    const e = [];
    return this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && !t.isVisible && e.push(t);
    }), e;
  }
  getSubMesh(e, t) {
    return e.subMeshes && e.subMeshes.length > 0 && t >= 0 && t < e.subMeshes.length ? e.subMeshes[t] : null;
  }
  getMeshHierarchy(e) {
    const t = [];
    let s = this._scene.getMeshById(e);
    if (!s)
      return t;
    let o = (a) => {
      t.push(a);
      let c = a.getChildMeshes(!0);
      for (let g = 0; g < c.length; g++)
        o(c[g]);
    };
    return o(s), t;
  }
  getTryOnMeshHierarchy(e) {
    const t = [];
    let s = this._scene.getMeshById(e);
    if (!s)
      return t;
    let o = (a) => {
      t.push(a);
      let c = a.getChildMeshes(!0);
      for (const g of c)
        (this.isVisibleCanvasMesh(g) || this.isVisibleTryOnMesh(g)) && o(g);
    };
    return o(s), t;
  }
  isVisibleCanvasMesh(e) {
    return this.isCanvasMesh(e) && e.isVisible;
  }
  isCanvasMesh(e) {
    return !e || !e.metadata ? !1 : e.metadata.hasOwnProperty("iscanvasMesh") && typeof e.metadata.iscanvasMesh == "boolean" ? e.metadata.iscanvasMesh : !1;
  }
  isAREnabledForMesh(e) {
    return e ? !e.metadata || e.metadata.AR === void 0 || e.metadata.AR === null || typeof e.metadata.AR != "boolean" ? !0 : e.metadata.AR : !1;
  }
  isTryOnEnabledForMesh(e) {
    return e ? !e.metadata || e.metadata.TryOn === void 0 || e.metadata.TryOn === null || typeof e.metadata.TryOn != "boolean" ? !0 : e.metadata.TryOn : !1;
  }
  isVisibleTryOnMesh(e) {
    return this.isTryOnEnabledForMesh(e) && this.isVisibleMesh(e);
  }
  getMeshesForAR() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      (this.isRealMesh(t) || this.isCanvasMesh(t)) && t.isVisible && this.isAREnabledForMesh(t) && e.push(t);
    }), e;
  }
  checkMaterialsForAR() {
    const e = this.getMeshesMaterials(this.getMeshesForAR());
    for (let t = 0; t < e.length; t++) {
      const s = e[t];
      if (!(s instanceof BABYLON.PBRMaterial) && !(s instanceof BABYLON.PBRMetallicRoughnessMaterial) && !(s instanceof BABYLON.StandardMaterial))
        return !1;
    }
    return !0;
  }
  getMeshesMaterials(e) {
    const t = [], s = [];
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      if (a.material)
        if (a.material instanceof BABYLON.MultiMaterial)
          for (let c = 0; c < a.material.subMaterials.length; c++) {
            let g = a.material.subMaterials[c];
            g && t.indexOf(g.id) === -1 && (s.push(g), t.push(g.id));
          }
        else
          t.indexOf(a.material.id) === -1 && (s.push(a.material), t.push(a.material.id));
    }
    return s;
  }
  getMeshMaterials(e) {
    const t = [];
    if (e && e.material)
      if (e.material instanceof BABYLON.MultiMaterial)
        for (let s = 0; s < e.material.subMaterials.length; s++) {
          let o = e.material.subMaterials[s];
          o && t.push(o);
        }
      else
        t.push(e.material);
    return t;
  }
  getHiddenMeshTotalVertices() {
    return this.getTotalVertices((e) => !e.isVisible);
  }
  getTotalVertices(e) {
    let t = 0;
    return this._scene && this._scene.meshes.forEach((s) => {
      this.isRealMesh(s) && (e && !e(s) || (t += s.getTotalVertices()));
    }), t;
  }
  getHiddenMeshTotalIndices() {
    return this.getTotalIndices((e) => !e.isVisible);
  }
  getTotalIndices(e) {
    let t = 0;
    return this._scene && this._scene.meshes.forEach((s) => {
      this.isRealMesh(s) && (e && !e(s) || (t += s.getTotalIndices()));
    }), t;
  }
  getAllMaterials() {
    const e = [];
    return this._scene && this._scene.materials.forEach((t) => {
      t.metadata && (t.metadata.isRealMaterial !== void 0 && !t.metadata.isRealMaterial || t.metadata.isEnvironmentNode !== void 0 && t.metadata.isEnvironmentNode) || t.id !== "groundMaterial" && t.id !== "default material" && e.push(t);
    }), e;
  }
  getMeshesUsingMaterial(e) {
    const t = [], s = this.getSceneMeshes();
    for (let o = 0; o < s.length; o++) {
      const a = s[o];
      this.isMeshUsingMaterial(a, e) && t.push(a);
    }
    return t;
  }
  isMeshUsingMaterial(e, t) {
    if (e.material) {
      if (e.material.id === t)
        return !0;
      if (e.material instanceof BABYLON.MultiMaterial)
        for (let s = 0; s < e.material.subMaterials.length; s++) {
          const o = e.material.subMaterials[s];
          if (o && o.id === t)
            return !0;
        }
    }
    return !1;
  }
  getAllUnusedMaterials() {
    const e = this.getAllMaterials(), t = [];
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      this.getMeshesUsingMaterial(o.id).length === 0 && t.push(o);
    }
    return t;
  }
  async getSceneScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    let s = { width: e, height: t };
    return await BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, s, "image/png");
  }
  containsPBRMaterials() {
    if (this._scene) {
      for (let e = 0; e < this._scene.materials.length; e++)
        if (this._scene.materials[e] instanceof BABYLON.PBRBaseMaterial)
          return !0;
    }
    return !1;
  }
  getMeshesForTryOn() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      (this.isRealMesh(t) || this.isCanvasMesh(t)) && t.isVisible && this.isTryOnEnabledForMesh(t) && e.push(t);
    }), e;
  }
  setupLights() {
    this._hemiLight = null, this._pointLight = null;
    let e = null, t = null;
    this._scene.lights.forEach((s) => {
      s instanceof BABYLON.HemisphericLight && (e === null && (e = s), s.id === this._defHemiLightID && (this._hemiLight = s)), s instanceof BABYLON.PointLight && (t === null && (t = s), s.id === this._defPointLightID && (this._pointLight = s));
    }), this._hemiLight === null && (e !== null ? this._hemiLight = e : (this._hemiLight = new BABYLON.HemisphericLight(
      "Default Hemispheric Light",
      BABYLON.Vector3.Up(),
      this._scene
    ), this._hemiLight.intensity = 0.5), this._hemiLight && (this._hemiLight.id = this._defHemiLightID)), this._pointLight === null && (t !== null ? this._pointLight = t : (this._pointLight = new BABYLON.PointLight(
      "Default Point Light",
      new BABYLON.Vector3(0, 5, 0),
      this._scene
    ), this._pointLight.intensity = 0.5), this._pointLight && (this._pointLight.id = this._defPointLightID));
  }
  setUpCustomLights(e) {
    Object.entries(e).forEach((t) => {
      const s = t[0], o = t[1].position, a = t[1].general.intensity, c = t[1].general.visible, g = {
        position: o,
        intensity: a,
        visible: c
      };
      this.createOrUpdateLight(s, g);
    });
  }
  createOrUpdateLight(e, t) {
    const s = this._scene.getLightByName(e);
    if (s && (this._scene.removeLight(s), s.dispose()), !t.visible)
      return;
    const o = new BABYLON.Vector3(t.position.x, t.position.y, t.position.z);
    let a;
    e.match(/directional/i) ? (a = new BABYLON.DirectionalLight(e, o, this._scene), a.intensity = t.intensity, a.id = Zakeke.generateUUID()) : e.match(/pointLight/i) ? (a = new BABYLON.PointLight(e, o, this._scene), a.intensity = t.intensity, a.id = Zakeke.generateUUID()) : e.match(/hemisphere/i) && (a = new BABYLON.HemisphericLight(e, o, this._scene), a.intensity = t.intensity, a.id = Zakeke.generateUUID());
  }
  getDefaultHemisphericLight() {
    return this._hemiLight;
  }
  getDefaultPointLight() {
    return this._pointLight;
  }
  isDefaultLight(e) {
    return e.id == this._defHemiLightID || e.id == this._defPointLightID;
  }
  setUpCameraByOptions(e) {
    if (e && this._scene) {
      let t = this._scene.cameras.find((s) => s instanceof BABYLON.ArcRotateCamera);
      e && t instanceof BABYLON.ArcRotateCamera && (t.beta = e.beta ?? t.beta, t.alpha = e.alpha ?? t.alpha, t.fov = e.fov ?? t.fov);
    }
  }
  setupCamera() {
    if (this._scene) {
      let e = this._scene.cameras.find((t) => t instanceof BABYLON.ArcRotateCamera);
      e ? this._camera = e : (this._camera = new BABYLON.ArcRotateCamera("camera1", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene), this._camera.setPosition(new BABYLON.Vector3(0, 3, -8))), this.setupCameraLimits(), this._canvas && this._camera.attachControl(this._canvas, !1);
    }
  }
  setCameraRadiusParameters(e) {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerRadiusLimit = e * (this._zoomEnabled ? 0.01 : 1), this._camera.upperRadiusLimit = e * (this._zoomEnabled ? 3 : 1), this._camera.wheelPrecision = 100 / e, this._camera.pinchPrecision = 100 / e, this._camera.minZ = e * 0.01, this._camera.maxZ = e * 1e3, this._camera.speed = e * 0.2, this._camera.wheelDeltaPercentage = 0.01, this._camera.pinchDeltaPercentage = 6e-4, this._camera.panningSensibility = 1e-6, this._camera.wheelPrecision = 100 / e, this._camera.panningAxis = BABYLON.Vector3.Zero(), this._camera.panningInertia = 0, this._camera.radius = e);
  }
  removeCameraLimits() {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerRadiusLimit = null, this._camera.upperRadiusLimit = null, this._camera.minZ = 1, this._camera.maxZ = 1e4);
  }
  getWorldExtends() {
    return this._scene ? this._scene.getWorldExtends((e) => this.isRealMesh(e) && e.isVisible) : null;
  }
  getCameraWorldExtends() {
    let e = null;
    if (this._scene) {
      let t = this._cameraPivot;
      if (!t)
        for (let s = 0; s < this._scene.meshes.length; s++) {
          const o = this._scene.meshes[s];
          if (o.metadata && o.metadata.isCameraPivot !== void 0 && o.metadata.isCameraPivot) {
            t = o;
            break;
          }
        }
      t && (e = this._scene.getWorldExtends((s) => s === t || this.meshHasParent(s.id, t.id)));
    }
    return e || (e = this.getWorldExtends()), e;
  }
  setupCameraLimits(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      if (e == null) {
        let s = this.getCameraWorldExtends();
        s && (e = s);
      }
      if (!e)
        return;
      const t = e.max.subtract(e.min);
      if (isFinite(t.length())) {
        this.removeCameraLimits();
        const s = this.calculateCameraRadius(e);
        if (this.setCameraRadiusParameters(s), this._limitLowerRadius) {
          if (this._scene.meshes.length && this._zoomEnabled) {
            this._camera.useFramingBehavior = !0;
            const o = this._camera.getBehaviorByName("Framing");
            o && o instanceof BABYLON.FramingBehavior && (o.elevationReturnTime = -1, this._camera.lowerRadiusLimit = null, this._minZoomPerc !== null && this._minZoomPerc !== void 0 && this._minZoomPerc > 0 && (this._camera.lowerRadiusLimit = s * this._minZoomPerc), this._maxZoomPerc !== null && this._maxZoomPerc !== void 0 && this._maxZoomPerc > 0 && (this._camera.upperRadiusLimit = s * this._maxZoomPerc));
          }
        } else
          this._camera.lowerRadiusLimit = null;
      }
    }
  }
  adjustCamera(e, t = !0, s = !0, o = !0, a = !1) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    let c = this.getCameraWorldExtends();
    if (!c)
      return;
    const g = c.max.subtract(c.min);
    if (!isFinite(g.length()))
      return;
    const w = c.min.add(g.scale(0.5));
    this.removeCameraLimits();
    const T = this.calculateCameraRadius(c);
    let H = this._camera.alpha;
    t || (H = -(Math.PI / 2), e && e === "gltf" && (H += Math.PI));
    let Y = this._camera.beta;
    s || (Y = Math.PI / 2 - 0.3);
    let ee = w.clone(), z = c.min.y, he = c.max.y, ne = z + (he - z) * this._positionScale;
    if (ee.y = ne, !o)
      this._camera.alpha = H, this._camera.beta = Y, this._camera.radius = T, this._camera.target = ee, this.setupCameraLimits(c);
    else {
      if (a) {
        const ye = this.calculateCameraRadius(c);
        this._camera.radius = ye;
      }
      this.animateCameraToFinalParamters(H, Y, T, ee, 2, () => {
        this.setupCameraLimits(c);
      });
    }
  }
  normalizeAngleOfView(e, t) {
    const s = BABYLON.Vector3.Zero(), o = new BABYLON.ArcRotateCamera("ghostCamera", e, t, 1, s, this._scene), a = o.position;
    return o.dispose(), this.computeCameraAngleOfView(s, a);
  }
  computeCameraAngleOfView(e, t) {
    const s = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    s.setPosition(t);
    const o = s.alpha, a = s.beta;
    return s.dispose(), {
      alpha: o,
      beta: a
    };
  }
  moveCamera(e, t) {
    var s = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    s.setPosition(t);
    var o = s.alpha, a = s.beta, c = s.radius;
    s.dispose(), this.moveCameraToFinalParameters(o, a, c, e);
  }
  animateCamera(e, t, s, o) {
    var a = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    a.setPosition(t);
    var c = a.alpha, g = a.beta, w = a.radius;
    a.dispose(), this.animateCameraToFinalParamters(c, g, w, e, s, o);
  }
  // riporta angle nel range -180, + 180
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, s = Math.floor((e + Math.PI) * (1 / t));
      e -= s * t;
    }
    return e;
  }
  wrap2Pi(e) {
    let t = e % (Math.PI * 2);
    return t < 0 && (t += Math.PI * 2), t;
  }
  zoomIn() {
    this.zoom(0.85);
  }
  zoomOut() {
    this.zoom(1.15);
  }
  zoom(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      let s = this._camera.radius, o = this._camera.lowerRadiusLimit !== null && this._camera.lowerRadiusLimit !== void 0 ? this._camera.lowerRadiusLimit : 0, a = Math.max(0, o), c = Number.MAX_VALUE;
      this._camera.upperRadiusLimit != null && (c = this._camera.upperRadiusLimit);
      var t = Math.max(a, Math.min(c, s * e));
      t !== s && this.animateCameraToFinalParamters(
        this._camera.alpha,
        this._camera.beta,
        t,
        this._camera.target,
        0.5
      );
    }
  }
  moveCameraToFinalParameters(e, t, s, o) {
    !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) || (this._camera.target = o, this._camera.alpha = e, this._camera.beta = t, this._camera.radius = s);
  }
  animateCameraToFinalParamters(e, t, s, o, a, c) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    let g = this._camera.radius, w = () => {
      if (this._camera) {
        this._scene.stopAnimation(this._camera);
        for (let Mt = 0; Mt < this._camera.animations.length; Mt++)
          this._camera.animations[Mt], this._camera.animations.splice(Mt--, 1);
      }
    };
    w();
    let T = this._camera.alpha;
    !this._camera.lowerAlphaLimit && !this._camera.upperAlphaLimit && (T = this.wrap2Pi(this._camera.alpha));
    let H = this._camera.beta;
    !this._camera.lowerBetaLimit && !this._camera.upperBetaLimit && (H = this.wrap2Pi(this._camera.beta));
    let Y = isFinite(e) ? this.wrapPi(e) : T;
    Math.abs(T - Y) > Math.PI && (Y += Math.PI * 2);
    let ee = isFinite(t) ? this.wrapPi(t) : H;
    Math.abs(H - ee) > Math.PI && (ee += Math.PI * 2);
    let z = 2;
    a && typeof a == "number" && a > 0 && (z = a);
    let he = 60, ne = Math.floor(z * he), _e = this._camera.target.subtract(o).length() / this._camera.radius, ue = [], xe = new BABYLON.CubicEase();
    xe.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
    let Ee = null;
    this._camera.target !== o && (_e >= 5e-3 ? (Ee = new BABYLON.Animation(
      "camTargetAnimation",
      "target",
      he,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), ue = [
      {
        frame: 0,
        value: this._camera.target
      },
      {
        frame: ne,
        value: o
      }
    ], Ee.setKeys(ue), Ee.setEasingFunction(xe)) : this._camera.target = o);
    let K = null;
    T !== Y && (K = new BABYLON.Animation(
      "camAlphaAnimation",
      "alpha",
      he,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), ue = [
      {
        frame: 0,
        value: T
      },
      {
        frame: ne,
        value: Y
      }
    ], K.setKeys(ue), K.setEasingFunction(xe));
    let j = null;
    H !== ee && (j = new BABYLON.Animation(
      "camBetaAnimation",
      "beta",
      he,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), ue = [
      {
        frame: 0,
        value: H
      },
      {
        frame: ne,
        value: ee
      }
    ], j.setKeys(ue), j.setEasingFunction(xe));
    let ht = Math.abs(this._camera.radius - s) / this._camera.radius, Ze = null;
    this._camera.radius !== s && (ht >= 5e-3 ? (Ze = new BABYLON.Animation(
      "camRadiusAnimation",
      "radius",
      he,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), ue = [
      {
        frame: 0,
        value: g
      },
      {
        frame: ne,
        value: s
      }
    ], Ze.setKeys(ue), Ze.setEasingFunction(xe)) : this._camera.radius = s);
    let pt = this._camera.animations.length;
    if (Ee && this._camera.animations.push(Ee), K && this._camera.animations.push(K), j && this._camera.animations.push(j), Ze && this._camera.animations.push(Ze), this._camera.animations.length > pt) {
      var Pt = this._scene.beginAnimation(this._camera, 0, ne, !1, 1);
      Pt.onAnimationEnd = () => {
        w(), this.setupShaderMaterialsCameraPosition(), c && c();
      };
    } else
      c && c();
  }
  //Returns the frustum slope based on the canvas ratio and camera FOV
  //returns The frustum slope represented as a Vector2 with X and Y slopes
  getFrustumSlope() {
    let e = this._camera;
    if (!e)
      return BABYLON.Vector2.Zero();
    let s = this._engine.getAspectRatio(e), o = Math.tan(e.fov / 2), a = o * s;
    return new BABYLON.Vector2(a, o);
  }
  calculateCameraRadius(e) {
    if (e == null) {
      let s = this.getCameraWorldExtends();
      s && (e = s);
    }
    if (!e)
      return 1;
    var t = this.calculateLowerRadiusFromModelBoundingSphere(e.min, e.max);
    return isFinite(t) || (t = 1), t + (this._cameraZoom ?? 0);
  }
  // Calculates the lowest radius for the camera based on the bounding box of the mesh.
  calculateLowerRadiusFromModelBoundingSphere(e, t) {
    const o = t.subtract(e).length(), a = this.getFrustumSlope(), c = o * 0.5, g = this._radiusScale, w = c * g, T = w * Math.sqrt(1 + 1 / (a.x * a.x)), H = w * Math.sqrt(1 + 1 / (a.y * a.y));
    let Y = Math.max(T, H);
    var ee = this._camera;
    return !ee || !(ee instanceof BABYLON.ArcRotateCamera) ? 0 : (ee.upperRadiusLimit && (Y = Y > ee.upperRadiusLimit ? ee.upperRadiusLimit : Y), Y);
  }
  getWorldCenter(e) {
    if (e == null) {
      let o = this.getCameraWorldExtends();
      o && (e = o);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? e.min.add(t.scale(0.5)) : null;
  }
  getCameraWorldCenter(e) {
    if (e == null) {
      let o = this.getCameraWorldExtends();
      o && (e = o);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? e.min.add(t.scale(0.5)) : null;
  }
  getCameraRadius(e) {
    if (e == null) {
      let o = this.getCameraWorldExtends();
      o && (e = o);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? this.calculateCameraRadius(e) : null;
  }
  setCameraLimitLowerRadius(e, t = !1) {
    if (this._limitLowerRadius = e, this.setupCameraLimits(), t && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
      let s = this._camera.target.clone(), o = this.getCameraWorldExtends();
      if (o) {
        let a = o.min.y, c = o.max.y, g = a + (c - a) * this._positionScale;
        s.y = g, this.animateCameraToFinalParamters(
          this._camera.alpha,
          this._camera.beta,
          this._camera.radius,
          s,
          0.5
        );
      }
    }
  }
  setCameraPositionScale(e, t = !1) {
    if (this._positionScale = e, t && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
      var s = this._camera.target.clone(), o = this.getCameraWorldExtends();
      if (o) {
        var a = o.min.y, c = o.max.y, g = a + (c - a) * this._positionScale;
        s.y = g, this.animateCameraToFinalParamters(
          this._camera.alpha,
          this._camera.beta,
          this._camera.radius,
          s,
          0.5
        );
      }
    }
  }
  getCameraPivot() {
    return this._cameraPivot;
  }
  setCameraPivot(e) {
    this._cameraPivot = e, this.adjustCamera(void 0, !0, !0, !0);
  }
  setZoomEnabled(e) {
    this._zoomEnabled = e, this.adjustCamera(void 0, !0, !0, !0);
  }
  setMinZoomPerc(e) {
    const t = e ?? null;
    t !== this._minZoomPerc && (this._minZoomPerc = t, this.adjustCamera(void 0, !0, !0, !1));
  }
  setMaxZoomPerc(e) {
    const t = e ?? null;
    t !== this._maxZoomPerc && (this._maxZoomPerc = t, this.adjustCamera(void 0, !0, !0, !1));
  }
  setCameraZoom(e) {
    e != null && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._cameraZoom = -(e / 10), this.adjustCamera(void 0, !0, !0, !1));
  }
  setCameraAlphaLimits(e, t) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const s = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).alpha;
      this.setCameraLowerAlphaLimit(e), this.setCameraUpperAlphaLimit(t), this._camera.alpha = s;
    }
  }
  setCameraLowerAlphaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.lowerAlphaLimit = null;
      else {
        let t = this.normalizeAngleOfView(e, this._camera.beta).alpha;
        this._camera.upperAlphaLimit && t > this._camera.upperAlphaLimit && (this._camera.upperAlphaLimit += Math.PI * 2), this._camera.lowerAlphaLimit = t;
      }
  }
  setCameraUpperAlphaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.upperAlphaLimit = null;
      else {
        let t = this.normalizeAngleOfView(e, this._camera.beta).alpha;
        this._camera.lowerAlphaLimit && t < this._camera.lowerAlphaLimit && (t += Math.PI * 2), this._camera.upperAlphaLimit = t;
      }
  }
  setCameraLowerBetaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.lowerBetaLimit = 0.01;
      else {
        let t = this.normalizeAngleOfView(this._camera.alpha, e).beta;
        this._camera.upperBetaLimit && t > this._camera.upperBetaLimit && (this._camera.upperBetaLimit += Math.PI * 2), this._camera.lowerBetaLimit = t;
      }
  }
  setCameraUpperBetaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.upperBetaLimit = Math.PI - 0.01;
      else {
        let t = this.normalizeAngleOfView(this._camera.alpha, e).beta;
        this._camera.lowerBetaLimit && t < this._camera.lowerBetaLimit && (this._camera.lowerBetaLimit -= Math.PI * 2), this._camera.upperBetaLimit = t;
      }
  }
  setCameraBetaLimits(e, t) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const s = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).beta;
      this.setCameraLowerBetaLimit(e), this.setCameraUpperBetaLimit(t), this._camera.beta = s;
    }
  }
  zoomOnMesh(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      this._camera.useFramingBehavior = !0;
      const t = this._camera.getBehaviorByName("Framing");
      t && t instanceof BABYLON.FramingBehavior && (t.framingTime = 0, t.elevationReturnTime = -1, t.radiusScale = this._radiusScale, t.positionScale = this._positionScale, t.zoomOnMeshHierarchy(e));
    }
  }
  async takeScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    const s = { width: e, height: t };
    return await BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, s, "image/png");
  }
  async takeContentScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    var s = this._scene.clearColor.clone();
    this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0), this._scene.render();
    let o = { width: e, height: t };
    const a = BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, o, "image/png");
    this._scene.render(), this._scene.getEngine().endFrame();
    const c = await a;
    return this._scene.clearColor = s, c;
  }
  async takeMaterialScreenshotAsync(e, t, s) {
    let o = this._scene.getMaterialByID(e);
    if (!o)
      return "";
    let a = this.getVisibleMeshes();
    for (let ee = 0; ee < a.length; ee++) {
      var c = a[ee];
      c.isVisible = !1;
    }
    let g = this._scene.clearColor.clone();
    this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
    let w = BABYLON.Mesh.CreateSphere("temp_sphere", 32, 2, this._scene);
    w.material = o;
    let T = new BABYLON.ArcRotateCamera("temp_camera", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene);
    T.setPosition(new BABYLON.Vector3(0, 0, -4)), this._scene.activeCamera = T, this._scene.render();
    let H = { width: t, height: s }, Y = await BABYLON.Tools.CreateScreenshotAsync(this._engine, T, H, "image/png");
    this._scene.clearColor = g, w.dispose();
    for (let ee = 0; ee < a.length; ee++) {
      var c = a[ee];
      c.isVisible = !0;
    }
    return this._scene.activeCamera = this._camera, T.dispose(), Y;
  }
  getScenePBRMaterials() {
    const e = [];
    return this._scene && this._scene.materials.forEach((t) => {
      t instanceof BABYLON.PBRBaseMaterial && e.push(t);
    }), e;
  }
  resetPBRMaterialsImageProcessingConfiguration() {
    var e = this.getScenePBRMaterials();
    e.forEach((t) => {
      this.adjustPBRMaterialImageProcessingConfiguration(t);
    });
  }
  adjustPBRMaterialImageProcessingConfiguration(e) {
    e instanceof BABYLON.PBRMaterial && e.imageProcessingConfiguration && (e.imageProcessingConfiguration.colorGradingWithGreenDepth = !1, e.imageProcessingConfiguration.colorGradingBGR = !1, e.imageProcessingConfiguration.exposure = 1, e.imageProcessingConfiguration.toneMappingEnabled = !1, e.imageProcessingConfiguration.contrast = 1);
  }
  animateMeshToFinalParameters(e, t, s, o, a, c = 2, g) {
    if (this._scene && e) {
      e.id;
      const H = () => {
        this._scene.stopAnimation(e);
        for (let xe = 0; xe < e.animations.length; xe++)
          e.animations.splice(xe--, 1);
      };
      H();
      const Y = c, ee = 60, z = Math.floor(Y * ee);
      let he, ne = null;
      e.position !== t && (ne = new BABYLON.Animation(
        "positionAnimation",
        "position",
        ee,
        BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      ), he = [
        {
          frame: 0,
          value: e.position
        },
        {
          frame: z,
          value: t
        }
      ], ne.setKeys(he));
      let ye = null, se = null;
      if (e.rotationQuaternion == null) {
        var w;
        s != null ? w = s.clone() : w = o.toEulerAngles().clone(), e.rotation != w && (ye = new BABYLON.Animation(
          "eulerAnimation",
          "rotation",
          ee,
          BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
        ), he = [
          {
            frame: 0,
            value: e.rotation
          },
          {
            frame: z,
            value: w
          }
        ], ye.setKeys(he));
      } else {
        let xe;
        o != null ? xe = o.clone() : (xe = BABYLON.Quaternion.Identity(), xe.copyFrom(BABYLON.Quaternion.RotationYawPitchRoll(s.y, s.x, s.z))), se = new BABYLON.Animation(
          "quaternionAnimation",
          "rotationQuaternion",
          ee,
          BABYLON.Animation.ANIMATIONTYPE_QUATERNION,
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
        ), he = [
          {
            frame: 0,
            value: e.rotationQuaternion
          },
          {
            frame: z,
            value: xe
          }
        ], se.setKeys(he);
      }
      let _e = null;
      e.scaling !== a && (_e = new BABYLON.Animation(
        "scalingAnimation",
        "scaling",
        ee,
        BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      ), he = [
        {
          frame: 0,
          value: e.scaling
        },
        {
          frame: z,
          value: a
        }
      ], _e.setKeys(he));
      let ue = e.animations.length;
      if (ne && e.animations.push(ne), ye && e.animations.push(ye), se && e.animations.push(se), _e && e.animations.push(_e), e.animations.length > ue) {
        var T = this._scene.beginAnimation(e, 0, z, !1, 1);
        T.onAnimationEnd = () => {
          H(), g && g();
        };
      }
    }
  }
  getMaterialsUsingTexture(e) {
    var t = this.getTextureMaterialsMap();
    return this._scene.materials.forEach((s) => {
      var o = this.getTexturesForMaterial(s);
      o.forEach((a) => {
        t.hasOwnProperty(a.uid) || (t[a.uid] = []), t[a.uid].push(s);
      });
    }), t.hasOwnProperty(e.uid) ? t[e.uid] : [];
  }
  getTextureMaterialsMap() {
    let e = {};
    return this._scene && this._scene.materials.forEach((t) => {
      var s = this.getTexturesForMaterial(t);
      s.forEach((o) => {
        e.hasOwnProperty(o.uid) || (e[o.uid] = []), e[o.uid].push(t);
      });
    }), e;
  }
  // Recupera tutte le texture di un materiale
  getTexturesForMaterial(e) {
    return e.getActiveTextures();
  }
  getTexturesExclusivelyForMaterial(e) {
    let t = this.getTexturesForMaterial(e), s = this.getTextureMaterialsMap();
    for (var o = 0; o < t.length; o++) {
      let c = t[o];
      var a = s.hasOwnProperty(c.uid) ? s[c.uid] : [];
      a.length > 1 && t.splice(o--, 1);
    }
    return t;
  }
  getStandardMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRBaseSimpleMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRMetallicRoughnessMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRSpecularGlossinessMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getNewPBRMaterialTextures(e) {
    return e.getActiveTextures();
  }
  createMeshesFromSubMeshes(e) {
    let t = e.getChildMeshes(!0);
    for (let a = 0; a < t.length; a++)
      this.createMeshesFromSubMeshes(t[a]);
    let s = [];
    if (e.subMeshes && e.subMeshes.length > 0)
      for (let a = 0; a < e.subMeshes.length; a++) {
        let c = this.createMeshFromSubMesh(e, a);
        c && s.push(c);
      }
    let o = new BABYLON.VertexData();
    o.positions = [], o.indices = [], o.normals = [], o.uvs = [], o.uvs2 = [], o.applyToMesh(e, !0), e.subMeshes = [], e.material = null, s.forEach((a) => {
      a.parent = e;
    });
  }
  createMeshFromSubMesh(e, t, s) {
    let o = null, a = e.subMeshes[t], c = e.getVerticesData(BABYLON.VertexBuffer.PositionKind), g = e.getVerticesData(BABYLON.VertexBuffer.NormalKind), w = e.getIndices();
    if (c && g && w) {
      let H = c.slice(
        3 * a.verticesStart,
        3 * (a.verticesStart + a.verticesCount)
      ), Y = g.slice(
        3 * a.verticesStart,
        3 * (a.verticesStart + a.verticesCount)
      ), ee = w.slice(a.indexStart, a.indexStart + a.indexCount), z = null;
      if (e.isVerticesDataPresent(BABYLON.VertexBuffer.UVKind)) {
        let ye = e.getVerticesData(BABYLON.VertexBuffer.UVKind);
        ye && (z = ye.slice(2 * a.verticesStart, 2 * (a.verticesStart + a.verticesCount)));
      }
      var T = null;
      if (e.isVerticesDataPresent(BABYLON.VertexBuffer.UV2Kind)) {
        let ye = e.getVerticesData(BABYLON.VertexBuffer.UV2Kind);
        ye && (T = ye.slice(
          2 * a.verticesStart,
          2 * (a.verticesStart + a.verticesCount)
        ));
      }
      for (let ye = 0; ye < ee.length; ye++)
        ee[ye] -= a.verticesStart;
      let he = new BABYLON.Mesh(s || e.name + "_part_" + a._id, this._scene), ne = new BABYLON.VertexData();
      ne.positions = H, ne.normals = Y, ne.indices = ee, z && (ne.uvs = z), T && (ne.uvs2 = T), ne.applyToMesh(he), e.material && (he.material = e.material instanceof BABYLON.MultiMaterial ? e.material.subMaterials[a.materialIndex] : e.material);
    }
    return o;
  }
  getNextIncrementalName(e) {
    let t = e;
    if (e) {
      let g;
      for (var s = 0; this._scene.getMeshByName(t); ) {
        if (!g) {
          g = e;
          var o = e.lastIndexOf("_");
          if (o > 0) {
            var a = e.substring(o + 1), c = parseInt(a);
            c.toString() === a && (g = e.substring(0, o));
          }
        }
        s++, t = g + "_" + s;
      }
    }
    return t;
  }
  createBox(e, t) {
    let s = t || "Box";
    s = this.getNextIncrementalName(s);
    let o = BABYLON.Mesh.CreateBox(s, 5, this._scene);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createBoundingBox(e, t) {
    let s = t || "BoundingBox";
    s = this.getNextIncrementalName(s);
    const o = e ? e.getHierarchyBoundingVectors() : this.getWorldExtends();
    if (!o)
      return this.createBox(e, t);
    const a = o.min, c = o.max, g = new BABYLON.BoundingInfo(a, c), w = c.subtract(a);
    if (!isFinite(w.length()))
      return this.createBox(e, t);
    const T = c.x - a.x, H = c.y - a.y, Y = c.z - a.z, ee = BABYLON.VertexData.CreateBox({ width: T, height: H, depth: Y }), z = new BABYLON.Mesh(s, this._scene);
    return ee.applyToMesh(z), z.position.copyFrom(g.boundingBox.centerWorld), z.refreshBoundingInfo(), e && e.parent && (z.parent = e.parent), z;
  }
  createSphere(e, t) {
    let s = t || "Sphere";
    s = this.getNextIncrementalName(s);
    const o = BABYLON.Mesh.CreateSphere(s, 30, 5, this._scene);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createPlane(e, t) {
    let s = t || "Plane";
    s = this.getNextIncrementalName(s);
    const o = BABYLON.Mesh.CreatePlane(s, 10, this._scene);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createDisc(e, t) {
    let s = t || "Disc";
    s = this.getNextIncrementalName(s);
    const o = BABYLON.MeshBuilder.CreateDisc(s, { tessellation: 70 }, this._scene);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createCylinder(e, t) {
    let s = t || "Cylinder";
    s = this.getNextIncrementalName(s);
    const o = BABYLON.Mesh.CreateCylinder(s, 6, 6, 6, 30, 1, this._scene, !1);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createTorus(e, t) {
    let s = t || "Torus";
    s = this.getNextIncrementalName(s);
    const o = BABYLON.Mesh.CreateTorus(s, 8, 1, 50, this._scene, !1);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createKnot(e, t) {
    let s = t || "Knot";
    s = this.getNextIncrementalName(s);
    const o = BABYLON.Mesh.CreateTorusKnot(s, 2, 0.5, 128, 64, 2, 3, this._scene);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createRibbon(e, t) {
    let s = t || "Ribbon";
    s = this.getNextIncrementalName(s);
    const o = function(w) {
      for (var T = [], H = -10; H < 10; H++)
        T.push(new BABYLON.Vector3(w, H, Math.sin(w / 3) * 5 * Math.exp(-(H - w) * (H - w) / 60) + H / 3));
      return T;
    };
    for (var a = [], c = 0; c < 20; c++)
      a[c] = o(c);
    const g = BABYLON.Mesh.CreateRibbon("ribbon", a, !1, !1, 0, this._scene);
    return g.id = Zakeke.generateUUID(), e && (g.parent = e), g;
  }
  async createRoundedCubeAsync(e, t, s) {
    const o = Wt.Shapes.RoundedCubeName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.RoundedCubeFileName;
    let g = t || "Rounded Cube";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createRoundedCylinderAsync(e, t, s) {
    const o = Wt.Shapes.RoundedCylinderName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.RoundedCylinderFileName;
    let g = t || "Rounded Cylinder";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createMatBallAsync(e, t, s) {
    const o = Wt.Shapes.MatBallName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.MatBallFileName;
    let g = t || "Mat Ball";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createMaleHeadAsync(e, t, s) {
    const o = Wt.Shapes.MaleHeadName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.MaleHeadFileName;
    let g = t || "Male Head";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createFemaleHeadAsync(e, t, s) {
    const o = Wt.Shapes.FemaleHeadName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.FemaleHeadFileName;
    let g = t || "Female Head";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createPokemonBallAsync(e, t, s) {
    const o = Wt.Shapes.PokemonBallName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.PokemonBallFileName;
    let g = t || "Pokemon Ball";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createShaderBallAsync(e, t, s) {
    const o = Wt.Shapes.ShaderBallName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.ShaderBallFileName;
    let g = t || "Shader Ball";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createBootsAsync(e, t, s) {
    const o = Wt.Shapes.BootsName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.BootsFolder, g = Wt.Shapes.BootsFileName;
    let w = t || "Boots";
    return w = this.getNextIncrementalName(w), await this.importPrimitiveShapeAsync(o, a + c, g, e, w, s);
  }
  async createSuzanneAsync(e, t, s) {
    const o = Wt.Shapes.SuzanneName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.SuzanneFileName;
    let g = t || "Suzanne";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createStepPyramidAsync(e, t, s) {
    const o = Wt.Shapes.StepPyramidName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.StepPyramidFileName;
    let g = t || "Step Pyramid";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createTeapotAsync(e, t, s) {
    const o = Wt.Shapes.TeapotName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.TeapotFileName;
    let g = t || "Teapot";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createAlloyWheelAsync(e, t, s) {
    const o = Wt.Shapes.AlloyWheelName, a = Wt.Shapes.RootUrl, c = Wt.Shapes.AlloyWheelFolder, g = Wt.Shapes.AlloyWheelFileName;
    let w = t || "Wheel";
    return w = this.getNextIncrementalName(w), await this.importPrimitiveShapeAsync(o, a + c, g, e, w, s);
  }
  async createTryonReferenceGlassesFrameAsync(e, t, s) {
    const o = Wt.TryonReferences.ReferenceGlassesFrameName, a = Wt.TryonReferences.RootUrl, c = Wt.TryonReferences.ReferenceGlassesFrameFileName;
    let g = t || "Reference Glasses Frame";
    return g = this.getNextIncrementalName(g), await this.importPrimitiveShapeAsync(o, a, c, e, g, s);
  }
  async createTryOnReferenceModelsAsync(e, t, s, o) {
    return await this.importPrimitiveShapeAsync(
      "",
      Wt.TryonReferences.RootUrl,
      s,
      e,
      t,
      o,
      !0
    );
  }
  async importPrimitiveShapeAsync(e, t, s, o, a, c, g = !1) {
    let w = [], T = await BABYLON.SceneLoader.ImportMeshAsync(e, t, s, this._scene, c);
    if (T && T.meshes) {
      w = T.meshes;
      for (let H = 0; H < w.length; H++) {
        let Y = w[H];
        if (Y.name === "__root__") {
          let ee = Y.getChildMeshes();
          for (let z = 0; z < ee.length; z++) {
            let he = ee[z];
            he.parent = null;
          }
          Y.dispose(), w.splice(H--, 1);
          continue;
        }
        Y.id = Zakeke.generateUUID(), o && (Y.parent = o);
      }
    }
    return w;
  }
  setTryOnReferenceVisible(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((s) => {
      s.isVisible = e;
    });
  }
  setTryOnReferenceEnabled(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((s) => {
      s.setEnabled(e);
    });
  }
  isTryOnReferenceVisible() {
    const { tryonReferencesModels: e } = this.getVTOMeshes();
    return e.length > 0 && e[0].isVisible;
  }
  transformEntireScene(e, t, s, o) {
    var c;
    const a = (c = this._scene) == null ? void 0 : c.meshes;
    a == null || a.forEach((g) => {
      g.parent == null && g.setParent(o);
    }), e && (o.position = new BABYLON.Vector3(e.x, e.y, e.z)), t && (o.rotation = new BABYLON.Vector3(t.x, t.y, t.z)), s && (o.scaling = new BABYLON.Vector3(s.x, s.y, s.z)), a == null || a.forEach((g) => {
      g.parent == o && g.setParent(null);
    });
  }
  scaleSceneToTryonReferenceModels(e) {
    this.setSceneScalePercentageForVTO(100, e), this.setScenePositionPercentageForVTO(0, 0, 0, e);
  }
  getSceneScalingPercentageForVTO() {
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return 100;
    const s = this._scene.getWorldExtends((z) => t.includes(z)), o = this._scene.getWorldExtends((z) => e.includes(z)), a = s.max.x - s.min.x, c = s.max.y - s.min.y, g = s.max.z - s.min.z, w = o.max.x - o.min.x, T = o.max.y - o.min.y, H = o.max.z - o.min.z;
    return 1 / Math.min(
      a / w,
      c / T,
      g / H
    ) * 100;
  }
  setSceneScalePercentageForVTO(e, t) {
    const { userMeshes: s, tryonReferencesModels: o } = this.getVTOMeshes();
    if (o.length === 0 || s.length === 0)
      return;
    const a = this._scene.getWorldExtends((se) => o.includes(se)), c = this._scene.getWorldExtends((se) => s.includes(se)), g = a.max.x - a.min.x, w = a.max.y - a.min.y, T = a.max.z - a.min.z, H = c.max.x - c.min.x, Y = c.max.y - c.min.y, ee = c.max.z - c.min.z, z = Math.min(
      g / H,
      w / Y,
      T / ee
    ), { x: he, y: ne, z: ye } = this.getScenePositionPercentageForVTO();
    s.filter((se) => !se.parent).forEach((se) => {
      se.scaling.scaleInPlace(z), se.scaling.scaleInPlace(e / 100), t === "shoes" && se.scaling.scaleInPlace(1.3);
    }), this.setScenePositionPercentageForVTO(he, ne, ye);
  }
  getScenePositionPercentageForVTO() {
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return { x: 0, y: 0, z: 0 };
    const s = this._scene.getWorldExtends((w) => t.includes(w)), o = this._scene.getWorldExtends((w) => e.includes(w)), a = s.max.add(s.min).scale(0.5), g = o.max.add(o.min).scale(0.5).subtract(a);
    return {
      x: g.x / (s.max.x - s.min.x) * 100,
      y: g.y / (s.max.y - s.min.y) * 100,
      z: g.z / (s.max.z - s.min.z) * 100
    };
  }
  setScenePositionPercentageForVTO(e, t, s, o) {
    const { userMeshes: a, tryonReferencesModels: c } = this.getVTOMeshes();
    if (c.length === 0 || a.length === 0)
      return;
    const g = this._scene.getWorldExtends((z) => c.includes(z)), w = this._scene.getWorldExtends((z) => a.includes(z)), T = g.max.add(g.min).scale(0.5), H = w.max.add(w.min).scale(0.5), Y = T.subtract(H), ee = new BABYLON.Vector3(
      e / 100 * (g.max.x - g.min.x),
      t / 100 * (g.max.y - g.min.y),
      s / 100 * (g.max.z - g.min.z)
    );
    a.filter((z) => !z.parent).forEach((z) => {
      z.position.addInPlace(Y), z.position.addInPlace(ee), o === "shoes" && (console.log("shoes down and scale up to 0.3"), z.position.y = 0);
    });
  }
  getSceneRotationForVTO() {
    var c;
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return { x: 0, y: 0, z: 0 };
    const s = e.filter((g) => !g.parent)[0], o = ((c = s.rotationQuaternion) == null ? void 0 : c.toEulerAngles()) ?? s.rotation, a = {
      x: o.x / Math.PI * 180,
      y: o.y / Math.PI * 180,
      z: o.z / Math.PI * 180
    };
    return a.x = a.x < 0 ? 360 + a.x : a.x, a.y = a.y < 0 ? 360 + a.y : a.y, a.z = a.z < 0 ? 360 + a.z : a.z, a;
  }
  setSceneRotationForVTO(e, t, s) {
    const { userMeshes: o, tryonReferencesModels: a } = this.getVTOMeshes();
    if (a.length === 0 || o.length === 0)
      return;
    const c = new BABYLON.Vector3(e / 180 * Math.PI, t / 180 * Math.PI, s / 180 * Math.PI);
    o.filter((g) => !g.parent).forEach((g) => {
      g.rotation = c;
    });
  }
  setVTOReferenceVisible(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((s) => {
      s.isVisible = e;
    });
  }
  replaceTransformNodeWithMesh(e) {
    let t = null;
    if (this._scene) {
      const s = e.parent, o = e.getChildren();
      t = new BABYLON.Mesh(e.name, this._scene, s), t.id = Zakeke.generateUUID(), t.scaling = e.scaling.clone(), t.position = e.position.clone(), t.rotation = e.rotation.clone(), e.rotationQuaternion && (t.rotationQuaternion = e.rotationQuaternion.clone()), o.forEach((a) => a.parent = t), e.dispose(), e.animations.forEach((a) => {
        t.animations.push(a.clone());
      }), this._scene.animationGroups.forEach((a) => {
        a.targetedAnimations.forEach((c) => {
          c.target === e && (c.target = t);
        });
      }), this._scene.skeletons.forEach((a) => {
        a.bones.forEach((c) => {
          c.getTransformNode() === e && c.linkTransformNode(t);
        });
      });
    }
    return t;
  }
  // import 3d model from a remote url
  async importMeshesFromUrlAsync(e, t, s, o, a, c) {
    let g;
    BABYLON.GLTFFileLoader.IncrementalLoading = !1, BABYLON.SceneLoader.OnPluginActivatedObservable.add((he) => {
      g = he.name;
    });
    let w = [];
    const T = await BABYLON.SceneLoader.ImportMeshAsync(
      "",
      e,
      void 0,
      this._scene,
      s,
      a
    );
    T && (T.meshes.forEach((he) => {
      he.id = Zakeke.generateUUID(), w.push(he), this.getMeshMaterials(he).forEach((ye) => ye.id = Zakeke.generateUUID());
    }), T.transformNodes.forEach((he) => {
      he.id = Zakeke.generateUUID();
      const ne = this.replaceTransformNodeWithMesh(he);
      ne && w.push(ne);
    }), T.geometries.forEach((he) => he.id = Zakeke.generateUUID()));
    let H = BABYLON.Tools.GetFilename(e), Y = H, ee = H.lastIndexOf(".");
    ee !== -1 && (Y = H.substr(0, ee));
    const z = w.filter((he) => !he.parent);
    if (z.length > 1 || z.length === 1 && z[0].name !== "__root__") {
      const he = new BABYLON.Mesh(Y, this._scene);
      he.id = Zakeke.generateUUID(), he.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, w.push(he), z.forEach((ne) => {
        ne.setParent(he);
      }), g === "obj" && (he.scaling = new BABYLON.Vector3(-he.scaling.x, he.scaling.y, he.scaling.z), he.rotation = new BABYLON.Vector3(0, Math.PI, 0));
    } else if (z.length === 1) {
      const he = z[0];
      if (he.name === "__root__") {
        let ye = BABYLON.Tools.GetFilename(e), se = H.lastIndexOf(".");
        se !== -1 && (ye = H.substring(0, se)), he.name = ye, g === "obj" && (he.scaling = new BABYLON.Vector3(-he.scaling.x, he.scaling.y, -he.scaling.z), he.rotation = new BABYLON.Vector3(0, Math.PI, 0));
      }
      if (["gltf", "glb", "obj"].includes(g)) {
        he.name += "_transforms", he.metadata = {
          isGltfTransformNode: !0
        };
        const ye = new BABYLON.Mesh(Y, this._scene);
        ye.id = Zakeke.generateUUID(), ye.metadata = {
          isRealMesh: !0,
          isGroup: !0
        }, w.push(ye), he.parent = ye;
      }
    }
    if (!c && g === "gltf" || g === "glb") {
      const he = [];
      w.forEach((ne) => {
        if (ne instanceof BABYLON.Mesh) {
          const se = BABYLON.VertexData.ExtractFromMesh(ne), _e = ["uvs", "uvs2", "uvs3", "uvs4", "uvs5", "uvs6"];
          for (const ue of _e)
            if (se && se[ue] && se[ue].length > 0)
              for (let xe = 0; xe < se[ue].length; xe += 2)
                se[ue][xe + 1] = 1 - se[ue][xe + 1];
          se.applyToMesh(ne);
        }
        this.getMeshMaterials(ne).forEach((se) => {
          he.includes(se) || he.push(se);
        });
      }), he.forEach((ne) => {
        ne.getActiveTextures().forEach((ye) => {
          ye instanceof BABYLON.Texture && (ye.vScale *= -1);
        });
      });
    }
    return this.adjustCamera(g, !1, !1, o, !0), this.setupShaderMaterialsCameraPosition(), w;
  }
  setupShaderMaterialsCameraPosition() {
    if (this._scene)
      for (let t = 0; t < this._scene.materials.length; t++) {
        var e = this._scene.materials[t];
        this.setupShaderMaterialCameraPosition(e);
      }
  }
  setupShaderMaterialCameraPosition(e) {
    if (this._scene && e && e instanceof BABYLON.ShaderMaterial) {
      const t = this._scene.activeCamera;
      t && e.setVector3("cameraPosition", t.position);
    }
  }
  getSceneCmScalingFactor(e = null, t = null) {
    let s = null;
    if (this._scene) {
      let a = null;
      for (let c = 0; c < this._scene.meshes.length; c++) {
        var o = this._scene.meshes[c];
        if (o.metadata && o.metadata.sizecm) {
          a = o;
          break;
        }
      }
      if (e && t && (a = t), a) {
        const c = a.getHierarchyBoundingVectors(), g = c.min, w = c.max, T = w.subtract(g);
        if (isFinite(T.length())) {
          const H = w.x - g.x, Y = w.y - g.y, ee = w.z - g.z, z = e || a.metadata.sizecm;
          return z.width !== void 0 && typeof z.width == "number" && !isNaN(z.width) && H !== 0 ? s = z.width / H : z.height !== void 0 && typeof z.height == "number" && !isNaN(z.height) && Y !== 0 ? s = z.height / Y : z.depth !== void 0 && typeof z.depth == "number" && !isNaN(z.depth) && ee !== 0 && (s = z.depth / ee), s;
        }
      }
    }
    return s;
  }
  async exportSceneToUsdzAsync(e, t, s, o, a = null, c = null, g = !0) {
    const w = this.getMeshesForAR();
    let T = e || "scene";
    return T = T.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      T,
      t,
      w,
      s,
      o,
      "usdz",
      a,
      c,
      g
    );
  }
  async exportMeshToUsdzAsync(e, t, s = null, o = null, a = !0) {
    const c = this.getMeshHierarchy(t.id);
    let g = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      g,
      e,
      c,
      void 0,
      void 0,
      "usdz",
      s,
      o,
      a
    );
  }
  async exportSceneToRemoteGlTFAsync(e, t, s, o, a = null, c = null, g = !0) {
    const w = this.getMeshesForAR();
    let T = e || "scene";
    return T = T.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      T,
      t,
      w,
      s,
      o,
      "glTF",
      a,
      c,
      g
    );
  }
  async exportMeshToRemoteGlTFAsync(e, t, s = null, o = null, a = !0) {
    const c = this.getMeshHierarchy(t.id);
    let g = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      g,
      e,
      c,
      void 0,
      void 0,
      "glTF",
      s,
      o,
      a
    );
  }
  async exportSceneToRemoteGLBAsync(e, t, s, o, a = null, c = null, g = !0) {
    const w = this.getMeshesForAR();
    let T = e || "scene";
    return T = T.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      T,
      t,
      w,
      s,
      o,
      "glb",
      a,
      c,
      g
    );
  }
  async exportMeshToRemoteGLBAsync(e, t, s = null, o = null, a = !0) {
    const c = this.getMeshHierarchy(t.id);
    let g = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      g,
      e,
      c,
      void 0,
      void 0,
      "glb",
      s,
      o,
      a
    );
  }
  async exportSceneToARMultiformatAsync(e, t, s = ["usdz", "glb", "png"], o, a, c = null, g = null, w = !0) {
    const T = this.getMeshesForAR();
    let H = e || "scene";
    return H = H.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARMultiformatAsync(
      H,
      t,
      T,
      s,
      c,
      g,
      w,
      o,
      a
    );
  }
  async exportMeshToARMultiformatAsync(e, t, s = ["usdz", "glb", "png"], o = null, a = null, c = !0, g, w) {
    const T = this.getMeshHierarchy(t.id);
    let H = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARMultiformatAsync(
      H,
      e,
      T,
      s,
      o,
      a,
      c,
      g,
      w
    );
  }
  convertGltfTransformNodes(e) {
    const t = [];
    return e.filter((s) => s.metadata && s.metadata.isGltfTransformNode).forEach((s) => {
      const o = new BABYLON.TransformNode(s.name + "-transform-node", this._scene);
      o.scaling.z = -1;
      const a = new BABYLON.Quaternion();
      a.set(0, 1, 0, 0), o.rotationQuaternion = a, t.push([s, s.parent, o]), s.setParent(o);
    }), t;
  }
  restoreGltfTransformNodes(e) {
    e.forEach(([t, s, o]) => {
      t.setParent(s), o.dispose();
    });
  }
  async getGltfBlobForARExport(e, t, s) {
    var w;
    const o = this.convertGltfTransformNodes(s);
    (w = this._scene) == null || w.render();
    const a = {
      meshes: s,
      materials: this.getMeshesMaterials(s),
      transformNodes: this._scene.transformNodes,
      lights: void 0,
      exportTextureUrls: t != null,
      rootUrl: t,
      shouldExportNode: (T) => {
        for (let H = 0; H < s.length; H++)
          if (s[H] === T)
            return !0;
        return !1;
      }
    }, c = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, a);
    if (c) {
      const T = new JSZip(), H = c.serverImages && c.glTFFiles.hasOwnProperty("TextureUrls.txt") ? c.serverImages : [];
      for (var g in c.glTFFiles)
        if (H.indexOf(g) === -1) {
          let ee = c.glTFFiles[g];
          gr.EndsWith(g, ".gltf") || gr.EndsWith(g, ".bin") ? T.file(g, ee, {
            compression: "DEFLATE",
            compressionOptions: {
              level: 9
              // force a compression and a compression level for this file
            }
          }) : T.file(g, ee, {
            compression: "STORE"
            // no compression
          });
        }
      this.restoreGltfTransformNodes(o), this._scene.render();
      let Y = await T.generateAsync({ type: "blob" });
      if (Y)
        return Y = Y, Y.lastModifiedDate = /* @__PURE__ */ new Date(), Y.name = "arobj.zip", Y;
    }
    return null;
  }
  async exportMeshToGLBBlob(e, t) {
    const s = this.getTryOnMeshHierarchy(t), o = this.convertGltfTransformNodes(s), a = {
      meshes: s,
      materials: this.getMeshesMaterials(s),
      transformNodes: void 0,
      lights: void 0,
      exportTextureUrls: e != null,
      rootUrl: e,
      shouldExportNode: (w) => {
        for (let T = 0; T < s.length; T++)
          if (s[T] === w)
            return !0;
        return !1;
      }
    }, c = await BABYLON.GLTF2Export.GLBAsync(this._scene, "model", a).catch((w) => (console.error(w), null));
    let g = null;
    if (c && c.glTFFiles) {
      for (let w in c.glTFFiles)
        if (gr.EndsWith(w, ".glb")) {
          const T = new cf(), H = await c.glTFFiles[w].arrayBuffer(), Y = T.readBinary(H);
          Y.getRoot().listNodes().filter((he) => he.getParent() === null || he.getParent() instanceof io).forEach((he) => {
          });
          const z = T.writeBinary(Y);
          g = new Blob([z], { type: "model/gltf-binary" });
        }
    }
    return this.restoreGltfTransformNodes(o), g;
  }
  async exportMeshesToARAsync(e, t, s, o, a, c = "usdz", g = null, w = null, T = !0) {
    let H = "";
    if (o && a && Zakeke.config) {
      const Y = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + o + "/" + a + "/" + c;
      try {
        H = await jQuery.ajax({
          url: Y,
          cache: !1,
          contentType: !1,
          processData: !1,
          type: "GET"
        });
      } catch {
        H = "";
      }
    }
    if (!H) {
      let Y = this.getSceneCmScalingFactor(g, w);
      const ee = await this.getGltfBlobForARExport(e, t, s);
      if (ee) {
        const z = {
          flipTextures: !0,
          formats: [c]
        };
        o && (z.sceneID = o), a && (z.sceneCode = a), Y && (z.scale = Y);
        let he = !0;
        window.isOwin != null && (he = window.isOwin);
        const ye = await new Tf("artasks", window.token, he).upload(ee, z);
        ye && ye.length > 0 && (H = ye[0].arFileUrl);
      }
    }
    return H;
  }
  async exportMeshesToARMultiformatAsync(e, t, s, o = ["usdz", "glb", "png"], a = null, c = null, g = !0, w, T) {
    let H = [], Y = [];
    if (w && T && Zakeke.config)
      for (let ee = 0; ee < o.length; ee++) {
        const z = o[ee], he = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + w + "/" + T + "/" + z;
        try {
          const ne = await jQuery.ajax({
            url: he,
            cache: !1,
            contentType: !1,
            processData: !1,
            type: "GET"
          });
          ne && Y.push({ format: z, arFileUrl: ne });
        } catch {
        }
        H = Y;
      }
    if (Y.length !== o.length) {
      const ee = this.getSceneCmScalingFactor(a, c), z = Y.map((ye) => ye.format), he = o.filter((ye) => !z.includes(ye)), ne = await this.getGltfBlobForARExport(e, t, s);
      if (ne) {
        const ye = {
          flipTextures: !0,
          formats: he
          // Escludo i formati cachati
        };
        w && (ye.sceneID = w), T && (ye.sceneCode = T), ee && (ye.scale = ee);
        let se = !0;
        window.isOwin !== void 0 && (se = window.isOwin);
        const ue = await new Tf("artasks", window.token, se).upload(ne, ye);
        if (ue && ue.length > 0)
          for (const xe of ue)
            xe && xe.arFileUrl && H.push({ format: xe.format, arFileUrl: xe.arFileUrl });
      }
    }
    return H;
  }
  // Metodi per esportazione on-the-fly client side
  async exportSceneToLocalGlTFBlobsAsync() {
    const e = Zakeke.generateUUID(), t = this.getSceneToGltfExportOptions(), s = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, t);
    let o = [];
    for (let a in s.glTFFiles)
      o.push(s.glTFFiles[a]);
    return o;
  }
  async exportSceneToLocalGlTFUrlsAsync() {
    const e = [], t = Zakeke.generateUUID(), s = this.getSceneToGltfExportOptions(), o = await BABYLON.GLTF2Export.GLTFAsync(this._scene, t, s);
    if (o)
      for (let c in o.glTFFiles) {
        var a = o.glTFFiles[c];
        e.push(this.getGltfFileUrl(c, a));
      }
    return e;
  }
  async downloadSceneLocalGltfAsync() {
    const e = Zakeke.generateUUID(), t = this.getSceneToGltfExportOptions(), s = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, t);
    s && s.downloadFiles();
  }
  async exportSceneToLocalGLBBlobAsync() {
    const e = await this.getSceneLocalGLBBlobInfoAsync();
    return e ? e.blob : null;
  }
  async exportSceneToLocalGLBBase64Async() {
    let e = null;
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    if (t && t.blob instanceof Blob) {
      let s = new FileReader();
      s.readAsDataURL(t.blob), s.onloadend = () => {
        let o = s.result;
        typeof o == "string" && (e = o);
      };
    }
    return e;
  }
  async exportSceneToLocalGLBUrlAsync() {
    let e = null;
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    return t && t.name && t.blob instanceof Blob && (e = this.getGltfFileUrl(t.name, t.blob)), e;
  }
  async downloadSceneLocalGLBAsync() {
    var s;
    (s = this._scene) == null || s.meshes.forEach((o) => {
      o.isVisible = !0;
    });
    const e = await this.getSceneLocalGLBBlobInfoAsync();
    if (e && e.name && e.blob instanceof Blob) {
      let o = this.getGltfFileUrl(e.name, e.blob);
      var t = document.createElement("a");
      document.body.appendChild(t), t.setAttribute("type", "hidden"), t.download = e.name, t.href = o, t.click(), document.body.removeChild(t), URL.revokeObjectURL(o);
    }
  }
  async getSceneLocalGLBBlobInfoAsync(e = null, t = null) {
    let s = {
      name: null,
      blob: null
    };
    const o = Zakeke.generateUUID(), a = this.getSceneToGltfExportOptions();
    let c = await BABYLON.GLTF2Export.GLBAsync(this._scene, o, a).catch((g) => (console.error(g), null));
    if (c && c.glTFFiles) {
      for (let g in c.glTFFiles)
        if (gr.EndsWith(g, ".glb")) {
          let w = this.getSceneCmScalingFactor(), T = 1;
          w && (T = w / 100);
          const H = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.Y, 2 * Math.PI), Y = new cf(), ee = await c.glTFFiles[g].arrayBuffer(), z = Y.readBinary(ee), he = z.getRoot().listNodes().filter((ue) => ue.getParent() === null || ue.getParent() instanceof io), ne = [0, 1, 0, 0], ye = he.every((ue) => {
            const xe = ue.getRotation();
            return ne.length === xe.length && ne.every((Ee, K) => Ee === xe[K]);
          });
          he.forEach((ue) => {
            ue.setScale([T, T, T]), ye && ue.setRotation([H.x, H.y, H.z, H.w]);
          });
          const se = Y.writeBinary(z), _e = new Blob([se], { type: "model/gltf-binary" });
          s.name = g, s.blob = _e;
          break;
        }
    }
    return s;
  }
  // -----------------------------------------------------------------------
  // Metodi per exportazione della scena in USDZ su client (on-the-fly)
  async exportSceneToLocalUSDZBlobAsync() {
    const e = await this.getSceneLocalUSDZBlobInfoAsync();
    return e ? e.blob : null;
  }
  async exportSceneToLocalUSDZBase64Async() {
    let e = null;
    const t = await this.getSceneLocalUSDZBlobInfoAsync();
    if (t && t.blob instanceof Blob) {
      let s = new FileReader();
      s.readAsDataURL(t.blob), s.onloadend = () => {
        let o = s.result;
        typeof o == "string" && (e = o);
      };
    }
    return e;
  }
  async exportSceneToLocalUSDZUrlAsync() {
    let e = null;
    const t = await this.getSceneLocalUSDZBlobInfoAsync();
    return t && t.name && t.blob instanceof Blob && (e = this.getUsdzFileUrl(t.name, t.blob)), e;
  }
  async downloadSceneLocalUSDZAsync() {
    const e = await this.getSceneLocalUSDZBlobInfoAsync();
    if (e && e.name && e.blob instanceof Blob) {
      let s = this.getUsdzFileUrl(e.name, e.blob);
      var t = document.createElement("a");
      document.body.appendChild(t), t.setAttribute("type", "hidden"), t.download = e.name, t.href = s, t.click(), document.body.removeChild(t), URL.revokeObjectURL(s);
    }
  }
  async getSceneLocalUSDZBlobInfoAsync() {
    let e = {
      name: null,
      blob: null
    };
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    if (t && t.name && t.blob && t.blob instanceof Blob) {
      const s = this.getGltfFileUrl(t.name, t.blob), o = await ex.convertGlbToUsdz(s);
      e.name = t.name.replace(".glb", ".usdz"), e.blob = o;
    }
    return e;
  }
  // -----------------------------------------------------------------------
  getSceneToGltfExportOptions() {
    var e = this.getMeshesForAR(), t = {
      meshes: e,
      materials: this.getMeshesMaterials(e),
      transformNodes: void 0,
      lights: void 0,
      exportTextureUrls: !1,
      rootUrl: null,
      shouldExportNode: (s) => {
        for (var o = 0; o < e.length; o++)
          if (e[o] === s)
            return !0;
        return !1;
      }
    };
    return t;
  }
  getGltfFileUrl(e, t) {
    var s = void 0;
    return gr.EndsWith(e, ".glb") ? s = { type: "model/gltf-binary" } : gr.EndsWith(e, ".bin") ? s = { type: "application/octet-stream" } : gr.EndsWith(e, ".gltf") ? s = { type: "model/gltf+json" } : gr.EndsWith(e, ".jpeg") ? s = { type: "image/jpeg" } : gr.EndsWith(e, ".png") && (s = { type: "image/png" }), window.URL.createObjectURL(new Blob([t], s));
  }
  getUsdzFileUrl(e, t) {
    var s = { type: "model/vnd.usdz+zip" };
    return window.URL.createObjectURL(new Blob([t], s));
  }
  exportSceneToBabylon() {
    const e = BABYLON.SceneSerializer.Serialize(this._scene);
    return JSON.stringify(e);
  }
  exportVisibleMeshesToBabylon() {
    const e = this.getVisibleMeshes(), t = BABYLON.SceneSerializer.SerializeMesh(e, !1, !1);
    return JSON.stringify(t);
  }
  downloadImageFromBase64(e, t, s) {
    var o = document.createElement("a");
    o.href = e, o.download = t, o.click(), o.remove();
  }
  getStandardMaterialTextureType(e, t) {
    return e.diffuseTexture === t ? "diffuse" : e.emissiveTexture === t ? "emissive" : e.ambientTexture === t ? "ambient" : e.lightmapTexture === t ? "lightmap" : e.opacityTexture === t ? "opacity" : e.specularTexture === t ? "specular" : e.reflectionTexture === t ? "reflection" : e.refractionTexture === t ? "refraction" : e.bumpTexture === t ? "bump" : null;
  }
  getPBRMetallicRoughnessMaterialTextureType(e, t) {
    return e.environmentTexture === t ? "environment" : e.normalTexture === t ? "normal" : e.emissiveTexture === t ? "emissive" : e.occlusionTexture === t ? "occlusion" : e.baseTexture === t ? "base" : e.metallicRoughnessTexture === t ? "metallicRoughness" : null;
  }
  getPBRSpecularGlossinessMaterialTextureType(e, t) {
    return e.environmentTexture === t ? "environment" : e.normalTexture === t ? "normal" : e.emissiveTexture === t ? "emissive" : e.occlusionTexture === t ? "occlusion" : e.diffuseTexture === t ? "diffuse" : e.specularGlossinessTexture === t ? "specularGlossiness" : null;
  }
  getPBRMaterialTextureType(e, t) {
    if (e.cameraColorGradingTexture === t)
      return "cameraColorGrading";
    if (e.albedoTexture === t)
      return "albedo";
    if (e.ambientTexture === t)
      return "ambient";
    if (e.opacityTexture === t)
      return "opacity";
    if (e.reflectionTexture === t)
      return "reflection";
    if (e.emissiveTexture === t)
      return "emissive";
    if (e.reflectivityTexture === t)
      return "reflectivity";
    if (e.metallicTexture === t)
      return "metallic";
    if (e.microSurfaceTexture === t)
      return "microSurface";
    if (e.bumpTexture === t)
      return "bump";
    if (e.lightmapTexture === t)
      return "lightmap";
    if (e.refractionTexture === t)
      return "refraction";
    if (e.clearCoat) {
      if (e.clearCoat.texture === t)
        return "clearCoat";
      if (e.clearCoat.bumpTexture === t)
        return "clearCoat_bump";
      if (e.clearCoat.tintTexture === t)
        return "clearCoat_tint";
      if (e.clearCoat.textureRoughness === t)
        return "clearCoat_textureRoughness";
      if (e.clearCoat.texture === t)
        return "clearCoat_texture";
    }
    if (e.anisotropy && e.anisotropy.texture === t)
      return "anisotropy_texture";
    if (e.sheen) {
      if (e.sheen.texture === t)
        return "sheen_texture";
      if (e.sheen.textureRoughness === t)
        return "sheen_textureRoughness";
    }
    if (e.subSurface) {
      if (e.subSurface.thicknessTexture === t)
        return "subSurface_thickness";
      if (e.subSurface.refractionIntensityTexture === t)
        return "subSurface_refractionIntensity";
      if (e.subSurface.translucencyIntensityTexture === t)
        return "subSurface_translucencyIntensity";
    }
    return null;
  }
  getZakekePBRMaterialTextureType(e, t) {
    return e.albedoTexture === t ? "albedo" : e.bumpTexture === t ? "bump" : e.reflectionTexture === t ? "reflection" : e.matCapReflectionTexture === t ? "matCapReflection" : e.reflectivityTexture === t ? "reflectivity" : e.microsurfaceTexture === t ? "microsurface" : e.ambientTexture === t ? "ambient" : e.aoTexture === t ? "ao" : e.opacityTexture === t ? "opacity" : null;
  }
  getMaterialTextureType(e, t) {
    return e instanceof BABYLON.StandardMaterial ? this.getStandardMaterialTextureType(e, t) : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? this.getPBRMetallicRoughnessMaterialTextureType(e, t) : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? this.getPBRSpecularGlossinessMaterialTextureType(e, t) : e instanceof BABYLON.PBRMaterial ? this.getPBRMaterialTextureType(e, t) : e instanceof Zakeke.PBRMaterial ? this.getZakekePBRMaterialTextureType(e, t) : null;
  }
  getMaterialTexture(e, t) {
    if (e instanceof BABYLON.StandardMaterial)
      switch (t) {
        case "diffuse":
          return e.diffuseTexture;
        case "emissive":
          return e.emissiveTexture;
        case "ambient":
          return e.ambientTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "opacity":
          return e.opacityTexture;
        case "specular":
          return e.specularTexture;
        case "reflection":
          return e.reflectionTexture;
        case "refraction":
          return e.refractionTexture;
        case "bump":
          return e.bumpTexture;
      }
    else if (e instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (t) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          return e[`${t}Texture`];
      }
    else if (e instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (t) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          return e[`${t}Texture`];
      }
    else if (e instanceof BABYLON.PBRMaterial)
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          return e[`${t}Texture`];
        case "refraction":
          return e.refractionTexture;
        case "environmentBRDF":
          return e.environmentBRDFTexture;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
      }
    else if (e instanceof Zakeke.PBRMaterial)
      switch (t) {
        case "albedo":
          return e.albedoTexture;
        case "bump":
          return e.bumpTexture;
        case "reflection":
          return e.reflectionTexture;
        case "matCapReflection":
          return e.matCapReflectionTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "microsurface":
          return e.microsurfaceTexture;
        case "ambient":
          return e.ambientTexture;
        case "ao":
          return e.aoTexture;
        case "opacity":
          return e.opacityTexture;
      }
    return null;
  }
  applyTexture(e, t, s) {
    if (e && s == "lightmap" && (e.coordinatesIndex = 1, (t instanceof BABYLON.StandardMaterial || t instanceof BABYLON.PBRMaterial || t instanceof BABYLON.PBRBaseSimpleMaterial) && (t.useLightmapAsShadowmap = !0)), t instanceof BABYLON.StandardMaterial)
      switch (s) {
        case "diffuse":
          t.diffuseTexture = e;
          break;
        case "emissive":
          t.emissiveTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "lightmap":
          t.lightmapTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
        case "specular":
          t.specularTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (s) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          t[`${s}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (s) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          t[`${s}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMaterial)
      switch (s) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          t[`${s}Texture`] = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else if (t instanceof BABYLON.ShaderMaterial)
      e && e instanceof BABYLON.Texture ? t.setTexture(s, e) : t.removeTexture(s);
    else if (t instanceof Zakeke.PBRMaterial)
      switch (s) {
        case "albedo":
          t.albedoTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "matCapReflection":
          t.matCapReflectionTexture = e;
          break;
        case "reflectivity":
          t.reflectivityTexture = e;
          break;
        case "microsurface":
          t.microsurfaceTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "ao":
          t.aoTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
      }
  }
  applyTextureOnSerializedMaterial(e, t, s, o) {
    if (e && s == "lightmap" && (e.coordinatesIndex = 1, (o === "BABYLON.StandardMaterial" || o === "BABYLON.PBRMaterial" || o === "BABYLON.PBRBaseSimpleMaterial") && (t.useLightmapAsShadowmap = !0)), o === "BABYLON.StandardMaterial")
      t[`${s}Texture`] = e;
    else if (o === "BABYLON.PBRMetallicRoughnessMaterial")
      t[`${s}Texture`] = e;
    else if (o === "BABYLON.PBRSpecularGlossinessMaterial")
      t[`${s}Texture`] = e;
    else if (o === "BABYLON.PBRMaterial")
      switch (s) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
        case "refraction":
          t[`${s}Texture`] = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else
      o === "Zakeke.PBRMaterial" && (t[`${s}Texture`] = e);
  }
  getSerializedMaterialTexture(e, t, s) {
    if (s === "BABYLON.StandardMaterial")
      return e[`${t}Texture`];
    if (s === "BABYLON.PBRMetallicRoughnessMaterial")
      return e[`${t}Texture`];
    if (s === "BABYLON.PBRSpecularGlossinessMaterial")
      return e[`${t}Texture`];
    if (s === "BABYLON.PBRMaterial")
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
        case "refraction":
          return e[`${t}Texture`];
        case "environmentBRDF":
          return e.environmentBRDFTexture;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
      }
    else if (s === "Zakeke.PBRMaterial")
      return e[`${t}Texture`];
    return null;
  }
  getMaterialTypeName(e) {
    return e instanceof BABYLON.StandardMaterial ? "BABYLON.StandardMaterial" : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? "BABYLON.PBRMetallicRoughnessMaterial" : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "BABYLON.PBRSpecularGlossinessMaterial" : e instanceof BABYLON.PBRMaterial ? "BABYLON.PBRMaterial" : e instanceof BABYLON.ShaderMaterial ? "BABYLON.ShaderMaterial" : e instanceof Zakeke.PBRMaterial ? "Zakeke.PBRMaterial" : "BABYLON.StandardMaterial";
  }
  async exportMeshToBabylon(e) {
    const t = this.getMeshHierarchy(e.id);
    return await this.exportMeshesToBabylon(t);
  }
  async exportMeshesToBabylon(e) {
    const t = this.getMeshesMaterials(e), s = e.map((a) => ({ id: a.id, doNotSerialize: a.doNotSerialize })), o = t.map((a) => ({ id: a.id, doNotSerialize: a.doNotSerialize }));
    e.forEach((a) => a.doNotSerialize = !1), t.forEach((a) => a.doNotSerialize = !1);
    try {
      const a = {};
      for (let w = 0; w < t.length; w++) {
        const T = t[w], H = T.id, Y = this.getMaterialDynamicTextures(T);
        if (Y.length > 0) {
          a[H] = {
            materialType: this.getMaterialTypeName(T),
            textures: []
          };
          for (let ee = 0; ee < Y.length; ee++) {
            const z = Y[ee], he = Zakeke.generateUUID(), ne = this.getMaterialTextureType(T, z), ye = await this.exportTextureToBase64Async(z, "image/png");
            if (ne && ye) {
              const se = {
                id: he,
                type: ne,
                base64String: ye,
                isProcedural: z instanceof BABYLON.ProceduralTexture
              };
              a[H].textures.push(se);
            }
          }
        }
      }
      const c = BABYLON.SceneSerializer.SerializeMesh(e, !1, !1);
      for (const w of c.materials) {
        const T = Object.getOwnPropertyNames(w).filter(
          (Y) => Y.slice(-7) === "Texture" && typeof w[Y] == "object"
        ), H = w.id;
        if (a.hasOwnProperty(H)) {
          const Y = a[H], ee = Y.materialType, z = Y.textures;
          for (const he of z) {
            const ne = this.getSerializedMaterialTexture(
              w,
              he.type,
              Y.materialType
            );
            if (ne) {
              if (he.isProcedural) {
                const ye = new BABYLON.Texture(
                  he.base64String,
                  this._scene,
                  void 0,
                  void 0,
                  void 0,
                  void 0
                );
                await hn.whenTextureIsReadyAsync(ye), ye.uScale = ne.uScale, ye.vScale = ne.vScale, ye.uOffset = ne.uOffset, ye.vOffset = ne.vOffset, ye.uAng = ne.uAng, ye.vAng = ne.vAng, ye.level = ne.level, ye.coordinatesIndex = ne.coordinatesIndex, ye.coordinatesMode = ne.coordinatesMode, ye.wrapU = ne.wrapU, ye.wrapV = ne.wrapV;
                const se = ye.serialize();
                se.url = he.base64String, se.name = "prcedural texture", this.applyTextureOnSerializedMaterial(
                  se,
                  w,
                  he.type,
                  ee
                ), ye.dispose();
              }
            } else
              ne.url = he.base64String, ne.name = "dynamic texture";
          }
        }
      }
      let g = JSON.stringify(c);
      return e.forEach((w) => {
        var T;
        return w.doNotSerialize = (T = s.find((H) => H.id === w.id)) == null ? void 0 : T.doNotSerialize;
      }), t.forEach(
        (w) => w.doNotSerialize = o.find((T) => T.id === w.id).doNotSerialize
      ), g;
    } finally {
      e.forEach((a) => {
        var c;
        return a.doNotSerialize = (c = s.find((g) => g.id === a.id)) == null ? void 0 : c.doNotSerialize;
      }), t.forEach(
        (a) => a.doNotSerialize = o.find((c) => c.id === a.id).doNotSerialize
      );
    }
  }
  async exportMeshesForTyOnToBabylon() {
    const e = this.getMeshesForTryOn();
    return await this.exportMeshesToBabylon(e);
  }
  downloadBlob(e) {
    const t = URL.createObjectURL(e), s = document.createElement("a");
    s.download = "mesh.json", s.href = t, s.click(), URL.revokeObjectURL(t);
  }
  async downloadMeshBabylonAsync(e) {
    const t = await this.exportMeshToBabylon(e);
    if (t) {
      const s = new Blob([t], { type: "application/json" });
      this.downloadBlob(s);
    }
  }
  async downloadMeshesBabylonAsync(e) {
    const t = await this.exportMeshesToBabylon(e);
    if (t) {
      const s = new Blob([t], { type: "application/json" });
      this.downloadBlob(s);
    }
  }
  async loadAllDelayedMaterialsAsync(e, t) {
    let s = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      var o = {};
      for (var a in this._scene.metadata.delayedMaterials)
        o[a] = {
          name: this._scene.metadata.delayedMaterials[a].name,
          file: this._scene.metadata.delayedMaterials[a].file
        };
      s = await this.loadMaterialsAsync(e, o, t);
    }
    return s;
  }
  async loadDelayedMaterialsAsync(e, t) {
    let s = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      for (var o = {}, a = 0; a < t.length; a++)
        this._scene.metadata.delayedMaterials.hasOwnProperty(t[a]) && (o[t[a]] = {
          name: this._scene.metadata.delayedMaterials[t[a]].name,
          file: this._scene.metadata.delayedMaterials[t[a]].file
        });
      s = await this.loadMaterialsAsync(e, o);
    }
    return s;
  }
  async loadDelayedMaterialAsync(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      var s = {};
      if (this._scene.metadata.delayedMaterials.hasOwnProperty(t)) {
        s[t] = {
          name: this._scene.metadata.delayedMaterials[t].name,
          file: this._scene.metadata.delayedMaterials[t].file
        };
        let o = await this.loadMaterialsAsync(e, s);
        if (o.length > 0)
          return o[0];
      }
    }
    return null;
  }
  async loadMaterialsAsync(e, t, s) {
    const o = [];
    let a = [];
    for (let g in t) {
      const w = this._scene.getMaterialByID(g);
      if (w)
        o.push(w);
      else {
        const T = t[g];
        a.push(this.loadMaterialInternalAsync(g, e, T.file));
      }
    }
    const c = await Promise.all(a);
    for (let g = 0; g < c.length; g++) {
      const w = c[g], T = JSON.parse(w), H = BABYLON.Material.Parse(T, this._scene, e);
      H && (Logger.info("Waiting for material ready: " + H.id + " - " + H.name), await hn.whenAllMaterialTexturesAreReady(H), Logger.info("Material ready: " + H.id + " - " + H.name), o.push(H), await (s == null ? void 0 : s(g + 1, c.length)));
    }
    return this.setupShaderMaterialsCameraPosition(), o;
  }
  loadMaterialInternalAsync(e, t, s) {
    if (Logger.info("Loading delayed material: " + e), this._loadingMaterials.hasOwnProperty(e))
      return this._loadingMaterials[e];
    let o = gr.EndsWith(t, "/") ? "" : "/";
    var a = t + o + s;
    let c = new Promise((g, w) => {
      BABYLON.Tools.LoadFile(
        a,
        (T) => {
          Logger.info("Loaded delayed material: " + e), g(T), delete this._loadingMaterials[e];
        },
        void 0,
        void 0,
        !1,
        (T, H) => {
          w(H), delete this._loadingMaterials[e];
        }
      );
    });
    return this._loadingMaterials[e] = c, c;
  }
  showMesh(e) {
    this.showHideMesh(e, !0);
  }
  hideMesh(e) {
    this.showHideMesh(e, !1);
  }
  showHideMesh(e, t) {
    var s = (a, c) => {
      a.isVisible = c;
      var g = a.getChildMeshes(!0);
      g && g.forEach((w) => {
        s(w, c);
      });
    }, o = this._scene.getMeshById(e);
    o && s(o, t);
  }
  changeMaterialColor(e, t, s) {
    for (let o = 0; o < this._scene.meshes.length && this._scene.meshes[o].material !== e; o++)
      ;
    t && e[t] !== void 0 && (e[t] = s);
  }
  applyMaterialByName(e, t) {
    if (this._scene) {
      let s = this._scene.getMaterialByName(e);
      s && this.applyMaterial(s, t);
    }
  }
  applyMaterial(e, t) {
    var s = (o) => {
      if (o.subMeshes && o.subMeshes.length > 0 && o.material && o.material instanceof BABYLON.MultiMaterial)
        for (let c = 0; c < o.subMeshes.length; c++) {
          let g = o.subMeshes[c];
          this.applyMaterialToSubMesh(e, o, g);
        }
      else
        o.material = e;
      var a = o.getChildMeshes(!0);
      a && a.forEach((c) => {
        s(c);
      });
    };
    t && s(t);
  }
  applyMaterialToSubMeshByName(e, t, s) {
    var o = this._scene.getMaterialByName(e);
    o && this.applyMaterialToSubMesh(o, t, s);
  }
  applyMaterialToSubMesh(e, t, s) {
    const o = s.materialIndex, a = t || s.getMesh();
    a.material instanceof BABYLON.MultiMaterial && o >= 0 && o < a.material.subMaterials.length && (a.material.subMaterials[o] = e);
  }
  getSubMeshMaterial(e, t) {
    const s = t.materialIndex, o = e || t.getMesh();
    return o.material instanceof BABYLON.MultiMaterial && s >= 0 && s < o.material.subMaterials.length ? o.material.subMaterials[s] : null;
  }
  async prefetchTexturesFormMeshAsync(e) {
    e.material && await this.prefetchTexturesForMaterialAsync(e.material);
    var t = e.getChildMeshes(!0);
    for (let s = 0; s < t.length; s++) {
      let o = t[s];
      o.material && await this.prefetchTexturesForMaterialAsync(o.material);
    }
  }
  async prefetchTexturesForMaterialAsync(e) {
    if (e) {
      var t = this.getTexturesForMaterial(e);
      for (let s = 0; s < t.length; s++)
        await hn.whenTextureIsReadyAsync(t[s]);
    }
  }
  checkDelayState(e) {
    e instanceof BABYLON.Mesh && e._checkDelayState();
    var t = e.getChildMeshes(!0);
    t.forEach((s) => this.checkDelayState(s));
  }
  // Crea una nuova mesh data da una minima espansione di quella passata in input
  // in modo che ne costituisca un rivestimento
  createEnvelopeMesh(e) {
    let t = 0.01;
    const s = e.getHierarchyBoundingVectors();
    if (s) {
      const a = s.min, c = s.max;
      t = new BABYLON.BoundingInfo(a, c).boundingSphere.radius * 5e-3;
    }
    const o = this.cloneMesh(e.id, !0, !0);
    return o && o instanceof BABYLON.Mesh && this.expandMesh(o, t), o;
  }
  expandMesh(e, t) {
    const s = new Qb();
    if (e && e instanceof BABYLON.Mesh) {
      s.expandMesh(e, t);
      const o = e.getChildMeshes();
      for (const a of o)
        a instanceof BABYLON.Mesh && s.expandMesh(a, t);
    }
  }
  cloneMesh(e, t = !1, s = !1) {
    let o = null;
    if (this._scene) {
      const a = this._scene.getMeshById(e);
      if (a) {
        const c = this.getNextIncrementalName(a.name);
        if (o = a.clone(c, a.parent), o) {
          o.id = Zakeke.generateUUID(), t && this.duplicateGeometry(a, o, s);
          const g = o.getChildMeshes();
          for (const w of g) {
            const T = this._scene.getMeshById(w.id);
            w.id = Zakeke.generateUUID();
            const H = w.parent ? w.parent.name : null;
            if (H) {
              const Y = w.name.indexOf(H + ".") + H.length + 1;
              w.name = w.name.substr(Y);
            }
            T && t && this.duplicateGeometry(T, w, s);
          }
        }
      }
    }
    return o;
  }
  duplicateGeometry(e, t, s = !1) {
    if (e instanceof BABYLON.Mesh && t instanceof BABYLON.Mesh) {
      const o = BABYLON.VertexData.ExtractFromMesh(e, !0, !0);
      return new BABYLON.Geometry(
        Zakeke.generateUUID(),
        t.getScene(),
        o,
        s,
        t
      );
    }
    return null;
  }
  // Material metadata
  getSceneMaterialMetadata(e) {
    return this._scene && this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(e) ? this._scene.metadata.materialsMetadata[e] : null;
  }
  getOrCreateSceneMaterialMetadata(e) {
    let t = this.getSceneMaterialMetadata(e);
    return t || (t = {}, this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.materialsMetadata || (this._scene.metadata.materialsMetadata = {}), this._scene.metadata.materialsMetadata[e] = t), t;
  }
  removeSceneMaterialMetadata(e) {
    this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(e) && delete this._scene.metadata.materialsMetadata[e];
  }
  offloadAllUnusedMaterials() {
    this.getAllUnusedMaterials().forEach((t) => this.offloadMaterial(t.id));
  }
  // Salva la serializzazione del materiale e lo rimuove dalla scena (eliminando anche le relative texture).
  // Lo scopo è quello di liberare la memoria occupata dalle texture
  offloadMaterial(e) {
    const t = this._scene.getMaterialByID(e);
    t && t.id !== "default material" && this.getMeshesUsingMaterial(e).length === 0 && (Logger.info("Offloading material: " + t.id + " - " + t.name), this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.offloadedMaterials || (this._scene.metadata.offloadedMaterials = {}), this._scene.metadata.offloadedMaterials[e] = this.getOffloadedMaterialInfo(t), Logger.info("Disposing material: " + e), t.dispose(!1, !0));
  }
  getOffloadedMaterialInfo(e) {
    return { name: e.name, data: e.serialize() };
  }
  // Il materiale restituito dalla versione sincrona potrebbe non essere pronto per l'applicazione alla mesh
  loadAllOffloadedMaterials(e) {
    let t = [];
    return this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials && (t = this.loadOffloadedMaterials(e, this._scene.metadata.offloadedMaterials)), t;
  }
  loadOffloadedMaterialsByIDs(e, t) {
    let s = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const o = {};
      for (let a = 0; a < t.length; a++)
        this._scene.metadata.offloadedMaterials.hasOwnProperty(t[a]) && (o[t[a]] = {
          name: this._scene.metadata.offloadedMaterials[t[a]].name,
          data: this._scene.metadata.offloadedMaterials[t[a]].data
        });
      s = this.loadOffloadedMaterials(e, o);
    }
    return s;
  }
  loadOffloadedMaterial(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const s = {};
      if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t)) {
        s[t] = {
          name: this._scene.metadata.offloadedMaterials[t].name,
          data: this._scene.metadata.offloadedMaterials[t].data
        };
        const o = this.loadOffloadedMaterials(e, s);
        if (o.length > 0)
          return o[0];
      }
    }
    return null;
  }
  loadOffloadedMaterials(e, t) {
    const s = [];
    for (const o in t) {
      const a = t[o], c = this.loadOffloadedMaterialInternal(o, a.name, e, a.data);
      c && s.push(c);
    }
    return s;
  }
  // Il nome viene passato solo ai fini del log
  loadOffloadedMaterialInternal(e, t, s, o) {
    const a = this._scene.getMaterialByID(e);
    if (a)
      return a;
    const c = t ? ` - ${t}` : "";
    return Logger.info("Loading offloaded material: " + e + c), BABYLON.Material.Parse(o, this._scene, s);
  }
  // Nella versione asincrona si aspetta che tutte le texture del materiale caricato siano pronte
  async loadAllOffloadedMaterialsAsync(e) {
    let t = [];
    return this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials && (t = await this.loadOffloadedMaterialsAsync(e, this._scene.metadata.offloadedMaterials)), t;
  }
  async loadOffloadedMaterialsByIDsAsync(e, t) {
    let s = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const o = {};
      for (let a = 0; a < t.length; a++)
        this._scene.metadata.offloadedMaterials.hasOwnProperty(t[a]) && (o[t[a]] = {
          name: this._scene.metadata.offloadedMaterials[t[a]].name,
          data: this._scene.metadata.offloadedMaterials[t[a]].data
        });
      s = await this.loadOffloadedMaterialsAsync(e, o);
    }
    return s;
  }
  async loadOffloadedMaterialAsync(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const s = {};
      if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t)) {
        s[t] = {
          name: this._scene.metadata.offloadedMaterials[t].name,
          data: this._scene.metadata.offloadedMaterials[t].data
        };
        const o = await this.loadOffloadedMaterialsAsync(e, s);
        if (o.length > 0)
          return o[0];
      }
    }
    return null;
  }
  async loadOffloadedMaterialsAsync(e, t) {
    const s = [], o = [];
    for (const c in t) {
      const g = t[c];
      o.push(this.loadOffloadedMaterialInternalAsync(c, g.name, e, g.data));
    }
    return (await Promise.all(o)).forEach((c) => {
      c && s.push(c);
    }), s;
  }
  // Il nome viene passato solo ai fini del log
  async loadOffloadedMaterialInternalAsync(e, t, s, o) {
    const a = this._scene.getMaterialByID(e);
    if (a)
      return a;
    const c = t ? ` - ${t}` : "";
    Logger.info("Loading offloaded material: " + e + c);
    const g = BABYLON.Material.Parse(o, this._scene, s);
    return g ? (Logger.info("Waiting for material ready: " + e + c), await hn.whenAllMaterialTexturesAreReady(g), Logger.info("Material ready: " + e + c)) : Logger.info("No material was created from offloaded material: " + e + c), g;
  }
  loadTextureFiles(e, t) {
    if (e)
      for (let s = 0; s < t.length; s++) {
        const o = t[s], a = /^(?:\/|[a-z]+:\/\/)/.test(o);
        let c = o;
        a || (c = e + o);
        const g = c.lastIndexOf("."), w = g > -1 ? c.substring(g).toLowerCase() : "";
        w === ".dds" || w === ".env" || w === ".hdr" ? BABYLON.Tools.LoadFile(c, () => {
        }) : (w === ".png" || w === ".jpg") && BABYLON.Tools.LoadImage(
          c,
          (he) => {
          },
          function() {
          },
          null
        );
      }
  }
  // Recupera il materiale specificato, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
  async getOrLoadMaterialAsync(e, t) {
    let s = this._scene.getMaterialByID(e);
    return !s && this._scene.metadata && (this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(e) ? s = await this.loadOffloadedMaterialAsync(t, e) : this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(e) && (s = await this.loadDelayedMaterialAsync(t, e))), s;
  }
  getOrCreateDummyMaterial() {
    let e = this._scene.getMaterialByID(this._dummyMaterialID);
    return e || (e = new BABYLON.StandardMaterial("Dummy Material", this._scene), e.id = this._dummyMaterialID, e.metadata = { isRealMaterial: !1 }), e;
  }
  isDummyMaterial(e) {
    return e.id === this._dummyMaterialID;
  }
  meshHasDummyMaterial(e, t) {
    var s;
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let o = 0; o < e.subMeshes.length; o++) {
        const c = e.subMeshes[o].materialIndex;
        if (e.material.subMaterials[c] && ((s = e.material.subMaterials[c]) == null ? void 0 : s.id) === this._dummyMaterialID)
          return !0;
      }
    else if (e.material && e.material.id === this._dummyMaterialID)
      return !0;
    if (t) {
      const o = e.getChildMeshes(!0);
      for (const a of o)
        if (this.meshHasDummyMaterial(a, !0))
          return !0;
    }
    return !1;
  }
  getMeshDelayedMaterialIDs(e) {
    var s;
    const t = [];
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let o = 0; o < e.subMeshes.length; o++) {
        const c = e.subMeshes[o].materialIndex;
        if (e.material.subMaterials[c] && ((s = e.material.subMaterials[c]) == null ? void 0 : s.id) === this._dummyMaterialID) {
          const g = `${e.id}_${c}`;
          if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(g)) {
            const w = this._scene.metadata.originalMeshMaterials[g];
            this._scene.metadata.delayedMaterials.hasOwnProperty(w) && t.indexOf(w) === -1 && t.push(w);
          }
        }
      }
    else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
      const o = this._scene.metadata.originalMeshMaterials[e.id];
      this._scene.metadata.delayedMaterials.hasOwnProperty(o) && t.indexOf(o) === -1 && t.push(o);
    }
    return e.getChildMeshes().forEach(
      (o) => Array.prototype.push.apply(t, this.getMeshDelayedMaterialIDs(o))
    ), t;
  }
  getMeshOffloadedMaterialIDs(e) {
    var s;
    const t = [];
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let o = 0; o < e.subMeshes.length; o++) {
        const c = e.subMeshes[o].materialIndex;
        if (e.material.subMaterials[c] && ((s = e.material.subMaterials[c]) == null ? void 0 : s.id) === this._dummyMaterialID) {
          const g = `${e.id}_${c}`;
          if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(g)) {
            const w = this._scene.metadata.originalMeshMaterials[g];
            this._scene.metadata.offloadedMaterials.hasOwnProperty(w) && t.indexOf(w) === -1 && t.push(w);
          }
        }
      }
    else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
      const o = this._scene.metadata.originalMeshMaterials[e.id];
      this._scene.metadata.offloadedMaterials.hasOwnProperty(o) && t.indexOf(o) === -1 && t.push(o);
    }
    return e.getChildMeshes().forEach(
      (o) => Array.prototype.push.apply(t, this.getMeshOffloadedMaterialIDs(o))
    ), t;
  }
  setDummyMaterialToInvisibleMeshes() {
    this.getInvisibleMeshes().forEach((t) => {
      this.setMeshDummyMaterial(t, !1);
    });
  }
  setMeshDummyMaterial(e, t) {
    this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.originalMeshMaterials || (this._scene.metadata.originalMeshMaterials = {});
    const s = this.getOrCreateDummyMaterial();
    if (e.material)
      if (e.subMeshes && e.subMeshes.length > 0 && e.material instanceof BABYLON.MultiMaterial)
        for (let o = 0; o < e.subMeshes.length; o++) {
          const c = e.subMeshes[o].materialIndex, g = e.material.subMaterials[c];
          if (g && !this.isDummyMaterial(g)) {
            const w = `${e.id}_${c}`;
            this._scene.metadata.originalMeshMaterials[w] = g.id, e.material.subMaterials[c] = s;
          }
        }
      else
        e.material && !this.isDummyMaterial(e.material) && (this._scene.metadata.originalMeshMaterials[e.id] = e.material.id, e.material = s);
    t && e.getChildMeshes().forEach((o) => this.setMeshDummyMaterial(o, !0));
  }
  // Il metodo è sincrono perché mi aspetto che tutti i materiali originali siano già presenti nella scena
  unsetAllDummyMaterials() {
    for (let e = 0; e < this._scene.meshes.length; e++)
      this.unsetMeshDummyMaterial(this._scene.meshes[e], !1);
  }
  // Il metodo è asincrono perché ci sia aspetta che non tutti i materiali siano presenti nella scena, in qual caso verranno caricati
  async unsetAllDummyMaterialsAsync(e) {
    for (let t = 0; t < this._scene.meshes.length; t++)
      await this.unsetMeshDummyMaterialAsync(this._scene.meshes[t], e, !1);
  }
  // Il metodo è sincrono perché mi aspetto che i materiali originali siano tutti gà presenti nella scena
  unsetMeshDummyMaterial(e, t) {
    var s;
    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
      if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
        for (let o = 0; o < e.subMeshes.length; o++) {
          const c = e.subMeshes[o].materialIndex;
          if (e.material.subMaterials[c] && ((s = e.material.subMaterials[c]) == null ? void 0 : s.id) === this._dummyMaterialID) {
            const g = `${e.id}_${c}`;
            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(g)) {
              const w = this._scene.metadata.originalMeshMaterials[g], T = this._scene.getMaterialByID(w);
              T && (e.material.subMaterials[c] = T, delete this._scene.metadata.originalMeshMaterials[g]);
            }
          }
        }
      else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
        const o = this._scene.metadata.originalMeshMaterials[e.id], a = this._scene.getMaterialByID(o);
        a && (e.material = a, delete this._scene.metadata.originalMeshMaterials[e.id]);
      }
      t && e.getChildMeshes().forEach((o) => this.unsetMeshDummyMaterial(o, !0));
    }
  }
  // Il metodo è asincrono perché ci si aspetta che non tutti i materiali siano presenti sulla scena, nel qual caso verranno caricati
  async unsetMeshDummyMaterialAsync(e, t, s) {
    var o;
    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
      if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
        for (let a = 0; a < e.subMeshes.length; a++) {
          const g = e.subMeshes[a].materialIndex;
          if (e.material.subMaterials[g] && ((o = e.material.subMaterials[g]) == null ? void 0 : o.id) === this._dummyMaterialID) {
            const w = `${e.id}_${g}`;
            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(w)) {
              const T = this._scene.metadata.originalMeshMaterials[w], H = await this.getOrLoadMaterialAsync(T, t);
              e.material.subMaterials[g] = H, delete this._scene.metadata.originalMeshMaterials[w];
            }
          }
        }
      else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
        const a = this._scene.metadata.originalMeshMaterials[e.id], c = await this.getOrLoadMaterialAsync(a, t);
        e.material = c, delete this._scene.metadata.originalMeshMaterials[e.id];
      }
      if (s) {
        const a = e.getChildMeshes();
        for (const c of a)
          await this.unsetMeshDummyMaterialAsync(c, t, !0);
      }
    }
  }
  async reloadAllLoadingErrorTexturesAsync(e) {
    for (const t of this._scene.textures)
      await this.reloadLoadingErrorTextureAsync(e, t);
  }
  async reloadMaterialLoadingErrorTexturesAsync(e, t) {
    for (const s of t.getActiveTextures())
      await this.reloadLoadingErrorTextureAsync(e, s);
  }
  reloadLoadingErrorTextureAsync(e, t) {
    if (t instanceof BABYLON.Texture && t.url) {
      const o = t.getInternalTexture();
      if (t.loadingError || o && o.loadingError) {
        const a = t.url, c = /^(?:\/|[a-z]+:\/\/)/.test(t.url);
        var s = t.url;
        return c || (s = e + t.url), new Promise((g, w) => {
          t.updateURL(
            s,
            null,
            () => {
              t.url = a, g();
            },
            void 0,
            () => {
              t.url = a, w();
            }
          );
        });
      }
    }
    return Promise.resolve();
  }
  isTextureLoadingError(e) {
    if (e.loadingError)
      return !0;
    const t = e.getInternalTexture();
    return t !== null && t.loadingError;
  }
  materialHasLoadingErrorTextues(e) {
    return e.getActiveTextures().some((t) => this.isTextureLoadingError(t));
  }
  // A dynamic texture is a procedural texture or a texture created from a Blob
  getMaterialDynamicTextures(e) {
    return e.getActiveTextures().filter(
      (s) => s instanceof BABYLON.ProceduralTexture || s instanceof BABYLON.Texture && s.url && s.url.indexOf("blob:") !== -1
    );
  }
  exportTextureToBase64Async(e, t = "image/png", s = !1) {
    return Promise.resolve().then(async () => {
      const o = await this.getPixelsFromTexture(e);
      if (!o)
        return null;
      const a = e.getSize();
      if (e.mimeType)
        switch (e.mimeType) {
          case "image/jpeg":
            t = "image/jpeg";
            break;
          case "image/png":
            t = "image/png";
            break;
        }
      return this.createBase64FromCanvasAsync(o, a.width, a.height, t, s);
    });
  }
  createBase64FromCanvasAsync(e, t, s, o, a = !1) {
    return new Promise(async (c, g) => {
      const w = BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, T = this._scene, H = T.getEngine(), Y = H.createRawTexture(
        e,
        t,
        s,
        BABYLON.Constants.TEXTUREFORMAT_RGBA,
        !1,
        a,
        BABYLON.Texture.NEAREST_SAMPLINGMODE,
        null,
        w
      );
      await BABYLON.TextureTools.ApplyPostProcess(
        "pass",
        Y,
        T,
        w,
        BABYLON.Constants.TEXTURE_NEAREST_SAMPLINGMODE,
        BABYLON.Constants.TEXTUREFORMAT_RGBA
      );
      const ee = await H._readTexturePixels(Y, t, s), z = await BABYLON.Tools.DumpDataAsync(
        t,
        s,
        ee,
        o,
        void 0,
        !0,
        !1
      );
      c(z);
    });
  }
  getPixelsFromTexture(e) {
    return e.textureType === BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, e.readPixels();
  }
  comparePBRMaterials(e, t) {
    (e.albedoColor && !t.albedoColor || !e.albedoColor && t.albedoColor || e.albedoColor && t.albedoColor && !e.albedoColor.equals(t.albedoColor)) && console.log("albedoColor"), e.allowShaderHotSwapping !== t.allowShaderHotSwapping && console.log("allowShaderHotSwapping"), e.alphaCutOff !== t.alphaCutOff && console.log("alphaCutOff"), (e.ambientColor && !t.ambientColor || !e.ambientColor && t.ambientColor || e.ambientColor && t.ambientColor && !e.ambientColor.equals(t.ambientColor)) && console.log("ambientColor"), e.ambientTextureStrength !== t.ambientTextureStrength && console.log("ambientTextureStrength"), this.compareAnisotropy(e.anisotropy, t.anisotropy), this.compareBRDF(e.brdf, t.brdf), this.compareClearCoat(e.clearCoat, t.clearCoat), e.depthFunction !== t.depthFunction && console.log("depthFunction"), this.compareDetailMap(e.detailMap, t.detailMap), e.directIntensity !== t.directIntensity && console.log("directIntensity"), e.disableBumpMap !== t.disableBumpMap && console.log("disableBumpMap"), e.disableColorWrite !== t.disableColorWrite && console.log("disableColorWrite"), e.disableDepthWrite !== t.disableDepthWrite && console.log("disableDepthWrite"), e.disableLighting !== t.disableLighting && console.log("disableLighting"), (e.emissiveColor && !t.emissiveColor || !e.emissiveColor && t.emissiveColor || e.emissiveColor && t.emissiveColor && !e.emissiveColor.equals(t.emissiveColor)) && console.log("emissiveColor"), e.emissiveIntensity !== t.emissiveIntensity && console.log("emissiveIntensity"), e.enableSpecularAntiAliasing !== t.enableSpecularAntiAliasing && console.log("enableSpecularAntiAliasing"), e.environmentIntensity !== t.environmentIntensity && console.log("environmentIntensity"), e.forceAlphaTest !== t.forceAlphaTest && console.log("forceAlphaTest"), e.forceDepthWrite !== t.forceDepthWrite && console.log("forceDepthWrite"), e.forceIrradianceInFragment !== t.forceIrradianceInFragment && console.log("forceIrradianceInFragment"), e.forceNormalForward !== t.forceNormalForward && console.log("forceNormalForward"), e.invertNormalMapX !== t.invertNormalMapX && console.log("invertNormalMapX"), e.invertNormalMapY !== t.invertNormalMapY && console.log("invertNormalMapY"), e.maxSimultaneousLights !== t.maxSimultaneousLights && console.log("maxSimultaneousLights"), e.metallic !== t.metallic && console.log("metallic"), e.metallicF0Factor !== t.metallicF0Factor && console.log("metallicF0Factor"), (e.metallicReflectanceColor && !t.metallicReflectanceColor || !e.metallicReflectanceColor && t.metallicReflectanceColor || e.metallicReflectanceColor && t.metallicReflectanceColor && !e.metallicReflectanceColor.equals(t.metallicReflectanceColor)) && console.log("metallicReflectanceColor"), e.microSurface !== t.microSurface && console.log("microSurface"), e.parallaxScaleBias !== t.parallaxScaleBias && console.log("parallaxScaleBias"), e.pointSize !== t.pointSize && console.log("pointSize"), this.comparePrePassConfiguration(e.prePassConfiguration, t.prePassConfiguration), (e.reflectionColor && !t.reflectionColor || !e.reflectionColor && t.reflectionColor || e.reflectionColor && t.reflectionColor && !e.reflectionColor.equals(t.reflectionColor)) && console.log("reflectionColor"), (e.reflectivityColor && !t.reflectivityColor || !e.reflectivityColor && t.reflectivityColor || e.reflectivityColor && t.reflectivityColor && !e.reflectivityColor.equals(t.reflectivityColor)) && console.log("reflectivityColor"), e.roughness !== t.roughness && console.log("roughness"), e.separateCullingPass !== t.separateCullingPass && console.log("separateCullingPass"), this.compareSheen(e.sheen, t.sheen), e.sideOrientation !== t.sideOrientation && console.log("sideOrientation"), e.specularIntensity !== t.specularIntensity && console.log("specularIntensity"), this.compareSubSurface(e.subSurface, t.subSurface), e.twoSidedLighting !== t.twoSidedLighting && console.log("twoSidedLighting"), e.unlit !== t.unlit && console.log("unlit"), e.useAlphaFresnel !== t.useAlphaFresnel && console.log("useAlphaFresnel"), e.useAlphaFromAlbedoTexture !== t.useAlphaFromAlbedoTexture && console.log("useAlphaFromAlbedoTexture"), e.useAmbientInGrayScale !== t.useAmbientInGrayScale && console.log("useAmbientInGrayScale"), e.useAmbientOcclusionFromMetallicTextureRed !== t.useAmbientOcclusionFromMetallicTextureRed && console.log("useAmbientOcclusionFromMetallicTextureRed"), e.useAutoMicroSurfaceFromReflectivityMap !== t.useAutoMicroSurfaceFromReflectivityMap && console.log("useAutoMicroSurfaceFromReflectivityMap"), e.useHorizonOcclusion !== t.useHorizonOcclusion && console.log("useHorizonOcclusion"), e.useLightmapAsShadowmap !== t.useLightmapAsShadowmap && console.log("useLightmapAsShadowmap"), e.useLinearAlphaFresnel !== t.useLinearAlphaFresnel && console.log("useLinearAlphaFresnel"), e.useMetallnessFromMetallicTextureBlue !== t.useMetallnessFromMetallicTextureBlue && console.log("useMetallnessFromMetallicTextureBlue"), e.useMicroSurfaceFromReflectivityMapAlpha !== t.useMicroSurfaceFromReflectivityMapAlpha && console.log("useMicroSurfaceFromReflectivityMapAlpha"), e.useObjectSpaceNormalMap !== t.useObjectSpaceNormalMap && console.log("useObjectSpaceNormalMap"), e.useOnlyMetallicFromMetallicReflectanceTexture !== t.useOnlyMetallicFromMetallicReflectanceTexture && console.log("useOnlyMetallicFromMetallicReflectanceTexture"), e.useParallax !== t.useParallax && console.log("useParallax"), e.useParallaxOcclusion !== t.useParallaxOcclusion && console.log("useParallaxOcclusion"), e.useRadianceOcclusion !== t.useRadianceOcclusion && console.log("useRadianceOcclusion"), e.useRadianceOverAlpha !== t.useRadianceOverAlpha && console.log("useRadianceOverAlpha"), e.useRoughnessFromMetallicTextureAlpha !== t.useRoughnessFromMetallicTextureAlpha && console.log("useRoughnessFromMetallicTextureAlpha"), e.useRoughnessFromMetallicTextureGreen !== t.useRoughnessFromMetallicTextureGreen && console.log("useRoughnessFromMetallicTextureGreen"), e.useSpecularOverAlpha !== t.useSpecularOverAlpha && console.log("useSpecularOverAlpha"), e.zOffset !== t.zOffset && console.log("zOffset"), e.zOffsetUnits !== t.zOffsetUnits && console.log("zOffsetUnits"), e.alpha !== t.alpha && console.log("alpha"), e.alphaMode !== t.alphaMode && console.log("alphaMode"), e.backFaceCulling !== t.backFaceCulling && console.log("backFaceCulling"), this.compareCameraCurve("", e.cameraColorCurves, t.cameraColorCurves), e.cameraColorCurvesEnabled !== t.cameraColorCurvesEnabled && console.log("cameraColorCurvesEnabled"), e.cameraColorGradingEnabled !== t.cameraColorGradingEnabled && console.log("cameraColorGradingEnabled"), e.cameraContrast !== t.cameraContrast && console.log("cameraContrast"), e.cameraExposure !== t.cameraExposure && console.log("cameraExposure"), e.cameraToneMappingEnabled !== t.cameraToneMappingEnabled && console.log("cameraToneMappingEnabled"), e.canRenderToMRT !== t.canRenderToMRT && console.log("canRenderToMRT"), e.cullBackFaces !== t.cullBackFaces && console.log("cullBackFaces"), e.fillMode !== t.fillMode && console.log("fillMode"), e.fogEnabled !== t.fogEnabled && console.log("fogEnabled"), e.hasRenderTargetTextures !== t.hasRenderTargetTextures && console.log("hasRenderTargetTextures"), this.compareImageProcessingConfiguration(e.imageProcessingConfiguration, t.imageProcessingConfiguration), e.indexOfRefraction !== t.indexOfRefraction && console.log("indexOfRefraction"), e.invertRefractionY !== t.invertRefractionY && console.log("invertRefractionY"), e.isFrozen !== t.isFrozen && console.log("isFrozen"), e.isPrePassCapable !== t.isPrePassCapable && console.log("isPrePassCapable"), e.linkRefractionWithTransparency !== t.linkRefractionWithTransparency && console.log("linkRefractionWithTransparency"), e.needDepthPrePass !== t.needDepthPrePass && console.log("needDepthPrePass"), e.realTimeFiltering !== t.realTimeFiltering && console.log("realTimeFiltering"), e.realTimeFilteringQuality !== t.realTimeFilteringQuality && console.log("realTimeFilteringQuality"), e.transparencyMode !== t.transparencyMode && console.log("transparencyMode"), e.useGLTFLightFalloff !== t.useGLTFLightFalloff && console.log("useGLTFLightFalloff"), e.useLogarithmicDepth !== t.useLogarithmicDepth && console.log("useLogarithmicDepth"), e.usePhysicalLightFalloff !== t.usePhysicalLightFalloff && console.log("usePhysicalLightFalloff"), this.compareTexture("albedo", e.albedoTexture, t.albedoTexture), this.compareTexture("emissive", e.emissiveTexture, t.emissiveTexture);
  }
  compareAnisotropy(e, t) {
    const s = "anisotropy";
    (e.direction && !t.direction || !e.direction && t.direction || e.direction && t.direction && !e.direction.equals(t.direction)) && console.log(s + " - direction"), e.intensity !== t.intensity && console.log(s + " - intensity"), e.isEnabled !== t.isEnabled && console.log(s + " - isEnabled");
  }
  compareBRDF(e, t) {
    const s = "brdf";
    e.useEnergyConservation !== t.useEnergyConservation && console.log(s + " - useEnergyConservation"), e.useSmithVisibilityHeightCorrelated !== t.useSmithVisibilityHeightCorrelated && console.log(s + " - useSmithVisibilityHeightCorrelated"), e.useSpecularGlossinessInputEnergyConservation !== t.useSpecularGlossinessInputEnergyConservation && console.log(s + " - useSpecularGlossinessInputEnergyConservation"), e.useSphericalHarmonics !== t.useSphericalHarmonics && console.log(s + " - useSphericalHarmonics");
  }
  compareClearCoat(e, t) {
    const s = "clearCoat";
    e.indexOfRefraction !== t.indexOfRefraction && console.log(s + " - indexOfRefraction"), e.intensity !== t.intensity && console.log(s + " - intensity"), e.isEnabled !== t.isEnabled && console.log(s + " - isEnabled"), e.isTintEnabled !== t.isTintEnabled && console.log(s + " - isTintEnabled"), e.roughness !== t.roughness && console.log(s + " - roughness"), (e.tintColor && !t.tintColor || !e.tintColor && t.tintColor || e.tintColor && t.tintColor && !e.tintColor.equals(t.tintColor)) && console.log(s + " - tintColor"), e.tintColorAtDistance !== t.tintColorAtDistance && console.log(s + " - tintColorAtDistance"), e.tintThickness !== t.tintThickness && console.log(s + " - tintThickness"), e.useRoughnessFromMainTexture != t.useRoughnessFromMainTexture && console.log(s + " - useRoughnessFromMainTexture");
  }
  compareDetailMap(e, t) {
    const s = "detailMap";
    e.bumpLevel !== t.bumpLevel && console.log(s + " - bumpLevel"), e.diffuseBlendLevel !== t.diffuseBlendLevel && console.log(s + " - diffuseBlendLevel"), e.isEnabled !== t.isEnabled && console.log(s + " - isEnabled"), e.normalBlendMethod !== t.normalBlendMethod && console.log(s + " - normalBlendMethod"), e.roughnessBlendLevel !== t.roughnessBlendLevel && console.log(s + " - roughnessBlendLevel");
  }
  comparePrePassConfiguration(e, t) {
    const s = "PrePassConfiguration";
    (e.currentViewProjection && !t.currentViewProjection || !e.currentViewProjection && t.currentViewProjection || e.currentViewProjection && t.currentViewProjection && !e.currentViewProjection.equals(t.currentViewProjection)) && console.log(s + " - currentViewProjection"), (e.previousViewProjection && !t.previousViewProjection || !e.previousViewProjection && t.previousViewProjection || e.previousViewProjection && t.previousViewProjection && !e.previousViewProjection.equals(t.previousViewProjection)) && console.log(s + " - previousViewProjection");
  }
  compareSheen(e, t) {
    const s = "Sheen";
    e.albedoScaling !== t.albedoScaling && console.log(s + " - albedoScaling"), (e.color && !t.color || !e.color && t.color || e.color && t.color && !e.color.equals(t.color)) && console.log(s + " - color"), e.intensity !== t.intensity && console.log(s + " - intensity"), e.isEnabled !== t.isEnabled && console.log(s + " - isEnabled"), e.linkSheenWithAlbedo !== t.linkSheenWithAlbedo && console.log(s + " - linkSheenWithAlbedo"), e.roughness !== t.roughness && console.log(s + " - roughness"), e.useRoughnessFromMainTexture !== t.useRoughnessFromMainTexture && console.log(s + " - useRoughnessFromMainTexture");
  }
  compareSubSurface(e, t) {
    const s = "SubSurface";
    (e.diffusionDistance && !t.diffusionDistance || !e.diffusionDistance && t.diffusionDistance || e.diffusionDistance && t.diffusionDistance && !e.diffusionDistance.equals(t.diffusionDistance)) && console.log(s + " - diffusionDistance"), e.indexOfRefraction !== t.indexOfRefraction && console.log(s + " - indexOfRefraction"), e.invertRefractionY !== t.invertRefractionY && console.log(s + " - invertRefractionY"), e.isRefractionEnabled !== t.isRefractionEnabled && console.log(s + " - isRefractionEnabled"), e.isScatteringEnabled !== t.isScatteringEnabled && console.log(s + " - isScatteringEnabled"), e.isTranslucencyEnabled !== t.isTranslucencyEnabled && console.log(s + " - isTranslucencyEnabled"), e.linkRefractionWithTransparency !== t.linkRefractionWithTransparency && console.log(s + " - linkRefractionWithTransparency"), e.maximumThickness !== t.maximumThickness && console.log(s + " - maximumThickness"), e.minimumThickness !== t.minimumThickness && console.log(s + " - minimumThickness"), e.refractionIntensity !== t.refractionIntensity && console.log(s + " - refractionIntensity"), (e.tintColor && !t.tintColor || !e.tintColor && t.tintColor || e.tintColor && t.tintColor && !e.tintColor.equals(t.tintColor)) && console.log(s + " - tintColor"), e.tintColorAtDistance !== t.tintColorAtDistance && console.log(s + " - tintColorAtDistance"), e.translucencyIntensity !== t.translucencyIntensity && console.log(s + " - translucencyIntensity"), e.useAlbedoToTintRefraction !== t.useAlbedoToTintRefraction && console.log(s + " - useAlbedoToTintRefraction"), e.useAlbedoToTintTranslucency !== t.useAlbedoToTintTranslucency && console.log(s + " - useAlbedoToTintTranslucency"), e.useGltfStyleTextures !== t.useGltfStyleTextures && console.log(s + " - useGltfStyleTextures"), e.useMaskFromThicknessTexture !== t.useMaskFromThicknessTexture && console.log(s + " - useMaskFromThicknessTexture"), e.useThicknessAsDepth !== t.useThicknessAsDepth && console.log(s + " - useThicknessAsDepth");
  }
  compareCameraCurve(e, t, s) {
    if ((t === null && s !== null || t !== null && s === null) && console.log("cameraColorCurves"), t && s) {
      const o = e ? e + " - cameraColorCurves" : "cameraColorCurves";
      t.globalDensity !== s.globalDensity && console.log(o + " - globalDensity"), t.globalExposure !== s.globalExposure && console.log(o + "- globalExposure"), t.globalHue !== s.globalHue && console.log(o + " - globalHue"), t.globalSaturation !== s.globalSaturation && console.log(o + " - globalSaturation"), t.highlightsDensity !== s.highlightsDensity && console.log(o + " - highlightsDensity"), t.highlightsExposure !== s.highlightsExposure && console.log(o + " - highlightsExposure"), t.highlightsHue !== s.highlightsHue && console.log(o + " - highlightsHue"), t.highlightsSaturation !== s.highlightsSaturation && console.log(o + " - highlightsSaturation"), t.midtonesDensity !== s.midtonesDensity && console.log(o + " - midtonesDensity"), t.midtonesExposure !== s.midtonesExposure && console.log(o + " - midtonesExposure"), t.midtonesHue !== s.midtonesHue && console.log(o + " - midtonesHue"), t.midtonesSaturation !== s.midtonesSaturation && console.log(o + " - midtonesSaturation"), t.shadowsDensity !== s.shadowsDensity && console.log(o + " - shadowsDensity"), t.shadowsExposure !== s.shadowsExposure && console.log(o + " - shadowsExposure"), t.shadowsHue !== s.shadowsHue && console.log(o + " - shadowsHue"), t.shadowsSaturation !== s.shadowsSaturation && console.log(o + " - shadowsSaturation");
    }
  }
  compareImageProcessingConfiguration(e, t) {
    const s = "imageProcessingConfiguration";
    this.compareCameraCurve(s, e.colorCurves, t.colorCurves), e.vignetteCameraFov !== t.vignetteCameraFov && console.log(s + " - vignetteCameraFov"), e.vignetteCentreX !== t.vignetteCentreX && console.log(s + " - vignetteCentreX"), e.vignetteCentreY !== t.vignetteCentreY && console.log(s + " - vignetteCentreY"), (e.vignetteColor && !t.vignetteColor || !e.vignetteColor && t.vignetteColor || e.vignetteColor && t.vignetteColor && !e.vignetteColor.equals(t.vignetteColor)) && console.log(s + " - vignetteColor"), e.vignetteStretch !== t.vignetteStretch && console.log(s + " - vignetteStretch"), e.vignetteWeight !== t.vignetteWeight && console.log(s + " - vignetteWeight"), e.applyByPostProcess !== t.applyByPostProcess && console.log(s + " - applyByPostProcess"), e.colorCurvesEnabled !== t.colorCurvesEnabled && console.log(s + " - colorCurvesEnabled"), e.colorGradingBGR !== t.colorGradingBGR && console.log(s + " - colorGradingBGR"), e.colorGradingEnabled !== t.colorGradingEnabled && console.log(s + " - colorGradingEnabled"), e.colorGradingWithGreenDepth !== t.colorGradingWithGreenDepth && console.log(s + " - colorGradingWithGreenDepth"), e.contrast !== t.contrast && console.log(s + " - contrast"), e.exposure !== t.exposure && console.log(s + " - exposure"), e.isEnabled !== t.isEnabled && console.log(s + " - isEnabled"), e.toneMappingEnabled !== t.toneMappingEnabled && console.log(s + " - toneMappingEnabled"), e.toneMappingType !== t.toneMappingType && console.log(s + " - toneMappingType"), e.vignetteBlendMode !== t.vignetteBlendMode && console.log(s + " - vignetteBlendMode"), e.vignetteEnabled !== t.vignetteEnabled && console.log(s + " - vignetteEnabled");
  }
  compareTexture(e, t, s) {
    if (t && !s || !t && s) {
      console.log(e);
      return;
    }
    if (t instanceof BABYLON.Texture && !(s instanceof BABYLON.Texture) || s instanceof BABYLON.Texture && !(t instanceof BABYLON.Texture)) {
      console.log(e);
      return;
    }
    t && s && (t.anisotropicFilteringLevel !== s.anisotropicFilteringLevel && console.log(e + " - anisotropicFilteringLevel"), t instanceof BABYLON.Texture && s instanceof BABYLON.Texture && (t.homogeneousRotationInUVTransform !== s.homogeneousRotationInUVTransform && console.log(e + " - homogeneousRotationInUVTransform"), t.uAng !== s.uAng && console.log(e + " - uAng"), t.uOffset !== s.uOffset && console.log(e + " - uOffset"), t.uRotationCenter !== s.uRotationCenter && console.log(e + " - uRotationCenterSearch"), t.uScale !== s.uScale && console.log(e + " - uScale"), t.vAng !== s.vAng && console.log(e + " - vAng"), t.vOffset !== s.vOffset && console.log(e + " - vOffset"), t.vRotationCenter !== s.vRotationCenter && console.log(e + " - vRotationCenterSearch"), t.vScale !== s.vScale && console.log(e + " - vScale"), t.wAng !== s.wAng && console.log(e + " - wAng"), t.wRotationCenter !== s.wRotationCenter && console.log(e + " - wRotationCenterSearch"), t.invertY !== s.invertY && console.log(e + " - invertY"), t.mimeType !== s.mimeType && console.log(e + " - mimeType")), t.invertZ !== s.invertZ && console.log(e + " - invertZ"), t.isRenderTarget !== s.isRenderTarget && console.log(e + " - isRenderTarget"), t.level !== s.level && console.log(e + " - level"), t.wrapR !== s.wrapR && console.log(e + " - wrapR"), t.canRescale !== s.canRescale && console.log(e + " - canRescale"), t.coordinatesIndex !== s.coordinatesIndex && console.log(e + " - coordinatesIndex"), t.coordinatesMode !== s.coordinatesMode && console.log(e + " - coordinatesMode"), t.gammaSpace !== s.gammaSpace && console.log(e + " - gammaSpace"), t.getAlphaFromRGB !== s.getAlphaFromRGB && console.log(e + " - getAlphaFromRGB"), t.hasAlpha !== s.hasAlpha && console.log(e + "- hasAlpha"), t.is2DArray !== s.is2DArray && console.log(e + " - is2DArray"), t.is3D !== s.is3D && console.log(e + " - is3D"), t.isBlocking !== s.isBlocking && console.log(e + " - isBlocking"), t.isCube !== s.isCube && console.log(e + " - isCube"), t.isRGBD !== s.isRGBD && console.log(e + " - isRGBD"), t.linearSpecularLOD !== s.linearSpecularLOD && console.log(e + " - linearSpecularLOD"), t.lodGenerationOffset !== s.lodGenerationOffset && console.log(e + " - lodGenerationOffset"), t.lodGenerationScale !== s.lodGenerationScale && console.log(e + " - lodGenerationScale"), t.noMipmap !== s.noMipmap && console.log(e + " - noMipmap"), t.samplingMode !== s.samplingMode && console.log(e + " - samplingMode"), t.textureFormat !== s.textureFormat && console.log(e + " - textureFormat"), t.textureType !== s.textureType && console.log(e + " - textureType"), t.wrapU !== s.wrapU && console.log(e + " - wrapU"), t.wrapV !== s.wrapV && console.log(e + " - wrapV"));
  }
  async showResizableCanvas(e, t, s, o, a, c, g, w, T) {
    if (!this._isLoading) {
      if (this._isLoading = !0, this._scene) {
        this.clearResizableMeshes();
        const H = this._resizableCanvas3DGenerator.generatePreview3D(
          {
            width: e,
            height: t,
            depth: s,
            borderRadius: o,
            radiusResolution: 0.1,
            type: a,
            borderColor: c,
            columns: g,
            rows: w,
            useCheckerTexture: !1
          },
          this._scene
        ), Y = await BABYLON.SceneLoader.ImportMeshAsync(
          "",
          "",
          "data:" + JSON.stringify(H)
        );
        this._loadedMeshes.push(...Y.meshes);
        const ee = Y.meshes[0], z = 2 / Math.max(e, t);
        if (ee.scaling.scaleInPlace(z), ee.position.z = 0, ee.rotate(BABYLON.Axis.Y, Math.PI, BABYLON.Space.LOCAL), this.camera && this.camera instanceof BABYLON.ArcRotateCamera && this.camera.setPosition(new BABYLON.Vector3(0, 1, 4)), !this._scene.lights.find((ye) => ye.name === "resizableLight")) {
          console.log("Creating light...");
          const ye = new BABYLON.HemisphericLight(
            "resizableLight",
            new BABYLON.Vector3(0.1, 1, 0.1),
            this._scene
          );
          ye.groundColor = new BABYLON.Color3(0.6, 0.6, 0.6), ye.intensity = 1;
          const se = this.getDefaultHemisphericLight();
          se && this._scene.removeLight(se);
        }
        const ne = Y.meshes.find((ye) => !ye.parent);
        return ne.metadata = {
          isResizable: !0,
          AR: !0,
          sizecm: {
            height: t / T
          }
        }, this._isLoading = !1, Y.meshes;
      }
      return this._isLoading = !1, null;
    }
  }
  /**
   * Remove all meshes from the scene
   */
  clearResizableMeshes() {
    this._scene.meshes.filter((e) => {
      var t;
      return (t = e.metadata) == null ? void 0 : t.isResizable;
    }).forEach((e) => e.dispose());
  }
  switchMode(e) {
    var o;
    console.log("Switch 3D mode", e);
    const t = this._scene.lights.find((a) => a.name === "resizableLight"), s = this.getDefaultHemisphericLight();
    e === "resizable" ? this._lastVisibilityStates.size === 0 && ((o = this._scene) == null || o.meshes.forEach((a) => {
      (!a.metadata || !a.metadata.isResizable) && (this._lastVisibilityStates.set(a, a.isVisible), a.isVisible = !1);
    })) : (t && (t.dispose(), this._scene.removeLight(t)), s && this._scene.addLight(s), this._lastVisibilityStates.forEach((a, c) => c.isVisible = a), this._lastVisibilityStates.clear(), this.clearResizableMeshes());
  }
  async rotate(e, t, s) {
    return new Promise((o) => {
      if (this._scene) {
        console.log(`Rotating scene on axis ${t} by ${e} degrees`);
        const a = e * Math.PI / 180;
        this._scene.meshes.filter((c) => !c.parent).forEach((c) => {
          if (!s)
            c.rotate(t, a, BABYLON.Space.WORLD), o();
          else {
            const g = c.rotationQuaternion ?? c.rotation.toQuaternion(), w = BABYLON.Quaternion.RotationAxis(t, a).multiply(
              g
            ), T = BABYLON.Animation.CreateAndStartAnimation(
              c.id + "rotation",
              c,
              "rotationQuaternion",
              60,
              20,
              g,
              w,
              BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT,
              void 0,
              () => {
                T == null || T.stop(), o();
              }
            );
          }
        });
      }
    });
  }
};
vd._shadowGenerator = null;
let ni = vd;
class qr extends BABYLON.ProceduralTexture {
  constructor(e, t, s, o, a, c, g) {
    super(e, t, s, o, c, g), this._initializing = !1, this._baseTexture = a, this.updateShaderUniforms();
  }
  get initializing() {
    return this._initializing;
  }
  get baseTexture() {
    return this._baseTexture;
  }
  set baseTexture(e) {
    this._baseTexture = e, this.updateShaderUniforms();
  }
  isReadyAsync() {
    return ni.whenTextureIsReadyAsync(this);
  }
  dispose() {
    super.dispose(), this._baseTexture && this._baseTexture.dispose();
  }
  beginInit() {
    this._initializing = !0;
  }
  endInit() {
    this._initializing = !1, this.updateShaderUniforms();
  }
  updateShaderUniforms() {
    this._initializing || this.setBaseTextureUniform();
  }
  setBaseTextureUniform() {
    this.setTexture("uSampler", this._baseTexture);
  }
}
const tu = class yd extends qr {
  constructor(e, t, s, o, a, c) {
    super(e, t, yd.FRAGMENT_SHADER, s, o, a, c), this._blur = 1 / 512, this.updateShaderUniforms();
  }
  //@BABYLON.serialize()
  get blur() {
    return this._blur / (1 / 7e3);
  }
  set blur(e) {
    this._blur = 1 / 7e3 * e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._blur != null ? this._blur : 1 / 512;
    this.setFloat("blur", e);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  //public serialize(): any {
  //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
  //    serializationObject.customType = BlurXProceduralTexture.CUSTOM_TYPE;
  //    return serializationObject;
  //}
  //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurXProceduralTexture {
  //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurXProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
  //    return texture;
  //}
};
tu.FRAGMENT_SHADER = "zakeke_BlurXProceduralTexture";
tu.CUSTOM_TYPE = "Zakeke.BlurXProceduralTexture";
let so = tu;
const tx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "uniform float blur;",
  "uniform sampler2D uSampler;",
  "void main(void) {",
  "   vec4 sum = vec4(0.0);",
  "   sum += texture2D(uSampler, vec2(vUV.x - 4.0*blur, vUV.y)) * 0.05;",
  "   sum += texture2D(uSampler, vec2(vUV.x - 3.0*blur, vUV.y)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x - 2.0*blur, vUV.y)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x - blur, vUV.y)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;",
  "   sum += texture2D(uSampler, vec2(vUV.x + blur, vUV.y)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 2.0*blur, vUV.y)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 3.0*blur, vUV.y)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 4.0*blur, vUV.y)) * 0.05;",
  "   gl_FragColor = sum;",
  "}"
], ix = tx.join(`
`);
BABYLON.Effect.ShadersStore[`${so.FRAGMENT_SHADER}PixelShader`] = ix;
const iu = class bd extends qr {
  constructor(e, t, s, o, a, c) {
    super(e, t, bd.FRAGMENT_SHADER, s, o, a, c), this._blur = 1 / 512, this.updateShaderUniforms();
  }
  get blur() {
    return this._blur / (1 / 7e3);
  }
  set blur(e) {
    this._blur = 1 / 7e3 * e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._blur != null ? this._blur : 1 / 512;
    this.setFloat("blur", e);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  //public serialize(): any {
  //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
  //    serializationObject.customType = BlurYProceduralTexture.CUSTOM_TYPE;
  //    return serializationObject;
  //}
  //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurYProceduralTexture {
  //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurYProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
  //    return texture;
  //}
};
iu.FRAGMENT_SHADER = "zakeke_BlurYProceduralTexture";
iu.CUSTOM_TYPE = "Zakeke.BlurYProceduralTexture";
let ro = iu;
const nx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "uniform float blur;",
  "uniform sampler2D uSampler;",
  "void main(void) {",
  "   vec4 sum = vec4(0.0);",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 4.0*blur)) * 0.05;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 3.0*blur)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 2.0*blur)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - blur)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + blur)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 2.0*blur)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 3.0*blur)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 4.0*blur)) * 0.05;",
  "   gl_FragColor = sum;",
  "}"
], sx = nx.join(`
`);
BABYLON.Effect.ShadersStore[`${ro.FRAGMENT_SHADER}PixelShader`] = sx;
const nu = class xd extends qr {
  constructor(e, t, s, o, a, c) {
    super(e, t, xd.FRAGMENT_SHADER, s, o, a, c), this._foreColor = new BABYLON.Vector3(1, 1, 1), this._backColor = new BABYLON.Vector3(0, 0, 0), this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector3()
  get foreColor() {
    return this._foreColor;
  }
  set foreColor(e) {
    this._foreColor = e, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector3()
  get backColor() {
    return this._backColor;
  }
  set backColor(e) {
    this._backColor = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._foreColor || new BABYLON.Vector3(1, 1, 1), t = this._backColor || new BABYLON.Vector3(0, 0, 0);
    this.setVector3("foreColor", e), this.setVector3("backColor", t);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
  * Resize the texture to new value.
  * @param size Define the new size the texture should have
  * @param generateMipMaps Define whether the new texture should create mip maps
  */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  /*
      public serialize(): any {
          var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
          serializationObject.customType = ForegroundBackgroundProceduralTexture.CUSTOM_TYPE;
          return serializationObject;
      }
  
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): ForegroundBackgroundProceduralTexture {
          var texture = BABYLON.SerializationHelper.Parse(() => new ForegroundBackgroundProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
          return texture;
      }
      */
};
nu.FRAGMENT_SHADER = "zakeke_ForegroundBackgroundProceduralTexture";
nu.CUSTOM_TYPE = "Zakeke.ForegroundBackgroundProceduralTexture";
let ao = nu;
const rx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform vec3 foreColor;",
  "uniform vec3 backColor;",
  "void main(void) {",
  "   // background color",
  "   vec4 background = vec4(backColor.xyz, 1);",
  "   vec4 foreground = vec4(foreColor.xyz, 1);",
  "   // texel",
  "	vec4 t0 = texture2D(uSampler, vUV.xy);",
  "   // change in white",
  "   t0 = vec4(foreground.xyz, t0.a);",
  "   gl_FragColor = mix(background, t0, t0.a);",
  "}"
], ax = rx.join(`
`);
BABYLON.Effect.ShadersStore[`${ao.FRAGMENT_SHADER}PixelShader`] = ax;
const su = class wd extends qr {
  constructor(e, t, s, o, a, c) {
    super(e, t, wd.FRAGMENT_SHADER, s, o, a, c), this._offset = new BABYLON.Vector2(0, 0), this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector2()
  get offset() {
    return this._offset;
  }
  set offset(e) {
    this._offset = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this.getRenderSize(), t = this._offset || new BABYLON.Vector2();
    this.setVector2("offset", new BABYLON.Vector2(t.x / e, t.y / e));
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
  * Resize the texture to new value.
  * @param size Define the new size the texture should have
  * @param generateMipMaps Define whether the new texture should create mip maps
  */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  /*
      public serialize(): any {
          var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
          serializationObject.customType = MoveProceduralTexture.CUSTOM_TYPE;
          return serializationObject;
      }
  
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): MoveProceduralTexture {
          var texture = BABYLON.SerializationHelper.Parse(() => new MoveProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
          return texture;
      }
      */
};
su.FRAGMENT_SHADER = "zakeke_MoveProceduralTexture";
su.CUSTOM_TYPE = "Zakeke.MoveProceduralTexture";
let ru = su;
const ox = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform vec2 offset;",
  "void main(void) {",
  "   // translated texel",
  "   gl_FragColor = texture2D(uSampler, vec2(vUV.x - offset.x, vUV.y + offset.y));",
  //'   gl_FragColor = texture2D(uSampler, vUV.xy - offset);',
  "}"
], lx = ox.join(`
`);
BABYLON.Effect.ShadersStore[`${ru.FRAGMENT_SHADER}PixelShader`] = lx;
const au = class Sd extends qr {
  constructor(e, t, s, o, a, c, g) {
    super(e, t, Sd.FRAGMENT_SHADER, s, o, c, g), this._blendTexture = a, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = new BABYLON.Vector2(1, 1);
      this.baseTexture && (e = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale)), this.setVector2("uSamplerScale", e), this.setTexture("uBlendSampler", this._blendTexture);
      var t = new BABYLON.Vector2(1, 1);
      this._blendTexture && (t = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale)), this.setVector2("uBlendScale", t);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
au.FRAGMENT_SHADER = "zakeke_MultiplyProceduralTexture";
au.CUSTOM_TYPE = "Zakeke.MultiplyProceduralTexture";
let Qa = au;
const hx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "void main(void) {",
  "	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = base * blend;",
  "}"
], ux = hx.join(`
`);
BABYLON.Effect.ShadersStore[`${Qa.FRAGMENT_SHADER}PixelShader`] = ux;
const ou = class Md extends qr {
  constructor(e, t, s, o, a, c) {
    super(e, t, Md.FRAGMENT_SHADER, s, o, a, c), this._bias = 50, this._invertR = !1, this._invertG = !1, this._bevel = !1, this._intensity = 0.5, this.updateShaderUniforms();
  }
  get bias() {
    return this._bias == null ? 50 : this._bias;
  }
  set bias(e) {
    this._bias = e, this.updateShaderUniforms();
  }
  get invertR() {
    return this._invertR == null ? !1 : this._invertR;
  }
  set invertR(e) {
    this._invertR = e, this.updateShaderUniforms();
  }
  get invertG() {
    return this._invertG == null ? !1 : this._invertG;
  }
  set invertG(e) {
    this._invertG = e, this.updateShaderUniforms();
  }
  get bevel() {
    return this._bevel == null ? !1 : this._bevel;
  }
  set bevel(e) {
    this._bevel = e, this.updateShaderUniforms();
  }
  get intensity() {
    return this._intensity == null ? 0.5 : this._intensity;
  }
  set intensity(e) {
    this._intensity = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = this.getRenderSize(), t = e < 1024 ? e * 2 : e;
      this.setFloat("size", e), this.setVector2("u_textureSize", new BABYLON.Vector2(e, e)), this.setVector3("dimensions", new BABYLON.Vector3(t, t, 0)), this.setFloat("bias", this.bias), this.setFloat("invertR", this.invertR ? -1 : 1), this.setFloat("invertG", this.invertG ? -1 : 1), this.setFloat("bevel", this.bevel ? 1 : 0), this.setFloat("intensity", this.intensity);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
ou.FRAGMENT_SHADER = "zakeke_normalMapProceduralTexture";
ou.CUSTOM_TYPE = "Zakeke.NormalMapProceduralTexture";
let Cd = ou;
const cx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform vec3 dimensions;",
  "uniform sampler2D uSampler;",
  "uniform vec2 u_textureSize;",
  "uniform float bias;",
  "uniform float invertR;",
  "uniform float invertG;",
  "uniform float bevel;",
  "uniform float intensity;",
  "void main(void) {",
  "   vec2 step = vec2(1.0, 1.0) / dimensions.xy;",
  "   vec4 black = vec4(0, 0, 0, 1);",
  "	vec4 bk = vec4(1, 1, 1, 1);",
  "	vec4 t0 = texture2D(uSampler, vUV.xy + vec2(0.0, 0.0));",
  "	vec4 t1 = texture2D(uSampler, vUV.xy + vec2(step.x, 0.0));",
  "	vec4 t2 = texture2D(uSampler, vUV.xy + vec2(-step.x, 0.0));",
  "	vec4 t3 = texture2D(uSampler, vUV.xy + vec2(0.0, step.y));",
  "	vec4 t4 = texture2D(uSampler, vUV.xy + vec2(0.0, -step.y));",
  "   if (bevel != 0.0) ",
  "   {",
  "      t0 = vec4(0, 0, 0, t0.a);",
  "      t1 = vec4(0, 0, 0, t1.a);",
  "      t2 = vec4(0, 0, 0, t2.a);",
  "      t3 = vec4(0, 0, 0, t3.a);",
  "      t4 = vec4(0, 0, 0, t4.a);",
  "   }",
  "	t0 = mix(bk, t0, t0.a);",
  "	t1 = mix(bk, t1, t1.a);",
  "	t2 = mix(bk, t2, t2.a);",
  "	t3 = mix(bk, t3, t3.a);",
  "	t4 = mix(bk, t4, t4.a);",
  "	float d0 = abs(t0.r);",
  "	float d1 = abs(t1.r);",
  "	float d2 = abs(t2.r);",
  "	float d3 = abs(t3.r);",
  "	float d4 = abs(t4.r);",
  "	float dx = ((d2 - d0) + (d0 - d1)) * intensity;",
  "	float dy = ((d4 - d0) + (d0 - d3)) * intensity;",
  "	vec4 normal = vec4(normalize(vec3(dx * invertR, dy * invertG, 1.0 - ((bias - 0.1) / 100.0))), 1.0);",
  "	gl_FragColor = vec4(normal.xyz * 0.5 + 0.5, 1.0);",
  "}"
], fx = cx.join(`
`);
BABYLON.Effect.ShadersStore[`${Cd.FRAGMENT_SHADER}PixelShader`] = fx;
const lu = class Ad extends qr {
  constructor(e, t, s, o, a, c, g) {
    super(e, t, Ad.FRAGMENT_SHADER, s, o, c, g), this._opacity = 1, this.updateShaderUniforms();
  }
  get opacity() {
    return this._opacity == null ? 1 : this._opacity;
  }
  set opacity(e) {
    this._opacity = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    super.updateShaderUniforms(), !this.initializing && this.setFloat("opacity", this.opacity);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
lu.FRAGMENT_SHADER = "zakeke_OpacityProceduralTexture";
lu.CUSTOM_TYPE = "Zakeke.OpacityProceduralTexture";
let dx = lu;
const gx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform float opacity;",
  "void main(void) {",
  "	vec4 color = texture2D(uSampler, vUV.xy);",
  "   color.a = opacity;",
  "   gl_FragColor = color;",
  "}"
], px = gx.join(`
`);
BABYLON.Effect.ShadersStore[`${dx.FRAGMENT_SHADER}PixelShader`] = px;
const hu = class Td extends qr {
  constructor(e, t, s, o, a, c, g) {
    super(e, t, Td.FRAGMENT_SHADER, s, o, c, g), this._blendTexture = a, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = new BABYLON.Vector2(1, 1);
      this.baseTexture && (e = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale)), this.setVector2("uSamplerScale", e), this.setTexture("uBlendSampler", this._blendTexture);
      var t = new BABYLON.Vector2(1, 1);
      this._blendTexture && (t = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale)), this.setVector2("uBlendScale", t);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
hu.FRAGMENT_SHADER = "zakeke_OverlayProceduralTexture";
hu.CUSTOM_TYPE = "Zakeke.OverlayProceduralTexture";
let rl = hu;
var _x = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "float BlendOverlayf(float base, float blend)",
  "{",
  "   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));",
  "}",
  "vec4 BlendOverlay(vec4 base, vec4 blend)",
  "{",
  "   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));",
  "}",
  "void main(void) {",
  "	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = BlendOverlay(base, blend);",
  "}"
], mx = _x.join(`
`);
BABYLON.Effect.ShadersStore[`${rl.FRAGMENT_SHADER}PixelShader`] = mx;
const uu = class al extends BABYLON.ProceduralTexture {
  constructor(e, t, s = null, o, a) {
    super(e, t, al.FRAGMENT_SHADER, s, o, a), this._baseTexture = null, this._blendTexture = null, this.updateShaderUniforms();
  }
  dispose() {
    this._baseTexture && this._baseTexture.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    this._baseTexture ? (this.setTexture("uSampler", this._baseTexture), this.setInt("hasSampler", 1), this.setVector2("uSamplerScale", new BABYLON.Vector2(this._baseTexture.uScale, this._baseTexture.vScale))) : (this.setInt("hasSampler", 0), this.setVector2("uSamplerScale", new BABYLON.Vector2(1, 1))), this._blendTexture ? (this.setTexture("uBlendSampler", this._blendTexture), this.setInt("hasBlend", 1), this.setVector2("uBlendScale", new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale))) : (this.setInt("hasBlend", 0), this.setVector2("uBlendScale", new BABYLON.Vector2(1, 1))), this.setFloat("size", this.getRenderSize());
  }
  render(e) {
    super.render(e);
  }
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  isReady() {
    return this._baseTexture && !this._baseTexture.isReady() || this._blendTexture && !this._blendTexture.isReady() ? !1 : super.isReady();
  }
  //@BABYLON.serializeAsTexture()
  get baseTexture() {
    return this._baseTexture;
  }
  set baseTexture(e) {
    this._baseTexture = e, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  /**
   * Serializes this normal map procedural texture
   * @returns a serialized normal map procedural texture object
   */
  serialize() {
    var e = BABYLON.SerializationHelper.Serialize(this, super.serialize());
    return e.customType = al.CUSTOM_TYPE, this.baseTexture ? e.baseTexture = this.baseTexture.serialize() : e.baseTexture = null, this.blendTexture ? e.blendTexture = this.blendTexture.serialize() : e.blendTexture = null, e;
  }
  /**
   * Creates a Normal Map Procedural Texture from parsed normal map procedural texture data
   * @param parsedTexture defines parsed texture data
   * @param scene defines the current scene
   * @param rootUrl defines the root URL containing normal map procedural texture information
   * @returns a parsed Normal Map Procedural Texture
   */
  static Parse(e, t, s) {
    var o = BABYLON.SerializationHelper.Parse(
      () => new al(
        e.name,
        e._size,
        t,
        void 0,
        e._generateMipMaps
      ),
      e,
      t,
      s
    );
    return e.baseTexture && (o.baseTexture = BABYLON.Texture.Parse(e.baseTexture, t, s)), e.blendTexture && (o.blendTexture = BABYLON.Texture.Parse(e.blendTexture, t, s)), o;
  }
};
uu.FRAGMENT_SHADER = "zakeke_BlendProceduralTexture";
uu.CUSTOM_TYPE = "Zakeke.BlendProceduralTexture";
let Ld = uu;
var vx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "uniform bool hasSampler;",
  "uniform bool hasBlend;",
  "float BlendOverlayf(float base, float blend)",
  "{",
  "   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));",
  "}",
  "vec4 BlendOverlay(vec4 base, vec4 blend)",
  "{",
  "   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));",
  "}",
  "void main(void) {",
  "   if (!hasSampler && !hasBlend)",
  "   {",
  "       gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);",
  "       return;",
  "   }",
  "   if (hasSampler && !hasBlend)",
  "   {",
  "       gl_FragColor = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "       return;",
  "   }",
  "   if (!hasSampler && hasBlend)",
  "   {",
  "       gl_FragColor = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "       return;",
  "   }",
  "   vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "   vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = BlendOverlay(base, blend);",
  "}"
], yx = vx.join(`
`);
BABYLON.Effect.ShadersStore[`${Ld.FRAGMENT_SHADER}PixelShader`] = yx;
BABYLON.RegisterClass("Zakeke.BlendProceduralTexture", Ld);
class Bd {
  constructor() {
  }
  getSubmeshIdx(e) {
    let t = e.lastIndexOf("-");
    if (t != -1) {
      e = e.substring(0, t);
      let s = Number(e.substring(t + 1));
      if (s && !isNaN(s))
        return s;
    }
    return null;
  }
  getRegExp(e, t) {
    if ((t & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
      let s = e.lastIndexOf("-");
      s != -1 && (e = e.substring(0, s), Number(e.substring(s + 1)));
    }
    return new RegExp(this.escapeRegExp(e).replace(/\\\*/g, ".*"), "i");
  }
  getElements(e, t, s, o, a) {
    const c = [], g = o.split(";");
    for (let w = 0; w < g.length; w++) {
      const T = g[w];
      let H = T, Y = this.getRegExp(T, a);
      if ((a & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const ee = this.getMeshes(e, t, s, Y, H);
        Array.prototype.push.apply(c, ee);
      }
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let ee = this.getSubmeshIdx(H);
        if (ee) {
          const z = this.getSubMeshes(e, t, s, Y, H, ee);
          Array.prototype.push.apply(c, z);
        }
      }
      if ((a & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const ee = this.getMaterials(e, t, s, Y, H);
        Array.prototype.push.apply(c, ee);
      }
      if ((a & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const ee = this.getLights(e, t, s, Y, H);
        Array.prototype.push.apply(c, ee);
      }
      if ((a & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const ee = this.getCameras(e, t, s, Y, H);
        Array.prototype.push.apply(c, ee);
      }
      if ((a & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const ee = this.getCameraLocations(e, t, s, Y);
        Array.prototype.push.apply(c, ee);
      }
    }
    return c;
  }
  getMeshElements(e, t, s, o, a) {
    const c = [], g = o.split(";");
    for (let w = 0; w < g.length; w++) {
      const T = g[w];
      let H = T, Y = this.getRegExp(T, a);
      if ((a & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const ee = this.getMeshes(e, t, s, Y, H);
        Array.prototype.push.apply(c, ee);
      }
    }
    return c;
  }
  getSubMeshElements(e, t, s, o, a) {
    const c = [], g = o.split(";");
    for (let w = 0; w < g.length; w++) {
      const T = g[w];
      let H = T, Y = this.getRegExp(T, a);
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let ee = this.getSubmeshIdx(H);
        if (ee) {
          const z = this.getSubMeshes(e, t, s, Y, H, ee);
          Array.prototype.push.apply(c, z);
        }
      }
    }
    return c;
  }
  getMaterialElements(e, t, s, o, a) {
    const c = [], g = o.split(";");
    for (let w = 0; w < g.length; w++) {
      const T = g[w];
      let H = T, Y = this.getRegExp(T, a);
      if ((a & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const ee = this.getMaterials(e, t, s, Y, H);
        Array.prototype.push.apply(c, ee);
      }
    }
    return c;
  }
  getLightElements(e, t, s, o, a) {
    const c = [], g = o.split(";");
    for (let w = 0; w < g.length; w++) {
      const T = g[w];
      let H = T, Y = this.getRegExp(T, a);
      if ((a & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const ee = this.getLights(e, t, s, Y, H);
        Array.prototype.push.apply(c, ee);
      }
    }
    return c;
  }
  getCameraElements(e, t, s, o, a) {
    const c = [], g = o.split(";");
    for (let w = 0; w < g.length; w++) {
      const T = g[w];
      let H = T, Y = this.getRegExp(T, a);
      if ((a & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const ee = this.getCameras(e, t, s, Y, H);
        Array.prototype.push.apply(c, ee);
      }
    }
    return c;
  }
  getCameraLocationElements(e, t, s, o, a) {
    const c = [], g = o.split(";");
    for (let w = 0; w < g.length; w++) {
      const T = g[w];
      let H = this.getRegExp(T, a);
      if ((a & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const Y = this.getCameraLocations(e, t, s, H);
        Array.prototype.push.apply(c, Y);
      }
    }
    return c;
  }
  getOffloadedElementIDs(e, t, s, o, a) {
    const c = [], g = o.split(";");
    for (let Y = 0; Y < g.length; Y++) {
      const ee = g[Y];
      let z = ee;
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var w = ee.lastIndexOf("-");
        w != -1 && (z = ee.substring(0, w), Number(ee.substring(w + 1)));
      }
      var T = new RegExp(this.escapeRegExp(z).replace(/\\\*/g, ".*"), "i");
      if ((a & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        var H = this.getOffloadedMaterialIDs(e, t, s, T, z);
        Array.prototype.push.apply(c, H);
      }
    }
    return c;
  }
  getDelayedElementIDs(e, t, s, o, a) {
    const c = [], g = o.split(";");
    for (let Y = 0; Y < g.length; Y++) {
      const ee = g[Y];
      let z = ee;
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var w = ee.lastIndexOf("-");
        w != -1 && (z = ee.substring(0, w), Number(ee.substring(w + 1)));
      }
      var T = new RegExp(this.escapeRegExp(z).replace(/\\\*/g, ".*"), "i");
      if ((a & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        var H = this.getDelayedMaterialIDs(e, t, s, T, z);
        Array.prototype.push.apply(c, H);
      }
    }
    return c;
  }
  getMeshes(e, t, s, o, a) {
    const c = [];
    if (t && t instanceof BABYLON.Scene)
      for (let g = 0; g < t.meshes.length; g++) {
        const w = t.meshes[g];
        (w.name && o.test(w.name) || w.id && w.id == a) && this.verifyFilter(w.id, s) && c.push(w);
      }
    return c;
  }
  getSubMeshes(e, t, s, o, a, c) {
    const g = [];
    if (t && t instanceof BABYLON.Scene)
      for (let w = 0; w < t.meshes.length; w++) {
        const T = t.meshes[w];
        (T.name && o.test(T.name) || T.id && T.id == a) && this.verifyFilter(T.id, s) && c < T.subMeshes.length && c >= 0 && g.push(T.subMeshes[c]);
      }
    return g;
  }
  getMaterials(e, t, s, o, a) {
    const c = [];
    if (t && t instanceof BABYLON.Scene)
      for (let g = 0; g < t.materials.length; g++) {
        const w = t.materials[g];
        (w.name && o.test(w.name) || w.id && w.id == a || w.metadata && !w.metadata.isRealMaterial && w.metadata.originalMaterialID == a) && this.verifyFilter(w.id, s) && c.push(w);
      }
    return c;
  }
  getOffloadedMaterialIDs(e, t, s, o, a) {
    const c = [];
    if (t && t instanceof BABYLON.Scene && t.metadata && t.metadata.offloadedMaterials)
      for (let g in t.metadata.offloadedMaterials) {
        const w = t.metadata.offloadedMaterials[g];
        (w.name && o.test(w.name) || g && g == a) && this.verifyFilter(g, s) && c.push(g);
      }
    return c;
  }
  getDelayedMaterialIDs(e, t, s, o, a) {
    const c = [];
    if (t && t instanceof BABYLON.Scene && t.metadata && t.metadata.delayedMaterials)
      for (let g in t.metadata.delayedMaterials) {
        const w = t.metadata.delayedMaterials[g];
        (w.name && o.test(w.name) || g && g == a) && this.verifyFilter(g, s) && c.push(g);
      }
    return c;
  }
  getLights(e, t, s, o, a) {
    const c = [];
    if (t && t instanceof BABYLON.Scene)
      for (let g = 0; g < t.lights.length; g++) {
        const w = t.lights[g];
        (w.name && o.test(w.name) || w.id && w.id == a) && this.verifyFilter(w.id, s) && c.push(w);
      }
    return c;
  }
  getCameras(e, t, s, o, a) {
    const c = [];
    if (t && t instanceof BABYLON.Scene)
      for (let g = 0; g < t.cameras.length; g++) {
        const w = t.cameras[g];
        (w.name && o.test(w.name) || w.id && w.id == a) && this.verifyFilter(w.id, s) && c.push(w);
      }
    return c;
  }
  getCameraLocations(e, t, s, o) {
    var a = [];
    if (e && e instanceof Zakeke.Scene)
      for (var c = 0; c < e.get("cameraLocations").length; c++) {
        var g = e.get("cameraLocations").at(c), w = g.getLocationID(), T = g.get("name");
        (T && o.test(T) || w && o.test(w)) && this.verifyFilter(w, s) && a.push(g);
      }
    return a;
  }
  getYesNoElements(e, t, s, o, a) {
    const c = { yes: [], no: [] }, g = o.split(";");
    for (let w = 0; w < g.length; w++) {
      const T = g[w];
      let H = T, Y = 0;
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let z = T.lastIndexOf("-");
        if (z != -1) {
          H = T.substring(0, z);
          let he = Number(T.substring(z + 1));
          he && !isNaN(he) && (Y = he);
        }
      }
      const ee = new RegExp(this.escapeRegExp(H).replace(/\\\*/g, ".*"), "i");
      if ((a & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const z = this.getYesNoMeshes(e, t, s, ee);
        Array.prototype.push.apply(c.yes, z.yes), Array.prototype.push.apply(c.no, z.no);
      }
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        const z = this.getYesNoSubMeshes(e, t, s, ee, Y);
        Array.prototype.push.apply(c.yes, z.yes), Array.prototype.push.apply(c.no, z.no);
      }
      if ((a & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const z = this.getYesNoMaterials(e, t, s, ee);
        Array.prototype.push.apply(c.yes, z.yes), Array.prototype.push.apply(c.no, z.no);
      }
      if ((a & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const z = this.getYesNoLights(e, t, s, ee);
        Array.prototype.push.apply(c.yes, z.yes), Array.prototype.push.apply(c.no, z.no);
      }
      if ((a & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const z = this.getYesNoCameras(e, t, s, ee);
        Array.prototype.push.apply(c.yes, z.yes), Array.prototype.push.apply(c.no, z.no);
      }
      if ((a & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const z = this.getYesNoCameraLocations(e, t, s, ee);
        Array.prototype.push.apply(c.yes, z.yes), Array.prototype.push.apply(c.no, z.no);
      }
    }
    return c;
  }
  getYesNoMeshes(e, t, s, o) {
    const a = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.meshes.length; c++) {
        let g = t.meshes[c], w = a.no;
        (g.name && o.test(g.name) || g.id && o.test(g.id)) && this.verifyFilter(g.id, s) && (w = a.yes), w.push(g);
      }
    return a;
  }
  getYesNoSubMeshes(e, t, s, o, a) {
    const c = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let g = 0; g < t.meshes.length; g++) {
        let w = t.meshes[g];
        if ((w.name && o.test(w.name) || w.id && o.test(w.id)) && this.verifyFilter(w.id, s) && w.subMeshes)
          for (let T = 0; T < w.subMeshes.length; T++)
            T == a ? c.yes.push(w.subMeshes[T]) : c.no.push(w.subMeshes[T]);
      }
    return c;
  }
  getYesNoMaterials(e, t, s, o) {
    const a = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.materials.length; c++) {
        let g = t.materials[c];
        (g.name && o.test(g.name) || g.id && o.test(g.id)) && this.verifyFilter(g.id, s) ? a.yes.push(g) : a.no.push(g);
      }
    return a;
  }
  getYesNoLights(e, t, s, o) {
    const a = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.lights.length; c++) {
        let g = t.lights[c];
        (g.name && o.test(g.name) || g.id && o.test(g.id)) && this.verifyFilter(g.id, s) ? a.yes.push(g) : a.no.push(g);
      }
    return a;
  }
  getYesNoCameras(e, t, s, o) {
    const a = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let c = 0; c < t.cameras.length; c++) {
        let g = t.cameras[c];
        (g.name && o.test(g.name) || g.id && o.test(g.id)) && this.verifyFilter(g.id, s) ? a.yes.push(g) : a.no.push(g);
      }
    return a;
  }
  getYesNoCameraLocations(e, t, s, o) {
    const a = { yes: [], no: [] };
    if (e && e instanceof Zakeke.Scene)
      for (let c = 0; c < e.get("cameraLocations").length; c++) {
        let g = e.get("cameraLocations").at(c), w = g.getLocationID(), T = g.get("name");
        (T && o.test(T) || w && o.test(w)) && this.verifyFilter(w, s) ? a.yes.push(g) : a.no.push(g);
      }
    return a;
  }
  escapeRegExp(e) {
    return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  verifyFilter(e, t) {
    return !t || t.length == 0 ? !0 : t.indexOf(e) !== -1;
  }
}
var nn = globalThis && globalThis.__awaiter || function(v, e, t, s) {
  function o(a) {
    return a instanceof t ? a : new t(function(c) {
      c(a);
    });
  }
  return new (t || (t = Promise))(function(a, c) {
    function g(H) {
      try {
        T(s.next(H));
      } catch (Y) {
        c(Y);
      }
    }
    function w(H) {
      try {
        T(s.throw(H));
      } catch (Y) {
        c(Y);
      }
    }
    function T(H) {
      H.done ? a(H.value) : o(H.value).then(g, w);
    }
    T((s = s.apply(v, e || [])).next());
  });
}, sn = globalThis && globalThis.__generator || function(v, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, s, o, a, c;
  return c = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function g(T) {
    return function(H) {
      return w([T, H]);
    };
  }
  function w(T) {
    if (s)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (s = 1, o && (a = T[0] & 2 ? o.return : T[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, T[1])).done)
          return a;
        switch (o = 0, a && (T = [T[0] & 2, a.value]), T[0]) {
          case 0:
          case 1:
            a = T;
            break;
          case 4:
            return t.label++, { value: T[1], done: !1 };
          case 5:
            t.label++, o = T[1], T = [0];
            continue;
          case 7:
            T = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (T[0] === 6 || T[0] === 2)) {
              t = 0;
              continue;
            }
            if (T[0] === 3 && (!a || T[1] > a[0] && T[1] < a[3])) {
              t.label = T[1];
              break;
            }
            if (T[0] === 6 && t.label < a[1]) {
              t.label = a[1], a = T;
              break;
            }
            if (a && t.label < a[2]) {
              t.label = a[2], t.ops.push(T);
              break;
            }
            a[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        T = e.call(v, t);
      } catch (H) {
        T = [6, H], o = 0;
      } finally {
        s = a = 0;
      }
    if (T[0] & 5)
      throw T[1];
    return { value: T[0] ? T[1] : void 0, done: !0 };
  }
}, bx = (
  /** @class */
  function() {
    function v(e, t, s) {
      this._zkModel = null, this._sceneHelper = null, this._deviceType = MPlaza.DeviceType.All, this._meshDesignRefreshRequiredListeners = [], this._beginAssetsLoadingListeners = [], this._endAssetsLoadingListeners = [], this._useMaterialOffloading = !1, this._prefetchMeshes = !0, this._prefetchMaterials = !0, this._zkScene = e, this._scene = t, this._sceneHelper = new ni(t), this._elementSelector = new Bd(), s && (this._zkModel = s);
    }
    return Object.defineProperty(v.prototype, "deviceType", {
      get: function() {
        return this._deviceType;
      },
      set: function(e) {
        this._deviceType != e && (this._deviceType = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "useMaterialOffloading", {
      get: function() {
        return this._useMaterialOffloading;
      },
      set: function(e) {
        this._useMaterialOffloading != e && (this._useMaterialOffloading = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "prefetchMeshes", {
      get: function() {
        return this._prefetchMeshes;
      },
      set: function(e) {
        this._prefetchMeshes !== e && (this._prefetchMeshes = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(v.prototype, "prefetchMaterials", {
      get: function() {
        return this._prefetchMaterials;
      },
      set: function(e) {
        this._prefetchMaterials !== e && (this._prefetchMaterials = e);
      },
      enumerable: !1,
      configurable: !0
    }), v.prototype.dispose = function() {
      this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null);
    }, v.prototype.addMeshDesignRefreshRequiredListeners = function(e) {
      this._meshDesignRefreshRequiredListeners.push(e);
    }, v.prototype.fireMeshDesignRefreshRequiredEvent = function(e, t) {
      for (var s = { meshes: e, effect: t }, o = 0; o < this._meshDesignRefreshRequiredListeners.length; ++o)
        this._meshDesignRefreshRequiredListeners[o](s);
    }, v.prototype.addBeginAssetsLoadingListener = function(e) {
      this._beginAssetsLoadingListeners.push(e);
    }, v.prototype.fireBeginAssetsLoadingEvent = function() {
      for (var e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
        this._beginAssetsLoadingListeners[e]();
    }, v.prototype.addEndAssetsLoadingListener = function(e) {
      this._endAssetsLoadingListeners.push(e);
    }, v.prototype.fireEndAssetsLoadingEvent = function() {
      for (var e = 0; e < this._endAssetsLoadingListeners.length; ++e)
        this._endAssetsLoadingListeners[e]();
    }, v.prototype.isActionForDevice = function(e) {
      var t = e.get("deviceTypes");
      return t === MPlaza.DeviceType.Any || t === MPlaza.DeviceType.All || (t & this._deviceType) === this._deviceType;
    }, v.prototype.setupMeshData = function(e) {
      e.data || (e.data = {
        filters: {},
        toShow: e.isVisible
      });
    }, v.prototype.setMeshFilterAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        return sn(this, function(o) {
          switch (o.label) {
            case 0:
              return this.setupMeshData(e), e.data.filters[t] = s, [4, this.chekMeshVisibilityAsync(e)];
            case 1:
              return o.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.setMeshVisibilityAsync = function(e, t) {
      return nn(this, void 0, void 0, function() {
        return sn(this, function(s) {
          switch (s.label) {
            case 0:
              return this.setupMeshData(e), e.data.toShow = t, [4, this.chekMeshVisibilityAsync(e)];
            case 1:
              return s.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.chekMeshVisibilityAsync = function(e) {
      return nn(this, void 0, void 0, function() {
        var t, s, o;
        return sn(this, function(a) {
          switch (a.label) {
            case 0:
              if (t = null, e && e.data && (t = e.data.toShow, t))
                for (s in e.data.filters)
                  t = t && e.data.filters[s];
              return t !== null && this._sceneHelper ? t ? (o = this._zkScene.get("rootUrl"), o ? [4, this._sceneHelper.unsetMeshDummyMaterialAsync(e, o, !0)] : [3, 2]) : [3, 4] : [3, 5];
            case 1:
              a.sent(), a.label = 2;
            case 2:
              return [4, ni.whenMeshIsReadyAsync(e)];
            case 3:
              a.sent(), a.label = 4;
            case 4:
              this._sceneHelper.showHideMesh(e.id, t), a.label = 5;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.getMeshByID = function(e) {
      return this._scene.getMeshByID(e);
    }, v.prototype.getMaterialByID = function(e) {
      return this._scene.getMaterialByID(e);
    }, v.prototype.setCameraLocation = function(e) {
      var t = this._zkScene.getCameraLocation(e);
      if (t) {
        var s = new BABYLON.Vector3(t.get("px"), t.get("py"), t.get("pz")), o = new BABYLON.Vector3(t.get("tx"), t.get("ty"), t.get("tz"));
        this._sceneHelper && this._sceneHelper.animateCamera(o, s, 0.5);
      }
    }, v.prototype.adjustCamera = function(e) {
      this._sceneHelper && (e !== void 0 && typeof e == "boolean" ? this._sceneHelper.adjustCamera(void 0, void 0, void 0, e) : this._sceneHelper.adjustCamera());
    }, v.prototype.zoomIn = function() {
      this._sceneHelper && this._sceneHelper.zoomIn();
    }, v.prototype.zoomOut = function() {
      this._sceneHelper && this._sceneHelper.zoomOut();
    }, v.prototype.zoom = function(e) {
      this._sceneHelper && this._sceneHelper.zoom(e);
    }, v.prototype.setCameraPivot = function(e) {
      if (this._sceneHelper) {
        var t = e ? this._scene.getMeshByID(e) : null;
        this._sceneHelper.setCameraPivot(t);
      }
    }, v.prototype.setCameraZoomEnabled = function(e) {
      this._sceneHelper && this._sceneHelper.setZoomEnabled(e);
    }, v.prototype.setMeshMaterial = function(e, t) {
      return nn(this, void 0, void 0, function() {
        var s;
        return sn(this, function(o) {
          switch (o.label) {
            case 0:
              return this._sceneHelper ? [4, ni.whenAllMaterialTexturesAreReady(e)] : [3, 2];
            case 1:
              o.sent(), s = t.material, Logger.info("Setting material to mesh | mesh: " + t.id + " - " + t.name + " | material: " + e.id + " - " + e.name), this._sceneHelper.applyMaterial(e, t), this._useMaterialOffloading && s && this._sceneHelper.offloadMaterial(s.id), o.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.setSubmeshMaterial = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o;
        return sn(this, function(a) {
          switch (a.label) {
            case 0:
              return this._sceneHelper ? [4, ni.whenAllMaterialTexturesAreReady(e)] : [3, 2];
            case 1:
              a.sent(), o = this._sceneHelper.getSubMeshMaterial(t, s), this._sceneHelper.applyMaterialToSubMesh(e, t, s), this._useMaterialOffloading && o && this._sceneHelper.offloadMaterial(o.id), a.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.getMaterialFromActionValue = function(e) {
      if (this._elementSelector) {
        var t = e.get("value");
        if (t != null && t != null) {
          var s = this._scene.getMaterialByID(t);
          return s || (s = this._scene.getMaterialByName(t)), s;
        }
      }
      return null;
    }, v.prototype.getDelayedMaterialIDFromAction = function(e) {
      if (this._zkScene && this._scene && this._elementSelector && e && e instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.delayedMaterials) {
        var t = e.get("value");
        if (t != null && t != null) {
          if (this._scene.metadata.delayedMaterials.hasOwnProperty(t))
            return t;
          for (var s in this._scene.metadata.delayedMaterials)
            if (this._scene.metadata.delayedMaterials[s].name === t)
              return s;
        }
      }
      return null;
    }, v.prototype.checkDelayedMaterial = function(e) {
      return nn(this, void 0, void 0, function() {
        var t, s;
        return sn(this, function(o) {
          switch (o.label) {
            case 0:
              return t = this.getMaterialByID(e), !t && this._sceneHelper ? (s = this._zkScene.get("rootUrl"), s != null && s != null ? [4, this._sceneHelper.loadDelayedMaterialAsync(s, e)] : [3, 2]) : [3, 2];
            case 1:
              t = o.sent(), o.label = 2;
            case 2:
              return [2, t];
          }
        });
      });
    }, v.prototype.getOffloadedMaterialIDFromAction = function(e) {
      if (this._zkScene && this._scene && this._elementSelector && e && e instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
        var t = e.get("value");
        if (t != null) {
          if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t))
            return t;
          for (var s in this._scene.metadata.offloadedMaterials)
            if (this._scene.metadata.offloadedMaterials[s].name === t)
              return s;
        }
      }
      return null;
    }, v.prototype.checkOffloadedMaterialAsync = function(e) {
      return nn(this, void 0, void 0, function() {
        var t, s;
        return sn(this, function(o) {
          switch (o.label) {
            case 0:
              return t = this.getMaterialByID(e), !t && this._sceneHelper ? (s = this._zkScene.get("rootUrl"), s == null ? [3, 2] : [4, this._sceneHelper.loadOffloadedMaterialAsync(s, e)]) : [3, 2];
            case 1:
              t = o.sent(), o.label = 2;
            case 2:
              return [2, t];
          }
        });
      });
    }, v.prototype.getDeepMaterialFromActionValueAsync = function(e) {
      return nn(this, void 0, void 0, function() {
        var t, s, o;
        return sn(this, function(a) {
          switch (a.label) {
            case 0:
              return t = this.getMaterialFromActionValue(e), !t && this._sceneHelper ? (s = this._zkScene.get("rootUrl"), s == null ? [3, 4] : (o = this.getOffloadedMaterialIDFromAction(e), o ? (Logger.info("Requesting offloaded material - id: ", o), [4, this._sceneHelper.loadOffloadedMaterialAsync(s, o)]) : [3, 2])) : [3, 4];
            case 1:
              return t = a.sent(), Logger.info("Obtained offloaded material - id: ", o), [3, 4];
            case 2:
              return o = this.getDelayedMaterialIDFromAction(e), o ? (Logger.info("Requesting delayed material - id: ", o), [4, this._sceneHelper.loadDelayedMaterialAsync(s, o)]) : [3, 4];
            case 3:
              t = a.sent(), Logger.info("Obtained delayed material - id: ", o), a.label = 4;
            case 4:
              return [2, t];
          }
        });
      });
    }, v.prototype.scriptRequiresDelayedLoading = function(e) {
      for (var t = 0; t < e.length; t++) {
        var s = e[t];
        if (this.actionsRequireDelayedLoading(s.actions))
          return !0;
      }
      return !1;
    }, v.prototype.actionsRequireDelayedLoading = function(e) {
      for (var t = 0; t < e.length; t++)
        if (this.actionRequiresDelayedLoading(e[t]))
          return !0;
      return !1;
    }, v.prototype.actionRequiresDelayedLoading = function(e) {
      if (this._sceneHelper && e.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && e.get("value") === "show") {
        var t = e.get("selector");
        if (t != null)
          for (var s = this._elementSelector.getElements(this._zkScene, this._scene, null, t, MPlaza.SceneElementType.Mesh), o = 0; o < s.length; o++) {
            var a = s[o];
            if (a instanceof BABYLON.AbstractMesh && !a.isVisible) {
              var c = this._sceneHelper.getMeshDelayedMaterialIDs(a), g = this._sceneHelper.getMeshOffloadedMaterialIDs(a);
              if (c.length > 0 || g.length > 0 || ni.meshRequiresDelayedLoading(a))
                return !0;
            }
          }
      }
      if (e.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || e.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial || e.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor || e.get("actionTypeID") === MPlaza.SceneActionType.SetMeshDesignMaterial) {
        var w = this.getMaterialFromActionValue(e);
        if (!w) {
          var T = this.getDelayedMaterialIDFromAction(e);
          if (T)
            return !0;
          var H = this.getOffloadedMaterialIDFromAction(e);
          if (H)
            return !0;
        }
      }
      if (e.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
        var t = e.get("selector");
        if (t != null) {
          var Y = this._elementSelector.getDelayedElementIDs(this._zkScene, this._scene, null, t, MPlaza.SceneElementType.Material), ee = this._elementSelector.getOffloadedElementIDs(this._zkScene, this._scene, null, t, MPlaza.SceneElementType.Material);
          if (Y.length > 0 || ee.length > 0)
            return !0;
        }
      }
      return !1;
    }, v.prototype.getAllMaterialElementsAsync = function(e) {
      return nn(this, void 0, void 0, function() {
        var t, s, o, a, c, g, w, T, H, Y;
        return sn(this, function(ee) {
          switch (ee.label) {
            case 0:
              return t = [], this._zkScene && this._scene && this._sceneHelper && this._elementSelector ? (s = this._elementSelector.getMaterialElements(this._zkScene, this._scene, null, e, MPlaza.SceneElementType.Material), Array.prototype.push.apply(t, s), o = s.map(function(z) {
                return z.id;
              }), a = this._elementSelector.getDelayedElementIDs(this._zkScene, this._scene, null, e, MPlaza.SceneElementType.Material), c = this._elementSelector.getOffloadedElementIDs(this._zkScene, this._scene, null, e, MPlaza.SceneElementType.Material), g = this._zkScene.get("rootUrl"), g == null ? [3, 4] : (w = [], a.forEach(function(z) {
                o.indexOf(z) === -1 && w.push(z);
              }), w.length > 0 ? [4, this._sceneHelper.loadDelayedMaterialsAsync(g, w)] : [3, 2])) : [3, 4];
            case 1:
              T = ee.sent(), Array.prototype.push.apply(t, T), ee.label = 2;
            case 2:
              return H = [], c.forEach(function(z) {
                o.indexOf(z) === -1 && H.push(z);
              }), H.length > 0 ? [4, this._sceneHelper.loadOffloadedMaterialsByIDsAsync(g, H)] : [3, 4];
            case 3:
              Y = ee.sent(), Array.prototype.push.apply(t, Y), ee.label = 4;
            case 4:
              return [2, t];
          }
        });
      });
    }, v.prototype.executeScriptAsync = function(e) {
      return nn(this, void 0, void 0, function() {
        var t, s, o;
        return sn(this, function(a) {
          switch (a.label) {
            case 0:
              t = this.scriptRequiresDelayedLoading(e), t && this.fireBeginAssetsLoadingEvent(), s = 0, a.label = 1;
            case 1:
              return s < e.length ? (o = e[s], [4, this.executeActionsAsync(o.attributeID, o.selectedValue, o.actions, !1)]) : [3, 4];
            case 2:
              a.sent(), a.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              return t && this.fireEndAssetsLoadingEvent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.executeActionsAsync = function(e, t, s, o) {
      return o === void 0 && (o = !0), nn(this, void 0, void 0, function() {
        var a, c;
        return sn(this, function(g) {
          switch (g.label) {
            case 0:
              return s.length > 0 ? (a = this.actionsRequireDelayedLoading(s), o && a && this.fireBeginAssetsLoadingEvent(), [4, this.checkActionsAssetsAreReadyAsync(s)]) : [3, 6];
            case 1:
              g.sent(), c = 0, g.label = 2;
            case 2:
              return c < s.length ? [4, this.executeActionAsync(e, t, s[c])] : [3, 5];
            case 3:
              g.sent(), g.label = 4;
            case 4:
              return c++, [3, 2];
            case 5:
              o && a && this.fireEndAssetsLoadingEvent(), g.label = 6;
            case 6:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.executeActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o;
        return sn(this, function(a) {
          switch (a.label) {
            case 0:
              if (!this.isActionForDevice(s))
                return [
                  2
                  /*return*/
                ];
              if (!s)
                return [3, 25];
              switch (o = s.get("actionTypeID"), o) {
                case MPlaza.SceneActionType.Filter:
                  return [3, 1];
                case MPlaza.SceneActionType.ShowHideMesh:
                  return [3, 3];
                case MPlaza.SceneActionType.SetMeshMaterial:
                  return [3, 5];
                case MPlaza.SceneActionType.SetSubMeshMaterial:
                  return [3, 7];
                case MPlaza.SceneActionType.SetMaterialColor:
                  return [3, 9];
                case MPlaza.SceneActionType.SetCameraLocation:
                  return [3, 11];
                case MPlaza.SceneActionType.AdjustCamera:
                  return [3, 13];
                case MPlaza.SceneActionType.SetCameraPivot:
                  return [3, 15];
                case MPlaza.SceneActionType.ResetCameraPivot:
                  return [3, 17];
                case MPlaza.SceneActionType.EnableDiableZoom:
                  return [3, 19];
                case MPlaza.SceneActionType.SetMeshDesignMaterial:
                  return [3, 21];
                case MPlaza.SceneActionType.SetMeshDesignEffect:
                  return [3, 23];
              }
              return [3, 25];
            case 1:
              return [4, this.executeFilterActionAsync(e, t, s)];
            case 2:
              return a.sent(), [3, 25];
            case 3:
              return [4, this.executeShowHideActionAsync(e, t, s)];
            case 4:
              return a.sent(), [3, 25];
            case 5:
              return [4, this.executeSetMeshMaterialActionAsync(e, t, s)];
            case 6:
              return a.sent(), [3, 25];
            case 7:
              return [4, this.executeSetSubMeshMaterialActionAsync(e, t, s)];
            case 8:
              return a.sent(), [3, 25];
            case 9:
              return [4, this.executeSetMaterialColorActionAsync(e, t, s)];
            case 10:
              return a.sent(), [3, 25];
            case 11:
              return [4, this.executeSetCameraLocationActionAsync(e, t, s)];
            case 12:
              return a.sent(), [3, 25];
            case 13:
              return [4, this.executeAdjustCameraActionAsync(e, t, s)];
            case 14:
              return a.sent(), [3, 25];
            case 15:
              return [4, this.executeSetCameraPivotActionAsync(e, t, s)];
            case 16:
              return a.sent(), [3, 25];
            case 17:
              return [4, this.executeResetCameraPivotActionAsync(e, t, s)];
            case 18:
              return a.sent(), [3, 25];
            case 19:
              return [4, this.executeEnableDisableZoomActionAsync(e, t, s)];
            case 20:
              return a.sent(), [3, 25];
            case 21:
              return [4, this.executeSetMeshDesignMaterialActionAsync(e, t, s)];
            case 22:
              return a.sent(), [3, 25];
            case 23:
              return [4, this.executeSetMeshDesignEffectActionAsync(e, t, s)];
            case 24:
              return a.sent(), [3, 25];
            case 25:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.executeFilterActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o, a, c, g, g;
        return sn(this, function(w) {
          switch (w.label) {
            case 0:
              if (!this.isActionForDevice(s))
                return [
                  2
                  /*return*/
                ];
              if (!(e !== null && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction))
                return [3, 8];
              if (o = s.get("selector"), o == null)
                return [3, 8];
              a = this._elementSelector.getYesNoElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), c = s.get("value") === "enable", g = 0, w.label = 1;
            case 1:
              return g < a.yes.length ? [4, this.setMeshFilterAsync(a.yes[g], e, c)] : [3, 4];
            case 2:
              w.sent(), w.label = 3;
            case 3:
              return g++, [3, 1];
            case 4:
              g = 0, w.label = 5;
            case 5:
              return g < a.no.length ? [4, this.setMeshFilterAsync(a.yes[g], e, !c)] : [3, 8];
            case 6:
              w.sent(), w.label = 7;
            case 7:
              return g++, [3, 5];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.executeShowHideActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o, a, c, g;
        return sn(this, function(w) {
          switch (w.label) {
            case 0:
              if (!this.isActionForDevice(s))
                return [
                  2
                  /*return*/
                ];
              if (!(this._zkScene && this._scene && this._sceneHelper && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction))
                return [3, 4];
              if (o = s.get("selector"), o == null)
                return [3, 4];
              a = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), c = s.get("value") === "show", g = 0, w.label = 1;
            case 1:
              return g < a.length ? [4, this.setMeshVisibilityAsync(a[g], c)] : [3, 4];
            case 2:
              w.sent(), w.label = 3;
            case 3:
              return g++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.executeSetMeshMaterialActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o, a, c, g;
        return sn(this, function(w) {
          switch (w.label) {
            case 0:
              return this.isActionForDevice(s) ? this._zkScene && this._scene && this._sceneHelper && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction ? (o = s.get("selector"), o == null ? [3, 5] : (a = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), [4, this.getDeepMaterialFromActionValueAsync(s)])) : [3, 5] : [
                2
                /*return*/
              ];
            case 1:
              if (c = w.sent(), !c)
                return [3, 5];
              g = 0, w.label = 2;
            case 2:
              return g < a.length ? [4, this.setMeshMaterial(c, a[g])] : [3, 5];
            case 3:
              w.sent(), w.label = 4;
            case 4:
              return g++, [3, 2];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.executeSetSubMeshMaterialActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o, a, c, g;
        return sn(this, function(w) {
          switch (w.label) {
            case 0:
              return this.isActionForDevice(s) ? this._zkScene && this._scene && this._sceneHelper && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction ? (o = s.get("selector"), o == null ? [3, 5] : (a = this._elementSelector.getSubMeshElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.SubMesh), [4, this.getDeepMaterialFromActionValueAsync(s)])) : [3, 5] : [
                2
                /*return*/
              ];
            case 1:
              if (c = w.sent(), !c)
                return [3, 5];
              g = 0, w.label = 2;
            case 2:
              return g < a.length ? [4, this.setSubmeshMaterial(c, null, a[g])] : [3, 5];
            case 3:
              w.sent(), w.label = 4;
            case 4:
              return g++, [3, 2];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.executeSetMaterialColorActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o, a, c, g, w, T;
        return sn(this, function(H) {
          switch (H.label) {
            case 0:
              return this.isActionForDevice(s) ? this._zkScene && this._scene && this._sceneHelper && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction ? (o = s.get("selector"), o == null ? [3, 2] : [4, this.getAllMaterialElementsAsync(o)]) : [3, 2] : [
                2
                /*return*/
              ];
            case 1:
              if (a = H.sent(), c = s.get("propertyName"), g = s.get("value"), c && g)
                for (t && (g = g.replace(/%value%/g, t)), w = BABYLON.Color3.FromHexString(g), T = 0; T < a.length; T++)
                  this._sceneHelper.changeMaterialColor(a[T], c, w);
              H.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.executeSetCameraLocationActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o, a, c, g;
        return sn(this, function(w) {
          if (!this.isActionForDevice(s))
            return [
              2
              /*return*/
            ];
          if (this._zkScene && this._scene && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction) {
            if (o = s.get("value"), a = null, o) {
              for (c = 0; c < this._zkScene.get("cameraLocations").length; c++)
                if (g = this._zkScene.get("cameraLocations").at(c), g.get("locationID") === o || g.get("name") === o) {
                  a = g;
                  break;
                }
            }
            a !== null && this.setCameraLocation(a.get("locationID"));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, v.prototype.executeAdjustCameraActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        return sn(this, function(o) {
          return this.isActionForDevice(s) ? (this._zkScene && this._scene && this._sceneHelper && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction && this._sceneHelper.adjustCamera(), [
            2
            /*return*/
          ]) : [
            2
            /*return*/
          ];
        });
      });
    }, v.prototype.executeSetCameraPivotActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o, a, c, g;
        return sn(this, function(w) {
          if (!this.isActionForDevice(s))
            return [
              2
              /*return*/
            ];
          if (this._zkScene && this._scene && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction) {
            if (o = s.get("value"), a = null, o) {
              for (c = 0; c < this._scene.meshes.length; c++)
                if (g = this._scene.meshes[c], g.id === o || g.name === o) {
                  a = g;
                  break;
                }
            }
            a && this.setCameraPivot(a.id);
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, v.prototype.executeResetCameraPivotActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        return sn(this, function(o) {
          return this.isActionForDevice(s) ? (this.setCameraPivot(null), [
            2
            /*return*/
          ]) : [
            2
            /*return*/
          ];
        });
      });
    }, v.prototype.executeEnableDisableZoomActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o;
        return sn(this, function(a) {
          return this.isActionForDevice(s) ? (this._zkScene && this._scene && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction && (o = s.get("value") === "enable", this.setCameraZoomEnabled(o)), [
            2
            /*return*/
          ]) : [
            2
            /*return*/
          ];
        });
      });
    }, v.prototype.executeSetMeshDesignMaterialActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o, a, c, g, w;
        return sn(this, function(T) {
          switch (T.label) {
            case 0:
              return this._zkScene && this._scene && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction ? (o = s.get("selector"), o != null && o != null ? (a = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), [4, this.getDeepMaterialFromActionValueAsync(s)]) : [3, 2]) : [3, 2];
            case 1:
              if (c = T.sent(), c) {
                for (g = 0; g < a.length; g++)
                  w = a[g], w.metadata = w.metadata || {}, w.metadata.designMaterialID = c.id;
                this.fireMeshDesignRefreshRequiredEvent(a, null);
              }
              T.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.executeSetMeshDesignEffectActionAsync = function(e, t, s) {
      return nn(this, void 0, void 0, function() {
        var o, a, c, g, w, T, H, Y, ee, z, he;
        return sn(this, function(ne) {
          switch (ne.label) {
            case 0:
              if (!this.isActionForDevice(s))
                return [
                  2
                  /*return*/
                ];
              if (!(this._zkScene && this._scene && this._elementSelector && s && s instanceof MPlaza.AttributeSceneAction))
                return [3, 4];
              if (o = s.get("selector"), !(o != null && o != null))
                return [3, 4];
              if (a = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), c = s.get("value"), g = null, c != null && c != null && this._zkModel)
                for (w = 0; w < this._zkModel.get("scenes").length; w++) {
                  if (T = this._zkModel.get("scenes").at(w), T.get("isDefault") && (H = T.get("meshDesignEffects"), H)) {
                    for (Y = 0; Y < H.length; Y++)
                      if (ee = H.at(Y), ee.get("effectID") === c || ee.get("name") === c) {
                        g = ee;
                        break;
                      }
                  }
                  if (g)
                    break;
                }
              return z = null, g ? (he = g.get("materialID"), he ? [4, this.checkOffloadedMaterialAsync(he)] : [3, 3]) : [3, 3];
            case 1:
              return z = ne.sent(), z ? [3, 3] : [4, this.checkDelayedMaterial(he)];
            case 2:
              z = ne.sent(), ne.label = 3;
            case 3:
              this.fireMeshDesignRefreshRequiredEvent(a, g), ne.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.prefetchMeshesForUnselectedOptionsAsync = function(e) {
      return nn(this, void 0, void 0, function() {
        var t, s, o, a, c, g, w;
        return sn(this, function(T) {
          switch (T.label) {
            case 0:
              if (!(this._zkScene && this._scene && this._elementSelector && this._sceneHelper && this._prefetchMeshes))
                return [3, 6];
              t = 0, T.label = 1;
            case 1:
              if (!(t < e.length))
                return [3, 6];
              if (s = e[t], !(s && s instanceof MPlaza.AttributeSceneAction))
                return [3, 5];
              if (!(s.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && s.get("value") == "show"))
                return [3, 5];
              if (o = s.get("selector"), !(o != null && o != null))
                return [3, 5];
              a = this._elementSelector.getElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), c = 0, T.label = 2;
            case 2:
              return c < a.length ? (g = a[c], g instanceof BABYLON.AbstractMesh && !g.isVisible ? (this._sceneHelper.checkDelayState(g), w = g.material, w ? [4, this._sceneHelper.prefetchTexturesForMaterialAsync(w)] : [3, 4]) : [3, 4]) : [3, 5];
            case 3:
              T.sent(), T.label = 4;
            case 4:
              return c++, [3, 2];
            case 5:
              return t++, [3, 1];
            case 6:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.checkActionsAssetsAreReadyAsync = function(e) {
      return nn(this, void 0, void 0, function() {
        var T, H, t, ee, s, o, a, c, g, w, T, H, Y, ee;
        return sn(this, function(z) {
          switch (z.label) {
            case 0:
              if (!(this._zkScene && this._scene && this._elementSelector && this._sceneHelper))
                return [3, 17];
              T = 0, z.label = 1;
            case 1:
              if (!(T < e.length))
                return [3, 11];
              if (H = e[T], t = [], !(H && H instanceof MPlaza.AttributeSceneAction))
                return [3, 8];
              if (!(H.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && H.get("value") === "show"))
                return [3, 8];
              if (ee = H.get("selector"), ee == null)
                return [3, 8];
              s = this._elementSelector.getElements(this._zkScene, this._scene, null, ee, MPlaza.SceneElementType.Mesh), o = 0, z.label = 2;
            case 2:
              return o < s.length ? (a = s[o], a instanceof BABYLON.AbstractMesh && !a.isVisible ? (c = this._zkScene.get("rootUrl"), c ? (g = this._sceneHelper.getMeshDelayedMaterialIDs(a), w = this._sceneHelper.getMeshOffloadedMaterialIDs(a), g.length > 0 ? [4, this._sceneHelper.loadDelayedMaterialsAsync(c, g)] : [3, 4]) : [3, 6]) : [3, 7]) : [3, 8];
            case 3:
              z.sent(), z.label = 4;
            case 4:
              return w.length > 0 ? [4, this._sceneHelper.loadOffloadedMaterialsByIDsAsync(c, w)] : [3, 6];
            case 5:
              z.sent(), z.label = 6;
            case 6:
              t.push(a), z.label = 7;
            case 7:
              return o++, [3, 2];
            case 8:
              return [4, ni.whenAllMeshesAreReadyAsync(t)];
            case 9:
              z.sent(), z.label = 10;
            case 10:
              return T++, [3, 1];
            case 11:
              T = 0, z.label = 12;
            case 12:
              return T < e.length ? (H = e[T], H && H instanceof MPlaza.AttributeSceneAction ? H.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || H.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial ? (Y = this.getMaterialFromActionValue(H), Y ? [3, 14] : [4, this.getDeepMaterialFromActionValueAsync(H)]) : [3, 14] : [3, 16]) : [3, 17];
            case 13:
              Y = z.sent(), z.label = 14;
            case 14:
              return H.get("actionTypeID") !== MPlaza.SceneActionType.SetMaterialColor ? [3, 16] : (ee = H.get("selector"), ee == null ? [3, 16] : [4, this.getAllMaterialElementsAsync(ee)]);
            case 15:
              z.sent(), z.label = 16;
            case 16:
              return T++, [3, 12];
            case 17:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, v.prototype.prefetchDataForUnselectedOptionsAsync = function(e) {
      return nn(this, void 0, void 0, function() {
        return sn(this, function(t) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, v;
  }()
);
class xx {
  constructor() {
    this._zkScene = null, this._scene = null, this._sceneHelper = null, this._meshLocationCache = {}, this._cameraAnimationCompletedListeners = [], this._meshAnimationCompletedListeners = [], this._beforeSaveMeshLocationListeners = [], this._afterSaveMeshLocationListeners = [];
  }
  dispose() {
    for (; this._cameraAnimationCompletedListeners.length > 0; )
      this._cameraAnimationCompletedListeners.pop();
    for (; this._meshAnimationCompletedListeners.length > 0; )
      this._meshAnimationCompletedListeners.pop();
    for (; this._beforeSaveMeshLocationListeners.length > 0; )
      this._beforeSaveMeshLocationListeners.pop();
    for (; this._afterSaveMeshLocationListeners.length > 0; )
      this._afterSaveMeshLocationListeners.pop();
    this.disposeSceneHelper();
  }
  setScene(e) {
    this._scene = e, this.resetSceneHelper(), this.resetCache();
  }
  setModel(e) {
    this._zkScene = e, this.resetCache();
  }
  setModelAndScene(e, t) {
    this._zkScene = e, this._scene = t, this.resetSceneHelper(), this.resetCache();
  }
  resetCache() {
    this._meshLocationCache = {};
  }
  invalidateCache(e) {
    this._meshLocationCache && delete this._meshLocationCache[e];
  }
  disposeSceneHelper() {
    this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null);
  }
  resetSceneHelper() {
    this.disposeSceneHelper(), this._scene && (this._sceneHelper = new ni(this._scene));
  }
  clearMeshLocations() {
    if (this._zkScene) {
      const e = this._zkScene.get("meshLocations");
      for (; e.length > 0; )
        e.remove(e.at(0));
    }
  }
  async setMeshLocationByID(e) {
    if (this._zkScene && this._scene) {
      const t = this._zkScene.getMeshLocation(e);
      t && await this.setMeshLocation(t);
    }
  }
  async setMeshLocation(e) {
    if (this._zkScene && this._scene && this._sceneHelper) {
      let T, H = !0;
      if (e) {
        let Y = e.get("locationID");
        if (H = e.get("adjustCamera"), this._meshLocationCache.hasOwnProperty(Y))
          T = this._meshLocationCache[Y];
        else {
          let ee = e.get("data"), z = null;
          if (typeof ee == "string") {
            let he = window.atob(ee), ne = he.length, ye = new Uint8Array(ne);
            for (let _e = 0; _e < ne; _e++)
              ye[_e] = he.charCodeAt(_e);
            let se = ye.buffer;
            z = new Uint8Array(se);
          } else
            Object.prototype.toString.call(ee) === "[object Array]" && (z = Uint8Array.from(ee));
          if (z != null) {
            let he = LZString.decompressFromUint8Array(z);
            if (T = JSON.parse(he), T) {
              for (var t in T) {
                var s = T[t];
                s.p && (s.p = new BABYLON.Vector3(s.p.x, s.p.y, s.p.z)), s.rE && (s.rE = new BABYLON.Vector3(s.rE.x, s.rE.y, s.rE.z)), s.rQ && (s.rQ = new BABYLON.Quaternion(s.rQ.x, s.rQ.y, s.rQ.z, s.rQ.w)), s.s && (s.s = new BABYLON.Vector3(s.s.x, s.s.y, s.s.z));
              }
              this._meshLocationCache[Y] = T;
            }
          }
        }
      }
      if (T) {
        const Y = [];
        if (H && T.hasOwnProperty("wemin") && T.hasOwnProperty("wemax")) {
          var o = {
            min: new BABYLON.Vector3(T.wemin.x, T.wemin.y, T.wemin.z),
            max: new BABYLON.Vector3(T.wemax.x, T.wemax.y, T.wemax.z)
          };
          let ee = this._sceneHelper.camera;
          if (ee && ee instanceof BABYLON.ArcRotateCamera) {
            ee.upperRadiusLimit = null;
            var a = this._sceneHelper.calculateCameraRadius(o), c = this._sceneHelper.getWorldCenter(o);
            c && (this._sceneHelper.setCameraRadiusParameters(a), Y.push(new Promise((z) => {
              ee && ee instanceof BABYLON.ArcRotateCamera && this._sceneHelper.animateCameraToFinalParamters(ee.alpha, ee.beta, a, c, 1, () => {
                this._sceneHelper && (this._sceneHelper.setupCameraLimits(o), this.fireCameraAnimationCompletedEvent(), z());
              });
            })));
          }
        }
        for (var g = 0; g < this._scene.meshes.length; g++) {
          var w = this._scene.meshes[g], t = w.id;
          if (T.hasOwnProperty(t)) {
            var s = T[t];
            Y.push(new Promise((he) => {
              this._sceneHelper.animateMeshToFinalParameters(w, s.p, s.rE, s.rQ, s.s, 1, () => {
                this.fireMeshAnimationCompletedEvent(), he();
              });
            }));
          }
        }
        await Promise.all(Y);
      }
    }
  }
  saveMeshLocation(e) {
    if (this._zkScene && this._scene) {
      var t = new Zakeke.SceneMeshLocation();
      t.set("name", e), this.updateMeshLocation(t), this._zkScene.get("meshLocations").push(t);
    }
  }
  saveExplodedMeshLocation() {
    if (this._zkScene && this._scene) {
      var e = this._zkScene.getOrCreateExplodedMeshLocation();
      this.updateMeshLocation(e);
    }
  }
  saveCollapsedMeshLocation() {
    if (this._zkScene && this._scene) {
      var e = this._zkScene.getOrCreateCollapsedMeshLocation();
      this.updateMeshLocation(e);
    }
  }
  updateMeshLocation(e) {
    if (this.fireBeforeSaveMeshLocationEvent(), this._scene && this._sceneHelper) {
      var t = this.getMeshPRSs(), s = this._sceneHelper.getWorldExtends();
      if (s) {
        let g = {
          x: s.min.x,
          y: s.min.y,
          z: s.min.z
        }, w = {
          x: s.max.x,
          y: s.max.y,
          z: s.max.z
        };
        t.wemin = g, t.wemax = w;
      }
      var o = JSON.stringify(t);
      let a = LZString.compressToUint8Array(o), c = [].slice.call(a);
      e.set("data", c), this.invalidateCache(e.get("locationID"));
    }
    this.fireAfterSaveMeshLocationEvent();
  }
  getMeshPRSs() {
    let e = {
      wemin: void 0,
      wemax: void 0
    };
    if (this._scene && this._sceneHelper)
      for (let t = 0; t < this._scene.meshes.length; t++) {
        const s = this._scene.meshes[t];
        if (this._sceneHelper.isRealMesh(s)) {
          let o = s.id, a = {
            p: void 0,
            rQ: void 0,
            rE: void 0,
            s: void 0
          }, c = {
            x: s.position.x,
            y: s.position.y,
            z: s.position.z
          };
          if (a.p = c, s.rotationQuaternion == null) {
            a.rQ = null;
            let w = {
              x: s.rotation.x,
              y: s.rotation.y,
              z: s.rotation.z
            };
            a.rE = w;
          } else {
            let w = {
              w: s.rotationQuaternion.w,
              x: s.rotationQuaternion.x,
              y: s.rotationQuaternion.y,
              z: s.rotationQuaternion.z
            };
            a.rQ = w, a.rE = null;
          }
          let g = {
            x: s.scaling.x,
            y: s.scaling.y,
            z: s.scaling.z
          };
          a.s = g, e[o] = a;
        }
      }
    return e;
  }
  async explodeMeshes() {
    if (this._zkScene) {
      let e = this._zkScene.getFirstExplodedMeshLocation();
      e && await this.setMeshLocation(e);
    }
  }
  async collapseMeshes() {
    if (this._zkScene) {
      let e = this._zkScene.getFirstCollapsedMeshLocation();
      e && await this.setMeshLocation(e);
    }
  }
  // Events
  fireCameraAnimationCompletedEvent() {
    for (let e = 0; e < this._cameraAnimationCompletedListeners.length; ++e)
      this._cameraAnimationCompletedListeners[e]();
  }
  addCameraAnimationCompletedListener(e) {
    this._cameraAnimationCompletedListeners.push(e);
  }
  fireMeshAnimationCompletedEvent() {
    for (let e = 0; e < this._meshAnimationCompletedListeners.length; ++e)
      this._meshAnimationCompletedListeners[e]();
  }
  addMeshAnimationCompletedListener(e) {
    this._meshAnimationCompletedListeners.push(e);
  }
  fireBeforeSaveMeshLocationEvent() {
    for (let e = 0; e < this._beforeSaveMeshLocationListeners.length; ++e)
      this._beforeSaveMeshLocationListeners[e]();
  }
  addBeforeSaveMeshLocationListener(e) {
    this._beforeSaveMeshLocationListeners.push(e);
  }
  fireAfterSaveMeshLocationEvent() {
    for (let e = 0; e < this._afterSaveMeshLocationListeners.length; ++e)
      this._afterSaveMeshLocationListeners[e]();
  }
  addAfterSaveMeshLocationListener(e) {
    this._afterSaveMeshLocationListeners.push(e);
  }
}
class wx {
  constructor(e, t) {
    this._glowLayer = null, this._zkScene = e, this._scene = t, this._sceneHelper = new ni(this._scene), this._glowLayer = this._scene.getGlowLayerByName("glow");
  }
  get enabled() {
    const e = this.getGlowConfig();
    return e && e.get("enabled") != null && typeof e.get("enabled") == "boolean" && e.get("enabled"), !1;
  }
  set enabled(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("enabled", e), this.update();
  }
  get intensity() {
    const e = this.getGlowConfig();
    return e && e.get("intensity") != null && typeof e.get("intensity") == "number" && e.get("intensity"), 1;
  }
  set intensity(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("intensity", e), this.update();
  }
  get blurSize() {
    const e = this.getGlowConfig();
    return e && e.get("blurSize") != null && typeof e.get("blurSize") == "number" && e.get("blurSize"), 1;
  }
  set blurSize(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("blurSize", e), this.update();
  }
  dispose() {
    this.destroyGlowLayer();
  }
  destroyGlowLayer() {
    this._glowLayer && (this._glowLayer.dispose(), this._glowLayer = null);
  }
  createOrUpdateGlowLayer(e, t) {
    this._glowLayer || (this._glowLayer = new BABYLON.GlowLayer("glow", this._scene)), this._glowLayer && (this._glowLayer.intensity = e, this._glowLayer.blurKernelSize = t);
  }
  update() {
    if (this._scene) {
      var e = this.getGlowConfig();
      if (e) {
        const t = this.enabled, s = this.intensity, o = this.blurSize;
        t ? this.createOrUpdateGlowLayer(s, o) : this.destroyGlowLayer();
      } else
        this.destroyGlowLayer();
    }
  }
  turnOffGlow() {
    this.destroyGlowLayer();
  }
  turnOnGlow() {
    this.update();
  }
  sanityCheck() {
    return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != null && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
  }
  isGlowEnabledForMesh(e) {
    return e ? e.metadata && e.metadata.enableGlow : !1;
  }
  // La possibilità di abilitare solo alcune mesh al glow viene disabilitata
  // perché c'è il problema che l'effetto glow è visibile attraverso le mesh
  // per cui il glow è diabilitato
  enableGlowForMesh(e) {
  }
  disableGlowForMesh(e) {
  }
  getGlowConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGlowConfig();
      if (e)
        return e;
    }
    return null;
  }
  getOrCreateGlowConfig() {
    return this.sanityCheck() ? this._zkScene.getOrCreateGlowConfig() : null;
  }
}
class cu {
  /**
   * Constructor
   * @param workers Array of workers to use for actions
   */
  constructor(e) {
    this._pendingActions = new Array(), this._workerInfos = e.map((t) => ({
      worker: t,
      active: !1
    }));
  }
  /**
   * Terminates all workers and clears any pending actions.
   */
  dispose() {
    for (const e of this._workerInfos)
      e.worker.terminate();
    delete this._workerInfos, delete this._pendingActions;
  }
  /**
   * Pushes an action to the worker pool. If all the workers are active, the action will be
   * pended until a worker has completed its action.
   * @param action The action to perform. Call onComplete when the action is complete.
   */
  push(e) {
    for (const t of this._workerInfos)
      if (!t.active) {
        this._execute(t, e);
        return;
      }
    this._pendingActions.push(e);
  }
  _execute(e, t) {
    e.active = !0, t(e.worker, () => {
      e.active = !1;
      const s = this._pendingActions.shift();
      s && this._execute(e, s);
    });
  }
}
function Ed(v) {
  return typeof importScripts == "function" ? (importScripts(v), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(v, () => {
      e();
    }, (s) => {
      t(new Error(s));
    });
  });
}
function Od(v) {
  if (v.length == 0)
    return Promise.resolve();
  let e = [];
  for (let t = 0; t < v.length; t++)
    e.push(Ed(v[t]));
  return new Promise((t) => {
    Promise.all(e).then(() => t());
  });
}
function Id(v, e, t) {
  return new MakeIncremental().getSceneIncrementalFiles(v, e, t);
}
function Sx() {
  let v;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const s = t.urls;
        v = Od(s), postMessage("done");
        break;
      }
      case "makeIncremental": {
        if (!v)
          throw new Error("Worker not initialized");
        v.then(() => {
          const s = t.sceneJson, o = t.version, a = t.options, c = Id(s, o, a);
          postMessage({ id: "result", files: c }), postMessage("done");
        });
        break;
      }
    }
  };
}
function Mx(v) {
  return typeof document != "object" || typeof v != "string" ? v : BABYLON.Tools.GetAbsoluteUrl(v);
}
const dl = class ba {
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
  }
  /**
   * Default instance for the incremental file maker
   */
  static get Default() {
    return ba._Default || (ba._Default = new ba([])), ba._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
  */
  constructor(e, t = ba.DefaultNumWorkers) {
    const s = e.map((o) => Mx(o));
    if (t && typeof Worker == "function") {
      const o = `${Ed}${Od}${Id}(${Sx})()`, a = URL.createObjectURL(new Blob([o], { type: "application/javascript" })), c = new Array(t);
      for (let g = 0; g < c.length; g++)
        c[g] = new Promise((w, T) => {
          const H = new Worker(a), Y = (z) => {
            H.removeEventListener("error", Y), H.removeEventListener("message", ee), T(z);
          }, ee = (z) => {
            z.data === "done" && (H.removeEventListener("error", Y), H.removeEventListener("message", ee), w(H));
          };
          H.addEventListener("error", Y), H.addEventListener("message", ee), H.postMessage({
            id: "init",
            urls: s
          });
        });
      this._workerPoolPromise = Promise.all(c).then((g) => new cu(g));
    }
  }
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : Promise.resolve();
  }
  getIncrementalFilesAsync(e, t, s) {
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((o) => new Promise((a, c) => {
        o.push((g, w) => {
          let T = [];
          const H = (ee) => {
            g.removeEventListener("error", H), g.removeEventListener("message", Y), c(ee), w();
          }, Y = (ee) => {
            ee.data === "done" ? (g.removeEventListener("error", H), g.removeEventListener("message", Y), a(T), w()) : ee.data.id === "result" && (T = ee.data.files);
          };
          g.addEventListener("error", H), g.addEventListener("message", Y), g.postMessage({ id: "makeIncremental", sceneJson: e, version: t, options: s });
        });
      }));
    throw new Error("Incremental file worker is not available");
  }
};
dl.DefaultNumWorkers = dl.GetDefaultNumWorkers();
dl._Default = null;
let Cx = dl;
var Gr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function kd(v) {
  return v && v.__esModule && Object.prototype.hasOwnProperty.call(v, "default") ? v.default : v;
}
function Ax(v) {
  if (v.__esModule)
    return v;
  var e = v.default;
  if (typeof e == "function") {
    var t = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(v).forEach(function(s) {
    var o = Object.getOwnPropertyDescriptor(v, s);
    Object.defineProperty(t, s, o.get ? o : {
      enumerable: !0,
      get: function() {
        return v[s];
      }
    });
  }), t;
}
var Pd = { exports: {} };
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
(function(v) {
  (function(e, t) {
    v.exports = e.document ? t(e, !0) : function(s) {
      if (!s.document)
        throw new Error("jQuery requires a window with a document");
      return t(s);
    };
  })(typeof window < "u" ? window : Gr, function(e, t) {
    var s = [], o = Object.getPrototypeOf, a = s.slice, c = s.flat ? function(b) {
      return s.flat.call(b);
    } : function(b) {
      return s.concat.apply([], b);
    }, g = s.push, w = s.indexOf, T = {}, H = T.toString, Y = T.hasOwnProperty, ee = Y.toString, z = ee.call(Object), he = {}, ne = function(O) {
      return typeof O == "function" && typeof O.nodeType != "number" && typeof O.item != "function";
    }, ye = function(O) {
      return O != null && O === O.window;
    }, se = e.document, _e = {
      type: !0,
      src: !0,
      nonce: !0,
      noModule: !0
    };
    function ue(b, O, G) {
      G = G || se;
      var Z, oe, ce = G.createElement("script");
      if (ce.text = b, O)
        for (Z in _e)
          oe = O[Z] || O.getAttribute && O.getAttribute(Z), oe && ce.setAttribute(Z, oe);
      G.head.appendChild(ce).parentNode.removeChild(ce);
    }
    function xe(b) {
      return b == null ? b + "" : typeof b == "object" || typeof b == "function" ? T[H.call(b)] || "object" : typeof b;
    }
    var Ee = "3.7.1", K = /HTML$/i, j = function(b, O) {
      return new j.fn.init(b, O);
    };
    j.fn = j.prototype = {
      // The current version of jQuery being used
      jquery: Ee,
      constructor: j,
      // The default length of a jQuery object is 0
      length: 0,
      toArray: function() {
        return a.call(this);
      },
      // Get the Nth element in the matched element set OR
      // Get the whole matched element set as a clean array
      get: function(b) {
        return b == null ? a.call(this) : b < 0 ? this[b + this.length] : this[b];
      },
      // Take an array of elements and push it onto the stack
      // (returning the new matched element set)
      pushStack: function(b) {
        var O = j.merge(this.constructor(), b);
        return O.prevObject = this, O;
      },
      // Execute a callback for every element in the matched set.
      each: function(b) {
        return j.each(this, b);
      },
      map: function(b) {
        return this.pushStack(j.map(this, function(O, G) {
          return b.call(O, G, O);
        }));
      },
      slice: function() {
        return this.pushStack(a.apply(this, arguments));
      },
      first: function() {
        return this.eq(0);
      },
      last: function() {
        return this.eq(-1);
      },
      even: function() {
        return this.pushStack(j.grep(this, function(b, O) {
          return (O + 1) % 2;
        }));
      },
      odd: function() {
        return this.pushStack(j.grep(this, function(b, O) {
          return O % 2;
        }));
      },
      eq: function(b) {
        var O = this.length, G = +b + (b < 0 ? O : 0);
        return this.pushStack(G >= 0 && G < O ? [this[G]] : []);
      },
      end: function() {
        return this.prevObject || this.constructor();
      },
      // For internal use only.
      // Behaves like an Array's method, not like a jQuery method.
      push: g,
      sort: s.sort,
      splice: s.splice
    }, j.extend = j.fn.extend = function() {
      var b, O, G, Z, oe, ce, de = arguments[0] || {}, Pe = 1, Oe = arguments.length, Ue = !1;
      for (typeof de == "boolean" && (Ue = de, de = arguments[Pe] || {}, Pe++), typeof de != "object" && !ne(de) && (de = {}), Pe === Oe && (de = this, Pe--); Pe < Oe; Pe++)
        if ((b = arguments[Pe]) != null)
          for (O in b)
            Z = b[O], !(O === "__proto__" || de === Z) && (Ue && Z && (j.isPlainObject(Z) || (oe = Array.isArray(Z))) ? (G = de[O], oe && !Array.isArray(G) ? ce = [] : !oe && !j.isPlainObject(G) ? ce = {} : ce = G, oe = !1, de[O] = j.extend(Ue, ce, Z)) : Z !== void 0 && (de[O] = Z));
      return de;
    }, j.extend({
      // Unique for each copy of jQuery on the page
      expando: "jQuery" + (Ee + Math.random()).replace(/\D/g, ""),
      // Assume jQuery is ready without the ready module
      isReady: !0,
      error: function(b) {
        throw new Error(b);
      },
      noop: function() {
      },
      isPlainObject: function(b) {
        var O, G;
        return !b || H.call(b) !== "[object Object]" ? !1 : (O = o(b), O ? (G = Y.call(O, "constructor") && O.constructor, typeof G == "function" && ee.call(G) === z) : !0);
      },
      isEmptyObject: function(b) {
        var O;
        for (O in b)
          return !1;
        return !0;
      },
      // Evaluates a script in a provided context; falls back to the global one
      // if not specified.
      globalEval: function(b, O, G) {
        ue(b, { nonce: O && O.nonce }, G);
      },
      each: function(b, O) {
        var G, Z = 0;
        if (ht(b))
          for (G = b.length; Z < G && O.call(b[Z], Z, b[Z]) !== !1; Z++)
            ;
        else
          for (Z in b)
            if (O.call(b[Z], Z, b[Z]) === !1)
              break;
        return b;
      },
      // Retrieve the text value of an array of DOM nodes
      text: function(b) {
        var O, G = "", Z = 0, oe = b.nodeType;
        if (!oe)
          for (; O = b[Z++]; )
            G += j.text(O);
        return oe === 1 || oe === 11 ? b.textContent : oe === 9 ? b.documentElement.textContent : oe === 3 || oe === 4 ? b.nodeValue : G;
      },
      // results is for internal usage only
      makeArray: function(b, O) {
        var G = O || [];
        return b != null && (ht(Object(b)) ? j.merge(
          G,
          typeof b == "string" ? [b] : b
        ) : g.call(G, b)), G;
      },
      inArray: function(b, O, G) {
        return O == null ? -1 : w.call(O, b, G);
      },
      isXMLDoc: function(b) {
        var O = b && b.namespaceURI, G = b && (b.ownerDocument || b).documentElement;
        return !K.test(O || G && G.nodeName || "HTML");
      },
      // Support: Android <=4.0 only, PhantomJS 1 only
      // push.apply(_, arraylike) throws on ancient WebKit
      merge: function(b, O) {
        for (var G = +O.length, Z = 0, oe = b.length; Z < G; Z++)
          b[oe++] = O[Z];
        return b.length = oe, b;
      },
      grep: function(b, O, G) {
        for (var Z, oe = [], ce = 0, de = b.length, Pe = !G; ce < de; ce++)
          Z = !O(b[ce], ce), Z !== Pe && oe.push(b[ce]);
        return oe;
      },
      // arg is for internal usage only
      map: function(b, O, G) {
        var Z, oe, ce = 0, de = [];
        if (ht(b))
          for (Z = b.length; ce < Z; ce++)
            oe = O(b[ce], ce, G), oe != null && de.push(oe);
        else
          for (ce in b)
            oe = O(b[ce], ce, G), oe != null && de.push(oe);
        return c(de);
      },
      // A global GUID counter for objects
      guid: 1,
      // jQuery.support is not used in Core but other projects attach their
      // properties to it so it needs to exist.
      support: he
    }), typeof Symbol == "function" && (j.fn[Symbol.iterator] = s[Symbol.iterator]), j.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
      function(b, O) {
        T["[object " + O + "]"] = O.toLowerCase();
      }
    );
    function ht(b) {
      var O = !!b && "length" in b && b.length, G = xe(b);
      return ne(b) || ye(b) ? !1 : G === "array" || O === 0 || typeof O == "number" && O > 0 && O - 1 in b;
    }
    function Ze(b, O) {
      return b.nodeName && b.nodeName.toLowerCase() === O.toLowerCase();
    }
    var pt = s.pop, Pt = s.sort, Mt = s.splice, Tt = "[\\x20\\t\\r\\n\\f]", at = new RegExp(
      "^" + Tt + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Tt + "+$",
      "g"
    );
    j.contains = function(b, O) {
      var G = O && O.parentNode;
      return b === G || !!(G && G.nodeType === 1 && // Support: IE 9 - 11+
      // IE doesn't have `contains` on SVG.
      (b.contains ? b.contains(G) : b.compareDocumentPosition && b.compareDocumentPosition(G) & 16));
    };
    var Ai = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function Ve(b, O) {
      return O ? b === "\0" ? "�" : b.slice(0, -1) + "\\" + b.charCodeAt(b.length - 1).toString(16) + " " : "\\" + b;
    }
    j.escapeSelector = function(b) {
      return (b + "").replace(Ai, Ve);
    };
    var Ot = se, Ft = g;
    (function() {
      var b, O, G, Z, oe, ce = Ft, de, Pe, Oe, Ue, rt, lt = j.expando, Ke = 0, xt = 0, It = dn(), ai = dn(), si = dn(), fn = dn(), Qi = function(Te, Fe) {
        return Te === Fe && (oe = !0), 0;
      }, Zi = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", Qt = "(?:\\\\[\\da-fA-F]{1,6}" + Tt + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", di = "\\[" + Tt + "*(" + Qt + ")(?:" + Tt + // Operator (capture 2)
      "*([*^$|!~]?=)" + Tt + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
      `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + Qt + "))|)" + Tt + "*\\]", yn = ":(" + Qt + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + di + ")*)|.*)\\)|)", mi = new RegExp(Tt + "+", "g"), Oi = new RegExp("^" + Tt + "*," + Tt + "*"), Qs = new RegExp("^" + Tt + "*([>+~]|" + Tt + ")" + Tt + "*"), ts = new RegExp(Tt + "|>"), en = new RegExp(yn), hs = new RegExp("^" + Qt + "$"), En = {
        ID: new RegExp("^#(" + Qt + ")"),
        CLASS: new RegExp("^\\.(" + Qt + ")"),
        TAG: new RegExp("^(" + Qt + "|[*])"),
        ATTR: new RegExp("^" + di),
        PSEUDO: new RegExp("^" + yn),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + Tt + "*(even|odd|(([+-]|)(\\d*)n|)" + Tt + "*(?:([+-]|)" + Tt + "*(\\d+)|))" + Tt + "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + Zi + ")$", "i"),
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + Tt + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + Tt + "*((?:-\\d)?\\d*)" + Tt + "*\\)|)(?=[^-]|$)", "i")
      }, Et = /^(?:input|select|textarea|button)$/i, Vn = /^h\d$/i, bn = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Ls = /[+~]/, oi = new RegExp("\\\\[\\da-fA-F]{1,6}" + Tt + "?|\\\\([^\\r\\n\\f])", "g"), Hi = function(Te, Fe) {
        var Xe = "0x" + Te.slice(1) - 65536;
        return Fe || (Xe < 0 ? String.fromCharCode(Xe + 65536) : String.fromCharCode(Xe >> 10 | 55296, Xe & 1023 | 56320));
      }, Ct = function() {
        xn();
      }, Bs = us(
        function(Te) {
          return Te.disabled === !0 && Ze(Te, "fieldset");
        },
        { dir: "parentNode", next: "legend" }
      );
      function Gt() {
        try {
          return de.activeElement;
        } catch {
        }
      }
      try {
        ce.apply(
          s = a.call(Ot.childNodes),
          Ot.childNodes
        ), s[Ot.childNodes.length].nodeType;
      } catch {
        ce = {
          apply: function(Fe, Xe) {
            Ft.apply(Fe, a.call(Xe));
          },
          call: function(Fe) {
            Ft.apply(Fe, a.call(arguments, 1));
          }
        };
      }
      function vi(Te, Fe, Xe, $e) {
        var Ce, De, Ne, q, te, be, Ae, qe = Fe && Fe.ownerDocument, ot = Fe ? Fe.nodeType : 9;
        if (Xe = Xe || [], typeof Te != "string" || !Te || ot !== 1 && ot !== 9 && ot !== 11)
          return Xe;
        if (!$e && (xn(Fe), Fe = Fe || de, Oe)) {
          if (ot !== 11 && (te = bn.exec(Te)))
            if (Ce = te[1]) {
              if (ot === 9)
                if (Ne = Fe.getElementById(Ce)) {
                  if (Ne.id === Ce)
                    return ce.call(Xe, Ne), Xe;
                } else
                  return Xe;
              else if (qe && (Ne = qe.getElementById(Ce)) && vi.contains(Fe, Ne) && Ne.id === Ce)
                return ce.call(Xe, Ne), Xe;
            } else {
              if (te[2])
                return ce.apply(Xe, Fe.getElementsByTagName(Te)), Xe;
              if ((Ce = te[3]) && Fe.getElementsByClassName)
                return ce.apply(Xe, Fe.getElementsByClassName(Ce)), Xe;
            }
          if (!fn[Te + " "] && (!Ue || !Ue.test(Te))) {
            if (Ae = Te, qe = Fe, ot === 1 && (ts.test(Te) || Qs.test(Te))) {
              for (qe = Ls.test(Te) && ji(Fe.parentNode) || Fe, (qe != Fe || !he.scope) && ((q = Fe.getAttribute("id")) ? q = j.escapeSelector(q) : Fe.setAttribute("id", q = lt)), be = is(Te), De = be.length; De--; )
                be[De] = (q ? "#" + q : ":scope") + " " + Pn(be[De]);
              Ae = be.join(",");
            }
            try {
              return ce.apply(
                Xe,
                qe.querySelectorAll(Ae)
              ), Xe;
            } catch {
              fn(Te, !0);
            } finally {
              q === lt && Fe.removeAttribute("id");
            }
          }
        }
        return ns(Te.replace(at, "$1"), Fe, Xe, $e);
      }
      function dn() {
        var Te = [];
        function Fe(Xe, $e) {
          return Te.push(Xe + " ") > O.cacheLength && delete Fe[Te.shift()], Fe[Xe + " "] = $e;
        }
        return Fe;
      }
      function jt(Te) {
        return Te[lt] = !0, Te;
      }
      function Xi(Te) {
        var Fe = de.createElement("fieldset");
        try {
          return !!Te(Fe);
        } catch {
          return !1;
        } finally {
          Fe.parentNode && Fe.parentNode.removeChild(Fe), Fe = null;
        }
      }
      function Es(Te) {
        return function(Fe) {
          return Ze(Fe, "input") && Fe.type === Te;
        };
      }
      function Jr(Te) {
        return function(Fe) {
          return (Ze(Fe, "input") || Ze(Fe, "button")) && Fe.type === Te;
        };
      }
      function Fs(Te) {
        return function(Fe) {
          return "form" in Fe ? Fe.parentNode && Fe.disabled === !1 ? "label" in Fe ? "label" in Fe.parentNode ? Fe.parentNode.disabled === Te : Fe.disabled === Te : Fe.isDisabled === Te || // Where there is no isDisabled, check manually
          Fe.isDisabled !== !Te && Bs(Fe) === Te : Fe.disabled === Te : "label" in Fe ? Fe.disabled === Te : !1;
        };
      }
      function Hn(Te) {
        return jt(function(Fe) {
          return Fe = +Fe, jt(function(Xe, $e) {
            for (var Ce, De = Te([], Xe.length, Fe), Ne = De.length; Ne--; )
              Xe[Ce = De[Ne]] && (Xe[Ce] = !($e[Ce] = Xe[Ce]));
          });
        });
      }
      function ji(Te) {
        return Te && typeof Te.getElementsByTagName < "u" && Te;
      }
      function xn(Te) {
        var Fe, Xe = Te ? Te.ownerDocument || Te : Ot;
        return Xe == de || Xe.nodeType !== 9 || !Xe.documentElement || (de = Xe, Pe = de.documentElement, Oe = !j.isXMLDoc(de), rt = Pe.matches || Pe.webkitMatchesSelector || Pe.msMatchesSelector, Pe.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        Ot != de && (Fe = de.defaultView) && Fe.top !== Fe && Fe.addEventListener("unload", Ct), he.getById = Xi(function($e) {
          return Pe.appendChild($e).id = j.expando, !de.getElementsByName || !de.getElementsByName(j.expando).length;
        }), he.disconnectedMatch = Xi(function($e) {
          return rt.call($e, "*");
        }), he.scope = Xi(function() {
          return de.querySelectorAll(":scope");
        }), he.cssHas = Xi(function() {
          try {
            return de.querySelector(":has(*,:jqfake)"), !1;
          } catch {
            return !0;
          }
        }), he.getById ? (O.filter.ID = function($e) {
          var Ce = $e.replace(oi, Hi);
          return function(De) {
            return De.getAttribute("id") === Ce;
          };
        }, O.find.ID = function($e, Ce) {
          if (typeof Ce.getElementById < "u" && Oe) {
            var De = Ce.getElementById($e);
            return De ? [De] : [];
          }
        }) : (O.filter.ID = function($e) {
          var Ce = $e.replace(oi, Hi);
          return function(De) {
            var Ne = typeof De.getAttributeNode < "u" && De.getAttributeNode("id");
            return Ne && Ne.value === Ce;
          };
        }, O.find.ID = function($e, Ce) {
          if (typeof Ce.getElementById < "u" && Oe) {
            var De, Ne, q, te = Ce.getElementById($e);
            if (te) {
              if (De = te.getAttributeNode("id"), De && De.value === $e)
                return [te];
              for (q = Ce.getElementsByName($e), Ne = 0; te = q[Ne++]; )
                if (De = te.getAttributeNode("id"), De && De.value === $e)
                  return [te];
            }
            return [];
          }
        }), O.find.TAG = function($e, Ce) {
          return typeof Ce.getElementsByTagName < "u" ? Ce.getElementsByTagName($e) : Ce.querySelectorAll($e);
        }, O.find.CLASS = function($e, Ce) {
          if (typeof Ce.getElementsByClassName < "u" && Oe)
            return Ce.getElementsByClassName($e);
        }, Ue = [], Xi(function($e) {
          var Ce;
          Pe.appendChild($e).innerHTML = "<a id='" + lt + "' href='' disabled='disabled'></a><select id='" + lt + "-\r\\' disabled='disabled'><option selected=''></option></select>", $e.querySelectorAll("[selected]").length || Ue.push("\\[" + Tt + "*(?:value|" + Zi + ")"), $e.querySelectorAll("[id~=" + lt + "-]").length || Ue.push("~="), $e.querySelectorAll("a#" + lt + "+*").length || Ue.push(".#.+[+~]"), $e.querySelectorAll(":checked").length || Ue.push(":checked"), Ce = de.createElement("input"), Ce.setAttribute("type", "hidden"), $e.appendChild(Ce).setAttribute("name", "D"), Pe.appendChild($e).disabled = !0, $e.querySelectorAll(":disabled").length !== 2 && Ue.push(":enabled", ":disabled"), Ce = de.createElement("input"), Ce.setAttribute("name", ""), $e.appendChild(Ce), $e.querySelectorAll("[name='']").length || Ue.push("\\[" + Tt + "*name" + Tt + "*=" + Tt + `*(?:''|"")`);
        }), he.cssHas || Ue.push(":has"), Ue = Ue.length && new RegExp(Ue.join("|")), Qi = function($e, Ce) {
          if ($e === Ce)
            return oe = !0, 0;
          var De = !$e.compareDocumentPosition - !Ce.compareDocumentPosition;
          return De || (De = ($e.ownerDocument || $e) == (Ce.ownerDocument || Ce) ? $e.compareDocumentPosition(Ce) : (
            // Otherwise we know they are disconnected
            1
          ), De & 1 || !he.sortDetached && Ce.compareDocumentPosition($e) === De ? $e === de || $e.ownerDocument == Ot && vi.contains(Ot, $e) ? -1 : Ce === de || Ce.ownerDocument == Ot && vi.contains(Ot, Ce) ? 1 : Z ? w.call(Z, $e) - w.call(Z, Ce) : 0 : De & 4 ? -1 : 1);
        }), de;
      }
      vi.matches = function(Te, Fe) {
        return vi(Te, null, null, Fe);
      }, vi.matchesSelector = function(Te, Fe) {
        if (xn(Te), Oe && !fn[Fe + " "] && (!Ue || !Ue.test(Fe)))
          try {
            var Xe = rt.call(Te, Fe);
            if (Xe || he.disconnectedMatch || // As well, disconnected nodes are said to be in a document
            // fragment in IE 9
            Te.document && Te.document.nodeType !== 11)
              return Xe;
          } catch {
            fn(Fe, !0);
          }
        return vi(Fe, de, null, [Te]).length > 0;
      }, vi.contains = function(Te, Fe) {
        return (Te.ownerDocument || Te) != de && xn(Te), j.contains(Te, Fe);
      }, vi.attr = function(Te, Fe) {
        (Te.ownerDocument || Te) != de && xn(Te);
        var Xe = O.attrHandle[Fe.toLowerCase()], $e = Xe && Y.call(O.attrHandle, Fe.toLowerCase()) ? Xe(Te, Fe, !Oe) : void 0;
        return $e !== void 0 ? $e : Te.getAttribute(Fe);
      }, vi.error = function(Te) {
        throw new Error("Syntax error, unrecognized expression: " + Te);
      }, j.uniqueSort = function(Te) {
        var Fe, Xe = [], $e = 0, Ce = 0;
        if (oe = !he.sortStable, Z = !he.sortStable && a.call(Te, 0), Pt.call(Te, Qi), oe) {
          for (; Fe = Te[Ce++]; )
            Fe === Te[Ce] && ($e = Xe.push(Ce));
          for (; $e--; )
            Mt.call(Te, Xe[$e], 1);
        }
        return Z = null, Te;
      }, j.fn.uniqueSort = function() {
        return this.pushStack(j.uniqueSort(a.apply(this)));
      }, O = j.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: jt,
        match: En,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" }
        },
        preFilter: {
          ATTR: function(Te) {
            return Te[1] = Te[1].replace(oi, Hi), Te[3] = (Te[3] || Te[4] || Te[5] || "").replace(oi, Hi), Te[2] === "~=" && (Te[3] = " " + Te[3] + " "), Te.slice(0, 4);
          },
          CHILD: function(Te) {
            return Te[1] = Te[1].toLowerCase(), Te[1].slice(0, 3) === "nth" ? (Te[3] || vi.error(Te[0]), Te[4] = +(Te[4] ? Te[5] + (Te[6] || 1) : 2 * (Te[3] === "even" || Te[3] === "odd")), Te[5] = +(Te[7] + Te[8] || Te[3] === "odd")) : Te[3] && vi.error(Te[0]), Te;
          },
          PSEUDO: function(Te) {
            var Fe, Xe = !Te[6] && Te[2];
            return En.CHILD.test(Te[0]) ? null : (Te[3] ? Te[2] = Te[4] || Te[5] || "" : Xe && en.test(Xe) && // Get excess from tokenize (recursively)
            (Fe = is(Xe, !0)) && // advance to the next closing parenthesis
            (Fe = Xe.indexOf(")", Xe.length - Fe) - Xe.length) && (Te[0] = Te[0].slice(0, Fe), Te[2] = Xe.slice(0, Fe)), Te.slice(0, 3));
          }
        },
        filter: {
          TAG: function(Te) {
            var Fe = Te.replace(oi, Hi).toLowerCase();
            return Te === "*" ? function() {
              return !0;
            } : function(Xe) {
              return Ze(Xe, Fe);
            };
          },
          CLASS: function(Te) {
            var Fe = It[Te + " "];
            return Fe || (Fe = new RegExp("(^|" + Tt + ")" + Te + "(" + Tt + "|$)")) && It(Te, function(Xe) {
              return Fe.test(
                typeof Xe.className == "string" && Xe.className || typeof Xe.getAttribute < "u" && Xe.getAttribute("class") || ""
              );
            });
          },
          ATTR: function(Te, Fe, Xe) {
            return function($e) {
              var Ce = vi.attr($e, Te);
              return Ce == null ? Fe === "!=" : Fe ? (Ce += "", Fe === "=" ? Ce === Xe : Fe === "!=" ? Ce !== Xe : Fe === "^=" ? Xe && Ce.indexOf(Xe) === 0 : Fe === "*=" ? Xe && Ce.indexOf(Xe) > -1 : Fe === "$=" ? Xe && Ce.slice(-Xe.length) === Xe : Fe === "~=" ? (" " + Ce.replace(mi, " ") + " ").indexOf(Xe) > -1 : Fe === "|=" ? Ce === Xe || Ce.slice(0, Xe.length + 1) === Xe + "-" : !1) : !0;
            };
          },
          CHILD: function(Te, Fe, Xe, $e, Ce) {
            var De = Te.slice(0, 3) !== "nth", Ne = Te.slice(-4) !== "last", q = Fe === "of-type";
            return $e === 1 && Ce === 0 ? (
              // Shortcut for :nth-*(n)
              function(te) {
                return !!te.parentNode;
              }
            ) : function(te, be, Ae) {
              var qe, ot, it, wt, gi, zi = De !== Ne ? "nextSibling" : "previousSibling", tn = te.parentNode, an = q && te.nodeName.toLowerCase(), cs = !Ae && !q, fi = !1;
              if (tn) {
                if (De) {
                  for (; zi; ) {
                    for (it = te; it = it[zi]; )
                      if (q ? Ze(it, an) : it.nodeType === 1)
                        return !1;
                    gi = zi = Te === "only" && !gi && "nextSibling";
                  }
                  return !0;
                }
                if (gi = [Ne ? tn.firstChild : tn.lastChild], Ne && cs) {
                  for (ot = tn[lt] || (tn[lt] = {}), qe = ot[Te] || [], wt = qe[0] === Ke && qe[1], fi = wt && qe[2], it = wt && tn.childNodes[wt]; it = ++wt && it && it[zi] || // Fallback to seeking `elem` from the start
                  (fi = wt = 0) || gi.pop(); )
                    if (it.nodeType === 1 && ++fi && it === te) {
                      ot[Te] = [Ke, wt, fi];
                      break;
                    }
                } else if (cs && (ot = te[lt] || (te[lt] = {}), qe = ot[Te] || [], wt = qe[0] === Ke && qe[1], fi = wt), fi === !1)
                  for (; (it = ++wt && it && it[zi] || (fi = wt = 0) || gi.pop()) && !((q ? Ze(it, an) : it.nodeType === 1) && ++fi && (cs && (ot = it[lt] || (it[lt] = {}), ot[Te] = [Ke, fi]), it === te)); )
                    ;
                return fi -= Ce, fi === $e || fi % $e === 0 && fi / $e >= 0;
              }
            };
          },
          PSEUDO: function(Te, Fe) {
            var Xe, $e = O.pseudos[Te] || O.setFilters[Te.toLowerCase()] || vi.error("unsupported pseudo: " + Te);
            return $e[lt] ? $e(Fe) : $e.length > 1 ? (Xe = [Te, Te, "", Fe], O.setFilters.hasOwnProperty(Te.toLowerCase()) ? jt(function(Ce, De) {
              for (var Ne, q = $e(Ce, Fe), te = q.length; te--; )
                Ne = w.call(Ce, q[te]), Ce[Ne] = !(De[Ne] = q[te]);
            }) : function(Ce) {
              return $e(Ce, 0, Xe);
            }) : $e;
          }
        },
        pseudos: {
          // Potentially complex pseudos
          not: jt(function(Te) {
            var Fe = [], Xe = [], $e = xr(Te.replace(at, "$1"));
            return $e[lt] ? jt(function(Ce, De, Ne, q) {
              for (var te, be = $e(Ce, null, q, []), Ae = Ce.length; Ae--; )
                (te = be[Ae]) && (Ce[Ae] = !(De[Ae] = te));
            }) : function(Ce, De, Ne) {
              return Fe[0] = Ce, $e(Fe, null, Ne, Xe), Fe[0] = null, !Xe.pop();
            };
          }),
          has: jt(function(Te) {
            return function(Fe) {
              return vi(Te, Fe).length > 0;
            };
          }),
          contains: jt(function(Te) {
            return Te = Te.replace(oi, Hi), function(Fe) {
              return (Fe.textContent || j.text(Fe)).indexOf(Te) > -1;
            };
          }),
          // "Whether an element is represented by a :lang() selector
          // is based solely on the element's language value
          // being equal to the identifier C,
          // or beginning with the identifier C immediately followed by "-".
          // The matching of C against the element's language value is performed case-insensitively.
          // The identifier C does not have to be a valid language name."
          // https://www.w3.org/TR/selectors/#lang-pseudo
          lang: jt(function(Te) {
            return hs.test(Te || "") || vi.error("unsupported lang: " + Te), Te = Te.replace(oi, Hi).toLowerCase(), function(Fe) {
              var Xe;
              do
                if (Xe = Oe ? Fe.lang : Fe.getAttribute("xml:lang") || Fe.getAttribute("lang"))
                  return Xe = Xe.toLowerCase(), Xe === Te || Xe.indexOf(Te + "-") === 0;
              while ((Fe = Fe.parentNode) && Fe.nodeType === 1);
              return !1;
            };
          }),
          // Miscellaneous
          target: function(Te) {
            var Fe = e.location && e.location.hash;
            return Fe && Fe.slice(1) === Te.id;
          },
          root: function(Te) {
            return Te === Pe;
          },
          focus: function(Te) {
            return Te === Gt() && de.hasFocus() && !!(Te.type || Te.href || ~Te.tabIndex);
          },
          // Boolean properties
          enabled: Fs(!1),
          disabled: Fs(!0),
          checked: function(Te) {
            return Ze(Te, "input") && !!Te.checked || Ze(Te, "option") && !!Te.selected;
          },
          selected: function(Te) {
            return Te.parentNode && Te.parentNode.selectedIndex, Te.selected === !0;
          },
          // Contents
          empty: function(Te) {
            for (Te = Te.firstChild; Te; Te = Te.nextSibling)
              if (Te.nodeType < 6)
                return !1;
            return !0;
          },
          parent: function(Te) {
            return !O.pseudos.empty(Te);
          },
          // Element/input types
          header: function(Te) {
            return Vn.test(Te.nodeName);
          },
          input: function(Te) {
            return Et.test(Te.nodeName);
          },
          button: function(Te) {
            return Ze(Te, "input") && Te.type === "button" || Ze(Te, "button");
          },
          text: function(Te) {
            var Fe;
            return Ze(Te, "input") && Te.type === "text" && // Support: IE <10 only
            // New HTML5 attribute values (e.g., "search") appear
            // with elem.type === "text"
            ((Fe = Te.getAttribute("type")) == null || Fe.toLowerCase() === "text");
          },
          // Position-in-collection
          first: Hn(function() {
            return [0];
          }),
          last: Hn(function(Te, Fe) {
            return [Fe - 1];
          }),
          eq: Hn(function(Te, Fe, Xe) {
            return [Xe < 0 ? Xe + Fe : Xe];
          }),
          even: Hn(function(Te, Fe) {
            for (var Xe = 0; Xe < Fe; Xe += 2)
              Te.push(Xe);
            return Te;
          }),
          odd: Hn(function(Te, Fe) {
            for (var Xe = 1; Xe < Fe; Xe += 2)
              Te.push(Xe);
            return Te;
          }),
          lt: Hn(function(Te, Fe, Xe) {
            var $e;
            for (Xe < 0 ? $e = Xe + Fe : Xe > Fe ? $e = Fe : $e = Xe; --$e >= 0; )
              Te.push($e);
            return Te;
          }),
          gt: Hn(function(Te, Fe, Xe) {
            for (var $e = Xe < 0 ? Xe + Fe : Xe; ++$e < Fe; )
              Te.push($e);
            return Te;
          })
        }
      }, O.pseudos.nth = O.pseudos.eq;
      for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        O.pseudos[b] = Es(b);
      for (b in { submit: !0, reset: !0 })
        O.pseudos[b] = Jr(b);
      function Yn() {
      }
      Yn.prototype = O.filters = O.pseudos, O.setFilters = new Yn();
      function is(Te, Fe) {
        var Xe, $e, Ce, De, Ne, q, te, be = ai[Te + " "];
        if (be)
          return Fe ? 0 : be.slice(0);
        for (Ne = Te, q = [], te = O.preFilter; Ne; ) {
          (!Xe || ($e = Oi.exec(Ne))) && ($e && (Ne = Ne.slice($e[0].length) || Ne), q.push(Ce = [])), Xe = !1, ($e = Qs.exec(Ne)) && (Xe = $e.shift(), Ce.push({
            value: Xe,
            // Cast descendant combinators to space
            type: $e[0].replace(at, " ")
          }), Ne = Ne.slice(Xe.length));
          for (De in O.filter)
            ($e = En[De].exec(Ne)) && (!te[De] || ($e = te[De]($e))) && (Xe = $e.shift(), Ce.push({
              value: Xe,
              type: De,
              matches: $e
            }), Ne = Ne.slice(Xe.length));
          if (!Xe)
            break;
        }
        return Fe ? Ne.length : Ne ? vi.error(Te) : (
          // Cache the tokens
          ai(Te, q).slice(0)
        );
      }
      function Pn(Te) {
        for (var Fe = 0, Xe = Te.length, $e = ""; Fe < Xe; Fe++)
          $e += Te[Fe].value;
        return $e;
      }
      function us(Te, Fe, Xe) {
        var $e = Fe.dir, Ce = Fe.next, De = Ce || $e, Ne = Xe && De === "parentNode", q = xt++;
        return Fe.first ? (
          // Check against closest ancestor/preceding element
          function(te, be, Ae) {
            for (; te = te[$e]; )
              if (te.nodeType === 1 || Ne)
                return Te(te, be, Ae);
            return !1;
          }
        ) : (
          // Check against all ancestor/preceding elements
          function(te, be, Ae) {
            var qe, ot, it = [Ke, q];
            if (Ae) {
              for (; te = te[$e]; )
                if ((te.nodeType === 1 || Ne) && Te(te, be, Ae))
                  return !0;
            } else
              for (; te = te[$e]; )
                if (te.nodeType === 1 || Ne)
                  if (ot = te[lt] || (te[lt] = {}), Ce && Ze(te, Ce))
                    te = te[$e] || te;
                  else {
                    if ((qe = ot[De]) && qe[0] === Ke && qe[1] === q)
                      return it[2] = qe[2];
                    if (ot[De] = it, it[2] = Te(te, be, Ae))
                      return !0;
                  }
            return !1;
          }
        );
      }
      function Mi(Te) {
        return Te.length > 1 ? function(Fe, Xe, $e) {
          for (var Ce = Te.length; Ce--; )
            if (!Te[Ce](Fe, Xe, $e))
              return !1;
          return !0;
        } : Te[0];
      }
      function er(Te, Fe, Xe) {
        for (var $e = 0, Ce = Fe.length; $e < Ce; $e++)
          vi(Te, Fe[$e], Xe);
        return Xe;
      }
      function ur(Te, Fe, Xe, $e, Ce) {
        for (var De, Ne = [], q = 0, te = Te.length, be = Fe != null; q < te; q++)
          (De = Te[q]) && (!Xe || Xe(De, $e, Ce)) && (Ne.push(De), be && Fe.push(q));
        return Ne;
      }
      function vs(Te, Fe, Xe, $e, Ce, De) {
        return $e && !$e[lt] && ($e = vs($e)), Ce && !Ce[lt] && (Ce = vs(Ce, De)), jt(function(Ne, q, te, be) {
          var Ae, qe, ot, it, wt = [], gi = [], zi = q.length, tn = Ne || er(
            Fe || "*",
            te.nodeType ? [te] : te,
            []
          ), an = Te && (Ne || !Fe) ? ur(tn, wt, Te, te, be) : tn;
          if (Xe ? (it = Ce || (Ne ? Te : zi || $e) ? (
            // ...intermediate processing is necessary
            []
          ) : (
            // ...otherwise use results directly
            q
          ), Xe(an, it, te, be)) : it = an, $e)
            for (Ae = ur(it, gi), $e(Ae, [], te, be), qe = Ae.length; qe--; )
              (ot = Ae[qe]) && (it[gi[qe]] = !(an[gi[qe]] = ot));
          if (Ne) {
            if (Ce || Te) {
              if (Ce) {
                for (Ae = [], qe = it.length; qe--; )
                  (ot = it[qe]) && Ae.push(an[qe] = ot);
                Ce(null, it = [], Ae, be);
              }
              for (qe = it.length; qe--; )
                (ot = it[qe]) && (Ae = Ce ? w.call(Ne, ot) : wt[qe]) > -1 && (Ne[Ae] = !(q[Ae] = ot));
            }
          } else
            it = ur(
              it === q ? it.splice(zi, it.length) : it
            ), Ce ? Ce(null, q, it, be) : ce.apply(q, it);
        });
      }
      function gn(Te) {
        for (var Fe, Xe, $e, Ce = Te.length, De = O.relative[Te[0].type], Ne = De || O.relative[" "], q = De ? 1 : 0, te = us(function(qe) {
          return qe === Fe;
        }, Ne, !0), be = us(function(qe) {
          return w.call(Fe, qe) > -1;
        }, Ne, !0), Ae = [function(qe, ot, it) {
          var wt = !De && (it || ot != G) || ((Fe = ot).nodeType ? te(qe, ot, it) : be(qe, ot, it));
          return Fe = null, wt;
        }]; q < Ce; q++)
          if (Xe = O.relative[Te[q].type])
            Ae = [us(Mi(Ae), Xe)];
          else {
            if (Xe = O.filter[Te[q].type].apply(null, Te[q].matches), Xe[lt]) {
              for ($e = ++q; $e < Ce && !O.relative[Te[$e].type]; $e++)
                ;
              return vs(
                q > 1 && Mi(Ae),
                q > 1 && Pn(
                  // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                  Te.slice(0, q - 1).concat({ value: Te[q - 2].type === " " ? "*" : "" })
                ).replace(at, "$1"),
                Xe,
                q < $e && gn(Te.slice(q, $e)),
                $e < Ce && gn(Te = Te.slice($e)),
                $e < Ce && Pn(Te)
              );
            }
            Ae.push(Xe);
          }
        return Mi(Ae);
      }
      function Us(Te, Fe) {
        var Xe = Fe.length > 0, $e = Te.length > 0, Ce = function(De, Ne, q, te, be) {
          var Ae, qe, ot, it = 0, wt = "0", gi = De && [], zi = [], tn = G, an = De || $e && O.find.TAG("*", be), cs = Ke += tn == null ? 1 : Math.random() || 0.1, fi = an.length;
          for (be && (G = Ne == de || Ne || be); wt !== fi && (Ae = an[wt]) != null; wt++) {
            if ($e && Ae) {
              for (qe = 0, !Ne && Ae.ownerDocument != de && (xn(Ae), q = !Oe); ot = Te[qe++]; )
                if (ot(Ae, Ne || de, q)) {
                  ce.call(te, Ae);
                  break;
                }
              be && (Ke = cs);
            }
            Xe && ((Ae = !ot && Ae) && it--, De && gi.push(Ae));
          }
          if (it += wt, Xe && wt !== it) {
            for (qe = 0; ot = Fe[qe++]; )
              ot(gi, zi, Ne, q);
            if (De) {
              if (it > 0)
                for (; wt--; )
                  gi[wt] || zi[wt] || (zi[wt] = pt.call(te));
              zi = ur(zi);
            }
            ce.apply(te, zi), be && !De && zi.length > 0 && it + Fe.length > 1 && j.uniqueSort(te);
          }
          return be && (Ke = cs, G = tn), gi;
        };
        return Xe ? jt(Ce) : Ce;
      }
      function xr(Te, Fe) {
        var Xe, $e = [], Ce = [], De = si[Te + " "];
        if (!De) {
          for (Fe || (Fe = is(Te)), Xe = Fe.length; Xe--; )
            De = gn(Fe[Xe]), De[lt] ? $e.push(De) : Ce.push(De);
          De = si(
            Te,
            Us(Ce, $e)
          ), De.selector = Te;
        }
        return De;
      }
      function ns(Te, Fe, Xe, $e) {
        var Ce, De, Ne, q, te, be = typeof Te == "function" && Te, Ae = !$e && is(Te = be.selector || Te);
        if (Xe = Xe || [], Ae.length === 1) {
          if (De = Ae[0] = Ae[0].slice(0), De.length > 2 && (Ne = De[0]).type === "ID" && Fe.nodeType === 9 && Oe && O.relative[De[1].type]) {
            if (Fe = (O.find.ID(
              Ne.matches[0].replace(oi, Hi),
              Fe
            ) || [])[0], Fe)
              be && (Fe = Fe.parentNode);
            else
              return Xe;
            Te = Te.slice(De.shift().value.length);
          }
          for (Ce = En.needsContext.test(Te) ? 0 : De.length; Ce-- && (Ne = De[Ce], !O.relative[q = Ne.type]); )
            if ((te = O.find[q]) && ($e = te(
              Ne.matches[0].replace(oi, Hi),
              Ls.test(De[0].type) && ji(Fe.parentNode) || Fe
            ))) {
              if (De.splice(Ce, 1), Te = $e.length && Pn(De), !Te)
                return ce.apply(Xe, $e), Xe;
              break;
            }
        }
        return (be || xr(Te, Ae))(
          $e,
          Fe,
          !Oe,
          Xe,
          !Fe || Ls.test(Te) && ji(Fe.parentNode) || Fe
        ), Xe;
      }
      he.sortStable = lt.split("").sort(Qi).join("") === lt, xn(), he.sortDetached = Xi(function(Te) {
        return Te.compareDocumentPosition(de.createElement("fieldset")) & 1;
      }), j.find = vi, j.expr[":"] = j.expr.pseudos, j.unique = j.uniqueSort, vi.compile = xr, vi.select = ns, vi.setDocument = xn, vi.tokenize = is, vi.escape = j.escapeSelector, vi.getText = j.text, vi.isXML = j.isXMLDoc, vi.selectors = j.expr, vi.support = j.support, vi.uniqueSort = j.uniqueSort;
    })();
    var Bt = function(b, O, G) {
      for (var Z = [], oe = G !== void 0; (b = b[O]) && b.nodeType !== 9; )
        if (b.nodeType === 1) {
          if (oe && j(b).is(G))
            break;
          Z.push(b);
        }
      return Z;
    }, yi = function(b, O) {
      for (var G = []; b; b = b.nextSibling)
        b.nodeType === 1 && b !== O && G.push(b);
      return G;
    }, on = j.expr.match.needsContext, Tn = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function Ki(b, O, G) {
      return ne(O) ? j.grep(b, function(Z, oe) {
        return !!O.call(Z, oe, Z) !== G;
      }) : O.nodeType ? j.grep(b, function(Z) {
        return Z === O !== G;
      }) : typeof O != "string" ? j.grep(b, function(Z) {
        return w.call(O, Z) > -1 !== G;
      }) : j.filter(O, b, G);
    }
    j.filter = function(b, O, G) {
      var Z = O[0];
      return G && (b = ":not(" + b + ")"), O.length === 1 && Z.nodeType === 1 ? j.find.matchesSelector(Z, b) ? [Z] : [] : j.find.matches(b, j.grep(O, function(oe) {
        return oe.nodeType === 1;
      }));
    }, j.fn.extend({
      find: function(b) {
        var O, G, Z = this.length, oe = this;
        if (typeof b != "string")
          return this.pushStack(j(b).filter(function() {
            for (O = 0; O < Z; O++)
              if (j.contains(oe[O], this))
                return !0;
          }));
        for (G = this.pushStack([]), O = 0; O < Z; O++)
          j.find(b, oe[O], G);
        return Z > 1 ? j.uniqueSort(G) : G;
      },
      filter: function(b) {
        return this.pushStack(Ki(this, b || [], !1));
      },
      not: function(b) {
        return this.pushStack(Ki(this, b || [], !0));
      },
      is: function(b) {
        return !!Ki(
          this,
          // If this is a positional/relative selector, check membership in the returned set
          // so $("p:first").is("p:last") won't return true for a doc with two "p".
          typeof b == "string" && on.test(b) ? j(b) : b || [],
          !1
        ).length;
      }
    });
    var as, qt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, kn = j.fn.init = function(b, O, G) {
      var Z, oe;
      if (!b)
        return this;
      if (G = G || as, typeof b == "string")
        if (b[0] === "<" && b[b.length - 1] === ">" && b.length >= 3 ? Z = [null, b, null] : Z = qt.exec(b), Z && (Z[1] || !O))
          if (Z[1]) {
            if (O = O instanceof j ? O[0] : O, j.merge(this, j.parseHTML(
              Z[1],
              O && O.nodeType ? O.ownerDocument || O : se,
              !0
            )), Tn.test(Z[1]) && j.isPlainObject(O))
              for (Z in O)
                ne(this[Z]) ? this[Z](O[Z]) : this.attr(Z, O[Z]);
            return this;
          } else
            return oe = se.getElementById(Z[2]), oe && (this[0] = oe, this.length = 1), this;
        else
          return !O || O.jquery ? (O || G).find(b) : this.constructor(O).find(b);
      else {
        if (b.nodeType)
          return this[0] = b, this.length = 1, this;
        if (ne(b))
          return G.ready !== void 0 ? G.ready(b) : (
            // Execute immediately if ready is not present
            b(j)
          );
      }
      return j.makeArray(b, this);
    };
    kn.prototype = j.fn, as = j(se);
    var Ms = /^(?:parents|prev(?:Until|All))/, Wn = {
      children: !0,
      contents: !0,
      next: !0,
      prev: !0
    };
    j.fn.extend({
      has: function(b) {
        var O = j(b, this), G = O.length;
        return this.filter(function() {
          for (var Z = 0; Z < G; Z++)
            if (j.contains(this, O[Z]))
              return !0;
        });
      },
      closest: function(b, O) {
        var G, Z = 0, oe = this.length, ce = [], de = typeof b != "string" && j(b);
        if (!on.test(b)) {
          for (; Z < oe; Z++)
            for (G = this[Z]; G && G !== O; G = G.parentNode)
              if (G.nodeType < 11 && (de ? de.index(G) > -1 : (
                // Don't pass non-elements to jQuery#find
                G.nodeType === 1 && j.find.matchesSelector(G, b)
              ))) {
                ce.push(G);
                break;
              }
        }
        return this.pushStack(ce.length > 1 ? j.uniqueSort(ce) : ce);
      },
      // Determine the position of an element within the set
      index: function(b) {
        return b ? typeof b == "string" ? w.call(j(b), this[0]) : w.call(
          this,
          // If it receives a jQuery object, the first element is used
          b.jquery ? b[0] : b
        ) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      },
      add: function(b, O) {
        return this.pushStack(
          j.uniqueSort(
            j.merge(this.get(), j(b, O))
          )
        );
      },
      addBack: function(b) {
        return this.add(
          b == null ? this.prevObject : this.prevObject.filter(b)
        );
      }
    });
    function zt(b, O) {
      for (; (b = b[O]) && b.nodeType !== 1; )
        ;
      return b;
    }
    j.each({
      parent: function(b) {
        var O = b.parentNode;
        return O && O.nodeType !== 11 ? O : null;
      },
      parents: function(b) {
        return Bt(b, "parentNode");
      },
      parentsUntil: function(b, O, G) {
        return Bt(b, "parentNode", G);
      },
      next: function(b) {
        return zt(b, "nextSibling");
      },
      prev: function(b) {
        return zt(b, "previousSibling");
      },
      nextAll: function(b) {
        return Bt(b, "nextSibling");
      },
      prevAll: function(b) {
        return Bt(b, "previousSibling");
      },
      nextUntil: function(b, O, G) {
        return Bt(b, "nextSibling", G);
      },
      prevUntil: function(b, O, G) {
        return Bt(b, "previousSibling", G);
      },
      siblings: function(b) {
        return yi((b.parentNode || {}).firstChild, b);
      },
      children: function(b) {
        return yi(b.firstChild);
      },
      contents: function(b) {
        return b.contentDocument != null && // Support: IE 11+
        // <object> elements with no `data` attribute has an object
        // `contentDocument` with a `null` prototype.
        o(b.contentDocument) ? b.contentDocument : (Ze(b, "template") && (b = b.content || b), j.merge([], b.childNodes));
      }
    }, function(b, O) {
      j.fn[b] = function(G, Z) {
        var oe = j.map(this, O, G);
        return b.slice(-5) !== "Until" && (Z = G), Z && typeof Z == "string" && (oe = j.filter(Z, oe)), this.length > 1 && (Wn[b] || j.uniqueSort(oe), Ms.test(b) && oe.reverse()), this.pushStack(oe);
      };
    });
    var Dt = /[^\x20\t\r\n\f]+/g;
    function Ht(b) {
      var O = {};
      return j.each(b.match(Dt) || [], function(G, Z) {
        O[Z] = !0;
      }), O;
    }
    j.Callbacks = function(b) {
      b = typeof b == "string" ? Ht(b) : j.extend({}, b);
      var O, G, Z, oe, ce = [], de = [], Pe = -1, Oe = function() {
        for (oe = oe || b.once, Z = O = !0; de.length; Pe = -1)
          for (G = de.shift(); ++Pe < ce.length; )
            ce[Pe].apply(G[0], G[1]) === !1 && b.stopOnFalse && (Pe = ce.length, G = !1);
        b.memory || (G = !1), O = !1, oe && (G ? ce = [] : ce = "");
      }, Ue = {
        // Add a callback or a collection of callbacks to the list
        add: function() {
          return ce && (G && !O && (Pe = ce.length - 1, de.push(G)), function rt(lt) {
            j.each(lt, function(Ke, xt) {
              ne(xt) ? (!b.unique || !Ue.has(xt)) && ce.push(xt) : xt && xt.length && xe(xt) !== "string" && rt(xt);
            });
          }(arguments), G && !O && Oe()), this;
        },
        // Remove a callback from the list
        remove: function() {
          return j.each(arguments, function(rt, lt) {
            for (var Ke; (Ke = j.inArray(lt, ce, Ke)) > -1; )
              ce.splice(Ke, 1), Ke <= Pe && Pe--;
          }), this;
        },
        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function(rt) {
          return rt ? j.inArray(rt, ce) > -1 : ce.length > 0;
        },
        // Remove all callbacks from the list
        empty: function() {
          return ce && (ce = []), this;
        },
        // Disable .fire and .add
        // Abort any current/pending executions
        // Clear all callbacks and values
        disable: function() {
          return oe = de = [], ce = G = "", this;
        },
        disabled: function() {
          return !ce;
        },
        // Disable .fire
        // Also disable .add unless we have memory (since it would have no effect)
        // Abort any pending executions
        lock: function() {
          return oe = de = [], !G && !O && (ce = G = ""), this;
        },
        locked: function() {
          return !!oe;
        },
        // Call all callbacks with the given context and arguments
        fireWith: function(rt, lt) {
          return oe || (lt = lt || [], lt = [rt, lt.slice ? lt.slice() : lt], de.push(lt), O || Oe()), this;
        },
        // Call all the callbacks with the given arguments
        fire: function() {
          return Ue.fireWith(this, arguments), this;
        },
        // To know if the callbacks have already been called at least once
        fired: function() {
          return !!Z;
        }
      };
      return Ue;
    };
    function Dn(b) {
      return b;
    }
    function Ln(b) {
      throw b;
    }
    function Sn(b, O, G, Z) {
      var oe;
      try {
        b && ne(oe = b.promise) ? oe.call(b).done(O).fail(G) : b && ne(oe = b.then) ? oe.call(b, O, G) : O.apply(void 0, [b].slice(Z));
      } catch (ce) {
        G.apply(void 0, [ce]);
      }
    }
    j.extend({
      Deferred: function(b) {
        var O = [
          // action, add listener, callbacks,
          // ... .then handlers, argument index, [final state]
          [
            "notify",
            "progress",
            j.Callbacks("memory"),
            j.Callbacks("memory"),
            2
          ],
          [
            "resolve",
            "done",
            j.Callbacks("once memory"),
            j.Callbacks("once memory"),
            0,
            "resolved"
          ],
          [
            "reject",
            "fail",
            j.Callbacks("once memory"),
            j.Callbacks("once memory"),
            1,
            "rejected"
          ]
        ], G = "pending", Z = {
          state: function() {
            return G;
          },
          always: function() {
            return oe.done(arguments).fail(arguments), this;
          },
          catch: function(ce) {
            return Z.then(null, ce);
          },
          // Keep pipe for back-compat
          pipe: function() {
            var ce = arguments;
            return j.Deferred(function(de) {
              j.each(O, function(Pe, Oe) {
                var Ue = ne(ce[Oe[4]]) && ce[Oe[4]];
                oe[Oe[1]](function() {
                  var rt = Ue && Ue.apply(this, arguments);
                  rt && ne(rt.promise) ? rt.promise().progress(de.notify).done(de.resolve).fail(de.reject) : de[Oe[0] + "With"](
                    this,
                    Ue ? [rt] : arguments
                  );
                });
              }), ce = null;
            }).promise();
          },
          then: function(ce, de, Pe) {
            var Oe = 0;
            function Ue(rt, lt, Ke, xt) {
              return function() {
                var It = this, ai = arguments, si = function() {
                  var Qi, Zi;
                  if (!(rt < Oe)) {
                    if (Qi = Ke.apply(It, ai), Qi === lt.promise())
                      throw new TypeError("Thenable self-resolution");
                    Zi = Qi && // Support: Promises/A+ section 2.3.4
                    // https://promisesaplus.com/#point-64
                    // Only check objects and functions for thenability
                    (typeof Qi == "object" || typeof Qi == "function") && Qi.then, ne(Zi) ? xt ? Zi.call(
                      Qi,
                      Ue(Oe, lt, Dn, xt),
                      Ue(Oe, lt, Ln, xt)
                    ) : (Oe++, Zi.call(
                      Qi,
                      Ue(Oe, lt, Dn, xt),
                      Ue(Oe, lt, Ln, xt),
                      Ue(
                        Oe,
                        lt,
                        Dn,
                        lt.notifyWith
                      )
                    )) : (Ke !== Dn && (It = void 0, ai = [Qi]), (xt || lt.resolveWith)(It, ai));
                  }
                }, fn = xt ? si : function() {
                  try {
                    si();
                  } catch (Qi) {
                    j.Deferred.exceptionHook && j.Deferred.exceptionHook(
                      Qi,
                      fn.error
                    ), rt + 1 >= Oe && (Ke !== Ln && (It = void 0, ai = [Qi]), lt.rejectWith(It, ai));
                  }
                };
                rt ? fn() : (j.Deferred.getErrorHook ? fn.error = j.Deferred.getErrorHook() : j.Deferred.getStackHook && (fn.error = j.Deferred.getStackHook()), e.setTimeout(fn));
              };
            }
            return j.Deferred(function(rt) {
              O[0][3].add(
                Ue(
                  0,
                  rt,
                  ne(Pe) ? Pe : Dn,
                  rt.notifyWith
                )
              ), O[1][3].add(
                Ue(
                  0,
                  rt,
                  ne(ce) ? ce : Dn
                )
              ), O[2][3].add(
                Ue(
                  0,
                  rt,
                  ne(de) ? de : Ln
                )
              );
            }).promise();
          },
          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function(ce) {
            return ce != null ? j.extend(ce, Z) : Z;
          }
        }, oe = {};
        return j.each(O, function(ce, de) {
          var Pe = de[2], Oe = de[5];
          Z[de[1]] = Pe.add, Oe && Pe.add(
            function() {
              G = Oe;
            },
            // rejected_callbacks.disable
            // fulfilled_callbacks.disable
            O[3 - ce][2].disable,
            // rejected_handlers.disable
            // fulfilled_handlers.disable
            O[3 - ce][3].disable,
            // progress_callbacks.lock
            O[0][2].lock,
            // progress_handlers.lock
            O[0][3].lock
          ), Pe.add(de[3].fire), oe[de[0]] = function() {
            return oe[de[0] + "With"](this === oe ? void 0 : this, arguments), this;
          }, oe[de[0] + "With"] = Pe.fireWith;
        }), Z.promise(oe), b && b.call(oe, oe), oe;
      },
      // Deferred helper
      when: function(b) {
        var O = arguments.length, G = O, Z = Array(G), oe = a.call(arguments), ce = j.Deferred(), de = function(Pe) {
          return function(Oe) {
            Z[Pe] = this, oe[Pe] = arguments.length > 1 ? a.call(arguments) : Oe, --O || ce.resolveWith(Z, oe);
          };
        };
        if (O <= 1 && (Sn(
          b,
          ce.done(de(G)).resolve,
          ce.reject,
          !O
        ), ce.state() === "pending" || ne(oe[G] && oe[G].then)))
          return ce.then();
        for (; G--; )
          Sn(oe[G], de(G), ce.reject);
        return ce.promise();
      }
    });
    var qn = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    j.Deferred.exceptionHook = function(b, O) {
      e.console && e.console.warn && b && qn.test(b.name) && e.console.warn(
        "jQuery.Deferred exception: " + b.message,
        b.stack,
        O
      );
    }, j.readyException = function(b) {
      e.setTimeout(function() {
        throw b;
      });
    };
    var Ds = j.Deferred();
    j.fn.ready = function(b) {
      return Ds.then(b).catch(function(O) {
        j.readyException(O);
      }), this;
    }, j.extend({
      // Is the DOM ready to be used? Set to true once it occurs.
      isReady: !1,
      // A counter to track how many items to wait for before
      // the ready event fires. See trac-6781
      readyWait: 1,
      // Handle when the DOM is ready
      ready: function(b) {
        (b === !0 ? --j.readyWait : j.isReady) || (j.isReady = !0, !(b !== !0 && --j.readyWait > 0) && Ds.resolveWith(se, [j]));
      }
    }), j.ready.then = Ds.then;
    function ln() {
      se.removeEventListener("DOMContentLoaded", ln), e.removeEventListener("load", ln), j.ready();
    }
    se.readyState === "complete" || se.readyState !== "loading" && !se.documentElement.doScroll ? e.setTimeout(j.ready) : (se.addEventListener("DOMContentLoaded", ln), e.addEventListener("load", ln));
    var Bn = function(b, O, G, Z, oe, ce, de) {
      var Pe = 0, Oe = b.length, Ue = G == null;
      if (xe(G) === "object") {
        oe = !0;
        for (Pe in G)
          Bn(b, O, Pe, G[Pe], !0, ce, de);
      } else if (Z !== void 0 && (oe = !0, ne(Z) || (de = !0), Ue && (de ? (O.call(b, Z), O = null) : (Ue = O, O = function(rt, lt, Ke) {
        return Ue.call(j(rt), Ke);
      })), O))
        for (; Pe < Oe; Pe++)
          O(
            b[Pe],
            G,
            de ? Z : Z.call(b[Pe], Pe, O(b[Pe], G))
          );
      return oe ? b : Ue ? O.call(b) : Oe ? O(b[0], G) : ce;
    }, Js = /^-ms-/, zn = /-([a-z])/g;
    function Ut(b, O) {
      return O.toUpperCase();
    }
    function ki(b) {
      return b.replace(Js, "ms-").replace(zn, Ut);
    }
    var Vt = function(b) {
      return b.nodeType === 1 || b.nodeType === 9 || !+b.nodeType;
    };
    function Jn() {
      this.expando = j.expando + Jn.uid++;
    }
    Jn.uid = 1, Jn.prototype = {
      cache: function(b) {
        var O = b[this.expando];
        return O || (O = {}, Vt(b) && (b.nodeType ? b[this.expando] = O : Object.defineProperty(b, this.expando, {
          value: O,
          configurable: !0
        }))), O;
      },
      set: function(b, O, G) {
        var Z, oe = this.cache(b);
        if (typeof O == "string")
          oe[ki(O)] = G;
        else
          for (Z in O)
            oe[ki(Z)] = O[Z];
        return oe;
      },
      get: function(b, O) {
        return O === void 0 ? this.cache(b) : (
          // Always use camelCase key (gh-2257)
          b[this.expando] && b[this.expando][ki(O)]
        );
      },
      access: function(b, O, G) {
        return O === void 0 || O && typeof O == "string" && G === void 0 ? this.get(b, O) : (this.set(b, O, G), G !== void 0 ? G : O);
      },
      remove: function(b, O) {
        var G, Z = b[this.expando];
        if (Z !== void 0) {
          if (O !== void 0)
            for (Array.isArray(O) ? O = O.map(ki) : (O = ki(O), O = O in Z ? [O] : O.match(Dt) || []), G = O.length; G--; )
              delete Z[O[G]];
          (O === void 0 || j.isEmptyObject(Z)) && (b.nodeType ? b[this.expando] = void 0 : delete b[this.expando]);
        }
      },
      hasData: function(b) {
        var O = b[this.expando];
        return O !== void 0 && !j.isEmptyObject(O);
      }
    };
    var nt = new Jn(), i = new Jn(), n = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, r = /[A-Z]/g;
    function l(b) {
      return b === "true" ? !0 : b === "false" ? !1 : b === "null" ? null : b === +b + "" ? +b : n.test(b) ? JSON.parse(b) : b;
    }
    function h(b, O, G) {
      var Z;
      if (G === void 0 && b.nodeType === 1)
        if (Z = "data-" + O.replace(r, "-$&").toLowerCase(), G = b.getAttribute(Z), typeof G == "string") {
          try {
            G = l(G);
          } catch {
          }
          i.set(b, O, G);
        } else
          G = void 0;
      return G;
    }
    j.extend({
      hasData: function(b) {
        return i.hasData(b) || nt.hasData(b);
      },
      data: function(b, O, G) {
        return i.access(b, O, G);
      },
      removeData: function(b, O) {
        i.remove(b, O);
      },
      // TODO: Now that all calls to _data and _removeData have been replaced
      // with direct calls to dataPriv methods, these can be deprecated.
      _data: function(b, O, G) {
        return nt.access(b, O, G);
      },
      _removeData: function(b, O) {
        nt.remove(b, O);
      }
    }), j.fn.extend({
      data: function(b, O) {
        var G, Z, oe, ce = this[0], de = ce && ce.attributes;
        if (b === void 0) {
          if (this.length && (oe = i.get(ce), ce.nodeType === 1 && !nt.get(ce, "hasDataAttrs"))) {
            for (G = de.length; G--; )
              de[G] && (Z = de[G].name, Z.indexOf("data-") === 0 && (Z = ki(Z.slice(5)), h(ce, Z, oe[Z])));
            nt.set(ce, "hasDataAttrs", !0);
          }
          return oe;
        }
        return typeof b == "object" ? this.each(function() {
          i.set(this, b);
        }) : Bn(this, function(Pe) {
          var Oe;
          if (ce && Pe === void 0)
            return Oe = i.get(ce, b), Oe !== void 0 || (Oe = h(ce, b), Oe !== void 0) ? Oe : void 0;
          this.each(function() {
            i.set(this, b, Pe);
          });
        }, null, O, arguments.length > 1, null, !0);
      },
      removeData: function(b) {
        return this.each(function() {
          i.remove(this, b);
        });
      }
    }), j.extend({
      queue: function(b, O, G) {
        var Z;
        if (b)
          return O = (O || "fx") + "queue", Z = nt.get(b, O), G && (!Z || Array.isArray(G) ? Z = nt.access(b, O, j.makeArray(G)) : Z.push(G)), Z || [];
      },
      dequeue: function(b, O) {
        O = O || "fx";
        var G = j.queue(b, O), Z = G.length, oe = G.shift(), ce = j._queueHooks(b, O), de = function() {
          j.dequeue(b, O);
        };
        oe === "inprogress" && (oe = G.shift(), Z--), oe && (O === "fx" && G.unshift("inprogress"), delete ce.stop, oe.call(b, de, ce)), !Z && ce && ce.empty.fire();
      },
      // Not public - generate a queueHooks object, or return the current one
      _queueHooks: function(b, O) {
        var G = O + "queueHooks";
        return nt.get(b, G) || nt.access(b, G, {
          empty: j.Callbacks("once memory").add(function() {
            nt.remove(b, [O + "queue", G]);
          })
        });
      }
    }), j.fn.extend({
      queue: function(b, O) {
        var G = 2;
        return typeof b != "string" && (O = b, b = "fx", G--), arguments.length < G ? j.queue(this[0], b) : O === void 0 ? this : this.each(function() {
          var Z = j.queue(this, b, O);
          j._queueHooks(this, b), b === "fx" && Z[0] !== "inprogress" && j.dequeue(this, b);
        });
      },
      dequeue: function(b) {
        return this.each(function() {
          j.dequeue(this, b);
        });
      },
      clearQueue: function(b) {
        return this.queue(b || "fx", []);
      },
      // Get a promise resolved when queues of a certain type
      // are emptied (fx is the type by default)
      promise: function(b, O) {
        var G, Z = 1, oe = j.Deferred(), ce = this, de = this.length, Pe = function() {
          --Z || oe.resolveWith(ce, [ce]);
        };
        for (typeof b != "string" && (O = b, b = void 0), b = b || "fx"; de--; )
          G = nt.get(ce[de], b + "queueHooks"), G && G.empty && (Z++, G.empty.add(Pe));
        return Pe(), oe.promise(O);
      }
    });
    var f = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, m = new RegExp("^(?:([+-])=|)(" + f + ")([a-z%]*)$", "i"), _ = ["Top", "Right", "Bottom", "Left"], y = se.documentElement, x = function(b) {
      return j.contains(b.ownerDocument, b);
    }, A = { composed: !0 };
    y.getRootNode && (x = function(b) {
      return j.contains(b.ownerDocument, b) || b.getRootNode(A) === b.ownerDocument;
    });
    var B = function(b, O) {
      return b = O || b, b.style.display === "none" || b.style.display === "" && // Otherwise, check computed style
      // Support: Firefox <=43 - 45
      // Disconnected elements can have computed display: none, so first confirm that elem is
      // in the document.
      x(b) && j.css(b, "display") === "none";
    };
    function C(b, O, G, Z) {
      var oe, ce, de = 20, Pe = Z ? function() {
        return Z.cur();
      } : function() {
        return j.css(b, O, "");
      }, Oe = Pe(), Ue = G && G[3] || (j.cssNumber[O] ? "" : "px"), rt = b.nodeType && (j.cssNumber[O] || Ue !== "px" && +Oe) && m.exec(j.css(b, O));
      if (rt && rt[3] !== Ue) {
        for (Oe = Oe / 2, Ue = Ue || rt[3], rt = +Oe || 1; de--; )
          j.style(b, O, rt + Ue), (1 - ce) * (1 - (ce = Pe() / Oe || 0.5)) <= 0 && (de = 0), rt = rt / ce;
        rt = rt * 2, j.style(b, O, rt + Ue), G = G || [];
      }
      return G && (rt = +rt || +Oe || 0, oe = G[1] ? rt + (G[1] + 1) * G[2] : +G[2], Z && (Z.unit = Ue, Z.start = rt, Z.end = oe)), oe;
    }
    var M = {};
    function R(b) {
      var O, G = b.ownerDocument, Z = b.nodeName, oe = M[Z];
      return oe || (O = G.body.appendChild(G.createElement(Z)), oe = j.css(O, "display"), O.parentNode.removeChild(O), oe === "none" && (oe = "block"), M[Z] = oe, oe);
    }
    function E(b, O) {
      for (var G, Z, oe = [], ce = 0, de = b.length; ce < de; ce++)
        Z = b[ce], Z.style && (G = Z.style.display, O ? (G === "none" && (oe[ce] = nt.get(Z, "display") || null, oe[ce] || (Z.style.display = "")), Z.style.display === "" && B(Z) && (oe[ce] = R(Z))) : G !== "none" && (oe[ce] = "none", nt.set(Z, "display", G)));
      for (ce = 0; ce < de; ce++)
        oe[ce] != null && (b[ce].style.display = oe[ce]);
      return b;
    }
    j.fn.extend({
      show: function() {
        return E(this, !0);
      },
      hide: function() {
        return E(this);
      },
      toggle: function(b) {
        return typeof b == "boolean" ? b ? this.show() : this.hide() : this.each(function() {
          B(this) ? j(this).show() : j(this).hide();
        });
      }
    });
    var D = /^(?:checkbox|radio)$/i, L = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, P = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
      var b = se.createDocumentFragment(), O = b.appendChild(se.createElement("div")), G = se.createElement("input");
      G.setAttribute("type", "radio"), G.setAttribute("checked", "checked"), G.setAttribute("name", "t"), O.appendChild(G), he.checkClone = O.cloneNode(!0).cloneNode(!0).lastChild.checked, O.innerHTML = "<textarea>x</textarea>", he.noCloneChecked = !!O.cloneNode(!0).lastChild.defaultValue, O.innerHTML = "<option></option>", he.option = !!O.lastChild;
    })();
    var S = {
      // XHTML parsers do not magically insert elements in the
      // same way that tag soup parsers do. So we cannot shorten
      // this by omitting <tbody> or other required elements.
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };
    S.tbody = S.tfoot = S.colgroup = S.caption = S.thead, S.th = S.td, he.option || (S.optgroup = S.option = [1, "<select multiple='multiple'>", "</select>"]);
    function I(b, O) {
      var G;
      return typeof b.getElementsByTagName < "u" ? G = b.getElementsByTagName(O || "*") : typeof b.querySelectorAll < "u" ? G = b.querySelectorAll(O || "*") : G = [], O === void 0 || O && Ze(b, O) ? j.merge([b], G) : G;
    }
    function U(b, O) {
      for (var G = 0, Z = b.length; G < Z; G++)
        nt.set(
          b[G],
          "globalEval",
          !O || nt.get(O[G], "globalEval")
        );
    }
    var V = /<|&#?\w+;/;
    function F(b, O, G, Z, oe) {
      for (var ce, de, Pe, Oe, Ue, rt, lt = O.createDocumentFragment(), Ke = [], xt = 0, It = b.length; xt < It; xt++)
        if (ce = b[xt], ce || ce === 0)
          if (xe(ce) === "object")
            j.merge(Ke, ce.nodeType ? [ce] : ce);
          else if (!V.test(ce))
            Ke.push(O.createTextNode(ce));
          else {
            for (de = de || lt.appendChild(O.createElement("div")), Pe = (L.exec(ce) || ["", ""])[1].toLowerCase(), Oe = S[Pe] || S._default, de.innerHTML = Oe[1] + j.htmlPrefilter(ce) + Oe[2], rt = Oe[0]; rt--; )
              de = de.lastChild;
            j.merge(Ke, de.childNodes), de = lt.firstChild, de.textContent = "";
          }
      for (lt.textContent = "", xt = 0; ce = Ke[xt++]; ) {
        if (Z && j.inArray(ce, Z) > -1) {
          oe && oe.push(ce);
          continue;
        }
        if (Ue = x(ce), de = I(lt.appendChild(ce), "script"), Ue && U(de), G)
          for (rt = 0; ce = de[rt++]; )
            P.test(ce.type || "") && G.push(ce);
      }
      return lt;
    }
    var W = /^([^.]*)(?:\.(.+)|)/;
    function Q() {
      return !0;
    }
    function ie() {
      return !1;
    }
    function ae(b, O, G, Z, oe, ce) {
      var de, Pe;
      if (typeof O == "object") {
        typeof G != "string" && (Z = Z || G, G = void 0);
        for (Pe in O)
          ae(b, Pe, G, Z, O[Pe], ce);
        return b;
      }
      if (Z == null && oe == null ? (oe = G, Z = G = void 0) : oe == null && (typeof G == "string" ? (oe = Z, Z = void 0) : (oe = Z, Z = G, G = void 0)), oe === !1)
        oe = ie;
      else if (!oe)
        return b;
      return ce === 1 && (de = oe, oe = function(Oe) {
        return j().off(Oe), de.apply(this, arguments);
      }, oe.guid = de.guid || (de.guid = j.guid++)), b.each(function() {
        j.event.add(this, O, oe, Z, G);
      });
    }
    j.event = {
      global: {},
      add: function(b, O, G, Z, oe) {
        var ce, de, Pe, Oe, Ue, rt, lt, Ke, xt, It, ai, si = nt.get(b);
        if (Vt(b))
          for (G.handler && (ce = G, G = ce.handler, oe = ce.selector), oe && j.find.matchesSelector(y, oe), G.guid || (G.guid = j.guid++), (Oe = si.events) || (Oe = si.events = /* @__PURE__ */ Object.create(null)), (de = si.handle) || (de = si.handle = function(fn) {
            return typeof j < "u" && j.event.triggered !== fn.type ? j.event.dispatch.apply(b, arguments) : void 0;
          }), O = (O || "").match(Dt) || [""], Ue = O.length; Ue--; )
            Pe = W.exec(O[Ue]) || [], xt = ai = Pe[1], It = (Pe[2] || "").split(".").sort(), xt && (lt = j.event.special[xt] || {}, xt = (oe ? lt.delegateType : lt.bindType) || xt, lt = j.event.special[xt] || {}, rt = j.extend({
              type: xt,
              origType: ai,
              data: Z,
              handler: G,
              guid: G.guid,
              selector: oe,
              needsContext: oe && j.expr.match.needsContext.test(oe),
              namespace: It.join(".")
            }, ce), (Ke = Oe[xt]) || (Ke = Oe[xt] = [], Ke.delegateCount = 0, (!lt.setup || lt.setup.call(b, Z, It, de) === !1) && b.addEventListener && b.addEventListener(xt, de)), lt.add && (lt.add.call(b, rt), rt.handler.guid || (rt.handler.guid = G.guid)), oe ? Ke.splice(Ke.delegateCount++, 0, rt) : Ke.push(rt), j.event.global[xt] = !0);
      },
      // Detach an event or set of events from an element
      remove: function(b, O, G, Z, oe) {
        var ce, de, Pe, Oe, Ue, rt, lt, Ke, xt, It, ai, si = nt.hasData(b) && nt.get(b);
        if (!(!si || !(Oe = si.events))) {
          for (O = (O || "").match(Dt) || [""], Ue = O.length; Ue--; ) {
            if (Pe = W.exec(O[Ue]) || [], xt = ai = Pe[1], It = (Pe[2] || "").split(".").sort(), !xt) {
              for (xt in Oe)
                j.event.remove(b, xt + O[Ue], G, Z, !0);
              continue;
            }
            for (lt = j.event.special[xt] || {}, xt = (Z ? lt.delegateType : lt.bindType) || xt, Ke = Oe[xt] || [], Pe = Pe[2] && new RegExp("(^|\\.)" + It.join("\\.(?:.*\\.|)") + "(\\.|$)"), de = ce = Ke.length; ce--; )
              rt = Ke[ce], (oe || ai === rt.origType) && (!G || G.guid === rt.guid) && (!Pe || Pe.test(rt.namespace)) && (!Z || Z === rt.selector || Z === "**" && rt.selector) && (Ke.splice(ce, 1), rt.selector && Ke.delegateCount--, lt.remove && lt.remove.call(b, rt));
            de && !Ke.length && ((!lt.teardown || lt.teardown.call(b, It, si.handle) === !1) && j.removeEvent(b, xt, si.handle), delete Oe[xt]);
          }
          j.isEmptyObject(Oe) && nt.remove(b, "handle events");
        }
      },
      dispatch: function(b) {
        var O, G, Z, oe, ce, de, Pe = new Array(arguments.length), Oe = j.event.fix(b), Ue = (nt.get(this, "events") || /* @__PURE__ */ Object.create(null))[Oe.type] || [], rt = j.event.special[Oe.type] || {};
        for (Pe[0] = Oe, O = 1; O < arguments.length; O++)
          Pe[O] = arguments[O];
        if (Oe.delegateTarget = this, !(rt.preDispatch && rt.preDispatch.call(this, Oe) === !1)) {
          for (de = j.event.handlers.call(this, Oe, Ue), O = 0; (oe = de[O++]) && !Oe.isPropagationStopped(); )
            for (Oe.currentTarget = oe.elem, G = 0; (ce = oe.handlers[G++]) && !Oe.isImmediatePropagationStopped(); )
              (!Oe.rnamespace || ce.namespace === !1 || Oe.rnamespace.test(ce.namespace)) && (Oe.handleObj = ce, Oe.data = ce.data, Z = ((j.event.special[ce.origType] || {}).handle || ce.handler).apply(oe.elem, Pe), Z !== void 0 && (Oe.result = Z) === !1 && (Oe.preventDefault(), Oe.stopPropagation()));
          return rt.postDispatch && rt.postDispatch.call(this, Oe), Oe.result;
        }
      },
      handlers: function(b, O) {
        var G, Z, oe, ce, de, Pe = [], Oe = O.delegateCount, Ue = b.target;
        if (Oe && // Support: IE <=9
        // Black-hole SVG <use> instance trees (trac-13180)
        Ue.nodeType && // Support: Firefox <=42
        // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
        // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
        // Support: IE 11 only
        // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
        !(b.type === "click" && b.button >= 1)) {
          for (; Ue !== this; Ue = Ue.parentNode || this)
            if (Ue.nodeType === 1 && !(b.type === "click" && Ue.disabled === !0)) {
              for (ce = [], de = {}, G = 0; G < Oe; G++)
                Z = O[G], oe = Z.selector + " ", de[oe] === void 0 && (de[oe] = Z.needsContext ? j(oe, this).index(Ue) > -1 : j.find(oe, this, null, [Ue]).length), de[oe] && ce.push(Z);
              ce.length && Pe.push({ elem: Ue, handlers: ce });
            }
        }
        return Ue = this, Oe < O.length && Pe.push({ elem: Ue, handlers: O.slice(Oe) }), Pe;
      },
      addProp: function(b, O) {
        Object.defineProperty(j.Event.prototype, b, {
          enumerable: !0,
          configurable: !0,
          get: ne(O) ? function() {
            if (this.originalEvent)
              return O(this.originalEvent);
          } : function() {
            if (this.originalEvent)
              return this.originalEvent[b];
          },
          set: function(G) {
            Object.defineProperty(this, b, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: G
            });
          }
        });
      },
      fix: function(b) {
        return b[j.expando] ? b : new j.Event(b);
      },
      special: {
        load: {
          // Prevent triggered image.load events from bubbling to window.load
          noBubble: !0
        },
        click: {
          // Utilize native event to ensure correct state for checkable inputs
          setup: function(b) {
            var O = this || b;
            return D.test(O.type) && O.click && Ze(O, "input") && J(O, "click", !0), !1;
          },
          trigger: function(b) {
            var O = this || b;
            return D.test(O.type) && O.click && Ze(O, "input") && J(O, "click"), !0;
          },
          // For cross-browser consistency, suppress native .click() on links
          // Also prevent it if we're currently inside a leveraged native-event stack
          _default: function(b) {
            var O = b.target;
            return D.test(O.type) && O.click && Ze(O, "input") && nt.get(O, "click") || Ze(O, "a");
          }
        },
        beforeunload: {
          postDispatch: function(b) {
            b.result !== void 0 && b.originalEvent && (b.originalEvent.returnValue = b.result);
          }
        }
      }
    };
    function J(b, O, G) {
      if (!G) {
        nt.get(b, O) === void 0 && j.event.add(b, O, Q);
        return;
      }
      nt.set(b, O, !1), j.event.add(b, O, {
        namespace: !1,
        handler: function(Z) {
          var oe, ce = nt.get(this, O);
          if (Z.isTrigger & 1 && this[O]) {
            if (ce)
              (j.event.special[O] || {}).delegateType && Z.stopPropagation();
            else if (ce = a.call(arguments), nt.set(this, O, ce), this[O](), oe = nt.get(this, O), nt.set(this, O, !1), ce !== oe)
              return Z.stopImmediatePropagation(), Z.preventDefault(), oe;
          } else
            ce && (nt.set(this, O, j.event.trigger(
              ce[0],
              ce.slice(1),
              this
            )), Z.stopPropagation(), Z.isImmediatePropagationStopped = Q);
        }
      });
    }
    j.removeEvent = function(b, O, G) {
      b.removeEventListener && b.removeEventListener(O, G);
    }, j.Event = function(b, O) {
      if (!(this instanceof j.Event))
        return new j.Event(b, O);
      b && b.type ? (this.originalEvent = b, this.type = b.type, this.isDefaultPrevented = b.defaultPrevented || b.defaultPrevented === void 0 && // Support: Android <=2.3 only
      b.returnValue === !1 ? Q : ie, this.target = b.target && b.target.nodeType === 3 ? b.target.parentNode : b.target, this.currentTarget = b.currentTarget, this.relatedTarget = b.relatedTarget) : this.type = b, O && j.extend(this, O), this.timeStamp = b && b.timeStamp || Date.now(), this[j.expando] = !0;
    }, j.Event.prototype = {
      constructor: j.Event,
      isDefaultPrevented: ie,
      isPropagationStopped: ie,
      isImmediatePropagationStopped: ie,
      isSimulated: !1,
      preventDefault: function() {
        var b = this.originalEvent;
        this.isDefaultPrevented = Q, b && !this.isSimulated && b.preventDefault();
      },
      stopPropagation: function() {
        var b = this.originalEvent;
        this.isPropagationStopped = Q, b && !this.isSimulated && b.stopPropagation();
      },
      stopImmediatePropagation: function() {
        var b = this.originalEvent;
        this.isImmediatePropagationStopped = Q, b && !this.isSimulated && b.stopImmediatePropagation(), this.stopPropagation();
      }
    }, j.each({
      altKey: !0,
      bubbles: !0,
      cancelable: !0,
      changedTouches: !0,
      ctrlKey: !0,
      detail: !0,
      eventPhase: !0,
      metaKey: !0,
      pageX: !0,
      pageY: !0,
      shiftKey: !0,
      view: !0,
      char: !0,
      code: !0,
      charCode: !0,
      key: !0,
      keyCode: !0,
      button: !0,
      buttons: !0,
      clientX: !0,
      clientY: !0,
      offsetX: !0,
      offsetY: !0,
      pointerId: !0,
      pointerType: !0,
      screenX: !0,
      screenY: !0,
      targetTouches: !0,
      toElement: !0,
      touches: !0,
      which: !0
    }, j.event.addProp), j.each({ focus: "focusin", blur: "focusout" }, function(b, O) {
      function G(Z) {
        if (se.documentMode) {
          var oe = nt.get(this, "handle"), ce = j.event.fix(Z);
          ce.type = Z.type === "focusin" ? "focus" : "blur", ce.isSimulated = !0, oe(Z), ce.target === ce.currentTarget && oe(ce);
        } else
          j.event.simulate(
            O,
            Z.target,
            j.event.fix(Z)
          );
      }
      j.event.special[b] = {
        // Utilize native event if possible so blur/focus sequence is correct
        setup: function() {
          var Z;
          if (J(this, b, !0), se.documentMode)
            Z = nt.get(this, O), Z || this.addEventListener(O, G), nt.set(this, O, (Z || 0) + 1);
          else
            return !1;
        },
        trigger: function() {
          return J(this, b), !0;
        },
        teardown: function() {
          var Z;
          if (se.documentMode)
            Z = nt.get(this, O) - 1, Z ? nt.set(this, O, Z) : (this.removeEventListener(O, G), nt.remove(this, O));
          else
            return !1;
        },
        // Suppress native focus or blur if we're currently inside
        // a leveraged native-event stack
        _default: function(Z) {
          return nt.get(Z.target, b);
        },
        delegateType: O
      }, j.event.special[O] = {
        setup: function() {
          var Z = this.ownerDocument || this.document || this, oe = se.documentMode ? this : Z, ce = nt.get(oe, O);
          ce || (se.documentMode ? this.addEventListener(O, G) : Z.addEventListener(b, G, !0)), nt.set(oe, O, (ce || 0) + 1);
        },
        teardown: function() {
          var Z = this.ownerDocument || this.document || this, oe = se.documentMode ? this : Z, ce = nt.get(oe, O) - 1;
          ce ? nt.set(oe, O, ce) : (se.documentMode ? this.removeEventListener(O, G) : Z.removeEventListener(b, G, !0), nt.remove(oe, O));
        }
      };
    }), j.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function(b, O) {
      j.event.special[b] = {
        delegateType: O,
        bindType: O,
        handle: function(G) {
          var Z, oe = this, ce = G.relatedTarget, de = G.handleObj;
          return (!ce || ce !== oe && !j.contains(oe, ce)) && (G.type = de.origType, Z = de.handler.apply(this, arguments), G.type = O), Z;
        }
      };
    }), j.fn.extend({
      on: function(b, O, G, Z) {
        return ae(this, b, O, G, Z);
      },
      one: function(b, O, G, Z) {
        return ae(this, b, O, G, Z, 1);
      },
      off: function(b, O, G) {
        var Z, oe;
        if (b && b.preventDefault && b.handleObj)
          return Z = b.handleObj, j(b.delegateTarget).off(
            Z.namespace ? Z.origType + "." + Z.namespace : Z.origType,
            Z.selector,
            Z.handler
          ), this;
        if (typeof b == "object") {
          for (oe in b)
            this.off(oe, O, b[oe]);
          return this;
        }
        return (O === !1 || typeof O == "function") && (G = O, O = void 0), G === !1 && (G = ie), this.each(function() {
          j.event.remove(this, b, G, O);
        });
      }
    });
    var le = /<script|<style|<link/i, fe = /checked\s*(?:[^=]|=\s*.checked.)/i, me = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    function ve(b, O) {
      return Ze(b, "table") && Ze(O.nodeType !== 11 ? O : O.firstChild, "tr") && j(b).children("tbody")[0] || b;
    }
    function Se(b) {
      return b.type = (b.getAttribute("type") !== null) + "/" + b.type, b;
    }
    function Re(b) {
      return (b.type || "").slice(0, 5) === "true/" ? b.type = b.type.slice(5) : b.removeAttribute("type"), b;
    }
    function He(b, O) {
      var G, Z, oe, ce, de, Pe, Oe;
      if (O.nodeType === 1) {
        if (nt.hasData(b) && (ce = nt.get(b), Oe = ce.events, Oe)) {
          nt.remove(O, "handle events");
          for (oe in Oe)
            for (G = 0, Z = Oe[oe].length; G < Z; G++)
              j.event.add(O, oe, Oe[oe][G]);
        }
        i.hasData(b) && (de = i.access(b), Pe = j.extend({}, de), i.set(O, Pe));
      }
    }
    function Ye(b, O) {
      var G = O.nodeName.toLowerCase();
      G === "input" && D.test(b.type) ? O.checked = b.checked : (G === "input" || G === "textarea") && (O.defaultValue = b.defaultValue);
    }
    function Je(b, O, G, Z) {
      O = c(O);
      var oe, ce, de, Pe, Oe, Ue, rt = 0, lt = b.length, Ke = lt - 1, xt = O[0], It = ne(xt);
      if (It || lt > 1 && typeof xt == "string" && !he.checkClone && fe.test(xt))
        return b.each(function(ai) {
          var si = b.eq(ai);
          It && (O[0] = xt.call(this, ai, si.html())), Je(si, O, G, Z);
        });
      if (lt && (oe = F(O, b[0].ownerDocument, !1, b, Z), ce = oe.firstChild, oe.childNodes.length === 1 && (oe = ce), ce || Z)) {
        for (de = j.map(I(oe, "script"), Se), Pe = de.length; rt < lt; rt++)
          Oe = oe, rt !== Ke && (Oe = j.clone(Oe, !0, !0), Pe && j.merge(de, I(Oe, "script"))), G.call(b[rt], Oe, rt);
        if (Pe)
          for (Ue = de[de.length - 1].ownerDocument, j.map(de, Re), rt = 0; rt < Pe; rt++)
            Oe = de[rt], P.test(Oe.type || "") && !nt.access(Oe, "globalEval") && j.contains(Ue, Oe) && (Oe.src && (Oe.type || "").toLowerCase() !== "module" ? j._evalUrl && !Oe.noModule && j._evalUrl(Oe.src, {
              nonce: Oe.nonce || Oe.getAttribute("nonce")
            }, Ue) : ue(Oe.textContent.replace(me, ""), Oe, Ue));
      }
      return b;
    }
    function Be(b, O, G) {
      for (var Z, oe = O ? j.filter(O, b) : b, ce = 0; (Z = oe[ce]) != null; ce++)
        !G && Z.nodeType === 1 && j.cleanData(I(Z)), Z.parentNode && (G && x(Z) && U(I(Z, "script")), Z.parentNode.removeChild(Z));
      return b;
    }
    j.extend({
      htmlPrefilter: function(b) {
        return b;
      },
      clone: function(b, O, G) {
        var Z, oe, ce, de, Pe = b.cloneNode(!0), Oe = x(b);
        if (!he.noCloneChecked && (b.nodeType === 1 || b.nodeType === 11) && !j.isXMLDoc(b))
          for (de = I(Pe), ce = I(b), Z = 0, oe = ce.length; Z < oe; Z++)
            Ye(ce[Z], de[Z]);
        if (O)
          if (G)
            for (ce = ce || I(b), de = de || I(Pe), Z = 0, oe = ce.length; Z < oe; Z++)
              He(ce[Z], de[Z]);
          else
            He(b, Pe);
        return de = I(Pe, "script"), de.length > 0 && U(de, !Oe && I(b, "script")), Pe;
      },
      cleanData: function(b) {
        for (var O, G, Z, oe = j.event.special, ce = 0; (G = b[ce]) !== void 0; ce++)
          if (Vt(G)) {
            if (O = G[nt.expando]) {
              if (O.events)
                for (Z in O.events)
                  oe[Z] ? j.event.remove(G, Z) : j.removeEvent(G, Z, O.handle);
              G[nt.expando] = void 0;
            }
            G[i.expando] && (G[i.expando] = void 0);
          }
      }
    }), j.fn.extend({
      detach: function(b) {
        return Be(this, b, !0);
      },
      remove: function(b) {
        return Be(this, b);
      },
      text: function(b) {
        return Bn(this, function(O) {
          return O === void 0 ? j.text(this) : this.empty().each(function() {
            (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = O);
          });
        }, null, b, arguments.length);
      },
      append: function() {
        return Je(this, arguments, function(b) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var O = ve(this, b);
            O.appendChild(b);
          }
        });
      },
      prepend: function() {
        return Je(this, arguments, function(b) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var O = ve(this, b);
            O.insertBefore(b, O.firstChild);
          }
        });
      },
      before: function() {
        return Je(this, arguments, function(b) {
          this.parentNode && this.parentNode.insertBefore(b, this);
        });
      },
      after: function() {
        return Je(this, arguments, function(b) {
          this.parentNode && this.parentNode.insertBefore(b, this.nextSibling);
        });
      },
      empty: function() {
        for (var b, O = 0; (b = this[O]) != null; O++)
          b.nodeType === 1 && (j.cleanData(I(b, !1)), b.textContent = "");
        return this;
      },
      clone: function(b, O) {
        return b = b ?? !1, O = O ?? b, this.map(function() {
          return j.clone(this, b, O);
        });
      },
      html: function(b) {
        return Bn(this, function(O) {
          var G = this[0] || {}, Z = 0, oe = this.length;
          if (O === void 0 && G.nodeType === 1)
            return G.innerHTML;
          if (typeof O == "string" && !le.test(O) && !S[(L.exec(O) || ["", ""])[1].toLowerCase()]) {
            O = j.htmlPrefilter(O);
            try {
              for (; Z < oe; Z++)
                G = this[Z] || {}, G.nodeType === 1 && (j.cleanData(I(G, !1)), G.innerHTML = O);
              G = 0;
            } catch {
            }
          }
          G && this.empty().append(O);
        }, null, b, arguments.length);
      },
      replaceWith: function() {
        var b = [];
        return Je(this, arguments, function(O) {
          var G = this.parentNode;
          j.inArray(this, b) < 0 && (j.cleanData(I(this)), G && G.replaceChild(O, this));
        }, b);
      }
    }), j.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function(b, O) {
      j.fn[b] = function(G) {
        for (var Z, oe = [], ce = j(G), de = ce.length - 1, Pe = 0; Pe <= de; Pe++)
          Z = Pe === de ? this : this.clone(!0), j(ce[Pe])[O](Z), g.apply(oe, Z.get());
        return this.pushStack(oe);
      };
    });
    var Ie = new RegExp("^(" + f + ")(?!px)[a-z%]+$", "i"), Ge = /^--/, et = function(b) {
      var O = b.ownerDocument.defaultView;
      return (!O || !O.opener) && (O = e), O.getComputedStyle(b);
    }, tt = function(b, O, G) {
      var Z, oe, ce = {};
      for (oe in O)
        ce[oe] = b.style[oe], b.style[oe] = O[oe];
      Z = G.call(b);
      for (oe in O)
        b.style[oe] = ce[oe];
      return Z;
    }, gt = new RegExp(_.join("|"), "i");
    (function() {
      function b() {
        if (Ue) {
          Oe.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", Ue.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", y.appendChild(Oe).appendChild(Ue);
          var rt = e.getComputedStyle(Ue);
          G = rt.top !== "1%", Pe = O(rt.marginLeft) === 12, Ue.style.right = "60%", ce = O(rt.right) === 36, Z = O(rt.width) === 36, Ue.style.position = "absolute", oe = O(Ue.offsetWidth / 3) === 12, y.removeChild(Oe), Ue = null;
        }
      }
      function O(rt) {
        return Math.round(parseFloat(rt));
      }
      var G, Z, oe, ce, de, Pe, Oe = se.createElement("div"), Ue = se.createElement("div");
      Ue.style && (Ue.style.backgroundClip = "content-box", Ue.cloneNode(!0).style.backgroundClip = "", he.clearCloneStyle = Ue.style.backgroundClip === "content-box", j.extend(he, {
        boxSizingReliable: function() {
          return b(), Z;
        },
        pixelBoxStyles: function() {
          return b(), ce;
        },
        pixelPosition: function() {
          return b(), G;
        },
        reliableMarginLeft: function() {
          return b(), Pe;
        },
        scrollboxSize: function() {
          return b(), oe;
        },
        // Support: IE 9 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Behavior in IE 9 is more subtle than in newer versions & it passes
        // some versions of this test; make sure not to make it pass there!
        //
        // Support: Firefox 70+
        // Only Firefox includes border widths
        // in computed dimensions. (gh-4529)
        reliableTrDimensions: function() {
          var rt, lt, Ke, xt;
          return de == null && (rt = se.createElement("table"), lt = se.createElement("tr"), Ke = se.createElement("div"), rt.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", lt.style.cssText = "box-sizing:content-box;border:1px solid", lt.style.height = "1px", Ke.style.height = "9px", Ke.style.display = "block", y.appendChild(rt).appendChild(lt).appendChild(Ke), xt = e.getComputedStyle(lt), de = parseInt(xt.height, 10) + parseInt(xt.borderTopWidth, 10) + parseInt(xt.borderBottomWidth, 10) === lt.offsetHeight, y.removeChild(rt)), de;
        }
      }));
    })();
    function ut(b, O, G) {
      var Z, oe, ce, de, Pe = Ge.test(O), Oe = b.style;
      return G = G || et(b), G && (de = G.getPropertyValue(O) || G[O], Pe && de && (de = de.replace(at, "$1") || void 0), de === "" && !x(b) && (de = j.style(b, O)), !he.pixelBoxStyles() && Ie.test(de) && gt.test(O) && (Z = Oe.width, oe = Oe.minWidth, ce = Oe.maxWidth, Oe.minWidth = Oe.maxWidth = Oe.width = de, de = G.width, Oe.width = Z, Oe.minWidth = oe, Oe.maxWidth = ce)), de !== void 0 ? (
        // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        de + ""
      ) : de;
    }
    function yt(b, O) {
      return {
        get: function() {
          if (b()) {
            delete this.get;
            return;
          }
          return (this.get = O).apply(this, arguments);
        }
      };
    }
    var At = ["Webkit", "Moz", "ms"], bt = se.createElement("div").style, li = {};
    function mt(b) {
      for (var O = b[0].toUpperCase() + b.slice(1), G = At.length; G--; )
        if (b = At[G] + O, b in bt)
          return b;
    }
    function Zt(b) {
      var O = j.cssProps[b] || li[b];
      return O || (b in bt ? b : li[b] = mt(b) || b);
    }
    var Xt = /^(none|table(?!-c[ea]).+)/, Nt = { position: "absolute", visibility: "hidden", display: "block" }, Jt = {
      letterSpacing: "0",
      fontWeight: "400"
    };
    function Ti(b, O, G) {
      var Z = m.exec(O);
      return Z ? (
        // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, Z[2] - (G || 0)) + (Z[3] || "px")
      ) : O;
    }
    function ri(b, O, G, Z, oe, ce) {
      var de = O === "width" ? 1 : 0, Pe = 0, Oe = 0, Ue = 0;
      if (G === (Z ? "border" : "content"))
        return 0;
      for (; de < 4; de += 2)
        G === "margin" && (Ue += j.css(b, G + _[de], !0, oe)), Z ? (G === "content" && (Oe -= j.css(b, "padding" + _[de], !0, oe)), G !== "margin" && (Oe -= j.css(b, "border" + _[de] + "Width", !0, oe))) : (Oe += j.css(b, "padding" + _[de], !0, oe), G !== "padding" ? Oe += j.css(b, "border" + _[de] + "Width", !0, oe) : Pe += j.css(b, "border" + _[de] + "Width", !0, oe));
      return !Z && ce >= 0 && (Oe += Math.max(0, Math.ceil(
        b["offset" + O[0].toUpperCase() + O.slice(1)] - ce - Oe - Pe - 0.5
        // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
        // Use an explicit zero to avoid NaN (gh-3964)
      )) || 0), Oe + Ue;
    }
    function Pi(b, O, G) {
      var Z = et(b), oe = !he.boxSizingReliable() || G, ce = oe && j.css(b, "boxSizing", !1, Z) === "border-box", de = ce, Pe = ut(b, O, Z), Oe = "offset" + O[0].toUpperCase() + O.slice(1);
      if (Ie.test(Pe)) {
        if (!G)
          return Pe;
        Pe = "auto";
      }
      return (!he.boxSizingReliable() && ce || // Support: IE 10 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Interestingly, in some cases IE 9 doesn't suffer from this issue.
      !he.reliableTrDimensions() && Ze(b, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
      // This happens for inline elements with no explicit setting (gh-3571)
      Pe === "auto" || // Support: Android <=4.1 - 4.3 only
      // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
      !parseFloat(Pe) && j.css(b, "display", !1, Z) === "inline") && // Make sure the element is visible & connected
      b.getClientRects().length && (ce = j.css(b, "boxSizing", !1, Z) === "border-box", de = Oe in b, de && (Pe = b[Oe])), Pe = parseFloat(Pe) || 0, Pe + ri(
        b,
        O,
        G || (ce ? "border" : "content"),
        de,
        Z,
        // Provide the current computed size to request scroll gutter calculation (gh-3589)
        Pe
      ) + "px";
    }
    j.extend({
      // Add in style property hooks for overriding the default
      // behavior of getting and setting a style property
      cssHooks: {
        opacity: {
          get: function(b, O) {
            if (O) {
              var G = ut(b, "opacity");
              return G === "" ? "1" : G;
            }
          }
        }
      },
      // Don't automatically add "px" to these possibly-unitless properties
      cssNumber: {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageSlice: !0,
        columnCount: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        scale: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0
      },
      // Add in properties whose names you wish to fix before
      // setting or getting the value
      cssProps: {},
      // Get and set the style property on a DOM Node
      style: function(b, O, G, Z) {
        if (!(!b || b.nodeType === 3 || b.nodeType === 8 || !b.style)) {
          var oe, ce, de, Pe = ki(O), Oe = Ge.test(O), Ue = b.style;
          if (Oe || (O = Zt(Pe)), de = j.cssHooks[O] || j.cssHooks[Pe], G !== void 0) {
            if (ce = typeof G, ce === "string" && (oe = m.exec(G)) && oe[1] && (G = C(b, O, oe), ce = "number"), G == null || G !== G)
              return;
            ce === "number" && !Oe && (G += oe && oe[3] || (j.cssNumber[Pe] ? "" : "px")), !he.clearCloneStyle && G === "" && O.indexOf("background") === 0 && (Ue[O] = "inherit"), (!de || !("set" in de) || (G = de.set(b, G, Z)) !== void 0) && (Oe ? Ue.setProperty(O, G) : Ue[O] = G);
          } else
            return de && "get" in de && (oe = de.get(b, !1, Z)) !== void 0 ? oe : Ue[O];
        }
      },
      css: function(b, O, G, Z) {
        var oe, ce, de, Pe = ki(O), Oe = Ge.test(O);
        return Oe || (O = Zt(Pe)), de = j.cssHooks[O] || j.cssHooks[Pe], de && "get" in de && (oe = de.get(b, !0, G)), oe === void 0 && (oe = ut(b, O, Z)), oe === "normal" && O in Jt && (oe = Jt[O]), G === "" || G ? (ce = parseFloat(oe), G === !0 || isFinite(ce) ? ce || 0 : oe) : oe;
      }
    }), j.each(["height", "width"], function(b, O) {
      j.cssHooks[O] = {
        get: function(G, Z, oe) {
          if (Z)
            return Xt.test(j.css(G, "display")) && // Support: Safari 8+
            // Table columns in Safari have non-zero offsetWidth & zero
            // getBoundingClientRect().width unless display is changed.
            // Support: IE <=11 only
            // Running getBoundingClientRect on a disconnected node
            // in IE throws an error.
            (!G.getClientRects().length || !G.getBoundingClientRect().width) ? tt(G, Nt, function() {
              return Pi(G, O, oe);
            }) : Pi(G, O, oe);
        },
        set: function(G, Z, oe) {
          var ce, de = et(G), Pe = !he.scrollboxSize() && de.position === "absolute", Oe = Pe || oe, Ue = Oe && j.css(G, "boxSizing", !1, de) === "border-box", rt = oe ? ri(
            G,
            O,
            oe,
            Ue,
            de
          ) : 0;
          return Ue && Pe && (rt -= Math.ceil(
            G["offset" + O[0].toUpperCase() + O.slice(1)] - parseFloat(de[O]) - ri(G, O, "border", !1, de) - 0.5
          )), rt && (ce = m.exec(Z)) && (ce[3] || "px") !== "px" && (G.style[O] = Z, Z = j.css(G, O)), Ti(G, Z, rt);
        }
      };
    }), j.cssHooks.marginLeft = yt(
      he.reliableMarginLeft,
      function(b, O) {
        if (O)
          return (parseFloat(ut(b, "marginLeft")) || b.getBoundingClientRect().left - tt(b, { marginLeft: 0 }, function() {
            return b.getBoundingClientRect().left;
          })) + "px";
      }
    ), j.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function(b, O) {
      j.cssHooks[b + O] = {
        expand: function(G) {
          for (var Z = 0, oe = {}, ce = typeof G == "string" ? G.split(" ") : [G]; Z < 4; Z++)
            oe[b + _[Z] + O] = ce[Z] || ce[Z - 2] || ce[0];
          return oe;
        }
      }, b !== "margin" && (j.cssHooks[b + O].set = Ti);
    }), j.fn.extend({
      css: function(b, O) {
        return Bn(this, function(G, Z, oe) {
          var ce, de, Pe = {}, Oe = 0;
          if (Array.isArray(Z)) {
            for (ce = et(G), de = Z.length; Oe < de; Oe++)
              Pe[Z[Oe]] = j.css(G, Z[Oe], !1, ce);
            return Pe;
          }
          return oe !== void 0 ? j.style(G, Z, oe) : j.css(G, Z);
        }, b, O, arguments.length > 1);
      }
    });
    function ci(b, O, G, Z, oe) {
      return new ci.prototype.init(b, O, G, Z, oe);
    }
    j.Tween = ci, ci.prototype = {
      constructor: ci,
      init: function(b, O, G, Z, oe, ce) {
        this.elem = b, this.prop = G, this.easing = oe || j.easing._default, this.options = O, this.start = this.now = this.cur(), this.end = Z, this.unit = ce || (j.cssNumber[G] ? "" : "px");
      },
      cur: function() {
        var b = ci.propHooks[this.prop];
        return b && b.get ? b.get(this) : ci.propHooks._default.get(this);
      },
      run: function(b) {
        var O, G = ci.propHooks[this.prop];
        return this.options.duration ? this.pos = O = j.easing[this.easing](
          b,
          this.options.duration * b,
          0,
          1,
          this.options.duration
        ) : this.pos = O = b, this.now = (this.end - this.start) * O + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), G && G.set ? G.set(this) : ci.propHooks._default.set(this), this;
      }
    }, ci.prototype.init.prototype = ci.prototype, ci.propHooks = {
      _default: {
        get: function(b) {
          var O;
          return b.elem.nodeType !== 1 || b.elem[b.prop] != null && b.elem.style[b.prop] == null ? b.elem[b.prop] : (O = j.css(b.elem, b.prop, ""), !O || O === "auto" ? 0 : O);
        },
        set: function(b) {
          j.fx.step[b.prop] ? j.fx.step[b.prop](b) : b.elem.nodeType === 1 && (j.cssHooks[b.prop] || b.elem.style[Zt(b.prop)] != null) ? j.style(b.elem, b.prop, b.now + b.unit) : b.elem[b.prop] = b.now;
        }
      }
    }, ci.propHooks.scrollTop = ci.propHooks.scrollLeft = {
      set: function(b) {
        b.elem.nodeType && b.elem.parentNode && (b.elem[b.prop] = b.now);
      }
    }, j.easing = {
      linear: function(b) {
        return b;
      },
      swing: function(b) {
        return 0.5 - Math.cos(b * Math.PI) / 2;
      },
      _default: "swing"
    }, j.fx = ci.prototype.init, j.fx.step = {};
    var hi, Ni, Bi = /^(?:toggle|show|hide)$/, Ri = /queueHooks$/;
    function Wi() {
      Ni && (se.hidden === !1 && e.requestAnimationFrame ? e.requestAnimationFrame(Wi) : e.setTimeout(Wi, j.fx.interval), j.fx.tick());
    }
    function Vi() {
      return e.setTimeout(function() {
        hi = void 0;
      }), hi = Date.now();
    }
    function Fn(b, O) {
      var G, Z = 0, oe = { height: b };
      for (O = O ? 1 : 0; Z < 4; Z += 2 - O)
        G = _[Z], oe["margin" + G] = oe["padding" + G] = b;
      return O && (oe.opacity = oe.width = b), oe;
    }
    function $n(b, O, G) {
      for (var Z, oe = (vn.tweeners[O] || []).concat(vn.tweeners["*"]), ce = 0, de = oe.length; ce < de; ce++)
        if (Z = oe[ce].call(G, O, b))
          return Z;
    }
    function Cs(b, O, G) {
      var Z, oe, ce, de, Pe, Oe, Ue, rt, lt = "width" in O || "height" in O, Ke = this, xt = {}, It = b.style, ai = b.nodeType && B(b), si = nt.get(b, "fxshow");
      G.queue || (de = j._queueHooks(b, "fx"), de.unqueued == null && (de.unqueued = 0, Pe = de.empty.fire, de.empty.fire = function() {
        de.unqueued || Pe();
      }), de.unqueued++, Ke.always(function() {
        Ke.always(function() {
          de.unqueued--, j.queue(b, "fx").length || de.empty.fire();
        });
      }));
      for (Z in O)
        if (oe = O[Z], Bi.test(oe)) {
          if (delete O[Z], ce = ce || oe === "toggle", oe === (ai ? "hide" : "show"))
            if (oe === "show" && si && si[Z] !== void 0)
              ai = !0;
            else
              continue;
          xt[Z] = si && si[Z] || j.style(b, Z);
        }
      if (Oe = !j.isEmptyObject(O), !(!Oe && j.isEmptyObject(xt))) {
        lt && b.nodeType === 1 && (G.overflow = [It.overflow, It.overflowX, It.overflowY], Ue = si && si.display, Ue == null && (Ue = nt.get(b, "display")), rt = j.css(b, "display"), rt === "none" && (Ue ? rt = Ue : (E([b], !0), Ue = b.style.display || Ue, rt = j.css(b, "display"), E([b]))), (rt === "inline" || rt === "inline-block" && Ue != null) && j.css(b, "float") === "none" && (Oe || (Ke.done(function() {
          It.display = Ue;
        }), Ue == null && (rt = It.display, Ue = rt === "none" ? "" : rt)), It.display = "inline-block")), G.overflow && (It.overflow = "hidden", Ke.always(function() {
          It.overflow = G.overflow[0], It.overflowX = G.overflow[1], It.overflowY = G.overflow[2];
        })), Oe = !1;
        for (Z in xt)
          Oe || (si ? "hidden" in si && (ai = si.hidden) : si = nt.access(b, "fxshow", { display: Ue }), ce && (si.hidden = !ai), ai && E([b], !0), Ke.done(function() {
            ai || E([b]), nt.remove(b, "fxshow");
            for (Z in xt)
              j.style(b, Z, xt[Z]);
          })), Oe = $n(ai ? si[Z] : 0, Z, Ke), Z in si || (si[Z] = Oe.start, ai && (Oe.end = Oe.start, Oe.start = 0));
      }
    }
    function _s(b, O) {
      var G, Z, oe, ce, de;
      for (G in b)
        if (Z = ki(G), oe = O[Z], ce = b[G], Array.isArray(ce) && (oe = ce[1], ce = b[G] = ce[0]), G !== Z && (b[Z] = ce, delete b[G]), de = j.cssHooks[Z], de && "expand" in de) {
          ce = de.expand(ce), delete b[Z];
          for (G in ce)
            G in b || (b[G] = ce[G], O[G] = oe);
        } else
          O[Z] = oe;
    }
    function vn(b, O, G) {
      var Z, oe, ce = 0, de = vn.prefilters.length, Pe = j.Deferred().always(function() {
        delete Oe.elem;
      }), Oe = function() {
        if (oe)
          return !1;
        for (var lt = hi || Vi(), Ke = Math.max(0, Ue.startTime + Ue.duration - lt), xt = Ke / Ue.duration || 0, It = 1 - xt, ai = 0, si = Ue.tweens.length; ai < si; ai++)
          Ue.tweens[ai].run(It);
        return Pe.notifyWith(b, [Ue, It, Ke]), It < 1 && si ? Ke : (si || Pe.notifyWith(b, [Ue, 1, 0]), Pe.resolveWith(b, [Ue]), !1);
      }, Ue = Pe.promise({
        elem: b,
        props: j.extend({}, O),
        opts: j.extend(!0, {
          specialEasing: {},
          easing: j.easing._default
        }, G),
        originalProperties: O,
        originalOptions: G,
        startTime: hi || Vi(),
        duration: G.duration,
        tweens: [],
        createTween: function(lt, Ke) {
          var xt = j.Tween(
            b,
            Ue.opts,
            lt,
            Ke,
            Ue.opts.specialEasing[lt] || Ue.opts.easing
          );
          return Ue.tweens.push(xt), xt;
        },
        stop: function(lt) {
          var Ke = 0, xt = lt ? Ue.tweens.length : 0;
          if (oe)
            return this;
          for (oe = !0; Ke < xt; Ke++)
            Ue.tweens[Ke].run(1);
          return lt ? (Pe.notifyWith(b, [Ue, 1, 0]), Pe.resolveWith(b, [Ue, lt])) : Pe.rejectWith(b, [Ue, lt]), this;
        }
      }), rt = Ue.props;
      for (_s(rt, Ue.opts.specialEasing); ce < de; ce++)
        if (Z = vn.prefilters[ce].call(Ue, b, rt, Ue.opts), Z)
          return ne(Z.stop) && (j._queueHooks(Ue.elem, Ue.opts.queue).stop = Z.stop.bind(Z)), Z;
      return j.map(rt, $n, Ue), ne(Ue.opts.start) && Ue.opts.start.call(b, Ue), Ue.progress(Ue.opts.progress).done(Ue.opts.done, Ue.opts.complete).fail(Ue.opts.fail).always(Ue.opts.always), j.fx.timer(
        j.extend(Oe, {
          elem: b,
          anim: Ue,
          queue: Ue.opts.queue
        })
      ), Ue;
    }
    j.Animation = j.extend(vn, {
      tweeners: {
        "*": [function(b, O) {
          var G = this.createTween(b, O);
          return C(G.elem, b, m.exec(O), G), G;
        }]
      },
      tweener: function(b, O) {
        ne(b) ? (O = b, b = ["*"]) : b = b.match(Dt);
        for (var G, Z = 0, oe = b.length; Z < oe; Z++)
          G = b[Z], vn.tweeners[G] = vn.tweeners[G] || [], vn.tweeners[G].unshift(O);
      },
      prefilters: [Cs],
      prefilter: function(b, O) {
        O ? vn.prefilters.unshift(b) : vn.prefilters.push(b);
      }
    }), j.speed = function(b, O, G) {
      var Z = b && typeof b == "object" ? j.extend({}, b) : {
        complete: G || !G && O || ne(b) && b,
        duration: b,
        easing: G && O || O && !ne(O) && O
      };
      return j.fx.off ? Z.duration = 0 : typeof Z.duration != "number" && (Z.duration in j.fx.speeds ? Z.duration = j.fx.speeds[Z.duration] : Z.duration = j.fx.speeds._default), (Z.queue == null || Z.queue === !0) && (Z.queue = "fx"), Z.old = Z.complete, Z.complete = function() {
        ne(Z.old) && Z.old.call(this), Z.queue && j.dequeue(this, Z.queue);
      }, Z;
    }, j.fn.extend({
      fadeTo: function(b, O, G, Z) {
        return this.filter(B).css("opacity", 0).show().end().animate({ opacity: O }, b, G, Z);
      },
      animate: function(b, O, G, Z) {
        var oe = j.isEmptyObject(b), ce = j.speed(O, G, Z), de = function() {
          var Pe = vn(this, j.extend({}, b), ce);
          (oe || nt.get(this, "finish")) && Pe.stop(!0);
        };
        return de.finish = de, oe || ce.queue === !1 ? this.each(de) : this.queue(ce.queue, de);
      },
      stop: function(b, O, G) {
        var Z = function(oe) {
          var ce = oe.stop;
          delete oe.stop, ce(G);
        };
        return typeof b != "string" && (G = O, O = b, b = void 0), O && this.queue(b || "fx", []), this.each(function() {
          var oe = !0, ce = b != null && b + "queueHooks", de = j.timers, Pe = nt.get(this);
          if (ce)
            Pe[ce] && Pe[ce].stop && Z(Pe[ce]);
          else
            for (ce in Pe)
              Pe[ce] && Pe[ce].stop && Ri.test(ce) && Z(Pe[ce]);
          for (ce = de.length; ce--; )
            de[ce].elem === this && (b == null || de[ce].queue === b) && (de[ce].anim.stop(G), oe = !1, de.splice(ce, 1));
          (oe || !G) && j.dequeue(this, b);
        });
      },
      finish: function(b) {
        return b !== !1 && (b = b || "fx"), this.each(function() {
          var O, G = nt.get(this), Z = G[b + "queue"], oe = G[b + "queueHooks"], ce = j.timers, de = Z ? Z.length : 0;
          for (G.finish = !0, j.queue(this, b, []), oe && oe.stop && oe.stop.call(this, !0), O = ce.length; O--; )
            ce[O].elem === this && ce[O].queue === b && (ce[O].anim.stop(!0), ce.splice(O, 1));
          for (O = 0; O < de; O++)
            Z[O] && Z[O].finish && Z[O].finish.call(this);
          delete G.finish;
        });
      }
    }), j.each(["toggle", "show", "hide"], function(b, O) {
      var G = j.fn[O];
      j.fn[O] = function(Z, oe, ce) {
        return Z == null || typeof Z == "boolean" ? G.apply(this, arguments) : this.animate(Fn(O, !0), Z, oe, ce);
      };
    }), j.each({
      slideDown: Fn("show"),
      slideUp: Fn("hide"),
      slideToggle: Fn("toggle"),
      fadeIn: { opacity: "show" },
      fadeOut: { opacity: "hide" },
      fadeToggle: { opacity: "toggle" }
    }, function(b, O) {
      j.fn[b] = function(G, Z, oe) {
        return this.animate(O, G, Z, oe);
      };
    }), j.timers = [], j.fx.tick = function() {
      var b, O = 0, G = j.timers;
      for (hi = Date.now(); O < G.length; O++)
        b = G[O], !b() && G[O] === b && G.splice(O--, 1);
      G.length || j.fx.stop(), hi = void 0;
    }, j.fx.timer = function(b) {
      j.timers.push(b), j.fx.start();
    }, j.fx.interval = 13, j.fx.start = function() {
      Ni || (Ni = !0, Wi());
    }, j.fx.stop = function() {
      Ni = null;
    }, j.fx.speeds = {
      slow: 600,
      fast: 200,
      // Default speed
      _default: 400
    }, j.fn.delay = function(b, O) {
      return b = j.fx && j.fx.speeds[b] || b, O = O || "fx", this.queue(O, function(G, Z) {
        var oe = e.setTimeout(G, b);
        Z.stop = function() {
          e.clearTimeout(oe);
        };
      });
    }, function() {
      var b = se.createElement("input"), O = se.createElement("select"), G = O.appendChild(se.createElement("option"));
      b.type = "checkbox", he.checkOn = b.value !== "", he.optSelected = G.selected, b = se.createElement("input"), b.value = "t", b.type = "radio", he.radioValue = b.value === "t";
    }();
    var Qn, Yt = j.expr.attrHandle;
    j.fn.extend({
      attr: function(b, O) {
        return Bn(this, j.attr, b, O, arguments.length > 1);
      },
      removeAttr: function(b) {
        return this.each(function() {
          j.removeAttr(this, b);
        });
      }
    }), j.extend({
      attr: function(b, O, G) {
        var Z, oe, ce = b.nodeType;
        if (!(ce === 3 || ce === 8 || ce === 2)) {
          if (typeof b.getAttribute > "u")
            return j.prop(b, O, G);
          if ((ce !== 1 || !j.isXMLDoc(b)) && (oe = j.attrHooks[O.toLowerCase()] || (j.expr.match.bool.test(O) ? Qn : void 0)), G !== void 0) {
            if (G === null) {
              j.removeAttr(b, O);
              return;
            }
            return oe && "set" in oe && (Z = oe.set(b, G, O)) !== void 0 ? Z : (b.setAttribute(O, G + ""), G);
          }
          return oe && "get" in oe && (Z = oe.get(b, O)) !== null ? Z : (Z = j.find.attr(b, O), Z ?? void 0);
        }
      },
      attrHooks: {
        type: {
          set: function(b, O) {
            if (!he.radioValue && O === "radio" && Ze(b, "input")) {
              var G = b.value;
              return b.setAttribute("type", O), G && (b.value = G), O;
            }
          }
        }
      },
      removeAttr: function(b, O) {
        var G, Z = 0, oe = O && O.match(Dt);
        if (oe && b.nodeType === 1)
          for (; G = oe[Z++]; )
            b.removeAttribute(G);
      }
    }), Qn = {
      set: function(b, O, G) {
        return O === !1 ? j.removeAttr(b, G) : b.setAttribute(G, G), G;
      }
    }, j.each(j.expr.match.bool.source.match(/\w+/g), function(b, O) {
      var G = Yt[O] || j.find.attr;
      Yt[O] = function(Z, oe, ce) {
        var de, Pe, Oe = oe.toLowerCase();
        return ce || (Pe = Yt[Oe], Yt[Oe] = de, de = G(Z, oe, ce) != null ? Oe : null, Yt[Oe] = Pe), de;
      };
    });
    var os = /^(?:input|select|textarea|button)$/i, Mn = /^(?:a|area)$/i;
    j.fn.extend({
      prop: function(b, O) {
        return Bn(this, j.prop, b, O, arguments.length > 1);
      },
      removeProp: function(b) {
        return this.each(function() {
          delete this[j.propFix[b] || b];
        });
      }
    }), j.extend({
      prop: function(b, O, G) {
        var Z, oe, ce = b.nodeType;
        if (!(ce === 3 || ce === 8 || ce === 2))
          return (ce !== 1 || !j.isXMLDoc(b)) && (O = j.propFix[O] || O, oe = j.propHooks[O]), G !== void 0 ? oe && "set" in oe && (Z = oe.set(b, G, O)) !== void 0 ? Z : b[O] = G : oe && "get" in oe && (Z = oe.get(b, O)) !== null ? Z : b[O];
      },
      propHooks: {
        tabIndex: {
          get: function(b) {
            var O = j.find.attr(b, "tabindex");
            return O ? parseInt(O, 10) : os.test(b.nodeName) || Mn.test(b.nodeName) && b.href ? 0 : -1;
          }
        }
      },
      propFix: {
        for: "htmlFor",
        class: "className"
      }
    }), he.optSelected || (j.propHooks.selected = {
      get: function(b) {
        var O = b.parentNode;
        return O && O.parentNode && O.parentNode.selectedIndex, null;
      },
      set: function(b) {
        var O = b.parentNode;
        O && (O.selectedIndex, O.parentNode && O.parentNode.selectedIndex);
      }
    }), j.each([
      "tabIndex",
      "readOnly",
      "maxLength",
      "cellSpacing",
      "cellPadding",
      "rowSpan",
      "colSpan",
      "useMap",
      "frameBorder",
      "contentEditable"
    ], function() {
      j.propFix[this.toLowerCase()] = this;
    });
    function un(b) {
      var O = b.match(Dt) || [];
      return O.join(" ");
    }
    function Ji(b) {
      return b.getAttribute && b.getAttribute("class") || "";
    }
    function cn(b) {
      return Array.isArray(b) ? b : typeof b == "string" ? b.match(Dt) || [] : [];
    }
    j.fn.extend({
      addClass: function(b) {
        var O, G, Z, oe, ce, de;
        return ne(b) ? this.each(function(Pe) {
          j(this).addClass(b.call(this, Pe, Ji(this)));
        }) : (O = cn(b), O.length ? this.each(function() {
          if (Z = Ji(this), G = this.nodeType === 1 && " " + un(Z) + " ", G) {
            for (ce = 0; ce < O.length; ce++)
              oe = O[ce], G.indexOf(" " + oe + " ") < 0 && (G += oe + " ");
            de = un(G), Z !== de && this.setAttribute("class", de);
          }
        }) : this);
      },
      removeClass: function(b) {
        var O, G, Z, oe, ce, de;
        return ne(b) ? this.each(function(Pe) {
          j(this).removeClass(b.call(this, Pe, Ji(this)));
        }) : arguments.length ? (O = cn(b), O.length ? this.each(function() {
          if (Z = Ji(this), G = this.nodeType === 1 && " " + un(Z) + " ", G) {
            for (ce = 0; ce < O.length; ce++)
              for (oe = O[ce]; G.indexOf(" " + oe + " ") > -1; )
                G = G.replace(" " + oe + " ", " ");
            de = un(G), Z !== de && this.setAttribute("class", de);
          }
        }) : this) : this.attr("class", "");
      },
      toggleClass: function(b, O) {
        var G, Z, oe, ce, de = typeof b, Pe = de === "string" || Array.isArray(b);
        return ne(b) ? this.each(function(Oe) {
          j(this).toggleClass(
            b.call(this, Oe, Ji(this), O),
            O
          );
        }) : typeof O == "boolean" && Pe ? O ? this.addClass(b) : this.removeClass(b) : (G = cn(b), this.each(function() {
          if (Pe)
            for (ce = j(this), oe = 0; oe < G.length; oe++)
              Z = G[oe], ce.hasClass(Z) ? ce.removeClass(Z) : ce.addClass(Z);
          else
            (b === void 0 || de === "boolean") && (Z = Ji(this), Z && nt.set(this, "__className__", Z), this.setAttribute && this.setAttribute(
              "class",
              Z || b === !1 ? "" : nt.get(this, "__className__") || ""
            ));
        }));
      },
      hasClass: function(b) {
        var O, G, Z = 0;
        for (O = " " + b + " "; G = this[Z++]; )
          if (G.nodeType === 1 && (" " + un(Ji(G)) + " ").indexOf(O) > -1)
            return !0;
        return !1;
      }
    });
    var qi = /\r/g;
    j.fn.extend({
      val: function(b) {
        var O, G, Z, oe = this[0];
        return arguments.length ? (Z = ne(b), this.each(function(ce) {
          var de;
          this.nodeType === 1 && (Z ? de = b.call(this, ce, j(this).val()) : de = b, de == null ? de = "" : typeof de == "number" ? de += "" : Array.isArray(de) && (de = j.map(de, function(Pe) {
            return Pe == null ? "" : Pe + "";
          })), O = j.valHooks[this.type] || j.valHooks[this.nodeName.toLowerCase()], (!O || !("set" in O) || O.set(this, de, "value") === void 0) && (this.value = de));
        })) : oe ? (O = j.valHooks[oe.type] || j.valHooks[oe.nodeName.toLowerCase()], O && "get" in O && (G = O.get(oe, "value")) !== void 0 ? G : (G = oe.value, typeof G == "string" ? G.replace(qi, "") : G ?? "")) : void 0;
      }
    }), j.extend({
      valHooks: {
        option: {
          get: function(b) {
            var O = j.find.attr(b, "value");
            return O ?? // Support: IE <=10 - 11 only
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            un(j.text(b));
          }
        },
        select: {
          get: function(b) {
            var O, G, Z, oe = b.options, ce = b.selectedIndex, de = b.type === "select-one", Pe = de ? null : [], Oe = de ? ce + 1 : oe.length;
            for (ce < 0 ? Z = Oe : Z = de ? ce : 0; Z < Oe; Z++)
              if (G = oe[Z], (G.selected || Z === ce) && // Don't return options that are disabled or in a disabled optgroup
              !G.disabled && (!G.parentNode.disabled || !Ze(G.parentNode, "optgroup"))) {
                if (O = j(G).val(), de)
                  return O;
                Pe.push(O);
              }
            return Pe;
          },
          set: function(b, O) {
            for (var G, Z, oe = b.options, ce = j.makeArray(O), de = oe.length; de--; )
              Z = oe[de], (Z.selected = j.inArray(j.valHooks.option.get(Z), ce) > -1) && (G = !0);
            return G || (b.selectedIndex = -1), ce;
          }
        }
      }
    }), j.each(["radio", "checkbox"], function() {
      j.valHooks[this] = {
        set: function(b, O) {
          if (Array.isArray(O))
            return b.checked = j.inArray(j(b).val(), O) > -1;
        }
      }, he.checkOn || (j.valHooks[this].get = function(b) {
        return b.getAttribute("value") === null ? "on" : b.value;
      });
    });
    var Di = e.location, d = { guid: Date.now() }, N = /\?/;
    j.parseXML = function(b) {
      var O, G;
      if (!b || typeof b != "string")
        return null;
      try {
        O = new e.DOMParser().parseFromString(b, "text/xml");
      } catch {
      }
      return G = O && O.getElementsByTagName("parsererror")[0], (!O || G) && j.error("Invalid XML: " + (G ? j.map(G.childNodes, function(Z) {
        return Z.textContent;
      }).join(`
`) : b)), O;
    };
    var re = /^(?:focusinfocus|focusoutblur)$/, pe = function(b) {
      b.stopPropagation();
    };
    j.extend(j.event, {
      trigger: function(b, O, G, Z) {
        var oe, ce, de, Pe, Oe, Ue, rt, lt, Ke = [G || se], xt = Y.call(b, "type") ? b.type : b, It = Y.call(b, "namespace") ? b.namespace.split(".") : [];
        if (ce = lt = de = G = G || se, !(G.nodeType === 3 || G.nodeType === 8) && !re.test(xt + j.event.triggered) && (xt.indexOf(".") > -1 && (It = xt.split("."), xt = It.shift(), It.sort()), Oe = xt.indexOf(":") < 0 && "on" + xt, b = b[j.expando] ? b : new j.Event(xt, typeof b == "object" && b), b.isTrigger = Z ? 2 : 3, b.namespace = It.join("."), b.rnamespace = b.namespace ? new RegExp("(^|\\.)" + It.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = G), O = O == null ? [b] : j.makeArray(O, [b]), rt = j.event.special[xt] || {}, !(!Z && rt.trigger && rt.trigger.apply(G, O) === !1))) {
          if (!Z && !rt.noBubble && !ye(G)) {
            for (Pe = rt.delegateType || xt, re.test(Pe + xt) || (ce = ce.parentNode); ce; ce = ce.parentNode)
              Ke.push(ce), de = ce;
            de === (G.ownerDocument || se) && Ke.push(de.defaultView || de.parentWindow || e);
          }
          for (oe = 0; (ce = Ke[oe++]) && !b.isPropagationStopped(); )
            lt = ce, b.type = oe > 1 ? Pe : rt.bindType || xt, Ue = (nt.get(ce, "events") || /* @__PURE__ */ Object.create(null))[b.type] && nt.get(ce, "handle"), Ue && Ue.apply(ce, O), Ue = Oe && ce[Oe], Ue && Ue.apply && Vt(ce) && (b.result = Ue.apply(ce, O), b.result === !1 && b.preventDefault());
          return b.type = xt, !Z && !b.isDefaultPrevented() && (!rt._default || rt._default.apply(Ke.pop(), O) === !1) && Vt(G) && Oe && ne(G[xt]) && !ye(G) && (de = G[Oe], de && (G[Oe] = null), j.event.triggered = xt, b.isPropagationStopped() && lt.addEventListener(xt, pe), G[xt](), b.isPropagationStopped() && lt.removeEventListener(xt, pe), j.event.triggered = void 0, de && (G[Oe] = de)), b.result;
        }
      },
      // Piggyback on a donor event to simulate a different one
      // Used only for `focus(in | out)` events
      simulate: function(b, O, G) {
        var Z = j.extend(
          new j.Event(),
          G,
          {
            type: b,
            isSimulated: !0
          }
        );
        j.event.trigger(Z, null, O);
      }
    }), j.fn.extend({
      trigger: function(b, O) {
        return this.each(function() {
          j.event.trigger(b, O, this);
        });
      },
      triggerHandler: function(b, O) {
        var G = this[0];
        if (G)
          return j.event.trigger(b, O, G, !0);
      }
    });
    var Le = /\[\]$/, je = /\r?\n/g, Qe = /^(?:submit|button|image|reset|file)$/i, vt = /^(?:input|select|textarea|keygen)/i;
    function Lt(b, O, G, Z) {
      var oe;
      if (Array.isArray(O))
        j.each(O, function(ce, de) {
          G || Le.test(b) ? Z(b, de) : Lt(
            b + "[" + (typeof de == "object" && de != null ? ce : "") + "]",
            de,
            G,
            Z
          );
        });
      else if (!G && xe(O) === "object")
        for (oe in O)
          Lt(b + "[" + oe + "]", O[oe], G, Z);
      else
        Z(b, O);
    }
    j.param = function(b, O) {
      var G, Z = [], oe = function(ce, de) {
        var Pe = ne(de) ? de() : de;
        Z[Z.length] = encodeURIComponent(ce) + "=" + encodeURIComponent(Pe ?? "");
      };
      if (b == null)
        return "";
      if (Array.isArray(b) || b.jquery && !j.isPlainObject(b))
        j.each(b, function() {
          oe(this.name, this.value);
        });
      else
        for (G in b)
          Lt(G, b[G], O, oe);
      return Z.join("&");
    }, j.fn.extend({
      serialize: function() {
        return j.param(this.serializeArray());
      },
      serializeArray: function() {
        return this.map(function() {
          var b = j.prop(this, "elements");
          return b ? j.makeArray(b) : this;
        }).filter(function() {
          var b = this.type;
          return this.name && !j(this).is(":disabled") && vt.test(this.nodeName) && !Qe.test(b) && (this.checked || !D.test(b));
        }).map(function(b, O) {
          var G = j(this).val();
          return G == null ? null : Array.isArray(G) ? j.map(G, function(Z) {
            return { name: O.name, value: Z.replace(je, `\r
`) };
          }) : { name: O.name, value: G.replace(je, `\r
`) };
        }).get();
      }
    });
    var $t = /%20/g, ii = /#.*$/, Gi = /([?&])_=[^&]*/, ls = /^(.*?):[ \t]*([^\r\n]*)$/mg, As = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, ms = /^(?:GET|HEAD)$/, zs = /^\/\//, Si = {}, bi = {}, kr = "*/".concat("*"), yr = se.createElement("a");
    yr.href = Di.href;
    function or(b) {
      return function(O, G) {
        typeof O != "string" && (G = O, O = "*");
        var Z, oe = 0, ce = O.toLowerCase().match(Dt) || [];
        if (ne(G))
          for (; Z = ce[oe++]; )
            Z[0] === "+" ? (Z = Z.slice(1) || "*", (b[Z] = b[Z] || []).unshift(G)) : (b[Z] = b[Z] || []).push(G);
      };
    }
    function es(b, O, G, Z) {
      var oe = {}, ce = b === bi;
      function de(Pe) {
        var Oe;
        return oe[Pe] = !0, j.each(b[Pe] || [], function(Ue, rt) {
          var lt = rt(O, G, Z);
          if (typeof lt == "string" && !ce && !oe[lt])
            return O.dataTypes.unshift(lt), de(lt), !1;
          if (ce)
            return !(Oe = lt);
        }), Oe;
      }
      return de(O.dataTypes[0]) || !oe["*"] && de("*");
    }
    function br(b, O) {
      var G, Z, oe = j.ajaxSettings.flatOptions || {};
      for (G in O)
        O[G] !== void 0 && ((oe[G] ? b : Z || (Z = {}))[G] = O[G]);
      return Z && j.extend(!0, b, Z), b;
    }
    function Kr(b, O, G) {
      for (var Z, oe, ce, de, Pe = b.contents, Oe = b.dataTypes; Oe[0] === "*"; )
        Oe.shift(), Z === void 0 && (Z = b.mimeType || O.getResponseHeader("Content-Type"));
      if (Z) {
        for (oe in Pe)
          if (Pe[oe] && Pe[oe].test(Z)) {
            Oe.unshift(oe);
            break;
          }
      }
      if (Oe[0] in G)
        ce = Oe[0];
      else {
        for (oe in G) {
          if (!Oe[0] || b.converters[oe + " " + Oe[0]]) {
            ce = oe;
            break;
          }
          de || (de = oe);
        }
        ce = ce || de;
      }
      if (ce)
        return ce !== Oe[0] && Oe.unshift(ce), G[ce];
    }
    function lr(b, O, G, Z) {
      var oe, ce, de, Pe, Oe, Ue = {}, rt = b.dataTypes.slice();
      if (rt[1])
        for (de in b.converters)
          Ue[de.toLowerCase()] = b.converters[de];
      for (ce = rt.shift(); ce; )
        if (b.responseFields[ce] && (G[b.responseFields[ce]] = O), !Oe && Z && b.dataFilter && (O = b.dataFilter(O, b.dataType)), Oe = ce, ce = rt.shift(), ce) {
          if (ce === "*")
            ce = Oe;
          else if (Oe !== "*" && Oe !== ce) {
            if (de = Ue[Oe + " " + ce] || Ue["* " + ce], !de) {
              for (oe in Ue)
                if (Pe = oe.split(" "), Pe[1] === ce && (de = Ue[Oe + " " + Pe[0]] || Ue["* " + Pe[0]], de)) {
                  de === !0 ? de = Ue[oe] : Ue[oe] !== !0 && (ce = Pe[0], rt.unshift(Pe[1]));
                  break;
                }
            }
            if (de !== !0)
              if (de && b.throws)
                O = de(O);
              else
                try {
                  O = de(O);
                } catch (lt) {
                  return {
                    state: "parsererror",
                    error: de ? lt : "No conversion from " + Oe + " to " + ce
                  };
                }
          }
        }
      return { state: "success", data: O };
    }
    j.extend({
      // Counter for holding the number of active queries
      active: 0,
      // Last-Modified header cache for next request
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Di.href,
        type: "GET",
        isLocal: As.test(Di.protocol),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        /*
        timeout: 0,
        data: null,
        dataType: null,
        username: null,
        password: null,
        cache: null,
        throws: false,
        traditional: false,
        headers: {},
        */
        accepts: {
          "*": kr,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        // Data converters
        // Keys separate source (or catchall "*") and destination types with a single space
        converters: {
          // Convert anything to text
          "* text": String,
          // Text to html (true = no transformation)
          "text html": !0,
          // Evaluate text as a json expression
          "text json": JSON.parse,
          // Parse text as xml
          "text xml": j.parseXML
        },
        // For options that shouldn't be deep extended:
        // you can add your own custom options here if
        // and when you create one that shouldn't be
        // deep extended (see ajaxExtend)
        flatOptions: {
          url: !0,
          context: !0
        }
      },
      // Creates a full fledged settings object into target
      // with both ajaxSettings and settings fields.
      // If target is omitted, writes into ajaxSettings.
      ajaxSetup: function(b, O) {
        return O ? (
          // Building a settings object
          br(br(b, j.ajaxSettings), O)
        ) : (
          // Extending ajaxSettings
          br(j.ajaxSettings, b)
        );
      },
      ajaxPrefilter: or(Si),
      ajaxTransport: or(bi),
      // Main method
      ajax: function(b, O) {
        typeof b == "object" && (O = b, b = void 0), O = O || {};
        var G, Z, oe, ce, de, Pe, Oe, Ue, rt, lt, Ke = j.ajaxSetup({}, O), xt = Ke.context || Ke, It = Ke.context && (xt.nodeType || xt.jquery) ? j(xt) : j.event, ai = j.Deferred(), si = j.Callbacks("once memory"), fn = Ke.statusCode || {}, Qi = {}, Zi = {}, Qt = "canceled", di = {
          readyState: 0,
          // Builds headers hashtable if needed
          getResponseHeader: function(mi) {
            var Oi;
            if (Oe) {
              if (!ce)
                for (ce = {}; Oi = ls.exec(oe); )
                  ce[Oi[1].toLowerCase() + " "] = (ce[Oi[1].toLowerCase() + " "] || []).concat(Oi[2]);
              Oi = ce[mi.toLowerCase() + " "];
            }
            return Oi == null ? null : Oi.join(", ");
          },
          // Raw string
          getAllResponseHeaders: function() {
            return Oe ? oe : null;
          },
          // Caches the header
          setRequestHeader: function(mi, Oi) {
            return Oe == null && (mi = Zi[mi.toLowerCase()] = Zi[mi.toLowerCase()] || mi, Qi[mi] = Oi), this;
          },
          // Overrides response content-type header
          overrideMimeType: function(mi) {
            return Oe == null && (Ke.mimeType = mi), this;
          },
          // Status-dependent callbacks
          statusCode: function(mi) {
            var Oi;
            if (mi)
              if (Oe)
                di.always(mi[di.status]);
              else
                for (Oi in mi)
                  fn[Oi] = [fn[Oi], mi[Oi]];
            return this;
          },
          // Cancel the request
          abort: function(mi) {
            var Oi = mi || Qt;
            return G && G.abort(Oi), yn(0, Oi), this;
          }
        };
        if (ai.promise(di), Ke.url = ((b || Ke.url || Di.href) + "").replace(zs, Di.protocol + "//"), Ke.type = O.method || O.type || Ke.method || Ke.type, Ke.dataTypes = (Ke.dataType || "*").toLowerCase().match(Dt) || [""], Ke.crossDomain == null) {
          Pe = se.createElement("a");
          try {
            Pe.href = Ke.url, Pe.href = Pe.href, Ke.crossDomain = yr.protocol + "//" + yr.host != Pe.protocol + "//" + Pe.host;
          } catch {
            Ke.crossDomain = !0;
          }
        }
        if (Ke.data && Ke.processData && typeof Ke.data != "string" && (Ke.data = j.param(Ke.data, Ke.traditional)), es(Si, Ke, O, di), Oe)
          return di;
        Ue = j.event && Ke.global, Ue && j.active++ === 0 && j.event.trigger("ajaxStart"), Ke.type = Ke.type.toUpperCase(), Ke.hasContent = !ms.test(Ke.type), Z = Ke.url.replace(ii, ""), Ke.hasContent ? Ke.data && Ke.processData && (Ke.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (Ke.data = Ke.data.replace($t, "+")) : (lt = Ke.url.slice(Z.length), Ke.data && (Ke.processData || typeof Ke.data == "string") && (Z += (N.test(Z) ? "&" : "?") + Ke.data, delete Ke.data), Ke.cache === !1 && (Z = Z.replace(Gi, "$1"), lt = (N.test(Z) ? "&" : "?") + "_=" + d.guid++ + lt), Ke.url = Z + lt), Ke.ifModified && (j.lastModified[Z] && di.setRequestHeader("If-Modified-Since", j.lastModified[Z]), j.etag[Z] && di.setRequestHeader("If-None-Match", j.etag[Z])), (Ke.data && Ke.hasContent && Ke.contentType !== !1 || O.contentType) && di.setRequestHeader("Content-Type", Ke.contentType), di.setRequestHeader(
          "Accept",
          Ke.dataTypes[0] && Ke.accepts[Ke.dataTypes[0]] ? Ke.accepts[Ke.dataTypes[0]] + (Ke.dataTypes[0] !== "*" ? ", " + kr + "; q=0.01" : "") : Ke.accepts["*"]
        );
        for (rt in Ke.headers)
          di.setRequestHeader(rt, Ke.headers[rt]);
        if (Ke.beforeSend && (Ke.beforeSend.call(xt, di, Ke) === !1 || Oe))
          return di.abort();
        if (Qt = "abort", si.add(Ke.complete), di.done(Ke.success), di.fail(Ke.error), G = es(bi, Ke, O, di), !G)
          yn(-1, "No Transport");
        else {
          if (di.readyState = 1, Ue && It.trigger("ajaxSend", [di, Ke]), Oe)
            return di;
          Ke.async && Ke.timeout > 0 && (de = e.setTimeout(function() {
            di.abort("timeout");
          }, Ke.timeout));
          try {
            Oe = !1, G.send(Qi, yn);
          } catch (mi) {
            if (Oe)
              throw mi;
            yn(-1, mi);
          }
        }
        function yn(mi, Oi, Qs, ts) {
          var en, hs, En, Et, Vn, bn = Oi;
          Oe || (Oe = !0, de && e.clearTimeout(de), G = void 0, oe = ts || "", di.readyState = mi > 0 ? 4 : 0, en = mi >= 200 && mi < 300 || mi === 304, Qs && (Et = Kr(Ke, di, Qs)), !en && j.inArray("script", Ke.dataTypes) > -1 && j.inArray("json", Ke.dataTypes) < 0 && (Ke.converters["text script"] = function() {
          }), Et = lr(Ke, Et, di, en), en ? (Ke.ifModified && (Vn = di.getResponseHeader("Last-Modified"), Vn && (j.lastModified[Z] = Vn), Vn = di.getResponseHeader("etag"), Vn && (j.etag[Z] = Vn)), mi === 204 || Ke.type === "HEAD" ? bn = "nocontent" : mi === 304 ? bn = "notmodified" : (bn = Et.state, hs = Et.data, En = Et.error, en = !En)) : (En = bn, (mi || !bn) && (bn = "error", mi < 0 && (mi = 0))), di.status = mi, di.statusText = (Oi || bn) + "", en ? ai.resolveWith(xt, [hs, bn, di]) : ai.rejectWith(xt, [di, bn, En]), di.statusCode(fn), fn = void 0, Ue && It.trigger(
            en ? "ajaxSuccess" : "ajaxError",
            [di, Ke, en ? hs : En]
          ), si.fireWith(xt, [di, bn]), Ue && (It.trigger("ajaxComplete", [di, Ke]), --j.active || j.event.trigger("ajaxStop")));
        }
        return di;
      },
      getJSON: function(b, O, G) {
        return j.get(b, O, G, "json");
      },
      getScript: function(b, O) {
        return j.get(b, void 0, O, "script");
      }
    }), j.each(["get", "post"], function(b, O) {
      j[O] = function(G, Z, oe, ce) {
        return ne(Z) && (ce = ce || oe, oe = Z, Z = void 0), j.ajax(j.extend({
          url: G,
          type: O,
          dataType: ce,
          data: Z,
          success: oe
        }, j.isPlainObject(G) && G));
      };
    }), j.ajaxPrefilter(function(b) {
      var O;
      for (O in b.headers)
        O.toLowerCase() === "content-type" && (b.contentType = b.headers[O] || "");
    }), j._evalUrl = function(b, O, G) {
      return j.ajax({
        url: b,
        // Make this explicit, since user can override this through ajaxSetup (trac-11264)
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        // Only evaluate the response if it is successful (gh-4126)
        // dataFilter is not invoked for failure responses, so using it instead
        // of the default converter is kludgy but it works.
        converters: {
          "text script": function() {
          }
        },
        dataFilter: function(Z) {
          j.globalEval(Z, O, G);
        }
      });
    }, j.fn.extend({
      wrapAll: function(b) {
        var O;
        return this[0] && (ne(b) && (b = b.call(this[0])), O = j(b, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && O.insertBefore(this[0]), O.map(function() {
          for (var G = this; G.firstElementChild; )
            G = G.firstElementChild;
          return G;
        }).append(this)), this;
      },
      wrapInner: function(b) {
        return ne(b) ? this.each(function(O) {
          j(this).wrapInner(b.call(this, O));
        }) : this.each(function() {
          var O = j(this), G = O.contents();
          G.length ? G.wrapAll(b) : O.append(b);
        });
      },
      wrap: function(b) {
        var O = ne(b);
        return this.each(function(G) {
          j(this).wrapAll(O ? b.call(this, G) : b);
        });
      },
      unwrap: function(b) {
        return this.parent(b).not("body").each(function() {
          j(this).replaceWith(this.childNodes);
        }), this;
      }
    }), j.expr.pseudos.hidden = function(b) {
      return !j.expr.pseudos.visible(b);
    }, j.expr.pseudos.visible = function(b) {
      return !!(b.offsetWidth || b.offsetHeight || b.getClientRects().length);
    }, j.ajaxSettings.xhr = function() {
      try {
        return new e.XMLHttpRequest();
      } catch {
      }
    };
    var Ts = {
      // File protocol always yields status code 0, assume 200
      0: 200,
      // Support: IE <=9 only
      // trac-1450: sometimes IE returns 1223 when it should be 204
      1223: 204
    }, $i = j.ajaxSettings.xhr();
    he.cors = !!$i && "withCredentials" in $i, he.ajax = $i = !!$i, j.ajaxTransport(function(b) {
      var O, G;
      if (he.cors || $i && !b.crossDomain)
        return {
          send: function(Z, oe) {
            var ce, de = b.xhr();
            if (de.open(
              b.type,
              b.url,
              b.async,
              b.username,
              b.password
            ), b.xhrFields)
              for (ce in b.xhrFields)
                de[ce] = b.xhrFields[ce];
            b.mimeType && de.overrideMimeType && de.overrideMimeType(b.mimeType), !b.crossDomain && !Z["X-Requested-With"] && (Z["X-Requested-With"] = "XMLHttpRequest");
            for (ce in Z)
              de.setRequestHeader(ce, Z[ce]);
            O = function(Pe) {
              return function() {
                O && (O = G = de.onload = de.onerror = de.onabort = de.ontimeout = de.onreadystatechange = null, Pe === "abort" ? de.abort() : Pe === "error" ? typeof de.status != "number" ? oe(0, "error") : oe(
                  // File: protocol always yields status 0; see trac-8605, trac-14207
                  de.status,
                  de.statusText
                ) : oe(
                  Ts[de.status] || de.status,
                  de.statusText,
                  // Support: IE <=9 only
                  // IE9 has no XHR2 but throws on binary (trac-11426)
                  // For XHR2 non-text, let the caller handle it (gh-2498)
                  (de.responseType || "text") !== "text" || typeof de.responseText != "string" ? { binary: de.response } : { text: de.responseText },
                  de.getAllResponseHeaders()
                ));
              };
            }, de.onload = O(), G = de.onerror = de.ontimeout = O("error"), de.onabort !== void 0 ? de.onabort = G : de.onreadystatechange = function() {
              de.readyState === 4 && e.setTimeout(function() {
                O && G();
              });
            }, O = O("abort");
            try {
              de.send(b.hasContent && b.data || null);
            } catch (Pe) {
              if (O)
                throw Pe;
            }
          },
          abort: function() {
            O && O();
          }
        };
    }), j.ajaxPrefilter(function(b) {
      b.crossDomain && (b.contents.script = !1);
    }), j.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /\b(?:java|ecma)script\b/
      },
      converters: {
        "text script": function(b) {
          return j.globalEval(b), b;
        }
      }
    }), j.ajaxPrefilter("script", function(b) {
      b.cache === void 0 && (b.cache = !1), b.crossDomain && (b.type = "GET");
    }), j.ajaxTransport("script", function(b) {
      if (b.crossDomain || b.scriptAttrs) {
        var O, G;
        return {
          send: function(Z, oe) {
            O = j("<script>").attr(b.scriptAttrs || {}).prop({ charset: b.scriptCharset, src: b.url }).on("load error", G = function(ce) {
              O.remove(), G = null, ce && oe(ce.type === "error" ? 404 : 200, ce.type);
            }), se.head.appendChild(O[0]);
          },
          abort: function() {
            G && G();
          }
        };
      }
    });
    var hr = [], Zn = /(=)\?(?=&|$)|\?\?/;
    j.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function() {
        var b = hr.pop() || j.expando + "_" + d.guid++;
        return this[b] = !0, b;
      }
    }), j.ajaxPrefilter("json jsonp", function(b, O, G) {
      var Z, oe, ce, de = b.jsonp !== !1 && (Zn.test(b.url) ? "url" : typeof b.data == "string" && (b.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && Zn.test(b.data) && "data");
      if (de || b.dataTypes[0] === "jsonp")
        return Z = b.jsonpCallback = ne(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, de ? b[de] = b[de].replace(Zn, "$1" + Z) : b.jsonp !== !1 && (b.url += (N.test(b.url) ? "&" : "?") + b.jsonp + "=" + Z), b.converters["script json"] = function() {
          return ce || j.error(Z + " was not called"), ce[0];
        }, b.dataTypes[0] = "json", oe = e[Z], e[Z] = function() {
          ce = arguments;
        }, G.always(function() {
          oe === void 0 ? j(e).removeProp(Z) : e[Z] = oe, b[Z] && (b.jsonpCallback = O.jsonpCallback, hr.push(Z)), ce && ne(oe) && oe(ce[0]), ce = oe = void 0;
        }), "script";
    }), he.createHTMLDocument = function() {
      var b = se.implementation.createHTMLDocument("").body;
      return b.innerHTML = "<form></form><form></form>", b.childNodes.length === 2;
    }(), j.parseHTML = function(b, O, G) {
      if (typeof b != "string")
        return [];
      typeof O == "boolean" && (G = O, O = !1);
      var Z, oe, ce;
      return O || (he.createHTMLDocument ? (O = se.implementation.createHTMLDocument(""), Z = O.createElement("base"), Z.href = se.location.href, O.head.appendChild(Z)) : O = se), oe = Tn.exec(b), ce = !G && [], oe ? [O.createElement(oe[1])] : (oe = F([b], O, ce), ce && ce.length && j(ce).remove(), j.merge([], oe.childNodes));
    }, j.fn.load = function(b, O, G) {
      var Z, oe, ce, de = this, Pe = b.indexOf(" ");
      return Pe > -1 && (Z = un(b.slice(Pe)), b = b.slice(0, Pe)), ne(O) ? (G = O, O = void 0) : O && typeof O == "object" && (oe = "POST"), de.length > 0 && j.ajax({
        url: b,
        // If "type" variable is undefined, then "GET" method will be used.
        // Make value of this field explicit since
        // user can override it through ajaxSetup method
        type: oe || "GET",
        dataType: "html",
        data: O
      }).done(function(Oe) {
        ce = arguments, de.html(Z ? (
          // If a selector was specified, locate the right elements in a dummy div
          // Exclude scripts to avoid IE 'Permission Denied' errors
          j("<div>").append(j.parseHTML(Oe)).find(Z)
        ) : (
          // Otherwise use the full result
          Oe
        ));
      }).always(G && function(Oe, Ue) {
        de.each(function() {
          G.apply(this, ce || [Oe.responseText, Ue, Oe]);
        });
      }), this;
    }, j.expr.pseudos.animated = function(b) {
      return j.grep(j.timers, function(O) {
        return b === O.elem;
      }).length;
    }, j.offset = {
      setOffset: function(b, O, G) {
        var Z, oe, ce, de, Pe, Oe, Ue, rt = j.css(b, "position"), lt = j(b), Ke = {};
        rt === "static" && (b.style.position = "relative"), Pe = lt.offset(), ce = j.css(b, "top"), Oe = j.css(b, "left"), Ue = (rt === "absolute" || rt === "fixed") && (ce + Oe).indexOf("auto") > -1, Ue ? (Z = lt.position(), de = Z.top, oe = Z.left) : (de = parseFloat(ce) || 0, oe = parseFloat(Oe) || 0), ne(O) && (O = O.call(b, G, j.extend({}, Pe))), O.top != null && (Ke.top = O.top - Pe.top + de), O.left != null && (Ke.left = O.left - Pe.left + oe), "using" in O ? O.using.call(b, Ke) : lt.css(Ke);
      }
    }, j.fn.extend({
      // offset() relates an element's border box to the document origin
      offset: function(b) {
        if (arguments.length)
          return b === void 0 ? this : this.each(function(oe) {
            j.offset.setOffset(this, b, oe);
          });
        var O, G, Z = this[0];
        if (Z)
          return Z.getClientRects().length ? (O = Z.getBoundingClientRect(), G = Z.ownerDocument.defaultView, {
            top: O.top + G.pageYOffset,
            left: O.left + G.pageXOffset
          }) : { top: 0, left: 0 };
      },
      // position() relates an element's margin box to its offset parent's padding box
      // This corresponds to the behavior of CSS absolute positioning
      position: function() {
        if (this[0]) {
          var b, O, G, Z = this[0], oe = { top: 0, left: 0 };
          if (j.css(Z, "position") === "fixed")
            O = Z.getBoundingClientRect();
          else {
            for (O = this.offset(), G = Z.ownerDocument, b = Z.offsetParent || G.documentElement; b && (b === G.body || b === G.documentElement) && j.css(b, "position") === "static"; )
              b = b.parentNode;
            b && b !== Z && b.nodeType === 1 && (oe = j(b).offset(), oe.top += j.css(b, "borderTopWidth", !0), oe.left += j.css(b, "borderLeftWidth", !0));
          }
          return {
            top: O.top - oe.top - j.css(Z, "marginTop", !0),
            left: O.left - oe.left - j.css(Z, "marginLeft", !0)
          };
        }
      },
      // This method will return documentElement in the following cases:
      // 1) For the element inside the iframe without offsetParent, this method will return
      //    documentElement of the parent window
      // 2) For the hidden or detached element
      // 3) For body or html element, i.e. in case of the html node - it will return itself
      //
      // but those exceptions were never presented as a real life use-cases
      // and might be considered as more preferable results.
      //
      // This logic, however, is not guaranteed and can change at any point in the future
      offsetParent: function() {
        return this.map(function() {
          for (var b = this.offsetParent; b && j.css(b, "position") === "static"; )
            b = b.offsetParent;
          return b || y;
        });
      }
    }), j.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(b, O) {
      var G = O === "pageYOffset";
      j.fn[b] = function(Z) {
        return Bn(this, function(oe, ce, de) {
          var Pe;
          if (ye(oe) ? Pe = oe : oe.nodeType === 9 && (Pe = oe.defaultView), de === void 0)
            return Pe ? Pe[O] : oe[ce];
          Pe ? Pe.scrollTo(
            G ? Pe.pageXOffset : de,
            G ? de : Pe.pageYOffset
          ) : oe[ce] = de;
        }, b, Z, arguments.length);
      };
    }), j.each(["top", "left"], function(b, O) {
      j.cssHooks[O] = yt(
        he.pixelPosition,
        function(G, Z) {
          if (Z)
            return Z = ut(G, O), Ie.test(Z) ? j(G).position()[O] + "px" : Z;
        }
      );
    }), j.each({ Height: "height", Width: "width" }, function(b, O) {
      j.each({
        padding: "inner" + b,
        content: O,
        "": "outer" + b
      }, function(G, Z) {
        j.fn[Z] = function(oe, ce) {
          var de = arguments.length && (G || typeof oe != "boolean"), Pe = G || (oe === !0 || ce === !0 ? "margin" : "border");
          return Bn(this, function(Oe, Ue, rt) {
            var lt;
            return ye(Oe) ? Z.indexOf("outer") === 0 ? Oe["inner" + b] : Oe.document.documentElement["client" + b] : Oe.nodeType === 9 ? (lt = Oe.documentElement, Math.max(
              Oe.body["scroll" + b],
              lt["scroll" + b],
              Oe.body["offset" + b],
              lt["offset" + b],
              lt["client" + b]
            )) : rt === void 0 ? (
              // Get width or height on the element, requesting but not forcing parseFloat
              j.css(Oe, Ue, Pe)
            ) : (
              // Set width or height on the element
              j.style(Oe, Ue, rt, Pe)
            );
          }, O, de ? oe : void 0, de);
        };
      });
    }), j.each([
      "ajaxStart",
      "ajaxStop",
      "ajaxComplete",
      "ajaxError",
      "ajaxSuccess",
      "ajaxSend"
    ], function(b, O) {
      j.fn[O] = function(G) {
        return this.on(O, G);
      };
    }), j.fn.extend({
      bind: function(b, O, G) {
        return this.on(b, null, O, G);
      },
      unbind: function(b, O) {
        return this.off(b, null, O);
      },
      delegate: function(b, O, G, Z) {
        return this.on(O, b, G, Z);
      },
      undelegate: function(b, O, G) {
        return arguments.length === 1 ? this.off(b, "**") : this.off(O, b || "**", G);
      },
      hover: function(b, O) {
        return this.on("mouseenter", b).on("mouseleave", O || b);
      }
    }), j.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
      function(b, O) {
        j.fn[O] = function(G, Z) {
          return arguments.length > 0 ? this.on(O, null, G, Z) : this.trigger(O);
        };
      }
    );
    var Pr = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    j.proxy = function(b, O) {
      var G, Z, oe;
      if (typeof O == "string" && (G = b[O], O = b, b = G), !!ne(b))
        return Z = a.call(arguments, 2), oe = function() {
          return b.apply(O || this, Z.concat(a.call(arguments)));
        }, oe.guid = b.guid = b.guid || j.guid++, oe;
    }, j.holdReady = function(b) {
      b ? j.readyWait++ : j.ready(!0);
    }, j.isArray = Array.isArray, j.parseJSON = JSON.parse, j.nodeName = Ze, j.isFunction = ne, j.isWindow = ye, j.camelCase = ki, j.type = xe, j.now = Date.now, j.isNumeric = function(b) {
      var O = j.type(b);
      return (O === "number" || O === "string") && // parseFloat NaNs numeric-cast false positives ("")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      !isNaN(b - parseFloat(b));
    }, j.trim = function(b) {
      return b == null ? "" : (b + "").replace(Pr, "$1");
    };
    var $s = e.jQuery, Un = e.$;
    return j.noConflict = function(b) {
      return e.$ === j && (e.$ = Un), b && e.jQuery === j && (e.jQuery = $s), j;
    }, typeof t > "u" && (e.jQuery = e.$ = j), j;
  });
})(Pd);
var Tx = Pd.exports;
const ua = /* @__PURE__ */ kd(Tx);
function Fw() {
  const v = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, e = window.devicePixelRatio || 1, t = {
    width: window.screen.width * e,
    height: window.screen.height * e
  };
  return !!(v && t.width === 1125 && t.height === 2436);
}
function Uw() {
  return /android/i.test(navigator.userAgent);
}
function Vw() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}
function Lx() {
  const v = navigator.userAgent || navigator.vendor || self.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    v
  ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    v.substr(0, 4)
  );
}
function Hw() {
  const v = document.compatMode === "CSS1Compat";
  return {
    l: window.pageXOffset || (v ? document.documentElement.scrollLeft : document.body.scrollLeft),
    t: window.pageYOffset || (v ? document.documentElement.scrollTop : document.body.scrollTop),
    w: window.innerWidth || (v ? document.documentElement.clientWidth : document.body.clientWidth),
    h: window.innerHeight || (v ? document.documentElement.clientHeight : document.body.clientHeight)
  };
}
function Yw(v, e, t) {
  var s = (v * 299 + e * 587 + t * 114) / 1e3;
  return s >= 128 ? "black" : "white";
}
function Gw(v) {
  var e = parseInt(v.substr(0, 2), 16), t = parseInt(v.substr(2, 2), 16), s = parseInt(v.substr(4, 2), 16), o = (e * 299 + t * 587 + s * 114) / 1e3;
  return o >= 128 ? "black" : "white";
}
function aa(v, e) {
  return typeof e > "u" || typeof e === null ? !1 : function(s, o) {
    let a = o !== o, c;
    return !a && typeof Array.prototype.indexOf == "function" ? (c = Array.prototype.indexOf, c.call(s, o) > -1) : (c = function(g, w) {
      var T = -1, H = -1;
      for (T = 0; T < g.length; T++) {
        var Y = g[T];
        if (a && Y !== Y || Y === w) {
          H = T;
          break;
        }
      }
      return H;
    }, c(s, o) > -1);
  }(v, e);
}
function Bx(v) {
  v = String(v).replace(/[^0-9a-f]/gi, ""), v.length < 6 && (v = v[0] + v[0] + v[1] + v[1] + v[2] + v[2]);
  var e = parseInt(v.substr(0 * 2, 2), 16), t = parseInt(v.substr(1 * 2, 2), 16), s = parseInt(v.substr(2 * 2, 2), 16), o = Math.sqrt(e * e * 0.241 + t * t * 0.691 + s * s * 0.068);
  return o;
}
function Ex(v) {
  return Bx(v) < 130;
}
function Ox(v, e = 0) {
  v = String(v).replace(/[^0-9a-f]/gi, ""), v.length < 6 && (v = v[0] + v[0] + v[1] + v[1] + v[2] + v[2]), e = e || 0;
  var t = "#", s, o;
  for (o = 0; o < 3; o++)
    s = parseInt(v.substr(o * 2, 2), 16), s = Math.round(Math.min(Math.max(0, s + s * e), 255)).toString(16), t += ("00" + s).substr(s.length);
  return t;
}
function Ix(v, e, t, s) {
  var o = new Image(), a = ua("<canvas>"), c = a[0], g = c.getContext("2d");
  o.crossOrigin = "anonymous", o.onload = function() {
    if (a.attr({ width: o.width, height: o.height }), g = c.getContext("2d"), g) {
      g.drawImage(o, 0, 0);
      let w = Nd(c, o.width, o.height, e, t);
      s && s(w);
    } else
      alert("Get a real browser!");
  }, o.src = v;
}
async function zh(v) {
  return new Promise((e, t) => {
    const s = new Image(), o = ua("<canvas>");
    let a = o[0], c = a.getContext("2d");
    s.crossOrigin = "anonymous", s.onload = function() {
      if (o.attr({ width: s.width, height: s.height }), c = a.getContext("2d"), c) {
        c.drawImage(s, 0, 0);
        let g = kx(a);
        e(g);
      } else
        t(new Error("HTML5 Canvas not supported"));
    }, s.src = v;
  });
}
function kx(v) {
  const e = v.getContext("2d");
  if (!e)
    return null;
  const t = v.width, s = v.height, a = e.getImageData(0, 0, v.width, v.height).data, c = (ye, se) => a[(t * se + ye) * 4 + 3], g = (ye) => ye < 10, w = (ye) => {
    const se = ye ? 1 : -1;
    for (var _e = ye ? 0 : s - 1; ye ? _e < s : _e > -1; _e += se)
      for (var ue = 0; ue < t; ue++)
        if (!g(c(ue, _e)))
          return _e;
    return null;
  }, T = (ye) => {
    const se = ye ? 1 : -1;
    for (var _e = ye ? 0 : t - 1; ye ? _e < t : _e > -1; _e += se)
      for (var ue = 0; ue < s; ue++)
        if (!g(c(_e, ue)))
          return _e;
    return null;
  }, H = w(!0), Y = w(!1), ee = T(!0), z = T(!1);
  if (H != null && Y != null && ee != null && z != null) {
    const ye = z - ee + 1, se = Y - H + 1, ue = ua("<canvas>").attr({ width: ye, height: se })[0];
    var he = ue.getContext("2d");
    if (!he)
      return null;
    he.drawImage(v, ee, H, ye, se, 0, 0, ye, se), he.getImageData(0, 0, ue.width, ue.height);
    var ne = ue.toDataURL();
    return ne;
  } else
    return null;
}
async function jw(v, e, t) {
  return new Promise((s, o) => {
    const a = new Image(), c = ua("<canvas>");
    let g = c[0], w = g.getContext("2d");
    a.crossOrigin = "anonymous", a.onload = function() {
      if (c.attr({ width: a.width, height: a.height }), w = g.getContext("2d"), w) {
        w.drawImage(a, 0, 0);
        let T = Nd(g, a.width, a.height, e, t);
        s(T);
      } else
        o(new Error("HTML5 Canvas not supported"));
    }, a.src = v;
  });
}
function Nd(v, e, t, s, o) {
  const a = v.getContext("2d");
  if (!a)
    return null;
  const g = a.getImageData(0, 0, v.width, v.height).data, w = (_e, ue) => g[(e * ue + _e) * 4 + 3], T = (_e) => _e === 0, H = (_e) => {
    const ue = _e ? 1 : -1;
    for (var xe = _e ? 0 : t - 1; _e ? xe < t : xe > -1; xe += ue)
      for (var Ee = 0; Ee < e; Ee++)
        if (!T(w(Ee, xe)))
          return xe;
    return null;
  }, Y = (_e) => {
    const ue = _e ? 1 : -1;
    for (var xe = _e ? 0 : e - 1; _e ? xe < e : xe > -1; xe += ue)
      for (var Ee = 0; Ee < t; Ee++)
        if (!T(w(xe, Ee)))
          return xe;
    return null;
  }, ee = H(!0), z = H(!1), he = Y(!0), ne = Y(!1);
  if (ee != null && z != null && he != null && ne != null) {
    const _e = ne - he, ue = z - ee, xe = s, Ee = o, K = xe / _e, j = Ee / ue;
    let ht = _e * K, Ze = ue * K;
    Ze > Ee && (ht = _e * j, Ze = ue * j);
    const Pt = ua("<canvas>").attr({ width: xe, height: Ee })[0];
    var ye = Pt.getContext("2d");
    if (!ye)
      return null;
    ye.drawImage(
      v,
      he,
      ee,
      _e,
      ue,
      (xe - ht) / 2,
      (Ee - Ze) / 2,
      ht,
      Ze
    ), ye.getImageData(0, 0, Pt.width, Pt.height);
    var se = Pt.toDataURL();
    return se;
  } else
    return null;
}
async function Px(v, e, t, s) {
  return new Promise((o) => {
    const a = new Image();
    a.crossOrigin = "anonymous", a.onload = function() {
      let g = ua("<canvas>")[0], w = g.getContext("2d");
      if (w) {
        g.width = e, g.height = t;
        const T = Math.min(e / a.width, t / a.height), H = a.width * T, Y = a.height * T;
        w.drawImage(
          a,
          0,
          0,
          a.width,
          a.height,
          (e - H + s) / 2,
          (t - Y + s) / 2,
          H - s,
          Y - s
        );
        const ee = g.toDataURL();
        o(ee);
      }
    }, a.src = v;
  });
}
function Ww(v, e, t) {
  var s = ua("<canvas>");
  s.attr({ width: e, height: t });
  var o = s[0], a = o.getContext("2d");
  if (a) {
    a.fillStyle = v, a.fillRect(0, 0, e, t);
    var c = o.toDataURL();
    return c;
  } else
    return null;
}
function qw(v, e) {
  return v ? v.match(new RegExp(".[^]{1," + e + "}", "g")) : null;
}
function Zw(v) {
  let e = 0, t, s;
  if (v.length === 0)
    return e;
  for (t = 0; t < v.length; t++)
    s = v.charCodeAt(t), e = (e << 5) - e + s, e |= 0;
  return e;
}
function Xw(v) {
  var e = document.createElement("a");
  return e.href = v, e.href;
}
function Rd(v) {
  for (var e = atob(v.split(",")[1]), t = v.split(",")[0].split(":")[1].split(";")[0], s = new ArrayBuffer(e.length), o = new Uint8Array(s), a = 0; a < e.length; a++)
    o[a] = e.charCodeAt(a);
  var c = new Blob([s], { type: t });
  return c;
}
function Kw(v, e) {
  if (typeof v != "number" && v < 1)
    throw new RangeError("Length must be a positive integer!");
  e === void 0 && (e = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");
  let t = "";
  const s = e.length;
  for (var o = 0; o < v; o++)
    t += e.charAt(Math.floor(Math.random() * s));
  return t;
}
async function Jw(v, e) {
  return new Promise((t) => {
    const s = new Uint8Array(v), o = new Blob([s], { type: e }), c = (window.URL || window.webkitURL).createObjectURL(o), g = new Image();
    g.src = c, g.onload = async () => {
      const w = document.createElement("canvas"), T = w.getContext("2d");
      w.width = g.width, w.height = g.height, T.translate(0, g.height), T.scale(1, -1), T.drawImage(g, 0, 0), w.toBlob((H) => {
        const Y = new FileReader();
        Y.addEventListener("loadend", () => {
          const ee = Y.result;
          t(ee);
        }), Y.readAsArrayBuffer(H);
      }, e);
    };
  });
}
function Jo(v) {
  return v instanceof BABYLON.PBRMaterial;
}
function $w() {
  const v = new URL(window.location.href);
  return new URLSearchParams(v.search);
}
class Nx {
  constructor() {
    this.previewFiles = {};
  }
  downloadFiles() {
    function e(t, s) {
      return t.indexOf(s, t.length - s.length) !== -1;
    }
    for (let t in this.previewFiles) {
      let s = null;
      const o = this.previewFiles[t];
      if (typeof o == "string" ? s = Rd(o) : s = o, s) {
        let a = null;
        if (e(t, ".jpeg") ? a = { type: "image/jpeg" } : e(t, ".png") && (a = { type: "image/png" }), a) {
          let c = document.createElement("a");
          document.body.appendChild(c), c.setAttribute("type", "hidden"), c.download = t, c.href = window.URL.createObjectURL(new Blob([s], a)), c.click();
        }
      }
    }
  }
}
class oo {
  static async getPreviewsAsync(e, t, s, o, a = !0) {
    await e.whenReadyAsync();
    const c = new Rx(e, t, s, o), g = await c.getPreviewsAsync(a);
    return c.dispose(), g;
  }
  static async downloadPreviewsAsync(e, t, s, o) {
    (await oo.getPreviewsAsync(e, t, s, o)).downloadFiles();
  }
}
class Rx {
  constructor(e, t, s, o) {
    this._width = 256, this._height = 256, this._crop = !1, this._materials = [], this._localEngine = null, this._hostingScene = null, this._hostingSceneHelper = null, this._hostingMesh = null, this._scene = e, this._rootUrl = t, this._materialIDs = s, this._options = o || {}, this.setupPreviewSize(), this._options.crop != null && (this._crop = this._options.crop), this.readMaterials();
  }
  dispose() {
    this.disposeHostingScene(), this.disposeLocalEngine();
  }
  getLocalEngine() {
    if (!this._localEngine) {
      const e = document.createElement("canvas");
      e.id = "MaterialPreviewCanvas", e.width = 1024, e.height = 1024, this._localEngine = new BABYLON.Engine(e, !0, { premultipliedAlpha: !1, preserveDrawingBuffer: !0 }), this._localEngine.setSize(this._width, this._height);
    }
    return this._localEngine;
  }
  disposeLocalEngine() {
    this._localEngine && this._localEngine.dispose();
  }
  disposeHostingScene() {
    this._hostingSceneHelper && (this._hostingSceneHelper.dispose(), this._hostingSceneHelper = null), this._hostingScene && (this._hostingScene.dispose(), this._hostingScene = null);
  }
  setupPreviewSize() {
    let e = this._options;
    e.width != null && e.height == null ? (this._width = e.width, this._height = e.width) : e.width == null && e.height != null ? (this._width = e.height, this._height = e.height) : e.width != null && e.height != null && (this._width = e.width, this._height = e.height);
  }
  readMaterials() {
    this._materialIDs.forEach((e) => {
      const t = this._scene.getMaterialByID(e);
      t && this._materials.push(t);
    });
  }
  async downloadPreviewsAsync() {
    (await this.getPreviewsAsync()).downloadFiles();
  }
  async getPreviewsAsync(e = !0) {
    const t = this.getLocalEngine();
    this._hostingScene = new BABYLON.Scene(t), this._hostingSceneHelper = new ni(this._hostingScene), this._hostingSceneHelper.setupCamera();
    const s = this._hostingScene.activeCamera;
    return s && (/firefox/i.test(navigator.userAgent) || new BABYLON.PassPostProcess("scale_pass", 4, s, BABYLON.Texture.BILINEAR_SAMPLINGMODE), new BABYLON.PassPostProcess("scale_pass", 2, s, BABYLON.Texture.BILINEAR_SAMPLINGMODE), new BABYLON.PassPostProcess("scale_pass", 1, s, BABYLON.Texture.BILINEAR_SAMPLINGMODE)), new Promise((o) => {
      const a = new BABYLON.CubeTexture(Wt.Environment.EnvironmentTextureCDNUrl, this._hostingScene, null, !1, null, async () => {
        if (!this._hostingScene || !this._hostingSceneHelper)
          return;
        this._hostingScene.environmentTexture = a, this._hostingSceneHelper.setupLights(), this._hostingMesh = this._hostingSceneHelper.createSphere(null), this._hostingSceneHelper.adjustCamera(void 0, void 0, void 0, !1);
        const c = new Nx();
        for (let g = 0; g < this._materials.length; g++) {
          const w = this._materials[g];
          await this.createMaterialPreviewFileAsync(w, c, e);
        }
        this.disposeHostingScene(), this.disposeLocalEngine(), o(c);
      }, null, void 0, !0, void 0, !0);
    });
  }
  async createMaterialPreviewFileAsync(e, t, s = !0) {
    if (this._hostingScene && this._hostingSceneHelper && this._hostingMesh) {
      const o = e.serialize(), a = BABYLON.Material.Parse(o, this._hostingScene, this._rootUrl);
      if (a) {
        this._hostingMesh.material = a, await ni.whenMeshMaterialIsReady(this._hostingMesh), this._hostingScene.render();
        let c = await this._hostingSceneHelper.takeContentScreenshotAsync(this._width, this._height);
        if (this._crop) {
          const T = await zh(c);
          T && (c = T);
        }
        let g = a.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
        g = this.getNextIncrementalName(g, ".png", t) + ".png", Logger.info("preview: " + g);
        let w = c;
        s && (w = Rd(c)), t.previewFiles[g] = w;
      }
    }
  }
  getNextIncrementalName(e, t, s) {
    let o = e;
    if (e) {
      let w, T = 0;
      for (; s.previewFiles.hasOwnProperty(o + t); ) {
        if (!w) {
          w = e;
          var a = e.lastIndexOf("_");
          if (a > 0) {
            var c = e.substring(a + 1), g = parseInt(c);
            g.toString() === c && (w = e.substring(0, a));
          }
        }
        T++, o = w + "_" + T;
      }
    }
    return o;
  }
}
class Dx {
  constructor(e, t, s, o) {
    this._bias = 50, this._invertR = !1, this._invertG = !1, this._preBlurEnabled = !1, this._preBlur = 3, this._postBlurEnabled = !1, this._postBlur = 3, this._bevel = !0, this._intensity = 0.5, this._activeTextures = [], this._preBlurXTexture = null, this._preBlurYTexture = null, this._normalMapTexture = null, this._postBlurXTexture = null, this._postBlurYTexture = null, this._baseTexture = e, this._size = t, this._scene = o, this.init(s);
  }
  init(e) {
    for (this._bias = e.get("bias"), this._invertR = e.get("invertR"), this._invertG = e.get("invertG"), this._bevel = e.get("bevel"), this._intensity = e.get("intensity"), this._preBlurEnabled = e.get("preBlurEnabled"), this._preBlur = e.get("preBlur"), this._postBlurEnabled = e.get("postBlurEnabled"), this._postBlur = e.get("postBlur"); this._activeTextures.length > 0; )
      this._activeTextures.pop();
    this.updateTextures();
  }
  updateTextures() {
    let e = this.updatePreBlurTexture();
    e = this.updateNormalmapTexture(e), e = this.updatePostBlurTexture(e);
  }
  updatePreBlurTexture() {
    let e = this._baseTexture;
    return this._preBlurEnabled && (this._preBlurXTexture ? this._preBlurXTexture.baseTexture = this._baseTexture : this._preBlurXTexture = new so("preBlurX", this._size, this._scene, this._baseTexture, void 0, !1), this._preBlurXTexture.beginInit(), this._preBlurXTexture.blur = this._preBlur, this._preBlurXTexture.refreshRate = 0, this._preBlurXTexture.endInit(), this._activeTextures.push(this._preBlurXTexture), this._preBlurYTexture ? this._preBlurYTexture.baseTexture = this._preBlurXTexture : this._preBlurYTexture = new ro("preBlurY", this._size, this._scene, this._preBlurXTexture, void 0, !1), this._preBlurYTexture.beginInit(), this._preBlurYTexture.blur = this._preBlur, this._preBlurYTexture.refreshRate = 0, this._preBlurYTexture.endInit(), this._activeTextures.push(this._preBlurYTexture), e = this._preBlurYTexture), e;
  }
  updateNormalmapTexture(e) {
    return this._normalMapTexture ? this._normalMapTexture.baseTexture = e : this._normalMapTexture = new Cd("procNormal", this._size, this._scene, e, void 0, !1), this._normalMapTexture.beginInit(), this._normalMapTexture.bias = this._bias, this._normalMapTexture.invertR = this._invertR, this._normalMapTexture.invertG = this._invertG, this._normalMapTexture.bevel = this._bevel, this._normalMapTexture.intensity = this._intensity, this._normalMapTexture.refreshRate = 0, this._normalMapTexture.endInit(), this._activeTextures.push(this._normalMapTexture), this._normalMapTexture;
  }
  updatePostBlurTexture(e) {
    let t = e;
    return this._postBlurEnabled && (this._postBlurXTexture ? this._postBlurXTexture.baseTexture = e : this._postBlurXTexture = new so("postBlurX", this._size, this._scene, e, void 0, !1), this._postBlurXTexture && (this._postBlurXTexture.beginInit(), this._postBlurXTexture.blur = this._postBlur, this._postBlurXTexture.refreshRate = 0, this._postBlurXTexture.endInit(), this._activeTextures.push(this._postBlurXTexture), this._postBlurYTexture ? this._postBlurYTexture.baseTexture = this._postBlurXTexture : this._postBlurYTexture = new ro("postBlurY", this._size, this._scene, this._postBlurXTexture, void 0, !1), this._postBlurYTexture && (this._postBlurYTexture.beginInit(), this._postBlurYTexture.blur = this._postBlur, this._postBlurYTexture.refreshRate = 0, this._postBlurYTexture.endInit(), this._activeTextures.push(this._postBlurYTexture), t = this._postBlurYTexture))), t;
  }
  dispose() {
    this._preBlurXTexture && (this._preBlurXTexture.dispose(), this._preBlurXTexture = null), this._preBlurYTexture && (this._preBlurYTexture.dispose(), this._preBlurYTexture = null), this._normalMapTexture && (this._normalMapTexture.dispose(), this._normalMapTexture = null), this._postBlurXTexture && (this._postBlurXTexture.dispose(), this._postBlurXTexture = null), this._postBlurYTexture && (this._postBlurYTexture.dispose(), this._postBlurYTexture = null);
  }
  async getNormalMapTextureAsync(e, t) {
    return await this.updateAsync(e, t), this._activeTextures.length > 0 ? this._activeTextures[this._activeTextures.length - 1] : null;
  }
  async updateAsync(e, t) {
    if (this.init(t), this._activeTextures.length > 0) {
      this._activeTextures[0].baseTexture = e;
      for (var s = 0; s < this._activeTextures.length; s++)
        await this._activeTextures[s].isReadyAsync(), this._activeTextures[s].render();
    }
  }
}
class zx {
  constructor(e, t, s, o) {
    this._baseTexture = e, this._size = t, this._scene = o, this._mask = new ao("mask", this._size, this._scene, this._baseTexture), this._mask.backColor = new BABYLON.Vector3(0, 0, 0), this._mask.foreColor = new BABYLON.Vector3(1, 1, 1), this._mask.refreshRate = 0, this._shadow = new ao("shadow", this._size, this._scene, this._baseTexture), this._shadow.backColor = new BABYLON.Vector3(0.1, 0.1, 0.1), this._shadow.foreColor = new BABYLON.Vector3(1, 1, 1), this._shadow.refreshRate = 0, this._shadowBlurX = new so("shadow_blurX", this._size, this._scene, this._shadow), this._shadowBlurX.blur = 5, this._shadowBlurX.refreshRate = 0, this._shadowBlurY = new ro("shadow_blurY", this._size, this._scene, this._shadowBlurX), this._shadowBlurY.blur = 5, this._shadowBlurY.refreshRate = 0, this._shadowMove = new ru("shadow_move", this._size, this._scene, this._shadowBlurY), this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5), this._shadowMove.refreshRate = 0, this._lightmap = new Qa("lightmap", this._size, this._scene, this._shadowMove, this._mask), this._lightmap.refreshRate = 0, this.updateParameters(s);
  }
  updateParameters(e) {
    if (e) {
      let t = new BABYLON.Vector3(0, 0, 0);
      if (e.get("color")) {
        const T = BABYLON.Color3.FromHexString(e.get("color"));
        t = new BABYLON.Vector3(T.r, T.g, T.b);
      }
      this._shadow.backColor = t;
      let s = 1, o = 135;
      e.get("angle") !== void 0 && e.get("angle") !== null && (o = e.get("angle")), e.get("distance") != null && e.get("distance") !== null && (s = e.get("distance"));
      let a = o * Math.PI / 180;
      a = this.wrapPi(a);
      const c = Math.cos(a) * s, g = Math.sin(a) * s;
      this._shadowMove.offset = new BABYLON.Vector2(-c, g);
      let w = 5;
      e.get("size") !== void 0 && e.get("size") !== null && (w = Math.max(0, Math.min(100, e.get("size")))), this._shadowBlurX.blur = w, this._shadowBlurY.blur = w;
    }
  }
  // riporta angle nel range -180, + 180
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, s = Math.floor((e + Math.PI) * (1 / t));
      e -= s * t;
    }
    return e;
  }
  dispose() {
    this._mask.dispose(), this._shadow.dispose(), this._shadowBlurX.dispose(), this._shadowBlurY.dispose(), this._shadowMove.dispose(), this._lightmap.dispose();
  }
  async getInnerShadowTextureAsync(e) {
    return await this.updateAsync(e), this._lightmap;
  }
  async updateAsync(e, t) {
    this.updateParameters(t), this._baseTexture = e, await ni.whenTextureIsReadyAsync(this._baseTexture), this._mask.baseTexture = this._baseTexture, await this._mask.isReadyAsync(), this._mask.render(), this._shadow.baseTexture = this._baseTexture, await this._shadow.isReadyAsync(), this._shadow.render(), await this._shadowBlurX.isReadyAsync(), this._shadowBlurX.render(), await this._shadowBlurY.isReadyAsync(), this._shadowBlurY.render(), await this._shadowMove.isReadyAsync(), this._shadowMove.render(), await this._lightmap.isReadyAsync(), this._lightmap.render();
  }
  //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
  //    return new Promise<void>((resolve, reject) => {
  //        if (texture.isReady())
  //            resolve();
  //        else {
  //            let t = setInterval(() => {
  //                if (texture.isReady()) {
  //                    clearInterval(t);
  //                    resolve();
  //                }
  //            }, 5);
  //        }
  //    });
  //}
}
class Fx {
  constructor(e, t, s, o) {
    this._size = t, this._baseTexture = e, this._scene = o, this._shadow = new ao("shadow", this._size, this._scene, this._baseTexture), this._shadow.backColor = new BABYLON.Vector3(1, 1, 1), this._shadow.foreColor = new BABYLON.Vector3(0.2, 0.2, 0.2), this._shadow.refreshRate = 0, this._shadowBlurX = new so("shadow_blurX", this._size, this._scene, this._shadow), this._shadowBlurX.blur = 15, this._shadowBlurX.refreshRate = 0, this._shadowBlurY = new ro("shadow_blurY", this._size, this._scene, this._shadowBlurX), this._shadowBlurY.blur = 15, this._shadowBlurY.refreshRate = 0, this._shadowMove = new ru("shadow_move", this._size, this._scene, this._shadowBlurY), this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5), this._shadowMove.refreshRate = 0, this.updateParameters(s);
  }
  updateParameters(e) {
    if (e) {
      var t = new BABYLON.Vector3(0, 0, 0);
      if (e.get("color")) {
        var s = BABYLON.Color3.FromHexString(e.get("color"));
        t = new BABYLON.Vector3(s.r, s.g, s.b);
      }
      this._shadow.foreColor = t;
      let o = 1, a = 135;
      e.get("angle") !== void 0 && e.get("angle") !== null && (a = e.get("angle")), e.get("distance") != null && e.get("distance") !== null && (o = e.get("distance"));
      let c = a * Math.PI / 180;
      c = this.wrapPi(c);
      const g = Math.cos(c) * o, w = Math.sin(c) * o;
      this._shadowMove.offset = new BABYLON.Vector2(-g, w);
      let T = 5;
      e.get("size") !== void 0 && e.get("size") !== null && (T = Math.max(0, Math.min(100, e.get("size")))), this._shadowBlurX.blur = T, this._shadowBlurY.blur = T;
    }
  }
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, s = Math.floor((e + Math.PI) * (1 / t));
      e -= s * t;
    }
    return e;
  }
  dispose() {
    this._shadow.dispose(), this._shadowBlurX.dispose(), this._shadowBlurY.dispose(), this._shadowMove.dispose();
  }
  async getOuterShadowTextureAsync(e) {
    return await this.updateAsync(e), this._shadowMove;
  }
  async updateAsync(e, t) {
    this.updateParameters(t), this._baseTexture = e, await ni.whenTextureIsReadyAsync(this._baseTexture), this._shadow.baseTexture = this._baseTexture, await this._shadow.isReadyAsync(), this._shadow.render(), await this._shadowBlurX.isReadyAsync(), this._shadowBlurX.render(), await this._shadowBlurY.isReadyAsync(), this._shadowBlurY.render(), await this._shadowMove.isReadyAsync(), this._shadowMove.render();
  }
  //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
  //    return new Promise<void>((resolve, reject) => {
  //        if (texture.isReady())
  //            resolve();
  //        else {
  //            let t = setInterval(() => {
  //                if (texture.isReady()) {
  //                    clearInterval(t);
  //                    resolve();
  //                }
  //            }, 5);
  //        }
  //    });
  //}
}
globalThis && globalThis.__awaiter;
globalThis && globalThis.__generator;
function Ah(v, e, t) {
  e === void 0 && (e = 50), t === void 0 && (t = {
    isImmediate: !1
  });
  var s;
  return function() {
    for (var o = [], a = 0; a < arguments.length; a++)
      o[a] = arguments[a];
    var c = this, g = function() {
      s = void 0, t.isImmediate || v.apply(c, o);
    }, w = t.isImmediate && s === void 0;
    s !== void 0 && clearTimeout(s), s = setTimeout(g, e), w && v.apply(c, o);
  };
}
const Lf = /android/i.test(navigator.userAgent), Bf = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, Dd = class _r {
  constructor(e, t, s, o, a, c, g, w = !0, T, H = 0) {
    this._subMesh = null, this._isRefreshing = !1, this._showDesign = !0, this._viewRotation = 0, this._designTextureResolution = 1024, this._effect = null, this._meshSide = null, this._side = null, this._isDisposed = !1, this._baseWidth = _r.DEFAULT_SIZE, this._baseHeight = _r.DEFAULT_SIZE, this._textureWidth = _r.DEFAULT_SIZE, this._textureHeight = _r.DEFAULT_SIZE, this._coordinatesIndex = 0, this._currentVisibliity = !0, this._canvasMesh = null, this._originalCanvasMeshPosition = null, this._originalCanvasMeshScaling = null, this._normalmapMaterial = null, this._originalMaterial = null, this._blankDataUrl = null, this._innerCanvasMesh = null, this._outerCanvasMesh = null, this._ownDynamicMaterial = !1, this._dynamicMaterial = null, this._dynamicTexture = null, this._normalmapTexture = null, this._dynamicOpacityTexture = null, this._ownOldDynamicMaterial = !1, this._oldDynamicMaterial = null, this._originalDiffuseTexture = null, this._combinedDiffuseTexture = null, this._originalMeshNormalmapTexture = null, this._originalDesignNormalmapTexture = null, this._meshCombinedNormalmapTexture = null, this._designCombinedNormalmapTexture = null, this._originalMeshLightmapTexture = null, this._originalDesignLightmapTexture = null, this._meshCombinedLightmapTexture = null, this._designCombinedLightmapTexture = null, this._innerShadowTexture = null, this._outerShadowTexture = null, this._context = null, this._canvas = null, this._canvasID = Zakeke.generateUUID(), this._customizer = null, this._renderingNeededListeners = [], this._proceduralNormalMap = null, this._innerShadowGenerator = null, this._outerShadowGenerator = null, this._debouncedUpdateDynamicTexture = null, this._originalViewMatrixValues = null, this._grids = [], this._lastUpdateTextureWasDynamic = !0, this.isFirstRender = !0, this._scene = e, this._sceneHelper = new ni(e), this._zkScene = t, this._mesh = s, this._subMesh = o, this._zkModel = a, this._zkDesign = c, this._grids = g, this._showDesign = w, this._viewRotation = H, T && (this._effect = T);
  }
  get showDesign() {
    return this._showDesign;
  }
  set showDesign(e) {
    this._showDesign != e && (this._showDesign = e);
  }
  get rotation() {
    return this._viewRotation;
  }
  set rotation(e) {
    this._viewRotation != e && (this._viewRotation = e);
  }
  get side() {
    return this._side;
  }
  // Temporary until we can access internal matrix (speak with Matteo)
  getInternalCustomizer() {
    return this._customizer;
  }
  // Factory method for async object creation and initialization
  static async createMeshDesignManagerAsync(e, t, s, o, a, c, g, w = !0, T, H = 0) {
    const Y = new _r(
      e,
      t,
      s,
      o,
      a,
      c,
      g,
      w,
      T,
      H
    );
    return await Y.initAsync(), Y;
  }
  async initAsync() {
    const e = this._zkScene.get("rootUrl");
    e && await this._sceneHelper.unsetMeshDummyMaterialAsync(this._mesh, e, !0), this.setupMeshSide(), this.setupTextureSize(), this.checkDefaultEffect(), this.refreshModelSide(), await this.setupClonedObjectsAsync(), await this.setupCanvasAsync(), await this.setupDynamicMaterialAsync(), await this.refreshAsync();
  }
  isForMesh(e, t) {
    return !e || !this._mesh || e.id !== this._mesh.id ? !1 : !this._subMesh && !t ? !0 : !this._subMesh || !t ? !1 : t.materialIndex === this._subMesh.materialIndex;
  }
  getMeshID() {
    return this._mesh ? this._mesh.id : null;
  }
  getSubMeshIdx() {
    return this._subMesh ? this._subMesh.materialIndex : 0;
  }
  getMaterialIDForDesign() {
    let e;
    return this._effect && this._effect.get("materialID") ? e = this._effect.get("materialID") : this._mesh && this._mesh.metadata && this._mesh.metadata.designMaterialID ? e = this._mesh.metadata.designMaterialID : this._meshSide && this._meshSide.get("materialID") && (e = this._meshSide.get("materialID")), e;
  }
  getDesignConfig() {
    let e;
    return this._effect && this._effect.get("config") ? e = this._effect.get("config") : this._meshSide && this._meshSide.get("config") && (e = this._meshSide.get("config")), e || (e = new MPlaza.MeshDesignConfig()), e;
  }
  dispose() {
    this._isDisposed = !0, this._customizer && (this._customizer.clearMemoryForIOS(), this._customizer = null), this.disposeOuterInnerCanvasMeshes(), this._canvasMesh && (this._canvasMesh.dispose(), this._canvasMesh = null, this._originalCanvasMeshPosition = null, this._originalCanvasMeshScaling = null), this.disposeDynamicMaterial(), this._dynamicOpacityTexture && (this._dynamicOpacityTexture.dispose(), this._dynamicOpacityTexture = null), this._dynamicTexture && (this._dynamicTexture.dispose(), this._dynamicTexture = null), this._renderingNeededListeners = [], $("#" + this._canvasID).remove(), this.restoreOrignalMaterial(), this.disposeNormalmapMaterial(), this._proceduralNormalMap && (this._proceduralNormalMap.dispose(), this._proceduralNormalMap = null), this._innerShadowGenerator && (this._innerShadowGenerator.dispose(), this._innerShadowGenerator = null), this._combinedDiffuseTexture && (this._combinedDiffuseTexture.dispose(), this._combinedDiffuseTexture = null), this._meshCombinedNormalmapTexture && (this._meshCombinedNormalmapTexture.dispose(), this._meshCombinedNormalmapTexture = null), this._designCombinedNormalmapTexture && (this._designCombinedNormalmapTexture.dispose(), this._designCombinedNormalmapTexture = null), this._meshCombinedLightmapTexture && (this._meshCombinedLightmapTexture.dispose(), this._meshCombinedLightmapTexture = null), this._designCombinedLightmapTexture && (this._designCombinedLightmapTexture.dispose(), this._designCombinedLightmapTexture = null);
  }
  disposeOuterInnerCanvasMeshes() {
    this._innerCanvasMesh && (this._innerCanvasMesh.dispose(), this._innerCanvasMesh = null), this._outerCanvasMesh && (this._outerCanvasMesh.dispose(), this._outerCanvasMesh = null);
  }
  disposeNormalmapMaterial() {
    this._normalmapMaterial && this._originalMaterial && this._normalmapMaterial.id !== this._originalMaterial.id && this._sceneHelper.getMeshesUsingMaterial(this._normalmapMaterial.id).length == 0 && (this._normalmapMaterial.dispose(), this._normalmapMaterial = null), this._originalMeshNormalmapTexture = null, this._originalMeshLightmapTexture = null;
  }
  disposeDynamicMaterial() {
    this._ownDynamicMaterial && this._dynamicMaterial && this._dynamicMaterial.dispose(), this._dynamicMaterial = null, this._originalDesignNormalmapTexture = null, this._originalDesignLightmapTexture = null;
  }
  disposeOldDynamicMaterial() {
    this._ownOldDynamicMaterial && this._oldDynamicMaterial && this._dynamicMaterial && this._oldDynamicMaterial != this._dynamicMaterial && this._oldDynamicMaterial.dispose(), this._oldDynamicMaterial = null;
  }
  createCanvasMeshClone(e) {
    if (this._canvasMesh) {
      const t = this._canvasMesh.clone(e + " - clone outer", null);
      if (t)
        return t.id = Zakeke.generateUUID(), this._canvasMesh.metadata && this._canvasMesh.metadata.AR !== void 0 && this._canvasMesh.metadata.AR !== null && (t.metadata || (t.metadata = {}), t.metadata.AR = this._canvasMesh.metadata.AR), t;
    }
    return null;
  }
  expandCanvasMesh(e) {
    if (!this._mesh || !this._canvasMesh)
      return;
    this.disposeOuterInnerCanvasMeshes();
    const t = this.getMeshHierarchySize(this._mesh), s = this.getMeshHierarchySize(this._canvasMesh);
    if (!t.equals(s))
      return;
    let o = 4e-3;
    e && (o += e);
    const a = 0.2;
    if (this._outerCanvasMesh = this.createCanvasMeshClone(this._mesh.name + " outer clone"), this._canvasMesh.isVisible = !1, this._outerCanvasMesh)
      if (Math.abs(t.x) <= 0.01 || Math.abs(t.y) <= 0.01 || Math.abs(t.z) <= 0.01) {
        const T = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), H = BABYLON.Vector3.FromArray(
          T,
          0
        ).normalize();
        this._outerCanvasMesh.position = this._outerCanvasMesh.position.add(H.scale(a));
      } else {
        const T = [...this._canvasMesh.getVerticesData(BABYLON.VertexBuffer.PositionKind)], H = [...this._canvasMesh.getVerticesData(BABYLON.VertexBuffer.NormalKind)];
        for (var c = 0; c < T.length; c += 3) {
          const z = new BABYLON.Vector3(H[c], H[c + 1], H[c + 2]), he = new BABYLON.Vector3(
            T[c] + z.x * o,
            T[c + 1] + z.y * o,
            T[c + 2] + z.z * o
          );
          T[c] = he.x, T[c + 1] = he.y, T[c + 2] = he.z;
        }
        const Y = BABYLON.VertexData.ExtractFromMesh(this._canvasMesh, !0, !0);
        Y.positions = T;
        const ee = new BABYLON.Geometry(this._canvasMesh.name + " outer geometry", this._scene);
        Y.applyToGeometry(ee), ee.applyToMesh(this._outerCanvasMesh), this._scene.render();
      }
  }
  // Nel caso in cui la mesh non sia un piano, espande la mesh clone in modo che
  // racchiuda quella originale e che eviti il problema z- fighting.
  // Nel caso in cui si tratti di un piano (o di un disco o equivalenti), la mesh clone verrà solo
  // spostata leggermente nella direzione della normale al piano
  // Tale possibilità verrà sfruttata soprattutto in fase di esportazione in altro formato che non preveda
  // proprietà simili al zOffset di Babylon JS
  expandCanvasMesh_old() {
    if (!this._mesh || !this._canvasMesh)
      return;
    const e = 0.01, t = 1 + e, s = this.getMeshHierarchySize(this._mesh), o = this.getMeshHierarchySize(this._canvasMesh);
    if (!s.equals(o))
      return;
    const a = 0.1;
    if (Math.abs(s.x) <= a || Math.abs(s.y) <= a || Math.abs(s.z) <= a) {
      let g = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), w = BABYLON.Vector3.FromArray(
        g,
        0
      ).normalize();
      this._canvasMesh.position = this._canvasMesh.position.add(w.scale(e));
    } else {
      let g = this._canvasMesh.scaling;
      g = g.multiplyByFloats(t, t, t), this._canvasMesh.scaling = g;
      let w = this.getMeshHierarchyCenter(this._mesh), T = this.getMeshHierarchyCenter(this._canvasMesh);
      const H = w.subtract(T);
      H.equals(BABYLON.Vector3.Zero()) || this._canvasMesh.position.addInPlace(H);
    }
  }
  contractCanvasMesh() {
    this._canvasMesh && (this._canvasMesh.isVisible = !0), this.disposeOuterInnerCanvasMeshes();
  }
  // Riporta la mesh clone allo stato originale, continuando a sfruttare unicamente la proprietà
  // zOffset per superare il problema dello z-fighting
  contractCanvasMesh_old() {
    if (!this._mesh || !this._canvasMesh || !this._originalCanvasMeshScaling || !this._originalCanvasMeshPosition)
      return;
    this._canvasMesh.scaling = this._originalCanvasMeshScaling, this._canvasMesh.position = this._originalCanvasMeshPosition;
    const e = this.getMeshHierarchyCenter(this._mesh), t = this.getMeshHierarchyCenter(this._canvasMesh), s = e.subtract(t);
    s.equals(BABYLON.Vector3.Zero()) || this._canvasMesh.position.addInPlace(s);
  }
  setupMeshSide() {
    if (this._meshSide = null, this._coordinatesIndex = 0, this._zkModel && this._mesh && this._mesh.id)
      for (let s = 0; s < this._zkModel.get("scenes").length; s++) {
        var e = this._zkModel.get("scenes").at(s);
        if (e.get("isDefault"))
          for (let o = 0; o < e.get("meshSides").length; o++) {
            var t = e.get("meshSides").at(o);
            if (t.get("meshID") == this._mesh.id) {
              this._meshSide = t, this._meshSide.get("uvChannel") >= 0 && (this._coordinatesIndex = this._meshSide.get("uvChannel"));
              return;
            }
          }
      }
  }
  setupTextureSize() {
    this._meshSide && (!Lf && !Bf ? (this._baseWidth = this._meshSide.getOrCreateConfig().getDesktopTextureResolutionWidth() ?? _r.DEFAULT_SIZE, this._baseHeight = this._meshSide.getOrCreateConfig().getDesktopTextureResolutionHeight() ?? _r.DEFAULT_SIZE) : Lf ? (this._baseWidth = this._meshSide.getOrCreateConfig().getMobileTextureResolutionWidth() ?? _r.DEFAULT_SIZE, this._baseHeight = this._meshSide.getOrCreateConfig().getMobileTextureResolutionHeight() ?? _r.DEFAULT_SIZE) : Bf && (this._baseWidth = 512, this._baseHeight = 512)), console.log("Texture size: " + this._baseWidth + "x" + this._baseHeight);
  }
  checkDefaultEffect() {
    if (!this._effect && this._meshSide) {
      var e = this._meshSide.getParentModel();
      if (e && e instanceof MPlaza.ModelScene) {
        let t = this.getMeshID();
        if (t) {
          let s = e.getDefaultDesignEffect(t, this.getSubMeshIdx());
          s && (this._effect = s);
        }
      }
    }
  }
  getAllSides() {
    const e = [];
    return this._zkModel.get("colors").each((t) => {
      t.get("sides").each((s) => {
        e.find((o) => o.get("sideID") == s.get("sideID")) || e.push(s);
      });
    }), e;
  }
  // Recupera il lato del modello corrispondente alla mesh in input
  // Del lato abbiamo solo sideID, mentre per il modello i lati sono per colore. Recuperiamo il colorID
  // in base agli elementi del design, considerando buono il primo colore con elementi grafici
  refreshModelSide() {
    if (this._side = null, this._meshSide && this._zkDesign) {
      const e = this._meshSide.get("sideID"), t = this._meshSide.tempID;
      let s = null;
      if (s = this.getAllSides().find(function(o) {
        return o.get("sideID") == e;
      }) || null, s) {
        let o = null;
        for (const a of this._zkDesign.get("designItems").models)
          if (o = a, o.isOnSide(s)) {
            const c = o && o.get("areas").length > 0 ? o.get("areas").at(0).get("colorID") : null;
            c && this._zkModel.get("colors").each(function(g) {
              g.get("colorID") == c && g.get("sides").each(function(w) {
                (w.tempID ? w.tempID == t : w.get("sideID") == e) && (s = w);
              });
            });
            break;
          }
        this._side = s;
      }
    }
  }
  async setupClonedObjectsAsync() {
    if (this._side) {
      for (var e = 0; e < this._scene.meshes.length; e++) {
        let t = this._scene.meshes[e];
        if (t && t.metadata && t.metadata.originalMeshID && t.metadata.originalMeshID == this._mesh.id) {
          this._canvasMesh = t, this._canvasMesh.isVisible = this._currentVisibliity, this._normalmapMaterial = this._mesh.material, this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial), this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial);
          break;
        }
      }
      if (!this._canvasMesh) {
        let t = this._mesh.name + " - clone";
        this._canvasMesh = this._mesh.clone(t, null), this._canvasMesh && (this._canvasMesh.id = Zakeke.generateUUID(), this._canvasMesh.isVisible = this._currentVisibliity, this._canvasMesh.doNotSerialize = !0, this._canvasMesh.isPickable = !1, this._canvasMesh.metadata = {}, this._canvasMesh.metadata.originalMeshID = this._mesh.id, this._canvasMesh.metadata.isRealMesh = !1, this._canvasMesh.metadata.iscanvasMesh = !0, this._mesh.metadata && this._mesh.metadata.AR !== void 0 && this._mesh.metadata.AR !== null && (this._canvasMesh.metadata.AR = this._mesh.metadata.AR));
      }
      this._canvasMesh && (this._originalCanvasMeshPosition = this._canvasMesh.position, this._originalCanvasMeshScaling = this._canvasMesh.scaling), this._normalmapMaterial || await this.setupNormalmapMaterialAsync();
    }
  }
  // Prepara il materiale per la normalmap da applicare alla mesh originale
  // posizionata sotto quella su cui è apposto il design.
  // Tale materiale viene utilizzato anche per l'eventuale lightmap di dropshadow (outer shadow)
  // quindi il nome andrebbe cambiato
  async setupNormalmapMaterialAsync() {
    this.disposeNormalmapMaterial(), this._originalMaterial = this._mesh.material;
    let e = Zakeke.generateUUID(), t = "normalmapMaterial - " + e;
    this._originalMaterial ? (t = this._originalMaterial.name + " - normalmap", this._normalmapMaterial = await this.cloneMaterialAsync(this._originalMaterial, t)) : this._normalmapMaterial = new BABYLON.StandardMaterial(t, this._scene), this._normalmapMaterial && (this._normalmapMaterial.id = e, this._normalmapMaterial.doNotSerialize = !0, this._normalmapMaterial.metadata = {}, this._originalMaterial ? this._normalmapMaterial.metadata.originalMaterialID = this._originalMaterial.id : this._normalmapMaterial.metadata.originalMaterialID = null, this._normalmapMaterial.metadata.isRealMaterial = !1, this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial), this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial));
  }
  // private getOriginalTexture(): BABYLON.Texture | null {
  //     if (this._originalMaterial) {
  //         var propertyName = this.getMaterialDiffuseTexturePropertyName(this._originalMaterial);
  //         if (!this._originalMaterial[propertyName])
  //             return null;
  //         return this._originalMaterial[propertyName];
  //     }
  //     return null;
  // }
  getMaterialDiffuseTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "diffuseTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? "baseTexture" : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "diffuseTexture" : e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial ? "albedoTexture" : "diffuseTexture";
  }
  getMaterialOpacityTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "opacityTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? null : (e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial, "opacityTexture");
  }
  getMaterialNormalmapTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "bumpTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "normalTexture" : (e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial, "bumpTexture");
  }
  getMaterialLightmapTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "ambientTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "occlusionTexture" : e instanceof BABYLON.PBRMaterial ? "ambientTexture" : e instanceof Zakeke.PBRMaterial ? "aoTexture" : "lightmapTexture";
  }
  getMaterialDiffuse(e) {
    let t = this.getMaterialDiffuseTexturePropertyName(e);
    return e[t];
  }
  getMaterialNormalmap(e) {
    if (!e)
      return null;
    let t = this.getMaterialNormalmapTexturePropertyName(e);
    return e[t];
  }
  getMaterialLightmap(e) {
    if (!e)
      return null;
    let t = this.getMaterialLightmapTexturePropertyName(e);
    return e[t];
  }
  getMaterialOpacity(e) {
    if (!e)
      return null;
    let t = this.getMaterialOpacityTexturePropertyName(e);
    return t ? e[t] : null;
  }
  setMaterialLightmap(e, t) {
    if (e) {
      var s = this.getMaterialLightmapTexturePropertyName(e);
      s && (e[s] = t, e instanceof Zakeke.PBRMaterial && (e.useAOTextureAsLightmap = !0));
    }
  }
  setTextureWrapping(e) {
    e && (e.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, e.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
  }
  async setupCanvasAsync() {
    if (this._side && this._canvasMesh && this._meshSide && !this._isRefreshing) {
      this._isRefreshing = !0;
      var e = this._baseWidth;
      this._meshSide.get("percWidth") > 0 && (e *= this._meshSide.get("percWidth"));
      var t = this._baseHeight;
      this._meshSide.get("percHeight") > 0 && (t *= this._meshSide.get("percHeight")), this._textureWidth = e, this._textureHeight = t;
      var s = $("<canvas>", { id: this._canvasID }).attr({ width: e, height: t });
      this._canvas = s[0], this._context = this._canvas.getContext("2d"), this._context && (this._context.imageSmoothingQuality = "high", this._context.imageSmoothingEnabled = !0, this._customizer = new MPlaza.Customizer(!0, !1, this._canvas, !0), this._blankDataUrl = this._canvas.toDataURL(), this._customizer.showSideImage = !1, this._customizer.model = this._zkModel, this._customizer.fitToScreenMargin = this._zkScene.getFitToScreenMargin(), this._customizer.setGrids(this._grids), this._customizer.setDesign(this._zkDesign), await new Promise(async (o) => {
        var a, c;
        await ((a = this._customizer) == null ? void 0 : a.setSide(this._side)), (c = this._customizer) == null || c.refresh({ boundsToAreas: !0 }, async () => {
          if (this._customizer) {
            if (this._meshSide) {
              let g = this._meshSide.get("matrix");
              if (g) {
                const w = JSON.parse(g);
                let T = new this._customizer.paper.Matrix(w);
                this._customizer.paper.view.matrix = T, this._customizer.paper.view.update();
              }
            }
            await this.updateDynamicTextureAsync(), this._customizer.addItemCreatedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            }), this._customizer.addItemChangedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            }), this._customizer.addItemRemovedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            }), this._customizer.addImageLoadedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            });
          }
          o();
        });
      }));
    }
    this._isRefreshing = !1;
  }
  setCustomizerGrids(e) {
    var t;
    this._grids = e, (t = this._customizer) == null || t.setGrids(e);
  }
  // Ripristino il materiale originale sulla mesh, a meno che non sia stato già cambiato
  restoreOrignalMaterial() {
    this._mesh && this._originalMaterial && this._mesh.material && this._normalmapMaterial && this._mesh.material.id === this._normalmapMaterial.id && (this._mesh.material = this._originalMaterial);
  }
  getMeshesUsingMaterial(e) {
    for (var t = [], s = this._scene.meshes, o = 0; o < s.length; o++) {
      var a = s[o];
      if (a.material) {
        if (a.material.id == e)
          t.push(a);
        else if (a.material instanceof BABYLON.MultiMaterial)
          for (var c = 0; c < a.material.subMaterials.length; c++) {
            let g = a.material.subMaterials[c];
            if (g != null && g.id === e) {
              t.push(a);
              break;
            }
          }
      }
    }
    return t;
  }
  async checkNormalmapMaterialAsync() {
    this._mesh && this._normalmapMaterial && (!this._mesh.material || this._mesh.material.id !== this._normalmapMaterial.id) && await this.setupNormalmapMaterialAsync();
  }
  // Se il materiale associato alla mesh è cambiato lo ricrea
  async checkDynamicMaterialAsync() {
    let e = this.getMaterialIDForDesign();
    e && this._side && this._canvasMesh && this._meshSide && this._dynamicMaterial && this._dynamicMaterial.id != e && await this.setupDynamicMaterialAsync();
  }
  async setupDynamicMaterialAsync() {
    if (this._side && this._canvasMesh && this._meshSide) {
      this._ownOldDynamicMaterial = this._ownDynamicMaterial, this._oldDynamicMaterial = this._dynamicMaterial;
      var e = this.getMaterialIDForDesign();
      if (e) {
        this._zkScene.get("rootUrl") && await this._sceneHelper.loadDelayedMaterialAsync(this._zkScene.get("rootUrl"), e);
        let t = this._scene.getMaterialById(e);
        t && (this._dynamicMaterial = await this.cloneMaterialAsync(t, t.name + " - clone"), this._ownDynamicMaterial = !0);
      }
      if (!this._dynamicMaterial) {
        if (this._mesh.material && this._mesh.material instanceof BABYLON.PBRBaseMaterial) {
          const t = new BABYLON.PBRMaterial(
            "dynamicMaterial",
            this._scene
          );
          t.enableSpecularAntiAliasing = !0, t.backFaceCulling = !1, t.albedoColor = BABYLON.Color3.White(), t.reflectivityColor = BABYLON.Color3.Black(), t.transparencyMode = this._zkScene.getDefaultDesignMaterialTransparencyMode(), t.useAlphaFromAlbedoTexture = !0, this._mesh.material.subSurface.indexOfRefraction != null && (t.subSurface.indexOfRefraction = this._mesh.material.subSurface.indexOfRefraction), Jo(this._mesh.material) && this._mesh.material.roughness != null && (t.roughness = this._mesh.material.roughness), Jo(this._mesh.material) && this._mesh.material.metallic != null && (t.metallic = this._mesh.material.metallic), Jo(this._mesh.material) && this._mesh.material.reflectionTexture != null && (t.reflectionTexture = this._mesh.material.reflectionTexture), Jo(this._mesh.material) && this._mesh.material.microSurface != null && (t.microSurface = this._mesh.material.microSurface), this._dynamicMaterial = t;
        } else
          this._dynamicMaterial = new BABYLON.StandardMaterial("dynamicMaterial", this._scene), this._dynamicMaterial.backFaceCulling = !1, this._dynamicMaterial.specularColor = BABYLON.Color3.Black(), this._dynamicMaterial.ambientColor = BABYLON.Color3.White(), this._dynamicMaterial.diffuseColor = BABYLON.Color3.White();
        this._dynamicMaterial.id = Zakeke.generateUUID(), this._ownDynamicMaterial = !0;
      }
      this._dynamicMaterial.zOffset = -1, this._dynamicMaterial.metadata = { isRealMaterial: !1 }, this._dynamicMaterial.doNotSerialize = this._ownDynamicMaterial, this._originalDiffuseTexture = this.getMaterialDiffuse(this._dynamicMaterial), this._originalDesignNormalmapTexture = this.getMaterialNormalmap(this._dynamicMaterial), this._originalDesignLightmapTexture = this.getMaterialLightmap(this._dynamicMaterial);
    }
  }
  /*
      private whenTextureIsReadyAsync(texture: BABYLON.BaseTexture): Promise<void> {
          return new Promise<void>((resolve, reject) => {
  
              let t = setInterval(() => {
                  if (texture.isReady()) {
                      clearInterval(t);
                      if (texture instanceof BABYLON.ProceduralTexture)
                          texture.getEffect();
                      resolve();
                  }
              }, 5);
  
          });
      }
      */
  async cloneMaterialAsync(e, t) {
    if (e) {
      var s = e.getActiveTextures();
      s.forEach(async (a) => {
        await ni.whenTextureIsReadyAsync(a);
      });
      var o = t || e.name + " - clone";
      if (e instanceof BABYLON.ShaderMaterial) {
        const a = this._zkScene.get("rootUrl");
        if (!a)
          return null;
        let c = e.serialize();
        return BABYLON.Material.Parse(c, this._scene, a);
      } else
        return e.clone(o);
    }
    return null;
  }
  getMeshHierarchySize(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return t.max.subtract(t.min);
  }
  getMeshHierarchyCenter(e) {
    let t = e.getHierarchyBoundingVectors(!0), s = t.max.subtract(t.min);
    return t.min.add(s.scale(0.5));
  }
  async refreshAsync(e) {
    this._isRefreshing || (this._isRefreshing = !0, typeof e < "u" && (this._effect = e), await this.checkDynamicMaterialAsync(), await this.checkNormalmapMaterialAsync(), this.refreshModelSide(), await new Promise(async (t) => {
      var s, o, a;
      if (this._meshSide && this.side && this._customizer) {
        if (await ((s = this._customizer) == null ? void 0 : s.setSide(this.side)), await ((o = this._customizer) == null ? void 0 : o.updateGrids()), (a = this._customizer) == null || a.adaptZoomToSideAreas(!1), this._meshSide && this._customizer) {
          let c = this._meshSide.get("matrix");
          if (c) {
            const g = JSON.parse(c);
            let w = new this._customizer.paper.Matrix(g);
            if (this._customizer.paper.view.matrix = w, this._customizer.paper.view.rotation += -this._viewRotation, this._textureWidth !== 1024) {
              const T = 1024 / this._textureWidth;
              let H = new paper.Matrix();
              H = H.scale(1 / T, 1 / T);
              const Y = w.prepend(H);
              this._customizer.paper.view.matrix = Y;
            }
          } else
            this._customizer.paper.view.rotation = -this._viewRotation;
          this._customizer.paper.view.update();
        }
        await this.updateDynamicTextureAsync(), t();
      } else
        t();
    }), this._isRefreshing = !1);
  }
  async updateDynamicTextureAsync() {
    if (this.isFirstRender) {
      console.log("First render..."), await this.updateDynamicTextureInternalAsync(), this.isFirstRender = !1;
      return;
    }
    this._debouncedUpdateDynamicTexture || (this._debouncedUpdateDynamicTexture = Ah(this.updateDynamicTextureInternalAsync, 10)), this._debouncedUpdateDynamicTexture();
  }
  async updateDynamicTextureInternalAsync(e = !0) {
    if (Logger.info("updateDynamicTextureInternal"), !this._side || !this._meshSide || !this._canvas || !this._canvasMesh || !this._dynamicMaterial)
      return;
    const t = this.getDesignConfig(), s = this._lastUpdateTextureWasDynamic != e;
    this._lastUpdateTextureWasDynamic = e, await this.checkDynamicMaterialAsync(), await this.checkNormalmapMaterialAsync();
    let o = t.getDiffuseEnabled(), a = t.getDiffuseBlendMode(), c = t.getDiffuseLevel();
    a !== "normal" && a !== "multiply" && a !== "overlay" && (a = "normal");
    const g = t.getOpacityEnabled();
    t.getOrCreateOpacityConfig();
    const w = t.getNormalmapEnabled(), T = t.getOrCreateNormalmapConfig(), H = t.getInnerShadowEnabled(), Y = t.getOrCreateInnerShadowConfig(), ee = t.getOuterShadowEnabled(), z = t.getOrCreateOuterShadowConfig();
    let he = "diffuseTexture";
    const ne = this._meshSide.get("materialTexture");
    ne ? he = ne : he = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial);
    let ye = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial), se = this._dynamicTexture;
    s && se && (se.dispose(), this._dynamicTexture = null);
    let _e = this._canvas.toDataURL(), ue = _e == this._blankDataUrl, xe = this.dataURItoBlob(_e), K = (window.URL || window.webkitURL).createObjectURL(xe);
    this._dynamicTexture || (e ? (this._dynamicTexture = new BABYLON.DynamicTexture("dynamicTexture", this._canvas, this._scene), this._dynamicTexture.hasAlpha = !0) : (this._dynamicTexture = new BABYLON.Texture(K, this._scene), this._dynamicTexture.hasAlpha = !0)), e ? this._dynamicTexture.update() : await ni.whenTextureIsReadyAsync(this._dynamicTexture), !ue && this._dynamicTexture && (w && await this.updateNormalmapTextureAsync(T), H && await this.updateInnerShadowTextureAsync(Y), ee && await this.updateOuterShadowTextureAsync(z), g && await this.updateOpacityTextureAsync(), this._originalDiffuseTexture && o && a !== "normal" && await this.combineDiffuseTexturesAsync(a, c), this._showDesign && (o && he && (a === "normal" || !this._originalDiffuseTexture || !this._combinedDiffuseTexture ? (this._dynamicTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._dynamicTexture), this._dynamicMaterial[he] = this._dynamicTexture) : this._combinedDiffuseTexture && (this._combinedDiffuseTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._combinedDiffuseTexture), this._dynamicMaterial[he] = this._combinedDiffuseTexture), this._dynamicMaterial[he].hasAlpha = !1, this._dynamicMaterial[he].hasAlpha = !0), !o && he && !this.compareTextures(
      this._dynamicMaterial[he],
      this._originalDiffuseTexture
    ) && (this._dynamicMaterial[he] = this._originalDiffuseTexture), g && ye && this._dynamicOpacityTexture && (this._dynamicOpacityTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._dynamicOpacityTexture), this._dynamicMaterial instanceof BABYLON.ShaderMaterial ? this._dynamicMaterial.setTexture(
      ye,
      this._dynamicOpacityTexture
    ) : this._dynamicMaterial[ye] = this._dynamicOpacityTexture), !g && ye && (this._dynamicMaterial[ye] = null), this._canvasMesh.material !== this._dynamicMaterial && (this._canvasMesh.material = this._dynamicMaterial), w && this._normalmapTexture ? await this.setNormalmapTextureAsync(T) : (this.resetMeshNormalmapTexture(), this.resetDesignNormalmapTexture()), H && this._innerShadowTexture ? await this.setInnerShadowTextureAsync(Y) : this.removeInnerShadowTexture(), ee && this._outerShadowTexture ? await this.setOuterShadowTextureAsync(z) : this.removeOuterShadowTexture(), this.disposeOldDynamicMaterial(), this._canvasMesh.isVisible = this._currentVisibliity && t.getShowDesign())), ue && (this._canvasMesh.isVisible = !1), this.fireRenderingNeededEvent();
  }
  resetDynamicTextures() {
    if (this._dynamicMaterial) {
      let e = "diffuseTexture";
      const t = this._meshSide ? this._meshSide.get("materialTexture") : null;
      t ? e = t : e = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial), e && !this.compareTextures(
        this._dynamicMaterial[e],
        this._originalDiffuseTexture
      ) && (this._dynamicMaterial[e] = this._originalDiffuseTexture || new BABYLON.Texture(this._blankDataUrl, this._scene), this._dynamicMaterial[e].hasAlpha = !1, this._dynamicMaterial[e].hasAlpha = !0), this.resetDesignNormalmapTexture();
      let s = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial);
      s && (this._dynamicMaterial[s] = null), this.removeInnerShadowTexture();
    }
    this._normalmapMaterial && (this.resetMeshNormalmapTexture(), this.removeOuterShadowTexture());
  }
  async updateOpacityTextureAsync() {
    this._dynamicTexture && (await ni.whenTextureIsReadyAsync(this._dynamicTexture), this._dynamicOpacityTexture || (this._dynamicOpacityTexture = new ao(
      "dynamicOpacity",
      this._textureWidth,
      this._scene,
      this._dynamicTexture
    ), this._dynamicOpacityTexture.backColor = new BABYLON.Vector3(0, 0, 0), this._dynamicOpacityTexture.foreColor = new BABYLON.Vector3(1, 1, 1), this._dynamicOpacityTexture.refreshRate = 0, this._dynamicOpacityTexture.getAlphaFromRGB = !0), this._dynamicOpacityTexture && (this._dynamicOpacityTexture.baseTexture = this._dynamicTexture, await ni.whenTextureIsReadyAsync(this._dynamicOpacityTexture), this._dynamicOpacityTexture.render()));
  }
  async combineDiffuseTexturesAsync(e, t) {
    if (!this._originalDiffuseTexture || !this._dynamicTexture)
      return;
    await ni.whenTextureIsReadyAsync(this._originalDiffuseTexture), await ni.whenTextureIsReadyAsync(this._dynamicTexture);
    const s = t === 0 ? this._dynamicTexture : this._originalDiffuseTexture, o = t === 0 ? this._originalDiffuseTexture : this._dynamicTexture;
    this._combinedDiffuseTexture || (e == "multiply" ? this._combinedDiffuseTexture = new Qa(
      "multiplyDiffuse",
      this._textureWidth,
      this._scene,
      s,
      o
    ) : this._combinedDiffuseTexture = new rl(
      "overlayDiffuse",
      this._textureWidth,
      this._scene,
      s,
      o
    ), this._combinedDiffuseTexture.refreshRate = 0), this._combinedDiffuseTexture && (this._combinedDiffuseTexture.baseTexture = s, this._combinedDiffuseTexture.blendTexture = o, await ni.whenTextureIsReadyAsync(this._combinedDiffuseTexture), this._combinedDiffuseTexture.render());
  }
  // NORMAL MAP
  async updateNormalmapTextureAsync(e) {
    this._dynamicTexture && (await ni.whenTextureIsReadyAsync(this._dynamicTexture), this._proceduralNormalMap || (this._proceduralNormalMap = new Dx(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    )), this._normalmapTexture = await this._proceduralNormalMap.getNormalMapTextureAsync(
      this._dynamicTexture,
      e
    ), this._normalmapTexture && (this._normalmapTexture.coordinatesIndex = this._coordinatesIndex));
  }
  // Aggiorna i materiali con la normalmapTexture
  // La complicazione principale qui è che le normalmap eventualmente devono essere combinate con quelle preesistenti
  // sul materiale. Inoltre, essendo i materiali clonati (per non modificare quelli originari) è necessario controllare
  // che le texture siano pronte
  async setNormalmapTextureAsync(e) {
    var o;
    let t = this._normalmapTexture, s = this._normalmapTexture;
    if (e.get("showOnMesh") && this._originalMeshNormalmapTexture && this._normalmapTexture && (await this.combineMeshNormalmapTexturesAsync(), this._meshCombinedNormalmapTexture && (t = this._meshCombinedNormalmapTexture)), e.get("showOnDesign") && this._originalDesignNormalmapTexture && this._normalmapTexture && (await this.combineDesignNormalmapTexturesAsync(), this._designCombinedNormalmapTexture && (s = this._designCombinedNormalmapTexture)), this._normalmapMaterial && t) {
      t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t);
      const a = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
      e.get("showOnMesh") ? this._normalmapMaterial[a] = t : this.resetMeshNormalmapTexture(), this._mesh.material !== this._normalmapMaterial && (this._mesh.material = this._normalmapMaterial, this._mesh.metadata || (this._mesh.metadata = {}), this._mesh.metadata.originalNormalmapMaterialID = (o = this._originalMaterial) == null ? void 0 : o.id);
    }
    if (this._dynamicMaterial && s) {
      s.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(s);
      const a = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
      e.get("showOnDesign") ? this._dynamicMaterial[a] = s : this.resetDesignNormalmapTexture();
    }
  }
  async combineMeshNormalmapTexturesAsync() {
    !this._originalMeshNormalmapTexture || !this._normalmapTexture || (await ni.whenTextureIsReadyAsync(this._originalMeshNormalmapTexture), await ni.whenTextureIsReadyAsync(this._normalmapTexture), this._meshCombinedNormalmapTexture || (this._meshCombinedNormalmapTexture = new rl(
      "overlayMeshNormal",
      this._textureWidth,
      this._scene,
      this._originalMeshNormalmapTexture,
      this._normalmapTexture
    ), this._meshCombinedNormalmapTexture.refreshRate = 0), this._meshCombinedNormalmapTexture && (this._meshCombinedNormalmapTexture.baseTexture = this._originalMeshNormalmapTexture, this._meshCombinedNormalmapTexture.blendTexture = this._normalmapTexture, await ni.whenTextureIsReadyAsync(this._meshCombinedNormalmapTexture), this._meshCombinedNormalmapTexture.render()));
  }
  resetMeshNormalmapTexture() {
    if (this._normalmapMaterial) {
      const e = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
      this.compareTextures(
        this._normalmapMaterial[e],
        this._originalMeshNormalmapTexture
      ) || (this._originalMeshNormalmapTexture ? this._normalmapMaterial[e] = this._originalMeshNormalmapTexture : this._normalmapMaterial[e] = null);
    }
  }
  resetDesignNormalmapTexture() {
    if (this._dynamicMaterial) {
      const e = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
      this.compareTextures(
        this._dynamicMaterial[e],
        this._originalDesignNormalmapTexture
      ) || (this._originalDesignNormalmapTexture ? this._dynamicMaterial[e] = this._originalDesignNormalmapTexture : this._dynamicMaterial[e] = null);
    }
  }
  async combineDesignNormalmapTexturesAsync() {
    !this._originalDesignNormalmapTexture || !this._normalmapTexture || (await ni.whenTextureIsReadyAsync(this._originalDesignNormalmapTexture), await ni.whenTextureIsReadyAsync(this._normalmapTexture), this._designCombinedNormalmapTexture || (this._designCombinedNormalmapTexture = new rl(
      "overlayDesignNormal",
      this._textureWidth,
      this._scene,
      this._originalDesignNormalmapTexture,
      this._normalmapTexture
    ), this._designCombinedNormalmapTexture.refreshRate = 0), this._designCombinedNormalmapTexture && (this._designCombinedNormalmapTexture.baseTexture = this._originalDesignNormalmapTexture, this._designCombinedNormalmapTexture.blendTexture = this._normalmapTexture, await ni.whenTextureIsReadyAsync(this._designCombinedNormalmapTexture), this._designCombinedNormalmapTexture.render()));
  }
  // INNER SHADOW
  async updateInnerShadowTextureAsync(e) {
    this._dynamicTexture && (await ni.whenTextureIsReadyAsync(this._dynamicTexture), this._innerShadowGenerator ? await this._innerShadowGenerator.updateAsync(this._dynamicTexture, e) : (this._innerShadowGenerator = new zx(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    ), this._innerShadowTexture = await this._innerShadowGenerator.getInnerShadowTextureAsync(
      this._dynamicTexture
    ), this._innerShadowTexture.coordinatesIndex = this._coordinatesIndex));
  }
  async setInnerShadowTextureAsync(e) {
    let t = this._innerShadowTexture;
    this._originalDesignLightmapTexture && this._innerShadowTexture && (await this.combineDesignLightmapTexturesAsync(), this._designCombinedLightmapTexture && (t = this._designCombinedLightmapTexture)), t && (t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t), this.setMaterialLightmap(this._dynamicMaterial, t));
  }
  async combineDesignLightmapTexturesAsync() {
    !this._originalDesignLightmapTexture || !this._innerShadowTexture || (await ni.whenTextureIsReadyAsync(this._originalDesignLightmapTexture), await ni.whenTextureIsReadyAsync(this._innerShadowTexture), this._designCombinedLightmapTexture || (this._designCombinedLightmapTexture = new Qa(
      "overlayDesignLightmaps",
      this._textureWidth,
      this._scene,
      this._originalDesignLightmapTexture,
      this._innerShadowTexture
    ), this._designCombinedLightmapTexture.refreshRate = 0), this._designCombinedLightmapTexture && (this._designCombinedLightmapTexture.baseTexture = this._originalDesignLightmapTexture, this._designCombinedLightmapTexture.blendTexture = this._innerShadowTexture, await ni.whenTextureIsReadyAsync(this._designCombinedLightmapTexture), this._designCombinedLightmapTexture.render()));
  }
  removeInnerShadowTexture() {
    if (this._dynamicMaterial) {
      let e = this.getMaterialLightmap(this._dynamicMaterial), t = this._originalDesignLightmapTexture;
      this.compareTextures(e, t) || this.setMaterialLightmap(this._dynamicMaterial, t);
    }
  }
  // OUTER SHADOW
  async updateOuterShadowTextureAsync(e) {
    this._dynamicTexture && (await ni.whenTextureIsReadyAsync(this._dynamicTexture), this._outerShadowGenerator ? await this._outerShadowGenerator.updateAsync(this._dynamicTexture, e) : (this._outerShadowGenerator = new Fx(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    ), this._outerShadowTexture = await this._outerShadowGenerator.getOuterShadowTextureAsync(
      this._dynamicTexture
    ), this._outerShadowTexture.coordinatesIndex = this._coordinatesIndex));
  }
  async setOuterShadowTextureAsync(e) {
    let t = this._outerShadowTexture;
    this._originalMeshLightmapTexture && this._outerShadowTexture && (await this.combineMeshLightmapTexturesAsync(), this._meshCombinedLightmapTexture && (t = this._meshCombinedLightmapTexture)), t && (t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t), this.setMaterialLightmap(this._normalmapMaterial, t), this._mesh.material !== this._normalmapMaterial && (this._mesh.material = this._normalmapMaterial));
  }
  async combineMeshLightmapTexturesAsync() {
    !this._originalMeshLightmapTexture || !this._outerShadowTexture || this._isDisposed || (await ni.whenTextureIsReadyAsync(this._originalMeshLightmapTexture), await ni.whenTextureIsReadyAsync(this._outerShadowTexture), this._meshCombinedLightmapTexture || (this._meshCombinedLightmapTexture = new Qa(
      "overlayMeshLightmap",
      this._textureWidth,
      this._scene,
      this._originalMeshLightmapTexture,
      this._outerShadowTexture
    ), this._meshCombinedLightmapTexture.refreshRate = 0), this._meshCombinedLightmapTexture && (this._meshCombinedLightmapTexture.baseTexture = this._originalMeshLightmapTexture, this._meshCombinedLightmapTexture.blendTexture = this._outerShadowTexture, await ni.whenTextureIsReadyAsync(this._meshCombinedLightmapTexture), this._meshCombinedLightmapTexture.render()));
  }
  removeOuterShadowTexture() {
    if (this._normalmapMaterial) {
      const e = this.getMaterialLightmap(this._normalmapMaterial), t = this._originalMeshLightmapTexture;
      this.compareTextures(e, t) || this.setMaterialLightmap(this._normalmapMaterial, t);
    }
  }
  compareTextures(e, t) {
    return typeof e > "u" && typeof t > "u" || e === null && t === null ? !0 : !e || !t ? !1 : e === t;
  }
  dataURItoBlob(e) {
    let t = atob(e.split(",")[1]), s = e.split(",")[0].split(":")[1].split(";")[0], o = new ArrayBuffer(t.length), a = new Uint8Array(o);
    for (let g = 0; g < t.length; g++)
      a[g] = t.charCodeAt(g);
    return new Blob([o], { type: s });
  }
  downloadImage(e, t) {
    let s = this.dataURItoBlob(e), o = window.URL.createObjectURL(s), a = t || "image.png", c = document.createElement("a");
    c.download = a, c.innerHTML = "Download File", c.href = o, c.onclick = (g) => {
      document.body.removeChild(c);
    }, c.style.display = "none", c.setAttribute("type", "hidden"), document.body.appendChild(c), c.click();
  }
  setDesignMeshVisibility(e) {
    this._currentVisibliity = e, this._canvasMesh && (this._canvasMesh.isVisible = e);
  }
  getItemsInfo() {
    return this._customizer ? this._customizer.getItemsInfo() : [];
  }
  removeItem(e) {
    this._customizer && this._customizer.removeItemByGuid(e);
  }
  addItemText(e) {
    this._customizer && this._customizer.addTextElement(null, e, !1);
  }
  setItemText(e, t) {
    this._customizer && this._customizer.modifyTextElementContentByGuid(e, t);
  }
  setItemBold(e, t) {
    if (this._customizer) {
      let s = this._customizer.findItemByGuid(e);
      if (s) {
        let a = this._customizer.getTextItemInfo(s).fontWeight.split(" "), c = [a.length > 1 ? a[0] : "normal"];
        c.push(t ? "bold" : "normal"), this._customizer.modifyTextElementFontWeight(s, c.join(" "));
      }
    }
  }
  setItemItalic(e, t) {
    if (this._customizer) {
      let s = this._customizer.findItemByGuid(e);
      if (s) {
        let a = this._customizer.getTextItemInfo(s).fontWeight.split(" "), c = [t ? "italic" : "normal"];
        c.push(a.length > 1 ? a[1] : a[0]), this._customizer.modifyTextElementFontWeight(s, c.join(" "));
      }
    }
  }
  setItemColor(e, t) {
    this._customizer && this._customizer.modifyTextElementFillColorByGuid(e, t);
  }
  setItemFontFamily(e, t) {
    this._customizer && this._customizer.modifyTextElementFontFamilyByGuid(e, t);
  }
  async addItemImage(e) {
    this._customizer && await this._customizer.insertImageById(e);
  }
  async setItemImage(e, t) {
    this._customizer && await this._customizer.replaceImageByGuid(e, t);
  }
  setItemTextOnPath(e, t) {
    if (this._customizer) {
      let s = this._customizer.findItemByGuid(e);
      t ? this._customizer.convertToTextOnPath(s) : this._customizer.convertToTextArea(s);
    }
  }
  removeItemImage(e) {
    this._customizer && this._customizer.removeImageByGuid(e);
  }
  containsItem(e) {
    if (this._customizer) {
      const t = this._customizer.findItemByGuid(e);
      return t != null && t != null;
    }
    return !1;
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  addNotifyMessageListener(e) {
    if (this._customizer) {
      const t = this._customizer;
      let s = Ah(
        (o, a, c, g, w, T, H, Y, ee) => {
          e(
            t.side.getSideID(),
            o,
            a,
            c,
            g,
            w,
            Y.requiredWidth,
            Y.requiredHeight,
            ee
          );
        },
        50
      );
      t.addNotifyMessageListeners(s);
    }
  }
  addRemoveMessageListener(e) {
    if (this._customizer) {
      const t = this._customizer;
      let s = Ah((o) => {
        e(t.side.getSideID(), o);
      }, 50);
      t.addRemoveMessageListeners(s);
    }
  }
  setEventMessages(e) {
    this._customizer && this._customizer.setCustomizedMessages(e);
  }
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t) {
    if (this._meshSide && this._customizer) {
      let c = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
      var s = JSON.parse(c), o = this._customizer.getTranslatedMatrixValues(s, e, t), a = JSON.stringify(o);
      this._meshSide.set("matrix", a);
    }
  }
  rotateDesignView(e, t, s) {
    if (this._meshSide && this._customizer) {
      var o = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values), a = JSON.parse(o), c = this._customizer.getRotatedMatrixValues(a, e, t, s), g = JSON.stringify(c);
      this._meshSide.set("matrix", g);
    }
  }
  scaleDesignView(e, t, s, o) {
    if (this._meshSide && this._customizer) {
      var a = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values), c = JSON.parse(a), g = this._customizer.getScaledMatrixValues(c, e, t, s, o), w = JSON.stringify(g);
      this._meshSide.set("matrix", w);
    }
  }
  async setDesignViewTextureUVChannelAsync(e) {
    this._meshSide && (this._meshSide.set("uvChannel", e), await this.updateDynamicTextureAsync());
  }
  async setDesignViewFormFactorAsync(e, t) {
    this._meshSide && (this._meshSide.set("percWidth", e), this._meshSide.set("percHeight", t), await this.refreshAsync());
  }
  async changeToDynamicTexture() {
    await this.updateDynamicTextureInternalAsync(!0);
  }
  async changeToRasterizedTexture() {
    await this.updateDynamicTextureInternalAsync(!1);
  }
};
Dd.DEFAULT_SIZE = 1024;
let zd = Dd;
class Ux {
  constructor(e, t, s, o, a = !0) {
    this._rotation = 0, this._grids = [], this._meshDesignManagers = [], this._renderingNeededListeners = [], this._designNotifyMessageListeners = [], this._designRemoveMessageListeners = [], this._designEventMessages = [], this._meshDesignManagersRefreshing = /* @__PURE__ */ new Set(), this._scene = e, this._zkScene = t, this._zkModel = s, this._zkDesign = o, this._showDesign = a, this.init();
  }
  get showDesign() {
    return this._showDesign;
  }
  set showDesign(e) {
    this._showDesign != e && (this._showDesign = e, this._meshDesignManagers.forEach((t) => t.showDesign = e));
  }
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation != e && (this._rotation = e, this._meshDesignManagers.forEach((t) => t.rotation = e));
  }
  dispose() {
    this._meshDesignManagers.forEach((e) => e.dispose());
  }
  init() {
  }
  isForModels(e, t, s) {
    return this._scene == e && this._zkModel == t && this._zkDesign == s;
  }
  getDefaultModelScene() {
    if (this._zkModel) {
      let e = this._zkModel.get("scenes").findWhere({ isDefault: !0 });
      if (e)
        return e;
    }
    return null;
  }
  getModelSceneMeshSide(e, t = 0) {
    if (this._scene && this._zkModel) {
      const s = this.getDefaultModelScene();
      if (s)
        for (let o = 0; o < s.get("meshSides").length; o++) {
          let a = s.get("meshSides").at(o);
          if (a.get("meshID") == e && a.get("subMeshID") == t)
            return a;
        }
    }
    return null;
  }
  async refreshAsync() {
    if (this._scene && this._zkModel && this._zkDesign) {
      const e = this.getDefaultModelScene();
      if (e) {
        let t = null, s = null, o = null;
        for (let a = 0; a < this._meshDesignManagers.length; a++) {
          t = this._meshDesignManagers[a];
          let c = !1;
          for (let w = 0; w < e.get("meshSides").length; w++)
            if (o = e.get("meshSides").at(w), o.get("meshID") == t.getMeshID() && o.get("subMeshID") == t.getSubMeshIdx()) {
              c = !0;
              break;
            }
          let g = !0;
          if (c) {
            let w = t.getMeshID();
            w && (s = this._scene.getMeshByID(w), s && (g = s.isVisible));
          }
          (!c || !g) && (t.dispose(), this._meshDesignManagers.splice(a--, 1));
        }
        for (let a = 0; a < e.get("meshSides").length; a++) {
          o = e.get("meshSides").at(a);
          const c = o.get("meshID"), g = o.get("subMeshID");
          c && await this.refreshMeshDesignAsync(c, g);
        }
      }
    }
  }
  isValidEffectForMesh(e, t, s) {
    if (s && s instanceof MPlaza.ModelSceneMeshDesignEffect) {
      const o = s.getParentModel();
      if (o && o instanceof MPlaza.ModelScene)
        return o.isEffectForMesh(e, t, s.get("effectID"));
    }
    return !1;
  }
  async refreshMeshDesignAsync(e, t = 0, s) {
    const o = this._scene.getMeshByID(e);
    console.log("Refreshing design manager", this._rotation);
    let a = s;
    if (s && !this.isValidEffectForMesh(e, t, s) && (a = void 0), o && o.isVisible) {
      let c = null;
      o.subMeshes && o.subMeshes.length > 0 && t >= 0 && t < o.subMeshes.length && (c = o.subMeshes[t]);
      let g = this.getMeshDesignMananger(o, c);
      if (g)
        g.showDesign = this._showDesign, g.rotation = this._rotation, await g.refreshAsync(a);
      else {
        g = await zd.createMeshDesignManagerAsync(
          this._scene,
          this._zkScene,
          o,
          c,
          this._zkModel,
          this._zkDesign,
          this._grids,
          this._showDesign,
          a,
          this.rotation
        ), g.addRenderingNeededListener(() => this.fireRenderingNeededEvent()), g.setEventMessages(this._designEventMessages);
        for (let w of this._designNotifyMessageListeners)
          g.addNotifyMessageListener(w);
        for (let w of this._designRemoveMessageListeners)
          g.addRemoveMessageListener(w);
        this._meshDesignManagers.push(g);
      }
    }
  }
  getMeshDesignMananger(e, t) {
    for (let s = 0; s < this._meshDesignManagers.length; s++) {
      const o = this._meshDesignManagers[s];
      if (o.isForMesh(e, t))
        return o;
    }
    return null;
  }
  clearMeshDesignManagers() {
    this._meshDesignManagers = [];
  }
  setCustomizerGrids(e) {
    this._grids = e, this._meshDesignManagers.forEach((t) => t.setCustomizerGrids(e));
  }
  getItemsInfo() {
    let e = [];
    for (let t = 0; t < this._meshDesignManagers.length; t++) {
      const o = this._meshDesignManagers[t].getItemsInfo();
      for (let a = 0; a < o.length; a++) {
        const c = o[a];
        let g = !1;
        for (let w = 0; w < e.length; w++)
          if (e[w].itemGuid == c.itemGuid) {
            g = !0;
            break;
          }
        g || e.push(c);
      }
    }
    return e;
  }
  async execOnMeshManagersContainingItem(e, t) {
    for (const s of this._meshDesignManagers)
      s.containsItem(e) && await t(s);
  }
  removeItem(e) {
    this.execOnMeshManagersContainingItem(e, async (t) => t.removeItem(e));
  }
  addItemText(e, t) {
    let s = this._meshDesignManagers.find((o) => o.side != null && o.side.get("sideID") === t);
    s && s.addItemText(e);
  }
  async addItemImage(e, t) {
    let s = this._meshDesignManagers.find((o) => o.side != null && o.side.get("sideID") === t);
    s && await s.addItemImage(e);
  }
  setItemText(e, t) {
    this.execOnMeshManagersContainingItem(e, async (s) => s.setItemText(e, t));
  }
  setItemItalic(e, t) {
    this.execOnMeshManagersContainingItem(e, async (s) => s.setItemItalic(e, t));
  }
  setItemBold(e, t) {
    this.execOnMeshManagersContainingItem(e, async (s) => s.setItemBold(e, t));
  }
  setItemColor(e, t) {
    this.execOnMeshManagersContainingItem(e, async (s) => s.setItemColor(e, t));
  }
  setItemFontFamily(e, t) {
    this.execOnMeshManagersContainingItem(e, async (s) => s.setItemFontFamily(e, t));
  }
  async setItemImage(e, t) {
    await this.execOnMeshManagersContainingItem(e, async (s) => s.setItemImage(e, t));
  }
  setItemTextOnPath(e, t, s) {
    const o = this._meshDesignManagers.find(
      (a) => a.side != null && a.side.get("sideID") === t
    );
    o && o.setItemTextOnPath(e, s);
  }
  removeItemImage(e) {
    this.execOnMeshManagersContainingItem(e, async (t) => t.removeItemImage(e));
  }
  setDesignVisibility(e, t) {
    const s = this._scene.getMeshByID(e);
    if (s) {
      const o = this.getMeshDesignMananger(s, s.subMeshes.length > 0 ? s.subMeshes[0] : null);
      o && o.setDesignMeshVisibility(t);
    }
  }
  getDesignItemsJson() {
    let e = "";
    for (let t = 0; t < this._zkDesign.get("designItems").length; t++)
      e && (e += `
`), e += this._zkDesign.get("designItems").at(t).get("json");
    return e;
  }
  getDesignID() {
    return this._zkDesign.getDesignID();
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  addNotifyMessageListener(e) {
    this._designNotifyMessageListeners.push(e);
    for (let t of this._meshDesignManagers)
      t.addNotifyMessageListener(e);
  }
  addRemoveMessageListener(e) {
    this._designRemoveMessageListeners.push(e);
    for (let t of this._meshDesignManagers)
      t.addRemoveMessageListener(e);
  }
  setEventMessages(e) {
    this._designEventMessages = e;
    for (let t of this._meshDesignManagers)
      t.setEventMessages(e);
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t, s, o) {
    const a = this.getMeshDesignMananger(e, t);
    a && a.translateDesignView(s, o);
  }
  rotateDesignView(e, t, s, o, a) {
    const c = this.getMeshDesignMananger(e, t);
    c && c.rotateDesignView(s, o, a);
  }
  scaleDesignView(e, t, s, o, a, c) {
    const g = this.getMeshDesignMananger(e, t);
    g && g.scaleDesignView(s, o, a, c);
  }
  async setDesignViewTextureUVChannelAsync(e, t, s) {
    const o = this.getMeshDesignMananger(e, t);
    o && await o.setDesignViewTextureUVChannelAsync(s);
  }
  async setDesignViewFormFactorAsync(e, t, s, o) {
    const a = this.getMeshDesignMananger(e, t);
    a && await a.setDesignViewFormFactorAsync(s, o);
  }
  // -------------------------------------------------------------
  // Mesh - Side connection
  // -------------------------------------------------------------
  async connectMeshToModelSideAsync(e, t, s) {
    let o = this.getModelSceneMeshSide(e, t);
    if (!o && this._scene && this._zkModel) {
      let a = this._scene.getMeshByID(e);
      if (a && a.subMeshes && a.subMeshes.length > 0 && t >= 0 && t < a.subMeshes.length) {
        a.subMeshes[t];
        let c = this.getDefaultModelScene();
        c && (o = new MPlaza.ModelSceneMeshSide(), o.set("meshID", e), o.set("subMeshID", t), o.set("sideID", s), c.get("meshSides").add(o), await this.refreshAsync());
      }
    }
  }
  expandCanvasMeshes(e) {
    console.log("expandRatio ", e), this._meshDesignManagers.forEach((t) => t.expandCanvasMesh(e));
  }
  contractCanvasMeshes() {
    this._meshDesignManagers.forEach((e) => e.contractCanvasMesh());
  }
  async changeToRasterizedTextures() {
    for (const e of this._meshDesignManagers)
      await e.changeToRasterizedTexture();
    console.log("All tasks for rasterized textures completed.");
  }
  async changeToDynamicTextures() {
    for (const e of this._meshDesignManagers)
      await e.changeToDynamicTexture();
    console.log("All dynamic textures changes completed.");
  }
}
const Ws = "base_model";
class Qw {
  constructor(e, t, s) {
    this._zkModel = e, this._zkScene = t, this._scene = s, this._sceneHelper = new ni(s);
  }
  /**
   * Replace the product model, used when discarding changes
   * @param newModel The new model to replace the current one
   */
  replaceModel(e) {
    this._zkModel = e;
  }
  getOrCreateMaterialsForVariant(e) {
    const t = this.getVariantMeshes(e), s = [];
    return t.forEach((o) => {
      const a = this._scene.getMeshById(o);
      a && a.getChildMeshes().forEach((c) => s.push(c));
    }), this.hasVariantCustomModel(e) ? this.getMaterialsForMeshes(s) : (this.getMaterialsForMeshes(s).forEach((a) => {
      this.isSceneMaterialForVariant(a) || this.setVariableMaterialID(a.id);
    }), this.getVariantMaterials(e));
  }
  // restituisce tutti materiali della scena per cui è possibile specificare se sono
  // variabili o meno in base alle varianti del prodotto. Da tale elenco verranno esclusi
  // tutti i materiali che sono stati già clonati per rappresentare la variazione.
  // verranno esclusi anche tutti i materiali che comunque sono stati marcati (metadata)
  // come materiali creati ad hoc per una preview di prodotto (isForPreview = true)
  // e verranno esclusi tutti i materiali non assegnati a nessuna mesh.
  // Verranno considerati quindi tutti i materiali non clonati assegnati ad almeno una mesh (direttamente
  // o indirettamente)
  getPossibleVariableMaterials() {
    const e = this._sceneHelper.getAllMaterials(), t = [];
    for (let s = 0; s < e.length; s++) {
      const o = e[s], a = this.getMeshesUsingMaterial(o.id), c = this.isSceneMaterialForVariant(o);
      a.length > 0 && !c && t.push(o);
    }
    return t;
  }
  // Restituisce l'elenco dei materiali della scena già selezionati come variabili
  getVariableMaterials() {
    const e = [], t = this._zkModel.getPreview3D();
    if (t) {
      const s = t.getVariantsAttributeOptions();
      if (s)
        for (let o = 0; o < s.get("variableMaterials").length; o++) {
          let a = s.get("variableMaterials").at(o).get("materialID"), c = this._scene.getMaterialById(a);
          c && e.push(c);
        }
    }
    return e;
  }
  getVariableMaterialsSelection() {
    const t = this.getVariableMaterials().map((a) => a.id);
    return this.getPossibleVariableMaterials().map((a) => ({
      id: a.id,
      name: a.name,
      selected: t.indexOf(a.id) != -1
    }));
  }
  getVariantMaterialsWithOriginal(e) {
    const t = [], s = this._zkModel.getPreview3D();
    if (s && e && e instanceof MPlaza.Color) {
      const o = this.getVariantID(e), a = s.getVariantsAttributeOptions();
      if (a) {
        const c = a.getVariantOption(o);
        if (c)
          for (let g = 0; g < c.get("materials").length; g++) {
            const w = c.get("materials").at(g), T = w.get("optionMaterialID"), H = this._scene.getMaterialById(T), Y = w.get("variableMaterialID"), ee = this._scene.getMaterialById(Y);
            H && ee && t.push({ material: H, variableMaterial: ee });
          }
      }
    }
    return t;
  }
  // Per tutti i materiali impostati come variabili, verifica che questi materiali esistano ancora.
  // Se un materiale esiste, aggiorna l'indicazione delle mesh alle quali è impostato e le azioni per opzione.
  // Se un materiale non esiste, lo elimina tra i materiali variabili.
  updateVariableMaterials() {
    const e = this._zkModel.getPreview3D();
    if (e) {
      const t = e.getVariantsAttributeOptions();
      if (t) {
        const s = [], o = [];
        for (let a = 0; a < t.get("variableMaterials").length; a++) {
          const g = t.get("variableMaterials").at(a).get("materialID");
          this._scene.getMaterialById(g) ? s.push(g) : o.push(g);
        }
        s.forEach((a) => this.setVariableMaterialID(a)), o.forEach((a) => this.unsetVariableMaterialID(a));
      }
    }
  }
  // Imposta un materiale come NON variabile per variante. Questo significa che vanno eliminate
  // tutte le eventuali azioni relative al materiale ed eventualmente le opzioni
  unsetVariableMaterialID(e) {
    const t = this._zkModel.getPreview3D();
    if (t) {
      const s = t.getVariantsAttributeOptions();
      if (s) {
        const o = this._zkModel.getAttributeByGuid(s.get("attributeGuid")), a = s.get("variableMaterials").getVariableMaterial(e);
        if (a) {
          const g = this._scene.getMaterialById(e);
          if (g)
            for (let w = 0; w < a.get("meshes").length; w++) {
              const T = this._scene.getMeshById(a.get("meshes")[w]);
              T && this._sceneHelper.applyMaterial(g, T);
            }
        }
        s.removeVariableMaterial(e);
        const c = [];
        for (let g = 0; g < s.get("variantOptions").length; g++) {
          const w = s.get("variantOptions").at(g);
          let T = null;
          o && (T = o.getOptionByGuid(w.get("optionGuid")));
          const H = [];
          for (let Y = 0; Y < w.get("materials").length; Y++) {
            const ee = w.get("materials").at(Y);
            if (ee.get("variableMaterialID") === e) {
              for (let z = 0; z < ee.get("actions").length; z++) {
                const he = ee.get("actions").at(z);
                if (T) {
                  const ne = T.get("actions").getActionByGuid(he.get("actionGuid"));
                  ne && T.get("actions").remove(ne);
                }
              }
              this.deleteSceneMaterial(ee.get("optionMaterialID")), H.push(ee);
            }
          }
          w.get("materials").remove(H), w.get("materials").length === 0 && c.push(w);
        }
        for (let g = 0; g < c.length; g++)
          this.removeVariantOption(s, c[g]);
      }
    }
  }
  // Imposta un materiale come variabile. Vengono generati i materiali cloni per le varie opzioni
  // e create le azioni di trasformazione della scena che impostano il materiale sulle varie mesh
  setVariableMaterialID(e) {
    const t = this._scene.getMaterialById(e);
    if (t) {
      const s = this.getMeshesUsingMaterial(t.id), o = s.map((w) => w.id), c = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions();
      c.setVariableMaterial(e, o);
      const g = [];
      for (let w = 0; w < this._zkModel.get("colors").length; w++) {
        const T = this._zkModel.get("colors").at(w), H = this.getVariantID(T);
        g.push(H), this.checkVariantOption(c, t, s, T);
      }
      for (let w = 0; w < c.get("variantOptions").length; w++) {
        const T = c.get("variantOptions").at(w);
        g.indexOf(T.get("variantID")) === -1 && this.removeVariantOption(c, T);
      }
    }
  }
  getVariantAttribute() {
    const e = this._zkModel.getPreview3D();
    if (!e)
      return null;
    const t = e.getVariantsAttributeOptions();
    if (!t)
      return null;
    let s = null;
    return t.get("attributeGuid") && (s = this._zkModel.getAttributeByGuid(t.get("attributeGuid"))), s || (s = this._zkModel.get("attributes").getAttributeByCode("variants_attribute")), s;
  }
  checkVariantOption(e, t, s, o) {
    const a = this.getVariantID(o);
    let c = e.get("variantOptions").getVariantOption(a);
    c || (c = this.createVariantOption(e, o)), this.checkVariantOptionMaterial(e, c, t, s, o);
  }
  createVariantOption(e, t) {
    const s = this.getVariantID(t), o = this.getOrCreateVariantAttribute(e), a = this.getOrCreateVariantAttributeOption(e, t, o), c = new MPlaza.VariantOption();
    return c.set("variantID", s), c.set("optionGuid", a.get("optionGuid")), e.get("variantOptions").push(c), c;
  }
  removeVariantOption(e, t) {
    const s = this._zkModel.getAttributeByGuid(e.get("attributeGuid"));
    if (s) {
      const o = s.getOptionByGuid(t.get("optionGuid"));
      o && s.get("options").remove(o);
    }
    for (let o = 0; o < t.get("materials").length; o++) {
      const c = t.get("materials").at(o).get("optionMaterialID");
      this.deleteSceneMaterial(c);
    }
    e.get("variantOptions").remove(t);
  }
  getOrCreateVariantAttribute(e) {
    let t = this.getVariantAttribute();
    if (!t) {
      for (let s = 0; s < e.get("variantOptions").length; s++)
        this.removeVariantOption(
          e,
          e.get("variantOptions").at(s)
        );
      t = new MPlaza.Attribute(), t.set("attributeGuid", MPlaza.generateUUID()), t.set("name", "Variants attribute"), t.set("attributeCode", "variants_attribute"), t.set("attributeTypeID", MPlaza.AttributeType.Options), this._zkModel.get("attributes").push(t);
    }
    return e.set("attributeGuid", t.get("attributeGuid")), t;
  }
  getOrCreateVariantAttributeOption(e, t, s) {
    const o = this.getVariantID(t);
    let a = s.getOptionByCode(o);
    return a || (a = new MPlaza.AttributeOption(), a.set("optionCode", o), a.set("name", t.get("name")), s.get("options").push(a)), a;
  }
  getVariantID(e) {
    return `${e.getModelID()}_${e.getColorID()}`;
  }
  checkVariantOptionMaterial(e, t, s, o, a) {
    const c = this.getVariantID(a);
    let g = null;
    for (let w = 0; w < t.get("materials").length; w++) {
      const T = t.get("materials").at(w);
      if (T.get("variableMaterialID") === s.id) {
        g = T;
        break;
      }
    }
    if (!g) {
      let w = this.getSceneMaterialForVariant(c, s.id);
      if (!w) {
        const T = `${s.name} - ${a.get("name")}`;
        w = this.cloneSceneMaterial(s.id, void 0, T), w && this.setupSceneMaterialForVariant(w, c, s.id);
      }
      w && (g = new MPlaza.VariantOptionMaterial(), g.set("optionMaterialID", w.id), g.set("variableMaterialID", s.id), t.get("materials").push(g));
    }
    g && this.checkVariantOptionActions(
      e,
      t,
      g,
      s,
      o,
      a
    );
  }
  // Una materiale creato per una variante viene marcato con dei metadati. Questo significa che i materiali creati in altro modo
  // e con i materiali giusti verrano riconosciuti e utilizzati per le azioni delle opzioni
  setupSceneMaterialForVariant(e, t, s) {
    const o = this.getOrCreateSceneMaterialMetadata(e.id);
    o.isForPreview = !0, o.autoCreate = !0, o.variantID = t, o.variableMaterialID = s;
  }
  getSceneMaterialForVariant(e, t) {
    const s = this._sceneHelper.getAllMaterials();
    for (let o = 0; o < s.length; o++) {
      const a = s[o], c = this.getSceneMaterialMetadata(a.id);
      if (c && c.isForPreview && c.variantID === e && c.variableMaterialID === t)
        return s[o];
    }
    return null;
  }
  isSceneMaterialForVariant(e) {
    if (!e)
      return !1;
    const t = this.getSceneMaterialMetadata(e.id);
    return t && t.isForPreview;
  }
  canDeleteSceneMaterialForVariant(e) {
    if (!e)
      return !1;
    const t = this.getSceneMaterialMetadata(e.id);
    return !t || t.isForPreview === void 0 || t.isForPreview === null || t.autoCreate === void 0 || t.autoCreate === null ? !0 : t.isForPreview && t.autoCreate;
  }
  getSceneMaterialMetadata(e) {
    return this._sceneHelper.getSceneMaterialMetadata(e);
  }
  getOrCreateSceneMaterialMetadata(e) {
    return this._sceneHelper.getOrCreateSceneMaterialMetadata(e);
  }
  removeSceneMaterialMetadata(e) {
    this._sceneHelper.removeSceneMaterialMetadata(e);
  }
  // Clona un materiale
  cloneSceneMaterial(e, t, s) {
    let o = this._scene.getMaterialById(e), a = null;
    if (o) {
      const c = s || `${o.name} - clone`;
      if (a = o.clone(c), a) {
        const g = t || MPlaza.generateUUID();
        a.id = g;
        const w = this._zkScene.getMappingForSceneMaterial(o.id);
        if (w) {
          const T = w.get("libraryMaterialID");
          this._zkScene.mapLibraryMaterial(T, a.id);
          const H = this._sceneHelper.getTexturesForMaterial(a), Y = this._sceneHelper.getTexturesForMaterial(a);
          for (let ee = 0; ee < Y.length; ee++) {
            const z = Y[ee], he = H[ee];
            z.materialMapping = he.materialMapping;
          }
        }
      }
    }
    return a;
  }
  deleteSceneMaterial(e) {
    const t = this._scene.getMaterialByID(e);
    if (t && this.canDeleteSceneMaterialForVariant(t)) {
      this.removeSceneMaterialMetadata(e);
      const s = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(e);
      s && this._zkScene.unregisterShaderMaterial(s), this._zkScene.removeMappingForSceneMaterial(t.id);
      const o = this._sceneHelper.getTexturesExclusivelyForMaterial(t);
      t.dispose();
      for (let a = 0; a < o.length; a++)
        o[a].dispose();
    }
  }
  checkVariantOptionActions(e, t, s, o, a, c) {
    let g = [];
    a.forEach((Y) => g.push(Y.id));
    let w = this.getOrCreateVariantAttribute(e), T = this.getOrCreateVariantAttributeOption(e, c, w);
    for (let Y = 0; Y < a.length; Y++) {
      let ee = a[Y], z = s.get("actions").getActionForMesh(ee.id);
      if (!z) {
        let he = new MPlaza.AttributeSceneAction();
        he.set("name", ""), he.set("actionTypeID", MPlaza.SceneActionType.SetMeshMaterial), he.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), he.set("selector", ee.id), he.set("value", s.get("optionMaterialID")), T.get("actions").push(he), z = new MPlaza.VariantOptionMaterialAction(), z.set("actionGuid", he.get("actionGuid")), z.set("meshID", ee.id), s.get("actions").push(z);
      }
    }
    let H = [];
    for (let Y = 0; Y < s.get("actions").length; Y++) {
      let ee = s.get("actions").at(Y);
      if (g.indexOf(ee.get("meshID")) === -1) {
        let z = T.getActionByGuid(ee.get("actionGuid"));
        z && T.get("actions").remove(z), H.push(ee);
      }
    }
    s.get("actions").remove(H);
  }
  isMaterialReal(e) {
    var o, a;
    const t = ((o = e.metadata) == null ? void 0 : o.isRealMaterial) !== !1 && e.id !== "default material", s = ((a = e.metadata) == null ? void 0 : a.isDesignMaterial) === !0;
    return t && !s;
  }
  getVariantMaterials(e) {
    let t = [];
    const s = this._zkModel.getPreview3D();
    if (s && e && e instanceof MPlaza.Color) {
      const o = this.getVariantID(e), a = s.getVariantsAttributeOptions();
      if (a) {
        const c = a.getVariantOption(o);
        if (c)
          for (let g = 0; g < c.get("materials").length; g++) {
            const T = c.get("materials").at(g).get("optionMaterialID"), H = this._scene.getMaterialById(T);
            H && this.isMaterialReal(H) && t.push(H);
          }
      }
    }
    return t;
  }
  getSelectedAttributeOption(e) {
    let t = {
      attributeID: null,
      attributeGuid: null,
      optionID: null,
      optionGuid: null
    };
    const s = this._zkModel.getPreview3D();
    if (s && e && e instanceof MPlaza.Color) {
      const o = this.getVariantID(e), a = s.getVariantsAttributeOptions();
      if (a && a.get("attributeGuid")) {
        const c = this._zkModel.getAttributeByGuid(a.get("attributeGuid"));
        if (c) {
          const g = a.getVariantOption(o);
          if (g) {
            const w = c.getOptionByGuid(g.get("optionGuid"));
            w && (t.attributeID = c.get("attributeID"), t.attributeGuid = c.get("attributeGuid"), t.optionID = w.get("optionID"), t.optionGuid = w.get("optionGuid"));
          }
        }
      }
    }
    return t;
  }
  resetOriginaMaterialsOnMeshes() {
    const e = this._zkModel.getPreview3D();
    if (e) {
      const t = e.getVariantsAttributeOptions();
      if (t)
        for (let s = 0; s < t.get("variableMaterials").length; s++) {
          const o = t.get("variableMaterials").at(s), a = o.get("materialID"), c = o.get("meshes"), g = this._scene.getMaterialByID(a);
          if (g)
            for (let w = 0; w < c.length; w++) {
              const T = this._scene.getMeshById(o.get("meshes")[w]);
              T && this._sceneHelper.applyMaterial(g, T);
            }
        }
    }
  }
  // Una mesh usa un materiale se sulla mesh è impostato direttamente quel materiale o se sulla mesh è
  // attualmente impostato un materiale creato ad hoc per la preview 3D e che deriva dal materiale in oggetto (clone)
  getMeshesUsingMaterial(e) {
    const t = [], s = this._sceneHelper.getSceneMeshes();
    for (let o = 0; o < s.length; o++) {
      const a = s[o];
      if (this._sceneHelper.isMeshUsingMaterial(a, e))
        t.push(a);
      else {
        const c = this._sceneHelper.getMeshMaterials(a);
        for (let g = 0; g < c.length; g++) {
          const w = c[g], T = this.getSceneMaterialMetadata(w.id);
          if (T && T.isForPreview && T.variableMaterialID && T.variableMaterialID === e) {
            t.push(a);
            break;
          }
        }
      }
    }
    return t;
  }
  getMaterialsForMeshes(e) {
    const t = e.map((o) => typeof o == "string" ? this._scene.getMeshById(o) : o), s = [];
    for (let o = 0; o < t.length; o++) {
      const a = t[o];
      if (a) {
        const c = this._sceneHelper.getMeshMaterials(a);
        for (let g = 0; g < c.length; g++) {
          const w = c[g];
          s.indexOf(w) === -1 && this.isMaterialReal(w) && s.push(w);
        }
      }
    }
    return s;
  }
  // Restituisce l'elenco delle mesh associate ad una variante
  // Se la variante non ha mesh associate, restituisce le mesh base
  getVariantMeshes(e) {
    const t = this._zkModel.getPreview3D();
    if (!t)
      return [Ws];
    const s = t == null ? void 0 : t.getVariantsAttributeOptions();
    if (!s)
      return [Ws];
    const o = this.getVariantID(e), a = s.get("variantOptions").getVariantOption(o);
    if (!a)
      return [Ws];
    const c = a.get("meshes");
    return c.length > 0 ? c : [Ws];
  }
  /**
   * Given a mesh, returns the variant it is associated with.
   * If the mesh is not associated with any variant, it returns null, which would be the base mesh.
   * It is used for AR, to know which variant was used for the measurement.
   * @param meshID The ID of the mesh to get the variant for.
   * @returns The variant associated with the mesh, or null if the mesh is not associated with any variant.
   */
  getVariantByMeshID(e) {
    const t = this._zkModel.getPreview3D();
    if (!t)
      return null;
    const s = t.getVariantsAttributeOptions();
    if (!s)
      return null;
    for (let o = 0; o < this._zkModel.get("colors").length; o++) {
      const a = this._zkModel.get("colors").at(o), c = this.getVariantID(a), g = s.getVariantOption(c);
      if (g && g.get("meshes").indexOf(e) !== -1)
        return a;
    }
    return null;
  }
  /**
   * Check if a variant has custom meshes associated with it.
   * @param modelColor  The color of the variant to check.
   * @returns True if the variant has custom meshes, false otherwise.
   */
  hasVariantCustomModel(e) {
    const t = this.getVariantMeshes(e);
    return !(t.length === 1 && t[0] === Ws);
  }
  /**
   * Set the meshes associated with a variant.
   * @param modelColor The color of the variant to set meshes for.
   * @param meshIDs The list of mesh IDs to set as variant meshes.
   */
  setVariantMeshes(e, t) {
    const o = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), a = this.getVariantID(e);
    let c = o.get("variantOptions").getVariantOption(a);
    c || (c = this.createVariantOption(o, e)), c.set("meshes", t), this.refreshOptionsShowHideVariantModels();
  }
  /**
   * Remove all meshes associated with a variant.
   * @param modelColor The color of the variant to remove meshes from.
   */
  removeVariantMeshes(e) {
    const s = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), o = this.getVariantID(e);
    let a = s.get("variantOptions").getVariantOption(o);
    if (a) {
      const c = a.get("meshes");
      for (const g of c) {
        const w = this._scene.getMeshById(g);
        w == null || w.dispose(!1, !0);
      }
      a.set("meshes", []);
    }
    this.updateVariableMaterials(), this.refreshOptionsShowHideVariantModels();
  }
  /**
   * Set the current base meshes for the scene.
   * @param meshIDs The list of mesh IDs to set as base meshes.
   */
  setBaseMeshes(e) {
    let t = this._scene.getMeshById(Ws);
    t || (t = new BABYLON.Mesh(Ws, this._scene), t.id = Ws);
    for (const s of e) {
      const o = this._scene.getMeshById(s);
      o && o.setParent(t);
    }
  }
  /**
   * Remove current base meshes from the scene.
   */
  removeBaseMeshes() {
    const e = this._scene.getMeshById(Ws);
    if (e) {
      const t = e.getChildMeshes(!0);
      for (const s of t)
        s.setParent(null);
    }
  }
  /**
   * Upgrade an old preview 3D scene to the new base mesh system.
   */
  upgradeToBaseMeshes() {
    this._scene.getMeshById(Ws) !== null || this.setBaseMeshes(
      this._scene.meshes.filter((t) => !t.parent && t.id !== Ws).map((t) => t.id) ?? []
    );
  }
  /**
   * This method will create or update all options by setting the correct show/hide actions
   * to show the base model or the variant model.
   */
  refreshOptionsShowHideVariantModels() {
    const t = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), s = this.getOrCreateVariantAttribute(t);
    for (let o = 0; o < this._zkModel.get("colors").length; o++) {
      const a = this._zkModel.get("colors").at(o), c = this.getVariantID(a);
      let g = t.get("variantOptions").getVariantOption(c);
      g || (g = this.createVariantOption(t, a));
      const w = this.getOrCreateVariantAttributeOption(t, a, s);
      let T = w.get("actions").find(
        (H) => H.get("selector") === "*" && H.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh
      );
      T || (T = new MPlaza.AttributeSceneAction(), T.set("name", ""), T.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), T.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), T.set("selector", "*"), T.set("value", "hide"), w.get("actions").push(T));
      for (let H = 0; H < w.get("actions").length; H++) {
        const Y = w.get("actions").at(H);
        Y.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && Y.get("selector") !== "*" && (w.get("actions").remove(Y), H--);
      }
      if ((g == null ? void 0 : g.get("meshes").length) === 0) {
        const H = new MPlaza.AttributeSceneAction();
        H.set("name", ""), H.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), H.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), H.set("selector", Ws), H.set("value", "show"), w.get("actions").push(H);
      } else
        for (const H of g.get("meshes")) {
          const Y = new MPlaza.AttributeSceneAction();
          Y.set("name", ""), Y.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), Y.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), Y.set("selector", H), Y.set("value", "show"), w.get("actions").push(Y);
        }
    }
  }
  // Design materials
  setDesignMaterialForVariantEnabled(e, t) {
    var g;
    const s = this.hasVariantCustomModel(e) ? e.get("colorID") : null, o = this._zkModel.get("scenes").at(0).get("meshSides").filter((w) => w.get("colorID") === s), a = (g = o.at(0)) == null ? void 0 : g.get("materialID");
    let c = a ? this._scene.getMaterialById(a) : null;
    t || (o.forEach((w) => {
      w.set("materialID", null);
    }), c && (o.some(
      (T) => T.get("materialID") === c.id
    ) || c.dispose())), t && !c && (c = new BABYLON.PBRMaterial("Design material", this._scene), c.id = Zakeke.generateUUID(), c.zOffset = -1, c.metallic = 0.5, c.roughness = 0.2, o.forEach((w) => {
      w.set("materialID", c.id);
    }));
  }
  getDesignMaterialForVariant(e) {
    const t = this.hasVariantCustomModel(e) ? e.get("colorID") : null, s = this._zkModel.get("scenes").at(0).get("meshSides").find((a) => a.get("colorID") === t), o = s ? s.get("materialID") : null;
    return o ? this._scene.getMaterialById(o) : null;
  }
}
function Fd(v) {
  return typeof importScripts == "function" ? (importScripts(v), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(v, () => {
      e();
    }, (s) => {
      t(new Error(s));
    });
  });
}
function Vx(v) {
  return new Promise((e, t) => {
    BABYLON.Tools.LoadFile(v, (s) => {
      e(s);
    }, void 0, void 0, !0, (s, o) => {
      t(o);
    });
  });
}
function Fh(v, e, t) {
  const s = e && v || t;
  if (s)
    return Fd(s).then(() => new Promise((o) => {
      DracoDecoderModule({ wasmBinary: e }).then((a) => {
        o({ module: a });
      });
    }));
}
function Uh(v, e, t, s, o) {
  const a = new v.DecoderBuffer();
  a.Init(e, e.byteLength);
  const c = new v.Decoder();
  let g, w;
  try {
    const H = c.GetEncodedGeometryType(a);
    switch (H) {
      case v.TRIANGULAR_MESH:
        g = new v.Mesh(), w = c.DecodeBufferToMesh(a, g);
        break;
      case v.POINT_CLOUD:
        g = new v.PointCloud(), w = c.DecodeBufferToPointCloud(a, g);
        break;
      default:
        throw new Error(`Invalid geometry type ${H}`);
    }
    if (!w.ok() || !g.ptr)
      throw new Error(w.error_msg());
    const Y = g.num_points();
    if (H === v.TRIANGULAR_MESH) {
      const z = g.num_faces(), he = new v.DracoInt32Array();
      try {
        const ne = new Uint32Array(z * 3);
        for (let ye = 0; ye < z; ye++) {
          c.GetFaceFromMesh(g, ye, he);
          const se = ye * 3;
          ne[se + 0] = he.GetValue(0), ne[se + 1] = he.GetValue(1), ne[se + 2] = he.GetValue(2);
        }
        s(ne);
      } finally {
        v.destroy(he);
      }
    }
    const ee = (z, he) => {
      const ne = new v.DracoFloat32Array();
      try {
        c.GetAttributeFloatForAllPoints(g, he, ne);
        const ye = new Float32Array(Y * he.num_components());
        for (let se = 0; se < ye.length; se++)
          ye[se] = ne.GetValue(se);
        o(z, ye);
      } finally {
        v.destroy(ne);
      }
    };
    if (t)
      for (const z in t) {
        const he = t[z], ne = c.GetAttributeByUniqueId(g, he);
        ee(z, ne);
      }
    else {
      const z = {
        position: "POSITION",
        normal: "NORMAL",
        color: "COLOR",
        uv: "TEX_COORD",
        uv2: "TEX_COORD",
        uv3: "TEX_COORD",
        uv4: "TEX_COORD",
        uv5: "TEX_COORD",
        uv6: "TEX_COORD"
      }, he = /^uv(\d+)$/;
      for (const ne in z) {
        const ye = ne.match(he);
        let se = -1;
        if (ye && ye.length > 1) {
          var T = parseInt(ye[1], 10);
          const _e = c.GetAttributeId(g, v.TEX_COORD);
          _e !== -1 && (se = _e + T - 1);
        } else
          se = c.GetAttributeId(g, v[z[ne]]);
        if (se !== -1) {
          const _e = c.GetAttributeByUniqueId(g, se);
          _e && _e.size() > 0 && ee(ne, _e);
        }
      }
    }
  } finally {
    g && v.destroy(g), v.destroy(c), v.destroy(a);
  }
}
function Hx() {
  let v;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const s = t.decoder;
        v = Fh(s.wasmUrl, s.wasmBinary, s.fallbackUrl), postMessage("done");
        break;
      }
      case "decodeMesh": {
        if (!v)
          throw new Error("Draco decoder module is not available");
        v.then((s) => {
          Uh(s.module, t.dataView, t.attributes, (o) => {
            postMessage({ id: "indices", value: o }, [o.buffer]);
          }, (o, a) => {
            postMessage({ id: o, value: a }, [a.buffer]);
          }), postMessage("done");
        });
        break;
      }
    }
  };
}
function Th(v) {
  return typeof document != "object" || typeof v != "string" ? v : BABYLON.Tools.GetAbsoluteUrl(v);
}
const lo = class Hr {
  /**
   * Returns true if the decoder configuration is available.
   */
  static get DecoderAvailable() {
    const e = Hr.Configuration.decoder;
    return !!(e.wasmUrl && e.wasmBinaryUrl && typeof WebAssembly == "object" || e.fallbackUrl);
  }
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 1);
  }
  /**
   * Default instance for the draco compression object.
   */
  static get Default() {
    return Hr._Default || (Hr._Default = new Hr()), Hr._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  constructor(e = Hr.DefaultNumWorkers) {
    const t = Hr.Configuration.decoder, s = t.wasmUrl && t.wasmBinaryUrl && typeof WebAssembly == "object" ? Vx(Th(t.wasmBinaryUrl)) : Promise.resolve(void 0);
    e && typeof Worker == "function" ? this._workerPoolPromise = s.then((o) => {
      const a = `${Fd}${Fh}${Uh}(${Hx})()`, c = URL.createObjectURL(new Blob([a], { type: "application/javascript" })), g = new Array(e);
      for (let w = 0; w < g.length; w++)
        g[w] = new Promise((T, H) => {
          const Y = new Worker(c), ee = (he) => {
            Y.removeEventListener("error", ee), Y.removeEventListener("message", z), H(he);
          }, z = (he) => {
            he.data === "done" && (Y.removeEventListener("error", ee), Y.removeEventListener("message", z), T(Y));
          };
          Y.addEventListener("error", ee), Y.addEventListener("message", z), Y.postMessage({
            id: "init",
            decoder: {
              wasmUrl: Th(t.wasmUrl),
              wasmBinary: o,
              fallbackUrl: Th(t.fallbackUrl)
            }
          });
        });
      return Promise.all(g).then((w) => new cu(w));
    }) : this._decoderModulePromise = s.then((o) => Fh(t.wasmUrl, o, t.fallbackUrl));
  }
  /**
   * Stop all async operations and release resources.
   */
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : this._decoderModulePromise ? this._decoderModulePromise.then(() => {
    }) : Promise.resolve();
  }
  /**
    * Decode Draco compressed mesh data to vertex data.
    * @param data The ArrayBuffer or ArrayBufferView for the Draco compression data
    * @param attributes A map of attributes from vertex buffer kinds to Draco unique ids
    * @returns A promise that resolves with the decoded vertex data
    */
  decodeMeshAsync(e, t) {
    const s = e instanceof ArrayBuffer ? new Uint8Array(e) : e;
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((o) => new Promise((a, c) => {
        o.push((g, w) => {
          const T = new BABYLON.VertexData(), H = (z) => {
            g.removeEventListener("error", H), g.removeEventListener("message", Y), c(z), w();
          }, Y = (z) => {
            z.data === "done" ? (g.removeEventListener("error", H), g.removeEventListener("message", Y), a(T), w()) : z.data.id === "indices" ? T.indices = z.data.value : T.set(z.data.value, z.data.id);
          };
          g.addEventListener("error", H), g.addEventListener("message", Y);
          const ee = new Uint8Array(s.byteLength);
          ee.set(new Uint8Array(s.buffer, s.byteOffset, s.byteLength)), g.postMessage({ id: "decodeMesh", dataView: ee, attributes: t }, [ee.buffer]);
        });
      }));
    if (this._decoderModulePromise)
      return this._decoderModulePromise.then((o) => {
        const a = new BABYLON.VertexData();
        return Uh(o.module, s, t, (c) => {
          a.indices = c;
        }, (c, g) => {
          a.set(g, c);
        }), a;
      });
    throw new Error("Draco decoder module is not available");
  }
};
lo.Configuration = {
  decoder: {
    //wasmUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_wasm_wrapper.js"),
    //wasmBinaryUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.wasm"),
    //fallbackUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.js")
    /*
    wasmUrl: "https://preview.babylonjs.com/draco_wasm_wrapper_gltf.js",
    wasmBinaryUrl: "https://preview.babylonjs.com/draco_decoder_gltf.wasm",
    fallbackUrl: "https://preview.babylonjs.com/draco_decoder_gltf.js"
    */
    wasmUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_wasm_wrapper.js",
    wasmBinaryUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.wasm",
    fallbackUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.js"
  }
};
lo.DefaultNumWorkers = lo.GetDefaultNumWorkers();
lo._Default = null;
let Yx = lo;
class Ud {
  constructor(e, t, s = !1) {
    this._originalSceneClearColor = null, this._originalCameraAutoRotate = null, this._environmentHelper = null, this._shadowLight = null, this._isHologram = !1, this._zkScene = e, this._scene = t, this._sceneHelper = new ni(this._scene), this._isHologram = s;
  }
  get scene() {
    return this._scene;
  }
  get isHologram() {
    return this._isHologram;
  }
  set isHologram(e) {
    this._isHologram = e, this.update();
  }
  dispose() {
    this._shadowLight && this._shadowLight.dispose(), this._environmentHelper && (this._environmentHelper.dispose(), this._environmentHelper = null), this.removeOldSkybox();
  }
  update() {
    this.configureScene(), this.configureCamera(), this.configureSkybox();
  }
  configureSkybox() {
    this.removeOldSkybox(), this._isHologram || this.createSkybox();
  }
  removeOldSkybox() {
    const e = this.getSkyboxMesh(), t = this.getSkyboxMaterial();
    e && e.dispose(), t && t.dispose();
  }
  createSkybox() {
    var s, o;
    this.getGeneralConfig();
    const e = this.getEnvironmentConfig(), t = this.getSkyboxConfig();
    if (t && t.get("createSkybox") != null && t.get("createSkybox")) {
      e && e.get("sizeAuto") != null && e.get("sizeAuto") != null && typeof e.get("sizeAuto") == "boolean" && e.get("sizeAuto");
      let a = null;
      t.get("size") != null && typeof t.get("size") == "number" && (a = t.get("size"));
      let c = null;
      t.get("texture") != null && typeof t.get("texture") == "string" && (c = t.get("texture"));
      let g = 0;
      t.get("blur") > 0 && (g = t.get("blur"));
      let w = null;
      t.get("extensions") != null && t.get("extensions") != null && Object.prototype.toString.call(t.get("extensions")) === "[object Array]" && ((s = t.get("extensions")) == null ? void 0 : s.length) === 6 && (w = t.get("extensions"));
      let T = null;
      if (t.get("files") != null && t.get("files") != null && Object.prototype.toString.call(t.get("files")) === "[object Array]" && ((o = t.get("files")) == null ? void 0 : o.length) === 6 && (T = t.get("files")), c) {
        let H = null;
        if (c.endsWith(".dds") ? H = BABYLON.CubeTexture.CreateFromPrefilteredData(c, this._scene) : c.endsWith(".hdr") ? H = new BABYLON.HDRCubeTexture(c, this._scene, 256, !1, !0, !1, !0) : c.endsWith(".env") ? H = new BABYLON.CubeTexture(
          c,
          this._scene,
          null,
          !1,
          null,
          void 0,
          null,
          void 0,
          !0,
          void 0,
          !0
        ) : c.endsWith(".basis") ? H = BABYLON.CubeTexture.CreateFromPrefilteredData(c, this._scene) : w && T ? H = new BABYLON.CubeTexture(c, this._scene, w, !1, T, void 0) : H = BABYLON.CubeTexture.CreateFromPrefilteredData(c, this._scene), H) {
          let Y = 1e3;
          a != null && a > 0 ? Y = a : Y = (this._scene.activeCamera.maxZ - this._scene.activeCamera.minZ) / 2;
          const ee = this._scene.createDefaultSkybox(H, !0, Y, g, !1);
          if (ee) {
            ee.metadata = { isSkyboxMesh: !0, isRealMesh: !1 }, ee.doNotSerialize = !0;
            const z = ee.material;
            z && (z.metadata = { isSkyboxMaterial: !0, isRealMaterial: !1 }, z.doNotSerialize = !0);
          }
        }
      }
    }
  }
  getSkyboxMesh() {
    return this._scene.meshes.find((t) => t.metadata && t.metadata.isSkyboxMesh) || null;
  }
  getSkyboxMaterial() {
    let e = this._scene.materials.find((t) => t.metadata && t.metadata.isSkyboxMaterial);
    return e || null;
  }
  getSkyboxTexture() {
    const e = this.getSkyboxMaterial();
    return e ? e.reflectionTexture : null;
  }
  update_OLD() {
    this.configureScene(), this.configureCamera(), this.configureEnvironment();
  }
  configureScene() {
    if (this._scene) {
      if (this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0), this._originalSceneClearColor = this._scene.clearColor.clone(), this._isHologram) {
        this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 1);
        return;
      }
      var e = this.getGeneralConfig();
      if (e) {
        let t = null;
        e.get("backgroundAlpha") != null && e.get("backgroundAlpha") != null && typeof e.get("backgroundAlpha") == "number" && (t = e.get("backgroundAlpha"));
        let s = null;
        if (e.get("backgroundColor") != null && typeof e.get("backgroundColor") == "string" && this.isValidHexColor(e.get("backgroundColor")) && (s = e.get("backgroundColor")), t || s) {
          this._originalSceneClearColor = this._scene.clearColor;
          let o = this._scene.clearColor;
          if (s != null) {
            let a = BABYLON.Color3.FromHexString(s);
            o.r = a.r, o.g = a.g, o.b = a.b;
          }
          t != null && (o.a = t);
        }
      }
    }
  }
  configureEnvironment() {
    if (this._environmentHelper && (this._environmentHelper.dispose(), this._environmentHelper = null), this._shadowLight && (this._shadowLight.dispose(), this._shadowLight = null), this._sceneHelper.countSceneMeshes() != 0) {
      var e = this.buildEnvironmentHelperOptions();
      if (e) {
        this._environmentHelper = this._scene.createDefaultEnvironment(e);
        const t = this.getEnvironmentSceneNodes();
        for (let s = 0; s < t.length; s++) {
          const o = t[s];
          o && (this.setDoNotSerialize(o), o.metadata || (o.metadata = {}), o.metadata.isEnvironmentNode = !0, o instanceof BABYLON.AbstractMesh && (o.isPickable = !1, o.metadata.isRealMesh = !1), o instanceof BABYLON.Material && (o.metadata.isRealMaterial = !1));
        }
      }
    }
  }
  buildEnvironmentHelperOptions() {
    let e = null;
    const t = this.getGeneralConfig(), s = this.getEnvironmentConfig(), o = this.getSkyboxConfig(), a = this.getGroundConfig(), c = this.getCameraConfig();
    let g = null;
    t && t.get("environmentTexture") != null && t.get("environmentTexture") != null && (g = t.get("environmentTexture"));
    let w = null;
    c && c.get("contrast") != null && typeof c.get("contrast") == "number" && (w = c.get("contrast"));
    let T = null;
    c && c.get("exposure") != null && typeof c.get("exposure") == "number" && (T = c.get("exposure"));
    let H = null;
    c && c.get("toneMappingEnabled") != null && typeof c.get("toneMappingEnabled") == "boolean" && (H = c.get("toneMappingEnabled"));
    let Y = null;
    s && s.get("sizeAuto") != null && s.get("sizeAuto") != null && typeof s.get("sizeAuto") == "boolean" && (Y = s.get("sizeAuto"));
    let ee = null;
    s && s.get("mainColor") != null && typeof s.get("mainColor") == "string" && this.isValidHexColor(s.get("mainColor")) && (ee = s.get("mainColor"));
    let z = null;
    a && a.get("size") != null && typeof a.get("size") == "number" && (z = a.get("size"));
    let he = null;
    a && a.get("color") != null && typeof a.get("color") == "string" && this.isValidHexColor(a.get("color")) && (he = a.get("color"));
    let ne = null;
    a && a.get("enableShadow") != null && typeof a.get("enableShadow") == "boolean" && (ne = a.get("enableShadow"));
    let ye = null;
    a && a.get("shadowLevel") != null && typeof a.get("shadowLevel") == "number" && (ye = a.get("shadowLevel"));
    let se = null;
    a && a.get("enableMirror") != null && typeof a.get("enableMirror") == "boolean" && (se = a.get("enableMirror"));
    let _e = null;
    a && a.get("texture") != null && typeof a.get("texture") == "string" && (_e = a.get("texture"));
    let ue = null;
    a && a.get("opacity") != null && typeof a.get("opacity") == "number" && (ue = a.get("opacity"));
    let xe = null;
    a && a.get("mirrorBlurKernel") != null && typeof a.get("mirrorBlurKernel") == "number" && (xe = a.get("mirrorBlurKernel"));
    let Ee = null;
    o && o.get("size") != null && typeof o.get("size") == "number" && (Ee = o.get("size"));
    let K = null;
    o && o.get("color") != null && typeof o.get("color") == "string" && this.isValidHexColor(o.get("color")) && (K = o.get("color"));
    let j = null;
    o && o.get("texture") != null && typeof o.get("texture") == "string" && (j = o.get("texture"));
    let ht = g != null || w != null || T != null || H;
    return (o || a || ht) && (e = e || {
      createSkybox: o && o.get("createSkybox"),
      createGround: a && a.get("createGround")
    }, e.setupImageProcessing = !1, g != null && (e.environmentTexture = g), (e.createSkybox || e.createGround) && (Y != null && (e.sizeAuto = Y), ee != null && (e.mainColor = BABYLON.Color3.FromHexString(ee)), e.createGround && (!e.sizeAuto && z != null && (e.groundSize = z), !e.mainColor && he != null && (e.groundColor = BABYLON.Color3.FromHexString(he)), ne != null && (e.enableGroundShadow = ne), e.enableGroundShadow && this.createShadowLight(), ye != null && (e.groundShadowLevel = ye), se != null && (e.enableGroundMirror = se), _e != null && (e.groundTexture = _e), ue != null && (e.groundOpacity = ue), e.enableGroundMirror && xe != null && (e.groundMirrorBlurKernel = xe)), e.createSkybox && (!e.sizeAuto && Ee != null && (e.skyboxSize = Ee), !e.mainColor && K != null && (e.skyboxColor = BABYLON.Color3.FromHexString(K)), j != null && (e.skyboxTexture = j)), c && (w != null && (e.cameraContrast = w), T != null && (e.cameraExposure = T), H != null && (e.toneMappingEnabled = H)))), e && (!e.environmentTexture && !this._scene.environmentTexture && (e.environmentTexture = Wt.Environment.EnvironmentTextureCDNUrl), e.createGround != null && e.createGround && !e.groundTexture && (e.groundTexture = Wt.Environment.GroundTextureCDNUrl), e.createSkybox != null && e.createSkybox && !e.skyboxTexture && (e.skyboxTexture = Wt.Environment.SkyboxTextureCDNUrl)), e;
  }
  createShadowLight() {
    if (this._shadowLight && (this._shadowLight.dispose(), this._shadowLight = null), this._scene && this._sceneHelper) {
      var e = this._sceneHelper.getSceneBoundingInfo();
      if (e && e.boundingBox) {
        const s = e.boundingBox.vectorsWorld, o = Number(s[1].x - s[0].x), a = Number(s[1].y - s[0].y), c = Number(s[1].z - s[0].z), g = e.boundingBox.centerWorld;
        e.boundingBox.maximumWorld;
        const w = g.x + o * 2.67, T = g.y + a * 4.5, H = g.z + c * 1, Y = new BABYLON.Vector3(w, T, H);
        let z = g.subtract(Y);
        z = BABYLON.Vector3.Normalize(z), z = new BABYLON.Vector3(-2, -3, 1), this._shadowLight = new BABYLON.DirectionalLight("shadowLight", z, this._scene), this._shadowLight.position = Y, this._shadowLight.intensity = 0.1;
        var t = new BABYLON.ShadowGenerator(512, this._shadowLight);
        t.useBlurExponentialShadowMap = !0, t.useKernelBlur = !0, t.usePercentageCloserFiltering = !0, t.blurKernel = 32;
        for (let he = 0; he < this._scene.meshes.length; he++) {
          const ne = this._scene.meshes[he];
          !this.isEnvironmentNode(ne) && this._sceneHelper.isRealMesh(ne) && (ne.receiveShadows = !1, t.addShadowCaster(ne));
        }
      }
    }
  }
  configureCamera() {
    if (!this._scene || !this._scene.activeCamera || !(this._scene.activeCamera instanceof BABYLON.ArcRotateCamera))
      return;
    const e = this.getCameraConfig();
    if (e) {
      const t = this._scene.activeCamera;
      this._originalCameraAutoRotate = t.useAutoRotationBehavior;
      let s = e.get("autoRotate");
      t.useAutoRotationBehavior = s != null && s;
      let o = t.getBehaviorByName("AutoRotation"), a = Number(e.get("rotationSpeed")), c = e.get("changeRotationDirection");
      if (s && a) {
        let g = c ? -1 : 1;
        o.idleRotationSpeed = a * g;
      }
    }
  }
  sanityCheck() {
    return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != null && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
  }
  getSceneConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getSceneConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getGeneralConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGeneralConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getEnvironmentConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getEnvironmentConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getSkyboxConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getSkyboxConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getGroundConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGroundConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getCameraConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getCameraConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  isValidHexColor(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  }
  getEnvironmentSceneNodes() {
    const e = [];
    return this._environmentHelper && (this._environmentHelper.rootMesh && e.push(this._environmentHelper.rootMesh), this._environmentHelper.skybox && e.push(this._environmentHelper.skybox), this._environmentHelper.skyboxMaterial && e.push(this._environmentHelper.skyboxMaterial), this._environmentHelper.skyboxTexture && e.push(this._environmentHelper.skyboxTexture), this._environmentHelper.ground && e.push(this._environmentHelper.ground), this._environmentHelper.groundMaterial && e.push(this._environmentHelper.groundMaterial), this._environmentHelper.groundTexture && e.push(this._environmentHelper.groundTexture), this._environmentHelper.groundMirror && e.push(this._environmentHelper.groundMirror), this._shadowLight && e.push(this._shadowLight)), e;
  }
  isEnvironmentNode(e) {
    const t = this.getEnvironmentSceneNodes();
    for (let s = 0; s < t.length; s++)
      if (e == t[s])
        return !0;
    return !1;
  }
  setDoNotSerialize(e) {
    (e instanceof BABYLON.AbstractMesh || e instanceof BABYLON.Material || e instanceof BABYLON.Light) && (e.doNotSerialize = !0);
  }
  reset() {
    this._scene && (this._originalSceneClearColor && (this._scene.clearColor = this._originalSceneClearColor), this._originalCameraAutoRotate != null && this._scene.activeCamera && this._scene.activeCamera instanceof BABYLON.ArcRotateCamera && (this._scene.activeCamera.useAutoRotationBehavior = this._originalCameraAutoRotate), this._environmentHelper && this._environmentHelper.updateOptions({}));
  }
}
function Vd(v) {
  return typeof importScripts == "function" ? (importScripts(v), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(
      v,
      () => {
        e();
      },
      (s) => {
        t(new Error(s));
      }
    );
  });
}
function Hd(v) {
  if (v.length == 0)
    return Promise.resolve();
  let e = [];
  for (let t = 0; t < v.length; t++)
    e.push(Vd(v[t]));
  return new Promise((t) => {
    Promise.all(e).then(() => t());
  });
}
function Yd(v, e) {
  return v ? v.match(new RegExp(".[^]{1," + e + "}", "g")) : null;
}
function Gd(v, e, t) {
  let s = "scene_" + e + ".babylon", o = v;
  const a = [];
  if (o.length <= 5e6) {
    let g = !1;
    o.length > 180 && o.length <= 1e6 && (o = LZString.compressToUint8Array(o), s = "compressed_" + s, g = !0);
    let w = null;
    if (!g)
      w = new Blob([o], { type: "text/plain" });
    else {
      let T = o.buffer;
      w = new Blob([T]);
    }
    w && a.push({
      name: s,
      blob: w
    });
  } else {
    let g = Yd(o, 8e5);
    if (g)
      for (let w = 0; w < g.length; w++) {
        let T = g[w], H = s + "_part_" + w, Y = !1;
        T.length > 180 && (T = LZString.compressToUint8Array(T), H = "compressed_" + H, Y = !0);
        let ee = null;
        if (!Y)
          ee = new Blob([T], { type: "text/plain" });
        else {
          var c = T.buffer;
          ee = new Blob([c]);
        }
        ee && a.push({
          name: H,
          blob: ee
        }), t(w / g.length * 100);
      }
  }
  return a;
}
function Gx(v) {
  return typeof document != "object" || typeof v != "string" ? v : BABYLON.Tools.GetAbsoluteUrl(v);
}
function jx() {
  let v;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const s = t.urls;
        v = Hd(s), postMessage("done");
        break;
      }
      case "makeBlobs": {
        if (!v)
          throw new Error("Worker not initialized");
        v.then(() => {
          const s = t.json, o = t.version, a = Gd(s, o, (c) => {
            postMessage({ id: "progress", perc: c });
          });
          postMessage({ id: "result", blobInfos: a }), postMessage("done");
        });
        break;
      }
    }
  };
}
const gl = class xa {
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
  }
  /**
   * Default instance for the draco compression object.
   */
  static get Default() {
    return xa._Default || (xa._Default = new xa([])), xa._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  constructor(e, t = xa.DefaultNumWorkers) {
    const s = e.map((o) => Gx(o));
    if (t && typeof Worker == "function") {
      const o = `${Vd}${Hd}${Yd}${Gd}(${jx})()`, a = URL.createObjectURL(new Blob([o], { type: "application/javascript" })), c = new Array(t);
      for (let g = 0; g < c.length; g++)
        c[g] = new Promise((w, T) => {
          const H = new Worker(a), Y = (z) => {
            H.removeEventListener("error", Y), H.removeEventListener("message", ee), T(z);
          }, ee = (z) => {
            z.data === "done" && (H.removeEventListener("error", Y), H.removeEventListener("message", ee), w(H));
          };
          H.addEventListener("error", Y), H.addEventListener("message", ee), H.postMessage({
            id: "init",
            urls: s
          });
        });
      this._workerPoolPromise = Promise.all(c).then((g) => new cu(g));
    }
  }
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : Promise.resolve();
  }
  getSceneBlobsAsync(e, t, s) {
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((o) => new Promise((a, c) => {
        o.push((g, w) => {
          let T = [];
          const H = (ee) => {
            g.removeEventListener("error", H), g.removeEventListener("message", Y), c(ee), w();
          }, Y = (ee) => {
            ee.data === "done" ? (g.removeEventListener("error", H), g.removeEventListener("message", Y), a(T), w()) : ee.data.id === "progress" ? s(ee.data.perc) : ee.data.id === "result" && (T = ee.data.blobInfos);
          };
          g.addEventListener("error", H), g.addEventListener("message", Y), g.postMessage({ id: "makeBlobs", json: e, version: t });
        });
      }));
    throw new Error("SceneToBlob worker is not available");
  }
};
gl.DefaultNumWorkers = gl.GetDefaultNumWorkers();
gl._Default = null;
let Wx = gl;
class Cl {
  static openSceneViewer(e, t, s = !0, o = null) {
    if (this._fallbackInvoked)
      return;
    const a = self.location.toString(), c = new URL(a), g = new URL(e), w = new URLSearchParams(g.search);
    if (c.hash = this._noArViewerSigil, w.set("mode", "ar_preferred"), w.has("disable_occlusion") || w.set("disable_occlusion", "true"), s || w.set("resizable", "false"), o && o.toLowerCase() === "wall" && w.set("enable_vertical_placement", "true"), w.has("sound")) {
      const Y = new URL(w.get("sound"), a);
      w.set("sound", Y.toString());
    }
    if (w.has("link")) {
      const Y = new URL(w.get("link"), a);
      w.set("link", Y.toString());
    }
    const T = `intent://arvr.google.com/scene-viewer/1.0?${w.toString() + "&file=" + encodeURIComponent(
      g.toString()
    )}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(c.toString())};end;`;
    console.log(T);
    const H = () => {
      self.location.hash === this._noArViewerSigil && !this._fallbackInvoked && (this._fallbackInvoked = !0, t && t(), self.history.back());
    };
    self.addEventListener("hashchange", H, { once: !0 }), this._anchor.setAttribute("href", T), this._anchor.setAttribute("target", "_blank"), document.body.appendChild(this._anchor), this._anchor.click();
  }
}
Cl._anchor = document.createElement("a");
Cl._linkOrTitle = /(link|title)(=|&)|(\?|&)(link|title)$/;
Cl._noArViewerSigil = "#model-viewer-no-ar-fallback";
Cl._fallbackInvoked = !1;
class qx {
  constructor(e, t, s) {
    this._meshesInfoPoints = {}, this._infoPoints = [], this._imageUrls = [], this._currentIdx = 0, this._imagePanel = null, this._loadingText = null, this._image = null, this._closeImageButton = null, this._moveNextImageButton = null, this._movePrevImageButton = null, this._isOnMoveNextButton = !1, this._isOnMovePrevButton = !1, this._lastCameraPosition = null, this.onBeforeShowImages = null, this.onAfterShowImages = null, this._infoPointsShown = !0, this._canShowInfoPointsContent = !0, this._infoPointPickedListeners = [], this._infoPointContentShownListeners = [], this._infoPointContentHiddenListeners = [], this._renderingNeededListeners = [], this.CLOSE_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-close' style='fill:§color§'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/g%3E%3C/svg%3E", this.CHEVRON_LEFT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-left'%3E%3Cpath fill='§color§' d='M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z' /%3E%3C/g%3E%3C/svg%3E", this.CHEVRON_RIGHT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-right'%3E%3Cpath fill='§color§' d='M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z' /%3E%3C/g%3E%3C/svg%3E", this._zkScene = e, this._scene = t, this._sceneHelper = new ni(t), this._style = {}, this.setDefaultStyle(), s && this.setStyle(s), this._rootContainer = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", !0, this._scene);
  }
  get infoPointsShown() {
    return this._infoPointsShown;
  }
  get canShowInfoPointsContent() {
    return this._canShowInfoPointsContent;
  }
  set canShowInfoPointsContent(e) {
    this._canShowInfoPointsContent = e, this.hideImages();
  }
  dispose() {
    this._renderingNeededListeners = [], this._rootContainer.dispose();
  }
  setDefaultStyle() {
    this._style.infoPointsStyle = {
      borderColor: "#ffffff",
      innerPointColor: "#ffffff",
      color: "#a01c20",
      highlightColor: "#bb2025"
    }, this._style.imagePanelStyle = {
      backgroundColor: this._scene.clearColor.toHexString(),
      loadingTextColor: "#ffffff",
      buttonsBorderColor: "#a01c20",
      buttonsColor: "#a01c20",
      buttonsBorderHighlightColor: "#bb2025",
      buttonsHighlightColor: "#bb2025",
      buttonsIconColor: "white"
    };
  }
  setStyle(e) {
    e ? (e.infoPointsStyle && (this._style.infoPointsStyle || (this._style.infoPointsStyle = {}), e.infoPointsStyle.borderColor && (this._style.infoPointsStyle.borderColor = e.infoPointsStyle.borderColor), e.infoPointsStyle.innerPointColor && (this._style.infoPointsStyle.innerPointColor = e.infoPointsStyle.innerPointColor), e.infoPointsStyle.color && (this._style.infoPointsStyle.color = e.infoPointsStyle.color), e.infoPointsStyle.highlightColor && (this._style.infoPointsStyle.highlightColor = e.infoPointsStyle.highlightColor)), e.imagePanelStyle && (this._style.imagePanelStyle || (this._style.imagePanelStyle = {}), e.imagePanelStyle.backgroundColor && (this._style.imagePanelStyle.backgroundColor = e.imagePanelStyle.backgroundColor), e.imagePanelStyle.loadingTextColor && (this._style.imagePanelStyle.loadingTextColor = e.imagePanelStyle.loadingTextColor), e.imagePanelStyle.buttonsBorderColor && (this._style.imagePanelStyle.buttonsBorderColor = e.imagePanelStyle.buttonsBorderColor), e.imagePanelStyle.buttonsColor && (this._style.imagePanelStyle.buttonsColor = e.imagePanelStyle.buttonsColor), e.imagePanelStyle.buttonsBorderHighlightColor && (this._style.imagePanelStyle.buttonsBorderHighlightColor = e.imagePanelStyle.buttonsBorderHighlightColor), e.imagePanelStyle.buttonsHighlightColor && (this._style.imagePanelStyle.buttonsHighlightColor = e.imagePanelStyle.buttonsHighlightColor), e.imagePanelStyle.buttonsIconColor && (this._style.imagePanelStyle.buttonsIconColor = e.imagePanelStyle.buttonsIconColor))) : this.setDefaultStyle();
  }
  applyStyle(e) {
    this.setStyle(e), this.refresh();
  }
  showInfoPoints() {
    this.hideImages(), this.getAllInfoPoints().forEach((e) => e.isVisible = !0), this._infoPointsShown = !0, this.fireRenderingNeededEvent();
  }
  hideInfoPoints() {
    this.hideImages(), this.getAllInfoPoints().forEach((e) => e.isVisible = !1), this._infoPointsShown = !1, this.fireRenderingNeededEvent();
  }
  refresh() {
    this.hideImages(), this.refreshInfoPoints(), this.updateGuiElementsStyle(), this.fireRenderingNeededEvent();
  }
  getAllInfoPoints() {
    const e = [];
    for (const t in this._meshesInfoPoints)
      e.push(this._meshesInfoPoints[t]);
    return e;
  }
  refreshInfoPoints() {
    for (let e = 0; e < this._scene.meshes.length; e++) {
      const t = this._scene.meshes[e], s = t.metadata && t.metadata.showInfoPoints && (t.isVisible || t.metadata.forceShowInfoPoints), o = t.material, a = o ? this.getMaterialPhotoUrls(o) : [];
      if (s && a.length > 0) {
        const c = this.getOrCreateMeshInfoPoint(t);
        this.updateInfoPointUrls(c, a);
      } else
        this.removeMeshInfoPoints(t);
    }
  }
  removeMeshInfoPoints(e) {
    this._meshesInfoPoints.hasOwnProperty(e.id) && (this._meshesInfoPoints[e.id].dispose(), delete this._meshesInfoPoints[e.id]);
  }
  getOrCreateMeshInfoPoint(e) {
    if (this._meshesInfoPoints.hasOwnProperty(e.id))
      return this._meshesInfoPoints[e.id];
    const t = this.createMeshInfoPoint(e);
    return this._meshesInfoPoints[e.id] = t, t;
  }
  updateInfoPointUrls(e, t) {
    e.metadata || (e.metadata = {}), e.metadata.urls = t;
  }
  createMeshInfoPoint(e) {
    var o, a, c, g;
    const t = new BABYLON.GUI.Ellipse("infoPoint");
    t.width = "29px", t.height = "29px", t.color = ((o = this._style.infoPointsStyle) == null ? void 0 : o.borderColor) || "#dddddd", t.thickness = 4, t.background = ((a = this._style.infoPointsStyle) == null ? void 0 : a.color) || "#a01c20", t.alpha = 1, t.onPointerEnterObservable.add((w) => {
      var T;
      t.background = ((T = this._style.infoPointsStyle) == null ? void 0 : T.highlightColor) || "#bb2025", this.fireRenderingNeededEvent();
    }), t.onPointerOutObservable.add((w) => {
      var T;
      t.background = ((T = this._style.infoPointsStyle) == null ? void 0 : T.color) || "#a01c20", this.fireRenderingNeededEvent();
    }), this._rootContainer.addControl(t);
    const s = new BABYLON.GUI.Ellipse("innerPoint");
    return s.width = 0.29, s.height = 0.29, s.color = ((c = this._style.infoPointsStyle) == null ? void 0 : c.innerPointColor) || "White", s.thickness = 0, s.background = ((g = this._style.infoPointsStyle) == null ? void 0 : g.innerPointColor) || "White", t.addControl(s), t.linkWithMesh(e), t.linkOffsetY = 0, t.shadowBlur = 6, t.shadowOffsetX = 2, t.shadowOffsetY = 2, t.isPointerBlocker = !0, t.hoverCursor = "pointer", t.onPointerClickObservable.add((w) => {
      if (t.metadata && t.metadata.urls) {
        const T = {
          meshID: e.id,
          materialID: e.material ? e.material.id : null,
          materialPhotoUrl: t.metadata.urls
        };
        this.fireInfoPointPickedEvent(T), this.showImages(t.metadata.urls);
      }
      this.fireRenderingNeededEvent();
    }), t;
  }
  getMaterialInfoPoint(e) {
    for (let t = 0; t < this._infoPoints.length; t++) {
      const s = this._infoPoints[t];
      if (s.metadata && s.metadata.materialID && s.metadata.materialID === e)
        return s;
    }
    return null;
  }
  getMaterialPhotoUrls(e) {
    return this._zkScene.get("materialPhotos").getMaterialPhotoUrls(e.id);
  }
  getOrCreateImagePanel() {
    return this._imagePanel || this.createImagePanel(), this._imagePanel;
  }
  createImagePanel() {
    var t;
    const e = new BABYLON.GUI.Rectangle("imagePanel");
    return e.background = ((t = this._style.imagePanelStyle) == null ? void 0 : t.backgroundColor) || this._scene.clearColor.toHexString(), e.width = 1, e.height = 1, e.zIndex = 1e4, e.isVisible = !1, this._imagePanel = e, this._rootContainer.addControl(e), this.addCloseButton(e), this.addMoveNextImageButton(e), this.addMovePrevImageButton(e), e;
  }
  addCloseButton(e) {
    var a, c, g;
    const t = new BABYLON.GUI.StackPanel("closePanel");
    t.height = "48px", t.width = "48px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_TOP, t.isVertical = !1, t.zIndex = 10003, e.addControl(t);
    const s = new BABYLON.GUI.Rectangle("closeRect");
    s.width = "24px", s.height = "24px", s.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, s.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, s.background = ((a = this._style.imagePanelStyle) == null ? void 0 : a.buttonsColor) || "#a01c20", s.color = ((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsBorderColor) || "#a01c20", s.isPointerBlocker = !0, s.hoverCursor = "pointer", s.onPointerEnterObservable.add((w) => {
      var T, H;
      s.background = ((T = this._style.imagePanelStyle) == null ? void 0 : T.buttonsHighlightColor) || "#bb2025", s.color = ((H = this._style.imagePanelStyle) == null ? void 0 : H.buttonsBorderHighlightColor) || "#bb2025", this.fireRenderingNeededEvent();
    }), s.onPointerOutObservable.add((w) => {
      var T, H;
      s.background = ((T = this._style.imagePanelStyle) == null ? void 0 : T.buttonsColor) || "#a01c20", s.color = ((H = this._style.imagePanelStyle) == null ? void 0 : H.buttonsBorderColor) || "#a01c20", this.fireRenderingNeededEvent();
    }), s.onPointerClickObservable.add((w) => {
      this.hideImages(), this.fireRenderingNeededEvent();
    }), t.addControl(s);
    const o = new BABYLON.GUI.Image("close", this.getCloseSvg(((g = this._style.imagePanelStyle) == null ? void 0 : g.buttonsIconColor) || "white"));
    o.width = 1, o.height = 1, o.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, s.addControl(o), this._closeImageButton = t;
  }
  addMoveNextImageButton(e) {
    var a, c, g;
    const t = new BABYLON.GUI.StackPanel("rightPanel");
    t.width = "48px", t.height = "48px", t.paddingRight = "24px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, t.isVertical = !1, t.zIndex = 10003, t.alpha = 0.3, t.isVisible = !1, e.addControl(t);
    const s = new BABYLON.GUI.Rectangle("rightRect");
    s.width = "24px", s.height = "48px", s.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, s.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, s.background = ((a = this._style.imagePanelStyle) == null ? void 0 : a.buttonsColor) || "#a01c20", s.color = ((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsBorderColor) || "#a01c20", s.isPointerBlocker = !0, s.hoverCursor = "pointer", s.onPointerEnterObservable.add((w) => {
      var T, H;
      this._isOnMoveNextButton = !0, s.background = ((T = this._style.imagePanelStyle) == null ? void 0 : T.buttonsHighlightColor) || "#bb2025", s.color = ((H = this._style.imagePanelStyle) == null ? void 0 : H.buttonsBorderHighlightColor) || "#bb2025", this.updateMoveNextImageButton(), this.fireRenderingNeededEvent();
    }), s.onPointerOutObservable.add((w) => {
      var T, H;
      this._isOnMoveNextButton = !1, s.background = ((T = this._style.imagePanelStyle) == null ? void 0 : T.buttonsColor) || "#a01c20", s.color = ((H = this._style.imagePanelStyle) == null ? void 0 : H.buttonsBorderColor) || "#a01c20", this.updateMoveNextImageButton(), this.fireRenderingNeededEvent();
    }), s.onPointerClickObservable.add((w) => {
      this.moveNextImage(), this.fireRenderingNeededEvent();
    }), t.addControl(s);
    const o = new BABYLON.GUI.Image("move-next", this.getChevronRightSvg(((g = this._style.imagePanelStyle) == null ? void 0 : g.buttonsIconColor) || "white"));
    o.width = 1, o.height = 1, o.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, o.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, s.addControl(o), this._moveNextImageButton = t;
  }
  addMovePrevImageButton(e) {
    var a, c, g;
    const t = new BABYLON.GUI.StackPanel("leftPanel");
    t.width = "48px", t.height = "48px", t.paddingLeft = "24px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, t.isVertical = !1, t.alpha = 0.3, t.zIndex = 10003, t.isVisible = !1, e.addControl(t);
    const s = new BABYLON.GUI.Rectangle("leftRect");
    s.width = "24px", s.height = "48px", s.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, s.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, s.background = ((a = this._style.imagePanelStyle) == null ? void 0 : a.buttonsColor) || "#a01c20", s.color = ((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsBorderColor) || "#a01c20", s.isPointerBlocker = !0, s.hoverCursor = "pointer", s.onPointerEnterObservable.add((w) => {
      var T, H;
      this._isOnMovePrevButton = !0, s.background = ((T = this._style.imagePanelStyle) == null ? void 0 : T.buttonsHighlightColor) || "#bb2025", s.color = ((H = this._style.imagePanelStyle) == null ? void 0 : H.buttonsBorderHighlightColor) || "#bb2025", this.updateMovePrevImageButton(), this.fireRenderingNeededEvent();
    }), s.onPointerOutObservable.add((w) => {
      var T, H;
      this._isOnMovePrevButton = !1, s.background = ((T = this._style.imagePanelStyle) == null ? void 0 : T.buttonsColor) || "#a01c20", s.color = ((H = this._style.imagePanelStyle) == null ? void 0 : H.buttonsBorderColor) || "#a01c20", this.updateMovePrevImageButton(), this.fireRenderingNeededEvent();
    }), s.onPointerClickObservable.add((w) => {
      this.movePrevImage(), this.fireRenderingNeededEvent();
    }), t.addControl(s);
    const o = new BABYLON.GUI.Image("move-prev", this.getChevronLeftSvg(((g = this._style.imagePanelStyle) == null ? void 0 : g.buttonsIconColor) || "white"));
    o.width = 1, o.height = 1, o.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, o.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, s.addControl(o), this._movePrevImageButton = t;
  }
  updateMoveNextImageButton() {
    this._moveNextImageButton && (this._imageUrls.length <= 1 ? this._moveNextImageButton.isVisible = !1 : (this._moveNextImageButton.isVisible = !0, this._moveNextImageButton.alpha = this.canMoveNextImage() ? this._isOnMoveNextButton ? 1 : 0.3 : 0.1));
  }
  updateMovePrevImageButton() {
    this._movePrevImageButton && (this._imageUrls.length <= 1 ? this._movePrevImageButton.isVisible = !1 : (this._movePrevImageButton.isVisible = !0, this._movePrevImageButton.alpha = this.canMovePrevImage() ? this._isOnMovePrevButton ? 1 : 0.3 : 0.1));
  }
  showImages(e) {
    this._canShowInfoPointsContent && (this._currentIdx = 0, this._imageUrls = e, this._isOnMoveNextButton = !1, this._isOnMovePrevButton = !1, this.getOrCreateImagePanel(), this._imagePanel && (this.onBeforeShowImages && this.onBeforeShowImages(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this._imagePanel.isVisible = !0, this.showCurrentImage(), this.fireInfoPointContentShownEvent()), this.fireRenderingNeededEvent());
  }
  moveNextImage() {
    this.canMoveNextImage() && (this._currentIdx++, this.showCurrentImage(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this.fireRenderingNeededEvent());
  }
  movePrevImage() {
    this.canMovePrevImage() && (this._currentIdx--, this.showCurrentImage(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this.fireRenderingNeededEvent());
  }
  showCurrentImage() {
    this._currentIdx >= 0 && this._currentIdx < this._imageUrls.length && this.showImage(this._imageUrls[this._currentIdx]);
  }
  canMoveNextImage() {
    return this._imageUrls.length > 0 && this._currentIdx < this._imageUrls.length - 1;
  }
  canMovePrevImage() {
    return this._imageUrls.length > 0 && this._currentIdx > 0;
  }
  hideImages() {
    this._imagePanel && (this._imagePanel.isVisible = !1, this.onAfterShowImages && this.onAfterShowImages(), this.fireInfoPointContentHiddenEvent(), this.fireRenderingNeededEvent());
  }
  showImage(e) {
    if (this._imagePanel) {
      this._image && (this._imagePanel.removeControl(this._image), this._image.isVisible = !1, this._image.dispose(), this._image = null), this.showLoadingText();
      const t = new BABYLON.GUI.Image("but", e);
      t.width = 1, t.height = 1, t.isVisible = !0, t.zIndex = 10002, t.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, t.onImageLoadedObservable.add((s) => {
        this.hideLoadingText();
      }), this._imagePanel.addControl(t), this._image = t, this.fireRenderingNeededEvent();
    }
  }
  /**
   * Update info points visibility and return true if at least one info point has been updated.
   * 
   * @return {boolean} Return true if any info point has been updated.
   */
  updateInfoPointsVisibility() {
    let e = !1;
    if (this._scene.activeCamera && (!this._lastCameraPosition || !this._lastCameraPosition.equals(this._scene.activeCamera.position))) {
      this._lastCameraPosition = this._scene.activeCamera.position.clone();
      for (const t in this._meshesInfoPoints) {
        const s = this._scene.getMeshByID(t);
        s && (this.updateMeshInfoPointVisibility(s, this._meshesInfoPoints[t]), e = !0);
      }
    }
    return e;
  }
  drawRay(e, t) {
    let s = t.subtract(e);
    s = s.normalize();
    const o = t.subtract(e).length() * 2, a = new BABYLON.Ray(e, s, o);
    BABYLON.RayHelper.CreateAndShow(a, this._scene, new BABYLON.Color3(1, 1, 0.1));
  }
  updateMeshInfoPointVisibility(e, t) {
    if (this._scene.activeCamera) {
      const s = this._sceneHelper.getMeshHierarchyCenter(e), o = this._scene.activeCamera.position;
      let a = s.subtract(o);
      a = a.normalize();
      const c = s.subtract(o).length() * 2, g = new BABYLON.Ray(o, a, c), w = this._scene.pickWithRay(g);
      w && w.pickedMesh && (t.alpha = w.pickedMesh === e ? 1 : 0.2);
    }
  }
  getCloseSvg(e) {
    return this.getSvg(this.CLOSE_SVG, e);
  }
  getChevronLeftSvg(e) {
    return this.getSvg(this.CHEVRON_LEFT_SVG, e);
  }
  getChevronRightSvg(e) {
    return this.getSvg(this.CHEVRON_RIGHT_SVG, e);
  }
  getSvg(e, t) {
    return e.replace("§color§", encodeURIComponent(t));
  }
  // -------------------------------------------------------------
  // Events 
  // -------------------------------------------------------------
  // picked
  fireInfoPointPickedEvent(e) {
    for (let t = 0; t < this._infoPointPickedListeners.length; t++)
      this._infoPointPickedListeners[t](e);
  }
  addInfoPointPickedListener(e) {
    this._infoPointPickedListeners.push(e);
  }
  addInfoPointPickedListenerRange(e) {
    this._infoPointPickedListeners.push(...e);
  }
  // Content shown
  fireInfoPointContentShownEvent() {
    for (let e = 0; e < this._infoPointContentShownListeners.length; e++)
      this._infoPointContentShownListeners[e]();
  }
  addInfoPointContentShownListener(e) {
    this._infoPointContentShownListeners.push(e);
  }
  addInfoPointContentShownListenerRange(e) {
    this._infoPointContentShownListeners.push(...e);
  }
  // content hidden
  fireInfoPointContentHiddenEvent() {
    for (let e = 0; e < this._infoPointContentHiddenListeners.length; e++)
      this._infoPointContentHiddenListeners[e]();
  }
  addInfoPointContentHiddenListener(e) {
    this._infoPointContentHiddenListeners.push(e);
  }
  addInfoPointContentHiddenListenerRange(e) {
    this._infoPointContentHiddenListeners.push(...e);
  }
  // Rendering Needed
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  showLoadingText() {
    var e;
    if (this._loadingText) {
      this._loadingText.isVisible = !0;
      return;
    }
    this._imagePanel && (this._loadingText = new BABYLON.GUI.TextBlock("loading"), this._loadingText.text = "Loading...", this._loadingText.left = 0.5, this._loadingText.top = 0.7, this._loadingText.zIndex = 10001, this._loadingText.color = ((e = this._style.imagePanelStyle) == null ? void 0 : e.loadingTextColor) || "white", this._imagePanel.addControl(this._loadingText), this.fireRenderingNeededEvent());
  }
  hideLoadingText() {
    this._loadingText && (this._loadingText.isVisible = !1), this.fireRenderingNeededEvent();
  }
  updateGuiElementsStyle() {
    this.updateMeshInfoPointsStyle(), this.updateImagePanelStyle(), this.fireRenderingNeededEvent();
  }
  updateMeshInfoPointsStyle() {
    this.getAllInfoPoints().forEach((e) => {
      var s, o, a;
      e.color = ((s = this._style.infoPointsStyle) == null ? void 0 : s.borderColor) || "#dddddd", e.background = ((o = this._style.infoPointsStyle) == null ? void 0 : o.color) || "#a01c20";
      const t = e.getChildByName("innerPoint");
      t && t instanceof BABYLON.GUI.Container && (t.background = ((a = this._style.infoPointsStyle) == null ? void 0 : a.innerPointColor) || "White");
    });
  }
  updateImagePanelStyle() {
    var e, t, s, o, a, c, g, w;
    if (this._imagePanel) {
      this._imagePanel.background = ((e = this._style.imagePanelStyle) == null ? void 0 : e.backgroundColor) || this._scene.clearColor.toHexString();
      const T = this._imagePanel.getChildByName("closePanel");
      if (T && T instanceof BABYLON.GUI.Container) {
        const ee = T.getChildByName("closeRect");
        ee && ee instanceof BABYLON.GUI.Container && (ee.background = ((t = this._style.imagePanelStyle) == null ? void 0 : t.buttonsColor) || "#a01c20", ee.color = ((s = this._style.imagePanelStyle) == null ? void 0 : s.buttonsBorderColor) || "#a01c20");
      }
      const H = this._imagePanel.getChildByName("rightPanel");
      if (H && H instanceof BABYLON.GUI.Container) {
        const ee = H.getChildByName("rightRect");
        ee && ee instanceof BABYLON.GUI.Container && (ee.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", ee.color = ((a = this._style.imagePanelStyle) == null ? void 0 : a.buttonsBorderColor) || "#a01c20");
      }
      const Y = this._imagePanel.getChildByName("leftPanel");
      if (Y && Y instanceof BABYLON.GUI.Container) {
        const ee = Y.getChildByName("leftRect");
        ee && ee instanceof BABYLON.GUI.Container && (ee.background = ((c = this._style.imagePanelStyle) == null ? void 0 : c.buttonsColor) || "#a01c20", ee.color = ((g = this._style.imagePanelStyle) == null ? void 0 : g.buttonsBorderColor) || "#a01c20");
      }
      this._loadingText && (this._loadingText.color = ((w = this._style.imagePanelStyle) == null ? void 0 : w.loadingTextColor) || "white");
    }
  }
}
var jd = /* @__PURE__ */ ((v) => (v[v.NotSelected = 0] = "NotSelected", v[v.Eyewear = 1] = "Eyewear", v[v.Scarves = 2] = "Scarves", v[v.Earrings = 3] = "Earrings", v[v.Headwear = 4] = "Headwear", v[v.Necklace = 5] = "Necklace", v[v.Shoes = 6] = "Shoes", v[v.Watches = 7] = "Watches", v[v.Bracelet = 8] = "Bracelet", v))(jd || {}), Wd = /* @__PURE__ */ ((v) => (v[v.NotSelected = 0] = "NotSelected", v[v.Mazing = 1] = "Mazing", v[v.Banuba = 2] = "Banuba", v[v.DeepAR = 3] = "DeepAR", v))(Wd || {}), Or = /* @__PURE__ */ ((v) => (v.VirtualTryOn = "try_on", v.GlassPupillaryDistanceTool = "pd", v.StyleButton = "styleButton", v.MandatoryPupillaryDistance = "mandatoryPD", v))(Or || {}), Zx = /* @__PURE__ */ ((v) => (v.Neutral = "neutral.hdr", v.Light = "light.hdr", v.Bright = "bright.hdr", v.Studio = "studio.hdr", v.Court = "court.hdr", v))(Zx || {}), Xx = /* @__PURE__ */ ((v) => (v.ViewProduct = "VIEW_PRODUCT", v.ViewArProdutc = "VIEW_AR_PRODUCT", v))(Xx || {}), Kx = (
  /** @class */
  function() {
    function v(e) {
      var t = this;
      if (this._axisRoot = null, this._axes = [], this._sceneEditor = e, !e.engine)
        throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
      var s = e.engine;
      if (!e.scene)
        throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
      this._editorScene = e.scene, this._scene = new BABYLON.Scene(s), this._scene.autoClear = !1, this._scene.postProcessesEnabled = !1, this._sceneEditor.addPreUpdateListener(function() {
        return t.onPreUpdate();
      }), this._sceneEditor.addPostUpdateListener(function() {
        return t.onPostUpdate();
      }), this.createAxes();
    }
    return v.prototype.dispose = function() {
      this._scene && (this._scene.dispose(), delete this._scene);
    }, v.prototype.onPreUpdate = function() {
      if (this._scene) {
        var e = this._editorScene.activeCamera;
        if (e && (this._scene.activeCamera = e, this._axisRoot)) {
          var t = BABYLON.Vector3.Distance(e.position, this._axisRoot.position) * 0.03;
          this._axisRoot.scaling = new BABYLON.Vector3(t, t, t), this._axisRoot.computeWorldMatrix(!0);
        }
      }
    }, v.prototype.onPostUpdate = function() {
    }, v.prototype.createAxes = function() {
      var e = this, t = 10, s = this._scene, o = new BABYLON.Mesh("axisRoot", s);
      o.isVisible = this._sceneEditor.canShowAxes();
      var a = function(ee, z, he) {
        var ne = new BABYLON.DynamicTexture("DynamicTexture", 50, s, !0);
        ne.hasAlpha = !0, ne.drawText(ee, 5, 40, "bold 36px Arial", z, "transparent", !0);
        var ye = BABYLON.MeshBuilder.CreatePlane("TextPlane", { size: he, updatable: !0 }, s), se = new BABYLON.StandardMaterial("TextPlaneMaterial", s);
        return se.metadata = { isRealMaterial: !1 }, se.backFaceCulling = !1, se.specularColor = new BABYLON.Color3(0, 0, 0), se.diffuseTexture = ne, ye.material = se, ye.metadata = { isRealMesh: !1, isAxis: !0 }, ye.parent = o, ye.isVisible = e._sceneEditor.canShowAxes(), ye;
      }, c = BABYLON.Mesh.CreateLines("axisX", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(t, 0, 0),
        new BABYLON.Vector3(t * 0.95, 0.05 * t, 0),
        new BABYLON.Vector3(t, 0, 0),
        new BABYLON.Vector3(t * 0.95, -0.05 * t, 0)
      ], s);
      c.metadata = { isRealMesh: !1, isAxis: !0 }, c.color = new BABYLON.Color3(1, 0, 0), c.parent = o, c.isVisible = this._sceneEditor.canShowAxes();
      var g = a("X", "red", t / 10);
      g.position = new BABYLON.Vector3(0.9 * t, -0.05 * t, 0);
      var w = BABYLON.Mesh.CreateLines("axisY", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(0, t, 0),
        new BABYLON.Vector3(-0.05 * t, t * 0.95, 0),
        new BABYLON.Vector3(0, t, 0),
        new BABYLON.Vector3(0.05 * t, t * 0.95, 0)
      ], s);
      w.metadata = { isRealMesh: !1, isAxis: !0 }, w.color = new BABYLON.Color3(0, 1, 0), w.parent = o, w.isVisible = this._sceneEditor.canShowAxes();
      var T = a("Y", "green", t / 10);
      T.position = new BABYLON.Vector3(0, 0.9 * t, -0.05 * t);
      var H = BABYLON.Mesh.CreateLines("axisZ", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(0, 0, t),
        new BABYLON.Vector3(0, -0.05 * t, t * 0.95),
        new BABYLON.Vector3(0, 0, t),
        new BABYLON.Vector3(0, 0.05 * t, t * 0.95)
      ], s);
      H.metadata = { isRealMesh: !1, isAxis: !0 }, H.color = new BABYLON.Color3(0, 0, 1), H.parent = o, H.isVisible = this._sceneEditor.canShowAxes();
      var Y = a("Z", "blue", t / 10);
      Y.position = new BABYLON.Vector3(0, 0.05 * t, 0.9 * t), this._axisRoot = o, this._axes.push(o, c, w, H, g, T, Y);
    }, v.prototype.refresh = function() {
      for (var e = 0; e < this._axes.length; e++) {
        var t = this._axes[e];
        t.isVisible = this._sceneEditor.canShowAxes();
      }
    }, v.prototype.render = function() {
      this._scene && this._scene.activeCamera && this._scene.render();
    }, v.prototype.getScene = function() {
      return this._scene;
    }, v;
  }()
), Jx = (
  /** @class */
  function() {
    function v(e) {
      var t = this;
      if (this._lightMeshes = [], this._lightSelectedListeners = [], this._sceneEditor = e, !e.engine)
        throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
      var s = e.engine;
      if (!e.scene)
        throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
      this._editorScene = e.scene, this._scene = new BABYLON.Scene(s), this._scene.autoClear = !1, this._scene.postProcessesEnabled = !1, this._scene.onPointerDown = this.onPointerDown, this._sceneEditorPreUpdate = function() {
        return t.onPreUpdate();
      }, this._sceneEditorPostUpdate = function() {
        return t.onPostUpdate();
      }, this._sceneEditor.addPreUpdateListener(this._sceneEditorPreUpdate), this._sceneEditor.addPostUpdateListener(this._sceneEditorPostUpdate);
    }
    return v.prototype.dispose = function() {
      this._sceneEditor && (this._sceneEditor.removePreUpdateListener(this._sceneEditorPreUpdate), this._sceneEditor.removePostUpdateListener(this._sceneEditorPostUpdate)), this._scene && (this._scene.dispose(), delete this._scene);
    }, v.prototype.onPreUpdate = function() {
      this._scene.activeCamera = this._editorScene.activeCamera;
    }, v.prototype.onPostUpdate = function() {
      this._scene.getEngine();
      for (var e = 0; e < this._lightMeshes.length; e++) {
        var t = this._lightMeshes[e], s = this._editorScene.getLightByID(t.id);
        s && this.configureLightMesh(t, s);
      }
    }, v.prototype.onPointerDown = function(e, t, s) {
      if (t.hit && t.pickedMesh) {
        var o = { name: t.pickedMesh.name, id: t.pickedMesh.id };
        this.fireLightSelectedEvent(o);
      }
    }, v.prototype.refresh = function() {
      this.updateLightMeshes();
    }, v.prototype.updateLightMeshes = function() {
      if (this._scene && this._sceneEditor) {
        for (var e = 0; e < this._editorScene.lights.length; e++) {
          var t = this._editorScene.lights[e], s = this._scene.getMeshByID(t.id);
          s ? this.configureLightMesh(s, t) : this._lightMeshes.push(this.createLightMesh(t));
        }
        for (var e = 0; e < this._lightMeshes.length; e++) {
          var s = this._lightMeshes[e], t = this._editorScene.getLightByID(s.id);
          t || (s.dispose(), this._lightMeshes.splice(e--, 1));
        }
      }
    }, v.prototype.createLightMesh = function(e) {
      var t = new BABYLON.Texture(v._lightTexture, this._scene);
      t.hasAlpha = !0;
      var s = new BABYLON.StandardMaterial("LightMeshMaterial_" + e.id, this._scene);
      s.emissiveColor = BABYLON.Color3.White(), s.useAlphaFromDiffuseTexture = !0, s.disableDepthWrite = !1, s.diffuseTexture = t;
      var o = BABYLON.Mesh.CreatePlane(e.name, 1, this._scene);
      return o.id = e.id, o.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL, o.material = s, this.configureLightMesh(o, e), o;
    }, v.prototype.clearLightMeshes = function() {
      if (this._scene)
        for (; this._lightMeshes.length > 0; ) {
          var e = this._lightMeshes.pop();
          e && e.dispose();
        }
    }, v.prototype.configureLightMesh = function(e, t) {
      var s = this._editorScene.activeCamera;
      if (s && e && t) {
        e.position = t.getAbsolutePosition();
        var o = BABYLON.Vector3.Distance(s.position, e.position) * 0.03;
        e.scaling = new BABYLON.Vector3(o, o, o), e.computeWorldMatrix(!0), e.isVisible = this._sceneEditor.canShowLights();
      }
    }, v.prototype.render = function() {
      this._scene && this._scene.render();
    }, v.prototype.getScene = function() {
      return this._scene;
    }, v.prototype.fireLightSelectedEvent = function(e) {
      for (var t = 0; t < this._lightSelectedListeners.length; ++t)
        this._lightSelectedListeners[t](e);
    }, v.prototype.addLightSelectedListener = function(e) {
      this._lightSelectedListeners.push(e);
    }, v._lightTexture = "data:image/png;base64,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", v;
  }()
);
class $x {
  /**
   * Create a new EventState
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   */
  constructor(e, t = !1, s, o) {
    this.skipNextObservers = !1, this.mask = 0, this.initalize(e, t, s, o);
  }
  /**
   * Initialize the current event state
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns the current event state
   */
  initalize(e, t = !1, s, o) {
    return this.mask = e, this.skipNextObservers = t, this.target = s, this.currentTarget = o, this;
  }
}
class Qx {
  /**
   * Creates a new observer
   * @param callback defines the callback to call when the observer is notified
   * @param mask defines the mask of the observer (used to filter notifications)
   * @param scope defines the current scope used to restore the JS context
   */
  constructor(e, t, s = null) {
    this.callback = e, this.mask = t, this.scope = s, this._willBeUnregistered = !1, this.unregisterOnNextCall = !1;
  }
}
class qd {
  constructor() {
    this._observers = null, this._observables = null;
  }
  /**
   * Release associated resources
   */
  dispose() {
    if (this._observers && this._observables)
      for (var e = 0; e < this._observers.length; e++)
        this._observables[e].remove(this._observers[e]);
    this._observers = null, this._observables = null;
  }
  /**
   * Raise a callback when one of the observable will notify
   * @param observables defines a list of observables to watch
   * @param callback defines the callback to call on notification
   * @param mask defines the mask used to filter notifications
   * @param scope defines the current scope used to restore the JS context
   * @returns the new MultiObserver
   */
  static Watch(e, t, s = 0, o = null) {
    let a = new qd();
    a._observers = new Array(), a._observables = e;
    for (var c of e) {
      let g = c.add(t, s, !1, o);
      g && a._observers.push(g);
    }
    return a;
  }
}
class Zd {
  /**
   * Creates a new observable
   * @param onObserverAdded defines a callback to call when a new observer is added
   */
  constructor(e) {
    this._observers = new Array(), this._onObserverAdded = null, this._eventState = new $x(0), e && (this._onObserverAdded = e);
  }
  /**
   * Gets the list of observers
   */
  get observers() {
    return this._observers;
  }
  /**
   * Create a new Observer with the specified callback
   * @param callback the callback that will be executed for that Observer
   * @param mask the mask used to filter observers
   * @param insertFirst if true the callback will be inserted at the first position, hence executed before the others ones. If false (default behavior) the callback will be inserted at the last position, executed after all the others already present.
   * @param scope optional scope for the callback to be called from
   * @param unregisterOnFirstCall defines if the observer as to be unregistered after the next notification
   * @returns the new observer created for the callback
   */
  add(e, t = 0, s = !1, o = null, a = !1) {
    if (!e)
      return null;
    var c = new Qx(e, t, o);
    return c.unregisterOnNextCall = a, s ? this._observers.unshift(c) : this._observers.push(c), this._onObserverAdded && this._onObserverAdded(c), c;
  }
  /**
   * Create a new Observer with the specified callback and unregisters after the next notification
   * @param callback the callback that will be executed for that Observer
   * @returns the new observer created for the callback
   */
  addOnce(e) {
    return this.add(e, void 0, void 0, void 0, !0);
  }
  /**
   * Remove an Observer from the Observable object
   * @param observer the instance of the Observer to remove
   * @returns false if it doesn't belong to this Observable
   */
  remove(e) {
    if (!e)
      return !1;
    var t = this._observers.indexOf(e);
    return t !== -1 ? (this._deferUnregister(e), !0) : !1;
  }
  /**
   * Remove a callback from the Observable object
   * @param callback the callback to remove
   * @param scope optional scope. If used only the callbacks with this scope will be removed
   * @returns false if it doesn't belong to this Observable
  */
  removeCallback(e, t) {
    for (var s = 0; s < this._observers.length; s++) {
      const o = this._observers[s];
      if (!o._willBeUnregistered && o.callback === e && (!t || t === o.scope))
        return this._deferUnregister(o), !0;
    }
    return !1;
  }
  _deferUnregister(e) {
    e.unregisterOnNextCall = !1, e._willBeUnregistered = !0, setTimeout(() => {
      this._remove(e);
    }, 0);
  }
  // This should only be called when not iterating over _observers to avoid callback skipping.
  // Removes an observer from the _observer Array.
  _remove(e) {
    if (!e)
      return !1;
    var t = this._observers.indexOf(e);
    return t !== -1 ? (this._observers.splice(t, 1), !0) : !1;
  }
  /**
   * Moves the observable to the top of the observer list making it get called first when notified
   * @param observer the observer to move
   */
  makeObserverTopPriority(e) {
    this._remove(e), this._observers.unshift(e);
  }
  /**
   * Moves the observable to the bottom of the observer list making it get called last when notified
   * @param observer the observer to move
   */
  makeObserverBottomPriority(e) {
    this._remove(e), this._observers.push(e);
  }
  /**
   * Notify all Observers by calling their respective callback with the given data
   * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
   * @param eventData defines the data to send to all observers
   * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
   */
  notifyObservers(e, t = 0, s, o) {
    if (!this._observers.length)
      return !0;
    let a = this._eventState;
    a.mask = t, a.target = s, a.currentTarget = o, a.skipNextObservers = !1, a.lastReturnValue = e;
    for (var c of this._observers)
      if (!c._willBeUnregistered && (c.mask & t && (c.scope ? a.lastReturnValue = c.callback.apply(c.scope, [e, a]) : a.lastReturnValue = c.callback(e, a), c.unregisterOnNextCall && this._deferUnregister(c)), a.skipNextObservers))
        return !1;
    return !0;
  }
  /**
   * Calling this will execute each callback, expecting it to be a promise or return a value.
   * If at any point in the chain one function fails, the promise will fail and the execution will not continue.
   * This is useful when a chain of events (sometimes async events) is needed to initialize a certain object
   * and it is crucial that all callbacks will be executed.
   * The order of the callbacks is kept, callbacks are not executed parallel.
   *
   * @param eventData The data to be sent to each callback
   * @param mask is used to filter observers defaults to 0
   * @param target defines the callback target (see EventState)
   * @param currentTarget defines he current object in the bubbling phase
   * @returns {Promise<T>} will return a Promise than resolves when all callbacks executed successfully.
   */
  notifyObserversWithPromise(e, t = 0, s, o) {
    let a = Promise.resolve(e);
    if (!this._observers.length)
      return a;
    let c = this._eventState;
    return c.mask = t, c.target = s, c.currentTarget = o, c.skipNextObservers = !1, this._observers.forEach((g) => {
      c.skipNextObservers || g._willBeUnregistered || g.mask & t && (g.scope ? a = a.then((w) => (c.lastReturnValue = w, g.callback.apply(g.scope, [e, c]))) : a = a.then((w) => (c.lastReturnValue = w, g.callback(e, c))), g.unregisterOnNextCall && this._deferUnregister(g));
    }), a.then(() => e);
  }
  /**
   * Notify a specific observer
   * @param observer defines the observer to notify
   * @param eventData defines the data to be sent to each callback
   * @param mask is used to filter observers defaults to 0
   */
  notifyObserver(e, t, s = 0) {
    let o = this._eventState;
    o.mask = s, o.skipNextObservers = !1, e.callback(t, o);
  }
  /**
   * Gets a boolean indicating if the observable has at least one observer
   * @returns true is the Observable has at least one Observer registered
   */
  hasObservers() {
    return this._observers.length > 0;
  }
  /**
  * Clear the list of observers
  */
  clear() {
    this._observers = new Array(), this._onObserverAdded = null;
  }
  /**
   * Clone the current observable
   * @returns a new observable
   */
  clone() {
    var e = new Zd();
    return e._observers = this._observers.slice(0), e;
  }
  /**
   * Does this observable handles observer registered with a given mask
   * @param mask defines the mask to be tested
   * @return whether or not one observer registered with the given mask is handeled
  **/
  hasSpecificMask(e = 0) {
    for (var t of this._observers)
      if (t.mask & e || t.mask === e)
        return !0;
    return !1;
  }
}
class Ef {
  /**
   * Creates a new Database
  */
  constructor() {
    this._idbFactory = typeof window < "u" ? window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB : indexedDB, this._db = null, this._hasReachedQuota = !1, this._isSupported = !0;
  }
  openAsync() {
    return new Promise((e, t) => this.open(e, t));
  }
  /**
   * Open the database and make it available
   * @param successCallback defines the callback to call on success
   * @param errorCallback defines the callback to call on error
   */
  open(e, t) {
    const s = () => {
      this._isSupported = !1, t && t();
    };
    if (!this._idbFactory)
      this._isSupported = !1, t && t();
    else if (this._db)
      e && e();
    else {
      this._hasReachedQuota = !1, this._isSupported = !0;
      const o = this._idbFactory.open("zakeke", 1);
      o.onerror = () => {
        s();
      }, o.onblocked = () => {
        Logger.info("IDB request blocked. Please reload the page."), s();
      }, o.onsuccess = () => {
        this._db = o.result, e();
      }, o.onupgradeneeded = (a) => {
        if (this._db = a.target.result, this._db)
          try {
            this._db.createObjectStore("files", { keyPath: "fileId" });
          } catch (c) {
            Logger.info("Error while creating object stores. Exception: " + c.message), s();
          }
      };
    }
  }
  loadFileAsync(e) {
    return new Promise((t, s) => {
      if (this._isSupported && this._db) {
        const o = "files";
        let a;
        const c = this._db.transaction([o]);
        c.oncomplete = () => {
          t(a ? a.data : null);
        }, c.onabort = () => {
          t(null);
        };
        const g = c.objectStore(o).get(e);
        g.onsuccess = (w) => {
          a = w.target.result;
        }, g.onerror = () => {
          Logger.info("Error loading file " + e + " from DB."), t(null);
        };
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), s("IndexedDB not supported or Db is not open");
    });
  }
  saveFileAsync(e, t) {
    return new Promise((s, o) => {
      if (this._isSupported) {
        const a = "files";
        if (!this._hasReachedQuota && this._db) {
          const c = this._db.transaction([a], "readwrite");
          c.onabort = (T) => {
            const H = T.srcElement.error;
            H && H.name === "QuotaExceededError" && (this._hasReachedQuota = !0, o("Quota Exceeded"));
          }, c.oncomplete = () => {
            Logger.info("File saved successfully"), s();
          };
          const g = { fileId: e, data: t }, w = c.objectStore(a).put(g);
          w.onsuccess = () => {
          }, w.onerror = () => {
            Logger.info("Error in DB add file request in Zakeke3D.Database."), o("Error in DB add file request");
          };
        } else {
          const c = this._hasReachedQuota ? "Quota has been reached" : "Database closed";
          o(c);
        }
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), o("IndexedDB not supported or Db is not open");
    });
  }
  deleteFileAsync(e) {
    return new Promise((t, s) => {
      if (this._isSupported && this._db) {
        const o = "files", a = this._db.transaction([o]);
        a.oncomplete = () => {
          t();
        }, a.onabort = () => {
          s("aborted cancellation");
        };
        const c = a.objectStore(o).get(e);
        c.onerror = () => {
          Logger.info("Error deleting file " + e + " from DB."), s("Error deleting file from DB");
        };
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), s("IndexedDB not supported or Db is not open");
    });
  }
}
var pl = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
pl.exports;
(function(v, e) {
  (function() {
    var t, s = "4.17.21", o = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", c = "Expected a function", g = "Invalid `variable` option passed into `_.template`", w = "__lodash_hash_undefined__", T = 500, H = "__lodash_placeholder__", Y = 1, ee = 2, z = 4, he = 1, ne = 2, ye = 1, se = 2, _e = 4, ue = 8, xe = 16, Ee = 32, K = 64, j = 128, ht = 256, Ze = 512, pt = 30, Pt = "...", Mt = 800, Tt = 16, at = 1, Ai = 2, Ve = 3, Ot = 1 / 0, Ft = 9007199254740991, Bt = 17976931348623157e292, yi = 0 / 0, on = 4294967295, Tn = on - 1, Ki = on >>> 1, as = [
      ["ary", j],
      ["bind", ye],
      ["bindKey", se],
      ["curry", ue],
      ["curryRight", xe],
      ["flip", Ze],
      ["partial", Ee],
      ["partialRight", K],
      ["rearg", ht]
    ], qt = "[object Arguments]", kn = "[object Array]", Ms = "[object AsyncFunction]", Wn = "[object Boolean]", zt = "[object Date]", Dt = "[object DOMException]", Ht = "[object Error]", Dn = "[object Function]", Ln = "[object GeneratorFunction]", Sn = "[object Map]", qn = "[object Number]", Ds = "[object Null]", ln = "[object Object]", Bn = "[object Promise]", Js = "[object Proxy]", zn = "[object RegExp]", Ut = "[object Set]", ki = "[object String]", Vt = "[object Symbol]", Jn = "[object Undefined]", nt = "[object WeakMap]", i = "[object WeakSet]", n = "[object ArrayBuffer]", r = "[object DataView]", l = "[object Float32Array]", h = "[object Float64Array]", f = "[object Int8Array]", m = "[object Int16Array]", _ = "[object Int32Array]", y = "[object Uint8Array]", x = "[object Uint8ClampedArray]", A = "[object Uint16Array]", B = "[object Uint32Array]", C = /\b__p \+= '';/g, M = /\b(__p \+=) '' \+/g, R = /(__e\(.*?\)|\b__t\)) \+\n'';/g, E = /&(?:amp|lt|gt|quot|#39);/g, D = /[&<>"']/g, L = RegExp(E.source), P = RegExp(D.source), S = /<%-([\s\S]+?)%>/g, I = /<%([\s\S]+?)%>/g, U = /<%=([\s\S]+?)%>/g, V = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, F = /^\w*$/, W = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Q = /[\\^$.*+?()[\]{}|]/g, ie = RegExp(Q.source), ae = /^\s+/, J = /\s/, le = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, fe = /\{\n\/\* \[wrapped with (.+)\] \*/, me = /,? & /, ve = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Se = /[()=,{}\[\]\/\s]/, Re = /\\(\\)?/g, He = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ye = /\w*$/, Je = /^[-+]0x[0-9a-f]+$/i, Be = /^0b[01]+$/i, Ie = /^\[object .+?Constructor\]$/, Ge = /^0o[0-7]+$/i, et = /^(?:0|[1-9]\d*)$/, tt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, gt = /($^)/, ut = /['\n\r\u2028\u2029\\]/g, yt = "\\ud800-\\udfff", At = "\\u0300-\\u036f", bt = "\\ufe20-\\ufe2f", li = "\\u20d0-\\u20ff", mt = At + bt + li, Zt = "\\u2700-\\u27bf", Xt = "a-z\\xdf-\\xf6\\xf8-\\xff", Nt = "\\xac\\xb1\\xd7\\xf7", Jt = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ti = "\\u2000-\\u206f", ri = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Pi = "A-Z\\xc0-\\xd6\\xd8-\\xde", ci = "\\ufe0e\\ufe0f", hi = Nt + Jt + Ti + ri, Ni = "['’]", Bi = "[" + yt + "]", Ri = "[" + hi + "]", Wi = "[" + mt + "]", Vi = "\\d+", Fn = "[" + Zt + "]", $n = "[" + Xt + "]", Cs = "[^" + yt + hi + Vi + Zt + Xt + Pi + "]", _s = "\\ud83c[\\udffb-\\udfff]", vn = "(?:" + Wi + "|" + _s + ")", Qn = "[^" + yt + "]", Yt = "(?:\\ud83c[\\udde6-\\uddff]){2}", os = "[\\ud800-\\udbff][\\udc00-\\udfff]", Mn = "[" + Pi + "]", un = "\\u200d", Ji = "(?:" + $n + "|" + Cs + ")", cn = "(?:" + Mn + "|" + Cs + ")", qi = "(?:" + Ni + "(?:d|ll|m|re|s|t|ve))?", Di = "(?:" + Ni + "(?:D|LL|M|RE|S|T|VE))?", d = vn + "?", N = "[" + ci + "]?", re = "(?:" + un + "(?:" + [Qn, Yt, os].join("|") + ")" + N + d + ")*", pe = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Le = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", je = N + d + re, Qe = "(?:" + [Fn, Yt, os].join("|") + ")" + je, vt = "(?:" + [Qn + Wi + "?", Wi, Yt, os, Bi].join("|") + ")", Lt = RegExp(Ni, "g"), $t = RegExp(Wi, "g"), ii = RegExp(_s + "(?=" + _s + ")|" + vt + je, "g"), Gi = RegExp([
      Mn + "?" + $n + "+" + qi + "(?=" + [Ri, Mn, "$"].join("|") + ")",
      cn + "+" + Di + "(?=" + [Ri, Mn + Ji, "$"].join("|") + ")",
      Mn + "?" + Ji + "+" + qi,
      Mn + "+" + Di,
      Le,
      pe,
      Vi,
      Qe
    ].join("|"), "g"), ls = RegExp("[" + un + yt + mt + ci + "]"), As = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ms = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], zs = -1, Si = {};
    Si[l] = Si[h] = Si[f] = Si[m] = Si[_] = Si[y] = Si[x] = Si[A] = Si[B] = !0, Si[qt] = Si[kn] = Si[n] = Si[Wn] = Si[r] = Si[zt] = Si[Ht] = Si[Dn] = Si[Sn] = Si[qn] = Si[ln] = Si[zn] = Si[Ut] = Si[ki] = Si[nt] = !1;
    var bi = {};
    bi[qt] = bi[kn] = bi[n] = bi[r] = bi[Wn] = bi[zt] = bi[l] = bi[h] = bi[f] = bi[m] = bi[_] = bi[Sn] = bi[qn] = bi[ln] = bi[zn] = bi[Ut] = bi[ki] = bi[Vt] = bi[y] = bi[x] = bi[A] = bi[B] = !0, bi[Ht] = bi[Dn] = bi[nt] = !1;
    var kr = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, yr = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, or = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, es = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, br = parseFloat, Kr = parseInt, lr = typeof Gr == "object" && Gr && Gr.Object === Object && Gr, Ts = typeof self == "object" && self && self.Object === Object && self, $i = lr || Ts || Function("return this")(), hr = e && !e.nodeType && e, Zn = hr && !0 && v && !v.nodeType && v, Pr = Zn && Zn.exports === hr, $s = Pr && lr.process, Un = function() {
      try {
        var Ce = Zn && Zn.require && Zn.require("util").types;
        return Ce || $s && $s.binding && $s.binding("util");
      } catch {
      }
    }(), b = Un && Un.isArrayBuffer, O = Un && Un.isDate, G = Un && Un.isMap, Z = Un && Un.isRegExp, oe = Un && Un.isSet, ce = Un && Un.isTypedArray;
    function de(Ce, De, Ne) {
      switch (Ne.length) {
        case 0:
          return Ce.call(De);
        case 1:
          return Ce.call(De, Ne[0]);
        case 2:
          return Ce.call(De, Ne[0], Ne[1]);
        case 3:
          return Ce.call(De, Ne[0], Ne[1], Ne[2]);
      }
      return Ce.apply(De, Ne);
    }
    function Pe(Ce, De, Ne, q) {
      for (var te = -1, be = Ce == null ? 0 : Ce.length; ++te < be; ) {
        var Ae = Ce[te];
        De(q, Ae, Ne(Ae), Ce);
      }
      return q;
    }
    function Oe(Ce, De) {
      for (var Ne = -1, q = Ce == null ? 0 : Ce.length; ++Ne < q && De(Ce[Ne], Ne, Ce) !== !1; )
        ;
      return Ce;
    }
    function Ue(Ce, De) {
      for (var Ne = Ce == null ? 0 : Ce.length; Ne-- && De(Ce[Ne], Ne, Ce) !== !1; )
        ;
      return Ce;
    }
    function rt(Ce, De) {
      for (var Ne = -1, q = Ce == null ? 0 : Ce.length; ++Ne < q; )
        if (!De(Ce[Ne], Ne, Ce))
          return !1;
      return !0;
    }
    function lt(Ce, De) {
      for (var Ne = -1, q = Ce == null ? 0 : Ce.length, te = 0, be = []; ++Ne < q; ) {
        var Ae = Ce[Ne];
        De(Ae, Ne, Ce) && (be[te++] = Ae);
      }
      return be;
    }
    function Ke(Ce, De) {
      var Ne = Ce == null ? 0 : Ce.length;
      return !!Ne && Oi(Ce, De, 0) > -1;
    }
    function xt(Ce, De, Ne) {
      for (var q = -1, te = Ce == null ? 0 : Ce.length; ++q < te; )
        if (Ne(De, Ce[q]))
          return !0;
      return !1;
    }
    function It(Ce, De) {
      for (var Ne = -1, q = Ce == null ? 0 : Ce.length, te = Array(q); ++Ne < q; )
        te[Ne] = De(Ce[Ne], Ne, Ce);
      return te;
    }
    function ai(Ce, De) {
      for (var Ne = -1, q = De.length, te = Ce.length; ++Ne < q; )
        Ce[te + Ne] = De[Ne];
      return Ce;
    }
    function si(Ce, De, Ne, q) {
      var te = -1, be = Ce == null ? 0 : Ce.length;
      for (q && be && (Ne = Ce[++te]); ++te < be; )
        Ne = De(Ne, Ce[te], te, Ce);
      return Ne;
    }
    function fn(Ce, De, Ne, q) {
      var te = Ce == null ? 0 : Ce.length;
      for (q && te && (Ne = Ce[--te]); te--; )
        Ne = De(Ne, Ce[te], te, Ce);
      return Ne;
    }
    function Qi(Ce, De) {
      for (var Ne = -1, q = Ce == null ? 0 : Ce.length; ++Ne < q; )
        if (De(Ce[Ne], Ne, Ce))
          return !0;
      return !1;
    }
    var Zi = hs("length");
    function Qt(Ce) {
      return Ce.split("");
    }
    function di(Ce) {
      return Ce.match(ve) || [];
    }
    function yn(Ce, De, Ne) {
      var q;
      return Ne(Ce, function(te, be, Ae) {
        if (De(te, be, Ae))
          return q = be, !1;
      }), q;
    }
    function mi(Ce, De, Ne, q) {
      for (var te = Ce.length, be = Ne + (q ? 1 : -1); q ? be-- : ++be < te; )
        if (De(Ce[be], be, Ce))
          return be;
      return -1;
    }
    function Oi(Ce, De, Ne) {
      return De === De ? er(Ce, De, Ne) : mi(Ce, ts, Ne);
    }
    function Qs(Ce, De, Ne, q) {
      for (var te = Ne - 1, be = Ce.length; ++te < be; )
        if (q(Ce[te], De))
          return te;
      return -1;
    }
    function ts(Ce) {
      return Ce !== Ce;
    }
    function en(Ce, De) {
      var Ne = Ce == null ? 0 : Ce.length;
      return Ne ? bn(Ce, De) / Ne : yi;
    }
    function hs(Ce) {
      return function(De) {
        return De == null ? t : De[Ce];
      };
    }
    function En(Ce) {
      return function(De) {
        return Ce == null ? t : Ce[De];
      };
    }
    function Et(Ce, De, Ne, q, te) {
      return te(Ce, function(be, Ae, qe) {
        Ne = q ? (q = !1, be) : De(Ne, be, Ae, qe);
      }), Ne;
    }
    function Vn(Ce, De) {
      var Ne = Ce.length;
      for (Ce.sort(De); Ne--; )
        Ce[Ne] = Ce[Ne].value;
      return Ce;
    }
    function bn(Ce, De) {
      for (var Ne, q = -1, te = Ce.length; ++q < te; ) {
        var be = De(Ce[q]);
        be !== t && (Ne = Ne === t ? be : Ne + be);
      }
      return Ne;
    }
    function Ls(Ce, De) {
      for (var Ne = -1, q = Array(Ce); ++Ne < Ce; )
        q[Ne] = De(Ne);
      return q;
    }
    function oi(Ce, De) {
      return It(De, function(Ne) {
        return [Ne, Ce[Ne]];
      });
    }
    function Hi(Ce) {
      return Ce && Ce.slice(0, Us(Ce) + 1).replace(ae, "");
    }
    function Ct(Ce) {
      return function(De) {
        return Ce(De);
      };
    }
    function Bs(Ce, De) {
      return It(De, function(Ne) {
        return Ce[Ne];
      });
    }
    function Gt(Ce, De) {
      return Ce.has(De);
    }
    function vi(Ce, De) {
      for (var Ne = -1, q = Ce.length; ++Ne < q && Oi(De, Ce[Ne], 0) > -1; )
        ;
      return Ne;
    }
    function dn(Ce, De) {
      for (var Ne = Ce.length; Ne-- && Oi(De, Ce[Ne], 0) > -1; )
        ;
      return Ne;
    }
    function jt(Ce, De) {
      for (var Ne = Ce.length, q = 0; Ne--; )
        Ce[Ne] === De && ++q;
      return q;
    }
    var Xi = En(kr), Es = En(yr);
    function Jr(Ce) {
      return "\\" + es[Ce];
    }
    function Fs(Ce, De) {
      return Ce == null ? t : Ce[De];
    }
    function Hn(Ce) {
      return ls.test(Ce);
    }
    function ji(Ce) {
      return As.test(Ce);
    }
    function xn(Ce) {
      for (var De, Ne = []; !(De = Ce.next()).done; )
        Ne.push(De.value);
      return Ne;
    }
    function Yn(Ce) {
      var De = -1, Ne = Array(Ce.size);
      return Ce.forEach(function(q, te) {
        Ne[++De] = [te, q];
      }), Ne;
    }
    function is(Ce, De) {
      return function(Ne) {
        return Ce(De(Ne));
      };
    }
    function Pn(Ce, De) {
      for (var Ne = -1, q = Ce.length, te = 0, be = []; ++Ne < q; ) {
        var Ae = Ce[Ne];
        (Ae === De || Ae === H) && (Ce[Ne] = H, be[te++] = Ne);
      }
      return be;
    }
    function us(Ce) {
      var De = -1, Ne = Array(Ce.size);
      return Ce.forEach(function(q) {
        Ne[++De] = q;
      }), Ne;
    }
    function Mi(Ce) {
      var De = -1, Ne = Array(Ce.size);
      return Ce.forEach(function(q) {
        Ne[++De] = [q, q];
      }), Ne;
    }
    function er(Ce, De, Ne) {
      for (var q = Ne - 1, te = Ce.length; ++q < te; )
        if (Ce[q] === De)
          return q;
      return -1;
    }
    function ur(Ce, De, Ne) {
      for (var q = Ne + 1; q--; )
        if (Ce[q] === De)
          return q;
      return q;
    }
    function vs(Ce) {
      return Hn(Ce) ? ns(Ce) : Zi(Ce);
    }
    function gn(Ce) {
      return Hn(Ce) ? Te(Ce) : Qt(Ce);
    }
    function Us(Ce) {
      for (var De = Ce.length; De-- && J.test(Ce.charAt(De)); )
        ;
      return De;
    }
    var xr = En(or);
    function ns(Ce) {
      for (var De = ii.lastIndex = 0; ii.test(Ce); )
        ++De;
      return De;
    }
    function Te(Ce) {
      return Ce.match(ii) || [];
    }
    function Fe(Ce) {
      return Ce.match(Gi) || [];
    }
    var Xe = function Ce(De) {
      De = De == null ? $i : $e.defaults($i.Object(), De, $e.pick($i, ms));
      var Ne = De.Array, q = De.Date, te = De.Error, be = De.Function, Ae = De.Math, qe = De.Object, ot = De.RegExp, it = De.String, wt = De.TypeError, gi = Ne.prototype, zi = be.prototype, tn = qe.prototype, an = De["__core-js_shared__"], cs = zi.toString, fi = tn.hasOwnProperty, rg = 0, _u = function() {
        var u = /[^.]+$/.exec(an && an.keys && an.keys.IE_PROTO || "");
        return u ? "Symbol(src)_1." + u : "";
      }(), fo = tn.toString, ag = cs.call(qe), og = $i._, lg = ot(
        "^" + cs.call(fi).replace(Q, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), go = Pr ? De.Buffer : t, Nr = De.Symbol, po = De.Uint8Array, mu = go ? go.allocUnsafe : t, _o = is(qe.getPrototypeOf, qe), vu = qe.create, yu = tn.propertyIsEnumerable, mo = gi.splice, bu = Nr ? Nr.isConcatSpreadable : t, Ba = Nr ? Nr.iterator : t, $r = Nr ? Nr.toStringTag : t, vo = function() {
        try {
          var u = na(qe, "defineProperty");
          return u({}, "", {}), u;
        } catch {
        }
      }(), hg = De.clearTimeout !== $i.clearTimeout && De.clearTimeout, ug = q && q.now !== $i.Date.now && q.now, cg = De.setTimeout !== $i.setTimeout && De.setTimeout, yo = Ae.ceil, bo = Ae.floor, Al = qe.getOwnPropertySymbols, fg = go ? go.isBuffer : t, xu = De.isFinite, dg = gi.join, gg = is(qe.keys, qe), Nn = Ae.max, ss = Ae.min, pg = q.now, _g = De.parseInt, wu = Ae.random, mg = gi.reverse, Tl = na(De, "DataView"), Ea = na(De, "Map"), Ll = na(De, "Promise"), fa = na(De, "Set"), Oa = na(De, "WeakMap"), Ia = na(qe, "create"), xo = Oa && new Oa(), da = {}, vg = sa(Tl), yg = sa(Ea), bg = sa(Ll), xg = sa(fa), wg = sa(Oa), wo = Nr ? Nr.prototype : t, ka = wo ? wo.valueOf : t, Su = wo ? wo.toString : t;
      function we(u) {
        if (wn(u) && !pi(u) && !(u instanceof Ei)) {
          if (u instanceof Vs)
            return u;
          if (fi.call(u, "__wrapped__"))
            return Mc(u);
        }
        return new Vs(u);
      }
      var ga = function() {
        function u() {
        }
        return function(p) {
          if (!pn(p))
            return {};
          if (vu)
            return vu(p);
          u.prototype = p;
          var k = new u();
          return u.prototype = t, k;
        };
      }();
      function So() {
      }
      function Vs(u, p) {
        this.__wrapped__ = u, this.__actions__ = [], this.__chain__ = !!p, this.__index__ = 0, this.__values__ = t;
      }
      we.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: S,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: I,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: U,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: we
        }
      }, we.prototype = So.prototype, we.prototype.constructor = we, Vs.prototype = ga(So.prototype), Vs.prototype.constructor = Vs;
      function Ei(u) {
        this.__wrapped__ = u, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = on, this.__views__ = [];
      }
      function Sg() {
        var u = new Ei(this.__wrapped__);
        return u.__actions__ = ys(this.__actions__), u.__dir__ = this.__dir__, u.__filtered__ = this.__filtered__, u.__iteratees__ = ys(this.__iteratees__), u.__takeCount__ = this.__takeCount__, u.__views__ = ys(this.__views__), u;
      }
      function Mg() {
        if (this.__filtered__) {
          var u = new Ei(this);
          u.__dir__ = -1, u.__filtered__ = !0;
        } else
          u = this.clone(), u.__dir__ *= -1;
        return u;
      }
      function Cg() {
        var u = this.__wrapped__.value(), p = this.__dir__, k = pi(u), X = p < 0, ge = k ? u.length : 0, Me = Dp(0, ge, this.__views__), ke = Me.start, ze = Me.end, We = ze - ke, ct = X ? ze : ke - 1, ft = this.__iteratees__, St = ft.length, kt = 0, Rt = ss(We, this.__takeCount__);
        if (!k || !X && ge == We && Rt == We)
          return qu(u, this.__actions__);
        var ei = [];
        e:
          for (; We-- && kt < Rt; ) {
            ct += p;
            for (var wi = -1, ti = u[ct]; ++wi < St; ) {
              var Li = ft[wi], Ii = Li.iteratee, ks = Li.type, gs = Ii(ti);
              if (ks == Ai)
                ti = gs;
              else if (!gs) {
                if (ks == at)
                  continue e;
                break e;
              }
            }
            ei[kt++] = ti;
          }
        return ei;
      }
      Ei.prototype = ga(So.prototype), Ei.prototype.constructor = Ei;
      function Qr(u) {
        var p = -1, k = u == null ? 0 : u.length;
        for (this.clear(); ++p < k; ) {
          var X = u[p];
          this.set(X[0], X[1]);
        }
      }
      function Ag() {
        this.__data__ = Ia ? Ia(null) : {}, this.size = 0;
      }
      function Tg(u) {
        var p = this.has(u) && delete this.__data__[u];
        return this.size -= p ? 1 : 0, p;
      }
      function Lg(u) {
        var p = this.__data__;
        if (Ia) {
          var k = p[u];
          return k === w ? t : k;
        }
        return fi.call(p, u) ? p[u] : t;
      }
      function Bg(u) {
        var p = this.__data__;
        return Ia ? p[u] !== t : fi.call(p, u);
      }
      function Eg(u, p) {
        var k = this.__data__;
        return this.size += this.has(u) ? 0 : 1, k[u] = Ia && p === t ? w : p, this;
      }
      Qr.prototype.clear = Ag, Qr.prototype.delete = Tg, Qr.prototype.get = Lg, Qr.prototype.has = Bg, Qr.prototype.set = Eg;
      function wr(u) {
        var p = -1, k = u == null ? 0 : u.length;
        for (this.clear(); ++p < k; ) {
          var X = u[p];
          this.set(X[0], X[1]);
        }
      }
      function Og() {
        this.__data__ = [], this.size = 0;
      }
      function Ig(u) {
        var p = this.__data__, k = Mo(p, u);
        if (k < 0)
          return !1;
        var X = p.length - 1;
        return k == X ? p.pop() : mo.call(p, k, 1), --this.size, !0;
      }
      function kg(u) {
        var p = this.__data__, k = Mo(p, u);
        return k < 0 ? t : p[k][1];
      }
      function Pg(u) {
        return Mo(this.__data__, u) > -1;
      }
      function Ng(u, p) {
        var k = this.__data__, X = Mo(k, u);
        return X < 0 ? (++this.size, k.push([u, p])) : k[X][1] = p, this;
      }
      wr.prototype.clear = Og, wr.prototype.delete = Ig, wr.prototype.get = kg, wr.prototype.has = Pg, wr.prototype.set = Ng;
      function Sr(u) {
        var p = -1, k = u == null ? 0 : u.length;
        for (this.clear(); ++p < k; ) {
          var X = u[p];
          this.set(X[0], X[1]);
        }
      }
      function Rg() {
        this.size = 0, this.__data__ = {
          hash: new Qr(),
          map: new (Ea || wr)(),
          string: new Qr()
        };
      }
      function Dg(u) {
        var p = Ro(this, u).delete(u);
        return this.size -= p ? 1 : 0, p;
      }
      function zg(u) {
        return Ro(this, u).get(u);
      }
      function Fg(u) {
        return Ro(this, u).has(u);
      }
      function Ug(u, p) {
        var k = Ro(this, u), X = k.size;
        return k.set(u, p), this.size += k.size == X ? 0 : 1, this;
      }
      Sr.prototype.clear = Rg, Sr.prototype.delete = Dg, Sr.prototype.get = zg, Sr.prototype.has = Fg, Sr.prototype.set = Ug;
      function ea(u) {
        var p = -1, k = u == null ? 0 : u.length;
        for (this.__data__ = new Sr(); ++p < k; )
          this.add(u[p]);
      }
      function Vg(u) {
        return this.__data__.set(u, w), this;
      }
      function Hg(u) {
        return this.__data__.has(u);
      }
      ea.prototype.add = ea.prototype.push = Vg, ea.prototype.has = Hg;
      function tr(u) {
        var p = this.__data__ = new wr(u);
        this.size = p.size;
      }
      function Yg() {
        this.__data__ = new wr(), this.size = 0;
      }
      function Gg(u) {
        var p = this.__data__, k = p.delete(u);
        return this.size = p.size, k;
      }
      function jg(u) {
        return this.__data__.get(u);
      }
      function Wg(u) {
        return this.__data__.has(u);
      }
      function qg(u, p) {
        var k = this.__data__;
        if (k instanceof wr) {
          var X = k.__data__;
          if (!Ea || X.length < o - 1)
            return X.push([u, p]), this.size = ++k.size, this;
          k = this.__data__ = new Sr(X);
        }
        return k.set(u, p), this.size = k.size, this;
      }
      tr.prototype.clear = Yg, tr.prototype.delete = Gg, tr.prototype.get = jg, tr.prototype.has = Wg, tr.prototype.set = qg;
      function Mu(u, p) {
        var k = pi(u), X = !k && ra(u), ge = !k && !X && Ur(u), Me = !k && !X && !ge && va(u), ke = k || X || ge || Me, ze = ke ? Ls(u.length, it) : [], We = ze.length;
        for (var ct in u)
          (p || fi.call(u, ct)) && !(ke && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ct == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          ge && (ct == "offset" || ct == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          Me && (ct == "buffer" || ct == "byteLength" || ct == "byteOffset") || // Skip index properties.
          Tr(ct, We))) && ze.push(ct);
        return ze;
      }
      function Cu(u) {
        var p = u.length;
        return p ? u[Fl(0, p - 1)] : t;
      }
      function Zg(u, p) {
        return Do(ys(u), ta(p, 0, u.length));
      }
      function Xg(u) {
        return Do(ys(u));
      }
      function Bl(u, p, k) {
        (k !== t && !ir(u[p], k) || k === t && !(p in u)) && Mr(u, p, k);
      }
      function Pa(u, p, k) {
        var X = u[p];
        (!(fi.call(u, p) && ir(X, k)) || k === t && !(p in u)) && Mr(u, p, k);
      }
      function Mo(u, p) {
        for (var k = u.length; k--; )
          if (ir(u[k][0], p))
            return k;
        return -1;
      }
      function Kg(u, p, k, X) {
        return Rr(u, function(ge, Me, ke) {
          p(X, ge, k(ge), ke);
        }), X;
      }
      function Au(u, p) {
        return u && fr(p, Gn(p), u);
      }
      function Jg(u, p) {
        return u && fr(p, xs(p), u);
      }
      function Mr(u, p, k) {
        p == "__proto__" && vo ? vo(u, p, {
          configurable: !0,
          enumerable: !0,
          value: k,
          writable: !0
        }) : u[p] = k;
      }
      function El(u, p) {
        for (var k = -1, X = p.length, ge = Ne(X), Me = u == null; ++k < X; )
          ge[k] = Me ? t : uh(u, p[k]);
        return ge;
      }
      function ta(u, p, k) {
        return u === u && (k !== t && (u = u <= k ? u : k), p !== t && (u = u >= p ? u : p)), u;
      }
      function Hs(u, p, k, X, ge, Me) {
        var ke, ze = p & Y, We = p & ee, ct = p & z;
        if (k && (ke = ge ? k(u, X, ge, Me) : k(u)), ke !== t)
          return ke;
        if (!pn(u))
          return u;
        var ft = pi(u);
        if (ft) {
          if (ke = Fp(u), !ze)
            return ys(u, ke);
        } else {
          var St = rs(u), kt = St == Dn || St == Ln;
          if (Ur(u))
            return Ku(u, ze);
          if (St == ln || St == qt || kt && !ge) {
            if (ke = We || kt ? {} : pc(u), !ze)
              return We ? Lp(u, Jg(ke, u)) : Tp(u, Au(ke, u));
          } else {
            if (!bi[St])
              return ge ? u : {};
            ke = Up(u, St, ze);
          }
        }
        Me || (Me = new tr());
        var Rt = Me.get(u);
        if (Rt)
          return Rt;
        Me.set(u, ke), Gc(u) ? u.forEach(function(ti) {
          ke.add(Hs(ti, p, k, ti, u, Me));
        }) : Hc(u) && u.forEach(function(ti, Li) {
          ke.set(Li, Hs(ti, p, k, Li, u, Me));
        });
        var ei = ct ? We ? Kl : Xl : We ? xs : Gn, wi = ft ? t : ei(u);
        return Oe(wi || u, function(ti, Li) {
          wi && (Li = ti, ti = u[Li]), Pa(ke, Li, Hs(ti, p, k, Li, u, Me));
        }), ke;
      }
      function $g(u) {
        var p = Gn(u);
        return function(k) {
          return Tu(k, u, p);
        };
      }
      function Tu(u, p, k) {
        var X = k.length;
        if (u == null)
          return !X;
        for (u = qe(u); X--; ) {
          var ge = k[X], Me = p[ge], ke = u[ge];
          if (ke === t && !(ge in u) || !Me(ke))
            return !1;
        }
        return !0;
      }
      function Lu(u, p, k) {
        if (typeof u != "function")
          throw new wt(c);
        return Va(function() {
          u.apply(t, k);
        }, p);
      }
      function Na(u, p, k, X) {
        var ge = -1, Me = Ke, ke = !0, ze = u.length, We = [], ct = p.length;
        if (!ze)
          return We;
        k && (p = It(p, Ct(k))), X ? (Me = xt, ke = !1) : p.length >= o && (Me = Gt, ke = !1, p = new ea(p));
        e:
          for (; ++ge < ze; ) {
            var ft = u[ge], St = k == null ? ft : k(ft);
            if (ft = X || ft !== 0 ? ft : 0, ke && St === St) {
              for (var kt = ct; kt--; )
                if (p[kt] === St)
                  continue e;
              We.push(ft);
            } else
              Me(p, St, X) || We.push(ft);
          }
        return We;
      }
      var Rr = tc(cr), Bu = tc(Il, !0);
      function Qg(u, p) {
        var k = !0;
        return Rr(u, function(X, ge, Me) {
          return k = !!p(X, ge, Me), k;
        }), k;
      }
      function Co(u, p, k) {
        for (var X = -1, ge = u.length; ++X < ge; ) {
          var Me = u[X], ke = p(Me);
          if (ke != null && (ze === t ? ke === ke && !Is(ke) : k(ke, ze)))
            var ze = ke, We = Me;
        }
        return We;
      }
      function ep(u, p, k, X) {
        var ge = u.length;
        for (k = xi(k), k < 0 && (k = -k > ge ? 0 : ge + k), X = X === t || X > ge ? ge : xi(X), X < 0 && (X += ge), X = k > X ? 0 : Wc(X); k < X; )
          u[k++] = p;
        return u;
      }
      function Eu(u, p) {
        var k = [];
        return Rr(u, function(X, ge, Me) {
          p(X, ge, Me) && k.push(X);
        }), k;
      }
      function Xn(u, p, k, X, ge) {
        var Me = -1, ke = u.length;
        for (k || (k = Hp), ge || (ge = []); ++Me < ke; ) {
          var ze = u[Me];
          p > 0 && k(ze) ? p > 1 ? Xn(ze, p - 1, k, X, ge) : ai(ge, ze) : X || (ge[ge.length] = ze);
        }
        return ge;
      }
      var Ol = ic(), Ou = ic(!0);
      function cr(u, p) {
        return u && Ol(u, p, Gn);
      }
      function Il(u, p) {
        return u && Ou(u, p, Gn);
      }
      function Ao(u, p) {
        return lt(p, function(k) {
          return Lr(u[k]);
        });
      }
      function ia(u, p) {
        p = zr(p, u);
        for (var k = 0, X = p.length; u != null && k < X; )
          u = u[dr(p[k++])];
        return k && k == X ? u : t;
      }
      function Iu(u, p, k) {
        var X = p(u);
        return pi(u) ? X : ai(X, k(u));
      }
      function fs(u) {
        return u == null ? u === t ? Jn : Ds : $r && $r in qe(u) ? Rp(u) : Xp(u);
      }
      function kl(u, p) {
        return u > p;
      }
      function tp(u, p) {
        return u != null && fi.call(u, p);
      }
      function ip(u, p) {
        return u != null && p in qe(u);
      }
      function np(u, p, k) {
        return u >= ss(p, k) && u < Nn(p, k);
      }
      function Pl(u, p, k) {
        for (var X = k ? xt : Ke, ge = u[0].length, Me = u.length, ke = Me, ze = Ne(Me), We = 1 / 0, ct = []; ke--; ) {
          var ft = u[ke];
          ke && p && (ft = It(ft, Ct(p))), We = ss(ft.length, We), ze[ke] = !k && (p || ge >= 120 && ft.length >= 120) ? new ea(ke && ft) : t;
        }
        ft = u[0];
        var St = -1, kt = ze[0];
        e:
          for (; ++St < ge && ct.length < We; ) {
            var Rt = ft[St], ei = p ? p(Rt) : Rt;
            if (Rt = k || Rt !== 0 ? Rt : 0, !(kt ? Gt(kt, ei) : X(ct, ei, k))) {
              for (ke = Me; --ke; ) {
                var wi = ze[ke];
                if (!(wi ? Gt(wi, ei) : X(u[ke], ei, k)))
                  continue e;
              }
              kt && kt.push(ei), ct.push(Rt);
            }
          }
        return ct;
      }
      function sp(u, p, k, X) {
        return cr(u, function(ge, Me, ke) {
          p(X, k(ge), Me, ke);
        }), X;
      }
      function Ra(u, p, k) {
        p = zr(p, u), u = yc(u, p);
        var X = u == null ? u : u[dr(Gs(p))];
        return X == null ? t : de(X, u, k);
      }
      function ku(u) {
        return wn(u) && fs(u) == qt;
      }
      function rp(u) {
        return wn(u) && fs(u) == n;
      }
      function ap(u) {
        return wn(u) && fs(u) == zt;
      }
      function Da(u, p, k, X, ge) {
        return u === p ? !0 : u == null || p == null || !wn(u) && !wn(p) ? u !== u && p !== p : op(u, p, k, X, Da, ge);
      }
      function op(u, p, k, X, ge, Me) {
        var ke = pi(u), ze = pi(p), We = ke ? kn : rs(u), ct = ze ? kn : rs(p);
        We = We == qt ? ln : We, ct = ct == qt ? ln : ct;
        var ft = We == ln, St = ct == ln, kt = We == ct;
        if (kt && Ur(u)) {
          if (!Ur(p))
            return !1;
          ke = !0, ft = !1;
        }
        if (kt && !ft)
          return Me || (Me = new tr()), ke || va(u) ? fc(u, p, k, X, ge, Me) : Pp(u, p, We, k, X, ge, Me);
        if (!(k & he)) {
          var Rt = ft && fi.call(u, "__wrapped__"), ei = St && fi.call(p, "__wrapped__");
          if (Rt || ei) {
            var wi = Rt ? u.value() : u, ti = ei ? p.value() : p;
            return Me || (Me = new tr()), ge(wi, ti, k, X, Me);
          }
        }
        return kt ? (Me || (Me = new tr()), Np(u, p, k, X, ge, Me)) : !1;
      }
      function lp(u) {
        return wn(u) && rs(u) == Sn;
      }
      function Nl(u, p, k, X) {
        var ge = k.length, Me = ge, ke = !X;
        if (u == null)
          return !Me;
        for (u = qe(u); ge--; ) {
          var ze = k[ge];
          if (ke && ze[2] ? ze[1] !== u[ze[0]] : !(ze[0] in u))
            return !1;
        }
        for (; ++ge < Me; ) {
          ze = k[ge];
          var We = ze[0], ct = u[We], ft = ze[1];
          if (ke && ze[2]) {
            if (ct === t && !(We in u))
              return !1;
          } else {
            var St = new tr();
            if (X)
              var kt = X(ct, ft, We, u, p, St);
            if (!(kt === t ? Da(ft, ct, he | ne, X, St) : kt))
              return !1;
          }
        }
        return !0;
      }
      function Pu(u) {
        if (!pn(u) || Gp(u))
          return !1;
        var p = Lr(u) ? lg : Ie;
        return p.test(sa(u));
      }
      function hp(u) {
        return wn(u) && fs(u) == zn;
      }
      function up(u) {
        return wn(u) && rs(u) == Ut;
      }
      function cp(u) {
        return wn(u) && Yo(u.length) && !!Si[fs(u)];
      }
      function Nu(u) {
        return typeof u == "function" ? u : u == null ? ws : typeof u == "object" ? pi(u) ? zu(u[0], u[1]) : Du(u) : sf(u);
      }
      function Rl(u) {
        if (!Ua(u))
          return gg(u);
        var p = [];
        for (var k in qe(u))
          fi.call(u, k) && k != "constructor" && p.push(k);
        return p;
      }
      function fp(u) {
        if (!pn(u))
          return Zp(u);
        var p = Ua(u), k = [];
        for (var X in u)
          X == "constructor" && (p || !fi.call(u, X)) || k.push(X);
        return k;
      }
      function Dl(u, p) {
        return u < p;
      }
      function Ru(u, p) {
        var k = -1, X = bs(u) ? Ne(u.length) : [];
        return Rr(u, function(ge, Me, ke) {
          X[++k] = p(ge, Me, ke);
        }), X;
      }
      function Du(u) {
        var p = $l(u);
        return p.length == 1 && p[0][2] ? mc(p[0][0], p[0][1]) : function(k) {
          return k === u || Nl(k, u, p);
        };
      }
      function zu(u, p) {
        return eh(u) && _c(p) ? mc(dr(u), p) : function(k) {
          var X = uh(k, u);
          return X === t && X === p ? ch(k, u) : Da(p, X, he | ne);
        };
      }
      function To(u, p, k, X, ge) {
        u !== p && Ol(p, function(Me, ke) {
          if (ge || (ge = new tr()), pn(Me))
            dp(u, p, ke, k, To, X, ge);
          else {
            var ze = X ? X(ih(u, ke), Me, ke + "", u, p, ge) : t;
            ze === t && (ze = Me), Bl(u, ke, ze);
          }
        }, xs);
      }
      function dp(u, p, k, X, ge, Me, ke) {
        var ze = ih(u, k), We = ih(p, k), ct = ke.get(We);
        if (ct) {
          Bl(u, k, ct);
          return;
        }
        var ft = Me ? Me(ze, We, k + "", u, p, ke) : t, St = ft === t;
        if (St) {
          var kt = pi(We), Rt = !kt && Ur(We), ei = !kt && !Rt && va(We);
          ft = We, kt || Rt || ei ? pi(ze) ? ft = ze : Cn(ze) ? ft = ys(ze) : Rt ? (St = !1, ft = Ku(We, !0)) : ei ? (St = !1, ft = Ju(We, !0)) : ft = [] : Ha(We) || ra(We) ? (ft = ze, ra(ze) ? ft = qc(ze) : (!pn(ze) || Lr(ze)) && (ft = pc(We))) : St = !1;
        }
        St && (ke.set(We, ft), ge(ft, We, X, Me, ke), ke.delete(We)), Bl(u, k, ft);
      }
      function Fu(u, p) {
        var k = u.length;
        if (k)
          return p += p < 0 ? k : 0, Tr(p, k) ? u[p] : t;
      }
      function Uu(u, p, k) {
        p.length ? p = It(p, function(Me) {
          return pi(Me) ? function(ke) {
            return ia(ke, Me.length === 1 ? Me[0] : Me);
          } : Me;
        }) : p = [ws];
        var X = -1;
        p = It(p, Ct(Kt()));
        var ge = Ru(u, function(Me, ke, ze) {
          var We = It(p, function(ct) {
            return ct(Me);
          });
          return { criteria: We, index: ++X, value: Me };
        });
        return Vn(ge, function(Me, ke) {
          return Ap(Me, ke, k);
        });
      }
      function gp(u, p) {
        return Vu(u, p, function(k, X) {
          return ch(u, X);
        });
      }
      function Vu(u, p, k) {
        for (var X = -1, ge = p.length, Me = {}; ++X < ge; ) {
          var ke = p[X], ze = ia(u, ke);
          k(ze, ke) && za(Me, zr(ke, u), ze);
        }
        return Me;
      }
      function pp(u) {
        return function(p) {
          return ia(p, u);
        };
      }
      function zl(u, p, k, X) {
        var ge = X ? Qs : Oi, Me = -1, ke = p.length, ze = u;
        for (u === p && (p = ys(p)), k && (ze = It(u, Ct(k))); ++Me < ke; )
          for (var We = 0, ct = p[Me], ft = k ? k(ct) : ct; (We = ge(ze, ft, We, X)) > -1; )
            ze !== u && mo.call(ze, We, 1), mo.call(u, We, 1);
        return u;
      }
      function Hu(u, p) {
        for (var k = u ? p.length : 0, X = k - 1; k--; ) {
          var ge = p[k];
          if (k == X || ge !== Me) {
            var Me = ge;
            Tr(ge) ? mo.call(u, ge, 1) : Hl(u, ge);
          }
        }
        return u;
      }
      function Fl(u, p) {
        return u + bo(wu() * (p - u + 1));
      }
      function _p(u, p, k, X) {
        for (var ge = -1, Me = Nn(yo((p - u) / (k || 1)), 0), ke = Ne(Me); Me--; )
          ke[X ? Me : ++ge] = u, u += k;
        return ke;
      }
      function Ul(u, p) {
        var k = "";
        if (!u || p < 1 || p > Ft)
          return k;
        do
          p % 2 && (k += u), p = bo(p / 2), p && (u += u);
        while (p);
        return k;
      }
      function Ci(u, p) {
        return nh(vc(u, p, ws), u + "");
      }
      function mp(u) {
        return Cu(ya(u));
      }
      function vp(u, p) {
        var k = ya(u);
        return Do(k, ta(p, 0, k.length));
      }
      function za(u, p, k, X) {
        if (!pn(u))
          return u;
        p = zr(p, u);
        for (var ge = -1, Me = p.length, ke = Me - 1, ze = u; ze != null && ++ge < Me; ) {
          var We = dr(p[ge]), ct = k;
          if (We === "__proto__" || We === "constructor" || We === "prototype")
            return u;
          if (ge != ke) {
            var ft = ze[We];
            ct = X ? X(ft, We, ze) : t, ct === t && (ct = pn(ft) ? ft : Tr(p[ge + 1]) ? [] : {});
          }
          Pa(ze, We, ct), ze = ze[We];
        }
        return u;
      }
      var Yu = xo ? function(u, p) {
        return xo.set(u, p), u;
      } : ws, yp = vo ? function(u, p) {
        return vo(u, "toString", {
          configurable: !0,
          enumerable: !1,
          value: dh(p),
          writable: !0
        });
      } : ws;
      function bp(u) {
        return Do(ya(u));
      }
      function Ys(u, p, k) {
        var X = -1, ge = u.length;
        p < 0 && (p = -p > ge ? 0 : ge + p), k = k > ge ? ge : k, k < 0 && (k += ge), ge = p > k ? 0 : k - p >>> 0, p >>>= 0;
        for (var Me = Ne(ge); ++X < ge; )
          Me[X] = u[X + p];
        return Me;
      }
      function xp(u, p) {
        var k;
        return Rr(u, function(X, ge, Me) {
          return k = p(X, ge, Me), !k;
        }), !!k;
      }
      function Lo(u, p, k) {
        var X = 0, ge = u == null ? X : u.length;
        if (typeof p == "number" && p === p && ge <= Ki) {
          for (; X < ge; ) {
            var Me = X + ge >>> 1, ke = u[Me];
            ke !== null && !Is(ke) && (k ? ke <= p : ke < p) ? X = Me + 1 : ge = Me;
          }
          return ge;
        }
        return Vl(u, p, ws, k);
      }
      function Vl(u, p, k, X) {
        var ge = 0, Me = u == null ? 0 : u.length;
        if (Me === 0)
          return 0;
        p = k(p);
        for (var ke = p !== p, ze = p === null, We = Is(p), ct = p === t; ge < Me; ) {
          var ft = bo((ge + Me) / 2), St = k(u[ft]), kt = St !== t, Rt = St === null, ei = St === St, wi = Is(St);
          if (ke)
            var ti = X || ei;
          else
            ct ? ti = ei && (X || kt) : ze ? ti = ei && kt && (X || !Rt) : We ? ti = ei && kt && !Rt && (X || !wi) : Rt || wi ? ti = !1 : ti = X ? St <= p : St < p;
          ti ? ge = ft + 1 : Me = ft;
        }
        return ss(Me, Tn);
      }
      function Gu(u, p) {
        for (var k = -1, X = u.length, ge = 0, Me = []; ++k < X; ) {
          var ke = u[k], ze = p ? p(ke) : ke;
          if (!k || !ir(ze, We)) {
            var We = ze;
            Me[ge++] = ke === 0 ? 0 : ke;
          }
        }
        return Me;
      }
      function ju(u) {
        return typeof u == "number" ? u : Is(u) ? yi : +u;
      }
      function Os(u) {
        if (typeof u == "string")
          return u;
        if (pi(u))
          return It(u, Os) + "";
        if (Is(u))
          return Su ? Su.call(u) : "";
        var p = u + "";
        return p == "0" && 1 / u == -Ot ? "-0" : p;
      }
      function Dr(u, p, k) {
        var X = -1, ge = Ke, Me = u.length, ke = !0, ze = [], We = ze;
        if (k)
          ke = !1, ge = xt;
        else if (Me >= o) {
          var ct = p ? null : Ip(u);
          if (ct)
            return us(ct);
          ke = !1, ge = Gt, We = new ea();
        } else
          We = p ? [] : ze;
        e:
          for (; ++X < Me; ) {
            var ft = u[X], St = p ? p(ft) : ft;
            if (ft = k || ft !== 0 ? ft : 0, ke && St === St) {
              for (var kt = We.length; kt--; )
                if (We[kt] === St)
                  continue e;
              p && We.push(St), ze.push(ft);
            } else
              ge(We, St, k) || (We !== ze && We.push(St), ze.push(ft));
          }
        return ze;
      }
      function Hl(u, p) {
        return p = zr(p, u), u = yc(u, p), u == null || delete u[dr(Gs(p))];
      }
      function Wu(u, p, k, X) {
        return za(u, p, k(ia(u, p)), X);
      }
      function Bo(u, p, k, X) {
        for (var ge = u.length, Me = X ? ge : -1; (X ? Me-- : ++Me < ge) && p(u[Me], Me, u); )
          ;
        return k ? Ys(u, X ? 0 : Me, X ? Me + 1 : ge) : Ys(u, X ? Me + 1 : 0, X ? ge : Me);
      }
      function qu(u, p) {
        var k = u;
        return k instanceof Ei && (k = k.value()), si(p, function(X, ge) {
          return ge.func.apply(ge.thisArg, ai([X], ge.args));
        }, k);
      }
      function Yl(u, p, k) {
        var X = u.length;
        if (X < 2)
          return X ? Dr(u[0]) : [];
        for (var ge = -1, Me = Ne(X); ++ge < X; )
          for (var ke = u[ge], ze = -1; ++ze < X; )
            ze != ge && (Me[ge] = Na(Me[ge] || ke, u[ze], p, k));
        return Dr(Xn(Me, 1), p, k);
      }
      function Zu(u, p, k) {
        for (var X = -1, ge = u.length, Me = p.length, ke = {}; ++X < ge; ) {
          var ze = X < Me ? p[X] : t;
          k(ke, u[X], ze);
        }
        return ke;
      }
      function Gl(u) {
        return Cn(u) ? u : [];
      }
      function jl(u) {
        return typeof u == "function" ? u : ws;
      }
      function zr(u, p) {
        return pi(u) ? u : eh(u, p) ? [u] : Sc(Yi(u));
      }
      var wp = Ci;
      function Fr(u, p, k) {
        var X = u.length;
        return k = k === t ? X : k, !p && k >= X ? u : Ys(u, p, k);
      }
      var Xu = hg || function(u) {
        return $i.clearTimeout(u);
      };
      function Ku(u, p) {
        if (p)
          return u.slice();
        var k = u.length, X = mu ? mu(k) : new u.constructor(k);
        return u.copy(X), X;
      }
      function Wl(u) {
        var p = new u.constructor(u.byteLength);
        return new po(p).set(new po(u)), p;
      }
      function Sp(u, p) {
        var k = p ? Wl(u.buffer) : u.buffer;
        return new u.constructor(k, u.byteOffset, u.byteLength);
      }
      function Mp(u) {
        var p = new u.constructor(u.source, Ye.exec(u));
        return p.lastIndex = u.lastIndex, p;
      }
      function Cp(u) {
        return ka ? qe(ka.call(u)) : {};
      }
      function Ju(u, p) {
        var k = p ? Wl(u.buffer) : u.buffer;
        return new u.constructor(k, u.byteOffset, u.length);
      }
      function $u(u, p) {
        if (u !== p) {
          var k = u !== t, X = u === null, ge = u === u, Me = Is(u), ke = p !== t, ze = p === null, We = p === p, ct = Is(p);
          if (!ze && !ct && !Me && u > p || Me && ke && We && !ze && !ct || X && ke && We || !k && We || !ge)
            return 1;
          if (!X && !Me && !ct && u < p || ct && k && ge && !X && !Me || ze && k && ge || !ke && ge || !We)
            return -1;
        }
        return 0;
      }
      function Ap(u, p, k) {
        for (var X = -1, ge = u.criteria, Me = p.criteria, ke = ge.length, ze = k.length; ++X < ke; ) {
          var We = $u(ge[X], Me[X]);
          if (We) {
            if (X >= ze)
              return We;
            var ct = k[X];
            return We * (ct == "desc" ? -1 : 1);
          }
        }
        return u.index - p.index;
      }
      function Qu(u, p, k, X) {
        for (var ge = -1, Me = u.length, ke = k.length, ze = -1, We = p.length, ct = Nn(Me - ke, 0), ft = Ne(We + ct), St = !X; ++ze < We; )
          ft[ze] = p[ze];
        for (; ++ge < ke; )
          (St || ge < Me) && (ft[k[ge]] = u[ge]);
        for (; ct--; )
          ft[ze++] = u[ge++];
        return ft;
      }
      function ec(u, p, k, X) {
        for (var ge = -1, Me = u.length, ke = -1, ze = k.length, We = -1, ct = p.length, ft = Nn(Me - ze, 0), St = Ne(ft + ct), kt = !X; ++ge < ft; )
          St[ge] = u[ge];
        for (var Rt = ge; ++We < ct; )
          St[Rt + We] = p[We];
        for (; ++ke < ze; )
          (kt || ge < Me) && (St[Rt + k[ke]] = u[ge++]);
        return St;
      }
      function ys(u, p) {
        var k = -1, X = u.length;
        for (p || (p = Ne(X)); ++k < X; )
          p[k] = u[k];
        return p;
      }
      function fr(u, p, k, X) {
        var ge = !k;
        k || (k = {});
        for (var Me = -1, ke = p.length; ++Me < ke; ) {
          var ze = p[Me], We = X ? X(k[ze], u[ze], ze, k, u) : t;
          We === t && (We = u[ze]), ge ? Mr(k, ze, We) : Pa(k, ze, We);
        }
        return k;
      }
      function Tp(u, p) {
        return fr(u, Ql(u), p);
      }
      function Lp(u, p) {
        return fr(u, dc(u), p);
      }
      function Eo(u, p) {
        return function(k, X) {
          var ge = pi(k) ? Pe : Kg, Me = p ? p() : {};
          return ge(k, u, Kt(X, 2), Me);
        };
      }
      function pa(u) {
        return Ci(function(p, k) {
          var X = -1, ge = k.length, Me = ge > 1 ? k[ge - 1] : t, ke = ge > 2 ? k[2] : t;
          for (Me = u.length > 3 && typeof Me == "function" ? (ge--, Me) : t, ke && ds(k[0], k[1], ke) && (Me = ge < 3 ? t : Me, ge = 1), p = qe(p); ++X < ge; ) {
            var ze = k[X];
            ze && u(p, ze, X, Me);
          }
          return p;
        });
      }
      function tc(u, p) {
        return function(k, X) {
          if (k == null)
            return k;
          if (!bs(k))
            return u(k, X);
          for (var ge = k.length, Me = p ? ge : -1, ke = qe(k); (p ? Me-- : ++Me < ge) && X(ke[Me], Me, ke) !== !1; )
            ;
          return k;
        };
      }
      function ic(u) {
        return function(p, k, X) {
          for (var ge = -1, Me = qe(p), ke = X(p), ze = ke.length; ze--; ) {
            var We = ke[u ? ze : ++ge];
            if (k(Me[We], We, Me) === !1)
              break;
          }
          return p;
        };
      }
      function Bp(u, p, k) {
        var X = p & ye, ge = Fa(u);
        function Me() {
          var ke = this && this !== $i && this instanceof Me ? ge : u;
          return ke.apply(X ? k : this, arguments);
        }
        return Me;
      }
      function nc(u) {
        return function(p) {
          p = Yi(p);
          var k = Hn(p) ? gn(p) : t, X = k ? k[0] : p.charAt(0), ge = k ? Fr(k, 1).join("") : p.slice(1);
          return X[u]() + ge;
        };
      }
      function _a(u) {
        return function(p) {
          return si(tf(ef(p).replace(Lt, "")), u, "");
        };
      }
      function Fa(u) {
        return function() {
          var p = arguments;
          switch (p.length) {
            case 0:
              return new u();
            case 1:
              return new u(p[0]);
            case 2:
              return new u(p[0], p[1]);
            case 3:
              return new u(p[0], p[1], p[2]);
            case 4:
              return new u(p[0], p[1], p[2], p[3]);
            case 5:
              return new u(p[0], p[1], p[2], p[3], p[4]);
            case 6:
              return new u(p[0], p[1], p[2], p[3], p[4], p[5]);
            case 7:
              return new u(p[0], p[1], p[2], p[3], p[4], p[5], p[6]);
          }
          var k = ga(u.prototype), X = u.apply(k, p);
          return pn(X) ? X : k;
        };
      }
      function Ep(u, p, k) {
        var X = Fa(u);
        function ge() {
          for (var Me = arguments.length, ke = Ne(Me), ze = Me, We = ma(ge); ze--; )
            ke[ze] = arguments[ze];
          var ct = Me < 3 && ke[0] !== We && ke[Me - 1] !== We ? [] : Pn(ke, We);
          if (Me -= ct.length, Me < k)
            return lc(
              u,
              p,
              Oo,
              ge.placeholder,
              t,
              ke,
              ct,
              t,
              t,
              k - Me
            );
          var ft = this && this !== $i && this instanceof ge ? X : u;
          return de(ft, this, ke);
        }
        return ge;
      }
      function sc(u) {
        return function(p, k, X) {
          var ge = qe(p);
          if (!bs(p)) {
            var Me = Kt(k, 3);
            p = Gn(p), k = function(ze) {
              return Me(ge[ze], ze, ge);
            };
          }
          var ke = u(p, k, X);
          return ke > -1 ? ge[Me ? p[ke] : ke] : t;
        };
      }
      function rc(u) {
        return Ar(function(p) {
          var k = p.length, X = k, ge = Vs.prototype.thru;
          for (u && p.reverse(); X--; ) {
            var Me = p[X];
            if (typeof Me != "function")
              throw new wt(c);
            if (ge && !ke && No(Me) == "wrapper")
              var ke = new Vs([], !0);
          }
          for (X = ke ? X : k; ++X < k; ) {
            Me = p[X];
            var ze = No(Me), We = ze == "wrapper" ? Jl(Me) : t;
            We && th(We[0]) && We[1] == (j | ue | Ee | ht) && !We[4].length && We[9] == 1 ? ke = ke[No(We[0])].apply(ke, We[3]) : ke = Me.length == 1 && th(Me) ? ke[ze]() : ke.thru(Me);
          }
          return function() {
            var ct = arguments, ft = ct[0];
            if (ke && ct.length == 1 && pi(ft))
              return ke.plant(ft).value();
            for (var St = 0, kt = k ? p[St].apply(this, ct) : ft; ++St < k; )
              kt = p[St].call(this, kt);
            return kt;
          };
        });
      }
      function Oo(u, p, k, X, ge, Me, ke, ze, We, ct) {
        var ft = p & j, St = p & ye, kt = p & se, Rt = p & (ue | xe), ei = p & Ze, wi = kt ? t : Fa(u);
        function ti() {
          for (var Li = arguments.length, Ii = Ne(Li), ks = Li; ks--; )
            Ii[ks] = arguments[ks];
          if (Rt)
            var gs = ma(ti), Ps = jt(Ii, gs);
          if (X && (Ii = Qu(Ii, X, ge, Rt)), Me && (Ii = ec(Ii, Me, ke, Rt)), Li -= Ps, Rt && Li < ct) {
            var An = Pn(Ii, gs);
            return lc(
              u,
              p,
              Oo,
              ti.placeholder,
              k,
              Ii,
              An,
              ze,
              We,
              ct - Li
            );
          }
          var nr = St ? k : this, Er = kt ? nr[u] : u;
          return Li = Ii.length, ze ? Ii = Kp(Ii, ze) : ei && Li > 1 && Ii.reverse(), ft && We < Li && (Ii.length = We), this && this !== $i && this instanceof ti && (Er = wi || Fa(Er)), Er.apply(nr, Ii);
        }
        return ti;
      }
      function ac(u, p) {
        return function(k, X) {
          return sp(k, u, p(X), {});
        };
      }
      function Io(u, p) {
        return function(k, X) {
          var ge;
          if (k === t && X === t)
            return p;
          if (k !== t && (ge = k), X !== t) {
            if (ge === t)
              return X;
            typeof k == "string" || typeof X == "string" ? (k = Os(k), X = Os(X)) : (k = ju(k), X = ju(X)), ge = u(k, X);
          }
          return ge;
        };
      }
      function ql(u) {
        return Ar(function(p) {
          return p = It(p, Ct(Kt())), Ci(function(k) {
            var X = this;
            return u(p, function(ge) {
              return de(ge, X, k);
            });
          });
        });
      }
      function ko(u, p) {
        p = p === t ? " " : Os(p);
        var k = p.length;
        if (k < 2)
          return k ? Ul(p, u) : p;
        var X = Ul(p, yo(u / vs(p)));
        return Hn(p) ? Fr(gn(X), 0, u).join("") : X.slice(0, u);
      }
      function Op(u, p, k, X) {
        var ge = p & ye, Me = Fa(u);
        function ke() {
          for (var ze = -1, We = arguments.length, ct = -1, ft = X.length, St = Ne(ft + We), kt = this && this !== $i && this instanceof ke ? Me : u; ++ct < ft; )
            St[ct] = X[ct];
          for (; We--; )
            St[ct++] = arguments[++ze];
          return de(kt, ge ? k : this, St);
        }
        return ke;
      }
      function oc(u) {
        return function(p, k, X) {
          return X && typeof X != "number" && ds(p, k, X) && (k = X = t), p = Br(p), k === t ? (k = p, p = 0) : k = Br(k), X = X === t ? p < k ? 1 : -1 : Br(X), _p(p, k, X, u);
        };
      }
      function Po(u) {
        return function(p, k) {
          return typeof p == "string" && typeof k == "string" || (p = js(p), k = js(k)), u(p, k);
        };
      }
      function lc(u, p, k, X, ge, Me, ke, ze, We, ct) {
        var ft = p & ue, St = ft ? ke : t, kt = ft ? t : ke, Rt = ft ? Me : t, ei = ft ? t : Me;
        p |= ft ? Ee : K, p &= ~(ft ? K : Ee), p & _e || (p &= ~(ye | se));
        var wi = [
          u,
          p,
          ge,
          Rt,
          St,
          ei,
          kt,
          ze,
          We,
          ct
        ], ti = k.apply(t, wi);
        return th(u) && bc(ti, wi), ti.placeholder = X, xc(ti, u, p);
      }
      function Zl(u) {
        var p = Ae[u];
        return function(k, X) {
          if (k = js(k), X = X == null ? 0 : ss(xi(X), 292), X && xu(k)) {
            var ge = (Yi(k) + "e").split("e"), Me = p(ge[0] + "e" + (+ge[1] + X));
            return ge = (Yi(Me) + "e").split("e"), +(ge[0] + "e" + (+ge[1] - X));
          }
          return p(k);
        };
      }
      var Ip = fa && 1 / us(new fa([, -0]))[1] == Ot ? function(u) {
        return new fa(u);
      } : _h;
      function hc(u) {
        return function(p) {
          var k = rs(p);
          return k == Sn ? Yn(p) : k == Ut ? Mi(p) : oi(p, u(p));
        };
      }
      function Cr(u, p, k, X, ge, Me, ke, ze) {
        var We = p & se;
        if (!We && typeof u != "function")
          throw new wt(c);
        var ct = X ? X.length : 0;
        if (ct || (p &= ~(Ee | K), X = ge = t), ke = ke === t ? ke : Nn(xi(ke), 0), ze = ze === t ? ze : xi(ze), ct -= ge ? ge.length : 0, p & K) {
          var ft = X, St = ge;
          X = ge = t;
        }
        var kt = We ? t : Jl(u), Rt = [
          u,
          p,
          k,
          X,
          ge,
          ft,
          St,
          Me,
          ke,
          ze
        ];
        if (kt && qp(Rt, kt), u = Rt[0], p = Rt[1], k = Rt[2], X = Rt[3], ge = Rt[4], ze = Rt[9] = Rt[9] === t ? We ? 0 : u.length : Nn(Rt[9] - ct, 0), !ze && p & (ue | xe) && (p &= ~(ue | xe)), !p || p == ye)
          var ei = Bp(u, p, k);
        else
          p == ue || p == xe ? ei = Ep(u, p, ze) : (p == Ee || p == (ye | Ee)) && !ge.length ? ei = Op(u, p, k, X) : ei = Oo.apply(t, Rt);
        var wi = kt ? Yu : bc;
        return xc(wi(ei, Rt), u, p);
      }
      function uc(u, p, k, X) {
        return u === t || ir(u, tn[k]) && !fi.call(X, k) ? p : u;
      }
      function cc(u, p, k, X, ge, Me) {
        return pn(u) && pn(p) && (Me.set(p, u), To(u, p, t, cc, Me), Me.delete(p)), u;
      }
      function kp(u) {
        return Ha(u) ? t : u;
      }
      function fc(u, p, k, X, ge, Me) {
        var ke = k & he, ze = u.length, We = p.length;
        if (ze != We && !(ke && We > ze))
          return !1;
        var ct = Me.get(u), ft = Me.get(p);
        if (ct && ft)
          return ct == p && ft == u;
        var St = -1, kt = !0, Rt = k & ne ? new ea() : t;
        for (Me.set(u, p), Me.set(p, u); ++St < ze; ) {
          var ei = u[St], wi = p[St];
          if (X)
            var ti = ke ? X(wi, ei, St, p, u, Me) : X(ei, wi, St, u, p, Me);
          if (ti !== t) {
            if (ti)
              continue;
            kt = !1;
            break;
          }
          if (Rt) {
            if (!Qi(p, function(Li, Ii) {
              if (!Gt(Rt, Ii) && (ei === Li || ge(ei, Li, k, X, Me)))
                return Rt.push(Ii);
            })) {
              kt = !1;
              break;
            }
          } else if (!(ei === wi || ge(ei, wi, k, X, Me))) {
            kt = !1;
            break;
          }
        }
        return Me.delete(u), Me.delete(p), kt;
      }
      function Pp(u, p, k, X, ge, Me, ke) {
        switch (k) {
          case r:
            if (u.byteLength != p.byteLength || u.byteOffset != p.byteOffset)
              return !1;
            u = u.buffer, p = p.buffer;
          case n:
            return !(u.byteLength != p.byteLength || !Me(new po(u), new po(p)));
          case Wn:
          case zt:
          case qn:
            return ir(+u, +p);
          case Ht:
            return u.name == p.name && u.message == p.message;
          case zn:
          case ki:
            return u == p + "";
          case Sn:
            var ze = Yn;
          case Ut:
            var We = X & he;
            if (ze || (ze = us), u.size != p.size && !We)
              return !1;
            var ct = ke.get(u);
            if (ct)
              return ct == p;
            X |= ne, ke.set(u, p);
            var ft = fc(ze(u), ze(p), X, ge, Me, ke);
            return ke.delete(u), ft;
          case Vt:
            if (ka)
              return ka.call(u) == ka.call(p);
        }
        return !1;
      }
      function Np(u, p, k, X, ge, Me) {
        var ke = k & he, ze = Xl(u), We = ze.length, ct = Xl(p), ft = ct.length;
        if (We != ft && !ke)
          return !1;
        for (var St = We; St--; ) {
          var kt = ze[St];
          if (!(ke ? kt in p : fi.call(p, kt)))
            return !1;
        }
        var Rt = Me.get(u), ei = Me.get(p);
        if (Rt && ei)
          return Rt == p && ei == u;
        var wi = !0;
        Me.set(u, p), Me.set(p, u);
        for (var ti = ke; ++St < We; ) {
          kt = ze[St];
          var Li = u[kt], Ii = p[kt];
          if (X)
            var ks = ke ? X(Ii, Li, kt, p, u, Me) : X(Li, Ii, kt, u, p, Me);
          if (!(ks === t ? Li === Ii || ge(Li, Ii, k, X, Me) : ks)) {
            wi = !1;
            break;
          }
          ti || (ti = kt == "constructor");
        }
        if (wi && !ti) {
          var gs = u.constructor, Ps = p.constructor;
          gs != Ps && "constructor" in u && "constructor" in p && !(typeof gs == "function" && gs instanceof gs && typeof Ps == "function" && Ps instanceof Ps) && (wi = !1);
        }
        return Me.delete(u), Me.delete(p), wi;
      }
      function Ar(u) {
        return nh(vc(u, t, Tc), u + "");
      }
      function Xl(u) {
        return Iu(u, Gn, Ql);
      }
      function Kl(u) {
        return Iu(u, xs, dc);
      }
      var Jl = xo ? function(u) {
        return xo.get(u);
      } : _h;
      function No(u) {
        for (var p = u.name + "", k = da[p], X = fi.call(da, p) ? k.length : 0; X--; ) {
          var ge = k[X], Me = ge.func;
          if (Me == null || Me == u)
            return ge.name;
        }
        return p;
      }
      function ma(u) {
        var p = fi.call(we, "placeholder") ? we : u;
        return p.placeholder;
      }
      function Kt() {
        var u = we.iteratee || gh;
        return u = u === gh ? Nu : u, arguments.length ? u(arguments[0], arguments[1]) : u;
      }
      function Ro(u, p) {
        var k = u.__data__;
        return Yp(p) ? k[typeof p == "string" ? "string" : "hash"] : k.map;
      }
      function $l(u) {
        for (var p = Gn(u), k = p.length; k--; ) {
          var X = p[k], ge = u[X];
          p[k] = [X, ge, _c(ge)];
        }
        return p;
      }
      function na(u, p) {
        var k = Fs(u, p);
        return Pu(k) ? k : t;
      }
      function Rp(u) {
        var p = fi.call(u, $r), k = u[$r];
        try {
          u[$r] = t;
          var X = !0;
        } catch {
        }
        var ge = fo.call(u);
        return X && (p ? u[$r] = k : delete u[$r]), ge;
      }
      var Ql = Al ? function(u) {
        return u == null ? [] : (u = qe(u), lt(Al(u), function(p) {
          return yu.call(u, p);
        }));
      } : mh, dc = Al ? function(u) {
        for (var p = []; u; )
          ai(p, Ql(u)), u = _o(u);
        return p;
      } : mh, rs = fs;
      (Tl && rs(new Tl(new ArrayBuffer(1))) != r || Ea && rs(new Ea()) != Sn || Ll && rs(Ll.resolve()) != Bn || fa && rs(new fa()) != Ut || Oa && rs(new Oa()) != nt) && (rs = function(u) {
        var p = fs(u), k = p == ln ? u.constructor : t, X = k ? sa(k) : "";
        if (X)
          switch (X) {
            case vg:
              return r;
            case yg:
              return Sn;
            case bg:
              return Bn;
            case xg:
              return Ut;
            case wg:
              return nt;
          }
        return p;
      });
      function Dp(u, p, k) {
        for (var X = -1, ge = k.length; ++X < ge; ) {
          var Me = k[X], ke = Me.size;
          switch (Me.type) {
            case "drop":
              u += ke;
              break;
            case "dropRight":
              p -= ke;
              break;
            case "take":
              p = ss(p, u + ke);
              break;
            case "takeRight":
              u = Nn(u, p - ke);
              break;
          }
        }
        return { start: u, end: p };
      }
      function zp(u) {
        var p = u.match(fe);
        return p ? p[1].split(me) : [];
      }
      function gc(u, p, k) {
        p = zr(p, u);
        for (var X = -1, ge = p.length, Me = !1; ++X < ge; ) {
          var ke = dr(p[X]);
          if (!(Me = u != null && k(u, ke)))
            break;
          u = u[ke];
        }
        return Me || ++X != ge ? Me : (ge = u == null ? 0 : u.length, !!ge && Yo(ge) && Tr(ke, ge) && (pi(u) || ra(u)));
      }
      function Fp(u) {
        var p = u.length, k = new u.constructor(p);
        return p && typeof u[0] == "string" && fi.call(u, "index") && (k.index = u.index, k.input = u.input), k;
      }
      function pc(u) {
        return typeof u.constructor == "function" && !Ua(u) ? ga(_o(u)) : {};
      }
      function Up(u, p, k) {
        var X = u.constructor;
        switch (p) {
          case n:
            return Wl(u);
          case Wn:
          case zt:
            return new X(+u);
          case r:
            return Sp(u, k);
          case l:
          case h:
          case f:
          case m:
          case _:
          case y:
          case x:
          case A:
          case B:
            return Ju(u, k);
          case Sn:
            return new X();
          case qn:
          case ki:
            return new X(u);
          case zn:
            return Mp(u);
          case Ut:
            return new X();
          case Vt:
            return Cp(u);
        }
      }
      function Vp(u, p) {
        var k = p.length;
        if (!k)
          return u;
        var X = k - 1;
        return p[X] = (k > 1 ? "& " : "") + p[X], p = p.join(k > 2 ? ", " : " "), u.replace(le, `{
/* [wrapped with ` + p + `] */
`);
      }
      function Hp(u) {
        return pi(u) || ra(u) || !!(bu && u && u[bu]);
      }
      function Tr(u, p) {
        var k = typeof u;
        return p = p ?? Ft, !!p && (k == "number" || k != "symbol" && et.test(u)) && u > -1 && u % 1 == 0 && u < p;
      }
      function ds(u, p, k) {
        if (!pn(k))
          return !1;
        var X = typeof p;
        return (X == "number" ? bs(k) && Tr(p, k.length) : X == "string" && p in k) ? ir(k[p], u) : !1;
      }
      function eh(u, p) {
        if (pi(u))
          return !1;
        var k = typeof u;
        return k == "number" || k == "symbol" || k == "boolean" || u == null || Is(u) ? !0 : F.test(u) || !V.test(u) || p != null && u in qe(p);
      }
      function Yp(u) {
        var p = typeof u;
        return p == "string" || p == "number" || p == "symbol" || p == "boolean" ? u !== "__proto__" : u === null;
      }
      function th(u) {
        var p = No(u), k = we[p];
        if (typeof k != "function" || !(p in Ei.prototype))
          return !1;
        if (u === k)
          return !0;
        var X = Jl(k);
        return !!X && u === X[0];
      }
      function Gp(u) {
        return !!_u && _u in u;
      }
      var jp = an ? Lr : vh;
      function Ua(u) {
        var p = u && u.constructor, k = typeof p == "function" && p.prototype || tn;
        return u === k;
      }
      function _c(u) {
        return u === u && !pn(u);
      }
      function mc(u, p) {
        return function(k) {
          return k == null ? !1 : k[u] === p && (p !== t || u in qe(k));
        };
      }
      function Wp(u) {
        var p = Vo(u, function(X) {
          return k.size === T && k.clear(), X;
        }), k = p.cache;
        return p;
      }
      function qp(u, p) {
        var k = u[1], X = p[1], ge = k | X, Me = ge < (ye | se | j), ke = X == j && k == ue || X == j && k == ht && u[7].length <= p[8] || X == (j | ht) && p[7].length <= p[8] && k == ue;
        if (!(Me || ke))
          return u;
        X & ye && (u[2] = p[2], ge |= k & ye ? 0 : _e);
        var ze = p[3];
        if (ze) {
          var We = u[3];
          u[3] = We ? Qu(We, ze, p[4]) : ze, u[4] = We ? Pn(u[3], H) : p[4];
        }
        return ze = p[5], ze && (We = u[5], u[5] = We ? ec(We, ze, p[6]) : ze, u[6] = We ? Pn(u[5], H) : p[6]), ze = p[7], ze && (u[7] = ze), X & j && (u[8] = u[8] == null ? p[8] : ss(u[8], p[8])), u[9] == null && (u[9] = p[9]), u[0] = p[0], u[1] = ge, u;
      }
      function Zp(u) {
        var p = [];
        if (u != null)
          for (var k in qe(u))
            p.push(k);
        return p;
      }
      function Xp(u) {
        return fo.call(u);
      }
      function vc(u, p, k) {
        return p = Nn(p === t ? u.length - 1 : p, 0), function() {
          for (var X = arguments, ge = -1, Me = Nn(X.length - p, 0), ke = Ne(Me); ++ge < Me; )
            ke[ge] = X[p + ge];
          ge = -1;
          for (var ze = Ne(p + 1); ++ge < p; )
            ze[ge] = X[ge];
          return ze[p] = k(ke), de(u, this, ze);
        };
      }
      function yc(u, p) {
        return p.length < 2 ? u : ia(u, Ys(p, 0, -1));
      }
      function Kp(u, p) {
        for (var k = u.length, X = ss(p.length, k), ge = ys(u); X--; ) {
          var Me = p[X];
          u[X] = Tr(Me, k) ? ge[Me] : t;
        }
        return u;
      }
      function ih(u, p) {
        if (!(p === "constructor" && typeof u[p] == "function") && p != "__proto__")
          return u[p];
      }
      var bc = wc(Yu), Va = cg || function(u, p) {
        return $i.setTimeout(u, p);
      }, nh = wc(yp);
      function xc(u, p, k) {
        var X = p + "";
        return nh(u, Vp(X, Jp(zp(X), k)));
      }
      function wc(u) {
        var p = 0, k = 0;
        return function() {
          var X = pg(), ge = Tt - (X - k);
          if (k = X, ge > 0) {
            if (++p >= Mt)
              return arguments[0];
          } else
            p = 0;
          return u.apply(t, arguments);
        };
      }
      function Do(u, p) {
        var k = -1, X = u.length, ge = X - 1;
        for (p = p === t ? X : p; ++k < p; ) {
          var Me = Fl(k, ge), ke = u[Me];
          u[Me] = u[k], u[k] = ke;
        }
        return u.length = p, u;
      }
      var Sc = Wp(function(u) {
        var p = [];
        return u.charCodeAt(0) === 46 && p.push(""), u.replace(W, function(k, X, ge, Me) {
          p.push(ge ? Me.replace(Re, "$1") : X || k);
        }), p;
      });
      function dr(u) {
        if (typeof u == "string" || Is(u))
          return u;
        var p = u + "";
        return p == "0" && 1 / u == -Ot ? "-0" : p;
      }
      function sa(u) {
        if (u != null) {
          try {
            return cs.call(u);
          } catch {
          }
          try {
            return u + "";
          } catch {
          }
        }
        return "";
      }
      function Jp(u, p) {
        return Oe(as, function(k) {
          var X = "_." + k[0];
          p & k[1] && !Ke(u, X) && u.push(X);
        }), u.sort();
      }
      function Mc(u) {
        if (u instanceof Ei)
          return u.clone();
        var p = new Vs(u.__wrapped__, u.__chain__);
        return p.__actions__ = ys(u.__actions__), p.__index__ = u.__index__, p.__values__ = u.__values__, p;
      }
      function $p(u, p, k) {
        (k ? ds(u, p, k) : p === t) ? p = 1 : p = Nn(xi(p), 0);
        var X = u == null ? 0 : u.length;
        if (!X || p < 1)
          return [];
        for (var ge = 0, Me = 0, ke = Ne(yo(X / p)); ge < X; )
          ke[Me++] = Ys(u, ge, ge += p);
        return ke;
      }
      function Qp(u) {
        for (var p = -1, k = u == null ? 0 : u.length, X = 0, ge = []; ++p < k; ) {
          var Me = u[p];
          Me && (ge[X++] = Me);
        }
        return ge;
      }
      function e_() {
        var u = arguments.length;
        if (!u)
          return [];
        for (var p = Ne(u - 1), k = arguments[0], X = u; X--; )
          p[X - 1] = arguments[X];
        return ai(pi(k) ? ys(k) : [k], Xn(p, 1));
      }
      var t_ = Ci(function(u, p) {
        return Cn(u) ? Na(u, Xn(p, 1, Cn, !0)) : [];
      }), i_ = Ci(function(u, p) {
        var k = Gs(p);
        return Cn(k) && (k = t), Cn(u) ? Na(u, Xn(p, 1, Cn, !0), Kt(k, 2)) : [];
      }), n_ = Ci(function(u, p) {
        var k = Gs(p);
        return Cn(k) && (k = t), Cn(u) ? Na(u, Xn(p, 1, Cn, !0), t, k) : [];
      });
      function s_(u, p, k) {
        var X = u == null ? 0 : u.length;
        return X ? (p = k || p === t ? 1 : xi(p), Ys(u, p < 0 ? 0 : p, X)) : [];
      }
      function r_(u, p, k) {
        var X = u == null ? 0 : u.length;
        return X ? (p = k || p === t ? 1 : xi(p), p = X - p, Ys(u, 0, p < 0 ? 0 : p)) : [];
      }
      function a_(u, p) {
        return u && u.length ? Bo(u, Kt(p, 3), !0, !0) : [];
      }
      function o_(u, p) {
        return u && u.length ? Bo(u, Kt(p, 3), !0) : [];
      }
      function l_(u, p, k, X) {
        var ge = u == null ? 0 : u.length;
        return ge ? (k && typeof k != "number" && ds(u, p, k) && (k = 0, X = ge), ep(u, p, k, X)) : [];
      }
      function Cc(u, p, k) {
        var X = u == null ? 0 : u.length;
        if (!X)
          return -1;
        var ge = k == null ? 0 : xi(k);
        return ge < 0 && (ge = Nn(X + ge, 0)), mi(u, Kt(p, 3), ge);
      }
      function Ac(u, p, k) {
        var X = u == null ? 0 : u.length;
        if (!X)
          return -1;
        var ge = X - 1;
        return k !== t && (ge = xi(k), ge = k < 0 ? Nn(X + ge, 0) : ss(ge, X - 1)), mi(u, Kt(p, 3), ge, !0);
      }
      function Tc(u) {
        var p = u == null ? 0 : u.length;
        return p ? Xn(u, 1) : [];
      }
      function h_(u) {
        var p = u == null ? 0 : u.length;
        return p ? Xn(u, Ot) : [];
      }
      function u_(u, p) {
        var k = u == null ? 0 : u.length;
        return k ? (p = p === t ? 1 : xi(p), Xn(u, p)) : [];
      }
      function c_(u) {
        for (var p = -1, k = u == null ? 0 : u.length, X = {}; ++p < k; ) {
          var ge = u[p];
          X[ge[0]] = ge[1];
        }
        return X;
      }
      function Lc(u) {
        return u && u.length ? u[0] : t;
      }
      function f_(u, p, k) {
        var X = u == null ? 0 : u.length;
        if (!X)
          return -1;
        var ge = k == null ? 0 : xi(k);
        return ge < 0 && (ge = Nn(X + ge, 0)), Oi(u, p, ge);
      }
      function d_(u) {
        var p = u == null ? 0 : u.length;
        return p ? Ys(u, 0, -1) : [];
      }
      var g_ = Ci(function(u) {
        var p = It(u, Gl);
        return p.length && p[0] === u[0] ? Pl(p) : [];
      }), p_ = Ci(function(u) {
        var p = Gs(u), k = It(u, Gl);
        return p === Gs(k) ? p = t : k.pop(), k.length && k[0] === u[0] ? Pl(k, Kt(p, 2)) : [];
      }), __ = Ci(function(u) {
        var p = Gs(u), k = It(u, Gl);
        return p = typeof p == "function" ? p : t, p && k.pop(), k.length && k[0] === u[0] ? Pl(k, t, p) : [];
      });
      function m_(u, p) {
        return u == null ? "" : dg.call(u, p);
      }
      function Gs(u) {
        var p = u == null ? 0 : u.length;
        return p ? u[p - 1] : t;
      }
      function v_(u, p, k) {
        var X = u == null ? 0 : u.length;
        if (!X)
          return -1;
        var ge = X;
        return k !== t && (ge = xi(k), ge = ge < 0 ? Nn(X + ge, 0) : ss(ge, X - 1)), p === p ? ur(u, p, ge) : mi(u, ts, ge, !0);
      }
      function y_(u, p) {
        return u && u.length ? Fu(u, xi(p)) : t;
      }
      var b_ = Ci(Bc);
      function Bc(u, p) {
        return u && u.length && p && p.length ? zl(u, p) : u;
      }
      function x_(u, p, k) {
        return u && u.length && p && p.length ? zl(u, p, Kt(k, 2)) : u;
      }
      function w_(u, p, k) {
        return u && u.length && p && p.length ? zl(u, p, t, k) : u;
      }
      var S_ = Ar(function(u, p) {
        var k = u == null ? 0 : u.length, X = El(u, p);
        return Hu(u, It(p, function(ge) {
          return Tr(ge, k) ? +ge : ge;
        }).sort($u)), X;
      });
      function M_(u, p) {
        var k = [];
        if (!(u && u.length))
          return k;
        var X = -1, ge = [], Me = u.length;
        for (p = Kt(p, 3); ++X < Me; ) {
          var ke = u[X];
          p(ke, X, u) && (k.push(ke), ge.push(X));
        }
        return Hu(u, ge), k;
      }
      function sh(u) {
        return u == null ? u : mg.call(u);
      }
      function C_(u, p, k) {
        var X = u == null ? 0 : u.length;
        return X ? (k && typeof k != "number" && ds(u, p, k) ? (p = 0, k = X) : (p = p == null ? 0 : xi(p), k = k === t ? X : xi(k)), Ys(u, p, k)) : [];
      }
      function A_(u, p) {
        return Lo(u, p);
      }
      function T_(u, p, k) {
        return Vl(u, p, Kt(k, 2));
      }
      function L_(u, p) {
        var k = u == null ? 0 : u.length;
        if (k) {
          var X = Lo(u, p);
          if (X < k && ir(u[X], p))
            return X;
        }
        return -1;
      }
      function B_(u, p) {
        return Lo(u, p, !0);
      }
      function E_(u, p, k) {
        return Vl(u, p, Kt(k, 2), !0);
      }
      function O_(u, p) {
        var k = u == null ? 0 : u.length;
        if (k) {
          var X = Lo(u, p, !0) - 1;
          if (ir(u[X], p))
            return X;
        }
        return -1;
      }
      function I_(u) {
        return u && u.length ? Gu(u) : [];
      }
      function k_(u, p) {
        return u && u.length ? Gu(u, Kt(p, 2)) : [];
      }
      function P_(u) {
        var p = u == null ? 0 : u.length;
        return p ? Ys(u, 1, p) : [];
      }
      function N_(u, p, k) {
        return u && u.length ? (p = k || p === t ? 1 : xi(p), Ys(u, 0, p < 0 ? 0 : p)) : [];
      }
      function R_(u, p, k) {
        var X = u == null ? 0 : u.length;
        return X ? (p = k || p === t ? 1 : xi(p), p = X - p, Ys(u, p < 0 ? 0 : p, X)) : [];
      }
      function D_(u, p) {
        return u && u.length ? Bo(u, Kt(p, 3), !1, !0) : [];
      }
      function z_(u, p) {
        return u && u.length ? Bo(u, Kt(p, 3)) : [];
      }
      var F_ = Ci(function(u) {
        return Dr(Xn(u, 1, Cn, !0));
      }), U_ = Ci(function(u) {
        var p = Gs(u);
        return Cn(p) && (p = t), Dr(Xn(u, 1, Cn, !0), Kt(p, 2));
      }), V_ = Ci(function(u) {
        var p = Gs(u);
        return p = typeof p == "function" ? p : t, Dr(Xn(u, 1, Cn, !0), t, p);
      });
      function H_(u) {
        return u && u.length ? Dr(u) : [];
      }
      function Y_(u, p) {
        return u && u.length ? Dr(u, Kt(p, 2)) : [];
      }
      function G_(u, p) {
        return p = typeof p == "function" ? p : t, u && u.length ? Dr(u, t, p) : [];
      }
      function rh(u) {
        if (!(u && u.length))
          return [];
        var p = 0;
        return u = lt(u, function(k) {
          if (Cn(k))
            return p = Nn(k.length, p), !0;
        }), Ls(p, function(k) {
          return It(u, hs(k));
        });
      }
      function Ec(u, p) {
        if (!(u && u.length))
          return [];
        var k = rh(u);
        return p == null ? k : It(k, function(X) {
          return de(p, t, X);
        });
      }
      var j_ = Ci(function(u, p) {
        return Cn(u) ? Na(u, p) : [];
      }), W_ = Ci(function(u) {
        return Yl(lt(u, Cn));
      }), q_ = Ci(function(u) {
        var p = Gs(u);
        return Cn(p) && (p = t), Yl(lt(u, Cn), Kt(p, 2));
      }), Z_ = Ci(function(u) {
        var p = Gs(u);
        return p = typeof p == "function" ? p : t, Yl(lt(u, Cn), t, p);
      }), X_ = Ci(rh);
      function K_(u, p) {
        return Zu(u || [], p || [], Pa);
      }
      function J_(u, p) {
        return Zu(u || [], p || [], za);
      }
      var $_ = Ci(function(u) {
        var p = u.length, k = p > 1 ? u[p - 1] : t;
        return k = typeof k == "function" ? (u.pop(), k) : t, Ec(u, k);
      });
      function Oc(u) {
        var p = we(u);
        return p.__chain__ = !0, p;
      }
      function Q_(u, p) {
        return p(u), u;
      }
      function zo(u, p) {
        return p(u);
      }
      var em = Ar(function(u) {
        var p = u.length, k = p ? u[0] : 0, X = this.__wrapped__, ge = function(Me) {
          return El(Me, u);
        };
        return p > 1 || this.__actions__.length || !(X instanceof Ei) || !Tr(k) ? this.thru(ge) : (X = X.slice(k, +k + (p ? 1 : 0)), X.__actions__.push({
          func: zo,
          args: [ge],
          thisArg: t
        }), new Vs(X, this.__chain__).thru(function(Me) {
          return p && !Me.length && Me.push(t), Me;
        }));
      });
      function tm() {
        return Oc(this);
      }
      function im() {
        return new Vs(this.value(), this.__chain__);
      }
      function nm() {
        this.__values__ === t && (this.__values__ = jc(this.value()));
        var u = this.__index__ >= this.__values__.length, p = u ? t : this.__values__[this.__index__++];
        return { done: u, value: p };
      }
      function sm() {
        return this;
      }
      function rm(u) {
        for (var p, k = this; k instanceof So; ) {
          var X = Mc(k);
          X.__index__ = 0, X.__values__ = t, p ? ge.__wrapped__ = X : p = X;
          var ge = X;
          k = k.__wrapped__;
        }
        return ge.__wrapped__ = u, p;
      }
      function am() {
        var u = this.__wrapped__;
        if (u instanceof Ei) {
          var p = u;
          return this.__actions__.length && (p = new Ei(this)), p = p.reverse(), p.__actions__.push({
            func: zo,
            args: [sh],
            thisArg: t
          }), new Vs(p, this.__chain__);
        }
        return this.thru(sh);
      }
      function om() {
        return qu(this.__wrapped__, this.__actions__);
      }
      var lm = Eo(function(u, p, k) {
        fi.call(u, k) ? ++u[k] : Mr(u, k, 1);
      });
      function hm(u, p, k) {
        var X = pi(u) ? rt : Qg;
        return k && ds(u, p, k) && (p = t), X(u, Kt(p, 3));
      }
      function um(u, p) {
        var k = pi(u) ? lt : Eu;
        return k(u, Kt(p, 3));
      }
      var cm = sc(Cc), fm = sc(Ac);
      function dm(u, p) {
        return Xn(Fo(u, p), 1);
      }
      function gm(u, p) {
        return Xn(Fo(u, p), Ot);
      }
      function pm(u, p, k) {
        return k = k === t ? 1 : xi(k), Xn(Fo(u, p), k);
      }
      function Ic(u, p) {
        var k = pi(u) ? Oe : Rr;
        return k(u, Kt(p, 3));
      }
      function kc(u, p) {
        var k = pi(u) ? Ue : Bu;
        return k(u, Kt(p, 3));
      }
      var _m = Eo(function(u, p, k) {
        fi.call(u, k) ? u[k].push(p) : Mr(u, k, [p]);
      });
      function mm(u, p, k, X) {
        u = bs(u) ? u : ya(u), k = k && !X ? xi(k) : 0;
        var ge = u.length;
        return k < 0 && (k = Nn(ge + k, 0)), Go(u) ? k <= ge && u.indexOf(p, k) > -1 : !!ge && Oi(u, p, k) > -1;
      }
      var vm = Ci(function(u, p, k) {
        var X = -1, ge = typeof p == "function", Me = bs(u) ? Ne(u.length) : [];
        return Rr(u, function(ke) {
          Me[++X] = ge ? de(p, ke, k) : Ra(ke, p, k);
        }), Me;
      }), ym = Eo(function(u, p, k) {
        Mr(u, k, p);
      });
      function Fo(u, p) {
        var k = pi(u) ? It : Ru;
        return k(u, Kt(p, 3));
      }
      function bm(u, p, k, X) {
        return u == null ? [] : (pi(p) || (p = p == null ? [] : [p]), k = X ? t : k, pi(k) || (k = k == null ? [] : [k]), Uu(u, p, k));
      }
      var xm = Eo(function(u, p, k) {
        u[k ? 0 : 1].push(p);
      }, function() {
        return [[], []];
      });
      function wm(u, p, k) {
        var X = pi(u) ? si : Et, ge = arguments.length < 3;
        return X(u, Kt(p, 4), k, ge, Rr);
      }
      function Sm(u, p, k) {
        var X = pi(u) ? fn : Et, ge = arguments.length < 3;
        return X(u, Kt(p, 4), k, ge, Bu);
      }
      function Mm(u, p) {
        var k = pi(u) ? lt : Eu;
        return k(u, Ho(Kt(p, 3)));
      }
      function Cm(u) {
        var p = pi(u) ? Cu : mp;
        return p(u);
      }
      function Am(u, p, k) {
        (k ? ds(u, p, k) : p === t) ? p = 1 : p = xi(p);
        var X = pi(u) ? Zg : vp;
        return X(u, p);
      }
      function Tm(u) {
        var p = pi(u) ? Xg : bp;
        return p(u);
      }
      function Lm(u) {
        if (u == null)
          return 0;
        if (bs(u))
          return Go(u) ? vs(u) : u.length;
        var p = rs(u);
        return p == Sn || p == Ut ? u.size : Rl(u).length;
      }
      function Bm(u, p, k) {
        var X = pi(u) ? Qi : xp;
        return k && ds(u, p, k) && (p = t), X(u, Kt(p, 3));
      }
      var Em = Ci(function(u, p) {
        if (u == null)
          return [];
        var k = p.length;
        return k > 1 && ds(u, p[0], p[1]) ? p = [] : k > 2 && ds(p[0], p[1], p[2]) && (p = [p[0]]), Uu(u, Xn(p, 1), []);
      }), Uo = ug || function() {
        return $i.Date.now();
      };
      function Om(u, p) {
        if (typeof p != "function")
          throw new wt(c);
        return u = xi(u), function() {
          if (--u < 1)
            return p.apply(this, arguments);
        };
      }
      function Pc(u, p, k) {
        return p = k ? t : p, p = u && p == null ? u.length : p, Cr(u, j, t, t, t, t, p);
      }
      function Nc(u, p) {
        var k;
        if (typeof p != "function")
          throw new wt(c);
        return u = xi(u), function() {
          return --u > 0 && (k = p.apply(this, arguments)), u <= 1 && (p = t), k;
        };
      }
      var ah = Ci(function(u, p, k) {
        var X = ye;
        if (k.length) {
          var ge = Pn(k, ma(ah));
          X |= Ee;
        }
        return Cr(u, X, p, k, ge);
      }), Rc = Ci(function(u, p, k) {
        var X = ye | se;
        if (k.length) {
          var ge = Pn(k, ma(Rc));
          X |= Ee;
        }
        return Cr(p, X, u, k, ge);
      });
      function Dc(u, p, k) {
        p = k ? t : p;
        var X = Cr(u, ue, t, t, t, t, t, p);
        return X.placeholder = Dc.placeholder, X;
      }
      function zc(u, p, k) {
        p = k ? t : p;
        var X = Cr(u, xe, t, t, t, t, t, p);
        return X.placeholder = zc.placeholder, X;
      }
      function Fc(u, p, k) {
        var X, ge, Me, ke, ze, We, ct = 0, ft = !1, St = !1, kt = !0;
        if (typeof u != "function")
          throw new wt(c);
        p = js(p) || 0, pn(k) && (ft = !!k.leading, St = "maxWait" in k, Me = St ? Nn(js(k.maxWait) || 0, p) : Me, kt = "trailing" in k ? !!k.trailing : kt);
        function Rt(An) {
          var nr = X, Er = ge;
          return X = ge = t, ct = An, ke = u.apply(Er, nr), ke;
        }
        function ei(An) {
          return ct = An, ze = Va(Li, p), ft ? Rt(An) : ke;
        }
        function wi(An) {
          var nr = An - We, Er = An - ct, rf = p - nr;
          return St ? ss(rf, Me - Er) : rf;
        }
        function ti(An) {
          var nr = An - We, Er = An - ct;
          return We === t || nr >= p || nr < 0 || St && Er >= Me;
        }
        function Li() {
          var An = Uo();
          if (ti(An))
            return Ii(An);
          ze = Va(Li, wi(An));
        }
        function Ii(An) {
          return ze = t, kt && X ? Rt(An) : (X = ge = t, ke);
        }
        function ks() {
          ze !== t && Xu(ze), ct = 0, X = We = ge = ze = t;
        }
        function gs() {
          return ze === t ? ke : Ii(Uo());
        }
        function Ps() {
          var An = Uo(), nr = ti(An);
          if (X = arguments, ge = this, We = An, nr) {
            if (ze === t)
              return ei(We);
            if (St)
              return Xu(ze), ze = Va(Li, p), Rt(We);
          }
          return ze === t && (ze = Va(Li, p)), ke;
        }
        return Ps.cancel = ks, Ps.flush = gs, Ps;
      }
      var Im = Ci(function(u, p) {
        return Lu(u, 1, p);
      }), km = Ci(function(u, p, k) {
        return Lu(u, js(p) || 0, k);
      });
      function Pm(u) {
        return Cr(u, Ze);
      }
      function Vo(u, p) {
        if (typeof u != "function" || p != null && typeof p != "function")
          throw new wt(c);
        var k = function() {
          var X = arguments, ge = p ? p.apply(this, X) : X[0], Me = k.cache;
          if (Me.has(ge))
            return Me.get(ge);
          var ke = u.apply(this, X);
          return k.cache = Me.set(ge, ke) || Me, ke;
        };
        return k.cache = new (Vo.Cache || Sr)(), k;
      }
      Vo.Cache = Sr;
      function Ho(u) {
        if (typeof u != "function")
          throw new wt(c);
        return function() {
          var p = arguments;
          switch (p.length) {
            case 0:
              return !u.call(this);
            case 1:
              return !u.call(this, p[0]);
            case 2:
              return !u.call(this, p[0], p[1]);
            case 3:
              return !u.call(this, p[0], p[1], p[2]);
          }
          return !u.apply(this, p);
        };
      }
      function Nm(u) {
        return Nc(2, u);
      }
      var Rm = wp(function(u, p) {
        p = p.length == 1 && pi(p[0]) ? It(p[0], Ct(Kt())) : It(Xn(p, 1), Ct(Kt()));
        var k = p.length;
        return Ci(function(X) {
          for (var ge = -1, Me = ss(X.length, k); ++ge < Me; )
            X[ge] = p[ge].call(this, X[ge]);
          return de(u, this, X);
        });
      }), oh = Ci(function(u, p) {
        var k = Pn(p, ma(oh));
        return Cr(u, Ee, t, p, k);
      }), Uc = Ci(function(u, p) {
        var k = Pn(p, ma(Uc));
        return Cr(u, K, t, p, k);
      }), Dm = Ar(function(u, p) {
        return Cr(u, ht, t, t, t, p);
      });
      function zm(u, p) {
        if (typeof u != "function")
          throw new wt(c);
        return p = p === t ? p : xi(p), Ci(u, p);
      }
      function Fm(u, p) {
        if (typeof u != "function")
          throw new wt(c);
        return p = p == null ? 0 : Nn(xi(p), 0), Ci(function(k) {
          var X = k[p], ge = Fr(k, 0, p);
          return X && ai(ge, X), de(u, this, ge);
        });
      }
      function Um(u, p, k) {
        var X = !0, ge = !0;
        if (typeof u != "function")
          throw new wt(c);
        return pn(k) && (X = "leading" in k ? !!k.leading : X, ge = "trailing" in k ? !!k.trailing : ge), Fc(u, p, {
          leading: X,
          maxWait: p,
          trailing: ge
        });
      }
      function Vm(u) {
        return Pc(u, 1);
      }
      function Hm(u, p) {
        return oh(jl(p), u);
      }
      function Ym() {
        if (!arguments.length)
          return [];
        var u = arguments[0];
        return pi(u) ? u : [u];
      }
      function Gm(u) {
        return Hs(u, z);
      }
      function jm(u, p) {
        return p = typeof p == "function" ? p : t, Hs(u, z, p);
      }
      function Wm(u) {
        return Hs(u, Y | z);
      }
      function qm(u, p) {
        return p = typeof p == "function" ? p : t, Hs(u, Y | z, p);
      }
      function Zm(u, p) {
        return p == null || Tu(u, p, Gn(p));
      }
      function ir(u, p) {
        return u === p || u !== u && p !== p;
      }
      var Xm = Po(kl), Km = Po(function(u, p) {
        return u >= p;
      }), ra = ku(function() {
        return arguments;
      }()) ? ku : function(u) {
        return wn(u) && fi.call(u, "callee") && !yu.call(u, "callee");
      }, pi = Ne.isArray, Jm = b ? Ct(b) : rp;
      function bs(u) {
        return u != null && Yo(u.length) && !Lr(u);
      }
      function Cn(u) {
        return wn(u) && bs(u);
      }
      function $m(u) {
        return u === !0 || u === !1 || wn(u) && fs(u) == Wn;
      }
      var Ur = fg || vh, Qm = O ? Ct(O) : ap;
      function ev(u) {
        return wn(u) && u.nodeType === 1 && !Ha(u);
      }
      function tv(u) {
        if (u == null)
          return !0;
        if (bs(u) && (pi(u) || typeof u == "string" || typeof u.splice == "function" || Ur(u) || va(u) || ra(u)))
          return !u.length;
        var p = rs(u);
        if (p == Sn || p == Ut)
          return !u.size;
        if (Ua(u))
          return !Rl(u).length;
        for (var k in u)
          if (fi.call(u, k))
            return !1;
        return !0;
      }
      function iv(u, p) {
        return Da(u, p);
      }
      function nv(u, p, k) {
        k = typeof k == "function" ? k : t;
        var X = k ? k(u, p) : t;
        return X === t ? Da(u, p, t, k) : !!X;
      }
      function lh(u) {
        if (!wn(u))
          return !1;
        var p = fs(u);
        return p == Ht || p == Dt || typeof u.message == "string" && typeof u.name == "string" && !Ha(u);
      }
      function sv(u) {
        return typeof u == "number" && xu(u);
      }
      function Lr(u) {
        if (!pn(u))
          return !1;
        var p = fs(u);
        return p == Dn || p == Ln || p == Ms || p == Js;
      }
      function Vc(u) {
        return typeof u == "number" && u == xi(u);
      }
      function Yo(u) {
        return typeof u == "number" && u > -1 && u % 1 == 0 && u <= Ft;
      }
      function pn(u) {
        var p = typeof u;
        return u != null && (p == "object" || p == "function");
      }
      function wn(u) {
        return u != null && typeof u == "object";
      }
      var Hc = G ? Ct(G) : lp;
      function rv(u, p) {
        return u === p || Nl(u, p, $l(p));
      }
      function av(u, p, k) {
        return k = typeof k == "function" ? k : t, Nl(u, p, $l(p), k);
      }
      function ov(u) {
        return Yc(u) && u != +u;
      }
      function lv(u) {
        if (jp(u))
          throw new te(a);
        return Pu(u);
      }
      function hv(u) {
        return u === null;
      }
      function uv(u) {
        return u == null;
      }
      function Yc(u) {
        return typeof u == "number" || wn(u) && fs(u) == qn;
      }
      function Ha(u) {
        if (!wn(u) || fs(u) != ln)
          return !1;
        var p = _o(u);
        if (p === null)
          return !0;
        var k = fi.call(p, "constructor") && p.constructor;
        return typeof k == "function" && k instanceof k && cs.call(k) == ag;
      }
      var hh = Z ? Ct(Z) : hp;
      function cv(u) {
        return Vc(u) && u >= -Ft && u <= Ft;
      }
      var Gc = oe ? Ct(oe) : up;
      function Go(u) {
        return typeof u == "string" || !pi(u) && wn(u) && fs(u) == ki;
      }
      function Is(u) {
        return typeof u == "symbol" || wn(u) && fs(u) == Vt;
      }
      var va = ce ? Ct(ce) : cp;
      function fv(u) {
        return u === t;
      }
      function dv(u) {
        return wn(u) && rs(u) == nt;
      }
      function gv(u) {
        return wn(u) && fs(u) == i;
      }
      var pv = Po(Dl), _v = Po(function(u, p) {
        return u <= p;
      });
      function jc(u) {
        if (!u)
          return [];
        if (bs(u))
          return Go(u) ? gn(u) : ys(u);
        if (Ba && u[Ba])
          return xn(u[Ba]());
        var p = rs(u), k = p == Sn ? Yn : p == Ut ? us : ya;
        return k(u);
      }
      function Br(u) {
        if (!u)
          return u === 0 ? u : 0;
        if (u = js(u), u === Ot || u === -Ot) {
          var p = u < 0 ? -1 : 1;
          return p * Bt;
        }
        return u === u ? u : 0;
      }
      function xi(u) {
        var p = Br(u), k = p % 1;
        return p === p ? k ? p - k : p : 0;
      }
      function Wc(u) {
        return u ? ta(xi(u), 0, on) : 0;
      }
      function js(u) {
        if (typeof u == "number")
          return u;
        if (Is(u))
          return yi;
        if (pn(u)) {
          var p = typeof u.valueOf == "function" ? u.valueOf() : u;
          u = pn(p) ? p + "" : p;
        }
        if (typeof u != "string")
          return u === 0 ? u : +u;
        u = Hi(u);
        var k = Be.test(u);
        return k || Ge.test(u) ? Kr(u.slice(2), k ? 2 : 8) : Je.test(u) ? yi : +u;
      }
      function qc(u) {
        return fr(u, xs(u));
      }
      function mv(u) {
        return u ? ta(xi(u), -Ft, Ft) : u === 0 ? u : 0;
      }
      function Yi(u) {
        return u == null ? "" : Os(u);
      }
      var vv = pa(function(u, p) {
        if (Ua(p) || bs(p)) {
          fr(p, Gn(p), u);
          return;
        }
        for (var k in p)
          fi.call(p, k) && Pa(u, k, p[k]);
      }), Zc = pa(function(u, p) {
        fr(p, xs(p), u);
      }), jo = pa(function(u, p, k, X) {
        fr(p, xs(p), u, X);
      }), yv = pa(function(u, p, k, X) {
        fr(p, Gn(p), u, X);
      }), bv = Ar(El);
      function xv(u, p) {
        var k = ga(u);
        return p == null ? k : Au(k, p);
      }
      var wv = Ci(function(u, p) {
        u = qe(u);
        var k = -1, X = p.length, ge = X > 2 ? p[2] : t;
        for (ge && ds(p[0], p[1], ge) && (X = 1); ++k < X; )
          for (var Me = p[k], ke = xs(Me), ze = -1, We = ke.length; ++ze < We; ) {
            var ct = ke[ze], ft = u[ct];
            (ft === t || ir(ft, tn[ct]) && !fi.call(u, ct)) && (u[ct] = Me[ct]);
          }
        return u;
      }), Sv = Ci(function(u) {
        return u.push(t, cc), de(Xc, t, u);
      });
      function Mv(u, p) {
        return yn(u, Kt(p, 3), cr);
      }
      function Cv(u, p) {
        return yn(u, Kt(p, 3), Il);
      }
      function Av(u, p) {
        return u == null ? u : Ol(u, Kt(p, 3), xs);
      }
      function Tv(u, p) {
        return u == null ? u : Ou(u, Kt(p, 3), xs);
      }
      function Lv(u, p) {
        return u && cr(u, Kt(p, 3));
      }
      function Bv(u, p) {
        return u && Il(u, Kt(p, 3));
      }
      function Ev(u) {
        return u == null ? [] : Ao(u, Gn(u));
      }
      function Ov(u) {
        return u == null ? [] : Ao(u, xs(u));
      }
      function uh(u, p, k) {
        var X = u == null ? t : ia(u, p);
        return X === t ? k : X;
      }
      function Iv(u, p) {
        return u != null && gc(u, p, tp);
      }
      function ch(u, p) {
        return u != null && gc(u, p, ip);
      }
      var kv = ac(function(u, p, k) {
        p != null && typeof p.toString != "function" && (p = fo.call(p)), u[p] = k;
      }, dh(ws)), Pv = ac(function(u, p, k) {
        p != null && typeof p.toString != "function" && (p = fo.call(p)), fi.call(u, p) ? u[p].push(k) : u[p] = [k];
      }, Kt), Nv = Ci(Ra);
      function Gn(u) {
        return bs(u) ? Mu(u) : Rl(u);
      }
      function xs(u) {
        return bs(u) ? Mu(u, !0) : fp(u);
      }
      function Rv(u, p) {
        var k = {};
        return p = Kt(p, 3), cr(u, function(X, ge, Me) {
          Mr(k, p(X, ge, Me), X);
        }), k;
      }
      function Dv(u, p) {
        var k = {};
        return p = Kt(p, 3), cr(u, function(X, ge, Me) {
          Mr(k, ge, p(X, ge, Me));
        }), k;
      }
      var zv = pa(function(u, p, k) {
        To(u, p, k);
      }), Xc = pa(function(u, p, k, X) {
        To(u, p, k, X);
      }), Fv = Ar(function(u, p) {
        var k = {};
        if (u == null)
          return k;
        var X = !1;
        p = It(p, function(Me) {
          return Me = zr(Me, u), X || (X = Me.length > 1), Me;
        }), fr(u, Kl(u), k), X && (k = Hs(k, Y | ee | z, kp));
        for (var ge = p.length; ge--; )
          Hl(k, p[ge]);
        return k;
      });
      function Uv(u, p) {
        return Kc(u, Ho(Kt(p)));
      }
      var Vv = Ar(function(u, p) {
        return u == null ? {} : gp(u, p);
      });
      function Kc(u, p) {
        if (u == null)
          return {};
        var k = It(Kl(u), function(X) {
          return [X];
        });
        return p = Kt(p), Vu(u, k, function(X, ge) {
          return p(X, ge[0]);
        });
      }
      function Hv(u, p, k) {
        p = zr(p, u);
        var X = -1, ge = p.length;
        for (ge || (ge = 1, u = t); ++X < ge; ) {
          var Me = u == null ? t : u[dr(p[X])];
          Me === t && (X = ge, Me = k), u = Lr(Me) ? Me.call(u) : Me;
        }
        return u;
      }
      function Yv(u, p, k) {
        return u == null ? u : za(u, p, k);
      }
      function Gv(u, p, k, X) {
        return X = typeof X == "function" ? X : t, u == null ? u : za(u, p, k, X);
      }
      var Jc = hc(Gn), $c = hc(xs);
      function jv(u, p, k) {
        var X = pi(u), ge = X || Ur(u) || va(u);
        if (p = Kt(p, 4), k == null) {
          var Me = u && u.constructor;
          ge ? k = X ? new Me() : [] : pn(u) ? k = Lr(Me) ? ga(_o(u)) : {} : k = {};
        }
        return (ge ? Oe : cr)(u, function(ke, ze, We) {
          return p(k, ke, ze, We);
        }), k;
      }
      function Wv(u, p) {
        return u == null ? !0 : Hl(u, p);
      }
      function qv(u, p, k) {
        return u == null ? u : Wu(u, p, jl(k));
      }
      function Zv(u, p, k, X) {
        return X = typeof X == "function" ? X : t, u == null ? u : Wu(u, p, jl(k), X);
      }
      function ya(u) {
        return u == null ? [] : Bs(u, Gn(u));
      }
      function Xv(u) {
        return u == null ? [] : Bs(u, xs(u));
      }
      function Kv(u, p, k) {
        return k === t && (k = p, p = t), k !== t && (k = js(k), k = k === k ? k : 0), p !== t && (p = js(p), p = p === p ? p : 0), ta(js(u), p, k);
      }
      function Jv(u, p, k) {
        return p = Br(p), k === t ? (k = p, p = 0) : k = Br(k), u = js(u), np(u, p, k);
      }
      function $v(u, p, k) {
        if (k && typeof k != "boolean" && ds(u, p, k) && (p = k = t), k === t && (typeof p == "boolean" ? (k = p, p = t) : typeof u == "boolean" && (k = u, u = t)), u === t && p === t ? (u = 0, p = 1) : (u = Br(u), p === t ? (p = u, u = 0) : p = Br(p)), u > p) {
          var X = u;
          u = p, p = X;
        }
        if (k || u % 1 || p % 1) {
          var ge = wu();
          return ss(u + ge * (p - u + br("1e-" + ((ge + "").length - 1))), p);
        }
        return Fl(u, p);
      }
      var Qv = _a(function(u, p, k) {
        return p = p.toLowerCase(), u + (k ? Qc(p) : p);
      });
      function Qc(u) {
        return fh(Yi(u).toLowerCase());
      }
      function ef(u) {
        return u = Yi(u), u && u.replace(tt, Xi).replace($t, "");
      }
      function e0(u, p, k) {
        u = Yi(u), p = Os(p);
        var X = u.length;
        k = k === t ? X : ta(xi(k), 0, X);
        var ge = k;
        return k -= p.length, k >= 0 && u.slice(k, ge) == p;
      }
      function t0(u) {
        return u = Yi(u), u && P.test(u) ? u.replace(D, Es) : u;
      }
      function i0(u) {
        return u = Yi(u), u && ie.test(u) ? u.replace(Q, "\\$&") : u;
      }
      var n0 = _a(function(u, p, k) {
        return u + (k ? "-" : "") + p.toLowerCase();
      }), s0 = _a(function(u, p, k) {
        return u + (k ? " " : "") + p.toLowerCase();
      }), r0 = nc("toLowerCase");
      function a0(u, p, k) {
        u = Yi(u), p = xi(p);
        var X = p ? vs(u) : 0;
        if (!p || X >= p)
          return u;
        var ge = (p - X) / 2;
        return ko(bo(ge), k) + u + ko(yo(ge), k);
      }
      function o0(u, p, k) {
        u = Yi(u), p = xi(p);
        var X = p ? vs(u) : 0;
        return p && X < p ? u + ko(p - X, k) : u;
      }
      function l0(u, p, k) {
        u = Yi(u), p = xi(p);
        var X = p ? vs(u) : 0;
        return p && X < p ? ko(p - X, k) + u : u;
      }
      function h0(u, p, k) {
        return k || p == null ? p = 0 : p && (p = +p), _g(Yi(u).replace(ae, ""), p || 0);
      }
      function u0(u, p, k) {
        return (k ? ds(u, p, k) : p === t) ? p = 1 : p = xi(p), Ul(Yi(u), p);
      }
      function c0() {
        var u = arguments, p = Yi(u[0]);
        return u.length < 3 ? p : p.replace(u[1], u[2]);
      }
      var f0 = _a(function(u, p, k) {
        return u + (k ? "_" : "") + p.toLowerCase();
      });
      function d0(u, p, k) {
        return k && typeof k != "number" && ds(u, p, k) && (p = k = t), k = k === t ? on : k >>> 0, k ? (u = Yi(u), u && (typeof p == "string" || p != null && !hh(p)) && (p = Os(p), !p && Hn(u)) ? Fr(gn(u), 0, k) : u.split(p, k)) : [];
      }
      var g0 = _a(function(u, p, k) {
        return u + (k ? " " : "") + fh(p);
      });
      function p0(u, p, k) {
        return u = Yi(u), k = k == null ? 0 : ta(xi(k), 0, u.length), p = Os(p), u.slice(k, k + p.length) == p;
      }
      function _0(u, p, k) {
        var X = we.templateSettings;
        k && ds(u, p, k) && (p = t), u = Yi(u), p = jo({}, p, X, uc);
        var ge = jo({}, p.imports, X.imports, uc), Me = Gn(ge), ke = Bs(ge, Me), ze, We, ct = 0, ft = p.interpolate || gt, St = "__p += '", kt = ot(
          (p.escape || gt).source + "|" + ft.source + "|" + (ft === U ? He : gt).source + "|" + (p.evaluate || gt).source + "|$",
          "g"
        ), Rt = "//# sourceURL=" + (fi.call(p, "sourceURL") ? (p.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++zs + "]") + `
`;
        u.replace(kt, function(ti, Li, Ii, ks, gs, Ps) {
          return Ii || (Ii = ks), St += u.slice(ct, Ps).replace(ut, Jr), Li && (ze = !0, St += `' +
__e(` + Li + `) +
'`), gs && (We = !0, St += `';
` + gs + `;
__p += '`), Ii && (St += `' +
((__t = (` + Ii + `)) == null ? '' : __t) +
'`), ct = Ps + ti.length, ti;
        }), St += `';
`;
        var ei = fi.call(p, "variable") && p.variable;
        if (!ei)
          St = `with (obj) {
` + St + `
}
`;
        else if (Se.test(ei))
          throw new te(g);
        St = (We ? St.replace(C, "") : St).replace(M, "$1").replace(R, "$1;"), St = "function(" + (ei || "obj") + `) {
` + (ei ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ze ? ", __e = _.escape" : "") + (We ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + St + `return __p
}`;
        var wi = nf(function() {
          return be(Me, Rt + "return " + St).apply(t, ke);
        });
        if (wi.source = St, lh(wi))
          throw wi;
        return wi;
      }
      function m0(u) {
        return Yi(u).toLowerCase();
      }
      function v0(u) {
        return Yi(u).toUpperCase();
      }
      function y0(u, p, k) {
        if (u = Yi(u), u && (k || p === t))
          return Hi(u);
        if (!u || !(p = Os(p)))
          return u;
        var X = gn(u), ge = gn(p), Me = vi(X, ge), ke = dn(X, ge) + 1;
        return Fr(X, Me, ke).join("");
      }
      function b0(u, p, k) {
        if (u = Yi(u), u && (k || p === t))
          return u.slice(0, Us(u) + 1);
        if (!u || !(p = Os(p)))
          return u;
        var X = gn(u), ge = dn(X, gn(p)) + 1;
        return Fr(X, 0, ge).join("");
      }
      function x0(u, p, k) {
        if (u = Yi(u), u && (k || p === t))
          return u.replace(ae, "");
        if (!u || !(p = Os(p)))
          return u;
        var X = gn(u), ge = vi(X, gn(p));
        return Fr(X, ge).join("");
      }
      function w0(u, p) {
        var k = pt, X = Pt;
        if (pn(p)) {
          var ge = "separator" in p ? p.separator : ge;
          k = "length" in p ? xi(p.length) : k, X = "omission" in p ? Os(p.omission) : X;
        }
        u = Yi(u);
        var Me = u.length;
        if (Hn(u)) {
          var ke = gn(u);
          Me = ke.length;
        }
        if (k >= Me)
          return u;
        var ze = k - vs(X);
        if (ze < 1)
          return X;
        var We = ke ? Fr(ke, 0, ze).join("") : u.slice(0, ze);
        if (ge === t)
          return We + X;
        if (ke && (ze += We.length - ze), hh(ge)) {
          if (u.slice(ze).search(ge)) {
            var ct, ft = We;
            for (ge.global || (ge = ot(ge.source, Yi(Ye.exec(ge)) + "g")), ge.lastIndex = 0; ct = ge.exec(ft); )
              var St = ct.index;
            We = We.slice(0, St === t ? ze : St);
          }
        } else if (u.indexOf(Os(ge), ze) != ze) {
          var kt = We.lastIndexOf(ge);
          kt > -1 && (We = We.slice(0, kt));
        }
        return We + X;
      }
      function S0(u) {
        return u = Yi(u), u && L.test(u) ? u.replace(E, xr) : u;
      }
      var M0 = _a(function(u, p, k) {
        return u + (k ? " " : "") + p.toUpperCase();
      }), fh = nc("toUpperCase");
      function tf(u, p, k) {
        return u = Yi(u), p = k ? t : p, p === t ? ji(u) ? Fe(u) : di(u) : u.match(p) || [];
      }
      var nf = Ci(function(u, p) {
        try {
          return de(u, t, p);
        } catch (k) {
          return lh(k) ? k : new te(k);
        }
      }), C0 = Ar(function(u, p) {
        return Oe(p, function(k) {
          k = dr(k), Mr(u, k, ah(u[k], u));
        }), u;
      });
      function A0(u) {
        var p = u == null ? 0 : u.length, k = Kt();
        return u = p ? It(u, function(X) {
          if (typeof X[1] != "function")
            throw new wt(c);
          return [k(X[0]), X[1]];
        }) : [], Ci(function(X) {
          for (var ge = -1; ++ge < p; ) {
            var Me = u[ge];
            if (de(Me[0], this, X))
              return de(Me[1], this, X);
          }
        });
      }
      function T0(u) {
        return $g(Hs(u, Y));
      }
      function dh(u) {
        return function() {
          return u;
        };
      }
      function L0(u, p) {
        return u == null || u !== u ? p : u;
      }
      var B0 = rc(), E0 = rc(!0);
      function ws(u) {
        return u;
      }
      function gh(u) {
        return Nu(typeof u == "function" ? u : Hs(u, Y));
      }
      function O0(u) {
        return Du(Hs(u, Y));
      }
      function I0(u, p) {
        return zu(u, Hs(p, Y));
      }
      var k0 = Ci(function(u, p) {
        return function(k) {
          return Ra(k, u, p);
        };
      }), P0 = Ci(function(u, p) {
        return function(k) {
          return Ra(u, k, p);
        };
      });
      function ph(u, p, k) {
        var X = Gn(p), ge = Ao(p, X);
        k == null && !(pn(p) && (ge.length || !X.length)) && (k = p, p = u, u = this, ge = Ao(p, Gn(p)));
        var Me = !(pn(k) && "chain" in k) || !!k.chain, ke = Lr(u);
        return Oe(ge, function(ze) {
          var We = p[ze];
          u[ze] = We, ke && (u.prototype[ze] = function() {
            var ct = this.__chain__;
            if (Me || ct) {
              var ft = u(this.__wrapped__), St = ft.__actions__ = ys(this.__actions__);
              return St.push({ func: We, args: arguments, thisArg: u }), ft.__chain__ = ct, ft;
            }
            return We.apply(u, ai([this.value()], arguments));
          });
        }), u;
      }
      function N0() {
        return $i._ === this && ($i._ = og), this;
      }
      function _h() {
      }
      function R0(u) {
        return u = xi(u), Ci(function(p) {
          return Fu(p, u);
        });
      }
      var D0 = ql(It), z0 = ql(rt), F0 = ql(Qi);
      function sf(u) {
        return eh(u) ? hs(dr(u)) : pp(u);
      }
      function U0(u) {
        return function(p) {
          return u == null ? t : ia(u, p);
        };
      }
      var V0 = oc(), H0 = oc(!0);
      function mh() {
        return [];
      }
      function vh() {
        return !1;
      }
      function Y0() {
        return {};
      }
      function G0() {
        return "";
      }
      function j0() {
        return !0;
      }
      function W0(u, p) {
        if (u = xi(u), u < 1 || u > Ft)
          return [];
        var k = on, X = ss(u, on);
        p = Kt(p), u -= on;
        for (var ge = Ls(X, p); ++k < u; )
          p(k);
        return ge;
      }
      function q0(u) {
        return pi(u) ? It(u, dr) : Is(u) ? [u] : ys(Sc(Yi(u)));
      }
      function Z0(u) {
        var p = ++rg;
        return Yi(u) + p;
      }
      var X0 = Io(function(u, p) {
        return u + p;
      }, 0), K0 = Zl("ceil"), J0 = Io(function(u, p) {
        return u / p;
      }, 1), $0 = Zl("floor");
      function Q0(u) {
        return u && u.length ? Co(u, ws, kl) : t;
      }
      function ey(u, p) {
        return u && u.length ? Co(u, Kt(p, 2), kl) : t;
      }
      function ty(u) {
        return en(u, ws);
      }
      function iy(u, p) {
        return en(u, Kt(p, 2));
      }
      function ny(u) {
        return u && u.length ? Co(u, ws, Dl) : t;
      }
      function sy(u, p) {
        return u && u.length ? Co(u, Kt(p, 2), Dl) : t;
      }
      var ry = Io(function(u, p) {
        return u * p;
      }, 1), ay = Zl("round"), oy = Io(function(u, p) {
        return u - p;
      }, 0);
      function ly(u) {
        return u && u.length ? bn(u, ws) : 0;
      }
      function hy(u, p) {
        return u && u.length ? bn(u, Kt(p, 2)) : 0;
      }
      return we.after = Om, we.ary = Pc, we.assign = vv, we.assignIn = Zc, we.assignInWith = jo, we.assignWith = yv, we.at = bv, we.before = Nc, we.bind = ah, we.bindAll = C0, we.bindKey = Rc, we.castArray = Ym, we.chain = Oc, we.chunk = $p, we.compact = Qp, we.concat = e_, we.cond = A0, we.conforms = T0, we.constant = dh, we.countBy = lm, we.create = xv, we.curry = Dc, we.curryRight = zc, we.debounce = Fc, we.defaults = wv, we.defaultsDeep = Sv, we.defer = Im, we.delay = km, we.difference = t_, we.differenceBy = i_, we.differenceWith = n_, we.drop = s_, we.dropRight = r_, we.dropRightWhile = a_, we.dropWhile = o_, we.fill = l_, we.filter = um, we.flatMap = dm, we.flatMapDeep = gm, we.flatMapDepth = pm, we.flatten = Tc, we.flattenDeep = h_, we.flattenDepth = u_, we.flip = Pm, we.flow = B0, we.flowRight = E0, we.fromPairs = c_, we.functions = Ev, we.functionsIn = Ov, we.groupBy = _m, we.initial = d_, we.intersection = g_, we.intersectionBy = p_, we.intersectionWith = __, we.invert = kv, we.invertBy = Pv, we.invokeMap = vm, we.iteratee = gh, we.keyBy = ym, we.keys = Gn, we.keysIn = xs, we.map = Fo, we.mapKeys = Rv, we.mapValues = Dv, we.matches = O0, we.matchesProperty = I0, we.memoize = Vo, we.merge = zv, we.mergeWith = Xc, we.method = k0, we.methodOf = P0, we.mixin = ph, we.negate = Ho, we.nthArg = R0, we.omit = Fv, we.omitBy = Uv, we.once = Nm, we.orderBy = bm, we.over = D0, we.overArgs = Rm, we.overEvery = z0, we.overSome = F0, we.partial = oh, we.partialRight = Uc, we.partition = xm, we.pick = Vv, we.pickBy = Kc, we.property = sf, we.propertyOf = U0, we.pull = b_, we.pullAll = Bc, we.pullAllBy = x_, we.pullAllWith = w_, we.pullAt = S_, we.range = V0, we.rangeRight = H0, we.rearg = Dm, we.reject = Mm, we.remove = M_, we.rest = zm, we.reverse = sh, we.sampleSize = Am, we.set = Yv, we.setWith = Gv, we.shuffle = Tm, we.slice = C_, we.sortBy = Em, we.sortedUniq = I_, we.sortedUniqBy = k_, we.split = d0, we.spread = Fm, we.tail = P_, we.take = N_, we.takeRight = R_, we.takeRightWhile = D_, we.takeWhile = z_, we.tap = Q_, we.throttle = Um, we.thru = zo, we.toArray = jc, we.toPairs = Jc, we.toPairsIn = $c, we.toPath = q0, we.toPlainObject = qc, we.transform = jv, we.unary = Vm, we.union = F_, we.unionBy = U_, we.unionWith = V_, we.uniq = H_, we.uniqBy = Y_, we.uniqWith = G_, we.unset = Wv, we.unzip = rh, we.unzipWith = Ec, we.update = qv, we.updateWith = Zv, we.values = ya, we.valuesIn = Xv, we.without = j_, we.words = tf, we.wrap = Hm, we.xor = W_, we.xorBy = q_, we.xorWith = Z_, we.zip = X_, we.zipObject = K_, we.zipObjectDeep = J_, we.zipWith = $_, we.entries = Jc, we.entriesIn = $c, we.extend = Zc, we.extendWith = jo, ph(we, we), we.add = X0, we.attempt = nf, we.camelCase = Qv, we.capitalize = Qc, we.ceil = K0, we.clamp = Kv, we.clone = Gm, we.cloneDeep = Wm, we.cloneDeepWith = qm, we.cloneWith = jm, we.conformsTo = Zm, we.deburr = ef, we.defaultTo = L0, we.divide = J0, we.endsWith = e0, we.eq = ir, we.escape = t0, we.escapeRegExp = i0, we.every = hm, we.find = cm, we.findIndex = Cc, we.findKey = Mv, we.findLast = fm, we.findLastIndex = Ac, we.findLastKey = Cv, we.floor = $0, we.forEach = Ic, we.forEachRight = kc, we.forIn = Av, we.forInRight = Tv, we.forOwn = Lv, we.forOwnRight = Bv, we.get = uh, we.gt = Xm, we.gte = Km, we.has = Iv, we.hasIn = ch, we.head = Lc, we.identity = ws, we.includes = mm, we.indexOf = f_, we.inRange = Jv, we.invoke = Nv, we.isArguments = ra, we.isArray = pi, we.isArrayBuffer = Jm, we.isArrayLike = bs, we.isArrayLikeObject = Cn, we.isBoolean = $m, we.isBuffer = Ur, we.isDate = Qm, we.isElement = ev, we.isEmpty = tv, we.isEqual = iv, we.isEqualWith = nv, we.isError = lh, we.isFinite = sv, we.isFunction = Lr, we.isInteger = Vc, we.isLength = Yo, we.isMap = Hc, we.isMatch = rv, we.isMatchWith = av, we.isNaN = ov, we.isNative = lv, we.isNil = uv, we.isNull = hv, we.isNumber = Yc, we.isObject = pn, we.isObjectLike = wn, we.isPlainObject = Ha, we.isRegExp = hh, we.isSafeInteger = cv, we.isSet = Gc, we.isString = Go, we.isSymbol = Is, we.isTypedArray = va, we.isUndefined = fv, we.isWeakMap = dv, we.isWeakSet = gv, we.join = m_, we.kebabCase = n0, we.last = Gs, we.lastIndexOf = v_, we.lowerCase = s0, we.lowerFirst = r0, we.lt = pv, we.lte = _v, we.max = Q0, we.maxBy = ey, we.mean = ty, we.meanBy = iy, we.min = ny, we.minBy = sy, we.stubArray = mh, we.stubFalse = vh, we.stubObject = Y0, we.stubString = G0, we.stubTrue = j0, we.multiply = ry, we.nth = y_, we.noConflict = N0, we.noop = _h, we.now = Uo, we.pad = a0, we.padEnd = o0, we.padStart = l0, we.parseInt = h0, we.random = $v, we.reduce = wm, we.reduceRight = Sm, we.repeat = u0, we.replace = c0, we.result = Hv, we.round = ay, we.runInContext = Ce, we.sample = Cm, we.size = Lm, we.snakeCase = f0, we.some = Bm, we.sortedIndex = A_, we.sortedIndexBy = T_, we.sortedIndexOf = L_, we.sortedLastIndex = B_, we.sortedLastIndexBy = E_, we.sortedLastIndexOf = O_, we.startCase = g0, we.startsWith = p0, we.subtract = oy, we.sum = ly, we.sumBy = hy, we.template = _0, we.times = W0, we.toFinite = Br, we.toInteger = xi, we.toLength = Wc, we.toLower = m0, we.toNumber = js, we.toSafeInteger = mv, we.toString = Yi, we.toUpper = v0, we.trim = y0, we.trimEnd = b0, we.trimStart = x0, we.truncate = w0, we.unescape = S0, we.uniqueId = Z0, we.upperCase = M0, we.upperFirst = fh, we.each = Ic, we.eachRight = kc, we.first = Lc, ph(we, function() {
        var u = {};
        return cr(we, function(p, k) {
          fi.call(we.prototype, k) || (u[k] = p);
        }), u;
      }(), { chain: !1 }), we.VERSION = s, Oe(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(u) {
        we[u].placeholder = we;
      }), Oe(["drop", "take"], function(u, p) {
        Ei.prototype[u] = function(k) {
          k = k === t ? 1 : Nn(xi(k), 0);
          var X = this.__filtered__ && !p ? new Ei(this) : this.clone();
          return X.__filtered__ ? X.__takeCount__ = ss(k, X.__takeCount__) : X.__views__.push({
            size: ss(k, on),
            type: u + (X.__dir__ < 0 ? "Right" : "")
          }), X;
        }, Ei.prototype[u + "Right"] = function(k) {
          return this.reverse()[u](k).reverse();
        };
      }), Oe(["filter", "map", "takeWhile"], function(u, p) {
        var k = p + 1, X = k == at || k == Ve;
        Ei.prototype[u] = function(ge) {
          var Me = this.clone();
          return Me.__iteratees__.push({
            iteratee: Kt(ge, 3),
            type: k
          }), Me.__filtered__ = Me.__filtered__ || X, Me;
        };
      }), Oe(["head", "last"], function(u, p) {
        var k = "take" + (p ? "Right" : "");
        Ei.prototype[u] = function() {
          return this[k](1).value()[0];
        };
      }), Oe(["initial", "tail"], function(u, p) {
        var k = "drop" + (p ? "" : "Right");
        Ei.prototype[u] = function() {
          return this.__filtered__ ? new Ei(this) : this[k](1);
        };
      }), Ei.prototype.compact = function() {
        return this.filter(ws);
      }, Ei.prototype.find = function(u) {
        return this.filter(u).head();
      }, Ei.prototype.findLast = function(u) {
        return this.reverse().find(u);
      }, Ei.prototype.invokeMap = Ci(function(u, p) {
        return typeof u == "function" ? new Ei(this) : this.map(function(k) {
          return Ra(k, u, p);
        });
      }), Ei.prototype.reject = function(u) {
        return this.filter(Ho(Kt(u)));
      }, Ei.prototype.slice = function(u, p) {
        u = xi(u);
        var k = this;
        return k.__filtered__ && (u > 0 || p < 0) ? new Ei(k) : (u < 0 ? k = k.takeRight(-u) : u && (k = k.drop(u)), p !== t && (p = xi(p), k = p < 0 ? k.dropRight(-p) : k.take(p - u)), k);
      }, Ei.prototype.takeRightWhile = function(u) {
        return this.reverse().takeWhile(u).reverse();
      }, Ei.prototype.toArray = function() {
        return this.take(on);
      }, cr(Ei.prototype, function(u, p) {
        var k = /^(?:filter|find|map|reject)|While$/.test(p), X = /^(?:head|last)$/.test(p), ge = we[X ? "take" + (p == "last" ? "Right" : "") : p], Me = X || /^find/.test(p);
        ge && (we.prototype[p] = function() {
          var ke = this.__wrapped__, ze = X ? [1] : arguments, We = ke instanceof Ei, ct = ze[0], ft = We || pi(ke), St = function(Li) {
            var Ii = ge.apply(we, ai([Li], ze));
            return X && kt ? Ii[0] : Ii;
          };
          ft && k && typeof ct == "function" && ct.length != 1 && (We = ft = !1);
          var kt = this.__chain__, Rt = !!this.__actions__.length, ei = Me && !kt, wi = We && !Rt;
          if (!Me && ft) {
            ke = wi ? ke : new Ei(this);
            var ti = u.apply(ke, ze);
            return ti.__actions__.push({ func: zo, args: [St], thisArg: t }), new Vs(ti, kt);
          }
          return ei && wi ? u.apply(this, ze) : (ti = this.thru(St), ei ? X ? ti.value()[0] : ti.value() : ti);
        });
      }), Oe(["pop", "push", "shift", "sort", "splice", "unshift"], function(u) {
        var p = gi[u], k = /^(?:push|sort|unshift)$/.test(u) ? "tap" : "thru", X = /^(?:pop|shift)$/.test(u);
        we.prototype[u] = function() {
          var ge = arguments;
          if (X && !this.__chain__) {
            var Me = this.value();
            return p.apply(pi(Me) ? Me : [], ge);
          }
          return this[k](function(ke) {
            return p.apply(pi(ke) ? ke : [], ge);
          });
        };
      }), cr(Ei.prototype, function(u, p) {
        var k = we[p];
        if (k) {
          var X = k.name + "";
          fi.call(da, X) || (da[X] = []), da[X].push({ name: p, func: k });
        }
      }), da[Oo(t, se).name] = [{
        name: "wrapper",
        func: t
      }], Ei.prototype.clone = Sg, Ei.prototype.reverse = Mg, Ei.prototype.value = Cg, we.prototype.at = em, we.prototype.chain = tm, we.prototype.commit = im, we.prototype.next = nm, we.prototype.plant = rm, we.prototype.reverse = am, we.prototype.toJSON = we.prototype.valueOf = we.prototype.value = om, we.prototype.first = we.prototype.head, Ba && (we.prototype[Ba] = sm), we;
    }, $e = Xe();
    Zn ? ((Zn.exports = $e)._ = $e, hr._ = $e) : $i._ = $e;
  }).call(Gr);
})(pl, pl.exports);
var ew = pl.exports;
function tw(v) {
  throw new Error('Could not dynamically require "' + v + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Xd = { exports: {} };
const iw = {}, nw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: iw
}, Symbol.toStringTag, { value: "Module" })), Of = /* @__PURE__ */ Ax(nw);
var $o = { exports: {} }, If;
function sw() {
  return If || (If = 1, function(v, e) {
    (function(t, s) {
      s(e);
    })(Gr, function(t) {
      var s = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], o = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191], a = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", c = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", g = {
        3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
        5: "class enum extends super const export import",
        6: "enum",
        strict: "implements interface let package private protected public static yield",
        strictBind: "eval arguments"
      }, w = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", T = {
        5: w,
        "5module": w + " export import",
        6: w + " const class extends export import super"
      }, H = /^in(stanceof)?$/, Y = new RegExp("[" + c + "]"), ee = new RegExp("[" + c + a + "]");
      function z(d, N) {
        for (var re = 65536, pe = 0; pe < N.length; pe += 2) {
          if (re += N[pe], re > d)
            return !1;
          if (re += N[pe + 1], re >= d)
            return !0;
        }
        return !1;
      }
      function he(d, N) {
        return d < 65 ? d === 36 : d < 91 ? !0 : d < 97 ? d === 95 : d < 123 ? !0 : d <= 65535 ? d >= 170 && Y.test(String.fromCharCode(d)) : N === !1 ? !1 : z(d, o);
      }
      function ne(d, N) {
        return d < 48 ? d === 36 : d < 58 ? !0 : d < 65 ? !1 : d < 91 ? !0 : d < 97 ? d === 95 : d < 123 ? !0 : d <= 65535 ? d >= 170 && ee.test(String.fromCharCode(d)) : N === !1 ? !1 : z(d, o) || z(d, s);
      }
      var ye = function(N, re) {
        re === void 0 && (re = {}), this.label = N, this.keyword = re.keyword, this.beforeExpr = !!re.beforeExpr, this.startsExpr = !!re.startsExpr, this.isLoop = !!re.isLoop, this.isAssign = !!re.isAssign, this.prefix = !!re.prefix, this.postfix = !!re.postfix, this.binop = re.binop || null, this.updateContext = null;
      };
      function se(d, N) {
        return new ye(d, { beforeExpr: !0, binop: N });
      }
      var _e = { beforeExpr: !0 }, ue = { startsExpr: !0 }, xe = {};
      function Ee(d, N) {
        return N === void 0 && (N = {}), N.keyword = d, xe[d] = new ye(d, N);
      }
      var K = {
        num: new ye("num", ue),
        regexp: new ye("regexp", ue),
        string: new ye("string", ue),
        name: new ye("name", ue),
        privateId: new ye("privateId", ue),
        eof: new ye("eof"),
        // Punctuation token types.
        bracketL: new ye("[", { beforeExpr: !0, startsExpr: !0 }),
        bracketR: new ye("]"),
        braceL: new ye("{", { beforeExpr: !0, startsExpr: !0 }),
        braceR: new ye("}"),
        parenL: new ye("(", { beforeExpr: !0, startsExpr: !0 }),
        parenR: new ye(")"),
        comma: new ye(",", _e),
        semi: new ye(";", _e),
        colon: new ye(":", _e),
        dot: new ye("."),
        question: new ye("?", _e),
        questionDot: new ye("?."),
        arrow: new ye("=>", _e),
        template: new ye("template"),
        invalidTemplate: new ye("invalidTemplate"),
        ellipsis: new ye("...", _e),
        backQuote: new ye("`", ue),
        dollarBraceL: new ye("${", { beforeExpr: !0, startsExpr: !0 }),
        // Operators. These carry several kinds of properties to help the
        // parser use them properly (the presence of these properties is
        // what categorizes them as operators).
        //
        // `binop`, when present, specifies that this operator is a binary
        // operator, and will refer to its precedence.
        //
        // `prefix` and `postfix` mark the operator as a prefix or postfix
        // unary operator.
        //
        // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
        // binary operators with a very low precedence, that should result
        // in AssignmentExpression nodes.
        eq: new ye("=", { beforeExpr: !0, isAssign: !0 }),
        assign: new ye("_=", { beforeExpr: !0, isAssign: !0 }),
        incDec: new ye("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
        prefix: new ye("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        logicalOR: se("||", 1),
        logicalAND: se("&&", 2),
        bitwiseOR: se("|", 3),
        bitwiseXOR: se("^", 4),
        bitwiseAND: se("&", 5),
        equality: se("==/!=/===/!==", 6),
        relational: se("</>/<=/>=", 7),
        bitShift: se("<</>>/>>>", 8),
        plusMin: new ye("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
        modulo: se("%", 10),
        star: se("*", 10),
        slash: se("/", 10),
        starstar: new ye("**", { beforeExpr: !0 }),
        coalesce: se("??", 1),
        // Keyword token types.
        _break: Ee("break"),
        _case: Ee("case", _e),
        _catch: Ee("catch"),
        _continue: Ee("continue"),
        _debugger: Ee("debugger"),
        _default: Ee("default", _e),
        _do: Ee("do", { isLoop: !0, beforeExpr: !0 }),
        _else: Ee("else", _e),
        _finally: Ee("finally"),
        _for: Ee("for", { isLoop: !0 }),
        _function: Ee("function", ue),
        _if: Ee("if"),
        _return: Ee("return", _e),
        _switch: Ee("switch"),
        _throw: Ee("throw", _e),
        _try: Ee("try"),
        _var: Ee("var"),
        _const: Ee("const"),
        _while: Ee("while", { isLoop: !0 }),
        _with: Ee("with"),
        _new: Ee("new", { beforeExpr: !0, startsExpr: !0 }),
        _this: Ee("this", ue),
        _super: Ee("super", ue),
        _class: Ee("class", ue),
        _extends: Ee("extends", _e),
        _export: Ee("export"),
        _import: Ee("import", ue),
        _null: Ee("null", ue),
        _true: Ee("true", ue),
        _false: Ee("false", ue),
        _in: Ee("in", { beforeExpr: !0, binop: 7 }),
        _instanceof: Ee("instanceof", { beforeExpr: !0, binop: 7 }),
        _typeof: Ee("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _void: Ee("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _delete: Ee("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
      }, j = /\r\n?|\n|\u2028|\u2029/, ht = new RegExp(j.source, "g");
      function Ze(d) {
        return d === 10 || d === 13 || d === 8232 || d === 8233;
      }
      function pt(d, N, re) {
        re === void 0 && (re = d.length);
        for (var pe = N; pe < re; pe++) {
          var Le = d.charCodeAt(pe);
          if (Ze(Le))
            return pe < re - 1 && Le === 13 && d.charCodeAt(pe + 1) === 10 ? pe + 2 : pe + 1;
        }
        return -1;
      }
      var Pt = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Mt = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, Tt = Object.prototype, at = Tt.hasOwnProperty, Ai = Tt.toString, Ve = Object.hasOwn || function(d, N) {
        return at.call(d, N);
      }, Ot = Array.isArray || function(d) {
        return Ai.call(d) === "[object Array]";
      }, Ft = /* @__PURE__ */ Object.create(null);
      function Bt(d) {
        return Ft[d] || (Ft[d] = new RegExp("^(?:" + d.replace(/ /g, "|") + ")$"));
      }
      function yi(d) {
        return d <= 65535 ? String.fromCharCode(d) : (d -= 65536, String.fromCharCode((d >> 10) + 55296, (d & 1023) + 56320));
      }
      var on = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, Tn = function(N, re) {
        this.line = N, this.column = re;
      };
      Tn.prototype.offset = function(N) {
        return new Tn(this.line, this.column + N);
      };
      var Ki = function(N, re, pe) {
        this.start = re, this.end = pe, N.sourceFile !== null && (this.source = N.sourceFile);
      };
      function as(d, N) {
        for (var re = 1, pe = 0; ; ) {
          var Le = pt(d, pe, N);
          if (Le < 0)
            return new Tn(re, N - pe);
          ++re, pe = Le;
        }
      }
      var qt = {
        // `ecmaVersion` indicates the ECMAScript version to parse. Must be
        // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
        // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
        // (the latest version the library supports). This influences
        // support for strict mode, the set of reserved words, and support
        // for new syntax features.
        ecmaVersion: null,
        // `sourceType` indicates the mode the code should be parsed in.
        // Can be either `"script"` or `"module"`. This influences global
        // strict mode and parsing of `import` and `export` declarations.
        sourceType: "script",
        // `onInsertedSemicolon` can be a callback that will be called when
        // a semicolon is automatically inserted. It will be passed the
        // position of the inserted semicolon as an offset, and if
        // `locations` is enabled, it is given the location as a `{line,
        // column}` object as second argument.
        onInsertedSemicolon: null,
        // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
        // trailing commas.
        onTrailingComma: null,
        // By default, reserved words are only enforced if ecmaVersion >= 5.
        // Set `allowReserved` to a boolean value to explicitly turn this on
        // an off. When this option has the value "never", reserved words
        // and keywords can also not be used as property names.
        allowReserved: null,
        // When enabled, a return at the top level is not considered an
        // error.
        allowReturnOutsideFunction: !1,
        // When enabled, import/export statements are not constrained to
        // appearing at the top of the program, and an import.meta expression
        // in a script isn't considered an error.
        allowImportExportEverywhere: !1,
        // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
        // When enabled, await identifiers are allowed to appear at the top-level scope,
        // but they are still not allowed in non-async functions.
        allowAwaitOutsideFunction: null,
        // When enabled, super identifiers are not constrained to
        // appearing in methods and do not raise an error when they appear elsewhere.
        allowSuperOutsideMethod: null,
        // When enabled, hashbang directive in the beginning of file is
        // allowed and treated as a line comment. Enabled by default when
        // `ecmaVersion` >= 2023.
        allowHashBang: !1,
        // By default, the parser will verify that private properties are
        // only used in places where they are valid and have been declared.
        // Set this to false to turn such checks off.
        checkPrivateFields: !0,
        // When `locations` is on, `loc` properties holding objects with
        // `start` and `end` properties in `{line, column}` form (with
        // line being 1-based and column 0-based) will be attached to the
        // nodes.
        locations: !1,
        // A function can be passed as `onToken` option, which will
        // cause Acorn to call that function with object in the same
        // format as tokens returned from `tokenizer().getToken()`. Note
        // that you are not allowed to call the parser from the
        // callback—that will corrupt its internal state.
        onToken: null,
        // A function can be passed as `onComment` option, which will
        // cause Acorn to call that function with `(block, text, start,
        // end)` parameters whenever a comment is skipped. `block` is a
        // boolean indicating whether this is a block (`/* */`) comment,
        // `text` is the content of the comment, and `start` and `end` are
        // character offsets that denote the start and end of the comment.
        // When the `locations` option is on, two more parameters are
        // passed, the full `{line, column}` locations of the start and
        // end of the comments. Note that you are not allowed to call the
        // parser from the callback—that will corrupt its internal state.
        // When this option has an array as value, objects representing the
        // comments are pushed to it.
        onComment: null,
        // Nodes have their start and end characters offsets recorded in
        // `start` and `end` properties (directly on the node, rather than
        // the `loc` object, which holds line/column data. To also add a
        // [semi-standardized][range] `range` property holding a `[start,
        // end]` array with the same numbers, set the `ranges` option to
        // `true`.
        //
        // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
        ranges: !1,
        // It is possible to parse multiple files into a single AST by
        // passing the tree produced by parsing the first file as
        // `program` option in subsequent parses. This will add the
        // toplevel forms of the parsed file to the `Program` (top) node
        // of an existing parse tree.
        program: null,
        // When `locations` is on, you can pass this to record the source
        // file in every node's `loc` object.
        sourceFile: null,
        // This value, if given, is stored in every node, whether
        // `locations` is on or off.
        directSourceFile: null,
        // When enabled, parenthesized expressions are represented by
        // (non-standard) ParenthesizedExpression nodes
        preserveParens: !1
      }, kn = !1;
      function Ms(d) {
        var N = {};
        for (var re in qt)
          N[re] = d && Ve(d, re) ? d[re] : qt[re];
        if (N.ecmaVersion === "latest" ? N.ecmaVersion = 1e8 : N.ecmaVersion == null ? (!kn && typeof console == "object" && console.warn && (kn = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), N.ecmaVersion = 11) : N.ecmaVersion >= 2015 && (N.ecmaVersion -= 2009), N.allowReserved == null && (N.allowReserved = N.ecmaVersion < 5), (!d || d.allowHashBang == null) && (N.allowHashBang = N.ecmaVersion >= 14), Ot(N.onToken)) {
          var pe = N.onToken;
          N.onToken = function(Le) {
            return pe.push(Le);
          };
        }
        return Ot(N.onComment) && (N.onComment = Wn(N, N.onComment)), N;
      }
      function Wn(d, N) {
        return function(re, pe, Le, je, Qe, vt) {
          var Lt = {
            type: re ? "Block" : "Line",
            value: pe,
            start: Le,
            end: je
          };
          d.locations && (Lt.loc = new Ki(this, Qe, vt)), d.ranges && (Lt.range = [Le, je]), N.push(Lt);
        };
      }
      var zt = 1, Dt = 2, Ht = 4, Dn = 8, Ln = 16, Sn = 32, qn = 64, Ds = 128, ln = 256, Bn = zt | Dt | ln;
      function Js(d, N) {
        return Dt | (d ? Ht : 0) | (N ? Dn : 0);
      }
      var zn = 0, Ut = 1, ki = 2, Vt = 3, Jn = 4, nt = 5, i = function(N, re, pe) {
        this.options = N = Ms(N), this.sourceFile = N.sourceFile, this.keywords = Bt(T[N.ecmaVersion >= 6 ? 6 : N.sourceType === "module" ? "5module" : 5]);
        var Le = "";
        N.allowReserved !== !0 && (Le = g[N.ecmaVersion >= 6 ? 6 : N.ecmaVersion === 5 ? 5 : 3], N.sourceType === "module" && (Le += " await")), this.reservedWords = Bt(Le);
        var je = (Le ? Le + " " : "") + g.strict;
        this.reservedWordsStrict = Bt(je), this.reservedWordsStrictBind = Bt(je + " " + g.strictBind), this.input = String(re), this.containsEsc = !1, pe ? (this.pos = pe, this.lineStart = this.input.lastIndexOf(`
`, pe - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(j).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = K.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = N.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && N.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(zt), this.regexpState = null, this.privateNameStack = [];
      }, n = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
      i.prototype.parse = function() {
        var N = this.options.program || this.startNode();
        return this.nextToken(), this.parseTopLevel(N);
      }, n.inFunction.get = function() {
        return (this.currentVarScope().flags & Dt) > 0;
      }, n.inGenerator.get = function() {
        return (this.currentVarScope().flags & Dn) > 0 && !this.currentVarScope().inClassFieldInit;
      }, n.inAsync.get = function() {
        return (this.currentVarScope().flags & Ht) > 0 && !this.currentVarScope().inClassFieldInit;
      }, n.canAwait.get = function() {
        for (var d = this.scopeStack.length - 1; d >= 0; d--) {
          var N = this.scopeStack[d];
          if (N.inClassFieldInit || N.flags & ln)
            return !1;
          if (N.flags & Dt)
            return (N.flags & Ht) > 0;
        }
        return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
      }, n.allowSuper.get = function() {
        var d = this.currentThisScope(), N = d.flags, re = d.inClassFieldInit;
        return (N & qn) > 0 || re || this.options.allowSuperOutsideMethod;
      }, n.allowDirectSuper.get = function() {
        return (this.currentThisScope().flags & Ds) > 0;
      }, n.treatFunctionsAsVar.get = function() {
        return this.treatFunctionsAsVarInScope(this.currentScope());
      }, n.allowNewDotTarget.get = function() {
        var d = this.currentThisScope(), N = d.flags, re = d.inClassFieldInit;
        return (N & (Dt | ln)) > 0 || re;
      }, n.inClassStaticBlock.get = function() {
        return (this.currentVarScope().flags & ln) > 0;
      }, i.extend = function() {
        for (var N = [], re = arguments.length; re--; )
          N[re] = arguments[re];
        for (var pe = this, Le = 0; Le < N.length; Le++)
          pe = N[Le](pe);
        return pe;
      }, i.parse = function(N, re) {
        return new this(re, N).parse();
      }, i.parseExpressionAt = function(N, re, pe) {
        var Le = new this(pe, N, re);
        return Le.nextToken(), Le.parseExpression();
      }, i.tokenizer = function(N, re) {
        return new this(re, N);
      }, Object.defineProperties(i.prototype, n);
      var r = i.prototype, l = /^(?:'((?:\\.|[^'\\])*?)'|"((?:\\.|[^"\\])*?)")/;
      r.strictDirective = function(d) {
        if (this.options.ecmaVersion < 5)
          return !1;
        for (; ; ) {
          Mt.lastIndex = d, d += Mt.exec(this.input)[0].length;
          var N = l.exec(this.input.slice(d));
          if (!N)
            return !1;
          if ((N[1] || N[2]) === "use strict") {
            Mt.lastIndex = d + N[0].length;
            var re = Mt.exec(this.input), pe = re.index + re[0].length, Le = this.input.charAt(pe);
            return Le === ";" || Le === "}" || j.test(re[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(Le) || Le === "!" && this.input.charAt(pe + 1) === "=");
          }
          d += N[0].length, Mt.lastIndex = d, d += Mt.exec(this.input)[0].length, this.input[d] === ";" && d++;
        }
      }, r.eat = function(d) {
        return this.type === d ? (this.next(), !0) : !1;
      }, r.isContextual = function(d) {
        return this.type === K.name && this.value === d && !this.containsEsc;
      }, r.eatContextual = function(d) {
        return this.isContextual(d) ? (this.next(), !0) : !1;
      }, r.expectContextual = function(d) {
        this.eatContextual(d) || this.unexpected();
      }, r.canInsertSemicolon = function() {
        return this.type === K.eof || this.type === K.braceR || j.test(this.input.slice(this.lastTokEnd, this.start));
      }, r.insertSemicolon = function() {
        if (this.canInsertSemicolon())
          return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
      }, r.semicolon = function() {
        !this.eat(K.semi) && !this.insertSemicolon() && this.unexpected();
      }, r.afterTrailingComma = function(d, N) {
        if (this.type === d)
          return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), N || this.next(), !0;
      }, r.expect = function(d) {
        this.eat(d) || this.unexpected();
      }, r.unexpected = function(d) {
        this.raise(d ?? this.start, "Unexpected token");
      };
      var h = function() {
        this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
      };
      r.checkPatternErrors = function(d, N) {
        if (d) {
          d.trailingComma > -1 && this.raiseRecoverable(d.trailingComma, "Comma is not permitted after the rest element");
          var re = N ? d.parenthesizedAssign : d.parenthesizedBind;
          re > -1 && this.raiseRecoverable(re, N ? "Assigning to rvalue" : "Parenthesized pattern");
        }
      }, r.checkExpressionErrors = function(d, N) {
        if (!d)
          return !1;
        var re = d.shorthandAssign, pe = d.doubleProto;
        if (!N)
          return re >= 0 || pe >= 0;
        re >= 0 && this.raise(re, "Shorthand property assignments are valid only in destructuring patterns"), pe >= 0 && this.raiseRecoverable(pe, "Redefinition of __proto__ property");
      }, r.checkYieldAwaitInDefaultParams = function() {
        this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
      }, r.isSimpleAssignTarget = function(d) {
        return d.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(d.expression) : d.type === "Identifier" || d.type === "MemberExpression";
      };
      var f = i.prototype;
      f.parseTopLevel = function(d) {
        var N = /* @__PURE__ */ Object.create(null);
        for (d.body || (d.body = []); this.type !== K.eof; ) {
          var re = this.parseStatement(null, !0, N);
          d.body.push(re);
        }
        if (this.inModule)
          for (var pe = 0, Le = Object.keys(this.undefinedExports); pe < Le.length; pe += 1) {
            var je = Le[pe];
            this.raiseRecoverable(this.undefinedExports[je].start, "Export '" + je + "' is not defined");
          }
        return this.adaptDirectivePrologue(d.body), this.next(), d.sourceType = this.options.sourceType, this.finishNode(d, "Program");
      };
      var m = { kind: "loop" }, _ = { kind: "switch" };
      f.isLet = function(d) {
        if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
          return !1;
        Mt.lastIndex = this.pos;
        var N = Mt.exec(this.input), re = this.pos + N[0].length, pe = this.input.charCodeAt(re);
        if (pe === 91 || pe === 92)
          return !0;
        if (d)
          return !1;
        if (pe === 123 || pe > 55295 && pe < 56320)
          return !0;
        if (he(pe, !0)) {
          for (var Le = re + 1; ne(pe = this.input.charCodeAt(Le), !0); )
            ++Le;
          if (pe === 92 || pe > 55295 && pe < 56320)
            return !0;
          var je = this.input.slice(re, Le);
          if (!H.test(je))
            return !0;
        }
        return !1;
      }, f.isAsyncFunction = function() {
        if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
          return !1;
        Mt.lastIndex = this.pos;
        var d = Mt.exec(this.input), N = this.pos + d[0].length, re;
        return !j.test(this.input.slice(this.pos, N)) && this.input.slice(N, N + 8) === "function" && (N + 8 === this.input.length || !(ne(re = this.input.charCodeAt(N + 8)) || re > 55295 && re < 56320));
      }, f.parseStatement = function(d, N, re) {
        var pe = this.type, Le = this.startNode(), je;
        switch (this.isLet(d) && (pe = K._var, je = "let"), pe) {
          case K._break:
          case K._continue:
            return this.parseBreakContinueStatement(Le, pe.keyword);
          case K._debugger:
            return this.parseDebuggerStatement(Le);
          case K._do:
            return this.parseDoStatement(Le);
          case K._for:
            return this.parseForStatement(Le);
          case K._function:
            return d && (this.strict || d !== "if" && d !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(Le, !1, !d);
          case K._class:
            return d && this.unexpected(), this.parseClass(Le, !0);
          case K._if:
            return this.parseIfStatement(Le);
          case K._return:
            return this.parseReturnStatement(Le);
          case K._switch:
            return this.parseSwitchStatement(Le);
          case K._throw:
            return this.parseThrowStatement(Le);
          case K._try:
            return this.parseTryStatement(Le);
          case K._const:
          case K._var:
            return je = je || this.value, d && je !== "var" && this.unexpected(), this.parseVarStatement(Le, je);
          case K._while:
            return this.parseWhileStatement(Le);
          case K._with:
            return this.parseWithStatement(Le);
          case K.braceL:
            return this.parseBlock(!0, Le);
          case K.semi:
            return this.parseEmptyStatement(Le);
          case K._export:
          case K._import:
            if (this.options.ecmaVersion > 10 && pe === K._import) {
              Mt.lastIndex = this.pos;
              var Qe = Mt.exec(this.input), vt = this.pos + Qe[0].length, Lt = this.input.charCodeAt(vt);
              if (Lt === 40 || Lt === 46)
                return this.parseExpressionStatement(Le, this.parseExpression());
            }
            return this.options.allowImportExportEverywhere || (N || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), pe === K._import ? this.parseImport(Le) : this.parseExport(Le, re);
          default:
            if (this.isAsyncFunction())
              return d && this.unexpected(), this.next(), this.parseFunctionStatement(Le, !0, !d);
            var $t = this.value, ii = this.parseExpression();
            return pe === K.name && ii.type === "Identifier" && this.eat(K.colon) ? this.parseLabeledStatement(Le, $t, ii, d) : this.parseExpressionStatement(Le, ii);
        }
      }, f.parseBreakContinueStatement = function(d, N) {
        var re = N === "break";
        this.next(), this.eat(K.semi) || this.insertSemicolon() ? d.label = null : this.type !== K.name ? this.unexpected() : (d.label = this.parseIdent(), this.semicolon());
        for (var pe = 0; pe < this.labels.length; ++pe) {
          var Le = this.labels[pe];
          if ((d.label == null || Le.name === d.label.name) && (Le.kind != null && (re || Le.kind === "loop") || d.label && re))
            break;
        }
        return pe === this.labels.length && this.raise(d.start, "Unsyntactic " + N), this.finishNode(d, re ? "BreakStatement" : "ContinueStatement");
      }, f.parseDebuggerStatement = function(d) {
        return this.next(), this.semicolon(), this.finishNode(d, "DebuggerStatement");
      }, f.parseDoStatement = function(d) {
        return this.next(), this.labels.push(m), d.body = this.parseStatement("do"), this.labels.pop(), this.expect(K._while), d.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(K.semi) : this.semicolon(), this.finishNode(d, "DoWhileStatement");
      }, f.parseForStatement = function(d) {
        this.next();
        var N = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
        if (this.labels.push(m), this.enterScope(0), this.expect(K.parenL), this.type === K.semi)
          return N > -1 && this.unexpected(N), this.parseFor(d, null);
        var re = this.isLet();
        if (this.type === K._var || this.type === K._const || re) {
          var pe = this.startNode(), Le = re ? "let" : this.value;
          return this.next(), this.parseVar(pe, !0, Le), this.finishNode(pe, "VariableDeclaration"), (this.type === K._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && pe.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === K._in ? N > -1 && this.unexpected(N) : d.await = N > -1), this.parseForIn(d, pe)) : (N > -1 && this.unexpected(N), this.parseFor(d, pe));
        }
        var je = this.isContextual("let"), Qe = !1, vt = new h(), Lt = this.parseExpression(N > -1 ? "await" : !0, vt);
        return this.type === K._in || (Qe = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (this.options.ecmaVersion >= 9 && (this.type === K._in ? N > -1 && this.unexpected(N) : d.await = N > -1), je && Qe && this.raise(Lt.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(Lt, !1, vt), this.checkLValPattern(Lt), this.parseForIn(d, Lt)) : (this.checkExpressionErrors(vt, !0), N > -1 && this.unexpected(N), this.parseFor(d, Lt));
      }, f.parseFunctionStatement = function(d, N, re) {
        return this.next(), this.parseFunction(d, x | (re ? 0 : A), !1, N);
      }, f.parseIfStatement = function(d) {
        return this.next(), d.test = this.parseParenExpression(), d.consequent = this.parseStatement("if"), d.alternate = this.eat(K._else) ? this.parseStatement("if") : null, this.finishNode(d, "IfStatement");
      }, f.parseReturnStatement = function(d) {
        return !this.inFunction && !this.options.allowReturnOutsideFunction && this.raise(this.start, "'return' outside of function"), this.next(), this.eat(K.semi) || this.insertSemicolon() ? d.argument = null : (d.argument = this.parseExpression(), this.semicolon()), this.finishNode(d, "ReturnStatement");
      }, f.parseSwitchStatement = function(d) {
        this.next(), d.discriminant = this.parseParenExpression(), d.cases = [], this.expect(K.braceL), this.labels.push(_), this.enterScope(0);
        for (var N, re = !1; this.type !== K.braceR; )
          if (this.type === K._case || this.type === K._default) {
            var pe = this.type === K._case;
            N && this.finishNode(N, "SwitchCase"), d.cases.push(N = this.startNode()), N.consequent = [], this.next(), pe ? N.test = this.parseExpression() : (re && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), re = !0, N.test = null), this.expect(K.colon);
          } else
            N || this.unexpected(), N.consequent.push(this.parseStatement(null));
        return this.exitScope(), N && this.finishNode(N, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(d, "SwitchStatement");
      }, f.parseThrowStatement = function(d) {
        return this.next(), j.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), d.argument = this.parseExpression(), this.semicolon(), this.finishNode(d, "ThrowStatement");
      };
      var y = [];
      f.parseCatchClauseParam = function() {
        var d = this.parseBindingAtom(), N = d.type === "Identifier";
        return this.enterScope(N ? Sn : 0), this.checkLValPattern(d, N ? Jn : ki), this.expect(K.parenR), d;
      }, f.parseTryStatement = function(d) {
        if (this.next(), d.block = this.parseBlock(), d.handler = null, this.type === K._catch) {
          var N = this.startNode();
          this.next(), this.eat(K.parenL) ? N.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), N.param = null, this.enterScope(0)), N.body = this.parseBlock(!1), this.exitScope(), d.handler = this.finishNode(N, "CatchClause");
        }
        return d.finalizer = this.eat(K._finally) ? this.parseBlock() : null, !d.handler && !d.finalizer && this.raise(d.start, "Missing catch or finally clause"), this.finishNode(d, "TryStatement");
      }, f.parseVarStatement = function(d, N, re) {
        return this.next(), this.parseVar(d, !1, N, re), this.semicolon(), this.finishNode(d, "VariableDeclaration");
      }, f.parseWhileStatement = function(d) {
        return this.next(), d.test = this.parseParenExpression(), this.labels.push(m), d.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(d, "WhileStatement");
      }, f.parseWithStatement = function(d) {
        return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), d.object = this.parseParenExpression(), d.body = this.parseStatement("with"), this.finishNode(d, "WithStatement");
      }, f.parseEmptyStatement = function(d) {
        return this.next(), this.finishNode(d, "EmptyStatement");
      }, f.parseLabeledStatement = function(d, N, re, pe) {
        for (var Le = 0, je = this.labels; Le < je.length; Le += 1) {
          var Qe = je[Le];
          Qe.name === N && this.raise(re.start, "Label '" + N + "' is already declared");
        }
        for (var vt = this.type.isLoop ? "loop" : this.type === K._switch ? "switch" : null, Lt = this.labels.length - 1; Lt >= 0; Lt--) {
          var $t = this.labels[Lt];
          if ($t.statementStart === d.start)
            $t.statementStart = this.start, $t.kind = vt;
          else
            break;
        }
        return this.labels.push({ name: N, kind: vt, statementStart: this.start }), d.body = this.parseStatement(pe ? pe.indexOf("label") === -1 ? pe + "label" : pe : "label"), this.labels.pop(), d.label = re, this.finishNode(d, "LabeledStatement");
      }, f.parseExpressionStatement = function(d, N) {
        return d.expression = N, this.semicolon(), this.finishNode(d, "ExpressionStatement");
      }, f.parseBlock = function(d, N, re) {
        for (d === void 0 && (d = !0), N === void 0 && (N = this.startNode()), N.body = [], this.expect(K.braceL), d && this.enterScope(0); this.type !== K.braceR; ) {
          var pe = this.parseStatement(null);
          N.body.push(pe);
        }
        return re && (this.strict = !1), this.next(), d && this.exitScope(), this.finishNode(N, "BlockStatement");
      }, f.parseFor = function(d, N) {
        return d.init = N, this.expect(K.semi), d.test = this.type === K.semi ? null : this.parseExpression(), this.expect(K.semi), d.update = this.type === K.parenR ? null : this.parseExpression(), this.expect(K.parenR), d.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(d, "ForStatement");
      }, f.parseForIn = function(d, N) {
        var re = this.type === K._in;
        return this.next(), N.type === "VariableDeclaration" && N.declarations[0].init != null && (!re || this.options.ecmaVersion < 8 || this.strict || N.kind !== "var" || N.declarations[0].id.type !== "Identifier") && this.raise(
          N.start,
          (re ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
        ), d.left = N, d.right = re ? this.parseExpression() : this.parseMaybeAssign(), this.expect(K.parenR), d.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(d, re ? "ForInStatement" : "ForOfStatement");
      }, f.parseVar = function(d, N, re, pe) {
        for (d.declarations = [], d.kind = re; ; ) {
          var Le = this.startNode();
          if (this.parseVarId(Le, re), this.eat(K.eq) ? Le.init = this.parseMaybeAssign(N) : !pe && re === "const" && !(this.type === K._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !pe && Le.id.type !== "Identifier" && !(N && (this.type === K._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : Le.init = null, d.declarations.push(this.finishNode(Le, "VariableDeclarator")), !this.eat(K.comma))
            break;
        }
        return d;
      }, f.parseVarId = function(d, N) {
        d.id = this.parseBindingAtom(), this.checkLValPattern(d.id, N === "var" ? Ut : ki, !1);
      };
      var x = 1, A = 2, B = 4;
      f.parseFunction = function(d, N, re, pe, Le) {
        this.initFunction(d), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !pe) && (this.type === K.star && N & A && this.unexpected(), d.generator = this.eat(K.star)), this.options.ecmaVersion >= 8 && (d.async = !!pe), N & x && (d.id = N & B && this.type !== K.name ? null : this.parseIdent(), d.id && !(N & A) && this.checkLValSimple(d.id, this.strict || d.generator || d.async ? this.treatFunctionsAsVar ? Ut : ki : Vt));
        var je = this.yieldPos, Qe = this.awaitPos, vt = this.awaitIdentPos;
        return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Js(d.async, d.generator)), N & x || (d.id = this.type === K.name ? this.parseIdent() : null), this.parseFunctionParams(d), this.parseFunctionBody(d, re, !1, Le), this.yieldPos = je, this.awaitPos = Qe, this.awaitIdentPos = vt, this.finishNode(d, N & x ? "FunctionDeclaration" : "FunctionExpression");
      }, f.parseFunctionParams = function(d) {
        this.expect(K.parenL), d.params = this.parseBindingList(K.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
      }, f.parseClass = function(d, N) {
        this.next();
        var re = this.strict;
        this.strict = !0, this.parseClassId(d, N), this.parseClassSuper(d);
        var pe = this.enterClassBody(), Le = this.startNode(), je = !1;
        for (Le.body = [], this.expect(K.braceL); this.type !== K.braceR; ) {
          var Qe = this.parseClassElement(d.superClass !== null);
          Qe && (Le.body.push(Qe), Qe.type === "MethodDefinition" && Qe.kind === "constructor" ? (je && this.raiseRecoverable(Qe.start, "Duplicate constructor in the same class"), je = !0) : Qe.key && Qe.key.type === "PrivateIdentifier" && C(pe, Qe) && this.raiseRecoverable(Qe.key.start, "Identifier '#" + Qe.key.name + "' has already been declared"));
        }
        return this.strict = re, this.next(), d.body = this.finishNode(Le, "ClassBody"), this.exitClassBody(), this.finishNode(d, N ? "ClassDeclaration" : "ClassExpression");
      }, f.parseClassElement = function(d) {
        if (this.eat(K.semi))
          return null;
        var N = this.options.ecmaVersion, re = this.startNode(), pe = "", Le = !1, je = !1, Qe = "method", vt = !1;
        if (this.eatContextual("static")) {
          if (N >= 13 && this.eat(K.braceL))
            return this.parseClassStaticBlock(re), re;
          this.isClassElementNameStart() || this.type === K.star ? vt = !0 : pe = "static";
        }
        if (re.static = vt, !pe && N >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === K.star) && !this.canInsertSemicolon() ? je = !0 : pe = "async"), !pe && (N >= 9 || !je) && this.eat(K.star) && (Le = !0), !pe && !je && !Le) {
          var Lt = this.value;
          (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? Qe = Lt : pe = Lt);
        }
        if (pe ? (re.computed = !1, re.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), re.key.name = pe, this.finishNode(re.key, "Identifier")) : this.parseClassElementName(re), N < 13 || this.type === K.parenL || Qe !== "method" || Le || je) {
          var $t = !re.static && M(re, "constructor"), ii = $t && d;
          $t && Qe !== "method" && this.raise(re.key.start, "Constructor can't have get/set modifier"), re.kind = $t ? "constructor" : Qe, this.parseClassMethod(re, Le, je, ii);
        } else
          this.parseClassField(re);
        return re;
      }, f.isClassElementNameStart = function() {
        return this.type === K.name || this.type === K.privateId || this.type === K.num || this.type === K.string || this.type === K.bracketL || this.type.keyword;
      }, f.parseClassElementName = function(d) {
        this.type === K.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), d.computed = !1, d.key = this.parsePrivateIdent()) : this.parsePropertyName(d);
      }, f.parseClassMethod = function(d, N, re, pe) {
        var Le = d.key;
        d.kind === "constructor" ? (N && this.raise(Le.start, "Constructor can't be a generator"), re && this.raise(Le.start, "Constructor can't be an async method")) : d.static && M(d, "prototype") && this.raise(Le.start, "Classes may not have a static property named prototype");
        var je = d.value = this.parseMethod(N, re, pe);
        return d.kind === "get" && je.params.length !== 0 && this.raiseRecoverable(je.start, "getter should have no params"), d.kind === "set" && je.params.length !== 1 && this.raiseRecoverable(je.start, "setter should have exactly one param"), d.kind === "set" && je.params[0].type === "RestElement" && this.raiseRecoverable(je.params[0].start, "Setter cannot use rest params"), this.finishNode(d, "MethodDefinition");
      }, f.parseClassField = function(d) {
        if (M(d, "constructor") ? this.raise(d.key.start, "Classes can't have a field named 'constructor'") : d.static && M(d, "prototype") && this.raise(d.key.start, "Classes can't have a static field named 'prototype'"), this.eat(K.eq)) {
          var N = this.currentThisScope(), re = N.inClassFieldInit;
          N.inClassFieldInit = !0, d.value = this.parseMaybeAssign(), N.inClassFieldInit = re;
        } else
          d.value = null;
        return this.semicolon(), this.finishNode(d, "PropertyDefinition");
      }, f.parseClassStaticBlock = function(d) {
        d.body = [];
        var N = this.labels;
        for (this.labels = [], this.enterScope(ln | qn); this.type !== K.braceR; ) {
          var re = this.parseStatement(null);
          d.body.push(re);
        }
        return this.next(), this.exitScope(), this.labels = N, this.finishNode(d, "StaticBlock");
      }, f.parseClassId = function(d, N) {
        this.type === K.name ? (d.id = this.parseIdent(), N && this.checkLValSimple(d.id, ki, !1)) : (N === !0 && this.unexpected(), d.id = null);
      }, f.parseClassSuper = function(d) {
        d.superClass = this.eat(K._extends) ? this.parseExprSubscripts(null, !1) : null;
      }, f.enterClassBody = function() {
        var d = { declared: /* @__PURE__ */ Object.create(null), used: [] };
        return this.privateNameStack.push(d), d.declared;
      }, f.exitClassBody = function() {
        var d = this.privateNameStack.pop(), N = d.declared, re = d.used;
        if (this.options.checkPrivateFields)
          for (var pe = this.privateNameStack.length, Le = pe === 0 ? null : this.privateNameStack[pe - 1], je = 0; je < re.length; ++je) {
            var Qe = re[je];
            Ve(N, Qe.name) || (Le ? Le.used.push(Qe) : this.raiseRecoverable(Qe.start, "Private field '#" + Qe.name + "' must be declared in an enclosing class"));
          }
      };
      function C(d, N) {
        var re = N.key.name, pe = d[re], Le = "true";
        return N.type === "MethodDefinition" && (N.kind === "get" || N.kind === "set") && (Le = (N.static ? "s" : "i") + N.kind), pe === "iget" && Le === "iset" || pe === "iset" && Le === "iget" || pe === "sget" && Le === "sset" || pe === "sset" && Le === "sget" ? (d[re] = "true", !1) : pe ? !0 : (d[re] = Le, !1);
      }
      function M(d, N) {
        var re = d.computed, pe = d.key;
        return !re && (pe.type === "Identifier" && pe.name === N || pe.type === "Literal" && pe.value === N);
      }
      f.parseExportAllDeclaration = function(d, N) {
        return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (d.exported = this.parseModuleExportName(), this.checkExport(N, d.exported, this.lastTokStart)) : d.exported = null), this.expectContextual("from"), this.type !== K.string && this.unexpected(), d.source = this.parseExprAtom(), this.semicolon(), this.finishNode(d, "ExportAllDeclaration");
      }, f.parseExport = function(d, N) {
        if (this.next(), this.eat(K.star))
          return this.parseExportAllDeclaration(d, N);
        if (this.eat(K._default))
          return this.checkExport(N, "default", this.lastTokStart), d.declaration = this.parseExportDefaultDeclaration(), this.finishNode(d, "ExportDefaultDeclaration");
        if (this.shouldParseExportStatement())
          d.declaration = this.parseExportDeclaration(d), d.declaration.type === "VariableDeclaration" ? this.checkVariableExport(N, d.declaration.declarations) : this.checkExport(N, d.declaration.id, d.declaration.id.start), d.specifiers = [], d.source = null;
        else {
          if (d.declaration = null, d.specifiers = this.parseExportSpecifiers(N), this.eatContextual("from"))
            this.type !== K.string && this.unexpected(), d.source = this.parseExprAtom();
          else {
            for (var re = 0, pe = d.specifiers; re < pe.length; re += 1) {
              var Le = pe[re];
              this.checkUnreserved(Le.local), this.checkLocalExport(Le.local), Le.local.type === "Literal" && this.raise(Le.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            d.source = null;
          }
          this.semicolon();
        }
        return this.finishNode(d, "ExportNamedDeclaration");
      }, f.parseExportDeclaration = function(d) {
        return this.parseStatement(null);
      }, f.parseExportDefaultDeclaration = function() {
        var d;
        if (this.type === K._function || (d = this.isAsyncFunction())) {
          var N = this.startNode();
          return this.next(), d && this.next(), this.parseFunction(N, x | B, !1, d);
        } else if (this.type === K._class) {
          var re = this.startNode();
          return this.parseClass(re, "nullableID");
        } else {
          var pe = this.parseMaybeAssign();
          return this.semicolon(), pe;
        }
      }, f.checkExport = function(d, N, re) {
        d && (typeof N != "string" && (N = N.type === "Identifier" ? N.name : N.value), Ve(d, N) && this.raiseRecoverable(re, "Duplicate export '" + N + "'"), d[N] = !0);
      }, f.checkPatternExport = function(d, N) {
        var re = N.type;
        if (re === "Identifier")
          this.checkExport(d, N, N.start);
        else if (re === "ObjectPattern")
          for (var pe = 0, Le = N.properties; pe < Le.length; pe += 1) {
            var je = Le[pe];
            this.checkPatternExport(d, je);
          }
        else if (re === "ArrayPattern")
          for (var Qe = 0, vt = N.elements; Qe < vt.length; Qe += 1) {
            var Lt = vt[Qe];
            Lt && this.checkPatternExport(d, Lt);
          }
        else
          re === "Property" ? this.checkPatternExport(d, N.value) : re === "AssignmentPattern" ? this.checkPatternExport(d, N.left) : re === "RestElement" && this.checkPatternExport(d, N.argument);
      }, f.checkVariableExport = function(d, N) {
        if (d)
          for (var re = 0, pe = N; re < pe.length; re += 1) {
            var Le = pe[re];
            this.checkPatternExport(d, Le.id);
          }
      }, f.shouldParseExportStatement = function() {
        return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
      }, f.parseExportSpecifier = function(d) {
        var N = this.startNode();
        return N.local = this.parseModuleExportName(), N.exported = this.eatContextual("as") ? this.parseModuleExportName() : N.local, this.checkExport(
          d,
          N.exported,
          N.exported.start
        ), this.finishNode(N, "ExportSpecifier");
      }, f.parseExportSpecifiers = function(d) {
        var N = [], re = !0;
        for (this.expect(K.braceL); !this.eat(K.braceR); ) {
          if (re)
            re = !1;
          else if (this.expect(K.comma), this.afterTrailingComma(K.braceR))
            break;
          N.push(this.parseExportSpecifier(d));
        }
        return N;
      }, f.parseImport = function(d) {
        return this.next(), this.type === K.string ? (d.specifiers = y, d.source = this.parseExprAtom()) : (d.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), d.source = this.type === K.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(d, "ImportDeclaration");
      }, f.parseImportSpecifier = function() {
        var d = this.startNode();
        return d.imported = this.parseModuleExportName(), this.eatContextual("as") ? d.local = this.parseIdent() : (this.checkUnreserved(d.imported), d.local = d.imported), this.checkLValSimple(d.local, ki), this.finishNode(d, "ImportSpecifier");
      }, f.parseImportDefaultSpecifier = function() {
        var d = this.startNode();
        return d.local = this.parseIdent(), this.checkLValSimple(d.local, ki), this.finishNode(d, "ImportDefaultSpecifier");
      }, f.parseImportNamespaceSpecifier = function() {
        var d = this.startNode();
        return this.next(), this.expectContextual("as"), d.local = this.parseIdent(), this.checkLValSimple(d.local, ki), this.finishNode(d, "ImportNamespaceSpecifier");
      }, f.parseImportSpecifiers = function() {
        var d = [], N = !0;
        if (this.type === K.name && (d.push(this.parseImportDefaultSpecifier()), !this.eat(K.comma)))
          return d;
        if (this.type === K.star)
          return d.push(this.parseImportNamespaceSpecifier()), d;
        for (this.expect(K.braceL); !this.eat(K.braceR); ) {
          if (N)
            N = !1;
          else if (this.expect(K.comma), this.afterTrailingComma(K.braceR))
            break;
          d.push(this.parseImportSpecifier());
        }
        return d;
      }, f.parseModuleExportName = function() {
        if (this.options.ecmaVersion >= 13 && this.type === K.string) {
          var d = this.parseLiteral(this.value);
          return on.test(d.value) && this.raise(d.start, "An export name cannot include a lone surrogate."), d;
        }
        return this.parseIdent(!0);
      }, f.adaptDirectivePrologue = function(d) {
        for (var N = 0; N < d.length && this.isDirectiveCandidate(d[N]); ++N)
          d[N].directive = d[N].expression.raw.slice(1, -1);
      }, f.isDirectiveCandidate = function(d) {
        return this.options.ecmaVersion >= 5 && d.type === "ExpressionStatement" && d.expression.type === "Literal" && typeof d.expression.value == "string" && // Reject parenthesized strings.
        (this.input[d.start] === '"' || this.input[d.start] === "'");
      };
      var R = i.prototype;
      R.toAssignable = function(d, N, re) {
        if (this.options.ecmaVersion >= 6 && d)
          switch (d.type) {
            case "Identifier":
              this.inAsync && d.name === "await" && this.raise(d.start, "Cannot use 'await' as identifier inside an async function");
              break;
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              d.type = "ObjectPattern", re && this.checkPatternErrors(re, !0);
              for (var pe = 0, Le = d.properties; pe < Le.length; pe += 1) {
                var je = Le[pe];
                this.toAssignable(je, N), je.type === "RestElement" && (je.argument.type === "ArrayPattern" || je.argument.type === "ObjectPattern") && this.raise(je.argument.start, "Unexpected token");
              }
              break;
            case "Property":
              d.kind !== "init" && this.raise(d.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(d.value, N);
              break;
            case "ArrayExpression":
              d.type = "ArrayPattern", re && this.checkPatternErrors(re, !0), this.toAssignableList(d.elements, N);
              break;
            case "SpreadElement":
              d.type = "RestElement", this.toAssignable(d.argument, N), d.argument.type === "AssignmentPattern" && this.raise(d.argument.start, "Rest elements cannot have a default value");
              break;
            case "AssignmentExpression":
              d.operator !== "=" && this.raise(d.left.end, "Only '=' operator can be used for specifying default value."), d.type = "AssignmentPattern", delete d.operator, this.toAssignable(d.left, N);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(d.expression, N, re);
              break;
            case "ChainExpression":
              this.raiseRecoverable(d.start, "Optional chaining cannot appear in left-hand side");
              break;
            case "MemberExpression":
              if (!N)
                break;
            default:
              this.raise(d.start, "Assigning to rvalue");
          }
        else
          re && this.checkPatternErrors(re, !0);
        return d;
      }, R.toAssignableList = function(d, N) {
        for (var re = d.length, pe = 0; pe < re; pe++) {
          var Le = d[pe];
          Le && this.toAssignable(Le, N);
        }
        if (re) {
          var je = d[re - 1];
          this.options.ecmaVersion === 6 && N && je && je.type === "RestElement" && je.argument.type !== "Identifier" && this.unexpected(je.argument.start);
        }
        return d;
      }, R.parseSpread = function(d) {
        var N = this.startNode();
        return this.next(), N.argument = this.parseMaybeAssign(!1, d), this.finishNode(N, "SpreadElement");
      }, R.parseRestBinding = function() {
        var d = this.startNode();
        return this.next(), this.options.ecmaVersion === 6 && this.type !== K.name && this.unexpected(), d.argument = this.parseBindingAtom(), this.finishNode(d, "RestElement");
      }, R.parseBindingAtom = function() {
        if (this.options.ecmaVersion >= 6)
          switch (this.type) {
            case K.bracketL:
              var d = this.startNode();
              return this.next(), d.elements = this.parseBindingList(K.bracketR, !0, !0), this.finishNode(d, "ArrayPattern");
            case K.braceL:
              return this.parseObj(!0);
          }
        return this.parseIdent();
      }, R.parseBindingList = function(d, N, re, pe) {
        for (var Le = [], je = !0; !this.eat(d); )
          if (je ? je = !1 : this.expect(K.comma), N && this.type === K.comma)
            Le.push(null);
          else {
            if (re && this.afterTrailingComma(d))
              break;
            if (this.type === K.ellipsis) {
              var Qe = this.parseRestBinding();
              this.parseBindingListItem(Qe), Le.push(Qe), this.type === K.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(d);
              break;
            } else
              Le.push(this.parseAssignableListItem(pe));
          }
        return Le;
      }, R.parseAssignableListItem = function(d) {
        var N = this.parseMaybeDefault(this.start, this.startLoc);
        return this.parseBindingListItem(N), N;
      }, R.parseBindingListItem = function(d) {
        return d;
      }, R.parseMaybeDefault = function(d, N, re) {
        if (re = re || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(K.eq))
          return re;
        var pe = this.startNodeAt(d, N);
        return pe.left = re, pe.right = this.parseMaybeAssign(), this.finishNode(pe, "AssignmentPattern");
      }, R.checkLValSimple = function(d, N, re) {
        N === void 0 && (N = zn);
        var pe = N !== zn;
        switch (d.type) {
          case "Identifier":
            this.strict && this.reservedWordsStrictBind.test(d.name) && this.raiseRecoverable(d.start, (pe ? "Binding " : "Assigning to ") + d.name + " in strict mode"), pe && (N === ki && d.name === "let" && this.raiseRecoverable(d.start, "let is disallowed as a lexically bound name"), re && (Ve(re, d.name) && this.raiseRecoverable(d.start, "Argument name clash"), re[d.name] = !0), N !== nt && this.declareName(d.name, N, d.start));
            break;
          case "ChainExpression":
            this.raiseRecoverable(d.start, "Optional chaining cannot appear in left-hand side");
            break;
          case "MemberExpression":
            pe && this.raiseRecoverable(d.start, "Binding member expression");
            break;
          case "ParenthesizedExpression":
            return pe && this.raiseRecoverable(d.start, "Binding parenthesized expression"), this.checkLValSimple(d.expression, N, re);
          default:
            this.raise(d.start, (pe ? "Binding" : "Assigning to") + " rvalue");
        }
      }, R.checkLValPattern = function(d, N, re) {
        switch (N === void 0 && (N = zn), d.type) {
          case "ObjectPattern":
            for (var pe = 0, Le = d.properties; pe < Le.length; pe += 1) {
              var je = Le[pe];
              this.checkLValInnerPattern(je, N, re);
            }
            break;
          case "ArrayPattern":
            for (var Qe = 0, vt = d.elements; Qe < vt.length; Qe += 1) {
              var Lt = vt[Qe];
              Lt && this.checkLValInnerPattern(Lt, N, re);
            }
            break;
          default:
            this.checkLValSimple(d, N, re);
        }
      }, R.checkLValInnerPattern = function(d, N, re) {
        switch (N === void 0 && (N = zn), d.type) {
          case "Property":
            this.checkLValInnerPattern(d.value, N, re);
            break;
          case "AssignmentPattern":
            this.checkLValPattern(d.left, N, re);
            break;
          case "RestElement":
            this.checkLValPattern(d.argument, N, re);
            break;
          default:
            this.checkLValPattern(d, N, re);
        }
      };
      var E = function(N, re, pe, Le, je) {
        this.token = N, this.isExpr = !!re, this.preserveSpace = !!pe, this.override = Le, this.generator = !!je;
      }, D = {
        b_stat: new E("{", !1),
        b_expr: new E("{", !0),
        b_tmpl: new E("${", !1),
        p_stat: new E("(", !1),
        p_expr: new E("(", !0),
        q_tmpl: new E("`", !0, !0, function(d) {
          return d.tryReadTemplateToken();
        }),
        f_stat: new E("function", !1),
        f_expr: new E("function", !0),
        f_expr_gen: new E("function", !0, !1, null, !0),
        f_gen: new E("function", !1, !1, null, !0)
      }, L = i.prototype;
      L.initialContext = function() {
        return [D.b_stat];
      }, L.curContext = function() {
        return this.context[this.context.length - 1];
      }, L.braceIsBlock = function(d) {
        var N = this.curContext();
        return N === D.f_expr || N === D.f_stat ? !0 : d === K.colon && (N === D.b_stat || N === D.b_expr) ? !N.isExpr : d === K._return || d === K.name && this.exprAllowed ? j.test(this.input.slice(this.lastTokEnd, this.start)) : d === K._else || d === K.semi || d === K.eof || d === K.parenR || d === K.arrow ? !0 : d === K.braceL ? N === D.b_stat : d === K._var || d === K._const || d === K.name ? !1 : !this.exprAllowed;
      }, L.inGeneratorContext = function() {
        for (var d = this.context.length - 1; d >= 1; d--) {
          var N = this.context[d];
          if (N.token === "function")
            return N.generator;
        }
        return !1;
      }, L.updateContext = function(d) {
        var N, re = this.type;
        re.keyword && d === K.dot ? this.exprAllowed = !1 : (N = re.updateContext) ? N.call(this, d) : this.exprAllowed = re.beforeExpr;
      }, L.overrideContext = function(d) {
        this.curContext() !== d && (this.context[this.context.length - 1] = d);
      }, K.parenR.updateContext = K.braceR.updateContext = function() {
        if (this.context.length === 1) {
          this.exprAllowed = !0;
          return;
        }
        var d = this.context.pop();
        d === D.b_stat && this.curContext().token === "function" && (d = this.context.pop()), this.exprAllowed = !d.isExpr;
      }, K.braceL.updateContext = function(d) {
        this.context.push(this.braceIsBlock(d) ? D.b_stat : D.b_expr), this.exprAllowed = !0;
      }, K.dollarBraceL.updateContext = function() {
        this.context.push(D.b_tmpl), this.exprAllowed = !0;
      }, K.parenL.updateContext = function(d) {
        var N = d === K._if || d === K._for || d === K._with || d === K._while;
        this.context.push(N ? D.p_stat : D.p_expr), this.exprAllowed = !0;
      }, K.incDec.updateContext = function() {
      }, K._function.updateContext = K._class.updateContext = function(d) {
        d.beforeExpr && d !== K._else && !(d === K.semi && this.curContext() !== D.p_stat) && !(d === K._return && j.test(this.input.slice(this.lastTokEnd, this.start))) && !((d === K.colon || d === K.braceL) && this.curContext() === D.b_stat) ? this.context.push(D.f_expr) : this.context.push(D.f_stat), this.exprAllowed = !1;
      }, K.colon.updateContext = function() {
        this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
      }, K.backQuote.updateContext = function() {
        this.curContext() === D.q_tmpl ? this.context.pop() : this.context.push(D.q_tmpl), this.exprAllowed = !1;
      }, K.star.updateContext = function(d) {
        if (d === K._function) {
          var N = this.context.length - 1;
          this.context[N] === D.f_expr ? this.context[N] = D.f_expr_gen : this.context[N] = D.f_gen;
        }
        this.exprAllowed = !0;
      }, K.name.updateContext = function(d) {
        var N = !1;
        this.options.ecmaVersion >= 6 && d !== K.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (N = !0), this.exprAllowed = N;
      };
      var P = i.prototype;
      P.checkPropClash = function(d, N, re) {
        if (!(this.options.ecmaVersion >= 9 && d.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (d.computed || d.method || d.shorthand))) {
          var pe = d.key, Le;
          switch (pe.type) {
            case "Identifier":
              Le = pe.name;
              break;
            case "Literal":
              Le = String(pe.value);
              break;
            default:
              return;
          }
          var je = d.kind;
          if (this.options.ecmaVersion >= 6) {
            Le === "__proto__" && je === "init" && (N.proto && (re ? re.doubleProto < 0 && (re.doubleProto = pe.start) : this.raiseRecoverable(pe.start, "Redefinition of __proto__ property")), N.proto = !0);
            return;
          }
          Le = "$" + Le;
          var Qe = N[Le];
          if (Qe) {
            var vt;
            je === "init" ? vt = this.strict && Qe.init || Qe.get || Qe.set : vt = Qe.init || Qe[je], vt && this.raiseRecoverable(pe.start, "Redefinition of property");
          } else
            Qe = N[Le] = {
              init: !1,
              get: !1,
              set: !1
            };
          Qe[je] = !0;
        }
      }, P.parseExpression = function(d, N) {
        var re = this.start, pe = this.startLoc, Le = this.parseMaybeAssign(d, N);
        if (this.type === K.comma) {
          var je = this.startNodeAt(re, pe);
          for (je.expressions = [Le]; this.eat(K.comma); )
            je.expressions.push(this.parseMaybeAssign(d, N));
          return this.finishNode(je, "SequenceExpression");
        }
        return Le;
      }, P.parseMaybeAssign = function(d, N, re) {
        if (this.isContextual("yield")) {
          if (this.inGenerator)
            return this.parseYield(d);
          this.exprAllowed = !1;
        }
        var pe = !1, Le = -1, je = -1, Qe = -1;
        N ? (Le = N.parenthesizedAssign, je = N.trailingComma, Qe = N.doubleProto, N.parenthesizedAssign = N.trailingComma = -1) : (N = new h(), pe = !0);
        var vt = this.start, Lt = this.startLoc;
        (this.type === K.parenL || this.type === K.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = d === "await");
        var $t = this.parseMaybeConditional(d, N);
        if (re && ($t = re.call(this, $t, vt, Lt)), this.type.isAssign) {
          var ii = this.startNodeAt(vt, Lt);
          return ii.operator = this.value, this.type === K.eq && ($t = this.toAssignable($t, !1, N)), pe || (N.parenthesizedAssign = N.trailingComma = N.doubleProto = -1), N.shorthandAssign >= $t.start && (N.shorthandAssign = -1), this.type === K.eq ? this.checkLValPattern($t) : this.checkLValSimple($t), ii.left = $t, this.next(), ii.right = this.parseMaybeAssign(d), Qe > -1 && (N.doubleProto = Qe), this.finishNode(ii, "AssignmentExpression");
        } else
          pe && this.checkExpressionErrors(N, !0);
        return Le > -1 && (N.parenthesizedAssign = Le), je > -1 && (N.trailingComma = je), $t;
      }, P.parseMaybeConditional = function(d, N) {
        var re = this.start, pe = this.startLoc, Le = this.parseExprOps(d, N);
        if (this.checkExpressionErrors(N))
          return Le;
        if (this.eat(K.question)) {
          var je = this.startNodeAt(re, pe);
          return je.test = Le, je.consequent = this.parseMaybeAssign(), this.expect(K.colon), je.alternate = this.parseMaybeAssign(d), this.finishNode(je, "ConditionalExpression");
        }
        return Le;
      }, P.parseExprOps = function(d, N) {
        var re = this.start, pe = this.startLoc, Le = this.parseMaybeUnary(N, !1, !1, d);
        return this.checkExpressionErrors(N) || Le.start === re && Le.type === "ArrowFunctionExpression" ? Le : this.parseExprOp(Le, re, pe, -1, d);
      }, P.parseExprOp = function(d, N, re, pe, Le) {
        var je = this.type.binop;
        if (je != null && (!Le || this.type !== K._in) && je > pe) {
          var Qe = this.type === K.logicalOR || this.type === K.logicalAND, vt = this.type === K.coalesce;
          vt && (je = K.logicalAND.binop);
          var Lt = this.value;
          this.next();
          var $t = this.start, ii = this.startLoc, Gi = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, Le), $t, ii, je, Le), ls = this.buildBinary(N, re, d, Gi, Lt, Qe || vt);
          return (Qe && this.type === K.coalesce || vt && (this.type === K.logicalOR || this.type === K.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(ls, N, re, pe, Le);
        }
        return d;
      }, P.buildBinary = function(d, N, re, pe, Le, je) {
        pe.type === "PrivateIdentifier" && this.raise(pe.start, "Private identifier can only be left side of binary expression");
        var Qe = this.startNodeAt(d, N);
        return Qe.left = re, Qe.operator = Le, Qe.right = pe, this.finishNode(Qe, je ? "LogicalExpression" : "BinaryExpression");
      }, P.parseMaybeUnary = function(d, N, re, pe) {
        var Le = this.start, je = this.startLoc, Qe;
        if (this.isContextual("await") && this.canAwait)
          Qe = this.parseAwait(pe), N = !0;
        else if (this.type.prefix) {
          var vt = this.startNode(), Lt = this.type === K.incDec;
          vt.operator = this.value, vt.prefix = !0, this.next(), vt.argument = this.parseMaybeUnary(null, !0, Lt, pe), this.checkExpressionErrors(d, !0), Lt ? this.checkLValSimple(vt.argument) : this.strict && vt.operator === "delete" && vt.argument.type === "Identifier" ? this.raiseRecoverable(vt.start, "Deleting local variable in strict mode") : vt.operator === "delete" && S(vt.argument) ? this.raiseRecoverable(vt.start, "Private fields can not be deleted") : N = !0, Qe = this.finishNode(vt, Lt ? "UpdateExpression" : "UnaryExpression");
        } else if (!N && this.type === K.privateId)
          (pe || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), Qe = this.parsePrivateIdent(), this.type !== K._in && this.unexpected();
        else {
          if (Qe = this.parseExprSubscripts(d, pe), this.checkExpressionErrors(d))
            return Qe;
          for (; this.type.postfix && !this.canInsertSemicolon(); ) {
            var $t = this.startNodeAt(Le, je);
            $t.operator = this.value, $t.prefix = !1, $t.argument = Qe, this.checkLValSimple(Qe), this.next(), Qe = this.finishNode($t, "UpdateExpression");
          }
        }
        if (!re && this.eat(K.starstar))
          if (N)
            this.unexpected(this.lastTokStart);
          else
            return this.buildBinary(Le, je, Qe, this.parseMaybeUnary(null, !1, !1, pe), "**", !1);
        else
          return Qe;
      };
      function S(d) {
        return d.type === "MemberExpression" && d.property.type === "PrivateIdentifier" || d.type === "ChainExpression" && S(d.expression);
      }
      P.parseExprSubscripts = function(d, N) {
        var re = this.start, pe = this.startLoc, Le = this.parseExprAtom(d, N);
        if (Le.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
          return Le;
        var je = this.parseSubscripts(Le, re, pe, !1, N);
        return d && je.type === "MemberExpression" && (d.parenthesizedAssign >= je.start && (d.parenthesizedAssign = -1), d.parenthesizedBind >= je.start && (d.parenthesizedBind = -1), d.trailingComma >= je.start && (d.trailingComma = -1)), je;
      }, P.parseSubscripts = function(d, N, re, pe, Le) {
        for (var je = this.options.ecmaVersion >= 8 && d.type === "Identifier" && d.name === "async" && this.lastTokEnd === d.end && !this.canInsertSemicolon() && d.end - d.start === 5 && this.potentialArrowAt === d.start, Qe = !1; ; ) {
          var vt = this.parseSubscript(d, N, re, pe, je, Qe, Le);
          if (vt.optional && (Qe = !0), vt === d || vt.type === "ArrowFunctionExpression") {
            if (Qe) {
              var Lt = this.startNodeAt(N, re);
              Lt.expression = vt, vt = this.finishNode(Lt, "ChainExpression");
            }
            return vt;
          }
          d = vt;
        }
      }, P.shouldParseAsyncArrow = function() {
        return !this.canInsertSemicolon() && this.eat(K.arrow);
      }, P.parseSubscriptAsyncArrow = function(d, N, re, pe) {
        return this.parseArrowExpression(this.startNodeAt(d, N), re, !0, pe);
      }, P.parseSubscript = function(d, N, re, pe, Le, je, Qe) {
        var vt = this.options.ecmaVersion >= 11, Lt = vt && this.eat(K.questionDot);
        pe && Lt && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
        var $t = this.eat(K.bracketL);
        if ($t || Lt && this.type !== K.parenL && this.type !== K.backQuote || this.eat(K.dot)) {
          var ii = this.startNodeAt(N, re);
          ii.object = d, $t ? (ii.property = this.parseExpression(), this.expect(K.bracketR)) : this.type === K.privateId && d.type !== "Super" ? ii.property = this.parsePrivateIdent() : ii.property = this.parseIdent(this.options.allowReserved !== "never"), ii.computed = !!$t, vt && (ii.optional = Lt), d = this.finishNode(ii, "MemberExpression");
        } else if (!pe && this.eat(K.parenL)) {
          var Gi = new h(), ls = this.yieldPos, As = this.awaitPos, ms = this.awaitIdentPos;
          this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
          var zs = this.parseExprList(K.parenR, this.options.ecmaVersion >= 8, !1, Gi);
          if (Le && !Lt && this.shouldParseAsyncArrow())
            return this.checkPatternErrors(Gi, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = ls, this.awaitPos = As, this.awaitIdentPos = ms, this.parseSubscriptAsyncArrow(N, re, zs, Qe);
          this.checkExpressionErrors(Gi, !0), this.yieldPos = ls || this.yieldPos, this.awaitPos = As || this.awaitPos, this.awaitIdentPos = ms || this.awaitIdentPos;
          var Si = this.startNodeAt(N, re);
          Si.callee = d, Si.arguments = zs, vt && (Si.optional = Lt), d = this.finishNode(Si, "CallExpression");
        } else if (this.type === K.backQuote) {
          (Lt || je) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
          var bi = this.startNodeAt(N, re);
          bi.tag = d, bi.quasi = this.parseTemplate({ isTagged: !0 }), d = this.finishNode(bi, "TaggedTemplateExpression");
        }
        return d;
      }, P.parseExprAtom = function(d, N, re) {
        this.type === K.slash && this.readRegexp();
        var pe, Le = this.potentialArrowAt === this.start;
        switch (this.type) {
          case K._super:
            return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), pe = this.startNode(), this.next(), this.type === K.parenL && !this.allowDirectSuper && this.raise(pe.start, "super() call outside constructor of a subclass"), this.type !== K.dot && this.type !== K.bracketL && this.type !== K.parenL && this.unexpected(), this.finishNode(pe, "Super");
          case K._this:
            return pe = this.startNode(), this.next(), this.finishNode(pe, "ThisExpression");
          case K.name:
            var je = this.start, Qe = this.startLoc, vt = this.containsEsc, Lt = this.parseIdent(!1);
            if (this.options.ecmaVersion >= 8 && !vt && Lt.name === "async" && !this.canInsertSemicolon() && this.eat(K._function))
              return this.overrideContext(D.f_expr), this.parseFunction(this.startNodeAt(je, Qe), 0, !1, !0, N);
            if (Le && !this.canInsertSemicolon()) {
              if (this.eat(K.arrow))
                return this.parseArrowExpression(this.startNodeAt(je, Qe), [Lt], !1, N);
              if (this.options.ecmaVersion >= 8 && Lt.name === "async" && this.type === K.name && !vt && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
                return Lt = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(K.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(je, Qe), [Lt], !0, N);
            }
            return Lt;
          case K.regexp:
            var $t = this.value;
            return pe = this.parseLiteral($t.value), pe.regex = { pattern: $t.pattern, flags: $t.flags }, pe;
          case K.num:
          case K.string:
            return this.parseLiteral(this.value);
          case K._null:
          case K._true:
          case K._false:
            return pe = this.startNode(), pe.value = this.type === K._null ? null : this.type === K._true, pe.raw = this.type.keyword, this.next(), this.finishNode(pe, "Literal");
          case K.parenL:
            var ii = this.start, Gi = this.parseParenAndDistinguishExpression(Le, N);
            return d && (d.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(Gi) && (d.parenthesizedAssign = ii), d.parenthesizedBind < 0 && (d.parenthesizedBind = ii)), Gi;
          case K.bracketL:
            return pe = this.startNode(), this.next(), pe.elements = this.parseExprList(K.bracketR, !0, !0, d), this.finishNode(pe, "ArrayExpression");
          case K.braceL:
            return this.overrideContext(D.b_expr), this.parseObj(!1, d);
          case K._function:
            return pe = this.startNode(), this.next(), this.parseFunction(pe, 0);
          case K._class:
            return this.parseClass(this.startNode(), !1);
          case K._new:
            return this.parseNew();
          case K.backQuote:
            return this.parseTemplate();
          case K._import:
            return this.options.ecmaVersion >= 11 ? this.parseExprImport(re) : this.unexpected();
          default:
            return this.parseExprAtomDefault();
        }
      }, P.parseExprAtomDefault = function() {
        this.unexpected();
      }, P.parseExprImport = function(d) {
        var N = this.startNode();
        if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === K.parenL && !d)
          return this.parseDynamicImport(N);
        if (this.type === K.dot) {
          var re = this.startNodeAt(N.start, N.loc && N.loc.start);
          return re.name = "import", N.meta = this.finishNode(re, "Identifier"), this.parseImportMeta(N);
        } else
          this.unexpected();
      }, P.parseDynamicImport = function(d) {
        if (this.next(), d.source = this.parseMaybeAssign(), !this.eat(K.parenR)) {
          var N = this.start;
          this.eat(K.comma) && this.eat(K.parenR) ? this.raiseRecoverable(N, "Trailing comma is not allowed in import()") : this.unexpected(N);
        }
        return this.finishNode(d, "ImportExpression");
      }, P.parseImportMeta = function(d) {
        this.next();
        var N = this.containsEsc;
        return d.property = this.parseIdent(!0), d.property.name !== "meta" && this.raiseRecoverable(d.property.start, "The only valid meta property for import is 'import.meta'"), N && this.raiseRecoverable(d.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(d.start, "Cannot use 'import.meta' outside a module"), this.finishNode(d, "MetaProperty");
      }, P.parseLiteral = function(d) {
        var N = this.startNode();
        return N.value = d, N.raw = this.input.slice(this.start, this.end), N.raw.charCodeAt(N.raw.length - 1) === 110 && (N.bigint = N.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(N, "Literal");
      }, P.parseParenExpression = function() {
        this.expect(K.parenL);
        var d = this.parseExpression();
        return this.expect(K.parenR), d;
      }, P.shouldParseArrow = function(d) {
        return !this.canInsertSemicolon();
      }, P.parseParenAndDistinguishExpression = function(d, N) {
        var re = this.start, pe = this.startLoc, Le, je = this.options.ecmaVersion >= 8;
        if (this.options.ecmaVersion >= 6) {
          this.next();
          var Qe = this.start, vt = this.startLoc, Lt = [], $t = !0, ii = !1, Gi = new h(), ls = this.yieldPos, As = this.awaitPos, ms;
          for (this.yieldPos = 0, this.awaitPos = 0; this.type !== K.parenR; )
            if ($t ? $t = !1 : this.expect(K.comma), je && this.afterTrailingComma(K.parenR, !0)) {
              ii = !0;
              break;
            } else if (this.type === K.ellipsis) {
              ms = this.start, Lt.push(this.parseParenItem(this.parseRestBinding())), this.type === K.comma && this.raiseRecoverable(
                this.start,
                "Comma is not permitted after the rest element"
              );
              break;
            } else
              Lt.push(this.parseMaybeAssign(!1, Gi, this.parseParenItem));
          var zs = this.lastTokEnd, Si = this.lastTokEndLoc;
          if (this.expect(K.parenR), d && this.shouldParseArrow(Lt) && this.eat(K.arrow))
            return this.checkPatternErrors(Gi, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = ls, this.awaitPos = As, this.parseParenArrowList(re, pe, Lt, N);
          (!Lt.length || ii) && this.unexpected(this.lastTokStart), ms && this.unexpected(ms), this.checkExpressionErrors(Gi, !0), this.yieldPos = ls || this.yieldPos, this.awaitPos = As || this.awaitPos, Lt.length > 1 ? (Le = this.startNodeAt(Qe, vt), Le.expressions = Lt, this.finishNodeAt(Le, "SequenceExpression", zs, Si)) : Le = Lt[0];
        } else
          Le = this.parseParenExpression();
        if (this.options.preserveParens) {
          var bi = this.startNodeAt(re, pe);
          return bi.expression = Le, this.finishNode(bi, "ParenthesizedExpression");
        } else
          return Le;
      }, P.parseParenItem = function(d) {
        return d;
      }, P.parseParenArrowList = function(d, N, re, pe) {
        return this.parseArrowExpression(this.startNodeAt(d, N), re, !1, pe);
      };
      var I = [];
      P.parseNew = function() {
        this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
        var d = this.startNode();
        if (this.next(), this.options.ecmaVersion >= 6 && this.type === K.dot) {
          var N = this.startNodeAt(d.start, d.loc && d.loc.start);
          N.name = "new", d.meta = this.finishNode(N, "Identifier"), this.next();
          var re = this.containsEsc;
          return d.property = this.parseIdent(!0), d.property.name !== "target" && this.raiseRecoverable(d.property.start, "The only valid meta property for new is 'new.target'"), re && this.raiseRecoverable(d.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(d.start, "'new.target' can only be used in functions and class static block"), this.finishNode(d, "MetaProperty");
        }
        var pe = this.start, Le = this.startLoc;
        return d.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), pe, Le, !0, !1), this.eat(K.parenL) ? d.arguments = this.parseExprList(K.parenR, this.options.ecmaVersion >= 8, !1) : d.arguments = I, this.finishNode(d, "NewExpression");
      }, P.parseTemplateElement = function(d) {
        var N = d.isTagged, re = this.startNode();
        return this.type === K.invalidTemplate ? (N || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), re.value = {
          raw: this.value,
          cooked: null
        }) : re.value = {
          raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
          cooked: this.value
        }, this.next(), re.tail = this.type === K.backQuote, this.finishNode(re, "TemplateElement");
      }, P.parseTemplate = function(d) {
        d === void 0 && (d = {});
        var N = d.isTagged;
        N === void 0 && (N = !1);
        var re = this.startNode();
        this.next(), re.expressions = [];
        var pe = this.parseTemplateElement({ isTagged: N });
        for (re.quasis = [pe]; !pe.tail; )
          this.type === K.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(K.dollarBraceL), re.expressions.push(this.parseExpression()), this.expect(K.braceR), re.quasis.push(pe = this.parseTemplateElement({ isTagged: N }));
        return this.next(), this.finishNode(re, "TemplateLiteral");
      }, P.isAsyncProp = function(d) {
        return !d.computed && d.key.type === "Identifier" && d.key.name === "async" && (this.type === K.name || this.type === K.num || this.type === K.string || this.type === K.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === K.star) && !j.test(this.input.slice(this.lastTokEnd, this.start));
      }, P.parseObj = function(d, N) {
        var re = this.startNode(), pe = !0, Le = {};
        for (re.properties = [], this.next(); !this.eat(K.braceR); ) {
          if (pe)
            pe = !1;
          else if (this.expect(K.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(K.braceR))
            break;
          var je = this.parseProperty(d, N);
          d || this.checkPropClash(je, Le, N), re.properties.push(je);
        }
        return this.finishNode(re, d ? "ObjectPattern" : "ObjectExpression");
      }, P.parseProperty = function(d, N) {
        var re = this.startNode(), pe, Le, je, Qe;
        if (this.options.ecmaVersion >= 9 && this.eat(K.ellipsis))
          return d ? (re.argument = this.parseIdent(!1), this.type === K.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(re, "RestElement")) : (re.argument = this.parseMaybeAssign(!1, N), this.type === K.comma && N && N.trailingComma < 0 && (N.trailingComma = this.start), this.finishNode(re, "SpreadElement"));
        this.options.ecmaVersion >= 6 && (re.method = !1, re.shorthand = !1, (d || N) && (je = this.start, Qe = this.startLoc), d || (pe = this.eat(K.star)));
        var vt = this.containsEsc;
        return this.parsePropertyName(re), !d && !vt && this.options.ecmaVersion >= 8 && !pe && this.isAsyncProp(re) ? (Le = !0, pe = this.options.ecmaVersion >= 9 && this.eat(K.star), this.parsePropertyName(re)) : Le = !1, this.parsePropertyValue(re, d, pe, Le, je, Qe, N, vt), this.finishNode(re, "Property");
      }, P.parseGetterSetter = function(d) {
        d.kind = d.key.name, this.parsePropertyName(d), d.value = this.parseMethod(!1);
        var N = d.kind === "get" ? 0 : 1;
        if (d.value.params.length !== N) {
          var re = d.value.start;
          d.kind === "get" ? this.raiseRecoverable(re, "getter should have no params") : this.raiseRecoverable(re, "setter should have exactly one param");
        } else
          d.kind === "set" && d.value.params[0].type === "RestElement" && this.raiseRecoverable(d.value.params[0].start, "Setter cannot use rest params");
      }, P.parsePropertyValue = function(d, N, re, pe, Le, je, Qe, vt) {
        (re || pe) && this.type === K.colon && this.unexpected(), this.eat(K.colon) ? (d.value = N ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, Qe), d.kind = "init") : this.options.ecmaVersion >= 6 && this.type === K.parenL ? (N && this.unexpected(), d.kind = "init", d.method = !0, d.value = this.parseMethod(re, pe)) : !N && !vt && this.options.ecmaVersion >= 5 && !d.computed && d.key.type === "Identifier" && (d.key.name === "get" || d.key.name === "set") && this.type !== K.comma && this.type !== K.braceR && this.type !== K.eq ? ((re || pe) && this.unexpected(), this.parseGetterSetter(d)) : this.options.ecmaVersion >= 6 && !d.computed && d.key.type === "Identifier" ? ((re || pe) && this.unexpected(), this.checkUnreserved(d.key), d.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = Le), d.kind = "init", N ? d.value = this.parseMaybeDefault(Le, je, this.copyNode(d.key)) : this.type === K.eq && Qe ? (Qe.shorthandAssign < 0 && (Qe.shorthandAssign = this.start), d.value = this.parseMaybeDefault(Le, je, this.copyNode(d.key))) : d.value = this.copyNode(d.key), d.shorthand = !0) : this.unexpected();
      }, P.parsePropertyName = function(d) {
        if (this.options.ecmaVersion >= 6) {
          if (this.eat(K.bracketL))
            return d.computed = !0, d.key = this.parseMaybeAssign(), this.expect(K.bracketR), d.key;
          d.computed = !1;
        }
        return d.key = this.type === K.num || this.type === K.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
      }, P.initFunction = function(d) {
        d.id = null, this.options.ecmaVersion >= 6 && (d.generator = d.expression = !1), this.options.ecmaVersion >= 8 && (d.async = !1);
      }, P.parseMethod = function(d, N, re) {
        var pe = this.startNode(), Le = this.yieldPos, je = this.awaitPos, Qe = this.awaitIdentPos;
        return this.initFunction(pe), this.options.ecmaVersion >= 6 && (pe.generator = d), this.options.ecmaVersion >= 8 && (pe.async = !!N), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Js(N, pe.generator) | qn | (re ? Ds : 0)), this.expect(K.parenL), pe.params = this.parseBindingList(K.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(pe, !1, !0, !1), this.yieldPos = Le, this.awaitPos = je, this.awaitIdentPos = Qe, this.finishNode(pe, "FunctionExpression");
      }, P.parseArrowExpression = function(d, N, re, pe) {
        var Le = this.yieldPos, je = this.awaitPos, Qe = this.awaitIdentPos;
        return this.enterScope(Js(re, !1) | Ln), this.initFunction(d), this.options.ecmaVersion >= 8 && (d.async = !!re), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, d.params = this.toAssignableList(N, !0), this.parseFunctionBody(d, !0, !1, pe), this.yieldPos = Le, this.awaitPos = je, this.awaitIdentPos = Qe, this.finishNode(d, "ArrowFunctionExpression");
      }, P.parseFunctionBody = function(d, N, re, pe) {
        var Le = N && this.type !== K.braceL, je = this.strict, Qe = !1;
        if (Le)
          d.body = this.parseMaybeAssign(pe), d.expression = !0, this.checkParams(d, !1);
        else {
          var vt = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(d.params);
          (!je || vt) && (Qe = this.strictDirective(this.end), Qe && vt && this.raiseRecoverable(d.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
          var Lt = this.labels;
          this.labels = [], Qe && (this.strict = !0), this.checkParams(d, !je && !Qe && !N && !re && this.isSimpleParamList(d.params)), this.strict && d.id && this.checkLValSimple(d.id, nt), d.body = this.parseBlock(!1, void 0, Qe && !je), d.expression = !1, this.adaptDirectivePrologue(d.body.body), this.labels = Lt;
        }
        this.exitScope();
      }, P.isSimpleParamList = function(d) {
        for (var N = 0, re = d; N < re.length; N += 1) {
          var pe = re[N];
          if (pe.type !== "Identifier")
            return !1;
        }
        return !0;
      }, P.checkParams = function(d, N) {
        for (var re = /* @__PURE__ */ Object.create(null), pe = 0, Le = d.params; pe < Le.length; pe += 1) {
          var je = Le[pe];
          this.checkLValInnerPattern(je, Ut, N ? null : re);
        }
      }, P.parseExprList = function(d, N, re, pe) {
        for (var Le = [], je = !0; !this.eat(d); ) {
          if (je)
            je = !1;
          else if (this.expect(K.comma), N && this.afterTrailingComma(d))
            break;
          var Qe = void 0;
          re && this.type === K.comma ? Qe = null : this.type === K.ellipsis ? (Qe = this.parseSpread(pe), pe && this.type === K.comma && pe.trailingComma < 0 && (pe.trailingComma = this.start)) : Qe = this.parseMaybeAssign(!1, pe), Le.push(Qe);
        }
        return Le;
      }, P.checkUnreserved = function(d) {
        var N = d.start, re = d.end, pe = d.name;
        if (this.inGenerator && pe === "yield" && this.raiseRecoverable(N, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && pe === "await" && this.raiseRecoverable(N, "Cannot use 'await' as identifier inside an async function"), this.currentThisScope().inClassFieldInit && pe === "arguments" && this.raiseRecoverable(N, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (pe === "arguments" || pe === "await") && this.raise(N, "Cannot use " + pe + " in class static initialization block"), this.keywords.test(pe) && this.raise(N, "Unexpected keyword '" + pe + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(N, re).indexOf("\\") !== -1)) {
          var Le = this.strict ? this.reservedWordsStrict : this.reservedWords;
          Le.test(pe) && (!this.inAsync && pe === "await" && this.raiseRecoverable(N, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(N, "The keyword '" + pe + "' is reserved"));
        }
      }, P.parseIdent = function(d) {
        var N = this.parseIdentNode();
        return this.next(!!d), this.finishNode(N, "Identifier"), d || (this.checkUnreserved(N), N.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = N.start)), N;
      }, P.parseIdentNode = function() {
        var d = this.startNode();
        return this.type === K.name ? d.name = this.value : this.type.keyword ? (d.name = this.type.keyword, (d.name === "class" || d.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = K.name) : this.unexpected(), d;
      }, P.parsePrivateIdent = function() {
        var d = this.startNode();
        return this.type === K.privateId ? d.name = this.value : this.unexpected(), this.next(), this.finishNode(d, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(d.start, "Private field '#" + d.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(d)), d;
      }, P.parseYield = function(d) {
        this.yieldPos || (this.yieldPos = this.start);
        var N = this.startNode();
        return this.next(), this.type === K.semi || this.canInsertSemicolon() || this.type !== K.star && !this.type.startsExpr ? (N.delegate = !1, N.argument = null) : (N.delegate = this.eat(K.star), N.argument = this.parseMaybeAssign(d)), this.finishNode(N, "YieldExpression");
      }, P.parseAwait = function(d) {
        this.awaitPos || (this.awaitPos = this.start);
        var N = this.startNode();
        return this.next(), N.argument = this.parseMaybeUnary(null, !0, !1, d), this.finishNode(N, "AwaitExpression");
      };
      var U = i.prototype;
      U.raise = function(d, N) {
        var re = as(this.input, d);
        N += " (" + re.line + ":" + re.column + ")";
        var pe = new SyntaxError(N);
        throw pe.pos = d, pe.loc = re, pe.raisedAt = this.pos, pe;
      }, U.raiseRecoverable = U.raise, U.curPosition = function() {
        if (this.options.locations)
          return new Tn(this.curLine, this.pos - this.lineStart);
      };
      var V = i.prototype, F = function(N) {
        this.flags = N, this.var = [], this.lexical = [], this.functions = [], this.inClassFieldInit = !1;
      };
      V.enterScope = function(d) {
        this.scopeStack.push(new F(d));
      }, V.exitScope = function() {
        this.scopeStack.pop();
      }, V.treatFunctionsAsVarInScope = function(d) {
        return d.flags & Dt || !this.inModule && d.flags & zt;
      }, V.declareName = function(d, N, re) {
        var pe = !1;
        if (N === ki) {
          var Le = this.currentScope();
          pe = Le.lexical.indexOf(d) > -1 || Le.functions.indexOf(d) > -1 || Le.var.indexOf(d) > -1, Le.lexical.push(d), this.inModule && Le.flags & zt && delete this.undefinedExports[d];
        } else if (N === Jn) {
          var je = this.currentScope();
          je.lexical.push(d);
        } else if (N === Vt) {
          var Qe = this.currentScope();
          this.treatFunctionsAsVar ? pe = Qe.lexical.indexOf(d) > -1 : pe = Qe.lexical.indexOf(d) > -1 || Qe.var.indexOf(d) > -1, Qe.functions.push(d);
        } else
          for (var vt = this.scopeStack.length - 1; vt >= 0; --vt) {
            var Lt = this.scopeStack[vt];
            if (Lt.lexical.indexOf(d) > -1 && !(Lt.flags & Sn && Lt.lexical[0] === d) || !this.treatFunctionsAsVarInScope(Lt) && Lt.functions.indexOf(d) > -1) {
              pe = !0;
              break;
            }
            if (Lt.var.push(d), this.inModule && Lt.flags & zt && delete this.undefinedExports[d], Lt.flags & Bn)
              break;
          }
        pe && this.raiseRecoverable(re, "Identifier '" + d + "' has already been declared");
      }, V.checkLocalExport = function(d) {
        this.scopeStack[0].lexical.indexOf(d.name) === -1 && this.scopeStack[0].var.indexOf(d.name) === -1 && (this.undefinedExports[d.name] = d);
      }, V.currentScope = function() {
        return this.scopeStack[this.scopeStack.length - 1];
      }, V.currentVarScope = function() {
        for (var d = this.scopeStack.length - 1; ; d--) {
          var N = this.scopeStack[d];
          if (N.flags & Bn)
            return N;
        }
      }, V.currentThisScope = function() {
        for (var d = this.scopeStack.length - 1; ; d--) {
          var N = this.scopeStack[d];
          if (N.flags & Bn && !(N.flags & Ln))
            return N;
        }
      };
      var W = function(N, re, pe) {
        this.type = "", this.start = re, this.end = 0, N.options.locations && (this.loc = new Ki(N, pe)), N.options.directSourceFile && (this.sourceFile = N.options.directSourceFile), N.options.ranges && (this.range = [re, 0]);
      }, Q = i.prototype;
      Q.startNode = function() {
        return new W(this, this.start, this.startLoc);
      }, Q.startNodeAt = function(d, N) {
        return new W(this, d, N);
      };
      function ie(d, N, re, pe) {
        return d.type = N, d.end = re, this.options.locations && (d.loc.end = pe), this.options.ranges && (d.range[1] = re), d;
      }
      Q.finishNode = function(d, N) {
        return ie.call(this, d, N, this.lastTokEnd, this.lastTokEndLoc);
      }, Q.finishNodeAt = function(d, N, re, pe) {
        return ie.call(this, d, N, re, pe);
      }, Q.copyNode = function(d) {
        var N = new W(this, d.start, this.startLoc);
        for (var re in d)
          N[re] = d[re];
        return N;
      };
      var ae = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", J = ae + " Extended_Pictographic", le = J, fe = le + " EBase EComp EMod EPres ExtPict", me = fe, ve = me, Se = {
        9: ae,
        10: J,
        11: le,
        12: fe,
        13: me,
        14: ve
      }, Re = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", He = {
        9: "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: Re
      }, Ye = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", Je = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", Be = Je + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", Ie = Be + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", Ge = Ie + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", et = Ge + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", tt = et + " Hrkt Katakana_Or_Hiragana Kawi Nag_Mundari Nagm Unknown Zzzz", gt = {
        9: Je,
        10: Be,
        11: Ie,
        12: Ge,
        13: et,
        14: tt
      }, ut = {};
      function yt(d) {
        var N = ut[d] = {
          binary: Bt(Se[d] + " " + Ye),
          binaryOfStrings: Bt(He[d]),
          nonBinary: {
            General_Category: Bt(Ye),
            Script: Bt(gt[d])
          }
        };
        N.nonBinary.Script_Extensions = N.nonBinary.Script, N.nonBinary.gc = N.nonBinary.General_Category, N.nonBinary.sc = N.nonBinary.Script, N.nonBinary.scx = N.nonBinary.Script_Extensions;
      }
      for (var At = 0, bt = [9, 10, 11, 12, 13, 14]; At < bt.length; At += 1) {
        var li = bt[At];
        yt(li);
      }
      var mt = i.prototype, Zt = function(N) {
        this.parser = N, this.validFlags = "gim" + (N.options.ecmaVersion >= 6 ? "uy" : "") + (N.options.ecmaVersion >= 9 ? "s" : "") + (N.options.ecmaVersion >= 13 ? "d" : "") + (N.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = ut[N.options.ecmaVersion >= 14 ? 14 : N.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
      };
      Zt.prototype.reset = function(N, re, pe) {
        var Le = pe.indexOf("v") !== -1, je = pe.indexOf("u") !== -1;
        this.start = N | 0, this.source = re + "", this.flags = pe, Le && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = je && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = je && this.parser.options.ecmaVersion >= 9);
      }, Zt.prototype.raise = function(N) {
        this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + N);
      }, Zt.prototype.at = function(N, re) {
        re === void 0 && (re = !1);
        var pe = this.source, Le = pe.length;
        if (N >= Le)
          return -1;
        var je = pe.charCodeAt(N);
        if (!(re || this.switchU) || je <= 55295 || je >= 57344 || N + 1 >= Le)
          return je;
        var Qe = pe.charCodeAt(N + 1);
        return Qe >= 56320 && Qe <= 57343 ? (je << 10) + Qe - 56613888 : je;
      }, Zt.prototype.nextIndex = function(N, re) {
        re === void 0 && (re = !1);
        var pe = this.source, Le = pe.length;
        if (N >= Le)
          return Le;
        var je = pe.charCodeAt(N), Qe;
        return !(re || this.switchU) || je <= 55295 || je >= 57344 || N + 1 >= Le || (Qe = pe.charCodeAt(N + 1)) < 56320 || Qe > 57343 ? N + 1 : N + 2;
      }, Zt.prototype.current = function(N) {
        return N === void 0 && (N = !1), this.at(this.pos, N);
      }, Zt.prototype.lookahead = function(N) {
        return N === void 0 && (N = !1), this.at(this.nextIndex(this.pos, N), N);
      }, Zt.prototype.advance = function(N) {
        N === void 0 && (N = !1), this.pos = this.nextIndex(this.pos, N);
      }, Zt.prototype.eat = function(N, re) {
        return re === void 0 && (re = !1), this.current(re) === N ? (this.advance(re), !0) : !1;
      }, Zt.prototype.eatChars = function(N, re) {
        re === void 0 && (re = !1);
        for (var pe = this.pos, Le = 0, je = N; Le < je.length; Le += 1) {
          var Qe = je[Le], vt = this.at(pe, re);
          if (vt === -1 || vt !== Qe)
            return !1;
          pe = this.nextIndex(pe, re);
        }
        return this.pos = pe, !0;
      }, mt.validateRegExpFlags = function(d) {
        for (var N = d.validFlags, re = d.flags, pe = !1, Le = !1, je = 0; je < re.length; je++) {
          var Qe = re.charAt(je);
          N.indexOf(Qe) === -1 && this.raise(d.start, "Invalid regular expression flag"), re.indexOf(Qe, je + 1) > -1 && this.raise(d.start, "Duplicate regular expression flag"), Qe === "u" && (pe = !0), Qe === "v" && (Le = !0);
        }
        this.options.ecmaVersion >= 15 && pe && Le && this.raise(d.start, "Invalid regular expression flag");
      }, mt.validateRegExpPattern = function(d) {
        this.regexp_pattern(d), !d.switchN && this.options.ecmaVersion >= 9 && d.groupNames.length > 0 && (d.switchN = !0, this.regexp_pattern(d));
      }, mt.regexp_pattern = function(d) {
        d.pos = 0, d.lastIntValue = 0, d.lastStringValue = "", d.lastAssertionIsQuantifiable = !1, d.numCapturingParens = 0, d.maxBackReference = 0, d.groupNames.length = 0, d.backReferenceNames.length = 0, this.regexp_disjunction(d), d.pos !== d.source.length && (d.eat(
          41
          /* ) */
        ) && d.raise("Unmatched ')'"), (d.eat(
          93
          /* ] */
        ) || d.eat(
          125
          /* } */
        )) && d.raise("Lone quantifier brackets")), d.maxBackReference > d.numCapturingParens && d.raise("Invalid escape");
        for (var N = 0, re = d.backReferenceNames; N < re.length; N += 1) {
          var pe = re[N];
          d.groupNames.indexOf(pe) === -1 && d.raise("Invalid named capture referenced");
        }
      }, mt.regexp_disjunction = function(d) {
        for (this.regexp_alternative(d); d.eat(
          124
          /* | */
        ); )
          this.regexp_alternative(d);
        this.regexp_eatQuantifier(d, !0) && d.raise("Nothing to repeat"), d.eat(
          123
          /* { */
        ) && d.raise("Lone quantifier brackets");
      }, mt.regexp_alternative = function(d) {
        for (; d.pos < d.source.length && this.regexp_eatTerm(d); )
          ;
      }, mt.regexp_eatTerm = function(d) {
        return this.regexp_eatAssertion(d) ? (d.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(d) && d.switchU && d.raise("Invalid quantifier"), !0) : (d.switchU ? this.regexp_eatAtom(d) : this.regexp_eatExtendedAtom(d)) ? (this.regexp_eatQuantifier(d), !0) : !1;
      }, mt.regexp_eatAssertion = function(d) {
        var N = d.pos;
        if (d.lastAssertionIsQuantifiable = !1, d.eat(
          94
          /* ^ */
        ) || d.eat(
          36
          /* $ */
        ))
          return !0;
        if (d.eat(
          92
          /* \ */
        )) {
          if (d.eat(
            66
            /* B */
          ) || d.eat(
            98
            /* b */
          ))
            return !0;
          d.pos = N;
        }
        if (d.eat(
          40
          /* ( */
        ) && d.eat(
          63
          /* ? */
        )) {
          var re = !1;
          if (this.options.ecmaVersion >= 9 && (re = d.eat(
            60
            /* < */
          )), d.eat(
            61
            /* = */
          ) || d.eat(
            33
            /* ! */
          ))
            return this.regexp_disjunction(d), d.eat(
              41
              /* ) */
            ) || d.raise("Unterminated group"), d.lastAssertionIsQuantifiable = !re, !0;
        }
        return d.pos = N, !1;
      }, mt.regexp_eatQuantifier = function(d, N) {
        return N === void 0 && (N = !1), this.regexp_eatQuantifierPrefix(d, N) ? (d.eat(
          63
          /* ? */
        ), !0) : !1;
      }, mt.regexp_eatQuantifierPrefix = function(d, N) {
        return d.eat(
          42
          /* * */
        ) || d.eat(
          43
          /* + */
        ) || d.eat(
          63
          /* ? */
        ) || this.regexp_eatBracedQuantifier(d, N);
      }, mt.regexp_eatBracedQuantifier = function(d, N) {
        var re = d.pos;
        if (d.eat(
          123
          /* { */
        )) {
          var pe = 0, Le = -1;
          if (this.regexp_eatDecimalDigits(d) && (pe = d.lastIntValue, d.eat(
            44
            /* , */
          ) && this.regexp_eatDecimalDigits(d) && (Le = d.lastIntValue), d.eat(
            125
            /* } */
          )))
            return Le !== -1 && Le < pe && !N && d.raise("numbers out of order in {} quantifier"), !0;
          d.switchU && !N && d.raise("Incomplete quantifier"), d.pos = re;
        }
        return !1;
      }, mt.regexp_eatAtom = function(d) {
        return this.regexp_eatPatternCharacters(d) || d.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(d) || this.regexp_eatCharacterClass(d) || this.regexp_eatUncapturingGroup(d) || this.regexp_eatCapturingGroup(d);
      }, mt.regexp_eatReverseSolidusAtomEscape = function(d) {
        var N = d.pos;
        if (d.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatAtomEscape(d))
            return !0;
          d.pos = N;
        }
        return !1;
      }, mt.regexp_eatUncapturingGroup = function(d) {
        var N = d.pos;
        if (d.eat(
          40
          /* ( */
        )) {
          if (d.eat(
            63
            /* ? */
          ) && d.eat(
            58
            /* : */
          )) {
            if (this.regexp_disjunction(d), d.eat(
              41
              /* ) */
            ))
              return !0;
            d.raise("Unterminated group");
          }
          d.pos = N;
        }
        return !1;
      }, mt.regexp_eatCapturingGroup = function(d) {
        if (d.eat(
          40
          /* ( */
        )) {
          if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(d) : d.current() === 63 && d.raise("Invalid group"), this.regexp_disjunction(d), d.eat(
            41
            /* ) */
          ))
            return d.numCapturingParens += 1, !0;
          d.raise("Unterminated group");
        }
        return !1;
      }, mt.regexp_eatExtendedAtom = function(d) {
        return d.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(d) || this.regexp_eatCharacterClass(d) || this.regexp_eatUncapturingGroup(d) || this.regexp_eatCapturingGroup(d) || this.regexp_eatInvalidBracedQuantifier(d) || this.regexp_eatExtendedPatternCharacter(d);
      }, mt.regexp_eatInvalidBracedQuantifier = function(d) {
        return this.regexp_eatBracedQuantifier(d, !0) && d.raise("Nothing to repeat"), !1;
      }, mt.regexp_eatSyntaxCharacter = function(d) {
        var N = d.current();
        return Xt(N) ? (d.lastIntValue = N, d.advance(), !0) : !1;
      };
      function Xt(d) {
        return d === 36 || d >= 40 && d <= 43 || d === 46 || d === 63 || d >= 91 && d <= 94 || d >= 123 && d <= 125;
      }
      mt.regexp_eatPatternCharacters = function(d) {
        for (var N = d.pos, re = 0; (re = d.current()) !== -1 && !Xt(re); )
          d.advance();
        return d.pos !== N;
      }, mt.regexp_eatExtendedPatternCharacter = function(d) {
        var N = d.current();
        return N !== -1 && N !== 36 && !(N >= 40 && N <= 43) && N !== 46 && N !== 63 && N !== 91 && N !== 94 && N !== 124 ? (d.advance(), !0) : !1;
      }, mt.regexp_groupSpecifier = function(d) {
        if (d.eat(
          63
          /* ? */
        )) {
          if (this.regexp_eatGroupName(d)) {
            d.groupNames.indexOf(d.lastStringValue) !== -1 && d.raise("Duplicate capture group name"), d.groupNames.push(d.lastStringValue);
            return;
          }
          d.raise("Invalid group");
        }
      }, mt.regexp_eatGroupName = function(d) {
        if (d.lastStringValue = "", d.eat(
          60
          /* < */
        )) {
          if (this.regexp_eatRegExpIdentifierName(d) && d.eat(
            62
            /* > */
          ))
            return !0;
          d.raise("Invalid capture group name");
        }
        return !1;
      }, mt.regexp_eatRegExpIdentifierName = function(d) {
        if (d.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(d)) {
          for (d.lastStringValue += yi(d.lastIntValue); this.regexp_eatRegExpIdentifierPart(d); )
            d.lastStringValue += yi(d.lastIntValue);
          return !0;
        }
        return !1;
      }, mt.regexp_eatRegExpIdentifierStart = function(d) {
        var N = d.pos, re = this.options.ecmaVersion >= 11, pe = d.current(re);
        return d.advance(re), pe === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(d, re) && (pe = d.lastIntValue), Nt(pe) ? (d.lastIntValue = pe, !0) : (d.pos = N, !1);
      };
      function Nt(d) {
        return he(d, !0) || d === 36 || d === 95;
      }
      mt.regexp_eatRegExpIdentifierPart = function(d) {
        var N = d.pos, re = this.options.ecmaVersion >= 11, pe = d.current(re);
        return d.advance(re), pe === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(d, re) && (pe = d.lastIntValue), Jt(pe) ? (d.lastIntValue = pe, !0) : (d.pos = N, !1);
      };
      function Jt(d) {
        return ne(d, !0) || d === 36 || d === 95 || d === 8204 || d === 8205;
      }
      mt.regexp_eatAtomEscape = function(d) {
        return this.regexp_eatBackReference(d) || this.regexp_eatCharacterClassEscape(d) || this.regexp_eatCharacterEscape(d) || d.switchN && this.regexp_eatKGroupName(d) ? !0 : (d.switchU && (d.current() === 99 && d.raise("Invalid unicode escape"), d.raise("Invalid escape")), !1);
      }, mt.regexp_eatBackReference = function(d) {
        var N = d.pos;
        if (this.regexp_eatDecimalEscape(d)) {
          var re = d.lastIntValue;
          if (d.switchU)
            return re > d.maxBackReference && (d.maxBackReference = re), !0;
          if (re <= d.numCapturingParens)
            return !0;
          d.pos = N;
        }
        return !1;
      }, mt.regexp_eatKGroupName = function(d) {
        if (d.eat(
          107
          /* k */
        )) {
          if (this.regexp_eatGroupName(d))
            return d.backReferenceNames.push(d.lastStringValue), !0;
          d.raise("Invalid named reference");
        }
        return !1;
      }, mt.regexp_eatCharacterEscape = function(d) {
        return this.regexp_eatControlEscape(d) || this.regexp_eatCControlLetter(d) || this.regexp_eatZero(d) || this.regexp_eatHexEscapeSequence(d) || this.regexp_eatRegExpUnicodeEscapeSequence(d, !1) || !d.switchU && this.regexp_eatLegacyOctalEscapeSequence(d) || this.regexp_eatIdentityEscape(d);
      }, mt.regexp_eatCControlLetter = function(d) {
        var N = d.pos;
        if (d.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatControlLetter(d))
            return !0;
          d.pos = N;
        }
        return !1;
      }, mt.regexp_eatZero = function(d) {
        return d.current() === 48 && !$n(d.lookahead()) ? (d.lastIntValue = 0, d.advance(), !0) : !1;
      }, mt.regexp_eatControlEscape = function(d) {
        var N = d.current();
        return N === 116 ? (d.lastIntValue = 9, d.advance(), !0) : N === 110 ? (d.lastIntValue = 10, d.advance(), !0) : N === 118 ? (d.lastIntValue = 11, d.advance(), !0) : N === 102 ? (d.lastIntValue = 12, d.advance(), !0) : N === 114 ? (d.lastIntValue = 13, d.advance(), !0) : !1;
      }, mt.regexp_eatControlLetter = function(d) {
        var N = d.current();
        return Ti(N) ? (d.lastIntValue = N % 32, d.advance(), !0) : !1;
      };
      function Ti(d) {
        return d >= 65 && d <= 90 || d >= 97 && d <= 122;
      }
      mt.regexp_eatRegExpUnicodeEscapeSequence = function(d, N) {
        N === void 0 && (N = !1);
        var re = d.pos, pe = N || d.switchU;
        if (d.eat(
          117
          /* u */
        )) {
          if (this.regexp_eatFixedHexDigits(d, 4)) {
            var Le = d.lastIntValue;
            if (pe && Le >= 55296 && Le <= 56319) {
              var je = d.pos;
              if (d.eat(
                92
                /* \ */
              ) && d.eat(
                117
                /* u */
              ) && this.regexp_eatFixedHexDigits(d, 4)) {
                var Qe = d.lastIntValue;
                if (Qe >= 56320 && Qe <= 57343)
                  return d.lastIntValue = (Le - 55296) * 1024 + (Qe - 56320) + 65536, !0;
              }
              d.pos = je, d.lastIntValue = Le;
            }
            return !0;
          }
          if (pe && d.eat(
            123
            /* { */
          ) && this.regexp_eatHexDigits(d) && d.eat(
            125
            /* } */
          ) && ri(d.lastIntValue))
            return !0;
          pe && d.raise("Invalid unicode escape"), d.pos = re;
        }
        return !1;
      };
      function ri(d) {
        return d >= 0 && d <= 1114111;
      }
      mt.regexp_eatIdentityEscape = function(d) {
        if (d.switchU)
          return this.regexp_eatSyntaxCharacter(d) ? !0 : d.eat(
            47
            /* / */
          ) ? (d.lastIntValue = 47, !0) : !1;
        var N = d.current();
        return N !== 99 && (!d.switchN || N !== 107) ? (d.lastIntValue = N, d.advance(), !0) : !1;
      }, mt.regexp_eatDecimalEscape = function(d) {
        d.lastIntValue = 0;
        var N = d.current();
        if (N >= 49 && N <= 57) {
          do
            d.lastIntValue = 10 * d.lastIntValue + (N - 48), d.advance();
          while ((N = d.current()) >= 48 && N <= 57);
          return !0;
        }
        return !1;
      };
      var Pi = 0, ci = 1, hi = 2;
      mt.regexp_eatCharacterClassEscape = function(d) {
        var N = d.current();
        if (Ni(N))
          return d.lastIntValue = -1, d.advance(), ci;
        var re = !1;
        if (d.switchU && this.options.ecmaVersion >= 9 && ((re = N === 80) || N === 112)) {
          d.lastIntValue = -1, d.advance();
          var pe;
          if (d.eat(
            123
            /* { */
          ) && (pe = this.regexp_eatUnicodePropertyValueExpression(d)) && d.eat(
            125
            /* } */
          ))
            return re && pe === hi && d.raise("Invalid property name"), pe;
          d.raise("Invalid property name");
        }
        return Pi;
      };
      function Ni(d) {
        return d === 100 || d === 68 || d === 115 || d === 83 || d === 119 || d === 87;
      }
      mt.regexp_eatUnicodePropertyValueExpression = function(d) {
        var N = d.pos;
        if (this.regexp_eatUnicodePropertyName(d) && d.eat(
          61
          /* = */
        )) {
          var re = d.lastStringValue;
          if (this.regexp_eatUnicodePropertyValue(d)) {
            var pe = d.lastStringValue;
            return this.regexp_validateUnicodePropertyNameAndValue(d, re, pe), ci;
          }
        }
        if (d.pos = N, this.regexp_eatLoneUnicodePropertyNameOrValue(d)) {
          var Le = d.lastStringValue;
          return this.regexp_validateUnicodePropertyNameOrValue(d, Le);
        }
        return Pi;
      }, mt.regexp_validateUnicodePropertyNameAndValue = function(d, N, re) {
        Ve(d.unicodeProperties.nonBinary, N) || d.raise("Invalid property name"), d.unicodeProperties.nonBinary[N].test(re) || d.raise("Invalid property value");
      }, mt.regexp_validateUnicodePropertyNameOrValue = function(d, N) {
        if (d.unicodeProperties.binary.test(N))
          return ci;
        if (d.switchV && d.unicodeProperties.binaryOfStrings.test(N))
          return hi;
        d.raise("Invalid property name");
      }, mt.regexp_eatUnicodePropertyName = function(d) {
        var N = 0;
        for (d.lastStringValue = ""; Bi(N = d.current()); )
          d.lastStringValue += yi(N), d.advance();
        return d.lastStringValue !== "";
      };
      function Bi(d) {
        return Ti(d) || d === 95;
      }
      mt.regexp_eatUnicodePropertyValue = function(d) {
        var N = 0;
        for (d.lastStringValue = ""; Ri(N = d.current()); )
          d.lastStringValue += yi(N), d.advance();
        return d.lastStringValue !== "";
      };
      function Ri(d) {
        return Bi(d) || $n(d);
      }
      mt.regexp_eatLoneUnicodePropertyNameOrValue = function(d) {
        return this.regexp_eatUnicodePropertyValue(d);
      }, mt.regexp_eatCharacterClass = function(d) {
        if (d.eat(
          91
          /* [ */
        )) {
          var N = d.eat(
            94
            /* ^ */
          ), re = this.regexp_classContents(d);
          return d.eat(
            93
            /* ] */
          ) || d.raise("Unterminated character class"), N && re === hi && d.raise("Negated character class may contain strings"), !0;
        }
        return !1;
      }, mt.regexp_classContents = function(d) {
        return d.current() === 93 ? ci : d.switchV ? this.regexp_classSetExpression(d) : (this.regexp_nonEmptyClassRanges(d), ci);
      }, mt.regexp_nonEmptyClassRanges = function(d) {
        for (; this.regexp_eatClassAtom(d); ) {
          var N = d.lastIntValue;
          if (d.eat(
            45
            /* - */
          ) && this.regexp_eatClassAtom(d)) {
            var re = d.lastIntValue;
            d.switchU && (N === -1 || re === -1) && d.raise("Invalid character class"), N !== -1 && re !== -1 && N > re && d.raise("Range out of order in character class");
          }
        }
      }, mt.regexp_eatClassAtom = function(d) {
        var N = d.pos;
        if (d.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatClassEscape(d))
            return !0;
          if (d.switchU) {
            var re = d.current();
            (re === 99 || vn(re)) && d.raise("Invalid class escape"), d.raise("Invalid escape");
          }
          d.pos = N;
        }
        var pe = d.current();
        return pe !== 93 ? (d.lastIntValue = pe, d.advance(), !0) : !1;
      }, mt.regexp_eatClassEscape = function(d) {
        var N = d.pos;
        if (d.eat(
          98
          /* b */
        ))
          return d.lastIntValue = 8, !0;
        if (d.switchU && d.eat(
          45
          /* - */
        ))
          return d.lastIntValue = 45, !0;
        if (!d.switchU && d.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatClassControlLetter(d))
            return !0;
          d.pos = N;
        }
        return this.regexp_eatCharacterClassEscape(d) || this.regexp_eatCharacterEscape(d);
      }, mt.regexp_classSetExpression = function(d) {
        var N = ci, re;
        if (!this.regexp_eatClassSetRange(d))
          if (re = this.regexp_eatClassSetOperand(d)) {
            re === hi && (N = hi);
            for (var pe = d.pos; d.eatChars(
              [38, 38]
              /* && */
            ); ) {
              if (d.current() !== 38 && (re = this.regexp_eatClassSetOperand(d))) {
                re !== hi && (N = ci);
                continue;
              }
              d.raise("Invalid character in character class");
            }
            if (pe !== d.pos)
              return N;
            for (; d.eatChars(
              [45, 45]
              /* -- */
            ); )
              this.regexp_eatClassSetOperand(d) || d.raise("Invalid character in character class");
            if (pe !== d.pos)
              return N;
          } else
            d.raise("Invalid character in character class");
        for (; ; )
          if (!this.regexp_eatClassSetRange(d)) {
            if (re = this.regexp_eatClassSetOperand(d), !re)
              return N;
            re === hi && (N = hi);
          }
      }, mt.regexp_eatClassSetRange = function(d) {
        var N = d.pos;
        if (this.regexp_eatClassSetCharacter(d)) {
          var re = d.lastIntValue;
          if (d.eat(
            45
            /* - */
          ) && this.regexp_eatClassSetCharacter(d)) {
            var pe = d.lastIntValue;
            return re !== -1 && pe !== -1 && re > pe && d.raise("Range out of order in character class"), !0;
          }
          d.pos = N;
        }
        return !1;
      }, mt.regexp_eatClassSetOperand = function(d) {
        return this.regexp_eatClassSetCharacter(d) ? ci : this.regexp_eatClassStringDisjunction(d) || this.regexp_eatNestedClass(d);
      }, mt.regexp_eatNestedClass = function(d) {
        var N = d.pos;
        if (d.eat(
          91
          /* [ */
        )) {
          var re = d.eat(
            94
            /* ^ */
          ), pe = this.regexp_classContents(d);
          if (d.eat(
            93
            /* ] */
          ))
            return re && pe === hi && d.raise("Negated character class may contain strings"), pe;
          d.pos = N;
        }
        if (d.eat(
          92
          /* \ */
        )) {
          var Le = this.regexp_eatCharacterClassEscape(d);
          if (Le)
            return Le;
          d.pos = N;
        }
        return null;
      }, mt.regexp_eatClassStringDisjunction = function(d) {
        var N = d.pos;
        if (d.eatChars(
          [92, 113]
          /* \q */
        )) {
          if (d.eat(
            123
            /* { */
          )) {
            var re = this.regexp_classStringDisjunctionContents(d);
            if (d.eat(
              125
              /* } */
            ))
              return re;
          } else
            d.raise("Invalid escape");
          d.pos = N;
        }
        return null;
      }, mt.regexp_classStringDisjunctionContents = function(d) {
        for (var N = this.regexp_classString(d); d.eat(
          124
          /* | */
        ); )
          this.regexp_classString(d) === hi && (N = hi);
        return N;
      }, mt.regexp_classString = function(d) {
        for (var N = 0; this.regexp_eatClassSetCharacter(d); )
          N++;
        return N === 1 ? ci : hi;
      }, mt.regexp_eatClassSetCharacter = function(d) {
        var N = d.pos;
        if (d.eat(
          92
          /* \ */
        ))
          return this.regexp_eatCharacterEscape(d) || this.regexp_eatClassSetReservedPunctuator(d) ? !0 : d.eat(
            98
            /* b */
          ) ? (d.lastIntValue = 8, !0) : (d.pos = N, !1);
        var re = d.current();
        return re < 0 || re === d.lookahead() && Wi(re) || Vi(re) ? !1 : (d.advance(), d.lastIntValue = re, !0);
      };
      function Wi(d) {
        return d === 33 || d >= 35 && d <= 38 || d >= 42 && d <= 44 || d === 46 || d >= 58 && d <= 64 || d === 94 || d === 96 || d === 126;
      }
      function Vi(d) {
        return d === 40 || d === 41 || d === 45 || d === 47 || d >= 91 && d <= 93 || d >= 123 && d <= 125;
      }
      mt.regexp_eatClassSetReservedPunctuator = function(d) {
        var N = d.current();
        return Fn(N) ? (d.lastIntValue = N, d.advance(), !0) : !1;
      };
      function Fn(d) {
        return d === 33 || d === 35 || d === 37 || d === 38 || d === 44 || d === 45 || d >= 58 && d <= 62 || d === 64 || d === 96 || d === 126;
      }
      mt.regexp_eatClassControlLetter = function(d) {
        var N = d.current();
        return $n(N) || N === 95 ? (d.lastIntValue = N % 32, d.advance(), !0) : !1;
      }, mt.regexp_eatHexEscapeSequence = function(d) {
        var N = d.pos;
        if (d.eat(
          120
          /* x */
        )) {
          if (this.regexp_eatFixedHexDigits(d, 2))
            return !0;
          d.switchU && d.raise("Invalid escape"), d.pos = N;
        }
        return !1;
      }, mt.regexp_eatDecimalDigits = function(d) {
        var N = d.pos, re = 0;
        for (d.lastIntValue = 0; $n(re = d.current()); )
          d.lastIntValue = 10 * d.lastIntValue + (re - 48), d.advance();
        return d.pos !== N;
      };
      function $n(d) {
        return d >= 48 && d <= 57;
      }
      mt.regexp_eatHexDigits = function(d) {
        var N = d.pos, re = 0;
        for (d.lastIntValue = 0; Cs(re = d.current()); )
          d.lastIntValue = 16 * d.lastIntValue + _s(re), d.advance();
        return d.pos !== N;
      };
      function Cs(d) {
        return d >= 48 && d <= 57 || d >= 65 && d <= 70 || d >= 97 && d <= 102;
      }
      function _s(d) {
        return d >= 65 && d <= 70 ? 10 + (d - 65) : d >= 97 && d <= 102 ? 10 + (d - 97) : d - 48;
      }
      mt.regexp_eatLegacyOctalEscapeSequence = function(d) {
        if (this.regexp_eatOctalDigit(d)) {
          var N = d.lastIntValue;
          if (this.regexp_eatOctalDigit(d)) {
            var re = d.lastIntValue;
            N <= 3 && this.regexp_eatOctalDigit(d) ? d.lastIntValue = N * 64 + re * 8 + d.lastIntValue : d.lastIntValue = N * 8 + re;
          } else
            d.lastIntValue = N;
          return !0;
        }
        return !1;
      }, mt.regexp_eatOctalDigit = function(d) {
        var N = d.current();
        return vn(N) ? (d.lastIntValue = N - 48, d.advance(), !0) : (d.lastIntValue = 0, !1);
      };
      function vn(d) {
        return d >= 48 && d <= 55;
      }
      mt.regexp_eatFixedHexDigits = function(d, N) {
        var re = d.pos;
        d.lastIntValue = 0;
        for (var pe = 0; pe < N; ++pe) {
          var Le = d.current();
          if (!Cs(Le))
            return d.pos = re, !1;
          d.lastIntValue = 16 * d.lastIntValue + _s(Le), d.advance();
        }
        return !0;
      };
      var Qn = function(N) {
        this.type = N.type, this.value = N.value, this.start = N.start, this.end = N.end, N.options.locations && (this.loc = new Ki(N, N.startLoc, N.endLoc)), N.options.ranges && (this.range = [N.start, N.end]);
      }, Yt = i.prototype;
      Yt.next = function(d) {
        !d && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new Qn(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
      }, Yt.getToken = function() {
        return this.next(), new Qn(this);
      }, typeof Symbol < "u" && (Yt[Symbol.iterator] = function() {
        var d = this;
        return {
          next: function() {
            var N = d.getToken();
            return {
              done: N.type === K.eof,
              value: N
            };
          }
        };
      }), Yt.nextToken = function() {
        var d = this.curContext();
        if ((!d || !d.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
          return this.finishToken(K.eof);
        if (d.override)
          return d.override(this);
        this.readToken(this.fullCharCodeAtPos());
      }, Yt.readToken = function(d) {
        return he(d, this.options.ecmaVersion >= 6) || d === 92 ? this.readWord() : this.getTokenFromCode(d);
      }, Yt.fullCharCodeAtPos = function() {
        var d = this.input.charCodeAt(this.pos);
        if (d <= 55295 || d >= 56320)
          return d;
        var N = this.input.charCodeAt(this.pos + 1);
        return N <= 56319 || N >= 57344 ? d : (d << 10) + N - 56613888;
      }, Yt.skipBlockComment = function() {
        var d = this.options.onComment && this.curPosition(), N = this.pos, re = this.input.indexOf("*/", this.pos += 2);
        if (re === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = re + 2, this.options.locations)
          for (var pe = void 0, Le = N; (pe = pt(this.input, Le, this.pos)) > -1; )
            ++this.curLine, Le = this.lineStart = pe;
        this.options.onComment && this.options.onComment(
          !0,
          this.input.slice(N + 2, re),
          N,
          this.pos,
          d,
          this.curPosition()
        );
      }, Yt.skipLineComment = function(d) {
        for (var N = this.pos, re = this.options.onComment && this.curPosition(), pe = this.input.charCodeAt(this.pos += d); this.pos < this.input.length && !Ze(pe); )
          pe = this.input.charCodeAt(++this.pos);
        this.options.onComment && this.options.onComment(
          !1,
          this.input.slice(N + d, this.pos),
          N,
          this.pos,
          re,
          this.curPosition()
        );
      }, Yt.skipSpace = function() {
        e:
          for (; this.pos < this.input.length; ) {
            var d = this.input.charCodeAt(this.pos);
            switch (d) {
              case 32:
              case 160:
                ++this.pos;
                break;
              case 13:
                this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
              case 10:
              case 8232:
              case 8233:
                ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
                break;
              case 47:
                switch (this.input.charCodeAt(this.pos + 1)) {
                  case 42:
                    this.skipBlockComment();
                    break;
                  case 47:
                    this.skipLineComment(2);
                    break;
                  default:
                    break e;
                }
                break;
              default:
                if (d > 8 && d < 14 || d >= 5760 && Pt.test(String.fromCharCode(d)))
                  ++this.pos;
                else
                  break e;
            }
          }
      }, Yt.finishToken = function(d, N) {
        this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
        var re = this.type;
        this.type = d, this.value = N, this.updateContext(re);
      }, Yt.readToken_dot = function() {
        var d = this.input.charCodeAt(this.pos + 1);
        if (d >= 48 && d <= 57)
          return this.readNumber(!0);
        var N = this.input.charCodeAt(this.pos + 2);
        return this.options.ecmaVersion >= 6 && d === 46 && N === 46 ? (this.pos += 3, this.finishToken(K.ellipsis)) : (++this.pos, this.finishToken(K.dot));
      }, Yt.readToken_slash = function() {
        var d = this.input.charCodeAt(this.pos + 1);
        return this.exprAllowed ? (++this.pos, this.readRegexp()) : d === 61 ? this.finishOp(K.assign, 2) : this.finishOp(K.slash, 1);
      }, Yt.readToken_mult_modulo_exp = function(d) {
        var N = this.input.charCodeAt(this.pos + 1), re = 1, pe = d === 42 ? K.star : K.modulo;
        return this.options.ecmaVersion >= 7 && d === 42 && N === 42 && (++re, pe = K.starstar, N = this.input.charCodeAt(this.pos + 2)), N === 61 ? this.finishOp(K.assign, re + 1) : this.finishOp(pe, re);
      }, Yt.readToken_pipe_amp = function(d) {
        var N = this.input.charCodeAt(this.pos + 1);
        if (N === d) {
          if (this.options.ecmaVersion >= 12) {
            var re = this.input.charCodeAt(this.pos + 2);
            if (re === 61)
              return this.finishOp(K.assign, 3);
          }
          return this.finishOp(d === 124 ? K.logicalOR : K.logicalAND, 2);
        }
        return N === 61 ? this.finishOp(K.assign, 2) : this.finishOp(d === 124 ? K.bitwiseOR : K.bitwiseAND, 1);
      }, Yt.readToken_caret = function() {
        var d = this.input.charCodeAt(this.pos + 1);
        return d === 61 ? this.finishOp(K.assign, 2) : this.finishOp(K.bitwiseXOR, 1);
      }, Yt.readToken_plus_min = function(d) {
        var N = this.input.charCodeAt(this.pos + 1);
        return N === d ? N === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || j.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(K.incDec, 2) : N === 61 ? this.finishOp(K.assign, 2) : this.finishOp(K.plusMin, 1);
      }, Yt.readToken_lt_gt = function(d) {
        var N = this.input.charCodeAt(this.pos + 1), re = 1;
        return N === d ? (re = d === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + re) === 61 ? this.finishOp(K.assign, re + 1) : this.finishOp(K.bitShift, re)) : N === 33 && d === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (N === 61 && (re = 2), this.finishOp(K.relational, re));
      }, Yt.readToken_eq_excl = function(d) {
        var N = this.input.charCodeAt(this.pos + 1);
        return N === 61 ? this.finishOp(K.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : d === 61 && N === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(K.arrow)) : this.finishOp(d === 61 ? K.eq : K.prefix, 1);
      }, Yt.readToken_question = function() {
        var d = this.options.ecmaVersion;
        if (d >= 11) {
          var N = this.input.charCodeAt(this.pos + 1);
          if (N === 46) {
            var re = this.input.charCodeAt(this.pos + 2);
            if (re < 48 || re > 57)
              return this.finishOp(K.questionDot, 2);
          }
          if (N === 63) {
            if (d >= 12) {
              var pe = this.input.charCodeAt(this.pos + 2);
              if (pe === 61)
                return this.finishOp(K.assign, 3);
            }
            return this.finishOp(K.coalesce, 2);
          }
        }
        return this.finishOp(K.question, 1);
      }, Yt.readToken_numberSign = function() {
        var d = this.options.ecmaVersion, N = 35;
        if (d >= 13 && (++this.pos, N = this.fullCharCodeAtPos(), he(N, !0) || N === 92))
          return this.finishToken(K.privateId, this.readWord1());
        this.raise(this.pos, "Unexpected character '" + yi(N) + "'");
      }, Yt.getTokenFromCode = function(d) {
        switch (d) {
          case 46:
            return this.readToken_dot();
          case 40:
            return ++this.pos, this.finishToken(K.parenL);
          case 41:
            return ++this.pos, this.finishToken(K.parenR);
          case 59:
            return ++this.pos, this.finishToken(K.semi);
          case 44:
            return ++this.pos, this.finishToken(K.comma);
          case 91:
            return ++this.pos, this.finishToken(K.bracketL);
          case 93:
            return ++this.pos, this.finishToken(K.bracketR);
          case 123:
            return ++this.pos, this.finishToken(K.braceL);
          case 125:
            return ++this.pos, this.finishToken(K.braceR);
          case 58:
            return ++this.pos, this.finishToken(K.colon);
          case 96:
            if (this.options.ecmaVersion < 6)
              break;
            return ++this.pos, this.finishToken(K.backQuote);
          case 48:
            var N = this.input.charCodeAt(this.pos + 1);
            if (N === 120 || N === 88)
              return this.readRadixNumber(16);
            if (this.options.ecmaVersion >= 6) {
              if (N === 111 || N === 79)
                return this.readRadixNumber(8);
              if (N === 98 || N === 66)
                return this.readRadixNumber(2);
            }
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return this.readNumber(!1);
          case 34:
          case 39:
            return this.readString(d);
          case 47:
            return this.readToken_slash();
          case 37:
          case 42:
            return this.readToken_mult_modulo_exp(d);
          case 124:
          case 38:
            return this.readToken_pipe_amp(d);
          case 94:
            return this.readToken_caret();
          case 43:
          case 45:
            return this.readToken_plus_min(d);
          case 60:
          case 62:
            return this.readToken_lt_gt(d);
          case 61:
          case 33:
            return this.readToken_eq_excl(d);
          case 63:
            return this.readToken_question();
          case 126:
            return this.finishOp(K.prefix, 1);
          case 35:
            return this.readToken_numberSign();
        }
        this.raise(this.pos, "Unexpected character '" + yi(d) + "'");
      }, Yt.finishOp = function(d, N) {
        var re = this.input.slice(this.pos, this.pos + N);
        return this.pos += N, this.finishToken(d, re);
      }, Yt.readRegexp = function() {
        for (var d, N, re = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(re, "Unterminated regular expression");
          var pe = this.input.charAt(this.pos);
          if (j.test(pe) && this.raise(re, "Unterminated regular expression"), d)
            d = !1;
          else {
            if (pe === "[")
              N = !0;
            else if (pe === "]" && N)
              N = !1;
            else if (pe === "/" && !N)
              break;
            d = pe === "\\";
          }
          ++this.pos;
        }
        var Le = this.input.slice(re, this.pos);
        ++this.pos;
        var je = this.pos, Qe = this.readWord1();
        this.containsEsc && this.unexpected(je);
        var vt = this.regexpState || (this.regexpState = new Zt(this));
        vt.reset(re, Le, Qe), this.validateRegExpFlags(vt), this.validateRegExpPattern(vt);
        var Lt = null;
        try {
          Lt = new RegExp(Le, Qe);
        } catch {
        }
        return this.finishToken(K.regexp, { pattern: Le, flags: Qe, value: Lt });
      }, Yt.readInt = function(d, N, re) {
        for (var pe = this.options.ecmaVersion >= 12 && N === void 0, Le = re && this.input.charCodeAt(this.pos) === 48, je = this.pos, Qe = 0, vt = 0, Lt = 0, $t = N ?? 1 / 0; Lt < $t; ++Lt, ++this.pos) {
          var ii = this.input.charCodeAt(this.pos), Gi = void 0;
          if (pe && ii === 95) {
            Le && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), vt === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), Lt === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), vt = ii;
            continue;
          }
          if (ii >= 97 ? Gi = ii - 97 + 10 : ii >= 65 ? Gi = ii - 65 + 10 : ii >= 48 && ii <= 57 ? Gi = ii - 48 : Gi = 1 / 0, Gi >= d)
            break;
          vt = ii, Qe = Qe * d + Gi;
        }
        return pe && vt === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === je || N != null && this.pos - je !== N ? null : Qe;
      };
      function os(d, N) {
        return N ? parseInt(d, 8) : parseFloat(d.replace(/_/g, ""));
      }
      function Mn(d) {
        return typeof BigInt != "function" ? null : BigInt(d.replace(/_/g, ""));
      }
      Yt.readRadixNumber = function(d) {
        var N = this.pos;
        this.pos += 2;
        var re = this.readInt(d);
        return re == null && this.raise(this.start + 2, "Expected number in radix " + d), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (re = Mn(this.input.slice(N, this.pos)), ++this.pos) : he(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(K.num, re);
      }, Yt.readNumber = function(d) {
        var N = this.pos;
        !d && this.readInt(10, void 0, !0) === null && this.raise(N, "Invalid number");
        var re = this.pos - N >= 2 && this.input.charCodeAt(N) === 48;
        re && this.strict && this.raise(N, "Invalid number");
        var pe = this.input.charCodeAt(this.pos);
        if (!re && !d && this.options.ecmaVersion >= 11 && pe === 110) {
          var Le = Mn(this.input.slice(N, this.pos));
          return ++this.pos, he(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(K.num, Le);
        }
        re && /[89]/.test(this.input.slice(N, this.pos)) && (re = !1), pe === 46 && !re && (++this.pos, this.readInt(10), pe = this.input.charCodeAt(this.pos)), (pe === 69 || pe === 101) && !re && (pe = this.input.charCodeAt(++this.pos), (pe === 43 || pe === 45) && ++this.pos, this.readInt(10) === null && this.raise(N, "Invalid number")), he(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
        var je = os(this.input.slice(N, this.pos), re);
        return this.finishToken(K.num, je);
      }, Yt.readCodePoint = function() {
        var d = this.input.charCodeAt(this.pos), N;
        if (d === 123) {
          this.options.ecmaVersion < 6 && this.unexpected();
          var re = ++this.pos;
          N = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, N > 1114111 && this.invalidStringToken(re, "Code point out of bounds");
        } else
          N = this.readHexChar(4);
        return N;
      }, Yt.readString = function(d) {
        for (var N = "", re = ++this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
          var pe = this.input.charCodeAt(this.pos);
          if (pe === d)
            break;
          pe === 92 ? (N += this.input.slice(re, this.pos), N += this.readEscapedChar(!1), re = this.pos) : pe === 8232 || pe === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (Ze(pe) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
        }
        return N += this.input.slice(re, this.pos++), this.finishToken(K.string, N);
      };
      var un = {};
      Yt.tryReadTemplateToken = function() {
        this.inTemplateElement = !0;
        try {
          this.readTmplToken();
        } catch (d) {
          if (d === un)
            this.readInvalidTemplateToken();
          else
            throw d;
        }
        this.inTemplateElement = !1;
      }, Yt.invalidStringToken = function(d, N) {
        if (this.inTemplateElement && this.options.ecmaVersion >= 9)
          throw un;
        this.raise(d, N);
      }, Yt.readTmplToken = function() {
        for (var d = "", N = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
          var re = this.input.charCodeAt(this.pos);
          if (re === 96 || re === 36 && this.input.charCodeAt(this.pos + 1) === 123)
            return this.pos === this.start && (this.type === K.template || this.type === K.invalidTemplate) ? re === 36 ? (this.pos += 2, this.finishToken(K.dollarBraceL)) : (++this.pos, this.finishToken(K.backQuote)) : (d += this.input.slice(N, this.pos), this.finishToken(K.template, d));
          if (re === 92)
            d += this.input.slice(N, this.pos), d += this.readEscapedChar(!0), N = this.pos;
          else if (Ze(re)) {
            switch (d += this.input.slice(N, this.pos), ++this.pos, re) {
              case 13:
                this.input.charCodeAt(this.pos) === 10 && ++this.pos;
              case 10:
                d += `
`;
                break;
              default:
                d += String.fromCharCode(re);
                break;
            }
            this.options.locations && (++this.curLine, this.lineStart = this.pos), N = this.pos;
          } else
            ++this.pos;
        }
      }, Yt.readInvalidTemplateToken = function() {
        for (; this.pos < this.input.length; this.pos++)
          switch (this.input[this.pos]) {
            case "\\":
              ++this.pos;
              break;
            case "$":
              if (this.input[this.pos + 1] !== "{")
                break;
            case "`":
              return this.finishToken(K.invalidTemplate, this.input.slice(this.start, this.pos));
          }
        this.raise(this.start, "Unterminated template");
      }, Yt.readEscapedChar = function(d) {
        var N = this.input.charCodeAt(++this.pos);
        switch (++this.pos, N) {
          case 110:
            return `
`;
          case 114:
            return "\r";
          case 120:
            return String.fromCharCode(this.readHexChar(2));
          case 117:
            return yi(this.readCodePoint());
          case 116:
            return "	";
          case 98:
            return "\b";
          case 118:
            return "\v";
          case 102:
            return "\f";
          case 13:
            this.input.charCodeAt(this.pos) === 10 && ++this.pos;
          case 10:
            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
          case 56:
          case 57:
            if (this.strict && this.invalidStringToken(
              this.pos - 1,
              "Invalid escape sequence"
            ), d) {
              var re = this.pos - 1;
              this.invalidStringToken(
                re,
                "Invalid escape sequence in template string"
              );
            }
          default:
            if (N >= 48 && N <= 55) {
              var pe = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], Le = parseInt(pe, 8);
              return Le > 255 && (pe = pe.slice(0, -1), Le = parseInt(pe, 8)), this.pos += pe.length - 1, N = this.input.charCodeAt(this.pos), (pe !== "0" || N === 56 || N === 57) && (this.strict || d) && this.invalidStringToken(
                this.pos - 1 - pe.length,
                d ? "Octal literal in template string" : "Octal literal in strict mode"
              ), String.fromCharCode(Le);
            }
            return Ze(N) ? "" : String.fromCharCode(N);
        }
      }, Yt.readHexChar = function(d) {
        var N = this.pos, re = this.readInt(16, d);
        return re === null && this.invalidStringToken(N, "Bad character escape sequence"), re;
      }, Yt.readWord1 = function() {
        this.containsEsc = !1;
        for (var d = "", N = !0, re = this.pos, pe = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
          var Le = this.fullCharCodeAtPos();
          if (ne(Le, pe))
            this.pos += Le <= 65535 ? 1 : 2;
          else if (Le === 92) {
            this.containsEsc = !0, d += this.input.slice(re, this.pos);
            var je = this.pos;
            this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
            var Qe = this.readCodePoint();
            (N ? he : ne)(Qe, pe) || this.invalidStringToken(je, "Invalid Unicode escape"), d += yi(Qe), re = this.pos;
          } else
            break;
          N = !1;
        }
        return d + this.input.slice(re, this.pos);
      }, Yt.readWord = function() {
        var d = this.readWord1(), N = K.name;
        return this.keywords.test(d) && (N = xe[d]), this.finishToken(N, d);
      };
      var Ji = "8.11.3";
      i.acorn = {
        Parser: i,
        version: Ji,
        defaultOptions: qt,
        Position: Tn,
        SourceLocation: Ki,
        getLineInfo: as,
        Node: W,
        TokenType: ye,
        tokTypes: K,
        keywordTypes: xe,
        TokContext: E,
        tokContexts: D,
        isIdentifierChar: ne,
        isIdentifierStart: he,
        Token: Qn,
        isNewLine: Ze,
        lineBreak: j,
        lineBreakG: ht,
        nonASCIIwhitespace: Pt
      };
      function cn(d, N) {
        return i.parse(d, N);
      }
      function qi(d, N, re) {
        return i.parseExpressionAt(d, N, re);
      }
      function Di(d, N) {
        return i.tokenizer(d, N);
      }
      t.Node = W, t.Parser = i, t.Position = Tn, t.SourceLocation = Ki, t.TokContext = E, t.Token = Qn, t.TokenType = ye, t.defaultOptions = qt, t.getLineInfo = as, t.isIdentifierChar = ne, t.isIdentifierStart = he, t.isNewLine = Ze, t.keywordTypes = xe, t.lineBreak = j, t.lineBreakG = ht, t.nonASCIIwhitespace = Pt, t.parse = cn, t.parseExpressionAt = qi, t.tokContexts = D, t.tokTypes = K, t.tokenizer = Di, t.version = Ji;
    });
  }($o, $o.exports)), $o.exports;
}
/*!
 * Paper.js v0.12.17 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Thu Nov 3 21:15:36 2022 +0100
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
(function(v) {
  (function(e, t) {
    e = e || Of;
    var s = e.window, o = e.document, a = new function() {
      var i = /^(statics|enumerable|beans|preserve)$/, n = [], r = n.slice, l = Object.create, h = Object.getOwnPropertyDescriptor, f = Object.defineProperty, m = n.forEach || function(C, M) {
        for (var R = 0, E = this.length; R < E; R++)
          C.call(M, this[R], R, this);
      }, _ = function(C, M) {
        for (var R in this)
          this.hasOwnProperty(R) && C.call(M, this[R], R, this);
      }, y = Object.assign || function(C) {
        for (var M = 1, R = arguments.length; M < R; M++) {
          var E = arguments[M];
          for (var D in E)
            E.hasOwnProperty(D) && (C[D] = E[D]);
        }
        return C;
      }, x = function(C, M, R) {
        if (C) {
          var E = h(C, "length");
          (E && typeof E.value == "number" ? m : _).call(C, M, R = R || C);
        }
        return R;
      };
      function A(C, M, R, E, D) {
        var L = {};
        function P(F, W) {
          W = W || (W = h(M, F)) && (W.get ? W : W.value), typeof W == "string" && W[0] === "#" && (W = C[W.substring(1)] || W);
          var Q = typeof W == "function", ie = W, ae = D || Q && !W.base ? W && W.get ? F in C : C[F] : null, J;
          (!D || !ae) && (Q && ae && (W.base = ae), Q && E !== !1 && (J = F.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (L[J[3].toLowerCase() + J[4]] = J[2]), (!ie || Q || !ie.get || typeof ie.get != "function" || !B.isPlainObject(ie)) && (ie = { value: ie, writable: !0 }), (h(C, F) || { configurable: !0 }).configurable && (ie.configurable = !0, ie.enumerable = R ?? !J), f(C, F, ie));
        }
        if (M) {
          for (var S in M)
            M.hasOwnProperty(S) && !i.test(S) && P(S);
          for (var S in L) {
            var I = L[S], U = C["set" + I], V = C["get" + I] || U && C["is" + I];
            V && (E === !0 || V.length === 0) && P(S, { get: V, set: U });
          }
        }
        return C;
      }
      function B() {
        for (var C = 0, M = arguments.length; C < M; C++) {
          var R = arguments[C];
          R && y(this, R);
        }
        return this;
      }
      return A(B, {
        inject: function(C) {
          if (C) {
            var M = C.statics === !0 ? C : C.statics, R = C.beans, E = C.preserve;
            M !== C && A(this.prototype, C, C.enumerable, R, E), A(this, M, null, R, E);
          }
          for (var D = 1, L = arguments.length; D < L; D++)
            this.inject(arguments[D]);
          return this;
        },
        extend: function() {
          for (var C = this, M, R, E = 0, D, L = arguments.length; E < L && !(M && R); E++)
            D = arguments[E], M = M || D.initialize, R = R || D.prototype;
          return M = M || function() {
            C.apply(this, arguments);
          }, R = M.prototype = R || l(this.prototype), f(
            R,
            "constructor",
            { value: M, writable: !0, configurable: !0 }
          ), A(M, this), arguments.length && this.inject.apply(M, arguments), M.base = C, M;
        }
      }).inject({
        enumerable: !1,
        initialize: B,
        set: B,
        inject: function() {
          for (var C = 0, M = arguments.length; C < M; C++) {
            var R = arguments[C];
            R && A(this, R, R.enumerable, R.beans, R.preserve);
          }
          return this;
        },
        extend: function() {
          var C = l(this);
          return C.inject.apply(C, arguments);
        },
        each: function(C, M) {
          return x(this, C, M);
        },
        clone: function() {
          return new this.constructor(this);
        },
        statics: {
          set: y,
          each: x,
          create: l,
          define: f,
          describe: h,
          clone: function(C) {
            return y(new C.constructor(), C);
          },
          isPlainObject: function(C) {
            var M = C != null && C.constructor;
            return M && (M === Object || M === B || M.name === "Object");
          },
          pick: function(C, M) {
            return C !== t ? C : M;
          },
          slice: function(C, M, R) {
            return r.call(C, M, R);
          }
        }
      });
    }();
    v.exports = a, a.inject({
      enumerable: !1,
      toString: function() {
        return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + a.each(this, function(i, n) {
          if (!/^_/.test(n)) {
            var r = typeof i;
            this.push(n + ": " + (r === "number" ? H.instance.number(i) : r === "string" ? "'" + i + "'" : i));
          }
        }, []).join(", ") + " }";
      },
      getClassName: function() {
        return this._class || "";
      },
      importJSON: function(i) {
        return a.importJSON(i, this);
      },
      exportJSON: function(i) {
        return a.exportJSON(this, i);
      },
      toJSON: function() {
        return a.serialize(this);
      },
      set: function(i, n) {
        return i && a.filter(this, i, n, this._prioritize), this;
      }
    }, {
      beans: !1,
      statics: {
        exports: {},
        extend: function i() {
          var n = i.base.apply(this, arguments), r = n.prototype._class;
          return r && !a.exports[r] && (a.exports[r] = n), n;
        },
        equals: function(i, n) {
          if (i === n)
            return !0;
          if (i && i.equals)
            return i.equals(n);
          if (n && n.equals)
            return n.equals(i);
          if (i && n && typeof i == "object" && typeof n == "object") {
            if (Array.isArray(i) && Array.isArray(n)) {
              var r = i.length;
              if (r !== n.length)
                return !1;
              for (; r--; )
                if (!a.equals(i[r], n[r]))
                  return !1;
            } else {
              var l = Object.keys(i), r = l.length;
              if (r !== Object.keys(n).length)
                return !1;
              for (; r--; ) {
                var h = l[r];
                if (!(n.hasOwnProperty(h) && a.equals(i[h], n[h])))
                  return !1;
              }
            }
            return !0;
          }
          return !1;
        },
        read: function(i, n, r, l) {
          if (this === a) {
            var h = this.peek(i, n);
            return i.__index++, h;
          }
          var f = this.prototype, m = f._readIndex, _ = n || m && i.__index || 0, y = i.length, x = i[_];
          if (l = l || y - _, x instanceof this || r && r.readNull && x == null && l <= 1)
            return m && (i.__index = _ + 1), x && r && r.clone ? x.clone() : x;
          if (x = a.create(f), m && (x.__read = !0), x = x.initialize.apply(x, _ > 0 || _ + l < y ? a.slice(i, _, _ + l) : i) || x, m) {
            i.__index = _ + x.__read;
            var A = x.__filtered;
            A && (i.__filtered = A, x.__filtered = t), x.__read = t;
          }
          return x;
        },
        peek: function(i, n) {
          return i[i.__index = n || i.__index || 0];
        },
        remain: function(i) {
          return i.length - (i.__index || 0);
        },
        readList: function(i, n, r, l) {
          for (var h = [], f, m = n || 0, _ = l ? m + l : i.length, y = m; y < _; y++)
            h.push(Array.isArray(f = i[y]) ? this.read(f, 0, r) : this.read(i, y, r, 1));
          return h;
        },
        readNamed: function(i, n, r, l, h) {
          var f = this.getNamed(i, n), m = f !== t;
          if (m) {
            var _ = i.__filtered;
            if (!_) {
              var y = this.getSource(i);
              _ = i.__filtered = a.create(y), _.__unfiltered = y;
            }
            _[n] = t;
          }
          return this.read(m ? [f] : i, r, l, h);
        },
        readSupported: function(i, n) {
          var r = this.getSource(i), l = this, h = !1;
          return r && Object.keys(r).forEach(function(f) {
            if (f in n) {
              var m = l.readNamed(i, f);
              m !== t && (n[f] = m), h = !0;
            }
          }), h;
        },
        getSource: function(i) {
          var n = i.__source;
          if (n === t) {
            var r = i.length === 1 && i[0];
            n = i.__source = r && a.isPlainObject(r) ? r : null;
          }
          return n;
        },
        getNamed: function(i, n) {
          var r = this.getSource(i);
          if (r)
            return n ? r[n] : i.__filtered || r;
        },
        hasNamed: function(i, n) {
          return !!this.getNamed(i, n);
        },
        filter: function(i, n, r, l) {
          var h;
          function f(A) {
            if (!(r && A in r) && !(h && A in h)) {
              var B = n[A];
              B !== t && (i[A] = B);
            }
          }
          if (l) {
            for (var m = {}, _ = 0, y, x = l.length; _ < x; _++)
              (y = l[_]) in n && (f(y), m[y] = !0);
            h = m;
          }
          return Object.keys(n.__unfiltered || n).forEach(f), i;
        },
        isPlainValue: function(i, n) {
          return a.isPlainObject(i) || Array.isArray(i) || n && typeof i == "string";
        },
        serialize: function(i, n, r, l) {
          n = n || {};
          var h = !l, f;
          if (h && (n.formatter = new H(n.precision), l = {
            length: 0,
            definitions: {},
            references: {},
            add: function(B, C) {
              var M = "#" + B._id, R = this.references[M];
              if (!R) {
                this.length++;
                var E = C.call(B), D = B._class;
                D && E[0] !== D && E.unshift(D), this.definitions[M] = E, R = this.references[M] = [M];
              }
              return R;
            }
          }), i && i._serialize) {
            f = i._serialize(n, l);
            var m = i._class;
            m && !i._compactSerialize && (h || !r) && f[0] !== m && f.unshift(m);
          } else if (Array.isArray(i)) {
            f = [];
            for (var _ = 0, y = i.length; _ < y; _++)
              f[_] = a.serialize(i[_], n, r, l);
          } else if (a.isPlainObject(i)) {
            f = {};
            for (var x = Object.keys(i), _ = 0, y = x.length; _ < y; _++) {
              var A = x[_];
              f[A] = a.serialize(
                i[A],
                n,
                r,
                l
              );
            }
          } else
            typeof i == "number" ? f = n.formatter.number(i, n.precision) : f = i;
          return h && l.length > 0 ? [["dictionary", l.definitions], f] : f;
        },
        deserialize: function(i, n, r, l, h) {
          var f = i, m = !r, _ = m && i && i.length && i[0][0] === "dictionary";
          if (r = r || {}, Array.isArray(i)) {
            var y = i[0], x = y === "dictionary";
            if (i.length == 1 && /^#/.test(y))
              return r.dictionary[y];
            y = a.exports[y], f = [];
            for (var A = y ? 1 : 0, B = i.length; A < B; A++)
              f.push(a.deserialize(
                i[A],
                n,
                r,
                x,
                _
              ));
            if (y) {
              var C = f;
              n ? f = n(y, C, m || h) : f = new y(C);
            }
          } else if (a.isPlainObject(i)) {
            f = {}, l && (r.dictionary = f);
            for (var M in i)
              f[M] = a.deserialize(i[M], n, r);
          }
          return _ ? f[1] : f;
        },
        exportJSON: function(i, n) {
          var r = a.serialize(i, n);
          return n && n.asString == !1 ? r : JSON.stringify(r);
        },
        importJSON: function(i, n) {
          return a.deserialize(
            typeof i == "string" ? JSON.parse(i) : i,
            function(r, l, h) {
              var f = h && n && n.constructor === r, m = f ? n : a.create(r.prototype);
              if (l.length === 1 && m instanceof K && (f || !(m instanceof ht))) {
                var _ = l[0];
                a.isPlainObject(_) && (_.insert = !1, f && (l = l.concat([K.INSERT])));
              }
              return (f ? m.set : r).apply(m, l), f && (n = null), m;
            }
          );
        },
        push: function(i, n) {
          var r = n.length;
          if (r < 4096)
            i.push.apply(i, n);
          else {
            var l = i.length;
            i.length += r;
            for (var h = 0; h < r; h++)
              i[l + h] = n[h];
          }
          return i;
        },
        splice: function(i, n, r, l) {
          var h = n && n.length, f = r === t;
          r = f ? i.length : r, r > i.length && (r = i.length);
          for (var m = 0; m < h; m++)
            n[m]._index = r + m;
          if (f)
            return a.push(i, n), [];
          var _ = [r, l];
          n && a.push(_, n);
          for (var y = i.splice.apply(i, _), m = 0, x = y.length; m < x; m++)
            y[m]._index = t;
          for (var m = r + h, x = i.length; m < x; m++)
            i[m]._index = m;
          return y;
        },
        capitalize: function(i) {
          return i.replace(/\b[a-z]/g, function(n) {
            return n.toUpperCase();
          });
        },
        camelize: function(i) {
          return i.replace(/-(.)/g, function(n, r) {
            return r.toUpperCase();
          });
        },
        hyphenate: function(i) {
          return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }
      }
    });
    var c = {
      on: function(i, n) {
        if (typeof i != "string")
          a.each(i, function(f, m) {
            this.on(m, f);
          }, this);
        else {
          var r = this._eventTypes, l = r && r[i], h = this._callbacks = this._callbacks || {};
          h = h[i] = h[i] || [], h.indexOf(n) === -1 && (h.push(n), l && l.install && h.length === 1 && l.install.call(this, i));
        }
        return this;
      },
      off: function(i, n) {
        if (typeof i != "string") {
          a.each(i, function(m, _) {
            this.off(_, m);
          }, this);
          return;
        }
        var r = this._eventTypes, l = r && r[i], h = this._callbacks && this._callbacks[i], f;
        return h && (!n || (f = h.indexOf(n)) !== -1 && h.length === 1 ? (l && l.uninstall && l.uninstall.call(this, i), delete this._callbacks[i]) : f !== -1 && h.splice(f, 1)), this;
      },
      once: function(i, n) {
        return this.on(i, function r() {
          n.apply(this, arguments), this.off(i, r);
        });
      },
      emit: function(i, n) {
        var r = this._callbacks && this._callbacks[i];
        if (!r)
          return !1;
        var l = a.slice(arguments, 1), h = n && n.target && !n.currentTarget;
        r = r.slice(), h && (n.currentTarget = this);
        for (var f = 0, m = r.length; f < m; f++)
          if (r[f].apply(this, l) == !1) {
            n && n.stop && n.stop();
            break;
          }
        return h && delete n.currentTarget, !0;
      },
      responds: function(i) {
        return !!(this._callbacks && this._callbacks[i]);
      },
      attach: "#on",
      detach: "#off",
      fire: "#emit",
      _installEvents: function(i) {
        var n = this._eventTypes, r = this._callbacks, l = i ? "install" : "uninstall";
        if (n) {
          for (var h in r)
            if (r[h].length > 0) {
              var f = n[h], m = f && f[l];
              m && m.call(this, h);
            }
        }
      },
      statics: {
        inject: function i(n) {
          var r = n._events;
          if (r) {
            var l = {};
            a.each(r, function(h, f) {
              var m = typeof h == "string", _ = m ? h : f, y = a.capitalize(_), x = _.substring(2).toLowerCase();
              l[x] = m ? {} : h, _ = "_" + _, n["get" + y] = function() {
                return this[_];
              }, n["set" + y] = function(A) {
                var B = this[_];
                B && this.off(x, B), A && this.on(x, A), this[_] = A;
              };
            }), n._eventTypes = l;
          }
          return i.base.apply(this, arguments);
        }
      }
    }, g = a.extend({
      _class: "PaperScope",
      initialize: function i() {
        nt = this, this.settings = new a({
          applyMatrix: !0,
          insertItems: !0,
          handleSize: 4,
          hitTolerance: 0
        }), this.project = null, this.projects = [], this.tools = [], this._id = i._id++, i._scopes[this._id] = this;
        var n = i.prototype;
        if (!this.support) {
          var r = Ut.getContext(1, 1) || {};
          n.support = {
            nativeDash: "setLineDash" in r || "mozDash" in r,
            nativeBlendModes: ki.nativeModes
          }, Ut.release(r);
        }
        if (!this.agent) {
          var l = e.navigator.userAgent.toLowerCase(), h = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(l) || [])[0], f = h === "darwin" ? "mac" : h, m = n.agent = n.browser = { platform: f };
          f && (m[f] = !0), l.replace(
            /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
            function(_, y, x, A, B) {
              if (!m.chrome) {
                var C = y === "opera" ? A : /^(node|trident)$/.test(y) ? B : x;
                m.version = C, m.versionNumber = parseFloat(C), y = { trident: "msie", jsdom: "node" }[y] || y, m.name = y, m[y] = !0;
              }
            }
          ), m.chrome && delete m.webkit, m.atom && delete m.chrome;
        }
      },
      version: "0.12.17",
      getView: function() {
        var i = this.project;
        return i && i._view;
      },
      getPaper: function() {
        return this;
      },
      execute: function(i, n) {
        var r = nt.PaperScript.execute(i, this, n);
        return Ht.updateFocus(), r;
      },
      install: function(i) {
        var n = this;
        a.each(["project", "view", "tool"], function(l) {
          a.define(i, l, {
            configurable: !0,
            get: function() {
              return n[l];
            }
          });
        });
        for (var r in this)
          !/^_/.test(r) && this[r] && (i[r] = this[r]);
      },
      setup: function(i) {
        return nt = this, this.project = new Ee(i), this;
      },
      createCanvas: function(i, n) {
        return Ut.getCanvas(i, n);
      },
      activate: function() {
        nt = this;
      },
      clear: function() {
        for (var i = this.projects, n = this.tools, r = i.length - 1; r >= 0; r--)
          i[r].remove();
        for (var r = n.length - 1; r >= 0; r--)
          n[r].remove();
      },
      remove: function() {
        this.clear(), delete g._scopes[this._id];
      },
      statics: new function() {
        function i(n) {
          return n += "Attribute", function(r, l) {
            return r[n](l) || r[n]("data-paper-" + l);
          };
        }
        return {
          _scopes: {},
          _id: 0,
          get: function(n) {
            return this._scopes[n] || null;
          },
          getAttribute: i("get"),
          hasAttribute: i("has")
        };
      }()
    }), w = a.extend(c, {
      initialize: function(i) {
        this._scope = nt, this._index = this._scope[this._list].push(this) - 1, (i || !this._scope[this._reference]) && this.activate();
      },
      activate: function() {
        if (!this._scope)
          return !1;
        var i = this._scope[this._reference];
        return i && i !== this && i.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", i), !0;
      },
      isActive: function() {
        return this._scope[this._reference] === this;
      },
      remove: function() {
        return this._index == null ? !1 : (a.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
      },
      getView: function() {
        return this._scope.getView();
      }
    }), T = {
      findItemBoundsCollisions: function(i, n, r) {
        function l(m) {
          for (var _ = new Array(m.length), y = 0; y < m.length; y++) {
            var x = m[y].getBounds();
            _[y] = [x.left, x.top, x.right, x.bottom];
          }
          return _;
        }
        var h = l(i), f = !n || n === i ? h : l(n);
        return this.findBoundsCollisions(h, f, r || 0);
      },
      findCurveBoundsCollisions: function(i, n, r, l) {
        function h(C) {
          for (var M = Math.min, R = Math.max, E = new Array(C.length), D = 0; D < C.length; D++) {
            var L = C[D];
            E[D] = [
              M(L[0], L[2], L[4], L[6]),
              M(L[1], L[3], L[5], L[7]),
              R(L[0], L[2], L[4], L[6]),
              R(L[1], L[3], L[5], L[7])
            ];
          }
          return E;
        }
        var f = h(i), m = !n || n === i ? f : h(n);
        if (l) {
          for (var _ = this.findBoundsCollisions(
            f,
            m,
            r || 0,
            !1,
            !0
          ), y = this.findBoundsCollisions(
            f,
            m,
            r || 0,
            !0,
            !0
          ), x = [], A = 0, B = _.length; A < B; A++)
            x[A] = { hor: _[A], ver: y[A] };
          return x;
        }
        return this.findBoundsCollisions(f, m, r || 0);
      },
      findBoundsCollisions: function(i, n, r, l, h) {
        var f = !n || i === n, m = f ? i : i.concat(n), _ = i.length, y = m.length;
        function x(He, Ye, Je) {
          for (var Be = 0, Ie = He.length; Be < Ie; ) {
            var Ge = Ie + Be >>> 1;
            m[He[Ge]][Ye] < Je ? Be = Ge + 1 : Ie = Ge;
          }
          return Be - 1;
        }
        for (var A = l ? 1 : 0, B = A + 2, C = l ? 0 : 1, M = C + 2, R = new Array(y), E = 0; E < y; E++)
          R[E] = E;
        R.sort(function(He, Ye) {
          return m[He][A] - m[Ye][A];
        });
        for (var D = [], L = new Array(_), E = 0; E < y; E++) {
          var P = R[E], S = m[P], I = f ? P : P - _, U = P < _, V = f || !U, F = U ? [] : null;
          if (D.length) {
            var W = x(
              D,
              B,
              S[A] - r
            ) + 1;
            if (D.splice(0, W), f && h) {
              F = F.concat(D);
              for (var Q = 0; Q < D.length; Q++) {
                var ie = D[Q];
                L[ie].push(I);
              }
            } else
              for (var ae = S[M], J = S[C], Q = 0; Q < D.length; Q++) {
                var ie = D[Q], le = m[ie], fe = ie < _, me = f || ie >= _;
                (h || (U && me || V && fe) && ae >= le[C] - r && J <= le[M] + r) && (U && me && F.push(
                  f ? ie : ie - _
                ), V && fe && L[ie].push(I));
              }
          }
          if (U && (i === n && F.push(P), L[P] = F), D.length) {
            var ve = S[B], Se = x(D, B, ve);
            D.splice(Se + 1, 0, P);
          } else
            D.push(P);
        }
        for (var E = 0; E < L.length; E++) {
          var Re = L[E];
          Re && Re.sort(function(Ye, Je) {
            return Ye - Je;
          });
        }
        return L;
      }
    }, H = a.extend({
      initialize: function(i) {
        this.precision = a.pick(i, 5), this.multiplier = Math.pow(10, this.precision);
      },
      number: function(i) {
        return this.precision < 16 ? Math.round(i * this.multiplier) / this.multiplier : i;
      },
      pair: function(i, n, r) {
        return this.number(i) + (r || ",") + this.number(n);
      },
      point: function(i, n) {
        return this.number(i.x) + (n || ",") + this.number(i.y);
      },
      size: function(i, n) {
        return this.number(i.width) + (n || ",") + this.number(i.height);
      },
      rectangle: function(i, n) {
        return this.point(i, n) + (n || ",") + this.size(i, n);
      }
    });
    H.instance = new H();
    var Y = new function() {
      var i = [
        [0.5773502691896257],
        [0, 0.7745966692414834],
        [0.33998104358485626, 0.8611363115940526],
        [0, 0.5384693101056831, 0.906179845938664],
        [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
        [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
        [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
        [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
        [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
        [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
        [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
        [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
        [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
        [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
        [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
      ], n = [
        [1],
        [0.8888888888888888, 0.5555555555555556],
        [0.6521451548625461, 0.34785484513745385],
        [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
        [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
        [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
        [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
        [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
        [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
        [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
        [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
        [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
        [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
        [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
        [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
      ], r = Math.abs, l = Math.sqrt, h = Math.pow, f = Math.log2 || function(B) {
        return Math.log(B) * Math.LOG2E;
      }, m = 1e-12, _ = 112e-18;
      function y(B, C, M) {
        return B < C ? C : B > M ? M : B;
      }
      function x(B, C, M) {
        function R(W) {
          var Q = W * 134217729, ie = W - Q, ae = ie + Q, J = W - ae;
          return [ae, J];
        }
        var E = C * C - B * M, D = C * C + B * M;
        if (r(E) * 3 < D) {
          var L = R(B), P = R(C), S = R(M), I = C * C, U = P[0] * P[0] - I + 2 * P[0] * P[1] + P[1] * P[1], V = B * M, F = L[0] * S[0] - V + L[0] * S[1] + L[1] * S[0] + L[1] * S[1];
          E = I - V + (U - F);
        }
        return E;
      }
      function A() {
        var B = Math.max.apply(Math, arguments);
        return B && (B < 1e-8 || B > 1e8) ? h(2, -Math.round(f(B))) : 0;
      }
      return {
        EPSILON: m,
        MACHINE_EPSILON: _,
        CURVETIME_EPSILON: 1e-8,
        GEOMETRIC_EPSILON: 1e-7,
        TRIGONOMETRIC_EPSILON: 1e-8,
        ANGULAR_EPSILON: 1e-5,
        KAPPA: 4 * (l(2) - 1) / 3,
        isZero: function(B) {
          return B >= -m && B <= m;
        },
        isMachineZero: function(B) {
          return B >= -_ && B <= _;
        },
        clamp: y,
        integrate: function(B, C, M, R) {
          for (var E = i[R - 2], D = n[R - 2], L = (M - C) * 0.5, P = L + C, S = 0, I = R + 1 >> 1, U = R & 1 ? D[S++] * B(P) : 0; S < I; ) {
            var V = L * E[S];
            U += D[S++] * (B(P + V) + B(P - V));
          }
          return L * U;
        },
        findRoot: function(B, C, M, R, E, D, L) {
          for (var P = 0; P < D; P++) {
            var S = B(M), I = S / C(M), U = M - I;
            if (r(I) < L) {
              M = U;
              break;
            }
            S > 0 ? (E = M, M = U <= R ? (R + E) * 0.5 : U) : (R = M, M = U >= E ? (R + E) * 0.5 : U);
          }
          return y(M, R, E);
        },
        solveQuadratic: function(B, C, M, R, E, D) {
          var L, P = 1 / 0;
          if (r(B) < m) {
            if (r(C) < m)
              return r(M) < m ? -1 : 0;
            L = -M / C;
          } else {
            C *= -0.5;
            var S = x(B, C, M);
            if (S && r(S) < _) {
              var I = A(r(B), r(C), r(M));
              I && (B *= I, C *= I, M *= I, S = x(B, C, M));
            }
            if (S >= -_) {
              var U = S < 0 ? 0 : l(S), V = C + (C < 0 ? -U : U);
              V === 0 ? (L = M / B, P = -L) : (L = V / B, P = M / V);
            }
          }
          var F = 0, W = E == null, Q = E - m, ie = D + m;
          return isFinite(L) && (W || L > Q && L < ie) && (R[F++] = W ? L : y(L, E, D)), P !== L && isFinite(P) && (W || P > Q && P < ie) && (R[F++] = W ? P : y(P, E, D)), F;
        },
        solveCubic: function(B, C, M, R, E, D, L) {
          var P = A(r(B), r(C), r(M), r(R)), S, I, U, V, F;
          P && (B *= P, C *= P, M *= P, R *= P);
          function W(Se) {
            S = Se;
            var Re = B * S;
            I = Re + C, U = I * S + M, V = (Re + I) * S + U, F = U * S + R;
          }
          if (r(B) < m)
            B = C, I = M, U = R, S = 1 / 0;
          else if (r(R) < m)
            I = C, U = M, S = 0;
          else {
            W(-(C / B) / 3);
            var Q = F / B, ie = h(r(Q), 1 / 3), ae = Q < 0 ? -1 : 1, J = -V / B, le = J > 0 ? 1.324717957244746 * Math.max(ie, l(J)) : ie, fe = S - ae * le;
            if (fe !== S) {
              do
                W(fe), fe = V === 0 ? S : S - F / V / (1 + _);
              while (ae * fe > ae * S);
              r(B) * S * S > r(R / S) && (U = -R / S, I = (U - M) / S);
            }
          }
          var me = Y.solveQuadratic(B, I, U, E, D, L), ve = D == null;
          return isFinite(S) && (me === 0 || me > 0 && S !== E[0] && S !== E[1]) && (ve || S > D - m && S < L + m) && (E[me++] = ve ? S : y(S, D, L)), me;
        }
      };
    }(), ee = {
      _id: 1,
      _pools: {},
      get: function(i) {
        if (i) {
          var n = this._pools[i];
          return n || (n = this._pools[i] = { _id: 1 }), n._id++;
        } else
          return this._id++;
      }
    }, z = a.extend({
      _class: "Point",
      _readIndex: !0,
      initialize: function(n, r) {
        var l = typeof n, h = this.__read, f = 0;
        if (l === "number") {
          var m = typeof r == "number";
          this._set(n, m ? r : n), h && (f = m ? 2 : 1);
        } else if (l === "undefined" || n === null)
          this._set(0, 0), h && (f = n === null ? 1 : 0);
        else {
          var _ = l === "string" ? n.split(/[\s,]+/) || [] : n;
          f = 1, Array.isArray(_) ? this._set(+_[0], +(_.length > 1 ? _[1] : _[0])) : "x" in _ ? this._set(_.x || 0, _.y || 0) : "width" in _ ? this._set(_.width || 0, _.height || 0) : "angle" in _ ? (this._set(_.length || 0, 0), this.setAngle(_.angle || 0)) : (this._set(0, 0), f = 0);
        }
        return h && (this.__read = f), this;
      },
      set: "#initialize",
      _set: function(i, n) {
        return this.x = i, this.y = n, this;
      },
      equals: function(i) {
        return this === i || i && (this.x === i.x && this.y === i.y || Array.isArray(i) && this.x === i[0] && this.y === i[1]) || !1;
      },
      clone: function() {
        return new z(this.x, this.y);
      },
      toString: function() {
        var i = H.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [n.number(this.x), n.number(this.y)];
      },
      getLength: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      setLength: function(i) {
        if (this.isZero()) {
          var n = this._angle || 0;
          this._set(
            Math.cos(n) * i,
            Math.sin(n) * i
          );
        } else {
          var r = i / this.getLength();
          Y.isZero(r) && this.getAngle(), this._set(
            this.x * r,
            this.y * r
          );
        }
      },
      getAngle: function() {
        return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
      },
      setAngle: function(i) {
        this.setAngleInRadians.call(this, i * Math.PI / 180);
      },
      getAngleInDegrees: "#getAngle",
      setAngleInDegrees: "#setAngle",
      getAngleInRadians: function() {
        if (arguments.length) {
          var i = z.read(arguments), n = this.getLength() * i.getLength();
          if (Y.isZero(n))
            return NaN;
          var r = this.dot(i) / n;
          return Math.acos(r < -1 ? -1 : r > 1 ? 1 : r);
        } else
          return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
      },
      setAngleInRadians: function(i) {
        if (this._angle = i, !this.isZero()) {
          var n = this.getLength();
          this._set(
            Math.cos(i) * n,
            Math.sin(i) * n
          );
        }
      },
      getQuadrant: function() {
        return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
      }
    }, {
      beans: !1,
      getDirectedAngle: function() {
        var i = z.read(arguments);
        return Math.atan2(this.cross(i), this.dot(i)) * 180 / Math.PI;
      },
      getDistance: function() {
        var i = arguments, n = z.read(i), r = n.x - this.x, l = n.y - this.y, h = r * r + l * l, f = a.read(i);
        return f ? h : Math.sqrt(h);
      },
      normalize: function(i) {
        i === t && (i = 1);
        var n = this.getLength(), r = n !== 0 ? i / n : 0, l = new z(this.x * r, this.y * r);
        return r >= 0 && (l._angle = this._angle), l;
      },
      rotate: function(i, n) {
        if (i === 0)
          return this.clone();
        i = i * Math.PI / 180;
        var r = n ? this.subtract(n) : this, l = Math.sin(i), h = Math.cos(i);
        return r = new z(
          r.x * h - r.y * l,
          r.x * l + r.y * h
        ), n ? r.add(n) : r;
      },
      transform: function(i) {
        return i ? i._transformPoint(this) : this;
      },
      add: function() {
        var i = z.read(arguments);
        return new z(this.x + i.x, this.y + i.y);
      },
      subtract: function() {
        var i = z.read(arguments);
        return new z(this.x - i.x, this.y - i.y);
      },
      multiply: function() {
        var i = z.read(arguments);
        return new z(this.x * i.x, this.y * i.y);
      },
      divide: function() {
        var i = z.read(arguments);
        return new z(this.x / i.x, this.y / i.y);
      },
      modulo: function() {
        var i = z.read(arguments);
        return new z(this.x % i.x, this.y % i.y);
      },
      negate: function() {
        return new z(-this.x, -this.y);
      },
      isInside: function() {
        return se.read(arguments).contains(this);
      },
      isClose: function() {
        var i = arguments, n = z.read(i), r = a.read(i);
        return this.getDistance(n) <= r;
      },
      isCollinear: function() {
        var i = z.read(arguments);
        return z.isCollinear(this.x, this.y, i.x, i.y);
      },
      isColinear: "#isCollinear",
      isOrthogonal: function() {
        var i = z.read(arguments);
        return z.isOrthogonal(this.x, this.y, i.x, i.y);
      },
      isZero: function() {
        var i = Y.isZero;
        return i(this.x) && i(this.y);
      },
      isNaN: function() {
        return isNaN(this.x) || isNaN(this.y);
      },
      isInQuadrant: function(i) {
        return this.x * (i > 1 && i < 4 ? -1 : 1) >= 0 && this.y * (i > 2 ? -1 : 1) >= 0;
      },
      dot: function() {
        var i = z.read(arguments);
        return this.x * i.x + this.y * i.y;
      },
      cross: function() {
        var i = z.read(arguments);
        return this.x * i.y - this.y * i.x;
      },
      project: function() {
        var i = z.read(arguments), n = i.isZero() ? 0 : this.dot(i) / i.dot(i);
        return new z(
          i.x * n,
          i.y * n
        );
      },
      statics: {
        min: function() {
          var i = arguments, n = z.read(i), r = z.read(i);
          return new z(
            Math.min(n.x, r.x),
            Math.min(n.y, r.y)
          );
        },
        max: function() {
          var i = arguments, n = z.read(i), r = z.read(i);
          return new z(
            Math.max(n.x, r.x),
            Math.max(n.y, r.y)
          );
        },
        random: function() {
          return new z(Math.random(), Math.random());
        },
        isCollinear: function(i, n, r, l) {
          return Math.abs(i * l - n * r) <= Math.sqrt((i * i + n * n) * (r * r + l * l)) * 1e-8;
        },
        isOrthogonal: function(i, n, r, l) {
          return Math.abs(i * r + n * l) <= Math.sqrt((i * i + n * n) * (r * r + l * l)) * 1e-8;
        }
      }
    }, a.each(["round", "ceil", "floor", "abs"], function(i) {
      var n = Math[i];
      this[i] = function() {
        return new z(n(this.x), n(this.y));
      };
    }, {})), he = z.extend({
      initialize: function(n, r, l, h) {
        this._x = n, this._y = r, this._owner = l, this._setter = h;
      },
      _set: function(i, n, r) {
        return this._x = i, this._y = n, r || this._owner[this._setter](this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner[this._setter](this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner[this._setter](this);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        return this._setter === "setPosition" ? 4 : 0;
      }
    }), ne = a.extend({
      _class: "Size",
      _readIndex: !0,
      initialize: function(n, r) {
        var l = typeof n, h = this.__read, f = 0;
        if (l === "number") {
          var m = typeof r == "number";
          this._set(n, m ? r : n), h && (f = m ? 2 : 1);
        } else if (l === "undefined" || n === null)
          this._set(0, 0), h && (f = n === null ? 1 : 0);
        else {
          var _ = l === "string" ? n.split(/[\s,]+/) || [] : n;
          f = 1, Array.isArray(_) ? this._set(+_[0], +(_.length > 1 ? _[1] : _[0])) : "width" in _ ? this._set(_.width || 0, _.height || 0) : "x" in _ ? this._set(_.x || 0, _.y || 0) : (this._set(0, 0), f = 0);
        }
        return h && (this.__read = f), this;
      },
      set: "#initialize",
      _set: function(i, n) {
        return this.width = i, this.height = n, this;
      },
      equals: function(i) {
        return i === this || i && (this.width === i.width && this.height === i.height || Array.isArray(i) && this.width === i[0] && this.height === i[1]) || !1;
      },
      clone: function() {
        return new ne(this.width, this.height);
      },
      toString: function() {
        var i = H.instance;
        return "{ width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [
          n.number(this.width),
          n.number(this.height)
        ];
      },
      add: function() {
        var i = ne.read(arguments);
        return new ne(this.width + i.width, this.height + i.height);
      },
      subtract: function() {
        var i = ne.read(arguments);
        return new ne(this.width - i.width, this.height - i.height);
      },
      multiply: function() {
        var i = ne.read(arguments);
        return new ne(this.width * i.width, this.height * i.height);
      },
      divide: function() {
        var i = ne.read(arguments);
        return new ne(this.width / i.width, this.height / i.height);
      },
      modulo: function() {
        var i = ne.read(arguments);
        return new ne(this.width % i.width, this.height % i.height);
      },
      negate: function() {
        return new ne(-this.width, -this.height);
      },
      isZero: function() {
        var i = Y.isZero;
        return i(this.width) && i(this.height);
      },
      isNaN: function() {
        return isNaN(this.width) || isNaN(this.height);
      },
      statics: {
        min: function(i, n) {
          return new ne(
            Math.min(i.width, n.width),
            Math.min(i.height, n.height)
          );
        },
        max: function(i, n) {
          return new ne(
            Math.max(i.width, n.width),
            Math.max(i.height, n.height)
          );
        },
        random: function() {
          return new ne(Math.random(), Math.random());
        }
      }
    }, a.each(["round", "ceil", "floor", "abs"], function(i) {
      var n = Math[i];
      this[i] = function() {
        return new ne(n(this.width), n(this.height));
      };
    }, {})), ye = ne.extend({
      initialize: function(n, r, l, h) {
        this._width = n, this._height = r, this._owner = l, this._setter = h;
      },
      _set: function(i, n, r) {
        return this._width = i, this._height = n, r || this._owner[this._setter](this), this;
      },
      getWidth: function() {
        return this._width;
      },
      setWidth: function(i) {
        this._width = i, this._owner[this._setter](this);
      },
      getHeight: function() {
        return this._height;
      },
      setHeight: function(i) {
        this._height = i, this._owner[this._setter](this);
      }
    }), se = a.extend({
      _class: "Rectangle",
      _readIndex: !0,
      beans: !0,
      initialize: function(n, r, l, h) {
        var f = arguments, m = typeof n, _;
        if (m === "number" ? (this._set(n, r, l, h), _ = 4) : m === "undefined" || n === null ? (this._set(0, 0, 0, 0), _ = n === null ? 1 : 0) : f.length === 1 && (Array.isArray(n) ? (this._set.apply(this, n), _ = 1) : n.x !== t || n.width !== t ? (this._set(
          n.x || 0,
          n.y || 0,
          n.width || 0,
          n.height || 0
        ), _ = 1) : n.from === t && n.to === t && (this._set(0, 0, 0, 0), a.readSupported(f, this) && (_ = 1))), _ === t) {
          var y = z.readNamed(f, "from"), x = a.peek(f), A = y.x, B = y.y, C, M;
          if (x && x.x !== t || a.hasNamed(f, "to")) {
            var R = z.readNamed(f, "to");
            C = R.x - A, M = R.y - B, C < 0 && (A = R.x, C = -C), M < 0 && (B = R.y, M = -M);
          } else {
            var E = ne.read(f);
            C = E.width, M = E.height;
          }
          this._set(A, B, C, M), _ = f.__index;
        }
        var D = f.__filtered;
        return D && (this.__filtered = D), this.__read && (this.__read = _), this;
      },
      set: "#initialize",
      _set: function(i, n, r, l) {
        return this.x = i, this.y = n, this.width = r, this.height = l, this;
      },
      clone: function() {
        return new se(this.x, this.y, this.width, this.height);
      },
      equals: function(i) {
        var n = a.isPlainValue(i) ? se.read(arguments) : i;
        return n === this || n && this.x === n.x && this.y === n.y && this.width === n.width && this.height === n.height || !1;
      },
      toString: function() {
        var i = H.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + ", width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [
          n.number(this.x),
          n.number(this.y),
          n.number(this.width),
          n.number(this.height)
        ];
      },
      getPoint: function(i) {
        var n = i ? z : he;
        return new n(this.x, this.y, this, "setPoint");
      },
      setPoint: function() {
        var i = z.read(arguments);
        this.x = i.x, this.y = i.y;
      },
      getSize: function(i) {
        var n = i ? ne : ye;
        return new n(this.width, this.height, this, "setSize");
      },
      _fw: 1,
      _fh: 1,
      setSize: function() {
        var i = ne.read(arguments), n = this._sx, r = this._sy, l = i.width, h = i.height;
        n && (this.x += (this.width - l) * n), r && (this.y += (this.height - h) * r), this.width = l, this.height = h, this._fw = this._fh = 1;
      },
      getLeft: function() {
        return this.x;
      },
      setLeft: function(i) {
        if (!this._fw) {
          var n = i - this.x;
          this.width -= this._sx === 0.5 ? n * 2 : n;
        }
        this.x = i, this._sx = this._fw = 0;
      },
      getTop: function() {
        return this.y;
      },
      setTop: function(i) {
        if (!this._fh) {
          var n = i - this.y;
          this.height -= this._sy === 0.5 ? n * 2 : n;
        }
        this.y = i, this._sy = this._fh = 0;
      },
      getRight: function() {
        return this.x + this.width;
      },
      setRight: function(i) {
        if (!this._fw) {
          var n = i - this.x;
          this.width = this._sx === 0.5 ? n * 2 : n;
        }
        this.x = i - this.width, this._sx = 1, this._fw = 0;
      },
      getBottom: function() {
        return this.y + this.height;
      },
      setBottom: function(i) {
        if (!this._fh) {
          var n = i - this.y;
          this.height = this._sy === 0.5 ? n * 2 : n;
        }
        this.y = i - this.height, this._sy = 1, this._fh = 0;
      },
      getCenterX: function() {
        return this.x + this.width / 2;
      },
      setCenterX: function(i) {
        this._fw || this._sx === 0.5 ? this.x = i - this.width / 2 : (this._sx && (this.x += (i - this.x) * 2 * this._sx), this.width = (i - this.x) * 2), this._sx = 0.5, this._fw = 0;
      },
      getCenterY: function() {
        return this.y + this.height / 2;
      },
      setCenterY: function(i) {
        this._fh || this._sy === 0.5 ? this.y = i - this.height / 2 : (this._sy && (this.y += (i - this.y) * 2 * this._sy), this.height = (i - this.y) * 2), this._sy = 0.5, this._fh = 0;
      },
      getCenter: function(i) {
        var n = i ? z : he;
        return new n(this.getCenterX(), this.getCenterY(), this, "setCenter");
      },
      setCenter: function() {
        var i = z.read(arguments);
        return this.setCenterX(i.x), this.setCenterY(i.y), this;
      },
      getArea: function() {
        return this.width * this.height;
      },
      isEmpty: function() {
        return this.width === 0 || this.height === 0;
      },
      contains: function(i) {
        return i && i.width !== t || (Array.isArray(i) ? i : arguments).length === 4 ? this._containsRectangle(se.read(arguments)) : this._containsPoint(z.read(arguments));
      },
      _containsPoint: function(i) {
        var n = i.x, r = i.y;
        return n >= this.x && r >= this.y && n <= this.x + this.width && r <= this.y + this.height;
      },
      _containsRectangle: function(i) {
        var n = i.x, r = i.y;
        return n >= this.x && r >= this.y && n + i.width <= this.x + this.width && r + i.height <= this.y + this.height;
      },
      intersects: function() {
        var i = se.read(arguments), n = a.read(arguments) || 0;
        return i.x + i.width > this.x - n && i.y + i.height > this.y - n && i.x < this.x + this.width + n && i.y < this.y + this.height + n;
      },
      intersect: function() {
        var i = se.read(arguments), n = Math.max(this.x, i.x), r = Math.max(this.y, i.y), l = Math.min(this.x + this.width, i.x + i.width), h = Math.min(this.y + this.height, i.y + i.height);
        return new se(n, r, l - n, h - r);
      },
      unite: function() {
        var i = se.read(arguments), n = Math.min(this.x, i.x), r = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x + i.width), h = Math.max(this.y + this.height, i.y + i.height);
        return new se(n, r, l - n, h - r);
      },
      include: function() {
        var i = z.read(arguments), n = Math.min(this.x, i.x), r = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x), h = Math.max(this.y + this.height, i.y);
        return new se(n, r, l - n, h - r);
      },
      expand: function() {
        var i = ne.read(arguments), n = i.width, r = i.height;
        return new se(
          this.x - n / 2,
          this.y - r / 2,
          this.width + n,
          this.height + r
        );
      },
      scale: function(i, n) {
        return this.expand(
          this.width * i - this.width,
          this.height * (n === t ? i : n) - this.height
        );
      }
    }, a.each(
      [
        ["Top", "Left"],
        ["Top", "Right"],
        ["Bottom", "Left"],
        ["Bottom", "Right"],
        ["Left", "Center"],
        ["Top", "Center"],
        ["Right", "Center"],
        ["Bottom", "Center"]
      ],
      function(i, n) {
        var r = i.join(""), l = /^[RL]/.test(r);
        n >= 4 && (i[1] += l ? "Y" : "X");
        var h = i[l ? 0 : 1], f = i[l ? 1 : 0], m = "get" + h, _ = "get" + f, y = "set" + h, x = "set" + f, A = "get" + r, B = "set" + r;
        this[A] = function(C) {
          var M = C ? z : he;
          return new M(this[m](), this[_](), this, B);
        }, this[B] = function() {
          var C = z.read(arguments);
          this[y](C.x), this[x](C.y);
        };
      },
      {
        beans: !0
      }
    )), _e = se.extend(
      {
        initialize: function(n, r, l, h, f, m) {
          this._set(n, r, l, h, !0), this._owner = f, this._setter = m;
        },
        _set: function(i, n, r, l, h) {
          return this._x = i, this._y = n, this._width = r, this._height = l, h || this._owner[this._setter](this), this;
        }
      },
      new function() {
        var i = se.prototype;
        return a.each(
          ["x", "y", "width", "height"],
          function(n) {
            var r = a.capitalize(n), l = "_" + n;
            this["get" + r] = function() {
              return this[l];
            }, this["set" + r] = function(h) {
              this[l] = h, this._dontNotify || this._owner[this._setter](this);
            };
          },
          a.each(
            [
              "Point",
              "Size",
              "Center",
              "Left",
              "Top",
              "Right",
              "Bottom",
              "CenterX",
              "CenterY",
              "TopLeft",
              "TopRight",
              "BottomLeft",
              "BottomRight",
              "LeftCenter",
              "TopCenter",
              "RightCenter",
              "BottomCenter"
            ],
            function(n) {
              var r = "set" + n;
              this[r] = function() {
                this._dontNotify = !0, i[r].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
              };
            },
            {
              isSelected: function() {
                return !!(this._owner._selection & 2);
              },
              setSelected: function(n) {
                var r = this._owner;
                r._changeSelection && r._changeSelection(2, n);
              }
            }
          )
        );
      }()
    ), ue = a.extend({
      _class: "Matrix",
      initialize: function i(n, r) {
        var l = arguments, h = l.length, f = !0;
        if (h >= 6 ? this._set.apply(this, l) : h === 1 || h === 2 ? n instanceof i ? this._set(
          n._a,
          n._b,
          n._c,
          n._d,
          n._tx,
          n._ty,
          r
        ) : Array.isArray(n) ? this._set.apply(
          this,
          r ? n.concat([r]) : n
        ) : f = !1 : h ? f = !1 : this.reset(), !f)
          throw new Error("Unsupported matrix parameters");
        return this;
      },
      set: "#initialize",
      _set: function(i, n, r, l, h, f, m) {
        return this._a = i, this._b = n, this._c = r, this._d = l, this._tx = h, this._ty = f, m || this._changed(), this;
      },
      _serialize: function(i, n) {
        return a.serialize(this.getValues(), i, !0, n);
      },
      _changed: function() {
        var i = this._owner;
        i && (i._applyMatrix ? i.transform(null, !0) : i._changed(25));
      },
      clone: function() {
        return new ue(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      },
      equals: function(i) {
        return i === this || i && this._a === i._a && this._b === i._b && this._c === i._c && this._d === i._d && this._tx === i._tx && this._ty === i._ty;
      },
      toString: function() {
        var i = H.instance;
        return "[[" + [
          i.number(this._a),
          i.number(this._c),
          i.number(this._tx)
        ].join(", ") + "], [" + [
          i.number(this._b),
          i.number(this._d),
          i.number(this._ty)
        ].join(", ") + "]]";
      },
      reset: function(i) {
        return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, i || this._changed(), this;
      },
      apply: function(i, n) {
        var r = this._owner;
        return r ? (r.transform(null, a.pick(i, !0), n), this.isIdentity()) : !1;
      },
      translate: function() {
        var i = z.read(arguments), n = i.x, r = i.y;
        return this._tx += n * this._a + r * this._c, this._ty += n * this._b + r * this._d, this._changed(), this;
      },
      scale: function() {
        var i = arguments, n = z.read(i), r = z.read(i, 0, { readNull: !0 });
        return r && this.translate(r), this._a *= n.x, this._b *= n.x, this._c *= n.y, this._d *= n.y, r && this.translate(r.negate()), this._changed(), this;
      },
      rotate: function(i) {
        i *= Math.PI / 180;
        var n = z.read(arguments, 1), r = n.x, l = n.y, h = Math.cos(i), f = Math.sin(i), m = r - r * h + l * f, _ = l - r * f - l * h, y = this._a, x = this._b, A = this._c, B = this._d;
        return this._a = h * y + f * A, this._b = h * x + f * B, this._c = -f * y + h * A, this._d = -f * x + h * B, this._tx += m * y + _ * A, this._ty += m * x + _ * B, this._changed(), this;
      },
      shear: function() {
        var i = arguments, n = z.read(i), r = z.read(i, 0, { readNull: !0 });
        r && this.translate(r);
        var l = this._a, h = this._b;
        return this._a += n.y * this._c, this._b += n.y * this._d, this._c += n.x * l, this._d += n.x * h, r && this.translate(r.negate()), this._changed(), this;
      },
      skew: function() {
        var i = arguments, n = z.read(i), r = z.read(i, 0, { readNull: !0 }), l = Math.PI / 180, h = new z(
          Math.tan(n.x * l),
          Math.tan(n.y * l)
        );
        return this.shear(h, r);
      },
      append: function(i, n) {
        if (i) {
          var r = this._a, l = this._b, h = this._c, f = this._d, m = i._a, _ = i._c, y = i._b, x = i._d, A = i._tx, B = i._ty;
          this._a = m * r + y * h, this._c = _ * r + x * h, this._b = m * l + y * f, this._d = _ * l + x * f, this._tx += A * r + B * h, this._ty += A * l + B * f, n || this._changed();
        }
        return this;
      },
      prepend: function(i, n) {
        if (i) {
          var r = this._a, l = this._b, h = this._c, f = this._d, m = this._tx, _ = this._ty, y = i._a, x = i._c, A = i._b, B = i._d, C = i._tx, M = i._ty;
          this._a = y * r + x * l, this._c = y * h + x * f, this._b = A * r + B * l, this._d = A * h + B * f, this._tx = y * m + x * _ + C, this._ty = A * m + B * _ + M, n || this._changed();
        }
        return this;
      },
      appended: function(i) {
        return this.clone().append(i);
      },
      prepended: function(i) {
        return this.clone().prepend(i);
      },
      invert: function() {
        var i = this._a, n = this._b, r = this._c, l = this._d, h = this._tx, f = this._ty, m = i * l - n * r, _ = null;
        return m && !isNaN(m) && isFinite(h) && isFinite(f) && (this._a = l / m, this._b = -n / m, this._c = -r / m, this._d = i / m, this._tx = (r * f - l * h) / m, this._ty = (n * h - i * f) / m, _ = this), _;
      },
      inverted: function() {
        return this.clone().invert();
      },
      concatenate: "#append",
      preConcatenate: "#prepend",
      chain: "#appended",
      _shiftless: function() {
        return new ue(this._a, this._b, this._c, this._d, 0, 0);
      },
      _orNullIfIdentity: function() {
        return this.isIdentity() ? null : this;
      },
      isIdentity: function() {
        return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
      },
      isInvertible: function() {
        var i = this._a * this._d - this._c * this._b;
        return i && !isNaN(i) && isFinite(this._tx) && isFinite(this._ty);
      },
      isSingular: function() {
        return !this.isInvertible();
      },
      transform: function(i, n, r) {
        return arguments.length < 3 ? this._transformPoint(z.read(arguments)) : this._transformCoordinates(i, n, r);
      },
      _transformPoint: function(i, n, r) {
        var l = i.x, h = i.y;
        return n || (n = new z()), n._set(
          l * this._a + h * this._c + this._tx,
          l * this._b + h * this._d + this._ty,
          r
        );
      },
      _transformCoordinates: function(i, n, r) {
        for (var l = 0, h = 2 * r; l < h; l += 2) {
          var f = i[l], m = i[l + 1];
          n[l] = f * this._a + m * this._c + this._tx, n[l + 1] = f * this._b + m * this._d + this._ty;
        }
        return n;
      },
      _transformCorners: function(i) {
        var n = i.x, r = i.y, l = n + i.width, h = r + i.height, f = [n, r, l, r, l, h, n, h];
        return this._transformCoordinates(f, f, 4);
      },
      _transformBounds: function(i, n, r) {
        for (var l = this._transformCorners(i), h = l.slice(0, 2), f = h.slice(), m = 2; m < 8; m++) {
          var _ = l[m], y = m & 1;
          _ < h[y] ? h[y] = _ : _ > f[y] && (f[y] = _);
        }
        return n || (n = new se()), n._set(
          h[0],
          h[1],
          f[0] - h[0],
          f[1] - h[1],
          r
        );
      },
      inverseTransform: function() {
        return this._inverseTransform(z.read(arguments));
      },
      _inverseTransform: function(i, n, r) {
        var l = this._a, h = this._b, f = this._c, m = this._d, _ = this._tx, y = this._ty, x = l * m - h * f, A = null;
        if (x && !isNaN(x) && isFinite(_) && isFinite(y)) {
          var B = i.x - this._tx, C = i.y - this._ty;
          n || (n = new z()), A = n._set(
            (B * m - C * f) / x,
            (C * l - B * h) / x,
            r
          );
        }
        return A;
      },
      decompose: function() {
        var i = this._a, n = this._b, r = this._c, l = this._d, h = i * l - n * r, f = Math.sqrt, m = Math.atan2, _ = 180 / Math.PI, y, x, A;
        if (i !== 0 || n !== 0) {
          var B = f(i * i + n * n);
          y = Math.acos(i / B) * (n > 0 ? 1 : -1), x = [B, h / B], A = [m(i * r + n * l, B * B), 0];
        } else if (r !== 0 || l !== 0) {
          var C = f(r * r + l * l);
          y = Math.asin(r / C) * (l > 0 ? 1 : -1), x = [h / C, C], A = [0, m(i * r + n * l, C * C)];
        } else
          y = 0, A = x = [0, 0];
        return {
          translation: this.getTranslation(),
          rotation: y * _,
          scaling: new z(x),
          skewing: new z(A[0] * _, A[1] * _)
        };
      },
      getValues: function() {
        return [this._a, this._b, this._c, this._d, this._tx, this._ty];
      },
      getTranslation: function() {
        return new z(this._tx, this._ty);
      },
      getScaling: function() {
        return this.decompose().scaling;
      },
      getRotation: function() {
        return this.decompose().rotation;
      },
      applyToContext: function(i) {
        this.isIdentity() || i.transform(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      }
    }, a.each(["a", "b", "c", "d", "tx", "ty"], function(i) {
      var n = a.capitalize(i), r = "_" + i;
      this["get" + n] = function() {
        return this[r];
      }, this["set" + n] = function(l) {
        this[r] = l, this._changed();
      };
    }, {})), xe = a.extend({
      _class: "Line",
      initialize: function(n, r, l, h, f) {
        var m = !1;
        arguments.length >= 4 ? (this._px = n, this._py = r, this._vx = l, this._vy = h, m = f) : (this._px = n.x, this._py = n.y, this._vx = r.x, this._vy = r.y, m = l), m || (this._vx -= this._px, this._vy -= this._py);
      },
      getPoint: function() {
        return new z(this._px, this._py);
      },
      getVector: function() {
        return new z(this._vx, this._vy);
      },
      getLength: function() {
        return this.getVector().getLength();
      },
      intersect: function(i, n) {
        return xe.intersect(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i._px,
          i._py,
          i._vx,
          i._vy,
          !0,
          n
        );
      },
      getSide: function(i, n) {
        return xe.getSide(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0,
          n
        );
      },
      getDistance: function(i) {
        return Math.abs(this.getSignedDistance(i));
      },
      getSignedDistance: function(i) {
        return xe.getSignedDistance(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0
        );
      },
      isCollinear: function(i) {
        return z.isCollinear(this._vx, this._vy, i._vx, i._vy);
      },
      isOrthogonal: function(i) {
        return z.isOrthogonal(this._vx, this._vy, i._vx, i._vy);
      },
      statics: {
        intersect: function(i, n, r, l, h, f, m, _, y, x) {
          y || (r -= i, l -= n, m -= h, _ -= f);
          var A = r * _ - l * m;
          if (!Y.isMachineZero(A)) {
            var B = i - h, C = n - f, M = (m * C - _ * B) / A, R = (r * C - l * B) / A, E = 1e-12, D = -E, L = 1 + E;
            if (x || D < M && M < L && D < R && R < L)
              return x || (M = M <= 0 ? 0 : M >= 1 ? 1 : M), new z(
                i + M * r,
                n + M * l
              );
          }
        },
        getSide: function(i, n, r, l, h, f, m, _) {
          m || (r -= i, l -= n);
          var y = h - i, x = f - n, A = y * l - x * r;
          return !_ && Y.isMachineZero(A) && (A = (y * r + y * r) / (r * r + l * l), A >= 0 && A <= 1 && (A = 0)), A < 0 ? -1 : A > 0 ? 1 : 0;
        },
        getSignedDistance: function(i, n, r, l, h, f, m) {
          return m || (r -= i, l -= n), r === 0 ? l > 0 ? h - i : i - h : l === 0 ? r < 0 ? f - n : n - f : ((h - i) * l - (f - n) * r) / (l > r ? l * Math.sqrt(1 + r * r / (l * l)) : r * Math.sqrt(1 + l * l / (r * r)));
        },
        getDistance: function(i, n, r, l, h, f, m) {
          return Math.abs(
            xe.getSignedDistance(i, n, r, l, h, f, m)
          );
        }
      }
    }), Ee = w.extend({
      _class: "Project",
      _list: "projects",
      _reference: "project",
      _compactSerialize: !0,
      initialize: function(n) {
        w.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new Wn(null, null, this), this._view = Ht.create(
          this,
          n || Ut.getCanvas(1, 1)
        ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
      },
      _serialize: function(i, n) {
        return a.serialize(this._children, i, !0, n);
      },
      _changed: function(i, n) {
        if (i & 1) {
          var r = this._view;
          r && (r._needsUpdate = !0, !r._requested && r._autoUpdate && r.requestUpdate());
        }
        var l = this._changes;
        if (l && n) {
          var h = this._changesById, f = n._id, m = h[f];
          m ? m.flags |= i : l.push(h[f] = { item: n, flags: i });
        }
      },
      clear: function() {
        for (var i = this._children, n = i.length - 1; n >= 0; n--)
          i[n].remove();
      },
      isEmpty: function() {
        return !this._children.length;
      },
      remove: function i() {
        return i.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
      },
      getView: function() {
        return this._view;
      },
      getCurrentStyle: function() {
        return this._currentStyle;
      },
      setCurrentStyle: function(i) {
        this._currentStyle.set(i);
      },
      getIndex: function() {
        return this._index;
      },
      getOptions: function() {
        return this._scope.settings;
      },
      getLayers: function() {
        return this._children;
      },
      getActiveLayer: function() {
        return this._activeLayer || new ht({ project: this, insert: !0 });
      },
      getSymbolDefinitions: function() {
        var i = [], n = {};
        return this.getItems({
          class: Pt,
          match: function(r) {
            var l = r._definition, h = l._id;
            return n[h] || (n[h] = !0, i.push(l)), !1;
          }
        }), i;
      },
      getSymbols: "getSymbolDefinitions",
      getSelectedItems: function() {
        var i = this._selectionItems, n = [];
        for (var r in i) {
          var l = i[r], h = l._selection;
          h & 1 && l.isInserted() ? n.push(l) : h || this._updateSelection(l);
        }
        return n;
      },
      _updateSelection: function(i) {
        var n = i._id, r = this._selectionItems;
        i._selection ? r[n] !== i && (this._selectionCount++, r[n] = i) : r[n] === i && (this._selectionCount--, delete r[n]);
      },
      selectAll: function() {
        for (var i = this._children, n = 0, r = i.length; n < r; n++)
          i[n].setFullySelected(!0);
      },
      deselectAll: function() {
        var i = this._selectionItems;
        for (var n in i)
          i[n].setFullySelected(!1);
      },
      addLayer: function(i) {
        return this.insertLayer(t, i);
      },
      insertLayer: function(i, n) {
        if (n instanceof ht) {
          n._remove(!1, !0), a.splice(this._children, [n], i, 0), n._setProject(this, !0);
          var r = n._name;
          r && n.setName(r), this._changes && n._changed(5), this._activeLayer || (this._activeLayer = n);
        } else
          n = null;
        return n;
      },
      _insertItem: function(i, n, r) {
        return n = this.insertLayer(i, n) || (this._activeLayer || this._insertItem(
          t,
          new ht(K.NO_INSERT),
          !0
        )).insertChild(i, n), r && n.activate && n.activate(), n;
      },
      getItems: function(i) {
        return K._getItems(this, i);
      },
      getItem: function(i) {
        return K._getItems(this, i, null, null, !0)[0] || null;
      },
      importJSON: function(i) {
        this.activate();
        var n = this._activeLayer;
        return a.importJSON(i, n && n.isEmpty() && n);
      },
      removeOn: function(i) {
        var n = this._removeSets;
        if (n) {
          i === "mouseup" && (n.mousedrag = null);
          var r = n[i];
          if (r) {
            for (var l in r) {
              var h = r[l];
              for (var f in n) {
                var m = n[f];
                m && m != r && delete m[h._id];
              }
              h.remove();
            }
            n[i] = null;
          }
        }
      },
      draw: function(i, n, r) {
        this._updateVersion++, i.save(), n.applyToContext(i);
        for (var l = this._children, h = new a({
          offset: new z(0, 0),
          pixelRatio: r,
          viewMatrix: n.isIdentity() ? null : n,
          matrices: [new ue()],
          updateMatrix: !0
        }), f = 0, m = l.length; f < m; f++)
          l[f].draw(i, h);
        if (i.restore(), this._selectionCount > 0) {
          i.save(), i.strokeWidth = 1;
          var _ = this._selectionItems, y = this._scope.settings.handleSize, x = this._updateVersion;
          for (var A in _)
            _[A]._drawSelection(i, n, y, _, x);
          i.restore();
        }
      }
    }), K = a.extend(
      c,
      {
        statics: {
          extend: function i(n) {
            return n._serializeFields && (n._serializeFields = a.set(
              {},
              this.prototype._serializeFields,
              n._serializeFields
            )), i.base.apply(this, arguments);
          },
          INSERT: { insert: !0 },
          NO_INSERT: { insert: !1 }
        },
        _class: "Item",
        _name: null,
        _applyMatrix: !0,
        _canApplyMatrix: !0,
        _canScaleStroke: !1,
        _pivot: null,
        _visible: !0,
        _blendMode: "normal",
        _opacity: 1,
        _locked: !1,
        _guide: !1,
        _clipMask: !1,
        _selection: 0,
        _selectBounds: !0,
        _selectChildren: !1,
        _serializeFields: {
          name: null,
          applyMatrix: null,
          matrix: new ue(),
          pivot: null,
          visible: !0,
          blendMode: "normal",
          opacity: 1,
          locked: !1,
          guide: !1,
          clipMask: !1,
          selected: !1,
          data: {}
        },
        _prioritize: ["applyMatrix"]
      },
      new function() {
        var i = [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onClick",
          "onDoubleClick",
          "onMouseMove",
          "onMouseEnter",
          "onMouseLeave"
        ];
        return a.each(
          i,
          function(n) {
            this._events[n] = {
              install: function(r) {
                this.getView()._countItemEvent(r, 1);
              },
              uninstall: function(r) {
                this.getView()._countItemEvent(r, -1);
              }
            };
          },
          {
            _events: {
              onFrame: {
                install: function() {
                  this.getView()._animateItem(this, !0);
                },
                uninstall: function() {
                  this.getView()._animateItem(this, !1);
                }
              },
              onLoad: {},
              onError: {}
            },
            statics: {
              _itemHandlers: i
            }
          }
        );
      }(),
      {
        initialize: function() {
        },
        _initialize: function(i, n) {
          var r = i && a.isPlainObject(i), l = r && i.internal === !0, h = this._matrix = new ue(), f = r && i.project || nt.project, m = nt.settings;
          return this._id = l ? null : ee.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && m.applyMatrix, n && h.translate(n), h._owner = this, this._style = new Wn(f._currentStyle, this, f), l || r && i.insert == !1 || !m.insertItems && !(r && i.insert == !0) ? this._setProject(f) : (r && i.parent || f)._insertItem(t, this, !0), r && i !== K.NO_INSERT && i !== K.INSERT && this.set(i, {
            internal: !0,
            insert: !0,
            project: !0,
            parent: !0
          }), r;
        },
        _serialize: function(i, n) {
          var r = {}, l = this;
          function h(f) {
            for (var m in f) {
              var _ = l[m];
              a.equals(_, m === "leading" ? f.fontSize * 1.2 : f[m]) || (r[m] = a.serialize(
                _,
                i,
                m !== "data",
                n
              ));
            }
          }
          return h(this._serializeFields), this instanceof j || h(this._style._defaults), [this._class, r];
        },
        _changed: function(i) {
          var n = this._symbol, r = this._parent || n, l = this._project;
          i & 8 && (this._bounds = this._position = this._decomposed = t), i & 16 && (this._globalMatrix = t), r && i & 72 && K._clearBoundsCache(r), i & 2 && K._clearBoundsCache(this), l && l._changed(i, this), n && n._changed(i);
        },
        getId: function() {
          return this._id;
        },
        getName: function() {
          return this._name;
        },
        setName: function(i) {
          if (this._name && this._removeNamed(), i === +i + "")
            throw new Error(
              "Names consisting only of numbers are not supported."
            );
          var n = this._getOwner();
          if (i && n) {
            var r = n._children, l = n._namedChildren;
            (l[i] = l[i] || []).push(this), i in r || (r[i] = this);
          }
          this._name = i || t, this._changed(256);
        },
        getStyle: function() {
          return this._style;
        },
        setStyle: function(i) {
          this.getStyle().set(i);
        }
      },
      a.each(
        ["locked", "visible", "blendMode", "opacity", "guide"],
        function(i) {
          var n = a.capitalize(i), r = "_" + i, l = {
            locked: 256,
            visible: 265
          };
          this["get" + n] = function() {
            return this[r];
          }, this["set" + n] = function(h) {
            h != this[r] && (this[r] = h, this._changed(l[i] || 257));
          };
        },
        {}
      ),
      {
        beans: !0,
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(i) {
          if (i !== this._selection) {
            this._selection = i;
            var n = this._project;
            n && (n._updateSelection(this), this._changed(257));
          }
        },
        _changeSelection: function(i, n) {
          var r = this._selection;
          this.setSelection(n ? r | i : r & ~i);
        },
        isSelected: function() {
          if (this._selectChildren) {
            for (var i = this._children, n = 0, r = i.length; n < r; n++)
              if (i[n].isSelected())
                return !0;
          }
          return !!(this._selection & 1);
        },
        setSelected: function(i) {
          if (this._selectChildren)
            for (var n = this._children, r = 0, l = n.length; r < l; r++)
              n[r].setSelected(i);
          this._changeSelection(1, i);
        },
        isFullySelected: function() {
          var i = this._children, n = !!(this._selection & 1);
          if (i && n) {
            for (var r = 0, l = i.length; r < l; r++)
              if (!i[r].isFullySelected())
                return !1;
            return !0;
          }
          return n;
        },
        setFullySelected: function(i) {
          var n = this._children;
          if (n)
            for (var r = 0, l = n.length; r < l; r++)
              n[r].setFullySelected(i);
          this._changeSelection(1, i);
        },
        isClipMask: function() {
          return this._clipMask;
        },
        setClipMask: function(i) {
          this._clipMask != (i = !!i) && (this._clipMask = i, i && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
        },
        getData: function() {
          return this._data || (this._data = {}), this._data;
        },
        setData: function(i) {
          this._data = i;
        },
        getPosition: function(i) {
          var n = i ? z : he, r = this._position || (this._position = this._getPositionFromBounds());
          return new n(r.x, r.y, this, "setPosition");
        },
        setPosition: function() {
          this.translate(z.read(arguments).subtract(this.getPosition(!0)));
        },
        _getPositionFromBounds: function(i) {
          return this._pivot ? this._matrix._transformPoint(this._pivot) : (i || this.getBounds()).getCenter(!0);
        },
        getPivot: function() {
          var i = this._pivot;
          return i ? new he(i.x, i.y, this, "setPivot") : null;
        },
        setPivot: function() {
          this._pivot = z.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = t;
        }
      },
      a.each(
        {
          getStrokeBounds: { stroke: !0 },
          getHandleBounds: { handle: !0 },
          getInternalBounds: { internal: !0 }
        },
        function(i, n) {
          this[n] = function(r) {
            return this.getBounds(r, i);
          };
        },
        {
          beans: !0,
          getBounds: function(i, n) {
            var r = n || i instanceof ue, l = a.set(
              {},
              r ? n : i,
              this._boundsOptions
            );
            (!l.stroke || this.getStrokeScaling()) && (l.cacheItem = this);
            var h = this._getCachedBounds(r && i, l).rect;
            return arguments.length ? h : new _e(
              h.x,
              h.y,
              h.width,
              h.height,
              this,
              "setBounds"
            );
          },
          setBounds: function() {
            var i = se.read(arguments), n = this.getBounds(), r = this._matrix, l = new ue(), h = i.getCenter();
            l.translate(h), (i.width != n.width || i.height != n.height) && (r.isInvertible() || (r.set(r._backup || new ue().translate(r.getTranslation())), n = this.getBounds()), l.scale(
              n.width !== 0 ? i.width / n.width : 0,
              n.height !== 0 ? i.height / n.height : 0
            )), h = n.getCenter(), l.translate(-h.x, -h.y), this.transform(l);
          },
          _getBounds: function(i, n) {
            var r = this._children;
            return !r || !r.length ? new se() : (K._updateBoundsCache(this, n.cacheItem), K._getBounds(r, i, n));
          },
          _getBoundsCacheKey: function(i, n) {
            return [
              i.stroke ? 1 : 0,
              i.handle ? 1 : 0,
              n ? 1 : 0
            ].join("");
          },
          _getCachedBounds: function(i, n, r) {
            i = i && i._orNullIfIdentity();
            var l = n.internal && !r, h = n.cacheItem, f = l ? null : this._matrix._orNullIfIdentity(), m = h && (!i || i.equals(f)) && this._getBoundsCacheKey(n, l), _ = this._bounds;
            if (K._updateBoundsCache(this._parent || this._symbol, h), m && _ && m in _) {
              var y = _[m];
              return {
                rect: y.rect.clone(),
                nonscaling: y.nonscaling
              };
            }
            var x = this._getBounds(i || f, n), A = x.rect || x, B = this._style, C = x.nonscaling || B.hasStroke() && !B.getStrokeScaling();
            if (m) {
              _ || (this._bounds = _ = {});
              var y = _[m] = {
                rect: A.clone(),
                nonscaling: C,
                internal: l
              };
            }
            return {
              rect: A,
              nonscaling: C
            };
          },
          _getStrokeMatrix: function(i, n) {
            var r = this.getStrokeScaling() ? null : n && n.internal ? this : this._parent || this._symbol && this._symbol._item, l = r ? r.getViewMatrix().invert() : i;
            return l && l._shiftless();
          },
          statics: {
            _updateBoundsCache: function(i, n) {
              if (i && n) {
                var r = n._id, l = i._boundsCache = i._boundsCache || {
                  ids: {},
                  list: []
                };
                l.ids[r] || (l.list.push(n), l.ids[r] = n);
              }
            },
            _clearBoundsCache: function(i) {
              var n = i._boundsCache;
              if (n) {
                i._bounds = i._position = i._boundsCache = t;
                for (var r = 0, l = n.list, h = l.length; r < h; r++) {
                  var f = l[r];
                  f !== i && (f._bounds = f._position = t, f._boundsCache && K._clearBoundsCache(f));
                }
              }
            },
            _getBounds: function(i, n, r) {
              var l = 1 / 0, h = -l, f = l, m = h, _ = !1;
              r = r || {};
              for (var y = 0, x = i.length; y < x; y++) {
                var A = i[y];
                if (A._visible && !A.isEmpty(!0)) {
                  var B = A._getCachedBounds(
                    n && n.appended(A._matrix),
                    r,
                    !0
                  ), C = B.rect;
                  l = Math.min(C.x, l), f = Math.min(C.y, f), h = Math.max(C.x + C.width, h), m = Math.max(C.y + C.height, m), B.nonscaling && (_ = !0);
                }
              }
              return {
                rect: isFinite(l) ? new se(l, f, h - l, m - f) : new se(),
                nonscaling: _
              };
            }
          }
        }
      ),
      {
        beans: !0,
        _decompose: function() {
          return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        getRotation: function() {
          var i = this._decompose();
          return i ? i.rotation : 0;
        },
        setRotation: function(i) {
          var n = this.getRotation();
          if (n != null && i != null) {
            var r = this._decomposed;
            this.rotate(i - n), r && (r.rotation = i, this._decomposed = r);
          }
        },
        getScaling: function() {
          var i = this._decompose(), n = i && i.scaling;
          return new he(n ? n.x : 1, n ? n.y : 1, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), n = z.read(arguments, 0, { clone: !0, readNull: !0 });
          if (i && n && !i.equals(n)) {
            var r = this.getRotation(), l = this._decomposed, h = new ue(), f = Y.isZero;
            if (f(i.x) || f(i.y))
              h.translate(l.translation), r && h.rotate(r), h.scale(n.x, n.y), this._matrix.set(h);
            else {
              var m = this.getPosition(!0);
              h.translate(m), r && h.rotate(r), h.scale(n.x / i.x, n.y / i.y), r && h.rotate(-r), h.translate(m.negate()), this.transform(h);
            }
            l && (l.scaling = n, this._decomposed = l);
          }
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        getGlobalMatrix: function(i) {
          var n = this._globalMatrix;
          if (n)
            for (var r = this._parent, l = []; r; ) {
              if (!r._globalMatrix) {
                n = null;
                for (var h = 0, f = l.length; h < f; h++)
                  l[h]._globalMatrix = null;
                break;
              }
              l.push(r), r = r._parent;
            }
          if (!n) {
            n = this._globalMatrix = this._matrix.clone();
            var r = this._parent;
            r && n.prepend(r.getGlobalMatrix(!0));
          }
          return i ? n : n.clone();
        },
        getViewMatrix: function() {
          return this.getGlobalMatrix().prepend(this.getView()._matrix);
        },
        getApplyMatrix: function() {
          return this._applyMatrix;
        },
        setApplyMatrix: function(i) {
          (this._applyMatrix = this._canApplyMatrix && !!i) && this.transform(null, !0);
        },
        getTransformContent: "#getApplyMatrix",
        setTransformContent: "#setApplyMatrix"
      },
      {
        getProject: function() {
          return this._project;
        },
        _setProject: function(i, n) {
          if (this._project !== i) {
            this._project && this._installEvents(!1), this._project = i;
            for (var r = this._children, l = 0, h = r && r.length; l < h; l++)
              r[l]._setProject(i);
            n = !0;
          }
          n && this._installEvents(!0);
        },
        getView: function() {
          return this._project._view;
        },
        _installEvents: function i(n) {
          i.base.call(this, n);
          for (var r = this._children, l = 0, h = r && r.length; l < h; l++)
            r[l]._installEvents(n);
        },
        getLayer: function() {
          for (var i = this; i = i._parent; )
            if (i instanceof ht)
              return i;
          return null;
        },
        getParent: function() {
          return this._parent;
        },
        setParent: function(i) {
          return i.addChild(this);
        },
        _getOwner: "#getParent",
        getChildren: function() {
          return this._children;
        },
        setChildren: function(i) {
          this.removeChildren(), this.addChildren(i);
        },
        getFirstChild: function() {
          return this._children && this._children[0] || null;
        },
        getLastChild: function() {
          return this._children && this._children[this._children.length - 1] || null;
        },
        getNextSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index + 1] || null;
        },
        getPreviousSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index - 1] || null;
        },
        getIndex: function() {
          return this._index;
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._style.equals(i._style) && this._matrix.equals(i._matrix) && this._locked === i._locked && this._visible === i._visible && this._blendMode === i._blendMode && this._opacity === i._opacity && this._clipMask === i._clipMask && this._guide === i._guide && this._equals(i) || !1;
        },
        _equals: function(i) {
          return a.equals(this._children, i._children);
        },
        clone: function(i) {
          var n = new this.constructor(K.NO_INSERT), r = this._children, l = a.pick(
            i ? i.insert : t,
            i === t || i === !0
          ), h = a.pick(i ? i.deep : t, !0);
          r && n.copyAttributes(this), (!r || h) && n.copyContent(this), r || n.copyAttributes(this), l && n.insertAbove(this);
          var f = this._name, m = this._parent;
          if (f && m) {
            for (var r = m._children, _ = f, y = 1; r[f]; )
              f = _ + " " + y++;
            f !== _ && n.setName(f);
          }
          return n;
        },
        copyContent: function(i) {
          for (var n = i._children, r = 0, l = n && n.length; r < l; r++)
            this.addChild(n[r].clone(!1), !0);
        },
        copyAttributes: function(i, n) {
          this.setStyle(i._style);
          for (var r = [
            "_locked",
            "_visible",
            "_blendMode",
            "_opacity",
            "_clipMask",
            "_guide"
          ], l = 0, h = r.length; l < h; l++) {
            var f = r[l];
            i.hasOwnProperty(f) && (this[f] = i[f]);
          }
          n || this._matrix.set(i._matrix, !0), this.setApplyMatrix(i._applyMatrix), this.setPivot(i._pivot), this.setSelection(i._selection);
          var m = i._data, _ = i._name;
          this._data = m ? a.clone(m) : null, _ && this.setName(_);
        },
        rasterize: function(i, n) {
          var r, l, h;
          a.isPlainObject(i) ? (r = i.resolution, l = i.insert, h = i.raster) : (r = i, l = n), h || (h = new pt(K.NO_INSERT));
          var f = this.getStrokeBounds(), m = (r || this.getView().getResolution()) / 72, _ = f.getTopLeft().floor(), y = f.getBottomRight().ceil(), x = new ne(y.subtract(_)), A = x.multiply(m);
          if (h.setSize(A, !0), !A.isZero()) {
            var B = h.getContext(!0), C = new ue().scale(m).translate(_.negate());
            B.save(), C.applyToContext(B), this.draw(B, new a({ matrices: [C] })), B.restore();
          }
          return h._matrix.set(
            new ue().translate(_.add(x.divide(2))).scale(1 / m)
          ), (l === t || l) && h.insertAbove(this), h;
        },
        contains: function() {
          var i = this._matrix;
          return i.isInvertible() && !!this._contains(i._inverseTransform(z.read(arguments)));
        },
        _contains: function(i) {
          var n = this._children;
          if (n) {
            for (var r = n.length - 1; r >= 0; r--)
              if (n[r].contains(i))
                return !0;
            return !1;
          }
          return i.isInside(this.getInternalBounds());
        },
        isInside: function() {
          return se.read(arguments).contains(this.getBounds());
        },
        _asPathItem: function() {
          return new Bt.Rectangle({
            rectangle: this.getInternalBounds(),
            matrix: this._matrix,
            insert: !1
          });
        },
        intersects: function(i, n) {
          return i instanceof K ? this._asPathItem().getIntersections(
            i._asPathItem(),
            null,
            n,
            !0
          ).length > 0 : !1;
        }
      },
      new function() {
        function i() {
          var l = arguments;
          return this._hitTest(
            z.read(l),
            Tt.getOptions(l)
          );
        }
        function n() {
          var l = arguments, h = z.read(l), f = Tt.getOptions(l), m = [];
          return this._hitTest(h, new a({ all: m }, f)), m;
        }
        function r(l, h, f, m) {
          var _ = this._children;
          if (_)
            for (var y = _.length - 1; y >= 0; y--) {
              var x = _[y], A = x !== m && x._hitTest(
                l,
                h,
                f
              );
              if (A && !h.all)
                return A;
            }
          return null;
        }
        return Ee.inject({
          hitTest: i,
          hitTestAll: n,
          _hitTest: r
        }), {
          hitTest: i,
          hitTestAll: n,
          _hitTestChildren: r
        };
      }(),
      {
        _hitTest: function(i, n, r) {
          if (this._locked || !this._visible || this._guide && !n.guides || this.isEmpty())
            return null;
          var l = this._matrix, h = r ? r.appended(l) : this.getGlobalMatrix().prepend(this.getView()._matrix), f = Math.max(n.tolerance, 1e-12), m = n._tolerancePadding = new ne(
            Bt._getStrokePadding(
              f,
              l._shiftless().invert()
            )
          );
          if (i = l._inverseTransform(i), !i || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(m.multiply(2))._containsPoint(i))
            return null;
          var _ = !(n.guides && !this._guide || n.selected && !this.isSelected() || n.type && n.type !== a.hyphenate(this._class) || n.class && !(this instanceof n.class)), y = n.match, x = this, A, B;
          function C(S) {
            return S && y && !y(S) && (S = null), S && n.all && n.all.push(S), S;
          }
          function M(S, I) {
            var U = I ? A["get" + I]() : x.getPosition();
            if (i.subtract(U).divide(m).length <= 1)
              return new Tt(S, x, {
                name: I ? a.hyphenate(I) : S,
                point: U
              });
          }
          var R = n.position, E = n.center, D = n.bounds;
          if (_ && this._parent && (R || E || D)) {
            if ((E || D) && (A = this.getInternalBounds()), B = R && M("position") || E && M("center", "Center"), !B && D)
              for (var L = [
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ], P = 0; P < 8 && !B; P++)
                B = M("bounds", L[P]);
            B = C(B);
          }
          return B || (B = this._hitTestChildren(i, n, h) || _ && C(this._hitTestSelf(
            i,
            n,
            h,
            this.getStrokeScaling() ? null : h._shiftless().invert()
          )) || null), B && B.point && (B.point = l.transform(B.point)), B;
        },
        _hitTestSelf: function(i, n) {
          if (n.fill && this.hasFill() && this._contains(i))
            return new Tt("fill", this);
        },
        matches: function(i, n) {
          function r(m, _) {
            for (var y in m)
              if (m.hasOwnProperty(y)) {
                var x = m[y], A = _[y];
                if (a.isPlainObject(x) && a.isPlainObject(A)) {
                  if (!r(x, A))
                    return !1;
                } else if (!a.equals(x, A))
                  return !1;
              }
            return !0;
          }
          var l = typeof i;
          if (l === "object") {
            for (var h in i)
              if (i.hasOwnProperty(h) && !this.matches(h, i[h]))
                return !1;
            return !0;
          } else {
            if (l === "function")
              return i(this);
            if (i === "match")
              return n(this);
            var f = /^(empty|editable)$/.test(i) ? this["is" + a.capitalize(i)]() : i === "type" ? a.hyphenate(this._class) : this[i];
            if (i === "class") {
              if (typeof n == "function")
                return this instanceof n;
              f = this._class;
            }
            if (typeof n == "function")
              return !!n(f);
            if (n) {
              if (n.test)
                return n.test(f);
              if (a.isPlainObject(n))
                return r(n, f);
            }
            return a.equals(f, n);
          }
        },
        getItems: function(i) {
          return K._getItems(this, i, this._matrix);
        },
        getItem: function(i) {
          return K._getItems(this, i, this._matrix, null, !0)[0] || null;
        },
        statics: {
          _getItems: function i(n, r, l, h, f) {
            if (!h) {
              var m = typeof r == "object" && r, _ = m && m.overlapping, y = m && m.inside, x = _ || y, C = x && se.read([x]);
              h = {
                items: [],
                recursive: m && m.recursive !== !1,
                inside: !!y,
                overlapping: !!_,
                rect: C,
                path: _ && new Bt.Rectangle({
                  rectangle: C,
                  insert: !1
                })
              }, m && (r = a.filter({}, r, {
                recursive: !0,
                inside: !0,
                overlapping: !0
              }));
            }
            var A = n._children, B = h.items, C = h.rect;
            l = C && (l || new ue());
            for (var M = 0, R = A && A.length; M < R; M++) {
              var E = A[M], D = l && l.appended(E._matrix), L = !0;
              if (C) {
                var x = E.getBounds(D);
                if (!C.intersects(x))
                  continue;
                C.contains(x) || h.overlapping && (x.contains(C) || h.path.intersects(E, D)) || (L = !1);
              }
              if (L && E.matches(r) && (B.push(E), f) || (h.recursive !== !1 && i(E, r, D, h, f), f && B.length > 0))
                break;
            }
            return B;
          }
        }
      },
      {
        importJSON: function(i) {
          var n = a.importJSON(i, this);
          return n !== this ? this.addChild(n) : n;
        },
        addChild: function(i) {
          return this.insertChild(t, i);
        },
        insertChild: function(i, n) {
          var r = n ? this.insertChildren(i, [n]) : null;
          return r && r[0];
        },
        addChildren: function(i) {
          return this.insertChildren(this._children.length, i);
        },
        insertChildren: function(i, n) {
          var r = this._children;
          if (r && n && n.length > 0) {
            n = a.slice(n);
            for (var l = {}, h = n.length - 1; h >= 0; h--) {
              var f = n[h], m = f && f._id;
              !f || l[m] ? n.splice(h, 1) : (f._remove(!1, !0), l[m] = !0);
            }
            a.splice(r, n, i, 0);
            for (var _ = this._project, y = _._changes, h = 0, x = n.length; h < x; h++) {
              var f = n[h], A = f._name;
              f._parent = this, f._setProject(_, !0), A && f.setName(A), y && f._changed(5);
            }
            this._changed(11);
          } else
            n = null;
          return n;
        },
        _insertItem: "#insertChild",
        _insertAt: function(i, n) {
          var r = i && i._getOwner(), l = i !== this && r ? this : null;
          return l && (l._remove(!1, !0), r._insertItem(i._index + n, l)), l;
        },
        insertAbove: function(i) {
          return this._insertAt(i, 1);
        },
        insertBelow: function(i) {
          return this._insertAt(i, 0);
        },
        sendToBack: function() {
          var i = this._getOwner();
          return i ? i._insertItem(0, this) : null;
        },
        bringToFront: function() {
          var i = this._getOwner();
          return i ? i._insertItem(t, this) : null;
        },
        appendTop: "#addChild",
        appendBottom: function(i) {
          return this.insertChild(0, i);
        },
        moveAbove: "#insertAbove",
        moveBelow: "#insertBelow",
        addTo: function(i) {
          return i._insertItem(t, this);
        },
        copyTo: function(i) {
          return this.clone(!1).addTo(i);
        },
        reduce: function(i) {
          var n = this._children;
          if (n && n.length === 1) {
            var r = n[0].reduce(i);
            return this._parent ? (r.insertAbove(this), this.remove()) : r.remove(), r;
          }
          return this;
        },
        _removeNamed: function() {
          var i = this._getOwner();
          if (i) {
            var n = i._children, r = i._namedChildren, l = this._name, h = r[l], f = h ? h.indexOf(this) : -1;
            f !== -1 && (n[l] == this && delete n[l], h.splice(f, 1), h.length ? n[l] = h[0] : delete r[l]);
          }
        },
        _remove: function(i, n) {
          var r = this._getOwner(), l = this._project, h = this._index;
          return this._style && this._style._dispose(), r ? (this._name && this._removeNamed(), h != null && (l._activeLayer === this && (l._activeLayer = this.getNextSibling() || this.getPreviousSibling()), a.splice(r._children, null, h, 1)), this._installEvents(!1), i && l._changes && this._changed(5), n && r._changed(11, this), this._parent = null, !0) : !1;
        },
        remove: function() {
          return this._remove(!0, !0);
        },
        replaceWith: function(i) {
          var n = i && i.insertBelow(this);
          return n && this.remove(), n;
        },
        removeChildren: function(i, n) {
          if (!this._children)
            return null;
          i = i || 0, n = a.pick(n, this._children.length);
          for (var r = a.splice(this._children, null, i, n - i), l = r.length - 1; l >= 0; l--)
            r[l]._remove(!0, !1);
          return r.length > 0 && this._changed(11), r;
        },
        clear: "#removeChildren",
        reverseChildren: function() {
          if (this._children) {
            this._children.reverse();
            for (var i = 0, n = this._children.length; i < n; i++)
              this._children[i]._index = i;
            this._changed(11);
          }
        },
        isEmpty: function(i) {
          var n = this._children, r = n ? n.length : 0;
          if (i) {
            for (var l = 0; l < r; l++)
              if (!n[l].isEmpty(i))
                return !1;
            return !0;
          }
          return !r;
        },
        isEditable: function() {
          for (var i = this; i; ) {
            if (!i._visible || i._locked)
              return !1;
            i = i._parent;
          }
          return !0;
        },
        hasFill: function() {
          return this.getStyle().hasFill();
        },
        hasStroke: function() {
          return this.getStyle().hasStroke();
        },
        hasShadow: function() {
          return this.getStyle().hasShadow();
        },
        _getOrder: function(i) {
          function n(m) {
            var _ = [];
            do
              _.unshift(m);
            while (m = m._parent);
            return _;
          }
          for (var r = n(this), l = n(i), h = 0, f = Math.min(r.length, l.length); h < f; h++)
            if (r[h] != l[h])
              return r[h]._index < l[h]._index ? 1 : -1;
          return 0;
        },
        hasChildren: function() {
          return this._children && this._children.length > 0;
        },
        isInserted: function() {
          return this._parent ? this._parent.isInserted() : !1;
        },
        isAbove: function(i) {
          return this._getOrder(i) === -1;
        },
        isBelow: function(i) {
          return this._getOrder(i) === 1;
        },
        isParent: function(i) {
          return this._parent === i;
        },
        isChild: function(i) {
          return i && i._parent === this;
        },
        isDescendant: function(i) {
          for (var n = this; n = n._parent; )
            if (n === i)
              return !0;
          return !1;
        },
        isAncestor: function(i) {
          return i ? i.isDescendant(this) : !1;
        },
        isSibling: function(i) {
          return this._parent === i._parent;
        },
        isGroupedWith: function(i) {
          for (var n = this._parent; n; ) {
            if (n._parent && /^(Group|Layer|CompoundPath)$/.test(n._class) && i.isDescendant(n))
              return !0;
            n = n._parent;
          }
          return !1;
        }
      },
      a.each(["rotate", "scale", "shear", "skew"], function(i) {
        var n = i === "rotate";
        this[i] = function() {
          var r = arguments, l = (n ? a : z).read(r), h = z.read(r, 0, { readNull: !0 });
          return this.transform(new ue()[i](
            l,
            h || this.getPosition(!0)
          ));
        };
      }, {
        translate: function() {
          var i = new ue();
          return this.transform(i.translate.apply(i, arguments));
        },
        transform: function(i, n, r) {
          var l = this._matrix, h = i && !i.isIdentity(), f = r && this._canApplyMatrix || this._applyMatrix && (h || !l.isIdentity() || n && this._children);
          if (!h && !f)
            return this;
          if (h) {
            !i.isInvertible() && l.isInvertible() && (l._backup = l.getValues()), l.prepend(i, !0);
            var m = this._style, _ = m.getFillColor(!0), y = m.getStrokeColor(!0);
            _ && _.transform(i), y && y.transform(i);
          }
          if (f && (f = this._transformContent(
            l,
            n,
            r
          ))) {
            var x = this._pivot;
            x && l._transformPoint(x, x, !0), l.reset(!0), r && this._canApplyMatrix && (this._applyMatrix = !0);
          }
          var A = this._bounds, B = this._position;
          (h || f) && this._changed(25);
          var C = h && A && i.decompose();
          if (C && C.skewing.isZero() && C.rotation % 90 === 0) {
            for (var M in A) {
              var R = A[M];
              if (R.nonscaling)
                delete A[M];
              else if (f || !R.internal) {
                var E = R.rect;
                i._transformBounds(E, E);
              }
            }
            this._bounds = A;
            var D = A[this._getBoundsCacheKey(
              this._boundsOptions || {}
            )];
            D && (this._position = this._getPositionFromBounds(D.rect));
          } else
            h && B && this._pivot && (this._position = i._transformPoint(B, B));
          return this;
        },
        _transformContent: function(i, n, r) {
          var l = this._children;
          if (l) {
            for (var h = 0, f = l.length; h < f; h++)
              l[h].transform(i, n, r);
            return !0;
          }
        },
        globalToLocal: function() {
          return this.getGlobalMatrix(!0)._inverseTransform(
            z.read(arguments)
          );
        },
        localToGlobal: function() {
          return this.getGlobalMatrix(!0)._transformPoint(
            z.read(arguments)
          );
        },
        parentToLocal: function() {
          return this._matrix._inverseTransform(z.read(arguments));
        },
        localToParent: function() {
          return this._matrix._transformPoint(z.read(arguments));
        },
        fitBounds: function(i, n) {
          i = se.read(arguments);
          var r = this.getBounds(), l = r.height / r.width, h = i.height / i.width, f = (n ? l > h : l < h) ? i.width / r.width : i.height / r.height, m = new se(
            new z(),
            new ne(r.width * f, r.height * f)
          );
          m.setCenter(i.getCenter()), this.setBounds(m);
        }
      }),
      {
        _setStyles: function(i, n, r) {
          var l = this._style, h = this._matrix;
          if (l.hasFill() && (i.fillStyle = l.getFillColor().toCanvasStyle(i, h)), l.hasStroke()) {
            i.strokeStyle = l.getStrokeColor().toCanvasStyle(i, h), i.lineWidth = l.getStrokeWidth();
            var f = l.getStrokeJoin(), m = l.getStrokeCap(), _ = l.getMiterLimit();
            if (f && (i.lineJoin = f), m && (i.lineCap = m), _ && (i.miterLimit = _), nt.support.nativeDash) {
              var y = l.getDashArray(), x = l.getDashOffset();
              y && y.length && ("setLineDash" in i ? (i.setLineDash(y), i.lineDashOffset = x) : (i.mozDash = y, i.mozDashOffset = x));
            }
          }
          if (l.hasShadow()) {
            var A = n.pixelRatio || 1, B = r._shiftless().prepend(
              new ue().scale(A, A)
            ), C = B.transform(new z(l.getShadowBlur(), 0)), M = B.transform(this.getShadowOffset());
            i.shadowColor = l.getShadowColor().toCanvasStyle(i), i.shadowBlur = C.getLength(), i.shadowOffsetX = M.x, i.shadowOffsetY = M.y;
          }
        },
        draw: function(i, n, r) {
          if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
            var l = n.matrices, h = n.viewMatrix, f = this._matrix, m = l[l.length - 1].appended(f);
            if (m.isInvertible()) {
              h = h ? h.appended(m) : m, l.push(m), n.updateMatrix && (this._globalMatrix = m);
              var _ = this._blendMode, y = Y.clamp(this._opacity, 0, 1), x = _ === "normal", A = ki.nativeModes[_], B = x && y === 1 || n.dontStart || n.clip || (A || x && y < 1) && this._canComposite(), C = n.pixelRatio || 1, M, R, E;
              if (!B) {
                var D = this.getStrokeBounds(h);
                if (!D.width || !D.height) {
                  l.pop();
                  return;
                }
                E = n.offset, R = n.offset = D.getTopLeft().floor(), M = i, i = Ut.getContext(D.getSize().ceil().add(1).multiply(C)), C !== 1 && i.scale(C, C);
              }
              i.save();
              var L = r ? r.appended(f) : this._canScaleStroke && !this.getStrokeScaling(!0) && h, P = !B && n.clipItem, S = !L || P;
              if (B ? (i.globalAlpha = y, A && (i.globalCompositeOperation = _)) : S && i.translate(-R.x, -R.y), S && (B ? f : h).applyToContext(i), P && n.clipItem.draw(i, n.extend({ clip: !0 })), L) {
                i.setTransform(C, 0, 0, C, 0, 0);
                var I = n.offset;
                I && i.translate(-I.x, -I.y);
              }
              this._draw(i, n, h, L), i.restore(), l.pop(), n.clip && !n.dontFinish && i.clip(this.getFillRule()), B || (ki.process(
                _,
                i,
                M,
                y,
                R.subtract(E).multiply(C)
              ), Ut.release(i), n.offset = E);
            }
          }
        },
        _isUpdated: function(i) {
          var n = this._parent;
          if (n instanceof yi)
            return n._isUpdated(i);
          var r = this._updateVersion === i;
          return !r && n && n._visible && n._isUpdated(i) && (this._updateVersion = i, r = !0), r;
        },
        _drawSelection: function(i, n, r, l, h) {
          var f = this._selection, m = f & 1, _ = f & 2 || m && this._selectBounds, y = f & 4;
          if (this._drawSelected || (m = !1), (m || _ || y) && this._isUpdated(h)) {
            var x, A = this.getSelectedColor(!0) || (x = this.getLayer()) && x.getSelectedColor(!0), B = n.appended(this.getGlobalMatrix(!0)), C = r / 2;
            if (i.strokeStyle = i.fillStyle = A ? A.toCanvasStyle(i) : "#009dec", m && this._drawSelected(i, B, l), y) {
              var M = this.getPosition(!0), R = this._parent, E = R ? R.localToGlobal(M) : M, D = E.x, L = E.y;
              i.beginPath(), i.arc(D, L, C, 0, Math.PI * 2, !0), i.stroke();
              for (var P = [[0, -1], [1, 0], [0, 1], [-1, 0]], S = C, I = r + 1, U = 0; U < 4; U++) {
                var V = P[U], F = V[0], W = V[1];
                i.moveTo(D + F * S, L + W * S), i.lineTo(D + F * I, L + W * I), i.stroke();
              }
            }
            if (_) {
              var Q = B._transformCorners(this.getInternalBounds());
              i.beginPath();
              for (var U = 0; U < 8; U++)
                i[U ? "lineTo" : "moveTo"](Q[U], Q[++U]);
              i.closePath(), i.stroke();
              for (var U = 0; U < 8; U++)
                i.fillRect(
                  Q[U] - C,
                  Q[++U] - C,
                  r,
                  r
                );
            }
          }
        },
        _canComposite: function() {
          return !1;
        }
      },
      a.each(["down", "drag", "up", "move"], function(i) {
        this["removeOn" + a.capitalize(i)] = function() {
          var n = {};
          return n[i] = !0, this.removeOn(n);
        };
      }, {
        removeOn: function(i) {
          for (var n in i)
            if (i[n]) {
              var r = "mouse" + n, l = this._project, h = l._removeSets = l._removeSets || {};
              h[r] = h[r] || {}, h[r][this._id] = this;
            }
          return this;
        }
      }),
      {
        tween: function(i, n, r) {
          r || (r = n, n = i, i = null, r || (r = n, n = null));
          var l = r && r.easing, h = r && r.start, f = r != null && (typeof r == "number" ? r : r.duration), m = new Js(this, i, n, f, l, h);
          function _(y) {
            m._handleFrame(y.time * 1e3), m.running || this.off("frame", _);
          }
          return f && this.on("frame", _), m;
        },
        tweenTo: function(i, n) {
          return this.tween(null, i, n);
        },
        tweenFrom: function(i, n) {
          return this.tween(i, null, n);
        }
      }
    ), j = K.extend({
      _class: "Group",
      _selectBounds: !1,
      _selectChildren: !0,
      _serializeFields: {
        children: []
      },
      initialize: function(n) {
        this._children = [], this._namedChildren = {}, this._initialize(n) || this.addChildren(Array.isArray(n) ? n : arguments);
      },
      _changed: function i(n) {
        i.base.call(this, n), n & 2050 && (this._clipItem = t);
      },
      _getClipItem: function() {
        var i = this._clipItem;
        if (i === t) {
          i = null;
          for (var n = this._children, r = 0, l = n.length; r < l; r++)
            if (n[r]._clipMask) {
              i = n[r];
              break;
            }
          this._clipItem = i;
        }
        return i;
      },
      isClipped: function() {
        return !!this._getClipItem();
      },
      setClipped: function(i) {
        var n = this.getFirstChild();
        n && n.setClipMask(i);
      },
      _getBounds: function i(n, r) {
        var l = this._getClipItem();
        return l ? l._getCachedBounds(
          l._matrix.prepended(n),
          a.set({}, r, { stroke: !1 })
        ) : i.base.call(this, n, r);
      },
      _hitTestChildren: function i(n, r, l) {
        var h = this._getClipItem();
        return (!h || h.contains(n)) && i.base.call(
          this,
          n,
          r,
          l,
          h
        );
      },
      _draw: function(i, n) {
        var r = n.clip, l = !r && this._getClipItem();
        n = n.extend({ clipItem: l, clip: !1 }), r ? (i.beginPath(), n.dontStart = n.dontFinish = !0) : l && l.draw(i, n.extend({ clip: !0 }));
        for (var h = this._children, f = 0, m = h.length; f < m; f++) {
          var _ = h[f];
          _ !== l && _.draw(i, n);
        }
      }
    }), ht = j.extend({
      _class: "Layer",
      initialize: function() {
        j.apply(this, arguments);
      },
      _getOwner: function() {
        return this._parent || this._index != null && this._project;
      },
      isInserted: function i() {
        return this._parent ? i.base.call(this) : this._index != null;
      },
      activate: function() {
        this._project._activeLayer = this;
      },
      _hitTestSelf: function() {
      }
    }), Ze = K.extend(
      {
        _class: "Shape",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _canScaleStroke: !0,
        _serializeFields: {
          type: null,
          size: null,
          radius: null
        },
        initialize: function(n, r) {
          this._initialize(n, r);
        },
        _equals: function(i) {
          return this._type === i._type && this._size.equals(i._size) && a.equals(this._radius, i._radius);
        },
        copyContent: function(i) {
          this.setType(i._type), this.setSize(i._size), this.setRadius(i._radius);
        },
        getType: function() {
          return this._type;
        },
        setType: function(i) {
          this._type = i;
        },
        getShape: "#getType",
        setShape: "#setType",
        getSize: function() {
          var i = this._size;
          return new ye(i.width, i.height, this, "setSize");
        },
        setSize: function() {
          var i = ne.read(arguments);
          if (!this._size)
            this._size = i.clone();
          else if (!this._size.equals(i)) {
            var n = this._type, r = i.width, l = i.height;
            n === "rectangle" ? this._radius.set(ne.min(this._radius, i.divide(2).abs())) : n === "circle" ? (r = l = (r + l) / 2, this._radius = r / 2) : n === "ellipse" && this._radius._set(r / 2, l / 2), this._size._set(r, l), this._changed(9);
          }
        },
        getRadius: function() {
          var i = this._radius;
          return this._type === "circle" ? i : new ye(i.width, i.height, this, "setRadius");
        },
        setRadius: function(i) {
          var n = this._type;
          if (n === "circle") {
            if (i === this._radius)
              return;
            var r = i * 2;
            this._radius = i, this._size._set(r, r);
          } else if (i = ne.read(arguments), !this._radius)
            this._radius = i.clone();
          else {
            if (this._radius.equals(i))
              return;
            if (this._radius.set(i), n === "rectangle") {
              var r = ne.max(this._size, i.multiply(2));
              this._size.set(r);
            } else
              n === "ellipse" && this._size._set(i.width * 2, i.height * 2);
          }
          this._changed(9);
        },
        isEmpty: function() {
          return !1;
        },
        toPath: function(i) {
          var n = new Bt[a.capitalize(this._type)]({
            center: new z(),
            size: this._size,
            radius: this._radius,
            insert: !1
          });
          return n.copyAttributes(this), nt.settings.applyMatrix && n.setApplyMatrix(!0), (i === t || i) && n.insertAbove(this), n;
        },
        toShape: "#clone",
        _asPathItem: function() {
          return this.toPath(!1);
        },
        _draw: function(i, n, r, l) {
          var h = this._style, f = h.hasFill(), m = h.hasStroke(), _ = n.dontFinish || n.clip, y = !l;
          if (f || m || _) {
            var x = this._type, A = this._radius, B = x === "circle";
            if (n.dontStart || i.beginPath(), y && B)
              i.arc(0, 0, A, 0, Math.PI * 2, !0);
            else {
              var C = B ? A : A.width, M = B ? A : A.height, R = this._size, E = R.width, D = R.height;
              if (y && x === "rectangle" && C === 0 && M === 0)
                i.rect(-E / 2, -D / 2, E, D);
              else {
                var L = E / 2, P = D / 2, S = 1 - 0.5522847498307936, I = C * S, U = M * S, V = [
                  -L,
                  -P + M,
                  -L,
                  -P + U,
                  -L + I,
                  -P,
                  -L + C,
                  -P,
                  L - C,
                  -P,
                  L - I,
                  -P,
                  L,
                  -P + U,
                  L,
                  -P + M,
                  L,
                  P - M,
                  L,
                  P - U,
                  L - I,
                  P,
                  L - C,
                  P,
                  -L + C,
                  P,
                  -L + I,
                  P,
                  -L,
                  P - U,
                  -L,
                  P - M
                ];
                l && l.transform(V, V, 32), i.moveTo(V[0], V[1]), i.bezierCurveTo(V[2], V[3], V[4], V[5], V[6], V[7]), L !== C && i.lineTo(V[8], V[9]), i.bezierCurveTo(V[10], V[11], V[12], V[13], V[14], V[15]), P !== M && i.lineTo(V[16], V[17]), i.bezierCurveTo(V[18], V[19], V[20], V[21], V[22], V[23]), L !== C && i.lineTo(V[24], V[25]), i.bezierCurveTo(V[26], V[27], V[28], V[29], V[30], V[31]);
              }
            }
            i.closePath();
          }
          !_ && (f || m) && (this._setStyles(i, n, r), f && (i.fill(h.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), m && i.stroke());
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _getBounds: function(i, n) {
          var r = new se(this._size).setCenter(0, 0), l = this._style, h = n.stroke && l.hasStroke() && l.getStrokeWidth();
          return i && (r = i._transformBounds(r)), h ? r.expand(Bt._getStrokePadding(
            h,
            this._getStrokeMatrix(i, n)
          )) : r;
        }
      },
      new function() {
        function i(r, l, h) {
          var f = r._radius;
          if (!f.isZero())
            for (var m = r._size.divide(2), _ = 1; _ <= 4; _++) {
              var y = new z(_ > 1 && _ < 4 ? -1 : 1, _ > 2 ? -1 : 1), x = y.multiply(m), A = x.subtract(y.multiply(f)), B = new se(
                h ? x.add(y.multiply(h)) : x,
                A
              );
              if (B.contains(l))
                return { point: A, quadrant: _ };
            }
        }
        function n(r, l, h, f) {
          var m = r.divide(l);
          return (!f || m.isInQuadrant(f)) && m.subtract(m.normalize()).multiply(l).divide(h).length <= 1;
        }
        return {
          _contains: function r(l) {
            if (this._type === "rectangle") {
              var h = i(this, l);
              return h ? l.subtract(h.point).divide(this._radius).getLength() <= 1 : r.base.call(this, l);
            } else
              return l.divide(this.size).getLength() <= 0.5;
          },
          _hitTestSelf: function r(l, h, f, m) {
            var _ = !1, y = this._style, x = h.stroke && y.hasStroke(), A = h.fill && y.hasFill();
            if (x || A) {
              var B = this._type, C = this._radius, M = x ? y.getStrokeWidth() / 2 : 0, R = h._tolerancePadding.add(
                Bt._getStrokePadding(
                  M,
                  !y.getStrokeScaling() && m
                )
              );
              if (B === "rectangle") {
                var E = R.multiply(2), D = i(this, l, E);
                if (D)
                  _ = n(
                    l.subtract(D.point),
                    C,
                    R,
                    D.quadrant
                  );
                else {
                  var L = new se(this._size).setCenter(0, 0), P = L.expand(E), S = L.expand(E.negate());
                  _ = P._containsPoint(l) && !S._containsPoint(l);
                }
              } else
                _ = n(l, C, R);
            }
            return _ ? new Tt(x ? "stroke" : "fill", this) : r.base.apply(this, arguments);
          }
        };
      }(),
      {
        statics: new function() {
          function i(n, r, l, h, f) {
            var m = a.create(Ze.prototype);
            return m._type = n, m._size = l, m._radius = h, m._initialize(a.getNamed(f), r), m;
          }
          return {
            Circle: function() {
              var n = arguments, r = z.readNamed(n, "center"), l = a.readNamed(n, "radius");
              return i(
                "circle",
                r,
                new ne(l * 2),
                l,
                n
              );
            },
            Rectangle: function() {
              var n = arguments, r = se.readNamed(n, "rectangle"), l = ne.min(
                ne.readNamed(n, "radius"),
                r.getSize(!0).divide(2)
              );
              return i(
                "rectangle",
                r.getCenter(!0),
                r.getSize(!0),
                l,
                n
              );
            },
            Ellipse: function() {
              var n = arguments, r = Ze._readEllipse(n), l = r.radius;
              return i(
                "ellipse",
                r.center,
                l.multiply(2),
                l,
                n
              );
            },
            _readEllipse: function(n) {
              var r, l;
              if (a.hasNamed(n, "radius"))
                r = z.readNamed(n, "center"), l = ne.readNamed(n, "radius");
              else {
                var h = se.readNamed(n, "rectangle");
                r = h.getCenter(!0), l = h.getSize(!0).divide(2);
              }
              return { center: r, radius: l };
            }
          };
        }()
      }
    ), pt = K.extend({
      _class: "Raster",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !1, handle: !1 },
      _serializeFields: {
        crossOrigin: null,
        source: null
      },
      _prioritize: ["crossOrigin"],
      _smoothing: "low",
      beans: !0,
      initialize: function(n, r) {
        if (!this._initialize(
          n,
          r !== t && z.read(arguments)
        )) {
          var l, h = typeof n, f = h === "string" ? o.getElementById(n) : h === "object" ? n : null;
          if (f && f !== K.NO_INSERT) {
            if (f.getContext || f.naturalHeight != null)
              l = f;
            else if (f) {
              var m = ne.read(arguments);
              m.isZero() || (l = Ut.getCanvas(m));
            }
          }
          l ? this.setImage(l) : this.setSource(n);
        }
        this._size || (this._size = new ne(), this._loaded = !1);
      },
      _equals: function(i) {
        return this.getSource() === i.getSource();
      },
      copyContent: function(i) {
        var n = i._image, r = i._canvas;
        if (n)
          this._setImage(n);
        else if (r) {
          var l = Ut.getCanvas(i._size);
          l.getContext("2d").drawImage(r, 0, 0), this._setImage(l);
        }
        this._crossOrigin = i._crossOrigin;
      },
      getSize: function() {
        var i = this._size;
        return new ye(
          i ? i.width : 0,
          i ? i.height : 0,
          this,
          "setSize"
        );
      },
      setSize: function(i, n) {
        var r = ne.read(arguments);
        if (r.equals(this._size))
          n && this.clear();
        else if (r.width > 0 && r.height > 0) {
          var l = !n && this.getElement();
          this._setImage(Ut.getCanvas(r)), l && this.getContext(!0).drawImage(
            l,
            0,
            0,
            r.width,
            r.height
          );
        } else
          this._canvas && Ut.release(this._canvas), this._size = r.clone();
      },
      getWidth: function() {
        return this._size ? this._size.width : 0;
      },
      setWidth: function(i) {
        this.setSize(i, this.getHeight());
      },
      getHeight: function() {
        return this._size ? this._size.height : 0;
      },
      setHeight: function(i) {
        this.setSize(this.getWidth(), i);
      },
      getLoaded: function() {
        return this._loaded;
      },
      isEmpty: function() {
        var i = this._size;
        return !i || i.width === 0 && i.height === 0;
      },
      getResolution: function() {
        var i = this._matrix, n = new z(0, 0).transform(i), r = new z(1, 0).transform(i).subtract(n), l = new z(0, 1).transform(i).subtract(n);
        return new ne(
          72 / r.getLength(),
          72 / l.getLength()
        );
      },
      getPpi: "#getResolution",
      getImage: function() {
        return this._image;
      },
      setImage: function(i) {
        var n = this;
        function r(l) {
          var h = n.getView(), f = l && l.type || "load";
          h && n.responds(f) && (nt = h._scope, n.emit(f, new Ln(l)));
        }
        this._setImage(i), this._loaded ? setTimeout(r, 0) : i && Dt.add(i, {
          load: function(l) {
            n._setImage(i), r(l);
          },
          error: r
        });
      },
      _setImage: function(i) {
        this._canvas && Ut.release(this._canvas), i && i.getContext ? (this._image = null, this._canvas = i, this._loaded = !0) : (this._image = i, this._canvas = null, this._loaded = !!(i && i.src && i.complete)), this._size = new ne(
          i ? i.naturalWidth || i.width : 0,
          i ? i.naturalHeight || i.height : 0
        ), this._context = null, this._changed(1033);
      },
      getCanvas: function() {
        if (!this._canvas) {
          var i = Ut.getContext(this._size);
          try {
            this._image && i.drawImage(this._image, 0, 0), this._canvas = i.canvas;
          } catch {
            Ut.release(i);
          }
        }
        return this._canvas;
      },
      setCanvas: "#setImage",
      getContext: function(i) {
        return this._context || (this._context = this.getCanvas().getContext("2d")), i && (this._image = null, this._changed(1025)), this._context;
      },
      setContext: function(i) {
        this._context = i;
      },
      getSource: function() {
        var i = this._image;
        return i && i.src || this.toDataURL();
      },
      setSource: function(i) {
        var n = new e.Image(), r = this._crossOrigin;
        r && (n.crossOrigin = r), i && (n.src = i), this.setImage(n);
      },
      getCrossOrigin: function() {
        var i = this._image;
        return i && i.crossOrigin || this._crossOrigin || "";
      },
      setCrossOrigin: function(i) {
        this._crossOrigin = i;
        var n = this._image;
        n && (n.crossOrigin = i);
      },
      getSmoothing: function() {
        return this._smoothing;
      },
      setSmoothing: function(i) {
        this._smoothing = typeof i == "string" ? i : i ? "low" : "off", this._changed(257);
      },
      getElement: function() {
        return this._canvas || this._loaded && this._image;
      }
    }, {
      beans: !1,
      getSubCanvas: function() {
        var i = se.read(arguments), n = Ut.getContext(i.getSize());
        return n.drawImage(
          this.getCanvas(),
          i.x,
          i.y,
          i.width,
          i.height,
          0,
          0,
          i.width,
          i.height
        ), n.canvas;
      },
      getSubRaster: function() {
        var i = se.read(arguments), n = new pt(K.NO_INSERT);
        return n._setImage(this.getSubCanvas(i)), n.translate(i.getCenter().subtract(this.getSize().divide(2))), n._matrix.prepend(this._matrix), n.insertAbove(this), n;
      },
      toDataURL: function() {
        var i = this._image, n = i && i.src;
        if (/^data:/.test(n))
          return n;
        var r = this.getCanvas();
        return r ? r.toDataURL.apply(r, arguments) : null;
      },
      drawImage: function(i) {
        var n = z.read(arguments, 1);
        this.getContext(!0).drawImage(i, n.x, n.y);
      },
      getAverageColor: function(i) {
        var n, r;
        if (i ? i instanceof Ft ? (r = i, n = i.getBounds()) : typeof i == "object" && ("width" in i ? n = new se(i) : "x" in i && (n = new se(i.x - 0.5, i.y - 0.5, 1, 1))) : n = this.getBounds(), !n)
          return null;
        var l = 32, h = Math.min(n.width, l), f = Math.min(n.height, l), m = pt._sampleContext;
        m ? m.clearRect(0, 0, l + 1, l + 1) : m = pt._sampleContext = Ut.getContext(
          new ne(l)
        ), m.save();
        var _ = new ue().scale(h / n.width, f / n.height).translate(-n.x, -n.y);
        _.applyToContext(m), r && r.draw(m, new a({ clip: !0, matrices: [_] })), this._matrix.applyToContext(m);
        var y = this.getElement(), x = this._size;
        y && m.drawImage(y, -x.width / 2, -x.height / 2), m.restore();
        for (var A = m.getImageData(
          0.5,
          0.5,
          Math.ceil(h),
          Math.ceil(f)
        ).data, B = [0, 0, 0], C = 0, M = 0, R = A.length; M < R; M += 4) {
          var E = A[M + 3];
          C += E, E /= 255, B[0] += A[M] * E, B[1] += A[M + 1] * E, B[2] += A[M + 2] * E;
        }
        for (var M = 0; M < 3; M++)
          B[M] /= C;
        return C ? qt.read(B) : null;
      },
      getPixel: function() {
        var i = z.read(arguments), n = this.getContext().getImageData(i.x, i.y, 1, 1).data;
        return new qt(
          "rgb",
          [n[0] / 255, n[1] / 255, n[2] / 255],
          n[3] / 255
        );
      },
      setPixel: function() {
        var i = arguments, n = z.read(i), r = qt.read(i), l = r._convert("rgb"), h = r._alpha, f = this.getContext(!0), m = f.createImageData(1, 1), _ = m.data;
        _[0] = l[0] * 255, _[1] = l[1] * 255, _[2] = l[2] * 255, _[3] = h != null ? h * 255 : 255, f.putImageData(m, n.x, n.y);
      },
      clear: function() {
        var i = this._size;
        this.getContext(!0).clearRect(0, 0, i.width + 1, i.height + 1);
      },
      createImageData: function() {
        var i = ne.read(arguments);
        return this.getContext().createImageData(i.width, i.height);
      },
      getImageData: function() {
        var i = se.read(arguments);
        return i.isEmpty() && (i = new se(this._size)), this.getContext().getImageData(
          i.x,
          i.y,
          i.width,
          i.height
        );
      },
      putImageData: function(i) {
        var n = z.read(arguments, 1);
        this.getContext(!0).putImageData(i, n.x, n.y);
      },
      setImageData: function(i) {
        this.setSize(i), this.getContext(!0).putImageData(i, 0, 0);
      },
      _getBounds: function(i, n) {
        var r = new se(this._size).setCenter(0, 0);
        return i ? i._transformBounds(r) : r;
      },
      _hitTestSelf: function(i) {
        if (this._contains(i)) {
          var n = this;
          return new Tt("pixel", n, {
            offset: i.add(n._size.divide(2)).round(),
            color: {
              get: function() {
                return n.getPixel(this.offset);
              }
            }
          });
        }
      },
      _draw: function(i, n, r) {
        var l = this.getElement();
        if (l && l.width > 0 && l.height > 0) {
          i.globalAlpha = Y.clamp(this._opacity, 0, 1), this._setStyles(i, n, r);
          var h = this._smoothing, f = h === "off";
          zt.setPrefixed(
            i,
            f ? "imageSmoothingEnabled" : "imageSmoothingQuality",
            f ? !1 : h
          ), i.drawImage(
            l,
            -this._size.width / 2,
            -this._size.height / 2
          );
        }
      },
      _canComposite: function() {
        return !0;
      }
    }), Pt = K.extend({
      _class: "SymbolItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !0 },
      _serializeFields: {
        symbol: null
      },
      initialize: function(n, r) {
        this._initialize(
          n,
          r !== t && z.read(arguments, 1)
        ) || this.setDefinition(n instanceof Mt ? n : new Mt(n));
      },
      _equals: function(i) {
        return this._definition === i._definition;
      },
      copyContent: function(i) {
        this.setDefinition(i._definition);
      },
      getDefinition: function() {
        return this._definition;
      },
      setDefinition: function(i) {
        this._definition = i, this._changed(9);
      },
      getSymbol: "#getDefinition",
      setSymbol: "#setDefinition",
      isEmpty: function() {
        return this._definition._item.isEmpty();
      },
      _getBounds: function(i, n) {
        var r = this._definition._item;
        return r._getCachedBounds(r._matrix.prepended(i), n);
      },
      _hitTestSelf: function(i, n, r) {
        var l = n.extend({ all: !1 }), h = this._definition._item._hitTest(i, l, r);
        return h && (h.item = this), h;
      },
      _draw: function(i, n) {
        this._definition._item.draw(i, n);
      }
    }), Mt = a.extend({
      _class: "SymbolDefinition",
      initialize: function(n, r) {
        this._id = ee.get(), this.project = nt.project, n && this.setItem(n, r);
      },
      _serialize: function(i, n) {
        return n.add(this, function() {
          return a.serialize(
            [this._class, this._item],
            i,
            !1,
            n
          );
        });
      },
      _changed: function(i) {
        i & 8 && K._clearBoundsCache(this), i & 1 && this.project._changed(i);
      },
      getItem: function() {
        return this._item;
      },
      setItem: function(i, n) {
        i._symbol && (i = i.clone()), this._item && (this._item._symbol = null), this._item = i, i.remove(), i.setSelected(!1), n || i.setPosition(new z()), i._symbol = this, this._changed(9);
      },
      getDefinition: "#getItem",
      setDefinition: "#setItem",
      place: function(i) {
        return new Pt(this, i);
      },
      clone: function() {
        return new Mt(this._item.clone(!1));
      },
      equals: function(i) {
        return i === this || i && this._item.equals(i._item) || !1;
      }
    }), Tt = a.extend({
      _class: "HitResult",
      initialize: function(n, r, l) {
        this.type = n, this.item = r, l && this.inject(l);
      },
      statics: {
        getOptions: function(i) {
          var n = i && a.read(i);
          return new a({
            type: null,
            tolerance: nt.settings.hitTolerance,
            fill: !n,
            stroke: !n,
            segments: !n,
            handles: !1,
            ends: !1,
            position: !1,
            center: !1,
            bounds: !1,
            guides: !1,
            selected: !1
          }, n);
        }
      }
    }), at = a.extend({
      _class: "Segment",
      beans: !0,
      _selection: 0,
      initialize: function(n, r, l, h, f, m) {
        var _ = arguments.length, y, x, A, B;
        _ > 0 && (n == null || typeof n == "object" ? _ === 1 && n && "point" in n ? (y = n.point, x = n.handleIn, A = n.handleOut, B = n.selection) : (y = n, x = r, A = l, B = h) : (y = [n, r], x = l !== t ? [l, h] : null, A = f !== t ? [f, m] : null)), new Ai(y, this, "_point"), new Ai(x, this, "_handleIn"), new Ai(A, this, "_handleOut"), B && this.setSelection(B);
      },
      _serialize: function(i, n) {
        var r = this._point, l = this._selection, h = l || this.hasHandles() ? [r, this._handleIn, this._handleOut] : r;
        return l && h.push(l), a.serialize(h, i, !0, n);
      },
      _changed: function(i) {
        var n = this._path;
        if (n) {
          var r = n._curves, l = this._index, h;
          r && ((!i || i === this._point || i === this._handleIn) && (h = l > 0 ? r[l - 1] : n._closed ? r[r.length - 1] : null) && h._changed(), (!i || i === this._point || i === this._handleOut) && (h = r[l]) && h._changed()), n._changed(41);
        }
      },
      getPoint: function() {
        return this._point;
      },
      setPoint: function() {
        this._point.set(z.read(arguments));
      },
      getHandleIn: function() {
        return this._handleIn;
      },
      setHandleIn: function() {
        this._handleIn.set(z.read(arguments));
      },
      getHandleOut: function() {
        return this._handleOut;
      },
      setHandleOut: function() {
        this._handleOut.set(z.read(arguments));
      },
      hasHandles: function() {
        return !this._handleIn.isZero() || !this._handleOut.isZero();
      },
      isSmooth: function() {
        var i = this._handleIn, n = this._handleOut;
        return !i.isZero() && !n.isZero() && i.isCollinear(n);
      },
      clearHandles: function() {
        this._handleIn._set(0, 0), this._handleOut._set(0, 0);
      },
      getSelection: function() {
        return this._selection;
      },
      setSelection: function(i) {
        var n = this._selection, r = this._path;
        this._selection = i = i || 0, r && i !== n && (r._updateSelection(this, n, i), r._changed(257));
      },
      _changeSelection: function(i, n) {
        var r = this._selection;
        this.setSelection(n ? r | i : r & ~i);
      },
      isSelected: function() {
        return !!(this._selection & 7);
      },
      setSelected: function(i) {
        this._changeSelection(7, i);
      },
      getIndex: function() {
        return this._index !== t ? this._index : null;
      },
      getPath: function() {
        return this._path || null;
      },
      getCurve: function() {
        var i = this._path, n = this._index;
        return i ? (n > 0 && !i._closed && n === i._segments.length - 1 && n--, i.getCurves()[n] || null) : null;
      },
      getLocation: function() {
        var i = this.getCurve();
        return i ? new Ot(i, this === i._segment1 ? 0 : 1) : null;
      },
      getNext: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index + 1] || this._path._closed && i[0]) || null;
      },
      smooth: function(i, n, r) {
        var l = i || {}, h = l.type, f = l.factor, m = this.getPrevious(), _ = this.getNext(), y = (m || this)._point, x = this._point, A = (_ || this)._point, B = y.getDistance(x), C = x.getDistance(A);
        if (!h || h === "catmull-rom") {
          var M = f === t ? 0.5 : f, R = Math.pow(B, M), E = R * R, D = Math.pow(C, M), L = D * D;
          if (!n && m) {
            var P = 2 * L + 3 * D * R + E, S = 3 * D * (D + R);
            this.setHandleIn(S !== 0 ? new z(
              (L * y._x + P * x._x - E * A._x) / S - x._x,
              (L * y._y + P * x._y - E * A._y) / S - x._y
            ) : new z());
          }
          if (!r && _) {
            var P = 2 * E + 3 * R * D + L, S = 3 * R * (R + D);
            this.setHandleOut(S !== 0 ? new z(
              (E * A._x + P * x._x - L * y._x) / S - x._x,
              (E * A._y + P * x._y - L * y._y) / S - x._y
            ) : new z());
          }
        } else if (h === "geometric") {
          if (m && _) {
            var I = y.subtract(A), U = f === t ? 0.4 : f, V = U * B / (B + C);
            n || this.setHandleIn(I.multiply(V)), r || this.setHandleOut(I.multiply(V - U));
          }
        } else
          throw new Error("Smoothing method '" + h + "' not supported.");
      },
      getPrevious: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index - 1] || this._path._closed && i[i.length - 1]) || null;
      },
      isFirst: function() {
        return !this._index;
      },
      isLast: function() {
        var i = this._path;
        return i && this._index === i._segments.length - 1 || !1;
      },
      reverse: function() {
        var i = this._handleIn, n = this._handleOut, r = i.clone();
        i.set(n), n.set(r);
      },
      reversed: function() {
        return new at(this._point, this._handleOut, this._handleIn);
      },
      remove: function() {
        return this._path ? !!this._path.removeSegment(this._index) : !1;
      },
      clone: function() {
        return new at(this._point, this._handleIn, this._handleOut);
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._point.equals(i._point) && this._handleIn.equals(i._handleIn) && this._handleOut.equals(i._handleOut) || !1;
      },
      toString: function() {
        var i = ["point: " + this._point];
        return this._handleIn.isZero() || i.push("handleIn: " + this._handleIn), this._handleOut.isZero() || i.push("handleOut: " + this._handleOut), "{ " + i.join(", ") + " }";
      },
      transform: function(i) {
        this._transformCoordinates(i, new Array(6), !0), this._changed();
      },
      interpolate: function(i, n, r) {
        var l = 1 - r, h = r, f = i._point, m = n._point, _ = i._handleIn, y = n._handleIn, x = n._handleOut, A = i._handleOut;
        this._point._set(
          l * f._x + h * m._x,
          l * f._y + h * m._y,
          !0
        ), this._handleIn._set(
          l * _._x + h * y._x,
          l * _._y + h * y._y,
          !0
        ), this._handleOut._set(
          l * A._x + h * x._x,
          l * A._y + h * x._y,
          !0
        ), this._changed();
      },
      _transformCoordinates: function(i, n, r) {
        var l = this._point, h = !r || !this._handleIn.isZero() ? this._handleIn : null, f = !r || !this._handleOut.isZero() ? this._handleOut : null, m = l._x, _ = l._y, y = 2;
        return n[0] = m, n[1] = _, h && (n[y++] = h._x + m, n[y++] = h._y + _), f && (n[y++] = f._x + m, n[y++] = f._y + _), i && (i._transformCoordinates(n, n, y / 2), m = n[0], _ = n[1], r ? (l._x = m, l._y = _, y = 2, h && (h._x = n[y++] - m, h._y = n[y++] - _), f && (f._x = n[y++] - m, f._y = n[y++] - _)) : (h || (n[y++] = m, n[y++] = _), f || (n[y++] = m, n[y++] = _))), n;
      }
    }), Ai = z.extend({
      initialize: function(n, r, l) {
        var h, f, m;
        if (!n)
          h = f = 0;
        else if ((h = n[0]) !== t)
          f = n[1];
        else {
          var _ = n;
          (h = _.x) === t && (_ = z.read(arguments), h = _.x), f = _.y, m = _.selected;
        }
        this._x = h, this._y = f, this._owner = r, r[l] = this, m && this.setSelected(!0);
      },
      _set: function(i, n) {
        return this._x = i, this._y = n, this._owner._changed(this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner._changed(this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner._changed(this);
      },
      isZero: function() {
        var i = Y.isZero;
        return i(this._x) && i(this._y);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        var i = this._owner;
        return this === i._point ? 1 : this === i._handleIn ? 2 : this === i._handleOut ? 4 : 0;
      }
    }), Ve = a.extend(
      {
        _class: "Curve",
        beans: !0,
        initialize: function(n, r, l, h, f, m, _, y) {
          var x = arguments.length, A, B, C, M, R, E;
          x === 3 ? (this._path = n, A = r, B = l) : x ? x === 1 ? "segment1" in n ? (A = new at(n.segment1), B = new at(n.segment2)) : "point1" in n ? (C = n.point1, R = n.handle1, E = n.handle2, M = n.point2) : Array.isArray(n) && (C = [n[0], n[1]], M = [n[6], n[7]], R = [n[2] - n[0], n[3] - n[1]], E = [n[4] - n[6], n[5] - n[7]]) : x === 2 ? (A = new at(n), B = new at(r)) : x === 4 ? (C = n, R = r, E = l, M = h) : x === 8 && (C = [n, r], M = [_, y], R = [l - n, h - r], E = [f - _, m - y]) : (A = new at(), B = new at()), this._segment1 = A || new at(C, null, R), this._segment2 = B || new at(M, E, null);
        },
        _serialize: function(i, n) {
          return a.serialize(
            this.hasHandles() ? [
              this.getPoint1(),
              this.getHandle1(),
              this.getHandle2(),
              this.getPoint2()
            ] : [this.getPoint1(), this.getPoint2()],
            i,
            !0,
            n
          );
        },
        _changed: function() {
          this._length = this._bounds = t;
        },
        clone: function() {
          return new Ve(this._segment1, this._segment2);
        },
        toString: function() {
          var i = ["point1: " + this._segment1._point];
          return this._segment1._handleOut.isZero() || i.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || i.push("handle2: " + this._segment2._handleIn), i.push("point2: " + this._segment2._point), "{ " + i.join(", ") + " }";
        },
        classify: function() {
          return Ve.classify(this.getValues());
        },
        remove: function() {
          var i = !1;
          if (this._path) {
            var n = this._segment2, r = n._handleOut;
            i = n.remove(), i && this._segment1._handleOut.set(r);
          }
          return i;
        },
        getPoint1: function() {
          return this._segment1._point;
        },
        setPoint1: function() {
          this._segment1._point.set(z.read(arguments));
        },
        getPoint2: function() {
          return this._segment2._point;
        },
        setPoint2: function() {
          this._segment2._point.set(z.read(arguments));
        },
        getHandle1: function() {
          return this._segment1._handleOut;
        },
        setHandle1: function() {
          this._segment1._handleOut.set(z.read(arguments));
        },
        getHandle2: function() {
          return this._segment2._handleIn;
        },
        setHandle2: function() {
          this._segment2._handleIn.set(z.read(arguments));
        },
        getSegment1: function() {
          return this._segment1;
        },
        getSegment2: function() {
          return this._segment2;
        },
        getPath: function() {
          return this._path;
        },
        getIndex: function() {
          return this._segment1._index;
        },
        getNext: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index + 1] || this._path._closed && i[0]) || null;
        },
        getPrevious: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index - 1] || this._path._closed && i[i.length - 1]) || null;
        },
        isFirst: function() {
          return !this._segment1._index;
        },
        isLast: function() {
          var i = this._path;
          return i && this._segment1._index === i._curves.length - 1 || !1;
        },
        isSelected: function() {
          return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
        },
        setSelected: function(i) {
          this.getPoint1().setSelected(i), this.getHandle1().setSelected(i), this.getHandle2().setSelected(i), this.getPoint2().setSelected(i);
        },
        getValues: function(i) {
          return Ve.getValues(this._segment1, this._segment2, i);
        },
        getPoints: function() {
          for (var i = this.getValues(), n = [], r = 0; r < 8; r += 2)
            n.push(new z(i[r], i[r + 1]));
          return n;
        }
      },
      {
        getLength: function() {
          return this._length == null && (this._length = Ve.getLength(this.getValues(), 0, 1)), this._length;
        },
        getArea: function() {
          return Ve.getArea(this.getValues());
        },
        getLine: function() {
          return new xe(this._segment1._point, this._segment2._point);
        },
        getPart: function(i, n) {
          return new Ve(Ve.getPart(this.getValues(), i, n));
        },
        getPartLength: function(i, n) {
          return Ve.getLength(this.getValues(), i, n);
        },
        divideAt: function(i) {
          return this.divideAtTime(i && i.curve === this ? i.time : this.getTimeAt(i));
        },
        divideAtTime: function(i, n) {
          var r = 1e-8, l = 1 - r, h = null;
          if (i >= r && i <= l) {
            var f = Ve.subdivide(this.getValues(), i), m = f[0], _ = f[1], y = n || this.hasHandles(), x = this._segment1, A = this._segment2, B = this._path;
            y && (x._handleOut._set(m[2] - m[0], m[3] - m[1]), A._handleIn._set(_[4] - _[6], _[5] - _[7]));
            var C = m[6], M = m[7], R = new at(
              new z(C, M),
              y && new z(m[4] - C, m[5] - M),
              y && new z(_[2] - C, _[3] - M)
            );
            B ? (B.insert(x._index + 1, R), h = this.getNext()) : (this._segment2 = R, this._changed(), h = new Ve(R, A));
          }
          return h;
        },
        splitAt: function(i) {
          var n = this._path;
          return n ? n.splitAt(i) : null;
        },
        splitAtTime: function(i) {
          return this.splitAt(this.getLocationAtTime(i));
        },
        divide: function(i, n) {
          return this.divideAtTime(i === t ? 0.5 : n ? i : this.getTimeAt(i));
        },
        split: function(i, n) {
          return this.splitAtTime(i === t ? 0.5 : n ? i : this.getTimeAt(i));
        },
        reversed: function() {
          return new Ve(this._segment2.reversed(), this._segment1.reversed());
        },
        clearHandles: function() {
          this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
        },
        statics: {
          getValues: function(i, n, r, l) {
            var h = i._point, f = i._handleOut, m = n._handleIn, _ = n._point, y = h.x, x = h.y, A = _.x, B = _.y, C = l ? [y, x, y, x, A, B, A, B] : [
              y,
              x,
              y + f._x,
              x + f._y,
              A + m._x,
              B + m._y,
              A,
              B
            ];
            return r && r._transformCoordinates(C, C, 4), C;
          },
          subdivide: function(i, n) {
            var r = i[0], l = i[1], h = i[2], f = i[3], m = i[4], _ = i[5], y = i[6], x = i[7];
            n === t && (n = 0.5);
            var A = 1 - n, B = A * r + n * h, C = A * l + n * f, M = A * h + n * m, R = A * f + n * _, E = A * m + n * y, D = A * _ + n * x, L = A * B + n * M, P = A * C + n * R, S = A * M + n * E, I = A * R + n * D, U = A * L + n * S, V = A * P + n * I;
            return [
              [r, l, B, C, L, P, U, V],
              [U, V, S, I, E, D, y, x]
            ];
          },
          getMonoCurves: function(i, n) {
            var r = [], l = n ? 0 : 1, h = i[l + 0], f = i[l + 2], m = i[l + 4], _ = i[l + 6];
            if (h >= f == f >= m && f >= m == m >= _ || Ve.isStraight(i))
              r.push(i);
            else {
              var y = 3 * (f - m) - h + _, x = 2 * (h + m) - 4 * f, A = f - h, B = 1e-8, C = 1 - B, M = [], R = Y.solveQuadratic(y, x, A, M, B, C);
              if (!R)
                r.push(i);
              else {
                M.sort();
                var E = M[0], D = Ve.subdivide(i, E);
                r.push(D[0]), R > 1 && (E = (M[1] - E) / (1 - E), D = Ve.subdivide(D[1], E), r.push(D[0])), r.push(D[1]);
              }
            }
            return r;
          },
          solveCubic: function(i, n, r, l, h, f) {
            var m = i[n], _ = i[n + 2], y = i[n + 4], x = i[n + 6], A = 0;
            if (!(m < r && x < r && _ < r && y < r || m > r && x > r && _ > r && y > r)) {
              var B = 3 * (_ - m), C = 3 * (y - _) - B, M = x - m - B - C;
              A = Y.solveCubic(M, C, B, m - r, l, h, f);
            }
            return A;
          },
          getTimeOf: function(i, n) {
            var r = new z(i[0], i[1]), l = new z(i[6], i[7]), h = 1e-12, f = 1e-7, m = n.isClose(r, h) ? 0 : n.isClose(l, h) ? 1 : null;
            if (m === null)
              for (var _ = [n.x, n.y], y = [], x = 0; x < 2; x++)
                for (var A = Ve.solveCubic(i, x, _[x], y, 0, 1), B = 0; B < A; B++) {
                  var C = y[B];
                  if (n.isClose(Ve.getPoint(i, C), f))
                    return C;
                }
            return n.isClose(r, f) ? 0 : n.isClose(l, f) ? 1 : null;
          },
          getNearestTime: function(i, n) {
            if (Ve.isStraight(i)) {
              var r = i[0], l = i[1], h = i[6], f = i[7], m = h - r, _ = f - l, y = m * m + _ * _;
              if (y === 0)
                return 0;
              var x = ((n.x - r) * m + (n.y - l) * _) / y;
              return x < 1e-12 ? 0 : x > 0.999999999999 ? 1 : Ve.getTimeOf(
                i,
                new z(r + x * m, l + x * _)
              );
            }
            var A = 100, B = 1 / 0, C = 0;
            function M(D) {
              if (D >= 0 && D <= 1) {
                var L = n.getDistance(Ve.getPoint(i, D), !0);
                if (L < B)
                  return B = L, C = D, !0;
              }
            }
            for (var R = 0; R <= A; R++)
              M(R / A);
            for (var E = 1 / (A * 2); E > 1e-8; )
              !M(C - E) && !M(C + E) && (E /= 2);
            return C;
          },
          getPart: function(i, n, r) {
            var l = n > r;
            if (l) {
              var h = n;
              n = r, r = h;
            }
            return n > 0 && (i = Ve.subdivide(i, n)[1]), r < 1 && (i = Ve.subdivide(i, (r - n) / (1 - n))[0]), l ? [i[6], i[7], i[4], i[5], i[2], i[3], i[0], i[1]] : i;
          },
          isFlatEnough: function(i, n) {
            var r = i[0], l = i[1], h = i[2], f = i[3], m = i[4], _ = i[5], y = i[6], x = i[7], A = 3 * h - 2 * r - y, B = 3 * f - 2 * l - x, C = 3 * m - 2 * y - r, M = 3 * _ - 2 * x - l;
            return Math.max(A * A, C * C) + Math.max(B * B, M * M) <= 16 * n * n;
          },
          getArea: function(i) {
            var n = i[0], r = i[1], l = i[2], h = i[3], f = i[4], m = i[5], _ = i[6], y = i[7];
            return 3 * ((y - r) * (l + f) - (_ - n) * (h + m) + h * (n - f) - l * (r - m) + y * (f + n / 3) - _ * (m + r / 3)) / 20;
          },
          getBounds: function(i) {
            for (var n = i.slice(0, 2), r = n.slice(), l = [0, 0], h = 0; h < 2; h++)
              Ve._addBounds(
                i[h],
                i[h + 2],
                i[h + 4],
                i[h + 6],
                h,
                0,
                n,
                r,
                l
              );
            return new se(n[0], n[1], r[0] - n[0], r[1] - n[1]);
          },
          _addBounds: function(i, n, r, l, h, f, m, _, y) {
            function x(U, V) {
              var F = U - V, W = U + V;
              F < m[h] && (m[h] = F), W > _[h] && (_[h] = W);
            }
            f /= 2;
            var A = m[h] + f, B = _[h] - f;
            if (i < A || n < A || r < A || l < A || i > B || n > B || r > B || l > B)
              if (n < i != n < l && r < i != r < l)
                x(i, 0), x(l, 0);
              else {
                var C = 3 * (n - r) - i + l, M = 2 * (i + r) - 4 * n, R = n - i, E = Y.solveQuadratic(C, M, R, y), D = 1e-8, L = 1 - D;
                x(l, 0);
                for (var P = 0; P < E; P++) {
                  var S = y[P], I = 1 - S;
                  D <= S && S <= L && x(
                    I * I * I * i + 3 * I * I * S * n + 3 * I * S * S * r + S * S * S * l,
                    f
                  );
                }
              }
          }
        }
      },
      a.each(
        ["getBounds", "getStrokeBounds", "getHandleBounds"],
        function(i) {
          this[i] = function() {
            this._bounds || (this._bounds = {});
            var n = this._bounds[i];
            return n || (n = this._bounds[i] = Bt[i](
              [this._segment1, this._segment2],
              !1,
              this._path
            )), n.clone();
          };
        },
        {}
      ),
      a.each({
        isStraight: function(i, n, r, l) {
          if (n.isZero() && r.isZero())
            return !0;
          var h = l.subtract(i);
          if (h.isZero())
            return !1;
          if (h.isCollinear(n) && h.isCollinear(r)) {
            var f = new xe(i, l), m = 1e-7;
            if (f.getDistance(i.add(n)) < m && f.getDistance(l.add(r)) < m) {
              var _ = h.dot(h), y = h.dot(n) / _, x = h.dot(r) / _;
              return y >= 0 && y <= 1 && x <= 0 && x >= -1;
            }
          }
          return !1;
        },
        isLinear: function(i, n, r, l) {
          var h = l.subtract(i).divide(3);
          return n.equals(h) && r.negate().equals(h);
        }
      }, function(i, n) {
        this[n] = function(r) {
          var l = this._segment1, h = this._segment2;
          return i(
            l._point,
            l._handleOut,
            h._handleIn,
            h._point,
            r
          );
        }, this.statics[n] = function(r, l) {
          var h = r[0], f = r[1], m = r[6], _ = r[7];
          return i(
            new z(h, f),
            new z(r[2] - h, r[3] - f),
            new z(r[4] - m, r[5] - _),
            new z(m, _),
            l
          );
        };
      }, {
        statics: {},
        hasHandles: function() {
          return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
        },
        hasLength: function(i) {
          return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (i || 0);
        },
        isCollinear: function(i) {
          return i && this.isStraight() && i.isStraight() && this.getLine().isCollinear(i.getLine());
        },
        isHorizontal: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
        },
        isVertical: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
        }
      }),
      {
        beans: !1,
        getLocationAt: function(i, n) {
          return this.getLocationAtTime(
            n ? i : this.getTimeAt(i)
          );
        },
        getLocationAtTime: function(i) {
          return i != null && i >= 0 && i <= 1 ? new Ot(this, i) : null;
        },
        getTimeAt: function(i, n) {
          return Ve.getTimeAt(this.getValues(), i, n);
        },
        getParameterAt: "#getTimeAt",
        getTimesWithTangent: function() {
          var i = z.read(arguments);
          return i.isZero() ? [] : Ve.getTimesWithTangent(this.getValues(), i);
        },
        getOffsetAtTime: function(i) {
          return this.getPartLength(0, i);
        },
        getLocationOf: function() {
          return this.getLocationAtTime(this.getTimeOf(z.read(arguments)));
        },
        getOffsetOf: function() {
          var i = this.getLocationOf.apply(this, arguments);
          return i ? i.getOffset() : null;
        },
        getTimeOf: function() {
          return Ve.getTimeOf(this.getValues(), z.read(arguments));
        },
        getParameterOf: "#getTimeOf",
        getNearestLocation: function() {
          var i = z.read(arguments), n = this.getValues(), r = Ve.getNearestTime(n, i), l = Ve.getPoint(n, r);
          return new Ot(this, r, l, null, i.getDistance(l));
        },
        getNearestPoint: function() {
          var i = this.getNearestLocation.apply(this, arguments);
          return i && i.getPoint();
        }
      },
      new function() {
        var i = [
          "getPoint",
          "getTangent",
          "getNormal",
          "getWeightedTangent",
          "getWeightedNormal",
          "getCurvature"
        ];
        return a.each(
          i,
          function(n) {
            this[n + "At"] = function(r, l) {
              var h = this.getValues();
              return Ve[n](h, l ? r : Ve.getTimeAt(h, r));
            }, this[n + "AtTime"] = function(r) {
              return Ve[n](this.getValues(), r);
            };
          },
          {
            statics: {
              _evaluateMethods: i
            }
          }
        );
      }(),
      new function() {
        function i(l) {
          var h = l[0], f = l[1], m = l[2], _ = l[3], y = l[4], x = l[5], A = l[6], B = l[7], C = 9 * (m - y) + 3 * (A - h), M = 6 * (h + y) - 12 * m, R = 3 * (m - h), E = 9 * (_ - x) + 3 * (B - f), D = 6 * (f + x) - 12 * _, L = 3 * (_ - f);
          return function(P) {
            var S = (C * P + M) * P + R, I = (E * P + D) * P + L;
            return Math.sqrt(S * S + I * I);
          };
        }
        function n(l, h) {
          return Math.max(2, Math.min(16, Math.ceil(Math.abs(h - l) * 32)));
        }
        function r(l, h, f, m) {
          if (h == null || h < 0 || h > 1)
            return null;
          var _ = l[0], y = l[1], x = l[2], A = l[3], B = l[4], C = l[5], M = l[6], R = l[7], E = Y.isZero;
          E(x - _) && E(A - y) && (x = _, A = y), E(B - M) && E(C - R) && (B = M, C = R);
          var D = 3 * (x - _), L = 3 * (B - x) - D, P = M - _ - D - L, S = 3 * (A - y), I = 3 * (C - A) - S, U = R - y - S - I, V, F;
          if (f === 0)
            V = h === 0 ? _ : h === 1 ? M : ((P * h + L) * h + D) * h + _, F = h === 0 ? y : h === 1 ? R : ((U * h + I) * h + S) * h + y;
          else {
            var W = 1e-8, Q = 1 - W;
            if (h < W ? (V = D, F = S) : h > Q ? (V = 3 * (M - B), F = 3 * (R - C)) : (V = (3 * P * h + 2 * L) * h + D, F = (3 * U * h + 2 * I) * h + S), m) {
              V === 0 && F === 0 && (h < W || h > Q) && (V = B - x, F = C - A);
              var ie = Math.sqrt(V * V + F * F);
              ie && (V /= ie, F /= ie);
            }
            if (f === 3) {
              var B = 6 * P * h + 2 * L, C = 6 * U * h + 2 * I, ae = Math.pow(V * V + F * F, 3 / 2);
              V = ae !== 0 ? (V * C - F * B) / ae : 0, F = 0;
            }
          }
          return f === 2 ? new z(F, -V) : new z(V, F);
        }
        return { statics: {
          classify: function(l) {
            var h = l[0], f = l[1], m = l[2], _ = l[3], y = l[4], x = l[5], A = l[6], B = l[7], C = h * (B - x) + f * (y - A) + A * x - B * y, M = m * (f - B) + _ * (A - h) + h * B - f * A, R = y * (_ - f) + x * (h - m) + m * f - _ * h, E = 3 * R, D = E - M, L = D - M + C, P = Math.sqrt(L * L + D * D + E * E), S = P !== 0 ? 1 / P : 0, I = Y.isZero, U = "serpentine";
            L *= S, D *= S, E *= S;
            function V(ie, ae, J) {
              var le = ae !== t, fe = le && ae > 0 && ae < 1, me = le && J > 0 && J < 1;
              return le && (!(fe || me) || ie === "loop" && !(fe && me)) && (ie = "arch", fe = me = !1), {
                type: ie,
                roots: fe || me ? fe && me ? ae < J ? [ae, J] : [J, ae] : [fe ? ae : J] : null
              };
            }
            if (I(L))
              return I(D) ? V(I(E) ? "line" : "quadratic") : V(U, E / (3 * D));
            var F = 3 * D * D - 4 * L * E;
            if (I(F))
              return V("cusp", D / (2 * L));
            var W = F > 0 ? Math.sqrt(F / 3) : Math.sqrt(-F), Q = 2 * L;
            return V(
              F > 0 ? U : "loop",
              (D + W) / Q,
              (D - W) / Q
            );
          },
          getLength: function(l, h, f, m) {
            if (h === t && (h = 0), f === t && (f = 1), Ve.isStraight(l)) {
              var _ = l;
              f < 1 && (_ = Ve.subdivide(_, f)[0], h /= f), h > 0 && (_ = Ve.subdivide(_, h)[1]);
              var y = _[6] - _[0], x = _[7] - _[1];
              return Math.sqrt(y * y + x * x);
            }
            return Y.integrate(
              m || i(l),
              h,
              f,
              n(h, f)
            );
          },
          getTimeAt: function(l, h, f) {
            if (f === t && (f = h < 0 ? 1 : 0), h === 0)
              return f;
            var m = Math.abs, _ = 1e-12, y = h > 0, x = y ? f : 0, A = y ? 1 : f, B = i(l), C = Ve.getLength(l, x, A, B), M = m(h) - C;
            if (m(M) < _)
              return y ? A : x;
            if (M > _)
              return null;
            var R = h / C, E = 0;
            function D(L) {
              return E += Y.integrate(
                B,
                f,
                L,
                n(f, L)
              ), f = L, E - h;
            }
            return Y.findRoot(
              D,
              B,
              f + R,
              x,
              A,
              32,
              1e-12
            );
          },
          getPoint: function(l, h) {
            return r(l, h, 0, !1);
          },
          getTangent: function(l, h) {
            return r(l, h, 1, !0);
          },
          getWeightedTangent: function(l, h) {
            return r(l, h, 1, !1);
          },
          getNormal: function(l, h) {
            return r(l, h, 2, !0);
          },
          getWeightedNormal: function(l, h) {
            return r(l, h, 2, !1);
          },
          getCurvature: function(l, h) {
            return r(l, h, 3, !1).x;
          },
          getPeaks: function(l) {
            var h = l[0], f = l[1], m = l[2], _ = l[3], y = l[4], x = l[5], A = l[6], B = l[7], C = -h + 3 * m - 3 * y + A, M = 3 * h - 6 * m + 3 * y, R = -3 * h + 3 * m, E = -f + 3 * _ - 3 * x + B, D = 3 * f - 6 * _ + 3 * x, L = -3 * f + 3 * _, P = 1e-8, S = 1 - P, I = [];
            return Y.solveCubic(
              9 * (C * C + E * E),
              9 * (C * M + D * E),
              2 * (M * M + D * D) + 3 * (R * C + L * E),
              R * M + D * L,
              I,
              P,
              S
            ), I.sort();
          }
        } };
      }(),
      new function() {
        function i(M, R, E, D, L, P, S) {
          var I = !S && E.getPrevious() === L, U = !S && E !== L && E.getNext() === L, V = 1e-8, F = 1 - V;
          if (D !== null && D >= (I ? V : 0) && D <= (U ? F : 1) && P !== null && P >= (U ? V : 0) && P <= (I ? F : 1)) {
            var W = new Ot(E, D, null, S), Q = new Ot(L, P, null, S);
            W._intersection = Q, Q._intersection = W, (!R || R(W)) && Ot.insert(M, W, !0);
          }
        }
        function n(M, R, E, D, L, P, S, I, U, V, F, W, Q) {
          if (++U >= 4096 || ++I >= 40)
            return U;
          var ie = 1e-9, ae = R[0], J = R[1], le = R[6], fe = R[7], me = xe.getSignedDistance, ve = me(ae, J, le, fe, R[2], R[3]), Se = me(ae, J, le, fe, R[4], R[5]), Re = ve * Se > 0 ? 3 / 4 : 4 / 9, He = Re * Math.min(0, ve, Se), Ye = Re * Math.max(0, ve, Se), Je = me(ae, J, le, fe, M[0], M[1]), Be = me(ae, J, le, fe, M[2], M[3]), Ie = me(ae, J, le, fe, M[4], M[5]), Ge = me(ae, J, le, fe, M[6], M[7]), et = r(Je, Be, Ie, Ge), tt = et[0], gt = et[1], ut, yt;
          if (ve === 0 && Se === 0 && Je === 0 && Be === 0 && Ie === 0 && Ge === 0 || (ut = l(tt, gt, He, Ye)) == null || (yt = l(
            tt.reverse(),
            gt.reverse(),
            He,
            Ye
          )) == null)
            return U;
          var At = V + (F - V) * ut, bt = V + (F - V) * yt;
          if (Math.max(Q - W, bt - At) < ie) {
            var li = (At + bt) / 2, mt = (W + Q) / 2;
            i(
              L,
              P,
              S ? D : E,
              S ? mt : li,
              S ? E : D,
              S ? li : mt
            );
          } else {
            M = Ve.getPart(M, ut, yt);
            var Zt = Q - W;
            if (yt - ut > 0.8)
              if (bt - At > Zt) {
                var Xt = Ve.subdivide(M, 0.5), li = (At + bt) / 2;
                U = n(
                  R,
                  Xt[0],
                  D,
                  E,
                  L,
                  P,
                  !S,
                  I,
                  U,
                  W,
                  Q,
                  At,
                  li
                ), U = n(
                  R,
                  Xt[1],
                  D,
                  E,
                  L,
                  P,
                  !S,
                  I,
                  U,
                  W,
                  Q,
                  li,
                  bt
                );
              } else {
                var Xt = Ve.subdivide(R, 0.5), mt = (W + Q) / 2;
                U = n(
                  Xt[0],
                  M,
                  D,
                  E,
                  L,
                  P,
                  !S,
                  I,
                  U,
                  W,
                  mt,
                  At,
                  bt
                ), U = n(
                  Xt[1],
                  M,
                  D,
                  E,
                  L,
                  P,
                  !S,
                  I,
                  U,
                  mt,
                  Q,
                  At,
                  bt
                );
              }
            else
              Zt === 0 || Zt >= ie ? U = n(
                R,
                M,
                D,
                E,
                L,
                P,
                !S,
                I,
                U,
                W,
                Q,
                At,
                bt
              ) : U = n(
                M,
                R,
                E,
                D,
                L,
                P,
                S,
                I,
                U,
                At,
                bt,
                W,
                Q
              );
          }
          return U;
        }
        function r(M, R, E, D) {
          var L = [0, M], P = [1 / 3, R], S = [2 / 3, E], I = [1, D], U = R - (2 * M + D) / 3, V = E - (M + 2 * D) / 3, F;
          if (U * V < 0)
            F = [[L, P, I], [L, S, I]];
          else {
            var W = U / V;
            F = [
              W >= 2 ? [L, P, I] : W <= 0.5 ? [L, S, I] : [L, P, S, I],
              [L, I]
            ];
          }
          return (U || V) < 0 ? F.reverse() : F;
        }
        function l(M, R, E, D) {
          return M[0][1] < E ? h(M, !0, E) : R[0][1] > D ? h(R, !1, D) : M[0][0];
        }
        function h(M, R, E) {
          for (var D = M[0][0], L = M[0][1], P = 1, S = M.length; P < S; P++) {
            var I = M[P][0], U = M[P][1];
            if (R ? U >= E : U <= E)
              return U === E ? I : D + (E - L) * (I - D) / (U - L);
            D = I, L = U;
          }
          return null;
        }
        function f(M, R, E, D, L) {
          var P = Y.isZero;
          if (P(D) && P(L)) {
            var S = Ve.getTimeOf(M, new z(R, E));
            return S === null ? [] : [S];
          }
          for (var I = Math.atan2(-L, D), U = Math.sin(I), V = Math.cos(I), F = [], W = [], Q = 0; Q < 8; Q += 2) {
            var ie = M[Q] - R, ae = M[Q + 1] - E;
            F.push(
              ie * V - ae * U,
              ie * U + ae * V
            );
          }
          return Ve.solveCubic(F, 1, 0, W, 0, 1), W;
        }
        function m(M, R, E, D, L, P, S) {
          for (var I = R[0], U = R[1], V = R[6], F = R[7], W = f(M, I, U, V - I, F - U), Q = 0, ie = W.length; Q < ie; Q++) {
            var ae = W[Q], J = Ve.getPoint(M, ae), le = Ve.getTimeOf(R, J);
            le !== null && i(
              L,
              P,
              S ? D : E,
              S ? le : ae,
              S ? E : D,
              S ? ae : le
            );
          }
        }
        function _(M, R, E, D, L, P) {
          var S = xe.intersect(
            M[0],
            M[1],
            M[6],
            M[7],
            R[0],
            R[1],
            R[6],
            R[7]
          );
          S && i(
            L,
            P,
            E,
            Ve.getTimeOf(M, S),
            D,
            Ve.getTimeOf(R, S)
          );
        }
        function y(M, R, E, D, L, P) {
          var S = 1e-12, I = Math.min, U = Math.max;
          if (U(M[0], M[2], M[4], M[6]) + S > I(R[0], R[2], R[4], R[6]) && I(M[0], M[2], M[4], M[6]) - S < U(R[0], R[2], R[4], R[6]) && U(M[1], M[3], M[5], M[7]) + S > I(R[1], R[3], R[5], R[7]) && I(M[1], M[3], M[5], M[7]) - S < U(R[1], R[3], R[5], R[7])) {
            var V = B(M, R);
            if (V)
              for (var F = 0; F < 2; F++) {
                var W = V[F];
                i(
                  L,
                  P,
                  E,
                  W[0],
                  D,
                  W[1],
                  !0
                );
              }
            else {
              var Q = Ve.isStraight(M), ie = Ve.isStraight(R), ae = Q && ie, J = Q && !ie, le = L.length;
              if ((ae ? _ : Q || ie ? m : n)(
                J ? R : M,
                J ? M : R,
                J ? D : E,
                J ? E : D,
                L,
                P,
                J,
                0,
                0,
                0,
                1,
                0,
                1
              ), !ae || L.length === le)
                for (var F = 0; F < 4; F++) {
                  var fe = F >> 1, me = F & 1, ve = fe * 6, Se = me * 6, Re = new z(M[ve], M[ve + 1]), He = new z(R[Se], R[Se + 1]);
                  Re.isClose(He, S) && i(
                    L,
                    P,
                    E,
                    fe,
                    D,
                    me
                  );
                }
            }
          }
          return L;
        }
        function x(M, R, E, D) {
          var L = Ve.classify(M);
          if (L.type === "loop") {
            var P = L.roots;
            i(
              E,
              D,
              R,
              P[0],
              R,
              P[1]
            );
          }
          return E;
        }
        function A(M, R, E, D, L, P) {
          var S = 1e-7, I = !R;
          I && (R = M);
          for (var U = M.length, V = R.length, F = new Array(U), W = I ? F : new Array(V), Q = [], ie = 0; ie < U; ie++)
            F[ie] = M[ie].getValues(D);
          if (!I)
            for (var ie = 0; ie < V; ie++)
              W[ie] = R[ie].getValues(L);
          for (var ae = T.findCurveBoundsCollisions(
            F,
            W,
            S
          ), J = 0; J < U; J++) {
            var le = M[J], fe = F[J];
            I && x(fe, le, Q, E);
            var me = ae[J];
            if (me)
              for (var ve = 0; ve < me.length; ve++) {
                if (P && Q.length)
                  return Q;
                var Se = me[ve];
                if (!I || Se > J) {
                  var Re = R[Se], He = W[Se];
                  y(
                    fe,
                    He,
                    le,
                    Re,
                    Q,
                    E
                  );
                }
              }
          }
          return Q;
        }
        function B(M, R) {
          function E(Ge) {
            var et = Ge[6] - Ge[0], tt = Ge[7] - Ge[1];
            return et * et + tt * tt;
          }
          var D = Math.abs, L = xe.getDistance, P = 1e-8, S = 1e-7, I = Ve.isStraight(M), U = Ve.isStraight(R), V = I && U, F = E(M) < E(R), W = F ? R : M, Q = F ? M : R, ie = W[0], ae = W[1], J = W[6] - ie, le = W[7] - ae;
          if (L(ie, ae, J, le, Q[0], Q[1], !0) < S && L(ie, ae, J, le, Q[6], Q[7], !0) < S)
            !V && L(ie, ae, J, le, W[2], W[3], !0) < S && L(ie, ae, J, le, W[4], W[5], !0) < S && L(ie, ae, J, le, Q[2], Q[3], !0) < S && L(ie, ae, J, le, Q[4], Q[5], !0) < S && (I = U = V = !0);
          else if (V)
            return null;
          if (I ^ U)
            return null;
          for (var fe = [M, R], me = [], ve = 0; ve < 4 && me.length < 2; ve++) {
            var Se = ve & 1, Re = Se ^ 1, He = ve >> 1, Ye = Ve.getTimeOf(fe[Se], new z(
              fe[Re][He ? 6 : 0],
              fe[Re][He ? 7 : 1]
            ));
            if (Ye != null) {
              var Je = Se ? [He, Ye] : [Ye, He];
              (!me.length || D(Je[0] - me[0][0]) > P && D(Je[1] - me[0][1]) > P) && me.push(Je);
            }
            if (ve > 2 && !me.length)
              break;
          }
          if (me.length !== 2)
            me = null;
          else if (!V) {
            var Be = Ve.getPart(M, me[0][0], me[1][0]), Ie = Ve.getPart(R, me[0][1], me[1][1]);
            (D(Ie[2] - Be[2]) > S || D(Ie[3] - Be[3]) > S || D(Ie[4] - Be[4]) > S || D(Ie[5] - Be[5]) > S) && (me = null);
          }
          return me;
        }
        function C(M, R) {
          var E = M[0], D = M[1], L = M[2], P = M[3], S = M[4], I = M[5], U = M[6], V = M[7], F = R.normalize(), W = F.x, Q = F.y, ie = 3 * U - 9 * S + 9 * L - 3 * E, ae = 3 * V - 9 * I + 9 * P - 3 * D, J = 6 * S - 12 * L + 6 * E, le = 6 * I - 12 * P + 6 * D, fe = 3 * L - 3 * E, me = 3 * P - 3 * D, ve = 2 * ie * Q - 2 * ae * W, Se = [];
          if (Math.abs(ve) < Y.CURVETIME_EPSILON) {
            var Re = ie * me - ae * fe, ve = ie * le - ae * J;
            if (ve != 0) {
              var He = -Re / ve;
              He >= 0 && He <= 1 && Se.push(He);
            }
          } else {
            var Ye = (J * J - 4 * ie * fe) * Q * Q + (-2 * J * le + 4 * ae * fe + 4 * ie * me) * W * Q + (le * le - 4 * ae * me) * W * W, Je = J * Q - le * W;
            if (Ye >= 0 && ve != 0) {
              var Be = Math.sqrt(Ye), Ie = -(Je + Be) / ve, Ge = (-Je + Be) / ve;
              Ie >= 0 && Ie <= 1 && Se.push(Ie), Ge >= 0 && Ge <= 1 && Se.push(Ge);
            }
          }
          return Se;
        }
        return {
          getIntersections: function(M) {
            var R = this.getValues(), E = M && M !== this && M.getValues();
            return E ? y(R, E, this, M, []) : x(R, this, []);
          },
          statics: {
            getOverlaps: B,
            getIntersections: A,
            getCurveLineIntersections: f,
            getTimesWithTangent: C
          }
        };
      }()
    ), Ot = a.extend(
      {
        _class: "CurveLocation",
        initialize: function(n, r, l, h, f) {
          if (r >= 0.99999999) {
            var m = n.getNext();
            m && (r = 0, n = m);
          }
          this._setCurve(n), this._time = r, this._point = l || n.getPointAtTime(r), this._overlap = h, this._distance = f, this._intersection = this._next = this._previous = null;
        },
        _setPath: function(i) {
          this._path = i, this._version = i ? i._version : 0;
        },
        _setCurve: function(i) {
          this._setPath(i._path), this._curve = i, this._segment = null, this._segment1 = i._segment1, this._segment2 = i._segment2;
        },
        _setSegment: function(i) {
          var n = i.getCurve();
          n ? this._setCurve(n) : (this._setPath(i._path), this._segment1 = i, this._segment2 = null), this._segment = i, this._time = i === this._segment1 ? 0 : 1, this._point = i._point.clone();
        },
        getSegment: function() {
          var i = this._segment;
          if (!i) {
            var n = this.getCurve(), r = this.getTime();
            r === 0 ? i = n._segment1 : r === 1 ? i = n._segment2 : r != null && (i = n.getPartLength(0, r) < n.getPartLength(r, 1) ? n._segment1 : n._segment2), this._segment = i;
          }
          return i;
        },
        getCurve: function() {
          var i = this._path, n = this;
          i && i._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
          function r(l) {
            var h = l && l.getCurve();
            if (h && (n._time = h.getTimeOf(n._point)) != null)
              return n._setCurve(h), h;
          }
          return this._curve || r(this._segment) || r(this._segment1) || r(this._segment2.getPrevious());
        },
        getPath: function() {
          var i = this.getCurve();
          return i && i._path;
        },
        getIndex: function() {
          var i = this.getCurve();
          return i && i.getIndex();
        },
        getTime: function() {
          var i = this.getCurve(), n = this._time;
          return i && n == null ? this._time = i.getTimeOf(this._point) : n;
        },
        getParameter: "#getTime",
        getPoint: function() {
          return this._point;
        },
        getOffset: function() {
          var i = this._offset;
          if (i == null) {
            i = 0;
            var n = this.getPath(), r = this.getIndex();
            if (n && r != null)
              for (var l = n.getCurves(), h = 0; h < r; h++)
                i += l[h].getLength();
            this._offset = i += this.getCurveOffset();
          }
          return i;
        },
        getCurveOffset: function() {
          var i = this._curveOffset;
          if (i == null) {
            var n = this.getCurve(), r = this.getTime();
            this._curveOffset = i = r != null && n && n.getPartLength(0, r);
          }
          return i;
        },
        getIntersection: function() {
          return this._intersection;
        },
        getDistance: function() {
          return this._distance;
        },
        divide: function() {
          var i = this.getCurve(), n = i && i.divideAtTime(this.getTime());
          return n && this._setSegment(n._segment1), n;
        },
        split: function() {
          var i = this.getCurve(), n = i._path, r = i && i.splitAtTime(this.getTime());
          return r && this._setSegment(n.getLastSegment()), r;
        },
        equals: function(i, n) {
          var r = this === i;
          if (!r && i instanceof Ot) {
            var l = this.getCurve(), h = i.getCurve(), f = l._path, m = h._path;
            if (f === m) {
              var _ = Math.abs, y = 1e-7, x = _(this.getOffset() - i.getOffset()), A = !n && this._intersection, B = !n && i._intersection;
              r = (x < y || f && _(f.getLength() - x) < y) && (!A && !B || A && B && A.equals(B, !0));
            }
          }
          return r;
        },
        toString: function() {
          var i = [], n = this.getPoint(), r = H.instance;
          n && i.push("point: " + n);
          var l = this.getIndex();
          l != null && i.push("index: " + l);
          var h = this.getTime();
          return h != null && i.push("time: " + r.number(h)), this._distance != null && i.push("distance: " + r.number(this._distance)), "{ " + i.join(", ") + " }";
        },
        isTouching: function() {
          var i = this._intersection;
          if (i && this.getTangent().isCollinear(i.getTangent())) {
            var n = this.getCurve(), r = i.getCurve();
            return !(n.isStraight() && r.isStraight() && n.getLine().intersect(r.getLine()));
          }
          return !1;
        },
        isCrossing: function() {
          var i = this._intersection;
          if (!i)
            return !1;
          var n = this.getTime(), r = i.getTime(), l = 1e-8, h = 1 - l, f = n >= l && n <= h, m = r >= l && r <= h;
          if (f && m)
            return !this.isTouching();
          var _ = this.getCurve(), y = _ && n < l ? _.getPrevious() : _, x = i.getCurve(), A = x && r < l ? x.getPrevious() : x;
          if (n > h && (_ = _.getNext()), r > h && (x = x.getNext()), !y || !_ || !A || !x)
            return !1;
          var B = [];
          function C(W, Q) {
            var ie = W.getValues(), ae = Ve.classify(ie).roots || Ve.getPeaks(ie), J = ae.length, le = Ve.getLength(
              ie,
              Q && J ? ae[J - 1] : 0,
              !Q && J ? ae[0] : 1
            );
            B.push(J ? le : le / 32);
          }
          function M(W, Q, ie) {
            return Q < ie ? W > Q && W < ie : W > Q || W < ie;
          }
          f || (C(y, !0), C(_, !1)), m || (C(A, !0), C(x, !1));
          var R = this.getPoint(), E = Math.min.apply(Math, B), D = f ? _.getTangentAtTime(n) : _.getPointAt(E).subtract(R), L = f ? D.negate() : y.getPointAt(-E).subtract(R), P = m ? x.getTangentAtTime(r) : x.getPointAt(E).subtract(R), S = m ? P.negate() : A.getPointAt(-E).subtract(R), I = L.getAngle(), U = D.getAngle(), V = S.getAngle(), F = P.getAngle();
          return !!(f ? M(I, V, F) ^ M(U, V, F) && M(I, F, V) ^ M(U, F, V) : M(V, I, U) ^ M(F, I, U) && M(V, U, I) ^ M(F, U, I));
        },
        hasOverlap: function() {
          return !!this._overlap;
        }
      },
      a.each(Ve._evaluateMethods, function(i) {
        var n = i + "At";
        this[i] = function() {
          var r = this.getCurve(), l = this.getTime();
          return l != null && r && r[n](l, !0);
        };
      }, {
        preserve: !0
      }),
      new function() {
        function i(n, r, l) {
          var h = n.length, f = 0, m = h - 1;
          function _(R, E) {
            for (var D = R + E; D >= -1 && D <= h; D += E) {
              var L = n[(D % h + h) % h];
              if (!r.getPoint().isClose(
                L.getPoint(),
                1e-7
              ))
                break;
              if (r.equals(L))
                return L;
            }
            return null;
          }
          for (; f <= m; ) {
            var y = f + m >>> 1, x = n[y], A;
            if (l && (A = r.equals(x) ? x : _(y, -1) || _(y, 1)))
              return r._overlap && (A._overlap = A._intersection._overlap = !0), A;
            var B = r.getPath(), C = x.getPath(), M = B !== C ? B._id - C._id : r.getIndex() + r.getTime() - (x.getIndex() + x.getTime());
            M < 0 ? m = y - 1 : f = y + 1;
          }
          return n.splice(f, 0, r), r;
        }
        return { statics: {
          insert: i,
          expand: function(n) {
            for (var r = n.slice(), l = n.length - 1; l >= 0; l--)
              i(r, n[l]._intersection, !1);
            return r;
          }
        } };
      }()
    ), Ft = K.extend({
      _class: "PathItem",
      _selectBounds: !1,
      _canScaleStroke: !0,
      beans: !0,
      initialize: function() {
      },
      statics: {
        create: function(i) {
          var n, r, l;
          if (a.isPlainObject(i) ? (r = i.segments, n = i.pathData) : Array.isArray(i) ? r = i : typeof i == "string" && (n = i), r) {
            var h = r[0];
            l = h && Array.isArray(h[0]);
          } else
            n && (l = (n.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(n));
          var f = l ? yi : Bt;
          return new f(i);
        }
      },
      _asPathItem: function() {
        return this;
      },
      isClockwise: function() {
        return this.getArea() >= 0;
      },
      setClockwise: function(i) {
        this.isClockwise() != (i = !!i) && this.reverse();
      },
      setPathData: function(i) {
        var n = i && i.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), r, l = !1, h, f, m = new z(), _ = new z();
        function y(S, I) {
          var U = +r[S];
          return l && (U += m[I]), U;
        }
        function x(S) {
          return new z(
            y(S, "x"),
            y(S + 1, "y")
          );
        }
        this.clear();
        for (var A = 0, B = n && n.length; A < B; A++) {
          var C = n[A], M = C[0], R = M.toLowerCase();
          r = C.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
          var E = r && r.length;
          switch (l = M === R, h === "z" && !/[mz]/.test(R) && this.moveTo(m), R) {
            case "m":
            case "l":
              for (var D = R === "m", L = 0; L < E; L += 2)
                this[D ? "moveTo" : "lineTo"](m = x(L)), D && (_ = m, D = !1);
              f = m;
              break;
            case "h":
            case "v":
              var P = R === "h" ? "x" : "y";
              m = m.clone();
              for (var L = 0; L < E; L++)
                m[P] = y(L, P), this.lineTo(m);
              f = m;
              break;
            case "c":
              for (var L = 0; L < E; L += 6)
                this.cubicCurveTo(
                  x(L),
                  f = x(L + 2),
                  m = x(L + 4)
                );
              break;
            case "s":
              for (var L = 0; L < E; L += 4)
                this.cubicCurveTo(
                  /[cs]/.test(h) ? m.multiply(2).subtract(f) : m,
                  f = x(L),
                  m = x(L + 2)
                ), h = R;
              break;
            case "q":
              for (var L = 0; L < E; L += 4)
                this.quadraticCurveTo(
                  f = x(L),
                  m = x(L + 2)
                );
              break;
            case "t":
              for (var L = 0; L < E; L += 2)
                this.quadraticCurveTo(
                  f = /[qt]/.test(h) ? m.multiply(2).subtract(f) : m,
                  m = x(L)
                ), h = R;
              break;
            case "a":
              for (var L = 0; L < E; L += 7)
                this.arcTo(
                  m = x(L + 5),
                  new ne(+r[L], +r[L + 1]),
                  +r[L + 2],
                  +r[L + 4],
                  +r[L + 3]
                );
              break;
            case "z":
              this.closePath(1e-12), m = _;
              break;
          }
          h = R;
        }
      },
      _canComposite: function() {
        return !(this.hasFill() && this.hasStroke());
      },
      _contains: function(i) {
        var n = i.isInside(
          this.getBounds({ internal: !0, handle: !0 })
        ) ? this._getWinding(i) : {};
        return n.onPath || !!(this.getFillRule() === "evenodd" ? n.windingL & 1 || n.windingR & 1 : n.winding);
      },
      getIntersections: function(i, n, r, l) {
        var h = this === i || !i, f = this._matrix._orNullIfIdentity(), m = h ? f : (r || i._matrix)._orNullIfIdentity();
        return h || this.getBounds(f).intersects(
          i.getBounds(m),
          1e-12
        ) ? Ve.getIntersections(
          this.getCurves(),
          !h && i.getCurves(),
          n,
          f,
          m,
          l
        ) : [];
      },
      getCrossings: function(i) {
        return this.getIntersections(i, function(n) {
          return n.isCrossing();
        });
      },
      getNearestLocation: function() {
        for (var i = z.read(arguments), n = this.getCurves(), r = 1 / 0, l = null, h = 0, f = n.length; h < f; h++) {
          var m = n[h].getNearestLocation(i);
          m._distance < r && (r = m._distance, l = m);
        }
        return l;
      },
      getNearestPoint: function() {
        var i = this.getNearestLocation.apply(this, arguments);
        return i && i.getPoint();
      },
      interpolate: function(i, n, r) {
        var l = !this._children, h = l ? "_segments" : "_children", f = i[h], m = n[h], _ = this[h];
        if (!f || !m || f.length !== m.length)
          throw new Error("Invalid operands in interpolate() call: " + i + ", " + n);
        var y = _.length, x = m.length;
        if (y < x)
          for (var A = l ? at : Bt, B = y; B < x; B++)
            this.add(new A());
        else
          y > x && this[l ? "removeSegments" : "removeChildren"](x, y);
        for (var B = 0; B < x; B++)
          _[B].interpolate(f[B], m[B], r);
        l && (this.setClosed(i._closed), this._changed(9));
      },
      compare: function(i) {
        var n = !1;
        if (i) {
          var r = this._children || [this], l = i._children ? i._children.slice() : [i], h = r.length, f = l.length, m = [], _ = 0;
          n = !0;
          for (var y = T.findItemBoundsCollisions(r, l, Y.GEOMETRIC_EPSILON), x = h - 1; x >= 0 && n; x--) {
            var A = r[x];
            n = !1;
            var B = y[x];
            if (B)
              for (var C = B.length - 1; C >= 0 && !n; C--)
                A.compare(l[B[C]]) && (m[B[C]] || (m[B[C]] = !0, _++), n = !0);
          }
          n = n && _ === f;
        }
        return n;
      }
    }), Bt = Ft.extend(
      {
        _class: "Path",
        _serializeFields: {
          segments: [],
          closed: !1
        },
        initialize: function(n) {
          this._closed = !1, this._segments = [], this._version = 0;
          var r = arguments, l = Array.isArray(n) ? typeof n[0] == "object" ? n : r : n && n.size === t && (n.x !== t || n.point !== t) ? r : null;
          l && l.length > 0 ? this.setSegments(l) : (this._curves = t, this._segmentSelection = 0, !l && typeof n == "string" && (this.setPathData(n), n = null)), this._initialize(!l && n);
        },
        _equals: function(i) {
          return this._closed === i._closed && a.equals(this._segments, i._segments);
        },
        copyContent: function(i) {
          this.setSegments(i._segments), this._closed = i._closed;
        },
        _changed: function i(n) {
          if (i.base.call(this, n), n & 8) {
            if (this._length = this._area = t, n & 32)
              this._version++;
            else if (this._curves)
              for (var r = 0, l = this._curves.length; r < l; r++)
                this._curves[r]._changed();
          } else
            n & 64 && (this._bounds = t);
        },
        getStyle: function() {
          var i = this._parent;
          return (i instanceof yi ? i : this)._style;
        },
        getSegments: function() {
          return this._segments;
        },
        setSegments: function(i) {
          var n = this.isFullySelected(), r = i && i.length;
          if (this._segments.length = 0, this._segmentSelection = 0, this._curves = t, r) {
            var l = i[r - 1];
            typeof l == "boolean" && (this.setClosed(l), r--), this._add(at.readList(i, 0, {}, r));
          }
          n && this.setFullySelected(!0);
        },
        getFirstSegment: function() {
          return this._segments[0];
        },
        getLastSegment: function() {
          return this._segments[this._segments.length - 1];
        },
        getCurves: function() {
          var i = this._curves, n = this._segments;
          if (!i) {
            var r = this._countCurves();
            i = this._curves = new Array(r);
            for (var l = 0; l < r; l++)
              i[l] = new Ve(
                this,
                n[l],
                n[l + 1] || n[0]
              );
          }
          return i;
        },
        getFirstCurve: function() {
          return this.getCurves()[0];
        },
        getLastCurve: function() {
          var i = this.getCurves();
          return i[i.length - 1];
        },
        isClosed: function() {
          return this._closed;
        },
        setClosed: function(i) {
          if (this._closed != (i = !!i)) {
            if (this._closed = i, this._curves) {
              var n = this._curves.length = this._countCurves();
              i && (this._curves[n - 1] = new Ve(
                this,
                this._segments[n - 1],
                this._segments[0]
              ));
            }
            this._changed(41);
          }
        }
      },
      {
        beans: !0,
        getPathData: function(i, n) {
          var r = this._segments, l = r.length, h = new H(n), f = new Array(6), m = !0, _, y, x, A, B, C, M, R, E = [];
          function D(P, S) {
            if (P._transformCoordinates(i, f), _ = f[0], y = f[1], m)
              E.push("M" + h.pair(_, y)), m = !1;
            else if (B = f[2], C = f[3], B === _ && C === y && M === x && R === A) {
              if (!S) {
                var I = _ - x, U = y - A;
                E.push(
                  I === 0 ? "v" + h.number(U) : U === 0 ? "h" + h.number(I) : "l" + h.pair(I, U)
                );
              }
            } else
              E.push("c" + h.pair(M - x, R - A) + " " + h.pair(B - x, C - A) + " " + h.pair(_ - x, y - A));
            x = _, A = y, M = f[4], R = f[5];
          }
          if (!l)
            return "";
          for (var L = 0; L < l; L++)
            D(r[L]);
          return this._closed && l > 0 && (D(r[0], !0), E.push("z")), E.join("");
        },
        isEmpty: function() {
          return !this._segments.length;
        },
        _transformContent: function(i) {
          for (var n = this._segments, r = new Array(6), l = 0, h = n.length; l < h; l++)
            n[l]._transformCoordinates(i, r, !0);
          return !0;
        },
        _add: function(i, m) {
          for (var r = this._segments, l = this._curves, h = i.length, f = m == null, m = f ? r.length : m, _ = 0; _ < h; _++) {
            var y = i[_];
            y._path && (y = i[_] = y.clone()), y._path = this, y._index = m + _, y._selection && this._updateSelection(y, 0, y._selection);
          }
          if (f)
            a.push(r, i);
          else {
            r.splice.apply(r, [m, 0].concat(i));
            for (var _ = m + h, x = r.length; _ < x; _++)
              r[_]._index = _;
          }
          if (l) {
            var A = this._countCurves(), B = m > 0 && m + h - 1 === A ? m - 1 : m, C = B, M = Math.min(B + h, A);
            i._curves && (l.splice.apply(l, [B, 0].concat(i._curves)), C += i._curves.length);
            for (var _ = C; _ < M; _++)
              l.splice(_, 0, new Ve(this, null, null));
            this._adjustCurves(B, M);
          }
          return this._changed(41), i;
        },
        _adjustCurves: function(i, n) {
          for (var r = this._segments, l = this._curves, h, f = i; f < n; f++)
            h = l[f], h._path = this, h._segment1 = r[f], h._segment2 = r[f + 1] || r[0], h._changed();
          (h = l[this._closed && !i ? r.length - 1 : i - 1]) && (h._segment2 = r[i] || r[0], h._changed()), (h = l[n]) && (h._segment1 = r[n], h._changed());
        },
        _countCurves: function() {
          var i = this._segments.length;
          return !this._closed && i > 0 ? i - 1 : i;
        },
        add: function(i) {
          var n = arguments;
          return n.length > 1 && typeof i != "number" ? this._add(at.readList(n)) : this._add([at.read(n)])[0];
        },
        insert: function(i, n) {
          var r = arguments;
          return r.length > 2 && typeof n != "number" ? this._add(at.readList(r, 1), i) : this._add([at.read(r, 1)], i)[0];
        },
        addSegment: function() {
          return this._add([at.read(arguments)])[0];
        },
        insertSegment: function(i) {
          return this._add([at.read(arguments, 1)], i)[0];
        },
        addSegments: function(i) {
          return this._add(at.readList(i));
        },
        insertSegments: function(i, n) {
          return this._add(at.readList(n), i);
        },
        removeSegment: function(i) {
          return this.removeSegments(i, i + 1)[0] || null;
        },
        removeSegments: function(i, n, r) {
          i = i || 0, n = a.pick(n, this._segments.length);
          var l = this._segments, h = this._curves, f = l.length, m = l.splice(i, n - i), _ = m.length;
          if (!_)
            return m;
          for (var y = 0; y < _; y++) {
            var x = m[y];
            x._selection && this._updateSelection(x, x._selection, 0), x._index = x._path = null;
          }
          for (var y = i, A = l.length; y < A; y++)
            l[y]._index = y;
          if (h) {
            for (var B = i > 0 && n === f + (this._closed ? 1 : 0) ? i - 1 : i, h = h.splice(B, _), y = h.length - 1; y >= 0; y--)
              h[y]._path = null;
            r && (m._curves = h.slice(1)), this._adjustCurves(B, B);
          }
          return this._changed(41), m;
        },
        clear: "#removeSegments",
        hasHandles: function() {
          for (var i = this._segments, n = 0, r = i.length; n < r; n++)
            if (i[n].hasHandles())
              return !0;
          return !1;
        },
        clearHandles: function() {
          for (var i = this._segments, n = 0, r = i.length; n < r; n++)
            i[n].clearHandles();
        },
        getLength: function() {
          if (this._length == null) {
            for (var i = this.getCurves(), n = 0, r = 0, l = i.length; r < l; r++)
              n += i[r].getLength();
            this._length = n;
          }
          return this._length;
        },
        getArea: function() {
          var i = this._area;
          if (i == null) {
            var n = this._segments, r = this._closed;
            i = 0;
            for (var l = 0, h = n.length; l < h; l++) {
              var f = l + 1 === h;
              i += Ve.getArea(Ve.getValues(
                n[l],
                n[f ? 0 : l + 1],
                null,
                f && !r
              ));
            }
            this._area = i;
          }
          return i;
        },
        isFullySelected: function() {
          var i = this._segments.length;
          return this.isSelected() && i > 0 && this._segmentSelection === i * 7;
        },
        setFullySelected: function(i) {
          i && this._selectSegments(!0), this.setSelected(i);
        },
        setSelection: function i(n) {
          n & 1 || this._selectSegments(!1), i.base.call(this, n);
        },
        _selectSegments: function(i) {
          var n = this._segments, r = n.length, l = i ? 7 : 0;
          this._segmentSelection = l * r;
          for (var h = 0; h < r; h++)
            n[h]._selection = l;
        },
        _updateSelection: function(i, n, r) {
          i._selection = r;
          var l = this._segmentSelection += r - n;
          l > 0 && this.setSelected(!0);
        },
        divideAt: function(i) {
          var n = this.getLocationAt(i), r;
          return n && (r = n.getCurve().divideAt(n.getCurveOffset())) ? r._segment1 : null;
        },
        splitAt: function(i) {
          var n = this.getLocationAt(i), r = n && n.index, l = n && n.time, h = 1e-8, f = 1 - h;
          l > f && (r++, l = 0);
          var m = this.getCurves();
          if (r >= 0 && r < m.length) {
            l >= h && m[r++].divideAtTime(l);
            var _ = this.removeSegments(r, this._segments.length, !0), y;
            return this._closed ? (this.setClosed(!1), y = this) : (y = new Bt(K.NO_INSERT), y.insertAbove(this), y.copyAttributes(this)), y._add(_, 0), this.addSegment(_[0]), y;
          }
          return null;
        },
        split: function(i, n) {
          var r, l = n === t ? i : (r = this.getCurves()[i]) && r.getLocationAtTime(n);
          return l != null ? this.splitAt(l) : null;
        },
        join: function(i, n) {
          var r = n || 0;
          if (i && i !== this) {
            var l = i._segments, h = this.getLastSegment(), f = i.getLastSegment();
            if (!f)
              return this;
            h && h._point.isClose(f._point, r) && i.reverse();
            var m = i.getFirstSegment();
            if (h && h._point.isClose(m._point, r))
              h.setHandleOut(m._handleOut), this._add(l.slice(1));
            else {
              var _ = this.getFirstSegment();
              _ && _._point.isClose(m._point, r) && i.reverse(), f = i.getLastSegment(), _ && _._point.isClose(f._point, r) ? (_.setHandleIn(f._handleIn), this._add(l.slice(0, l.length - 1), 0)) : this._add(l.slice());
            }
            i._closed && this._add([l[0]]), i.remove();
          }
          var y = this.getFirstSegment(), x = this.getLastSegment();
          return y !== x && y._point.isClose(x._point, r) && (y.setHandleIn(x._handleIn), x.remove(), this.setClosed(!0)), this;
        },
        reduce: function(i) {
          for (var n = this.getCurves(), r = i && i.simplify, l = r ? 1e-7 : 0, h = n.length - 1; h >= 0; h--) {
            var f = n[h];
            !f.hasHandles() && (!f.hasLength(l) || r && f.isCollinear(f.getNext())) && f.remove();
          }
          return this;
        },
        reverse: function() {
          this._segments.reverse();
          for (var i = 0, n = this._segments.length; i < n; i++) {
            var r = this._segments[i], l = r._handleIn;
            r._handleIn = r._handleOut, r._handleOut = l, r._index = i;
          }
          this._curves = null, this._changed(9);
        },
        flatten: function(i) {
          for (var n = new on(this, i || 0.25, 256, !0), r = n.parts, l = r.length, h = [], f = 0; f < l; f++)
            h.push(new at(r[f].curve.slice(0, 2)));
          !this._closed && l > 0 && h.push(new at(r[l - 1].curve.slice(6))), this.setSegments(h);
        },
        simplify: function(i) {
          var n = new Tn(this).fit(i || 2.5);
          return n && this.setSegments(n), !!n;
        },
        smooth: function(i) {
          var n = this, r = i || {}, l = r.type || "asymmetric", h = this._segments, f = h.length, m = this._closed;
          function _(tt, gt) {
            var ut = tt && tt.index;
            if (ut != null) {
              var yt = tt.path;
              if (yt && yt !== n)
                throw new Error(tt._class + " " + ut + " of " + yt + " is not part of " + n);
              gt && tt instanceof Ve && ut++;
            } else
              ut = typeof tt == "number" ? tt : gt;
            return Math.min(ut < 0 && m ? ut % f : ut < 0 ? ut + f : ut, f - 1);
          }
          var y = m && r.from === t && r.to === t, x = _(r.from, 0), A = _(r.to, f - 1);
          if (x > A)
            if (m)
              x -= f;
            else {
              var B = x;
              x = A, A = B;
            }
          if (/^(?:asymmetric|continuous)$/.test(l)) {
            var C = l === "asymmetric", M = Math.min, R = A - x + 1, E = R - 1, D = y ? M(R, 4) : 1, L = D, P = D, S = [];
            if (m || (L = M(1, x), P = M(1, f - A - 1)), E += L + P, E <= 1)
              return;
            for (var I = 0, U = x - L; I <= E; I++, U++)
              S[I] = h[(U < 0 ? U + f : U) % f]._point;
            for (var V = S[0]._x + 2 * S[1]._x, F = S[0]._y + 2 * S[1]._y, W = 2, Q = E - 1, ie = [V], ae = [F], J = [W], le = [], fe = [], I = 1; I < E; I++) {
              var me = I < Q, ve = me || C ? 1 : 2, Se = me ? 4 : C ? 2 : 7, Re = me ? 4 : C ? 3 : 8, He = me ? 2 : C ? 0 : 1, Ye = ve / W;
              W = J[I] = Se - Ye, V = ie[I] = Re * S[I]._x + He * S[I + 1]._x - Ye * V, F = ae[I] = Re * S[I]._y + He * S[I + 1]._y - Ye * F;
            }
            le[Q] = ie[Q] / J[Q], fe[Q] = ae[Q] / J[Q];
            for (var I = E - 2; I >= 0; I--)
              le[I] = (ie[I] - le[I + 1]) / J[I], fe[I] = (ae[I] - fe[I + 1]) / J[I];
            le[E] = (3 * S[E]._x - le[Q]) / 2, fe[E] = (3 * S[E]._y - fe[Q]) / 2;
            for (var I = L, Je = E - P, U = x; I <= Je; I++, U++) {
              var Be = h[U < 0 ? U + f : U], Ie = Be._point, Ge = le[I] - Ie._x, et = fe[I] - Ie._y;
              (y || I < Je) && Be.setHandleOut(Ge, et), (y || I > L) && Be.setHandleIn(-Ge, -et);
            }
          } else
            for (var I = x; I <= A; I++)
              h[I < 0 ? I + f : I].smooth(
                r,
                !y && I === x,
                !y && I === A
              );
        },
        toShape: function(i) {
          if (!this._closed)
            return null;
          var n = this._segments, r, l, h, f;
          function m(C, M) {
            var R = n[C], E = R.getNext(), D = n[M], L = D.getNext();
            return R._handleOut.isZero() && E._handleIn.isZero() && D._handleOut.isZero() && L._handleIn.isZero() && E._point.subtract(R._point).isCollinear(
              L._point.subtract(D._point)
            );
          }
          function _(C) {
            var M = n[C], R = M.getPrevious(), E = M.getNext();
            return R._handleOut.isZero() && M._handleIn.isZero() && M._handleOut.isZero() && E._handleIn.isZero() && M._point.subtract(R._point).isOrthogonal(
              E._point.subtract(M._point)
            );
          }
          function y(C) {
            var M = n[C], R = M.getNext(), E = M._handleOut, D = R._handleIn, L = 0.5522847498307936;
            if (E.isOrthogonal(D)) {
              var P = M._point, S = R._point, I = new xe(P, E, !0).intersect(
                new xe(S, D, !0),
                !0
              );
              return I && Y.isZero(E.getLength() / I.subtract(P).getLength() - L) && Y.isZero(D.getLength() / I.subtract(S).getLength() - L);
            }
            return !1;
          }
          function x(C, M) {
            return n[C]._point.getDistance(n[M]._point);
          }
          if (!this.hasHandles() && n.length === 4 && m(0, 2) && m(1, 3) && _(1) ? (r = Ze.Rectangle, l = new ne(x(0, 3), x(0, 1)), f = n[1]._point.add(n[2]._point).divide(2)) : n.length === 8 && y(0) && y(2) && y(4) && y(6) && m(1, 5) && m(3, 7) ? (r = Ze.Rectangle, l = new ne(x(1, 6), x(0, 3)), h = l.subtract(new ne(
            x(0, 7),
            x(1, 2)
          )).divide(2), f = n[3]._point.add(n[4]._point).divide(2)) : n.length === 4 && y(0) && y(1) && y(2) && y(3) && (Y.isZero(x(0, 2) - x(1, 3)) ? (r = Ze.Circle, h = x(0, 2) / 2) : (r = Ze.Ellipse, h = new ne(x(2, 0) / 2, x(3, 1) / 2)), f = n[1]._point), r) {
            var A = this.getPosition(!0), B = new r({
              center: A,
              size: l,
              radius: h,
              insert: !1
            });
            return B.copyAttributes(this, !0), B._matrix.prepend(this._matrix), B.rotate(f.subtract(A).getAngle() + 90), (i === t || i) && B.insertAbove(this), B;
          }
          return null;
        },
        toPath: "#clone",
        compare: function i(n) {
          if (!n || n instanceof yi)
            return i.base.call(this, n);
          var r = this.getCurves(), l = n.getCurves(), h = r.length, f = l.length;
          if (!h || !f)
            return h == f;
          for (var m = r[0].getValues(), _ = [], y = 0, x, A = 0, B, C = 0; C < f; C++) {
            var D = l[C].getValues();
            _.push(D);
            var M = Ve.getOverlaps(m, D);
            if (M) {
              x = !C && M[0][0] > 0 ? f - 1 : C, B = M[0][1];
              break;
            }
          }
          for (var R = Math.abs, E = 1e-8, D = _[x], L; m && D; ) {
            var M = Ve.getOverlaps(m, D);
            if (M) {
              var P = M[0][0];
              if (R(P - A) < E) {
                A = M[1][0], A === 1 && (m = ++y < h ? r[y].getValues() : null, A = 0);
                var S = M[0][1];
                if (R(S - B) < E) {
                  if (L || (L = [x, S]), B = M[1][1], B === 1 && (++x >= f && (x = 0), D = _[x] || l[x].getValues(), B = 0), !m)
                    return L[0] === x && L[1] === B;
                  continue;
                }
              }
            }
            break;
          }
          return !1;
        },
        _hitTestSelf: function(i, n, r, l) {
          var h = this, f = this.getStyle(), m = this._segments, _ = m.length, y = this._closed, x = n._tolerancePadding, A = x, B, C, M, R, E, D, L = n.stroke && f.hasStroke(), P = n.fill && f.hasFill(), S = n.curves, I = L ? f.getStrokeWidth() / 2 : P && n.tolerance > 0 || S ? 0 : null;
          I !== null && (I > 0 ? (B = f.getStrokeJoin(), C = f.getStrokeCap(), M = f.getMiterLimit(), A = A.add(
            Bt._getStrokePadding(I, l)
          )) : B = C = "round");
          function U(le, fe) {
            return i.subtract(le).divide(fe).length <= 1;
          }
          function V(le, fe, me) {
            if (!n.selected || fe.isSelected()) {
              var ve = le._point;
              if (fe !== ve && (fe = fe.add(ve)), U(fe, A))
                return new Tt(me, h, {
                  segment: le,
                  point: fe
                });
            }
          }
          function F(le, fe) {
            return (fe || n.segments) && V(le, le._point, "segment") || !fe && n.handles && (V(le, le._handleIn, "handle-in") || V(le, le._handleOut, "handle-out"));
          }
          function W(le) {
            R.add(le);
          }
          function Q(le) {
            var fe = y || le._index > 0 && le._index < _ - 1;
            if ((fe ? B : C) === "round")
              return U(le._point, A);
            if (R = new Bt({ internal: !0, closed: !0 }), fe ? le.isSmooth() || Bt._addBevelJoin(
              le,
              B,
              I,
              M,
              null,
              l,
              W,
              !0
            ) : C === "square" && Bt._addSquareCap(
              le,
              C,
              I,
              null,
              l,
              W,
              !0
            ), !R.isEmpty()) {
              var me;
              return R.contains(i) || (me = R.getNearestLocation(i)) && U(me.getPoint(), x);
            }
          }
          if (n.ends && !n.segments && !y) {
            if (D = F(m[0], !0) || F(m[_ - 1], !0))
              return D;
          } else if (n.segments || n.handles) {
            for (var ie = 0; ie < _; ie++)
              if (D = F(m[ie]))
                return D;
          }
          if (I !== null) {
            if (E = this.getNearestLocation(i), E) {
              var ae = E.getTime();
              ae === 0 || ae === 1 && _ > 1 ? Q(E.getSegment()) || (E = null) : U(E.getPoint(), A) || (E = null);
            }
            if (!E && B === "miter" && _ > 1)
              for (var ie = 0; ie < _; ie++) {
                var J = m[ie];
                if (i.getDistance(J._point) <= M * I && Q(J)) {
                  E = J.getLocation();
                  break;
                }
              }
          }
          return !E && P && this._contains(i) || E && !L && !S ? new Tt("fill", this) : E ? new Tt(L ? "stroke" : "curve", this, {
            location: E,
            point: E.getPoint()
          }) : null;
        }
      },
      a.each(
        Ve._evaluateMethods,
        function(i) {
          this[i + "At"] = function(n) {
            var r = this.getLocationAt(n);
            return r && r[i]();
          };
        },
        {
          beans: !1,
          getLocationOf: function() {
            for (var i = z.read(arguments), n = this.getCurves(), r = 0, l = n.length; r < l; r++) {
              var h = n[r].getLocationOf(i);
              if (h)
                return h;
            }
            return null;
          },
          getOffsetOf: function() {
            var i = this.getLocationOf.apply(this, arguments);
            return i ? i.getOffset() : null;
          },
          getLocationAt: function(i) {
            if (typeof i == "number") {
              for (var n = this.getCurves(), r = 0, l = 0, h = n.length; l < h; l++) {
                var f = r, m = n[l];
                if (r += m.getLength(), r > i)
                  return m.getLocationAt(i - f);
              }
              if (n.length > 0 && i <= this.getLength())
                return new Ot(n[n.length - 1], 1);
            } else if (i && i.getPath && i.getPath() === this)
              return i;
            return null;
          },
          getOffsetsWithTangent: function() {
            var i = z.read(arguments);
            if (i.isZero())
              return [];
            for (var n = [], r = 0, l = this.getCurves(), h = 0, f = l.length; h < f; h++) {
              for (var m = l[h], _ = m.getTimesWithTangent(i), y = 0, x = _.length; y < x; y++) {
                var A = r + m.getOffsetAtTime(_[y]);
                n.indexOf(A) < 0 && n.push(A);
              }
              r += m.length;
            }
            return n;
          }
        }
      ),
      new function() {
        function i(r, l, h, f) {
          if (f <= 0)
            return;
          var m = f / 2, _ = f - 2, y = m - 1, x = new Array(6), A, B;
          function C(P) {
            var S = x[P], I = x[P + 1];
            (A != S || B != I) && (r.beginPath(), r.moveTo(A, B), r.lineTo(S, I), r.stroke(), r.beginPath(), r.arc(S, I, m, 0, Math.PI * 2, !0), r.fill());
          }
          for (var M = 0, R = l.length; M < R; M++) {
            var E = l[M], D = E._selection;
            if (E._transformCoordinates(h, x), A = x[0], B = x[1], D & 2 && C(2), D & 4 && C(4), r.fillRect(A - m, B - m, f, f), _ > 0 && !(D & 1)) {
              var L = r.fillStyle;
              r.fillStyle = "#ffffff", r.fillRect(A - y, B - y, _, _), r.fillStyle = L;
            }
          }
        }
        function n(r, l, h) {
          var f = l._segments, m = f.length, _ = new Array(6), y = !0, x, A, B, C, M, R, E, D;
          function L(S) {
            if (h)
              S._transformCoordinates(h, _), x = _[0], A = _[1];
            else {
              var I = S._point;
              x = I._x, A = I._y;
            }
            if (y)
              r.moveTo(x, A), y = !1;
            else {
              if (h)
                M = _[2], R = _[3];
              else {
                var U = S._handleIn;
                M = x + U._x, R = A + U._y;
              }
              M === x && R === A && E === B && D === C ? r.lineTo(x, A) : r.bezierCurveTo(E, D, M, R, x, A);
            }
            if (B = x, C = A, h)
              E = _[4], D = _[5];
            else {
              var U = S._handleOut;
              E = B + U._x, D = C + U._y;
            }
          }
          for (var P = 0; P < m; P++)
            L(f[P]);
          l._closed && m > 0 && L(f[0]);
        }
        return {
          _draw: function(r, l, h, f) {
            var m = l.dontStart, _ = l.dontFinish || l.clip, y = this.getStyle(), x = y.hasFill(), A = y.hasStroke(), B = y.getDashArray(), C = !nt.support.nativeDash && A && B && B.length;
            m || r.beginPath(), (x || A && !C || _) && (n(r, this, f), this._closed && r.closePath());
            function M(S) {
              return B[(S % C + C) % C];
            }
            if (!_ && (x || A) && (this._setStyles(r, l, h), x && (r.fill(y.getFillRule()), r.shadowColor = "rgba(0,0,0,0)"), A)) {
              if (C) {
                m || r.beginPath();
                for (var R = new on(
                  this,
                  0.25,
                  32,
                  !1,
                  f
                ), E = R.length, D = -y.getDashOffset(), L, P = 0; D > 0; )
                  D -= M(P--) + M(P--);
                for (; D < E; )
                  L = D + M(P++), (D > 0 || L > 0) && R.drawPart(
                    r,
                    Math.max(D, 0),
                    Math.max(L, 0)
                  ), D = L + M(P++);
              }
              r.stroke();
            }
          },
          _drawSelected: function(r, l) {
            r.beginPath(), n(r, this, l), r.stroke(), i(r, this._segments, l, nt.settings.handleSize);
          }
        };
      }(),
      new function() {
        function i(n) {
          var r = n._segments;
          if (!r.length)
            throw new Error("Use a moveTo() command first");
          return r[r.length - 1];
        }
        return {
          moveTo: function() {
            var n = this._segments;
            n.length === 1 && this.removeSegment(0), n.length || this._add([new at(z.read(arguments))]);
          },
          moveBy: function() {
            throw new Error("moveBy() is unsupported on Path items.");
          },
          lineTo: function() {
            this._add([new at(z.read(arguments))]);
          },
          cubicCurveTo: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = z.read(n), f = i(this);
            f.setHandleOut(r.subtract(f._point)), this._add([new at(h, l.subtract(h))]);
          },
          quadraticCurveTo: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = i(this)._point;
            this.cubicCurveTo(
              r.add(h.subtract(r).multiply(1 / 3)),
              r.add(l.subtract(r).multiply(1 / 3)),
              l
            );
          },
          curveTo: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = a.pick(a.read(n), 0.5), f = 1 - h, m = i(this)._point, _ = r.subtract(m.multiply(f * f)).subtract(l.multiply(h * h)).divide(2 * h * f);
            if (_.isNaN())
              throw new Error(
                "Cannot put a curve through points with parameter = " + h
              );
            this.quadraticCurveTo(_, l);
          },
          arcTo: function() {
            var n = arguments, r = Math.abs, l = Math.sqrt, h = i(this), f = h._point, m = z.read(n), _, y = a.peek(n), x = a.pick(y, !0), A, B, C, M;
            if (typeof x == "boolean")
              var R = f.add(m).divide(2), _ = R.add(R.subtract(f).rotate(
                x ? -90 : 90
              ));
            else if (a.remain(n) <= 2)
              _ = m, m = z.read(n);
            else if (!f.equals(m)) {
              var E = ne.read(n), D = Y.isZero;
              if (D(E.width) || D(E.height))
                return this.lineTo(m);
              var L = a.read(n), x = !!a.read(n), P = !!a.read(n), R = f.add(m).divide(2), S = f.subtract(R).rotate(-L), I = S.x, U = S.y, V = r(E.width), F = r(E.height), W = V * V, Q = F * F, ie = I * I, ae = U * U, J = l(ie / W + ae / Q);
              if (J > 1 && (V *= J, F *= J, W = V * V, Q = F * F), J = (W * Q - W * ae - Q * ie) / (W * ae + Q * ie), r(J) < 1e-12 && (J = 0), J < 0)
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              A = new z(V * U / F, -F * I / V).multiply((P === x ? -1 : 1) * l(J)).rotate(L).add(R), M = new ue().translate(A).rotate(L).scale(V, F), C = M._inverseTransform(f), B = C.getDirectedAngle(M._inverseTransform(m)), !x && B > 0 ? B -= 360 : x && B < 0 && (B += 360);
            }
            if (_) {
              var le = new xe(
                f.add(_).divide(2),
                _.subtract(f).rotate(90),
                !0
              ), fe = new xe(
                _.add(m).divide(2),
                m.subtract(_).rotate(90),
                !0
              ), me = new xe(f, m), ve = me.getSide(_);
              if (A = le.intersect(fe, !0), !A) {
                if (!ve)
                  return this.lineTo(m);
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              }
              C = f.subtract(A), B = C.getDirectedAngle(m.subtract(A));
              var Se = me.getSide(A, !0);
              Se === 0 ? B = ve * r(B) : ve === Se && (B += B < 0 ? 360 : -360);
            }
            if (B) {
              for (var Re = 1e-5, He = r(B), Ye = He >= 360 ? 4 : Math.ceil((He - Re) / 90), Je = B / Ye, Be = Je * Math.PI / 360, Ie = 4 / 3 * Math.sin(Be) / (1 + Math.cos(Be)), Ge = [], et = 0; et <= Ye; et++) {
                var S = m, tt = null;
                if (et < Ye && (tt = C.rotate(90).multiply(Ie), M ? (S = M._transformPoint(C), tt = M._transformPoint(C.add(tt)).subtract(S)) : S = A.add(C)), !et)
                  h.setHandleOut(tt);
                else {
                  var gt = C.rotate(-90).multiply(Ie);
                  M && (gt = M._transformPoint(C.add(gt)).subtract(S)), Ge.push(new at(S, gt, tt));
                }
                C = C.rotate(Je);
              }
              this._add(Ge);
            }
          },
          lineBy: function() {
            var n = z.read(arguments), r = i(this)._point;
            this.lineTo(r.add(n));
          },
          curveBy: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = a.read(n), f = i(this)._point;
            this.curveTo(f.add(r), f.add(l), h);
          },
          cubicCurveBy: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = z.read(n), f = i(this)._point;
            this.cubicCurveTo(
              f.add(r),
              f.add(l),
              f.add(h)
            );
          },
          quadraticCurveBy: function() {
            var n = arguments, r = z.read(n), l = z.read(n), h = i(this)._point;
            this.quadraticCurveTo(h.add(r), h.add(l));
          },
          arcBy: function() {
            var n = arguments, r = i(this)._point, l = r.add(z.read(n)), h = a.pick(a.peek(n), !0);
            typeof h == "boolean" ? this.arcTo(l, h) : this.arcTo(l, r.add(z.read(n)));
          },
          closePath: function(n) {
            this.setClosed(!0), this.join(this, n);
          }
        };
      }(),
      {
        _getBounds: function(i, n) {
          var r = n.handle ? "getHandleBounds" : n.stroke ? "getStrokeBounds" : "getBounds";
          return Bt[r](this._segments, this._closed, this, i, n);
        },
        statics: {
          getBounds: function(i, n, r, l, h, f) {
            var m = i[0];
            if (!m)
              return new se();
            var _ = new Array(6), y = m._transformCoordinates(l, new Array(6)), x = y.slice(0, 2), A = x.slice(), B = new Array(2);
            function C(E) {
              E._transformCoordinates(l, _);
              for (var D = 0; D < 2; D++)
                Ve._addBounds(
                  y[D],
                  y[D + 4],
                  _[D + 2],
                  _[D],
                  D,
                  f ? f[D] : 0,
                  x,
                  A,
                  B
                );
              var L = y;
              y = _, _ = L;
            }
            for (var M = 1, R = i.length; M < R; M++)
              C(i[M]);
            return n && C(m), new se(x[0], x[1], A[0] - x[0], A[1] - x[1]);
          },
          getStrokeBounds: function(i, n, r, l, h) {
            var f = r.getStyle(), m = f.hasStroke(), _ = f.getStrokeWidth(), y = m && r._getStrokeMatrix(l, h), x = m && Bt._getStrokePadding(
              _,
              y
            ), A = Bt.getBounds(
              i,
              n,
              r,
              l,
              h,
              x
            );
            if (!m)
              return A;
            var B = _ / 2, C = f.getStrokeJoin(), M = f.getStrokeCap(), R = f.getMiterLimit(), E = new se(new ne(x));
            function D(V) {
              A = A.include(V);
            }
            function L(V) {
              A = A.unite(
                E.setCenter(V._point.transform(l))
              );
            }
            function P(V, F) {
              F === "round" || V.isSmooth() ? L(V) : Bt._addBevelJoin(
                V,
                F,
                B,
                R,
                l,
                y,
                D
              );
            }
            function S(V, F) {
              F === "round" ? L(V) : Bt._addSquareCap(
                V,
                F,
                B,
                l,
                y,
                D
              );
            }
            var I = i.length - (n ? 0 : 1);
            if (I > 0) {
              for (var U = 1; U < I; U++)
                P(i[U], C);
              n ? P(i[0], C) : (S(i[0], M), S(i[i.length - 1], M));
            }
            return A;
          },
          _getStrokePadding: function(i, n) {
            if (!n)
              return [i, i];
            var r = new z(i, 0).transform(n), l = new z(0, i).transform(n), h = r.getAngleInRadians(), f = r.getLength(), m = l.getLength(), _ = Math.sin(h), y = Math.cos(h), x = Math.tan(h), A = Math.atan2(m * x, f), B = Math.atan2(m, x * f);
            return [
              Math.abs(f * Math.cos(A) * y + m * Math.sin(A) * _),
              Math.abs(m * Math.sin(B) * y + f * Math.cos(B) * _)
            ];
          },
          _addBevelJoin: function(i, n, r, l, h, f, m, _) {
            var y = i.getCurve(), x = y.getPrevious(), A = y.getPoint1().transform(h), B = x.getNormalAtTime(1).multiply(r).transform(f), C = y.getNormalAtTime(0).multiply(r).transform(f), M = B.getDirectedAngle(C);
            if ((M < 0 || M >= 180) && (B = B.negate(), C = C.negate()), _ && m(A), m(A.add(B)), n === "miter") {
              var R = new xe(
                A.add(B),
                new z(-B.y, B.x),
                !0
              ).intersect(new xe(
                A.add(C),
                new z(-C.y, C.x),
                !0
              ), !0);
              R && A.getDistance(R) <= l * r && m(R);
            }
            m(A.add(C));
          },
          _addSquareCap: function(i, n, r, l, h, f, m) {
            var _ = i._point.transform(l), y = i.getLocation(), x = y.getNormal().multiply(y.getTime() === 0 ? r : -r).transform(h);
            n === "square" && (m && (f(_.subtract(x)), f(_.add(x))), _ = _.add(x.rotate(-90))), f(_.add(x)), f(_.subtract(x));
          },
          getHandleBounds: function(i, n, r, l, h) {
            var f = r.getStyle(), m = h.stroke && f.hasStroke(), _, y;
            if (m) {
              var x = r._getStrokeMatrix(l, h), A = f.getStrokeWidth() / 2, B = A;
              f.getStrokeJoin() === "miter" && (B = A * f.getMiterLimit()), f.getStrokeCap() === "square" && (B = Math.max(B, A * Math.SQRT2)), _ = Bt._getStrokePadding(A, x), y = Bt._getStrokePadding(B, x);
            }
            for (var C = new Array(6), M = 1 / 0, R = -M, E = M, D = R, L = 0, P = i.length; L < P; L++) {
              var S = i[L];
              S._transformCoordinates(l, C);
              for (var I = 0; I < 6; I += 2) {
                var U = I ? _ : y, V = U ? U[0] : 0, F = U ? U[1] : 0, W = C[I], Q = C[I + 1], ie = W - V, ae = W + V, J = Q - F, le = Q + F;
                ie < M && (M = ie), ae > R && (R = ae), J < E && (E = J), le > D && (D = le);
              }
            }
            return new se(M, E, R - M, D - E);
          }
        }
      }
    );
    Bt.inject({ statics: new function() {
      var i = 0.5522847498307936, n = [
        new at([-1, 0], [0, i], [0, -i]),
        new at([0, -1], [-i, 0], [i, 0]),
        new at([1, 0], [0, -i], [0, i]),
        new at([0, 1], [i, 0], [-i, 0])
      ];
      function r(h, f, m) {
        var _ = a.getNamed(m), y = new Bt(_ && (_.insert == !0 ? K.INSERT : _.insert == !1 ? K.NO_INSERT : null));
        return y._add(h), y._closed = f, y.set(_, K.INSERT);
      }
      function l(h, f, m) {
        for (var _ = new Array(4), y = 0; y < 4; y++) {
          var x = n[y];
          _[y] = new at(
            x._point.multiply(f).add(h),
            x._handleIn.multiply(f),
            x._handleOut.multiply(f)
          );
        }
        return r(_, !0, m);
      }
      return {
        Line: function() {
          var h = arguments;
          return r([
            new at(z.readNamed(h, "from")),
            new at(z.readNamed(h, "to"))
          ], !1, h);
        },
        Circle: function() {
          var h = arguments, f = z.readNamed(h, "center"), m = a.readNamed(h, "radius");
          return l(f, new ne(m), h);
        },
        Rectangle: function() {
          var h = arguments, f = se.readNamed(h, "rectangle"), m = ne.readNamed(
            h,
            "radius",
            0,
            { readNull: !0 }
          ), _ = f.getBottomLeft(!0), y = f.getTopLeft(!0), x = f.getTopRight(!0), A = f.getBottomRight(!0), B;
          if (!m || m.isZero())
            B = [
              new at(_),
              new at(y),
              new at(x),
              new at(A)
            ];
          else {
            m = ne.min(m, f.getSize(!0).divide(2));
            var C = m.width, M = m.height, R = C * i, E = M * i;
            B = [
              new at(_.add(C, 0), null, [-R, 0]),
              new at(_.subtract(0, M), [0, E]),
              new at(y.add(0, M), null, [0, -E]),
              new at(y.add(C, 0), [-R, 0], null),
              new at(x.subtract(C, 0), null, [R, 0]),
              new at(x.add(0, M), [0, -E], null),
              new at(A.subtract(0, M), null, [0, E]),
              new at(A.subtract(C, 0), [R, 0])
            ];
          }
          return r(B, !0, h);
        },
        RoundRectangle: "#Rectangle",
        Ellipse: function() {
          var h = arguments, f = Ze._readEllipse(h);
          return l(f.center, f.radius, h);
        },
        Oval: "#Ellipse",
        Arc: function() {
          var h = arguments, f = z.readNamed(h, "from"), m = z.readNamed(h, "through"), _ = z.readNamed(h, "to"), y = a.getNamed(h), x = new Bt(y && y.insert == !1 && K.NO_INSERT);
          return x.moveTo(f), x.arcTo(m, _), x.set(y);
        },
        RegularPolygon: function() {
          for (var h = arguments, f = z.readNamed(h, "center"), m = a.readNamed(h, "sides"), _ = a.readNamed(h, "radius"), y = 360 / m, x = m % 3 === 0, A = new z(0, x ? -_ : _), B = x ? -1 : 0.5, C = new Array(m), M = 0; M < m; M++)
            C[M] = new at(f.add(
              A.rotate((M + B) * y)
            ));
          return r(C, !0, h);
        },
        Star: function() {
          for (var h = arguments, f = z.readNamed(h, "center"), m = a.readNamed(h, "points") * 2, _ = a.readNamed(h, "radius1"), y = a.readNamed(h, "radius2"), x = 360 / m, A = new z(0, -1), B = new Array(m), C = 0; C < m; C++)
            B[C] = new at(f.add(A.rotate(x * C).multiply(C % 2 ? y : _)));
          return r(B, !0, h);
        }
      };
    }() });
    var yi = Ft.extend(
      {
        _class: "CompoundPath",
        _serializeFields: {
          children: []
        },
        beans: !0,
        initialize: function(n) {
          this._children = [], this._namedChildren = {}, this._initialize(n) || (typeof n == "string" ? this.setPathData(n) : this.addChildren(Array.isArray(n) ? n : arguments));
        },
        insertChildren: function i(n, r) {
          var l = r, h = l[0];
          h && typeof h[0] == "number" && (l = [l]);
          for (var f = r.length - 1; f >= 0; f--) {
            var m = l[f];
            l === r && !(m instanceof Bt) && (l = a.slice(l)), Array.isArray(m) ? l[f] = new Bt({ segments: m, insert: !1 }) : m instanceof yi && (l.splice.apply(l, [f, 1].concat(m.removeChildren())), m.remove());
          }
          return i.base.call(this, n, l);
        },
        reduce: function i(n) {
          for (var r = this._children, l = r.length - 1; l >= 0; l--) {
            var h = r[l].reduce(n);
            h.isEmpty() && h.remove();
          }
          if (!r.length) {
            var h = new Bt(K.NO_INSERT);
            return h.copyAttributes(this), h.insertAbove(this), this.remove(), h;
          }
          return i.base.call(this);
        },
        isClosed: function() {
          for (var i = this._children, n = 0, r = i.length; n < r; n++)
            if (!i[n]._closed)
              return !1;
          return !0;
        },
        setClosed: function(i) {
          for (var n = this._children, r = 0, l = n.length; r < l; r++)
            n[r].setClosed(i);
        },
        getFirstSegment: function() {
          var i = this.getFirstChild();
          return i && i.getFirstSegment();
        },
        getLastSegment: function() {
          var i = this.getLastChild();
          return i && i.getLastSegment();
        },
        getCurves: function() {
          for (var i = this._children, n = [], r = 0, l = i.length; r < l; r++)
            a.push(n, i[r].getCurves());
          return n;
        },
        getFirstCurve: function() {
          var i = this.getFirstChild();
          return i && i.getFirstCurve();
        },
        getLastCurve: function() {
          var i = this.getLastChild();
          return i && i.getLastCurve();
        },
        getArea: function() {
          for (var i = this._children, n = 0, r = 0, l = i.length; r < l; r++)
            n += i[r].getArea();
          return n;
        },
        getLength: function() {
          for (var i = this._children, n = 0, r = 0, l = i.length; r < l; r++)
            n += i[r].getLength();
          return n;
        },
        getPathData: function(i, n) {
          for (var r = this._children, l = [], h = 0, f = r.length; h < f; h++) {
            var m = r[h], _ = m._matrix;
            l.push(m.getPathData(i && !_.isIdentity() ? i.appended(_) : i, n));
          }
          return l.join("");
        },
        _hitTestChildren: function i(n, r, l) {
          return i.base.call(
            this,
            n,
            r.class === Bt || r.type === "path" ? r : a.set({}, r, { fill: !1 }),
            l
          );
        },
        _draw: function(i, n, r, l) {
          var h = this._children;
          if (h.length) {
            n = n.extend({ dontStart: !0, dontFinish: !0 }), i.beginPath();
            for (var f = 0, m = h.length; f < m; f++)
              h[f].draw(i, n, l);
            if (!n.clip) {
              this._setStyles(i, n, r);
              var _ = this._style;
              _.hasFill() && (i.fill(_.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), _.hasStroke() && i.stroke();
            }
          }
        },
        _drawSelected: function(i, n, r) {
          for (var l = this._children, h = 0, f = l.length; h < f; h++) {
            var m = l[h], _ = m._matrix;
            r[m._id] || m._drawSelected(i, _.isIdentity() ? n : n.appended(_));
          }
        }
      },
      new function() {
        function i(n, r) {
          var l = n._children;
          if (r && !l.length)
            throw new Error("Use a moveTo() command first");
          return l[l.length - 1];
        }
        return a.each(
          [
            "lineTo",
            "cubicCurveTo",
            "quadraticCurveTo",
            "curveTo",
            "arcTo",
            "lineBy",
            "cubicCurveBy",
            "quadraticCurveBy",
            "curveBy",
            "arcBy"
          ],
          function(n) {
            this[n] = function() {
              var r = i(this, !0);
              r[n].apply(r, arguments);
            };
          },
          {
            moveTo: function() {
              var n = i(this), r = n && n.isEmpty() ? n : new Bt(K.NO_INSERT);
              r !== n && this.addChild(r), r.moveTo.apply(r, arguments);
            },
            moveBy: function() {
              var n = i(this, !0), r = n && n.getLastSegment(), l = z.read(arguments);
              this.moveTo(r ? l.add(r._point) : l);
            },
            closePath: function(n) {
              i(this, !0).closePath(n);
            }
          }
        );
      }(),
      a.each(["reverse", "flatten", "simplify", "smooth"], function(i) {
        this[i] = function(n) {
          for (var r = this._children, l, h = 0, f = r.length; h < f; h++)
            l = r[h][i](n) || l;
          return l;
        };
      }, {})
    );
    Ft.inject(new function() {
      var i = Math.min, n = Math.max, r = Math.abs, l = {
        unite: { 1: !0, 2: !0 },
        intersect: { 2: !0 },
        subtract: { 1: !0 },
        exclude: { 1: !0, "-1": !0 }
      };
      function h(L) {
        return L._children || [L];
      }
      function f(L, P) {
        var S = L.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
        if (P) {
          for (var I = h(S), U = 0, V = I.length; U < V; U++) {
            var L = I[U];
            !L._closed && !L.isEmpty() && (L.closePath(1e-12), L.getFirstSegment().setHandleIn(0, 0), L.getLastSegment().setHandleOut(0, 0));
          }
          S = S.resolveCrossings().reorient(S.getFillRule() === "nonzero", !0);
        }
        return S;
      }
      function m(L, P, S, I, U) {
        var V = new yi(K.NO_INSERT);
        return V.addChildren(L, !0), V = V.reduce({ simplify: P }), U && U.insert == !1 || V.insertAbove(I && S.isSibling(I) && S.getIndex() < I.getIndex() ? I : S), V.copyAttributes(S, !0), V;
      }
      function _(L) {
        return L.hasOverlap() || L.isCrossing();
      }
      function y(L, P, S, I) {
        if (I && (I.trace == !1 || I.stroke) && /^(subtract|intersect)$/.test(S))
          return x(L, P, S);
        var U = f(L, !0), V = P && L !== P && f(P, !0), F = l[S];
        F[S] = !0, V && (F.subtract || F.exclude) ^ (V.isClockwise() ^ U.isClockwise()) && V.reverse();
        var W = M(Ot.expand(
          U.getIntersections(V, _)
        )), Q = h(U), ie = V && h(V), ae = [], J = [], le;
        function fe(tt) {
          for (var gt = 0, ut = tt.length; gt < ut; gt++) {
            var yt = tt[gt];
            a.push(ae, yt._segments), a.push(J, yt.getCurves()), yt._overlapsOnly = !0;
          }
        }
        function me(tt) {
          for (var gt = [], ut = 0, yt = tt && tt.length; ut < yt; ut++)
            gt.push(J[tt[ut]]);
          return gt;
        }
        if (W.length) {
          fe(Q), ie && fe(ie);
          for (var ve = new Array(J.length), Se = 0, Re = J.length; Se < Re; Se++)
            ve[Se] = J[Se].getValues();
          for (var He = T.findCurveBoundsCollisions(
            ve,
            ve,
            0,
            !0
          ), Ye = {}, Se = 0; Se < J.length; Se++) {
            var Je = J[Se], Be = Je._path._id, Ie = Ye[Be] = Ye[Be] || {};
            Ie[Je.getIndex()] = {
              hor: me(He[Se].hor),
              ver: me(He[Se].ver)
            };
          }
          for (var Se = 0, Re = W.length; Se < Re; Se++)
            E(
              W[Se]._segment,
              U,
              V,
              Ye,
              F
            );
          for (var Se = 0, Re = ae.length; Se < Re; Se++) {
            var Ge = ae[Se], et = Ge._intersection;
            Ge._winding || E(
              Ge,
              U,
              V,
              Ye,
              F
            ), et && et._overlap || (Ge._path._overlapsOnly = !1);
          }
          le = D(ae, F);
        } else
          le = C(
            ie ? Q.concat(ie) : Q.slice(),
            function(tt) {
              return !!F[tt];
            }
          );
        return m(le, !0, L, P, I);
      }
      function x(L, P, S) {
        var I = f(L), U = f(P), V = I.getIntersections(U, _), F = S === "subtract", W = S === "divide", Q = {}, ie = [];
        function ae(fe) {
          if (!Q[fe._id] && (W || U.contains(fe.getPointAt(fe.getLength() / 2)) ^ F))
            return ie.unshift(fe), Q[fe._id] = !0;
        }
        for (var J = V.length - 1; J >= 0; J--) {
          var le = V[J].split();
          le && (ae(le) && le.getFirstSegment().setHandleIn(0, 0), I.getLastSegment().setHandleOut(0, 0));
        }
        return ae(I), m(ie, !1, L, P);
      }
      function A(L, P) {
        for (var S = L; S; ) {
          if (S === P)
            return;
          S = S._previous;
        }
        for (; L._next && L._next !== P; )
          L = L._next;
        if (!L._next) {
          for (; P._previous; )
            P = P._previous;
          L._next = P, P._previous = L;
        }
      }
      function B(L) {
        for (var P = L.length - 1; P >= 0; P--)
          L[P].clearHandles();
      }
      function C(L, P, S) {
        var I = L && L.length;
        if (I) {
          var U = a.each(L, function(He, Ye) {
            this[He._id] = {
              container: null,
              winding: He.isClockwise() ? 1 : -1,
              index: Ye
            };
          }, {}), V = L.slice().sort(function(He, Ye) {
            return r(Ye.getArea()) - r(He.getArea());
          }), F = V[0], W = T.findItemBoundsCollisions(
            V,
            null,
            Y.GEOMETRIC_EPSILON
          );
          S == null && (S = F.isClockwise());
          for (var Q = 0; Q < I; Q++) {
            var ie = V[Q], ae = U[ie._id], J = 0, le = W[Q];
            if (le) {
              for (var fe = null, me = le.length - 1; me >= 0; me--)
                if (le[me] < Q) {
                  fe = fe || ie.getInteriorPoint();
                  var ve = V[le[me]];
                  if (ve.contains(fe)) {
                    var Se = U[ve._id];
                    J = Se.winding, ae.winding += J, ae.container = Se.exclude ? Se.container : ve;
                    break;
                  }
                }
            }
            if (P(ae.winding) === P(J))
              ae.exclude = !0, L[ae.index] = null;
            else {
              var Re = ae.container;
              ie.setClockwise(
                Re ? !Re.isClockwise() : S
              );
            }
          }
        }
        return L;
      }
      function M(L, P, S) {
        var I = P && [], U = 1e-8, V = 1 - U, F = !1, W = S || [], Q = S && {}, ie, ae, J;
        function le(gt) {
          return gt._path._id + "." + gt._segment1._index;
        }
        for (var fe = (S && S.length) - 1; fe >= 0; fe--) {
          var me = S[fe];
          me._path && (Q[le(me)] = !0);
        }
        for (var fe = L.length - 1; fe >= 0; fe--) {
          var ve = L[fe], Se = ve._time, Re = Se, He = P && !P(ve), me = ve._curve, Ye;
          if (me && (me !== ae ? (F = !me.hasHandles() || Q && Q[le(me)], ie = [], J = null, ae = me) : J >= U && (Se /= J)), He) {
            ie && ie.push(ve);
            continue;
          } else
            P && I.unshift(ve);
          if (J = Re, Se < U)
            Ye = me._segment1;
          else if (Se > V)
            Ye = me._segment2;
          else {
            var Je = me.divideAtTime(Se, !0);
            F && W.push(me, Je), Ye = Je._segment1;
            for (var Be = ie.length - 1; Be >= 0; Be--) {
              var Ie = ie[Be];
              Ie._time = (Ie._time - Se) / (1 - Se);
            }
          }
          ve._setSegment(Ye);
          var Ge = Ye._intersection, et = ve._intersection;
          if (Ge) {
            A(Ge, et);
            for (var tt = Ge; tt; )
              A(tt._intersection, Ge), tt = tt._next;
          } else
            Ye._intersection = et;
        }
        return S || B(W), I || L;
      }
      function R(L, P, S, I, U) {
        var V = Array.isArray(P) ? P : P[S ? "hor" : "ver"], F = S ? 1 : 0, W = F ^ 1, Q = [L.x, L.y], ie = Q[F], ae = Q[W], J = 1e-9, le = 1e-6, fe = ie - J, me = ie + J, ve = 0, Se = 0, Re = 0, He = 0, Ye = !1, Je = !1, Be = 1, Ie = [], Ge, et;
        function tt(Nt) {
          var Jt = Nt[W + 0], Ti = Nt[W + 6];
          if (!(ae < i(Jt, Ti) || ae > n(Jt, Ti))) {
            var ri = Nt[F + 0], Pi = Nt[F + 2], ci = Nt[F + 4], hi = Nt[F + 6];
            if (Jt === Ti) {
              (ri < me && hi > fe || hi < me && ri > fe) && (Ye = !0);
              return;
            }
            var Ni = ae === Jt ? 0 : ae === Ti || fe > n(ri, Pi, ci, hi) || me < i(ri, Pi, ci, hi) ? 1 : Ve.solveCubic(Nt, W, ae, Ie, 0, 1) > 0 ? Ie[0] : 1, Bi = Ni === 0 ? ri : Ni === 1 ? hi : Ve.getPoint(Nt, Ni)[S ? "y" : "x"], Ri = Jt > Ti ? 1 : -1, Wi = Ge[W] > Ge[W + 6] ? 1 : -1, Vi = Ge[F + 6];
            return ae !== Jt ? (Bi < fe ? Re += Ri : Bi > me ? He += Ri : Ye = !0, Bi > ie - le && Bi < ie + le && (Be /= 2)) : (Ri !== Wi ? ri < fe ? Re += Ri : ri > me && (He += Ri) : ri != Vi && (Vi < me && Bi > me ? (He += Ri, Ye = !0) : Vi > fe && Bi < fe && (Re += Ri, Ye = !0)), Be /= 4), Ge = Nt, !U && Bi > fe && Bi < me && Ve.getTangent(Nt, Ni)[S ? "x" : "y"] === 0 && R(L, P, !S, I, !0);
          }
        }
        function gt(Nt) {
          var Jt = Nt[W + 0], Ti = Nt[W + 2], ri = Nt[W + 4], Pi = Nt[W + 6];
          if (ae <= n(Jt, Ti, ri, Pi) && ae >= i(Jt, Ti, ri, Pi)) {
            for (var ci = Nt[F + 0], hi = Nt[F + 2], Ni = Nt[F + 4], Bi = Nt[F + 6], Ri = fe > n(ci, hi, Ni, Bi) || me < i(ci, hi, Ni, Bi) ? [Nt] : Ve.getMonoCurves(Nt, S), Wi, Vi = 0, Fn = Ri.length; Vi < Fn; Vi++)
              if (Wi = tt(Ri[Vi]))
                return Wi;
          }
        }
        for (var ut = 0, yt = V.length; ut < yt; ut++) {
          var At = V[ut], bt = At._path, li = At.getValues(), mt;
          if ((!ut || V[ut - 1]._path !== bt) && (Ge = null, bt._closed || (et = Ve.getValues(
            bt.getLastCurve().getSegment2(),
            At.getSegment1(),
            null,
            !I
          ), et[W] !== et[W + 6] && (Ge = et)), !Ge)) {
            Ge = li;
            for (var Zt = bt.getLastCurve(); Zt && Zt !== At; ) {
              var Xt = Zt.getValues();
              if (Xt[W] !== Xt[W + 6]) {
                Ge = Xt;
                break;
              }
              Zt = Zt.getPrevious();
            }
          }
          if (mt = gt(li))
            return mt;
          if (ut + 1 === yt || V[ut + 1]._path !== bt) {
            if (et && (mt = gt(et)))
              return mt;
            Ye && !Re && !He && (Re = He = bt.isClockwise(I) ^ S ? 1 : -1), ve += Re, Se += He, Re = He = 0, Ye && (Je = !0, Ye = !1), et = null;
          }
        }
        return ve = r(ve), Se = r(Se), {
          winding: n(ve, Se),
          windingL: ve,
          windingR: Se,
          quality: Be,
          onPath: Je
        };
      }
      function E(L, P, S, I, U) {
        var V = [], F = L, W = 0, J;
        do {
          var Q = L.getCurve();
          if (Q) {
            var ie = Q.getLength();
            V.push({ segment: L, curve: Q, length: ie }), W += ie;
          }
          L = L.getNext();
        } while (L && !L._intersection && L !== F);
        for (var ae = [0.5, 0.25, 0.75], J = { winding: 0, quality: -1 }, le = 1e-3, fe = 1 - le, me = 0; me < ae.length && J.quality < 0.5; me++)
          for (var ie = W * ae[me], ve = 0, Se = V.length; ve < Se; ve++) {
            var Re = V[ve], He = Re.length;
            if (ie <= He) {
              var Q = Re.curve, Ye = Q._path, Je = Ye._parent, Be = Je instanceof yi ? Je : Ye, Ie = Y.clamp(Q.getTimeAt(ie), le, fe), Ge = Q.getPointAtTime(Ie), et = r(Q.getTangentAtTime(Ie).y) < Math.SQRT1_2, tt = null;
              if (U.subtract && S) {
                var gt = Be === P ? S : P, ut = gt._getWinding(Ge, et, !0);
                if (Be === P && ut.winding || Be === S && !ut.winding) {
                  if (ut.quality < 1)
                    continue;
                  tt = { winding: 0, quality: 1 };
                }
              }
              tt = tt || R(
                Ge,
                I[Ye._id][Q.getIndex()],
                et,
                !0
              ), tt.quality > J.quality && (J = tt);
              break;
            }
            ie -= He;
          }
        for (var ve = V.length - 1; ve >= 0; ve--)
          V[ve].segment._winding = J;
      }
      function D(L, P) {
        var S = [], I;
        function U(yt) {
          var At;
          return !!(yt && !yt._visited && (!P || P[(At = yt._winding || {}).winding] && !(P.unite && At.winding === 2 && At.windingL && At.windingR)));
        }
        function V(yt) {
          if (yt) {
            for (var At = 0, bt = I.length; At < bt; At++)
              if (yt === I[At])
                return !0;
          }
          return !1;
        }
        function F(yt) {
          for (var At = yt._segments, bt = 0, li = At.length; bt < li; bt++)
            At[bt]._visited = !0;
        }
        function W(yt, At) {
          var bt = yt._intersection, li = bt, mt = [];
          At && (I = [yt]);
          function Zt(Xt, Nt) {
            for (; Xt && Xt !== Nt; ) {
              var Jt = Xt._segment, Ti = Jt && Jt._path;
              if (Ti) {
                var ri = Jt.getNext() || Ti.getFirstSegment(), Pi = ri._intersection;
                Jt !== yt && (V(Jt) || V(ri) || ri && U(Jt) && (U(ri) || Pi && U(Pi._segment))) && mt.push(Jt), At && I.push(Jt);
              }
              Xt = Xt._next;
            }
          }
          if (bt) {
            for (Zt(bt); bt && bt._previous; )
              bt = bt._previous;
            Zt(bt, li);
          }
          return mt;
        }
        L.sort(function(yt, At) {
          var bt = yt._intersection, li = At._intersection, mt = !!(bt && bt._overlap), Zt = !!(li && li._overlap), Xt = yt._path, Nt = At._path;
          return mt ^ Zt ? mt ? 1 : -1 : !bt ^ !li ? bt ? 1 : -1 : Xt !== Nt ? Xt._id - Nt._id : yt._index - At._index;
        });
        for (var Q = 0, ie = L.length; Q < ie; Q++) {
          var ae = L[Q], J = U(ae), le = null, fe = !1, me = !0, ve = [], Se, Re, He;
          if (J && ae._path._overlapsOnly) {
            var Ye = ae._path, Je = ae._intersection._segment._path;
            Ye.compare(Je) && (Ye.getArea() && S.push(Ye.clone(!1)), F(Ye), F(Je), J = !1);
          }
          for (; J; ) {
            var Be = !le, Ie = W(ae, Be), Ge = Ie.shift(), fe = !Be && (V(ae) || V(Ge)), et = !fe && Ge;
            if (Be && (le = new Bt(K.NO_INSERT), Se = null), fe) {
              (ae.isFirst() || ae.isLast()) && (me = ae._path._closed), ae._visited = !0;
              break;
            }
            if (et && Se && (ve.push(Se), Se = null), Se || (et && Ie.push(ae), Se = {
              start: le._segments.length,
              crossings: Ie,
              visited: Re = [],
              handleIn: He
            }), et && (ae = Ge), !U(ae)) {
              le.removeSegments(Se.start);
              for (var tt = 0, gt = Re.length; tt < gt; tt++)
                Re[tt]._visited = !1;
              Re.length = 0;
              do
                ae = Se && Se.crossings.shift(), (!ae || !ae._path) && (ae = null, Se = ve.pop(), Se && (Re = Se.visited, He = Se.handleIn));
              while (Se && !U(ae));
              if (!ae)
                break;
            }
            var ut = ae.getNext();
            le.add(new at(
              ae._point,
              He,
              ut && ae._handleOut
            )), ae._visited = !0, Re.push(ae), ae = ut || ae._path.getFirstSegment(), He = ut && ut._handleIn;
          }
          fe && (me && (le.getFirstSegment().setHandleIn(He), le.setClosed(me)), le.getArea() !== 0 && S.push(le));
        }
        return S;
      }
      return {
        _getWinding: function(L, P, S) {
          return R(L, this.getCurves(), P, S);
        },
        unite: function(L, P) {
          return y(this, L, "unite", P);
        },
        intersect: function(L, P) {
          return y(this, L, "intersect", P);
        },
        subtract: function(L, P) {
          return y(this, L, "subtract", P);
        },
        exclude: function(L, P) {
          return y(this, L, "exclude", P);
        },
        divide: function(L, P) {
          return P && (P.trace == !1 || P.stroke) ? x(this, L, "divide") : m([
            this.subtract(L, P),
            this.intersect(L, P)
          ], !0, this, L, P);
        },
        resolveCrossings: function() {
          var L = this._children, P = L || [this];
          function S(Se, Re) {
            var He = Se && Se._intersection;
            return He && He._overlap && He._path === Re;
          }
          var I = !1, U = !1, V = this.getIntersections(null, function(Se) {
            return Se.hasOverlap() && (I = !0) || Se.isCrossing() && (U = !0);
          }), F = I && U && [];
          if (V = Ot.expand(V), I)
            for (var W = M(V, function(Se) {
              return Se.hasOverlap();
            }, F), Q = W.length - 1; Q >= 0; Q--) {
              var ie = W[Q], ae = ie._path, J = ie._segment, le = J.getPrevious(), fe = J.getNext();
              S(le, ae) && S(fe, ae) && (J.remove(), le._handleOut._set(0, 0), fe._handleIn._set(0, 0), le !== J && !le.getCurve().hasLength() && (fe._handleIn.set(le._handleIn), le.remove()));
            }
          U && (M(V, I && function(Se) {
            var Re = Se.getCurve(), He = Se.getSegment(), Ye = Se._intersection, Je = Ye._curve, Be = Ye._segment;
            if (Re && Je && Re._path && Je._path)
              return !0;
            He && (He._intersection = null), Be && (Be._intersection = null);
          }, F), F && B(F), P = D(a.each(P, function(Se) {
            a.push(this, Se._segments);
          }, [])));
          var me = P.length, ve;
          return me > 1 && L ? (P !== L && this.setChildren(P), ve = this) : me === 1 && !L && (P[0] !== this && this.setSegments(P[0].removeSegments()), ve = this), ve || (ve = new yi(K.NO_INSERT), ve.addChildren(P), ve = ve.reduce(), ve.copyAttributes(this), this.replaceWith(ve)), ve;
        },
        reorient: function(L, P) {
          var S = this._children;
          return S && S.length ? this.setChildren(C(
            this.removeChildren(),
            function(I) {
              return !!(L ? I : I & 1);
            },
            P
          )) : P !== t && this.setClockwise(P), this;
        },
        getInteriorPoint: function() {
          var L = this.getBounds(), P = L.getCenter(!0);
          if (!this.contains(P)) {
            for (var S = this.getCurves(), I = P.y, U = [], V = [], F = 0, W = S.length; F < W; F++) {
              var Q = S[F].getValues(), ie = Q[1], ae = Q[3], J = Q[5], le = Q[7];
              if (I >= i(ie, ae, J, le) && I <= n(ie, ae, J, le))
                for (var fe = Ve.getMonoCurves(Q), me = 0, ve = fe.length; me < ve; me++) {
                  var Se = fe[me], Re = Se[1], He = Se[7];
                  if (Re !== He && (I >= Re && I <= He || I >= He && I <= Re)) {
                    var Ye = I === Re ? Se[0] : I === He ? Se[6] : Ve.solveCubic(Se, 1, I, V, 0, 1) === 1 ? Ve.getPoint(Se, V[0]).x : (Se[0] + Se[6]) / 2;
                    U.push(Ye);
                  }
                }
            }
            U.length > 1 && (U.sort(function(Je, Be) {
              return Je - Be;
            }), P.x = (U[0] + U[1]) / 2);
          }
          return P;
        }
      };
    }());
    var on = a.extend(
      {
        _class: "PathFlattener",
        initialize: function(i, n, r, l, h) {
          var f = [], m = [], _ = 0, y = 1 / (r || 32), x = i._segments, A = x[0], B;
          function C(D, L) {
            var P = Ve.getValues(D, L, h);
            f.push(P), M(P, D._index, 0, 1);
          }
          function M(D, L, P, S) {
            if (S - P > y && !(l && Ve.isStraight(D)) && !Ve.isFlatEnough(D, n || 0.25)) {
              var I = Ve.subdivide(D, 0.5), U = (P + S) / 2;
              M(I[0], L, P, U), M(I[1], L, U, S);
            } else {
              var V = D[6] - D[0], F = D[7] - D[1], W = Math.sqrt(V * V + F * F);
              W > 0 && (_ += W, m.push({
                offset: _,
                curve: D,
                index: L,
                time: S
              }));
            }
          }
          for (var R = 1, E = x.length; R < E; R++)
            B = x[R], C(A, B), A = B;
          i._closed && C(B || A, x[0]), this.curves = f, this.parts = m, this.length = _, this.index = 0;
        },
        _get: function(i) {
          for (var n = this.parts, r = n.length, l, h = this.index; l = h, !(!h || n[--h].offset < i); )
            ;
          for (; l < r; l++) {
            var f = n[l];
            if (f.offset >= i) {
              this.index = l;
              var m = n[l - 1], _ = m && m.index === f.index ? m.time : 0, y = m ? m.offset : 0;
              return {
                index: f.index,
                time: _ + (f.time - _) * (i - y) / (f.offset - y)
              };
            }
          }
          return {
            index: n[r - 1].index,
            time: 1
          };
        },
        drawPart: function(i, n, r) {
          for (var l = this._get(n), h = this._get(r), f = l.index, m = h.index; f <= m; f++) {
            var _ = Ve.getPart(
              this.curves[f],
              f === l.index ? l.time : 0,
              f === h.index ? h.time : 1
            );
            f === l.index && i.moveTo(_[0], _[1]), i.bezierCurveTo.apply(i, _.slice(2));
          }
        }
      },
      a.each(
        Ve._evaluateMethods,
        function(i) {
          this[i + "At"] = function(n) {
            var r = this._get(n);
            return Ve[i](this.curves[r.index], r.time);
          };
        },
        {}
      )
    ), Tn = a.extend({
      initialize: function(i) {
        for (var n = this.points = [], r = i._segments, l = i._closed, h = 0, f, m = r.length; h < m; h++) {
          var _ = r[h].point;
          (!f || !f.equals(_)) && n.push(f = _.clone());
        }
        l && (n.unshift(n[n.length - 1]), n.push(n[1])), this.closed = l;
      },
      fit: function(i) {
        var n = this.points, r = n.length, l = null;
        return r > 0 && (l = [new at(n[0])], r > 1 && (this.fitCubic(
          l,
          i,
          0,
          r - 1,
          n[1].subtract(n[0]),
          n[r - 2].subtract(n[r - 1])
        ), this.closed && (l.shift(), l.pop()))), l;
      },
      fitCubic: function(i, n, r, l, h, f) {
        var m = this.points;
        if (l - r === 1) {
          var _ = m[r], y = m[l], x = _.getDistance(y) / 3;
          this.addCurve(i, [
            _,
            _.add(h.normalize(x)),
            y.add(f.normalize(x)),
            y
          ]);
          return;
        }
        for (var A = this.chordLengthParameterize(r, l), B = Math.max(n, n * n), C, M = !0, R = 0; R <= 4; R++) {
          var E = this.generateBezier(r, l, A, h, f), D = this.findMaxError(r, l, E, A);
          if (D.error < n && M) {
            this.addCurve(i, E);
            return;
          }
          if (C = D.index, D.error >= B)
            break;
          M = this.reparameterize(r, l, A, E), B = D.error;
        }
        var L = m[C - 1].subtract(m[C + 1]);
        this.fitCubic(i, n, r, C, h, L), this.fitCubic(i, n, C, l, L.negate(), f);
      },
      addCurve: function(i, n) {
        var r = i[i.length - 1];
        r.setHandleOut(n[1].subtract(n[0])), i.push(new at(n[3], n[2].subtract(n[3])));
      },
      generateBezier: function(i, n, r, l, h) {
        for (var f = 1e-12, m = Math.abs, _ = this.points, y = _[i], x = _[n], A = [[0, 0], [0, 0]], B = [0, 0], C = 0, M = n - i + 1; C < M; C++) {
          var R = r[C], E = 1 - R, D = 3 * R * E, L = E * E * E, P = D * E, S = D * R, I = R * R * R, U = l.normalize(P), V = h.normalize(S), F = _[i + C].subtract(y.multiply(L + P)).subtract(x.multiply(S + I));
          A[0][0] += U.dot(U), A[0][1] += U.dot(V), A[1][0] = A[0][1], A[1][1] += V.dot(V), B[0] += U.dot(F), B[1] += V.dot(F);
        }
        var W = A[0][0] * A[1][1] - A[1][0] * A[0][1], Q, ie;
        if (m(W) > f) {
          var ae = A[0][0] * B[1] - A[1][0] * B[0], J = B[0] * A[1][1] - B[1] * A[0][1];
          Q = J / W, ie = ae / W;
        } else {
          var le = A[0][0] + A[0][1], fe = A[1][0] + A[1][1];
          Q = ie = m(le) > f ? B[0] / le : m(fe) > f ? B[1] / fe : 0;
        }
        var me = x.getDistance(y), ve = f * me, Se, Re;
        if (Q < ve || ie < ve)
          Q = ie = me / 3;
        else {
          var He = x.subtract(y);
          Se = l.normalize(Q), Re = h.normalize(ie), Se.dot(He) - Re.dot(He) > me * me && (Q = ie = me / 3, Se = Re = null);
        }
        return [
          y,
          y.add(Se || l.normalize(Q)),
          x.add(Re || h.normalize(ie)),
          x
        ];
      },
      reparameterize: function(i, n, r, l) {
        for (var h = i; h <= n; h++)
          r[h - i] = this.findRoot(l, this.points[h], r[h - i]);
        for (var h = 1, f = r.length; h < f; h++)
          if (r[h] <= r[h - 1])
            return !1;
        return !0;
      },
      findRoot: function(i, n, r) {
        for (var l = [], h = [], f = 0; f <= 2; f++)
          l[f] = i[f + 1].subtract(i[f]).multiply(3);
        for (var f = 0; f <= 1; f++)
          h[f] = l[f + 1].subtract(l[f]).multiply(2);
        var m = this.evaluate(3, i, r), _ = this.evaluate(2, l, r), y = this.evaluate(1, h, r), x = m.subtract(n), A = _.dot(_) + x.dot(y);
        return Y.isMachineZero(A) ? r : r - x.dot(_) / A;
      },
      evaluate: function(i, n, r) {
        for (var l = n.slice(), h = 1; h <= i; h++)
          for (var f = 0; f <= i - h; f++)
            l[f] = l[f].multiply(1 - r).add(l[f + 1].multiply(r));
        return l[0];
      },
      chordLengthParameterize: function(i, n) {
        for (var r = [0], l = i + 1; l <= n; l++)
          r[l - i] = r[l - i - 1] + this.points[l].getDistance(this.points[l - 1]);
        for (var l = 1, h = n - i; l <= h; l++)
          r[l] /= r[h];
        return r;
      },
      findMaxError: function(i, n, r, l) {
        for (var h = Math.floor((n - i + 1) / 2), f = 0, m = i + 1; m < n; m++) {
          var _ = this.evaluate(3, r, l[m - i]), y = _.subtract(this.points[m]), x = y.x * y.x + y.y * y.y;
          x >= f && (f = x, h = m);
        }
        return {
          error: f,
          index: h
        };
      }
    }), Ki = K.extend({
      _class: "TextItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _serializeFields: {
        content: null
      },
      _boundsOptions: { stroke: !1, handle: !1 },
      initialize: function(n) {
        this._content = "", this._lines = [];
        var r = n && a.isPlainObject(n) && n.x === t && n.y === t;
        this._initialize(r && n, !r && z.read(arguments));
      },
      _equals: function(i) {
        return this._content === i._content;
      },
      copyContent: function(i) {
        this.setContent(i._content);
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(i) {
        this._content = "" + i, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
      },
      isEmpty: function() {
        return !this._content;
      },
      getCharacterStyle: "#getStyle",
      setCharacterStyle: "#setStyle",
      getParagraphStyle: "#getStyle",
      setParagraphStyle: "#setStyle"
    }), as = Ki.extend({
      _class: "PointText",
      initialize: function() {
        Ki.apply(this, arguments);
      },
      getPoint: function() {
        var i = this._matrix.getTranslation();
        return new he(i.x, i.y, this, "setPoint");
      },
      setPoint: function() {
        var i = z.read(arguments);
        this.translate(i.subtract(this._matrix.getTranslation()));
      },
      _draw: function(i, n, r) {
        if (this._content) {
          this._setStyles(i, n, r);
          var l = this._lines, h = this._style, f = h.hasFill(), m = h.hasStroke(), _ = h.getLeading(), y = i.shadowColor;
          i.font = h.getFontStyle(), i.textAlign = h.getJustification();
          for (var x = 0, A = l.length; x < A; x++) {
            i.shadowColor = y;
            var B = l[x];
            f && (i.fillText(B, 0, 0), i.shadowColor = "rgba(0,0,0,0)"), m && i.strokeText(B, 0, 0), i.translate(0, _);
          }
        }
      },
      _getBounds: function(i, n) {
        var r = this._style, l = this._lines, h = l.length, f = r.getJustification(), m = r.getLeading(), _ = this.getView().getTextWidth(r.getFontStyle(), l), y = 0;
        f !== "left" && (y -= _ / (f === "center" ? 2 : 1));
        var x = new se(
          y,
          h ? -0.75 * m : 0,
          _,
          h * m
        );
        return i ? i._transformBounds(x, x) : x;
      }
    }), qt = a.extend(
      new function() {
        var i = {
          gray: ["gray"],
          rgb: ["red", "green", "blue"],
          hsb: ["hue", "saturation", "brightness"],
          hsl: ["hue", "saturation", "lightness"],
          gradient: ["gradient", "origin", "destination", "highlight"]
        }, n = {}, r = {
          transparent: [0, 0, 0, 0]
        }, l;
        function h(_) {
          var y = _.match(
            /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
          ) || _.match(
            /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
          ), x = "rgb", A;
          if (y) {
            var B = y[4] ? 4 : 3;
            A = new Array(B);
            for (var C = 0; C < B; C++) {
              var M = y[C + 1];
              A[C] = parseInt(M.length == 1 ? M + M : M, 16) / 255;
            }
          } else if (y = _.match(/^(rgb|hsl)a?\((.*)\)$/)) {
            x = y[1], A = y[2].trim().split(/[,\s]+/g);
            for (var R = x === "hsl", C = 0, E = Math.min(A.length, 4); C < E; C++) {
              var D = A[C], M = parseFloat(D);
              if (R)
                if (C === 0) {
                  var L = D.match(/([a-z]*)$/)[1];
                  M *= {
                    turn: 360,
                    rad: 180 / Math.PI,
                    grad: 0.9
                  }[L] || 1;
                } else
                  C < 3 && (M /= 100);
              else
                C < 3 && (M /= /%$/.test(D) ? 100 : 255);
              A[C] = M;
            }
          } else {
            var P = r[_];
            if (!P)
              if (s) {
                l || (l = Ut.getContext(1, 1, {
                  willReadFrequently: !0
                }), l.globalCompositeOperation = "copy"), l.fillStyle = "rgba(0,0,0,0)", l.fillStyle = _, l.fillRect(0, 0, 1, 1);
                var S = l.getImageData(0, 0, 1, 1).data;
                P = r[_] = [
                  S[0] / 255,
                  S[1] / 255,
                  S[2] / 255
                ];
              } else
                P = [0, 0, 0];
            A = P.slice();
          }
          return [x, A];
        }
        var f = [
          [0, 3, 1],
          [2, 0, 1],
          [1, 0, 3],
          [1, 2, 0],
          [3, 1, 0],
          [0, 1, 2]
        ], m = {
          "rgb-hsb": function(_, y, x) {
            var A = Math.max(_, y, x), B = Math.min(_, y, x), C = A - B, M = C === 0 ? 0 : (A == _ ? (y - x) / C + (y < x ? 6 : 0) : A == y ? (x - _) / C + 2 : (_ - y) / C + 4) * 60;
            return [M, A === 0 ? 0 : C / A, A];
          },
          "hsb-rgb": function(_, y, x) {
            _ = (_ / 60 % 6 + 6) % 6;
            var B = Math.floor(_), A = _ - B, B = f[B], C = [
              x,
              x * (1 - y),
              x * (1 - y * A),
              x * (1 - y * (1 - A))
            ];
            return [C[B[0]], C[B[1]], C[B[2]]];
          },
          "rgb-hsl": function(_, y, x) {
            var A = Math.max(_, y, x), B = Math.min(_, y, x), C = A - B, M = C === 0, R = M ? 0 : (A == _ ? (y - x) / C + (y < x ? 6 : 0) : A == y ? (x - _) / C + 2 : (_ - y) / C + 4) * 60, E = (A + B) / 2, D = M ? 0 : E < 0.5 ? C / (A + B) : C / (2 - A - B);
            return [R, D, E];
          },
          "hsl-rgb": function(_, y, x) {
            if (_ = (_ / 360 % 1 + 1) % 1, y === 0)
              return [x, x, x];
            for (var A = [_ + 1 / 3, _, _ - 1 / 3], B = x < 0.5 ? x * (1 + y) : x + y - x * y, C = 2 * x - B, M = [], R = 0; R < 3; R++) {
              var E = A[R];
              E < 0 && (E += 1), E > 1 && (E -= 1), M[R] = 6 * E < 1 ? C + (B - C) * 6 * E : 2 * E < 1 ? B : 3 * E < 2 ? C + (B - C) * (2 / 3 - E) * 6 : C;
            }
            return M;
          },
          "rgb-gray": function(_, y, x) {
            return [_ * 0.2989 + y * 0.587 + x * 0.114];
          },
          "gray-rgb": function(_) {
            return [_, _, _];
          },
          "gray-hsb": function(_) {
            return [0, 0, _];
          },
          "gray-hsl": function(_) {
            return [0, 0, _];
          },
          "gradient-rgb": function() {
            return [];
          },
          "rgb-gradient": function() {
            return [];
          }
        };
        return a.each(i, function(_, y) {
          n[y] = [], a.each(_, function(x, A) {
            var B = a.capitalize(x), C = /^(hue|saturation)$/.test(x), M = n[y][A] = y === "gradient" ? x === "gradient" ? function(R) {
              var E = this._components[0];
              return R = kn.read(
                Array.isArray(R) ? R : arguments,
                0,
                { readNull: !0 }
              ), E !== R && (E && E._removeOwner(this), R && R._addOwner(this)), R;
            } : function() {
              return z.read(arguments, 0, {
                readNull: x === "highlight",
                clone: !0
              });
            } : function(R) {
              return R == null || isNaN(R) ? 0 : +R;
            };
            this["get" + B] = function() {
              return this._type === y || C && /^hs[bl]$/.test(this._type) ? this._components[A] : this._convert(y)[A];
            }, this["set" + B] = function(R) {
              this._type !== y && !(C && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(y), this._properties = i[y], this._type = y), this._components[A] = M.call(this, R), this._changed();
            };
          }, this);
        }, {
          _class: "Color",
          _readIndex: !0,
          initialize: function _(y) {
            var x = arguments, A = this.__read, B = 0, C, M, R, E;
            Array.isArray(y) && (x = y, y = x[0]);
            var D = y != null && typeof y;
            if (D === "string" && y in i && (C = y, y = x[1], Array.isArray(y) ? (M = y, R = x[2]) : (A && (B = 1), x = a.slice(x, 1), D = typeof y)), !M) {
              if (E = D === "number" ? x : D === "object" && y.length != null ? y : null, E) {
                C || (C = E.length >= 3 ? "rgb" : "gray");
                var L = i[C].length;
                R = E[L], A && (B += E === arguments ? L + (R != null ? 1 : 0) : 1), E.length > L && (E = a.slice(E, 0, L));
              } else if (D === "string") {
                var P = h(y);
                C = P[0], M = P[1], M.length === 4 && (R = M[3], M.length--);
              } else if (D === "object")
                if (y.constructor === _) {
                  if (C = y._type, M = y._components.slice(), R = y._alpha, C === "gradient")
                    for (var S = 1, I = M.length; S < I; S++) {
                      var U = M[S];
                      U && (M[S] = U.clone());
                    }
                } else if (y.constructor === kn)
                  C = "gradient", E = x;
                else {
                  C = "hue" in y ? "lightness" in y ? "hsl" : "hsb" : "gradient" in y || "stops" in y || "radial" in y ? "gradient" : "gray" in y ? "gray" : "rgb";
                  var V = i[C], F = n[C];
                  this._components = M = [];
                  for (var S = 0, I = V.length; S < I; S++) {
                    var W = y[V[S]];
                    W == null && !S && C === "gradient" && "stops" in y && (W = {
                      stops: y.stops,
                      radial: y.radial
                    }), W = F[S].call(this, W), W != null && (M[S] = W);
                  }
                  R = y.alpha;
                }
              A && C && (B = 1);
            }
            if (this._type = C || "rgb", !M) {
              this._components = M = [];
              for (var F = n[this._type], S = 0, I = F.length; S < I; S++) {
                var W = F[S].call(this, E && E[S]);
                W != null && (M[S] = W);
              }
            }
            return this._components = M, this._properties = i[this._type], this._alpha = R, A && (this.__read = B), this;
          },
          set: "#initialize",
          _serialize: function(_, y) {
            var x = this.getComponents();
            return a.serialize(
              /^(gray|rgb)$/.test(this._type) ? x : [this._type].concat(x),
              _,
              !0,
              y
            );
          },
          _changed: function() {
            this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
          },
          _convert: function(_) {
            var y;
            return this._type === _ ? this._components.slice() : (y = m[this._type + "-" + _]) ? y.apply(this, this._components) : m["rgb-" + _].apply(
              this,
              m[this._type + "-rgb"].apply(
                this,
                this._components
              )
            );
          },
          convert: function(_) {
            return new qt(_, this._convert(_), this._alpha);
          },
          getType: function() {
            return this._type;
          },
          setType: function(_) {
            this._components = this._convert(_), this._properties = i[_], this._type = _;
          },
          getComponents: function() {
            var _ = this._components.slice();
            return this._alpha != null && _.push(this._alpha), _;
          },
          getAlpha: function() {
            return this._alpha != null ? this._alpha : 1;
          },
          setAlpha: function(_) {
            this._alpha = _ == null ? null : Math.min(Math.max(_, 0), 1), this._changed();
          },
          hasAlpha: function() {
            return this._alpha != null;
          },
          equals: function(_) {
            var y = a.isPlainValue(_, !0) ? qt.read(arguments) : _;
            return y === this || y && this._class === y._class && this._type === y._type && this.getAlpha() === y.getAlpha() && a.equals(this._components, y._components) || !1;
          },
          toString: function() {
            for (var _ = this._properties, y = [], x = this._type === "gradient", A = H.instance, B = 0, C = _.length; B < C; B++) {
              var M = this._components[B];
              M != null && y.push(_[B] + ": " + (x ? M : A.number(M)));
            }
            return this._alpha != null && y.push("alpha: " + A.number(this._alpha)), "{ " + y.join(", ") + " }";
          },
          toCSS: function(_) {
            var y = this._convert("rgb"), x = _ || this._alpha == null ? 1 : this._alpha;
            function A(B) {
              return Math.round((B < 0 ? 0 : B > 1 ? 1 : B) * 255);
            }
            return y = [
              A(y[0]),
              A(y[1]),
              A(y[2])
            ], x < 1 && y.push(x < 0 ? 0 : x), _ ? "#" + ((1 << 24) + (y[0] << 16) + (y[1] << 8) + y[2]).toString(16).slice(1) : (y.length == 4 ? "rgba(" : "rgb(") + y.join(",") + ")";
          },
          toCanvasStyle: function(_, y) {
            if (this._canvasStyle)
              return this._canvasStyle;
            if (this._type !== "gradient")
              return this._canvasStyle = this.toCSS();
            var x = this._components, A = x[0], B = A._stops, C = x[1], M = x[2], R = x[3], E = y && y.inverted(), D;
            if (E && (C = E._transformPoint(C), M = E._transformPoint(M), R && (R = E._transformPoint(R))), A._radial) {
              var L = M.getDistance(C);
              if (R) {
                var P = R.subtract(C);
                P.getLength() > L && (R = C.add(P.normalize(L - 0.1)));
              }
              var S = R || C;
              D = _.createRadialGradient(
                S.x,
                S.y,
                0,
                C.x,
                C.y,
                L
              );
            } else
              D = _.createLinearGradient(
                C.x,
                C.y,
                M.x,
                M.y
              );
            for (var I = 0, U = B.length; I < U; I++) {
              var V = B[I], F = V._offset;
              D.addColorStop(
                F ?? I / (U - 1),
                V._color.toCanvasStyle()
              );
            }
            return this._canvasStyle = D;
          },
          transform: function(_) {
            if (this._type === "gradient") {
              for (var y = this._components, x = 1, A = y.length; x < A; x++) {
                var B = y[x];
                _._transformPoint(B, B, !0);
              }
              this._changed();
            }
          },
          statics: {
            _types: i,
            random: function() {
              var _ = Math.random;
              return new qt(_(), _(), _());
            },
            _setOwner: function(_, y, x) {
              return _ && (_._owner && y && _._owner !== y && (_ = _.clone()), !_._owner ^ !y && (_._owner = y || null, _._setter = x || null)), _;
            }
          }
        });
      }(),
      new function() {
        var i = {
          add: function(n, r) {
            return n + r;
          },
          subtract: function(n, r) {
            return n - r;
          },
          multiply: function(n, r) {
            return n * r;
          },
          divide: function(n, r) {
            return n / r;
          }
        };
        return a.each(i, function(n, r) {
          this[r] = function(l) {
            l = qt.read(arguments);
            for (var h = this._type, f = this._components, m = l._convert(h), _ = 0, y = f.length; _ < y; _++)
              m[_] = n(f[_], m[_]);
            return new qt(
              h,
              m,
              this._alpha != null ? n(this._alpha, l.getAlpha()) : null
            );
          };
        }, {});
      }()
    ), kn = a.extend({
      _class: "Gradient",
      initialize: function(n, r) {
        this._id = ee.get(), n && a.isPlainObject(n) && (this.set(n), n = r = null), this._stops == null && this.setStops(n || ["white", "black"]), this._radial == null && this.setRadial(typeof r == "string" && r === "radial" || r || !1);
      },
      _serialize: function(i, n) {
        return n.add(this, function() {
          return a.serialize(
            [this._stops, this._radial],
            i,
            !0,
            n
          );
        });
      },
      _changed: function() {
        for (var i = 0, n = this._owners && this._owners.length; i < n; i++)
          this._owners[i]._changed();
      },
      _addOwner: function(i) {
        this._owners || (this._owners = []), this._owners.push(i);
      },
      _removeOwner: function(i) {
        var n = this._owners ? this._owners.indexOf(i) : -1;
        n != -1 && (this._owners.splice(n, 1), this._owners.length || (this._owners = t));
      },
      clone: function() {
        for (var i = [], n = 0, r = this._stops.length; n < r; n++)
          i[n] = this._stops[n].clone();
        return new kn(i, this._radial);
      },
      getStops: function() {
        return this._stops;
      },
      setStops: function(i) {
        if (i.length < 2)
          throw new Error(
            "Gradient stop list needs to contain at least two stops."
          );
        var n = this._stops;
        if (n)
          for (var r = 0, l = n.length; r < l; r++)
            n[r]._owner = t;
        n = this._stops = Ms.readList(i, 0, { clone: !0 });
        for (var r = 0, l = n.length; r < l; r++)
          n[r]._owner = this;
        this._changed();
      },
      getRadial: function() {
        return this._radial;
      },
      setRadial: function(i) {
        this._radial = i, this._changed();
      },
      equals: function(i) {
        if (i === this)
          return !0;
        if (i && this._class === i._class) {
          var n = this._stops, r = i._stops, l = n.length;
          if (l === r.length) {
            for (var h = 0; h < l; h++)
              if (!n[h].equals(r[h]))
                return !1;
            return !0;
          }
        }
        return !1;
      }
    }), Ms = a.extend({
      _class: "GradientStop",
      initialize: function(n, r) {
        var l = n, h = r;
        typeof n == "object" && r === t && (Array.isArray(n) && typeof n[0] != "number" ? (l = n[0], h = n[1]) : ("color" in n || "offset" in n || "rampPoint" in n) && (l = n.color, h = n.offset || n.rampPoint || 0)), this.setColor(l), this.setOffset(h);
      },
      clone: function() {
        return new Ms(this._color.clone(), this._offset);
      },
      _serialize: function(i, n) {
        var r = this._color, l = this._offset;
        return a.serialize(
          l == null ? [r] : [r, l],
          i,
          !0,
          n
        );
      },
      _changed: function() {
        this._owner && this._owner._changed(129);
      },
      getOffset: function() {
        return this._offset;
      },
      setOffset: function(i) {
        this._offset = i, this._changed();
      },
      getRampPoint: "#getOffset",
      setRampPoint: "#setOffset",
      getColor: function() {
        return this._color;
      },
      setColor: function() {
        qt._setOwner(this._color, null), this._color = qt._setOwner(
          qt.read(arguments, 0),
          this,
          "setColor"
        ), this._changed();
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._color.equals(i._color) && this._offset == i._offset || !1;
      }
    }), Wn = a.extend(new function() {
      var i = {
        fillColor: null,
        fillRule: "nonzero",
        strokeColor: null,
        strokeWidth: 1,
        strokeCap: "butt",
        strokeJoin: "miter",
        strokeScaling: !0,
        miterLimit: 10,
        dashOffset: 0,
        dashArray: [],
        shadowColor: null,
        shadowBlur: 0,
        shadowOffset: new z(),
        selectedColor: null
      }, n = a.set({}, i, {
        fontFamily: "sans-serif",
        fontWeight: "normal",
        fontSize: 12,
        leading: null,
        justification: "left"
      }), r = a.set({}, n, {
        fillColor: new qt()
      }), l = {
        strokeWidth: 193,
        strokeCap: 193,
        strokeJoin: 193,
        strokeScaling: 201,
        miterLimit: 193,
        fontFamily: 9,
        fontWeight: 9,
        fontSize: 9,
        font: 9,
        leading: 9,
        justification: 9
      }, h = {
        beans: !0
      }, f = {
        _class: "Style",
        beans: !0,
        initialize: function(_, y, x) {
          this._values = {}, this._owner = y, this._project = y && y._project || x || nt.project, this._defaults = !y || y instanceof j ? n : y instanceof Ki ? r : i, _ && this.set(_);
        }
      };
      return a.each(n, function(m, _) {
        var y = /Color$/.test(_), x = _ === "shadowOffset", A = a.capitalize(_), B = l[_], C = "set" + A, M = "get" + A;
        f[C] = function(R) {
          var E = this._owner, D = E && E._children, L = D && D.length > 0 && !(E instanceof yi);
          if (L)
            for (var P = 0, S = D.length; P < S; P++)
              D[P]._style[C](R);
          if ((_ === "selectedColor" || !L) && _ in this._defaults) {
            var I = this._values[_];
            I !== R && (y && (I && (qt._setOwner(I, null), I._canvasStyle = null), R && R.constructor === qt && (R = qt._setOwner(
              R,
              E,
              L && C
            ))), this._values[_] = R, E && E._changed(B || 129));
          }
        }, f[M] = function(R) {
          var E = this._owner, D = E && E._children, L = D && D.length > 0 && !(E instanceof yi), P;
          if (L && !R)
            for (var S = 0, I = D.length; S < I; S++) {
              var U = D[S]._style[M]();
              if (!S)
                P = U;
              else if (!a.equals(P, U))
                return t;
            }
          else if (_ in this._defaults) {
            var P = this._values[_];
            if (P === t)
              P = this._defaults[_], P && P.clone && (P = P.clone());
            else {
              var V = y ? qt : x ? z : null;
              V && !(P && P.constructor === V) && (this._values[_] = P = V.read(
                [P],
                0,
                { readNull: !0, clone: !0 }
              ));
            }
          }
          return P && y && (P = qt._setOwner(P, E, L && C)), P;
        }, h[M] = function(R) {
          return this._style[M](R);
        }, h[C] = function(R) {
          this._style[C](R);
        };
      }), a.each({
        Font: "FontFamily",
        WindingRule: "FillRule"
      }, function(m, _) {
        var y = "get" + _, x = "set" + _;
        f[y] = h[y] = "#get" + m, f[x] = h[x] = "#set" + m;
      }), K.inject(h), f;
    }(), {
      set: function(i) {
        var n = i instanceof Wn, r = n ? i._values : i;
        if (r) {
          for (var l in r)
            if (l in this._defaults) {
              var h = r[l];
              this[l] = h && n && h.clone ? h.clone() : h;
            }
        }
      },
      equals: function(i) {
        function n(r, l, h) {
          var f = r._values, m = l._values, _ = l._defaults;
          for (var y in f) {
            var x = f[y], A = m[y];
            if (!(h && y in m) && !a.equals(
              x,
              A === t ? _[y] : A
            ))
              return !1;
          }
          return !0;
        }
        return i === this || i && this._class === i._class && n(this, i) && n(i, this, !0) || !1;
      },
      _dispose: function() {
        var i;
        i = this.getFillColor(), i && (i._canvasStyle = null), i = this.getStrokeColor(), i && (i._canvasStyle = null), i = this.getShadowColor(), i && (i._canvasStyle = null);
      },
      hasFill: function() {
        var i = this.getFillColor();
        return !!i && i.alpha > 0;
      },
      hasStroke: function() {
        var i = this.getStrokeColor();
        return !!i && i.alpha > 0 && this.getStrokeWidth() > 0;
      },
      hasShadow: function() {
        var i = this.getShadowColor();
        return !!i && i.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
      },
      getView: function() {
        return this._project._view;
      },
      getFontStyle: function() {
        var i = this.getFontSize();
        return this.getFontWeight() + " " + i + (/[a-z]/i.test(i + "") ? " " : "px ") + this.getFontFamily();
      },
      getFont: "#getFontFamily",
      setFont: "#setFontFamily",
      getLeading: function i() {
        var n = i.base.call(this), r = this.getFontSize();
        return /pt|em|%|px/.test(r) && (r = this.getView().getPixelSize(r)), n ?? r * 1.2;
      }
    }), zt = new function() {
      function i(n, r, l, h) {
        for (var f = ["", "webkit", "moz", "Moz", "ms", "o"], m = r[0].toUpperCase() + r.substring(1), _ = 0; _ < 6; _++) {
          var y = f[_], x = y ? y + m : r;
          if (x in n) {
            if (l)
              n[x] = h;
            else
              return n[x];
            break;
          }
        }
      }
      return {
        getStyles: function(n) {
          var r = n && n.nodeType !== 9 ? n.ownerDocument : n, l = r && r.defaultView;
          return l && l.getComputedStyle(n, "");
        },
        getBounds: function(n, r) {
          var l = n.ownerDocument, h = l.body, f = l.documentElement, m;
          try {
            m = n.getBoundingClientRect();
          } catch {
            m = { left: 0, top: 0, width: 0, height: 0 };
          }
          var _ = m.left - (f.clientLeft || h.clientLeft || 0), y = m.top - (f.clientTop || h.clientTop || 0);
          if (!r) {
            var x = l.defaultView;
            _ += x.pageXOffset || f.scrollLeft || h.scrollLeft, y += x.pageYOffset || f.scrollTop || h.scrollTop;
          }
          return new se(_, y, m.width, m.height);
        },
        getViewportBounds: function(n) {
          var r = n.ownerDocument, l = r.defaultView, h = r.documentElement;
          return new se(
            0,
            0,
            l.innerWidth || h.clientWidth,
            l.innerHeight || h.clientHeight
          );
        },
        getOffset: function(n, r) {
          return zt.getBounds(n, r).getPoint();
        },
        getSize: function(n) {
          return zt.getBounds(n, !0).getSize();
        },
        isInvisible: function(n) {
          return zt.getSize(n).equals(new ne(0, 0));
        },
        isInView: function(n) {
          return !zt.isInvisible(n) && zt.getViewportBounds(n).intersects(
            zt.getBounds(n, !0)
          );
        },
        isInserted: function(n) {
          return o.body.contains(n);
        },
        getPrefixed: function(n, r) {
          return n && i(n, r);
        },
        setPrefixed: function(n, r, l) {
          if (typeof r == "object")
            for (var h in r)
              i(n, h, !0, r[h]);
          else
            i(n, r, !0, l);
        }
      };
    }(), Dt = {
      add: function(i, n) {
        if (i)
          for (var r in n)
            for (var l = n[r], h = r.split(/[\s,]+/g), f = 0, m = h.length; f < m; f++) {
              var _ = h[f], y = i === o && (_ === "touchstart" || _ === "touchmove") ? { passive: !1 } : !1;
              i.addEventListener(_, l, y);
            }
      },
      remove: function(i, n) {
        if (i)
          for (var r in n)
            for (var l = n[r], h = r.split(/[\s,]+/g), f = 0, m = h.length; f < m; f++)
              i.removeEventListener(h[f], l, !1);
      },
      getPoint: function(i) {
        var n = i.targetTouches ? i.targetTouches.length ? i.targetTouches[0] : i.changedTouches[0] : i;
        return new z(
          n.pageX || n.clientX + o.documentElement.scrollLeft,
          n.pageY || n.clientY + o.documentElement.scrollTop
        );
      },
      getTarget: function(i) {
        return i.target || i.srcElement;
      },
      getRelatedTarget: function(i) {
        return i.relatedTarget || i.toElement;
      },
      getOffset: function(i, n) {
        return Dt.getPoint(i).subtract(zt.getOffset(
          n || Dt.getTarget(i)
        ));
      }
    };
    Dt.requestAnimationFrame = new function() {
      var i = zt.getPrefixed(s, "requestAnimationFrame"), n = !1, r = [], l;
      function h() {
        var f = r;
        r = [];
        for (var m = 0, _ = f.length; m < _; m++)
          f[m]();
        n = i && r.length, n && i(h);
      }
      return function(f) {
        r.push(f), i ? n || (i(h), n = !0) : l || (l = setInterval(h, 1e3 / 60));
      };
    }();
    var Ht = a.extend(
      c,
      {
        _class: "View",
        initialize: function i(n, r) {
          function l(B) {
            return r[B] || parseInt(r.getAttribute(B), 10);
          }
          function h() {
            var B = zt.getSize(r);
            return B.isNaN() || B.isZero() ? new ne(l("width"), l("height")) : B;
          }
          var f;
          if (s && r) {
            this._id = r.getAttribute("id"), this._id == null && r.setAttribute("id", this._id = "paper-view-" + i._id++), Dt.add(r, this._viewEvents);
            var m = "none";
            if (zt.setPrefixed(r.style, {
              userDrag: m,
              userSelect: m,
              touchCallout: m,
              contentZooming: m,
              tapHighlightColor: "rgba(0,0,0,0)"
            }), g.hasAttribute(r, "resize")) {
              var _ = this;
              Dt.add(s, this._windowEvents = {
                resize: function() {
                  _.setViewSize(h());
                }
              });
            }
            if (f = h(), g.hasAttribute(r, "stats") && typeof Stats < "u") {
              this._stats = new Stats();
              var y = this._stats.domElement, x = y.style, A = zt.getOffset(r);
              x.position = "absolute", x.left = A.x + "px", x.top = A.y + "px", o.body.appendChild(y);
            }
          } else
            f = new ne(r), r = null;
          this._project = n, this._scope = n._scope, this._element = r, this._pixelRatio || (this._pixelRatio = s && s.devicePixelRatio || 1), this._setElementSize(f.width, f.height), this._viewSize = f, i._views.push(this), i._viewsById[this._id] = this, (this._matrix = new ue())._owner = this, i._focused || (i._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !nt.agent.node, this._needsUpdate = !1;
        },
        remove: function() {
          if (!this._project)
            return !1;
          Ht._focused === this && (Ht._focused = null), Ht._views.splice(Ht._views.indexOf(this), 1), delete Ht._viewsById[this._id];
          var i = this._project;
          return i._view === this && (i._view = null), Dt.remove(this._element, this._viewEvents), Dt.remove(s, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
        },
        _events: a.each(
          K._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
          function(i) {
            this[i] = {};
          },
          {
            onFrame: {
              install: function() {
                this.play();
              },
              uninstall: function() {
                this.pause();
              }
            }
          }
        ),
        _animate: !1,
        _time: 0,
        _count: 0,
        getAutoUpdate: function() {
          return this._autoUpdate;
        },
        setAutoUpdate: function(i) {
          this._autoUpdate = i, i && this.requestUpdate();
        },
        update: function() {
        },
        draw: function() {
          this.update();
        },
        requestUpdate: function() {
          if (!this._requested) {
            var i = this;
            Dt.requestAnimationFrame(function() {
              if (i._requested = !1, i._animate) {
                i.requestUpdate();
                var n = i._element;
                (!zt.getPrefixed(o, "hidden") || g.getAttribute(n, "keepalive") === "true") && zt.isInView(n) && i._handleFrame();
              }
              i._autoUpdate && i.update();
            }), this._requested = !0;
          }
        },
        play: function() {
          this._animate = !0, this.requestUpdate();
        },
        pause: function() {
          this._animate = !1;
        },
        _handleFrame: function() {
          nt = this._scope;
          var i = Date.now() / 1e3, n = this._last ? i - this._last : 0;
          this._last = i, this.emit("frame", new a({
            delta: n,
            time: this._time += n,
            count: this._count++
          })), this._stats && this._stats.update();
        },
        _animateItem: function(i, n) {
          var r = this._frameItems;
          n ? (r[i._id] = {
            item: i,
            time: 0,
            count: 0
          }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete r[i._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
        },
        _handleFrameItems: function(i) {
          for (var n in this._frameItems) {
            var r = this._frameItems[n];
            r.item.emit("frame", new a(i, {
              time: r.time += i.delta,
              count: r.count++
            }));
          }
        },
        _changed: function() {
          this._project._changed(4097), this._bounds = this._decomposed = t;
        },
        getElement: function() {
          return this._element;
        },
        getPixelRatio: function() {
          return this._pixelRatio;
        },
        getResolution: function() {
          return this._pixelRatio * 72;
        },
        getViewSize: function() {
          var i = this._viewSize;
          return new ye(i.width, i.height, this, "setViewSize");
        },
        setViewSize: function() {
          var i = ne.read(arguments), n = i.subtract(this._viewSize);
          n.isZero() || (this._setElementSize(i.width, i.height), this._viewSize.set(i), this._changed(), this.emit("resize", { size: i, delta: n }), this._autoUpdate && this.update());
        },
        _setElementSize: function(i, n) {
          var r = this._element;
          r && (r.width !== i && (r.width = i), r.height !== n && (r.height = n));
        },
        getBounds: function() {
          return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
            new se(new z(), this._viewSize)
          )), this._bounds;
        },
        getSize: function() {
          return this.getBounds().getSize();
        },
        isVisible: function() {
          return zt.isInView(this._element);
        },
        isInserted: function() {
          return zt.isInserted(this._element);
        },
        getPixelSize: function(i) {
          var n = this._element, r;
          if (n) {
            var l = n.parentNode, h = o.createElement("div");
            h.style.fontSize = i, l.appendChild(h), r = parseFloat(zt.getStyles(h).fontSize), l.removeChild(h);
          } else
            r = parseFloat(r);
          return r;
        },
        getTextWidth: function(i, n) {
          return 0;
        }
      },
      a.each(["rotate", "scale", "shear", "skew"], function(i) {
        var n = i === "rotate";
        this[i] = function() {
          var r = arguments, l = (n ? a : z).read(r), h = z.read(r, 0, { readNull: !0 });
          return this.transform(new ue()[i](
            l,
            h || this.getCenter(!0)
          ));
        };
      }, {
        _decompose: function() {
          return this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        translate: function() {
          var i = new ue();
          return this.transform(i.translate.apply(i, arguments));
        },
        getCenter: function() {
          return this.getBounds().getCenter();
        },
        setCenter: function() {
          var i = z.read(arguments);
          this.translate(this.getCenter().subtract(i));
        },
        getZoom: function() {
          var i = this._decompose().scaling;
          return (i.x + i.y) / 2;
        },
        setZoom: function(i) {
          this.transform(new ue().scale(
            i / this.getZoom(),
            this.getCenter()
          ));
        },
        getRotation: function() {
          return this._decompose().rotation;
        },
        setRotation: function(i) {
          var n = this.getRotation();
          n != null && i != null && this.rotate(i - n);
        },
        getScaling: function() {
          var i = this._decompose().scaling;
          return new he(i.x, i.y, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), n = z.read(arguments, 0, { clone: !0, readNull: !0 });
          i && n && this.scale(n.x / i.x, n.y / i.y);
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        transform: function(i) {
          this._matrix.append(i);
        },
        scrollBy: function() {
          this.translate(z.read(arguments).negate());
        }
      }),
      {
        projectToView: function() {
          return this._matrix._transformPoint(z.read(arguments));
        },
        viewToProject: function() {
          return this._matrix._inverseTransform(z.read(arguments));
        },
        getEventPoint: function(i) {
          return this.viewToProject(Dt.getOffset(i, this._element));
        }
      },
      {
        statics: {
          _views: [],
          _viewsById: {},
          _id: 0,
          create: function(i, n) {
            o && typeof n == "string" && (n = o.getElementById(n));
            var r = s ? Dn : Ht;
            return new r(i, n);
          }
        }
      },
      new function() {
        if (!s)
          return;
        var i, n, r = !1, l = !1;
        function h(J) {
          var le = Dt.getTarget(J);
          return le.getAttribute && Ht._viewsById[le.getAttribute("id")];
        }
        function f() {
          var J = Ht._focused;
          if (!J || !J.isVisible()) {
            for (var le = 0, fe = Ht._views.length; le < fe; le++)
              if ((J = Ht._views[le]).isVisible()) {
                Ht._focused = n = J;
                break;
              }
          }
        }
        function m(J, le, fe) {
          J._handleMouseEvent("mousemove", le, fe);
        }
        var _ = s.navigator, y, x, A;
        _.pointerEnabled || _.msPointerEnabled ? (y = "pointerdown MSPointerDown", x = "pointermove MSPointerMove", A = "pointerup pointercancel MSPointerUp MSPointerCancel") : (y = "touchstart", x = "touchmove", A = "touchend touchcancel", "ontouchstart" in s && _.userAgent.match(
          /mobile|tablet|ip(ad|hone|od)|android|silk/i
        ) || (y += " mousedown", x += " mousemove", A += " mouseup"));
        var B = {}, C = {
          mouseout: function(J) {
            var le = Ht._focused, fe = Dt.getRelatedTarget(J);
            if (le && (!fe || fe.nodeName === "HTML")) {
              var me = Dt.getOffset(J, le._element), ve = me.x, Se = Math.abs, Re = Se(ve), He = 1 << 25, Ye = Re - He;
              me.x = Se(Ye) < Re ? Ye * (ve < 0 ? -1 : 1) : ve, m(le, J, le.viewToProject(me));
            }
          },
          scroll: f
        };
        B[y] = function(J) {
          var le = Ht._focused = h(J);
          r || (r = !0, le._handleMouseEvent("mousedown", J));
        }, C[x] = function(J) {
          var le = Ht._focused;
          if (!l) {
            var fe = h(J);
            fe ? le !== fe && (le && m(le, J), i || (i = le), le = Ht._focused = n = fe) : n && n === le && (i && !i.isInserted() && (i = null), le = Ht._focused = i, i = null, f());
          }
          le && m(le, J);
        }, C[y] = function() {
          l = !0;
        }, C[A] = function(J) {
          var le = Ht._focused;
          le && r && le._handleMouseEvent("mouseup", J), l = r = !1;
        }, Dt.add(o, C), Dt.add(s, {
          load: f
        });
        var M = !1, R = !1, E = {
          doubleclick: "click",
          mousedrag: "mousemove"
        }, D = !1, L, P, S, I, U, V, F, W;
        function Q(J, le, fe, me, ve, Se, Re) {
          var He = !1, Ye;
          function Je(Be, Ie) {
            if (Be.responds(Ie)) {
              if (Ye || (Ye = new Ds(
                Ie,
                me,
                ve,
                le || Be,
                Se ? ve.subtract(Se) : null
              )), Be.emit(Ie, Ye) && (M = !0, Ye.prevented && (R = !0), Ye.stopped))
                return He = !0;
            } else {
              var Ge = E[Ie];
              if (Ge)
                return Je(Be, Ge);
            }
          }
          for (; J && J !== Re && !Je(J, fe); )
            J = J._parent;
          return He;
        }
        function ie(J, le, fe, me, ve, Se) {
          return J._project.removeOn(fe), R = M = !1, U && Q(
            U,
            null,
            fe,
            me,
            ve,
            Se
          ) || le && le !== U && !le.isDescendant(U) && Q(le, null, fe === "mousedrag" ? "mousemove" : fe, me, ve, Se, U) || Q(
            J,
            U || le || J,
            fe,
            me,
            ve,
            Se
          );
        }
        var ae = {
          mousedown: {
            mousedown: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mouseup: {
            mouseup: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mousemove: {
            mousedrag: 1,
            mousemove: 1,
            mouseenter: 1,
            mouseleave: 1
          }
        };
        return {
          _viewEvents: B,
          _handleMouseEvent: function(J, le, fe) {
            var me = this._itemEvents, ve = me.native[J], Se = J === "mousemove", Re = this._scope.tool, He = this;
            function Ye(gt) {
              return me.virtual[gt] || He.responds(gt) || Re && Re.responds(gt);
            }
            Se && r && Ye("mousedrag") && (J = "mousedrag"), fe || (fe = this.getEventPoint(le));
            var Je = this.getBounds().contains(fe), Be = ve && Je && He._project.hitTest(fe, {
              tolerance: 0,
              fill: !0,
              stroke: !0
            }), Ie = Be && Be.item || null, Ge = !1, et = {};
            if (et[J.substr(5)] = !0, ve && Ie !== I && (I && Q(I, null, "mouseleave", le, fe), Ie && Q(Ie, null, "mouseenter", le, fe), I = Ie), D ^ Je && (Q(
              this,
              null,
              Je ? "mouseenter" : "mouseleave",
              le,
              fe
            ), Ge = !0), (Je || et.drag) && !fe.equals(P) && (ie(
              this,
              Ie,
              Se ? J : "mousemove",
              le,
              fe,
              P
            ), Ge = !0), D = Je, et.down && Je || et.up && L) {
              if (ie(this, Ie, J, le, fe, L), et.down) {
                if (W = Ie === V && Date.now() - F < 300, S = V = Ie, !R && Ie) {
                  for (var tt = Ie; tt && !tt.responds("mousedrag"); )
                    tt = tt._parent;
                  tt && (U = Ie);
                }
                L = fe;
              } else
                et.up && (!R && Ie === S && (F = Date.now(), ie(this, Ie, W ? "doubleclick" : "click", le, fe, L), W = !1), S = U = null);
              D = !1, Ge = !0;
            }
            P = fe, Ge && Re && (M = Re._handleMouseEvent(J, le, fe, et) || M), le.cancelable !== !1 && (M && !et.move || et.down && Ye("mouseup")) && le.preventDefault();
          },
          _handleKeyEvent: function(J, le, fe, me) {
            var ve = this._scope, Se = ve.tool, Re;
            function He(Ye) {
              Ye.responds(J) && (nt = ve, Ye.emit(J, Re = Re || new Sn(J, le, fe, me)));
            }
            this.isVisible() && (He(this), Se && Se.responds(J) && He(Se));
          },
          _countItemEvent: function(J, le) {
            var fe = this._itemEvents, me = fe.native, ve = fe.virtual;
            for (var Se in ae)
              me[Se] = (me[Se] || 0) + (ae[Se][J] || 0) * le;
            ve[J] = (ve[J] || 0) + le;
          },
          statics: {
            updateFocus: f,
            _resetState: function() {
              r = l = M = D = !1, i = n = L = P = S = I = U = V = F = W = null;
            }
          }
        };
      }()
    ), Dn = Ht.extend({
      _class: "CanvasView",
      initialize: function(n, r) {
        if (!(r instanceof s.HTMLCanvasElement)) {
          var l = ne.read(arguments, 1);
          if (l.isZero())
            throw new Error(
              "Cannot create CanvasView with the provided argument: " + a.slice(arguments, 1)
            );
          r = Ut.getCanvas(l);
        }
        var h = this._context = r.getContext("2d");
        if (h.save(), this._pixelRatio = 1, !/^off|false$/.test(g.getAttribute(r, "hidpi"))) {
          var f = s.devicePixelRatio || 1, m = zt.getPrefixed(
            h,
            "backingStorePixelRatio"
          ) || 1;
          this._pixelRatio = f / m;
        }
        Ht.call(this, n, r), this._needsUpdate = !0;
      },
      remove: function i() {
        return this._context.restore(), i.base.call(this);
      },
      _setElementSize: function i(n, r) {
        var l = this._pixelRatio;
        if (i.base.call(this, n * l, r * l), l !== 1) {
          var h = this._element, f = this._context;
          if (!g.hasAttribute(h, "resize")) {
            var m = h.style;
            m.width = n + "px", m.height = r + "px";
          }
          f.restore(), f.save(), f.scale(l, l);
        }
      },
      getContext: function() {
        return this._context;
      },
      getPixelSize: function i(n) {
        var r = nt.agent, l;
        if (r && r.firefox)
          l = i.base.call(this, n);
        else {
          var h = this._context, f = h.font;
          h.font = n + " serif", l = parseFloat(h.font), h.font = f;
        }
        return l;
      },
      getTextWidth: function(i, n) {
        var r = this._context, l = r.font, h = 0;
        r.font = i;
        for (var f = 0, m = n.length; f < m; f++)
          h = Math.max(h, r.measureText(n[f]).width);
        return r.font = l, h;
      },
      update: function() {
        if (!this._needsUpdate)
          return !1;
        var i = this._project, n = this._context, r = this._viewSize;
        return n.clearRect(0, 0, r.width + 1, r.height + 1), i && i.draw(n, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
      }
    }), Ln = a.extend({
      _class: "Event",
      initialize: function(n) {
        this.event = n, this.type = n && n.type;
      },
      prevented: !1,
      stopped: !1,
      preventDefault: function() {
        this.prevented = !0, this.event.preventDefault();
      },
      stopPropagation: function() {
        this.stopped = !0, this.event.stopPropagation();
      },
      stop: function() {
        this.stopPropagation(), this.preventDefault();
      },
      getTimeStamp: function() {
        return this.event.timeStamp;
      },
      getModifiers: function() {
        return qn.modifiers;
      }
    }), Sn = Ln.extend({
      _class: "KeyEvent",
      initialize: function(n, r, l, h) {
        this.type = n, this.event = r, this.key = l, this.character = h;
      },
      toString: function() {
        return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
      }
    }), qn = new function() {
      var i = {
        "	": "tab",
        " ": "space",
        "\b": "backspace",
        "": "delete",
        Spacebar: "space",
        Del: "delete",
        Win: "meta",
        Esc: "escape"
      }, n = {
        tab: "	",
        space: " ",
        enter: "\r"
      }, r = {}, l = {}, h, f, m = new a({
        shift: !1,
        control: !1,
        alt: !1,
        meta: !1,
        capsLock: !1,
        space: !1
      }).inject({
        option: {
          get: function() {
            return this.alt;
          }
        },
        command: {
          get: function() {
            var x = nt && nt.agent;
            return x && x.mac ? this.meta : this.control;
          }
        }
      });
      function _(x) {
        var A = x.key || x.keyIdentifier;
        return A = /^U\+/.test(A) ? String.fromCharCode(parseInt(A.substr(2), 16)) : /^Arrow[A-Z]/.test(A) ? A.substr(5) : A === "Unidentified" || A === t ? String.fromCharCode(x.keyCode) : A, i[A] || (A.length > 1 ? a.hyphenate(A) : A.toLowerCase());
      }
      function y(x, A, B, C) {
        var M = Ht._focused, R;
        if (r[A] = x, x ? l[A] = B : delete l[A], A.length > 1 && (R = a.camelize(A)) in m) {
          m[R] = x;
          var E = nt && nt.agent;
          if (R === "meta" && E && E.mac)
            if (x)
              h = {};
            else {
              for (var D in h)
                D in l && y(!1, D, h[D], C);
              h = null;
            }
        } else
          x && h && (h[A] = B);
        M && M._handleKeyEvent(
          x ? "keydown" : "keyup",
          C,
          A,
          B
        );
      }
      return Dt.add(o, {
        keydown: function(x) {
          var A = _(x), B = nt && nt.agent;
          A.length > 1 || B && B.chrome && (x.altKey || B.mac && x.metaKey || !B.mac && x.ctrlKey) ? y(
            !0,
            A,
            n[A] || (A.length > 1 ? "" : A),
            x
          ) : f = A;
        },
        keypress: function(x) {
          if (f) {
            var A = _(x), B = x.charCode, C = B >= 32 ? String.fromCharCode(B) : A.length > 1 ? "" : A;
            A !== f && (A = C.toLowerCase()), y(!0, A, C, x), f = null;
          }
        },
        keyup: function(x) {
          var A = _(x);
          A in l && y(!1, A, l[A], x);
        }
      }), Dt.add(s, {
        blur: function(x) {
          for (var A in l)
            y(!1, A, l[A], x);
        }
      }), {
        modifiers: m,
        isDown: function(x) {
          return !!r[x];
        }
      };
    }(), Ds = Ln.extend({
      _class: "MouseEvent",
      initialize: function(n, r, l, h, f) {
        this.type = n, this.event = r, this.point = l, this.target = h, this.delta = f;
      },
      toString: function() {
        return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
      }
    }), ln = Ln.extend({
      _class: "ToolEvent",
      _item: null,
      initialize: function(n, r, l) {
        this.tool = n, this.type = r, this.event = l;
      },
      _choosePoint: function(i, n) {
        return i || (n ? n.clone() : null);
      },
      getPoint: function() {
        return this._choosePoint(this._point, this.tool._point);
      },
      setPoint: function(i) {
        this._point = i;
      },
      getLastPoint: function() {
        return this._choosePoint(this._lastPoint, this.tool._lastPoint);
      },
      setLastPoint: function(i) {
        this._lastPoint = i;
      },
      getDownPoint: function() {
        return this._choosePoint(this._downPoint, this.tool._downPoint);
      },
      setDownPoint: function(i) {
        this._downPoint = i;
      },
      getMiddlePoint: function() {
        return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
      },
      setMiddlePoint: function(i) {
        this._middlePoint = i;
      },
      getDelta: function() {
        return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
      },
      setDelta: function(i) {
        this._delta = i;
      },
      getCount: function() {
        return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
      },
      setCount: function(i) {
        this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = i;
      },
      getItem: function() {
        if (!this._item) {
          var i = this.tool._scope.project.hitTest(this.getPoint());
          if (i) {
            for (var n = i.item, r = n._parent; /^(Group|CompoundPath)$/.test(r._class); )
              n = r, r = r._parent;
            this._item = n;
          }
        }
        return this._item;
      },
      setItem: function(i) {
        this._item = i;
      },
      toString: function() {
        return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Bn = w.extend({
      _class: "Tool",
      _list: "tools",
      _reference: "tool",
      _events: [
        "onMouseDown",
        "onMouseUp",
        "onMouseDrag",
        "onMouseMove",
        "onActivate",
        "onDeactivate",
        "onEditOptions",
        "onKeyDown",
        "onKeyUp"
      ],
      initialize: function(n) {
        w.call(this), this._moveCount = -1, this._downCount = -1, this.set(n);
      },
      getMinDistance: function() {
        return this._minDistance;
      },
      setMinDistance: function(i) {
        this._minDistance = i, i != null && this._maxDistance != null && i > this._maxDistance && (this._maxDistance = i);
      },
      getMaxDistance: function() {
        return this._maxDistance;
      },
      setMaxDistance: function(i) {
        this._maxDistance = i, this._minDistance != null && i != null && i < this._minDistance && (this._minDistance = i);
      },
      getFixedDistance: function() {
        return this._minDistance == this._maxDistance ? this._minDistance : null;
      },
      setFixedDistance: function(i) {
        this._minDistance = this._maxDistance = i;
      },
      _handleMouseEvent: function(i, n, r, l) {
        nt = this._scope, l.drag && !this.responds(i) && (i = "mousemove");
        var h = l.move || l.drag, f = this.responds(i), m = this.minDistance, _ = this.maxDistance, y = !1, x = this;
        function A(C, M) {
          var R = r, E = h ? x._point : x._downPoint || R;
          if (h) {
            if (x._moveCount >= 0 && R.equals(E))
              return !1;
            if (E && (C != null || M != null)) {
              var D = R.subtract(E), L = D.getLength();
              if (L < (C || 0))
                return !1;
              M && (R = E.add(D.normalize(
                Math.min(L, M)
              )));
            }
            x._moveCount++;
          }
          return x._point = R, x._lastPoint = E || R, l.down && (x._moveCount = -1, x._downPoint = R, x._downCount++), !0;
        }
        function B() {
          f && (y = x.emit(i, new ln(x, i, n)) || y);
        }
        if (l.down)
          A(), B();
        else if (l.up)
          A(null, _), B();
        else if (f)
          for (; A(m, _); )
            B();
        return y;
      }
    }), Js = a.extend(c, {
      _class: "Tween",
      statics: {
        easings: new a({
          linear: function(i) {
            return i;
          },
          easeInQuad: function(i) {
            return i * i;
          },
          easeOutQuad: function(i) {
            return i * (2 - i);
          },
          easeInOutQuad: function(i) {
            return i < 0.5 ? 2 * i * i : -1 + 2 * (2 - i) * i;
          },
          easeInCubic: function(i) {
            return i * i * i;
          },
          easeOutCubic: function(i) {
            return --i * i * i + 1;
          },
          easeInOutCubic: function(i) {
            return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
          },
          easeInQuart: function(i) {
            return i * i * i * i;
          },
          easeOutQuart: function(i) {
            return 1 - --i * i * i * i;
          },
          easeInOutQuart: function(i) {
            return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
          },
          easeInQuint: function(i) {
            return i * i * i * i * i;
          },
          easeOutQuint: function(i) {
            return 1 + --i * i * i * i * i;
          },
          easeInOutQuint: function(i) {
            return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
          }
        })
      },
      initialize: function i(n, r, l, h, f, m) {
        this.object = n;
        var _ = typeof f, y = _ === "function";
        this.type = y ? _ : _ === "string" ? f : "linear", this.easing = y ? f : i.easings[this.type], this.duration = h, this.running = !1, this._then = null, this._startTime = null;
        var x = r || l;
        this._keys = x ? Object.keys(x) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = x && this._getState(r), this._to = x && this._getState(l), m !== !1 && this.start();
      },
      then: function(i) {
        return this._then = i, this;
      },
      start: function() {
        return this._startTime = null, this.running = !0, this;
      },
      stop: function() {
        return this.running = !1, this;
      },
      update: function(i) {
        if (this.running) {
          i >= 1 && (i = 1, this.running = !1);
          for (var n = this.easing(i), r = this._keys, l = function(A) {
            return typeof A == "function" ? A(n, i) : A;
          }, h = 0, f = r && r.length; h < f; h++) {
            var m = r[h], _ = l(this._from[m]), y = l(this._to[m]), x = _ && y && _.__add && y.__add ? y.__subtract(_).__multiply(n).__add(_) : (y - _) * n + _;
            this._setProperty(this._parsedKeys[m], x);
          }
          this.responds("update") && this.emit("update", new a({
            progress: i,
            factor: n
          })), !this.running && this._then && this._then(this.object);
        }
        return this;
      },
      _events: {
        onUpdate: {}
      },
      _handleFrame: function(i) {
        var n = this._startTime, r = n ? (i - n) / this.duration : 0;
        n || (this._startTime = i), this.update(r);
      },
      _getState: function(i) {
        for (var n = this._keys, r = {}, l = 0, h = n.length; l < h; l++) {
          var f = n[l], m = this._parsedKeys[f], _ = this._getProperty(m), y;
          if (i) {
            var x = this._resolveValue(_, i[f]);
            this._setProperty(m, x), y = this._getProperty(m), y = y && y.clone ? y.clone() : y, this._setProperty(m, _);
          } else
            y = _ && _.clone ? _.clone() : _;
          r[f] = y;
        }
        return r;
      },
      _resolveValue: function(i, n) {
        if (n) {
          if (Array.isArray(n) && n.length === 2) {
            var r = n[0];
            return r && r.match && r.match(/^[+\-\*\/]=/) ? this._calculate(i, r[0], n[1]) : n;
          } else if (typeof n == "string") {
            var l = n.match(/^[+\-*/]=(.*)/);
            if (l) {
              var h = JSON.parse(l[1].replace(
                /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                '"$2": '
              ));
              return this._calculate(i, n[0], h);
            }
          }
        }
        return n;
      },
      _calculate: function(i, n, r) {
        return nt.PaperScript.calculateBinary(i, n, r);
      },
      _parseKeys: function(i) {
        for (var n = {}, r = 0, l = i.length; r < l; r++) {
          var h = i[r], f = h.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
          n[h] = f.split("/");
        }
        return n;
      },
      _getProperty: function(i, n) {
        for (var r = this.object, l = 0, h = i.length - (n || 0); l < h && r; l++)
          r = r[i[l]];
        return r;
      },
      _setProperty: function(i, n) {
        var r = this._getProperty(i, 1);
        r && (r[i[i.length - 1]] = n);
      }
    }), zn = {
      request: function(i) {
        var n = new e.XMLHttpRequest();
        return n.open(
          (i.method || "get").toUpperCase(),
          i.url,
          a.pick(i.async, !0)
        ), i.mimeType && n.overrideMimeType(i.mimeType), n.onload = function() {
          var r = n.status;
          r === 0 || r === 200 ? i.onLoad && i.onLoad.call(n, n.responseText) : n.onerror();
        }, n.onerror = function() {
          var r = n.status, l = 'Could not load "' + i.url + '" (Status: ' + r + ")";
          if (i.onError)
            i.onError(l, r);
          else
            throw new Error(l);
        }, n.send(null);
      }
    }, Ut = a.exports.CanvasProvider = {
      canvases: [],
      getCanvas: function(i, n, r) {
        if (!s)
          return null;
        var l, h = !0;
        typeof i == "object" && (n = i.height, i = i.width), this.canvases.length ? l = this.canvases.pop() : (l = o.createElement("canvas"), h = !1);
        var f = l.getContext("2d", r || {});
        if (!f)
          throw new Error("Canvas " + l + " is unable to provide a 2D context.");
        return l.width === i && l.height === n ? h && f.clearRect(0, 0, i + 1, n + 1) : (l.width = i, l.height = n), f.save(), l;
      },
      getContext: function(i, n, r) {
        var l = this.getCanvas(i, n, r);
        return l ? l.getContext("2d", r || {}) : null;
      },
      release: function(i) {
        var n = i && i.canvas ? i.canvas : i;
        n && n.getContext && (n.getContext("2d").restore(), this.canvases.push(n));
      }
    }, ki = new function() {
      var i = Math.min, n = Math.max, r = Math.abs, l, h, f, m, _, y, x, A, B, C, M;
      function R(U, V, F) {
        return 0.2989 * U + 0.587 * V + 0.114 * F;
      }
      function E(U, V, F, ie) {
        var Q = ie - R(U, V, F);
        B = U + Q, C = V + Q, M = F + Q;
        var ie = R(B, C, M), ae = i(B, C, M), J = n(B, C, M);
        if (ae < 0) {
          var le = ie - ae;
          B = ie + (B - ie) * ie / le, C = ie + (C - ie) * ie / le, M = ie + (M - ie) * ie / le;
        }
        if (J > 255) {
          var fe = 255 - ie, me = J - ie;
          B = ie + (B - ie) * fe / me, C = ie + (C - ie) * fe / me, M = ie + (M - ie) * fe / me;
        }
      }
      function D(U, V, F) {
        return n(U, V, F) - i(U, V, F);
      }
      function L(U, V, F, W) {
        var Q = [U, V, F], ie = n(U, V, F), ae = i(U, V, F), J;
        ae = ae === U ? 0 : ae === V ? 1 : 2, ie = ie === U ? 0 : ie === V ? 1 : 2, J = i(ae, ie) === 0 ? n(ae, ie) === 1 ? 2 : 1 : 0, Q[ie] > Q[ae] ? (Q[J] = (Q[J] - Q[ae]) * W / (Q[ie] - Q[ae]), Q[ie] = W) : Q[J] = Q[ie] = 0, Q[ae] = 0, B = Q[0], C = Q[1], M = Q[2];
      }
      var P = {
        multiply: function() {
          B = _ * l / 255, C = y * h / 255, M = x * f / 255;
        },
        screen: function() {
          B = _ + l - _ * l / 255, C = y + h - y * h / 255, M = x + f - x * f / 255;
        },
        overlay: function() {
          B = _ < 128 ? 2 * _ * l / 255 : 255 - 2 * (255 - _) * (255 - l) / 255, C = y < 128 ? 2 * y * h / 255 : 255 - 2 * (255 - y) * (255 - h) / 255, M = x < 128 ? 2 * x * f / 255 : 255 - 2 * (255 - x) * (255 - f) / 255;
        },
        "soft-light": function() {
          var U = l * _ / 255;
          B = U + _ * (255 - (255 - _) * (255 - l) / 255 - U) / 255, U = h * y / 255, C = U + y * (255 - (255 - y) * (255 - h) / 255 - U) / 255, U = f * x / 255, M = U + x * (255 - (255 - x) * (255 - f) / 255 - U) / 255;
        },
        "hard-light": function() {
          B = l < 128 ? 2 * l * _ / 255 : 255 - 2 * (255 - l) * (255 - _) / 255, C = h < 128 ? 2 * h * y / 255 : 255 - 2 * (255 - h) * (255 - y) / 255, M = f < 128 ? 2 * f * x / 255 : 255 - 2 * (255 - f) * (255 - x) / 255;
        },
        "color-dodge": function() {
          B = _ === 0 ? 0 : l === 255 ? 255 : i(255, 255 * _ / (255 - l)), C = y === 0 ? 0 : h === 255 ? 255 : i(255, 255 * y / (255 - h)), M = x === 0 ? 0 : f === 255 ? 255 : i(255, 255 * x / (255 - f));
        },
        "color-burn": function() {
          B = _ === 255 ? 255 : l === 0 ? 0 : n(0, 255 - (255 - _) * 255 / l), C = y === 255 ? 255 : h === 0 ? 0 : n(0, 255 - (255 - y) * 255 / h), M = x === 255 ? 255 : f === 0 ? 0 : n(0, 255 - (255 - x) * 255 / f);
        },
        darken: function() {
          B = _ < l ? _ : l, C = y < h ? y : h, M = x < f ? x : f;
        },
        lighten: function() {
          B = _ > l ? _ : l, C = y > h ? y : h, M = x > f ? x : f;
        },
        difference: function() {
          B = _ - l, B < 0 && (B = -B), C = y - h, C < 0 && (C = -C), M = x - f, M < 0 && (M = -M);
        },
        exclusion: function() {
          B = _ + l * (255 - _ - _) / 255, C = y + h * (255 - y - y) / 255, M = x + f * (255 - x - x) / 255;
        },
        hue: function() {
          L(l, h, f, D(_, y, x)), E(B, C, M, R(_, y, x));
        },
        saturation: function() {
          L(_, y, x, D(l, h, f)), E(B, C, M, R(_, y, x));
        },
        luminosity: function() {
          E(_, y, x, R(l, h, f));
        },
        color: function() {
          E(l, h, f, R(_, y, x));
        },
        add: function() {
          B = i(_ + l, 255), C = i(y + h, 255), M = i(x + f, 255);
        },
        subtract: function() {
          B = n(_ - l, 0), C = n(y - h, 0), M = n(x - f, 0);
        },
        average: function() {
          B = (_ + l) / 2, C = (y + h) / 2, M = (x + f) / 2;
        },
        negation: function() {
          B = 255 - r(255 - l - _), C = 255 - r(255 - h - y), M = 255 - r(255 - f - x);
        }
      }, S = this.nativeModes = a.each([
        "source-over",
        "source-in",
        "source-out",
        "source-atop",
        "destination-over",
        "destination-in",
        "destination-out",
        "destination-atop",
        "lighter",
        "darker",
        "copy",
        "xor"
      ], function(U) {
        this[U] = !0;
      }, {}), I = Ut.getContext(1, 1, { willReadFrequently: !0 });
      I && (a.each(P, function(U, V) {
        var F = V === "darken", W = !1;
        I.save();
        try {
          I.fillStyle = F ? "#300" : "#a00", I.fillRect(0, 0, 1, 1), I.globalCompositeOperation = V, I.globalCompositeOperation === V && (I.fillStyle = F ? "#a00" : "#300", I.fillRect(0, 0, 1, 1), W = I.getImageData(0, 0, 1, 1).data[0] !== F ? 170 : 51);
        } catch {
        }
        I.restore(), S[V] = W;
      }), Ut.release(I)), this.process = function(U, V, F, W, Q) {
        var ie = V.canvas, ae = U === "normal";
        if (ae || S[U])
          F.save(), F.setTransform(1, 0, 0, 1, 0, 0), F.globalAlpha = W, ae || (F.globalCompositeOperation = U), F.drawImage(ie, Q.x, Q.y), F.restore();
        else {
          var J = P[U];
          if (!J)
            return;
          for (var le = F.getImageData(
            Q.x,
            Q.y,
            ie.width,
            ie.height
          ), fe = le.data, me = V.getImageData(
            0,
            0,
            ie.width,
            ie.height
          ).data, ve = 0, Se = fe.length; ve < Se; ve += 4) {
            l = me[ve], _ = fe[ve], h = me[ve + 1], y = fe[ve + 1], f = me[ve + 2], x = fe[ve + 2], m = me[ve + 3], A = fe[ve + 3], J();
            var Re = m * W / 255, He = 1 - Re;
            fe[ve] = Re * B + He * _, fe[ve + 1] = Re * C + He * y, fe[ve + 2] = Re * M + He * x, fe[ve + 3] = m * W + He * A;
          }
          F.putImageData(le, Q.x, Q.y);
        }
      };
    }(), Vt = new function() {
      var i = "http://www.w3.org/2000/svg", n = "http://www.w3.org/2000/xmlns", r = "http://www.w3.org/1999/xlink", l = {
        href: r,
        xlink: n,
        xmlns: n + "/",
        "xmlns:xlink": n + "/"
      };
      function h(_, y, x) {
        return m(o.createElementNS(i, _), y, x);
      }
      function f(_, y) {
        var x = l[y], A = x ? _.getAttributeNS(x, y) : _.getAttribute(y);
        return A === "null" ? null : A;
      }
      function m(_, y, x) {
        for (var A in y) {
          var B = y[A], C = l[A];
          typeof B == "number" && x && (B = x.number(B)), C ? _.setAttributeNS(C, A, B) : _.setAttribute(A, B);
        }
        return _;
      }
      return {
        svg: i,
        xmlns: n,
        xlink: r,
        create: h,
        get: f,
        set: m
      };
    }(), Jn = a.each({
      fillColor: ["fill", "color"],
      fillRule: ["fill-rule", "string"],
      strokeColor: ["stroke", "color"],
      strokeWidth: ["stroke-width", "number"],
      strokeCap: ["stroke-linecap", "string"],
      strokeJoin: ["stroke-linejoin", "string"],
      strokeScaling: ["vector-effect", "lookup", {
        true: "none",
        false: "non-scaling-stroke"
      }, function(i, n) {
        return !n && (i instanceof Ft || i instanceof Ze || i instanceof Ki);
      }],
      miterLimit: ["stroke-miterlimit", "number"],
      dashArray: ["stroke-dasharray", "array"],
      dashOffset: ["stroke-dashoffset", "number"],
      fontFamily: ["font-family", "string"],
      fontWeight: ["font-weight", "string"],
      fontSize: ["font-size", "number"],
      justification: ["text-anchor", "lookup", {
        left: "start",
        center: "middle",
        right: "end"
      }],
      opacity: ["opacity", "number"],
      blendMode: ["mix-blend-mode", "style"]
    }, function(i, n) {
      var r = a.capitalize(n), l = i[2];
      this[n] = {
        type: i[1],
        property: n,
        attribute: i[0],
        toSVG: l,
        fromSVG: l && a.each(l, function(h, f) {
          this[h] = f;
        }, {}),
        exportFilter: i[3],
        get: "get" + r,
        set: "set" + r
      };
    }, {});
    new function() {
      var i;
      function n(P, S, I) {
        var U = new a(), V = P.getTranslation();
        if (S) {
          var F;
          P.isInvertible() ? (P = P._shiftless(), F = P._inverseTransform(V), V = null) : F = new z(), U[I ? "cx" : "x"] = F.x, U[I ? "cy" : "y"] = F.y;
        }
        if (!P.isIdentity()) {
          var W = P.decompose();
          if (W) {
            var Q = [], ie = W.rotation, ae = W.scaling, J = W.skewing;
            V && !V.isZero() && Q.push("translate(" + i.point(V) + ")"), ie && Q.push("rotate(" + i.number(ie) + ")"), (!Y.isZero(ae.x - 1) || !Y.isZero(ae.y - 1)) && Q.push("scale(" + i.point(ae) + ")"), J.x && Q.push("skewX(" + i.number(J.x) + ")"), J.y && Q.push("skewY(" + i.number(J.y) + ")"), U.transform = Q.join(" ");
          } else
            U.transform = "matrix(" + P.getValues().join(",") + ")";
        }
        return U;
      }
      function r(P, S) {
        for (var I = n(P._matrix), U = P._children, V = Vt.create("g", I, i), F = 0, W = U.length; F < W; F++) {
          var Q = U[F], ie = D(Q, S);
          if (ie)
            if (Q.isClipMask()) {
              var ae = Vt.create("clipPath");
              ae.appendChild(ie), R(Q, ae, "clip"), Vt.set(V, {
                "clip-path": "url(#" + ae.id + ")"
              });
            } else
              V.appendChild(ie);
        }
        return V;
      }
      function l(P, S) {
        var I = n(P._matrix, !0), U = P.getSize(), V = P.getImage();
        return I.x -= U.width / 2, I.y -= U.height / 2, I.width = U.width, I.height = U.height, I.href = S.embedImages == !1 && V && V.src || P.toDataURL(), Vt.create("image", I, i);
      }
      function h(P, S) {
        var I = S.matchShapes;
        if (I) {
          var U = P.toShape(!1);
          if (U)
            return f(U);
        }
        var V = P._segments, F = V.length, W, Q = n(P._matrix);
        if (I && F >= 2 && !P.hasHandles())
          if (F > 2) {
            W = P._closed ? "polygon" : "polyline";
            for (var ie = [], ae = 0; ae < F; ae++)
              ie.push(i.point(V[ae]._point));
            Q.points = ie.join(" ");
          } else {
            W = "line";
            var J = V[0]._point, le = V[1]._point;
            Q.set({
              x1: J.x,
              y1: J.y,
              x2: le.x,
              y2: le.y
            });
          }
        else
          W = "path", Q.d = P.getPathData(null, S.precision);
        return Vt.create(W, Q, i);
      }
      function f(P) {
        var S = P._type, I = P._radius, U = n(P._matrix, !0, S !== "rectangle");
        if (S === "rectangle") {
          S = "rect";
          var V = P._size, F = V.width, W = V.height;
          U.x -= F / 2, U.y -= W / 2, U.width = F, U.height = W, I.isZero() && (I = null);
        }
        return I && (S === "circle" ? U.r = I : (U.rx = I.width, U.ry = I.height)), Vt.create(S, U, i);
      }
      function m(P, S) {
        var I = n(P._matrix), U = P.getPathData(null, S.precision);
        return U && (I.d = U), Vt.create("path", I, i);
      }
      function _(P, S) {
        var I = n(P._matrix, !0), U = P._definition, V = M(U, "symbol"), F = U._item, W = F.getStrokeBounds();
        return V || (V = Vt.create("symbol", {
          viewBox: i.rectangle(W)
        }), V.appendChild(D(F, S)), R(U, V, "symbol")), I.href = "#" + V.id, I.x += W.x, I.y += W.y, I.width = W.width, I.height = W.height, I.overflow = "visible", Vt.create("use", I, i);
      }
      function y(P) {
        var S = M(P, "color");
        if (!S) {
          var I = P.getGradient(), U = I._radial, V = P.getOrigin(), F = P.getDestination(), W;
          if (U) {
            W = {
              cx: V.x,
              cy: V.y,
              r: V.getDistance(F)
            };
            var Q = P.getHighlight();
            Q && (W.fx = Q.x, W.fy = Q.y);
          } else
            W = {
              x1: V.x,
              y1: V.y,
              x2: F.x,
              y2: F.y
            };
          W.gradientUnits = "userSpaceOnUse", S = Vt.create((U ? "radial" : "linear") + "Gradient", W, i);
          for (var ie = I._stops, ae = 0, J = ie.length; ae < J; ae++) {
            var le = ie[ae], fe = le._color, me = fe.getAlpha(), ve = le._offset;
            W = {
              offset: ve ?? ae / (J - 1)
            }, fe && (W["stop-color"] = fe.toCSS(!0)), me < 1 && (W["stop-opacity"] = me), S.appendChild(
              Vt.create("stop", W, i)
            );
          }
          R(P, S, "color");
        }
        return "url(#" + S.id + ")";
      }
      function x(P) {
        var S = Vt.create(
          "text",
          n(P._matrix, !0),
          i
        );
        return S.textContent = P._content, S;
      }
      var A = {
        Group: r,
        Layer: r,
        Raster: l,
        Path: h,
        Shape: f,
        CompoundPath: m,
        SymbolItem: _,
        PointText: x
      };
      function B(P, S, I) {
        var U = {}, V = !I && P.getParent(), F = [];
        return P._name != null && (U.id = P._name), a.each(Jn, function(W) {
          var Q = W.get, ie = W.type, ae = P[Q]();
          if (W.exportFilter ? W.exportFilter(P, ae) : !V || !a.equals(V[Q](), ae)) {
            if (ie === "color" && ae != null) {
              var J = ae.getAlpha();
              J < 1 && (U[W.attribute + "-opacity"] = J);
            }
            ie === "style" ? F.push(W.attribute + ": " + ae) : U[W.attribute] = ae == null ? "none" : ie === "color" ? ae.gradient ? y(ae) : ae.toCSS(!0) : ie === "array" ? ae.join(",") : ie === "lookup" ? W.toSVG[ae] : ae;
          }
        }), F.length && (U.style = F.join(";")), U.opacity === 1 && delete U.opacity, P._visible || (U.visibility = "hidden"), Vt.set(S, U, i);
      }
      var C;
      function M(P, S) {
        return C || (C = { ids: {}, svgs: {} }), P && C.svgs[S + "-" + (P._id || P.__id || (P.__id = ee.get("svg")))];
      }
      function R(P, S, I) {
        C || M();
        var U = C.ids[I] = (C.ids[I] || 0) + 1;
        S.id = I + "-" + U, C.svgs[I + "-" + (P._id || P.__id)] = S;
      }
      function E(P, S) {
        var I = P, U = null;
        if (C) {
          I = P.nodeName.toLowerCase() === "svg" && P;
          for (var V in C.svgs)
            U || (I || (I = Vt.create("svg"), I.appendChild(P)), U = I.insertBefore(
              Vt.create("defs"),
              I.firstChild
            )), U.appendChild(C.svgs[V]);
          C = null;
        }
        return S.asString ? new e.XMLSerializer().serializeToString(I) : I;
      }
      function D(P, S, I) {
        var U = A[P._class], V = U && U(P, S);
        if (V) {
          var F = S.onExport;
          F && (V = F(P, V, S) || V);
          var W = JSON.stringify(P._data);
          W && W !== "{}" && W !== "null" && V.setAttribute("data-paper-data", W);
        }
        return V && B(P, V, I);
      }
      function L(P) {
        return P || (P = {}), i = new H(P.precision), P;
      }
      K.inject({
        exportSVG: function(P) {
          return P = L(P), E(D(this, P, !0), P);
        }
      }), Ee.inject({
        exportSVG: function(P) {
          P = L(P);
          var S = this._children, I = this.getView(), U = a.pick(P.bounds, "view"), V = P.matrix || U === "view" && I._matrix, F = V && ue.read([V]), W = U === "view" ? new se([0, 0], I.getViewSize()) : U === "content" ? K._getBounds(S, F, { stroke: !0 }).rect : se.read([U], 0, { readNull: !0 }), Q = {
            version: "1.1",
            xmlns: Vt.svg,
            "xmlns:xlink": Vt.xlink
          };
          W && (Q.width = W.width, Q.height = W.height, (W.x || W.x === 0 || W.y || W.y === 0) && (Q.viewBox = i.rectangle(W)));
          var ie = Vt.create("svg", Q, i), ae = ie;
          F && !F.isIdentity() && (ae = ie.appendChild(Vt.create(
            "g",
            n(F),
            i
          )));
          for (var J = 0, le = S.length; J < le; J++)
            ae.appendChild(D(S[J], P, !0));
          return E(ie, P);
        }
      });
    }(), new function() {
      var i = {}, n;
      function r(S, I, U, V, F, W) {
        var Q = Vt.get(S, I) || W, ie = Q == null ? V ? null : U ? "" : 0 : U ? Q : parseFloat(Q);
        return /%\s*$/.test(Q) ? ie / 100 * (F ? 1 : n[/x|^width/.test(I) ? "width" : "height"]) : ie;
      }
      function l(S, I, U, V, F, W, Q) {
        return I = r(S, I || "x", !1, V, F, W), U = r(S, U || "y", !1, V, F, Q), V && (I == null || U == null) ? null : new z(I, U);
      }
      function h(S, I, U, V, F) {
        return I = r(S, I || "width", !1, V, F), U = r(S, U || "height", !1, V, F), V && (I == null || U == null) ? null : new ne(I, U);
      }
      function f(S, I, U) {
        return S === "none" ? null : I === "number" ? parseFloat(S) : I === "array" ? S ? S.split(/[\s,]+/g).map(parseFloat) : [] : I === "color" ? D(S) || S : I === "lookup" ? U[S] : S;
      }
      function m(S, I, U, V) {
        var F = S.childNodes, W = I === "clippath", Q = I === "defs", ie = new j(), ae = ie._project, J = ae._currentStyle, le = [];
        if (!W && !Q && (ie = E(ie, S, V), ae._currentStyle = ie._style.clone()), V)
          for (var fe = S.querySelectorAll("defs"), me = 0, ve = fe.length; me < ve; me++)
            L(fe[me], U, !1);
        for (var me = 0, ve = F.length; me < ve; me++) {
          var Se = F[me], Re;
          Se.nodeType === 1 && !/^defs$/i.test(Se.nodeName) && (Re = L(Se, U, !1)) && !(Re instanceof Mt) && le.push(Re);
        }
        return ie.addChildren(le), W && (ie = E(ie.reduce(), S, V)), ae._currentStyle = J, (W || Q) && (ie.remove(), ie = null), ie;
      }
      function _(S, I) {
        for (var U = S.getAttribute("points").match(
          /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
        ), V = [], F = 0, W = U.length; F < W; F += 2)
          V.push(new z(
            parseFloat(U[F]),
            parseFloat(U[F + 1])
          ));
        var Q = new Bt(V);
        return I === "polygon" && Q.closePath(), Q;
      }
      function y(S) {
        return Ft.create(S.getAttribute("d"));
      }
      function x(S, I) {
        var U = (r(S, "href", !0) || "").substring(1), V = I === "radialgradient", F;
        if (U)
          F = i[U].getGradient(), F._radial ^ V && (F = F.clone(), F._radial = V);
        else {
          for (var W = S.childNodes, Q = [], ie = 0, ae = W.length; ie < ae; ie++) {
            var J = W[ie];
            J.nodeType === 1 && Q.push(E(new Ms(), J));
          }
          F = new kn(Q, V);
        }
        var le, fe, me, ve = r(S, "gradientUnits", !0) !== "userSpaceOnUse";
        V ? (le = l(
          S,
          "cx",
          "cy",
          !1,
          ve,
          "50%",
          "50%"
        ), fe = le.add(
          r(S, "r", !1, !1, ve, "50%"),
          0
        ), me = l(S, "fx", "fy", !0, ve)) : (le = l(
          S,
          "x1",
          "y1",
          !1,
          ve,
          "0%",
          "0%"
        ), fe = l(
          S,
          "x2",
          "y2",
          !1,
          ve,
          "100%",
          "0%"
        ));
        var Se = E(
          new qt(F, le, fe, me),
          S
        );
        return Se._scaleToBounds = ve, null;
      }
      var A = {
        "#document": function(S, I, U, V) {
          for (var F = S.childNodes, W = 0, Q = F.length; W < Q; W++) {
            var ie = F[W];
            if (ie.nodeType === 1)
              return L(ie, U, V);
          }
        },
        g: m,
        svg: m,
        clippath: m,
        polygon: _,
        polyline: _,
        path: y,
        lineargradient: x,
        radialgradient: x,
        image: function(S) {
          var I = new pt(r(S, "href", !0));
          return I.on("load", function() {
            var U = h(S);
            this.setSize(U);
            var V = l(S).add(U.divide(2));
            this._matrix.append(new ue().translate(V));
          }), I;
        },
        symbol: function(S, I, U, V) {
          return new Mt(
            m(S, I, U, V),
            !0
          );
        },
        defs: m,
        use: function(S) {
          var I = (r(S, "href", !0) || "").substring(1), U = i[I], V = l(S);
          return U ? U instanceof Mt ? U.place(V) : U.clone().translate(V) : null;
        },
        circle: function(S) {
          return new Ze.Circle(
            l(S, "cx", "cy"),
            r(S, "r")
          );
        },
        ellipse: function(S) {
          return new Ze.Ellipse({
            center: l(S, "cx", "cy"),
            radius: h(S, "rx", "ry")
          });
        },
        rect: function(S) {
          return new Ze.Rectangle(new se(
            l(S),
            h(S)
          ), h(S, "rx", "ry"));
        },
        line: function(S) {
          return new Bt.Line(
            l(S, "x1", "y1"),
            l(S, "x2", "y2")
          );
        },
        text: function(S) {
          var I = new as(l(S).add(
            l(S, "dx", "dy")
          ));
          return I.setContent(S.textContent.trim() || ""), I;
        },
        switch: m
      };
      function B(S, I, U, V) {
        if (S.transform) {
          for (var F = (V.getAttribute(U) || "").split(/\)\s*/g), W = new ue(), Q = 0, ie = F.length; Q < ie; Q++) {
            var ae = F[Q];
            if (!ae)
              break;
            for (var J = ae.split(/\(\s*/), le = J[0], fe = J[1].split(/[\s,]+/g), me = 0, ve = fe.length; me < ve; me++)
              fe[me] = parseFloat(fe[me]);
            switch (le) {
              case "matrix":
                W.append(
                  new ue(fe[0], fe[1], fe[2], fe[3], fe[4], fe[5])
                );
                break;
              case "rotate":
                W.rotate(fe[0], fe[1] || 0, fe[2] || 0);
                break;
              case "translate":
                W.translate(fe[0], fe[1] || 0);
                break;
              case "scale":
                W.scale(fe);
                break;
              case "skewX":
                W.skew(fe[0], 0);
                break;
              case "skewY":
                W.skew(0, fe[0]);
                break;
            }
          }
          S.transform(W);
        }
      }
      function C(S, I, U) {
        var V = U === "fill-opacity" ? "getFillColor" : "getStrokeColor", F = S[V] && S[V]();
        F && F.setAlpha(parseFloat(I));
      }
      var M = a.set(a.each(Jn, function(S) {
        this[S.attribute] = function(I, U) {
          if (I[S.set] && (I[S.set](f(U, S.type, S.fromSVG)), S.type === "color")) {
            var V = I[S.get]();
            if (V && V._scaleToBounds) {
              var F = I.getBounds();
              V.transform(new ue().translate(F.getPoint()).scale(F.getSize()));
            }
          }
        };
      }, {}), {
        id: function(S, I) {
          i[I] = S, S.setName && S.setName(I);
        },
        "clip-path": function(S, I) {
          var U = D(I);
          if (U)
            if (U = U.clone(), U.setClipMask(!0), S instanceof j)
              S.insertChild(0, U);
            else
              return new j(U, S);
        },
        gradientTransform: B,
        transform: B,
        "fill-opacity": C,
        "stroke-opacity": C,
        visibility: function(S, I) {
          S.setVisible && S.setVisible(I === "visible");
        },
        display: function(S, I) {
          S.setVisible && S.setVisible(I !== null);
        },
        "stop-color": function(S, I) {
          S.setColor && S.setColor(I);
        },
        "stop-opacity": function(S, I) {
          S._color && S._color.setAlpha(parseFloat(I));
        },
        offset: function(S, I) {
          if (S.setOffset) {
            var U = I.match(/(.*)%$/);
            S.setOffset(U ? U[1] / 100 : parseFloat(I));
          }
        },
        viewBox: function(S, I, U, V, F) {
          var W = new se(f(I, "array")), Q = h(V, null, null, !0), ie, ae;
          if (S instanceof j) {
            var J = Q ? Q.divide(W.getSize()) : 1, ae = new ue().scale(J).translate(W.getPoint().negate());
            ie = S;
          } else
            S instanceof Mt && (Q && W.setSize(Q), ie = S._item);
          if (ie) {
            if (R(V, "overflow", F) !== "visible") {
              var le = new Ze.Rectangle(W);
              le.setClipMask(!0), ie.addChild(le);
            }
            ae && ie.transform(ae);
          }
        }
      });
      function R(S, I, U) {
        var V = S.attributes[I], F = V && V.value;
        if (!F && S.style) {
          var W = a.camelize(I);
          F = S.style[W], !F && U.node[W] !== U.parent[W] && (F = U.node[W]);
        }
        return F ? F === "none" ? null : F : t;
      }
      function E(S, I, U) {
        var V = I.parentNode, F = {
          node: zt.getStyles(I) || {},
          parent: !U && !/^defs$/i.test(V.tagName) && zt.getStyles(V) || {}
        };
        return a.each(M, function(W, Q) {
          var ie = R(I, Q, F);
          S = ie !== t && W(S, ie, Q, I, F) || S;
        }), S;
      }
      function D(S) {
        var I = S && S.match(/\((?:["'#]*)([^"')]+)/), U = I && I[1], V = U && i[s ? U.replace(s.location.href.split("#")[0] + "#", "") : U];
        return V && V._scaleToBounds && (V = V.clone(), V._scaleToBounds = !0), V;
      }
      function L(S, I, U) {
        var V = S.nodeName.toLowerCase(), F = V !== "#document", W = o.body, Q, ie, ae;
        U && F && (n = nt.getView().getSize(), n = h(S, null, null, !0) || n, Q = Vt.create("svg", {
          style: "stroke-width: 1px; stroke-miterlimit: 10"
        }), ie = S.parentNode, ae = S.nextSibling, Q.appendChild(S), W.appendChild(Q));
        var J = nt.settings, le = J.applyMatrix, fe = J.insertItems;
        J.applyMatrix = !1, J.insertItems = !1;
        var me = A[V], ve = me && me(S, V, I, U) || null;
        if (J.insertItems = fe, J.applyMatrix = le, ve) {
          F && !(ve instanceof j) && (ve = E(ve, S, U));
          var Se = I.onImport, Re = F && S.getAttribute("data-paper-data");
          Se && (ve = Se(S, ve, I) || ve), I.expandShapes && ve instanceof Ze && (ve.remove(), ve = ve.toPath()), Re && (ve._data = JSON.parse(Re));
        }
        return Q && (W.removeChild(Q), ie && (ae ? ie.insertBefore(S, ae) : ie.appendChild(S))), U && (i = {}, ve && a.pick(I.applyMatrix, le) && ve.matrix.apply(!0, !0)), ve;
      }
      function P(S, I, U) {
        if (!S)
          return null;
        I = typeof I == "function" ? { onLoad: I } : I || {};
        var V = nt, F = null;
        function W(J) {
          try {
            var le = typeof J == "object" ? J : new e.DOMParser().parseFromString(
              J.trim(),
              "image/svg+xml"
            );
            if (!le.nodeName)
              throw le = null, new Error("Unsupported SVG source: " + S);
            nt = V, F = L(le, I, !0), (!I || I.insert !== !1) && U._insertItem(t, F);
            var fe = I.onLoad;
            fe && fe(F, J);
          } catch (me) {
            Q(me);
          }
        }
        function Q(J, le) {
          var fe = I.onError;
          if (fe)
            fe(J, le);
          else
            throw new Error(J);
        }
        if (typeof S == "string" && !/^[\s\S]*</.test(S)) {
          var ie = o.getElementById(S);
          ie ? W(ie) : zn.request({
            url: S,
            async: !0,
            onLoad: W,
            onError: Q
          });
        } else if (typeof File < "u" && S instanceof File) {
          var ae = new FileReader();
          return ae.onload = function() {
            W(ae.result);
          }, ae.onerror = function() {
            Q(ae.error);
          }, ae.readAsText(S);
        } else
          W(S);
        return F;
      }
      K.inject({
        importSVG: function(S, I) {
          return P(S, I, this);
        }
      }), Ee.inject({
        importSVG: function(S, I) {
          return this.activate(), P(S, I, this);
        }
      });
    }(), a.exports.PaperScript = (function() {
      var i = this, n = i.acorn;
      if (!n && typeof tw < "u")
        try {
          n = sw();
        } catch {
        }
      if (!n) {
        var r, l;
        n = r = l = {}, function(E, D) {
          if (typeof r == "object" && typeof l == "object")
            return D(r);
          if (typeof t == "function" && t.amd)
            return t(["exports"], D);
          D(E.acorn || (E.acorn = {}));
        }(this, function(E) {
          E.version = "0.5.0";
          var D, L, P, S;
          E.parse = function(q, te) {
            return L = String(q), P = L.length, U(te), ce(), Jr(D.program);
          };
          var I = E.defaultOptions = {
            ecmaVersion: 5,
            strictSemicolons: !1,
            allowTrailingCommas: !0,
            forbidReserved: !1,
            allowReturnOutsideFunction: !1,
            locations: !1,
            onComment: null,
            ranges: !1,
            program: null,
            sourceFile: null,
            directSourceFile: null
          };
          function U(q) {
            D = q || {};
            for (var te in I)
              Object.prototype.hasOwnProperty.call(D, te) || (D[te] = I[te]);
            S = D.sourceFile || null;
          }
          var V = E.getLineInfo = function(q, te) {
            for (var be = 1, Ae = 0; ; ) {
              O.lastIndex = Ae;
              var qe = O.exec(q);
              if (qe && qe.index < te)
                ++be, Ae = qe.index + qe[0].length;
              else
                break;
            }
            return { line: be, column: te - Ae };
          };
          E.tokenize = function(q, te) {
            L = String(q), P = L.length, U(te), ce();
            var be = {};
            function Ae(qe) {
              return Re = Q, Zi(qe), be.start = W, be.end = Q, be.startLoc = ie, be.endLoc = ae, be.type = J, be.value = le, be;
            }
            return Ae.jumpTo = function(qe, ot) {
              if (F = qe, D.locations) {
                me = 1, ve = O.lastIndex = 0;
                for (var it; (it = O.exec(L)) && it.index < qe; )
                  ++me, ve = it.index + it[0].length;
              }
              fe = ot, Ue();
            }, Ae;
          };
          var F, W, Q, ie, ae, J, le, fe, me, ve, Se, Re, He, Ye, Je, Be;
          function Ie(q, te) {
            var be = V(L, q);
            te += " (" + be.line + ":" + be.column + ")";
            var Ae = new SyntaxError(te);
            throw Ae.pos = q, Ae.loc = be, Ae.raisedAt = F, Ae;
          }
          var Ge = [], et = { type: "num" }, tt = { type: "regexp" }, gt = { type: "string" }, ut = { type: "name" }, yt = { type: "eof" }, At = { keyword: "break" }, bt = { keyword: "case", beforeExpr: !0 }, li = { keyword: "catch" }, mt = { keyword: "continue" }, Zt = { keyword: "debugger" }, Xt = { keyword: "default" }, Nt = { keyword: "do", isLoop: !0 }, Jt = { keyword: "else", beforeExpr: !0 }, Ti = { keyword: "finally" }, ri = { keyword: "for", isLoop: !0 }, Pi = { keyword: "function" }, ci = { keyword: "if" }, hi = { keyword: "return", beforeExpr: !0 }, Ni = { keyword: "switch" }, Bi = { keyword: "throw", beforeExpr: !0 }, Ri = { keyword: "try" }, Wi = { keyword: "var" }, Vi = { keyword: "while", isLoop: !0 }, Fn = { keyword: "with" }, $n = { keyword: "new", beforeExpr: !0 }, Cs = { keyword: "this" }, _s = { keyword: "null", atomValue: null }, vn = { keyword: "true", atomValue: !0 }, Qn = { keyword: "false", atomValue: !1 }, Yt = { keyword: "in", binop: 7, beforeExpr: !0 }, os = {
            break: At,
            case: bt,
            catch: li,
            continue: mt,
            debugger: Zt,
            default: Xt,
            do: Nt,
            else: Jt,
            finally: Ti,
            for: ri,
            function: Pi,
            if: ci,
            return: hi,
            switch: Ni,
            throw: Bi,
            try: Ri,
            var: Wi,
            while: Vi,
            with: Fn,
            null: _s,
            true: vn,
            false: Qn,
            new: $n,
            in: Yt,
            instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
            this: Cs,
            typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
            void: { keyword: "void", prefix: !0, beforeExpr: !0 },
            delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
          }, Mn = { type: "[", beforeExpr: !0 }, un = { type: "]" }, Ji = { type: "{", beforeExpr: !0 }, cn = { type: "}" }, qi = { type: "(", beforeExpr: !0 }, Di = { type: ")" }, d = { type: ",", beforeExpr: !0 }, N = { type: ";", beforeExpr: !0 }, re = { type: ":", beforeExpr: !0 }, pe = { type: "." }, Le = { type: "?", beforeExpr: !0 }, je = { binop: 10, beforeExpr: !0 }, Qe = { isAssign: !0, beforeExpr: !0 }, vt = { isAssign: !0, beforeExpr: !0 }, Lt = { postfix: !0, prefix: !0, isUpdate: !0 }, $t = { prefix: !0, beforeExpr: !0 }, ii = { binop: 1, beforeExpr: !0 }, Gi = { binop: 2, beforeExpr: !0 }, ls = { binop: 3, beforeExpr: !0 }, As = { binop: 4, beforeExpr: !0 }, ms = { binop: 5, beforeExpr: !0 }, zs = { binop: 6, beforeExpr: !0 }, Si = { binop: 7, beforeExpr: !0 }, bi = { binop: 8, beforeExpr: !0 }, kr = { binop: 9, prefix: !0, beforeExpr: !0 }, yr = { binop: 10, beforeExpr: !0 };
          E.tokTypes = {
            bracketL: Mn,
            bracketR: un,
            braceL: Ji,
            braceR: cn,
            parenL: qi,
            parenR: Di,
            comma: d,
            semi: N,
            colon: re,
            dot: pe,
            question: Le,
            slash: je,
            eq: Qe,
            name: ut,
            eof: yt,
            num: et,
            regexp: tt,
            string: gt
          };
          for (var or in os)
            E.tokTypes["_" + or] = os[or];
          function es(q) {
            q = q.split(" ");
            var te = "", be = [];
            e:
              for (var Ae = 0; Ae < q.length; ++Ae) {
                for (var qe = 0; qe < be.length; ++qe)
                  if (be[qe][0].length == q[Ae].length) {
                    be[qe].push(q[Ae]);
                    continue e;
                  }
                be.push([q[Ae]]);
              }
            function ot(wt) {
              if (wt.length == 1)
                return te += "return str === " + JSON.stringify(wt[0]) + ";";
              te += "switch(str){";
              for (var gi = 0; gi < wt.length; ++gi)
                te += "case " + JSON.stringify(wt[gi]) + ":";
              te += "return true}return false;";
            }
            if (be.length > 3) {
              be.sort(function(wt, gi) {
                return gi.length - wt.length;
              }), te += "switch(str.length){";
              for (var Ae = 0; Ae < be.length; ++Ae) {
                var it = be[Ae];
                te += "case " + it[0].length + ":", ot(it);
              }
              te += "}";
            } else
              ot(q);
            return new Function("str", te);
          }
          var br = es("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), Kr = es("class enum extends super const export import"), lr = es("implements interface let package private protected public static yield"), Ts = es("eval arguments"), $i = es("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), hr = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Zn = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Pr = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", $s = new RegExp("[" + Zn + "]"), Un = new RegExp("[" + Zn + Pr + "]"), b = /[\n\r\u2028\u2029]/, O = /\r\n|[\n\r\u2028\u2029]/g, G = E.isIdentifierStart = function(q) {
            return q < 65 ? q === 36 : q < 91 ? !0 : q < 97 ? q === 95 : q < 123 ? !0 : q >= 170 && $s.test(String.fromCharCode(q));
          }, Z = E.isIdentifierChar = function(q) {
            return q < 48 ? q === 36 : q < 58 ? !0 : q < 65 ? !1 : q < 91 ? !0 : q < 97 ? q === 95 : q < 123 ? !0 : q >= 170 && Un.test(String.fromCharCode(q));
          };
          function oe() {
            this.line = me, this.column = F - ve;
          }
          function ce() {
            me = 1, F = ve = 0, fe = !0, Ue();
          }
          function de(q, te) {
            Q = F, D.locations && (ae = new oe()), J = q, Ue(), le = te, fe = q.beforeExpr;
          }
          function Pe() {
            var q = D.onComment && D.locations && new oe(), te = F, be = L.indexOf("*/", F += 2);
            if (be === -1 && Ie(F - 2, "Unterminated comment"), F = be + 2, D.locations) {
              O.lastIndex = te;
              for (var Ae; (Ae = O.exec(L)) && Ae.index < F; )
                ++me, ve = Ae.index + Ae[0].length;
            }
            D.onComment && D.onComment(
              !0,
              L.slice(te + 2, be),
              te,
              F,
              q,
              D.locations && new oe()
            );
          }
          function Oe() {
            for (var q = F, te = D.onComment && D.locations && new oe(), be = L.charCodeAt(F += 2); F < P && be !== 10 && be !== 13 && be !== 8232 && be !== 8233; )
              ++F, be = L.charCodeAt(F);
            D.onComment && D.onComment(
              !1,
              L.slice(q + 2, F),
              q,
              F,
              te,
              D.locations && new oe()
            );
          }
          function Ue() {
            for (; F < P; ) {
              var q = L.charCodeAt(F);
              if (q === 32)
                ++F;
              else if (q === 13) {
                ++F;
                var te = L.charCodeAt(F);
                te === 10 && ++F, D.locations && (++me, ve = F);
              } else if (q === 10 || q === 8232 || q === 8233)
                ++F, D.locations && (++me, ve = F);
              else if (q > 8 && q < 14)
                ++F;
              else if (q === 47) {
                var te = L.charCodeAt(F + 1);
                if (te === 42)
                  Pe();
                else if (te === 47)
                  Oe();
                else
                  break;
              } else if (q === 160)
                ++F;
              else if (q >= 5760 && hr.test(String.fromCharCode(q)))
                ++F;
              else
                break;
            }
          }
          function rt() {
            var q = L.charCodeAt(F + 1);
            return q >= 48 && q <= 57 ? Oi(!0) : (++F, de(pe));
          }
          function lt() {
            var q = L.charCodeAt(F + 1);
            return fe ? (++F, di()) : q === 61 ? Qt(vt, 2) : Qt(je, 1);
          }
          function Ke() {
            var q = L.charCodeAt(F + 1);
            return q === 61 ? Qt(vt, 2) : Qt(yr, 1);
          }
          function xt(q) {
            var te = L.charCodeAt(F + 1);
            return te === q ? Qt(q === 124 ? ii : Gi, 2) : te === 61 ? Qt(vt, 2) : Qt(q === 124 ? ls : ms, 1);
          }
          function It() {
            var q = L.charCodeAt(F + 1);
            return q === 61 ? Qt(vt, 2) : Qt(As, 1);
          }
          function ai(q) {
            var te = L.charCodeAt(F + 1);
            return te === q ? te == 45 && L.charCodeAt(F + 2) == 62 && b.test(L.slice(Re, F)) ? (F += 3, Oe(), Ue(), Zi()) : Qt(Lt, 2) : te === 61 ? Qt(vt, 2) : Qt(kr, 1);
          }
          function si(q) {
            var te = L.charCodeAt(F + 1), be = 1;
            return te === q ? (be = q === 62 && L.charCodeAt(F + 2) === 62 ? 3 : 2, L.charCodeAt(F + be) === 61 ? Qt(vt, be + 1) : Qt(bi, be)) : te == 33 && q == 60 && L.charCodeAt(F + 2) == 45 && L.charCodeAt(F + 3) == 45 ? (F += 4, Oe(), Ue(), Zi()) : (te === 61 && (be = L.charCodeAt(F + 2) === 61 ? 3 : 2), Qt(Si, be));
          }
          function fn(q) {
            var te = L.charCodeAt(F + 1);
            return te === 61 ? Qt(zs, L.charCodeAt(F + 2) === 61 ? 3 : 2) : Qt(q === 61 ? Qe : $t, 1);
          }
          function Qi(q) {
            switch (q) {
              case 46:
                return rt();
              case 40:
                return ++F, de(qi);
              case 41:
                return ++F, de(Di);
              case 59:
                return ++F, de(N);
              case 44:
                return ++F, de(d);
              case 91:
                return ++F, de(Mn);
              case 93:
                return ++F, de(un);
              case 123:
                return ++F, de(Ji);
              case 125:
                return ++F, de(cn);
              case 58:
                return ++F, de(re);
              case 63:
                return ++F, de(Le);
              case 48:
                var te = L.charCodeAt(F + 1);
                if (te === 120 || te === 88)
                  return mi();
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                return Oi(!1);
              case 34:
              case 39:
                return Qs(q);
              case 47:
                return lt();
              case 37:
              case 42:
                return Ke();
              case 124:
              case 38:
                return xt(q);
              case 94:
                return It();
              case 43:
              case 45:
                return ai(q);
              case 60:
              case 62:
                return si(q);
              case 61:
              case 33:
                return fn(q);
              case 126:
                return Qt($t, 1);
            }
            return !1;
          }
          function Zi(q) {
            if (q ? F = W + 1 : W = F, D.locations && (ie = new oe()), q)
              return di();
            if (F >= P)
              return de(yt);
            var te = L.charCodeAt(F);
            if (G(te) || te === 92)
              return En();
            var be = Qi(te);
            if (be === !1) {
              var Ae = String.fromCharCode(te);
              if (Ae === "\\" || $s.test(Ae))
                return En();
              Ie(F, "Unexpected character '" + Ae + "'");
            }
            return be;
          }
          function Qt(q, te) {
            var be = L.slice(F, F + te);
            F += te, de(q, be);
          }
          function di() {
            for (var qe = "", q, te, be = F; ; ) {
              F >= P && Ie(be, "Unterminated regular expression");
              var Ae = L.charAt(F);
              if (b.test(Ae) && Ie(be, "Unterminated regular expression"), q)
                q = !1;
              else {
                if (Ae === "[")
                  te = !0;
                else if (Ae === "]" && te)
                  te = !1;
                else if (Ae === "/" && !te)
                  break;
                q = Ae === "\\";
              }
              ++F;
            }
            var qe = L.slice(be, F);
            ++F;
            var ot = hs();
            ot && !/^[gmsiy]*$/.test(ot) && Ie(be, "Invalid regexp flag");
            try {
              var it = new RegExp(qe, ot);
            } catch (wt) {
              wt instanceof SyntaxError && Ie(be, wt.message), Ie(wt);
            }
            return de(tt, it);
          }
          function yn(q, te) {
            for (var be = F, Ae = 0, qe = 0, ot = te ?? 1 / 0; qe < ot; ++qe) {
              var it = L.charCodeAt(F), wt;
              if (it >= 97 ? wt = it - 97 + 10 : it >= 65 ? wt = it - 65 + 10 : it >= 48 && it <= 57 ? wt = it - 48 : wt = 1 / 0, wt >= q)
                break;
              ++F, Ae = Ae * q + wt;
            }
            return F === be || te != null && F - be !== te ? null : Ae;
          }
          function mi() {
            F += 2;
            var q = yn(16);
            return q == null && Ie(W + 2, "Expected hexadecimal number"), G(L.charCodeAt(F)) && Ie(F, "Identifier directly after number"), de(et, q);
          }
          function Oi(q) {
            var te = F, be = !1, Ae = L.charCodeAt(F) === 48;
            !q && yn(10) === null && Ie(te, "Invalid number"), L.charCodeAt(F) === 46 && (++F, yn(10), be = !0);
            var qe = L.charCodeAt(F);
            (qe === 69 || qe === 101) && (qe = L.charCodeAt(++F), (qe === 43 || qe === 45) && ++F, yn(10) === null && Ie(te, "Invalid number"), be = !0), G(L.charCodeAt(F)) && Ie(F, "Identifier directly after number");
            var ot = L.slice(te, F), it;
            return be ? it = parseFloat(ot) : !Ae || ot.length === 1 ? it = parseInt(ot, 10) : /[89]/.test(ot) || Be ? Ie(te, "Invalid number") : it = parseInt(ot, 8), de(et, it);
          }
          function Qs(q) {
            F++;
            for (var te = ""; ; ) {
              F >= P && Ie(W, "Unterminated string constant");
              var be = L.charCodeAt(F);
              if (be === q)
                return ++F, de(gt, te);
              if (be === 92) {
                be = L.charCodeAt(++F);
                var Ae = /^[0-7]+/.exec(L.slice(F, F + 3));
                for (Ae && (Ae = Ae[0]); Ae && parseInt(Ae, 8) > 255; )
                  Ae = Ae.slice(0, -1);
                if (Ae === "0" && (Ae = null), ++F, Ae)
                  Be && Ie(F - 2, "Octal literal in strict mode"), te += String.fromCharCode(parseInt(Ae, 8)), F += Ae.length - 1;
                else
                  switch (be) {
                    case 110:
                      te += `
`;
                      break;
                    case 114:
                      te += "\r";
                      break;
                    case 120:
                      te += String.fromCharCode(ts(2));
                      break;
                    case 117:
                      te += String.fromCharCode(ts(4));
                      break;
                    case 85:
                      te += String.fromCharCode(ts(8));
                      break;
                    case 116:
                      te += "	";
                      break;
                    case 98:
                      te += "\b";
                      break;
                    case 118:
                      te += "\v";
                      break;
                    case 102:
                      te += "\f";
                      break;
                    case 48:
                      te += "\0";
                      break;
                    case 13:
                      L.charCodeAt(F) === 10 && ++F;
                    case 10:
                      D.locations && (ve = F, ++me);
                      break;
                    default:
                      te += String.fromCharCode(be);
                      break;
                  }
              } else
                (be === 13 || be === 10 || be === 8232 || be === 8233) && Ie(W, "Unterminated string constant"), te += String.fromCharCode(be), ++F;
            }
          }
          function ts(q) {
            var te = yn(16, q);
            return te === null && Ie(W, "Bad character escape sequence"), te;
          }
          var en;
          function hs() {
            en = !1;
            for (var q, te = !0, be = F; ; ) {
              var Ae = L.charCodeAt(F);
              if (Z(Ae))
                en && (q += L.charAt(F)), ++F;
              else if (Ae === 92) {
                en || (q = L.slice(be, F)), en = !0, L.charCodeAt(++F) != 117 && Ie(F, "Expecting Unicode escape sequence \\uXXXX"), ++F;
                var qe = ts(4), ot = String.fromCharCode(qe);
                ot || Ie(F - 1, "Invalid Unicode escape"), (te ? G(qe) : Z(qe)) || Ie(F - 4, "Invalid Unicode escape"), q += ot;
              } else
                break;
              te = !1;
            }
            return en ? q : L.slice(be, F);
          }
          function En() {
            var q = hs(), te = ut;
            return !en && $i(q) && (te = os[q]), de(te, q);
          }
          function Et() {
            Se = W, Re = Q, He = ae, Zi();
          }
          function Vn(q) {
            if (Be = q, F = W, D.locations)
              for (; F < ve; )
                ve = L.lastIndexOf(`
`, ve - 2) + 1, --me;
            Ue(), Zi();
          }
          function bn() {
            this.type = null, this.start = W, this.end = null;
          }
          function Ls() {
            this.start = ie, this.end = null, S !== null && (this.source = S);
          }
          function oi() {
            var q = new bn();
            return D.locations && (q.loc = new Ls()), D.directSourceFile && (q.sourceFile = D.directSourceFile), D.ranges && (q.range = [W, 0]), q;
          }
          function Hi(q) {
            var te = new bn();
            return te.start = q.start, D.locations && (te.loc = new Ls(), te.loc.start = q.loc.start), D.ranges && (te.range = [q.range[0], 0]), te;
          }
          function Ct(q, te) {
            return q.type = te, q.end = Re, D.locations && (q.loc.end = He), D.ranges && (q.range[1] = Re), q;
          }
          function Bs(q) {
            return D.ecmaVersion >= 5 && q.type === "ExpressionStatement" && q.expression.type === "Literal" && q.expression.value === "use strict";
          }
          function Gt(q) {
            if (J === q)
              return Et(), !0;
          }
          function vi() {
            return !D.strictSemicolons && (J === yt || J === cn || b.test(L.slice(Re, W)));
          }
          function dn() {
            !Gt(N) && !vi() && Xi();
          }
          function jt(q) {
            J === q ? Et() : Xi();
          }
          function Xi() {
            Ie(W, "Unexpected token");
          }
          function Es(q) {
            q.type !== "Identifier" && q.type !== "MemberExpression" && Ie(q.start, "Assigning to rvalue"), Be && q.type === "Identifier" && Ts(q.name) && Ie(q.start, "Assigning to " + q.name + " in strict mode");
          }
          function Jr(q) {
            Se = Re = F, D.locations && (He = new oe()), Ye = Be = null, Je = [], Zi();
            var te = q || oi(), be = !0;
            for (q || (te.body = []); J !== yt; ) {
              var Ae = ji();
              te.body.push(Ae), be && Bs(Ae) && Vn(!0), be = !1;
            }
            return Ct(te, "Program");
          }
          var Fs = { kind: "loop" }, Hn = { kind: "switch" };
          function ji() {
            (J === je || J === vt && le == "/=") && Zi(!0);
            var q = J, te = oi();
            switch (q) {
              case At:
              case mt:
                Et();
                var be = q === At;
                Gt(N) || vi() ? te.label = null : J !== ut ? Xi() : (te.label = Ne(), dn());
                for (var Ae = 0; Ae < Je.length; ++Ae) {
                  var qe = Je[Ae];
                  if ((te.label == null || qe.name === te.label.name) && (qe.kind != null && (be || qe.kind === "loop") || te.label && be))
                    break;
                }
                return Ae === Je.length && Ie(te.start, "Unsyntactic " + q.keyword), Ct(te, be ? "BreakStatement" : "ContinueStatement");
              case Zt:
                return Et(), dn(), Ct(te, "DebuggerStatement");
              case Nt:
                return Et(), Je.push(Fs), te.body = ji(), Je.pop(), jt(Vi), te.test = xn(), dn(), Ct(te, "DoWhileStatement");
              case ri:
                if (Et(), Je.push(Fs), jt(qi), J === N)
                  return is(te, null);
                if (J === Wi) {
                  var ot = oi();
                  return Et(), us(ot, !0), Ct(ot, "VariableDeclaration"), ot.declarations.length === 1 && Gt(Yt) ? Pn(te, ot) : is(te, ot);
                }
                var ot = Mi(!1, !0);
                return Gt(Yt) ? (Es(ot), Pn(te, ot)) : is(te, ot);
              case Pi:
                return Et(), Ce(te, !0);
              case ci:
                return Et(), te.test = xn(), te.consequent = ji(), te.alternate = Gt(Jt) ? ji() : null, Ct(te, "IfStatement");
              case hi:
                return !Ye && !D.allowReturnOutsideFunction && Ie(W, "'return' outside of function"), Et(), Gt(N) || vi() ? te.argument = null : (te.argument = Mi(), dn()), Ct(te, "ReturnStatement");
              case Ni:
                Et(), te.discriminant = xn(), te.cases = [], jt(Ji), Je.push(Hn);
                for (var it, wt; J != cn; )
                  if (J === bt || J === Xt) {
                    var gi = J === bt;
                    it && Ct(it, "SwitchCase"), te.cases.push(it = oi()), it.consequent = [], Et(), gi ? it.test = Mi() : (wt && Ie(Se, "Multiple default clauses"), wt = !0, it.test = null), jt(re);
                  } else
                    it || Xi(), it.consequent.push(ji());
                return it && Ct(it, "SwitchCase"), Et(), Je.pop(), Ct(te, "SwitchStatement");
              case Bi:
                return Et(), b.test(L.slice(Re, W)) && Ie(Re, "Illegal newline after throw"), te.argument = Mi(), dn(), Ct(te, "ThrowStatement");
              case Ri:
                if (Et(), te.block = Yn(), te.handler = null, J === li) {
                  var zi = oi();
                  Et(), jt(qi), zi.param = Ne(), Be && Ts(zi.param.name) && Ie(zi.param.start, "Binding " + zi.param.name + " in strict mode"), jt(Di), zi.guard = null, zi.body = Yn(), te.handler = Ct(zi, "CatchClause");
                }
                return te.guardedHandlers = Ge, te.finalizer = Gt(Ti) ? Yn() : null, !te.handler && !te.finalizer && Ie(te.start, "Missing catch or finally clause"), Ct(te, "TryStatement");
              case Wi:
                return Et(), us(te), dn(), Ct(te, "VariableDeclaration");
              case Vi:
                return Et(), te.test = xn(), Je.push(Fs), te.body = ji(), Je.pop(), Ct(te, "WhileStatement");
              case Fn:
                return Be && Ie(W, "'with' in strict mode"), Et(), te.object = xn(), te.body = ji(), Ct(te, "WithStatement");
              case Ji:
                return Yn();
              case N:
                return Et(), Ct(te, "EmptyStatement");
              default:
                var tn = le, an = Mi();
                if (q === ut && an.type === "Identifier" && Gt(re)) {
                  for (var Ae = 0; Ae < Je.length; ++Ae)
                    Je[Ae].name === tn && Ie(an.start, "Label '" + tn + "' is already declared");
                  var cs = J.isLoop ? "loop" : J === Ni ? "switch" : null;
                  return Je.push({ name: tn, kind: cs }), te.body = ji(), Je.pop(), te.label = an, Ct(te, "LabeledStatement");
                } else
                  return te.expression = an, dn(), Ct(te, "ExpressionStatement");
            }
          }
          function xn() {
            jt(qi);
            var q = Mi();
            return jt(Di), q;
          }
          function Yn(q) {
            var te = oi(), be = !0, Ae = !1, qe;
            for (te.body = [], jt(Ji); !Gt(cn); ) {
              var ot = ji();
              te.body.push(ot), be && q && Bs(ot) && (qe = Ae, Vn(Ae = !0)), be = !1;
            }
            return Ae && !qe && Vn(!1), Ct(te, "BlockStatement");
          }
          function is(q, te) {
            return q.init = te, jt(N), q.test = J === N ? null : Mi(), jt(N), q.update = J === Di ? null : Mi(), jt(Di), q.body = ji(), Je.pop(), Ct(q, "ForStatement");
          }
          function Pn(q, te) {
            return q.left = te, q.right = Mi(), jt(Di), q.body = ji(), Je.pop(), Ct(q, "ForInStatement");
          }
          function us(q, te) {
            for (q.declarations = [], q.kind = "var"; ; ) {
              var be = oi();
              if (be.id = Ne(), Be && Ts(be.id.name) && Ie(be.id.start, "Binding " + be.id.name + " in strict mode"), be.init = Gt(Qe) ? Mi(!0, te) : null, q.declarations.push(Ct(be, "VariableDeclarator")), !Gt(d))
                break;
            }
            return q;
          }
          function Mi(q, te) {
            var be = er(te);
            if (!q && J === d) {
              var Ae = Hi(be);
              for (Ae.expressions = [be]; Gt(d); )
                Ae.expressions.push(er(te));
              return Ct(Ae, "SequenceExpression");
            }
            return be;
          }
          function er(q) {
            var te = ur(q);
            if (J.isAssign) {
              var be = Hi(te);
              return be.operator = le, be.left = te, Et(), be.right = er(q), Es(te), Ct(be, "AssignmentExpression");
            }
            return te;
          }
          function ur(q) {
            var te = vs(q);
            if (Gt(Le)) {
              var be = Hi(te);
              return be.test = te, be.consequent = Mi(!0), jt(re), be.alternate = Mi(!0, q), Ct(be, "ConditionalExpression");
            }
            return te;
          }
          function vs(q) {
            return gn(Us(), -1, q);
          }
          function gn(q, te, be) {
            var Ae = J.binop;
            if (Ae != null && (!be || J !== Yt) && Ae > te) {
              var qe = Hi(q);
              qe.left = q, qe.operator = le;
              var ot = J;
              Et(), qe.right = gn(Us(), Ae, be);
              var it = Ct(qe, ot === ii || ot === Gi ? "LogicalExpression" : "BinaryExpression");
              return gn(it, te, be);
            }
            return q;
          }
          function Us() {
            if (J.prefix) {
              var q = oi(), te = J.isUpdate;
              return q.operator = le, q.prefix = !0, fe = !0, Et(), q.argument = Us(), te ? Es(q.argument) : Be && q.operator === "delete" && q.argument.type === "Identifier" && Ie(q.start, "Deleting local variable in strict mode"), Ct(q, te ? "UpdateExpression" : "UnaryExpression");
            }
            for (var be = xr(); J.postfix && !vi(); ) {
              var q = Hi(be);
              q.operator = le, q.prefix = !1, q.argument = be, Es(be), Et(), be = Ct(q, "UpdateExpression");
            }
            return be;
          }
          function xr() {
            return ns(Te());
          }
          function ns(q, te) {
            if (Gt(pe)) {
              var be = Hi(q);
              return be.object = q, be.property = Ne(!0), be.computed = !1, ns(Ct(be, "MemberExpression"), te);
            } else if (Gt(Mn)) {
              var be = Hi(q);
              return be.object = q, be.property = Mi(), be.computed = !0, jt(un), ns(Ct(be, "MemberExpression"), te);
            } else if (!te && Gt(qi)) {
              var be = Hi(q);
              return be.callee = q, be.arguments = De(Di, !1), ns(Ct(be, "CallExpression"), te);
            } else
              return q;
          }
          function Te() {
            switch (J) {
              case Cs:
                var Ae = oi();
                return Et(), Ct(Ae, "ThisExpression");
              case ut:
                return Ne();
              case et:
              case gt:
              case tt:
                var Ae = oi();
                return Ae.value = le, Ae.raw = L.slice(W, Q), Et(), Ct(Ae, "Literal");
              case _s:
              case vn:
              case Qn:
                var Ae = oi();
                return Ae.value = J.atomValue, Ae.raw = J.keyword, Et(), Ct(Ae, "Literal");
              case qi:
                var q = ie, te = W;
                Et();
                var be = Mi();
                return be.start = te, be.end = Q, D.locations && (be.loc.start = q, be.loc.end = ae), D.ranges && (be.range = [te, Q]), jt(Di), be;
              case Mn:
                var Ae = oi();
                return Et(), Ae.elements = De(un, !0, !0), Ct(Ae, "ArrayExpression");
              case Ji:
                return Xe();
              case Pi:
                var Ae = oi();
                return Et(), Ce(Ae, !1);
              case $n:
                return Fe();
              default:
                Xi();
            }
          }
          function Fe() {
            var q = oi();
            return Et(), q.callee = ns(Te(), !0), Gt(qi) ? q.arguments = De(Di, !1) : q.arguments = Ge, Ct(q, "NewExpression");
          }
          function Xe() {
            var q = oi(), te = !0, be = !1;
            for (q.properties = [], Et(); !Gt(cn); ) {
              if (te)
                te = !1;
              else if (jt(d), D.allowTrailingCommas && Gt(cn))
                break;
              var Ae = { key: $e() }, qe = !1, ot;
              if (Gt(re) ? (Ae.value = Mi(!0), ot = Ae.kind = "init") : D.ecmaVersion >= 5 && Ae.key.type === "Identifier" && (Ae.key.name === "get" || Ae.key.name === "set") ? (qe = be = !0, ot = Ae.kind = Ae.key.name, Ae.key = $e(), J !== qi && Xi(), Ae.value = Ce(oi(), !1)) : Xi(), Ae.key.type === "Identifier" && (Be || be))
                for (var it = 0; it < q.properties.length; ++it) {
                  var wt = q.properties[it];
                  if (wt.key.name === Ae.key.name) {
                    var gi = ot == wt.kind || qe && wt.kind === "init" || ot === "init" && (wt.kind === "get" || wt.kind === "set");
                    gi && !Be && ot === "init" && wt.kind === "init" && (gi = !1), gi && Ie(Ae.key.start, "Redefinition of property");
                  }
                }
              q.properties.push(Ae);
            }
            return Ct(q, "ObjectExpression");
          }
          function $e() {
            return J === et || J === gt ? Te() : Ne(!0);
          }
          function Ce(q, te) {
            J === ut ? q.id = Ne() : te ? Xi() : q.id = null, q.params = [];
            var be = !0;
            for (jt(qi); !Gt(Di); )
              be ? be = !1 : jt(d), q.params.push(Ne());
            var Ae = Ye, qe = Je;
            if (Ye = !0, Je = [], q.body = Yn(!0), Ye = Ae, Je = qe, Be || q.body.body.length && Bs(q.body.body[0]))
              for (var ot = q.id ? -1 : 0; ot < q.params.length; ++ot) {
                var it = ot < 0 ? q.id : q.params[ot];
                if ((lr(it.name) || Ts(it.name)) && Ie(it.start, "Defining '" + it.name + "' in strict mode"), ot >= 0)
                  for (var wt = 0; wt < ot; ++wt)
                    it.name === q.params[wt].name && Ie(it.start, "Argument name clash in strict mode");
              }
            return Ct(q, te ? "FunctionDeclaration" : "FunctionExpression");
          }
          function De(q, te, be) {
            for (var Ae = [], qe = !0; !Gt(q); ) {
              if (qe)
                qe = !1;
              else if (jt(d), te && D.allowTrailingCommas && Gt(q))
                break;
              be && J === d ? Ae.push(null) : Ae.push(Mi(!0));
            }
            return Ae;
          }
          function Ne(q) {
            var te = oi();
            return q && D.forbidReserved == "everywhere" && (q = !1), J === ut ? (!q && (D.forbidReserved && (D.ecmaVersion === 3 ? br : Kr)(le) || Be && lr(le)) && L.slice(W, Q).indexOf("\\") == -1 && Ie(W, "The keyword '" + le + "' is reserved"), te.name = le) : q && J.keyword ? te.name = J.keyword : Xi(), fe = !1, Et(), Ct(te, "Identifier");
          }
        }), n.version || (n = null);
      }
      function h(E, D) {
        return (i.acorn || n).parse(E, D);
      }
      var f = {
        "+": "__add",
        "-": "__subtract",
        "*": "__multiply",
        "/": "__divide",
        "%": "__modulo",
        "==": "__equals",
        "!=": "__equals"
      }, m = {
        "-": "__negate",
        "+": "__self"
      }, _ = a.each(
        ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
        function(E) {
          this["__" + E] = "#" + E;
        },
        {
          __self: function() {
            return this;
          }
        }
      );
      z.inject(_), ne.inject(_), qt.inject(_);
      function y(E, D, L) {
        var P = f[D];
        if (E && E[P]) {
          var S = E[P](L);
          return D === "!=" ? !S : S;
        }
        switch (D) {
          case "+":
            return E + L;
          case "-":
            return E - L;
          case "*":
            return E * L;
          case "/":
            return E / L;
          case "%":
            return E % L;
          case "==":
            return E == L;
          case "!=":
            return E != L;
        }
      }
      function x(E, D) {
        var L = m[E];
        if (D && D[L])
          return D[L]();
        switch (E) {
          case "+":
            return +D;
          case "-":
            return -D;
        }
      }
      function A(E, D) {
        if (!E)
          return "";
        D = D || {};
        var L = [];
        function P(Be) {
          for (var Ie = 0, Ge = L.length; Ie < Ge; Ie++) {
            var et = L[Ie];
            if (et[0] >= Be)
              break;
            Be += et[1];
          }
          return Be;
        }
        function S(Be) {
          return E.substring(
            P(Be.range[0]),
            P(Be.range[1])
          );
        }
        function I(Be, Ie) {
          return E.substring(
            P(Be.range[1]),
            P(Ie.range[0])
          );
        }
        function U(Be, Ie) {
          for (var Ge = P(Be.range[0]), et = P(Be.range[1]), tt = 0, gt = L.length - 1; gt >= 0; gt--)
            if (Ge > L[gt][0]) {
              tt = gt + 1;
              break;
            }
          L.splice(tt, 0, [Ge, Ie.length - et + Ge]), E = E.substring(0, Ge) + Ie + E.substring(et);
        }
        function V(Be, Ie) {
          switch (Be.type) {
            case "UnaryExpression":
              if (Be.operator in m && Be.argument.type !== "Literal") {
                var Ge = S(Be.argument);
                U(Be, '$__("' + Be.operator + '", ' + Ge + ")");
              }
              break;
            case "BinaryExpression":
              if (Be.operator in f && Be.left.type !== "Literal") {
                var et = S(Be.left), tt = S(Be.right), gt = I(Be.left, Be.right), ut = Be.operator;
                U(Be, "__$__(" + et + "," + gt.replace(
                  new RegExp("\\" + ut),
                  '"' + ut + '"'
                ) + ", " + tt + ")");
              }
              break;
            case "UpdateExpression":
            case "AssignmentExpression":
              var yt = Ie && Ie.type;
              if (!(yt === "ForStatement" || yt === "BinaryExpression" && /^[=!<>]/.test(Ie.operator) || yt === "MemberExpression" && Ie.computed)) {
                if (Be.type === "UpdateExpression") {
                  var Ge = S(Be.argument), At = "__$__(" + Ge + ', "' + Be.operator[0] + '", 1)', bt = Ge + " = " + At;
                  Be.prefix ? bt = "(" + bt + ")" : (yt === "AssignmentExpression" || yt === "VariableDeclarator" || yt === "BinaryExpression") && (S(Ie.left || Ie.id) === Ge && (bt = At), bt = Ge + "; " + bt), U(Be, bt);
                } else if (/^.=$/.test(Be.operator) && Be.left.type !== "Literal") {
                  var et = S(Be.left), tt = S(Be.right), At = et + " = __$__(" + et + ', "' + Be.operator[0] + '", ' + tt + ")";
                  U(Be, /^\(.*\)$/.test(S(Be)) ? "(" + At + ")" : At);
                }
              }
              break;
          }
        }
        function F(Be) {
          switch (Be.type) {
            case "ExportDefaultDeclaration":
              U({
                range: [Be.start, Be.declaration.start]
              }, "module.exports = ");
              break;
            case "ExportNamedDeclaration":
              var Ie = Be.declaration, Ge = Be.specifiers;
              if (Ie) {
                var et = Ie.declarations;
                et && (et.forEach(function(gt) {
                  U(gt, "module.exports." + S(gt));
                }), U({
                  range: [
                    Be.start,
                    Ie.start + Ie.kind.length
                  ]
                }, ""));
              } else if (Ge) {
                var tt = Ge.map(function(gt) {
                  var ut = S(gt);
                  return "module.exports." + ut + " = " + ut + "; ";
                }).join("");
                tt && U(Be, tt);
              }
              break;
          }
        }
        function W(Be, Ie, Ge) {
          if (Be) {
            for (var et in Be)
              if (et !== "range" && et !== "loc") {
                var tt = Be[et];
                if (Array.isArray(tt))
                  for (var gt = 0, ut = tt.length; gt < ut; gt++)
                    W(tt[gt], Be, Ge);
                else
                  tt && typeof tt == "object" && W(tt, Be, Ge);
              }
            Ge.operatorOverloading !== !1 && V(Be, Ie), Ge.moduleExports !== !1 && F(Be);
          }
        }
        function Q(Be) {
          var Ie = "", Ge = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          for (Be = (Math.abs(Be) << 1) + (Be < 0 ? 1 : 0); Be || !Ie; ) {
            var et = Be & 31;
            Be >>= 5, Be && (et |= 32), Ie += Ge[et];
          }
          return Ie;
        }
        var ie = D.url || "", ae = D.sourceMaps, J = D.paperFeatures || {}, le = D.source || E, fe = D.offset || 0, me = nt.agent, ve = me.versionNumber, Se = !1, Re = /\r\n|\n|\r/mg, He;
        if (ae && (me.chrome && ve >= 30 || me.webkit && ve >= 537.76 || me.firefox && ve >= 23 || me.node)) {
          if (me.node)
            fe -= 2;
          else if (s && ie && !s.location.href.indexOf(ie)) {
            var Ye = o.getElementsByTagName("html")[0].innerHTML;
            fe = Ye.substr(0, Ye.indexOf(E) + 1).match(
              Re
            ).length + 1;
          }
          Se = fe > 0 && !(me.chrome && ve >= 36 || me.safari && ve >= 600 || me.firefox && ve >= 40 || me.node);
          var Je = ["AA" + Q(Se ? 0 : fe) + "A"];
          Je.length = (E.match(Re) || []).length + 1 + (Se ? fe : 0), He = {
            version: 3,
            file: ie,
            names: [],
            mappings: Je.join(";AACA"),
            sourceRoot: "",
            sources: [ie],
            sourcesContent: [le]
          };
        }
        return (J.operatorOverloading !== !1 || J.moduleExports !== !1) && W(h(E, {
          ranges: !0,
          preserveParens: !0,
          sourceType: "module"
        }), null, J), He && (Se && (E = new Array(fe + 1).join(`
`) + E), /^(inline|both)$/.test(ae) && (E += `
//# sourceMappingURL=data:application/json;base64,` + e.btoa(unescape(encodeURIComponent(
          JSON.stringify(He)
        )))), E += `
//# sourceURL=` + (ie || "paperscript")), {
          url: ie,
          source: le,
          code: E,
          map: He
        };
      }
      function B(E, D, L) {
        nt = D;
        var P = D.getView(), S = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(E) && !/\bnew\s+Tool\b/.test(E) ? new Bn() : null, I = S ? S._events : [], U = ["onFrame", "onResize"].concat(I), V = [], F = [], W, Q = typeof E == "object" ? E : A(E, L);
        E = Q.code;
        function ie(ve, Se) {
          for (var Re in ve)
            (Se || !/^_/.test(Re)) && new RegExp("([\\b\\s\\W]|^)" + Re.replace(/\$/g, "\\$") + "\\b").test(E) && (V.push(Re), F.push(ve[Re]));
        }
        ie(
          { __$__: y, $__: x, paper: D, tool: S },
          !0
        ), ie(D), E = "var module = { exports: {} }; " + E;
        var fe = a.each(U, function(ve) {
          new RegExp("\\s+" + ve + "\\b").test(E) && (V.push(ve), this.push("module.exports." + ve + " = " + ve + ";"));
        }, []).join(`
`);
        fe && (E += `
` + fe), E += `
return module.exports;`;
        var ae = nt.agent;
        if (o && (ae.chrome || ae.firefox && ae.versionNumber < 40)) {
          var J = o.createElement("script"), le = o.head || o.getElementsByTagName("head")[0];
          ae.firefox && (E = `
` + E), J.appendChild(o.createTextNode(
            "document.__paperscript__ = function(" + V + ") {" + E + `
}`
          )), le.appendChild(J), W = o.__paperscript__, delete o.__paperscript__, le.removeChild(J);
        } else
          W = Function(V, E);
        var fe = W && W.apply(D, F), me = fe || {};
        return a.each(I, function(ve) {
          var Se = me[ve];
          Se && (S[ve] = Se);
        }), P && (me.onResize && P.setOnResize(me.onResize), P.emit("resize", {
          size: P.size,
          delta: new z()
        }), me.onFrame && P.setOnFrame(me.onFrame), P.requestUpdate()), fe;
      }
      function C(E) {
        if (/^text\/(?:x-|)paperscript$/.test(E.type) && g.getAttribute(E, "ignore") !== "true") {
          var D = g.getAttribute(E, "canvas"), L = o.getElementById(D), P = E.src || E.getAttribute("data-src"), S = g.hasAttribute(E, "async"), I = "data-paper-scope";
          if (!L)
            throw new Error('Unable to find canvas with id "' + D + '"');
          var U = g.get(L.getAttribute(I)) || new g().setup(L);
          return L.setAttribute(I, U._id), P ? zn.request({
            url: P,
            async: S,
            mimeType: "text/plain",
            onLoad: function(V) {
              B(V, U, P);
            }
          }) : B(E.innerHTML, U, E.baseURI), E.setAttribute("data-paper-ignore", "true"), U;
        }
      }
      function M() {
        a.each(
          o && o.getElementsByTagName("script"),
          C
        );
      }
      function R(E) {
        return E ? C(E) : M();
      }
      return s && (o.readyState === "complete" ? setTimeout(M) : Dt.add(s, { load: M })), {
        compile: A,
        execute: B,
        load: R,
        parse: h,
        calculateBinary: y,
        calculateUnary: x
      };
    }).call(this);
    var nt = new (g.inject(a.exports, {
      Base: a,
      Numerical: Y,
      Key: qn,
      DomEvent: Dt,
      DomElement: zt,
      document: o,
      window: s,
      Symbol: Mt,
      PlacedSymbol: Pt
    }))();
    return nt.agent.node && Of(nt), typeof t == "function" && t.amd ? t("paper", nt) : v && (v.exports = nt), nt;
  }).call(Gr, typeof self == "object" ? self : null);
})(Xd);
var rw = Xd.exports;
const aw = /* @__PURE__ */ kd(rw);
function ow(v) {
  if (v && !(typeof window > "u")) {
    var e = document.createElement("style");
    return e.setAttribute("type", "text/css"), e.innerHTML = v, document.head.appendChild(e), v;
  }
}
function Ma(v, e) {
  var t = v.__state.conversionName.toString(), s = Math.round(v.r), o = Math.round(v.g), a = Math.round(v.b), c = v.a, g = Math.round(v.h), w = v.s.toFixed(1), T = v.v.toFixed(1);
  if (e || t === "THREE_CHAR_HEX" || t === "SIX_CHAR_HEX") {
    for (var H = v.hex.toString(16); H.length < 6; )
      H = "0" + H;
    return "#" + H;
  } else {
    if (t === "CSS_RGB")
      return "rgb(" + s + "," + o + "," + a + ")";
    if (t === "CSS_RGBA")
      return "rgba(" + s + "," + o + "," + a + "," + c + ")";
    if (t === "HEX")
      return "0x" + v.hex.toString(16);
    if (t === "RGB_ARRAY")
      return "[" + s + "," + o + "," + a + "]";
    if (t === "RGBA_ARRAY")
      return "[" + s + "," + o + "," + a + "," + c + "]";
    if (t === "RGB_OBJ")
      return "{r:" + s + ",g:" + o + ",b:" + a + "}";
    if (t === "RGBA_OBJ")
      return "{r:" + s + ",g:" + o + ",b:" + a + ",a:" + c + "}";
    if (t === "HSV_OBJ")
      return "{h:" + g + ",s:" + w + ",v:" + T + "}";
    if (t === "HSVA_OBJ")
      return "{h:" + g + ",s:" + w + ",v:" + T + ",a:" + c + "}";
  }
  return "unknown format";
}
var kf = Array.prototype.forEach, Wa = Array.prototype.slice, _t = {
  BREAK: {},
  extend: function(e) {
    return this.each(Wa.call(arguments, 1), function(t) {
      var s = this.isObject(t) ? Object.keys(t) : [];
      s.forEach((function(o) {
        this.isUndefined(t[o]) || (e[o] = t[o]);
      }).bind(this));
    }, this), e;
  },
  defaults: function(e) {
    return this.each(Wa.call(arguments, 1), function(t) {
      var s = this.isObject(t) ? Object.keys(t) : [];
      s.forEach((function(o) {
        this.isUndefined(e[o]) && (e[o] = t[o]);
      }).bind(this));
    }, this), e;
  },
  compose: function() {
    var e = Wa.call(arguments);
    return function() {
      for (var t = Wa.call(arguments), s = e.length - 1; s >= 0; s--)
        t = [e[s].apply(this, t)];
      return t[0];
    };
  },
  each: function(e, t, s) {
    if (e) {
      if (kf && e.forEach && e.forEach === kf)
        e.forEach(t, s);
      else if (e.length === e.length + 0) {
        var o = void 0, a = void 0;
        for (o = 0, a = e.length; o < a; o++)
          if (o in e && t.call(s, e[o], o) === this.BREAK)
            return;
      } else
        for (var c in e)
          if (t.call(s, e[c], c) === this.BREAK)
            return;
    }
  },
  defer: function(e) {
    setTimeout(e, 0);
  },
  debounce: function(e, t, s) {
    var o = void 0;
    return function() {
      var a = this, c = arguments;
      function g() {
        o = null, s || e.apply(a, c);
      }
      var w = s || !o;
      clearTimeout(o), o = setTimeout(g, t), w && e.apply(a, c);
    };
  },
  toArray: function(e) {
    return e.toArray ? e.toArray() : Wa.call(e);
  },
  isUndefined: function(e) {
    return e === void 0;
  },
  isNull: function(e) {
    return e === null;
  },
  isNaN: function(v) {
    function e(t) {
      return v.apply(this, arguments);
    }
    return e.toString = function() {
      return v.toString();
    }, e;
  }(function(v) {
    return isNaN(v);
  }),
  isArray: Array.isArray || function(v) {
    return v.constructor === Array;
  },
  isObject: function(e) {
    return e === Object(e);
  },
  isNumber: function(e) {
    return e === e + 0;
  },
  isString: function(e) {
    return e === e + "";
  },
  isBoolean: function(e) {
    return e === !1 || e === !0;
  },
  isFunction: function(e) {
    return e instanceof Function;
  }
}, lw = [
  {
    litmus: _t.isString,
    conversions: {
      THREE_CHAR_HEX: {
        read: function(e) {
          var t = e.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
          return t === null ? !1 : {
            space: "HEX",
            hex: parseInt("0x" + t[1].toString() + t[1].toString() + t[2].toString() + t[2].toString() + t[3].toString() + t[3].toString(), 0)
          };
        },
        write: Ma
      },
      SIX_CHAR_HEX: {
        read: function(e) {
          var t = e.match(/^#([A-F0-9]{6})$/i);
          return t === null ? !1 : {
            space: "HEX",
            hex: parseInt("0x" + t[1].toString(), 0)
          };
        },
        write: Ma
      },
      CSS_RGB: {
        read: function(e) {
          var t = e.match(/^rgb\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
          return t === null ? !1 : {
            space: "RGB",
            r: parseFloat(t[1]),
            g: parseFloat(t[2]),
            b: parseFloat(t[3])
          };
        },
        write: Ma
      },
      CSS_RGBA: {
        read: function(e) {
          var t = e.match(/^rgba\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
          return t === null ? !1 : {
            space: "RGB",
            r: parseFloat(t[1]),
            g: parseFloat(t[2]),
            b: parseFloat(t[3]),
            a: parseFloat(t[4])
          };
        },
        write: Ma
      }
    }
  },
  {
    litmus: _t.isNumber,
    conversions: {
      HEX: {
        read: function(e) {
          return {
            space: "HEX",
            hex: e,
            conversionName: "HEX"
          };
        },
        write: function(e) {
          return e.hex;
        }
      }
    }
  },
  {
    litmus: _t.isArray,
    conversions: {
      RGB_ARRAY: {
        read: function(e) {
          return e.length !== 3 ? !1 : {
            space: "RGB",
            r: e[0],
            g: e[1],
            b: e[2]
          };
        },
        write: function(e) {
          return [e.r, e.g, e.b];
        }
      },
      RGBA_ARRAY: {
        read: function(e) {
          return e.length !== 4 ? !1 : {
            space: "RGB",
            r: e[0],
            g: e[1],
            b: e[2],
            a: e[3]
          };
        },
        write: function(e) {
          return [e.r, e.g, e.b, e.a];
        }
      }
    }
  },
  {
    litmus: _t.isObject,
    conversions: {
      RGBA_OBJ: {
        read: function(e) {
          return _t.isNumber(e.r) && _t.isNumber(e.g) && _t.isNumber(e.b) && _t.isNumber(e.a) ? {
            space: "RGB",
            r: e.r,
            g: e.g,
            b: e.b,
            a: e.a
          } : !1;
        },
        write: function(e) {
          return {
            r: e.r,
            g: e.g,
            b: e.b,
            a: e.a
          };
        }
      },
      RGB_OBJ: {
        read: function(e) {
          return _t.isNumber(e.r) && _t.isNumber(e.g) && _t.isNumber(e.b) ? {
            space: "RGB",
            r: e.r,
            g: e.g,
            b: e.b
          } : !1;
        },
        write: function(e) {
          return {
            r: e.r,
            g: e.g,
            b: e.b
          };
        }
      },
      HSVA_OBJ: {
        read: function(e) {
          return _t.isNumber(e.h) && _t.isNumber(e.s) && _t.isNumber(e.v) && _t.isNumber(e.a) ? {
            space: "HSV",
            h: e.h,
            s: e.s,
            v: e.v,
            a: e.a
          } : !1;
        },
        write: function(e) {
          return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: e.a
          };
        }
      },
      HSV_OBJ: {
        read: function(e) {
          return _t.isNumber(e.h) && _t.isNumber(e.s) && _t.isNumber(e.v) ? {
            space: "HSV",
            h: e.h,
            s: e.s,
            v: e.v
          } : !1;
        },
        write: function(e) {
          return {
            h: e.h,
            s: e.s,
            v: e.v
          };
        }
      }
    }
  }
], qa = void 0, Qo = void 0, Vh = function() {
  Qo = !1;
  var e = arguments.length > 1 ? _t.toArray(arguments) : arguments[0];
  return _t.each(lw, function(t) {
    if (t.litmus(e))
      return _t.each(t.conversions, function(s, o) {
        if (qa = s.read(e), Qo === !1 && qa !== !1)
          return Qo = qa, qa.conversionName = o, qa.conversion = s, _t.BREAK;
      }), _t.BREAK;
  }), Qo;
}, Pf = void 0, _l = {
  hsv_to_rgb: function(e, t, s) {
    var o = Math.floor(e / 60) % 6, a = e / 60 - Math.floor(e / 60), c = s * (1 - t), g = s * (1 - a * t), w = s * (1 - (1 - a) * t), T = [[s, w, c], [g, s, c], [c, s, w], [c, g, s], [w, c, s], [s, c, g]][o];
    return {
      r: T[0] * 255,
      g: T[1] * 255,
      b: T[2] * 255
    };
  },
  rgb_to_hsv: function(e, t, s) {
    var o = Math.min(e, t, s), a = Math.max(e, t, s), c = a - o, g = void 0, w = void 0;
    if (a !== 0)
      w = c / a;
    else
      return {
        h: NaN,
        s: 0,
        v: 0
      };
    return e === a ? g = (t - s) / c : t === a ? g = 2 + (s - e) / c : g = 4 + (e - t) / c, g /= 6, g < 0 && (g += 1), {
      h: g * 360,
      s: w,
      v: a / 255
    };
  },
  rgb_to_hex: function(e, t, s) {
    var o = this.hex_with_component(0, 2, e);
    return o = this.hex_with_component(o, 1, t), o = this.hex_with_component(o, 0, s), o;
  },
  component_from_hex: function(e, t) {
    return e >> t * 8 & 255;
  },
  hex_with_component: function(e, t, s) {
    return s << (Pf = t * 8) | e & ~(255 << Pf);
  }
}, hw = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
  return typeof v;
} : function(v) {
  return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
}, rr = function(v, e) {
  if (!(v instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, ar = function() {
  function v(e, t) {
    for (var s = 0; s < t.length; s++) {
      var o = t[s];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }
  return function(e, t, s) {
    return t && v(e.prototype, t), s && v(e, s), e;
  };
}(), Wr = function v(e, t, s) {
  e === null && (e = Function.prototype);
  var o = Object.getOwnPropertyDescriptor(e, t);
  if (o === void 0) {
    var a = Object.getPrototypeOf(e);
    return a === null ? void 0 : v(a, t, s);
  } else {
    if ("value" in o)
      return o.value;
    var c = o.get;
    return c === void 0 ? void 0 : c.call(s);
  }
}, Zr = function(v, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  v.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: v,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(v, e) : v.__proto__ = e);
}, Xr = function(v, e) {
  if (!v)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : v;
}, jn = function() {
  function v() {
    if (rr(this, v), this.__state = Vh.apply(this, arguments), this.__state === !1)
      throw new Error("Failed to interpret color arguments");
    this.__state.a = this.__state.a || 1;
  }
  return ar(v, [{
    key: "toString",
    value: function() {
      return Ma(this);
    }
  }, {
    key: "toHexString",
    value: function() {
      return Ma(this, !0);
    }
  }, {
    key: "toOriginal",
    value: function() {
      return this.__state.conversion.write(this);
    }
  }]), v;
}();
function fu(v, e, t) {
  Object.defineProperty(v, e, {
    get: function() {
      return this.__state.space === "RGB" ? this.__state[e] : (jn.recalculateRGB(this, e, t), this.__state[e]);
    },
    set: function(o) {
      this.__state.space !== "RGB" && (jn.recalculateRGB(this, e, t), this.__state.space = "RGB"), this.__state[e] = o;
    }
  });
}
function du(v, e) {
  Object.defineProperty(v, e, {
    get: function() {
      return this.__state.space === "HSV" ? this.__state[e] : (jn.recalculateHSV(this), this.__state[e]);
    },
    set: function(s) {
      this.__state.space !== "HSV" && (jn.recalculateHSV(this), this.__state.space = "HSV"), this.__state[e] = s;
    }
  });
}
jn.recalculateRGB = function(v, e, t) {
  if (v.__state.space === "HEX")
    v.__state[e] = _l.component_from_hex(v.__state.hex, t);
  else if (v.__state.space === "HSV")
    _t.extend(v.__state, _l.hsv_to_rgb(v.__state.h, v.__state.s, v.__state.v));
  else
    throw new Error("Corrupted color state");
};
jn.recalculateHSV = function(v) {
  var e = _l.rgb_to_hsv(v.r, v.g, v.b);
  _t.extend(v.__state, {
    s: e.s,
    v: e.v
  }), _t.isNaN(e.h) ? _t.isUndefined(v.__state.h) && (v.__state.h = 0) : v.__state.h = e.h;
};
jn.COMPONENTS = ["r", "g", "b", "h", "s", "v", "hex", "a"];
fu(jn.prototype, "r", 2);
fu(jn.prototype, "g", 1);
fu(jn.prototype, "b", 0);
du(jn.prototype, "h");
du(jn.prototype, "s");
du(jn.prototype, "v");
Object.defineProperty(jn.prototype, "a", {
  get: function() {
    return this.__state.a;
  },
  set: function(e) {
    this.__state.a = e;
  }
});
Object.defineProperty(jn.prototype, "hex", {
  get: function() {
    return this.__state.space !== "HEX" && (this.__state.hex = _l.rgb_to_hex(this.r, this.g, this.b), this.__state.space = "HEX"), this.__state.hex;
  },
  set: function(e) {
    this.__state.space = "HEX", this.__state.hex = e;
  }
});
var ca = function() {
  function v(e, t) {
    rr(this, v), this.initialValue = e[t], this.domElement = document.createElement("div"), this.object = e, this.property = t, this.__onChange = void 0, this.__onFinishChange = void 0;
  }
  return ar(v, [{
    key: "onChange",
    value: function(t) {
      return this.__onChange = t, this;
    }
  }, {
    key: "onFinishChange",
    value: function(t) {
      return this.__onFinishChange = t, this;
    }
  }, {
    key: "setValue",
    value: function(t) {
      return this.object[this.property] = t, this.__onChange && this.__onChange.call(this, t), this.updateDisplay(), this;
    }
  }, {
    key: "getValue",
    value: function() {
      return this.object[this.property];
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return this;
    }
  }, {
    key: "isModified",
    value: function() {
      return this.initialValue !== this.getValue();
    }
  }]), v;
}(), uw = {
  HTMLEvents: ["change"],
  MouseEvents: ["click", "mousemove", "mousedown", "mouseup", "mouseover"],
  KeyboardEvents: ["keydown"]
}, Kd = {};
_t.each(uw, function(v, e) {
  _t.each(v, function(t) {
    Kd[t] = e;
  });
});
var cw = /(\d+(\.\d+)?)px/;
function pr(v) {
  if (v === "0" || _t.isUndefined(v))
    return 0;
  var e = v.match(cw);
  return _t.isNull(e) ? 0 : parseFloat(e[1]);
}
var st = {
  makeSelectable: function(e, t) {
    e === void 0 || e.style === void 0 || (e.onselectstart = t ? function() {
      return !1;
    } : function() {
    }, e.style.MozUserSelect = t ? "auto" : "none", e.style.KhtmlUserSelect = t ? "auto" : "none", e.unselectable = t ? "on" : "off");
  },
  makeFullscreen: function(e, t, s) {
    var o = s, a = t;
    _t.isUndefined(a) && (a = !0), _t.isUndefined(o) && (o = !0), e.style.position = "absolute", a && (e.style.left = 0, e.style.right = 0), o && (e.style.top = 0, e.style.bottom = 0);
  },
  fakeEvent: function(e, t, s, o) {
    var a = s || {}, c = Kd[t];
    if (!c)
      throw new Error("Event type " + t + " not supported.");
    var g = document.createEvent(c);
    switch (c) {
      case "MouseEvents": {
        var w = a.x || a.clientX || 0, T = a.y || a.clientY || 0;
        g.initMouseEvent(
          t,
          a.bubbles || !1,
          a.cancelable || !0,
          window,
          a.clickCount || 1,
          0,
          0,
          w,
          T,
          !1,
          !1,
          !1,
          !1,
          0,
          null
        );
        break;
      }
      case "KeyboardEvents": {
        var H = g.initKeyboardEvent || g.initKeyEvent;
        _t.defaults(a, {
          cancelable: !0,
          ctrlKey: !1,
          altKey: !1,
          shiftKey: !1,
          metaKey: !1,
          keyCode: void 0,
          charCode: void 0
        }), H(t, a.bubbles || !1, a.cancelable, window, a.ctrlKey, a.altKey, a.shiftKey, a.metaKey, a.keyCode, a.charCode);
        break;
      }
      default: {
        g.initEvent(t, a.bubbles || !1, a.cancelable || !0);
        break;
      }
    }
    _t.defaults(g, o), e.dispatchEvent(g);
  },
  bind: function(e, t, s, o) {
    var a = o || !1;
    return e.addEventListener ? e.addEventListener(t, s, a) : e.attachEvent && e.attachEvent("on" + t, s), st;
  },
  unbind: function(e, t, s, o) {
    var a = o || !1;
    return e.removeEventListener ? e.removeEventListener(t, s, a) : e.detachEvent && e.detachEvent("on" + t, s), st;
  },
  addClass: function(e, t) {
    if (e.className === void 0)
      e.className = t;
    else if (e.className !== t) {
      var s = e.className.split(/ +/);
      s.indexOf(t) === -1 && (s.push(t), e.className = s.join(" ").replace(/^\s+/, "").replace(/\s+$/, ""));
    }
    return st;
  },
  removeClass: function(e, t) {
    if (t)
      if (e.className === t)
        e.removeAttribute("class");
      else {
        var s = e.className.split(/ +/), o = s.indexOf(t);
        o !== -1 && (s.splice(o, 1), e.className = s.join(" "));
      }
    else
      e.className = void 0;
    return st;
  },
  hasClass: function(e, t) {
    return new RegExp("(?:^|\\s+)" + t + "(?:\\s+|$)").test(e.className) || !1;
  },
  getWidth: function(e) {
    var t = getComputedStyle(e);
    return pr(t["border-left-width"]) + pr(t["border-right-width"]) + pr(t["padding-left"]) + pr(t["padding-right"]) + pr(t.width);
  },
  getHeight: function(e) {
    var t = getComputedStyle(e);
    return pr(t["border-top-width"]) + pr(t["border-bottom-width"]) + pr(t["padding-top"]) + pr(t["padding-bottom"]) + pr(t.height);
  },
  getOffset: function(e) {
    var t = e, s = { left: 0, top: 0 };
    if (t.offsetParent)
      do
        s.left += t.offsetLeft, s.top += t.offsetTop, t = t.offsetParent;
      while (t);
    return s;
  },
  isActive: function(e) {
    return e === document.activeElement && (e.type || e.href);
  }
}, Jd = function(v) {
  Zr(e, v);
  function e(t, s) {
    rr(this, e);
    var o = Xr(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s)), a = o;
    o.__prev = o.getValue(), o.__checkbox = document.createElement("input"), o.__checkbox.setAttribute("type", "checkbox");
    function c() {
      a.setValue(!a.__prev);
    }
    return st.bind(o.__checkbox, "change", c, !1), o.domElement.appendChild(o.__checkbox), o.updateDisplay(), o;
  }
  return ar(e, [{
    key: "setValue",
    value: function(s) {
      var o = Wr(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, s);
      return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()), this.__prev = this.getValue(), o;
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return this.getValue() === !0 ? (this.__checkbox.setAttribute("checked", "checked"), this.__checkbox.checked = !0, this.__prev = !0) : (this.__checkbox.checked = !1, this.__prev = !1), Wr(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(ca), fw = function(v) {
  Zr(e, v);
  function e(t, s, o) {
    rr(this, e);
    var a = Xr(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s)), c = o, g = a;
    if (a.__select = document.createElement("select"), _t.isArray(c)) {
      var w = {};
      _t.each(c, function(T) {
        w[T] = T;
      }), c = w;
    }
    return _t.each(c, function(T, H) {
      var Y = document.createElement("option");
      Y.innerHTML = H, Y.setAttribute("value", T), g.__select.appendChild(Y);
    }), a.updateDisplay(), st.bind(a.__select, "change", function() {
      var T = this.options[this.selectedIndex].value;
      g.setValue(T);
    }), a.domElement.appendChild(a.__select), a;
  }
  return ar(e, [{
    key: "setValue",
    value: function(s) {
      var o = Wr(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, s);
      return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()), o;
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return st.isActive(this.__select) ? this : (this.__select.value = this.getValue(), Wr(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this));
    }
  }]), e;
}(ca), dw = function(v) {
  Zr(e, v);
  function e(t, s) {
    rr(this, e);
    var o = Xr(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s)), a = o;
    function c() {
      a.setValue(a.__input.value);
    }
    function g() {
      a.__onFinishChange && a.__onFinishChange.call(a, a.getValue());
    }
    return o.__input = document.createElement("input"), o.__input.setAttribute("type", "text"), st.bind(o.__input, "keyup", c), st.bind(o.__input, "change", c), st.bind(o.__input, "blur", g), st.bind(o.__input, "keydown", function(w) {
      w.keyCode === 13 && this.blur();
    }), o.updateDisplay(), o.domElement.appendChild(o.__input), o;
  }
  return ar(e, [{
    key: "updateDisplay",
    value: function() {
      return st.isActive(this.__input) || (this.__input.value = this.getValue()), Wr(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(ca);
function Nf(v) {
  var e = v.toString();
  return e.indexOf(".") > -1 ? e.length - e.indexOf(".") - 1 : 0;
}
var $d = function(v) {
  Zr(e, v);
  function e(t, s, o) {
    rr(this, e);
    var a = Xr(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s)), c = o || {};
    return a.__min = c.min, a.__max = c.max, a.__step = c.step, _t.isUndefined(a.__step) ? a.initialValue === 0 ? a.__impliedStep = 1 : a.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(a.initialValue)) / Math.LN10)) / 10 : a.__impliedStep = a.__step, a.__precision = Nf(a.__impliedStep), a;
  }
  return ar(e, [{
    key: "setValue",
    value: function(s) {
      var o = s;
      return this.__min !== void 0 && o < this.__min ? o = this.__min : this.__max !== void 0 && o > this.__max && (o = this.__max), this.__step !== void 0 && o % this.__step !== 0 && (o = Math.round(o / this.__step) * this.__step), Wr(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, o);
    }
  }, {
    key: "min",
    value: function(s) {
      return this.__min = s, this;
    }
  }, {
    key: "max",
    value: function(s) {
      return this.__max = s, this;
    }
  }, {
    key: "step",
    value: function(s) {
      return this.__step = s, this.__impliedStep = s, this.__precision = Nf(s), this;
    }
  }]), e;
}(ca);
function gw(v, e) {
  var t = Math.pow(10, e);
  return Math.round(v * t) / t;
}
var ml = function(v) {
  Zr(e, v);
  function e(t, s, o) {
    rr(this, e);
    var a = Xr(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s, o));
    a.__truncationSuspended = !1;
    var c = a, g = void 0;
    function w() {
      var he = parseFloat(c.__input.value);
      _t.isNaN(he) || c.setValue(he);
    }
    function T() {
      c.__onFinishChange && c.__onFinishChange.call(c, c.getValue());
    }
    function H() {
      T();
    }
    function Y(he) {
      var ne = g - he.clientY;
      c.setValue(c.getValue() + ne * c.__impliedStep), g = he.clientY;
    }
    function ee() {
      st.unbind(window, "mousemove", Y), st.unbind(window, "mouseup", ee), T();
    }
    function z(he) {
      st.bind(window, "mousemove", Y), st.bind(window, "mouseup", ee), g = he.clientY;
    }
    return a.__input = document.createElement("input"), a.__input.setAttribute("type", "text"), st.bind(a.__input, "change", w), st.bind(a.__input, "blur", H), st.bind(a.__input, "mousedown", z), st.bind(a.__input, "keydown", function(he) {
      he.keyCode === 13 && (c.__truncationSuspended = !0, this.blur(), c.__truncationSuspended = !1, T());
    }), a.updateDisplay(), a.domElement.appendChild(a.__input), a;
  }
  return ar(e, [{
    key: "updateDisplay",
    value: function() {
      return this.__input.value = this.__truncationSuspended ? this.getValue() : gw(this.getValue(), this.__precision), Wr(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}($d);
function Rf(v, e, t, s, o) {
  return s + (o - s) * ((v - e) / (t - e));
}
var Hh = function(v) {
  Zr(e, v);
  function e(t, s, o, a, c) {
    rr(this, e);
    var g = Xr(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s, { min: o, max: a, step: c })), w = g;
    g.__background = document.createElement("div"), g.__foreground = document.createElement("div"), st.bind(g.__background, "mousedown", T), st.bind(g.__background, "touchstart", ee), st.addClass(g.__background, "slider"), st.addClass(g.__foreground, "slider-fg");
    function T(ne) {
      document.activeElement.blur(), st.bind(window, "mousemove", H), st.bind(window, "mouseup", Y), H(ne);
    }
    function H(ne) {
      ne.preventDefault();
      var ye = w.__background.getBoundingClientRect();
      return w.setValue(Rf(ne.clientX, ye.left, ye.right, w.__min, w.__max)), !1;
    }
    function Y() {
      st.unbind(window, "mousemove", H), st.unbind(window, "mouseup", Y), w.__onFinishChange && w.__onFinishChange.call(w, w.getValue());
    }
    function ee(ne) {
      ne.touches.length === 1 && (st.bind(window, "touchmove", z), st.bind(window, "touchend", he), z(ne));
    }
    function z(ne) {
      var ye = ne.touches[0].clientX, se = w.__background.getBoundingClientRect();
      w.setValue(Rf(ye, se.left, se.right, w.__min, w.__max));
    }
    function he() {
      st.unbind(window, "touchmove", z), st.unbind(window, "touchend", he), w.__onFinishChange && w.__onFinishChange.call(w, w.getValue());
    }
    return g.updateDisplay(), g.__background.appendChild(g.__foreground), g.domElement.appendChild(g.__background), g;
  }
  return ar(e, [{
    key: "updateDisplay",
    value: function() {
      var s = (this.getValue() - this.__min) / (this.__max - this.__min);
      return this.__foreground.style.width = s * 100 + "%", Wr(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}($d), Qd = function(v) {
  Zr(e, v);
  function e(t, s, o) {
    rr(this, e);
    var a = Xr(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s)), c = a;
    return a.__button = document.createElement("div"), a.__button.innerHTML = o === void 0 ? "Fire" : o, st.bind(a.__button, "click", function(g) {
      return g.preventDefault(), c.fire(), !1;
    }), st.addClass(a.__button, "button"), a.domElement.appendChild(a.__button), a;
  }
  return ar(e, [{
    key: "fire",
    value: function() {
      this.__onChange && this.__onChange.call(this), this.getValue().call(this.object), this.__onFinishChange && this.__onFinishChange.call(this, this.getValue());
    }
  }]), e;
}(ca), Yh = function(v) {
  Zr(e, v);
  function e(t, s) {
    rr(this, e);
    var o = Xr(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
    o.__color = new jn(o.getValue()), o.__temp = new jn(0);
    var a = o;
    o.domElement = document.createElement("div"), st.makeSelectable(o.domElement, !1), o.__selector = document.createElement("div"), o.__selector.className = "selector", o.__saturation_field = document.createElement("div"), o.__saturation_field.className = "saturation-field", o.__field_knob = document.createElement("div"), o.__field_knob.className = "field-knob", o.__field_knob_border = "2px solid ", o.__hue_knob = document.createElement("div"), o.__hue_knob.className = "hue-knob", o.__hue_field = document.createElement("div"), o.__hue_field.className = "hue-field", o.__input = document.createElement("input"), o.__input.type = "text", o.__input_textShadow = "0 1px 1px ", st.bind(o.__input, "keydown", function(ne) {
      ne.keyCode === 13 && Y.call(this);
    }), st.bind(o.__input, "blur", Y), st.bind(o.__selector, "mousedown", function() {
      st.addClass(this, "drag").bind(window, "mouseup", function() {
        st.removeClass(a.__selector, "drag");
      });
    }), st.bind(o.__selector, "touchstart", function() {
      st.addClass(this, "drag").bind(window, "touchend", function() {
        st.removeClass(a.__selector, "drag");
      });
    });
    var c = document.createElement("div");
    _t.extend(o.__selector.style, {
      width: "122px",
      height: "102px",
      padding: "3px",
      backgroundColor: "#222",
      boxShadow: "0px 1px 3px rgba(0,0,0,0.3)"
    }), _t.extend(o.__field_knob.style, {
      position: "absolute",
      width: "12px",
      height: "12px",
      border: o.__field_knob_border + (o.__color.v < 0.5 ? "#fff" : "#000"),
      boxShadow: "0px 1px 3px rgba(0,0,0,0.5)",
      borderRadius: "12px",
      zIndex: 1
    }), _t.extend(o.__hue_knob.style, {
      position: "absolute",
      width: "15px",
      height: "2px",
      borderRight: "4px solid #fff",
      zIndex: 1
    }), _t.extend(o.__saturation_field.style, {
      width: "100px",
      height: "100px",
      border: "1px solid #555",
      marginRight: "3px",
      display: "inline-block",
      cursor: "pointer"
    }), _t.extend(c.style, {
      width: "100%",
      height: "100%",
      background: "none"
    }), Df(c, "top", "rgba(0,0,0,0)", "#000"), _t.extend(o.__hue_field.style, {
      width: "15px",
      height: "100px",
      border: "1px solid #555",
      cursor: "ns-resize",
      position: "absolute",
      top: "3px",
      right: "3px"
    }), _w(o.__hue_field), _t.extend(o.__input.style, {
      outline: "none",
      textAlign: "center",
      color: "#fff",
      border: 0,
      fontWeight: "bold",
      textShadow: o.__input_textShadow + "rgba(0,0,0,0.7)"
    }), st.bind(o.__saturation_field, "mousedown", g), st.bind(o.__saturation_field, "touchstart", g), st.bind(o.__field_knob, "mousedown", g), st.bind(o.__field_knob, "touchstart", g), st.bind(o.__hue_field, "mousedown", w), st.bind(o.__hue_field, "touchstart", w);
    function g(ne) {
      z(ne), st.bind(window, "mousemove", z), st.bind(window, "touchmove", z), st.bind(window, "mouseup", T), st.bind(window, "touchend", T);
    }
    function w(ne) {
      he(ne), st.bind(window, "mousemove", he), st.bind(window, "touchmove", he), st.bind(window, "mouseup", H), st.bind(window, "touchend", H);
    }
    function T() {
      st.unbind(window, "mousemove", z), st.unbind(window, "touchmove", z), st.unbind(window, "mouseup", T), st.unbind(window, "touchend", T), ee();
    }
    function H() {
      st.unbind(window, "mousemove", he), st.unbind(window, "touchmove", he), st.unbind(window, "mouseup", H), st.unbind(window, "touchend", H), ee();
    }
    function Y() {
      var ne = Vh(this.value);
      ne !== !1 ? (a.__color.__state = ne, a.setValue(a.__color.toOriginal())) : this.value = a.__color.toString();
    }
    function ee() {
      a.__onFinishChange && a.__onFinishChange.call(a, a.__color.toOriginal());
    }
    o.__saturation_field.appendChild(c), o.__selector.appendChild(o.__field_knob), o.__selector.appendChild(o.__saturation_field), o.__selector.appendChild(o.__hue_field), o.__hue_field.appendChild(o.__hue_knob), o.domElement.appendChild(o.__input), o.domElement.appendChild(o.__selector), o.updateDisplay();
    function z(ne) {
      ne.type.indexOf("touch") === -1 && ne.preventDefault();
      var ye = a.__saturation_field.getBoundingClientRect(), se = ne.touches && ne.touches[0] || ne, _e = se.clientX, ue = se.clientY, xe = (_e - ye.left) / (ye.right - ye.left), Ee = 1 - (ue - ye.top) / (ye.bottom - ye.top);
      return Ee > 1 ? Ee = 1 : Ee < 0 && (Ee = 0), xe > 1 ? xe = 1 : xe < 0 && (xe = 0), a.__color.v = Ee, a.__color.s = xe, a.setValue(a.__color.toOriginal()), !1;
    }
    function he(ne) {
      ne.type.indexOf("touch") === -1 && ne.preventDefault();
      var ye = a.__hue_field.getBoundingClientRect(), se = ne.touches && ne.touches[0] || ne, _e = se.clientY, ue = 1 - (_e - ye.top) / (ye.bottom - ye.top);
      return ue > 1 ? ue = 1 : ue < 0 && (ue = 0), a.__color.h = ue * 360, a.setValue(a.__color.toOriginal()), !1;
    }
    return o;
  }
  return ar(e, [{
    key: "updateDisplay",
    value: function() {
      var s = Vh(this.getValue());
      if (s !== !1) {
        var o = !1;
        _t.each(jn.COMPONENTS, function(g) {
          if (!_t.isUndefined(s[g]) && !_t.isUndefined(this.__color.__state[g]) && s[g] !== this.__color.__state[g])
            return o = !0, {};
        }, this), o && _t.extend(this.__color.__state, s);
      }
      _t.extend(this.__temp.__state, this.__color.__state), this.__temp.a = 1;
      var a = this.__color.v < 0.5 || this.__color.s > 0.5 ? 255 : 0, c = 255 - a;
      _t.extend(this.__field_knob.style, {
        marginLeft: 100 * this.__color.s - 7 + "px",
        marginTop: 100 * (1 - this.__color.v) - 7 + "px",
        backgroundColor: this.__temp.toHexString(),
        border: this.__field_knob_border + "rgb(" + a + "," + a + "," + a + ")"
      }), this.__hue_knob.style.marginTop = (1 - this.__color.h / 360) * 100 + "px", this.__temp.s = 1, this.__temp.v = 1, Df(this.__saturation_field, "left", "#fff", this.__temp.toHexString()), this.__input.value = this.__color.toString(), _t.extend(this.__input.style, {
        backgroundColor: this.__color.toHexString(),
        color: "rgb(" + a + "," + a + "," + a + ")",
        textShadow: this.__input_textShadow + "rgba(" + c + "," + c + "," + c + ",.7)"
      });
    }
  }]), e;
}(ca), pw = ["-moz-", "-o-", "-webkit-", "-ms-", ""];
function Df(v, e, t, s) {
  v.style.background = "", _t.each(pw, function(o) {
    v.style.cssText += "background: " + o + "linear-gradient(" + e + ", " + t + " 0%, " + s + " 100%); ";
  });
}
function _w(v) {
  v.style.background = "", v.style.cssText += "background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);", v.style.cssText += "background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", v.style.cssText += "background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", v.style.cssText += "background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", v.style.cssText += "background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);";
}
var mw = {
  load: function(e, t) {
    var s = t || document, o = s.createElement("link");
    o.type = "text/css", o.rel = "stylesheet", o.href = e, s.getElementsByTagName("head")[0].appendChild(o);
  },
  inject: function(e, t) {
    var s = t || document, o = document.createElement("style");
    o.type = "text/css", o.innerHTML = e;
    var a = s.getElementsByTagName("head")[0];
    try {
      a.appendChild(o);
    } catch {
    }
  }
}, vw = `<div id="dg-save" class="dg dialogue">

  Here's the new load parameter for your <code>GUI</code>'s constructor:

  <textarea id="dg-new-constructor"></textarea>

  <div id="dg-save-locally">

    <input id="dg-local-storage" type="checkbox"/> Automatically save
    values to <code>localStorage</code> on exit.

    <div id="dg-local-explain">The values saved to <code>localStorage</code> will
      override those passed to <code>dat.GUI</code>'s constructor. This makes it
      easier to work incrementally, but <code>localStorage</code> is fragile,
      and your friends may not see the same values you do.

    </div>

  </div>

</div>`, yw = function(e, t) {
  var s = e[t];
  return _t.isArray(arguments[2]) || _t.isObject(arguments[2]) ? new fw(e, t, arguments[2]) : _t.isNumber(s) ? _t.isNumber(arguments[2]) && _t.isNumber(arguments[3]) ? _t.isNumber(arguments[4]) ? new Hh(e, t, arguments[2], arguments[3], arguments[4]) : new Hh(e, t, arguments[2], arguments[3]) : _t.isNumber(arguments[4]) ? new ml(e, t, { min: arguments[2], max: arguments[3], step: arguments[4] }) : new ml(e, t, { min: arguments[2], max: arguments[3] }) : _t.isString(s) ? new dw(e, t) : _t.isFunction(s) ? new Qd(e, t, "") : _t.isBoolean(s) ? new Jd(e, t) : null;
};
function bw(v) {
  setTimeout(v, 1e3 / 60);
}
var xw = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || bw, ww = function() {
  function v() {
    rr(this, v), this.backgroundElement = document.createElement("div"), _t.extend(this.backgroundElement.style, {
      backgroundColor: "rgba(0,0,0,0.8)",
      top: 0,
      left: 0,
      display: "none",
      zIndex: "1000",
      opacity: 0,
      WebkitTransition: "opacity 0.2s linear",
      transition: "opacity 0.2s linear"
    }), st.makeFullscreen(this.backgroundElement), this.backgroundElement.style.position = "fixed", this.domElement = document.createElement("div"), _t.extend(this.domElement.style, {
      position: "fixed",
      display: "none",
      zIndex: "1001",
      opacity: 0,
      WebkitTransition: "-webkit-transform 0.2s ease-out, opacity 0.2s linear",
      transition: "transform 0.2s ease-out, opacity 0.2s linear"
    }), document.body.appendChild(this.backgroundElement), document.body.appendChild(this.domElement);
    var e = this;
    st.bind(this.backgroundElement, "click", function() {
      e.hide();
    });
  }
  return ar(v, [{
    key: "show",
    value: function() {
      var t = this;
      this.backgroundElement.style.display = "block", this.domElement.style.display = "block", this.domElement.style.opacity = 0, this.domElement.style.webkitTransform = "scale(1.1)", this.layout(), _t.defer(function() {
        t.backgroundElement.style.opacity = 1, t.domElement.style.opacity = 1, t.domElement.style.webkitTransform = "scale(1)";
      });
    }
  }, {
    key: "hide",
    value: function() {
      var t = this, s = function o() {
        t.domElement.style.display = "none", t.backgroundElement.style.display = "none", st.unbind(t.domElement, "webkitTransitionEnd", o), st.unbind(t.domElement, "transitionend", o), st.unbind(t.domElement, "oTransitionEnd", o);
      };
      st.bind(this.domElement, "webkitTransitionEnd", s), st.bind(this.domElement, "transitionend", s), st.bind(this.domElement, "oTransitionEnd", s), this.backgroundElement.style.opacity = 0, this.domElement.style.opacity = 0, this.domElement.style.webkitTransform = "scale(1.1)";
    }
  }, {
    key: "layout",
    value: function() {
      this.domElement.style.left = window.innerWidth / 2 - st.getWidth(this.domElement) / 2 + "px", this.domElement.style.top = window.innerHeight / 2 - st.getHeight(this.domElement) / 2 + "px";
    }
  }]), v;
}(), Sw = ow(`.dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1 !important}.dg.main:hover .close-button,.dg.main .close-button.drag{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear;border:0;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button.close-top{position:relative}.dg.main .close-button.close-bottom{position:absolute}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-y:visible}.dg.a.has-save>ul.close-top{margin-top:0}.dg.a.has-save>ul.close-bottom{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{top:0;z-index:1002}.dg.a .save-row.close-top{position:relative}.dg.a .save-row.close-bottom{position:fixed}.dg li{-webkit-transition:height .1s ease-out;-o-transition:height .1s ease-out;-moz-transition:height .1s ease-out;transition:height .1s ease-out;-webkit-transition:overflow .1s linear;-o-transition:overflow .1s linear;-moz-transition:overflow .1s linear;transition:overflow .1s linear}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid rgba(0,0,0,0)}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px;overflow:hidden}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .cr.function .property-name{width:100%}.dg .c{float:left;width:60%;position:relative}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:7px}.dg .c select{margin-top:5px}.dg .cr.function,.dg .cr.function .property-name,.dg .cr.function *,.dg .cr.boolean,.dg .cr.boolean *{cursor:pointer}.dg .cr.color{overflow:visible}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0px 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco, monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px 'Lucida Grande', sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px 4px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid rgba(255,255,255,0.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2FA1D6}.dg .cr.number input[type=text]{color:#2FA1D6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.function:hover,.dg .cr.boolean:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2FA1D6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}
`);
mw.inject(Sw);
var zf = "dg", Ff = 72, Uf = 20, ho = "Default", Xa = function() {
  try {
    return !!window.localStorage;
  } catch {
    return !1;
  }
}(), eo = void 0, Vf = !0, wa = void 0, Lh = !1, eg = [], rn = function v(e) {
  var t = this, s = e || {};
  this.domElement = document.createElement("div"), this.__ul = document.createElement("ul"), this.domElement.appendChild(this.__ul), st.addClass(this.domElement, zf), this.__folders = {}, this.__controllers = [], this.__rememberedObjects = [], this.__rememberedObjectIndecesToControllers = [], this.__listening = [], s = _t.defaults(s, {
    closeOnTop: !1,
    autoPlace: !0,
    width: v.DEFAULT_WIDTH
  }), s = _t.defaults(s, {
    resizable: s.autoPlace,
    hideable: s.autoPlace
  }), _t.isUndefined(s.load) ? s.load = { preset: ho } : s.preset && (s.load.preset = s.preset), _t.isUndefined(s.parent) && s.hideable && eg.push(this), s.resizable = _t.isUndefined(s.parent) && s.resizable, s.autoPlace && _t.isUndefined(s.scrollable) && (s.scrollable = !0);
  var o = Xa && localStorage.getItem(Sa(this, "isLocal")) === "true", a = void 0, c = void 0;
  if (Object.defineProperties(
    this,
    {
      parent: {
        get: function() {
          return s.parent;
        }
      },
      scrollable: {
        get: function() {
          return s.scrollable;
        }
      },
      autoPlace: {
        get: function() {
          return s.autoPlace;
        }
      },
      closeOnTop: {
        get: function() {
          return s.closeOnTop;
        }
      },
      preset: {
        get: function() {
          return t.parent ? t.getRoot().preset : s.load.preset;
        },
        set: function(ee) {
          t.parent ? t.getRoot().preset = ee : s.load.preset = ee, Tw(this), t.revert();
        }
      },
      width: {
        get: function() {
          return s.width;
        },
        set: function(ee) {
          s.width = ee, Wh(t, ee);
        }
      },
      name: {
        get: function() {
          return s.name;
        },
        set: function(ee) {
          s.name = ee, c && (c.innerHTML = s.name);
        }
      },
      closed: {
        get: function() {
          return s.closed;
        },
        set: function(ee) {
          s.closed = ee, s.closed ? st.addClass(t.__ul, v.CLASS_CLOSED) : st.removeClass(t.__ul, v.CLASS_CLOSED), this.onResize(), t.__closeButton && (t.__closeButton.innerHTML = ee ? v.TEXT_OPEN : v.TEXT_CLOSED);
        }
      },
      load: {
        get: function() {
          return s.load;
        }
      },
      useLocalStorage: {
        get: function() {
          return o;
        },
        set: function(ee) {
          Xa && (o = ee, ee ? st.bind(window, "unload", a) : st.unbind(window, "unload", a), localStorage.setItem(Sa(t, "isLocal"), ee));
        }
      }
    }
  ), _t.isUndefined(s.parent)) {
    if (this.closed = s.closed || !1, st.addClass(this.domElement, v.CLASS_MAIN), st.makeSelectable(this.domElement, !1), Xa && o) {
      t.useLocalStorage = !0;
      var g = localStorage.getItem(Sa(this, "gui"));
      g && (s.load = JSON.parse(g));
    }
    this.__closeButton = document.createElement("div"), this.__closeButton.innerHTML = v.TEXT_CLOSED, st.addClass(this.__closeButton, v.CLASS_CLOSE_BUTTON), s.closeOnTop ? (st.addClass(this.__closeButton, v.CLASS_CLOSE_TOP), this.domElement.insertBefore(this.__closeButton, this.domElement.childNodes[0])) : (st.addClass(this.__closeButton, v.CLASS_CLOSE_BOTTOM), this.domElement.appendChild(this.__closeButton)), st.bind(this.__closeButton, "click", function() {
      t.closed = !t.closed;
    });
  } else {
    s.closed === void 0 && (s.closed = !0);
    var w = document.createTextNode(s.name);
    st.addClass(w, "controller-name"), c = gu(t, w);
    var T = function(ee) {
      return ee.preventDefault(), t.closed = !t.closed, !1;
    };
    st.addClass(this.__ul, v.CLASS_CLOSED), st.addClass(c, "title"), st.bind(c, "click", T), s.closed || (this.closed = !1);
  }
  s.autoPlace && (_t.isUndefined(s.parent) && (Vf && (wa = document.createElement("div"), st.addClass(wa, zf), st.addClass(wa, v.CLASS_AUTO_PLACE_CONTAINER), document.body.appendChild(wa), Vf = !1), wa.appendChild(this.domElement), st.addClass(this.domElement, v.CLASS_AUTO_PLACE)), this.parent || Wh(t, s.width)), this.__resizeHandler = function() {
    t.onResizeDebounced();
  }, st.bind(window, "resize", this.__resizeHandler), st.bind(this.__ul, "webkitTransitionEnd", this.__resizeHandler), st.bind(this.__ul, "transitionend", this.__resizeHandler), st.bind(this.__ul, "oTransitionEnd", this.__resizeHandler), this.onResize(), s.resizable && Aw(this), a = function() {
    Xa && localStorage.getItem(Sa(t, "isLocal")) === "true" && localStorage.setItem(Sa(t, "gui"), JSON.stringify(t.getSaveObject()));
  }, this.saveToLocalStorageIfPossible = a;
  function H() {
    var Y = t.getRoot();
    Y.width += 1, _t.defer(function() {
      Y.width -= 1;
    });
  }
  s.parent || H();
};
rn.toggleHide = function() {
  Lh = !Lh, _t.each(eg, function(v) {
    v.domElement.style.display = Lh ? "none" : "";
  });
};
rn.CLASS_AUTO_PLACE = "a";
rn.CLASS_AUTO_PLACE_CONTAINER = "ac";
rn.CLASS_MAIN = "main";
rn.CLASS_CONTROLLER_ROW = "cr";
rn.CLASS_TOO_TALL = "taller-than-window";
rn.CLASS_CLOSED = "closed";
rn.CLASS_CLOSE_BUTTON = "close-button";
rn.CLASS_CLOSE_TOP = "close-top";
rn.CLASS_CLOSE_BOTTOM = "close-bottom";
rn.CLASS_DRAG = "drag";
rn.DEFAULT_WIDTH = 245;
rn.TEXT_CLOSED = "Close Controls";
rn.TEXT_OPEN = "Open Controls";
rn._keydownHandler = function(v) {
  document.activeElement.type !== "text" && (v.which === Ff || v.keyCode === Ff) && rn.toggleHide();
};
st.bind(window, "keydown", rn._keydownHandler, !1);
_t.extend(
  rn.prototype,
  {
    add: function(e, t) {
      return to(this, e, t, {
        factoryArgs: Array.prototype.slice.call(arguments, 2)
      });
    },
    addColor: function(e, t) {
      return to(this, e, t, {
        color: !0
      });
    },
    remove: function(e) {
      this.__ul.removeChild(e.__li), this.__controllers.splice(this.__controllers.indexOf(e), 1);
      var t = this;
      _t.defer(function() {
        t.onResize();
      });
    },
    destroy: function() {
      if (this.parent)
        throw new Error("Only the root GUI should be removed with .destroy(). For subfolders, use gui.removeFolder(folder) instead.");
      this.autoPlace && wa.removeChild(this.domElement);
      var e = this;
      _t.each(this.__folders, function(t) {
        e.removeFolder(t);
      }), st.unbind(window, "keydown", rn._keydownHandler, !1), Hf(this);
    },
    addFolder: function(e) {
      if (this.__folders[e] !== void 0)
        throw new Error('You already have a folder in this GUI by the name "' + e + '"');
      var t = { name: e, parent: this };
      t.autoPlace = this.autoPlace, this.load && this.load.folders && this.load.folders[e] && (t.closed = this.load.folders[e].closed, t.load = this.load.folders[e]);
      var s = new rn(t);
      this.__folders[e] = s;
      var o = gu(this, s.domElement);
      return st.addClass(o, "folder"), s;
    },
    removeFolder: function(e) {
      this.__ul.removeChild(e.domElement.parentElement), delete this.__folders[e.name], this.load && this.load.folders && this.load.folders[e.name] && delete this.load.folders[e.name], Hf(e);
      var t = this;
      _t.each(e.__folders, function(s) {
        e.removeFolder(s);
      }), _t.defer(function() {
        t.onResize();
      });
    },
    open: function() {
      this.closed = !1;
    },
    close: function() {
      this.closed = !0;
    },
    hide: function() {
      this.domElement.style.display = "none";
    },
    show: function() {
      this.domElement.style.display = "";
    },
    onResize: function() {
      var e = this.getRoot();
      if (e.scrollable) {
        var t = st.getOffset(e.__ul).top, s = 0;
        _t.each(e.__ul.childNodes, function(o) {
          e.autoPlace && o === e.__save_row || (s += st.getHeight(o));
        }), window.innerHeight - t - Uf < s ? (st.addClass(e.domElement, rn.CLASS_TOO_TALL), e.__ul.style.height = window.innerHeight - t - Uf + "px") : (st.removeClass(e.domElement, rn.CLASS_TOO_TALL), e.__ul.style.height = "auto");
      }
      e.__resize_handle && _t.defer(function() {
        e.__resize_handle.style.height = e.__ul.offsetHeight + "px";
      }), e.__closeButton && (e.__closeButton.style.width = e.width + "px");
    },
    onResizeDebounced: _t.debounce(function() {
      this.onResize();
    }, 50),
    remember: function() {
      if (_t.isUndefined(eo) && (eo = new ww(), eo.domElement.innerHTML = vw), this.parent)
        throw new Error("You can only call remember on a top level GUI.");
      var e = this;
      _t.each(Array.prototype.slice.call(arguments), function(t) {
        e.__rememberedObjects.length === 0 && Cw(e), e.__rememberedObjects.indexOf(t) === -1 && e.__rememberedObjects.push(t);
      }), this.autoPlace && Wh(this, this.width);
    },
    getRoot: function() {
      for (var e = this; e.parent; )
        e = e.parent;
      return e;
    },
    getSaveObject: function() {
      var e = this.load;
      return e.closed = this.closed, this.__rememberedObjects.length > 0 && (e.preset = this.preset, e.remembered || (e.remembered = {}), e.remembered[this.preset] = el(this)), e.folders = {}, _t.each(this.__folders, function(t, s) {
        e.folders[s] = t.getSaveObject();
      }), e;
    },
    save: function() {
      this.load.remembered || (this.load.remembered = {}), this.load.remembered[this.preset] = el(this), Gh(this, !1), this.saveToLocalStorageIfPossible();
    },
    saveAs: function(e) {
      this.load.remembered || (this.load.remembered = {}, this.load.remembered[ho] = el(this, !0)), this.load.remembered[e] = el(this), this.preset = e, jh(this, e, !0), this.saveToLocalStorageIfPossible();
    },
    revert: function(e) {
      _t.each(this.__controllers, function(t) {
        this.getRoot().load.remembered ? tg(e || this.getRoot(), t) : t.setValue(t.initialValue), t.__onFinishChange && t.__onFinishChange.call(t, t.getValue());
      }, this), _t.each(this.__folders, function(t) {
        t.revert(t);
      }), e || Gh(this.getRoot(), !1);
    },
    listen: function(e) {
      var t = this.__listening.length === 0;
      this.__listening.push(e), t && ig(this.__listening);
    },
    updateDisplay: function() {
      _t.each(this.__controllers, function(e) {
        e.updateDisplay();
      }), _t.each(this.__folders, function(e) {
        e.updateDisplay();
      });
    }
  }
);
function gu(v, e, t) {
  var s = document.createElement("li");
  return e && s.appendChild(e), t ? v.__ul.insertBefore(s, t) : v.__ul.appendChild(s), v.onResize(), s;
}
function Hf(v) {
  st.unbind(window, "resize", v.__resizeHandler), v.saveToLocalStorageIfPossible && st.unbind(window, "unload", v.saveToLocalStorageIfPossible);
}
function Gh(v, e) {
  var t = v.__preset_select[v.__preset_select.selectedIndex];
  e ? t.innerHTML = t.value + "*" : t.innerHTML = t.value;
}
function Mw(v, e, t) {
  if (t.__li = e, t.__gui = v, _t.extend(t, {
    options: function(c) {
      if (arguments.length > 1) {
        var g = t.__li.nextElementSibling;
        return t.remove(), to(v, t.object, t.property, {
          before: g,
          factoryArgs: [_t.toArray(arguments)]
        });
      }
      if (_t.isArray(c) || _t.isObject(c)) {
        var w = t.__li.nextElementSibling;
        return t.remove(), to(v, t.object, t.property, {
          before: w,
          factoryArgs: [c]
        });
      }
    },
    name: function(c) {
      return t.__li.firstElementChild.firstElementChild.innerHTML = c, t;
    },
    listen: function() {
      return t.__gui.listen(t), t;
    },
    remove: function() {
      return t.__gui.remove(t), t;
    }
  }), t instanceof Hh) {
    var s = new ml(t.object, t.property, { min: t.__min, max: t.__max, step: t.__step });
    _t.each(["updateDisplay", "onChange", "onFinishChange", "step", "min", "max"], function(a) {
      var c = t[a], g = s[a];
      t[a] = s[a] = function() {
        var w = Array.prototype.slice.call(arguments);
        return g.apply(s, w), c.apply(t, w);
      };
    }), st.addClass(e, "has-slider"), t.domElement.insertBefore(s.domElement, t.domElement.firstElementChild);
  } else if (t instanceof ml) {
    var o = function(c) {
      if (_t.isNumber(t.__min) && _t.isNumber(t.__max)) {
        var g = t.__li.firstElementChild.firstElementChild.innerHTML, w = t.__gui.__listening.indexOf(t) > -1;
        t.remove();
        var T = to(v, t.object, t.property, {
          before: t.__li.nextElementSibling,
          factoryArgs: [t.__min, t.__max, t.__step]
        });
        return T.name(g), w && T.listen(), T;
      }
      return c;
    };
    t.min = _t.compose(o, t.min), t.max = _t.compose(o, t.max);
  } else
    t instanceof Jd ? (st.bind(e, "click", function() {
      st.fakeEvent(t.__checkbox, "click");
    }), st.bind(t.__checkbox, "click", function(a) {
      a.stopPropagation();
    })) : t instanceof Qd ? (st.bind(e, "click", function() {
      st.fakeEvent(t.__button, "click");
    }), st.bind(e, "mouseover", function() {
      st.addClass(t.__button, "hover");
    }), st.bind(e, "mouseout", function() {
      st.removeClass(t.__button, "hover");
    })) : t instanceof Yh && (st.addClass(e, "color"), t.updateDisplay = _t.compose(function(a) {
      return e.style.borderLeftColor = t.__color.toString(), a;
    }, t.updateDisplay), t.updateDisplay());
  t.setValue = _t.compose(function(a) {
    return v.getRoot().__preset_select && t.isModified() && Gh(v.getRoot(), !0), a;
  }, t.setValue);
}
function tg(v, e) {
  var t = v.getRoot(), s = t.__rememberedObjects.indexOf(e.object);
  if (s !== -1) {
    var o = t.__rememberedObjectIndecesToControllers[s];
    if (o === void 0 && (o = {}, t.__rememberedObjectIndecesToControllers[s] = o), o[e.property] = e, t.load && t.load.remembered) {
      var a = t.load.remembered, c = void 0;
      if (a[v.preset])
        c = a[v.preset];
      else if (a[ho])
        c = a[ho];
      else
        return;
      if (c[s] && c[s][e.property] !== void 0) {
        var g = c[s][e.property];
        e.initialValue = g, e.setValue(g);
      }
    }
  }
}
function to(v, e, t, s) {
  if (e[t] === void 0)
    throw new Error('Object "' + e + '" has no property "' + t + '"');
  var o = void 0;
  if (s.color)
    o = new Yh(e, t);
  else {
    var a = [e, t].concat(s.factoryArgs);
    o = yw.apply(v, a);
  }
  s.before instanceof ca && (s.before = s.before.__li), tg(v, o), st.addClass(o.domElement, "c");
  var c = document.createElement("span");
  st.addClass(c, "property-name"), c.innerHTML = o.property;
  var g = document.createElement("div");
  g.appendChild(c), g.appendChild(o.domElement);
  var w = gu(v, g, s.before);
  return st.addClass(w, rn.CLASS_CONTROLLER_ROW), o instanceof Yh ? st.addClass(w, "color") : st.addClass(w, hw(o.getValue())), Mw(v, w, o), v.__controllers.push(o), o;
}
function Sa(v, e) {
  return document.location.href + "." + e;
}
function jh(v, e, t) {
  var s = document.createElement("option");
  s.innerHTML = e, s.value = e, v.__preset_select.appendChild(s), t && (v.__preset_select.selectedIndex = v.__preset_select.length - 1);
}
function Yf(v, e) {
  e.style.display = v.useLocalStorage ? "block" : "none";
}
function Cw(v) {
  var e = v.__save_row = document.createElement("li");
  st.addClass(v.domElement, "has-save"), v.__ul.insertBefore(e, v.__ul.firstChild), st.addClass(e, "save-row");
  var t = document.createElement("span");
  t.innerHTML = "&nbsp;", st.addClass(t, "button gears");
  var s = document.createElement("span");
  s.innerHTML = "Save", st.addClass(s, "button"), st.addClass(s, "save");
  var o = document.createElement("span");
  o.innerHTML = "New", st.addClass(o, "button"), st.addClass(o, "save-as");
  var a = document.createElement("span");
  a.innerHTML = "Revert", st.addClass(a, "button"), st.addClass(a, "revert");
  var c = v.__preset_select = document.createElement("select");
  if (v.load && v.load.remembered ? _t.each(v.load.remembered, function(Y, ee) {
    jh(v, ee, ee === v.preset);
  }) : jh(v, ho, !1), st.bind(c, "change", function() {
    for (var Y = 0; Y < v.__preset_select.length; Y++)
      v.__preset_select[Y].innerHTML = v.__preset_select[Y].value;
    v.preset = this.value;
  }), e.appendChild(c), e.appendChild(t), e.appendChild(s), e.appendChild(o), e.appendChild(a), Xa) {
    var g = document.getElementById("dg-local-explain"), w = document.getElementById("dg-local-storage"), T = document.getElementById("dg-save-locally");
    T.style.display = "block", localStorage.getItem(Sa(v, "isLocal")) === "true" && w.setAttribute("checked", "checked"), Yf(v, g), st.bind(w, "change", function() {
      v.useLocalStorage = !v.useLocalStorage, Yf(v, g);
    });
  }
  var H = document.getElementById("dg-new-constructor");
  st.bind(H, "keydown", function(Y) {
    Y.metaKey && (Y.which === 67 || Y.keyCode === 67) && eo.hide();
  }), st.bind(t, "click", function() {
    H.innerHTML = JSON.stringify(v.getSaveObject(), void 0, 2), eo.show(), H.focus(), H.select();
  }), st.bind(s, "click", function() {
    v.save();
  }), st.bind(o, "click", function() {
    var Y = prompt("Enter a new preset name.");
    Y && v.saveAs(Y);
  }), st.bind(a, "click", function() {
    v.revert();
  });
}
function Aw(v) {
  var e = void 0;
  v.__resize_handle = document.createElement("div"), _t.extend(v.__resize_handle.style, {
    width: "6px",
    marginLeft: "-3px",
    height: "200px",
    cursor: "ew-resize",
    position: "absolute"
  });
  function t(a) {
    return a.preventDefault(), v.width += e - a.clientX, v.onResize(), e = a.clientX, !1;
  }
  function s() {
    st.removeClass(v.__closeButton, rn.CLASS_DRAG), st.unbind(window, "mousemove", t), st.unbind(window, "mouseup", s);
  }
  function o(a) {
    return a.preventDefault(), e = a.clientX, st.addClass(v.__closeButton, rn.CLASS_DRAG), st.bind(window, "mousemove", t), st.bind(window, "mouseup", s), !1;
  }
  st.bind(v.__resize_handle, "mousedown", o), st.bind(v.__closeButton, "mousedown", o), v.domElement.insertBefore(v.__resize_handle, v.domElement.firstElementChild);
}
function Wh(v, e) {
  v.domElement.style.width = e + "px", v.__save_row && v.autoPlace && (v.__save_row.style.width = e + "px"), v.__closeButton && (v.__closeButton.style.width = e + "px");
}
function el(v, e) {
  var t = {};
  return _t.each(v.__rememberedObjects, function(s, o) {
    var a = {}, c = v.__rememberedObjectIndecesToControllers[o];
    _t.each(c, function(g, w) {
      a[w] = e ? g.initialValue : g.getValue();
    }), t[o] = a;
  }), t;
}
function Tw(v) {
  for (var e = 0; e < v.__preset_select.length; e++)
    v.__preset_select[e].value === v.preset && (v.__preset_select.selectedIndex = e);
}
function ig(v) {
  v.length !== 0 && xw.call(window, function() {
    ig(v);
  }), _t.each(v, function(e) {
    e.updateDisplay();
  });
}
var Lw = rn;
let Bh = null;
class Bw {
  constructor(e) {
    if (this.debug = null, this.config = null, this.updateConfig = (t) => {
      this.config = t;
    }, Bh)
      return Bh;
    Bh = this, this.config = e, this.init();
  }
  init() {
    if (this.debug)
      return;
    const e = new Lw({ width: 300 });
    let t;
    window.parent !== window ? (t = this.getExportIntegration(), e.add(t, "export").name("Save")) : (t = this.getExportStandalone(), e.add(t, "export").name("Export")), this.debug = e, this.debug.domElement.style.display = "none", new URLSearchParams(window.location.search).get("config") === "true" && (this.debug.open(), this.debug.domElement.style.display = "block");
  }
  getExportIntegration() {
    return {
      export: () => {
        const t = "babylon-customization.json", s = this.exportConfigCustmizations(this.config);
        window.parent.postMessage(
          {
            type: "exportConfig",
            data: {
              filename: t,
              config: s
            }
          },
          "*"
        );
      }
    };
  }
  getExportStandalone() {
    return {
      export: () => {
        const t = "babylon-customization.json", s = JSON.stringify(this.exportConfigCustmizations(this.config));
        let o = document.createElement("a");
        o.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(s)), o.setAttribute("download", t), o.style.display = "none", document.body.appendChild(o), o.click(), document.body.removeChild(o);
      }
    };
  }
  updateDisplay(e) {
    if (e) {
      for (var t in e.__controllers)
        e.__controllers[t].updateDisplay();
      for (var s in e.__folders)
        this.updateDisplay(e.__folders[s]);
    }
  }
  exportConfigCustmizations(e) {
    if (!(!e || !this.debug))
      return e;
  }
  exportCustomProperties(e) {
    return Object.entries(e.__folders).map(([t, s]) => ({
      [t]: this.exportCustomPropertiesProps(s)
    })).reduce((t, s) => ({ ...s, ...t }), {});
  }
  exportCustomPropertiesProps(e) {
    const t = e.__controllers.reduce(
      (o, a) => ({
        ...o,
        [a.property]: a.getValue()
      }),
      {}
    ), s = Object.entries(e.__folders).map(([o, a]) => ({
      [o]: this.exportCustomPropertiesProps(a)
    })).reduce((o, a) => ({ ...a, ...o }), {});
    return {
      ...t,
      ...s
    };
  }
}
class Ew {
  constructor(e, t, s) {
    this.gui = null, this.config = null, this.sceneHelper = null, this.shadowMinZController = null, this.shadowMaxZController = null;
    const o = new Bw(e);
    o.init(), this.gui = o, this.onUpdate = t, this.config = e, this.sceneHelper = s;
  }
  /**
   * The function "setupGui" configures the general, environment, lights, and camera settings based on
   * the provided configuration object, and calls the onUpdate function with the updated configuration.
   * @param {SceneConfig} config - The `config` parameter is an object that contains the initial configuration
   * for the GUI. It may include properties such as general settings, environment settings, lights
   * settings, and camera settings.
   * @param onUpdate - The `onUpdate` parameter is a callback function that will be called whenever
   * there is an update to the configuration. It takes a new configuration object as a parameter
   * (`newConfig: SceneConfig`).
   */
  setupGui(e) {
    if (!this.config)
      return;
    const t = (s) => {
      var o;
      this.onUpdate(s), (o = this.gui) == null || o.updateConfig(s);
    };
    this.configureGeneral(this.config, t), this.configureEnvironment(this.config, t), this.configureLights(this.config, t), this.configureCamera(this.config, t, e), this.configureShadows(this.config, t), this.configureAr(this.config, t), this.configureModel(this.config, t), this.configureAnimations(this.config, t, e);
  }
  configureModel(e, t) {
    var o, a;
    if (!e.model)
      return;
    const s = (a = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : a.addFolder("Model");
    e.model.config || (e.model.config = { doubleSided: !0 }), s == null || s.add(e.model.config, "doubleSided").name("Double Sided").onFinishChange(() => {
      t(e);
    });
  }
  configureShadows(e, t) {
    var a, c, g, w, T, H;
    if (!e.environment || !e.environment.shadows)
      return;
    const s = (c = (a = this.gui) == null ? void 0 : a.debug) == null ? void 0 : c.addFolder("Shadows");
    s == null || s.add(e.environment.shadows, "enableShadows").name("Enable Shadows").onChange(() => {
      t(e);
    }), s == null || s.addColor(e.environment.shadows, "shadowHexColor").name("Hex Color").onChange(() => {
      t(e);
    }), s == null || s.add(e.environment.shadows, "shadowDarkness", 0, 1, 0.1).name("Transparency").onChange(() => {
      t(e);
    }), s == null || s.add(e.environment.shadows, "groundSizeMultiplierWidth", 0, 5, 0.1).name("Ground Width").onChange(() => {
      t(e);
    }), s == null || s.add(e.environment.shadows, "groundSizeMultiplierLength", 0, 5, 0.1).name("Ground Length").onChange(() => {
      t(e);
    }), s == null || s.add(e.environment.shadows, "shadowMapSize", 0, 128, 4).name("Map Size").onChange(() => {
      t(e);
    });
    const o = {
      enableShadowMinZ: !!((w = (g = e == null ? void 0 : e.environment) == null ? void 0 : g.shadows) != null && w.shadowMinZ),
      enableShadowMaxZ: !!((H = (T = e == null ? void 0 : e.environment) == null ? void 0 : T.shadows) != null && H.shadowMaxZ)
    };
    s == null || s.add(o, "enableShadowMinZ").name("Enable starting shadow clipping").onChange(() => {
      o.enableShadowMinZ ? e.environment.shadows.shadowMinZ = 0 : (e.environment.shadows.shadowMinZ = null, t(e)), this.buildShadowZConfig(e, s, t);
    }), s == null || s.add(o, "enableShadowMaxZ").name("Enable ending shadow clipping").onChange(() => {
      o.enableShadowMaxZ ? e.environment.shadows.shadowMaxZ = 0 : (e.environment.shadows.shadowMaxZ = null, t(e)), this.buildShadowZConfig(e, s, t);
    }), s && this.buildShadowZConfig(e, s, t);
  }
  buildShadowZConfig(e, t, s) {
    var o, a, c, g, w, T, H, Y, ee, z;
    ((a = (o = e == null ? void 0 : e.environment) == null ? void 0 : o.shadows) == null ? void 0 : a.shadowMinZ) !== void 0 && ((g = (c = e == null ? void 0 : e.environment) == null ? void 0 : c.shadows) == null ? void 0 : g.shadowMinZ) !== null ? this.shadowMinZController || (this.shadowMinZController = t == null ? void 0 : t.add((w = e == null ? void 0 : e.environment) == null ? void 0 : w.shadows, "shadowMinZ", -50, 0, 1).name("Clipping Start").onChange(() => {
      s(e);
    })) : this.shadowMinZController && (t == null || t.remove(this.shadowMinZController), this.shadowMinZController = null), ((H = (T = e == null ? void 0 : e.environment) == null ? void 0 : T.shadows) == null ? void 0 : H.shadowMaxZ) !== void 0 && ((ee = (Y = e == null ? void 0 : e.environment) == null ? void 0 : Y.shadows) == null ? void 0 : ee.shadowMaxZ) !== null ? this.shadowMaxZController || (this.shadowMaxZController = t == null ? void 0 : t.add((z = e == null ? void 0 : e.environment) == null ? void 0 : z.shadows, "shadowMaxZ", 0, 50, 1).name("Clipping End").onChange(() => {
      s(e);
    })) : this.shadowMaxZController && (t == null || t.remove(this.shadowMaxZController), this.shadowMaxZController = null);
  }
  configureGeneral(e, t) {
    var o, a;
    if (!e.general)
      return;
    const s = (a = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : a.addFolder("General");
    s == null || s.addColor(e.general, "backgroundColor").name("Background Color").onChange(() => {
      t(e);
    }), s == null || s.add(e.general, "removeDefaultBackground").name("Remove Background").onChange(() => {
      t(e);
    }), e.camera && (s == null || s.add(e.camera, "toneMappingEnabled").name("Tone Mapping Enabled").onFinishChange(() => {
      t(e);
    }), s == null || s.add(e.camera, "toneMappingType", {
      Standard: 0,
      AcesToneMapping: 1
    }).name("Tone Mapping Type").onFinishChange(() => {
      var c;
      (c = e == null ? void 0 : e.camera) != null && c.toneMappingType && (e.camera.toneMappingType = Number(e.camera.toneMappingType)), t(e);
    }), this.configureAntialias(s, e, t));
  }
  configureAntialias(e, t, s) {
    if (!e || !t.general)
      return;
    const o = e == null ? void 0 : e.addFolder("Antialias"), a = o == null ? void 0 : o.addFolder("Desktop"), c = o == null ? void 0 : o.addFolder("Mobile"), g = {
      desktop: null,
      mobile: null
    };
    t.general.antialias ? t.general.antialias && t.general.antialias.desktop && !t.general.antialias.mobile && (t.general.antialias.mobile = {
      enabled: t.general.antialias.desktop.enabled,
      inRotationEnabled: t.general.antialias.desktop.inRotationEnabled
    }) : t.general.antialias = {
      desktop: {
        enabled: !0,
        inRotationEnabled: !1
      },
      mobile: {
        enabled: !0,
        inRotationEnabled: !1
      }
    };
    function w(ee, z, he = !0) {
      var _e, ue, xe;
      const ne = (ue = (_e = t.general) == null ? void 0 : _e.antialias) == null ? void 0 : ue[ee];
      if (!ne)
        return;
      const { enabled: ye, inRotationEnabled: se } = ne;
      if (ne.inRotationEnabled = ye ? se : !1, z) {
        const Ee = (xe = z.domElement.parentElement) == null ? void 0 : xe.parentElement;
        Ee && (Ee.style.display = ye ? "" : "none");
      }
      he && s(t);
    }
    function T(ee, z) {
      var ye, se;
      const he = (se = (ye = t.general) == null ? void 0 : ye.antialias) == null ? void 0 : se[z];
      if (!he)
        return null;
      ee == null || ee.add(he, "enabled").name("Enabled").onChange(() => {
        w(z, g[z] ?? void 0);
      });
      const ne = ee == null ? void 0 : ee.add(he, "inRotationEnabled").name("In Rotation Enabled").listen().onChange(() => s(t));
      return g[z] = ne, ne;
    }
    const H = T(a, "desktop"), Y = T(c, "mobile");
    w("desktop", H ?? void 0, !1), w("mobile", Y ?? void 0, !1);
  }
  configureAr(e, t) {
    var H, Y, ee, z, he;
    if (!e.general || !e.general.meshSize)
      return;
    const s = (Y = (H = this.gui) == null ? void 0 : H.debug) == null ? void 0 : Y.addFolder("Augmented Reality");
    s == null || s.add(e.general, "arEnabled").name("Enabled").onChange(() => {
      t(e);
    }), s == null || s.add({ enabled: e.general.arAnchor === "wall" }, "enabled").name("Enable wall placement").onChange((ne) => {
      e.general && (e.general.arAnchor = ne ? "wall" : null), t(e);
    }), s == null || s.add({ enabled: e.general.arScale ?? !1 }, "enabled").name("Resizable in AR").onChange((ne) => {
      e.general && (e.general.arScale = ne), t(e);
    }), s == null || s.add({ enabled: e.general.arOnTheFly }, "enabled").name("Faster AR Conversion").onChange((ne) => {
      e.general && (e.general.arOnTheFly = ne), t(e);
    });
    const o = s == null ? void 0 : s.addFolder("Measure Scene Ar"), a = {
      options: {
        width: ((ee = e.general.meshSize) == null ? void 0 : ee.width) ?? !1,
        height: ((z = e.general.meshSize) == null ? void 0 : z.height) ?? !1,
        depth: ((he = e.general.meshSize) == null ? void 0 : he.depth) ?? !1
      }
    };
    let g = (() => {
      const { width: ne, height: ye, depth: se } = a.options;
      return ne ? "width" : ye ? "height" : se ? "depth" : null;
    })();
    const w = (ne) => {
      if (ne === "none" || !ne)
        return 0;
      if (e.general && e.general.meshSize)
        return e.general.meshSize[ne];
    };
    o == null || o.add(a, "options", {
      None: "none",
      Width: "width",
      Height: "height",
      Depth: "depth"
    }).name("Know Dimension").setValue(g).onFinishChange((ne) => {
      g = ne, ne === "none" && e.general && e.general.meshSize && (e.general.meshSize = {
        width: null,
        height: null,
        depth: null
      }, t(e)), T == null || T.setValue(w(g));
    });
    const T = o == null ? void 0 : o.add({ size: 0 }, "size", -500, 500, 1).name("Measure (cm)").setValue(w(g)).onFinishChange((ne) => {
      e.general && e.general.meshSize && (Object.keys(e.general.meshSize).forEach((ye) => {
        e.general && e.general.meshSize && (e.general.meshSize[ye] = ye !== g ? null : ne);
      }), t(e));
    });
  }
  configureEnvironment(e, t) {
    var o, a;
    if (!e.general || !e.general.environmentOptions)
      return;
    const s = (a = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : a.addFolder("Environment");
    s == null || s.add(e.general, "exposure", 0, 5, 0.1).name("Exposure").onChange(() => {
      t(e);
    }), s == null || s.add(e.general, "contrast", 0, 5, 0.1).name("Contrast").onChange(() => {
      t(e);
    }).isModified, s == null || s.add(e.general.environmentOptions, "rotationY", 0, 10, 1e-3).name("Rotation Y").onChange(() => {
      t(e);
    }), s == null || s.add(e.general.environmentOptions, "intensity", 0, 20, 0.1).name("Intensity").onChange(() => {
      t(e);
    }), s == null || s.add(e.general.environmentOptions, "pbrIntensity", 0, 20, 0.1).name("PBR Intensity").onChange(() => {
      t(e);
    });
  }
  configureCamera(e, t, s) {
    var H, Y;
    const o = s == null ? void 0 : s.cameras.find((ee) => ee instanceof BABYLON.ArcRotateCamera);
    if (!e.camera || !e.camera.position || !o)
      return;
    const a = (Y = (H = this.gui) == null ? void 0 : H.debug) == null ? void 0 : Y.addFolder("Camera");
    a == null || a.add(e.camera, "autoRotate").name("Auto Rotate").onChange(() => {
      t(e);
    }), e.camera.zoom === void 0 && (e.camera.zoom = 0), a == null || a.add(e.camera, "zoom", -50, 10, 0.1).name("Initial Zoom").onChange(() => {
      t(e);
    }), a == null || a.add(e.camera.position, "fov", 0, 1.6, 1e-3).name("Fov").onChange((ee) => {
      o.fov = ee, s == null || s.render();
    });
    const c = a == null ? void 0 : a.addFolder("Rotation");
    c == null || c.add(e.camera.position, "alpha", -10, 10, 0.01).name("X").onChange((ee) => {
      o.alpha = ee, s == null || s.render();
    }), c == null || c.add(e.camera.position, "beta", -3, 3, 0.01).name("Y").onChange((ee) => {
      o.beta = ee, s == null || s.render();
    });
    const g = a == null ? void 0 : a.addFolder("Zoom Settings");
    e.camera.useMinZoomPerc = e.camera.useMinZoomPerc === null ? !1 : e.camera.useMinZoomPerc, e.camera.useMaxZoomPerc = e.camera.useMaxZoomPerc === null ? !1 : e.camera.useMaxZoomPerc, g == null || g.add(e.camera, "useMinZoomPerc", 0, 1, 0.01).name("Enable Max Zoom").onChange(() => {
      t(e);
    });
    const w = g == null ? void 0 : g.add(e.camera, "minZoomPerc", 0, 10, 0.01).name("Max Zoom");
    w == null || w.onChange((ee) => {
      var he;
      const z = (he = e.camera) == null ? void 0 : he.maxZoomPerc;
      z && ee > z && w.setValue(z), t(e);
    }), g == null || g.add(e.camera, "useMaxZoomPerc", 0, 1, 0.01).name("Enable Min Zoom").onChange(() => {
      t(e);
    });
    const T = g == null ? void 0 : g.add(e.camera, "maxZoomPerc", 0, 10, 0.01).name("Min Zoom");
    T == null || T.onChange((ee) => {
      var he;
      const z = (he = e.camera) == null ? void 0 : he.minZoomPerc;
      ee === 0 ? T.setValue(0.01) : z && ee < z && T.setValue(z), t(e);
    });
  }
  configureLights(e, t) {
    var o, a;
    if (!e.lights)
      return;
    const s = (a = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : a.addFolder("Lights");
    this.configureLight(
      s,
      "Directional Light Back",
      e.lights.directionalLightBack,
      e,
      t
    ), this.configureLight(
      s,
      "Directional Light Left",
      e.lights.directionalLightLeft,
      e,
      t
    ), this.configureLight(s, "Point Light Back", e.lights.pointLightBack, e, t), this.configureLight(s, "Point Light Front", e.lights.pointLightFront, e, t), this.configureLight(s, "Hemisphere Light", e.lights.hemisphereLight, e, t);
  }
  configureLight(e, t, s, o, a) {
    const c = e == null ? void 0 : e.addFolder(t), g = c == null ? void 0 : c.addFolder("position"), w = c == null ? void 0 : c.addFolder("general");
    g == null || g.add(s.position, "x", -100, 100, 0.1).name("Position X").onChange(() => {
      a(o);
    }), g == null || g.add(s.position, "y", -100, 100, 0.1).name("Position Y").onChange(() => {
      a(o);
    }), g == null || g.add(s.position, "z", -100, 100, 0.1).name("Position Z").onChange(() => {
      a(o);
    }), w == null || w.add(s.general, "intensity", 0, 50, 0.1).name("Intensity").onChange(() => {
      a(o);
    }), w == null || w.add(s.general, "visible").name("Visible").onChange(() => {
      a(o);
    });
  }
  configureAnimations(e, t, s) {
    var c, g;
    const o = (s == null ? void 0 : s.animationGroups) && s.animationGroups.length > 0;
    if (!e.animations || !o)
      return;
    const a = (g = (c = this.gui) == null ? void 0 : c.debug) == null ? void 0 : g.addFolder("animations");
    a == null || a.add(e.animations, "runAtStart").name("Run At Start").onChange(() => t(e)), a == null || a.add(e.animations, "loop").name("Loop").onChange(() => t(e)), a == null || a.add(e.animations, "speed", 0.1, 5, 0.1).name("Speed").onChange(() => t(e));
  }
}
var Ow = /* @__PURE__ */ ((v) => (v.CameraMovement = "camera-movement", v.ScriptExecution = "script-execution", v.DesignChanged = "design-changed", v))(Ow || {});
class pu {
  constructor(e) {
    this._zkScene = null, this._zkModel = null, this._canvasID = "zakeke-canvas-viewer3D-" + Zakeke.makeID(5), this._canvas = null, this._domElement = null, this._lastWidth = Number.MIN_VALUE, this._lastHeight = Number.MIN_VALUE, this._engine = null, this._scene = null, this._bindedResize = null, this._sceneHelper = null, this._environmentManager = null, this._glowManager = null, this._sceneActionsExecutor = null, this._renderingNeeded = !1, this._renderingPaused = !1, this._autoRender = !1, this._antiAliasConfig = {
      enabled: !0,
      inRotationEnabled: !1
    }, this._postProcesses = [], this._camera = null, this._hemiLight = null, this._pointLight = null, this._highlightColor = "#00ff00", this._highlightSize = 2, this._highlightLayer = null, this._highlightBlurHorizontalSize = 1, this._highlightBlurVerticalSize = 1, this._highlightAnimationID = null, this._highlightCurrentMeshes = [], this._highlightNextMeshes = [], this._deviceType = MPlaza.DeviceType.All, this._destroyed = !1, this._sceneDesignManager = null, this._meshLocationsManager = null, this._groupPickedListeners = [], this._focusAttributesListeners = [], this._designNotifyMessageListeners = [], this._designRemoveMessageListeners = [], this._designEventMessages = [], this._onDelayLoadingStart = null, this._onDelayLoadingProgress = null, this._onDelayLoadingSuccess = null, this._onDelayLoadingError = null, this._infoPointPickedListeners = [], this._infoPointContentShownListeners = [], this._infoPointContentHiddenListeners = [], this._beginAssetsLoadingListeners = [], this._endAssetsLoadingListeners = [], this._nextSceneMeshesLoadedListeners = [], this._nextSceneTexturesLoadedListeners = [], this._beginSceneLoadingListeners = [], this._endSceneLoadingListeners = [], this._arFileUrls = {}, this._designTextureResolution = 1024, this._configPreview = !1, this._defaultBackgroundColor = null, this._grids = [], this._dracoCompression = null, this._infoPointsManager = null, this._infoPointsManagerStyle = null, this._canShowInfoPoints = !0, this._canShowInfoPointsContent = !0, this._broadcastChannel = null, this._isHologramSource = !1, this._isHologram = !1, this._lastResizableMeshID = "", this._brandLogoButton = null, this._advancedTexture = null, this._createGui = null, this._performanceInfo = null, this._currentRotation = 0, this._isRotating = !1, this._isViewer = !1, this._isSelectionMode = !0, this._mouseWheelInput = null, this._modelParentNode = null, this.setCameraLocked = (t) => {
      this._zkScene && this._sceneHelper && this._scene && (this._sceneHelper.setupCamera(), this._camera = this._scene.activeCamera, this._camera && (t ? (this._sceneHelper.setCameraLimitLowerRadius(!0), this._sceneHelper.setMinZoomPerc(1), this._sceneHelper.setMaxZoomPerc(1)) : (this._sceneHelper.setCameraLimitLowerRadius(!1), this._sceneHelper.setMinZoomPerc(1), this._sceneHelper.setMaxZoomPerc(1.5))));
    }, e != null && (typeof e == "boolean" ? this._configPreview = e : (this._configPreview = e.configPreview, e.defaultBackgroundColor && (this._defaultBackgroundColor = BABYLON.Color4.FromHexString(e.defaultBackgroundColor)), this._isViewer = (e == null ? void 0 : e.isViewer) ?? !1)), this._elementSelector = new Bd();
  }
  get zkScene() {
    return this._zkScene;
  }
  get zkModel() {
    return this._zkModel;
  }
  get canvas() {
    return this._canvas;
  }
  get engine() {
    return this._engine;
  }
  get scene() {
    return this._scene;
  }
  get autoRender() {
    return this._autoRender;
  }
  set autoRender(e) {
    this._autoRender = e;
  }
  get antiAliasConfig() {
    return this._antiAliasConfig;
  }
  set antiAliasConfig(e) {
    this._antiAliasConfig = e;
  }
  get isLowEndDevice() {
    return this._performanceInfo && this._performanceInfo.isLowEndDevice;
  }
  get isHologramSource() {
    return this.isHologramSource;
  }
  get createGui() {
    return this._createGui;
  }
  set createGui(e) {
    this._createGui = e;
  }
  set isHologramSource(e) {
    this._isHologramSource = e, e && (this._isHologram = !1, this.detachBroadcastChannelEventHandlers());
  }
  get isHologram() {
    return this._isHologram;
  }
  set isHologram(e) {
    this._isHologram = e, e ? (this._isHologramSource = !1, this.attachBroadcastChannelEventHandlers()) : this.detachBroadcastChannelEventHandlers(), this.refreshEnvironment();
  }
  get isSelectionMode() {
    return this._isSelectionMode;
  }
  set isSelectionMode(e) {
    this._isSelectionMode = e;
  }
  setupAntiAliasing() {
    if (this._zkScene) {
      let e = this.getAntiAliasingConfig();
      this._antiAliasConfig = e, e.enabled === !0 ? this.enableAntialiasing() : e.enabled === !1 && this.disableAntialiasing();
    }
  }
  getAntiAliasingConfig() {
    var t, s, o, a, c;
    if (!this._zkScene)
      return this._antiAliasConfig;
    const e = (a = (o = (s = (t = this._zkScene).get) == null ? void 0 : s.call(t, "config")) == null ? void 0 : o.toJSON) == null ? void 0 : a.call(o);
    return (c = e == null ? void 0 : e.general) != null && c.antialias ? Lx() ? e.general.antialias.mobile ?? this._antiAliasConfig : e.general.antialias.desktop ?? this._antiAliasConfig : this._antiAliasConfig;
  }
  enableAntialiasing() {
    this._scene && this._antiAliasConfig.enabled && (this.createAntialiasPostProcesses(), this._scene.postProcessesEnabled = !0);
  }
  disableAntialiasing(e = !1) {
    this._scene && (this._scene.postProcessesEnabled = !1), e && this.disposePostProcesses();
  }
  // Per coerenza con tutto il resto inserisco questi metodi set & get,
  // andrebbero usate solo le proprietà, ma questo anche in SceneEditor
  getARScale() {
    let e = !0;
    if (this._zkScene) {
      let t = this._zkScene.getARScale();
      return t ?? e;
    }
    return e;
  }
  setARScale(e) {
    this._zkScene && this._zkScene.setARScale(e);
  }
  getUseMaterialOffloading() {
    let e = !1;
    if (this.zkScene) {
      let t = this.zkScene.getUseMaterialOffloading();
      return t ?? e;
    }
    return e;
  }
  setUseMaterialOffloading(e) {
    this._zkScene && this._zkScene.setUseMaterialOffloading(e);
  }
  getPrefetchMeshes() {
    if (this.zkScene) {
      const t = this.zkScene.getPrefetchMeshes();
      return t ?? !0;
    }
    return !0;
  }
  setPrefetchMeshes(e) {
    this._zkScene && this._zkScene.setPrefetchMeshes(e);
  }
  getPrefetchMaterials() {
    if (this.zkScene) {
      const t = this.zkScene.getPrefetchMaterials();
      return t ?? !0;
    }
    return !0;
  }
  setPrefetchMaterials(e) {
    this._zkScene && this._zkScene.setPrefetchMaterials(e);
  }
  getShowHideInfoPoints() {
    return this.canShowInfoPoints;
  }
  setShowHideInfoPoints(e) {
    this.canShowInfoPoints = e;
  }
  get camera() {
    return this._camera;
  }
  get deviceType() {
    return this._deviceType;
  }
  set deviceType(e) {
    this._deviceType = e;
  }
  getDeviceType() {
    return this.deviceType;
  }
  get highlightColor() {
    return this._highlightColor;
  }
  set highlightColor(e) {
    this._highlightColor = e;
  }
  get highlightSize() {
    return this._highlightSize;
  }
  set highlightSize(e) {
    this._highlightSize = e;
  }
  get destroyed() {
    return this._destroyed;
  }
  get onDelayLoadingStart() {
    return this._onDelayLoadingStart;
  }
  set onDelayLoadingStart(e) {
    this._onDelayLoadingStart = e;
  }
  get onDelayLoadingProgress() {
    return this._onDelayLoadingProgress;
  }
  set onDelayLoadingProgress(e) {
    this._onDelayLoadingProgress = e;
  }
  get onDelayLoadingSuccess() {
    return this._onDelayLoadingSuccess;
  }
  set onDelayLoadingSuccess(e) {
    this._onDelayLoadingSuccess = e;
  }
  get onDelayLoadingError() {
    return this._onDelayLoadingError;
  }
  set onDelayLoadingError(e) {
    this._onDelayLoadingError = e;
  }
  get dracoCompression() {
    return this._dracoCompression || (this._dracoCompression = Yx.Default), this._dracoCompression;
  }
  get infoPointsShown() {
    return this._infoPointsManager ? this._infoPointsManager.infoPointsShown : !1;
  }
  get infoPointsManagerStyle() {
    return this._infoPointsManagerStyle;
  }
  set infoPointsManagerStyle(e) {
    this._infoPointsManagerStyle = e, this.updateInfoPointsManagerStyle();
  }
  get canShowInfoPoints() {
    return this._canShowInfoPoints;
  }
  set canShowInfoPoints(e) {
    this._canShowInfoPoints = e, this.refreshInfoPoints();
  }
  get canShowInfoPointsContent() {
    return this._canShowInfoPointsContent;
  }
  set canShowInfoPointsContent(e) {
    this._canShowInfoPointsContent = e, this._infoPointsManager && (this._infoPointsManager.canShowInfoPointsContent = e);
  }
  static async createSceneViewerAsync(e) {
    const t = new pu(e);
    return await t.initAsync(), t;
  }
  dispose() {
    this.closeBroadcastChannel(), this.removeCanvas(), this.removeDomElement(), this.deleteScene(), this.deleteEngine();
  }
  async initAsync() {
    this._bindedResize = this.resize.bind(this), Zakeke.Tools.Init(), BABYLON.Geometry.onDelayLoadingStart = (e) => {
      this._onDelayLoadingStart && this._onDelayLoadingStart(e);
    }, BABYLON.Geometry.onDelayLoadingProgress = (e) => {
      this._onDelayLoadingProgress && this._onDelayLoadingProgress(e);
    }, BABYLON.Geometry.onDelayLoadingSuccess = (e) => {
      this._onDelayLoadingSuccess && this._onDelayLoadingSuccess(e);
    }, BABYLON.Geometry.onDelayLoadingError = (e) => {
      this._onDelayLoadingError && this._onDelayLoadingError(e);
    }, BABYLON.Geometry.dracoDecodingFunction = (e, t, s) => {
      this.dracoDecodingFunction(e, t, s);
    }, this.createCanvas(), this.createDOMElement(), await this.init3DEngineAsync();
  }
  async init3DEngineAsync() {
    this.createEngine(), await this.createEmptySceneAsync(), this._destroyed = !1;
  }
  createCanvas() {
    return this._canvas = document.createElement("canvas"), this._canvas.setAttribute("id", this._canvasID), this._canvas.setAttribute("touch-action", "none"), this._canvas.addEventListener("dblclick", (e) => this.setRenderingNeeded()), this._canvas;
  }
  removeCanvas() {
    this._canvas && (this._canvas.remove(), this._canvas = null);
  }
  deleteEngine() {
    this._engine && (this._engine.dispose(), this._engine = null), this._destroyed = !0, $(window).off("resize", this._bindedResize);
  }
  deleteScene() {
    this.deleteComponents(), this._scene && (this._scene.dispose(), this._scene = null);
  }
  deleteComponents() {
    this.resetPerformanceInfo(), this.emptyArFileCache(), this.disposeInfoPointsManager(), this._meshLocationsManager && (this._meshLocationsManager.dispose(), this._meshLocationsManager = null), this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null), this._glowManager && (this._glowManager.dispose(), this._glowManager = null), this._sceneActionsExecutor && (this._sceneActionsExecutor.dispose(), this._sceneActionsExecutor = null), this.disposePostProcesses();
  }
  disposeInfoPointsManager() {
    this._infoPointsManager && (this._infoPointsManager.dispose(), this._infoPointsManager = null);
  }
  disposePostProcesses() {
    for (; this._postProcesses.length > 0; ) {
      var e = this._postProcesses.pop();
      e && e.dispose();
    }
  }
  emptyArFileCache() {
    this._arFileUrls = {};
  }
  async resetSceneAsync() {
    await this.init3DEngineAsync();
  }
  /**
   * In some case, we need to replace the model with a new one for example when reverting some changes in the preview 3D.
   * Backbone don't allow to replace all the model, so we need to replace the model with a old clone.
   * @param zkModel The new model to replace the old one.
   */
  replaceModel(e) {
    this._zkModel = e, this.render();
  }
  setZkScene(e) {
    this._zkScene = e;
  }
  closeBroadcastChannel() {
    this._broadcastChannel && (this._broadcastChannel.close(), this._broadcastChannel = null);
  }
  openBroadcastChannel() {
    if (!this._broadcastChannel && window.BroadcastChannel)
      try {
        this._broadcastChannel = new BroadcastChannel("zakeke-broadcast-channel");
      } catch (e) {
        console.error("Failed opening broadcast channel"), console.error(e);
      }
  }
  getOrCreateBroadcastChannel() {
    return this.openBroadcastChannel(), this._broadcastChannel;
  }
  createEngine() {
    this.deleteScene(), this.deleteEngine(), this._engine = new BABYLON.Engine(this._canvas, !0, { stencil: !0, preserveDrawingBuffer: !0 }), this._engine.enableOfflineSupport = !1, this._engine.disableUniformBuffers = !0, Logger.info("WebGL version: " + this._engine.webGLVersion), $(window).resize(this._bindedResize), $(window).on("orientationchange", () => {
      setTimeout(() => this._bindedResize(), 100);
    });
  }
  createBrandLogoButton() {
    var e = BABYLON.GUI.Button.CreateImageOnlyButton(
      "zakeke-logo",
      "https://zakeke.blob.core.windows.net/files/images/logo_hq.png"
    );
    return e.image.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, e.width = "120px", e.height = "70px", e.color = "transparent", e.hoverCursor = "pointer", e.onPointerClickObservable.add(function() {
      window.open("https://www.zakeke.com/");
    }), this._brandLogoButton = e, this._advancedTexture = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", !0, this._scene), this._advancedTexture.updateSamplingMode(BABYLON.Texture.NEAREST_NEAREST), this._advancedTexture.renderScale = 2, this._advancedTexture.addControl(this._brandLogoButton), this._brandLogoButton;
  }
  async createEmptySceneAsync() {
    this.deleteScene(), this._engine && (this._scene = new BABYLON.Scene(this._engine), this._defaultBackgroundColor && this._scene.clearColor.copyFrom(this._defaultBackgroundColor), await this.setupSceneAsync());
  }
  refreshLights() {
    var s, o, a, c, g, w;
    if (!this._zkScene)
      return;
    ((o = (s = this._zkScene) == null ? void 0 : s.getGeneralConfig()) == null ? void 0 : o.get("preventDefaultLights")) !== !0 && ((a = this._sceneHelper) == null || a.setupLights());
    const t = (g = (c = this._zkScene) == null ? void 0 : c.getSceneConfig()) == null ? void 0 : g.get("lights");
    t != null && t.attributes && ((w = this._sceneHelper) == null || w.setUpCustomLights(t.attributes));
  }
  async setupSceneAsync(e = !0) {
    var t, s, o, a, c, g, w, T, H, Y, ee;
    if (this._zkScene && this._zkScene.get("config") && ((s = (t = this._zkScene.get("config")) == null ? void 0 : t.get("general")) != null && s.get("meshSize"))) {
      const z = (a = (o = this._zkScene.get("config")) == null ? void 0 : o.get("general")) == null ? void 0 : a.get("meshSize"), he = (c = this._scene) == null ? void 0 : c.meshes.find((ne) => !ne.parent);
      he && z && (z.width || z.height || z.depth) && (he.metadata ? he.metadata.sizecm = z : he.metadata = { sizecm: z });
    }
    if (this.refreshModel(), this._engine && this._scene) {
      this._sceneHelper = new ni(this._scene);
      const z = this._zkScene ? this._zkScene.getCameraPositionScale() : void 0, he = this._zkScene ? this._zkScene.getCameraLimitLowerRadius() : void 0, ne = this._zkScene ? this._zkScene.getCameraZoomEnabled() : void 0, ye = this._zkScene ? this._zkScene.getCameraUseMinZoomPerc() : !1, se = this._zkScene ? this._zkScene.getCameraMinZoomPerc() : 1, _e = this._zkScene ? this._zkScene.getCameraUseMaxZoomPerc() : !1, ue = this._zkScene ? this._zkScene.getCameraMaxZoomPerc() : 1.5, xe = this._zkScene ? this._zkScene.getCameraLowerAlphaLimit() : null, Ee = this._zkScene ? this._zkScene.getCameraUpperAlphaLimit() : null, K = this._zkScene ? this._zkScene.getCameraLowerBetaLimit() : null, j = this._zkScene ? this._zkScene.getCameraUpperBetaLimit() : null, ht = this._zkScene ? (g = this._zkScene.getCameraConfig()) == null ? void 0 : g.get("zoom") : null;
      if (z != null && z != null && this._sceneHelper.setCameraPositionScale(z, !1), he != null && he != null && this._sceneHelper.setCameraLimitLowerRadius(he, !1), ne != null && ne != null && this._sceneHelper.setZoomEnabled(ne), this._sceneHelper.setCameraZoom(ht), this._sceneHelper.setupCamera(), this._camera = this._scene.activeCamera, this._mouseWheelInput = ((w = this._camera) == null ? void 0 : w.inputs.attached.mousewheel) ?? null, this._camera && (ye ? this._sceneHelper.setMinZoomPerc(se) : this._sceneHelper.setMinZoomPerc(null), _e ? this._sceneHelper.setMaxZoomPerc(ue) : this._sceneHelper.setMaxZoomPerc(null), this._sceneHelper.setCameraAlphaLimits(xe, Ee), this._sceneHelper.setCameraBetaLimits(K, j)), this._camera && e && (this._camera.onViewMatrixChangedObservable.add(() => {
        this.notifyCameraMovement();
      }), this._camera.onRestoreStateObservable.add(() => {
        this.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded();
      }), this.refreshCameraPosition()), (T = this._sceneHelper) == null || T.setupAnimations(this._zkScene), this._modelParentNode || (this._modelParentNode = new BABYLON.TransformNode("modelParent")), (H = this._sceneHelper) == null || H.setupShadows(this._zkScene), this.refreshLights(), this.createHighlightLayer(), await this.refreshEnvironment(), await this.fixEnvironmentTexture(), this.setupGlowManager(), this._zkScene && (this._meshLocationsManager = new xx(), this._meshLocationsManager.setModelAndScene(this._zkScene, this._scene), this._meshLocationsManager.addMeshAnimationCompletedListener(() => this.setRenderingNeeded())), await this.setupSceneActionsExecutorAsync(), this.setRenderingOnDelayLoaded(), this.setupAntiAliasing(), this._scene.onPointerDown = (Ze, pt) => this.onPointerDown(Ze, pt), this._scene.registerBeforeRender(() => {
        this.onBeforeRender();
      }), this.refreshInfoPoints(), this.refreshModel(), this.refreshPBRMaterials(), this._zkScene) {
        const Ze = (ee = (Y = this._zkScene) == null ? void 0 : Y.getGeneralConfig()) == null ? void 0 : ee.get("removeDefaultBackground");
        this._sceneHelper.removeDefaultBackground(Ze), this._sceneHelper.setUpSceneToneMapping(this._zkScene);
      }
      this._engine.stopRenderLoop(), this.render(), this._engine.runRenderLoop(() => {
        this.checkRendering();
      });
    }
  }
  onBeforeRender() {
    if (this._scene && this._sceneHelper) {
      if (this._camera) {
        const e = this._sceneHelper.getDefaultPointLight();
        e && (e.position = this._camera.position);
      }
      this._scene.meshes.forEach((e) => {
        e.mustDepthSortFacets && e.isFacetDataEnabled && e.updateFacetData();
      });
    }
  }
  render() {
    this._scene && !this._scene.isDisposed && !this._renderingPaused && this._scene.render();
  }
  // Disabilito il post-processing quando la camera è in movimento
  checkRendering() {
    this._scene && (this._autoRender || this._renderingNeeded || this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving() ? (this.checkPerformance(), (this.isLowEndDevice || this._autoRender && !this._camera.autoRotationBehavior || // fix: in autorotate the antialiasing will be disabled without autoRotationBehavior check
    this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving()) && !this._antiAliasConfig.inRotationEnabled ? this.disableAntialiasing() : this.enableAntialiasing(), this.render(), this._renderingNeeded && (this._renderingNeeded = !1)) : !this._scene.postProcessesEnabled && !this._antiAliasConfig.inRotationEnabled && (this.enableAntialiasing(), this.render()), this._infoPointsManager && this._infoPointsManager.updateInfoPointsVisibility() && this.render());
  }
  resetPerformanceInfo() {
    this._performanceInfo = null;
  }
  checkPerformance() {
    if (this._performanceInfo || (this._performanceInfo = { totalFPS: 0, countFPS: 0, isLowEndDevice: !1, chekDone: !1 }), this._engine && !this._performanceInfo.chekDone) {
      this._performanceInfo.totalFPS += this._engine.getFps(), this._performanceInfo.countFPS++;
      const e = this._performanceInfo.totalFPS / this._performanceInfo.countFPS;
      this._performanceInfo.countFPS > 30 && (this._performanceInfo.isLowEndDevice = e <= 30, this._performanceInfo.chekDone = !0);
    }
  }
  createAntialiasPostProcesses() {
    if (this._camera && this._postProcesses.length === 0) {
      var e = /firefox/i.test(navigator.userAgent);
      e || this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 4, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      ), this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 2, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      ), this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 1, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      );
    }
  }
  getDAMMainMesh() {
    var e, t;
    return (t = (e = this._sceneHelper) == null ? void 0 : e.getVTOMeshes().userMeshes.filter((s) => !s.parent)) == null ? void 0 : t[0];
  }
  setRenderingNeeded() {
    this._renderingNeeded = !0;
  }
  setLongRenderingNeeded() {
    this.setRenderingNeeded();
    for (let e = 50; e <= 1e3; e += 200)
      setTimeout(() => this.setRenderingNeeded(), e);
  }
  refreshRendering() {
    this.setLongRenderingNeeded();
  }
  pauseRendering() {
    this._renderingPaused = !0;
  }
  resumeRendering() {
    this._renderingPaused = !1, this.setRenderingNeeded();
  }
  setLoadingScreen(e) {
    this._engine && (this._engine.loadingScreen = e);
  }
  setRenderingOnDelayLoaded() {
    if (this._scene) {
      var e = this;
      this._scene.getGeometries().forEach(function(t) {
        var s = t.onGeometryUpdated;
        t.onGeometryUpdated = function(o, a) {
          e.setLongRenderingNeeded(), s && s.apply(this, [o, a]);
        };
      });
    }
  }
  createHighlightLayer() {
    this._scene && (this._highlightLayer = new BABYLON.HighlightLayer("hl1", this._scene), this.updateHighlightLayerExcludedDesignMeshes(), this.setupHighlightLayerIntensity());
  }
  setupHighlightLayerIntensity() {
    this._highlightLayer && (this._highlightLayer.blurHorizontalSize = this._highlightSize, this._highlightLayer.blurVerticalSize = this._highlightSize, this._highlightBlurHorizontalSize = this._highlightSize, this._highlightBlurVerticalSize = this._highlightSize);
  }
  updateHighlightLayerExcludedDesignMeshes() {
    this.scene && this._sceneHelper && this._highlightLayer && (this._highlightLayer.removeAllMeshes(), this.scene.meshes.filter(this._sceneHelper.isCanvasMesh).forEach((e) => this._highlightLayer.addExcludedMesh(e)));
  }
  createDOMElement() {
    this._canvas && (this._domElement = document.createElement("div"), this._domElement.setAttribute("id", "zakeke-canvas-viewer3D-div-" + Zakeke.makeID(5)), this._domElement.appendChild(this._canvas), this._domElement.style.position = "absolute", this._domElement.style.width = "100%", this._domElement.style.height = "100%", this._domElement.style.left = "0", this._domElement.style.top = "0");
  }
  removeDomElement() {
    this._domElement && (this.detach(), this._domElement.remove(), this._domElement = null);
  }
  appendTo(e) {
    this._domElement && (e.firstChild ? e.insertBefore(this._domElement, e.firstChild) : e.appendChild(this._domElement), e.appendChild(this._domElement), this.resize(), this.resize());
  }
  detach() {
    this._domElement && this._domElement.parentNode && this._domElement.parentNode.removeChild(this._domElement);
  }
  updateView(e = !0, t = !1) {
    this.resize(t), e && this._scene && this.adjustCamera(!1);
  }
  resize(e = !1) {
    if (this._canvas) {
      this.disableAntialiasing(!0);
      var t = this._canvas.parentNode;
      if (!(!t || !(t instanceof HTMLElement))) {
        var s = t.offsetWidth, o = t.offsetHeight;
        (s != this._lastWidth || o != this._lastHeight || e) && (this._canvas.style.width = "100%", this._canvas.style.height = "100%", this._engine && (this._engine.resize(), this._brandLogoButton && (this._brandLogoButton.left = -this._canvas.width + 100 + "px", this._brandLogoButton.top = -this._canvas.height + 50 + "px", console.group(
          "BrandLogoButton",
          "left: " + this._brandLogoButton.left + " - top: " + this._brandLogoButton.top
        ), console.groupEnd()), this.setRenderingNeeded())), this._lastWidth = s, this._lastHeight = o, this.enableAntialiasing();
      }
    }
  }
  switchFullScreen(e) {
    this._sceneHelper && this._sceneHelper.switchFullScreen(e);
  }
  setupGlowManager() {
    this._glowManager && (this._glowManager.dispose(), this._glowManager = null), this._zkScene && this._scene && (this._glowManager = new wx(this._zkScene, this._scene), this._glowManager.update(), this.setRenderingNeeded());
  }
  async setupSceneActionsExecutorAsync() {
    this._zkScene && this._scene && (this._sceneActionsExecutor = new bx(this._zkScene, this._scene), this._sceneActionsExecutor.deviceType = this.deviceType, this._sceneActionsExecutor.useMaterialOffloading = !this._configPreview && this.getUseMaterialOffloading(), this._sceneActionsExecutor.prefetchMeshes = this.getPrefetchMeshes(), this._sceneActionsExecutor.prefetchMaterials = this.getPrefetchMaterials(), this._sceneActionsExecutor.addMeshDesignRefreshRequiredListeners(async (e) => {
      await this.refreshMeshesDesignAsync(e.meshes, e.effect);
    }), this._sceneActionsExecutor.addBeginAssetsLoadingListener(() => this.fireBeginAssetsLoadingEvent()), this._sceneActionsExecutor.addEndAssetsLoadingListener(() => this.fireEndAssetsLoadingEvent()));
  }
  restoreCameraState() {
    this._sceneHelper && (this._sceneHelper.restoreCameraState(), this._sceneHelper.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded());
  }
  async fixEnvironmentTexture() {
    if (this._scene && this._scene.environmentTexture && this._scene.environmentTexture.url && typeof this._scene.environmentTexture.url == "string") {
      const e = this._scene.environmentTexture.url, t = (e.match(/http/g) || []).length;
      let s = e;
      if (t > 1) {
        let g = e.lastIndexOf("http");
        g >= 0 && (s = e.substring(g));
      } else if (t == 0 && this._zkScene && this._zkScene.get("rootUrl")) {
        let g = this._zkScene.get("rootUrl");
        if (g) {
          const w = g.endsWith("/") ? "" : "/";
          s = g + w + e;
        }
      } else if (t === 0)
        return;
      let o, a, c;
      this._scene && this._scene.metadata && (this._scene.metadata.environmentTextureRotationY !== void 0 && typeof this._scene.metadata.environmentTextureRotationY == "number" && (o = this._scene.metadata.environmentTextureRotationY), this._scene.metadata.environmentTextureExtensions && (a = this._scene.metadata.environmentTextureExtensions), this._scene.metadata.environmentTextureFiles && (c = this._scene.metadata.environmentTextureFiles)), await this.setSceneEnvironmentTexture(s, o, a, c);
    } else
      await this.checkSceneEmptyEnvironmentTexture();
  }
  async checkSceneEmptyEnvironmentTexture() {
    this._scene && this._sceneHelper && this._sceneHelper.containsPBRMaterials() && !this._scene.environmentTexture && await this.setDefaultSceneEnvironmentTexture();
  }
  async setDefaultSceneEnvironmentTexture() {
    const e = Wt.Environment.EnvironmentTextureCDNUrl;
    await this.setSceneEnvironmentTexture(e);
  }
  async setSceneEnvironmentTexture(e, t, s, o, a, c) {
    return new Promise((g) => {
      if (this._scene && this._sceneHelper)
        if (this._scene.environmentTexture && this._sceneHelper.isTextureWithUrl(this._scene.environmentTexture) && this._scene.environmentTexture.url && this._scene.environmentTexture.url != e && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null), this._scene && this._sceneHelper) {
          this._scene.environmentTexture && this._sceneHelper.isTextureWithUrl(this._scene.environmentTexture) && this._scene.environmentTexture.url && this._scene.environmentTexture.url != e && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null);
          const w = () => {
            a && a(), this.setLongRenderingNeeded();
          };
          this._scene.metadata || (this._scene.metadata = {}), delete this._scene.metadata.environmentTextureType, delete this._scene.metadata.environmentTextureSize, delete this._scene.metadata.environmentTextureExtensions, delete this._scene.metadata.environmentTextureFiles;
          let T = null;
          e.endsWith(".dds") ? T = BABYLON.CubeTexture.CreateFromPrefilteredData(e, this._scene) : e.endsWith(".hdr") ? (T = new BABYLON.HDRCubeTexture(
            e,
            this._scene,
            128,
            (c == null ? void 0 : c.get("mipMaps")) || void 0,
            (c == null ? void 0 : c.get("generateHarmonics")) || void 0,
            (c == null ? void 0 : c.get("gammaSpace")) || void 0,
            (c == null ? void 0 : c.get("prefilterOnLoad")) || void 0,
            w
          ), this._scene.metadata.environmentTextureType = "BABYLON.HDRCubeTexture", this._scene.metadata.environmentTextureSize = 128) : e.endsWith(".env") ? T = new BABYLON.CubeTexture(
            e,
            this._scene,
            null,
            !1,
            null,
            w,
            null,
            void 0,
            !0,
            void 0,
            !0
          ) : e.endsWith(".basis") ? T = BABYLON.CubeTexture.CreateFromPrefilteredData(e, this._scene) : s && s.length === 6 && o && o.length === 6 && (T = new BABYLON.CubeTexture(
            e,
            this._scene,
            s,
            !1,
            o,
            w
          ), this._scene.metadata.environmentTextureExtensions = s, this._scene.metadata.environmentTextureFiles = o), T && ni.whenTextureIsReadyAsync(T).then(() => {
            var H, Y, ee, z, he, ne, ye, se;
            if (T && this._scene) {
              const _e = (z = (ee = (Y = (H = this._zkScene) == null ? void 0 : H.get("config")) == null ? void 0 : Y.get("general")) == null ? void 0 : ee.get("environmentOptions")) == null ? void 0 : z.get("intensity"), ue = (se = (ye = (ne = (he = this._zkScene) == null ? void 0 : he.get("config")) == null ? void 0 : ne.get("general")) == null ? void 0 : ye.get("environmentOptions")) == null ? void 0 : se.get("rotationY");
              _e && (T.level = _e), ue ? T.rotationY = ue : this._scene.metadata && this._scene.metadata.environmentTextureRotationY != null && delete this._scene.metadata.environmentTextureRotationY, this._scene.environmentTexture = T, this.setRenderingNeeded(), g();
            }
          });
        } else
          g();
    });
  }
  async loadSceneFromModelAsync(e, t, s) {
    if (e && e instanceof MPlaza.Model && (this._zkModel = e), t && t instanceof Zakeke.Scene) {
      this._zkScene = t, this.checkSceneShaderMaterials(t);
      const o = t.get("rootUrl"), a = t.get("sceneFileName");
      o && a && await this.loadSceneFromRemoteFilesAsync(o, a, s);
    }
  }
  async loadSceneFromModelDataAsync(e, t, s, o) {
    if (e && e instanceof MPlaza.Model && (this._zkModel = e), t && t instanceof Zakeke.Scene) {
      this._zkScene = t, this.checkSceneShaderMaterials(t);
      var a = "data:" + s;
      const c = t.get("rootUrl");
      c && await this.loadSceneFromRemoteFilesAsync(c, a, o);
    }
  }
  preSceneFileLoading() {
  }
  postSceneFileLoading() {
  }
  // Carica la scena Babylon JS tramite rootUrl e sceneFilename
  // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
  // il path in base a rootUrl e al nome della texture
  // textureUrl = rootUrl + texture.name
  async loadSceneFromRemoteFilesAsync(e, t, s) {
    if (!this._engine)
      throw new Error("Unable to load scene when the 3D engine is null");
    try {
      this.fireBeginSceneLoadingEvent(), this.preSceneFileLoading(), this.pauseRendering(), this._engine.sceneFileRootUrl = e;
      let o = await BABYLON.SceneLoader.LoadAsync(e, t, this._engine, s);
      if (this._destroyed) {
        Logger.info("Loading scene engine destroyed"), o.dispose();
        return;
      }
      if (await new Promise((T) => o.executeWhenReady(() => T())), this._destroyed)
        throw Logger.info("Loading scene engine destroyed"), o.dispose(), new Error("Engine destroyed while loading scene");
      const a = ni.visibleMeshesRequireDelayedLoading(o);
      a && this.fireBeginAssetsLoadingEvent();
      let c = 0;
      const g = o.meshes.filter((T) => T.isVisible);
      for (let T = 0; T < g.length; T++)
        await this.fireNextSceneMeshesLoadedEvent(T + 1, g.length), await new Promise((H) => {
          setTimeout(() => {
            H();
          }, 10);
        });
      await ni.whenAllVisibleMeshesAreReadyAsync(g), a && this.fireEndAssetsLoadingEvent(), this.deleteScene(), this._scene = o;
      let w = [];
      for (let T = 0; T < this._scene.textures.length; T++) {
        const H = this._scene.textures[T];
        w.push(H.name), H instanceof BABYLON.Texture && H.onLoadObservable && H.onLoadObservable.add((Y) => {
          this.setLongRenderingNeeded();
        });
      }
      if (this._scene && this._scene.metadata && !this._scene.metadata.delayedMaterials)
        for (let T = 0; T < this._scene.textures.length; T++)
          await this.fireNextSceneTextureLoadedEvent(T + 1, this._scene.textures.length), await new Promise((H) => {
            setTimeout(() => {
              H();
            }, 10);
          });
      if (await this.setupSceneAsync(), this._sceneHelper) {
        this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials && await this._sceneHelper.loadAllDelayedMaterialsAsync(
          e,
          this.fireNextSceneTextureLoadedEvent.bind(this)
        ), this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._sceneHelper.loadAllOffloadedMaterials(e), this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials && this._sceneHelper.unsetAllDummyMaterials(), this._sceneHelper.setupShaderMaterialsCameraPosition();
        try {
          await this.reloadAllLoadingErrorTexturesAsync();
        } catch (T) {
          console.error(T);
        }
      }
      if (this._environmentManager) {
        const T = this._environmentManager.getSkyboxTexture();
        T && await ni.whenTextureIsReadyAsync(T);
      }
    } finally {
      this.resumeRendering(), this.postSceneFileLoading(), this.fireEndSceneLoadingEvent();
    }
  }
  getSkyboxTexture() {
    var e;
    return (e = this._environmentManager) == null ? void 0 : e.getSkyboxTexture();
  }
  // Carica la scena Babylon JS tramite rootUrl e sceneFilename
  // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
  // il path in base a rootUrl e al nome della texture
  // textureUrl = rootUrl + texture.name
  async loadSceneFromRemoteFilesAsync_OLD(e, t, s) {
    return new Promise(async (o, a) => {
      this._engine || a(), this.preSceneFileLoading(), this._engine.sceneFileRootUrl = e;
      let c = await BABYLON.SceneLoader.LoadAsync(e, t, this._engine, s);
      if (this._destroyed) {
        Logger.info("Loading scene engine destroyed"), c.dispose();
        return;
      }
      c.executeWhenReady(async () => {
        this._destroyed && (Logger.info("Loading scene engine destroyed"), c.dispose(), a());
        const g = c.meshes.filter((T) => T.isVisible), w = ni.visibleMeshesRequireDelayedLoading(c);
        w && this.fireBeginAssetsLoadingEvent(), await ni.whenAllVisibleMeshesAreReadyAsync(g), w && this.fireEndAssetsLoadingEvent(), this.deleteScene(), this._scene = c;
        for (let T = 0; T < this._scene.textures.length; T++) {
          const H = this._scene.textures[T];
          H instanceof BABYLON.Texture && H.onLoadObservable && H.onLoadObservable.add((Y) => {
            this.setLongRenderingNeeded();
          });
        }
        await this.setupSceneAsync(), this._sceneHelper && (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials && await this._sceneHelper.loadAllDelayedMaterialsAsync(e), this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._sceneHelper.loadAllOffloadedMaterials(e), this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials && this._sceneHelper.unsetAllDummyMaterials(), this._sceneHelper.setupShaderMaterialsCameraPosition()), this.postSceneFileLoading(), o();
      });
    });
  }
  checkSceneShaderMaterials(e) {
    if (e instanceof Zakeke.Scene && e.get("shaderMaterials"))
      for (let t = 0; t < e.get("shaderMaterials").length; t++) {
        const s = e.get("shaderMaterials").at(t), o = s.get("name"), a = s.get("vertex"), c = s.get("fragment");
        if (o && a && c) {
          const g = { name: o, vertex: a, fragment: c };
          this.setupShadersStore(g);
        }
      }
  }
  checkShaderMaterial(e) {
    if (e && e instanceof Zakeke.Material && e.get("shaders")) {
      const s = e.get("shaders").get("name"), o = e.get("shaders").get("vertex"), a = e.get("shaders").get("fragment");
      if (s && o && a) {
        const c = { name: s, vertex: o, fragment: a };
        this.setupShadersStore(c);
      }
    }
  }
  setupShadersStore(e) {
    if (e && e.hasOwnProperty("name") && e.hasOwnProperty("vertex") && e.hasOwnProperty("fragment")) {
      var t = e.name + "VertexShader", s = e.name + "FragmentShader";
      BABYLON.Effect.ShadersStore[t] = e.vertex, BABYLON.Effect.ShadersStore[s] = e.fragment;
    }
  }
  isRealMesh(e) {
    return this._sceneHelper ? this._sceneHelper.isRealMesh(e) : !1;
  }
  countSceneMeshes() {
    return this._sceneHelper ? this._sceneHelper.countSceneMeshes() : 0;
  }
  getVisibleMeshes() {
    return this._sceneHelper ? this._sceneHelper.getVisibleMeshes() : [];
  }
  getSceneBoundingInfo() {
    return this._sceneHelper ? this._sceneHelper.getSceneBoundingInfo() : null;
  }
  selectMesh(e) {
    this.selectUnselectMesh(e, !0);
  }
  unselectMesh(e) {
    this.selectUnselectMesh(e, !1);
  }
  unselectAllMeshes() {
    this._scene && (this._scene.meshes.forEach((e) => this.unselectSingleMesh(e)), this.fireFocusAttributesEvent({ groups: [] }));
  }
  selectUnselectMesh(e, t) {
    if (this._scene && (this._scene.meshes.forEach((o) => this.unselectSingleMesh(o)), t)) {
      let o = (c) => {
        this.selectSingleMesh(c);
        const g = c.getChildMeshes();
        g && g.forEach((w) => o(w));
      };
      const a = this._scene.getMeshByID(e);
      if (a) {
        o(a);
        const c = this.getGroupForMesh(a);
        c && (this.highlightGroupForMesh(a), this.fireGroupPickedEvent({ groupID: c.get("groupID") }));
        var s = this.getVisibleHiddenAttributesForMesh(a);
        this.fireFocusAttributesEvent({ groups: s }), s.length > 0 && this.highlightMeshes([a]);
      }
    }
  }
  selectSingleMesh(e) {
    this.setRenderingNeeded(), e.selected = !0;
  }
  unselectSingleMesh(e) {
    this.setRenderingNeeded(), e.selected = !1;
  }
  selectMeshesWithMaterial(e) {
    this.selectUnselectMeshesWithMaterial(e, !0);
  }
  unselectMeshesWithMaterial(e) {
    this.selectUnselectMeshesWithMaterial(e, !1);
  }
  selectUnselectMeshesWithMaterial(e, t) {
    if (this._scene && (this._scene.meshes.forEach((s) => this.unselectSingleMesh(s)), t)) {
      let s = (o) => {
        o.material && o.material.id === e && this.selectSingleMesh(o);
        const a = o.getChildMeshes();
        a && a.forEach((c) => {
          s(c);
        });
      };
      this._scene.meshes.forEach((o) => {
        s(o);
      });
    }
  }
  onPointerDown(e, t) {
    t.hit && t.pickedMesh ? this.selectMesh(t.pickedMesh.id) : this.unselectAllMeshes();
  }
  getSelectedRootMesh() {
    if (this._scene)
      for (let e = 0; e < this._scene.meshes.length; e++) {
        const t = this._scene.meshes[e];
        if (t.selected) {
          const s = t.parent;
          if (!s || !s.selected)
            return t;
        }
      }
    return null;
  }
  getMeshByID(e) {
    return this._scene ? this._scene.getMeshByID(e) : null;
  }
  getMeshByName(e) {
    return this._scene ? this._scene.getMeshByName(e) : null;
  }
  getMaterialByID(e) {
    return this._scene ? this._scene.getMaterialByID(e) : null;
  }
  setCameraLocation(e, t = !1, s = !0) {
    if (this._zkScene && this._sceneHelper) {
      const o = this._zkScene.getCameraLocation(e);
      if (o) {
        const a = new BABYLON.Vector3(
          o.get("px"),
          o.get("py"),
          o.get("pz")
        ), c = new BABYLON.Vector3(
          o.get("tx"),
          o.get("ty"),
          o.get("tz")
        );
        if (s) {
          if (!t)
            this._sceneHelper.animateCamera(c, a, 0.5);
          else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const g = this._sceneHelper.computeCameraAngleOfView(c, a);
            this._sceneHelper.animateCameraToFinalParamters(
              g.alpha,
              g.beta,
              this._camera.radius,
              this._camera.target,
              0.5
            );
          }
        } else if (!t)
          this._sceneHelper.moveCamera(c, a);
        else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
          const g = this._sceneHelper.computeCameraAngleOfView(c, a);
          this._sceneHelper.moveCameraToFinalParameters(
            g.alpha,
            g.beta,
            this._camera.radius,
            this._camera.target
          );
        }
      }
    }
    this.setRenderingNeeded();
  }
  adjustCamera(e) {
    this._sceneHelper && (e != null && e != null && typeof e == "boolean" ? this._sceneHelper.adjustCamera(void 0, void 0, void 0, e) : this._sceneHelper.adjustCamera(), this.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded());
  }
  zoomIn() {
    this._sceneHelper && this._sceneHelper.zoomIn();
  }
  zoomOut() {
    this._sceneHelper && this._sceneHelper.zoomOut();
  }
  zoom(e) {
    this._sceneHelper && this._sceneHelper.zoom(e);
  }
  setCameraPivot(e) {
    if (this._scene && this._sceneHelper) {
      const t = e ? this._scene.getMeshByID(e) : null;
      this._sceneHelper.setCameraPivot(t);
    }
  }
  setCameraZoomEnabled(e) {
    this._scene && this._sceneHelper && (this._sceneHelper.setZoomEnabled(e), this.setRenderingNeeded());
  }
  async executeScriptAsync(e) {
    this._sceneActionsExecutor && (await this._sceneActionsExecutor.executeScriptAsync(e), this.notifyScriptExecution(e), this.setupShaderMaterialsCameraPosition(), this.refreshInfoPoints(), this.setLongRenderingNeeded());
  }
  async executeActionsAsync(e, t, s) {
    this._sceneActionsExecutor && (await this._sceneActionsExecutor.executeActionsAsync(e, t, s), this.notifyActionExecution(e, t, s), this.setupShaderMaterialsCameraPosition(), this.refreshInfoPoints(), this.setLongRenderingNeeded());
  }
  async prefetchMeshesForUnselectedOptionsAsync(e) {
    this._sceneActionsExecutor && await this._sceneActionsExecutor.prefetchMeshesForUnselectedOptionsAsync(e);
  }
  async prefetchDataForUnselectedOptionsAsync(e) {
    this._sceneActionsExecutor && await this._sceneActionsExecutor.prefetchDataForUnselectedOptionsAsync(e);
  }
  async refreshPBRMaterials() {
    var o, a, c, g, w;
    const e = (o = this._scene) == null ? void 0 : o.materials, t = (c = (a = this._zkScene) == null ? void 0 : a.get("config")) == null ? void 0 : c.toJSON();
    if (!t || !e)
      return;
    const s = (w = (g = t == null ? void 0 : t.general) == null ? void 0 : g.environmentOptions) == null ? void 0 : w.pbrIntensity;
    s && (e == null || e.forEach((T) => {
      T instanceof BABYLON.PBRMaterial && (T.environmentIntensity = s);
    }));
  }
  async refreshModel() {
    var s, o, a, c, g, w, T, H;
    const e = (s = this._scene) == null ? void 0 : s.meshes, t = (a = (o = this._zkScene) == null ? void 0 : o.get("config")) == null ? void 0 : a.toJSON();
    if (!(!t || !e) && ((T = this._sceneHelper) == null || T.transformEntireScene(
      (c = t.model) == null ? void 0 : c.position,
      (g = t.model) == null ? void 0 : g.rotation,
      (w = t.model) == null ? void 0 : w.scale,
      this._modelParentNode
    ), (H = t.model) != null && H.config)) {
      const Y = t.model.config.doubleSided;
      Y !== void 0 && (e == null || e.forEach((ee) => {
        ee.material instanceof BABYLON.PBRMaterial && ee.material && !(ee instanceof BABYLON.GroundMesh) && (ee.material.backFaceCulling = !Y);
      }));
    }
  }
  async refreshEnvironment() {
    if (this._zkScene && this._scene) {
      const e = this._zkScene.getOrCreateGeneralConfig().get("environmentTexture"), t = this._zkScene.getOrCreateGeneralConfig().get("environmentOptions");
      e && t && !this._scene.textures.some((s) => s.url === e) && await this.setSceneEnvironmentTexture(e, void 0, void 0, void 0, void 0, t), (!this._environmentManager || this._environmentManager.scene != this._scene || this._environmentManager.isHologram != this._isHologram) && (this._environmentManager = new Ud(this._zkScene, this._scene, this._isHologram)), this._environmentManager.update(), this.setLongRenderingNeeded(), this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._autoRender = this._camera.useAutoRotationBehavior), this.setRenderingNeeded();
    }
  }
  highlightMeshes(e) {
    if (!e || Object.prototype.toString.call(e) !== "[object Array]" || this._highlightSize == 0)
      return;
    const t = this._highlightBlurHorizontalSize, s = this._highlightBlurVerticalSize, o = (g) => {
      g.isVisible && this._highlightLayer && this._highlightLayer.addMesh(g, BABYLON.Color3.FromHexString(this._highlightColor)), g.getChildMeshes().forEach((T) => {
        T instanceof BABYLON.Mesh && o(T);
      });
    }, a = (g) => {
      this._highlightLayer && this._highlightLayer.removeMesh(g), g.getChildMeshes().forEach((T) => {
        T instanceof BABYLON.Mesh && a(T);
      });
    }, c = () => {
      if (this._highlightAnimationID && (clearInterval(this._highlightAnimationID), this._highlightAnimationID = null), this._highlightCurrentMeshes && this._highlightCurrentMeshes.forEach((g) => {
        g instanceof BABYLON.Mesh && a(g);
      }), this._highlightLayer && (this._highlightLayer.blurHorizontalSize = t, this._highlightLayer.blurVerticalSize = s), this._highlightNextMeshes) {
        const g = this._highlightNextMeshes;
        this._highlightNextMeshes = [], this.highlightMeshes(g);
      }
    };
    if (this._highlightAnimationID) {
      this._highlightNextMeshes = e, c();
      return;
    }
    if (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer) {
      this._highlightCurrentMeshes = e, e.forEach((ee) => {
        ee instanceof BABYLON.Mesh && o(ee);
      });
      const g = 800, w = 20, T = w / g;
      let H = t, Y = s;
      this._highlightAnimationID = window.setInterval(() => {
        this._highlightLayer && (H -= t * T, Y -= s * T, H = Math.max(0, H), Y = Math.max(0, Y), H >= 0 && (this._highlightLayer.blurHorizontalSize = H), Y >= 0 && (this._highlightLayer.blurVerticalSize = Y), (H == 0 || Y == 0) && c(), this.setRenderingNeeded());
      }, w), this.setRenderingNeeded();
    }
  }
  highlightGroupForMesh(e) {
    const t = this.getGroupForMesh(e);
    this.highlightGroup(t);
  }
  highlightGroupByID(e) {
    if (this._zkModel) {
      const t = this._zkModel.get("attributeGroups").findWhere({ groupID: e });
      t ? this.highlightGroup(t) : this.highlightGroup(null);
    }
  }
  highlightGroup(e) {
    if (this._zkScene && this._scene && e) {
      const s = e.get("meshSelector");
      if (s) {
        var t = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        );
        this.highlightMeshes(t);
      }
    }
  }
  getGroupForMesh(e) {
    if (this._zkModel && this._zkScene && this._scene && e && this._sceneHelper) {
      const t = this._zkModel.get("attributeGroups");
      for (let s = 0; s < t.length; s++) {
        const o = t.at(s), a = o.get("meshSelector");
        if (a) {
          const c = this._elementSelector.getMeshElements(
            this._zkScene,
            this._scene,
            null,
            a,
            MPlaza.SceneElementType.Mesh
          );
          for (let g = 0; g < c.length; g++) {
            let w = c[g];
            if (e.id == w.id || this._sceneHelper.meshHasParent(e.id, w.id))
              return o;
          }
        }
      }
    }
    return null;
  }
  highlightAttributeByID(e) {
    if (this._zkModel) {
      const t = this._zkModel.get("attributes").findWhere({ attributeID: e });
      t ? this.highlightAttribute(t) : this.highlightAttribute(null);
    }
  }
  highlightAttribute(e) {
    if (this._zkScene && this._scene && e) {
      const s = e.get("meshSelector");
      if (s) {
        var t = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          s,
          MPlaza.SceneElementType.Mesh
        );
        this.highlightMeshes(t);
      }
    }
  }
  getVisibleHiddenAttributesForMesh(e) {
    const t = [], s = (a) => {
      let c = t.find((g) => g.groupId == a);
      return c || (c = { groupId: a, visibleAttributes: [], hiddenAttributes: [] }, t.push(c)), c;
    };
    if (this._zkModel && this._zkScene && this._scene && e) {
      const a = this._zkModel.get("attributes");
      for (let c = 0; c < a.length; c++) {
        const g = a.at(c), w = g.get("attributeID"), T = g.get("meshSelector");
        if (T) {
          const H = s(g.get("groupID"));
          var o = this._elementSelector.getMeshElements(
            this._zkScene,
            this._scene,
            null,
            T,
            MPlaza.SceneElementType.Mesh
          );
          o.find((ee) => this._sceneHelper ? e.id == ee.id || this._sceneHelper.meshHasParent(e.id, ee.id) : !1) ? H.visibleAttributes.push(w) : H.hiddenAttributes.push(w);
        }
      }
    }
    return t.filter((a) => a.visibleAttributes.length > 0);
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireGroupPickedEvent(e) {
    for (let t = 0; t < this._groupPickedListeners.length; t++)
      this._groupPickedListeners[t](e);
  }
  addGroupPickedListener(e) {
    this._groupPickedListeners.push(e);
  }
  fireFocusAttributesEvent(e) {
    for (let t = 0; t < this._focusAttributesListeners.length; t++)
      this._focusAttributesListeners[t](e);
  }
  addFocusAttributesListener(e) {
    this._focusAttributesListeners.push(e);
  }
  addNotifyMessageListener(e) {
    this._designNotifyMessageListeners.push(e), this._sceneDesignManager && this._sceneDesignManager.addNotifyMessageListener(e);
  }
  addRemoveMessageListener(e) {
    this._designRemoveMessageListeners.push(e), this._sceneDesignManager && this._sceneDesignManager.addRemoveMessageListener(e);
  }
  setEventMessages(e) {
    this._designEventMessages = e, this._sceneDesignManager && this._sceneDesignManager.setEventMessages(e);
  }
  addInfoPointPickedListener(e) {
    this._infoPointPickedListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointPickedListener(e);
  }
  addInfoPointContentShownListener(e) {
    this._infoPointContentShownListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointContentShownListener(e);
  }
  addInfoPointContentHiddenListener(e) {
    this._infoPointContentHiddenListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointContentHiddenListener(e);
  }
  // begin assets loading
  addBeginAssetsLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginAssetsLoadingEvent() {
    Logger.info("Begin Assets Loading");
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndAssetsLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndAssetsLoadingEvent() {
    Logger.info("End Assets Loading");
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  addNextSceneMeshesLoadedListeners(e) {
    this._nextSceneMeshesLoadedListeners.push(e);
  }
  async fireNextSceneMeshesLoadedEvent(e, t) {
    let s = [];
    for (let o = 0; o < this._nextSceneMeshesLoadedListeners.length; ++o)
      s.push(this._nextSceneMeshesLoadedListeners[o](e, t));
    await Promise.all(s);
  }
  addNextSceneTextureLoadedListeners(e) {
    this._nextSceneTexturesLoadedListeners.push(e);
  }
  async fireNextSceneTextureLoadedEvent(e, t) {
    let s = [];
    for (let o = 0; o < this._nextSceneTexturesLoadedListeners.length; ++o)
      s.push(this._nextSceneTexturesLoadedListeners[o](e, t));
    await Promise.all(s);
  }
  addBeginSceneLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginSceneLoadingEvent() {
    Logger.info("Begin Scene Loading");
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndSceneLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndSceneLoadingEvent() {
    Logger.info("End Scene Loading");
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  // --------------------------------------------------------------
  async getSceneScreenshotAsync(e, t) {
    return this._sceneHelper ? (this.setRenderingNeeded(), await this._sceneHelper.takeScreenshotAsync(e, t)) : null;
  }
  async getSceneContentScreenshotAsync(e, t, s = 0, o, a, c) {
    if (!this._sceneHelper || !this.scene || !this.zkModel || !this.zkScene)
      return null;
    this.preSceneContentScreenshot(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null), this.setRenderingNeeded();
    let g = "";
    if (a)
      g = await this._sceneHelper.takeContentScreenshotAsync(e, t);
    else {
      const T = this._canvas;
      if (T) {
        const H = T.width, Y = T.height;
        T.width = e, T.height = t;
        const ee = this.scene.activeCamera.position.clone(), z = this.scene.activeCamera.target.clone(), he = c ? {
          position: new BABYLON.Vector3(c.get("px"), c.get("py"), c.get("pz")),
          target: new BABYLON.Vector3(c.get("tx"), c.get("ty"), c.get("tz"))
        } : {
          position: this._scene.activeCamera.position,
          target: this._scene.activeCamera.target
        };
        this._scene.activeCamera.position = he.position, this._scene.activeCamera.target = he.target, this._scene.render(), g = await this._sceneHelper.takeContentScreenshotAsync(e, t), this._scene.activeCamera.position = ee, this._scene.activeCamera.target = z, T.width = H, T.height = Y;
      }
    }
    console.log("senza Utils");
    let w = await zh(g);
    if (w || (console.error("Failed trimming image.", g), w = g), w = await Px(w, e, t, s), !w)
      throw new Error("Failed resizing image.");
    return this.refreshEnvironment(), this.postSceneContentScreenshot(), w;
  }
  preSceneContentScreenshot() {
  }
  postSceneContentScreenshot() {
  }
  preSceneMaterialScreenshot() {
    this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null);
  }
  postSceneMaterialScreenshot() {
    this.refreshEnvironment();
  }
  async getMaterialScreenshotAsync(e, t, s) {
    if (!this._scene || !this._sceneHelper)
      return null;
    this.preSceneMaterialScreenshot();
    let o = null;
    const a = await this.getSceneRootUrl();
    if (a) {
      const c = await oo.getPreviewsAsync(
        this._scene,
        a,
        [e],
        {
          width: t,
          height: s,
          crop: !0
        },
        !1
      ), g = Object.keys(c.previewFiles);
      g.length == 1 && (o = c.previewFiles[g[0]]);
    } else {
      const c = await this._sceneHelper.takeMaterialScreenshotAsync(e, t, s);
      console.log("0 TRIM IMAGE", c);
      const g = await zh(c);
      g && (o = g);
    }
    return this.postSceneMaterialScreenshot(), o;
  }
  // Used to avoid multiple listeners when using react redraw
  clearListeners() {
    this._groupPickedListeners = [], this._focusAttributesListeners = [];
  }
  // Il parametro showDesign è stato aggiunto per impedire la visualizzazione dei design sugli oggetti.
  // Un utilizzo di questo parametro viene fatto quando si vogliono ottenere le informazioni sugli item
  // del design senza volerli visualizzare perché ad esempio potrebbero essere elementi di testo con
  // dei font ancora non caricati. In tal caso andrebbero prima caricati i font e poi visualizzato il design
  async renderDesignAsync(e, t = !0) {
    if (this._scene && this._zkScene && this._zkModel && e) {
      if (this._sceneDesignManager && this._sceneDesignManager.isForModels(this._scene, this._zkModel, e))
        this._sceneDesignManager.showDesign = t, this._sceneDesignManager.rotation = this._currentRotation, await this._sceneDesignManager.refreshAsync();
      else {
        this.emptyArFileCache(), this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this._sceneDesignManager = new Ux(
          this._scene,
          this._zkScene,
          this._zkModel,
          e,
          t
        ), this._sceneDesignManager.addRenderingNeededListener(() => {
          this.setLongRenderingNeeded(), this.notifyDesignChanged(e);
        }), this._sceneDesignManager.setCustomizerGrids(this._grids), this._sceneDesignManager.setEventMessages(this._designEventMessages);
        for (const s of this._designNotifyMessageListeners)
          this._sceneDesignManager.addNotifyMessageListener(s);
        for (const s of this._designRemoveMessageListeners)
          this._sceneDesignManager.addRemoveMessageListener(s);
        await this._sceneDesignManager.refreshAsync();
      }
      this.updateHighlightLayerExcludedDesignMeshes(), this.setLongRenderingNeeded();
    }
  }
  resetDesign() {
    this._scene && this._zkScene && this._zkModel && (this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this.updateHighlightLayerExcludedDesignMeshes(), this.setLongRenderingNeeded());
  }
  clearMeshDesignManagers() {
    this._sceneDesignManager && this._sceneDesignManager.clearMeshDesignManagers();
  }
  async refreshMeshesDesignAsync(e, t) {
    e && Object.prototype.toString.call(e) === "[object Array]" && e.forEach(async (s) => await this.refreshMeshDesignAsync(s.id, void 0, t || void 0));
  }
  async refreshMeshDesignAsync(e, t = 0, s) {
    var o;
    (o = this._sceneDesignManager) == null || o.refreshMeshDesignAsync(e, t, s);
  }
  setCustomizerGrids(e) {
    var t;
    this._grids = e, (t = this._sceneDesignManager) == null || t.setCustomizerGrids(e);
  }
  removeDesignItem(e) {
    var t;
    (t = this._sceneDesignManager) == null || t.removeItem(e);
  }
  addDesignItemText(e, t) {
    var s;
    return (s = this._sceneDesignManager) == null ? void 0 : s.addItemText(e, t);
  }
  async addDesignItemImage(e, t) {
    var s;
    await ((s = this._sceneDesignManager) == null ? void 0 : s.addItemImage(e, t));
  }
  getDesignItemsInfo() {
    var e;
    return ((e = this._sceneDesignManager) == null ? void 0 : e.getItemsInfo()) || [];
  }
  setDesignItemText(e, t) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemText(e, t);
  }
  setDesignItemBold(e, t) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemBold(e, t);
  }
  setDesignItemItalic(e, t) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemItalic(e, t);
  }
  setDesignItemColor(e, t) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemColor(e, t);
  }
  setDesignItemFontFamily(e, t) {
    var s;
    (s = this._sceneDesignManager) == null || s.setItemFontFamily(e, t);
  }
  async setDesignItemImage(e, t) {
    var s;
    await ((s = this._sceneDesignManager) == null ? void 0 : s.setItemImage(e, t));
  }
  setItemTextOnPath(e, t, s) {
    var o;
    (o = this._sceneDesignManager) == null || o.setItemTextOnPath(e, t, s);
  }
  removeDesignItemImage(e) {
    var t;
    (t = this._sceneDesignManager) == null || t.removeItemImage(e);
  }
  setDesignVisibility(e, t) {
    var s;
    (s = this._sceneDesignManager) == null || s.setDesignVisibility(e, t);
  }
  setupShaderMaterialsCameraPosition() {
    if (this._scene)
      for (let e = 0; e < this._scene.materials.length; e++) {
        const t = this._scene.materials[e];
        this.setupShaderMaterialCameraPosition(t);
      }
  }
  setupShaderMaterialCameraPosition(e) {
    this._scene && this._scene.activeCamera && e && e instanceof BABYLON.ShaderMaterial && e.setVector3("cameraPosition", this._scene.activeCamera.position);
  }
  setMeshLocation(e) {
    this._meshLocationsManager && this._meshLocationsManager.setMeshLocationByID(e);
  }
  async explodeMeshes() {
    this._meshLocationsManager && await this._meshLocationsManager.explodeMeshes();
  }
  async collapseMeshes() {
    this._meshLocationsManager && await this._meshLocationsManager.collapseMeshes();
  }
  dracoDecodingFunction(e, t, s) {
    this.decodeDracoFile(e, t, s);
  }
  decodeDracoFile(e, t, s) {
    var o = (/* @__PURE__ */ new Date()).getTime(), a = new Uint8Array(t), c = msgpack.decode(a);
    this.dracoCompression.decodeMeshAsync(c.data, c.attributes).then(function(g) {
      let w = {};
      g && (g.indices && (w.indices = g.indices), g.positions && (w.positions = g.positions), g.normals && (w.normals = g.normals), g.tangents && (w.tangents = g.tangents), g.uvs && (w.uvs = g.uvs), g.uvs2 && (w.uv2s = g.uvs2), g.uvs3 && (w.uv3s = g.uvs3), g.uvs4 && (w.uv4s = g.uvs4), g.uvs5 && (w.uv5s = g.uvs5), g.uvs6 && (w.uv6s = g.uvs6));
      var T = /* @__PURE__ */ new Date(), H = T.getTime(), Y = H - o, ee = T.getHours() + ":" + T.getMinutes() + ":" + T.getSeconds() + "." + T.getMilliseconds();
      console.log(
        "Draco Decoding [" + ee + "] - " + e + "	" + t.byteLength + "	" + Y + " ms"
      ), s && s(w);
    });
  }
  exportSceneToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : this._sceneHelper.exportSceneToBabylon();
  }
  exportVisibleMeshesToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : this._sceneHelper.exportVisibleMeshesToBabylon();
  }
  async exportMeshesForTyOnToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : await this._sceneHelper.exportMeshesForTyOnToBabylon();
  }
  async exportMeshToBabylon(e) {
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return null;
    const t = this._scene.getMeshById(e);
    return t ? await this._sceneHelper.exportMeshToBabylon(t) : null;
  }
  async downloadMeshToBabylon(e) {
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return;
    const t = this._scene.getMeshById(e);
    t && await this._sceneHelper.downloadMeshBabylonAsync(t);
  }
  async saveSceneOnDatabaseAsync(e) {
    const t = this.exportSceneToBabylon();
    if (t) {
      const s = new Ef();
      await s.openAsync(), await s.saveFileAsync(e, t);
    }
  }
  async saveVisibleMeshesOnDatabaseAsync(e) {
    const t = await this.exportMeshesForTyOnToBabylon();
    if (t) {
      const s = new Ef();
      await s.openAsync(), await s.saveFileAsync(e, t);
    }
  }
  async saveGlbOnDatabaseAsync(e) {
    let t = null, s = "";
    if (t = await this.exportSceneToLocalGLBAsync(), t) {
      const o = await t.arrayBuffer(), a = Math.random().toString(36).substring(7), c = new FormData();
      c.append("blob", new Blob([o]), `model_${a}.glb`);
      try {
        const g = await fetch(Zakeke.config.baseApiUrl + "tryonassetupload/asset-upload", {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + window.token
          },
          body: c
        });
        if (g.status === 200)
          return s = await g.text(), s = s.replace(/^"|"$/g, "").substring(s.indexOf("fileUrl=") + 8 - 1), console.log("solo parametro restituito da asset-upload", s), s;
        console.error("Error uploading model", g);
      } catch (g) {
        console.error("Error uploading model", g);
      }
    }
    return s;
  }
  getArFileUrlCacheKey(e, t, s = "usdz") {
    let o = "scene_" + e;
    if (t && (o += "_code_" + t), this._sceneDesignManager) {
      var a = this._sceneDesignManager.getDesignItemsJson();
      if (a) {
        var c = CryptoJS.SHA1(a).toString();
        o += "_design_" + this._sceneDesignManager.getDesignID() + "_" + c;
      }
    }
    return o += "_" + s, o;
  }
  getCachedArFileUrl(e, t, s = "usdz") {
    var o = this.getArFileUrlCacheKey(e, t, s);
    return this._arFileUrls.hasOwnProperty(o) ? this._arFileUrls[o] : null;
  }
  cacheArFileUrl(e, t, s, o) {
    if (o) {
      var a = this.getArFileUrlCacheKey(e, t || void 0, s);
      this._arFileUrls[a] = o;
    }
  }
  async exportMeshToGLBBlob(e) {
    var a, c, g, w;
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return null;
    let t = null;
    const s = this._zkScene.get("rootUrl");
    s && (t = s), await ((a = this._sceneDesignManager) == null ? void 0 : a.changeToRasterizedTextures()), (c = this._sceneDesignManager) == null || c.expandCanvasMeshes(0.05);
    let o = await this._sceneHelper.exportMeshToGLBBlob(t, e);
    return console.log("dopo l'export faccio rientrare l'expand", o), (g = this._sceneDesignManager) == null || g.expandCanvasMeshes(-0.05), await ((w = this._sceneDesignManager) == null ? void 0 : w.changeToDynamicTextures()), o;
  }
  async exportSceneToUsdzAsync(e, t, s) {
    var H, Y, ee, z;
    if (!this._zkScene || !this._sceneHelper)
      return null;
    const o = "usdz";
    let a = null;
    if (e && (!this._sceneDesignManager || s) && (a = this.getCachedArFileUrl(e, t, o)), a)
      return a;
    let c = null, g = null;
    const w = this._zkScene.get("name");
    w && (c = w);
    const T = this._zkScene.get("rootUrl");
    return T && (g = T), await ((H = this._sceneDesignManager) == null ? void 0 : H.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), a = await this._sceneHelper.exportSceneToUsdzAsync(
      c,
      g,
      this._sceneDesignManager && !s ? void 0 : e,
      this._sceneDesignManager && !s ? void 0 : t,
      ((Y = this.zkScene) == null ? void 0 : Y.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (ee = this._zkScene) == null ? void 0 : ee.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((z = this._sceneDesignManager) == null ? void 0 : z.changeToDynamicTextures()), a && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, o, a), a;
  }
  async exportMeshToUsdzAsync(e) {
    var s, o, a;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let c = null;
      const g = this._zkScene.get("rootUrl");
      g && (c = g), await ((s = this._sceneDesignManager) == null ? void 0 : s.changeToRasterizedTextures());
      const w = await this._sceneHelper.exportMeshToUsdzAsync(
        c,
        t,
        ((o = this.zkScene) == null ? void 0 : o.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return await ((a = this._sceneDesignManager) == null ? void 0 : a.changeToDynamicTextures()), Logger.info("USDZ: " + w), w;
    }
    return null;
  }
  async exportSceneToRemoteGlTFAsync(e, t, s) {
    var w, T, H, Y;
    if (!this._sceneHelper)
      return null;
    const o = "glTF";
    let a = null;
    if (e && (!this._sceneDesignManager || s) && (a = this.getCachedArFileUrl(e, t, o)), a)
      return a;
    let c = null, g = null;
    if (this._zkScene) {
      const ee = this._zkScene.get("name");
      ee && (c = ee);
      const z = this._zkScene.get("rootUrl");
      z && (g = z);
    }
    return await ((w = this._sceneDesignManager) == null ? void 0 : w.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), a = await this._sceneHelper.exportSceneToRemoteGlTFAsync(
      c,
      g,
      this._sceneDesignManager && !s ? void 0 : e,
      this._sceneDesignManager && !s ? void 0 : t,
      ((T = this.zkScene) == null ? void 0 : T.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (H = this._zkScene) == null ? void 0 : H.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((Y = this._sceneDesignManager) == null ? void 0 : Y.changeToDynamicTextures()), a && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, o, a), Logger.info("GlTF: " + a), a;
  }
  async exportMeshToRemoteGlTFAsync(e) {
    var s, o, a;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let c = null;
      const g = this._zkScene.get("rootUrl");
      g && (c = g), await ((s = this._sceneDesignManager) == null ? void 0 : s.changeToRasterizedTextures());
      const w = await this._sceneHelper.exportMeshToRemoteGlTFAsync(
        c,
        t,
        ((o = this.zkScene) == null ? void 0 : o.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return Logger.info("GlTF: " + w), await ((a = this._sceneDesignManager) == null ? void 0 : a.changeToDynamicTextures()), w;
    }
    return null;
  }
  async exportSceneToRemoteGLBAsync(e, t, s) {
    var w, T, H, Y;
    if (!this._sceneHelper)
      return null;
    const o = "glb";
    let a = null;
    if (e && (!this._sceneDesignManager || s) && (a = this.getCachedArFileUrl(e, t, o)), a)
      return a;
    let c = null, g = null;
    if (this._zkScene) {
      const ee = this._zkScene.get("name");
      ee && (c = ee);
      const z = this._zkScene.get("rootUrl");
      z && (g = z);
    }
    return await ((w = this._sceneDesignManager) == null ? void 0 : w.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), a = await this._sceneHelper.exportSceneToRemoteGLBAsync(
      c,
      g,
      this._sceneDesignManager && !s ? void 0 : e,
      this._sceneDesignManager && !s ? void 0 : t,
      ((T = this.zkScene) == null ? void 0 : T.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (H = this._zkScene) == null ? void 0 : H.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((Y = this._sceneDesignManager) == null ? void 0 : Y.changeToDynamicTextures()), a && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, o, a), Logger.info("GLB: " + a), a;
  }
  async exportMeshToRemoteGLBAsync(e) {
    var s, o, a;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let c = null;
      const g = this._zkScene.get("rootUrl");
      g && (c = g), await ((s = this._sceneDesignManager) == null ? void 0 : s.changeToRasterizedTextures());
      const w = await this._sceneHelper.exportMeshToRemoteGLBAsync(
        c,
        t,
        ((o = this.zkScene) == null ? void 0 : o.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return Logger.info("GlTF: " + w), await ((a = this._sceneDesignManager) == null ? void 0 : a.changeToDynamicTextures()), w;
    }
    return null;
  }
  // Esporta la scena nei formati glb e usdz utili per visualizzarli con model-viewer
  // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  async exportSceneToARAsync(e, t) {
    var c, g;
    let s = [];
    if (!this._sceneHelper)
      return s;
    let o = null, a = null;
    if (this._zkScene) {
      const w = this._zkScene.get("name");
      w && (o = w);
      const T = this._zkScene.get("rootUrl");
      T && (a = T);
    }
    return await ((c = this._sceneDesignManager) == null ? void 0 : c.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), s = await this._sceneHelper.exportSceneToARMultiformatAsync(
      o,
      a,
      ["usdz", "glb"],
      e,
      t
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((g = this._sceneDesignManager) == null ? void 0 : g.changeToDynamicTextures()), s;
  }
  // Esporta la mesh nei formati glb e usdz utili per visualizzarli con model-viewer
  // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  async exportMeshToARAsync(e) {
    var o, a, c;
    let t = [];
    const s = this.getMeshByID(e);
    if (s && this._zkScene && this._sceneHelper) {
      let g = null;
      const w = this._zkScene.get("rootUrl");
      w && (g = w), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToRasterizedTextures()), t = await this._sceneHelper.exportMeshToARMultiformatAsync(
        g,
        s,
        ["usdz", "glb"],
        ((a = this.zkScene) == null ? void 0 : a.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      ), await ((c = this._sceneDesignManager) == null ? void 0 : c.changeToDynamicTextures());
    }
    return t;
  }
  isAREnabled() {
    if (!this._zkScene)
      return !1;
    let e = this._zkScene.getAREnabled();
    return e != null && e && this._sceneHelper != null && // this._sceneHelper.getMeshesForAR().length > 0 &&
    this._sceneHelper.checkMaterialsForAR();
  }
  async exportSceneToLocalGLBAsync() {
    var t, s;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes();
    let e = null;
    return this._sceneHelper && (e = await this._sceneHelper.exportSceneToLocalGLBBlobAsync()), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((s = this._sceneDesignManager) == null ? void 0 : s.changeToDynamicTextures()), e;
  }
  async downloadSceneLocalGLBAsync() {
    this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), this._sceneHelper && await this._sceneHelper.downloadSceneLocalGLBAsync(), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes();
  }
  async exportSceneToLocalUSDZAsync() {
    var t, s;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes();
    let e = null;
    return this._sceneHelper && (e = await this._sceneHelper.exportSceneToLocalUSDZUrlAsync()), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((s = this._sceneDesignManager) == null ? void 0 : s.changeToDynamicTextures()), e;
  }
  async downloadSceneLocalUSDZAsync() {
    this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), this._sceneHelper && await this._sceneHelper.downloadSceneLocalUSDZAsync(), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes();
  }
  getSceneRootUrl() {
    return new Promise((e, t) => {
      let s = null;
      this._zkScene ? (s = this._zkScene.get("rootUrl") || null, s ? e(s) : jQuery.ajax({
        url: this._zkScene.getSceneRootUrlApiUrl(),
        type: "GET",
        success: function(o) {
          s = o, e(s);
        },
        error: function(o, a, c) {
          t(c);
        }
      })) : e(s);
    });
  }
  isTryOnMeshVisibleEnabledToShow() {
    const e = this.getVisibleMeshes();
    for (const t of e) {
      const s = t.getChildren();
      if (s.length > 0 && s.find(
        (a) => this._sceneHelper.isTryOnEnabledForMesh(a)
      ) && this._sceneHelper.isTryOnEnabledForMesh(t))
        return !0;
    }
    return !1;
  }
  getTryOnMeshVisible() {
    const e = this.getVisibleMeshes();
    for (let t of e) {
      const s = t.getChildren();
      if (s.length > 0 && !t.parent && s.find(
        (a) => {
          var c;
          return (c = this._sceneHelper) == null ? void 0 : c.isTryOnEnabledForMesh(a);
        }
      ))
        return t;
    }
    return null;
  }
  getFrameDAMSettings() {
    if (this._zkScene) {
      const e = this._zkScene.getFrameDAMSettings() ?? null;
      if (e)
        return JSON.parse(e);
    }
    return null;
  }
  getMeshFineTuningData(e) {
    const t = typeof e == "string" ? this.getMeshByID(e) : e;
    return t && t.metadata && t.metadata.tryOnFineTuningSettings ? t.metadata.tryOnFineTuningSettings : null;
  }
  getDAMFineTuningData() {
    var e, t;
    return (e = this.zkScene) != null && e.getFrameDAMSettings() && ((t = this.getFrameDAMSettings()) == null ? void 0 : t.finetuning) || null;
  }
  getTryOnFineTuningMeshVisible() {
    var t;
    const e = this.getVisibleMeshes();
    for (const s of e) {
      const o = s.getChildren();
      if (o.length > 0 && o.find(
        (c) => {
          var g;
          return (g = this._sceneHelper) == null ? void 0 : g.isTryOnEnabledForMesh(c);
        }
      ) && (t = s == null ? void 0 : s.metadata) != null && t.tryOnFineTuningSettings)
        return s;
    }
    return null;
  }
  refreshInfoPoints() {
    if (!(this._zkScene && this._zkScene.getInfoPointsEnabled() && this.canShowInfoPoints)) {
      this.disposeInfoPointsManager(), this.setLongRenderingNeeded();
      return;
    }
    const t = this.getInfoPointsManagerStyle();
    let s = null;
    this._infoPointsManager || this._scene && this._zkScene && (this._infoPointsManager = new qx(this._zkScene, this._scene, t), this._infoPointPickedListeners && this._infoPointPickedListeners.length > 0 && this._infoPointsManager.addInfoPointPickedListenerRange(this._infoPointPickedListeners), this._infoPointContentShownListeners && this._infoPointContentShownListeners.length > 0 && this._infoPointsManager.addInfoPointContentShownListenerRange(this._infoPointContentShownListeners), this._infoPointContentHiddenListeners && this._infoPointContentHiddenListeners.length > 0 && this._infoPointsManager.addInfoPointContentHiddenListenerRange(
      this._infoPointContentHiddenListeners
    ), this._infoPointsManager.onBeforeShowImages = () => {
      s === null && (s = this.antiAliasConfig.enabled), this.antiAliasConfig.enabled = !1, this.disableAntialiasing();
    }, this._infoPointsManager.onAfterShowImages = () => {
      this.antiAliasConfig.enabled = s, s = null, this.enableAntialiasing(), this.setLongRenderingNeeded();
    }, this._infoPointsManager.addRenderingNeededListener(() => this.setRenderingNeeded())), this._infoPointsManager && (this.updateInfoPointsManagerStyle(), this._infoPointsManager.canShowInfoPointsContent = this.canShowInfoPointsContent, this._infoPointsManager.refresh()), this.setLongRenderingNeeded();
  }
  getInfoPointsManagerStyle() {
    const e = this._infoPointsManagerStyle ? this._infoPointsManagerStyle : {};
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsStyleConfig();
      t && (e.infoPointsStyle || (e.infoPointsStyle = {}), t.get("borderColor") && (e.infoPointsStyle.borderColor = t.get("borderColor")), t.get("innerPointColor") && (e.infoPointsStyle.innerPointColor = t.get("innerPointColor")), t.get("color") && (e.infoPointsStyle.color = t.get("color")), t.get("highlightColor") && (e.infoPointsStyle.highlightColor = t.get("highlightColor")));
    }
    return e;
  }
  updateInfoPointsManagerStyle() {
    if (this._infoPointsManager) {
      const e = this.getInfoPointsManagerStyle();
      this._infoPointsManager.applyStyle(e);
    }
  }
  showInfoPoints() {
    this._infoPointsManager && (this._infoPointsManager.showInfoPoints(), this.render(), this.setRenderingNeeded());
  }
  hideInfoPoints() {
    this._infoPointsManager && (this._infoPointsManager.hideInfoPoints(), this.render(), this.setRenderingNeeded());
  }
  // try to reload all textures with loading errors
  async reloadAllLoadingErrorTexturesAsync() {
    if (this._zkScene && this._sceneHelper) {
      const e = this._zkScene.get("rootUrl");
      e && await this._sceneHelper.reloadAllLoadingErrorTexturesAsync(e);
    }
  }
  // try to reload the material textures with loading errors
  async reloadMaterialLoadingErrorTexturesAsync(e) {
    if (this._zkScene && this._sceneHelper) {
      const t = this._zkScene.get("rootUrl");
      t && await this._sceneHelper.reloadMaterialLoadingErrorTexturesAsync(t, e);
    }
  }
  // try to reload the texture having loading errors
  async reloadLoadingErrorTextureAsync(e) {
    if (this._zkScene && this._sceneHelper) {
      const t = this._zkScene.get("rootUrl");
      t && await this._sceneHelper.reloadLoadingErrorTextureAsync(t, e);
    }
  }
  // were there any loading errors for the texture?
  isTextureLoadingError(e) {
    return this._sceneHelper ? this._sceneHelper.isTextureLoadingError(e) : !1;
  }
  // the material has some texture with loading errors
  materialHasLoadingErrorTextues(e) {
    return this._sceneHelper ? this._sceneHelper.materialHasLoadingErrorTextues(e) : !1;
  }
  notifyCameraMovement() {
    if (this._isHologramSource && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      let e = this.getOrCreateBroadcastChannel();
      if (!e)
        return;
      e.postMessage({
        type: "camera-movement",
        target: { x: this._camera.target.x, y: this._camera.target.y, z: this._camera.target.z },
        alpha: this._camera.alpha,
        beta: this._camera.beta,
        radius: this._camera.radius
      });
    }
  }
  notifyScriptExecution(e) {
    if (this._isHologramSource) {
      const t = e.map((o) => ({
        attributeID: o.attributeID,
        selectedValue: o.selectedValue,
        actions: o.actions.map((a) => a.toJSON())
        /*
        actions: s.actions.map(a => ({
        	attributeGuid: a.get("actionGuid"),
        	name: a.get("name"),
        	actionTypeID: a.get("actionTypeID"),
        	sceneElementTypeID: a.get("sceneElementTypeID"),
        	selector: a.get("selector"),
        	propertyName: a.get("propertyName"),
        	value: a.get("value"),
        	execOrder: a.get("execOrder"),
        	deviceTypes: a.get("deviceTypes")
        }))
        */
      }));
      let s = this.getOrCreateBroadcastChannel();
      if (!s)
        return;
      s.postMessage({
        type: "script-execution",
        script: t
      });
    }
  }
  notifyDesignChanged(e) {
    if (this._isHologramSource) {
      let t = this.getOrCreateBroadcastChannel();
      if (!t)
        return;
      t.postMessage({
        type: "design-changed",
        design: e.toJSON()
      });
    }
  }
  notifyActionExecution(e, t, s) {
    this.notifyScriptExecution([
      {
        attributeID: e,
        selectedValue: t,
        actions: s
      }
    ]);
  }
  attachBroadcastChannelEventHandlers() {
    if (this._isHologram && !this._isHologramSource) {
      var e = this.getOrCreateBroadcastChannel();
      if (!e)
        return;
      e.onmessage = (t) => this.onBroadcastMessageReceived(t);
    }
  }
  detachBroadcastChannelEventHandlers() {
    this._broadcastChannel && (this._broadcastChannel.onmessage = null);
  }
  onBroadcastMessageReceived(e) {
    this._isHologram && e && e.data && e.data.type && (e.data.type === "camera-movement" ? this.processCameraMovementEvent(e) : e.data.type === "script-execution" ? this.processScriptExecution(e) : e.data.type === "design-changed" && this.processDesignChanged(e));
  }
  processCameraMovementEvent(e) {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && e && e.data && (this._camera.target = new BABYLON.Vector3(e.data.target.x, e.data.target.y, e.data.target.z), this._camera.alpha = e.data.alpha, this._camera.beta = e.data.beta, this._camera.radius = e.data.radius, this.setRenderingNeeded());
  }
  processScriptExecution(e) {
    if (e && e.data && e.data.script && Object.prototype.toString.call(e.data.script) === "[object Array]") {
      var t = e.data.script.map(
        (s) => ({
          attributeID: s.attributeID,
          selectedValue: s.selectedValue,
          actions: s.actions.map((o) => new MPlaza.AttributeSceneAction(o))
        })
      );
      this.executeScriptAsync(t);
    }
  }
  processDesignChanged(e) {
    if (e && e.data && e.data.design) {
      let t = new MPlaza.Design(e.data.design);
      this.renderDesignAsync(t);
    }
  }
  loadSceneConfig(e) {
    const t = new Zakeke.SceneConfig(e);
    if (this._zkScene && !this._zkScene.get("config"))
      this._zkScene.set("config", t);
    else {
      const s = new Zakeke.Scene();
      s.set("config", t), this._zkScene = s;
    }
    this.checkSceneShaderMaterials(this._zkScene);
  }
  updateFromConfig(e, t) {
    var s, o;
    if (this._zkScene) {
      let a = (o = (s = this._zkScene) == null ? void 0 : s.get("config")) == null ? void 0 : o.toJSON();
      const c = ew.merge(a, e), g = new Zakeke.SceneConfig(c);
      if (this._zkScene.set("config", g), (t == null ? void 0 : t.preventRefresh) === !0)
        return;
      this.setupSceneAsync((t == null ? void 0 : t.updateCamera) === !0);
    }
  }
  /**
   * Set up new camera position if parameter is present in config
   */
  refreshCameraPosition() {
    var s, o, a;
    const e = (o = (s = this._zkScene) == null ? void 0 : s.get("config")) == null ? void 0 : o.toJSON(), t = e == null ? void 0 : e.camera;
    t && (t != null && t.position) && ((a = this._sceneHelper) == null || a.setUpCameraByOptions(t.position));
  }
  setupDebugGUI() {
    var s;
    const e = (s = this._zkScene) == null ? void 0 : s.get("config"), t = (o) => {
      this.updateFromConfig(o, { updateCamera: !1 });
    };
    this._createGui = new Ew(
      e.toJSON(),
      (o) => t(o),
      this._sceneHelper
    ), this._createGui.setupGui(this._scene);
  }
  async setUpEmptyScene(e) {
    this._scene && (e && this.loadSceneConfig(e), await this.setupSceneAsync(), this.setRenderingNeeded());
  }
  /**
   * Loads a babylon scene from a remote URL.
   * @param rootUrl The root URL of the scene.
   * @param sceneFileName The name of the scene file.
   * @param sceneConfig Optional scene configuration.
   */
  async loadFromSceneUrl(e, t, s) {
    await this.loadSceneFromRemoteFilesAsync(e, t), s && this.loadSceneConfig(s), await this.setupSceneAsync(), this.setRenderingNeeded();
  }
  /**
   * Loads a scene from a GLB file URL.
   * @param url The URL of the GLB file.
   * @param sceneConfig Optional scene configuration.
   */
  async loadFromGlbUrl(e, t) {
    var o, a, c;
    const s = ((o = t == null ? void 0 : t.camera) == null ? void 0 : o.animateIntro) !== void 0 ? (a = t == null ? void 0 : t.camera) == null ? void 0 : a.animateIntro : !0;
    await ((c = this._sceneHelper) == null ? void 0 : c.importMeshesFromUrlAsync(e, null, void 0, s, ".glb", this._isViewer)), t && this.loadSceneConfig(t), await this.setupSceneAsync(), this.updateView(!1, !0);
  }
  /**
   * Loads a scene from a file.
   * @param file The file to load the scene from.
   */
  async loadFromFile(e, t) {
    var s, o;
    ((s = t == null ? void 0 : t.camera) == null ? void 0 : s.animateIntro) !== void 0 && ((o = t == null ? void 0 : t.camera) == null || o.animateIntro);
    try {
      await BABYLON.SceneLoader.AppendAsync(e.name, e, this._scene);
    } catch (a) {
      console.log("dropObjectIntoScene: ", a);
    }
    t && this.loadSceneConfig(t), await this.setupSceneAsync(), this.updateView(!0, !0), this.setRenderingNeeded();
  }
  async showResizableCanvasModel(e) {
    if (this._scene && this._zkScene && this._zkModel && this._sceneHelper) {
      const t = await this._sceneHelper.showResizableCanvas(
        e.width,
        e.height,
        e.depth,
        e.borderRadius,
        e.type,
        e.borderColor,
        e.columns,
        e.rows,
        e.ppcm
      );
      if (!t)
        return { meshes: [], matrixJson: "" };
      const s = new aw.PaperScope();
      s.setup(new s.Size(1, 1));
      const o = new s.Matrix(), a = zd.DEFAULT_SIZE;
      o.translate(a / 2, a / 2), o.scale(a / e.width, a / e.height);
      const c = JSON.stringify(o.values);
      return { meshes: t, matrixJson: c };
    }
    return { meshes: [], matrixJson: "" };
  }
  async showResizableCanvasPerCurrentSide(e) {
    console.log("showResizableCanvasPerCurrentSide", e);
    const t = `resizable-canvas-${e.width}-${e.height}-${e.colorId}-${e.currentSideId}-${e.columns}-${e.rows}-${e.type}-${e.borderColor}`;
    if (this._lastResizableMeshID === t)
      return;
    this._lastResizableMeshID = t;
    const s = await this.showResizableCanvasModel(e);
    if (s.meshes.length === 0)
      return;
    const o = this._zkModel.get("scenes").at(0).get("meshSides");
    o.filter((w) => w.get("isResizable")).forEach((w) => o.remove(w));
    const c = e.type === "mirrored" ? ["front", "borders"] : ["front"];
    let g = 0;
    for (const w of s.meshes)
      if (w && c.includes(w.name)) {
        w.id = t.replace("sideIdPlaceholder", e.currentSideId.toString()) + g++;
        const T = new MPlaza.ModelSceneMeshSide({
          sideID: e.currentSideId,
          meshID: w.id,
          uvChannel: 0,
          percWidth: 1,
          percHeight: 1,
          subMeshID: 0,
          matrix: s.matrixJson,
          isResizable: !0
        });
        o.push(T);
      }
    console.log({ meshSides: o }), setTimeout(() => this.adjustCamera(!1), 100);
  }
  async showResizableCanvasPerVariant(e) {
    if (console.log("showResizableCanvasPerVariant", e), !this.zkModel)
      return;
    const t = `resizable-canvas-${e.width}-${e.height}-${e.colorId}-sideIdPlaceholder-${e.columns}-${e.rows}-${e.type}-${e.borderColor}`;
    if (this._lastResizableMeshID === t)
      return;
    this._lastResizableMeshID = t;
    const s = await this.showResizableCanvasModel(e);
    if (s.meshes.length === 0)
      return;
    let o = 0;
    const a = e.sidesIds.length > 1;
    let c = ["front", "back", "borders"];
    e.type === "colored" ? a ? c = ["front", "back"] : c = ["front"] : e.type === "mirrored" && (a ? c = ["front", "back", "borders"] : c = ["front", "borders"]);
    const g = this._zkModel.get("scenes").at(0).get("meshSides");
    g.filter((T) => T.get("isResizable")).forEach((T) => g.remove(T));
    for (const T of s.meshes)
      if (T && c.includes(T.name)) {
        const H = !a || T.name === "front" ? e.sidesIds[0] : e.sidesIds[1];
        T.id = t.replace("sideIdPlaceholder", H.toString()) + o++;
        const Y = new MPlaza.ModelSceneMeshSide({
          sideID: H,
          meshID: T.id,
          uvChannel: 0,
          percWidth: 1,
          percHeight: 1,
          subMeshID: 0,
          matrix: s.matrixJson,
          isResizable: !0
        });
        g.push(Y);
      }
    setTimeout(() => this.adjustCamera(!1), 100);
  }
  clearResizableProduct() {
    var e;
    (e = this._sceneHelper) == null || e.clearResizableMeshes();
  }
  setMouseWheelInputEnabled(e) {
    this._camera && this._mouseWheelInput && (e ? this._camera.inputs.add(this._mouseWheelInput) : this._camera.inputs.remove(this._mouseWheelInput));
  }
  setCameraPinchingZoom(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.inputs.attached.pointers;
      t.pinchZoom = e, t.multiTouchPanAndZoom = e;
    }
  }
  switchMode(e) {
    var t;
    e === "upload" && (this._lastResizableMeshID = ""), (t = this._sceneHelper) == null || t.switchMode(e), setTimeout(() => this.adjustCamera(!1), 100);
  }
  async setCanvasRotation(e, t) {
    var w;
    if (e = e % 360, this._isRotating || !this._zkModel || !this._sceneHelper || !this._sceneDesignManager || this._currentRotation === e)
      return;
    const s = this._zkModel.get("scenes").at(0).get("meshSides");
    if (s.length === 0)
      return;
    const a = s.at(0).get("meshID"), c = this.getMeshByID(a);
    if (!c)
      return;
    const g = c.getFacetNormal(0);
    this._isRotating = !0, await ((w = this._sceneHelper) == null ? void 0 : w.rotate(this._currentRotation - e, g, t)), this._currentRotation = e, this._isRotating = !1, this._sceneDesignManager.rotation = this._currentRotation, await this._sceneDesignManager.refreshAsync(), this.setRenderingNeeded();
  }
  getFitToScreenMargin() {
    return this._zkScene ? this._zkScene.getFitToScreenMargin() : 1;
  }
  setFitToScreenMargin(e) {
    this._zkScene && this._zkScene.setFitToScreenMargin(e);
  }
}
class Iw {
  constructor(e) {
    this.materials = [], this.guid = Zakeke.generateUUID(), this.groupName = e;
  }
}
var kw = /* @__PURE__ */ ((v) => (v[v.uploading = 0] = "uploading", v[v.progress = 1] = "progress", v[v.checking = 2] = "checking", v[v.success = 3] = "success", v[v.completed_success = 4] = "completed_success", v[v.completed_error = 5] = "completed_error", v))(kw || {});
const ng = class ol extends pu {
  constructor(e) {
    super({ configPreview: !0 }), this._dracoEnabled = !0, this._dracoEncodingSpeed = 5, this._dracoDecodingSpeed = 5, this._envMode = Ss.Editor, this._selectOnPick = !0, this._showBoundingBox = !1, this._editorBackgroundColor = "#444444", this._showGround = !0, this._ground = null, this._showLights = !1, this._lightsLayer = null, this._showAxes = !1, this._axesLayer = null, this._showFineTuning = !1, this._fineTuningModelLoaded = !1, this._showHighlight = !0, this._highlightOver = !0, this._highlightOverColor = "#0082ff", this._editingMode = Za.None, this._manipulatedNode = null, this._oldManipulatedNode = null, this._EditControl = org.ssatguru.babylonjs.component.EditControl, this._editControl = null, this._editControlVisible = !1, this._shiftPressed = !1, this._ctrlPressed = !1, this._realMeshVisibility = {}, this._sceneSourceTasks = [], this._isLoadingSourceFiles = !1, this._authorizationToken = "", this._incrementalWorkersScriptsUrls = [], this._preUpdateListeners = [], this._postUpdateListeners = [], this._meshSelectedListeners = [], this._selectionChangedListeners = [], this._lightSelectedListeners = [], this._sceneCreatedListeners = [], this._cameraLocationCreatedListeners = [], this._sceneSourceTaskSuccessListeners = [], this._sceneSourceTaskErrorListeners = [], this._sceneSourceTasksCheckListeners = [], this._meshesUpdateListeners = [], this._materialsUpdateListeners = [], this._lightsUpdateListeners = [], this._cameraLocationsUpdateListeners = [], this._meshLocationCreatedListeners = [], this._meshLocationsUpdateListeners = [], this._arTaskSuccessListeners = [], this._arTaskErrorListeners = [], this._arTasksCheckListeners = [], this._tryOnFineTuningSettingListeners = [], this._tryOnFineTuningCloseListeners = [], this._pickedProvider = Wd.NotSelected, this._providerData = { mesh: new Blob() }, this._sessionTryOnEnabled = !1, this._tryOnInfoLoading = !0, this._initialMeshMaterials = {}, this._initialSubMeshMaterials = {}, this._lastMeshMaterials = {}, this._lastSubMeshMaterials = {}, this._meshOver = null, this._incrementalFilesMaker = null, this._sceneToBlobs = null, this._showMeasurements = !1, this._modelMeasurements = BABYLON.Vector3.Zero(), e && (this._incrementalWorkersScriptsUrls = e.incrementalWorkersScriptsUrls, this._authorizationToken = e.authorizationToken, e.showGround != null && e.showGround != null && (this._showGround = e.showGround), e.editorBackgroundColor !== void 0 && e.editorBackgroundColor !== null && (this._editorBackgroundColor = e.editorBackgroundColor), e.showHighlight !== void 0 && e.showHighlight !== null && (this._showHighlight = e.showHighlight), e.highlightColor !== void 0 && e.highlightColor !== null && (this._highlightColor = e.highlightColor), e.highlightOver !== void 0 && e.highlightOver != null && (this._highlightOver = e.highlightOver), e.highlightOverColor !== void 0 && e.highlightOverColor != null && (this._highlightOverColor = e.highlightOverColor));
  }
  // Real mesh visibility
  get realMeshVisibility() {
    return this._realMeshVisibility;
  }
  // Environemnt manager
  get environmentManager() {
    return this._environmentManager;
  }
  // EnvMode
  get envMode() {
    return this._envMode;
  }
  // Source tasks
  get sceneSourceTasks() {
    return this._sceneSourceTasks;
  }
  set envMode(e) {
    this._envMode != e && (this._envMode = e, this.refreshEnvironment());
  }
  // SelectOnPick
  get selectOnPick() {
    return this._selectOnPick;
  }
  set seletOnPick(e) {
    this._selectOnPick != e && (this._selectOnPick = e);
  }
  // ShowBoundingBox
  get showBoundingBox() {
    return this._showBoundingBox;
  }
  set showBoundingBox(e) {
    this._showBoundingBox != e && (this._showBoundingBox = e, this.updateBoundingBox(), this.setRenderingNeeded());
  }
  // EditorBackgroundColor
  get editorBackgroundColor() {
    return this._editorBackgroundColor;
  }
  set editorBackgroundColor(e) {
    this._editorBackgroundColor != e && this.setEditorBackgroundColor(e);
  }
  // ShowGround
  get showGround() {
    return this._showGround;
  }
  set showGround(e) {
    this._showGround != e && (this._showGround = e, this.refreshGround());
  }
  // ShowLights
  get showLights() {
    return this._showLights;
  }
  set showLights(e) {
    this._showLights != e && (this._showLights = e, this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded());
  }
  // ShowAxes
  get showAxes() {
    return this._showAxes;
  }
  set showAxes(e) {
    this._showAxes != e && (this._showAxes = e, this._axesLayer && this._axesLayer.refresh(), this.setRenderingNeeded());
  }
  get showFineTuning() {
    return this._showFineTuning;
  }
  set showFineTuning(e) {
    this._showFineTuning = e, this._fineTuningModelLoaded = !1;
  }
  set fineTuningModelLoaded(e) {
    this._fineTuningModelLoaded = e;
  }
  get fineTuningModelLoaded() {
    return this._fineTuningModelLoaded;
  }
  get sessionTryOnEnabled() {
    return this._sessionTryOnEnabled;
  }
  set sessionTryOnEnabled(e) {
    this._sessionTryOnEnabled = e;
  }
  get tryOnInfoLoading() {
    return this._tryOnInfoLoading;
  }
  set tryOnInfoLoading(e) {
    this._tryOnInfoLoading = e;
  }
  // ShowHighlight
  get showHighlight() {
    return this._showHighlight;
  }
  set showHighlight(e) {
    this._showHighlight != e && (this._showHighlight = e);
  }
  // HighlightOver
  get highlightOver() {
    return this._highlightOver;
  }
  set highlightOver(e) {
    this._highlightOver != e && (this._highlightOver = e);
  }
  // HighlightOverColor
  get highlightOverColor() {
    return this._highlightOverColor;
  }
  set highlightOverColor(e) {
    this._highlightOverColor != e && (this._highlightOverColor = e);
  }
  // EditingMode
  get editingMode() {
    return this._editingMode;
  }
  set editingMode(e) {
    this._editingMode != e && this.setEditingMode(e);
  }
  // EditingControlVisible
  get editControlVisible() {
    return this._editControlVisible;
  }
  set editControlVisible(e) {
    this._editControlVisible != e && this.showHideEditControl(e);
  }
  get selectedProvider() {
    return this._pickedProvider;
  }
  get selectedProviderFineTuningData() {
    return this._providerData;
  }
  get modelMeasurements() {
    return this._modelMeasurements;
  }
  set modelMeasurements(e) {
    this._modelMeasurements = e;
  }
  get showMeasurements() {
    return this._showMeasurements;
  }
  fireHideMeasurementsEvent() {
    this._showMeasurements = !1;
  }
  fireShowMeasurementsEvent() {
    this._showMeasurements = !0;
  }
  static async createSceneEditorAsync(e) {
    const t = new ol(e);
    return await t.initAsync(), t.checkSceneSourceTasks(), t;
  }
  createCanvas() {
    const e = super.createCanvas();
    return e.addEventListener(
      "keydown",
      (t) => {
        this._shiftPressed = t.key == "Shift", this._ctrlPressed = t.key == "Control";
      },
      !1
    ), e.addEventListener(
      "keyup",
      (t) => {
        this._shiftPressed = t.key != "Shift", this._ctrlPressed = t.key != "Control";
      },
      !1
    ), e.addEventListener("dblclick", (t) => {
      this.setRenderingNeeded();
    }), e;
  }
  deleteComponents() {
    super.deleteComponents(), this._editControl && (this._editControl.detach(), this._editControl = null), this._lightsLayer && (this._lightsLayer.dispose(), this._lightsLayer = null), this._axesLayer && (this._axesLayer.dispose(), this._axesLayer = null);
  }
  dispose() {
    super.dispose(), this._incrementalFilesMaker && (this._incrementalFilesMaker.dispose(), delete this._incrementalFilesMaker), this._sceneToBlobs && (this._sceneToBlobs.dispose(), delete this._sceneToBlobs);
  }
  createEngine() {
    super.createEngine(), BABYLON.SceneLoader.ForceFullSceneLoadingForIncremental = !0;
  }
  async createEmptySceneAsync() {
    await super.createEmptySceneAsync(), this._engine && this.fireSceneCreatedEvent();
  }
  async setupSceneAsync() {
    await super.setupSceneAsync(), this._engine && this._scene && (this._scene.setRenderingAutoClearDepthStencil(1, !0, !0, !1), this._scene.setRenderingAutoClearDepthStencil(2, !0, !0, !1), this._lightsLayer = new Jx(this), this._lightsLayer.addLightSelectedListener((e) => {
      this.lightsLayer_onLightSelected(e);
    }), this.setupAxes(), this._zkModel && this._meshLocationsManager && (this._meshLocationsManager.addBeforeSaveMeshLocationListener(() => this.onBeforeSaveMeshLocation()), this._meshLocationsManager.addAfterSaveMeshLocationListener(() => this.onAfterSaveMeshLocation())), this._scene.onPointerMove = (e, t) => this.onPointerMove(e, t));
  }
  render() {
    this.firePreUpdateEvent(), super.render(), this._lightsLayer && this._lightsLayer.render(), this._axesLayer && this._axesLayer.render(), this.firePostUpdateEvent();
  }
  deleteHighlightLayer() {
    this._highlightLayer && (this._highlightLayer.dispose(), this._highlightLayer = null), this.setRenderingNeeded();
  }
  setupHighlightLayerIntensity() {
    this._highlightLayer && (this._highlightLayer.blurHorizontalSize = this._highlightBlurHorizontalSize, this._highlightLayer.blurVerticalSize = this._highlightBlurVerticalSize);
  }
  setupAxes() {
    this._axesLayer = new Kx(this);
  }
  getMatchSameNameTextures() {
    if (this._zkScene) {
      let e = this._zkScene.getMatchSameNameTextures();
      return e ?? !1;
    }
    return !1;
  }
  setMatchSameNameTextures(e) {
    this._zkScene && this._zkScene.setMatchSameNameTextures(e);
  }
  getAREnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getAREnabled();
      return t ?? e;
    }
    return e;
  }
  setAREnabled(e) {
    this._zkScene && this._zkScene.setAREnabled(e);
  }
  getAROnTheFly() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getAROnTheFly();
      return t ?? e;
    }
    return e;
  }
  setAROnTheFly(e) {
    this._zkScene && this._zkScene.setAROnTheFly(e);
  }
  setARAnchor(e) {
    this._zkScene && this._zkScene.setARAnchor(e);
  }
  getTryOnEnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getTryOnEnabled();
      return t ?? e;
    }
    return e;
  }
  setTryOnEnabled(e) {
    this._zkScene && this._zkScene.setTryOnEnabled(e);
  }
  setTryOnSelectedType(e) {
    if (this._zkScene) {
      const t = this.getTryOnDefaultTypeSettings(), s = this._zkScene.getTryOnSettings() || t;
      s.type = e, this.setTryOnTypeSettings(s);
    }
  }
  setFrameDAMSettings(e) {
    this._zkScene && this._zkScene.setFrameDAMSettings(typeof e == "string" ? e : JSON.stringify(e));
  }
  getForceDracoCompression() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getForceDracoCompression();
      return t ?? e;
    }
    return e;
  }
  setForceDracoCompression(e) {
    this._zkScene && this._zkScene.setForceDracoCompression(e);
  }
  getWebPEnabled() {
    return this._zkScene ? this._zkScene.getWebPEnabled() : !1;
  }
  setWebPEnabled(e) {
    this._zkScene && this._zkScene.setWebPEnabled(e);
  }
  getWebPType() {
    return this._zkScene ? this._zkScene.getWebPType() : "Lossless";
  }
  setWebPType(e) {
    this._zkScene && this._zkScene.setWebPType(e);
  }
  getWebPQuality() {
    return this._zkScene ? this._zkScene.getWebPQuality() : 80;
  }
  setWebPQuality(e) {
    this._zkScene && this._zkScene.setWebPQuality(e);
  }
  setProvider(e) {
    this._pickedProvider = e;
  }
  setProviderFineTuningData(e) {
    this._providerData = {
      mesh: e.mesh ? e.mesh : this._providerData.mesh,
      settings: e.settings ? e.settings : this._providerData.settings
    };
  }
  resetProviderFineTuningData() {
    var e;
    (e = this._scene) == null || e.meshes.forEach((t) => {
      t.metadata && t.metadata.tryOnFineTuningSettings && (t.metadata.tryOnFineTuningSettings = null);
    }), this._providerData = {};
  }
  setMeshFineTuningData(e, t) {
    const s = typeof e == "string" ? this.getMeshByID(e) : e;
    s && (s.metadata || (s.metadata = {}), s.metadata.tryOnFineTuningSettings = t);
  }
  setDAMFineTuningData(e) {
    const t = {
      finetuning: e
    };
    this.setFrameDAMSettings(t);
  }
  getTryOnSelectedType() {
    if (this._zkScene) {
      let e = this._zkScene.getTryOnSettings();
      if (e && e.type)
        return e.type;
    }
    return null;
  }
  getTryOnSettings() {
    const e = this.getTryOnDefaultTypeSettings();
    if (this._zkScene) {
      let t = this._zkScene.getTryOnSettings();
      if (t)
        return t;
    }
    return e;
  }
  getTryOnSetting(e) {
    if (this._zkScene) {
      let t = this._zkScene.getTryOnSettings();
      if (t && e in t.typeSettings && t.typeSettings[e] && typeof t.typeSettings[e] == "boolean")
        return t.typeSettings[e];
    }
    return !1;
  }
  setTryOnSetting(e, t) {
    let s = this.getTryOnDefaultTypeSettings();
    if (this._zkScene) {
      let o = this._zkScene.getTryOnSettings();
      if (!o) {
        switch (e) {
          case Or.GlassPupillaryDistanceTool:
          case Or.VirtualTryOn:
          case Or.MandatoryPupillaryDistance:
            s.typeSettings[e] = t;
            break;
          case Or.StyleButton:
            s.styleButton = t;
        }
        this.setTryOnTypeSettings(s);
        return;
      }
      switch (e) {
        case Or.GlassPupillaryDistanceTool:
          o.typeSettings.pd = t;
          break;
        case Or.VirtualTryOn:
          o.typeSettings.try_on = t;
          break;
        case Or.MandatoryPupillaryDistance:
          o.typeSettings.mandatoryPD = t;
          break;
        case Or.StyleButton:
          o.styleButton = t;
          break;
      }
      o.typeSettings.pd && o.typeSettings.try_on || (o.styleButton = "single"), this._zkScene.setTryOnSettings(o);
    }
  }
  setTryOnTypeSettings(e) {
    this._zkScene && this._zkScene.setTryOnSettings(e);
  }
  getTryOnDefaultTypeSettings() {
    return {
      type: jd.NotSelected,
      styleButton: "single",
      buttonCustomizations: [
        {
          image: "base",
          textLabel: "Virtual Try-on",
          textColor: null,
          backgroundColor: null,
          borderColor: null,
          borderWidth: 0,
          borderRadius: 0
        }
      ],
      typeSettings: {
        try_on: !0,
        pd: !1,
        active: this.getTryOnEnabled() ?? !1
      }
    };
  }
  setTryOnDefaultTypeSettings() {
    let e = this.getTryOnDefaultTypeSettings();
    this.setTryOnTypeSettings(e);
  }
  getUseDelayedMaterialLoading() {
    let e = !1;
    if (this.zkScene) {
      let t = this.zkScene.getUseDelayedMaterialLoading();
      return t ?? e;
    }
    return e;
  }
  setUseDelayedMaterialLoading(e) {
    this._zkScene && this._zkScene.setUseDelayedMaterialLoading(e);
  }
  getUseDelayedTextureLoading() {
    if (this._zkScene) {
      let t = this._zkScene.getUseDelayedTextureLoading();
      return t ?? !1;
    }
    return !1;
  }
  setUseDelayedTextureLoading(e) {
    this._zkScene && this._zkScene.setUseDelayedTextureLoading(e);
  }
  getGlowEnabled() {
    return this._glowManager ? this._glowManager.enabled : !1;
  }
  setGlowEnabled(e) {
    this._glowManager && (this._glowManager.enabled = e, this.setRenderingNeeded());
  }
  getGlowIntensity() {
    return this._glowManager ? this._glowManager.intensity : 1;
  }
  setGlowIntensity(e) {
    this._glowManager && (this._glowManager.intensity = e, this.setRenderingNeeded());
  }
  getGlowBlurSize() {
    return this._glowManager ? this._glowManager.blurSize : 16;
  }
  setGlowBlurSize(e) {
    this._glowManager && (this._glowManager.blurSize = e, this.setRenderingNeeded());
  }
  getInfoPointsEnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getInfoPointsEnabled();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsEnabled(e) {
    this._zkScene && this._zkScene.setInfoPointsEnabled(e), this.refreshInfoPoints();
  }
  getInfoPointsBorderColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsBorderColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsBorderColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsBorderColor(e), this.refreshInfoPoints());
  }
  getInfoPointsInnerPointColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsInnerPointColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsInnerPointColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsInnerPointColor(e), this.refreshInfoPoints());
  }
  getInfoPointsColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsColor(e), this.refreshInfoPoints());
  }
  getInfoPointsHighlightColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsHighlightColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsHighlightColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsHighlightColor(e), this.refreshInfoPoints());
  }
  enableGlowForMesh(e) {
    this._glowManager && this._glowManager.enableGlowForMesh(e);
  }
  disableGlowForMesh(e) {
    this._glowManager && (this._glowManager.disableGlowForMesh(e), this.setRenderingNeeded());
  }
  enableARForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.AR = !0);
  }
  disableARForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.AR = !1);
  }
  disableTryOnForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.TryOn = !1, e.getChildMeshes().forEach((t) => this.disableTryOnForMesh(t)));
  }
  enableTryOnForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.TryOn = !0, e.getChildMeshes().forEach((t) => this.enableTryOnForMesh(t)));
  }
  enableInfoPointsForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.showInfoPoints = !0, this.refreshInfoPoints());
  }
  disableInfoPointsForMesh(e) {
    e && e.metadata && e.metadata.showInfoPoints !== void 0 && e.metadata.showInfoPoints !== null && (delete e.metadata.showInfoPoints, this.refreshInfoPoints());
  }
  enableForcedInfoPointsVisibilityOnMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.forceShowInfoPoints = !0, this.refreshInfoPoints());
  }
  disableForcedInfoPointsVisibilityOnMesh(e) {
    e && e.metadata && e.metadata.forceShowInfoPoints !== void 0 && e.metadata.forceShowInfoPoints !== null && (delete e.metadata.forceShowInfoPoints, this.refreshInfoPoints());
  }
  setEditorBackgroundColor(e) {
    this._editorBackgroundColor = e, this.refreshEnvironment();
  }
  setViewerBackgroundAlpha(e) {
    this._zkScene && (this._zkScene.getOrCreateGeneralConfig().set("backgroundAlpha", e), this.refreshEnvironment());
  }
  setViewerBackgroundColor(e) {
    this._zkScene && (this._zkScene.getOrCreateGeneralConfig().set("backgroundColor", e), this.refreshEnvironment());
  }
  setViewerEnvironmentSizeAuto(e) {
    this._zkScene && (this._zkScene.getOrCreateEnvironmentConfig().set("sizeAuto", e), this.refreshEnvironment());
  }
  setViewerEnvironmentMainColor(e) {
    this._zkScene && (this._zkScene.getOrCreateEnvironmentConfig().set("mainColor", e), this.refreshEnvironment());
  }
  setViewerSkyboxCreateSkybox(e) {
    this._zkScene && (this._zkScene.getOrCreateSkyboxConfig().set("createSkybox", e), this.refreshEnvironment());
  }
  setViewerSkyboxSize(e) {
    this._zkScene && (this._zkScene.getOrCreateSkyboxConfig().set("size", e), this.refreshEnvironment());
  }
  setViewerSkyboxBlur(e) {
    if (this._zkScene) {
      let t = e >= 0 ? e : 0;
      this._zkScene.getOrCreateSkyboxConfig().set("blur", t), this.refreshEnvironment();
    }
  }
  setViewerSkyboxTexture(e, t, s) {
    if (this._zkScene && e != null && typeof e == "string") {
      const o = this._zkScene.getOrCreateSkyboxConfig();
      o.set("texture", e), o.set("extensions", t), o.set("files", s), this.refreshEnvironment();
    }
  }
  removeViewerSkyboxTexture() {
    if (this._zkScene) {
      const e = this._zkScene.getSkyboxConfig();
      e && e.get("texture") != null && (e.unset("texture"), this.refreshEnvironment());
    }
  }
  setViewerSkyboxColor(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateSkyboxConfig().set("color", e), this.refreshEnvironment());
  }
  setViewerGroundCreateGround(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("createGround", e), this.refreshEnvironment());
  }
  setViewerGroundSize(e) {
    this._zkScene && (this._zkScene.getOrCreateGroundConfig().set("size", e), this.refreshEnvironment());
  }
  setViewerGroundTexture(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateGroundConfig().set("texture", e), this.refreshEnvironment());
  }
  removeViewerGroundTexture() {
    if (this._zkScene) {
      const e = this._zkScene.getGroundConfig();
      e && e.get("texture") != null && (e.unset("texture"), this.refreshEnvironment());
    }
  }
  setViewerGroundColor(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateGroundConfig().set("color", e), this.refreshEnvironment());
  }
  setViewerGroundOpacity(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("opacity", e), this.refreshEnvironment());
  }
  setViewerGroundEnableShadow(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("enableShadow", e), this.refreshEnvironment());
  }
  setViewerGroundShadowLevel(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("shadowLevel", e), this.refreshEnvironment());
  }
  setViewerGroundEnableMirror(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("enableMirror", e), this.refreshEnvironment());
  }
  setViewerGroundMirrorBlur(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("mirrorBlurKernel", e), this.refreshEnvironment());
  }
  setViewerCameraAutoRotate(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateCameraConfig().set("autoRotate", e), this.autoRender = e, this.refreshEnvironment());
  }
  setViewerCameraContrast(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateCameraConfig().set("contrast", e), this.refreshEnvironment());
  }
  setViewerCameraExposure(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateCameraConfig().set("exposure", e), this.refreshEnvironment());
  }
  setViewerCameraUpperAlphaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const o = this._zkScene.getOrCreateCameraConfig().get("lowerAlphaLimit");
      this._zkScene.setCameraUpperAlphaLimit(Math.max(e, o ?? e)), (t = this._sceneHelper) == null || t.setCameraUpperAlphaLimit(Math.max(e, o ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraLowerAlphaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const o = this._zkScene.getOrCreateCameraConfig().get("upperAlphaLimit");
      this._zkScene.setCameraLowerAlphaLimit(Math.min(e, o ?? e)), (t = this._sceneHelper) == null || t.setCameraLowerAlphaLimit(Math.min(e, o ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraLowerBetaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const o = this._zkScene.getOrCreateCameraConfig().get("upperBetaLimit");
      this._zkScene.setCameraLowerBetaLimit(Math.min(e, o ?? e)), (t = this._sceneHelper) == null || t.setCameraLowerBetaLimit(Math.min(e, o ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraUpperBetaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const o = this._zkScene.getOrCreateCameraConfig().get("lowerBetaLimit");
      this._zkScene.setCameraUpperBetaLimit(Math.max(e, o ?? e)), (t = this._sceneHelper) == null || t.setCameraUpperBetaLimit(Math.max(e, o ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraToneMappingEnabled(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateCameraConfig().set("toneMappingEnabled", e), this.refreshEnvironment());
  }
  serializeFromVector(e) {
    return e ? { x: e.x, y: e.y, z: e.z } : null;
  }
  setModelTransformsFromDAMMesh() {
    var t;
    const e = this.getDAMMainMesh();
    if (e) {
      const s = e.position, o = e.rotation, a = e.scaling, c = (t = this._zkScene) == null ? void 0 : t.getOrCreateModelConfig();
      c.set("position", this.serializeFromVector(s)), c.set("rotation", this.serializeFromVector(o)), c.set("scale", this.serializeFromVector(a));
    }
  }
  resetEditorEnvironment() {
    this.resetEditorBackground(), this.resetEditorCamera(), this.setRenderingNeeded();
  }
  resetEditorBackground() {
    this._scene && (this._scene.clearColor = BABYLON.Color3.FromHexString(this._editorBackgroundColor).toColor4(), this.refreshGround(), this.setRenderingNeeded());
  }
  resetEditorCamera() {
    if (this._scene) {
      const e = this._scene.activeCamera;
      e instanceof BABYLON.ArcRotateCamera && (e.useAutoRotationBehavior = !1), this._autoRender = !1, this.setRenderingNeeded();
    }
  }
  preSceneContentScreenshot() {
    this.resetEditorEnvironment(), this.removeGround();
  }
  postSceneContentScreenshot() {
  }
  preSceneMaterialScreenshot() {
    super.preSceneMaterialScreenshot(), this.adjustSceneForSerialization();
  }
  postSceneMaterialScreenshot() {
    super.postSceneMaterialScreenshot();
  }
  sceneReadyForSave() {
    if (this._scene) {
      for (let e = 0; e < this._scene.meshes.length; e++)
        if (!this._scene.meshes[e].isReady())
          return !1;
    }
    return !0;
  }
  isCurrentCameraPivot(e) {
    if (this._sceneHelper) {
      const t = this._sceneHelper.getCameraPivot();
      return t && t.id === e;
    }
    return !1;
  }
  getCurrentCameraPivotID() {
    if (this._scene && this._sceneHelper) {
      const e = this._sceneHelper.getCameraPivot();
      if (e) {
        const t = this._scene.getMeshByID(e.id);
        if (t)
          return t.id;
      }
    }
    return null;
  }
  // Riscritta quella di SceneViewer perché viene salvata l'informazione
  // sul nuovo pivot, non solo modifcato il punto di vista
  setCameraPivot(e) {
    if (this._scene && this._sceneHelper) {
      for (let s = 0; s < this._scene.meshes.length; s++) {
        var t = this._scene.meshes[s];
        t.metadata && t.metadata.isCameraPivot != null && delete t.metadata.isCameraPivot;
      }
      if (e) {
        const s = this._scene.getMeshByID(e);
        s && (s.metadata = s.metadata || {}, s.metadata.isCameraPivot = !0), this._sceneHelper.setCameraPivot(s || null);
      } else
        this._sceneHelper.setCameraPivot(null);
    }
  }
  // --------------------------------------------------------
  // Funzioni per il salvataggio della scena
  // --------------------------------------------------------
  async getBlobFromEmbeddedTextureAsync(e) {
    let t = null;
    if (e.url) {
      const c = e.url;
      var s = c.substring(0, 5) === "data:", o = c.substring(0, 5) === "blob:", a = s && c.indexOf(";base64,") !== -1;
      if (s && e._buffer && (e._buffer instanceof ArrayBuffer || e._buffer instanceof Uint8Array || e._buffer instanceof Blob))
        e._buffer instanceof Blob ? t = e._buffer : e._buffer instanceof Uint8Array ? t = new Blob([e._buffer], { type: e.mimeType }) : e._buffer instanceof ArrayBuffer && (t = new Blob([new Uint8Array(e._buffer)], { type: e.mimeType }));
      else if (o)
        await new Promise((g) => {
          var w = new XMLHttpRequest();
          w.open("GET", c, !0), w.responseType = "blob", w.onload = function(T) {
            this.status == 200 && g(this.response);
          }, w.send();
        });
      else if (a) {
        const g = new Uint8Array(BABYLON.Tools.DecodeBase64(c));
        t = new Blob([g], { type: e.mimeType });
      }
    }
    return t;
  }
  async uploadEmbeddedTexturesAsync(e) {
    const t = [];
    if (this._zkScene && this._scene && this._sceneHelper) {
      this._scene, this._zkScene;
      const s = this._sceneHelper;
      this.getAllMaterials().forEach((a) => {
        a.getActiveTextures().filter((g) => g instanceof BABYLON.Texture).forEach((g) => {
          if (g.url) {
            var w = g.url.substring(0, 5) === "data:", T = g.url.substring(0, 5) === "blob:", H = w && g.url.indexOf(";base64,") !== -1;
            if (w || T || H) {
              const Y = s.getMaterialTextureType(a, g);
              Y && t.push({
                texture: g,
                material: a,
                type: Y
              });
            }
          }
        });
      });
    }
    for (let s = 0; s < t.length; s++) {
      const o = t[s], a = o.texture, c = await this.getBlobFromEmbeddedTextureAsync(a);
      if (c) {
        let g = ".png";
        a.mimeType === "image/jpeg" && (g = ".jpg");
        const T = `${o.type.replace(" ", "_")}${g}`;
        let H = new File([c], T);
        const Y = await this.uploadTextureFileAsync(H, o.material);
        if (Y) {
          const ee = Y.get("url");
          ee && await new Promise((z, he) => {
            a.updateURL(
              ee,
              void 0,
              () => z(),
              void 0,
              () => he()
            );
          });
        }
        e && e(s / t.length * 100, "textures");
      }
    }
  }
  useIncrementalLoading() {
    if (this._sceneHelper) {
      const e = this._sceneHelper.getTotalVertices(), t = this._sceneHelper.getTotalIndices();
      if (e + t >= 1e3)
        return !0;
    }
    return !1;
  }
  // Prepara il modello backbone zkScene per il salvataggio. Nel dettaglio:
  // 1. Esegue lo screenshot della scena e imposta i byte nel modello zkScene
  // 2. Recupera il JSON della scena da Babylon JS.
  // 3. Esegue l'upload del file in modo che possa essere salvato nel percorso previsto per la scena corrente.
  // 4. Aggiorna il modello impostando i dati relativi al file "uploadato" (essenzialmente il fileObject)
  updateSceneModel(e, t, s, o) {
    if (this._zkScene && this._scene) {
      this._scene;
      const a = this._zkScene;
      this.resetRealVisibility();
      const c = this.infoPointsShown;
      c && this.hideInfoPoints(), this.uploadEmbeddedTexturesAsync((g, w) => {
        s && s(g, w);
      }).then(() => {
        this.getSceneScreenshotAsync(500, 450).then((g) => {
          c && this.showInfoPoints(), a.set("imageData", g), a.set("version", a.get("version") + 1);
          var w = this.useIncrementalLoading();
          w ? this.uploadSceneIncrementalFiles(
            (T) => {
              this.onUploadScenFileSuccess(T), e && e();
            },
            (T) => {
              t && t(T);
            },
            (T) => {
              s && s(T);
            },
            o
          ) : this.uploadSceneFile(
            (T) => {
              this.onUploadScenFileSuccess(T), e && e();
            },
            (T) => {
              t && t(T);
            },
            (T, H) => {
              s && s(T, H);
            }
          );
        });
      }).catch((g) => {
        t && t(g);
      });
    }
  }
  // Aggiorna il modello con i dati sul file di scena salvato
  onUploadScenFileSuccess(e) {
    this._zkScene && e && (e.hasOwnProperty("fileObjectID") || e.hasOwnProperty("fileLength")) && e.hasOwnProperty("rootUrl") && e.hasOwnProperty("sceneFileName") && (e.hasOwnProperty("manifestFileObjectID") || e.hasOwnProperty("manifestFileLength")) && (e.hasOwnProperty("incrementalsFileObjectID") || e.hasOwnProperty("incrementalsFileLength")) ? (this._zkScene.set("fileObjectID", e.fileObjectID), this._zkScene.set("fileLength", e.fileLength), this._zkScene.set("url", e.url), this._zkScene.set("rootUrl", e.rootUrl), this._zkScene.set("sceneFileName", e.sceneFileName), this._zkScene.set("manifestFileObjectID", e.manifestFileObjectID), this._zkScene.set("manifestFileLength", e.manifestFileLength), this._zkScene.set("manifestFileUrl", e.manifestFileUrl), this._zkScene.set("incrementalsFileObjectID", e.incrementalsFileObjectID), this._zkScene.set("incrementalsFileLength", e.incrementalsFileLength), this._zkScene.set("incrementalsFileUrl", e.incrementalsFileUrl)) : Logger.info("le informazioni sul file di scena salvato sono vuote o incorrette");
  }
  uploadSceneFile(e, t, s) {
    if (!this._scene || !this._zkScene) {
      t && t("No scene to upload");
      return;
    }
    this._scene;
    const o = this._zkScene, a = o.get("version"), c = this.getSceneJson();
    this.getSceneFileBlobsAsync(c, a, (g) => {
      s && s(g, "optimize");
    }).then((g) => {
      const w = new FormData();
      for (let T = 0; T < g.length; T++) {
        const H = g[T];
        w.append("file_" + T, H.blob, H.name);
      }
      fetch(o.getSceneIncrementalFileUploadUrl(), {
        method: "POST",
        body: w,
        headers: {
          Authorization: "Bearer " + this._authorizationToken
        }
      }).then((T) => {
        if (!T.ok)
          throw new Error("HTTP error " + T.status);
        return T.json();
      }).then((T) => {
        e && e(T);
      }).catch((T) => {
        t && t(T.message);
      });
    });
  }
  async getSceneFileBlobsAsync(e, t, s) {
    let o = [];
    return this._sceneToBlobs || (this._sceneToBlobs = new Wx(this._incrementalWorkersScriptsUrls)), this._sceneToBlobs && (await this._sceneToBlobs.whenReadyAsync(), o = await this._sceneToBlobs.getSceneBlobsAsync(e, t, s)), o;
  }
  // Serializza in JSON la scena Babylon JS
  getSceneJson() {
    var t;
    let e = "";
    if (this._scene && this._sceneHelper) {
      const s = this._envMode;
      this.setEnvironmentMode(Ss.Editor), this.disableAntialiasing(!0);
      const o = this.resetCameraRotationLimits();
      this.deleteHighlightLayer();
      const a = this._manipulatedNode;
      this.setManipulatedNode(null), this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading() && this._sceneHelper.offloadAllUnusedMaterials(), this._sceneHelper.setDummyMaterialToInvisibleMeshes(), this.adjustSceneForSerialization();
      const c = BABYLON.SceneSerializer.Serialize(this._scene);
      if (c.postProcesses = [], e = JSON.stringify(c), this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading()) {
        const g = (t = this._zkScene) == null ? void 0 : t.get("rootUrl");
        g && this._sceneHelper.loadAllOffloadedMaterials(g);
      }
      this._sceneHelper.unsetAllDummyMaterials(), s != Ss.Editor && this.setEnvironmentMode(s), this.enableAntialiasing(), this.createHighlightLayer(), this.setManipulatedNode(a), this.setCameraRotationLimits(o);
    }
    return e;
  }
  resetCameraRotationLimits() {
    const e = {
      lowerAlphaLimit: null,
      upperAlphaLimit: null,
      lowerBetaLimit: null,
      upperBetaLimit: null
    };
    return this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (e.lowerAlphaLimit = this._camera.lowerAlphaLimit, e.upperAlphaLimit = this._camera.upperAlphaLimit, e.lowerBetaLimit = this._camera.lowerBetaLimit, e.upperBetaLimit = this._camera.upperBetaLimit, this._camera.lowerAlphaLimit = null, this._camera.upperAlphaLimit = null, this._camera.lowerBetaLimit = 0.01, this._camera.upperBetaLimit = Math.PI - 0.01), e;
  }
  setCameraRotationLimits(e) {
    e = e || {
      lowerAlphaLimit: null,
      upperAlphaLimit: null,
      lowerBetaLimit: 0.01,
      upperBetaLimit: Math.PI - 0.01
    }, this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerAlphaLimit = e.lowerAlphaLimit, this._camera.upperAlphaLimit = e.upperAlphaLimit, this._camera.lowerBetaLimit = e.lowerBetaLimit || 0.01, this._camera.upperBetaLimit = e.upperBetaLimit || Math.PI - 0.01);
  }
  // Metodo fondamentale per modificare gli url delle texture ed eliminare le
  // le texture non più utilizzate. In fase di caricamento della scena, Babylon JS
  // risolve il nome delle texture in base al path della scena. Quindi gli url delle
  // texture vanno, se necessario, trasformanti in path relativi.
  adjustSceneForSerialization() {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const e = this._sceneHelper;
      this.removeDisabledFresnelParameters();
      let t = !1;
      this._zkScene.getUseDelayedTextureLoading() != null && (t = this._zkScene.getUseDelayedTextureLoading()), this._scene.useDelayedTextureLoading = t;
      const s = this.getMatchSameNameTextures(), o = this._zkScene.getSourcesIDs();
      this._zkScene.getLibraryMaterialIDs();
      const a = {}, c = {}, g = [], w = [], T = [], H = e.getTextureUrl(this._scene.environmentTexture), Y = H !== null && H.endsWith(Wt.Environment.EnvironmentTextureName);
      if (this._zkScene.set("useDefaultEnvironmentTexture", Y), this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture)) {
        const _e = this._scene.environmentTexture.rotationY;
        this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.environmentTextureRotationY = _e;
      }
      this._scene.textures.forEach((_e) => {
        if (!e.isTextureWithUrl(_e))
          return;
        let ue = _e.url;
        if (_e.getInternalTexture) {
          const xe = _e.getInternalTexture();
          xe && xe.url && (ue = xe.url);
        }
        if (ue) {
          let xe = ue;
          if (xe === Wt.Environment.EnvironmentTextureCDNUrl) {
            _e.url = "textures/" + Zakeke.getEmptyUUID().replace(/-/g, "") + "/" + Wt.Environment.EnvironmentTextureName, _e.name = _e.url;
            return;
          }
          if (xe == Wt.Environment.SkyboxTextureCDNUrl || xe == Wt.Environment.GroundTextureCDNUrl)
            return;
          let Ee = !1;
          xe.startsWith("blob:") && _e.metadata && _e.metadata.fileUrl && (xe = _e.metadata.fileUrl);
          for (let j = 0; j < o.length; j++) {
            let ht = o[j].replace(/-/g, ""), Ze = xe.indexOf(ht);
            if (Ze != -1) {
              Ee = !0, _e.name = xe.substring(Ze), _e.url = _e.name, Logger.info("texture url: " + _e.url);
              break;
            }
          }
          let K = !1;
          if (_e.materialMapping) {
            K = !0;
            let j = _e.materialMapping.libraryMaterialID.replace(/-/g, ""), ht = _e.materialMapping.sceneMaterialID.replace(/-/g, ""), Ze = xe, pt = _e.name, Pt = xe.indexOf(j);
            if (Pt != -1) {
              let Mt = xe.replace(new RegExp(j, "g"), ht);
              Ze = Mt, pt = Mt;
              let Tt = {};
              if (a.hasOwnProperty(j) ? Tt = a[j] : a[j] = Tt, Pt = Mt.lastIndexOf("/"), Pt !== -1) {
                let at = Mt.substring(Pt + 1);
                Tt.hasOwnProperty(at) ? (Ze = Tt[at], pt = Ze, aa(g, Ze) || g.push(Ze)) : (Pt = Mt.lastIndexOf("/", Pt - 1), Pt !== -1 && (Pt = Mt.lastIndexOf("/", Pt - 1), Pt != -1 && (Ze = Mt.substring(Pt + 1), pt = Ze, aa(g, Ze) || g.push(Ze), s && (Tt[at] = Ze))));
              }
              _e.name = pt, _e.url = Ze;
            }
          }
          if (!Ee && !K) {
            const j = this.extractTextureNameAndUrl(xe, s, c);
            if (j.url && j.name && (_e.url = j.url, _e.name = j.name, aa(g, _e.url) || g.push(_e.url)), _e.metadata && _e.metadata.mobileUrl) {
              const ht = this.extractTextureNameAndUrl(
                _e.metadata.mobileUrl,
                s,
                c
              );
              ht.url && ht.name && (_e.metadata.mobileUrl = ht.url, aa(g, _e.metadata.mobileUrl) || g.push(_e.metadata.mobileUrl), aa(T, _e.metadata.mobileUrl) || T.push(_e.metadata.mobileUrl), aa(w, _e.url) || w.push(_e.url));
            }
          }
        }
      });
      const ee = ["px", "py", "pz", "nx", "ny", "nz"], z = (_e) => {
        let ue = _e.lastIndexOf("."), xe = _e;
        if (ue !== -1) {
          let Ee = _e.substring(0, ue);
          for (let K = 0; K < ee.length; K++) {
            const j = ee[K];
            if (ue = Ee.lastIndexOf("_" + j), ue != -1) {
              xe = Ee.substring(0, ue);
              break;
            }
          }
        }
        return xe;
      }, he = (_e) => {
        const ue = z(_e);
        for (let xe = 0; xe < g.length; xe++) {
          const Ee = g[xe];
          if (ue.endsWith(Ee))
            return !0;
        }
        return !1;
      }, ne = (_e) => {
        const ue = z(_e);
        for (let xe = 0; xe < w.length; xe++) {
          const Ee = w[xe];
          if (ue.endsWith(Ee))
            return !0;
        }
        return !1;
      }, ye = (_e) => {
        const ue = z(_e);
        for (let xe = 0; xe < T.length; xe++) {
          const Ee = T[xe];
          if (ue.endsWith(Ee))
            return !0;
        }
        return !1;
      }, se = [];
      for (let _e = 0; _e < this._zkScene.get("textures").length; _e++) {
        const ue = this._zkScene.get("textures").at(_e), xe = ue.get("url");
        xe && he(xe) ? ne(xe) ? ue.set("usage", Zakeke.TextureUsage.Desktop) : ye(xe) ? ue.set("usage", Zakeke.TextureUsage.Mobile) : ue.set("usage", Zakeke.TextureUsage.Any) : se.push(ue);
      }
      se.length > 0 && this._zkScene.get("textures").remove(se), this._zkScene.set("usedTextureUrls", g);
    }
  }
  // Metodo da usare per le texture caricate dall'utente, per trasformre il percorso assoluto
  // del tipo ..../textures/{ materialID }/{filename.xxx} nel percorso relativo textures/{materialID}/{filename.xxx}
  // Utilizza ed aggiorna eventualmente un dictionary per riutilizzare lo stesso percorso a parità di nome
  extractTextureNameAndUrl(e, t, s) {
    const o = { name: "", url: "" };
    let a = e.lastIndexOf("/");
    if (a !== -1) {
      const c = e.substring(a + 1);
      if (s.hasOwnProperty(c))
        o.url = s[c], o.name = o.url;
      else if (a = e.lastIndexOf("/", a - 1), a !== -1 && (a = e.lastIndexOf("/", a - 1), a !== -1)) {
        const g = e.substring(a + 1);
        o.url = g, o.name = g, t && (s[c] = g);
      }
    }
    return o;
  }
  removeDisabledFresnelParameters() {
    const e = function(t) {
      return t && t.isEnabled != null && !t.isEnabled && t.leftColor != null && t.leftColor != null && t.leftColor instanceof BABYLON.Color3 && t.leftColor.equals(BABYLON.Color3.White()) && t.rightColor != null && t.rightColor != null && t.rightColor instanceof BABYLON.Color3 && t.rightColor.equals(BABYLON.Color3.Black()) && t.bias != null && t.bias == 0 && t.power != null && t.power == 1;
    };
    this._scene && this._scene.materials.forEach(function(t) {
      t instanceof BABYLON.StandardMaterial ? (t.diffuseFresnelParameters && e(t.diffuseFresnelParameters) && (t.diffuseFresnelParameters = new BABYLON.FresnelParameters(), t.diffuseFresnelParameters.isEnabled = !1), t.emissiveFresnelParameters && e(t.emissiveFresnelParameters) && (t.emissiveFresnelParameters = new BABYLON.FresnelParameters(), t.emissiveFresnelParameters.isEnabled = !1), t.opacityFresnelParameters && e(t.opacityFresnelParameters) && (t.opacityFresnelParameters = new BABYLON.FresnelParameters(), t.opacityFresnelParameters.isEnabled = !1), t.reflectionFresnelParameters && e(t.reflectionFresnelParameters) && (t.reflectionFresnelParameters = new BABYLON.FresnelParameters(), t.reflectionFresnelParameters.isEnabled = !1), t.refractionFresnelParameters && e(t.refractionFresnelParameters) && (t.refractionFresnelParameters = new BABYLON.FresnelParameters(), t.refractionFresnelParameters.isEnabled = !1)) : t instanceof BABYLON.PBRMaterial || t instanceof Zakeke.PBRMaterial && t.opacityFresnelParameters && e(t.opacityFresnelParameters) && (t.opacityFresnelParameters = void 0);
    });
  }
  // Versione che utilizza un webworker (incapsulato in IncrementalFiles) per produrre i file incrementali (ed eventualmente
  // codificarli con Draco). In futuro si potrebbe convertire in async.
  uploadSceneIncrementalFiles(e, t, s, o) {
    if (!this._scene || !this._zkScene || !this._sceneHelper) {
      t && t("No scene to upload");
      return;
    }
    const a = this._zkScene, c = this._sceneHelper;
    let g = a.get("version"), w = this.envMode;
    this.setEnvironmentMode(Ss.Editor), this.disableAntialiasing(!0);
    let T = this.resetCameraRotationLimits();
    this.deleteHighlightLayer(), this.adjustSceneForSerialization(), c.setDummyMaterialToInvisibleMeshes();
    let H = this.getUseDelayedMaterialLoading(), Y = this.getUseMaterialOffloading(), ee = {}, z = {};
    H ? this.getAllMaterials().forEach((se) => {
      const _e = this.getMeshesUsingMaterial(se.id);
      se.id !== "default material" && _e.length === 0 && (ee[se.id] = {
        name: se.name,
        file: "material_" + g + "_" + se.id.replace(/[^a-z0-9]/gi, "_").toLowerCase() + ".json"
      });
    }) : Y && this.getAllMaterials().forEach((se) => {
      const _e = this.getMeshesUsingMaterial(se.id);
      se.id !== "default material" && _e.length === 0 && (z[se.id] = c.getOffloadedMaterialInfo(se));
    }), this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.offloadedMaterials = z, this._scene.metadata.delayedMaterials = ee;
    let he = BABYLON.SceneSerializer.Serialize(this._scene);
    if (he.postProcesses = [], he.metadata && he.metadata.originalMeshMaterials) {
      const ye = JSON.parse(JSON.stringify(he.metadata.originalMeshMaterials));
      c.unsetAllDummyMaterials(), he.metadata.originalMeshMaterials = ye;
    }
    const ne = {
      useDraco: this._dracoEnabled,
      forceDraco: a.getForceDracoCompression() ?? !1,
      dracoEncodingSpeed: this._dracoEncodingSpeed,
      dracoDecodingSpeed: this._dracoDecodingSpeed,
      excludedMeshes: [],
      delayMatarialLoading: Object.keys(ee),
      offloadedMaterialIDs: Object.keys(z)
    };
    console.log(ne), this.getSceneIncrementalFilesAsync(g, he, ne, s).then(
      (ye) => {
        let se = new FormData();
        for (let ue = 0; ue < ye.length; ue++) {
          const xe = ye[ue];
          let Ee = xe.name, K = xe.data, j = !1;
          !xe.dracoEncoded && xe.data.length > 180 && xe.data.length < 45e4 && (Logger.info("Uncompressed file length: " + xe.data.length), K = LZString.compressToUint8Array(xe.data), Logger.info("Compressed file length: " + K.length), Ee = "compressed_" + xe.name, j = !0);
          let ht;
          if (!xe.dracoEncoded && !j)
            ht = new Blob([K], { type: "text/plain" });
          else {
            var _e = K.buffer;
            ht = new Blob([_e]);
          }
          se.append("file_" + ue, ht, Ee);
        }
        fetch(a.getSceneIncrementalFileUploadUrl(), {
          method: "POST",
          headers: {
            Authorization: "Bearer " + this._authorizationToken
          },
          body: se
        }).then((ue) => {
          if (!ue.ok)
            throw new Error("HTTP error " + ue.status);
          return ue.json();
        }).then((ue) => {
          e && e(ue);
        }).catch(function(ue) {
          t && t(ue.message);
        }), w != Ss.Editor && this.setEnvironmentMode(w), this.enableAntialiasing(), this.createHighlightLayer(), this.setCameraRotationLimits(T);
      }
    );
  }
  // Utilizza il web worker MakeIncrementalFiles per ottenere i file incrementali (eventualmente codificati con Draco)
  async getSceneIncrementalFilesAsync(e, t, s, o) {
    let a = [];
    return this._incrementalFilesMaker || (this._incrementalFilesMaker = new Cx(this._incrementalWorkersScriptsUrls)), this._incrementalFilesMaker && (await this._incrementalFilesMaker.whenReadyAsync(), a = await this._incrementalFilesMaker.getIncrementalFilesAsync(t, e, s)), a;
  }
  // Fine funzioni salvataggio scena
  // --------------------------------------------------------
  async setNewSceneModelAsync(e, t) {
    this._zkModel = e, this._zkScene = t, await this.init3DEngineAsync(), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), this.fireCameraLocationsUpdateEvent();
  }
  getSceneConfig() {
    var e;
    return ((e = this._zkScene) == null ? void 0 : e.getSceneConfig()) ?? null;
  }
  preSceneFileLoading() {
    this.resetRealVisibility();
  }
  postSceneFileLoading() {
    this.fireSceneCreatedEvent(), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), this.fireCameraLocationsUpdateEvent();
  }
  // ==============================================================================
  // Importazione Assets
  // ==============================================================================
  // I file "uploadati" dall'utente non vengono caricati immediatamente nella scena
  // ma viene creato un task di elaborazione lato server il cui stato verrà controllato tramite polling.
  // Per ogni task server di caricamento verrà creato un oggetto task lato client che è utile
  // per il recupero tramite polling delle informazioni.
  // I task lato client avranno uno degli stati:
  //   uploading         - Task avviato per l'uploading dei file
  //   progress          - Task in elaborazione
  //   checking          - Chimata Ajax di controllo stato in corso
  //   success           - Task server completato con successo, si possono importare i relativi file nella scena Babylon JS corrente
  //   completed_success - Task eseguito correttamente e file importati nella scena Babylon JS
  //   completed_error   - Task in errore, può essere eliminato dalla lista dei task da controllare
  loadSceneSourceFiles(e, t, s, o) {
    if (this._zkScene) {
      const T = this._zkScene, H = new FormData();
      if (t)
        H.append("url", t);
      else if (e) {
        for (let se = 0; se < e.length; se++)
          H.append("file-" + se, e[se]);
        var a = this._zkScene.getTexturesConfig();
        if (a) {
          var c = new Zakeke.SceneSourceTaskOptions();
          c.set("textures", a);
          var g = JSON.stringify(c), w = new Blob([g], {
            type: "application/json"
          });
          H.append("task-options", w, "task-options.json");
        }
      }
      const Y = {
        downloadProgress: 0,
        uploadProgress: 0,
        status: 0,
        message: "",
        sceneSourceInfo: {},
        taskID: void 0,
        sourceID: void 0,
        meshes: []
      };
      this._sceneSourceTasks.push(Y);
      const ee = T.getSourceTasksUrl(), z = new Request(ee, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this._authorizationToken
        },
        body: H
      }), he = (se) => {
        const _e = se.loaded / se.total;
        Y.uploadProgress = _e * 100, this.fireSceneSourceTaskCheckEvent();
      }, ne = (se) => {
        const _e = se.loaded / se.total;
        Y.downloadProgress = _e * 100, this.fireSceneSourceTaskCheckEvent();
      }, ye = new XMLHttpRequest();
      ye.upload.addEventListener("progress", he), ye.addEventListener("progress", ne), z.signal.addEventListener("fetch", () => ye.send()), fetch(z).then((se) => se.json()).then((se) => {
        se && se.hasOwnProperty("taskID") && se.hasOwnProperty("sourceID") ? (Y.taskID = se.taskID, Y.sourceID = se.sourceID, Y.status = 1, this.fireSceneSourceTaskCheckEvent()) : Logger.info("task creation process did not go well"), s && s(Y);
      }).catch((se) => {
        this._sceneSourceTasks = this._sceneSourceTasks.filter((_e) => {
        }), this.fireSceneSourceTaskCheckEvent(), o && o(se);
      }), this.fireSceneSourceTaskCheckEvent();
    }
  }
  // Il metodo viene richiamato ogni secondo per il controllo dei task di caricamento file
  // eventualmente presenti in coda
  checkSceneSourceTasks() {
    if (this._scene && this._zkScene && this._sceneSourceTasks && this._sceneSourceTasks.length > 0) {
      const t = this._zkScene;
      for (let s = 0; s < this._sceneSourceTasks.length; s++) {
        let o = this._sceneSourceTasks[s];
        if (o.status == 5 || o.status == 4) {
          this._sceneSourceTasks.splice(s--, 1), this.fireSceneSourceTaskCheckEvent();
          continue;
        }
        if (!(o.status == 2 || o.status == 0)) {
          if (o.status == 1) {
            o.status = 2;
            const a = (c) => {
              c.status = 5, this.fireSceneSourceTaskErrorEvent(c.taskID), this.fireSceneSourceTaskCheckEvent();
            };
            var e = async (c) => {
              try {
                const g = await fetch(t.getSourceTaskResultUrl(c.taskID), {
                  method: "GET",
                  cache: "no-cache",
                  headers: {
                    Authorization: "Bearer " + this._authorizationToken
                  }
                });
                if (g.ok) {
                  const w = await g.json();
                  if (w && w.hasOwnProperty("taskID") && w.hasOwnProperty("state") && w.hasOwnProperty("message") && w.hasOwnProperty("sourceFile"))
                    if (w.state == 2) {
                      c.sceneSourceInfo = {
                        sourceID: w.sourceFile.sourceID,
                        fileObjectID: w.sourceFile.fileObjectID,
                        fileLength: w.sourceFile.fileLength,
                        url: w.sourceFile.url,
                        rootUrl: w.sourceFile.rootUrl,
                        sceneFileName: w.sourceFile.sceneFileName,
                        textureFiles: []
                      };
                      for (let T = 0; T < w.sourceFile.textureFiles.length; T++)
                        c.sceneSourceInfo.textureFiles.push({
                          textureID: w.sourceFile.textureFiles[T].textureID,
                          fileObjectID: w.sourceFile.textureFiles[T].fileObjectID,
                          fileLength: w.sourceFile.textureFiles[T].fileLength,
                          url: w.sourceFile.textureFiles[T].url
                        });
                      c.status = 3;
                    } else
                      w.state == 3 ? a(c) : c.status = 1;
                  else
                    a(c);
                } else
                  a(c);
              } catch {
                a(c);
              }
            };
            e(o);
          }
          o.status == 3 && (this._isLoadingSourceFiles || (this._isLoadingSourceFiles = !0, o.sceneSourceInfo.rootUrl && o.sceneSourceInfo.sceneFileName ? (this.updateSceneModelFromSourceTask(o), this.loadMeshesFromRemoteFiles(
            o.sceneSourceInfo.rootUrl,
            o.sceneSourceInfo.sceneFileName,
            (a) => {
              a && Object.prototype.toString.call(a) === "[object Array]" && a.forEach((c) => {
                c.isPickable = !0;
              }), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskSuccessEvent(a), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), o.meshes = a, o.status = 4;
            },
            (a) => {
              Logger.info("Errore nel caricamento delle mesh: " + a), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskErrorEvent(o.taskID), o.status = 5;
            }
          )) : (Logger.info("Risultato del task di caricamento non valido"), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskErrorEvent(o.taskID), o.status = 5), this.fireSceneSourceTaskCheckEvent()));
        }
      }
    }
    setTimeout(() => this.checkSceneSourceTasks(), 500);
  }
  updateSceneModelFromSourceTask(e) {
    if (this._zkScene) {
      const t = new Zakeke.SceneSource();
      t.set("sourceID", e.sceneSourceInfo.sourceID), t.set("fileObjectID", e.sceneSourceInfo.fileObjectID), t.set("fileLength", e.sceneSourceInfo.fileLength), t.set("url", e.sceneSourceInfo.url), t.set("rootUrl", e.sceneSourceInfo.rootUrl), t.set("sceneFileName", e.sceneSourceInfo.sceneFileName);
      for (let s = 0; s < e.sceneSourceInfo.textureFiles.length; s++) {
        const o = e.sceneSourceInfo.textureFiles[s];
        if (o.textureID && (o.fileObjectID || o.fileLength) && o.url) {
          const a = new Zakeke.SceneSourceTexture();
          a.set("textureID", o.textureID), a.set("fileObjectID", o.fileObjectID), a.set("fileLength", o.fileLength), a.set("url", o.url), t.get("textures").push(a);
        }
      }
      this._zkScene.get("sources").push(t);
    }
  }
  // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
  // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
  // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
  // del file di scena
  loadMeshesFromRemoteFiles(e, t, s, o) {
    if (!this._scene || !this._sceneHelper) {
      o && o("No scene to fill with imported meshes");
      return;
    }
    this._scene;
    const a = this._sceneHelper;
    let c = e + t;
    a.importMeshesFromUrlAsync(c, null, void 0).then(async (g) => (Logger.info("Uploading embedded textures..."), await this.uploadEmbeddedTexturesAsync(), g)).then((g) => (Logger.info("File imported successfully."), this.checkSceneEmptyEnvironmentTexture(), this.refreshEnvironment(), g)).then((g) => {
      Logger.info("Operation completed successfully."), s == null || s(g);
    }).catch((g) => {
      Logger.info("Error loading file"), o && o(g);
    }), Logger.info("loading finished");
  }
  // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
  // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
  // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
  // del file di scena
  loadMeshesFromRemoteFiles_OLD(e, t, s, o) {
    if (!this._scene || !this._sceneHelper) {
      o && o("No scene to fill with imported meshes");
      return;
    }
    const a = this._scene, c = this._sceneHelper;
    let g = t, w = t.lastIndexOf(".");
    w !== -1 && (g = t.substr(0, w));
    const T = this._scene.materials.map((z) => z.id);
    let H;
    BABYLON.GLTFFileLoader.IncrementalLoading = !1, BABYLON.SceneLoader.OnPluginActivatedObservable.add((z) => {
      H = z.name;
    });
    const Y = new BABYLON.AssetsManager(this._scene), ee = Y.addMeshTask("mesh-task", "", e, t);
    ee.onSuccess = (z) => {
      Logger.info("task completed successfully");
      const he = z.loadedMeshes, ne = new BABYLON.Mesh(g, a);
      ne.id = Zakeke.generateUUID(), ne.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, he.forEach((ye) => {
        ye.parent || (ye.parent = ne), ye.material || (ye.material = new BABYLON.StandardMaterial(ye.name + "Mat", a)), ye.id = Zakeke.generateUUID();
      }), a.materials.forEach((ye) => {
        aa(T, ye.id) || (ye.id = Zakeke.generateUUID());
      }), this.checkSceneEmptyEnvironmentTexture(), this.refreshEnvironment(), c.adjustCamera(H, !1, !1), c.setupShaderMaterialsCameraPosition(), s && s(he);
    }, ee.onError = (z, he, ne) => {
      Logger.info("task completed with errors"), o && o(he);
    }, Y.onFinish = function() {
      Logger.info("loading finished");
    }, Y.load();
  }
  // Fine importazione Assets
  // ==============================================================================
  isRealMesh(e) {
    return this._sceneHelper ? this._sceneHelper.isRealMesh(e) : !1;
  }
  onMeshChanged(e) {
    this.updateBoundingBox(), this.setRenderingNeeded();
  }
  onSubMeshChanged(e) {
    this.updateBoundingBox(), this.setRenderingNeeded();
  }
  onMaterialChanged(e) {
    this.setRenderingNeeded();
  }
  onLightChanged(e) {
    this.setRenderingNeeded();
  }
  getSceneMeshesByName(e) {
    return this._sceneHelper ? this._sceneHelper.getSceneMeshesByName(e) : [];
  }
  getSceneMeshes() {
    return this._sceneHelper ? this._sceneHelper.getSceneMeshes() : [];
  }
  getMeshesUsingMaterial(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshesUsingMaterial(e) : [];
  }
  getMeshesMaterials(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshesMaterials(e) : [];
  }
  getMeshMaterials(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshMaterials(e) : [];
  }
  getAllMaterials() {
    return this._sceneHelper ? this._sceneHelper.getAllMaterials() : [];
  }
  // restituisce un array di gruppi di materiali
  // ogni gruppo è del tipo MaterialGroup, con proprietà
  // "group"(nome del gruppo)
  // "materials"(elenco materiali)
  getGroupedMaterials() {
    const e = [], t = {}, s = this.getAllMaterials();
    for (let o = 0; o < s.length; o++) {
      let a = s[o];
      if (a.id == "groundMaterial")
        continue;
      const c = this.getMaterialGroup(a.id);
      let g = null;
      t.hasOwnProperty(c) ? g = t[c] : (g = new Iw(c), e.push(g), t[c] = g), g && g.materials.push(a);
    }
    return e.sort(function(o, a) {
      var c = o.groupName.toLowerCase(), g = a.groupName.toLowerCase();
      return c < g ? -1 : c > g ? 1 : 0;
    });
  }
  // Assegna il gruppo ad un array di materiali
  setMaterialsGroup(e, t, s = !0) {
    for (let o = 0; o < e.length; o++) {
      const a = e[o];
      this.setMaterialGroup(a, t, s);
    }
  }
  // Assegna il gruppo ad un singolo materiale
  setMaterialGroup(e, t, s = !0) {
    !this._scene || !this._scene.getMaterialByID(e) || (this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.groups || (this._scene.metadata.groups = {}), this._scene.metadata.groups[e] = t, s && this.fireMaterialsUpdateEvent());
  }
  // Restituisce il gruppo di un materiale
  getMaterialGroup(e) {
    return this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(e) ? this._scene.metadata.groups[e] : ol.EmptyGroupName;
  }
  // Elimina il gruppo di un materiale
  removeMaterialGroup(e) {
    this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(e) && (delete this._scene.metadata.groups[e], this.fireMaterialsUpdateEvent());
  }
  getMaterialsByGroup(e) {
    const t = [], s = e || ol.EmptyGroupName;
    return this._scene && this._sceneHelper && this._sceneHelper.getAllMaterials().forEach((o) => {
      this.getMaterialGroup(o.id) === s && t.push(o);
    }), t;
  }
  getGroupCenter(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshHierarchyCenter(e) : null;
  }
  getGroupBoundingInfo(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return new BABYLON.BoundingInfo(t.min, t.max);
  }
  showHideBoundingBox(e) {
    this._showBoundingBox = e, this.updateBoundingBox(), this.setRenderingNeeded();
  }
  updateBoundingBox() {
    this.deleteBoundingBox(), this.showBoundingBox && this.createSceneBoundingBox(!0);
  }
  deleteBoundingBox() {
    let e = this.getSceneBoundingBox();
    e && e.dispose();
  }
  setCameraPositionScale(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraPositionScale(e), this._sceneHelper.setCameraPositionScale(e, !0), this.setRenderingNeeded());
  }
  setCameraLimitLowerRadius(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLimitLowerRadius(e), this._sceneHelper.setCameraLimitLowerRadius(e, !0), this.setRenderingNeeded());
  }
  setCameraZoomEnabled(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraZoomEnabled(e), this._sceneHelper.setZoomEnabled(e), this.setRenderingNeeded());
  }
  setCameraUseMinZoomPercentage(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUseMinZoomPerc(e), this._sceneHelper.setMinZoomPerc(e ? this._zkScene.getCameraMinZoomPerc() : void 0), this.setRenderingNeeded());
  }
  setCameraMinZoomPercentage(e) {
    if (this._zkScene && this._sceneHelper) {
      this._zkScene.setCameraMinZoomPerc(e);
      var t = this._zkScene.getCameraUseMinZoomPerc();
      this._sceneHelper.setMinZoomPerc(t ? e : void 0), this.setRenderingNeeded();
    }
  }
  setCameraUseMaxZoomPercentage(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUseMaxZoomPerc(e), this._sceneHelper.setMaxZoomPerc(e ? this._zkScene.getCameraMaxZoomPerc() : void 0), this.setRenderingNeeded());
  }
  setCameraMaxZoomPercentage(e) {
    if (this._zkScene && this._sceneHelper) {
      this._zkScene.setCameraMaxZoomPerc(e);
      const t = this._zkScene.getCameraUseMaxZoomPerc();
      this._sceneHelper.setMaxZoomPerc(t ? e : void 0), this.setRenderingNeeded();
    }
  }
  lockCameraAlphaAngle() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.alpha ?? 0;
      this._zkScene.setCameraLowerAlphaLimit(e), this._zkScene.setCameraUpperAlphaLimit(e), this._sceneHelper.setCameraAlphaLimits(e, e), this.setRenderingNeeded();
    }
  }
  unlockCameraAlphaAngle() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerAlphaLimit(null), this._zkScene.setCameraUpperAlphaLimit(null), this._sceneHelper.setCameraAlphaLimits(null, null), this.setRenderingNeeded());
  }
  lockCameraBetaAngle() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      var e = this._camera.beta ?? -1.57;
      this._zkScene.setCameraLowerBetaLimit(e), this._zkScene.setCameraUpperBetaLimit(e), this._sceneHelper.setCameraBetaLimits(e, e), this.setRenderingNeeded();
    }
  }
  unlockCameraBetaAngle() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerBetaLimit(null), this._zkScene.setCameraUpperBetaLimit(null), this._sceneHelper.setCameraBetaLimits(null, null), this.setRenderingNeeded());
  }
  setCameraLowerAlphaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.alpha;
      this._zkScene.setCameraLowerAlphaLimit(e), this._sceneHelper.setCameraLowerAlphaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraLowerAlphaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerAlphaLimit(null), this._sceneHelper.setCameraLowerAlphaLimit(null), this.setRenderingNeeded());
  }
  setCameraUpperAlphaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      var e = this._camera.alpha;
      this._zkScene.setCameraUpperAlphaLimit(e), this._sceneHelper.setCameraUpperAlphaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraUpperAlphaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUpperAlphaLimit(null), this._sceneHelper.setCameraUpperAlphaLimit(null), this.setRenderingNeeded());
  }
  setCameraLowerBetaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.beta;
      this._zkScene.setCameraLowerBetaLimit(e), this._sceneHelper.setCameraLowerBetaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraLowerBetaLimit() {
    this._zkScene && this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerBetaLimit(null), this._sceneHelper.setCameraLowerBetaLimit(null), this.setRenderingNeeded());
  }
  setCameraUpperBetaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.beta;
      this._zkScene.setCameraUpperBetaLimit(e), this._sceneHelper.setCameraUpperBetaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraUpperBetaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUpperBetaLimit(null), this._sceneHelper.setCameraUpperBetaLimit(null), this.setRenderingNeeded());
  }
  // Mesh selection overrides (the selection logic si a little bit different
  // respect the parent SceneViewer one)
  selectMesh(e) {
    this.selectUnselectMesh(e, !0);
  }
  unselectMesh(e) {
    this.selectUnselectMesh(e, !1);
  }
  unselectAllMeshes() {
    this._scene && this._scene.meshes.forEach((e) => this.unselectSingleMesh(e));
  }
  selectUnselectMesh(e, t) {
    if (this._scene) {
      if (this.deleteBoundingBox(), this.unselectAllMeshes(), t) {
        const s = (a) => {
          this.selectSingleMesh(a), a.getChildMeshes().forEach((c) => s(c));
        };
        let o = this._scene.getMeshByID(e);
        this._isSelectionMode || (o = this.getDAMMainMesh() ?? o), o && s(o), this.setManipulatedNode(o);
      } else
        this.setManipulatedNode(null);
      this.fireSelectionChangedEvent();
    }
  }
  selectSingleMesh(e) {
    e.selected = !0, this.highlightMesh(e, !0), this.setRenderingNeeded();
  }
  unselectSingleMesh(e) {
    e.selected = !1, this.highlightMesh(e, !1), this.setRenderingNeeded();
  }
  isMeshSelected(e) {
    return e && e.selected != null && e.selected;
  }
  // Show-hide mesh methods
  showMesh(e) {
    this.resetRealVisibility(), this.showHideMesh(e, !0, !0);
  }
  hideMesh(e) {
    this.resetRealVisibility(), this.showHideMesh(e, !1, !0);
  }
  showHideMesh(e, t, s = !0) {
    var o;
    if (this._scene && this._sceneHelper && this._camera) {
      this._scene;
      const a = this._sceneHelper, c = this._camera, g = (H, Y) => {
        H.isVisible = Y, Logger.info(H.name), H.getChildMeshes().forEach((ee) => g(ee, Y));
      }, w = (H, Y) => {
        g(H, Y), !(a && c && H.metadata && H.metadata.isGroup && H.getChildMeshes().length === 0) && Y && !c.isCompletelyInFrustum(H) && (a.adjustCamera(void 0, !1, !1), a.setupShaderMaterialsCameraPosition()), s && this.fireMeshesUpdateEvent(), this.setRenderingNeeded();
      }, T = this._scene.getMeshByID(e);
      if (T) {
        const H = (o = this._zkScene) == null ? void 0 : o.get("rootUrl");
        H ? a.unsetMeshDummyMaterialAsync(T, H, !0).then(() => w(T, t)) : w(T, t);
      }
      this.refreshInfoPoints();
    }
  }
  // Permette di mostrare esclusivamente la mesh selezionata (e i suoi figli)
  // Lo stato precedente delle mesh viene memorizzato in modo da poter essere
  // ripristinato con la funzione resetRealVisibility
  setTemporaryExclusivelyVisible(e) {
    this._scene && (this.resetRealVisibility(), this._realMeshVisibility = {}, this._scene.meshes.forEach((t) => {
      this._realMeshVisibility[t.id] = t.isVisible, this.isRealMesh(t) && (t.isVisible = !1);
    }), this.showHideMesh(e, !0, !1));
  }
  // Reimposto lo stato di visibilità come era precedentemente alla chiamata
  // a setTempraryExclusiveVisible
  resetRealVisibility() {
    this._scene && this._sceneHelper && this._realMeshVisibility && (this._sceneHelper.getSceneMeshes().forEach((t) => {
      this._realMeshVisibility.hasOwnProperty(t.id) && (t.isVisible = this._realMeshVisibility[t.id]);
    }), this.setRenderingNeeded());
  }
  // Funzione per modificare il colore di un materiale in modo progressivo (tramite animazione)
  changeMaterialColor(e, t, s) {
    this._sceneHelper && this._sceneHelper.changeMaterialColor(e, t, s);
  }
  renameMesh(e, t) {
    if (this._scene) {
      const s = this._scene.getMeshByID(e);
      s && (s.name = t, this.fireMeshesUpdateEvent());
    }
  }
  //#region Events
  // PreUpdateEvent
  firePreUpdateEvent() {
    this._preUpdateListeners.forEach((e) => e());
  }
  addPreUpdateListener(e) {
    this._preUpdateListeners.push(e);
  }
  removePreUpdateListener(e) {
    for (let t = 0; t < this._preUpdateListeners.length; t++)
      if (this._preUpdateListeners[t] == e) {
        this._preUpdateListeners.splice(t--, 1);
        break;
      }
  }
  // PostUpdateEvent
  firePostUpdateEvent() {
    this._postUpdateListeners.forEach((e) => e());
  }
  addPostUpdateListener(e) {
    this._postUpdateListeners.push(e);
  }
  removePostUpdateListener(e) {
    for (let t = 0; t < this._postUpdateListeners.length; t++)
      if (this._postUpdateListeners[t] == e) {
        this._postUpdateListeners.splice(t--, 1);
        break;
      }
  }
  // MeshSelected
  fireMeshSelectedEvent(e) {
    this._meshSelectedListeners.forEach((t) => t(e));
  }
  addMeshSelectedListener(e) {
    this._meshSelectedListeners.push(e);
  }
  removeMeshSelectedListener(e) {
    const t = this._meshSelectedListeners.indexOf(e);
    t != -1 && this._meshSelectedListeners.splice(t, 1);
  }
  // SelectionChanged
  fireSelectionChangedEvent() {
    this._selectionChangedListeners.forEach((e) => e());
  }
  addSelectionChangedListener(e) {
    this._selectionChangedListeners.push(e);
  }
  removeSelectionChangedListener(e) {
    const t = this._selectionChangedListeners.indexOf(e);
    t != -1 && this._selectionChangedListeners.splice(t, 1);
  }
  // LightsSelected
  fireLightSelectedEvent(e) {
    this._lightSelectedListeners.forEach((t) => t(e));
  }
  addLightSelectedListener(e) {
    this._lightSelectedListeners.push(e);
  }
  // SceneCreated
  fireSceneCreatedEvent() {
    this._sceneCreatedListeners.forEach((e) => e());
  }
  addSceneCreatedListener(e) {
    this._sceneCreatedListeners.push(e);
  }
  // CameraLocationCreated
  fireCameraLocationCreatedEvent(e) {
    this._cameraLocationCreatedListeners.forEach((t) => t(e));
  }
  addCameraLocationCreatedListener(e) {
    this._cameraLocationCreatedListeners.push(e);
  }
  // CameraLocationsUpdate
  fireCameraLocationsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllCameraLocations()), !e)
      throw "Failed firing positions update event: lights are null and no scene present";
    this._cameraLocationsUpdateListeners.forEach((t) => t(e));
  }
  addCameraLocationsUpdateListener(e) {
    this._cameraLocationsUpdateListeners.push(e);
  }
  // SceneSourceTaskSuccess
  fireSceneSourceTaskSuccessEvent(e) {
    this._sceneSourceTaskSuccessListeners.forEach((t) => t(e));
  }
  addSceneSourceTaskSuccessListener(e) {
    this._sceneSourceTaskSuccessListeners.push(e);
  }
  // SceneSourceTaskError
  fireSceneSourceTaskErrorEvent(e) {
    this._sceneSourceTaskErrorListeners.forEach((t) => t(e));
  }
  addSceneSourceTaskErrorListener(e) {
    this._sceneSourceTaskErrorListeners.push(e);
  }
  removeSceneSourceTaskErrorListener(e) {
    const t = this._sceneSourceTaskErrorListeners.indexOf(e);
    t != -1 && this._sceneSourceTaskErrorListeners.splice(t, 1);
  }
  // SceneSourceTaskCheck
  fireSceneSourceTaskCheckEvent() {
    this._sceneSourceTasksCheckListeners.forEach((e) => e());
  }
  addSceneSourceTaskCheckListener(e) {
    this._sceneSourceTasksCheckListeners.push(e);
  }
  removeSceneSourceTaskCheckListener(e) {
    const t = this._sceneSourceTasksCheckListeners.indexOf(e);
    t != -1 && this._sceneSourceTasksCheckListeners.splice(t, 1);
  }
  // MeshesUpdate
  fireMeshesUpdateEvent(e) {
    if (!e && this._scene && (e = this.getSceneMeshes()), !e)
      throw "Failed firing mesh update event: meshes are null and no scene present";
    this._meshesUpdateListeners.forEach((t) => t(e));
  }
  addMeshesUpdateListener(e) {
    this._meshesUpdateListeners.push(e);
  }
  removeMeshesUpdateListener(e) {
    const t = this._meshesUpdateListeners.indexOf(e);
    t != -1 && this._meshesUpdateListeners.splice(t, 1);
  }
  // MaterialsUpdate
  fireMaterialsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getGroupedMaterials()), !e)
      throw "Failed firing materials update event: materials are null and no scene present";
    this._materialsUpdateListeners.forEach((t) => t(e));
  }
  addMaterialsUpdateListener(e) {
    this._materialsUpdateListeners.push(e);
  }
  // LighsUpdate
  fireLightsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllLights()), !e)
      throw "Failed firing lights update event: lights are null and no scene present";
    this._lightsUpdateListeners.forEach((t) => t(e));
  }
  addLightsUpdateListener(e) {
    this._lightsUpdateListeners.push(e);
  }
  // MeshLocationCreated
  fireMeshLocationCreatedEvent(e) {
    this._meshLocationCreatedListeners.forEach((t) => t(e));
  }
  addMeshLocationCreatedListener(e) {
    this._meshLocationCreatedListeners.push(e);
  }
  // MeshLocationsUpdate
  fireMeshLocationsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllMeshLocations()), e)
      this._meshLocationsUpdateListeners.forEach((t) => t(e));
    else
      throw "Failed firing mesh positions update event: positions are null and no scene present";
  }
  addMeshLocatonsUpdateListener(e) {
    this._meshLocationsUpdateListeners.push(e);
  }
  // ArTaskSuccess
  fireArTaskSuccessEvent() {
    this._arTaskSuccessListeners.forEach((e) => e());
  }
  addArTaskSuccessListener(e) {
    this._arTaskSuccessListeners.push(e);
  }
  // ArTaskError
  fireArTaskErrorEvent() {
    this._arTaskErrorListeners.forEach((e) => e());
  }
  addArTaskErrorListener(e) {
    this._arTaskErrorListeners.push(e);
  }
  // ArTaskCheck
  fireArTaskCheckEvent() {
    this._arTasksCheckListeners.forEach((e) => e());
  }
  addArTaskCheckListener(e) {
    this._arTasksCheckListeners.push(e);
  }
  fireFineTuningSettingEvent(e) {
    this._tryOnFineTuningSettingListeners.forEach((t) => t(e));
  }
  addFineTuningSettingListener(e) {
    return this._tryOnFineTuningSettingListeners.push(e), this._tryOnFineTuningSettingListeners.length - 1;
  }
  removeFineTuningSettingListener(e) {
    this._tryOnFineTuningSettingListeners.splice(e, 1);
  }
  removeAllFineTuningSettingListeners() {
    this._tryOnFineTuningSettingListeners = [];
  }
  fireFineTuningCloseEvent() {
    this._tryOnFineTuningCloseListeners.forEach((e) => e());
  }
  addFineTuningCloseListener(e) {
    this._tryOnFineTuningCloseListeners.push(e);
  }
  // Clear
  clearListeners() {
    this._meshSelectedListeners = [], this._selectionChangedListeners = [], this._lightSelectedListeners = [], this._sceneCreatedListeners = [], this._cameraLocationCreatedListeners = [], this._sceneSourceTaskSuccessListeners = [], this._sceneSourceTaskErrorListeners = [], this._sceneSourceTasksCheckListeners = [], this._meshesUpdateListeners = [], this._materialsUpdateListeners = [], this._lightsUpdateListeners = [], this._cameraLocationsUpdateListeners = [], this._meshLocationCreatedListeners = [], this._meshLocationsUpdateListeners = [], this._arTaskSuccessListeners = [], this._arTaskErrorListeners = [], this._arTasksCheckListeners = [], this._tryOnFineTuningSettingListeners = [], this._tryOnFineTuningCloseListeners = [];
  }
  //#endregion
  //#region Interazione utente (Pointer Down/Move)
  onPointerDown(e, t) {
    if (!(!this._scene || !this._sceneHelper || this._envMode != Ss.Editor) && this._selectOnPick && t && t.hit && t.pickedMesh && t.pickedMesh !== this._ground) {
      this.selectMesh(t.pickedMesh.id);
      const s = this.convertSceneToScreenPoint(this._scene.pointerX, this._scene.pointerY);
      if (s) {
        const o = {
          name: t.pickedMesh.name,
          id: t.pickedMesh.id,
          scenePointerX: this._scene.pointerX,
          scenePointerY: this._scene.pointerY,
          screenPointerX: s.X,
          screenPointerY: s.Y
        };
        this.fireMeshSelectedEvent(o);
      }
    }
  }
  onPointerMove(e, t) {
    if (!this._scene || !this._sceneHelper || this._envMode != Ss.Editor)
      return;
    if (this.highlightMeshOver(!1), !this._highlightOver) {
      this._meshOver = null;
      return;
    }
    const s = this._scene.pick(this._scene.pointerX, this._scene.pointerY);
    s && s.hit && s.pickedMesh && this._sceneHelper.isRealMesh(s.pickedMesh) && (this._meshOver = s.pickedMesh, this.highlightMeshOver(!0));
  }
  //#endregion
  //#region Element Selection
  getSubMesh(e, t) {
    return this._sceneHelper ? this._sceneHelper.getSubMesh(e, t) : null;
  }
  getLightByID(e) {
    return this._scene ? this._scene.getLightByID(e) : null;
  }
  //#endregion
  //#region Apply material
  applyMaterialByName(e, t) {
    this._sceneHelper && this._sceneHelper.applyMaterialByName(e, t);
  }
  applyMaterial(e, t) {
    this._sceneHelper && (this._sceneHelper.applyMaterial(e, t), this.setLongRenderingNeeded());
  }
  applyMaterialToSubMeshByName(e, t, s) {
    this._sceneHelper && this._sceneHelper.applyMaterialToSubMeshByName(e, t, s);
  }
  applyMaterialToSubMesh(e, t, s) {
    this._sceneHelper && this._sceneHelper.applyMaterialToSubMesh(e, t, s);
  }
  resetMeshMaterial(e, t) {
    t ? this._initialMeshMaterials : this._lastMeshMaterials;
  }
  resetSubMeshMaterial(e, t, s) {
    const o = s ? this._initialSubMeshMaterials : this._lastSubMeshMaterials;
    if (e && t && e.material instanceof BABYLON.MultiMaterial) {
      const a = t.materialIndex;
      if (a >= 0 && a < e.material.subMaterials.length) {
        const c = `${e.id}_${a}`;
        if (o.hasOwnProperty(c)) {
          const g = o[c], w = this.getMaterialByID(g);
          w && (e.material.subMaterials[a] = w);
        }
      }
    }
    this.setRenderingNeeded();
  }
  //#endregion
  getExtension(e) {
    var t = e.lastIndexOf(".");
    if (t !== -1) {
      var s = e.substring(t).toLowerCase();
      return s;
    }
  }
  //#region Caricamento texture da file esterni
  loadMobileTextureFilesAsync(e, t, s, o) {
    return new Promise((a, c) => {
      this.loadMobileTextureFiles(
        e,
        t,
        s,
        o,
        () => a(),
        (g) => c()
      );
    });
  }
  loadMobileTextureFiles(e, t, s, o, a, c) {
    const g = e.length === 6 || this.getExtension(e[0].name) === ".dds" || this.getExtension(e[0].name) === ".hdr" || this.getExtension(e[0].name) === ".env" || this.getExtension(e[0].name) === ".basis";
    this.uploadTextureFiles(
      e,
      t,
      s,
      (w) => {
        w.length > 0 && (g ? this.setMobileCubeTextureImages(w, t, s) : this.setMobileTextureImage(w[0], t, s, o)), a && a();
      },
      c,
      !1
    );
  }
  loadTextureFilesAsync(e, t, s, o) {
    return new Promise((a, c) => {
      this.loadTextureFiles(
        e,
        t,
        s,
        o,
        () => a(),
        (g) => c(g)
      );
    });
  }
  // Per il caso di texture di ambiente si suppone che material sia null e che type sia
  // uno di "environment", "skybox", "ground"
  loadTextureFiles(e, t, s, o, a, c) {
    const g = e.length === 6 || this.getExtension(e[0].name) === ".dds" || this.getExtension(e[0].name) === ".hdr" || this.getExtension(e[0].name) === ".env" || this.getExtension(e[0].name) === ".basis";
    this.uploadTextureFiles(
      e,
      t,
      s,
      async (w) => {
        w.length > 0 && (g ? await this.setCubeTextureImages(w, t, s) : (await this.setTextureImage(w[0], t, s, o), (!s.includes("sheen") && !s.includes("clearCoat") && !s.includes("subSurface") && !s.includes("anisotropy") && (!t[s + "Texture"].metadata || !t[s + "Texture"].metadata.mobileUrl) || !t[s.split("_")[0]][s.toLowerCase().includes("texture") ? "texture" : s.split("_")[1] + "Texture"].metadata || !t[s.split("_")[0]][s.toLowerCase().includes("texture") ? "texture" : s.split("_")[1] + "Texture"].metadata.mobileUrl) && await new Promise(async (T) => {
          this.uploadTextureFiles(
            e,
            t,
            s,
            async (H) => {
              this.setMobileTextureImage(H[0], t, s, o), T();
            },
            c,
            !0
          );
        })), a && a());
      },
      c,
      !1
    );
  }
  getRecursiveBoundingBox(e) {
    this.calculateRecursiveBoundingBox(e);
    const t = e.getBoundingInfo().boundingBox.scale(2);
    return e.setBoundingInfo(new BABYLON.BoundingInfo(BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero())), new BABYLON.BoundingBox(t.minimum, t.maximum);
  }
  calculateRecursiveBoundingBox(e) {
    const t = (o) => {
      o.refreshBoundingInfo();
      for (const a of o.getChildMeshes(!0))
        t(a);
    };
    t(e);
    const s = e.getHierarchyBoundingVectors(!0);
    e.setBoundingInfo(new BABYLON.BoundingInfo(s.min, s.max));
  }
  calculateBoundingBox(e) {
    let { min: t, max: s } = e[0].getHierarchyBoundingVectors(!1);
    for (let o = 1; o < e.length; o++) {
      const a = e[o].getHierarchyBoundingVectors(!1);
      t = BABYLON.Vector3.Minimize(t, a.min), s = BABYLON.Vector3.Maximize(s, a.max);
    }
    return new BABYLON.BoundingBox(t, s).extendSizeWorld.length();
  }
  // VERIFICA SE CI SONO MESH CHE SUPERANO I BOUNDS DELLE MESH DI RIFERIMENTO
  // Ritorna 1 se la mesh supera il volume di tutte le altre mesh
  // Ritorna -1 se la mesh è superata da almeno una delle altre mesh
  // Ritorna 0 se la mesh non supera il volume di nessuna delle altre mesh o se il volume è simile
  //maxThreshold percentuale di sensibilità del controllo
  //minThreshold aumentondolo aumenta la sensibilità del controllo
  checkMeshHiddenByMeshes(e, t, s, o) {
    const a = this.calculateBoundingBox(t), c = this.calculateBoundingBox(e);
    return c - c * s > a ? 1 : c + c * o < a ? -1 : 0;
  }
  uploadTextureFileAsync(e, t) {
    return new Promise((s, o) => {
      if (!this._scene || !this._zkScene || !e) {
        s(null);
        return;
      }
      const a = t ? t.id : Zakeke.getEmptyUUID(), c = (T) => {
        if (this._zkScene && T && T.textureID && T.materialID && (T.fileObjectID || T.fileLength) && T.url) {
          const H = new Zakeke.SceneTexture();
          return H.set("textureID", T.textureID), H.set("materialID", T.materialID), H.set("fileObjectID", T.fileObjectID), H.set("fileLength", T.fileLength), H.set("url", T.url), this._zkScene.get("textures").push(H), H;
        }
        return null;
      }, g = new FormData();
      g.append("file", e);
      const w = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this._authorizationToken}`
        },
        body: g
      };
      fetch(this.getTexturesUploadUrl(a), w).then((T) => {
        if (T.ok)
          return T.json();
        throw new Error("An error occurred");
      }).then((T) => {
        if (Array.isArray(T)) {
          const H = c(T[0]);
          H ? s(H) : o("Invalid image");
        } else
          o("Invalid image");
      }).catch((T) => {
        o("An error occurred: " + T.message);
      });
    });
  }
  async uploadTextureFiles(e, t, s, o, a, c) {
    if (!this._scene || !this._zkScene || !e || e.length == 0)
      return;
    const g = t ? t.id : Zakeke.getEmptyUUID(), w = (ue) => {
      if (this._zkScene && ue && ue.textureID && ue.materialID && (ue.fileObjectID || ue.fileLength) && ue.url) {
        const xe = new Zakeke.SceneTexture();
        return xe.set("textureID", ue.textureID), xe.set("materialID", ue.materialID), xe.set("fileObjectID", ue.fileObjectID), xe.set("fileLength", ue.fileLength), xe.set("url", ue.url), this._zkScene.get("textures").push(xe), xe;
      }
      return null;
    }, T = (ue) => {
      const xe = ue.lastIndexOf(".");
      return xe !== -1 ? ue.substring(xe) : null;
    }, H = (ue, xe) => {
      const Ee = ue.lastIndexOf(".");
      return Ee !== -1 ? ue.substring(0, Ee).endsWith("_" + xe) : !1;
    }, Y = T(e[0].name), ee = this.canLoadCubemap(t, s) && (e.length == 6 || Y === ".dds" || Y === ".hdr" || Y === ".env" || Y === ".basis"), z = [];
    if (ee && e.length == 6) {
      const ue = ["px", "py", "pz", "nx", "ny", "nz"];
      for (let xe = 0; xe < e.length; xe++) {
        const Ee = e[xe];
        let K = -1;
        for (let j = 0; j < ue.length; j++)
          if (H(Ee.name, ue[j])) {
            z.push(Ee), K = j;
            break;
          }
        K !== -1 && ue.splice(K, 1);
      }
      if (ue.length != 0) {
        const xe = "Immagini per la cube map non valide";
        a && a(xe), Logger.info(xe);
        return;
      }
    } else
      z.push(e[0]);
    const he = new FormData();
    for (let ue = 0; ue < z.length; ue++)
      he.append("file-" + ue, z[ue]);
    var ne = this._zkScene.getTexturesConfig();
    if (ne) {
      var ye = JSON.stringify(ne), se = new Blob([ye], {
        type: "application/json"
      });
      he.append("options", se, "options.json");
    }
    he.forEach((ue) => console.log("File: ", ue));
    const _e = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this._authorizationToken}`
        // 'Content-Type': 'multipart/form-data',
      },
      body: he
    };
    fetch(this.getTexturesUploadUrl(g) + "?resize=" + c, _e).then((ue) => {
      if (!ue.ok)
        throw new Error("An error occurred: " + ue.status);
      return ue.json();
    }).then((ue) => {
      const xe = [];
      if (Object.prototype.toString.call(ue) === "[object Array]")
        for (let Ee = 0; Ee < ue.length; Ee++) {
          const K = w(ue[Ee]);
          if (!K) {
            const j = "Immagini non valide";
            if (a) {
              a(j);
              return;
            }
          }
          K && xe.push(K);
        }
      o && o(xe);
    }).catch((ue) => {
      const xe = "An error occurred: " + ue.message;
      a && a(xe);
    });
  }
  getTexturesUploadUrl(e) {
    return this._zkScene ? this._zkScene.getTexturesUrl(e) : "";
  }
  removeAllMaterialPhotos(e) {
    if (this._zkScene) {
      const t = [];
      for (let s = 0; s < this._zkScene.get("materialPhotos").length; s++)
        this._zkScene.get("materialPhotos").at(s).get("materialID") === e.id && t.push(this._zkScene.get("materialPhotos").at(s));
      t.length > 0 && this._zkScene.get("materialPhotos").remove(t);
    }
  }
  removeMaterialPhotoAtIndex(e, t) {
    if (this._zkScene) {
      const s = [];
      for (let o = 0; o < this._zkScene.get("materialPhotos").length; o++)
        this._zkScene.get("materialPhotos").at(o).get("materialID") === e.id && s.push(this._zkScene.get("materialPhotos").at(o));
      if (s.length > 0) {
        const o = s[t];
        this._zkScene.get("materialPhotos").remove(o);
      }
    }
  }
  loadMaterialPhotoFiles(e, t, s, o) {
    this.uploadMaterialPhotoFiles(
      e,
      t,
      (a) => {
        this.refreshInfoPoints(), s && s();
      },
      o
    );
  }
  uploadMaterialPhotoFiles(e, t, s, o) {
    if (!this._scene || !this._zkScene || !e || e.length === 0)
      return;
    const a = t.id, c = (T) => {
      if (this._zkScene && T && T.photoID && T.materialID && (T.fileObjectID || T.fileLength) && T.url) {
        const H = new Zakeke.SceneMaterialPhoto();
        return H.set("photoID", T.photoID), H.set("materialID", T.materialID), H.set("fileObjectID", T.fileObjectID), H.set("fileLength", T.fileLength), H.set("url", T.url), this._zkScene.get("materialPhotos").push(H), H;
      }
      return null;
    }, g = (T) => {
      const H = T.lastIndexOf(".");
      return H !== -1 ? T.substring(H) : null;
    }, w = new FormData();
    for (let T = 0; T < e.length; T++) {
      const H = g(e[T].name);
      (H === ".png" || H === ".jpg") && w.append("file-" + T, e[T]);
    }
    jQuery.ajax({
      url: this.getMaterialPhotosUploadUrl(a),
      data: w,
      cache: !1,
      contentType: !1,
      processData: !1,
      type: "POST",
      success: (T) => {
        const H = [];
        if (Object.prototype.toString.call(T) === "[object Array]")
          for (let Y = 0; Y < T.length; Y++) {
            const ee = c(T[Y]);
            if (!ee) {
              const z = "Immagini non valide";
              if (o) {
                o(z);
                return;
              }
            }
            ee && H.push(ee);
          }
        s && s(H);
      },
      error: (T, H, Y) => {
        const ee = "An error occurred: " + H + " Error: " + Y;
        o && o(ee);
      }
    });
  }
  getMaterialPhotosUploadUrl(e) {
    return this._zkScene ? this._zkScene.getMaterialPhotosUrl(e) : "";
  }
  // Verifica se il material può caricare una cubemap per il tipo di proprietà specificato (type)
  canLoadCubemap(e, t) {
    return e ? e instanceof BABYLON.StandardMaterial && (t == "reflection" || t == "refraction") ? !0 : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? t === "environment" : e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial ? t === "reflection" : e instanceof BABYLON.ShaderMaterial : t == "environment" || t == "skybox";
  }
  // Aggiorna la configurazione di ambiente impostando l'url di una texture caricata
  setEnvironmentTexture(e, t, s, o, a) {
    t === "environment" ? this.setSceneEnvironmentTexture(e, void 0, s, o, a) : t === "skybox" ? this.setViewerSkyboxTexture(e, s, o) : t === "ground" && this.setViewerGroundTexture(e);
  }
  removeSceneEnvironmentTexture() {
    this._scene && this._scene.environmentTexture && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null, this._scene.metadata && this._scene.metadata.environmentTextureRotationY != null && delete this._scene.metadata.environmentTextureRotationY), this.setRenderingNeeded();
  }
  setSceneEnvironmentTextureRotationY(e) {
    this._scene && this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture) && (this._scene.environmentTexture.rotationY = e * Math.PI / 180, this.setLongRenderingNeeded());
  }
  // Crea e imposta la singola texture sul materiale per il tipo di proprietà specificato
  async setTextureImage(e, t, s, o) {
    return new Promise((a) => {
      if (this._scene && e && e instanceof Zakeke.SceneTexture) {
        const c = e.get("url");
        if (c)
          if (!t)
            this.setEnvironmentTexture(c, s);
          else {
            const g = this.getMaterialTexture(t, s);
            let w = !0;
            g && g instanceof BABYLON.Texture && (w = g.invertY);
            const T = new BABYLON.Texture(
              c,
              this._scene,
              o,
              w,
              void 0,
              () => this.setRenderingNeeded()
            );
            g && g instanceof BABYLON.Texture && (T.uScale = g.uScale, T.vScale = g.vScale, T.uOffset = g.uOffset, T.vOffset = g.vOffset, T.uAng = g.uAng, T.vAng = g.vAng, T.level = g.level, T.coordinatesIndex = g.coordinatesIndex, T.coordinatesMode = g.coordinatesMode, T.hasAlpha = g.hasAlpha, T.wrapU = g.wrapU, T.wrapV = g.wrapV, T.gammaSpace = g.gammaSpace), ni.whenTextureIsReadyAsync(T).then(() => {
              this.applyTexture(T, t, s), g && !this.isTextureUsed(g) && g.dispose(), this.setRenderingNeeded(), a();
            });
          }
      }
    });
  }
  // Crea la cubemap e la imposta sul materiale e tipo di poprietà specificato
  async setCubeTextureImages(e, t, s) {
    return new Promise((o) => {
      (!this._scene || Object.prototype.toString.call(e) != "[object Array]") && o();
      for (let w = 0; w < e.length; w++) {
        const T = e[w];
        (!T || !(T instanceof Zakeke.SceneTexture)) && o();
      }
      const a = () => this.setLongRenderingNeeded();
      let c = null;
      const g = this.getCubeTextureInfo(e);
      if (g.url && this._scene)
        if (e.length === 1) {
          const w = g.url;
          w && (t ? w.endsWith(".dds") ? c = BABYLON.CubeTexture.CreateFromPrefilteredData(w, this._scene) : w.endsWith(".hdr") ? c = new BABYLON.HDRCubeTexture(
            w,
            this._scene,
            128,
            void 0,
            void 0,
            void 0,
            void 0,
            a
          ) : w.endsWith(".env") ? c = new BABYLON.CubeTexture(
            w,
            this._scene,
            null,
            !1,
            null,
            a,
            null,
            void 0,
            !0,
            void 0,
            !0
          ) : w.endsWith(".basis") && (c = BABYLON.CubeTexture.CreateFromPrefilteredData(w, this._scene)) : this.setEnvironmentTexture(w, s));
        } else
          e.length === 6 && g.files.length === 6 && g.extensions.length === 6 && (t ? c = new BABYLON.CubeTexture(
            g.url,
            this._scene,
            g.extensions,
            !1,
            g.files,
            a
          ) : this.setEnvironmentTexture(
            g.url,
            s,
            g.extensions,
            g.files,
            a
          ));
      c ? ni.whenTextureIsReadyAsync(c).then(() => {
        if (t) {
          const w = this.getMaterialTexture(t, s);
          this.applyTexture(c, t, s), w && !this.isTextureUsed(w) && w.dispose(), this.setRenderingNeeded(), o();
        }
      }) : o();
    });
  }
  setMobileTextureImage(e, t, s, o) {
    if (this._scene && this._sceneHelper) {
      const a = e.get("url");
      if (a) {
        let c = null;
        t ? c = this.getMaterialTexture(t, s) : c = this._scene.environmentTexture, c !== null && this._sceneHelper.isTextureWithUrl(c) && (c.metadata || (c.metadata = {}), c.metadata.mobileUrl = a);
      }
    }
  }
  setMobileCubeTextureImages(e, t, s) {
    if (!this._scene || Object.prototype.toString.call(e) != "[object Array]")
      return;
    for (let a = 0; a < e.length; a++) {
      const c = e[a];
      if (!c || !(c instanceof Zakeke.SceneTexture))
        return;
    }
    const o = this.getCubeTextureInfo(e);
    if (o.url) {
      let a = null;
      t ? a = this.getMaterialTexture(t, s) : a = this._scene.environmentTexture, a && a instanceof BABYLON.CubeTexture && (a.metadata || (a.metadata = {}), a.metadata.mobileUrl = o.url, o.files.length === 6 && (a.metadata.mobileFiles = o.files, a.metadata.mobileExtensions = o.extensions));
    }
  }
  // Costruisce l'url della cubemap da utilizzare per la costruzione della texture di Babylon JS
  // Nel caso di cubemap con 6 immagini (_px _nx...), restituisce l'url senza il suffisso
  getCubeTextureInfo(e) {
    const t = {
      url: null,
      files: [],
      extensions: []
    };
    if (e.length === 1)
      t.url = e[0].get("url") || null;
    else if (e.length === 6) {
      const s = ["px", "py", "pz", "nx", "ny", "nz"];
      let o = null;
      const a = [], c = [], g = (H, Y) => {
        const ee = H.lastIndexOf(".");
        return ee !== -1 ? H.substring(0, ee).endsWith("_" + Y) : !1;
      }, w = (H, Y) => {
        const ee = H.lastIndexOf(".");
        if (ee !== -1) {
          const z = H.substring(0, ee);
          if (z.endsWith("_" + Y))
            return z.substring(0, z.length - ("_" + Y).length);
        }
        return null;
      }, T = (H, Y) => {
        const ee = H.lastIndexOf("_" + Y);
        return ee !== -1 ? H.substr(ee) : null;
      };
      for (let H = 0; H < s.length; H++) {
        const Y = s[H];
        for (let ee = 0; ee < e.length; ee++) {
          const z = e[ee].get("url");
          if (z && g(z, Y)) {
            a.push(z);
            const he = T(z, Y);
            he && c.push(he), o || (o = w(z, Y));
            break;
          }
        }
      }
      t.url = o, t.files = a, t.extensions = c;
    }
    return t;
  }
  isTextureUsed(e) {
    if (this._scene && e)
      for (let t = 0; t < this._scene.materials.length; t++) {
        const o = this._scene.materials[t].getActiveTextures();
        for (let a = 0; a < o.length; a++)
          if (o[a].uid === e.uid)
            return !0;
      }
    return !1;
  }
  async changeTextureInvertYAsync(e, t, s) {
    if (this._scene && this._sceneHelper) {
      var o = this._sceneHelper.getMaterialTexture(e, t);
      if (o && o instanceof BABYLON.Texture && o.invertY != s) {
        let c = o.url;
        if (c) {
          let g = c;
          if (!/^(?:\/|[a-z]+:\/\/)/.test(c)) {
            var a = await this.getSceneRootUrl();
            a && (g = a + c);
          }
          const T = new BABYLON.Texture(
            g,
            this._scene,
            void 0,
            s,
            void 0,
            () => this.setRenderingNeeded()
          );
          o && o instanceof BABYLON.Texture && (T.uScale = o.uScale, T.vScale = o.vScale, T.uOffset = o.uOffset, T.vOffset = o.vOffset, T.uAng = o.uAng, T.vAng = o.vAng, T.level = o.level, T.coordinatesIndex = o.coordinatesIndex, T.coordinatesMode = o.coordinatesMode, T.hasAlpha = o.hasAlpha, T.wrapU = o.wrapU, T.wrapV = o.wrapV, T.gammaSpace = o.gammaSpace), await ni.whenTextureIsReadyAsync(T), this.applyTexture(T, e, t), o && !this.isTextureUsed(o) && o.dispose(), this.setRenderingNeeded();
        }
      }
    }
  }
  applyTextureByName(e, t, s) {
    if (this._scene) {
      const o = this._scene.textures.find((a) => a.name === e);
      o && this.applyTexture(o, t, s);
    }
  }
  applyTexture(e, t, s) {
    if (e && s == "lightmap" && (e.coordinatesIndex = 1, (t instanceof BABYLON.StandardMaterial || t instanceof BABYLON.PBRMaterial || t instanceof BABYLON.PBRBaseSimpleMaterial) && (t.useLightmapAsShadowmap = !0)), t instanceof BABYLON.StandardMaterial)
      switch (s) {
        case "diffuse":
          t.diffuseTexture = e;
          break;
        case "emissive":
          t.emissiveTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "lightmap":
          t.lightmapTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
        case "specular":
          t.specularTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (s) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          t[`${s}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (s) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          t[`${s}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMaterial)
      switch (s) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          t[`${s}Texture`] = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else if (t instanceof BABYLON.ShaderMaterial)
      e && e instanceof BABYLON.Texture ? t.setTexture(s, e) : t.removeTexture(s);
    else if (t instanceof Zakeke.PBRMaterial)
      switch (s) {
        case "albedo":
          t.albedoTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "matCapReflection":
          t.matCapReflectionTexture = e;
          break;
        case "reflectivity":
          t.reflectivityTexture = e;
          break;
        case "microsurface":
          t.microsurfaceTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "ao":
          t.aoTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
      }
    this.setLongRenderingNeeded();
  }
  getMaterialTexture(e, t) {
    if (e instanceof BABYLON.StandardMaterial)
      switch (t) {
        case "diffuse":
          return e.diffuseTexture;
        case "emissive":
          return e.emissiveTexture;
        case "ambient":
          return e.ambientTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "opacity":
          return e.opacityTexture;
        case "specular":
          return e.specularTexture;
        case "reflection":
          return e.reflectionTexture;
        case "refraction":
          return e.refractionTexture;
        case "bump":
          return e.bumpTexture;
      }
    else if (e instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (t) {
        case "environment":
          return e.environmentTexture;
        case "normal":
          return e.normalTexture;
        case "emissive":
          return e.emissiveTexture;
        case "occlusion":
          return e.occlusionTexture;
        case "base":
          return e.baseTexture;
        case "metallicRoughness":
          return e.metallicRoughnessTexture;
      }
    else if (e instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (t) {
        case "environment":
          return e.environmentTexture;
        case "normal":
          return e.normalTexture;
        case "emissive":
          return e.emissiveTexture;
        case "occlusion":
          return e.occlusionTexture;
        case "diffuse":
          return e.diffuseTexture;
        case "specularGlossiness":
          return e.specularGlossinessTexture;
      }
    else if (e instanceof BABYLON.PBRMaterial)
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
          return e.albedoTexture;
        case "ambient":
          return e.ambientTexture;
        case "opacity":
          return e.opacityTexture;
        case "reflection":
          return e.reflectionTexture;
        case "emissive":
          return e.emissiveTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "metallic":
          return e.metallicTexture;
        case "microSurface":
          return e.microSurfaceTexture;
        case "bump":
          return e.bumpTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "refraction":
          return e.refractionTexture;
        case "clearCoat":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
      }
    else if (e instanceof Zakeke.PBRMaterial)
      switch (t) {
        case "albedo":
          return e.albedoTexture;
        case "bump":
          return e.bumpTexture;
        case "reflection":
          return e.reflectionTexture;
        case "matCapReflection":
          return e.matCapReflectionTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "microsurface":
          return e.microsurfaceTexture;
        case "ambient":
          return e.ambientTexture;
        case "ao":
          return e.aoTexture;
        case "opacity":
          return e.opacityTexture;
      }
    return null;
  }
  removeMaterialTexture(e, t) {
    this.applyTexture(null, e, t);
  }
  removeMaterialMobileTexture(e, t) {
    const s = this.getMaterialTexture(e, t);
    s && s.metadata && s.metadata.mobileUrl && (delete s.metadata.mobileUrl, s.metadata.hasOwnProperty("mobileFiles") && delete s.metadata.mobileFiles, s.metadata.hasOwnProperty("mobileExtensions") && delete s.metadata.mobileExtensions, Object.keys(s.metadata).length === 0 && s.metadata.constructor === Object && delete s.metadata);
  }
  //#endregion
  //#region Operazioni sugli elementi della scena
  /**
   * Create a group of meshes
   * @param parentId Id of the parent node of the group
   * @param name Name of the group
   * @param children Array of meshes to be included in the group
   */
  createGroup(e, t, s) {
    if (this._scene) {
      const o = new BABYLON.Mesh(t, this._scene);
      if (o.id = Zakeke.generateUUID(), o.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, e) {
        const a = this._scene.getMeshByID(e);
        a && (o.parent = a);
      }
      return s && s.forEach((a) => a.parent = o), this.fireMeshesUpdateEvent(), o;
    }
    return null;
  }
  deleteMesh(e, t) {
    const s = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = this._scene, a = this._sceneHelper, c = this._zkScene, g = o.getMeshByID(e);
      if (g) {
        const w = (H) => {
          const Y = this.getMeshMaterials(H);
          for (let ee = 0; ee < Y.length; ee++) {
            const z = Y[ee];
            if (!z)
              continue;
            const he = this.getMeshesUsingMaterial(z.id);
            he.length === 1 && he.every((ne) => a.meshHasParent(ne.id, g.id)) && (s.materialIDs.push(Y[ee].id), Y[ee].dispose());
          }
          H.getChildMeshes().forEach((ee) => w(ee));
        };
        t && (w(g), this.fireMaterialsUpdateEvent());
        const T = a.getCameraPivot();
        T && T === g && this.setCameraPivot(null), this.isMeshSelected(g) && this.unselectMesh(g.id), g.dispose(), s.meshIDs.push(e);
      }
      this.fireMeshesUpdateEvent(), this.setRenderingNeeded(), s.materialIDs.forEach((w) => {
        const T = c.getLibraryShaderMaterialIDForSceneMaterial(w);
        T && c.unregisterShaderMaterial(T);
      });
    }
    return s;
  }
  // Cancella tutte le mesh
  deleteAllMeshes() {
    if (this._scene && this._sceneHelper) {
      for (let e = 0; e < this._scene.meshes.length; e++) {
        const t = this._scene.meshes[e];
        this._sceneHelper.isRealMesh(t) && (this._scene.meshes.splice(e--, 1), t.dispose());
      }
      this.setCameraPivot(null), this.setRenderingNeeded();
    }
  }
  deleteDuplicatedMeshesWithDifferentParent(e, t) {
    const s = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = this._scene, a = this._sceneHelper, c = this._zkScene, g = (T) => {
        const H = this.getSceneMeshesByName(T.name);
        let Y = !1;
        for (let z = 0; z < H.length; z++) {
          var ee = H[z];
          if (ee.id != T.id && !a.meshHasParent(ee.id, e)) {
            if (t) {
              const he = this.getMeshMaterials(ee);
              for (let ne = 0; ne < he.length; ne++)
                this.getMeshesUsingMaterial(he[ne].id).length == 1 && (s.materialIDs.push(he[ne].id), he[ne].dispose());
            }
            s.meshIDs.push(ee.id), ee.dispose(), H.splice(z--, 1), Y = !0;
            break;
          }
        }
        Y || T.getChildMeshes().forEach((z) => g(z));
      }, w = o.getMeshByID(e);
      w && w.getChildMeshes().forEach((T) => g(T)), this.setRenderingNeeded(), s.materialIDs.forEach((T) => {
        const H = c.getLibraryShaderMaterialIDForSceneMaterial(T);
        H && c.unregisterShaderMaterial(H);
      });
    }
    return s;
  }
  // Cancella tutte le mesh figlie di quella in input
  // che hanno lo stesso nome di altre mesh con id diverso
  // Questa funzione può essere utile per elminiare oggetti duplicati importati
  // con file diversi
  deleteDuplicatedChildMeshes(e, t) {
    const s = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = this._scene, a = this._sceneHelper, c = this._zkScene, g = (T) => {
        const H = this.getSceneMeshesByName(T.name);
        let Y = !1;
        for (let ee = 0; ee < H.length; ee++) {
          const z = H[ee];
          if (z.id != T.id && !a.meshHasParent(z.id, e)) {
            if (t) {
              const he = this.getMeshMaterials(T);
              for (let ne = 0; ne < he.length; ne++)
                this.getMeshesUsingMaterial(he[ne].id).length == 1 && (s.materialIDs.push(he[ne].id), he[ne].dispose());
            }
            s.meshIDs.push(T.id), T.dispose(), Y = !0;
            break;
          }
        }
        if (!Y) {
          const ee = T.getChildMeshes();
          for (let z = 0; z < ee.length; z++)
            g(ee[z]);
        }
      }, w = o.getMeshByID(e);
      w && w.getChildMeshes().forEach((T) => g(T)), this.setRenderingNeeded(), s.materialIDs.forEach((T) => {
        const H = c.getLibraryShaderMaterialIDForSceneMaterial(T);
        H && c.unregisterShaderMaterial(H);
      });
    }
    return s;
  }
  deleteMaterial(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMaterialByID(e);
      t && (this.deleteMaterialInternal(t), this.fireMaterialsUpdateEvent(), this.setRenderingNeeded());
    }
  }
  deleteMaterialInternal(e) {
    if (this._scene && this._sceneHelper && e) {
      const t = e.id;
      if (this._zkScene) {
        const o = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(e.id);
        o && this._zkScene.unregisterShaderMaterial(o);
      }
      const s = this._sceneHelper.getTexturesExclusivelyForMaterial(e);
      e.dispose();
      for (let o = 0; o < s.length; o++)
        s[o].dispose();
      this._sceneHelper.removeSceneMaterialMetadata(t);
    }
  }
  deleteAllMaterials() {
    if (this._scene) {
      for (; this._scene.materials.length > 0; ) {
        const e = this._scene.materials.pop();
        e && this.deleteMaterialInternal(e);
      }
      this.fireMaterialsUpdateEvent(), this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
  }
  renameMaterial(e, t) {
    if (this._scene) {
      const s = this._scene.getMaterialByID(e);
      s && (s.name = t), this.fireMaterialsUpdateEvent();
    }
  }
  cloneMesh(e) {
    let t = null;
    return this._scene && this._sceneHelper && (t = this._sceneHelper.cloneMesh(e, !1, !1), this.setRenderingNeeded(), this.fireMeshesUpdateEvent()), t;
  }
  // Same as clone but with duplicated geometry data too
  duplicateMesh(e, t = !1) {
    let s = null;
    return this._scene && this._sceneHelper && (s = this._sceneHelper.cloneMesh(e, !0, t), this.setRenderingNeeded(), this.fireMeshesUpdateEvent()), s;
  }
  cloneMaterial(e, t, s) {
    let o = null;
    if (this._scene && this._sceneHelper) {
      const c = this._scene.getMaterialById(e);
      if (c) {
        const g = s || c.name + " - clone";
        if (o = c.clone(g), o) {
          const w = t || Zakeke.generateUUID();
          if (o.id = w, this._zkScene) {
            const T = this._zkScene.getMappingForSceneMaterial(c.id);
            if (T) {
              var a = T.get("libraryMaterialID");
              this._zkScene.mapLibraryMaterial(a, o.id);
              const H = this._sceneHelper.getTexturesForMaterial(o), Y = this._sceneHelper.getTexturesForMaterial(o);
              for (let ee = 0; ee < Y.length; ee++) {
                const z = Y[ee], he = H[ee];
                z.materialMapping = he.materialMapping;
              }
            }
          }
        }
      }
      this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
    return o;
  }
  createMaterial(e, t, s) {
    let o = null;
    if (this._scene) {
      const a = e || "new material", c = t || "Standard";
      c === "Standard" ? o = new BABYLON.StandardMaterial(a, this._scene) : c === "PBRMetallicRoughness" ? (o = new BABYLON.PBRMetallicRoughnessMaterial(a, this._scene), o.subSurface.indexOfRefraction = 1, o._imageProcessingConfiguration.contrast = 1) : c === "PBRSpecularGlossiness" ? o = new BABYLON.PBRSpecularGlossinessMaterial(a, this._scene) : c === "PBR" ? (o = new BABYLON.PBRMaterial(a, this._scene), o.enableSpecularAntiAliasing = !0, o.metallic = 0.9, o.roughness = 0.3, o.indexOfRefraction = 1.5) : c === "NewPBR" && (o = new Zakeke.PBRMaterial(a, this._scene)), o && (o.id = Zakeke.generateUUID(), s && (o.metadata || (o.metadata = {}), o.metadata.group = s)), this.checkSceneEmptyEnvironmentTexture(), this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
    return o;
  }
  changeMeshParent(e, t) {
    if (this._scene) {
      const s = this._scene.getMeshById(e);
      if (s && (!s.parent || s.parent.id != t)) {
        const o = this._scene.getMeshById(t);
        s.setParent(o), this.setRenderingNeeded(), this.fireMeshesUpdateEvent();
      }
    }
  }
  removeMeshParent(e) {
    if (this._scene) {
      const t = this._scene.getMeshByID(e);
      t && (t.parent = null, this.fireMeshesUpdateEvent());
    }
  }
  setManipulatedNode(e) {
    e !== this._manipulatedNode && (this._manipulatedNode = e, this.showHideEditControl(this._editControlVisible), this.setRenderingNeeded());
  }
  importLibraryMaterial(e) {
    if (this._scene && this._sceneHelper && this._zkScene && e && e instanceof Zakeke.Material) {
      e.get("shaders") && this.checkShaderMaterial(e);
      const s = e.get("JSON") || e.get("json"), o = e.get("rootUrl");
      if (s && o) {
        const a = JSON.parse(s), c = BABYLON.Material.Parse(a, this._scene, o);
        if (c) {
          if (c.id = Zakeke.generateUUID(), this._zkScene.mapLibraryMaterial(e.getMaterialID(), c.id), e.get("shaders")) {
            const H = e.get("shaders"), Y = H.get("name"), ee = H.get("vertex"), z = H.get("fragment");
            Y && ee && z && this._zkScene.registerShaderMaterial(
              e.getMaterialID(),
              Y,
              ee,
              z
            ), this.setupShaderMaterialCameraPosition(c);
          }
          e.get("sourceTextureImages").forEach((H) => {
            var ee, z;
            if ((ee = this._zkScene) != null && ee.get("textures").find((he) => he.get("url") === H.get("url")))
              return;
            let Y = new Zakeke.SceneTexture();
            Y.set("textureID", Zakeke.generateUUID()), Y.set("materialID", c.id), Y.set("fileObjectID", H.get("fileObjectID")), Y.set("fileLength", H.get("fileLength")), Y.set("url", H.get("url")), (z = this.zkScene) == null || z.get("textures").push(Y);
          }), e.get("textureImages").forEach((H) => {
            var ee, z;
            if ((ee = this._zkScene) != null && ee.get("textures").find((he) => he.get("url") === H.get("imageUrl")))
              return;
            let Y = new Zakeke.SceneTexture();
            Y.set("textureID", Zakeke.generateUUID()), Y.set("materialID", c.id), Y.set("fileObjectID", H.get("fileObjectID")), Y.set("fileLength", H.get("fileLength")), Y.set("url", H.get("imageUrl")), (z = this.zkScene) == null || z.get("textures").push(Y);
          });
          const T = this._sceneHelper.getTexturesForMaterial(c);
          for (let H = 0; H < T.length; H++) {
            var t = T[H];
            t.materialMapping = {
              libraryMaterialRootUrl: o,
              libraryMaterialID: e.getMaterialID(),
              sceneMaterialID: c.id
            };
          }
        }
      }
      this.fireMaterialsUpdateEvent(), this.setRenderingNeeded();
    }
  }
  //#endregion
  //#region Recupero Texture
  // I metodi per il recupero delle texture sono stati spostati in SceneHelper
  // Li lascio qui solo momentaneamente
  getTexturesForMaterial(e) {
    return this._sceneHelper ? this._sceneHelper.getTexturesForMaterial(e) : [];
  }
  getStandardMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getStandardMaterialTextures(e) : [];
  }
  getPBRBaseSimpleMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRBaseSimpleMaterialTextures(e) : [];
  }
  getPBRMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRMaterialTextures(e) : [];
  }
  getNewPBRMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getNewPBRMaterialTextures(e) : [];
  }
  getPBRMetallicRoughnessMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRMetallicRoughnessMaterialTextures(e) : [];
  }
  getPBRSpecularGlossinessMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRSpecularGlossinessMaterialTextures(e) : [];
  }
  //#endregion
  //#region Camera Location
  removeCameraLocation(e) {
    var t;
    (t = this._zkScene) == null || t.get("cameraLocations").remove(e), this.fireCameraLocationsUpdateEvent();
  }
  saveCameraLocation(e) {
    if (this._zkScene && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.position, s = this._camera.target, o = new Zakeke.SceneCameraLocation();
      o.set("name", e), o.set("px", t.x), o.set("py", t.y), o.set("pz", t.z), o.set("tx", s.x), o.set("ty", s.y), o.set("tz", s.z), this._zkScene.get("cameraLocations").push(o), this.fireCameraLocationCreatedEvent(o), this.fireCameraLocationsUpdateEvent();
    }
  }
  clearCameraLocations() {
    if (this._zkScene) {
      const e = this._zkScene.get("cameraLocations");
      for (; e.length > 0; )
        e.remove(e.at(0));
      this.fireCameraLocationsUpdateEvent();
    }
  }
  //public setCameraLocation(locationID: string) {
  //    if (this._sceneHelper && this._zkScene) {
  //        const zkCameraLocation = this._zkScene.getCameraLocation(locationID);
  //        if (zkCameraLocation) {
  //            const position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
  //            const target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
  //            this._sceneHelper.animateCamera(target, position, 0.5);
  //        }
  //    }
  //    this.setRenderingNeeded();
  //}
  getAllCameraLocations() {
    const e = [];
    if (this._zkScene)
      for (let t = 0; t < this._zkScene.get("cameraLocations").length; t++)
        e.push(this._zkScene.get("cameraLocations").at(t));
    return e;
  }
  //#endregion
  //#region Collapse / Explode (Mesh Locations)
  saveMeshLocation(e) {
    this._meshLocationsManager && this._meshLocationsManager.saveMeshLocation(e);
  }
  saveExplodedMeshLocation() {
    this._meshLocationsManager && this._meshLocationsManager.saveExplodedMeshLocation();
  }
  saveCollapsedMeshLocation() {
    this._meshLocationsManager && this._meshLocationsManager.saveCollapsedMeshLocation();
  }
  onBeforeSaveMeshLocation() {
    this._oldManipulatedNode = this._manipulatedNode, this.setManipulatedNode(null);
  }
  onAfterSaveMeshLocation() {
    this.fireMeshLocationsUpdateEvent(), this.setManipulatedNode(this._oldManipulatedNode);
  }
  clearMeshLocations() {
    this._meshLocationsManager && this._meshLocationsManager.clearMeshLocations();
  }
  getAllMeshLocations() {
    const e = [];
    if (this._zkScene)
      for (let t = 0; t < this._zkScene.get("meshLocations").length; t++)
        e.push(this._zkScene.get("meshLocations").at(t));
    return e;
  }
  //#endregion
  //#region Material Library
  // Nota Bene
  // E' un po' incasinato, c'è da mettere ordine, primo abbozzo di implementazione.
  // Il problema principale è la gestione delle texture
  // che possono provenire da fonti diverse (sorgenti, librerie e caricate singolarmente dall'utente).
  // In breve: innanzitutto scatta una screenshot del materiale. per fare questo nasconde tutte le mesh,
  // crea una sfera temporanea e una camera temporanea prende la screenshot e poi rattiva le mesh così
  // come erano inialmente. Poi, clona il materiale iniziale (babylon) e lo associa ad un nuovo materiale lato server (zkMaterial).
  // Recupera le texture (babylon) associate al materiale di scena.
  // Per copiare le immagini lato server, recupera i fileObjectID per ognuna delle texture.
  // (Per una texture babylon possono esserci più file fileObjectID associati. Ad esempio, per una cubemap, ci saranno 6 fileObjectID associati.)
  // Per ogni fileObjectID, memorizza su skMaterial anche la provenienza, in modo che lato server il path possa essere costruito correttamente.
  // Salva il nuovo zkMaterial (lato server avverrà la copia dei file di immagini texture).
  // Alla fine elimina il nuovo materiale creato come clone.
  makeLibraryMaterial(e, t) {
    return new Promise((s, o) => {
      this.getMaterialScreenShotForLibrary(e, (a) => {
        a ? this.createLibraryMaterial(e, t, a, s) : o("No data generated for screenshot");
      });
    });
  }
  getMaterialScreenShotForLibrary(e, t) {
    if (this._scene && this._sceneHelper) {
      this.resetEditorEnvironment(), this.removeGround(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null);
      const s = 500, o = 500;
      this._sceneHelper.takeMaterialScreenshotAsync(e, s, o).then((a) => {
        Ix(a, s, o, (c) => {
          this.refreshEnvironment(), t && t(c);
        });
      });
    } else
      t && t(null);
  }
  createLibraryMaterial(e, t, s, o) {
    let a = null;
    const c = () => {
      a && this.deleteMaterial(a.id), o && o();
    };
    if (!this._scene || !this._sceneHelper || !this._zkScene) {
      c();
      return;
    }
    const g = this._scene, w = this._sceneHelper, T = this._zkScene;
    if (!g.getMaterialByID(e)) {
      c();
      return;
    }
    const Y = new Zakeke.Material();
    Y.set("name", t), Y.set("imageData", s);
    let ee = e, z = ee.replace(/-/g, "");
    const he = Y.getMaterialID(), ne = he.replace(/-/g, "");
    if (a = this.cloneMaterial(e, he, t), !a) {
      c();
      return;
    }
    const ye = T.getSourcesIDs();
    T.getLibraryMaterialIDs();
    const se = w.getTexturesForMaterial(a), _e = [];
    for (let ht = 0; ht < se.length; ht++) {
      const Ze = se[ht];
      if (Ze.materialMapping) {
        const pt = Ze.materialMapping.libraryMaterialID;
        pt && _e.push(pt);
      }
    }
    let ue = new Zakeke.Materials();
    const xe = ["px", "py", "pz", "nx", "ny", "nz"], Ee = function(ht) {
      const Ze = ht.lastIndexOf(".");
      if (Ze !== -1) {
        const pt = ht.substring(0, Ze);
        if (xe.some((Pt) => pt.endsWith("_" + Pt)))
          return pt.substring(0, pt.length - 3);
      }
      return ht;
    }, K = (ht, Ze) => Ee(ht).endsWith(Ze), j = () => {
      for (let Ze = 0; Ze < se.length; Ze++) {
        const pt = se[Ze];
        if (pt && w.isTextureWithUrl(pt) && pt.url) {
          let Pt = null, Mt = null;
          for (let Ot = 0; Ot < ye.length; Ot++) {
            const Ft = ye[Ot].replace(/-/g, "");
            if (pt.url.indexOf(Ft) != -1) {
              Pt = ye[Ot], Mt = Ft;
              break;
            }
          }
          const Tt = [];
          for (let Ot = 0; Ot < T.get("textures").length; Ot++) {
            const Ft = T.get("textures").at(Ot);
            Ft.get("url") && K(Ft.get("url"), pt.url) && Tt.push({
              fileObjectID: Ft.get("fileObjectID"),
              url: Ft.get("url"),
              fileLength: Ft.get("fileLength")
            });
          }
          for (let Ot = 0; Ot < Tt.length; Ot++) {
            const Ft = new Zakeke.MaterialSourceTextureImage();
            Ft.set("fileObjectID", Tt[Ot].fileObjectID), Ft.set("url", Tt[Ot].url || ""), Ft.set("fileLength", Tt[Ot].fileLength || -1), Pt ? (Ft.set("sceneID", T.getSceneID()), Ft.set("sourceID", Pt)) : (Ft.set("sceneID", T.getSceneID()), Ft.set("materialID", ee)), Y.get("sourceTextureImages").push(Ft);
          }
          let at = "", Ai = "", Ve = pt.name;
          if (Pt && Mt) {
            const Ot = pt.url.indexOf(Mt);
            Ot != -1 && (Ve = pt.url.substring(Ot)), at = Mt, Ai = "textures/" + ne, pt.name = Ve.replace(new RegExp(at, "g"), Ai);
          } else {
            var ht = pt.url.lastIndexOf("/");
            ht !== -1 && (ht = pt.url.lastIndexOf("/", ht - 1), ht !== -1 && (ht = pt.url.lastIndexOf("/", ht - 1), ht != -1 && (Ve = pt.url.substring(ht + 1)))), at = z, Ai = ne, pt.name = Ve.replace(
              new RegExp("textures/([A-Za-z0-9]*)/(.*)", "g"),
              "textures/" + Ai + "/$2"
            );
          }
          pt.url = pt.name;
        }
      }
      if (a) {
        const Ze = a.serialize(), pt = JSON.stringify(Ze);
        Y.set("JSON", pt), Y.save(null, {
          success: function(Pt, Mt, Tt) {
            c();
          },
          error: function(Pt, Mt, Tt) {
            c();
          }
        });
      } else
        c();
    };
    if (_e.length > 0) {
      const ht = { ids: _e.join(",") };
      try {
        ue.fetch({
          success: (Ze, pt, Pt) => {
            ue = Ze, j();
          },
          error: (Ze, pt, Pt) => {
            Logger.info("Errore nel salvataggio del materiale di libreria"), c();
          },
          data: ht
        });
      } catch {
      }
    } else
      j();
  }
  //#endregion
  //#region Lights
  lightsLayer_onLightSelected(e) {
    this.fireLightSelectedEvent(e);
  }
  isDefaultLight(e) {
    return this._sceneHelper ? this._sceneHelper.isDefaultLight(e) : !1;
  }
  createLight(e, t) {
    let s = null;
    if (this._scene) {
      const o = e || "new light", a = t || "Point", c = BABYLON.Vector3.Zero(), g = BABYLON.Vector3.Zero(), w = 25 * Math.PI / 180, T = 2;
      a == "Point" ? s = new BABYLON.PointLight(o, c, this._scene) : a == "Directional" ? s = new BABYLON.DirectionalLight(o, g, this._scene) : a == "Spot" ? s = new BABYLON.SpotLight(o, c, g, w, T, this._scene) : a == "Hemispheric" && (s = new BABYLON.HemisphericLight(o, g, this._scene)), s && (s.id = Zakeke.generateUUID()), this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
    return s;
  }
  cloneLight(e, t, s) {
    let o = null;
    if (this._scene) {
      const a = this._scene.getLightByID(e);
      if (a) {
        const c = s || a.name + " - clone";
        if (o = a.clone(c), o) {
          o.name = c;
          const g = t || Zakeke.generateUUID();
          o.id = g, this._lightsLayer && this._lightsLayer.refresh();
        }
      }
      this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
    return o;
  }
  renameLight(e, t) {
    if (this._scene) {
      const s = this._scene.getLightByID(e);
      s && (s.name = t, this._lightsLayer && this._lightsLayer.refresh()), this.fireLightsUpdateEvent();
    }
  }
  deleteLight(e) {
    if (this._scene) {
      const t = this._scene.getLightByID(e);
      t && (t.dispose(), this._scene.meshes.forEach((s) => s._markSubMeshesAsLightDirty()), this._lightsLayer && this._lightsLayer.refresh()), this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
  }
  getAllLights() {
    return this._scene ? this._scene.lights : [];
  }
  canShowLights() {
    return this._showLights && this._envMode == Ss.Editor;
  }
  showHideLights(e) {
    this._showLights = e, this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded();
  }
  //#endregion
  //#region Ground
  canShowGround() {
    return this._showGround && this._envMode == Ss.Editor;
  }
  removeGround() {
    this._ground && (this._ground.dispose(), this._ground = null), this.setRenderingNeeded();
  }
  refreshGround() {
    if (!this._scene)
      return;
    if (this.removeGround(), !this.canShowGround()) {
      this.setRenderingNeeded();
      return;
    }
    const e = this._scene.clearColor, t = e.toHexString(), s = Ex(t) ? 0.8 : -0.5, o = BABYLON.Color3.FromHexString(Ox(t, s));
    let a = 1e3, c = 1;
    if (this.countSceneMeshes() > 0) {
      const w = this._scene.getWorldExtends((Y) => this.isRealMesh(Y)), H = w.max.subtract(w.min).length() * 1.5;
      isFinite(H) && (a = H * 20, c = a / 100);
    }
    this._ground = BABYLON.Mesh.CreateGround("ground", a, a, 10, this._scene), this._ground.doNotSerialize = !0, this._ground.isVisible = this.showGround, this._ground.isPickable = !1, this._ground.metadata = {
      isRealMesh: !1,
      isGround: !0
    };
    const g = new BABYLON.GridMaterial("groundMaterial", this._scene);
    g.doNotSerialize = !0, g.backFaceCulling = !1, g.mainColor = new BABYLON.Color3(e.r, e.g, e.b), g.opacity = 1, g.gridRatio = c, g.lineColor = o, g.metadata = { isRealMaterial: !1 }, this._ground.material = g, this.setRenderingNeeded();
  }
  showHideGround(e) {
    this.showGround = e, this.refreshGround();
  }
  //#endregion
  //#region Axes
  canShowAxes() {
    return this._showAxes && this._envMode == Ss.Editor;
  }
  showHideAxes(e) {
    this._showAxes = e, this._axesLayer && this._axesLayer.refresh(), this.setRenderingNeeded();
  }
  //#endregion
  //#region Highlights
  showHideHighlight(e) {
    this._showHighlight = e;
    const t = this.getSelectedRootMesh();
    this.highlightMesh(t, e), this.setRenderingNeeded();
  }
  setHighlightOver(e) {
    this._highlightOver = e;
  }
  highlightMesh(e, t) {
    if (!this._showHighlight || this._envMode != Ss.Editor) {
      this.deleteHighlightLayer();
      return;
    }
    e && e instanceof BABYLON.Mesh && (t ? (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer && this._highlightLayer.addMesh(e, BABYLON.Color3.FromHexString(this._highlightColor))) : this._highlightLayer && this._highlightLayer.removeMesh(e)), this.setLongRenderingNeeded();
  }
  highlightMeshOver(e) {
    if (!this._showHighlight || this._envMode != Ss.Editor) {
      this.deleteHighlightLayer();
      return;
    }
    this._meshOver && this._meshOver instanceof BABYLON.Mesh && !this.isMeshSelected(this._meshOver) && (e && this._highlightOver ? (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer && !this._highlightLayer.hasMesh(this._meshOver) && this._highlightLayer.addMesh(this._meshOver, BABYLON.Color3.FromHexString(this.highlightOverColor))) : this._highlightLayer && this._highlightLayer.removeMesh(this._meshOver)), this.setLongRenderingNeeded();
  }
  //#endregion
  //#region Edit control (Gizmo)
  showHideEditControl(e) {
    this._scene && this._camera && this._canvas && (this._editControlVisible = e, this._editControl && (!e || this._manipulatedNode == null) && (this._editControl.detach(), this._editControl = null), e && this._manipulatedNode && (this._editControl ? this._editControl.switchTo(this._manipulatedNode) : (this._editControl = new this._EditControl(
      this._manipulatedNode,
      this._camera,
      this._canvas,
      0.75,
      !0
    ), this._editControl.setRotSnapValue(3.14 / 18), this._editControl.setTransSnapValue(0.5), this._editControl.setScaleSnapValue(0.25), this._editControl.addActionEndListener((t) => {
      this.fireMeshesUpdateEvent();
    })), this.setEditingMode(this._editingMode)), this.setRenderingNeeded());
  }
  setEditingMode(e) {
    this._editingMode = e, this._editControl && (e === Za.Translate ? this._editControl.enableTranslation() : e === Za.Rotate ? this._editControl.enableRotation() : e === Za.Scaling && this._editControl.enableScaling()), this.setRenderingNeeded();
  }
  undoEditing() {
    this._editControl && this._editControl.undo();
  }
  redoEditing() {
    this._editControl && this._editControl.redo();
  }
  //#endregion
  //#region Environment
  setEnvironmentMode(e) {
    e != this._envMode && (this._envMode = e, this.refreshEnvironment());
  }
  async refreshEnvironment() {
    this._scene && (this.setRenderingNeeded(), this._envMode == Ss.Editor ? (this.disableAntialiasing(), this.resetEditorEnvironment(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null)) : (this.deleteHighlightLayer(), this.refreshGround(), this._zkScene && ((!this._environmentManager || this._environmentManager.scene != this._scene) && (this._environmentManager = new Ud(this._zkScene, this._scene)), this._environmentManager.update(), this.setLongRenderingNeeded())), this.refreshGround(), this._lightsLayer && this._lightsLayer.refresh(), this._axesLayer && this._axesLayer.refresh(), this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this.autoRender = this._camera.useAutoRotationBehavior), this.setRenderingNeeded());
  }
  //#endregion
  //#region Zoom & Move camera
  zoomOnMesh(e) {
    this._sceneHelper && this._sceneHelper.zoomOnMesh(e);
  }
  // Sperimentale (è difficile capire come muovere la camera per inquadrare un oggetto)
  moveCameraToMeshPosition(e) {
    if (this._scene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const s = this._sceneHelper.getMeshHierarchyCenter(e), o = this._camera.target, a = this._camera.radius, c = s.subtract(o), g = c.length();
      if (isFinite(g)) {
        let w = c.normalize(), T = o.add(w.scale(a));
        const H = new BABYLON.Ray(T, w.scale(-1), a), Y = this._scene.pickWithRay(H, (ee) => ee === e);
        if (Y && Y.hit) {
          const ee = new BABYLON.Vector3(), z = new BABYLON.Quaternion(), he = new BABYLON.Vector3();
          e.getWorldMatrix().decompose(ee, z, he), 0.1 / ee.length() * 100, Y.pickedPoint;
          var t = Y.getNormal();
          t && (w = t.normalize(), T = o.add(w.scale(a)));
        }
        this._sceneHelper.animateCamera(o, T, 1);
      }
      this.setRenderingNeeded();
    }
  }
  //#endregion
  //#region Scene & Mesh Export: USDZ, glTF, Obj, AR
  exportMeshToOBJ(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t || !(t instanceof BABYLON.Mesh))
      return;
    const s = BABYLON.OBJExport.OBJ([t]);
    this.saveTextAsFile(s, t.name + ".obj");
  }
  exportMeshGeometryToJson(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t || !(t instanceof BABYLON.Mesh))
      return;
    const s = {
      positions: t.getVerticesData(BABYLON.VertexBuffer.PositionKind),
      normals: t.getVerticesData(BABYLON.VertexBuffer.NormalKind),
      colors: t.getVerticesData(BABYLON.VertexBuffer.ColorKind),
      uvs: t.getVerticesData(BABYLON.VertexBuffer.UVKind),
      uvs2: t.getVerticesData(BABYLON.VertexBuffer.UV2Kind),
      indices: t.getIndices()
    }, o = JSON.stringify(s, null, 0);
    this.saveTextAsFile(o, t.name + ".json");
  }
  enableDisableARForMesh(e, t) {
    const s = this.getMeshByID(e);
    s && (s.metadata || (s.metadata = {}), s.metadata.AR = t);
  }
  isAREnabledForMesh(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata ? t.metadata.AR !== void 0 ? t.metadata.AR : !0 : !1;
  }
  enableDisableTryOnForMesh(e, t) {
    const s = this.getMeshByID(e);
    s && (s.metadata || (s.metadata = {}), s.metadata.AR = t);
  }
  isTryOnEnabledForMesh(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata ? t.metadata.TryOn !== void 0 ? t.metadata.TryOn : !0 : !1;
  }
  //#endregion
  //#region Utilities
  splitSubMeshes(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMeshByID(e);
      t && this._sceneHelper.createMeshesFromSubMeshes(t);
    }
  }
  flipMeshFaces(e) {
    const t = this.getMeshByID(e);
    if (!t)
      return;
    const s = (o) => {
      o instanceof BABYLON.Mesh && o.flipFaces(!0), o.getChildMeshes().forEach((a) => s(a));
    };
    s(t);
  }
  convertSceneToScreenPoint(e, t) {
    if (this._canvas) {
      let s = 0, o = 0, a = this._canvas;
      do
        s += a.offsetLeft, o += a.offsetTop, a = a.offsetParent;
      while (a);
      return { X: e + s, Y: t + o };
    }
    return null;
  }
  saveTextAsFile(e, t) {
    const s = e, o = new Blob([s], { type: "text/plain" }), a = window.URL.createObjectURL(o), c = t;
    this.downloadFile(c, a);
  }
  saveBytesAsFile(e, t) {
    const s = new Blob([e]), o = window.URL.createObjectURL(s);
    this.downloadFile(t, o);
  }
  saveBlobAsFile(e, t, s) {
    let o = null;
    s ? o = window.URL.createObjectURL(new Blob([e], { type: s })) : o = window.URL.createObjectURL(new Blob([e])), this.downloadFile(t, o);
  }
  downloadFile(e, t) {
    var s = document.createElement("a");
    s.download = e, s.innerHTML = "Download File", s.href = t, s.onclick = (o) => {
      document.body.removeChild(s);
    }, s.style.display = "none", document.body.appendChild(s), s.click();
  }
  //#endregion
  //#region Draco
  // Test Draco encoding
  exportDracoEncodedToFile(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t)
      return;
    const s = this.getDracoEncodedGeometry(t);
    s && this.saveBytesAsFile(s, t.name + "_draco.dat");
  }
  // Funzione utile per testare la codifica Draco delle geometrie
  // La codifica reale delle mesh avviene durante il salvataggio e se ne
  // occupa la classe MakeIncremental, utilizzata in un worker thread
  getDracoEncodedGeometry(e) {
    let t = null;
    if (this._scene && e && e instanceof BABYLON.Mesh) {
      const o = e.getVerticesData(BABYLON.VertexBuffer.PositionKind), a = e.getVerticesData(BABYLON.VertexBuffer.NormalKind), c = e.getVerticesData(BABYLON.VertexBuffer.ColorKind), g = e.getVerticesData(BABYLON.VertexBuffer.UVKind), w = e.getVerticesData(BABYLON.VertexBuffer.UV2Kind), T = e.getIndices(), H = {};
      T && (H.indices = new Uint32Array(T)), o && (H.positions = new Float32Array(o)), a && (H.normals = new Float32Array(a)), g && (H.uvs = new Float32Array(g)), w && (H.uvs2 = new Float32Array(w)), c && (H.colors = new Uint32Array(c));
      const Y = DracoEncoderModule(), ee = new Y.Encoder(), z = new Y.MeshBuilder(), he = new Y.Mesh(), ne = H.indices.length / 3, ye = H.positions.length / 3;
      z.AddFacesToMesh(he, ne, H.indices), z.AddFloatAttributeToMesh(he, Y.POSITION, ye, 3, H.positions), H.normals && z.AddFloatAttributeToMesh(he, Y.NORMAL, ye, 3, H.normals), H.colors && z.AddFloatAttributeToMesh(he, Y.COLOR, ye, 4, H.colors), H.uvs && z.AddFloatAttributeToMesh(he, Y.TEX_COORD, ye, 2, H.uvs), H.uvs2 && z.AddFloatAttributeToMesh(he, Y.TEX_COORD, ye, 2, H.uvs2), ee.SetSpeedOptions(5, 5), ee.SetAttributeQuantization(Y.POSITION, 14), ee.SetAttributeQuantization(Y.TEX_COORD, 12), ee.SetAttributeQuantization(Y.NORMAL, 10), ee.SetAttributeQuantization(Y.COLOR, 10), ee.SetAttributeQuantization(Y.GENERIC, 8), ee.SetEncodingMethod(Y.MESH_EDGEBREAKER_ENCODING);
      const se = new Y.DracoInt8Array(), _e = ee.EncodeMeshToDracoBuffer(he, se);
      t = new ArrayBuffer(_e);
      var s = new Int8Array(t);
      for (let ue = 0; ue < _e; ++ue)
        s[ue] = se.GetValue(ue);
      Y.destroy(he), Y.destroy(se), Y.destroy(ee), Y.destroy(z);
    }
    return t;
  }
  // Decodifica dei dati Draco ereditata da SceneViewer
  //#endregion
  //#region Mesh Creation
  // Crea una mesh (cubo) custom specificandone la geometria
  // utile per comprendere il modo in cui Babylon JS organizza i dati delle geomtrie
  createCustomMesh() {
    let e = null;
    if (this._scene) {
      e = new BABYLON.Mesh("custom", this._scene);
      var t = [-5, 2, -3, -7, -2, -3, -3, -2, -3, 5, 2, 3, 7, -2, 3, 3, -2, 3], s = [0, 1, 2, 3, 4, 5], o = [1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0, 1], a = [0, 1, 0, 0, 1, 0], c = [];
      BABYLON.VertexData.ComputeNormals(t, s, c);
      const g = new BABYLON.VertexData();
      g.positions = t, g.indices = s, g.colors = o, g.normals = c, g.uvs = a, g.applyToMesh(e);
    }
    return e;
  }
  createBox(e, t) {
    let s = null, o = null;
    return this._scene && this._sceneHelper && (e && (o = this._scene.getMeshByID(e)), s = this._sceneHelper.createBox(o, t), this.setLongRenderingNeeded()), s;
  }
  getSceneBoundingBox() {
    let e = null;
    if (this._scene)
      for (let t = 0; t < this._scene.meshes.length; t++) {
        const s = this._scene.meshes[t];
        if (s && s.metadata && s.metadata.sceneBoundingBox) {
          e = s;
          break;
        }
      }
    return e;
  }
  getOrCreateSceneBoundingBox(e = !0) {
    let t = this.getSceneBoundingBox();
    return t || (t = this.createBoundingBox(null, "SceneBoundingBox", e), t && (t.metadata || (t.metadata = {}), t.metadata.boundingBox = !0, t.metadata.sceneBoundingBox = !0)), t;
  }
  createSceneBoundingBox(e = !0) {
    let t = this.getSceneBoundingBox();
    return t ? t.isVisible = e : (t = this.createBoundingBox(null, "SceneBoundingBox", e), t && (t.metadata || (t.metadata = {}), t.metadata.boundingBox = !0, t.metadata.sceneBoundingBox = !0)), t;
  }
  createBoundingBox(e, t, s = !0) {
    let o = null;
    if (e && (o = this.getMeshByID(e)), this._sceneHelper) {
      var a = this._sceneHelper.createBoundingBox(o, t);
      return a && (a.isVisible = s), this.setLongRenderingNeeded(), a;
    }
    return null;
  }
  createSphere(e, t) {
    let s = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = this._sceneHelper.createSphere(o, t), this.setLongRenderingNeeded()), s;
  }
  createPlane(e, t) {
    let s = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = this._sceneHelper.createPlane(o, t), this.setLongRenderingNeeded()), s;
  }
  createDisc(e, t) {
    let s = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = this._sceneHelper.createDisc(o, t), this.setLongRenderingNeeded()), s;
  }
  createCylinder(e, t) {
    let s = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = this._sceneHelper.createCylinder(o, t), this.setLongRenderingNeeded()), s;
  }
  createTorus(e, t) {
    let s = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = this._sceneHelper.createTorus(o, t), this.setLongRenderingNeeded()), s;
  }
  createKnot(e, t) {
    let s = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = this._sceneHelper.createKnot(o, t), this.setLongRenderingNeeded()), s;
  }
  createRibbon(e, t) {
    let s = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = this._sceneHelper.createRibbon(o, t), this.setLongRenderingNeeded()), s;
  }
  async createRoundedCubeAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createRoundedCubeAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createRoundedCylinderAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createRoundedCylinderAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createMatBallAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createMatBallAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createMaleHeadAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createMaleHeadAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createFemaleHeadAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createFemaleHeadAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createPokemonBallAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createPokemonBallAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createShaderBallAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createShaderBallAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createBootsAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createBootsAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createSuzanneAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createSuzanneAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createStepPyramidAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createStepPyramidAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createTeapotAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createTeapotAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createAlloyWheelAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createAlloyWheelAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  async createTryonReferenceGlassesFrameAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.createTryonReferenceGlassesFrameAsync(o, t), this.setLongRenderingNeeded()), s;
  }
  removeAllVTOReferenceMeshes() {
    if (!this.scene)
      return [];
    const e = [], t = [...this.scene.meshes];
    for (const s of t)
      s.name && s.name.toLowerCase().includes("vto_reference") ? s.dispose(!1, !0) : e.push(s);
    return e;
  }
  hideAllVTOFiles(e) {
    for (const t of e)
      t.name && t.name.toLowerCase().includes("vto_reference") && (t.metadata || (t.metadata = {}), t.metadata.TryOn = !1);
  }
  async createTryOnReferenceModelsAsync(e, t, s) {
    let o = null, a = [];
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (a = await this._sceneHelper.createTryOnReferenceModelsAsync(o, t, s), this.fireMeshesUpdateEvent(), this.setRenderingNeeded(), this.hideAllVTOFiles(a)), a;
  }
  setTryOnReferenceVisible(e) {
    this._sceneHelper && (this._sceneHelper.setTryOnReferenceVisible(e), this.setRenderingNeeded());
  }
  isTryOnReferenceVisible() {
    return this._sceneHelper ? this._sceneHelper.isTryOnReferenceVisible() : !1;
  }
  scaleSceneToTryonReferenceModels(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.scaleSceneToTryonReferenceModels(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getSceneScalingPercentageForVTO() {
    return this._sceneHelper ? this._sceneHelper.getSceneScalingPercentageForVTO() : 100;
  }
  setSceneScalePercentageForVTO(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.setSceneScalePercentageForVTO(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getScenePositionPercentageForVTO() {
    return this._sceneHelper ? this._sceneHelper.getScenePositionPercentageForVTO() : { x: 0, y: 0, z: 0 };
  }
  setScenePositionPercentageForVTO(e, t, s) {
    var o;
    this._sceneHelper && (this._sceneHelper.setScenePositionPercentageForVTO(e, t, s), (o = this._sceneHelper) == null || o.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getSceneRotationForVTO() {
    return this._sceneHelper ? this._sceneHelper.getSceneRotationForVTO() : { x: 0, y: 0, z: 0 };
  }
  setSceneRotationForVTO(e, t, s) {
    var o;
    this._sceneHelper && (this._sceneHelper.setSceneRotationForVTO(e, t, s), (o = this._sceneHelper) == null || o.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  setVTOReferenceVisible(e) {
    this._sceneHelper && (this._sceneHelper.setVTOReferenceVisible(e), this.setRenderingNeeded());
  }
  setShadowsVisibility(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.setShadowsVisibility(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  async importMeshesFromUrlAsync(e, t) {
    let s = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (s = await this._sceneHelper.importMeshesFromUrlAsync(t, o), this.checkSceneEmptyEnvironmentTexture(), this.setLongRenderingNeeded()), s;
  }
  //#endregion
  //#region 2D Design Rendering
  async connectMeshToModelSideAsync(e, t, s) {
    this._sceneDesignManager && this._sceneDesignManager.connectMeshToModelSideAsync(e, t, s);
  }
  clearMeshDesignManagers() {
    this._sceneDesignManager && this._sceneDesignManager.clearMeshDesignManagers();
  }
  getMeshDesignMananger(e, t) {
    var s;
    return this._sceneDesignManager && this.scene ? (s = this._sceneDesignManager) == null ? void 0 : s.getMeshDesignMananger(e, t) : null;
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t, s, o) {
    this._sceneDesignManager && this._sceneDesignManager.translateDesignView(e, t, s, o);
  }
  rotateDesignView(e, t, s, o, a) {
    this._sceneDesignManager && this._sceneDesignManager.rotateDesignView(e, t, s, o, a);
  }
  scaleDesignView(e, t, s, o, a, c) {
    this._sceneDesignManager && this._sceneDesignManager.scaleDesignView(e, t, s, o, a, c);
  }
  async setDesignViewTextureUVChannelAsync(e, t, s) {
    this._sceneDesignManager && await this._sceneDesignManager.setDesignViewTextureUVChannelAsync(e, t, s);
  }
  async setDesignViewFormFactorAsync(e, t, s, o) {
    this._sceneDesignManager && await this._sceneDesignManager.setDesignViewFormFactorAsync(e, t, s, o);
  }
  //#endregion
  //#region Mesh measuring
  getCurrentARMeshUsedForMeasure() {
    var t;
    return (t = this.scene) == null ? void 0 : t.meshes.find((s) => s.metadata && s.metadata.sizecm);
  }
  getCurrentARSizeCm() {
    var t;
    const e = this.getCurrentARMeshUsedForMeasure();
    return (t = e == null ? void 0 : e.metadata) == null ? void 0 : t.sizecm;
  }
  setSceneSizeCm(e, t) {
    const s = this.getOrCreateSceneBoundingBox(!1);
    s && this.setMeshSizeCm(s.id, e, t);
  }
  getSceneWidthCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.width ? e.metadata.sizecm.width : null;
  }
  getSceneHeightCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.height ? e.metadata.sizecm.height : null;
  }
  getSceneDepthCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.depth ? e.metadata.sizecm.depth : null;
  }
  setMeshSizeCm(e, t, s) {
    const o = this.getMeshByID(e);
    if (o) {
      let a = null;
      t && typeof t == "number" && !isNaN(t) && (s === "width" ? a = { width: t } : s === "height" ? a = { height: t } : s === "depth" && (a = { depth: t })), o.metadata || (o.metadata = {}), o.metadata.sizecm = a;
    }
  }
  getMeshWidthCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.width ? t.metadata.sizecm.width : null;
  }
  getMeshHeightCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.height ? t.metadata.sizecm.height : null;
  }
  getMeshDepthCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.depth ? t.metadata.sizecm.depth : null;
  }
  //#endregion
  //#region Material Previews
  async getMaterialsPreviewsAsync(e, t, s, o, a = !0) {
    const c = [];
    if (this._scene && this._sceneHelper && this._zkScene) {
      const w = await this.getSceneRootUrl();
      if (w) {
        const T = await oo.getPreviewsAsync(
          this._scene,
          w,
          e,
          { width: t, height: s },
          !0
        );
        for (var g in T.previewFiles)
          c.push(T.previewFiles[g]);
      }
    }
    return c;
  }
  async getAllMaterialsPreviewsAsync(e, t, s, o = !0) {
    const a = [];
    if (this._scene && this._sceneHelper && this._zkScene) {
      const g = this._sceneHelper.getAllMaterials().map((w) => w.id);
      return this.getMaterialsPreviewsAsync(g, e, t, s, o);
    }
    return a;
  }
  async downloadMaterialsPreviewsAsync(e, t, s, o) {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const a = await this.getSceneRootUrl();
      a && await oo.downloadPreviewsAsync(this._scene, a, e, {
        width: t,
        height: s,
        crop: o
      });
    }
  }
  async downloadAllMaterialsPreviewsAsync(e, t, s) {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const a = this._sceneHelper.getAllMaterials().map((c) => c.id);
      await this.downloadMaterialsPreviewsAsync(a, e, t, s);
    }
  }
  //#endregion
  createEnvelopeMesh(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMeshByID(e);
      if (t && t instanceof BABYLON.Mesh)
        return this._sceneHelper.createEnvelopeMesh(t);
    }
    return null;
  }
  expandMesh(e, t) {
    if (this._scene && this._sceneHelper) {
      const s = this._scene.getMeshByID(e);
      s && s instanceof BABYLON.Mesh && this._sceneHelper.expandMesh(s, t);
    }
  }
  enableDisableMeshFacetData(e, t) {
    if (this._scene && this._sceneHelper) {
      const s = this._scene.getMeshByID(e);
      s && (t ? s.updateFacetData() : s.disableFacetData());
    }
  }
  enableDisableDepthSortFacets(e, t) {
    if (this._scene && this._sceneHelper) {
      const s = this._scene.getMeshByID(e);
      s && (s.mustDepthSortFacets = t);
    }
  }
};
ng.EmptyGroupName = "_dummy_";
let Pw = ng;
var Nw = /* @__PURE__ */ ((v) => (v[v.Box = 0] = "Box", v[v.RoundedBox = 1] = "RoundedBox", v[v.Sphere = 2] = "Sphere", v[v.Plane = 3] = "Plane", v[v.Cylinder = 4] = "Cylinder", v[v.RoundedCylinder = 5] = "RoundedCylinder", v[v.Torus = 6] = "Torus", v[v.Knot = 7] = "Knot", v[v.Ribbon = 8] = "Ribbon", v[v.Custom = 9] = "Custom", v))(Nw || {});
class sg extends Pw {
  constructor(e) {
    super(e), this._zkMaterial = null, this._material = null, this._meshType = 0, this._mesh = null, this._materialCreatedListeners = [], this._filesInput = null;
  }
  get zkMaterial() {
    return this._zkMaterial;
  }
  get material() {
    return this._material;
  }
  static async createMaterialEditorAsync(e) {
    e || (e = {
      authorizationToken: "",
      showGround: !1,
      editorBackgroundColor: "#33334c",
      showHighlight: !1,
      incrementalWorkersScriptsUrls: []
    });
    const t = new sg(e);
    return await t.initAsync(), t;
  }
  deleteComponents() {
    super.deleteComponents(), this.deleteEditorMaterial(), this.deleteEditorMesh();
  }
  deleteEditorMaterial() {
    this._material && (this._material.dispose(), this._material = null, this.fireMaterialCreatedEvent());
  }
  deleteEditorMesh() {
    this._mesh && (this._mesh.dispose(), this._mesh = null), this._scene && this._sceneHelper && this._sceneHelper.getSceneMeshes().forEach((t) => t.dispose());
  }
  dispose() {
    super.dispose();
  }
  async createEmptySceneAsync() {
    await super.createEmptySceneAsync(), this.createEditorMaterial(void 0, "Standard"), await this.createEditorMeshAsync();
  }
  createEditorMaterial(e, t, s) {
    let o = null;
    return t != "ShaderMaterial" ? o = super.createMaterial(e, t, s) : (o = this.createShaderMaterial(), o && (o.id = Zakeke.generateUUID(), this.checkSceneEmptyEnvironmentTexture())), this._material = o, this.setRenderingNeeded(), this.fireMaterialCreatedEvent(), o;
  }
  applyEditorMaterial() {
    this._material && this._mesh && this.applyMaterial(this._material, this._mesh);
  }
  async replaceSceneAsync(e) {
    var t = null, s = null;
    this._material && this._zkMaterial && (t = this._material.serialize(), s = this._zkMaterial.get("rootUrl")), this.deleteScene(), this._scene = e, await this.setupSceneAsync(), t && s ? (this._material = BABYLON.Material.Parse(t, this._scene, s), this.fireMaterialCreatedEvent()) : this.createEditorMaterial(void 0, "Standard"), this.applyEditorMaterial(), this.adjustCamera(!1);
  }
  createShaderMaterial() {
    let e = null;
    if (this._scene && this._zkMaterial && this._zkMaterial.get("shaders")) {
      const s = this._zkMaterial.get("name") || "ShaderMaterial - " + Zakeke.makeID(5);
      var t = {
        vertex: this._zkMaterial.get("shaders").get("name"),
        fragment: this._zkMaterial.get("shaders").get("name")
      };
      const o = {
        attributes: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Attribute),
        uniforms: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Uniform),
        samplers: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Sampler)
      };
      e = new BABYLON.ShaderMaterial(s, this._scene, t, o), this.setupShaderMaterialCameraPosition(e);
    }
    return e;
  }
  createEditorMaterialFromJson(e, t) {
    if (this._scene) {
      var s = JSON.parse(e);
      this._material = BABYLON.Material.Parse(s, this._scene, t), this._material && this.setupShaderMaterialCameraPosition(this._material), this.checkSceneEmptyEnvironmentTexture(), this.fireMaterialCreatedEvent();
    }
  }
  async createEditorMeshAsync() {
    switch (this.deleteEditorMesh(), this._meshType) {
      case 0:
        this._mesh = this.createBox(null, "box");
        break;
      case 1:
        {
          const e = await this.createRoundedCubeAsync(null, "rounded box");
          e.length == 1 ? this._mesh = e[0] : this._mesh = this.createGroup(null, "rounded box group", e);
        }
        break;
      case 2:
        this._mesh = this.createSphere(null, "sphere");
        break;
      case 3:
        this._mesh = this.createPlane(null, "plane");
        break;
      case 4:
        this._mesh = this.createCylinder(null, "cylinder");
        break;
      case 5:
        {
          const e = await this.createRoundedCylinderAsync(null, "rounded cylinder");
          e.length == 1 ? this._mesh = e[0] : (this._mesh = this.createGroup(null, "rounded cylinder group"), e.forEach((t) => t.parent = this._mesh));
        }
        break;
      case 6:
        this._mesh = this.createTorus(null, "torus");
        break;
      case 7:
        this._mesh = this.createKnot(null, "knot");
        break;
      case 8:
        this._mesh = this.createRibbon(null, "ribbon");
        break;
    }
    this.applyEditorMaterial(), this.adjustCamera(!1);
  }
  async setEditorMeshType(e) {
    this._meshType = e, await this.createEditorMeshAsync();
  }
  async updateMaterialModelAsync() {
    if (this._zkMaterial && this._material && this._sceneHelper) {
      const t = await this._sceneHelper.takeMaterialScreenshotAsync(this._material.id, 500, 450);
      this._zkMaterial.set("imageData", t);
      const s = this._zkMaterial.get("name");
      s && s != this._material.name && (this._material.name = s);
      var e = this.getEditorMaterialJson();
      e && this._zkMaterial.set("JSON", e);
    }
  }
  getEditorMaterialJson() {
    if (this._scene && this._sceneHelper && this._material) {
      const s = this._sceneHelper;
      this._scene.textures.forEach((o) => {
        if (s.isTextureWithUrl(o) && o.url) {
          var a = o.url.lastIndexOf("/");
          if (a !== -1 && (a = o.url.lastIndexOf("/", a - 1), a !== -1 && (a = o.url.lastIndexOf("/", a - 1), a != -1))) {
            var c = o.url.substring(a + 1);
            o.name = c, o.url = o.name;
          }
        }
      });
      var e = this._material.serialize(), t = JSON.stringify(e);
      return t;
    }
    return null;
  }
  setMaterialModel(e, t) {
    if (this._zkMaterial = e, this.deleteEditorMaterial(), this._zkMaterial && this._zkMaterial instanceof Zakeke.Material) {
      const a = this._zkMaterial.get("shaders");
      if (a) {
        const c = a.get("name"), g = a.get("vertex"), w = a.get("fragment");
        c && g && w && this.setupShadersStore({ name: c, vertex: g, fragment: w });
      }
      var s = this._zkMaterial.get("JSON"), o = this._zkMaterial.get("rootUrl");
      s && o ? this.createEditorMaterialFromJson(s, o) : this.createEditorMaterial(this._zkMaterial.get("name") || void 0, t), this._material && (this._material.id = this._zkMaterial.getMaterialID());
    } else
      this.createEditorMaterial(void 0, t);
    this.applyEditorMaterial(), this.adjustCamera(!1), this.setupShaderMaterialsCameraPosition();
  }
  getTexturesUploadUrl(e) {
    return this._zkMaterial ? this._zkMaterial.getTexturesUrl() : "";
  }
  loadEditorMaterialTextureFiles__(e, t, s, o) {
    this.loadTextureFiles(e, this._material, t, !1, s, o);
  }
  loadEditorMaterialTextureFiles(e, t, s, o) {
    if (!this._material)
      return;
    const a = (z) => {
      let he = z.lastIndexOf(".");
      if (he !== -1)
        return z.substring(he);
    }, c = (z, he) => {
      const ne = z.lastIndexOf(".");
      return ne !== -1 ? z.substring(0, ne).endsWith("_" + he) : !1;
    };
    if (!(!e || e.length == 0)) {
      var g = this.canLoadCubemap(this._material, t) && (e.length == 6 || a(e[0].name) == ".dds" || a(e[0].name) == ".hdr"), w = [];
      if (g && e.length == 6) {
        var T = ["px", "py", "pz", "nx", "ny", "nz"];
        for (let z = 0; z < e.length; z++) {
          const he = e[z];
          let ne = -1;
          for (var H = 0; H < T.length; H++)
            if (c(he.name, T[H])) {
              w.push(he), ne = H;
              break;
            }
          ne !== -1 && T.splice(ne, 1);
        }
        if (T.length != 0) {
          var Y = "Immagini per la cube map non valide";
          o && o(Y), Logger.info(Y);
          return;
        }
      } else
        w.push(e[0]);
      var ee = new FormData();
      for (let z = 0; z < w.length; z++)
        ee.append("file-" + z, w[z]);
      jQuery.ajax({
        url: this.getTexturesUploadUrl(this._material.id),
        data: ee,
        cache: !1,
        contentType: !1,
        processData: !1,
        type: "POST",
        success: (z) => {
          Object.prototype.toString.call(z) === "[object Array]" && (g ? this.setEditorMaterialCubeTextureImages(z, t) : this.setEditorMaterialTextureImage(z[0], t)), s && s();
        },
        error: (z, he, ne) => {
          var ye = "An error occurred: " + he + "nError: " + ne;
          o && o(ye);
        }
      });
    }
  }
  setEditorMaterialTextureImage(e, t) {
    if (this._scene && this._zkMaterial && this._material && e && e.imageUrl && e.fileObjectID) {
      const s = new Zakeke.MaterialTextureImage();
      s.set("textureImageID", Zakeke.generateUUID()), s.set("fileObjectID", e.fileObjectID), s.set("imageUrl", e.imageUrl), this._zkMaterial.get("textureImages").push(s);
      const o = e.imageUrl, a = new BABYLON.Texture(o, this._scene), c = this.getMaterialTexture(this._material, t);
      c && c instanceof BABYLON.Texture && (a.uScale = c.uScale, a.vScale = c.vScale, a.uOffset = c.uOffset, a.vOffset = c.vOffset, a.uAng = c.uAng, a.vAng = c.vAng, a.level = c.level, a.coordinatesIndex = c.coordinatesIndex, a.coordinatesMode = c.coordinatesMode, a.hasAlpha = c.hasAlpha, a.wrapU = c.wrapU, a.wrapV = c.wrapV), this.applyTexture(a, this._material, t), c && !this.isTextureUsed(c) && c.dispose();
    }
  }
  setEditorMaterialCubeTextureImages(e, t) {
    if (!this._scene || !this._zkMaterial || !this._material || Object.prototype.toString.call(e) != "[object Array]")
      return;
    let s = null;
    const o = () => this.setRenderingNeeded();
    if (e.length == 1) {
      let w = e[0];
      if (w.imageUrl && w.fileObjectID) {
        w.imageUrl.endsWith(".dds") ? s = BABYLON.CubeTexture.CreateFromPrefilteredData(w.imageUrl, this._scene) : w.imageUrl.endsWith(".hdr") && (s = new BABYLON.HDRCubeTexture(
          w.imageUrl,
          this._scene,
          512,
          void 0,
          void 0,
          void 0,
          void 0,
          o
        ));
        var a = new Zakeke.MaterialTextureImage();
        a.set("textureImageID", Zakeke.generateUUID()), a.set("fileObjectID", w.fileObjectID), a.set("imageUrl", w.imageUrl), this._zkMaterial.get("textureImages").push(a);
      }
    } else if (e.length == 6) {
      const w = ["px", "py", "pz", "nx", "ny", "nz"];
      let T = "";
      const H = [], Y = [], ee = (ne, ye) => {
        var se = ne.lastIndexOf(".");
        if (se !== -1) {
          var _e = ne.substring(0, se);
          return _e.endsWith("_" + ye);
        }
        return !1;
      }, z = (ne, ye) => {
        const se = ne.lastIndexOf(".");
        if (se !== -1) {
          var _e = ne.substring(0, se);
          if (_e.endsWith("_" + ye))
            return _e.substring(0, _e.length - ("_" + ye).length);
        }
        return null;
      }, he = (ne, ye) => {
        const se = ne.lastIndexOf("_" + ye);
        return se !== -1 ? ne.substr(se) : null;
      };
      for (let ne = 0; ne < w.length; ne++) {
        var c = w[ne];
        for (let ye = 0; ye < e.length; ye++) {
          const _e = e[ye].imageUrl;
          if (_e && ee(_e, c)) {
            H.push(_e), Y.push(he(_e, c) ?? ""), T || (T = z(_e, c) ?? "");
            break;
          }
        }
      }
      for (let ne = 0; ne < e.length; ne++) {
        const ye = e[ne];
        if (ye.imageUrl && ye.fileObjectID != null) {
          const se = ye.imageUrl, _e = ye.fileObjectID, ue = new Zakeke.MaterialTextureImage();
          ue.set("textureImageID", Zakeke.generateUUID()), ue.set("fileObjectID", _e), ue.set("imageUrl", se), this._zkMaterial.get("textureImages").push(ue);
        }
      }
      s = new BABYLON.CubeTexture(T, this._scene, Y, !1, H);
    }
    if (s) {
      var g = this.getMaterialTexture(this._material, t);
      this.applyTexture(s, this._material, t), g && !this.isTextureUsed(g) && g.dispose();
    }
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireMaterialCreatedEvent() {
    for (let e = 0; e < this._materialCreatedListeners.length; ++e)
      this._materialCreatedListeners[e]();
  }
  addMaterialCreatedListener(e) {
    this._materialCreatedListeners.push(e);
  }
  //#region Load Custom Mesh
  loadFiles(e, t, s) {
    if (!this._engine || !this._scene || !this._sceneHelper)
      return;
    const o = this._engine, a = this._scene, c = this._sceneHelper;
    this._filesInput || (this._filesInput = new BABYLON.FilesInput(
      o,
      a,
      async (g, w) => {
        await this.replaceSceneAsync(w);
        const T = c.getSceneMeshes();
        this._meshType = 9, this._mesh = this.createGroup(null, "group", T), this.applyEditorMaterial(), t && t();
      },
      null,
      //(progress: BABYLON.SceneLoaderProgressEvent) => { }, // progressCallback
      null,
      //() => { },  // additionalRenderLoopLogicCallback
      null,
      //(remaining: number) => { }, // textureLoadingCallback
      null,
      //(files?: File[]) => { },  // startingProcessingFilesCallback
      null,
      //(sceneFile: File) => { }, // onReloadCallback
      (g, w, T) => {
        s && s(T);
      }
    )), this._filesInput && this._filesInput.loadFiles(e);
  }
  //#endregion
}
const Rw = "https://3dviewer-img.futurefashionsolution.com/_common/envMap/default.env", e1 = {
  general: {
    backgroundAlpha: 1,
    backgroundColor: "#ffffff",
    removeDefaultBackground: !0,
    environmentTexture: Rw,
    matchSameNameTextures: null,
    antialiasEnabled: null,
    tryOnEnabled: null,
    tryOnSettings: null,
    arEnabled: !0,
    arOnTheFly: !1,
    arAnchor: null,
    arScale: null,
    meshSize: {
      height: null,
      width: null,
      depth: null
    },
    antialias: {
      desktop: {
        enabled: !0,
        inRotationEnabled: !0
      }
    },
    frameDAMSettings: null,
    useDelayedTextureLoading: null,
    useDelayedMaterialLoading: null,
    useMaterialOffloading: null,
    prefetchMeshes: null,
    prefetchMaterials: null,
    exposure: 1,
    contrast: 1,
    preventDefaultLights: !0,
    forceDracoCompression: null,
    fitToScreenMargin: 1,
    environmentOptions: {
      mipMaps: !1,
      generateHarmonics: !1,
      gammaSpace: !0,
      prefilterOnLoad: !0,
      rotationY: 1.57,
      intensity: 1,
      // environment intensity
      pbrIntensity: 1
      // pbr intensity
    }
  },
  environment: {
    sizeAuto: null,
    mainColor: "#CB0E00",
    backgroundColor: "#5CA0B5",
    skybox: {
      createSkybox: !1,
      size: null,
      texture: null,
      extensions: null,
      files: null,
      color: null,
      blur: 0
    },
    ground: {
      createGround: !1,
      size: null,
      texture: null,
      color: null,
      opacity: null,
      enableShadow: !1,
      shadowLevel: null,
      enableMirror: !0,
      mirrorBlurKernel: null
    },
    shadows: {
      enableShadows: !1,
      groundSizeMultiplierWidth: 1.2,
      groundSizeMultiplierLength: 1.5,
      shadowMapSize: 51,
      shadowHexColor: "#454545",
      contactHardeningUVRatio: 0.4,
      useContactHardeningShadow: !0,
      useBlurCloseExponentialShadowMap: !1,
      usePercentageCloserFiltering: !1,
      useKernelBlur: !0,
      usePoissonSampling: !1,
      blurBoxOffset: 10,
      blurScale: 4,
      blurKernel: 10,
      depthScale: 1,
      shadowDarkness: 0.3
    }
  },
  camera: {
    autoRotate: !1,
    rotationSpeed: 0.2,
    changeRotationDirection: !1,
    contrast: 1.6,
    exposure: 0.8,
    toneMappingEnabled: !1,
    toneMappingType: 0,
    setInitialZoomToBoundingBox: !0,
    initialZoomToBBInertiaDamping: 0.9,
    initialZoomToBBModelSizeRadius: 0.7,
    initialZoomToBBScrollZoomEnabled: !0,
    initialZoomToBBScrollLowerLimit: 2,
    initialZoomToBBScrollUpperLimit: 2,
    positionScale: null,
    limitLowerRadius: !0,
    zoomEnabled: null,
    useMinZoomPerc: !0,
    minZoomPerc: 0.5,
    useMaxZoomPerc: !0,
    maxZoomPerc: 1.5,
    lowerAlphaLimit: null,
    upperAlphaLimit: null,
    fixedAlphaAngle: null,
    fixedBetaAngle: null,
    useLowerAlphaLimit: null,
    lowerBetaLimit: 0,
    upperBetaLimit: 3,
    useLowerBetaLimit: null,
    useUpperAlphaLimit: null,
    useUpperBetaLimit: null,
    zoom: 0,
    position: {
      alpha: 1.57,
      beta: 1.55,
      fov: 0.4
    },
    animateIntro: !1
  },
  model: {
    rotation: {
      x: 0,
      y: 0,
      z: 0
    },
    position: {
      x: 0,
      y: 0,
      z: 0
    },
    scale: {
      x: 1,
      y: 1,
      z: 1
    },
    config: {
      doubleSided: !1
    }
  },
  glow: null,
  infoPoints: null,
  uiConfig: {
    urlARIcon: "",
    urlLoader: ""
  },
  lights: {
    directionalLightBack: {
      position: {
        x: -1,
        y: 0,
        z: -1
      },
      general: {
        intensity: 3,
        visible: !0
      }
    },
    directionalLightLeft: {
      position: {
        x: 0,
        y: 0,
        z: 1
      },
      general: {
        intensity: 1.2,
        visible: !0
      }
    },
    pointLightBack: {
      position: {
        x: 1,
        y: 0.5,
        z: 0.5
      },
      general: {
        intensity: 2,
        visible: !1
      }
    },
    pointLightFront: {
      position: {
        x: -1,
        y: 0.5,
        z: -0.5
      },
      general: {
        intensity: 2,
        visible: !1
      }
    },
    hemisphereLight: {
      position: {
        x: 0,
        y: 30.76964,
        z: 0
      },
      general: {
        intensity: 0.5,
        visible: !1
      }
    }
  },
  textures: null,
  animations: {
    runAtStart: !0,
    loop: !0,
    speed: 1
  }
};



/***/ }),

/***/ "./node_modules/axios/lib/adapters/adapters.js":
/*!*****************************************************!*\
  !*** ./node_modules/axios/lib/adapters/adapters.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _http_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./http.js */ "./node_modules/axios/lib/helpers/null.js");
/* harmony import */ var _xhr_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./xhr.js */ "./node_modules/axios/lib/adapters/xhr.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");





const knownAdapters = {
  http: _http_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  xhr: _xhr_js__WEBPACK_IMPORTED_MODULE_1__["default"]
}

_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  getAdapter: (adapters) => {
    adapters = _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"](
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
});


/***/ }),

/***/ "./node_modules/axios/lib/adapters/xhr.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/adapters/xhr.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _core_settle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./../core/settle.js */ "./node_modules/axios/lib/core/settle.js");
/* harmony import */ var _helpers_cookies_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./../helpers/cookies.js */ "./node_modules/axios/lib/helpers/cookies.js");
/* harmony import */ var _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./../helpers/buildURL.js */ "./node_modules/axios/lib/helpers/buildURL.js");
/* harmony import */ var _core_buildFullPath_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../core/buildFullPath.js */ "./node_modules/axios/lib/core/buildFullPath.js");
/* harmony import */ var _helpers_isURLSameOrigin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./../helpers/isURLSameOrigin.js */ "./node_modules/axios/lib/helpers/isURLSameOrigin.js");
/* harmony import */ var _defaults_transitional_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../defaults/transitional.js */ "./node_modules/axios/lib/defaults/transitional.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _helpers_parseProtocol_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helpers/parseProtocol.js */ "./node_modules/axios/lib/helpers/parseProtocol.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _helpers_speedometer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/speedometer.js */ "./node_modules/axios/lib/helpers/speedometer.js");
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = (0,_helpers_speedometer_js__WEBPACK_IMPORTED_MODULE_0__["default"])(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isFormData(requestData) && (_platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].isStandardBrowserEnv || _platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].isStandardBrowserWebWorkerEnv)) {
      requestHeaders.setContentType(false); // Let the browser set it
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = (0,_core_buildFullPath_js__WEBPACK_IMPORTED_MODULE_4__["default"])(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), (0,_helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_5__["default"])(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      (0,_core_settle_js__WEBPACK_IMPORTED_MODULE_6__["default"])(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"]('Request aborted', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"]('Network Error', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || _defaults_transitional_js__WEBPACK_IMPORTED_MODULE_8__["default"];
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"](
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ETIMEDOUT : _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (_platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || (0,_helpers_isURLSameOrigin_js__WEBPACK_IMPORTED_MODULE_9__["default"])(fullPath))
        && config.xsrfCookieName && _helpers_cookies_js__WEBPACK_IMPORTED_MODULE_10__["default"].read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_11__["default"](null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = (0,_helpers_parseProtocol_js__WEBPACK_IMPORTED_MODULE_12__["default"])(fullPath);

    if (protocol && _platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].protocols.indexOf(protocol) === -1) {
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"]('Unsupported protocol ' + protocol + ':', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});


/***/ }),

/***/ "./node_modules/axios/lib/axios.js":
/*!*****************************************!*\
  !*** ./node_modules/axios/lib/axios.js ***!
  \*****************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers/bind.js */ "./node_modules/axios/lib/helpers/bind.js");
/* harmony import */ var _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core/Axios.js */ "./node_modules/axios/lib/core/Axios.js");
/* harmony import */ var _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./core/mergeConfig.js */ "./node_modules/axios/lib/core/mergeConfig.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./defaults/index.js */ "./node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./helpers/formDataToJSON.js */ "./node_modules/axios/lib/helpers/formDataToJSON.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _cancel_CancelToken_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./cancel/CancelToken.js */ "./node_modules/axios/lib/cancel/CancelToken.js");
/* harmony import */ var _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./cancel/isCancel.js */ "./node_modules/axios/lib/cancel/isCancel.js");
/* harmony import */ var _env_data_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./env/data.js */ "./node_modules/axios/lib/env/data.js");
/* harmony import */ var _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./helpers/toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _helpers_spread_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./helpers/spread.js */ "./node_modules/axios/lib/helpers/spread.js");
/* harmony import */ var _helpers_isAxiosError_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./helpers/isAxiosError.js */ "./node_modules/axios/lib/helpers/isAxiosError.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _helpers_HttpStatusCode_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./helpers/HttpStatusCode.js */ "./node_modules/axios/lib/helpers/HttpStatusCode.js");



















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"](defaultConfig);
  const instance = (0,_helpers_bind_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.request, context);

  // Copy axios.prototype to instance
  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].extend(instance, _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype, context, {allOwnKeys: true});

  // Copy context to instance
  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance((0,_core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"])(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(_defaults_index_js__WEBPACK_IMPORTED_MODULE_4__["default"]);

// Expose Axios class to allow class inheritance
axios.Axios = _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"];

// Expose Cancel & CancelToken
axios.CanceledError = _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_5__["default"];
axios.CancelToken = _cancel_CancelToken_js__WEBPACK_IMPORTED_MODULE_6__["default"];
axios.isCancel = _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_7__["default"];
axios.VERSION = _env_data_js__WEBPACK_IMPORTED_MODULE_8__.VERSION;
axios.toFormData = _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_9__["default"];

// Expose AxiosError class
axios.AxiosError = _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_10__["default"];

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = _helpers_spread_js__WEBPACK_IMPORTED_MODULE_11__["default"];

// Expose isAxiosError
axios.isAxiosError = _helpers_isAxiosError_js__WEBPACK_IMPORTED_MODULE_12__["default"];

// Expose mergeConfig
axios.mergeConfig = _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"];

axios.AxiosHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_13__["default"];

axios.formToJSON = thing => (0,_helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_14__["default"])(_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHTMLForm(thing) ? new FormData(thing) : thing);

axios.HttpStatusCode = _helpers_HttpStatusCode_js__WEBPACK_IMPORTED_MODULE_15__["default"];

axios.default = axios;

// this module should only have a default export
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (axios);


/***/ }),

/***/ "./node_modules/axios/lib/cancel/CancelToken.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/cancel/CancelToken.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _CanceledError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new _CanceledError_js__WEBPACK_IMPORTED_MODULE_0__["default"](message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CancelToken);


/***/ }),

/***/ "./node_modules/axios/lib/cancel/CanceledError.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/cancel/CanceledError.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].call(this, message == null ? 'canceled' : message, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].inherits(CanceledError, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"], {
  __CANCEL__: true
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CanceledError);


/***/ }),

/***/ "./node_modules/axios/lib/cancel/isCancel.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/cancel/isCancel.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isCancel)
/* harmony export */ });


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}


/***/ }),

/***/ "./node_modules/axios/lib/core/Axios.js":
/*!**********************************************!*\
  !*** ./node_modules/axios/lib/core/Axios.js ***!
  \**********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helpers/buildURL.js */ "./node_modules/axios/lib/helpers/buildURL.js");
/* harmony import */ var _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./InterceptorManager.js */ "./node_modules/axios/lib/core/InterceptorManager.js");
/* harmony import */ var _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./dispatchRequest.js */ "./node_modules/axios/lib/core/dispatchRequest.js");
/* harmony import */ var _mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mergeConfig.js */ "./node_modules/axios/lib/core/mergeConfig.js");
/* harmony import */ var _buildFullPath_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./buildFullPath.js */ "./node_modules/axios/lib/core/buildFullPath.js");
/* harmony import */ var _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/validator.js */ "./node_modules/axios/lib/helpers/validator.js");
/* harmony import */ var _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");











const validators = _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__["default"](),
      response: new _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__["default"]()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = (0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    let contextHeaders;

    // Flatten headers
    contextHeaders = headers && _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(
      headers.common,
      headers[config.method]
    );

    contextHeaders && _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_4__["default"].concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [_dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__["default"].bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__["default"].call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = (0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(this.defaults, config);
    const fullPath = (0,_buildFullPath_js__WEBPACK_IMPORTED_MODULE_6__["default"])(config.baseURL, config.url);
    return (0,_helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_7__["default"])(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request((0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request((0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Axios);


/***/ }),

/***/ "./node_modules/axios/lib/core/AxiosError.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/core/AxiosError.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype);

  _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosError);


/***/ }),

/***/ "./node_modules/axios/lib/core/AxiosHeaders.js":
/*!*****************************************************!*\
  !*** ./node_modules/axios/lib/core/AxiosHeaders.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_parseHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/parseHeaders.js */ "./node_modules/axios/lib/helpers/parseHeaders.js");





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(value)) return;

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders((0,_helpers_parseHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"])(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this, (value, header) => {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].freezeMethods(AxiosHeaders.prototype);
_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].freezeMethods(AxiosHeaders);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosHeaders);


/***/ }),

/***/ "./node_modules/axios/lib/core/InterceptorManager.js":
/*!***********************************************************!*\
  !*** ./node_modules/axios/lib/core/InterceptorManager.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InterceptorManager);


/***/ }),

/***/ "./node_modules/axios/lib/core/buildFullPath.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/buildFullPath.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ buildFullPath)
/* harmony export */ });
/* harmony import */ var _helpers_isAbsoluteURL_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/isAbsoluteURL.js */ "./node_modules/axios/lib/helpers/isAbsoluteURL.js");
/* harmony import */ var _helpers_combineURLs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/combineURLs.js */ "./node_modules/axios/lib/helpers/combineURLs.js");





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !(0,_helpers_isAbsoluteURL_js__WEBPACK_IMPORTED_MODULE_0__["default"])(requestedURL)) {
    return (0,_helpers_combineURLs_js__WEBPACK_IMPORTED_MODULE_1__["default"])(baseURL, requestedURL);
  }
  return requestedURL;
}


/***/ }),

/***/ "./node_modules/axios/lib/core/dispatchRequest.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/core/dispatchRequest.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ dispatchRequest)
/* harmony export */ });
/* harmony import */ var _transformData_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./transformData.js */ "./node_modules/axios/lib/core/transformData.js");
/* harmony import */ var _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../cancel/isCancel.js */ "./node_modules/axios/lib/cancel/isCancel.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../defaults/index.js */ "./node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../adapters/adapters.js */ "./node_modules/axios/lib/adapters/adapters.js");









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_0__["default"](null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(config.headers);

  // Transform request data
  config.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_3__["default"].getAdapter(config.adapter || _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__["default"].adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
      config,
      config.transformResponse,
      response
    );

    response.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!(0,_cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_5__["default"])(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}


/***/ }),

/***/ "./node_modules/axios/lib/core/mergeConfig.js":
/*!****************************************************!*\
  !*** ./node_modules/axios/lib/core/mergeConfig.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ mergeConfig)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");





const headersToObject = (thing) => thing instanceof _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_0__["default"] ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(target) && _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(source)) {
      return _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge.call({caseless}, target, source);
    } else if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(source)) {
      return _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge({}, source);
    } else if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}


/***/ }),

/***/ "./node_modules/axios/lib/core/settle.js":
/*!***********************************************!*\
  !*** ./node_modules/axios/lib/core/settle.js ***!
  \***********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ settle)
/* harmony export */ });
/* harmony import */ var _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"](
      'Request failed with status code ' + response.status,
      [_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_BAD_REQUEST, _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}


/***/ }),

/***/ "./node_modules/axios/lib/core/transformData.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/transformData.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ transformData)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../defaults/index.js */ "./node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || _defaults_index_js__WEBPACK_IMPORTED_MODULE_0__["default"];
  const context = response || config;
  const headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(context.headers);
  let data = context.data;

  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}


/***/ }),

/***/ "./node_modules/axios/lib/defaults/index.js":
/*!**************************************************!*\
  !*** ./node_modules/axios/lib/defaults/index.js ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _transitional_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./transitional.js */ "./node_modules/axios/lib/defaults/transitional.js");
/* harmony import */ var _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helpers/toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _helpers_toURLEncodedForm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helpers/toURLEncodedForm.js */ "./node_modules/axios/lib/helpers/toURLEncodedForm.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");
/* harmony import */ var _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers/formDataToJSON.js */ "./node_modules/axios/lib/helpers/formDataToJSON.js");










const DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: _transitional_js__WEBPACK_IMPORTED_MODULE_1__["default"],

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(data);

    if (isObjectPayload && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify((0,_helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_2__["default"])(data)) : data;
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBuffer(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBuffer(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStream(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFile(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBlob(data)
    ) {
      return data;
    }
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBufferView(data)) {
      return data.buffer;
    }
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return (0,_helpers_toURLEncodedForm_js__WEBPACK_IMPORTED_MODULE_3__["default"])(data, this.formSerializer).toString();
      }

      if ((isFileList = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return (0,_helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(e, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__["default"].ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: _platform_index_js__WEBPACK_IMPORTED_MODULE_6__["default"].classes.FormData,
    Blob: _platform_index_js__WEBPACK_IMPORTED_MODULE_6__["default"].classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge(DEFAULT_CONTENT_TYPE);
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (defaults);


/***/ }),

/***/ "./node_modules/axios/lib/defaults/transitional.js":
/*!*********************************************************!*\
  !*** ./node_modules/axios/lib/defaults/transitional.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});


/***/ }),

/***/ "./node_modules/axios/lib/env/data.js":
/*!********************************************!*\
  !*** ./node_modules/axios/lib/env/data.js ***!
  \********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VERSION": () => (/* binding */ VERSION)
/* harmony export */ });
const VERSION = "1.3.6";

/***/ }),

/***/ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js":
/*!****************************************************************!*\
  !*** ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js ***!
  \****************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _toFormData_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && (0,_toFormData_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosURLSearchParams);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/HttpStatusCode.js":
/*!**********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/HttpStatusCode.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HttpStatusCode);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/bind.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/helpers/bind.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ bind)
/* harmony export */ });


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/buildURL.js":
/*!****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/buildURL.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ buildURL)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/AxiosURLSearchParams.js */ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js");





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isURLSearchParams(params) ?
      params.toString() :
      new _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_1__["default"](params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/combineURLs.js":
/*!*******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/combineURLs.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ combineURLs)
/* harmony export */ });


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/cookies.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/helpers/cookies.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");





/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(path)) {
          cookie.push('path=' + path);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })());


/***/ }),

/***/ "./node_modules/axios/lib/helpers/formDataToJSON.js":
/*!**********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/formDataToJSON.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(target) ? target.length : name;

    if (isLast) {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFormData(formData) && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(formData.entries)) {
    const obj = {};

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formDataToJSON);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isAbsoluteURL.js":
/*!*********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isAbsoluteURL)
/* harmony export */ });


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isAxiosError.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAxiosError.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isAxiosError)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(payload) && (payload.isAxiosError === true);
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isURLSameOrigin.js":
/*!***********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");





/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());


/***/ }),

/***/ "./node_modules/axios/lib/helpers/null.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/helpers/null.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// eslint-disable-next-line strict
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (null);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/parseHeaders.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/parseHeaders.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});


/***/ }),

/***/ "./node_modules/axios/lib/helpers/parseProtocol.js":
/*!*********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/parseProtocol.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ parseProtocol)
/* harmony export */ });


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/speedometer.js":
/*!*******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/speedometer.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (speedometer);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/spread.js":
/*!**************************************************!*\
  !*** ./node_modules/axios/lib/helpers/spread.js ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ spread)
/* harmony export */ });


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/toFormData.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/toFormData.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../platform/node/classes/FormData.js */ "./node_modules/axios/lib/helpers/null.js");




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(thing) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(arr) && !arr.some(isVisitable);
}

const predicates = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"], {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (_platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__["default"] || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isSpecCompliantForm(formData);

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBlob(value)) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__["default"]('Blob is not supported. Use a Buffer instead.');
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBuffer(value) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) && isFlatArray(value)) ||
        ((_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFileList(value) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '[]')) && (arr = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(value, function each(el, key) {
      const result = !(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(el) || el === null) && visitor.call(
        formData, el, _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (toFormData);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/toURLEncodedForm.js":
/*!************************************************************!*\
  !*** ./node_modules/axios/lib/helpers/toURLEncodedForm.js ***!
  \************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ toURLEncodedForm)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _toFormData_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");






function toURLEncodedForm(data, options) {
  return (0,_toFormData_js__WEBPACK_IMPORTED_MODULE_0__["default"])(data, new _platform_index_js__WEBPACK_IMPORTED_MODULE_1__["default"].classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (_platform_index_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNode && _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/validator.js":
/*!*****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/validator.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _env_data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../env/data.js */ "./node_modules/axios/lib/env/data.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + _env_data_js__WEBPACK_IMPORTED_MODULE_0__.VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"](
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('options must be an object', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('option ' + opt + ' must be ' + result, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('Unknown option ' + opt, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  assertOptions,
  validators
});


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/classes/Blob.js":
/*!*****************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/Blob.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof Blob !== 'undefined' ? Blob : null);


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/classes/FormData.js":
/*!*********************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/FormData.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof FormData !== 'undefined' ? FormData : null);


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js":
/*!****************************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../helpers/AxiosURLSearchParams.js */ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/index.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _classes_URLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes/URLSearchParams.js */ "./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js");
/* harmony import */ var _classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./classes/FormData.js */ "./node_modules/axios/lib/platform/browser/classes/FormData.js");
/* harmony import */ var _classes_Blob_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./classes/Blob.js */ "./node_modules/axios/lib/platform/browser/classes/Blob.js");




/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  isBrowser: true,
  classes: {
    URLSearchParams: _classes_URLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__["default"],
    FormData: _classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__["default"],
    Blob: _classes_Blob_js__WEBPACK_IMPORTED_MODULE_2__["default"]
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});


/***/ }),

/***/ "./node_modules/axios/lib/utils.js":
/*!*****************************************!*\
  !*** ./node_modules/axios/lib/utils.js ***!
  \*****************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers/bind.js */ "./node_modules/axios/lib/helpers/bind.js");




// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = (0,_helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__["default"])(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject
});


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.tsx");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});